import axios from 'axios';
import React, { useState, useEffect, useMemo, useCallback, useRef, useContext, createContext as createContext$1, useLayoutEffect, Suspense, forwardRef, Children, useDebugValue, useReducer, useImperativeHandle, Fragment as Fragment$2, createElement, memo, Component as Component$1, createRef } from 'react';
import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import { usePostHog, PostHogProvider } from 'posthog-js/react';
import { useLocation, useNavigate, Outlet, Navigate, NavLink, useInRouterContext } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactDOM, { createPortal } from 'react-dom';
import { toast } from 'react-toastify';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1G = ":root{--primary-color:#012d6b;--primary-50:#8096b5;--primary-20:#ccd5e1;--primary-10:#e5eaf0;--primary-color-rgb:1,45,107;--secondary-color:#5d6ebb;--secondary-50:#aeb7dd;--secondary-20:#dee2f1;--secondary-10:#eff0f8;--info:#4f6af6;--info-10:#eef1fe;--info-20:#c8d3fc;--accent:#7c5cfc;--accent-10:#f0edfe;--accent-20:#d3c9fe;--smoothShadow:rgba(99,99,99,.2) 0px 3px 5px 0;--pre-arrival:#6582ff;--pre-arrival-50:#b3bfff;--pre-arrival-20:#dee2f1;--pre-arrival-10:#eff0f8;--pre-arrival-room-upgrades:var(--pre-arrival-50);--pre-arrival-booked-extras:var(--pre-arrival-20);--on-arrival:#de63a8;--on-arrival-50:#eeb2d3;--on-arrival-20:#f8e0ee;--on-arrival-10:#fceff6;--on-arrival-room-upgrades:var(--on-arrival-50);--on-arrival-booked-extras:var(--on-arrival-20);--in-stay:#f0a83c;--in-stay-50:#f8d39e;--in-stay-20:#fdedd8;--in-stay-10:#fff6eb;--gold:#d4af37;--white:#fff;--text:#000;--grey:#171717;--grey-64:#6a6a6a;--grey-20:#d1d1d1;--grey-8:#e8e8e8;--bg-dark:#dfe6f1;--bg-light:#edf1f6;--bg-light-80:#f2f4f8;--bg-light-48:#f6f8fb;--success:#34a853;--success-10:#e6f7f1;--success-20:#d5eed4;--danger:#d13c2f;--danger-10:#faeaea;--danger-20:#f6d8d5;--warning:#e98e46;--warning-10:#fff2e8;--warning-20:#f4bf96;--disabled:#e8e8e8;--ai-gradient:linear-gradient(135deg,var(--primary-color),var(--danger));--ai-glow:rgba(93,110,187,.4);--ai-glow-hover:rgba(93,110,187,.55);--ai-bg-subtle:linear-gradient(180deg,rgba(93,110,187,.04),rgba(209,60,47,.02));--tips:#5dade2;--tips-20:#dfeef9;--bid-strength-0:#d13c2f;--bid-strength-0-bg:#f9e3e1;--bid-strength-1:#ff7043;--bid-strength-1-bg:#ffe6dc;--bid-strength-2:#f0a83c;--bid-strength-2-bg:#fdf4e4;--bid-strength-3:#34a853;--bid-strength-3-bg:#e1f3e9;--bid-strength-4:#24a645;--bid-strength-4-bg:#dbf3e4;--upsell-pending:#fff6eb;--upsell-denied:#faeaea;--upsell-confirmed:#ebf6ed;--border-radius-small:6px;--border-radius-medium:8px;--menu-text-weight:400;--menu-text-size:15px;--menu-text-line-height:112%;--body-regular-weight:400;--body-regular-size:15px;--body-regular-line-height:160%;--body-small-weight:400;--body-small-size:13px;--body-small-line-height:112%;--body-xs-weight:400;--body-xs-size:11px;--body-xs-line-height:112%;--body-xxs-weight:400;--body-xxs-size:9px;--body-xxs-line-height:112%;--label-weight:500;--label-size:12px;--label-line-height:112%;--button-text-weight:500;--button-text-size:15px;--button-text-line-height:20px;--font-weight-light:300;--font-weight-medium:500;--font-weight-semibold:600}body{font-weight:400}h1{font-size:32px!important;line-height:36px!important}h1,h2{font-weight:500!important}h2{color:var(--primary-color);font-size:22px;line-height:30px!important}h3{font-size:22px!important}h3,h4{font-weight:500!important;line-height:24px!important}h4{font-size:18px!important}h5{font-size:16px!important;line-height:20px!important}h5,h6{font-weight:500!important}h6{font-size:15px!important;line-height:112%!important}b{font-weight:500}small{font-size:var(--body-small-size)}label{font-size:var(--label-size);font-weight:var(--label-weight);line-height:var(--label-line-height)}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:200;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_ExLight.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:300;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_Light.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:400;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_Regular.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:500;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_Medium.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:600;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_SemiBold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:700;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_Bold.woff2) format(\"woff2\")}@font-face{font-display:swap;font-family:Just Sans;font-style:normal;font-weight:800;src:url(https://d3tdybah66uz0i.cloudfront.net/JustSans/JUST_Sans_ExBold.woff2) format(\"woff2\")}";
styleInject(css_248z$1G);

class UTCDateMini extends Date {
  constructor() {
    super();
    this.setTime(arguments.length === 0 ?
    // Enables Sinon's fake timers that override the constructor
    Date.now() : arguments.length === 1 ? typeof arguments[0] === "string" ? +new Date(arguments[0]) : arguments[0] : Date.UTC(...arguments));
  }
  getTimezoneOffset() {
    return 0;
  }
}

// Replace getter and setter functions with UTC counterparts
const re = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach(method => {
  if (re.test(method)) {
    const utcMethod = Date.prototype[method.replace(re, "$1UTC")];
    if (utcMethod) UTCDateMini.prototype[method] = utcMethod;
  }
});

/**
 * UTC date class. It maps getters and setters to corresponding UTC methods,
 * forcing all calculations in the UTC time zone.
 *
 * Combined with date-fns, it allows using the class the same way as
 * the original date class.
 *
 * This complete version provides not only getters, setters,
 * and `getTimezoneOffset`, but also the formatter functions, mirroring
 * all original `Date` functionality. Use this version when you need to format
 * a string or in an environment you don't fully control (a library).
 * For a minimal version, see `UTCDateMini`.
 */
class UTCDate extends UTCDateMini {
  toString() {
    const date = this.toDateString();
    const time = this.toTimeString();
    return `${date} ${time}`;
  }
  toDateString() {
    const weekday = weekdayFormat.format(this);
    const date = dateFormat.format(this);
    const year = this.getFullYear();
    return `${weekday} ${date} ${year}`;
  }
  toTimeString() {
    const time = timeFormat.format(this);
    return `${time} GMT+0000 (Coordinated Universal Time)`;
  }
  toLocaleString(locales, options) {
    return Date.prototype.toLocaleString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
  toLocaleDateString(locales, options) {
    return Date.prototype.toLocaleDateString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
  toLocaleTimeString(locales, options) {
    return Date.prototype.toLocaleTimeString.call(this, locales, {
      timeZone: "UTC",
      ...options
    });
  }
}
var weekdayFormat = new Intl.DateTimeFormat("en-US", {
  weekday: "short",
  timeZone: "UTC"
});
var dateFormat = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  timeZone: "UTC"
});
var timeFormat = new Intl.DateTimeFormat("en-GB", {
  hour12: false,
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  timeZone: "UTC"
});

const parseDate$2 = date => {
  return new UTCDate(date);
};

function _typeof$1(o) {
  "@babel/helpers - typeof";

  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof$1(o);
}

function toInteger$2(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs$1(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate$2(argument) {
  requiredArgs$1(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var timestamp = toDate$2(dirtyDate).getTime();
  var amount = toInteger$2(dirtyAmount);
  return new Date(timestamp + amount);
}

var defaultOptions$2 = {};
function getDefaultOptions$1() {
  return defaultOptions$2;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds$2(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds$2(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds$2(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate$1(value) {
  requiredArgs$1(1, arguments);
  return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  if (!isDate$1(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate$2(dirtyDate);
  return !isNaN(Number(date));
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs$1(2, arguments);
  var dateLeft = toDate$2(dirtyDateLeft);
  var dateRight = toDate$2(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds$1(dirtyDate, dirtyAmount) {
  requiredArgs$1(2, arguments);
  var amount = toInteger$2(dirtyAmount);
  return addMilliseconds$1(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var weekStartsOn = 1;
  var date = toDate$2(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek$1(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek$1(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var year = getUTCISOWeekYear$1(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek$1(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCISOWeek$1(dirtyDate) {
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  var diff = startOfUTCISOWeek$1(date).getTime() - startOfUTCISOWeekYear$1(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function startOfUTCWeek$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions = getDefaultOptions$1();
  var weekStartsOn = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate$2(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek$1(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek$1(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear$1(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs$1(1, arguments);
  var defaultOptions = getDefaultOptions$1();
  var firstWeekContainsDate = toInteger$2((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear$1(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek$1(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek$1(dirtyDate, options) {
  requiredArgs$1(1, arguments);
  var date = toDate$2(dirtyDate);
  var diff = startOfUTCWeek$1(date, options).getTime() - startOfUTCWeekYear$1(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros$2(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$6 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros$2(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros$2(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros$2(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros$2(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros$2(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros$2(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros$2(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros$2(fractionalSeconds, token.length);
  }
};
var formatters$7 = formatters$6;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters$4 = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$7.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear$1(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros$2(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros$2(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear$1(date);

    // Padding
    return addLeadingZeros$2(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros$2(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros$2(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros$2(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$7.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros$2(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek$1(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros$2(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek$1(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros$2(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$7.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear$1(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros$2(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros$2(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros$2(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros$2(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$7.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$7.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros$2(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros$2(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$7.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$7.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$7.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes$1(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone$1(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort$1(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort$1(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone$1(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros$2(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros$2(timestamp, token.length);
  }
};
function formatTimezoneShort$1(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros$2(minutes, 2);
}
function formatTimezoneWithOptionalMinutes$1(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros$2(Math.abs(offset) / 60, 2);
  }
  return formatTimezone$1(offset, dirtyDelimiter);
}
function formatTimezone$1(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros$2(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros$2(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$5 = formatters$4;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters$1 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$2 = longFormatters$1;

var protectedDayOfYearTokens$1 = ['D', 'DD'];
var protectedWeekYearTokens$1 = ['YY', 'YYYY'];
function isProtectedDayOfYearToken$1(token) {
  return protectedDayOfYearTokens$1.indexOf(token) !== -1;
}
function isProtectedWeekYearToken$1(token) {
  return protectedWeekYearTokens$1.indexOf(token) !== -1;
}
function throwProtectedError$1(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$1 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$2 = formatDistance$1;

function buildFormatLongFn$1(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1 = {
  date: buildFormatLongFn$1({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn$1({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn$1({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$2 = formatLong$1;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative$1 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var formatRelative$2 = formatRelative$1;

function buildLocalizeFn$1(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize$1 = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn$1({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn$1({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn$1({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn$1({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn$1({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2 = localize$1;

function buildMatchFn$1(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn$1(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn$1({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn$1({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn$1({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn$1({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn$1({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn$1({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$2 = match$1;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: formatDistance$2,
  formatLong: formatLong$2,
  formatRelative: formatRelative$2,
  localize: localize$2,
  match: match$2,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale$1 = locale;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format$2(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs$1(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions$1();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale$1;
  var firstWeekContainsDate = toInteger$2((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger$2((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate$2(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds$2(originalDate);
  var utcDate = subMilliseconds$1(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$2[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$5[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken$1(substring)) {
        throwProtectedError$1(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs$1(1, arguments);
  var additionalDigits = toInteger$2((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString$1(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear$1(dateStrings.date, additionalDigits);
    date = parseDate$1(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime$1(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns$2 = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString$1(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns$2.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns$2.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns$2.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns$2.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear$1(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate$1(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate$1(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear$1(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate$1(year, month, day) || !validateDayOfYearDate$1(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime$1(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime$1(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone$1(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear$1(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex$1(year) ? 29 : 28));
}
function validateDayOfYearDate$1(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex$1(year) ? 366 : 365);
}
function validateWeekDate$1(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime$1(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone$1(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * Parses a calendar day ('yyyy-MM-dd') into a Date at local midnight.
 *
 * Use this instead of parseDate when the result is passed to date-fns helpers
 * (eachDayOfInterval, eachWeekOfInterval, differenceInDays, ...) or read back
 * with local getters. Those work in local time, and date-fns 2.x drops the
 * UTCDate that parseDate returns, so a UTC-parsed day lands on the previous
 * day everywhere west of UTC.
 *
 * For values that are only formatted back to a string, keep using parseDate.
 */
const parseCalendarDay = date => {
  if (date instanceof Date) {
    return date;
  }
  return parseISO(date);
};

function getDefaultExportFromCjs$1 (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var format$1 = {exports: {}};

var interopRequireDefault = {exports: {}};

(function (module) {
	function _interopRequireDefault(e) {
	  return e && e.__esModule ? e : {
	    "default": e
	  };
	}
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (interopRequireDefault));

var interopRequireDefaultExports = interopRequireDefault.exports;

var isValid = {exports: {}};

var isDate = {exports: {}};

var _typeof = {exports: {}};

(function (module) {
	function _typeof(o) {
	  "@babel/helpers - typeof";

	  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
	    return typeof o;
	  } : function (o) {
	    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports; 
} (_typeof));

var _typeofExports = _typeof.exports;

var requiredArgs = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requiredArgs;
	function requiredArgs(required, args) {
	  if (args.length < required) {
	    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
	  }
	}
	module.exports = exports.default; 
} (requiredArgs, requiredArgs.exports));

var requiredArgsExports = requiredArgs.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isDate;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isDate
	 * @category Common Helpers
	 * @summary Is the given value a date?
	 *
	 * @description
	 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
	 *
	 * @param {*} value - the value to check
	 * @returns {boolean} true if the given value is a date
	 * @throws {TypeError} 1 arguments required
	 *
	 * @example
	 * // For a valid date:
	 * const result = isDate(new Date())
	 * //=> true
	 *
	 * @example
	 * // For an invalid date:
	 * const result = isDate(new Date(NaN))
	 * //=> true
	 *
	 * @example
	 * // For some value:
	 * const result = isDate('2014-02-31')
	 * //=> false
	 *
	 * @example
	 * // For an object:
	 * const result = isDate({})
	 * //=> false
	 */
	function isDate(value) {
	  (0, _index.default)(1, arguments);
	  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
	}
	module.exports = exports.default; 
} (isDate, isDate.exports));

var isDateExports = isDate.exports;

var toDate$1 = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toDate;
	var _typeof2 = _interopRequireDefault(_typeofExports);
	var _index = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name toDate
	 * @category Common Helpers
	 * @summary Convert the given argument to an instance of Date.
	 *
	 * @description
	 * Convert the given argument to an instance of Date.
	 *
	 * If the argument is an instance of Date, the function returns its clone.
	 *
	 * If the argument is a number, it is treated as a timestamp.
	 *
	 * If the argument is none of the above, the function returns Invalid Date.
	 *
	 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
	 *
	 * @param {Date|Number} argument - the value to convert
	 * @returns {Date} the parsed date in the local time zone
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // Clone the date:
	 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
	 * //=> Tue Feb 11 2014 11:30:30
	 *
	 * @example
	 * // Convert the timestamp to date:
	 * const result = toDate(1392098430000)
	 * //=> Tue Feb 11 2014 11:30:30
	 */
	function toDate(argument) {
	  (0, _index.default)(1, arguments);
	  var argStr = Object.prototype.toString.call(argument);

	  // Clone the date
	  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
	    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
	    return new Date(argument.getTime());
	  } else if (typeof argument === 'number' || argStr === '[object Number]') {
	    return new Date(argument);
	  } else {
	    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
	      // eslint-disable-next-line no-console
	      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
	      // eslint-disable-next-line no-console
	      console.warn(new Error().stack);
	    }
	    return new Date(NaN);
	  }
	}
	module.exports = exports.default; 
} (toDate$1, toDate$1.exports));

var toDateExports = toDate$1.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isValid;
	var _index = _interopRequireDefault(isDateExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name isValid
	 * @category Common Helpers
	 * @summary Is the given date valid?
	 *
	 * @description
	 * Returns false if argument is Invalid Date and true otherwise.
	 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
	 * Invalid Date is a Date, whose time value is NaN.
	 *
	 * Time value of Date: http://es5.github.io/#x15.9.1.1
	 *
	 * @param {*} date - the date to check
	 * @returns {Boolean} the date is valid
	 * @throws {TypeError} 1 argument required
	 *
	 * @example
	 * // For the valid date:
	 * const result = isValid(new Date(2014, 1, 31))
	 * //=> true
	 *
	 * @example
	 * // For the value, convertable into a date:
	 * const result = isValid(1393804800000)
	 * //=> true
	 *
	 * @example
	 * // For the invalid date:
	 * const result = isValid(new Date(''))
	 * //=> false
	 */
	function isValid(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
	    return false;
	  }
	  var date = (0, _index2.default)(dirtyDate);
	  return !isNaN(Number(date));
	}
	module.exports = exports.default; 
} (isValid, isValid.exports));

var isValidExports = isValid.exports;

var subMilliseconds = {exports: {}};

var addMilliseconds = {exports: {}};

var toInteger$1 = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toInteger;
	function toInteger(dirtyNumber) {
	  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
	    return NaN;
	  }
	  var number = Number(dirtyNumber);
	  if (isNaN(number)) {
	    return number;
	  }
	  return number < 0 ? Math.ceil(number) : Math.floor(number);
	}
	module.exports = exports.default; 
} (toInteger$1, toInteger$1.exports));

var toIntegerExports = toInteger$1.exports;
var toInteger = /*@__PURE__*/getDefaultExportFromCjs$1(toIntegerExports);

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addMilliseconds;
	var _index = _interopRequireDefault(toIntegerExports);
	var _index2 = _interopRequireDefault(toDateExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	/**
	 * @name addMilliseconds
	 * @category Millisecond Helpers
	 * @summary Add the specified number of milliseconds to the given date.
	 *
	 * @description
	 * Add the specified number of milliseconds to the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds added
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
	 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:30.750
	 */
	function addMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index3.default)(2, arguments);
	  var timestamp = (0, _index2.default)(dirtyDate).getTime();
	  var amount = (0, _index.default)(dirtyAmount);
	  return new Date(timestamp + amount);
	}
	module.exports = exports.default; 
} (addMilliseconds, addMilliseconds.exports));

var addMillisecondsExports = addMilliseconds.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = subMilliseconds;
	var _index = _interopRequireDefault(addMillisecondsExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	/**
	 * @name subMilliseconds
	 * @category Millisecond Helpers
	 * @summary Subtract the specified number of milliseconds from the given date.
	 *
	 * @description
	 * Subtract the specified number of milliseconds from the given date.
	 *
	 * @param {Date|Number} date - the date to be changed
	 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
	 * @returns {Date} the new date with the milliseconds subtracted
	 * @throws {TypeError} 2 arguments required
	 *
	 * @example
	 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
	 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
	 * //=> Thu Jul 10 2014 12:45:29.250
	 */
	function subMilliseconds(dirtyDate, dirtyAmount) {
	  (0, _index2.default)(2, arguments);
	  var amount = (0, _index3.default)(dirtyAmount);
	  return (0, _index.default)(dirtyDate, -amount);
	}
	module.exports = exports.default; 
} (subMilliseconds, subMilliseconds.exports));

var subMillisecondsExports = subMilliseconds.exports;

var formatters$3 = {exports: {}};

var getUTCDayOfYear = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCDayOfYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_DAY = 86400000;
	function getUTCDayOfYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var timestamp = date.getTime();
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	  var startOfYearTimestamp = date.getTime();
	  var difference = timestamp - startOfYearTimestamp;
	  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
	}
	module.exports = exports.default; 
} (getUTCDayOfYear, getUTCDayOfYear.exports));

var getUTCDayOfYearExports = getUTCDayOfYear.exports;

var getUTCISOWeek = {exports: {}};

var startOfUTCISOWeek = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	function startOfUTCISOWeek(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var weekStartsOn = 1;
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default; 
} (startOfUTCISOWeek, startOfUTCISOWeek.exports));

var startOfUTCISOWeekExports = startOfUTCISOWeek.exports;

var startOfUTCISOWeekYear = {exports: {}};

var getUTCISOWeekYear = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeekYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCISOWeekExports);
	function getUTCISOWeekYear(dirtyDate) {
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var fourthOfJanuaryOfNextYear = new Date(0);
	  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
	  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
	  var fourthOfJanuaryOfThisYear = new Date(0);
	  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
	  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default; 
} (getUTCISOWeekYear, getUTCISOWeekYear.exports));

var getUTCISOWeekYearExports = getUTCISOWeekYear.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCISOWeekYear;
	var _index = _interopRequireDefault(getUTCISOWeekYearExports);
	var _index2 = _interopRequireDefault(startOfUTCISOWeekExports);
	var _index3 = _interopRequireDefault(requiredArgsExports);
	function startOfUTCISOWeekYear(dirtyDate) {
	  (0, _index3.default)(1, arguments);
	  var year = (0, _index.default)(dirtyDate);
	  var fourthOfJanuary = new Date(0);
	  fourthOfJanuary.setUTCFullYear(year, 0, 4);
	  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index2.default)(fourthOfJanuary);
	  return date;
	}
	module.exports = exports.default; 
} (startOfUTCISOWeekYear, startOfUTCISOWeekYear.exports));

var startOfUTCISOWeekYearExports = startOfUTCISOWeekYear.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCISOWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfUTCISOWeekExports);
	var _index3 = _interopRequireDefault(startOfUTCISOWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCISOWeek(dirtyDate) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default; 
} (getUTCISOWeek, getUTCISOWeek.exports));

var getUTCISOWeekExports = getUTCISOWeek.exports;

var getUTCWeek = {exports: {}};

var startOfUTCWeek = {exports: {}};

var defaultOptions$1 = {};

Object.defineProperty(defaultOptions$1, "__esModule", {
  value: true
});
defaultOptions$1.getDefaultOptions = getDefaultOptions;
defaultOptions$1.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(toIntegerExports);
	var _index4 = defaultOptions$1;
	function startOfUTCWeek(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index4.getDefaultOptions)();
	  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  var date = (0, _index.default)(dirtyDate);
	  var day = date.getUTCDay();
	  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
	  date.setUTCDate(date.getUTCDate() - diff);
	  date.setUTCHours(0, 0, 0, 0);
	  return date;
	}
	module.exports = exports.default; 
} (startOfUTCWeek, startOfUTCWeek.exports));

var startOfUTCWeekExports = startOfUTCWeek.exports;

var startOfUTCWeekYear = {exports: {}};

var getUTCWeekYear = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeekYear;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	var _index5 = defaultOptions$1;
	function getUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var year = date.getUTCFullYear();
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var firstWeekOfNextYear = new Date(0);
	  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
	  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
	  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
	  var firstWeekOfThisYear = new Date(0);
	  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
	  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
	  if (date.getTime() >= startOfNextYear.getTime()) {
	    return year + 1;
	  } else if (date.getTime() >= startOfThisYear.getTime()) {
	    return year;
	  } else {
	    return year - 1;
	  }
	}
	module.exports = exports.default; 
} (getUTCWeekYear, getUTCWeekYear.exports));

var getUTCWeekYearExports = getUTCWeekYear.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = startOfUTCWeekYear;
	var _index = _interopRequireDefault(getUTCWeekYearExports);
	var _index2 = _interopRequireDefault(requiredArgsExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekExports);
	var _index4 = _interopRequireDefault(toIntegerExports);
	var _index5 = defaultOptions$1;
	function startOfUTCWeekYear(dirtyDate, options) {
	  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
	  (0, _index2.default)(1, arguments);
	  var defaultOptions = (0, _index5.getDefaultOptions)();
	  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
	  var year = (0, _index.default)(dirtyDate, options);
	  var firstWeek = new Date(0);
	  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
	  firstWeek.setUTCHours(0, 0, 0, 0);
	  var date = (0, _index3.default)(firstWeek, options);
	  return date;
	}
	module.exports = exports.default; 
} (startOfUTCWeekYear, startOfUTCWeekYear.exports));

var startOfUTCWeekYearExports = startOfUTCWeekYear.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getUTCWeek;
	var _index = _interopRequireDefault(toDateExports);
	var _index2 = _interopRequireDefault(startOfUTCWeekExports);
	var _index3 = _interopRequireDefault(startOfUTCWeekYearExports);
	var _index4 = _interopRequireDefault(requiredArgsExports);
	var MILLISECONDS_IN_WEEK = 604800000;
	function getUTCWeek(dirtyDate, options) {
	  (0, _index4.default)(1, arguments);
	  var date = (0, _index.default)(dirtyDate);
	  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();

	  // Round the number of days to the nearest integer
	  // because the number of milliseconds in a week is not constant
	  // (e.g. it's different in the week of the daylight saving time clock shift)
	  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
	}
	module.exports = exports.default; 
} (getUTCWeek, getUTCWeek.exports));

var getUTCWeekExports = getUTCWeek.exports;

var addLeadingZeros$1 = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addLeadingZeros;
	function addLeadingZeros(number, targetLength) {
	  var sign = number < 0 ? '-' : '';
	  var output = Math.abs(number).toString();
	  while (output.length < targetLength) {
	    output = '0' + output;
	  }
	  return sign + output;
	}
	module.exports = exports.default; 
} (addLeadingZeros$1, addLeadingZeros$1.exports));

var addLeadingZerosExports = addLeadingZeros$1.exports;

var lightFormatters = {exports: {}};

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(addLeadingZerosExports);
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* |                                |
	 * |  d  | Day of month                   |  D  |                                |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  y  | Year (abs)                     |  Y  |                                |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 */

	var formatters = {
	  // Year
	  y: function y(date, token) {
	    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
	    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
	    // |----------|-------|----|-------|-------|-------|
	    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
	    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
	    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
	    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
	    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

	    var signedYear = date.getUTCFullYear();
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var year = signedYear > 0 ? signedYear : 1 - signedYear;
	    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
	  },
	  // Month
	  M: function M(date, token) {
	    var month = date.getUTCMonth();
	    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
	  },
	  // Day of the month
	  d: function d(date, token) {
	    return (0, _index.default)(date.getUTCDate(), token.length);
	  },
	  // AM or PM
	  a: function a(date, token) {
	    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return dayPeriodEnumValue.toUpperCase();
	      case 'aaa':
	        return dayPeriodEnumValue;
	      case 'aaaaa':
	        return dayPeriodEnumValue[0];
	      case 'aaaa':
	      default:
	        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token) {
	    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
	  },
	  // Hour [0-23]
	  H: function H(date, token) {
	    return (0, _index.default)(date.getUTCHours(), token.length);
	  },
	  // Minute
	  m: function m(date, token) {
	    return (0, _index.default)(date.getUTCMinutes(), token.length);
	  },
	  // Second
	  s: function s(date, token) {
	    return (0, _index.default)(date.getUTCSeconds(), token.length);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    var numberOfDigits = token.length;
	    var milliseconds = date.getUTCMilliseconds();
	    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
	    return (0, _index.default)(fractionalSeconds, token.length);
	  }
	};
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default; 
} (lightFormatters, lightFormatters.exports));

var lightFormattersExports = lightFormatters.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(getUTCDayOfYearExports);
	var _index2 = _interopRequireDefault(getUTCISOWeekExports);
	var _index3 = _interopRequireDefault(getUTCISOWeekYearExports);
	var _index4 = _interopRequireDefault(getUTCWeekExports);
	var _index5 = _interopRequireDefault(getUTCWeekYearExports);
	var _index6 = _interopRequireDefault(addLeadingZerosExports);
	var _index7 = _interopRequireDefault(lightFormattersExports);
	var dayPeriodEnum = {
	  am: 'am',
	  pm: 'pm',
	  midnight: 'midnight',
	  noon: 'noon',
	  morning: 'morning',
	  afternoon: 'afternoon',
	  evening: 'evening',
	  night: 'night'
	};
	/*
	 * |     | Unit                           |     | Unit                           |
	 * |-----|--------------------------------|-----|--------------------------------|
	 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
	 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
	 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
	 * |  d  | Day of month                   |  D  | Day of year                    |
	 * |  e  | Local day of week              |  E  | Day of week                    |
	 * |  f  |                                |  F* | Day of week in month           |
	 * |  g* | Modified Julian day            |  G  | Era                            |
	 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
	 * |  i! | ISO day of week                |  I! | ISO week of year               |
	 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
	 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
	 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
	 * |  m  | Minute                         |  M  | Month                          |
	 * |  n  |                                |  N  |                                |
	 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
	 * |  p! | Long localized time            |  P! | Long localized date            |
	 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
	 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
	 * |  s  | Second                         |  S  | Fraction of second             |
	 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
	 * |  u  | Extended year                  |  U* | Cyclic year                    |
	 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
	 * |  w  | Local week of year             |  W* | Week of month                  |
	 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
	 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
	 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
	 *
	 * Letters marked by * are not implemented but reserved by Unicode standard.
	 *
	 * Letters marked by ! are non-standard, but implemented by date-fns:
	 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
	 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
	 *   i.e. 7 for Sunday, 1 for Monday, etc.
	 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
	 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
	 *   `R` is supposed to be used in conjunction with `I` and `i`
	 *   for universal ISO week-numbering date, whereas
	 *   `Y` is supposed to be used in conjunction with `w` and `e`
	 *   for week-numbering date specific to the locale.
	 * - `P` is long localized date format
	 * - `p` is long localized time format
	 */

	var formatters = {
	  // Era
	  G: function G(date, token, localize) {
	    var era = date.getUTCFullYear() > 0 ? 1 : 0;
	    switch (token) {
	      // AD, BC
	      case 'G':
	      case 'GG':
	      case 'GGG':
	        return localize.era(era, {
	          width: 'abbreviated'
	        });
	      // A, B
	      case 'GGGGG':
	        return localize.era(era, {
	          width: 'narrow'
	        });
	      // Anno Domini, Before Christ
	      case 'GGGG':
	      default:
	        return localize.era(era, {
	          width: 'wide'
	        });
	    }
	  },
	  // Year
	  y: function y(date, token, localize) {
	    // Ordinal number
	    if (token === 'yo') {
	      var signedYear = date.getUTCFullYear();
	      // Returns 1 for 1 BC (which is year 0 in JavaScript)
	      var year = signedYear > 0 ? signedYear : 1 - signedYear;
	      return localize.ordinalNumber(year, {
	        unit: 'year'
	      });
	    }
	    return _index7.default.y(date, token);
	  },
	  // Local week-numbering year
	  Y: function Y(date, token, localize, options) {
	    var signedWeekYear = (0, _index5.default)(date, options);
	    // Returns 1 for 1 BC (which is year 0 in JavaScript)
	    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

	    // Two digit year
	    if (token === 'YY') {
	      var twoDigitYear = weekYear % 100;
	      return (0, _index6.default)(twoDigitYear, 2);
	    }

	    // Ordinal number
	    if (token === 'Yo') {
	      return localize.ordinalNumber(weekYear, {
	        unit: 'year'
	      });
	    }

	    // Padding
	    return (0, _index6.default)(weekYear, token.length);
	  },
	  // ISO week-numbering year
	  R: function R(date, token) {
	    var isoWeekYear = (0, _index3.default)(date);

	    // Padding
	    return (0, _index6.default)(isoWeekYear, token.length);
	  },
	  // Extended year. This is a single number designating the year of this calendar system.
	  // The main difference between `y` and `u` localizers are B.C. years:
	  // | Year | `y` | `u` |
	  // |------|-----|-----|
	  // | AC 1 |   1 |   1 |
	  // | BC 1 |   1 |   0 |
	  // | BC 2 |   2 |  -1 |
	  // Also `yy` always returns the last two digits of a year,
	  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
	  u: function u(date, token) {
	    var year = date.getUTCFullYear();
	    return (0, _index6.default)(year, token.length);
	  },
	  // Quarter
	  Q: function Q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'Q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'QQ':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'Qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'QQQ':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'QQQQQ':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'QQQQ':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone quarter
	  q: function q(date, token, localize) {
	    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
	    switch (token) {
	      // 1, 2, 3, 4
	      case 'q':
	        return String(quarter);
	      // 01, 02, 03, 04
	      case 'qq':
	        return (0, _index6.default)(quarter, 2);
	      // 1st, 2nd, 3rd, 4th
	      case 'qo':
	        return localize.ordinalNumber(quarter, {
	          unit: 'quarter'
	        });
	      // Q1, Q2, Q3, Q4
	      case 'qqq':
	        return localize.quarter(quarter, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
	      case 'qqqqq':
	        return localize.quarter(quarter, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // 1st quarter, 2nd quarter, ...
	      case 'qqqq':
	      default:
	        return localize.quarter(quarter, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Month
	  M: function M(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      case 'M':
	      case 'MM':
	        return _index7.default.M(date, token);
	      // 1st, 2nd, ..., 12th
	      case 'Mo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'MMM':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // J, F, ..., D
	      case 'MMMMM':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // January, February, ..., December
	      case 'MMMM':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone month
	  L: function L(date, token, localize) {
	    var month = date.getUTCMonth();
	    switch (token) {
	      // 1, 2, ..., 12
	      case 'L':
	        return String(month + 1);
	      // 01, 02, ..., 12
	      case 'LL':
	        return (0, _index6.default)(month + 1, 2);
	      // 1st, 2nd, ..., 12th
	      case 'Lo':
	        return localize.ordinalNumber(month + 1, {
	          unit: 'month'
	        });
	      // Jan, Feb, ..., Dec
	      case 'LLL':
	        return localize.month(month, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // J, F, ..., D
	      case 'LLLLL':
	        return localize.month(month, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // January, February, ..., December
	      case 'LLLL':
	      default:
	        return localize.month(month, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // Local week of year
	  w: function w(date, token, localize, options) {
	    var week = (0, _index4.default)(date, options);
	    if (token === 'wo') {
	      return localize.ordinalNumber(week, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(week, token.length);
	  },
	  // ISO week of year
	  I: function I(date, token, localize) {
	    var isoWeek = (0, _index2.default)(date);
	    if (token === 'Io') {
	      return localize.ordinalNumber(isoWeek, {
	        unit: 'week'
	      });
	    }
	    return (0, _index6.default)(isoWeek, token.length);
	  },
	  // Day of the month
	  d: function d(date, token, localize) {
	    if (token === 'do') {
	      return localize.ordinalNumber(date.getUTCDate(), {
	        unit: 'date'
	      });
	    }
	    return _index7.default.d(date, token);
	  },
	  // Day of year
	  D: function D(date, token, localize) {
	    var dayOfYear = (0, _index.default)(date);
	    if (token === 'Do') {
	      return localize.ordinalNumber(dayOfYear, {
	        unit: 'dayOfYear'
	      });
	    }
	    return (0, _index6.default)(dayOfYear, token.length);
	  },
	  // Day of week
	  E: function E(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    switch (token) {
	      // Tue
	      case 'E':
	      case 'EE':
	      case 'EEE':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'EEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'EEEEEE':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'EEEE':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Local day of week
	  e: function e(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (Nth day of week with current locale or weekStartsOn)
	      case 'e':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'ee':
	        return (0, _index6.default)(localDayOfWeek, 2);
	      // 1st, 2nd, ..., 7th
	      case 'eo':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'eee':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'eeeee':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'eeeeee':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'eeee':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Stand-alone local day of week
	  c: function c(date, token, localize, options) {
	    var dayOfWeek = date.getUTCDay();
	    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
	    switch (token) {
	      // Numerical value (same as in `e`)
	      case 'c':
	        return String(localDayOfWeek);
	      // Padded numerical value
	      case 'cc':
	        return (0, _index6.default)(localDayOfWeek, token.length);
	      // 1st, 2nd, ..., 7th
	      case 'co':
	        return localize.ordinalNumber(localDayOfWeek, {
	          unit: 'day'
	        });
	      case 'ccc':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'standalone'
	        });
	      // T
	      case 'ccccc':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'standalone'
	        });
	      // Tu
	      case 'cccccc':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'standalone'
	        });
	      // Tuesday
	      case 'cccc':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'standalone'
	        });
	    }
	  },
	  // ISO day of week
	  i: function i(date, token, localize) {
	    var dayOfWeek = date.getUTCDay();
	    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
	    switch (token) {
	      // 2
	      case 'i':
	        return String(isoDayOfWeek);
	      // 02
	      case 'ii':
	        return (0, _index6.default)(isoDayOfWeek, token.length);
	      // 2nd
	      case 'io':
	        return localize.ordinalNumber(isoDayOfWeek, {
	          unit: 'day'
	        });
	      // Tue
	      case 'iii':
	        return localize.day(dayOfWeek, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      // T
	      case 'iiiii':
	        return localize.day(dayOfWeek, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      // Tu
	      case 'iiiiii':
	        return localize.day(dayOfWeek, {
	          width: 'short',
	          context: 'formatting'
	        });
	      // Tuesday
	      case 'iiii':
	      default:
	        return localize.day(dayOfWeek, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM or PM
	  a: function a(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    switch (token) {
	      case 'a':
	      case 'aa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'aaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'aaaaa':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'aaaa':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // AM, PM, midnight, noon
	  b: function b(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours === 12) {
	      dayPeriodEnumValue = dayPeriodEnum.noon;
	    } else if (hours === 0) {
	      dayPeriodEnumValue = dayPeriodEnum.midnight;
	    } else {
	      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
	    }
	    switch (token) {
	      case 'b':
	      case 'bb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'bbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        }).toLowerCase();
	      case 'bbbbb':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'bbbb':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // in the morning, in the afternoon, in the evening, at night
	  B: function B(date, token, localize) {
	    var hours = date.getUTCHours();
	    var dayPeriodEnumValue;
	    if (hours >= 17) {
	      dayPeriodEnumValue = dayPeriodEnum.evening;
	    } else if (hours >= 12) {
	      dayPeriodEnumValue = dayPeriodEnum.afternoon;
	    } else if (hours >= 4) {
	      dayPeriodEnumValue = dayPeriodEnum.morning;
	    } else {
	      dayPeriodEnumValue = dayPeriodEnum.night;
	    }
	    switch (token) {
	      case 'B':
	      case 'BB':
	      case 'BBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'abbreviated',
	          context: 'formatting'
	        });
	      case 'BBBBB':
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'narrow',
	          context: 'formatting'
	        });
	      case 'BBBB':
	      default:
	        return localize.dayPeriod(dayPeriodEnumValue, {
	          width: 'wide',
	          context: 'formatting'
	        });
	    }
	  },
	  // Hour [1-12]
	  h: function h(date, token, localize) {
	    if (token === 'ho') {
	      var hours = date.getUTCHours() % 12;
	      if (hours === 0) hours = 12;
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.h(date, token);
	  },
	  // Hour [0-23]
	  H: function H(date, token, localize) {
	    if (token === 'Ho') {
	      return localize.ordinalNumber(date.getUTCHours(), {
	        unit: 'hour'
	      });
	    }
	    return _index7.default.H(date, token);
	  },
	  // Hour [0-11]
	  K: function K(date, token, localize) {
	    var hours = date.getUTCHours() % 12;
	    if (token === 'Ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Hour [1-24]
	  k: function k(date, token, localize) {
	    var hours = date.getUTCHours();
	    if (hours === 0) hours = 24;
	    if (token === 'ko') {
	      return localize.ordinalNumber(hours, {
	        unit: 'hour'
	      });
	    }
	    return (0, _index6.default)(hours, token.length);
	  },
	  // Minute
	  m: function m(date, token, localize) {
	    if (token === 'mo') {
	      return localize.ordinalNumber(date.getUTCMinutes(), {
	        unit: 'minute'
	      });
	    }
	    return _index7.default.m(date, token);
	  },
	  // Second
	  s: function s(date, token, localize) {
	    if (token === 'so') {
	      return localize.ordinalNumber(date.getUTCSeconds(), {
	        unit: 'second'
	      });
	    }
	    return _index7.default.s(date, token);
	  },
	  // Fraction of second
	  S: function S(date, token) {
	    return _index7.default.S(date, token);
	  },
	  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
	  X: function X(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    if (timezoneOffset === 0) {
	      return 'Z';
	    }
	    switch (token) {
	      // Hours and optional minutes
	      case 'X':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);

	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XX`
	      case 'XXXX':
	      case 'XX':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);

	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `XXX`
	      case 'XXXXX':
	      case 'XXX': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
	  x: function x(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Hours and optional minutes
	      case 'x':
	        return formatTimezoneWithOptionalMinutes(timezoneOffset);

	      // Hours, minutes and optional seconds without `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xx`
	      case 'xxxx':
	      case 'xx':
	        // Hours and minutes without `:` delimiter
	        return formatTimezone(timezoneOffset);

	      // Hours, minutes and optional seconds with `:` delimiter
	      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
	      // so this token always has the same output as `xxx`
	      case 'xxxxx':
	      case 'xxx': // Hours and minutes with `:` delimiter
	      default:
	        return formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (GMT)
	  O: function O(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'O':
	      case 'OO':
	      case 'OOO':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'OOOO':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Timezone (specific non-location)
	  z: function z(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timezoneOffset = originalDate.getTimezoneOffset();
	    switch (token) {
	      // Short
	      case 'z':
	      case 'zz':
	      case 'zzz':
	        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
	      // Long
	      case 'zzzz':
	      default:
	        return 'GMT' + formatTimezone(timezoneOffset, ':');
	    }
	  },
	  // Seconds timestamp
	  t: function t(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = Math.floor(originalDate.getTime() / 1000);
	    return (0, _index6.default)(timestamp, token.length);
	  },
	  // Milliseconds timestamp
	  T: function T(date, token, _localize, options) {
	    var originalDate = options._originalDate || date;
	    var timestamp = originalDate.getTime();
	    return (0, _index6.default)(timestamp, token.length);
	  }
	};
	function formatTimezoneShort(offset, dirtyDelimiter) {
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = Math.floor(absOffset / 60);
	  var minutes = absOffset % 60;
	  if (minutes === 0) {
	    return sign + String(hours);
	  }
	  var delimiter = dirtyDelimiter || '';
	  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
	}
	function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
	  if (offset % 60 === 0) {
	    var sign = offset > 0 ? '-' : '+';
	    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
	  }
	  return formatTimezone(offset, dirtyDelimiter);
	}
	function formatTimezone(offset, dirtyDelimiter) {
	  var delimiter = dirtyDelimiter || '';
	  var sign = offset > 0 ? '-' : '+';
	  var absOffset = Math.abs(offset);
	  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
	  var minutes = (0, _index6.default)(absOffset % 60, 2);
	  return sign + hours + delimiter + minutes;
	}
	var _default = formatters;
	exports.default = _default;
	module.exports = exports.default; 
} (formatters$3, formatters$3.exports));

var formattersExports = formatters$3.exports;

var longFormatters = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });
	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });
	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });
	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	};
	var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });
	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });
	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });
	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	};
	var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];
	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }
	  var dateTimeFormat;
	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;
	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;
	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;
	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }
	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	};
	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default; 
} (longFormatters, longFormatters.exports));

var longFormattersExports = longFormatters.exports;

var getTimezoneOffsetInMilliseconds$1 = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getTimezoneOffsetInMilliseconds;
	/**
	 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
	 * They usually appear for dates that denote time before the timezones were introduced
	 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
	 * and GMT+01:00:00 after that date)
	 *
	 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
	 * which would lead to incorrect calculations.
	 *
	 * This function returns the timezone offset in milliseconds that takes seconds in account.
	 */
	function getTimezoneOffsetInMilliseconds(date) {
	  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
	  utcDate.setUTCFullYear(date.getFullYear());
	  return date.getTime() - utcDate.getTime();
	}
	module.exports = exports.default; 
} (getTimezoneOffsetInMilliseconds$1, getTimezoneOffsetInMilliseconds$1.exports));

var getTimezoneOffsetInMillisecondsExports = getTimezoneOffsetInMilliseconds$1.exports;
var getTimezoneOffsetInMilliseconds = /*@__PURE__*/getDefaultExportFromCjs$1(getTimezoneOffsetInMillisecondsExports);

var protectedTokens = {};

Object.defineProperty(protectedTokens, "__esModule", {
  value: true
});
protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken;
protectedTokens.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var defaultLocale = {exports: {}};

var enUS = {exports: {}};

var formatDistance = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatDistanceLocale = {
	  lessThanXSeconds: {
	    one: 'less than a second',
	    other: 'less than {{count}} seconds'
	  },
	  xSeconds: {
	    one: '1 second',
	    other: '{{count}} seconds'
	  },
	  halfAMinute: 'half a minute',
	  lessThanXMinutes: {
	    one: 'less than a minute',
	    other: 'less than {{count}} minutes'
	  },
	  xMinutes: {
	    one: '1 minute',
	    other: '{{count}} minutes'
	  },
	  aboutXHours: {
	    one: 'about 1 hour',
	    other: 'about {{count}} hours'
	  },
	  xHours: {
	    one: '1 hour',
	    other: '{{count}} hours'
	  },
	  xDays: {
	    one: '1 day',
	    other: '{{count}} days'
	  },
	  aboutXWeeks: {
	    one: 'about 1 week',
	    other: 'about {{count}} weeks'
	  },
	  xWeeks: {
	    one: '1 week',
	    other: '{{count}} weeks'
	  },
	  aboutXMonths: {
	    one: 'about 1 month',
	    other: 'about {{count}} months'
	  },
	  xMonths: {
	    one: '1 month',
	    other: '{{count}} months'
	  },
	  aboutXYears: {
	    one: 'about 1 year',
	    other: 'about {{count}} years'
	  },
	  xYears: {
	    one: '1 year',
	    other: '{{count}} years'
	  },
	  overXYears: {
	    one: 'over 1 year',
	    other: 'over {{count}} years'
	  },
	  almostXYears: {
	    one: 'almost 1 year',
	    other: 'almost {{count}} years'
	  }
	};
	var formatDistance = function formatDistance(token, count, options) {
	  var result;
	  var tokenValue = formatDistanceLocale[token];
	  if (typeof tokenValue === 'string') {
	    result = tokenValue;
	  } else if (count === 1) {
	    result = tokenValue.one;
	  } else {
	    result = tokenValue.other.replace('{{count}}', count.toString());
	  }
	  if (options !== null && options !== void 0 && options.addSuffix) {
	    if (options.comparison && options.comparison > 0) {
	      return 'in ' + result;
	    } else {
	      return result + ' ago';
	    }
	  }
	  return result;
	};
	var _default = formatDistance;
	exports.default = _default;
	module.exports = exports.default; 
} (formatDistance, formatDistance.exports));

var formatDistanceExports = formatDistance.exports;

var formatLong = {exports: {}};

var buildFormatLongFn = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildFormatLongFn;
	function buildFormatLongFn(args) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    // TODO: Remove String()
	    var width = options.width ? String(options.width) : args.defaultWidth;
	    var format = args.formats[width] || args.formats[args.defaultWidth];
	    return format;
	  };
	}
	module.exports = exports.default; 
} (buildFormatLongFn, buildFormatLongFn.exports));

var buildFormatLongFnExports = buildFormatLongFn.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(buildFormatLongFnExports);
	var dateFormats = {
	  full: 'EEEE, MMMM do, y',
	  long: 'MMMM do, y',
	  medium: 'MMM d, y',
	  short: 'MM/dd/yyyy'
	};
	var timeFormats = {
	  full: 'h:mm:ss a zzzz',
	  long: 'h:mm:ss a z',
	  medium: 'h:mm:ss a',
	  short: 'h:mm a'
	};
	var dateTimeFormats = {
	  full: "{{date}} 'at' {{time}}",
	  long: "{{date}} 'at' {{time}}",
	  medium: '{{date}}, {{time}}',
	  short: '{{date}}, {{time}}'
	};
	var formatLong = {
	  date: (0, _index.default)({
	    formats: dateFormats,
	    defaultWidth: 'full'
	  }),
	  time: (0, _index.default)({
	    formats: timeFormats,
	    defaultWidth: 'full'
	  }),
	  dateTime: (0, _index.default)({
	    formats: dateTimeFormats,
	    defaultWidth: 'full'
	  })
	};
	var _default = formatLong;
	exports.default = _default;
	module.exports = exports.default; 
} (formatLong, formatLong.exports));

var formatLongExports = formatLong.exports;

var formatRelative = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var formatRelativeLocale = {
	  lastWeek: "'last' eeee 'at' p",
	  yesterday: "'yesterday at' p",
	  today: "'today at' p",
	  tomorrow: "'tomorrow at' p",
	  nextWeek: "eeee 'at' p",
	  other: 'P'
	};
	var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
	  return formatRelativeLocale[token];
	};
	var _default = formatRelative;
	exports.default = _default;
	module.exports = exports.default; 
} (formatRelative, formatRelative.exports));

var formatRelativeExports = formatRelative.exports;

var localize = {exports: {}};

var buildLocalizeFn = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildLocalizeFn;
	function buildLocalizeFn(args) {
	  return function (dirtyIndex, options) {
	    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
	    var valuesArray;
	    if (context === 'formatting' && args.formattingValues) {
	      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
	      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
	      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
	    } else {
	      var _defaultWidth = args.defaultWidth;
	      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
	      valuesArray = args.values[_width] || args.values[_defaultWidth];
	    }
	    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
	    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
	    return valuesArray[index];
	  };
	}
	module.exports = exports.default; 
} (buildLocalizeFn, buildLocalizeFn.exports));

var buildLocalizeFnExports = buildLocalizeFn.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(buildLocalizeFnExports);
	var eraValues = {
	  narrow: ['B', 'A'],
	  abbreviated: ['BC', 'AD'],
	  wide: ['Before Christ', 'Anno Domini']
	};
	var quarterValues = {
	  narrow: ['1', '2', '3', '4'],
	  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
	  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
	};

	// Note: in English, the names of days of the week and months are capitalized.
	// If you are making a new locale based on this one, check if the same is true for the language you're working on.
	// Generally, formatted dates should look like they are in the middle of a sentence,
	// e.g. in Spanish language the weekdays and months should be in the lowercase.
	var monthValues = {
	  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
	  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
	};
	var dayValues = {
	  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
	  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
	  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
	};
	var dayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'morning',
	    afternoon: 'afternoon',
	    evening: 'evening',
	    night: 'night'
	  }
	};
	var formattingDayPeriodValues = {
	  narrow: {
	    am: 'a',
	    pm: 'p',
	    midnight: 'mi',
	    noon: 'n',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  abbreviated: {
	    am: 'AM',
	    pm: 'PM',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  },
	  wide: {
	    am: 'a.m.',
	    pm: 'p.m.',
	    midnight: 'midnight',
	    noon: 'noon',
	    morning: 'in the morning',
	    afternoon: 'in the afternoon',
	    evening: 'in the evening',
	    night: 'at night'
	  }
	};
	var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
	  var number = Number(dirtyNumber);

	  // If ordinal numbers depend on context, for example,
	  // if they are different for different grammatical genders,
	  // use `options.unit`.
	  //
	  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
	  // 'day', 'hour', 'minute', 'second'.

	  var rem100 = number % 100;
	  if (rem100 > 20 || rem100 < 10) {
	    switch (rem100 % 10) {
	      case 1:
	        return number + 'st';
	      case 2:
	        return number + 'nd';
	      case 3:
	        return number + 'rd';
	    }
	  }
	  return number + 'th';
	};
	var localize = {
	  ordinalNumber: ordinalNumber,
	  era: (0, _index.default)({
	    values: eraValues,
	    defaultWidth: 'wide'
	  }),
	  quarter: (0, _index.default)({
	    values: quarterValues,
	    defaultWidth: 'wide',
	    argumentCallback: function argumentCallback(quarter) {
	      return quarter - 1;
	    }
	  }),
	  month: (0, _index.default)({
	    values: monthValues,
	    defaultWidth: 'wide'
	  }),
	  day: (0, _index.default)({
	    values: dayValues,
	    defaultWidth: 'wide'
	  }),
	  dayPeriod: (0, _index.default)({
	    values: dayPeriodValues,
	    defaultWidth: 'wide',
	    formattingValues: formattingDayPeriodValues,
	    defaultFormattingWidth: 'wide'
	  })
	};
	var _default = localize;
	exports.default = _default;
	module.exports = exports.default; 
} (localize, localize.exports));

var localizeExports = localize.exports;

var match = {exports: {}};

var buildMatchFn = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchFn;
	function buildMatchFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var width = options.width;
	    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
	    var matchResult = string.match(matchPattern);
	    if (!matchResult) {
	      return null;
	    }
	    var matchedString = matchResult[0];
	    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
	    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    }) : findKey(parsePatterns, function (pattern) {
	      return pattern.test(matchedString);
	    });
	    var value;
	    value = args.valueCallback ? args.valueCallback(key) : key;
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	function findKey(object, predicate) {
	  for (var key in object) {
	    if (object.hasOwnProperty(key) && predicate(object[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	function findIndex(array, predicate) {
	  for (var key = 0; key < array.length; key++) {
	    if (predicate(array[key])) {
	      return key;
	    }
	  }
	  return undefined;
	}
	module.exports = exports.default; 
} (buildMatchFn, buildMatchFn.exports));

var buildMatchFnExports = buildMatchFn.exports;

var buildMatchPatternFn = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = buildMatchPatternFn;
	function buildMatchPatternFn(args) {
	  return function (string) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var matchResult = string.match(args.matchPattern);
	    if (!matchResult) return null;
	    var matchedString = matchResult[0];
	    var parseResult = string.match(args.parsePattern);
	    if (!parseResult) return null;
	    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
	    value = options.valueCallback ? options.valueCallback(value) : value;
	    var rest = string.slice(matchedString.length);
	    return {
	      value: value,
	      rest: rest
	    };
	  };
	}
	module.exports = exports.default; 
} (buildMatchPatternFn, buildMatchPatternFn.exports));

var buildMatchPatternFnExports = buildMatchPatternFn.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(buildMatchFnExports);
	var _index2 = _interopRequireDefault(buildMatchPatternFnExports);
	var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
	var parseOrdinalNumberPattern = /\d+/i;
	var matchEraPatterns = {
	  narrow: /^(b|a)/i,
	  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
	  wide: /^(before christ|before common era|anno domini|common era)/i
	};
	var parseEraPatterns = {
	  any: [/^b/i, /^(a|c)/i]
	};
	var matchQuarterPatterns = {
	  narrow: /^[1234]/i,
	  abbreviated: /^q[1234]/i,
	  wide: /^[1234](th|st|nd|rd)? quarter/i
	};
	var parseQuarterPatterns = {
	  any: [/1/i, /2/i, /3/i, /4/i]
	};
	var matchMonthPatterns = {
	  narrow: /^[jfmasond]/i,
	  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
	  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
	};
	var parseMonthPatterns = {
	  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
	  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
	};
	var matchDayPatterns = {
	  narrow: /^[smtwf]/i,
	  short: /^(su|mo|tu|we|th|fr|sa)/i,
	  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
	  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
	};
	var parseDayPatterns = {
	  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
	  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
	};
	var matchDayPeriodPatterns = {
	  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
	  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
	};
	var parseDayPeriodPatterns = {
	  any: {
	    am: /^a/i,
	    pm: /^p/i,
	    midnight: /^mi/i,
	    noon: /^no/i,
	    morning: /morning/i,
	    afternoon: /afternoon/i,
	    evening: /evening/i,
	    night: /night/i
	  }
	};
	var match = {
	  ordinalNumber: (0, _index2.default)({
	    matchPattern: matchOrdinalNumberPattern,
	    parsePattern: parseOrdinalNumberPattern,
	    valueCallback: function valueCallback(value) {
	      return parseInt(value, 10);
	    }
	  }),
	  era: (0, _index.default)({
	    matchPatterns: matchEraPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseEraPatterns,
	    defaultParseWidth: 'any'
	  }),
	  quarter: (0, _index.default)({
	    matchPatterns: matchQuarterPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseQuarterPatterns,
	    defaultParseWidth: 'any',
	    valueCallback: function valueCallback(index) {
	      return index + 1;
	    }
	  }),
	  month: (0, _index.default)({
	    matchPatterns: matchMonthPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseMonthPatterns,
	    defaultParseWidth: 'any'
	  }),
	  day: (0, _index.default)({
	    matchPatterns: matchDayPatterns,
	    defaultMatchWidth: 'wide',
	    parsePatterns: parseDayPatterns,
	    defaultParseWidth: 'any'
	  }),
	  dayPeriod: (0, _index.default)({
	    matchPatterns: matchDayPeriodPatterns,
	    defaultMatchWidth: 'any',
	    parsePatterns: parseDayPeriodPatterns,
	    defaultParseWidth: 'any'
	  })
	};
	var _default = match;
	exports.default = _default;
	module.exports = exports.default; 
} (match, match.exports));

var matchExports = match.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(formatDistanceExports);
	var _index2 = _interopRequireDefault(formatLongExports);
	var _index3 = _interopRequireDefault(formatRelativeExports);
	var _index4 = _interopRequireDefault(localizeExports);
	var _index5 = _interopRequireDefault(matchExports);
	/**
	 * @type {Locale}
	 * @category Locales
	 * @summary English locale (United States).
	 * @language English
	 * @iso-639-2 eng
	 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
	 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
	 */
	var locale = {
	  code: 'en-US',
	  formatDistance: _index.default,
	  formatLong: _index2.default,
	  formatRelative: _index3.default,
	  localize: _index4.default,
	  match: _index5.default,
	  options: {
	    weekStartsOn: 0 /* Sunday */,
	    firstWeekContainsDate: 1
	  }
	};
	var _default = locale;
	exports.default = _default;
	module.exports = exports.default; 
} (enUS, enUS.exports));

var enUSExports = enUS.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var _index = _interopRequireDefault(enUSExports);
	var _default = _index.default;
	exports.default = _default;
	module.exports = exports.default; 
} (defaultLocale, defaultLocale.exports));

var defaultLocaleExports = defaultLocale.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = format;
	var _index = _interopRequireDefault(isValidExports);
	var _index2 = _interopRequireDefault(subMillisecondsExports);
	var _index3 = _interopRequireDefault(toDateExports);
	var _index4 = _interopRequireDefault(formattersExports);
	var _index5 = _interopRequireDefault(longFormattersExports);
	var _index6 = _interopRequireDefault(getTimezoneOffsetInMillisecondsExports);
	var _index7 = protectedTokens;
	var _index8 = _interopRequireDefault(toIntegerExports);
	var _index9 = _interopRequireDefault(requiredArgsExports);
	var _index10 = defaultOptions$1;
	var _index11 = _interopRequireDefault(defaultLocaleExports);
	// This RegExp consists of three parts separated by `|`:
	// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
	//   (one of the certain letters followed by `o`)
	// - (\w)\1* matches any sequences of the same letter
	// - '' matches two quote characters in a row
	// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
	//   except a single quote symbol, which ends the sequence.
	//   Two quote characters do not end the sequence.
	//   If there is no matching single quote
	//   then the sequence will continue until the end of the string.
	// - . matches any single character unmatched by previous parts of the RegExps
	var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

	// This RegExp catches symbols escaped by quotes, and also
	// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
	var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
	var escapedStringRegExp = /^'([^]*?)'?$/;
	var doubleQuoteRegExp = /''/g;
	var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

	/**
	 * @name format
	 * @category Common Helpers
	 * @summary Format the date.
	 *
	 * @description
	 * Return the formatted date string in the given format. The result may vary by locale.
	 *
	 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
	 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * The characters wrapped between two single quotes characters (') are escaped.
	 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
	 * (see the last example)
	 *
	 * Format of the string is based on Unicode Technical Standard #35:
	 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
	 * with a few additions (see note 7 below the table).
	 *
	 * Accepted patterns:
	 * | Unit                            | Pattern | Result examples                   | Notes |
	 * |---------------------------------|---------|-----------------------------------|-------|
	 * | Era                             | G..GGG  | AD, BC                            |       |
	 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
	 * |                                 | GGGGG   | A, B                              |       |
	 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
	 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
	 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
	 * |                                 | yyyyy   | ...                               | 3,5   |
	 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
	 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
	 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
	 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
	 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
	 * |                                 | YYYYY   | ...                               | 3,5   |
	 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
	 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
	 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
	 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
	 * |                                 | RRRRR   | ...                               | 3,5,7 |
	 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
	 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
	 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
	 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
	 * |                                 | uuuuu   | ...                               | 3,5   |
	 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
	 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | QQ      | 01, 02, 03, 04                    |       |
	 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
	 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
	 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
	 * |                                 | qq      | 01, 02, 03, 04                    |       |
	 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
	 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
	 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
	 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
	 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | MM      | 01, 02, ..., 12                   |       |
	 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
	 * |                                 | MMMM    | January, February, ..., December  | 2     |
	 * |                                 | MMMMM   | J, F, ..., D                      |       |
	 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
	 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
	 * |                                 | LL      | 01, 02, ..., 12                   |       |
	 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
	 * |                                 | LLLL    | January, February, ..., December  | 2     |
	 * |                                 | LLLLL   | J, F, ..., D                      |       |
	 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
	 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | ww      | 01, 02, ..., 53                   |       |
	 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
	 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
	 * |                                 | II      | 01, 02, ..., 53                   | 7     |
	 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
	 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
	 * |                                 | dd      | 01, 02, ..., 31                   |       |
	 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
	 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
	 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
	 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
	 * |                                 | DDDD    | ...                               | 3     |
	 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
	 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
	 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
	 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
	 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
	 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
	 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
	 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
	 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | ee      | 02, 03, ..., 01                   |       |
	 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
	 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
	 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
	 * |                                 | cc      | 02, 03, ..., 01                   |       |
	 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
	 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
	 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
	 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
	 * | AM, PM                          | a..aa   | AM, PM                            |       |
	 * |                                 | aaa     | am, pm                            |       |
	 * |                                 | aaaa    | a.m., p.m.                        | 2     |
	 * |                                 | aaaaa   | a, p                              |       |
	 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
	 * |                                 | bbb     | am, pm, noon, midnight            |       |
	 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
	 * |                                 | bbbbb   | a, p, n, mi                       |       |
	 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
	 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
	 * |                                 | BBBBB   | at night, in the morning, ...     |       |
	 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
	 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
	 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
	 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
	 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
	 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
	 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
	 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
	 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
	 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
	 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
	 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
	 * | Minute                          | m       | 0, 1, ..., 59                     |       |
	 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | mm      | 00, 01, ..., 59                   |       |
	 * | Second                          | s       | 0, 1, ..., 59                     |       |
	 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
	 * |                                 | ss      | 00, 01, ..., 59                   |       |
	 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
	 * |                                 | SS      | 00, 01, ..., 99                   |       |
	 * |                                 | SSS     | 000, 001, ..., 999                |       |
	 * |                                 | SSSS    | ...                               | 3     |
	 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
	 * |                                 | XX      | -0800, +0530, Z                   |       |
	 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
	 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
	 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
	 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
	 * |                                 | xx      | -0800, +0530, +0000               |       |
	 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
	 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
	 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
	 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
	 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
	 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
	 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
	 * | Seconds timestamp               | t       | 512969520                         | 7     |
	 * |                                 | tt      | ...                               | 3,7   |
	 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
	 * |                                 | TT      | ...                               | 3,7   |
	 * | Long localized date             | P       | 04/29/1453                        | 7     |
	 * |                                 | PP      | Apr 29, 1453                      | 7     |
	 * |                                 | PPP     | April 29th, 1453                  | 7     |
	 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
	 * | Long localized time             | p       | 12:00 AM                          | 7     |
	 * |                                 | pp      | 12:00:00 AM                       | 7     |
	 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
	 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
	 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
	 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
	 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
	 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
	 * Notes:
	 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
	 *    are the same as "stand-alone" units, but are different in some languages.
	 *    "Formatting" units are declined according to the rules of the language
	 *    in the context of a date. "Stand-alone" units are always nominative singular:
	 *
	 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
	 *
	 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
	 *
	 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
	 *    the single quote characters (see below).
	 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
	 *    the output will be the same as default pattern for this unit, usually
	 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
	 *    are marked with "2" in the last column of the table.
	 *
	 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
	 *
	 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
	 *
	 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
	 *    The output will be padded with zeros to match the length of the pattern.
	 *
	 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
	 *
	 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
	 *    These tokens represent the shortest form of the quarter.
	 *
	 * 5. The main difference between `y` and `u` patterns are B.C. years:
	 *
	 *    | Year | `y` | `u` |
	 *    |------|-----|-----|
	 *    | AC 1 |   1 |   1 |
	 *    | BC 1 |   1 |   0 |
	 *    | BC 2 |   2 |  -1 |
	 *
	 *    Also `yy` always returns the last two digits of a year,
	 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
	 *
	 *    | Year | `yy` | `uu` |
	 *    |------|------|------|
	 *    | 1    |   01 |   01 |
	 *    | 14   |   14 |   14 |
	 *    | 376  |   76 |  376 |
	 *    | 1453 |   53 | 1453 |
	 *
	 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
	 *    except local week-numbering years are dependent on `options.weekStartsOn`
	 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
	 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
	 *
	 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
	 *    so right now these tokens fall back to GMT timezones.
	 *
	 * 7. These patterns are not in the Unicode Technical Standard #35:
	 *    - `i`: ISO day of week
	 *    - `I`: ISO week of year
	 *    - `R`: ISO week-numbering year
	 *    - `t`: seconds timestamp
	 *    - `T`: milliseconds timestamp
	 *    - `o`: ordinal number modifier
	 *    - `P`: long localized date
	 *    - `p`: long localized time
	 *
	 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
	 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
	 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 *
	 * @param {Date|Number} date - the original date
	 * @param {String} format - the string of tokens
	 * @param {Object} [options] - an object with options.
	 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
	 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
	 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
	 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
	 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @returns {String} the formatted date string
	 * @throws {TypeError} 2 arguments required
	 * @throws {RangeError} `date` must not be Invalid Date
	 * @throws {RangeError} `options.locale` must contain `localize` property
	 * @throws {RangeError} `options.locale` must contain `formatLong` property
	 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
	 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
	 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
	 * @throws {RangeError} format string contains an unescaped latin alphabet character
	 *
	 * @example
	 * // Represent 11 February 2014 in middle-endian format:
	 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
	 * //=> '02/11/2014'
	 *
	 * @example
	 * // Represent 2 July 2014 in Esperanto:
	 * import { eoLocale } from 'date-fns/locale/eo'
	 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
	 *   locale: eoLocale
	 * })
	 * //=> '2-a de julio 2014'
	 *
	 * @example
	 * // Escape string by single quote characters:
	 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
	 * //=> "3 o'clock"
	 */

	function format(dirtyDate, dirtyFormatStr, options) {
	  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
	  (0, _index9.default)(2, arguments);
	  var formatStr = String(dirtyFormatStr);
	  var defaultOptions = (0, _index10.getDefaultOptions)();
	  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
	  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

	  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
	  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
	    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
	  }
	  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

	  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
	  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
	    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
	  }
	  if (!locale.localize) {
	    throw new RangeError('locale must contain localize property');
	  }
	  if (!locale.formatLong) {
	    throw new RangeError('locale must contain formatLong property');
	  }
	  var originalDate = (0, _index3.default)(dirtyDate);
	  if (!(0, _index.default)(originalDate)) {
	    throw new RangeError('Invalid time value');
	  }

	  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
	  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
	  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
	  var timezoneOffset = (0, _index6.default)(originalDate);
	  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
	  var formatterOptions = {
	    firstWeekContainsDate: firstWeekContainsDate,
	    weekStartsOn: weekStartsOn,
	    locale: locale,
	    _originalDate: originalDate
	  };
	  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
	    var firstCharacter = substring[0];
	    if (firstCharacter === 'p' || firstCharacter === 'P') {
	      var longFormatter = _index5.default[firstCharacter];
	      return longFormatter(substring, locale.formatLong);
	    }
	    return substring;
	  }).join('').match(formattingTokensRegExp).map(function (substring) {
	    // Replace two single quote characters with one single quote character
	    if (substring === "''") {
	      return "'";
	    }
	    var firstCharacter = substring[0];
	    if (firstCharacter === "'") {
	      return cleanEscapedString(substring);
	    }
	    var formatter = _index4.default[firstCharacter];
	    if (formatter) {
	      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
	        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
	      }
	      return formatter(utcDate, substring, locale.localize, formatterOptions);
	    }
	    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
	      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
	    }
	    return substring;
	  }).join('');
	  return result;
	}
	function cleanEscapedString(input) {
	  var matched = input.match(escapedStringRegExp);
	  if (!matched) {
	    return input;
	  }
	  return matched[1].replace(doubleQuoteRegExp, "'");
	}
	module.exports = exports.default; 
} (format$1, format$1.exports));

var formatExports = format$1.exports;
var dateFnsFormat = /*@__PURE__*/getDefaultExportFromCjs$1(formatExports);

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date)
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);

  for (var i = formatted.length - 1; i >= 0; --i) {
    if (formatted[i].type === 'timeZoneName') {
      return formatted[i].value
    }
  }
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : ''
}

// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error(
      "date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`"
    )
  }
  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length,
  })
}

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date)
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5,
};

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }
    return filled
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN]
    }
    throw error
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date);
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
  // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]]
}

// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var dtfCache = {};
function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported =
      testDateFormatted === '06/25/2014, 00:00:00' ||
      testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';

    dtfCache[timeZone] = hourCycleSupported
      ? new Intl.DateTimeFormat('en-US', {
          hourCycle: 'h23',
          timeZone: timeZone,
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        })
      : new Intl.DateTimeFormat('en-US', {
          hour12: false,
          timeZone: timeZone,
          year: 'numeric',
          month: 'numeric',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
        });
  }
  return dtfCache[timeZone]
}

/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
var MILLISECONDS_IN_MINUTE$2 = 60000;

var patterns$1 = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/,
};

// Parse various time zone offset formats to an offset in milliseconds
function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset;

  // Empty string
  if (!timezoneString) {
    return 0
  }

  // Z
  token = patterns$1.timezoneZ.exec(timezoneString);
  if (token) {
    return 0
  }

  var hours;

  // ±hh
  token = patterns$1.timezoneHH.exec(timezoneString);
  if (token) {
    hours = parseInt(token[1], 10);

    if (!validateTimezone(hours)) {
      return NaN
    }

    return -(hours * MILLISECONDS_IN_HOUR$1)
  }

  // ±hh:mm or ±hhmm
  token = patterns$1.timezoneHHMM.exec(timezoneString);
  if (token) {
    hours = parseInt(token[2], 10);
    var minutes = parseInt(token[3], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR$1 + minutes * MILLISECONDS_IN_MINUTE$2;
    return token[1] === '+' ? -absoluteOffset : absoluteOffset
  }

  // IANA time zone
  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);

    var offset = calcOffset(utcDate, timezoneString);

    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);

    return -fixedOffset
  }

  return NaN
}

function toUtcDate(date) {
  return newDateUTC(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
    date.getHours(),
    date.getMinutes(),
    date.getSeconds(),
    date.getMilliseconds()
  )
}

function calcOffset(date, timezoneString) {
  var tokens = tzTokenizeDate(date, timezoneString);

  // ms dropped because it's not provided by tzTokenizeDate
  var asUTC = newDateUTC(
    tokens[0],
    tokens[1] - 1,
    tokens[2],
    tokens[3] % 24,
    tokens[4],
    tokens[5],
    0
  ).getTime();

  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime();

  // Our UTC time is just a guess because our offset is just a guess
  var utcGuess = localTS - offset;

  // Test whether the zone matches the offset for this ts
  var o2 = calcOffset(new Date(utcGuess), timezoneString);

  // If so, offset didn't change, and we're done
  if (offset === o2) {
    return offset
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= o2 - offset;

  // If that gives us the local time we want, we're done
  var o3 = calcOffset(new Date(utcGuess), timezoneString);
  if (o2 === o3) {
    return o2
  }

  // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
  return Math.max(o2, o3)
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || (0 <= minutes && minutes <= 59))
}

var validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: timeZoneString });
    validIANATimezoneCache[timeZoneString] = true;
    return true
  } catch (error) {
    return false
  }
}

var MILLISECONDS_IN_MINUTE$1 = 60 * 1000;

var formatters$1 = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);

    if (timezoneOffset === 0) {
      return 'Z'
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset)

      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx': // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset)

      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter
      default:
        return formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, date);

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':')
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':')
    }
  },

  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return tzIntlTimeZoneName('short', date, options)
      // Long
      case 'zzzz':
      default:
        return tzIntlTimeZoneName('long', date, options)
    }
  },
};

function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone
    ? tzParseTimezone(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE$1
    : originalDate.getTimezoneOffset();
  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError('Invalid time zone specified: ' + timeZone)
  }
  return timeZoneOffset
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2)
  }
  return formatTimezone(offset, dirtyDelimeter)
}

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours)
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2)
}

var formatters$2 = formatters$1;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;

var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,

  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/, // 0 additional digits
    /^([+-]\d{3})$/, // 1 additional digit
    /^([+-]\d{4})$/, // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/, // 0 additional digits
    /^([+-]\d{5})/, // 1 additional digit
    /^([+-]\d{6})/, // 2 additional digits
  ],

  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,

  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,

  // time zone tokens (to identify the presence of a tz)
  timeZone: tzPattern,
};

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present')
  }

  if (argument === null) {
    return new Date(NaN)
  }

  var options = dirtyOptions || {};

  var additionalDigits =
    options.additionalDigits == null
      ? DEFAULT_ADDITIONAL_DIGITS
      : toInteger(options.additionalDigits);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2')
  }

  // Clone the date
  if (
    argument instanceof Date ||
    (typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]')
  ) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (
    typeof argument === 'number' ||
    Object.prototype.toString.call(argument) === '[object Number]'
  ) {
    return new Date(argument)
  } else if (
    !(
      typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]'
    )
  ) {
    return new Date(NaN)
  }

  var dateStrings = splitDateString(argument);

  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;

  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN)
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN)
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = tzParseTimezone(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
      if (isNaN(offset)) {
        return new Date(NaN)
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time));
      offset = getTimezoneOffsetInMilliseconds(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(NaN)
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);
    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];

  var token;

  // YYYY or ±YYYYY
  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length),
    }
  }

  // YY or ±YYY
  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length),
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null,
  }
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token;
  var date;
  var month;
  var week;

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date
  }

  // YYYY-MM
  token = patterns.MM.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month);
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = patterns.DDD.exec(dateString);
  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date
  }

  // yyyy-MM-dd or YYYYMMDD
  token = patterns.MMDD.exec(dateString);
  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN)
    }

    date.setUTCFullYear(year, month, day);
    return date
  }

  // YYYY-Www or YYYYWww
  token = patterns.Www.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = patterns.WwwD.exec(dateString);
  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN)
    }

    return dayOfISOWeekYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes;

  // hh
  token = patterns.HH.exec(timeString);
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = patterns.HHMM.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = patterns.HHMMSS.exec(timeString);
  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN
    }

    return (hours % 24) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date
}

// Validation functions

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || (year % 4 === 0 && year % 100 !== 0)
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false
  }

  if (date != null) {
    if (date < 1) {
      return false
    }

    var isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false
    }
    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false
    }
  }

  return true
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false
  }

  var isLeapYear = isLeapYearIndex(year);
  if (isLeapYear && dayOfYear > 366) {
    return false
  }
  if (!isLeapYear && dayOfYear > 365) {
    return false
  }

  return true
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false
  }

  if (day != null && (day < 0 || day > 6)) {
    return false
  }

  return true
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false
  }

  return true
}

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @param {Date|Number} [options.originalDate] - can be used to pass the original unmodified date to `format` to
 *   improve correctness of the replaced timezone token close to the DST threshold.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};

  var matches = formatStr.match(tzFormattingTokensRegExp);
  if (matches) {
    var date = toDate(options.originalDate || dirtyDate, options);
    // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.
    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result // This is a quoted portion, matched only to ensure we don't match inside it
      }
      var pos = result.indexOf(token);
      var precededByQuotedSection = result[pos - 1] === "'";
      var replaced = result.replace(
        token,
        "'" + formatters$2[token[0]](date, token, null, options) + "'"
      );
      // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed, so it doesn't look like an escaped quote.
      return precededByQuotedSection
        ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1)
        : replaced
    }, formatStr);
  }

  return dateFnsFormat(dirtyDate, formatStr, options)
}

var cloneObject$1 = {exports: {}};

var assign = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = assign;
	function assign(target, object) {
	  if (target == null) {
	    throw new TypeError('assign requires that input parameter not be null or undefined');
	  }
	  for (var property in object) {
	    if (Object.prototype.hasOwnProperty.call(object, property)) {
	      target[property] = object[property];
	    }
	  }
	  return target;
	}
	module.exports = exports.default; 
} (assign, assign.exports));

var assignExports = assign.exports;

(function (module, exports) {

	var _interopRequireDefault = interopRequireDefaultExports.default;
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cloneObject;
	var _index = _interopRequireDefault(assignExports);
	function cloneObject(object) {
	  return (0, _index.default)({}, object);
	}
	module.exports = exports.default; 
} (cloneObject$1, cloneObject$1.exports));

var cloneObjectExports = cloneObject$1.exports;
var cloneObject = /*@__PURE__*/getDefaultExportFromCjs$1(cloneObjectExports);

/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = toDate(dirtyDate, options);

  var offsetMilliseconds = tzParseTimezone(timeZone, date, true);

  var d = new Date(date.getTime() - offsetMilliseconds);

  var resultDate = new Date(0);

  resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

  resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());

  return resultDate
}

/**
 * @name formatInTimeZone
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @param {Date|String|Number} date - the date representing the local time / real UTC time
 * @param {String} timeZone - the time zone this date should be formatted for; can be an offset or IANA time zone
 * @param {String} formatStr - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 */
function formatInTimeZone(date, timeZone, formatStr, options) {
  var extendedOptions = cloneObject(options);
  extendedOptions.timeZone = timeZone;
  extendedOptions.originalDate = date;
  return format(utcToZonedTime(date, timeZone), formatStr, extendedOptions)
}

const formatDate$1 = (date, outputFormat) => {
  if (typeof date === 'string') {
    // Always treat string as UTC
    date = parseDate$2(date);
  }
  if (!outputFormat) {
    outputFormat = 'P';
  }
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const utcDate = new Date(Date.UTC(year, month, day, 0, 0, 0));
  return formatInTimeZone(utcDate, 'UTC', outputFormat);
};

const formatNights = nights => {
  const count = Number(nights) || 0;
  return `${count} ${count === 1 ? 'nt' : 'nts'}`;
};

const isPartialUpgrade = (nights, stayNights) => {
  const upgradeNights = Number(nights);
  return Boolean(upgradeNights) && Boolean(stayNights) && upgradeNights < Number(stayNights);
};

const formatDateTime = (date, format, timezone = 'UTC') => {
  if (typeof date === 'string') {
    // Always treat string as UTC
    date = parseDate$2(date);
  }
  if (!format) {
    format = 'P p';
  }
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  const utcDate = new Date(Date.UTC(year, month, day, hours, minutes, seconds));
  return formatInTimeZone(utcDate, timezone, format);
};

const formatDateTimeNoConversion = (date, formatStr = 'P p') => {
  if (typeof date === 'string') {
    date = parseDate$2(date);
  }
  return format$2(date, formatStr);
};

const ASC = 'asc',
  DESC = 'desc';
const sortSelectedColumn = (column, sortOrder, data1, data2 = false, isData2PropertyOfData1 = false) => {
  if (data2) {
    let propsData2 = [...column.path];
    let propsData1 = propsData2.shift();
    if (isData2PropertyOfData1) {
      return compareValuesData2PropertyValueOfData1(data1, data2, propsData1, propsData2, sortOrder);
    }
  }
  return simpleCompare(data1, column.path, sortOrder);
};
const simpleCompare = (data1, props, sortOrder) => {
  data1.sort((a, b) => compareValues(a, b, [...props], sortOrder));
  return data1;
};
const compareValuesData2PropertyValueOfData1 = (data1, data2, propsData1, propsData2, sortOrder) => {
  data1.sort((a, b) => {
    let values = getValues(a, b, [...propsData1]);
    let withEmptyValues = emptyValues(values.a, values.b, sortOrder);
    return withEmptyValues === false ? compareValues(data2[values.a], data2[values.b], [...propsData2], sortOrder) : withEmptyValues;
  });
  return data1;
};
const emptyValues = (a, b, sortOrder) => {
  if (a.length === 0 && b.length === 0) return 0;
  if (a.length === 0 && sortOrder === DESC) return 1;
  if (a.length === 0 && sortOrder === ASC) return -1;
  if (b.length === 0 && sortOrder === DESC) return -1;
  if (b.length === 0 && sortOrder === ASC) return 1;
  return false;
};
const getValues = (a, b, properties) => {
  let length = properties.length;
  let prop = properties.shift();
  while (length > 1) {
    a = a[prop] ?? [];
    b = b[prop] ?? [];
    prop = properties.shift();
    length--;
  }
  return {
    a: a[prop] ?? [],
    b: b[prop] ?? []
  };
};
const compare = (a, b, order) => {
  let cmp = 0;
  if (typeof a === 'string') a = a.toLowerCase();
  if (typeof b === 'string') b = b.toLowerCase();
  if (a < b) {
    cmp = -1;
  } else if (a > b) {
    cmp = 1;
  }
  if (order === DESC) {
    cmp = -cmp;
  }
  return cmp;
};
const compareValues = (a, b, properties, order) => {
  let length = properties.length;
  let prop = properties.shift();
  while (length > 1) {
    a = a[prop] ?? [];
    b = b[prop] ?? [];
    prop = properties.shift();
    length--;
  }
  return compare(a[prop] ?? '', b[prop] ?? '', order);
};

const validateEmail = email => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

const colors$1 = {
  // Base colors
  primaryColor: 'var(--primary-color)',
  primary50: 'var(--primary-50)',
  primary20: 'var(--primary-20)',
  primary10: 'var(--primary-10)',
  primaryColorRgb: 'var(--primary-color-rgb)',
  secondaryColor: 'var(--secondary-color)',
  secondary50: 'var(--secondary-50)',
  secondary20: 'var(--secondary-20)',
  secondary10: 'var(--secondary-10)',
  // Program colors
  preArrival: 'var(--pre-arrival)',
  preArrival50: 'var(--pre-arrival-50)',
  preArrival20: 'var(--pre-arrival-20)',
  preArrival10: 'var(--pre-arrival-10)',
  preArrivalRoomUpgrades: 'var(--pre-arrival-room-upgrades)',
  preArrivalBookedExtras: 'var(--pre-arrival-booked-extras)',
  onArrival: 'var(--on-arrival)',
  onArrival50: 'var(--on-arrival-50)',
  onArrival20: 'var(--on-arrival-20)',
  onArrival10: 'var(--on-arrival-10)',
  onArrivalRoomUpgrades: 'var(--on-arrival-room-upgrades)',
  onArrivalBookedExtras: 'var(--on-arrival-booked-extras)',
  inStay: 'var(--in-stay)',
  inStay50: 'var(--in-stay-50)',
  inStay20: 'var(--in-stay-20)',
  inStay10: 'var(--in-stay-10)',
  // Misc colors
  white: 'var(--white)',
  text: 'var(--text)',
  grey: 'var(--grey)',
  grey64: 'var(--grey-64)',
  grey20: 'var(--grey-20)',
  grey8: 'var(--grey-8)',
  bgDark: 'var(--bg-dark)',
  bgLight: 'var(--bg-light)',
  bgLight80: 'var(--bg-light-80)',
  bgLight48: 'var(--bg-light-48)',
  // Status colors
  success: 'var(--success)',
  success10: 'var(--success-10)',
  success20: 'var(--success-20)',
  danger: 'var(--danger)',
  danger10: 'var(--danger-10)',
  danger20: 'var(--danger-20)',
  warning: 'var(--warning)',
  warning10: 'var(--warning-10)',
  warning20: 'var(--warning-20)',
  disabled: 'var(--disabled)',
  // Tips colors
  tips: 'var(--tips)',
  tips20: 'var(--tips-20)'
};

async function urlToFile(url, fileName) {
  const response = await axios.get(url, {
    responseType: 'blob'
  });
  const blob = response.data;
  const mimeType = response.headers['content-type'] || blob.type;
  if (!fileName) {
    const extension = mimeType.split('/')[1];
    fileName = `file.${extension}`;
  }
  return new File([blob], fileName, {
    type: mimeType
  });
}
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

const getCSSVariable = name => {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
};

const formatCompactNumber = (n, checkInteger, fractionDigits = 2) => {
  let num;
  if (n < 1e3) {
    num = Number.parseFloat(n.toFixed(fractionDigits));
    return checkInteger && Number.isInteger(num) ? num.toFixed() : num.toFixed(fractionDigits);
  }
  if (n >= 1e3 && n < 1e6) {
    num = Number.parseFloat(+(n / 1e3).toFixed(fractionDigits));
    return checkInteger && Number.isInteger(num) ? num.toFixed() + "K" : num.toFixed(fractionDigits) + "K";
  }
  if (n >= 1e6 && n < 1e9) {
    num = Number.parseFloat(+(n / 1e6).toFixed(fractionDigits));
    return checkInteger && Number.isInteger(num) ? num.toFixed() + "M" : num.toFixed(fractionDigits) + "M";
  }
  if (n >= 1e9 && n < 1e12) {
    num = Number.parseFloat(+(n / 1e9).toFixed(fractionDigits));
    return checkInteger && Number.isInteger(num) ? num.toFixed() + "B" : num.toFixed(fractionDigits) + "B";
  }
  if (n >= 1e12) {
    num = Number.parseFloat(+(n / 1e12).toFixed(fractionDigits));
    return checkInteger && Number.isInteger(num) ? num.toFixed() + "T" : num.toFixed(fractionDigits) + "T";
  }
};

const formatCurrency = (amount, currencyCode, compact, showDecimals = true) => {
  if (!amount) {
    amount = 0;
  }
  let formatter = new Intl.NumberFormat();
  if (!currencyCode) {
    if (compact) {
      amount = formatCompactNumber(amount, true);
    } else if (!showDecimals) {
      amount = Math.round(amount);
    } else {
      amount = Number.isInteger(amount) ? amount : amount.toFixed(2);
    }
    return formatter.format(amount);
  }
  if (!Intl.NumberFormat) {
    if (compact) {
      return currencyCode + ' ' + formatCompactNumber(amount, true);
    }
    if (!showDecimals) {
      return currencyCode + ' ' + Math.round(amount);
    }
    return currencyCode + ' ' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
  }
  let options = {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: 'narrowSymbol'
  };
  if (compact) {
    options['notation'] = 'compact';
  }
  if (!showDecimals) {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }
  return new Intl.NumberFormat(navigator.language, options).format(amount);
};

/**
 * Formats a numeric percentage for display, e.g. 82.97 -> '83%'.
 *
 * Returns null when there is no number to show, so callers can decide between hiding the value
 * and rendering their own placeholder instead of printing a stray '%'.
 */
const formatPercentage = (value, decimals = 0) => {
  if (typeof value === 'string' && value.trim() === '') {
    return null;
  }
  const numericValue = typeof value === 'string' ? Number(value) : value;
  if (typeof numericValue !== 'number' || !Number.isFinite(numericValue)) {
    return null;
  }
  return `${numericValue.toFixed(decimals)}%`;
};

let cachedTextarea = null;

/**
 * Decodes HTML entities in a plain-text string (e.g. "What Is Upselling &amp; Cross-Selling"
 * becomes "What Is Upselling & Cross-Selling"). Returns the input unchanged when there are
 * no entities to decode, when the input is not a string, or when running outside a browser
 * (no `document` available — useful for SSR safety).
 *
 * Use for titles, labels, and any text coming from a backend that may include escaped HTML
 * entities. Do NOT use to render formatted HTML — for that, sanitize and use
 * `dangerouslySetInnerHTML`.
 */
const decodeHtmlEntities = text => {
  if (typeof text !== 'string' || !text.includes('&')) {
    return text;
  }
  if (typeof document === 'undefined') {
    return text;
  }
  if (!cachedTextarea) {
    cachedTextarea = document.createElement('textarea');
  }
  cachedTextarea.innerHTML = text;
  return cachedTextarea.value;
};

const restUrls = {
  loadUserProfile: '/me/whoami',
  saveUserProfile: '/account',
  loadTranslations: '/translations',
  reservationBundleChangeStatus: '/reservation_bundles/change_status',
  // Tasks & Annotations
  usersList: '/users/list_users_access_hotel',
  cscUsersList: '/users/customer_success_consultant_list',
  tasksTodoCount: '/tasks/todoCount',
  tasksList: '/tasks',
  markTaskAsDone: '/tasks/mark_as_done',
  assignTaskToUser: '/tasks/assign',
  changeDueDate: '/tasks/change_due_date',
  projectsList: '/projects',
  tasksSaveProject: '/projects/save_project',
  tasksCommentsList: '/tasks/list_comments',
  taskSaveComment: '/tasks/save_comment',
  taskRemove: '/tasks/remove',
  taskRemoveComment: '/tasks/remove_comment',
  tasksDeleteProject: '/projects/delete',
  annotationsList: '/annotations',
  annotationsRemove: '/annotations/remove',
  annotationsCommentsList: '/annotations/list_comments',
  annotationsSaveComment: '/annotations/save_comment',
  annotationRemoveComment: '/annotations/remove_comment'
};
const taskDueDateStatus = {
  OVERDUE: 'OVERDUE',
  DUE_TODAY: 'DUE_TODAY',
  DUE_TOMORROW: 'DUE_TOMORROW',
  DUE_CURRENT_WEEK: 'DUE_CURRENT_WEEK',
  DUE_NEXT_WEEK: 'DUE_NEXT_WEEK'
};
const tasksPriorities = [{
  label: 'Low',
  value: 'LOW'
}, {
  label: 'Medium',
  value: 'MEDIUM'
}, {
  label: 'High',
  value: 'HIGH'
}, {
  label: 'Urgent',
  value: 'URGENT'
}];
const visibilityFilters = [{
  label: 'All',
  value: ''
}, {
  label: 'Hotel',
  value: 'HOTEL'
}, {
  label: 'USG',
  value: 'USG'
}, {
  label: 'Reseller',
  value: 'RESELLER'
}];
const taskPriorityColours = {
  LOW_BG: '#B7E6AC',
  LOW_TEXT: '#4A8A3B',
  MEDIUM_BG: '#FFECC8',
  MEDIUM_TEXT: '#DCA311',
  HIGH_BG: '#F8D5BC',
  HIGH_TEXT: '#AF5413',
  URGENT_BG: '#F2DEDD',
  URGENT_TEXT: '#D55244'
};
const taskStatus = {
  TODO: 'TODO',
  DONE: 'DONE',
  DELETED: 'DELETED'
};
const taskPriority = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  URGENT: 'URGENT'
};
const reservationBundleDecision = {
  ACCEPT: 'ACCEPT',
  DECLINE: 'DECLINE'
};
const upgradeBidRejectionReasons = [{
  label: 'No Room Type Availability',
  value: 'NO_ROOM_TYPE_AVAILABILITY'
}, {
  label: 'Limited Room Type Availability',
  value: 'LIMITED_ROOM_TYPE_AVAILABILITY'
}, {
  label: 'Offer too weak for current occupancy',
  value: 'OFFER_TOO_WEAK'
}, {
  label: "Guest can't be upgraded to different room type",
  value: 'GUEST_CANT_BE_UPGRADED'
}, {
  label: 'Payment was not received',
  value: 'PAYMENT_NOT_RECEIVED'
}];
const bookedExtraStatus = {
  CONFIRMED: 'CONFIRMED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  CANCELLED: 'CANCELLED'
};
const roomUpgradesStatus = {
  CONFIRMED: 'CONFIRMED',
  PENDING: 'PENDING',
  CANCELLED: 'CANCELLED',
  REPLACED: 'REPLACED'
};
const upgradeBidsStatus = {
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  PENDING: 'PENDING'
};
const programs = {
  A: 'PRE_ARRIVAL',
  B: 'ON_ARRIVAL',
  C: 'IN_STAY'
};
const touchpoints = {
  RESERVATION_CONFIRMATION: 'RESERVATION_CONFIRMATION',
  PRE_ARRIVAL_UPSELLING: 'PRE_ARRIVAL_UPSELLING',
  PRE_ARRIVAL_UPSELLING_REMINDER: 'PRE_ARRIVAL_UPSELLING_REMINDER',
  AT_RESERVATION: 'AT_RESERVATION',
  REGISTRATION_CARD: 'REGISTRATION_CARD',
  FRONT_DESK: 'FRONT_DESK',
  SPA: 'SPA',
  F_AND_B: 'F_AND_B',
  INHOUSE_EXTRAS: 'INHOUSE_EXTRAS',
  HOTEL_DIRECTORY: 'HOTEL_DIRECTORY'
};
const programBTouchpoints = [touchpoints.FRONT_DESK, touchpoints.F_AND_B, touchpoints.SPA, touchpoints.AT_RESERVATION];
const transactionsStatus$1 = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  EXPIRED: 'EXPIRED',
  REPLACED: 'REPLACED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING',
  BYPASSED: 'BYPASSED'
};
const roomAvailabilityCapturePoint = {
  AT_CREATION: 'AT_CREATION',
  AT_DECISION: 'AT_DECISION',
  AT_CHECKIN: 'AT_CHECKIN',
  AT_CHECKOUT: 'AT_CHECKOUT',
  CURRENT: 'CURRENT',
  AT_CREATION_FROM: 'AT_CREATION_FROM',
  AT_DECISION_FROM: 'AT_DECISION_FROM'
};
const dataLoadingStatus$9 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const HOTEL_STATUS = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
  ONBOARDING: 'ONBOARDING',
  TERMINATED: 'TERMINATED'
};
const userRoles = {
  ACCOUNT_ADMIN: 'ACCOUNT_ADMIN',
  USER: 'USER',
  ADMIN: 'ADMIN',
  TRAINER: 'TRAINER',
  TRANSLATOR: 'TRANSLATOR',
  SYSTEM: 'SYSTEM',
  RESELLER: 'RESELLER',
  USG_EMPLOYEE_SALES: 'USG_EMPLOYEE_SALES'
};
const featureFlagsCodes = {
  ALTERNATIVE_UPGRADES: 'ALTERNATIVE_UPGRADES',
  BIDS_AUTOPILOT: 'BIDS_AUTOPILOT',
  ROOM_UPGRADES_FIXED_PRICES: 'ROOM_UPGRADES_FIXED_PRICES',
  ROOM_UPGRADES_FIXED_PRICES_INSTANT_CONFIRMATION: 'ROOM_UPGRADES_FIXED_PRICES_INSTANT_CONFIRMATION',
  EMAIL_TEMPLATE_GALLERY: 'EMAIL_TEMPLATE_GALLERY',
  EMAIL_TEMPLATE_EXPERIMENT: 'EMAIL_TEMPLATE_EXPERIMENT',
  MANUALLY_SELECTED_EXTRAS: 'MANUALLY_SELECTED_EXTRAS',
  SEND_REQUESTS_MANUALLY: 'SEND_REQUESTS_MANUALLY',
  NO_ROOM_TYPE_NOT_MAPPED_EMAIL: 'NO_ROOM_TYPE_NOT_MAPPED_EMAIL',
  NO_CSV_REPORT_RECEIPT_CHECK: 'NO_CSV_REPORT_RECEIPT_CHECK',
  CAR_RENTAL: 'CAR_RENTAL',
  GUSTAVE: 'GUSTAVE',
  AGODA_EMAILS: 'AGODA_EMAILS',
  GUEST_RETARGETING: 'GUEST_RETARGETING',
  HIDE_REGULAR_UPGRADE_PRICE: 'HIDE_REGULAR_UPGRADE_PRICE',
  CHANGEABLE_GUEST_PAGE_INTRODUCTIONS: 'CHANGEABLE_GUEST_PAGE_INTRODUCTIONS',
  BLOCK_ROOMS_FOR_DATES: 'BLOCK_ROOMS_FOR_DATES',
  DISABLE_REGISTRATION_CARD_UPSELLING: 'DISABLE_REGISTRATION_CARD_UPSELLING',
  INSTANT_ROOM_UPGRADE: 'INSTANT_ROOM_UPGRADE',
  RESERVATION_CONFIRMATION_SETUP: 'RESERVATION_CONFIRMATION_SETUP',
  PRE_ARRIVAL_CONCIERGE_EMAIL_SETUP: 'PRE_ARRIVAL_CONCIERGE_EMAIL_SETUP',
  POSTSTAY_EMAIL_SETUP: 'POSTSTAY_EMAIL_SETUP',
  REGISTRATION_CARD_EMAIL_DELIVERY: 'REGISTRATION_CARD_EMAIL_DELIVERY',
  RESERVATION_CONFIRMATION_DELIVERY: 'RESERVATION_CONFIRMATION_DELIVERY',
  PRE_ARRIVAL_CONCIERGE_EMAIL_DELIVERY: 'PRE_ARRIVAL_CONCIERGE_EMAIL_DELIVERY',
  PRE_ARRIVAL_UPSELLING_EMAIL_DELIVERY: 'PRE_ARRIVAL_UPSELLING_EMAIL_DELIVERY',
  PRE_ARRIVAL_UPSELLING_REMINDER_EMAIL_DELIVERY: 'PRE_ARRIVAL_UPSELLING_REMINDER_EMAIL_DELIVERY',
  POSTSTAY_EMAIL_DELIVERY: 'POSTSTAY_EMAIL_DELIVERY',
  MOBILE_MESSAGE_DELIVERY: 'MOBILE_MESSAGE_DELIVERY',
  MOBILE_MESSAGES: 'MOBILE_MESSAGES',
  DISABLE_ROOM_UPGRADE_NOTIFICATION_EMAIL_DELIVERY: 'DISABLE_ROOM_UPGRADE_NOTIFICATION_EMAIL_DELIVERY',
  DISABLE_BOOKED_EXTRA_NOTIFICATION_EMAIL_DELIVERY: 'DISABLE_BOOKED_EXTRA_NOTIFICATION_EMAIL_DELIVERY',
  INHOUSE_MESSAGE_SETUP: 'INHOUSE_MESSAGE_SETUP',
  FIRST_INHOUSE_MESSAGE_DELIVERY: 'FIRST_INHOUSE_MESSAGE_DELIVERY',
  SECOND_INHOUSE_MESSAGE_DELIVERY: 'SECOND_INHOUSE_MESSAGE_DELIVERY',
  THIRD_INHOUSE_MESSAGE_DELIVERY: 'THIRD_INHOUSE_MESSAGE_DELIVERY',
  INHOUSE_RESERVATION_SEARCH: 'INHOUSE_RESERVATION_SEARCH',
  HOTEL_DIRECTORY: 'HOTEL_DIRECTORY',
  HOTEL_DIRECTORY_VOICE_AGENT: 'HOTEL_DIRECTORY_VOICE_AGENT',
  REGISTRATION_CARD: 'REGISTRATION_CARD',
  STORE_REGISTRATION_CARDS: 'STORE_REGISTRATION_CARDS',
  REGISTRATION_CARD_KEYCARD: 'REGISTRATION_CARD_KEYCARD',
  SHOW_CONTACT_DETAILS_GUESTS_PROFILES: 'SHOW_CONTACT_DETAILS_GUESTS_PROFILES',
  RESERVATION_CANCELLATION_SETUP: 'RESERVATION_CANCELLATION_SETUP',
  RESERVATION_CANCELLATION_DELIVERY: 'RESERVATION_CANCELLATION_DELIVERY',
  CALCULATE_AVAILABILITY_FROM_RESERVATIONS: 'CALCULATE_AVAILABILITY_FROM_RESERVATIONS',
  VERIFY_ROOM_AVAILABILITY: 'VERIFY_ROOM_AVAILABILITY',
  ROOM_UPGRADE_DYNAMIC_PRICING: 'ROOM_UPGRADE_DYNAMIC_PRICING',
  ROOM_UPGRADE_ENHANCED_DYNAMIC_PRICING: 'ROOM_UPGRADE_ENHANCED_DYNAMIC_PRICING',
  YIELD_MINIMUM_ROOM_UPGRADE_PRICE: 'YIELD_MINIMUM_ROOM_UPGRADE_PRICE',
  HIDE_GUEST_PAGES_SAME_DAY_ARRIVALS: 'HIDE_GUEST_PAGES_SAME_DAY_ARRIVALS',
  SECURITY_2FA_CHALLENGE: 'SECURITY_2FA_CHALLENGE',
  REALTIME_ROOM_UPGRADE_BIDS_AUTOPILOT: 'REALTIME_ROOM_UPGRADE_BIDS_AUTOPILOT',
  UPSELL_WITH_CURRENT_RESERVATION_ROOM_TYPE: 'UPSELL_WITH_CURRENT_RESERVATION_ROOM_TYPE',
  HIGHLIGHT_MOST_POPULAR_ROOM_UPGRADES: 'HIGHLIGHT_MOST_POPULAR_ROOM_UPGRADES',
  MANUAL_EXTRA_DISPLAY_SEQUENCE: 'MANUAL_EXTRA_DISPLAY_SEQUENCE',
  TRACK_CONFIRMATION_NUMBER: 'TRACK_CONFIRMATION_NUMBER',
  GUSTAVE_ALLOW_TWO_WAYS_INTEGRATIONS: 'GUSTAVE_ALLOW_TWO_WAYS_INTEGRATIONS',
  GUSTAVE_DISABLE_ROOM_UPGRADE_PRICE_EDIT: 'GUSTAVE_DISABLE_ROOM_UPGRADE_PRICE_EDIT',
  GUSTAVE_RESERVATIONS_DEPARTMENT: 'GUSTAVE_RESERVATIONS_DEPARTMENT',
  GUSTAVE_SHOW_ROOM_TYPE_COMPARISON: 'GUSTAVE_SHOW_ROOM_TYPE_COMPARISON',
  GUSTAVE_HIDE_DASHBOARD_LEADERBOARDS: 'GUSTAVE_HIDE_DASHBOARD_LEADERBOARDS',
  GUSTAVE_HIDE_PROCEED_WITHOUT_RESERVATION: 'GUSTAVE_HIDE_PROCEED_WITHOUT_RESERVATION',
  EXTERNAL_PAYMENT_GATEWAY: 'EXTERNAL_PAYMENT_GATEWAY',
  EXTERNAL_PRE_REGISTRATION: 'EXTERNAL_PRE_REGISTRATION',
  USER_PROFILE_PICTURE: 'USER_PROFILE_PICTURE',
  EXTERNAL_SURVEY: 'EXTERNAL_SURVEY',
  ONSITE_TRANSACTION_TARGET_CALCULATOR: 'ONSITE_TRANSACTION_TARGET_CALCULATOR',
  SENIOR_LEADERSHIP_REPORT: 'SENIOR_LEADERSHIP_REPORT',
  WHATSAPP: 'WHATSAPP',
  TASKS: 'TASKS',
  SMS: 'SMS',
  PRODUCT_LITE: 'PRODUCT_LITE',
  CROSS_PROPERTY_ROOM_UPGRADES: 'CROSS_PROPERTY_ROOM_UPGRADES',
  SPOTLIGHT_LIST: 'SPOTLIGHT_LIST',
  CREATE_TASKS_FROM_ALERTS: 'CREATE_TASKS_FROM_ALERTS',
  SEND_RESERVATION_DATES_CHANGED_NOTIFICATION: 'SEND_RESERVATION_DATES_CHANGED_NOTIFICATION',
  SHOW_ROOM_TYPE_ANALYSIS: 'SHOW_ROOM_TYPE_ANALYSIS',
  IMPROVE_ROOM_TYPE_DESCRIPTION: 'IMPROVE_ROOM_TYPE_DESCRIPTION',
  SHOW_COACHING_TIPS: 'SHOW_COACHING_TIPS',
  SHOW_FLASHCARDS: 'SHOW_FLASHCARDS',
  ELEARNING_VIDEO: 'ELEARNING_VIDEO',
  GUSTAVE_USE_NEW_ADD_TRANSACTIONS_PAGE: 'GUSTAVE_USE_NEW_ADD_TRANSACTIONS_PAGE',
  ON_ARRIVAL_CONFIRMATION_EMAIL: 'ON_ARRIVAL_CONFIRMATION_EMAIL',
  UPGRADE_OFFER_CONFIRMATION_DELIVERY: 'UPGRADE_OFFER_CONFIRMATION_DELIVERY',
  BOOKED_EXTRAS_CONFIRMATION_DELIVERY: 'BOOKED_EXTRAS_CONFIRMATION_DELIVERY',
  UPGRADE_ACCEPTED_DELIVERY: 'UPGRADE_ACCEPTED_DELIVERY',
  UPGRADE_DENIED_DELIVERY: 'UPGRADE_DENIED_DELIVERY',
  ALTERNATIVE_UPGRADE_DELIVERY: 'ALTERNATIVE_UPGRADE_DELIVERY',
  ON_ARRIVAL_CONFIRMATION_DELIVERY: 'ON_ARRIVAL_CONFIRMATION_DELIVERY',
  PRE_ARRIVAL_PAYMENT_REQUIRED: 'PRE_ARRIVAL_PAYMENT_REQUIRED',
  REQUIRE_UPGRADE_BID_REJECTION_REASON: 'REQUIRE_UPGRADE_BID_REJECTION_REASON',
  AI_INSIGHTS: 'AI_INSIGHTS'
};

const getRootStyle = rootVar => {
  let docStyle = getComputedStyle(document.documentElement);
  return docStyle.getPropertyValue(rootVar);
};

const encodeFilters = filters => {
  return btoa(JSON.stringify(filters));
};
const decodeFilters = encoded => {
  return JSON.parse(atob(encoded));
};
const readFiltersFromUrl = () => {
  const encoded = new URLSearchParams(window.location.search).get('filters');
  if (!encoded) {
    return null;
  }
  try {
    return decodeFilters(encoded);
  } catch (error) {
    return null;
  }
};

let lastId = 0;
const genid = (prefix = 'genid', previous = false) => {
  if (!previous) {
    lastId++;
  }
  return `${prefix}${lastId}`;
};

const range = (start, stop, step) => Array.from({
  length: Math.max(0, Math.ceil((stop + 1 - start) / step))
}, (_, i) => start + i * step);

const getColour = colour => {
  if (!colour) {
    return '';
  }
  return colour.startsWith('#') ? colour : '#' + colour;
};

const changeWhitelabelTheme = whitelabel => {
  for (const [property, value] of Object.entries(whitelabel)) {
    if (value === '') {
      continue;
    }
    document.documentElement.style.setProperty(property, value);
  }
};
const changeWhitelabelThemeV2 = whitelabel => {
  document.documentElement.style.setProperty('--primary-color', whitelabel['--primaryColor']);
  document.documentElement.style.setProperty('--secondary-color', whitelabel['--secondaryColor']);
};
const resetWhiteLabelTheme = () => {
  // eslint-disable-next-line
  for (const [property, value] of Object.entries(document.documentElement.style)) {
    if (!value.includes('--')) {
      break;
    }
    document.documentElement.style.setProperty(value, null);
  }
};

const trackGroup = (posthog, currentHotel) => {
  posthog.resetGroups();
  if (currentHotel) {
    posthog.group('hotel', currentHotel.id);
  }
  if (currentHotel?.chainId) {
    posthog.group('chain', currentHotel.chainId);
  }
  if (currentHotel?.groupId) {
    posthog.group('group', currentHotel.groupId);
  }
};

/**
 * Centralized API endpoints for shared providers in usg-lib
 * These endpoints are used by providers that are shared across extranet and gustave
 */
const apiEndpoints = {
  // User & Auth
  whoami: '/me/whoami',
  loadHotelBookmarks: '/me/load_hotel_bookmarks',
  saveHotelBookmark: '/me/save_hotel_bookmark',
  saveUserSettings: '/me/save_user_settings',
  switchHotel: '/me/switch_hotel',
  // Hotels
  hotels: '/hotels',
  hotelsList: '/hotels/list',
  loadTestHotels: '/hotels/load_test_hotels',
  // Feature Flags
  featureFlags: '/feature_flags',
  saveFeatureFlags: '/feature_flags/save',
  // Room Types
  roomTypes: '/room_types',
  // Extra Types
  extraTypes: '/extra_types',
  // Bundles
  bundles: '/room_upgrade_bundles',
  // Market Segments
  marketSegments: '/market_segments',
  // Rate Plans
  ratePlans: '/rate_plans',
  // Reservation Sources
  reservationSources: '/reservation_sources',
  // Reseller
  resellerWhitelabel: '/resellers/white_label.json',
  reseller: '/resellers',
  // Reservation Profile - Upsells
  upgradeBidChangeStatus: '/upgrade_bids/change_status',
  upgradeBidReinstateStatus: '/upgrade_bids/amend_status',
  bookedExtraChangeStatus: '/booked_extras/change_status',
  bookedExtraReinstateStatus: '/booked_extras/amend_status',
  bookedExtraAmend: '/booked_extras/amend',
  upgradeBidAmendPrice: '/upgrade_bids/amend_price',
  roomTypeAvailability: '/room_type_availability',
  roomTypeAvailabilityHasAvailability: id => `/room_type_availability/has_availability/${id}`,
  alternativeUpgrades: '/alternative_upgrades.json',
  // // Reservation Profile - Registration Card
  regCardLink: '/reservations/registration_card_url',
  // Users
  usersList: '/users/list_users_access_hotel'
};

const ERROR_PLACEHOLDER = Symbol('ERROR');
const refCache = {
  _map: new Map(),
  _key: (type, id) => `${type}|${id}`,
  has(type, id) {
    return this._map.has(this._key(type, id));
  },
  get(type, id) {
    const value = this._map.get(this._key(type, id));
    if (value === ERROR_PLACEHOLDER) {
      return undefined;
    }
    return value;
  },
  set(type, id, value) {
    this._map.set(this._key(type, id), value);
  },
  setError(type, id) {
    this._map.set(this._key(type, id), ERROR_PLACEHOLDER);
  },
  isError(type, id) {
    return this._map.get(this._key(type, id)) === ERROR_PLACEHOLDER;
  },
  preloadMany(type, items) {
    items.forEach(item => {
      const id = item.id ?? item.uuid ?? item.code;
      if (id != null) this.set(type, id, item);
    });
  },
  clear() {
    this._map.clear();
  },
  debug() {
    const stats = {
      total: this._map.size,
      byType: {},
      errors: 0
    };
    for (const [key, value] of this._map.entries()) {
      const [type] = key.split('|');
      stats.byType[type] = (stats.byType[type] || 0) + 1;
      if (value === ERROR_PLACEHOLDER) {
        stats.errors++;
      }
    }
    console.table(stats);
    return stats;
  }
};

// Expose in development
if (process.env.NODE_ENV === 'development') {
  window.refCache = refCache;
}

// Cache promises to avoid creating duplicates
const promiseCache = new Map();

/**
 * Create or get cached promise for a reference
 */
const getOrCreatePromise = (type, id, ctx) => {
  const key = `${type}|${id}`;

  // Return existing promise if available
  if (promiseCache.has(key)) {
    return promiseCache.get(key);
  }

  // Create new promise
  const promise = new Promise(resolve => {
    // Report need
    ctx.reportNeed({
      type,
      id
    });

    // Subscribe to data arrival
    const unsubscribe = ctx.subscribe(key, () => {
      const value = refCache.get(type, id);
      promiseCache.delete(key); // Clean up
      unsubscribe();
      resolve(value);
    });
  });
  promiseCache.set(key, promise);
  return promise;
};

/**
 * Get a reference with Suspense support
 * Call this from provider getter functions to enable lazy loading with Suspense
 *
 * @param {string} type - Reference type (room_type, extra_type, etc.)
 * @param {string|number} id - Reference ID
 * @param {Object} refCollectorCtx - RefCollectorProvider context
 * @param {Object} [preloadedData] - Optional pre-loaded data to check first
 * @returns {Object|undefined} The reference object, or throws a Promise for Suspense
 *
 * @example
 * const getRoomType = useCallback((roomTypeId) => {
 *   return getSuspenseRef('room_type', roomTypeId, refCollectorCtx, roomTypesList);
 * }, [roomTypesList, refCollectorCtx]);
 */
function getSuspenseRef(type, id, refCollectorCtx, preloadedData = null) {
  if (!id) {
    return undefined;
  }

  // First check pre-loaded data (e.g., from initial list fetch)
  if (preloadedData && preloadedData[id]) {
    return preloadedData[id];
  }

  // Check if in refCache
  const cached = refCache.get(type, id);
  if (cached) {
    return cached;
  }

  // Check if there was an error loading this ref
  const isError = refCache.isError(type, id);
  if (isError) {
    return undefined;
  }

  // Not in cache and we have a collector context - throw promise for Suspense
  if (refCollectorCtx) {
    throw getOrCreatePromise(type, id, refCollectorCtx);
  }
  return undefined;
}

const TYPE_TO_URL = {
  room_type: apiEndpoints.roomTypes,
  extra_type: apiEndpoints.extraTypes,
  rate_plan: apiEndpoints.ratePlans,
  reservation_source: apiEndpoints.reservationSources,
  market_segment: apiEndpoints.marketSegments,
  hotel: apiEndpoints.hotelsList
};
const MAX_IDS_PER_REQUEST = 50;
function chunk(arr, size) {
  const out = [];
  for (let i = 0; i < arr.length; i += size) {
    out.push(arr.slice(i, i + size));
  }
  return out;
}
async function fetchChunk(type, idsChunk) {
  const url = TYPE_TO_URL[type];
  try {
    const response = await axios.get(url, {
      params: {
        'ids[]': idsChunk,
        extended: 'true'
      }
    });
    let dict = response.data;

    // Normalize array responses to dict
    if (Array.isArray(dict)) {
      const normalized = {};
      for (const item of dict) {
        const key = item.id ?? item.code ?? item.uuid;
        if (key != null) {
          normalized[key] = item;
        }
      }
      dict = normalized;
    }

    // Handle nested response (e.g., {extraTypes: {...}})
    if (type === 'extra_type' && dict.extraTypes) {
      dict = dict.extraTypes;
    }
    if (type === 'hotel' && dict.hotels) {
      dict = Object.fromEntries(dict.hotels.map(hotel => [hotel.id, hotel]));
    }

    // Cache successful fetches
    Object.entries(dict).forEach(([id, value]) => {
      refCache.set(type, id, value);
    });

    // Mark missing IDs as errors to prevent retry
    idsChunk.forEach(id => {
      if (!dict[id]) {
        refCache.setError(type, id);
      }
    });
  } catch (err) {
    console.warn(`Failed to fetch ${type} references (chunk of ${idsChunk.length}):`, err);
    // Mark all IDs in this chunk as errors
    idsChunk.forEach(id => {
      refCache.setError(type, id);
    });
    throw err;
  }
}
/**
 * Batch fetch references by type
 * @param {Array<{type: string, id: string|number}>} batch
 */
async function fetchRefs(batch) {
  if (!batch || batch.length === 0) {
    return;
  }
  const grouped = {};
  for (const {
    type,
    id
  } of batch) {
    if (!TYPE_TO_URL[type]) continue;
    grouped[type] ??= new Set();
    grouped[type].add(id);
  }
  const fetchPromises = [];
  for (const [type, idSet] of Object.entries(grouped)) {
    const ids = Array.from(idSet);
    const chunks = chunk(ids, MAX_IDS_PER_REQUEST);

    // Create a promise for each chunk
    for (const idsChunk of chunks) {
      fetchPromises.push(fetchChunk(type, idsChunk));
    }
  }

  // Execute all fetches in parallel
  await Promise.all(fetchPromises);
}

const useBroadcastChannel = channelName => {
  const [message, setMessage] = useState(null);
  const channel = new BroadcastChannel(channelName);
  useEffect(() => {
    const handleMessage = event => {
      setMessage(event.data);
    };
    channel.onmessage = handleMessage;

    // Clean up the channel when the component unmounts
    return () => {
      channel.close();
    };
  }, [channel]);
  const sendMessage = msg => {
    channel.postMessage(msg);
  };
  return {
    message,
    sendMessage
  };
};

const retrieveColumnsFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const columns = urlParams.get('columns');
  if (columns) {
    try {
      const decoded = decodeFilters(columns);
      if (Array.isArray(decoded)) {
        return decoded;
      }
    } catch (e) {}
  }
  return null;
};
const asColumnArray = value => Array.isArray(value) ? value : [];
const useColumnVisibility = ({
  defaultVisibleColumns,
  columnsVisibilityOptions,
  resolveColumnId,
  storageKey,
  onUrlStateChange
}) => {
  const [selectedColumns, setSelectedColumns] = useState(() => {
    const columnsFromUrl = retrieveColumnsFromUrl();
    if (columnsFromUrl) {
      return columnsFromUrl;
    }
    if (storageKey) {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        try {
          const parsed = JSON.parse(stored);
          if (Array.isArray(parsed)) {
            return parsed;
          }
        } catch (e) {}
      }
    }
    return asColumnArray(defaultVisibleColumns);
  });
  useEffect(() => {
    if (retrieveColumnsFromUrl()) {
      return;
    }
    if (storageKey && localStorage.getItem(storageKey)) {
      return;
    }
    setSelectedColumns(asColumnArray(defaultVisibleColumns));
  }, [defaultVisibleColumns, storageKey]);
  const visibleColumns = useMemo(() => {
    const migrated = resolveColumnId ? [...new Set(selectedColumns.map(resolveColumnId))] : selectedColumns;
    if (!Array.isArray(columnsVisibilityOptions) || columnsVisibilityOptions.length === 0) {
      return migrated;
    }
    const validValues = new Set(columnsVisibilityOptions.map(opt => opt.value));
    const validColumns = migrated.filter(column => validValues.has(column));
    return validColumns.length > 0 ? validColumns : asColumnArray(defaultVisibleColumns);
  }, [selectedColumns, columnsVisibilityOptions, resolveColumnId, defaultVisibleColumns]);
  const notifyUrlStateChange = useCallback(columns => {
    if (!onUrlStateChange) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    params.set('columns', encodeFilters(columns));
    onUrlStateChange(params);
  }, [onUrlStateChange]);
  const applyColumns = useCallback(columns => {
    const selection = asColumnArray(columns);
    setSelectedColumns(selection);
    if (storageKey) {
      localStorage.setItem(storageKey, JSON.stringify(selection));
    }
    notifyUrlStateChange(selection);
  }, [storageKey, notifyUrlStateChange]);
  return {
    visibleColumns,
    applyColumns
  };
};

/**
 * Custom hook for handling drag and drop functionality in tables
 * @param {Array} items - The array of items to be reordered
 * @param {Function} setItems - Function to update the items array
 * @param {Function} onSortChange - Optional callback when items are reordered
 * @param {string} positionKey - The key for the position field (default: 'position')
 * @returns {Object} Drag and drop handlers and state
 */
const useDragAndDrop = (items, setItems, onSortChange, positionKey = 'position') => {
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragOverIndexRef = useRef(null);
  const onDragStart = useCallback(index => {
    setDraggedIndex(index);
    // Add a small delay to ensure smooth animation
    setTimeout(() => {
      setDraggedIndex(index);
    }, 10);
  }, []);
  const onDragEnter = useCallback((index, isTargetDraggable = true) => {
    // Only show drop indicator if we're actually dragging and hovering over a different draggable row
    if (draggedIndex !== null && index !== draggedIndex && isTargetDraggable) {
      setDragOverIndex(index);
      dragOverIndexRef.current = index;
    }
  }, [draggedIndex]);
  const onDragLeave = useCallback(index => {
    // Clear the drop indicator when leaving the specific row
    if (dragOverIndex === index) {
      setDragOverIndex(null);
    }
  }, [dragOverIndex]);
  const onDragEnd = useCallback(() => {
    const currentDragOverIndex = dragOverIndexRef.current;

    // Clear drag states
    setDraggedIndex(null);
    setDragOverIndex(null);
    dragOverIndexRef.current = null;

    // If no valid drop target, return early
    if (draggedIndex === null || currentDragOverIndex === null || draggedIndex === currentDragOverIndex) {
      return;
    }

    // Add a small delay for smooth animation
    setTimeout(() => {
      const updated = [...items];
      const [removed] = updated.splice(draggedIndex, 1);
      updated.splice(currentDragOverIndex, 0, removed);

      // Update positions if positionKey is provided
      if (positionKey) {
        const withPositions = updated.map((item, i) => ({
          ...item,
          [positionKey]: i + 1
        }));
        setItems(withPositions);
        if (onSortChange) onSortChange(withPositions);
      } else {
        setItems(updated);
        if (onSortChange) onSortChange(updated);
      }
    }, 150);
  }, [draggedIndex, items, setItems, onSortChange, positionKey]);
  const onDragOver = useCallback((e, index, isTargetDraggable = true) => {
    e.preventDefault();
    // Update drag over index while dragging over a draggable row
    if (draggedIndex !== null && index !== draggedIndex && isTargetDraggable) {
      setDragOverIndex(index);
      dragOverIndexRef.current = index;
    }
  }, [draggedIndex]);
  return {
    draggedIndex,
    dragOverIndex,
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDragEnd,
    onDragOver
  };
};

const SidebarContext = /*#__PURE__*/createContext$1({
  isCollapsed: false
});
const SidebarProvider = ({
  children,
  isCollapsed
}) => {
  return /*#__PURE__*/jsx(SidebarContext.Provider, {
    value: {
      isCollapsed
    },
    children: children
  });
};
const useSidebar = () => {
  return useContext(SidebarContext);
};

/**
 * Hook to calculate the left offset for side panels based on sidebar state.
 * Returns undefined if sidebar context is not available (for backward compatibility).
 * 
 * @param {Object} options - Configuration options
 * @param {number} options.collapsedWidth - Width when sidebar is collapsed (default: 70)
 * @param {number} options.expandedWidth - Width when sidebar is expanded (default: 250)
 * @param {boolean} options.enabled - Whether to calculate the offset (default: true)
 * @returns {number|undefined} The calculated left offset or undefined
 */
const useSidePanelLeftOffset = ({
  collapsedWidth = 70,
  expandedWidth = 250,
  enabled = true
} = {}) => {
  const {
    isCollapsed
  } = useSidebar();
  return useMemo(() => {
    if (!enabled) {
      return undefined;
    }

    // If sidebar context is not available, isCollapsed will be false (default from context)
    // We can't distinguish between "context not available" and "sidebar expanded"
    // So we always return the offset if enabled
    return isCollapsed ? collapsedWidth : expandedWidth;
  }, [isCollapsed, collapsedWidth, expandedWidth, enabled]);
};

const MOBILE_BREAKPOINT$3 = 768;
const useIsMobileViewport$1 = () => {
  const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT$3;
  const [isMobile, setIsMobile] = useState(getIsMobile);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobile;
};

const useWindowWidth = () => {
  const getWidth = () => typeof window !== 'undefined' ? window.innerWidth : 1920;
  const [width, setWidth] = useState(getWidth);
  useEffect(() => {
    const handleResize = () => {
      setWidth(getWidth());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return width;
};

const MOBILE_BREAKPOINT$2 = 1024;

/**
 * Hook to calculate the left position for FixedBottomBar based on sidebar state and viewport.
 * Returns a string in the format "Xpx" that can be passed directly to FixedBottomBar's leftPosition prop.
 * 
 * @param {Object} options - Configuration options
 * @param {number} options.collapsedWidth - Width when sidebar is collapsed (default: 70)
 * @param {number} options.expandedWidth - Width when sidebar is expanded (default: 250)
 * @param {number} options.mobileBreakpoint - Breakpoint for mobile viewport (default: 1024)
 * @returns {string} The calculated left position as a string (e.g., "0px", "70px", "250px")
 */
const useFixedBottomBarPosition = ({
  collapsedWidth = 70,
  expandedWidth = 250,
  mobileBreakpoint = MOBILE_BREAKPOINT$2
} = {}) => {
  const sidebarContext = useSidebar();
  const sidebarCollapsed = sidebarContext?.isCollapsed ?? false;
  const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth <= mobileBreakpoint;
  const [isMobile, setIsMobile] = useState(getIsMobile);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [mobileBreakpoint]);
  const leftPosition = useMemo(() => {
    if (isMobile) {
      return '0px';
    }
    const currentSidebarWidth = sidebarCollapsed ? collapsedWidth : expandedWidth;
    return `${currentSidebarWidth}px`;
  }, [isMobile, sidebarCollapsed, collapsedWidth, expandedWidth]);
  return leftPosition;
};

//#region src/lib/parseHotkeys.ts
var l = [
	"shift",
	"alt",
	"meta",
	"mod",
	"ctrl",
	"control"
];
function u() {
	return typeof navigator > "u" ? !1 : /mac/i.test(navigator.userAgent) && !/iphone|ipad|ipod/i.test(navigator.userAgent);
}
var d = {
	esc: "escape",
	return: "enter",
	left: "arrowleft",
	right: "arrowright",
	up: "arrowup",
	down: "arrowdown",
	ShiftLeft: "shift",
	ShiftRight: "shift",
	AltLeft: "alt",
	AltRight: "alt",
	MetaLeft: "meta",
	MetaRight: "meta",
	OSLeft: "meta",
	OSRight: "meta",
	ControlLeft: "ctrl",
	ControlRight: "ctrl"
};
function f(e) {
	return (d[e.trim()] || e.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function p(e) {
	return l.includes(e);
}
function m(e, t = ",") {
	return e.toLowerCase().split(t);
}
function h(e, t = "+", n = ">", r = !1, i, a) {
	let o = [], s = !1;
	e = e.trim(), e.includes(n) ? (s = !0, o = e.toLocaleLowerCase().split(n).map((e) => f(e))) : o = e.toLocaleLowerCase().split(t).map((e) => f(e));
	let c = {
		alt: o.includes("alt"),
		ctrl: o.includes("ctrl") || o.includes("control"),
		shift: o.includes("shift"),
		meta: o.includes("meta"),
		mod: o.includes("mod"),
		useKey: r
	}, u = o.filter((e) => !l.includes(e));
	return {
		...c,
		keys: u,
		description: i,
		isSequence: s,
		hotkey: e,
		metadata: a
	};
}
//#endregion
//#region src/lib/isHotkeyPressed.ts
typeof document < "u" && (document.addEventListener("keydown", (e) => {
	e.code !== void 0 && y([f(e.code)]);
}), document.addEventListener("keyup", (e) => {
	e.code !== void 0 && b([f(e.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
	g.clear();
}), window.addEventListener("focus", () => {
	g.clear();
}), window.addEventListener("contextmenu", () => {
	setTimeout(() => {
		g.clear();
	}, 0);
})), typeof document < "u" && document.addEventListener("visibilitychange", () => {
	g.clear();
});
var g = /* @__PURE__ */ new Set();
function _(e) {
	return Array.isArray(e);
}
function v(e, t = ",") {
	return (_(e) ? e : e.split(t)).every((e) => g.has(e.trim().toLowerCase()));
}
function y(e) {
	let t = Array.isArray(e) ? e : [e];
	g.has("meta") && g.forEach((e) => {
		p(e) || g.delete(e.toLowerCase());
	}), t.forEach((e) => {
		g.add(e.toLowerCase());
	});
}
function b(e) {
	e === "meta" ? g.clear() : (Array.isArray(e) ? e : [e]).forEach((e) => {
		g.delete(e.toLowerCase());
	});
}
//#endregion
//#region src/lib/validators.ts
function x(e, t, n) {
	(typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function S(e, t, n) {
	return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
var C = [
	"input",
	"textarea",
	"select",
	"searchbox",
	"slider",
	"spinbutton",
	"menuitem",
	"menuitemcheckbox",
	"menuitemradio",
	"option",
	"radio",
	"textbox"
];
function w(e) {
	return T(e, C);
}
function T(e, t = !1) {
	let { target: n, composed: r } = e, i, a;
	return E(n) && r ? (i = e.composedPath()[0] && e.composedPath()[0].tagName, a = e.composedPath()[0] && e.composedPath()[0].role) : (i = n && n.tagName, a = n && n.role), _(t) ? !!(i && t?.some((e) => e.toLowerCase() === i.toLowerCase() || e === a)) : !!(i && t && t);
}
function E(e) {
	return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function D(e, t) {
	return e.length === 0 && t ? !1 : t ? e.some((e) => t.includes(e)) || e.includes("*") : !0;
}
var O = (e, t, n = !1) => {
	let { alt: r, meta: i, mod: a, shift: o, ctrl: s, keys: c, useKey: l } = t, { code: d, key: p, ctrlKey: m, metaKey: h, shiftKey: g, altKey: _ } = e, y = f(d), b = typeof e.getModifierState == "function" && e.getModifierState("AltGraph");
	if (!l && !c?.includes(y) && ![
		"ctrl",
		"control",
		"unknown",
		"meta",
		"alt",
		"shift",
		"os"
	].includes(y)) return !1;
	if (!n) {
		if (r !== _ && y !== "alt" || o !== g && y !== "shift") return !1;
		if (a) {
			if (u() ? !h : !m) return !1;
		} else if (i !== h && y !== "meta" && y !== "os" || s !== m && y !== "ctrl" && y !== "control") return !1;
		if (b && !r && !s && !a && ![
			"alt",
			"ctrl",
			"control"
		].includes(y)) return !1;
	}
	return l && c?.length === 1 && c.includes(p.toLowerCase()) || c && c.length === 1 && c.includes(y) ? !0 : c && c.length > 0 ? c.includes(y) ? v(c) : !1 : !c || c.length === 0;
}, k = createContext$1(void 0), A = () => useContext(k);
//#endregion
//#region src/lib/deepEqual.ts
function M(e, t) {
	return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && Object.keys(e).reduce((n, r) => n && M(e[r], t[r]), !0) : e === t;
}
//#endregion
//#region src/lib/HotkeysProvider.tsx
var N = createContext$1({
	hotkeys: [],
	activeScopes: [],
	toggleScope: () => {},
	enableScope: () => {},
	disableScope: () => {}
}), P = () => useContext(N);
//#endregion
//#region src/lib/useDeepEqualMemo.ts
function I(e) {
	let t = useRef(void 0);
	return M(t.current, e) || (t.current = e), t.current;
}
//#endregion
//#region src/lib/useHotkeys.ts
var L = (e) => {
	e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, R = typeof window < "u" ? useLayoutEffect : useEffect;
function z(e) {
	if (!e) return;
	let { enabled: t, preventDefault: n, ignoreEventWhen: r, ...i } = e;
	return typeof t == "function" ? i : {
		...i,
		enabled: t
	};
}
function B(e, n, r, i) {
	let [a, c] = useState(null), l = useCallback((e) => (c(e), () => c(null)), []), u = useRef(!1), d = Array.isArray(r) ? Array.isArray(i) ? void 0 : i : r, g = _(e) ? e.join(d?.delimiter) : e, v = Array.isArray(r) ? r : Array.isArray(i) ? i : void 0, C = useCallback(n, v ?? []), E = useRef(C);
	v ? E.current = C : E.current = n;
	let k = I(z(d)), j = useRef(d?.enabled);
	j.current = d?.enabled;
	let M = useRef(d?.preventDefault);
	M.current = d?.preventDefault;
	let N = useRef(d?.ignoreEventWhen);
	N.current = d?.ignoreEventWhen;
	let { activeScopes: F } = P(), B = A();
	return R(() => {
		if (j.current === !1 || !D(F, k?.scopes)) return;
		let e = [], t, n = (n, r = !1) => {
			if (!(w(n) && !T(n, k?.enableOnFormTags))) {
				if (a !== null) {
					let e = a.getRootNode();
					if ((e instanceof Document || e instanceof ShadowRoot) && e.activeElement !== a && !a.contains(e.activeElement)) {
						L(n);
						return;
					}
				}
				n.target?.isContentEditable && !k?.enableOnContentEditable || m(g, k?.delimiter).forEach((i) => {
					if (i.includes(k?.splitKey ?? "+") && i.includes(k?.sequenceSplitKey ?? ">")) {
						console.warn(`Hotkey ${i} contains both ${k?.splitKey ?? "+"} and ${k?.sequenceSplitKey ?? ">"} which is not supported.`);
						return;
					}
					let a = h(i, k?.splitKey, k?.sequenceSplitKey, k?.useKey, k?.description, k?.metadata);
					if (a.isSequence) {
						t = setTimeout(() => {
							e = [];
						}, k?.sequenceTimeoutMs ?? 1e3);
						let r = a.useKey ? n.key : f(n.code);
						if (p(r.toLowerCase())) return;
						if (e.push(r), r !== a.keys?.[e.length - 1]) {
							e = [], t && clearTimeout(t);
							return;
						}
						e.length === a.keys?.length && (E.current(n, a), t && clearTimeout(t), e = []);
					} else if (O(n, a, k?.ignoreModifiers) || a.keys?.includes("*")) {
						if (N.current?.(n) || r && u.current || (x(n, a, M.current), !S(n, a, j.current))) return;
						E.current(n, a), r || (u.current = !0);
					}
				});
			}
		}, r = (e) => {
			e.code !== void 0 && (y(f(e.code)), (k?.keydown === void 0 && k?.keyup !== !0 || k?.keydown) && n(e));
		}, i = (e) => {
			e.code !== void 0 && (b(f(e.code)), u.current = !1, k?.keyup && n(e, !0));
		}, o = a || d?.document || document;
		return o.addEventListener("keyup", i, d?.eventListenerOptions), o.addEventListener("keydown", r, d?.eventListenerOptions), B && m(g, k?.delimiter).forEach((e) => {
			B.addHotkey(h(e, k?.splitKey, k?.sequenceSplitKey, k?.useKey, k?.description, k?.metadata));
		}), () => {
			o.removeEventListener("keyup", i, d?.eventListenerOptions), o.removeEventListener("keydown", r, d?.eventListenerOptions), B && m(g, k?.delimiter).forEach((e) => {
				B.removeHotkey(h(e, k?.splitKey, k?.sequenceSplitKey, k?.useKey, k?.description, k?.metadata));
			}), e = [], t && clearTimeout(t);
		};
	}, [
		a,
		k,
		F,
		g
	]), l;
}

const CurrentUserContext = /*#__PURE__*/createContext$1({});

const CurrentUserProvider = ({
  initUser = null,
  children
}) => {
  const [currentUser, setCurrentUser] = useState(initUser);
  const [userIsLoggedIn, setUserIsLoggedIn] = useState(initUser === null ? null : true);
  const loadCurrentUser = useCallback(async () => {
    try {
      const response = await axios.get(apiEndpoints.whoami);
      setCurrentUser(response.data);
      setUserIsLoggedIn(true);
    } catch (error) {
      console.error('Failed to load current user:', error);
      setCurrentUser(null);
      setUserIsLoggedIn(false);
    }
  }, []);
  useEffect(() => {
    if (userIsLoggedIn === null) {
      loadCurrentUser();
    }
  }, [userIsLoggedIn]);
  const logout = useCallback(() => {
    setCurrentUser(null);
    setUserIsLoggedIn(false);
  }, []);
  const changeHotel = useCallback(newHotel => {
    let newUserData = structuredClone(currentUser);
    newUserData.currentHotelId = newHotel.id;
    setCurrentUser(newUserData);
  }, [currentUser]);
  const value = useMemo(() => ({
    currentUser,
    userIsLoggedIn,
    isLoading: userIsLoggedIn === null,
    isAuthenticated: userIsLoggedIn === true,
    loadCurrentUser,
    changeHotel,
    logout
  }), [currentUser, userIsLoggedIn, loadCurrentUser, logout]);
  return /*#__PURE__*/jsx(CurrentUserContext.Provider, {
    value: value,
    children: children
  });
};
const useCurrentUser = () => {
  const context = useContext(CurrentUserContext);
  if (!context) {
    throw new Error('useCurrentUser must be used within a CurrentUserProvider');
  }
  return context;
};

const CurrentHotelContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$8 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const CurrentHotelProvider = ({
  initHotel,
  children
}) => {
  const [currentHotel, setCurrentHotel] = useState(initHotel ?? null);
  const [loadingState, setLoadingState] = useState(initHotel ? dataLoadingStatus$8.success : dataLoadingStatus$8.idle);
  const [error, setError] = useState(null);
  const {
    currentUser,
    isLoading: isUserLoading
  } = useCurrentUser();
  const isLegacy = !window.location.pathname.startsWith('/app');
  const location = isLegacy ? window.location : useLocation();
  const interceptorIdRef = useRef(null);
  const currentHotelId = useMemo(() => {
    if (isLegacy) {
      return currentUser?.currentHotelId;
    }
    const pathParts = location.pathname.split('/');
    const hotelIdParam = parseInt(pathParts[1], 10);
    return !hotelIdParam ? null : hotelIdParam;
  }, [currentUser, location.pathname]);
  const loadCurrentHotel = useCallback(async () => {
    if (!currentHotelId) {
      setCurrentHotel(null);
      setLoadingState(dataLoadingStatus$8.success);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$8.loading);
    setError(null);
    try {
      const response = await axios.get(`${apiEndpoints.hotels}/${currentHotelId}`);
      setCurrentHotel(response.data);
      setLoadingState(dataLoadingStatus$8.success);
      return response.data;
    } catch (err) {
      console.error('Failed to load current hotel:', err);
      setError(err?.response?.data?.message || 'Failed to load hotel');
      setLoadingState(dataLoadingStatus$8.error);
      setCurrentHotel(null);
    }
  }, [currentHotelId]);
  const linkTo = useCallback(path => {
    return `/${currentHotelId ? currentHotelId : 'all'}/${path}`;
  }, [currentHotelId]);
  useEffect(() => {
    if (initHotel) {
      return;
    }
    if (isUserLoading) {
      return;
    }
    loadCurrentHotel();
  }, [currentUser?.currentHotelId, isUserLoading, loadCurrentHotel, initHotel]);
  useLayoutEffect(() => {
    if (interceptorIdRef.current !== null) {
      axios.interceptors.request.eject(interceptorIdRef.current);
      interceptorIdRef.current = null;
    }
    interceptorIdRef.current = axios.interceptors.request.use(config => {
      const params = {
        ...(config.params || {})
      };
      if (currentHotelId) {
        params.hotelId = currentHotelId;
      } else {
        delete params.hotelId;
      }
      return {
        ...config,
        params
      };
    });

    // Cleanup
    return () => {
      if (interceptorIdRef.current !== null) {
        axios.interceptors.request.eject(interceptorIdRef.current);
        interceptorIdRef.current = null;
      }
    };
  }, [currentHotelId]);
  const value = useMemo(() => ({
    currentHotel,
    loadingState,
    currentHotelId,
    isLoading: loadingState === dataLoadingStatus$8.loading,
    isHotelLoading: loadingState === dataLoadingStatus$8.loading,
    hasHotel: !!currentHotel,
    error,
    loadCurrentHotel,
    setCurrentHotel,
    linkTo
  }), [currentHotelId, currentHotel, loadingState, error, loadCurrentHotel, linkTo]);
  return /*#__PURE__*/jsx(CurrentHotelContext.Provider, {
    value: value,
    children: children
  });
};
const useCurrentHotel = () => {
  const context = useContext(CurrentHotelContext);
  if (!context) {
    throw new Error('useCurrentHotel must be used within a CurrentHotelProvider');
  }
  return context;
};

const useTrackedHotkeys = (keys, callback, action, options) => {
  const posthog = usePostHog();
  const navigate = useNavigate();
  const {
    linkTo
  } = useCurrentHotel();
  return B(keys, event => {
    if (callback && typeof callback === 'string') {
      posthog.capture('hotkey_triggered', {
        keys,
        action: 'goto:' + callback
      });
      navigate(linkTo(callback));
    } else {
      posthog.capture('hotkey_triggered', {
        keys,
        action: action || 'unknown'
      });
      callback(event);
    }
  }, options);
};

var css_248z$1F = ".DemoModeProvider-module__demoMode___hK90p:before{border:8px solid var(--secondary-color);content:\"\";inset:0;pointer-events:none;position:fixed;z-index:1000000}.DemoModeProvider-module__demoBadge___JyMjk{align-items:center;background-color:var(--secondary-color);border-radius:0 0 8px 8px;box-shadow:0 2px 8px rgba(0,0,0,.15);color:var(--white);display:flex;font-weight:600;gap:8px;left:50%;padding:8px 16px;position:fixed;top:0;transform:translateX(-50%);z-index:1000001}.DemoModeProvider-module__demoBadge___JyMjk svg{height:20px;width:20px}";
var css$1D = {"demoMode":"DemoModeProvider-module__demoMode___hK90p","demoBadge":"DemoModeProvider-module__demoBadge___JyMjk"};
styleInject(css_248z$1F);

const DemoModeContext = /*#__PURE__*/createContext$1({});

var css_248z$1E = ":root{--alert-info-bg:var(--bg-light);--alert-info-color:var(--primary-color);--alert-warning-bg:var(--warning-10);--alert-warning-color:var(--warning);--alert-success-bg:var(--success-10);--alert-success-color:var(--success);--alert-danger-bg:var(--danger-10);--alert-danger-color:var(--danger);--alert-tip-bg:var(--tips-20);--alert-tip-color:var(--tips)}.Alert-module__alert___zP4AL{align-items:center;border-radius:var(--border-radius-small);display:flex;gap:1rem;justify-content:space-between;margin-bottom:15px;padding:1rem}.Alert-module__alert___zP4AL .Alert-module__content___9Fty2{align-items:center;display:flex;flex:1;gap:15px}.Alert-module__alert___zP4AL .Alert-module__content___9Fty2 ol,.Alert-module__alert___zP4AL .Alert-module__content___9Fty2 ul{list-style-position:inside}.Alert-module__alert___zP4AL .Alert-module__icon___RUu7X{display:flex}.Alert-module__alert___zP4AL .Alert-module__icon___RUu7X svg{display:block;height:20px;width:20px}.Alert-module__alert___zP4AL .Alert-module__textWrapper___atS9m{align-items:flex-start;display:flex;flex-direction:column;gap:.25rem;margin-top:0}.Alert-module__alert___zP4AL .Alert-module__text___-Oyu2,.Alert-module__alert___zP4AL .Alert-module__title___QHuwO{font-size:var(--body-regular-size);font-weight:var(--font-weight-medium);line-height:var(--body-regular-line-height)}.Alert-module__alert___zP4AL .Alert-module__text___-Oyu2{color:var(--text)}.Alert-module__alert___zP4AL .Alert-module__button___Fd5z2{flex-shrink:0;margin-left:auto}.Alert-module__alert___zP4AL svg{min-width:18px}.Alert-module__alert___zP4AL.Alert-module__info___-J-F1{background-color:var(--alert-info-bg)}.Alert-module__alert___zP4AL.Alert-module__info___-J-F1 .Alert-module__title___QHuwO,.Alert-module__alert___zP4AL.Alert-module__info___-J-F1 svg{color:var(--alert-info-color)}.Alert-module__alert___zP4AL.Alert-module__info___-J-F1 .Alert-module__button___Fd5z2{border-bottom-color:var(--alert-info-color);color:var(--alert-info-color)}.Alert-module__alert___zP4AL.Alert-module__info___-J-F1 .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--alert-info-color);color:var(--alert-info-color);opacity:.8}.Alert-module__alert___zP4AL.Alert-module__tip___0jMUt{background-color:var(--alert-tip-bg)}.Alert-module__alert___zP4AL.Alert-module__tip___0jMUt .Alert-module__title___QHuwO,.Alert-module__alert___zP4AL.Alert-module__tip___0jMUt svg{color:var(--alert-tip-color)}.Alert-module__alert___zP4AL.Alert-module__tip___0jMUt .Alert-module__button___Fd5z2{border-bottom-color:var(--alert-tip-color);color:var(--alert-tip-color)}.Alert-module__alert___zP4AL.Alert-module__tip___0jMUt .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--alert-tip-color);color:var(--alert-tip-color);opacity:.8}.Alert-module__alert___zP4AL.Alert-module__warning___uOpos{background-color:var(--alert-warning-bg)}.Alert-module__alert___zP4AL.Alert-module__warning___uOpos .Alert-module__title___QHuwO,.Alert-module__alert___zP4AL.Alert-module__warning___uOpos svg{color:var(--alert-warning-color)}.Alert-module__alert___zP4AL.Alert-module__warning___uOpos .Alert-module__button___Fd5z2{border-bottom-color:var(--alert-warning-color);color:var(--alert-warning-color)}.Alert-module__alert___zP4AL.Alert-module__warning___uOpos .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--alert-warning-color);color:var(--alert-warning-color);opacity:.8}.Alert-module__alert___zP4AL.Alert-module__success___lftZT{background-color:var(--alert-success-bg)}.Alert-module__alert___zP4AL.Alert-module__success___lftZT .Alert-module__title___QHuwO,.Alert-module__alert___zP4AL.Alert-module__success___lftZT svg{color:var(--alert-success-color)}.Alert-module__alert___zP4AL.Alert-module__success___lftZT .Alert-module__button___Fd5z2{border-bottom-color:var(--alert-success-color);color:var(--alert-success-color)}.Alert-module__alert___zP4AL.Alert-module__success___lftZT .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--alert-success-color);color:var(--alert-success-color);opacity:.8}.Alert-module__alert___zP4AL.Alert-module__danger___53-01{background-color:var(--alert-danger-bg)}.Alert-module__alert___zP4AL.Alert-module__danger___53-01 .Alert-module__title___QHuwO,.Alert-module__alert___zP4AL.Alert-module__danger___53-01 svg{color:var(--alert-danger-color)}.Alert-module__alert___zP4AL.Alert-module__danger___53-01 .Alert-module__button___Fd5z2{border-bottom-color:var(--alert-danger-color);color:var(--alert-danger-color)}.Alert-module__alert___zP4AL.Alert-module__danger___53-01 .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--alert-danger-color);color:var(--alert-danger-color);opacity:.8}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6{animation:Alert-module__slideUp___unDlc .3s ease-out;background:#fff;border-radius:var(--border-radius-medium);box-shadow:0 10px 40px rgba(0,0,0,.3);margin-bottom:0;padding:15px}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__content___9Fty2{align-items:center;flex-direction:column;text-align:center}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__icon___RUu7X{align-items:center;align-self:center;margin-top:0}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__icon___RUu7X svg{color:var(--primary-color);height:25px;width:25px}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__textWrapper___atS9m{align-items:center}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__title___QHuwO{color:var(--text);font-size:var(--body-regular-size);font-weight:600}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__button___Fd5z2{border-bottom-color:var(--primary-color);color:var(--primary-color)}.Alert-module__alert___zP4AL.Alert-module__overlay___ui0F6 .Alert-module__button___Fd5z2:hover:not(.Alert-module__disabled___6nYYz){border-bottom-color:var(--primary-color);color:var(--primary-color);opacity:.8}@keyframes Alert-module__slideUp___unDlc{0%{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}.Alert-module__illustration___Xcmz9{bottom:-10px;pointer-events:none;position:absolute;right:0;z-index:0}@media (max-width:640px){.Alert-module__alert___zP4AL{align-items:stretch;flex-direction:column}.Alert-module__alert___zP4AL .Alert-module__button___Fd5z2{margin-left:0;text-align:left;width:100%}.Alert-module__alert___zP4AL .Alert-module__textWrapper___atS9m{align-items:flex-start;flex-direction:column;gap:.25rem}}";
var css$1C = {"alert":"Alert-module__alert___zP4AL","content":"Alert-module__content___9Fty2","icon":"Alert-module__icon___RUu7X","textWrapper":"Alert-module__textWrapper___atS9m","title":"Alert-module__title___QHuwO","text":"Alert-module__text___-Oyu2","button":"Alert-module__button___Fd5z2","info":"Alert-module__info___-J-F1","disabled":"Alert-module__disabled___6nYYz","tip":"Alert-module__tip___0jMUt","warning":"Alert-module__warning___uOpos","success":"Alert-module__success___lftZT","danger":"Alert-module__danger___53-01","overlay":"Alert-module__overlay___ui0F6","slideUp":"Alert-module__slideUp___unDlc","illustration":"Alert-module__illustration___Xcmz9"};
styleInject(css_248z$1E);

var css_248z$1D = ":root{--button-primary:var(--primary-color);--button-primary-color:var(--white);--button-primary-hover-bg:var(--bg-dark);--button-primary-hover-color:var(--primary-color);--button-secondary:var(--secondary-color);--button-secondary-color:var(--white);--button-secondary-hover-bg:var(--secondary-50);--button-secondary-hover-color:var(--white);--button-tertiary:var(--white);--button-tertiary-color:var(--text);--button-tertiary-border-color:var(--bg-dark);--button-tertiary-hover-border-color:var(--text);--button-disabled:var(--grey-8);--button-disabled-color:var(--grey-20);--button-disabled-border-color:var(--grey-20);--button-success:#10b981;--button-danger:#ef4444;--button-warning:#f59e0b;--button-info:#3b82f6}.Button-module__button___18Bed{align-items:center;border:1px solid transparent;border-radius:var(--border-radius-medium);cursor:pointer;display:inline-flex;font-size:var(--button-text-size);font-weight:var(--button-text-weight);gap:8px;justify-content:center;line-height:var(--button-text-line-height);min-width:fit-content;padding:12px 20px;transition:all .2s ease-in-out}.Button-module__button___18Bed .Button-module__badge___46FWg{align-items:center;background-color:var(--danger);border-radius:999px;box-sizing:border-box;color:#fff;display:inline-flex;font-size:11px;font-weight:500;height:20px;justify-content:center;line-height:1;margin-left:6px;min-width:20px;padding:0 6px}.Button-module__button___18Bed.Button-module__small___zfmcP{font-size:14px;max-height:35px;padding:8px}.Button-module__button___18Bed.Button-module__small___zfmcP .Button-module__icon___xIuVv svg{height:14px!important;width:14px!important}.Button-module__button___18Bed.Button-module__xsmall___QS3d-{font-size:12px;height:24px;padding:0 8px}.Button-module__button___18Bed.Button-module__xsmall___QS3d- .Button-module__icon___xIuVv svg{height:12px!important;width:12px!important}.Button-module__button___18Bed.Button-module__primary___st6yY{background-color:var(--button-primary);color:var(--button-primary-color)}.Button-module__button___18Bed.Button-module__primary___st6yY:hover:not(.Button-module__disabled___UzdWL){background-color:var(--button-primary-hover-bg);color:var(--button-primary-hover-color)}.Button-module__button___18Bed.Button-module__secondary___j-3rj{background-color:var(--button-secondary);color:var(--button-secondary-color)}.Button-module__button___18Bed.Button-module__secondary___j-3rj:hover:not(.Button-module__disabled___UzdWL){background-color:var(--button-secondary-hover-bg);color:var(--button-secondary-hover-color)}.Button-module__button___18Bed.Button-module__tertiary___Nd7xM{background-color:var(--button-tertiary);border:1px solid var(--button-tertiary-border-color);color:var(--button-tertiary-color)}.Button-module__button___18Bed.Button-module__tertiary___Nd7xM:hover:not(.Button-module__disabled___UzdWL){background-color:var(--button-tertiary);border-color:var(--button-tertiary-hover-border-color)}.Button-module__button___18Bed.Button-module__link___MzvJO{background-color:transparent;border:0;border-bottom:1.5px solid var(--primary-50);border-radius:0;color:var(--primary-50);font-size:var(--body-regular-size);padding:0 0 2px}.Button-module__button___18Bed.Button-module__link___MzvJO:hover:not(.Button-module__disabled___UzdWL){border-bottom:1px solid var(--primary-20);color:var(--primary-20)}.Button-module__button___18Bed.Button-module__link___MzvJO .Button-module__icon___xIuVv{font-size:inherit}.Button-module__button___18Bed.Button-module__link___MzvJO .Button-module__icon___xIuVv svg{height:12px;width:12px}.Button-module__button___18Bed.Button-module__ghost___kQ0A8{background-color:transparent;border-radius:var(--border-radius-small);padding:2px}.Button-module__button___18Bed.Button-module__success___CHTsg{background-color:var(--button-success);color:#fff}.Button-module__button___18Bed.Button-module__success___CHTsg:hover:not(.Button-module__disabled___UzdWL){opacity:.9}.Button-module__button___18Bed.Button-module__danger___Hxs5n{background-color:var(--button-danger);color:#fff}.Button-module__button___18Bed.Button-module__danger___Hxs5n:hover:not(.Button-module__disabled___UzdWL){opacity:.9}.Button-module__button___18Bed.Button-module__warning___1voOb{background-color:var(--button-warning);color:#fff}.Button-module__button___18Bed.Button-module__warning___1voOb:hover:not(.Button-module__disabled___UzdWL){opacity:.9}.Button-module__button___18Bed.Button-module__info___2z1ZG{background-color:var(--button-info);color:#fff}.Button-module__button___18Bed.Button-module__info___2z1ZG:hover:not(.Button-module__disabled___UzdWL){opacity:.9}.Button-module__button___18Bed.Button-module__disabled___UzdWL{background-color:var(--button-disabled);border-color:var(--button-disabled-border-color);color:var(--button-disabled-color);cursor:not-allowed;pointer-events:none}.Button-module__button___18Bed .Button-module__icon___xIuVv{align-items:center;color:currentColor;display:flex;justify-content:center}.Button-module__button___18Bed .Button-module__icon___xIuVv svg{color:currentColor;height:15px;width:15px}.Button-module__button___18Bed .Button-module__icon___xIuVv svg circle,.Button-module__button___18Bed .Button-module__icon___xIuVv svg line,.Button-module__button___18Bed .Button-module__icon___xIuVv svg path,.Button-module__button___18Bed .Button-module__icon___xIuVv svg rect{stroke:currentColor}.Button-module__button___18Bed .Button-module__content___PpYVU{align-items:center;display:flex;gap:4px;line-height:1}.Button-module__button___18Bed.Button-module__small___zfmcP .Button-module__content___PpYVU svg{height:14px;width:14px}.Button-module__button___18Bed.Button-module__xsmall___QS3d- .Button-module__content___PpYVU svg{height:12px;width:12px}";
var css$1B = {"button":"Button-module__button___18Bed","badge":"Button-module__badge___46FWg","small":"Button-module__small___zfmcP","icon":"Button-module__icon___xIuVv","xsmall":"Button-module__xsmall___QS3d-","primary":"Button-module__primary___st6yY","disabled":"Button-module__disabled___UzdWL","secondary":"Button-module__secondary___j-3rj","tertiary":"Button-module__tertiary___Nd7xM","link":"Button-module__link___MzvJO","ghost":"Button-module__ghost___kQ0A8","success":"Button-module__success___CHTsg","danger":"Button-module__danger___Hxs5n","warning":"Button-module__warning___1voOb","info":"Button-module__info___2z1ZG","content":"Button-module__content___PpYVU"};
styleInject(css_248z$1D);

const Button$1 = ({
  children,
  icon,
  iconPosition = 'left',
  variant = 'primary',
  size = 'default',
  disabled = false,
  fillWidth = false,
  onClick,
  className = '',
  type = 'button',
  count,
  ...props
}) => {
  const hasContent = children != null;
  const buttonClasses = [css$1B.button, css$1B[variant], css$1B[size], disabled ? css$1B.disabled : '', className].filter(Boolean).join(' ');
  return /*#__PURE__*/jsxs("button", {
    type: type,
    className: buttonClasses,
    onClick: onClick,
    disabled: disabled,
    style: {
      gap: icon && hasContent ? '8px' : '0',
      ...(fillWidth && {
        flex: 1
      })
    },
    ...props,
    children: [iconPosition === 'left' && icon && /*#__PURE__*/jsx("span", {
      className: css$1B.icon,
      children: icon
    }), hasContent && /*#__PURE__*/jsx("span", {
      className: css$1B.content,
      children: children
    }), typeof count === 'number' && /*#__PURE__*/jsx("span", {
      className: css$1B.badge,
      children: count
    }), iconPosition === 'right' && icon && /*#__PURE__*/jsx("span", {
      className: css$1B.icon,
      children: icon
    })]
  });
};
Button$1.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.node,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link', 'success', 'warning', 'danger', 'ghost']),
  size: PropTypes.oneOf(['xsmall', 'small', 'default']),
  disabled: PropTypes.bool,
  fillWidth: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  count: PropTypes.number
};

const AlertTriangle = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M9 8.75006V5.0121M9 11.5207V11.5535M13.7249 14.6667H4.27506C2.98425 14.6667 1.89494 13.8136 1.55221 12.6465C1.40591 12.1482 1.58567 11.6293 1.86063 11.1874L6.58557 2.66756C7.69258 0.888643 10.3074 0.888646 11.4144 2.66756L16.1394 11.1874C16.4143 11.6293 16.5941 12.1482 16.4478 12.6465C16.1051 13.8136 15.0157 14.6667 13.7249 14.6667Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
AlertTriangle.propTypes = {
  color: PropTypes.string
};

const Book02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.77118 14.8569V2.51401M8.77118 14.8569L7.55662 13.6423C6.87077 12.9565 5.94098 12.5712 4.97105 12.5712H1.91325C1.4083 12.5712 0.999756 12.1618 0.999756 11.6569V2.05686C0.999756 1.55192 1.4091 1.14258 1.91404 1.14258H5.42777C6.39771 1.14258 7.32792 1.52788 8.01376 2.21373L8.77118 2.97115L9.5286 2.21373C10.2144 1.52788 11.1447 1.14258 12.1146 1.14258H16.0855C16.5904 1.14258 16.9998 1.55192 16.9998 2.05686V11.6569C16.9998 12.1618 16.5904 12.5712 16.0855 12.5712H12.5717C11.6018 12.5712 10.6716 12.9565 9.98575 13.6423L8.77118 14.8569Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Book02.propTypes = {
  color: PropTypes.string
};

const InformationCircleContained = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M9 9L9 12.75M9 6.22046V6.1875M1.5 9C1.5 4.85786 4.85787 1.5 9 1.5C13.1421 1.5 16.5 4.85787 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
InformationCircleContained.propTypes = {
  color: PropTypes.string
};

const ChevronRight = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 7 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.33333 0.833496L5.5 5.00016L1.33333 9.16683",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ChevronRight.propTypes = {
  color: PropTypes.string
};

const VARIANT_ICONS = {
  info: InformationCircleContained,
  tip: Book02,
  success: InformationCircleContained,
  warning: AlertTriangle,
  danger: AlertTriangle,
  overlay: InformationCircleContained
};
const Alert = ({
  variant = 'info',
  title,
  icon,
  actionText,
  onActionClick,
  className = '',
  textClassName,
  illustration,
  style = {},
  children
}) => {
  const DefaultIcon = VARIANT_ICONS[variant];
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1C.alert} ${css$1C[variant]} ${className}`,
    style: style,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$1C.content,
      children: [/*#__PURE__*/jsx("div", {
        className: css$1C.icon,
        children: icon || /*#__PURE__*/jsx(DefaultIcon, {})
      }), /*#__PURE__*/jsxs("div", {
        className: css$1C.textWrapper,
        children: [title && /*#__PURE__*/jsx("span", {
          className: css$1C.title,
          children: title
        }), children && /*#__PURE__*/jsx("span", {
          className: `${textClassName} ${css$1C.text}`,
          children: children
        })]
      })]
    }), actionText && onActionClick && /*#__PURE__*/jsx(Button$1, {
      variant: "link",
      onClick: onActionClick,
      className: css$1C.button,
      icon: /*#__PURE__*/jsx(ChevronRight, {}),
      iconPosition: "right",
      children: actionText
    }), illustration && /*#__PURE__*/jsx("div", {
      className: css$1C.illustration,
      children: illustration
    })]
  });
};
Alert.propTypes = {
  variant: PropTypes.oneOf(['info', 'warning', 'success', 'danger', 'tip', 'overlay']),
  title: PropTypes.string,
  icon: PropTypes.node,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  actionText: PropTypes.string,
  onActionClick: PropTypes.func,
  className: PropTypes.string
};

var css_248z$1C = ".Dropdown-module__dropdownContainer___jFr2r{display:flex;flex-direction:column;position:relative;width:100%}.Dropdown-module__dropdownContainer___jFr2r.Dropdown-module__label-left___UHcrp{align-items:center;flex-direction:row;gap:10px}.Dropdown-module__dropdownContainer___jFr2r.Dropdown-module__label-left___UHcrp .Dropdown-module__label___BvcH4{margin-bottom:0;white-space:nowrap}.Dropdown-module__dropdownContainer___jFr2r.Dropdown-module__label-left___UHcrp .Dropdown-module__select___648CD{flex:1}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__label___BvcH4{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__label___BvcH4 .Dropdown-module__required___zloW2{color:var(--danger);margin-left:.15rem}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__selectWrapper___0EjyY{align-items:center;display:flex;position:relative;width:100%}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__icon___LRUeM{align-items:center;color:var(--primary-color);display:flex;left:.6rem;pointer-events:none;position:absolute;z-index:1}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__icon___LRUeM svg{height:1.2rem;width:1.2rem}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD{appearance:none;background-color:var(--white);background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3E%3Cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3E%3C/svg%3E\");background-position:right .5rem center;background-repeat:no-repeat;background-size:1.5em 1.5em;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem 30px .6rem .6rem;transition:all .2s ease;width:100%}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD.Dropdown-module__withIcon___eIWfp{padding-left:2.4rem}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD.Dropdown-module__small___qocLB{padding:3px 30px 3px 5px}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD:focus{background-color:var(--bg-light-48);outline:none}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD.Dropdown-module__error___2zMXB{border-color:var(--danger)}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD.Dropdown-module__disabled___HAP6b{background-color:var(--grey-8);cursor:not-allowed;opacity:.7}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD option{padding:.5rem}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__select___648CD option[value=\"\"]:disabled{color:var(--grey-64)}.Dropdown-module__dropdownContainer___jFr2r .Dropdown-module__errorMessage___6I33S{color:var(--danger);display:block;font-size:.75rem;margin-top:.2rem}";
var css$1A = {"dropdownContainer":"Dropdown-module__dropdownContainer___jFr2r","label-left":"Dropdown-module__label-left___UHcrp","label":"Dropdown-module__label___BvcH4","select":"Dropdown-module__select___648CD","required":"Dropdown-module__required___zloW2","selectWrapper":"Dropdown-module__selectWrapper___0EjyY","icon":"Dropdown-module__icon___LRUeM","withIcon":"Dropdown-module__withIcon___eIWfp","small":"Dropdown-module__small___qocLB","error":"Dropdown-module__error___2zMXB","disabled":"Dropdown-module__disabled___HAP6b","errorMessage":"Dropdown-module__errorMessage___6I33S"};
styleInject(css_248z$1C);

const Dropdown = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = null,
  required = false,
  disabled = false,
  error = '',
  name,
  labelPosition = 'top',
  style,
  icon = null,
  size
}) => {
  const handleChange = e => {
    onChange(e);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1A.dropdownContainer} ${css$1A[`label-${labelPosition}`]}`,
    style: style,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$1A.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$1A.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$1A.selectWrapper,
      children: [icon && /*#__PURE__*/jsx("div", {
        className: css$1A.icon,
        children: icon
      }), /*#__PURE__*/jsxs("select", {
        className: `${css$1A.select} ${error ? css$1A.error : ''} ${disabled ? css$1A.disabled : ''} ${icon ? css$1A.withIcon : ''} ${size === 'small' ? css$1A.small : ''}`,
        value: value,
        onChange: handleChange,
        disabled: disabled,
        name: name,
        required: required,
        "data-error": !!error,
        children: [placeholder && /*#__PURE__*/jsx("option", {
          value: "",
          disabled: true,
          children: placeholder
        }), options.map(option => /*#__PURE__*/jsx("option", {
          value: option.value,
          disabled: option.disabled ?? false,
          children: option.label
        }, option.value))]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$1A.errorMessage,
      children: error
    })]
  });
};
Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  placeholder: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  size: PropTypes.oneOf(['small'])
};

const FlexContainer = ({
  className,
  justifyContent,
  flexDirection,
  flexGrow,
  flexBasis,
  flexShrink,
  flexWrap,
  flexFlow,
  flex,
  alignItems,
  margin,
  padding,
  width,
  height,
  maxWidth,
  bgColor,
  gap,
  style,
  children,
  ...rest
}) => {
  return /*#__PURE__*/jsx("div", {
    className: className,
    style: {
      display: 'flex',
      justifyContent: justifyContent || 'flex-start',
      flexDirection: flexDirection || 'row',
      flexGrow: flexGrow || 0,
      flexBasis: flexBasis || 'auto',
      flexShrink: flexShrink || 1,
      flexWrap: flexWrap || 'nowrap',
      flexFlow: flexFlow || 'row',
      flex: flex || '0 1 auto',
      alignItems: alignItems || 'stretch',
      margin: margin || '0',
      padding: padding || '0',
      width: width || 'auto',
      height: height || 'auto',
      maxWidth: maxWidth || 'none',
      backgroundColor: bgColor || 'none',
      gap: gap || '0',
      ...style
    },
    ...rest,
    children: children
  });
};
FlexContainer.propTypes = {
  className: PropTypes.string,
  justifyContent: PropTypes.string,
  flexDirection: PropTypes.string,
  flexGrow: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexBasis: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexShrink: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  flexWrap: PropTypes.string,
  flex: PropTypes.string,
  alignItems: PropTypes.string,
  margin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bgColor: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node
};

var css_248z$1B = ".FormGrid-module__formGrid___6em3a{display:grid;gap:10px;grid-template-columns:repeat(var(--grid-columns,1),1fr);margin-bottom:1rem;width:100%}.FormGrid-module__formGrid___6em3a .FormGrid-module__formGridItem___5CCHY{min-width:0}.FormGrid-module__formGrid___6em3a button{margin-top:30px}.FormGrid-module__formGrid___6em3a .FormGrid-module__formLabel___0U8XJ{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:5px;text-align:left}.FormGrid-module__formGrid___6em3a .FormGrid-module__formLabel___0U8XJ .FormGrid-module__required___Ytu1q{color:var(--danger);margin-left:.15rem}@media (max-width:768px){.FormGrid-module__formGrid___6em3a{gap:1rem;grid-template-columns:1fr}}";
var css$1z = {"formGrid":"FormGrid-module__formGrid___6em3a","formGridItem":"FormGrid-module__formGridItem___5CCHY","formLabel":"FormGrid-module__formLabel___0U8XJ","required":"FormGrid-module__required___Ytu1q"};
styleInject(css_248z$1B);

const FormGrid = ({
  label,
  children,
  columns = 1,
  className = '',
  style,
  required = false
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1z.formGrid} ${className}`,
    style: {
      '--grid-columns': columns,
      ...style
    },
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$1z.formLabel,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$1z.required,
        children: "*"
      })]
    }), React.Children.map(children, child => child && /*#__PURE__*/jsx("div", {
      className: css$1z.formGridItem,
      style: {
        gridColumn: `span ${child.props.columnSpan || 1}`
      },
      children: child
    }))]
  });
};
FormGrid.propTypes = {
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  className: PropTypes.string
};

var css_248z$1A = ":root{--spin-color:var(--primary-color)}.InlineLoading-module__spinner___VTLoU{display:inline-block}.InlineLoading-module__spinner___VTLoU .InlineLoading-module__spinnerSection___CRMn3{animation:InlineLoading-module__spin___zrlSm 1s ease-in-out infinite;-webkit-animation:InlineLoading-module__spin___zrlSm 1s ease-in-out infinite;border:3px solid #fff;border-radius:50%;border-top:3px solid var(--spin-color);display:inline-block}@keyframes InlineLoading-module__spin___zrlSm{to{-webkit-transform:rotate(1turn)}}@-webkit-keyframes InlineLoading-module__spin___zrlSm{to{-webkit-transform:rotate(1turn)}}";
var css$1y = {"spinner":"InlineLoading-module__spinner___VTLoU","spinnerSection":"InlineLoading-module__spinnerSection___CRMn3","spin":"InlineLoading-module__spin___zrlSm"};
styleInject(css_248z$1A);

const InlineLoading = ({
  width,
  ...rest
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$1y.spinner,
    ...rest,
    style: {
      width: width ? `${width}px` : '25px',
      height: width ? `${width}px` : '25px'
    },
    children: /*#__PURE__*/jsx("div", {
      className: css$1y.spinnerSection,
      style: {
        width: width ? `${width}px` : '25px',
        height: width ? `${width}px` : '25px'
      }
    })
  });
};

var css_248z$1z = ".Modal-module__modalBody___ohjQm{height:100%;padding:1.5rem}.Modal-module__modalOverlay___rI8Wz{align-items:center;background-color:rgba(76,76,76,.839);bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:999999}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1{background:#fff;border-radius:8px;max-height:90vh;max-width:min(1000px,100% - 32px);overflow-y:auto;position:relative;width:fit-content}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__small___qdBEU{max-width:min(400px,100% - 32px);width:min(400px,100% - 32px)}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__medium___JRDXg{max-width:min(640px,100% - 32px);width:min(640px,100% - 32px)}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__large___O42Af{max-width:min(1000px,100% - 32px);width:min(1000px,100% - 32px)}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalHeader___IuHIg{align-items:center;border-bottom:1px solid var(--bg-dark);display:flex;justify-content:space-between;padding:.5rem 1.5rem;position:relative}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalHeader___IuHIg h3{font-weight:500;margin:0;padding-right:30px}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalHeader___IuHIg .Modal-module__closeBtn___bjDac{background:none;border:none;border-radius:var(--border-radius-small);color:var(--grey-64);cursor:pointer;padding:3px 5px;position:absolute;right:12px;top:50%;transform:translateY(-50%);width:auto!important}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalHeader___IuHIg .Modal-module__closeBtn___bjDac:hover{background-color:var(--bg-dark);transition:all .3s}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalFooter___TEqdK{border-top:1px solid var(--bg-dark);padding:.75rem 1.5rem}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__stickyLayout___TQ1kT{display:flex;flex-direction:column;overflow:hidden}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__stickyLayout___TQ1kT .Modal-module__modalHeader___IuHIg{flex-shrink:0}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__stickyLayout___TQ1kT .Modal-module__modalBody___ohjQm{flex:1;overflow-x:hidden;overflow-y:auto}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1.Modal-module__stickyLayout___TQ1kT .Modal-module__modalFooter___TEqdK{flex-shrink:0}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalBody___ohjQm.Modal-module__noBodyPadding___Pdh9C{padding:0}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalActions___k2xRq{align-items:center;display:flex;gap:.75rem;justify-content:flex-end;margin-top:1rem}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalActions___k2xRq.Modal-module__alignLeft___RBqOl{justify-content:flex-start}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalActions___k2xRq.Modal-module__alignCenter___Aj4wm{justify-content:center}.Modal-module__modalOverlay___rI8Wz .Modal-module__modalContent___6Cgb1 .Modal-module__modalActions___k2xRq.Modal-module__alignRight___stPBp{justify-content:flex-end}";
var css$1x = {"modalBody":"Modal-module__modalBody___ohjQm","modalOverlay":"Modal-module__modalOverlay___rI8Wz","modalContent":"Modal-module__modalContent___6Cgb1","small":"Modal-module__small___qdBEU","medium":"Modal-module__medium___JRDXg","large":"Modal-module__large___O42Af","modalHeader":"Modal-module__modalHeader___IuHIg","closeBtn":"Modal-module__closeBtn___bjDac","modalFooter":"Modal-module__modalFooter___TEqdK","stickyLayout":"Modal-module__stickyLayout___TQ1kT","noBodyPadding":"Modal-module__noBodyPadding___Pdh9C","modalActions":"Modal-module__modalActions___k2xRq","alignLeft":"Modal-module__alignLeft___RBqOl","alignCenter":"Modal-module__alignCenter___Aj4wm","alignRight":"Modal-module__alignRight___stPBp"};
styleInject(css_248z$1z);

const X02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M22 2L2 22M22 22L2 2",
    stroke: color,
    strokeWidth: "3.33333",
    strokeLinecap: "round"
  })
});
X02.propTypes = {
  color: PropTypes.string
};

const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  titleColor,
  className,
  style,
  width,
  size,
  stickyLayout = false,
  footer,
  closeButtonColor,
  bodyPadding = true
}) => {
  useEffect(() => {
    const handleEscapeKey = event => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscapeKey);
    }
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [isOpen, onClose]);
  if (!isOpen) {
    return null;
  }
  const mergedStyle = width !== undefined ? {
    ...style,
    width
  } : style;
  return /*#__PURE__*/createPortal(/*#__PURE__*/jsx("div", {
    className: `usg-modal ${css$1x.modalOverlay}${className ? ` ${className}` : ''}`,
    onClick: onClose,
    children: /*#__PURE__*/jsxs("div", {
      className: `${css$1x.modalContent} ${size ? css$1x[size] : ''} ${stickyLayout ? css$1x.stickyLayout : ''}`,
      style: mergedStyle,
      onClick: e => e.stopPropagation(),
      children: [/*#__PURE__*/jsxs("div", {
        className: css$1x.modalHeader,
        children: [/*#__PURE__*/jsx("h3", {
          style: {
            color: titleColor
          },
          children: title
        }), /*#__PURE__*/jsx("button", {
          className: css$1x.closeBtn,
          onClick: onClose,
          children: /*#__PURE__*/jsx(X02, {
            color: closeButtonColor || colors$1.primaryColor,
            width: 12,
            height: 12
          })
        })]
      }), /*#__PURE__*/jsx("div", {
        className: `${css$1x.modalBody} ${bodyPadding ? '' : css$1x.noBodyPadding}`,
        children: children
      }), footer && /*#__PURE__*/jsx("div", {
        className: css$1x.modalFooter,
        children: footer
      })]
    })
  }), document.body);
};
Modal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  titleColor: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  stickyLayout: PropTypes.bool,
  footer: PropTypes.node,
  closeButtonColor: PropTypes.string,
  bodyPadding: PropTypes.bool
};

const ModalActions = ({
  children,
  className,
  align = 'right'
}) => {
  const alignmentClass = align === 'right' ? css$1x.alignRight : align === 'center' ? css$1x.alignCenter : css$1x.alignLeft;
  return /*#__PURE__*/jsx("div", {
    className: `${css$1x.modalActions} ${alignmentClass} ${className || ''}`,
    children: children
  });
};
ModalActions.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right'])
};

var css_248z$1y = ".MultiSelect-module__multiSelectContainer___9nD5u{display:flex;flex-direction:column;position:relative;width:100%}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__label___wK9tj{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__label___wK9tj .MultiSelect-module__required___m8xvg{color:var(--danger);margin-left:.15rem}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM{align-items:center;background-color:#fff;border:1px solid var(--bg-dark);border-radius:8px;cursor:pointer;display:flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);justify-content:space-between;line-height:var(--body-regular-line-height);padding:.6rem;position:relative;transition:all .2s ease;width:100%}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM.MultiSelect-module__open___x14LL{background-color:var(--bg-light-48)}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM.MultiSelect-module__error___0iD8U{border-color:var(--danger)}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM.MultiSelect-module__disabled___DYbY2{background-color:var(--disabled);cursor:not-allowed}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM .MultiSelect-module__selectedValue___cPKY-{color:var(--text);flex:1;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM .MultiSelect-module__arrow___8vPGq{color:var(--text);font-size:.75rem;margin-right:.4rem;transition:transform .2s ease}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM .MultiSelect-module__arrow___8vPGq:after{border-bottom:1.5px solid;border-right:1.5px solid;content:\"\";display:inline-block;height:.375rem;margin-top:-.125rem;transform:rotate(45deg);transition:transform .2s ease;width:.375rem}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__select___yE8qM.MultiSelect-module__open___x14LL .MultiSelect-module__arrow___8vPGq:after{transform:rotate(-135deg)}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR{background:#fff;border:1px solid var(--grey-20);border-radius:4px;box-shadow:0 2px 4px rgba(0,0,0,.1);left:0;margin-top:4px;position:absolute;right:0;top:100%;z-index:1000}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR.MultiSelect-module__dropdownAbove___79nFW{bottom:100%;margin-bottom:4px;margin-top:0;top:auto}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__searchInput___kBE6B{background-color:#fff;border:none;border-bottom:1px solid var(--grey-8);border-radius:8px 8px 0 0;color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);outline:none;padding:.5rem 1rem;width:100%}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0{max-height:200px;overflow-y:auto}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__option___2hJ2w{align-items:center;cursor:pointer;display:flex;font-size:var(--body-regular-size);padding:.5rem 1rem;transition:background-color .2s ease}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__option___2hJ2w.MultiSelect-module__selected___WrMHg,.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__option___2hJ2w:hover{background-color:var(--bg-light)}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__option___2hJ2w .MultiSelect-module__checkbox___9yg7u{accent-color:var(--primary-color);border-radius:4px;cursor:pointer;height:1rem;margin-right:.5rem;width:1rem}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__selectAll___4bXp8{background-color:var(--grey-8);font-weight:500}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__selectAll___4bXp8.MultiSelect-module__selected___WrMHg,.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__dropdown___J3ByR .MultiSelect-module__options___bUQT0 .MultiSelect-module__selectAll___4bXp8:hover{background-color:var(--grey-8)}.MultiSelect-module__multiSelectContainer___9nD5u .MultiSelect-module__errorMessage___TS-2d{color:var(--danger);display:block;font-size:.75rem;margin-top:.2rem}";
var css$1w = {"multiSelectContainer":"MultiSelect-module__multiSelectContainer___9nD5u","label":"MultiSelect-module__label___wK9tj","required":"MultiSelect-module__required___m8xvg","select":"MultiSelect-module__select___yE8qM","open":"MultiSelect-module__open___x14LL","error":"MultiSelect-module__error___0iD8U","disabled":"MultiSelect-module__disabled___DYbY2","selectedValue":"MultiSelect-module__selectedValue___cPKY-","arrow":"MultiSelect-module__arrow___8vPGq","dropdown":"MultiSelect-module__dropdown___J3ByR","dropdownAbove":"MultiSelect-module__dropdownAbove___79nFW","searchInput":"MultiSelect-module__searchInput___kBE6B","options":"MultiSelect-module__options___bUQT0","option":"MultiSelect-module__option___2hJ2w","selected":"MultiSelect-module__selected___WrMHg","checkbox":"MultiSelect-module__checkbox___9yg7u","selectAll":"MultiSelect-module__selectAll___4bXp8","errorMessage":"MultiSelect-module__errorMessage___TS-2d"};
styleInject(css_248z$1y);

const MultiSelect = ({
  label,
  value = [],
  onChange,
  options = [],
  placeholder = 'Select options',
  required = false,
  disabled = false,
  error = '',
  name,
  selectedText = 'items',
  onSelectAll,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const [searchTerm, setSearchTerm] = useState('');
  const [position, setPosition] = useState('below');
  const wrapperRef = useRef(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = event => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  useEffect(() => {
    if (isOpen && wrapperRef.current && dropdownRef.current) {
      const wrapperRect = wrapperRef.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;
      const spaceBelow = window.innerHeight - wrapperRect.bottom;
      const spaceAbove = wrapperRect.top;
      setPosition(spaceBelow < dropdownHeight && spaceAbove > spaceBelow ? 'above' : 'below');
    }
  }, [isOpen]);
  const handleToggle = () => {
    if (!disabled) {
      setIsOpen(!isOpen);
    }
  };
  const handleSelect = option => {
    const newValue = value.includes(option.value) ? value.filter(v => v !== option.value) : [...value, option.value];
    onChange({
      target: {
        name,
        value: newValue
      }
    });
  };
  const filteredOptions = options.filter(option => String(option.label).toLowerCase().includes(searchTerm.toLowerCase()));
  const selectedOptions = options.filter(opt => value.includes(opt.value));
  const isAllSelected = value.length === options.length;
  const getDisplayValue = () => {
    if (value.length === 0) return placeholder;
    if (value.length <= 5) {
      return selectedOptions.map(opt => opt.label).join(', ');
    }
    return `${value.length} ${selectedText} selected`;
  };
  if (filteredOptions.length === 0 && searchTerm.trim() === '') {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: css$1w.multiSelectContainer,
    ref: wrapperRef,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$1w.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$1w.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: `${css$1w.select} ${isOpen ? css$1w.open : ''} ${error ? css$1w.error : ''} ${disabled ? css$1w.disabled : ''}`,
      onClick: handleToggle,
      "data-error": !!error,
      children: [/*#__PURE__*/jsx("div", {
        className: css$1w.selectedValue,
        children: getDisplayValue()
      }), /*#__PURE__*/jsx("div", {
        className: css$1w.arrow
      })]
    }), isOpen && /*#__PURE__*/jsxs("div", {
      className: `${css$1w.dropdown} ${position === 'above' ? css$1w.dropdownAbove : ''}`,
      ref: dropdownRef,
      children: [/*#__PURE__*/jsx("input", {
        type: "text",
        className: css$1w.searchInput,
        placeholder: `Search ${selectedText}`,
        value: searchTerm,
        onChange: e => setSearchTerm(e.target.value)
      }), /*#__PURE__*/jsxs("div", {
        className: css$1w.options,
        children: [onSelectAll && /*#__PURE__*/jsxs("div", {
          className: `${css$1w.option} ${css$1w.selectAll} ${isAllSelected ? css$1w.selected : ''}`,
          onClick: onSelectAll,
          children: [/*#__PURE__*/jsx("input", {
            type: "checkbox",
            checked: isAllSelected,
            onChange: () => {},
            className: css$1w.checkbox
          }), "Select All"]
        }), filteredOptions.map(option => /*#__PURE__*/jsxs("div", {
          className: `${css$1w.option} ${value.includes(option.value) ? css$1w.selected : ''}`,
          onClick: () => handleSelect(option),
          children: [/*#__PURE__*/jsx("input", {
            type: "checkbox",
            checked: value.includes(option.value),
            onChange: () => {},
            className: css$1w.checkbox
          }), option.label]
        }, option.value))]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$1w.errorMessage,
      children: error
    })]
  });
};
MultiSelect.propTypes = {
  label: PropTypes.string,
  value: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string.isRequired,
  selectedText: PropTypes.string
};

var css_248z$1x = ".SectionTitle-module__sectionTitle___y4ASo{align-items:center;color:var(--primary-color);display:flex;font-size:14px;font-weight:500;gap:6px;line-height:18px;margin:0 0 8px;width:100%}.SectionTitle-module__sectionTitle___y4ASo .SectionTitle-module__icon___DuyPF{align-items:center;display:flex;flex-shrink:0;height:16px;justify-content:center;width:16px}.SectionTitle-module__sectionTitle___y4ASo .SectionTitle-module__icon___DuyPF svg{color:inherit;height:100%;width:100%}";
var css$1v = {"sectionTitle":"SectionTitle-module__sectionTitle___y4ASo","icon":"SectionTitle-module__icon___DuyPF"};
styleInject(css_248z$1x);

const SectionTitle = ({
  children,
  className,
  color,
  icon,
  ...props
}) => {
  return /*#__PURE__*/jsxs("h6", {
    className: `${css$1v.sectionTitle} ${className || ''}`,
    style: {
      color: color
    },
    ...props,
    children: [icon && /*#__PURE__*/jsx("span", {
      className: css$1v.icon,
      children: icon
    }), children]
  });
};

const UserBookmarksContext = /*#__PURE__*/createContext$1(null);

const allowedUserRoles$1 = [userRoles.ADMIN, userRoles.USG_EMPLOYEE_SALES, userRoles.RESELLER];
const UserBookmarksProvider = ({
  toast,
  children
}) => {
  const {
    currentUser
  } = useCurrentUser();
  const posthog = usePostHog();
  const [bookmarks, setBookmarks] = useState([]);
  const isAllowed = useMemo(() => {
    return !!currentUser && allowedUserRoles$1.includes(currentUser.role);
  }, [currentUser]);
  const loadBookmarks = useCallback(async () => {
    try {
      const response = await axios.get(apiEndpoints.loadHotelBookmarks);
      setBookmarks(Object.values(response.data.hotels || {}));
    } catch (error) {
      console.error('Failed to load hotel bookmarks:', error);
    }
  }, []);
  useEffect(() => {
    if (isAllowed) {
      loadBookmarks();
    } else {
      setBookmarks([]);
    }
  }, [isAllowed, loadBookmarks]);
  const isBookmarked = useCallback(hotelId => {
    return bookmarks.some(b => b.id === hotelId);
  }, [bookmarks]);
  const toggleBookmark = useCallback(async hotel => {
    if (!hotel?.id) {
      return;
    }
    const hotelId = hotel.id;
    const nextBookmarked = !isBookmarked(hotelId);
    const formData = new FormData();
    formData.append('isBookmarked', nextBookmarked ? 1 : 0);
    try {
      await axios.post(apiEndpoints.saveHotelBookmark, formData);
      setBookmarks(prev => nextBookmarked ? [...prev, hotel] : prev.filter(b => b.id !== hotelId));
      posthog.capture('hotel_bookmark:toggled', {
        is_bookmarked: nextBookmarked
      });
    } catch (error) {
      if (toast) {
        toast.error('Failed to update bookmark');
      }
    }
  }, [isBookmarked, toast]);
  const value = useMemo(() => ({
    bookmarks,
    isAllowed,
    isBookmarked,
    toggleBookmark
  }), [bookmarks, isAllowed, isBookmarked, toggleBookmark]);
  return /*#__PURE__*/jsx(UserBookmarksContext.Provider, {
    value: value,
    children: children
  });
};
const useUserBookmarks = () => {
  const context = useContext(UserBookmarksContext);
  if (!context) {
    throw new Error('useUserBookmarks must be used within a UserBookmarksProvider');
  }
  return context;
};

const DemoModeConfigurationModal = ({
  onConfirm,
  onCancel,
  toast
}) => {
  const posthog = usePostHog();
  useCurrentHotel();
  const {
    bookmarks
  } = useUserBookmarks();
  const [testHotels, setTestHotels] = useState({});
  const [selectedTestHotelId, setSelectedTestHotelId] = useState('');
  const [selectedRealHotelIds, setSelectedRealHotelIds] = useState([]);
  const [isLoadingTestHotels, setIsLoadingTestHotels] = useState(true);
  useEffect(() => {
    const loadTestHotels = async () => {
      try {
        const response = await axios.get(apiEndpoints.loadTestHotels);
        setTestHotels(response.data.hotels || {});
      } catch (error) {
        toast?.error('Failed to load test hotels');
      } finally {
        setIsLoadingTestHotels(false);
      }
    };
    loadTestHotels();
  }, [toast]);
  const testHotelOptions = useMemo(() => {
    const options = Object.entries(testHotels).map(([id, hotel]) => ({
      label: hotel.name,
      value: hotel.id
    }));
    options.unshift({
      label: 'Select Test Hotel',
      value: ''
    });
    return options;
  }, [testHotels]);
  const availableRealHotels = useMemo(() => {
    return bookmarks.filter(bookmark => !bookmark.isTestHotel);
  }, [bookmarks]);
  const realHotelOptions = useMemo(() => {
    return availableRealHotels.map(hotel => ({
      value: hotel.id,
      label: hotel.name
    }));
  }, [availableRealHotels]);
  const handleTestHotelChange = evt => {
    setSelectedTestHotelId(evt.target.value);
  };
  const handleRealHotelsChange = evt => {
    setSelectedRealHotelIds(evt.target.value);
  };
  const handleSelectAllToggle = () => {
    if (selectedRealHotelIds.length === availableRealHotels.length) {
      setSelectedRealHotelIds([]);
    } else {
      setSelectedRealHotelIds(availableRealHotels.map(h => h.id));
    }
  };
  const handleConfirm = () => {
    const testHotel = testHotels[selectedTestHotelId];
    const realHotels = availableRealHotels.filter(h => selectedRealHotelIds.includes(h.id));
    posthog.capture('demo_mode:configuration_save', {
      test_hotel_id: testHotel?.id,
      real_hotel_count: realHotels.length
    });
    onConfirm(testHotel, realHotels);
  };
  const handleCancel = () => {
    posthog.capture('demo_mode:configuration_cancel');
    onCancel();
  };
  const isConfirmDisabled = !selectedTestHotelId || selectedRealHotelIds.length === 0;
  return /*#__PURE__*/jsx(Modal, {
    title: "Configure Demo Mode",
    titleColor: colors$1.primaryColor,
    isOpen: true,
    onClose: handleCancel,
    style: {
      width: 'min(640px, calc(100vw - 32px))',
      height: 'min(600px, calc(100vh - 32px))'
    },
    children: /*#__PURE__*/jsxs(FlexContainer, {
      flexDirection: "column",
      flexFlow: "column",
      gap: 16,
      children: [/*#__PURE__*/jsxs(FormGrid, {
        children: [/*#__PURE__*/jsx(SectionTitle, {
          children: "Test Hotel"
        }), isLoadingTestHotels ? /*#__PURE__*/jsx(InlineLoading, {}) : /*#__PURE__*/jsx(Dropdown, {
          label: "Select Test Hotel",
          name: "testHotel",
          options: testHotelOptions,
          value: selectedTestHotelId,
          onChange: handleTestHotelChange
        })]
      }), /*#__PURE__*/jsxs(FormGrid, {
        children: [/*#__PURE__*/jsx(SectionTitle, {
          children: "Real Hotels"
        }), availableRealHotels.length === 0 ? /*#__PURE__*/jsx(Alert, {
          variant: "info",
          children: "You have no bookmarked hotels available for demo mode. Bookmark hotels with the star icon in the header to add them to your demo set."
        }) : /*#__PURE__*/jsx(MultiSelect, {
          label: "Select Real Hotels",
          name: "realHotels",
          value: selectedRealHotelIds,
          onChange: handleRealHotelsChange,
          onSelectAll: handleSelectAllToggle,
          options: realHotelOptions,
          selectedText: "hotels"
        })]
      }), /*#__PURE__*/jsx(FormGrid, {
        children: /*#__PURE__*/jsxs(FlexContainer, {
          justifyContent: "flex-end",
          gap: 10,
          children: [/*#__PURE__*/jsx(Button$1, {
            variant: "tertiary",
            onClick: handleCancel,
            children: "Cancel"
          }), /*#__PURE__*/jsx(Button$1, {
            variant: "primary",
            onClick: handleConfirm,
            disabled: isConfirmDisabled,
            children: "Confirm"
          })]
        })
      })]
    })
  });
};

const ScreenIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5.52051 14.1666L8.33301 11.3094L11.1455 14.1666M2.70801 11.3094H13.958C14.9935 11.3094 15.833 10.4567 15.833 9.40468V2.73801C15.833 1.68604 14.9935 0.833252 13.958 0.833252H2.70801C1.67247 0.833252 0.833008 1.68604 0.833008 2.73801V9.40468C0.833008 10.4567 1.67247 11.3094 2.70801 11.3094Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ScreenIcon.propTypes = {
  color: PropTypes.string
};

var css_248z$1w = ".LoadingScreen-module__loadingContainer___kWl3s{align-items:center;background-color:hsla(0,0%,100%,.3);bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:10000}.LoadingScreen-module__loadingContainer___kWl3s .LoadingScreen-module__loadingContent___4Hsro{align-items:center;display:flex;flex-direction:column;gap:1.5rem}.LoadingScreen-module__loadingContainer___kWl3s .LoadingScreen-module__loadingContent___4Hsro .LoadingScreen-module__spinner___MzT2Z{align-items:center;display:flex;gap:.5rem;justify-content:center}.LoadingScreen-module__loadingContainer___kWl3s .LoadingScreen-module__loadingContent___4Hsro .LoadingScreen-module__spinner___MzT2Z .LoadingScreen-module__spinnerDot___En-5A{animation:LoadingScreen-module__pulse___0Y0vW 1.4s ease-in-out infinite;background-color:var(--primary-color);border-radius:50%;height:12px;width:12px}.LoadingScreen-module__loadingContainer___kWl3s .LoadingScreen-module__loadingContent___4Hsro .LoadingScreen-module__spinner___MzT2Z .LoadingScreen-module__spinnerDot___En-5A:first-child{animation-delay:-.32s}.LoadingScreen-module__loadingContainer___kWl3s .LoadingScreen-module__loadingContent___4Hsro .LoadingScreen-module__spinner___MzT2Z .LoadingScreen-module__spinnerDot___En-5A:nth-child(2){animation-delay:-.16s}@keyframes LoadingScreen-module__pulse___0Y0vW{0%,80%,to{opacity:.4;transform:scale(.6)}40%{opacity:1;transform:scale(1)}}";
var css$1u = {"loadingContainer":"LoadingScreen-module__loadingContainer___kWl3s","loadingContent":"LoadingScreen-module__loadingContent___4Hsro","spinner":"LoadingScreen-module__spinner___MzT2Z","spinnerDot":"LoadingScreen-module__spinnerDot___En-5A","pulse":"LoadingScreen-module__pulse___0Y0vW"};
styleInject(css_248z$1w);

const LoadingScreen = () => {
  return /*#__PURE__*/jsx("div", {
    className: css$1u.loadingContainer,
    children: /*#__PURE__*/jsx("div", {
      className: css$1u.loadingContent,
      children: /*#__PURE__*/jsxs("div", {
        className: css$1u.spinner,
        children: [/*#__PURE__*/jsx("div", {
          className: css$1u.spinnerDot
        }), /*#__PURE__*/jsx("div", {
          className: css$1u.spinnerDot
        }), /*#__PURE__*/jsx("div", {
          className: css$1u.spinnerDot
        })]
      })
    })
  });
};

const LoadingContext = /*#__PURE__*/createContext$1({});

const LoadingProvider = ({
  children
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const showLoading = useCallback(() => setIsLoading(true), [setIsLoading]);
  const hideLoading = useCallback(() => setIsLoading(false), [setIsLoading]);
  const value = useMemo(() => ({
    isLoading,
    showLoading,
    hideLoading
  }), [isLoading, showLoading, hideLoading]);
  return /*#__PURE__*/jsxs(LoadingContext.Provider, {
    value: value,
    children: [children, isLoading && /*#__PURE__*/jsx(LoadingScreen, {})]
  });
};
const useLoading = () => {
  const context = useContext(LoadingContext);
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider');
  }
  return context;
};

const useSwitchHotel = ({
  getRedirectUrl,
  toast
} = {}) => {
  const posthog = usePostHog();
  const {
    changeHotel,
    currentUser
  } = useCurrentUser();
  const {
    showLoading,
    hideLoading
  } = useLoading();
  return useCallback(async hotel => {
    showLoading();
    posthog.capture('hotel_switcher:switch_hotel');
    const hotelFormData = new FormData();
    hotelFormData.append('hotelId', hotel.id);
    try {
      await axios.post(apiEndpoints.switchHotel, hotelFormData);
      changeHotel(hotel);
      window.location.href = getRedirectUrl ? getRedirectUrl(hotel, currentUser) : `/app/${hotel.id}/dashboard`;
    } catch (error) {
      console.error('Error switching hotel:', error);
      toast?.error('Failed to switch hotel');
      throw error;
    } finally {
      hideLoading();
    }
  }, [posthog, changeHotel, currentUser, showLoading, hideLoading, getRedirectUrl, toast]);
};

const allowedUserRoles = [userRoles.ADMIN, userRoles.USG_EMPLOYEE_SALES, userRoles.RESELLER];
const DemoModeProvider = ({
  toast,
  getRedirectUrl,
  children
}) => {
  const posthog = usePostHog();
  const {
    currentHotelId
  } = useCurrentHotel();
  const {
    currentUser
  } = useCurrentUser();
  useLocation();
  const switchHotel = useSwitchHotel({
    getRedirectUrl,
    toast
  });
  const [selectedHotelId, setSelectedHotelId] = useState(() => currentUser?.userSettings?.demoHotelsConfig?.testHotelId ?? null);
  const [selectedRealHotelIds, setSelectedRealHotelIds] = useState(() => currentUser?.userSettings?.demoHotelsConfig?.realHotelIds ?? []);
  const [isDemoMode, setIsDemoMode] = useState(() => currentUser?.userSettings?.demoModeEnabled ?? false);
  const lastSyncedDemoModeRef = useRef(currentUser?.userSettings?.demoModeEnabled);
  useEffect(() => {
    const v = currentUser?.userSettings?.demoModeEnabled;
    if (v === undefined) return;
    if (lastSyncedDemoModeRef.current === v) return;
    lastSyncedDemoModeRef.current = v;
    setIsDemoMode(v);
  }, [currentUser?.userSettings?.demoModeEnabled]);
  const lastSyncedConfigRef = useRef(currentUser?.userSettings?.demoHotelsConfig);
  useEffect(() => {
    const v = currentUser?.userSettings?.demoHotelsConfig;
    if (v === undefined) return;
    if (lastSyncedConfigRef.current === v) return;
    lastSyncedConfigRef.current = v;
    setSelectedHotelId(v?.testHotelId ?? null);
    setSelectedRealHotelIds(v?.realHotelIds ?? []);
  }, [currentUser?.userSettings?.demoHotelsConfig]);
  const isUserAllowed = useMemo(() => {
    return allowedUserRoles.includes(currentUser?.role) && !!currentHotelId;
  }, [currentUser?.role, currentHotelId]);
  useEffect(() => {
    if (!isUserAllowed) {
      setIsDemoMode(false);
    }
  }, [isUserAllowed]);
  const persistDemoMode = useCallback(async nextValue => {
    const previousIsDemoMode = isDemoMode;
    const previousSelectedHotelId = selectedHotelId;
    const previousSelectedRealHotelIds = selectedRealHotelIds;
    setIsDemoMode(nextValue);
    setSelectedHotelId(null);
    setSelectedRealHotelIds([]);
    if (!isUserAllowed) {
      return;
    }
    const formData = new FormData();
    formData.append('settings[demoModeEnabled]', nextValue ? '1' : '0');
    try {
      await axios.post(apiEndpoints.saveUserSettings, formData);
    } catch (error) {
      setIsDemoMode(previousIsDemoMode);
      setSelectedHotelId(previousSelectedHotelId);
      setSelectedRealHotelIds(previousSelectedRealHotelIds);
      if (toast) {
        toast.error('Failed to update demo mode');
      }
    }
  }, [isDemoMode, selectedHotelId, selectedRealHotelIds, isUserAllowed, toast]);
  const toggleDemoMode = useCallback(async () => {
    posthog.capture('demo_mode:toggle_click');
    const nextValue = isUserAllowed ? !isDemoMode : false;
    await persistDemoMode(nextValue);
  }, [isDemoMode, isUserAllowed, persistDemoMode, posthog]);
  const disableDemoMode = useCallback(async () => {
    await persistDemoMode(false);
  }, [persistDemoMode]);
  const handleClose = useCallback(() => {
    disableDemoMode();
  }, [disableDemoMode]);
  const handleConfirm = useCallback(async (testHotel, realHotels) => {
    const formData = new FormData();
    formData.append('settings[demoHotelsConfig][testHotelId]', testHotel.id);
    realHotels.forEach(hotel => {
      formData.append('settings[demoHotelsConfig][realHotelIds][]', hotel.id);
    });
    try {
      await axios.post(apiEndpoints.saveUserSettings, formData);
    } catch (error) {
      if (toast) {
        toast.error('Failed to save demo configuration');
      }
      return;
    }
    setSelectedHotelId(testHotel.id);
    setSelectedRealHotelIds(realHotels.map(h => h.id));
    const isOnSelectedReal = realHotels.some(h => Number(h.id) === currentHotelId);
    if (!isOnSelectedReal) {
      await switchHotel(realHotels[0]);
    }
  }, [currentHotelId, switchHotel, toast]);
  const changeTestHotel = useCallback(async testHotel => {
    const previousSelectedHotelId = selectedHotelId;
    setSelectedHotelId(testHotel.id);
    const formData = new FormData();
    formData.append('settings[demoHotelsConfig][testHotelId]', testHotel.id);
    selectedRealHotelIds.forEach(id => {
      formData.append('settings[demoHotelsConfig][realHotelIds][]', id);
    });
    try {
      await axios.post(apiEndpoints.saveUserSettings, formData);
      posthog.capture('demo_mode:change_test_hotel', {
        test_hotel_id: testHotel.id
      });
    } catch (error) {
      setSelectedHotelId(previousSelectedHotelId);
      if (toast) {
        toast.error('Failed to update test hotel');
      }
    }
  }, [selectedHotelId, selectedRealHotelIds, toast, posthog]);
  const isOnDemoTestHotel = useMemo(() => {
    if (!isDemoMode || !selectedHotelId) {
      return false;
    }
    return currentHotelId === Number(selectedHotelId);
  }, [isDemoMode, selectedHotelId, currentHotelId]);
  const shouldOpenInDemoTab = useMemo(() => {
    return isDemoMode && !!selectedHotelId && !isOnDemoTestHotel;
  }, [isDemoMode, selectedHotelId, isOnDemoTestHotel]);
  const shouldShowConfigurationModal = isDemoMode && isUserAllowed && (!selectedHotelId || selectedRealHotelIds.length === 0);
  const value = useMemo(() => ({
    demoTestHotelId: selectedHotelId,
    selectedRealHotelIds,
    isDemoMode,
    isOnDemoTestHotel,
    shouldOpenInDemoTab,
    toggleDemoMode,
    disableDemoMode,
    changeTestHotel,
    isUserAllowed
  }), [selectedHotelId, selectedRealHotelIds, isDemoMode, isOnDemoTestHotel, shouldOpenInDemoTab, toggleDemoMode, disableDemoMode, changeTestHotel, isUserAllowed]);
  return /*#__PURE__*/jsx(DemoModeContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsxs("div", {
      className: isDemoMode ? `${css$1D.demoMode}` : '',
      children: [isDemoMode && /*#__PURE__*/jsxs("div", {
        className: css$1D.demoBadge,
        children: [/*#__PURE__*/jsx(ScreenIcon, {
          color: colors$1.white
        }), /*#__PURE__*/jsx("span", {
          children: "DEMO"
        })]
      }), shouldShowConfigurationModal && /*#__PURE__*/jsx(DemoModeConfigurationModal, {
        onConfirm: handleConfirm,
        onCancel: handleClose,
        toast: toast
      }), children]
    })
  });
};
const useDemoMode = () => {
  const context = useContext(DemoModeContext);
  if (!context) {
    throw new Error('demoModeContext must be used within a DemoModeProvider');
  }
  return context;
};

const useUsersList = () => {
  const [fetchedUsersList, setFetchedUsersList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$9.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel
  } = useCurrentHotel();
  const {
    isDemoMode
  } = useDemoMode();
  const loadUsersList = useCallback(async () => {
    if (!currentHotel?.id) {
      setFetchedUsersList({});
      setLoadingState(dataLoadingStatus$9.idle);
      return;
    }
    setLoadingState(dataLoadingStatus$9.loading);
    setError(null);
    try {
      const response = await axios.get(apiEndpoints.usersList);
      const data = response.data.users || {};
      setFetchedUsersList(data);
      setLoadingState(dataLoadingStatus$9.success);
    } catch (err) {
      console.error('Failed to load users list:', err);
      setFetchedUsersList({});
      setLoadingState(dataLoadingStatus$9.error);
      setError(err?.response?.data?.message || 'Failed to load users');
    }
  }, [currentHotel?.id]);
  const usersList = useMemo(() => {
    if (!isDemoMode) {
      return fetchedUsersList;
    }
    return Object.fromEntries(Object.entries(fetchedUsersList).map(([id, user]) => [id, {
      ...user,
      fullName: 'Demo User'
    }]));
  }, [fetchedUsersList, isDemoMode]);
  useEffect(() => {
    loadUsersList();
  }, [loadUsersList]);
  return {
    usersList,
    loadingState,
    isLoading: loadingState === dataLoadingStatus$9.loading,
    error,
    refresh: loadUsersList
  };
};

const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
const useCountUp = (target, duration = 800) => {
  const safeTarget = Number.isFinite(target) ? target : 0;
  const [current, setCurrent] = useState(0);
  const previousTargetRef = useRef(0);
  useEffect(() => {
    const startValue = previousTargetRef.current;
    const endValue = safeTarget;
    if (startValue === endValue) {
      setCurrent(endValue);
      return undefined;
    }
    let rafId;
    let startTime = null;
    const step = timestamp => {
      if (startTime === null) {
        startTime = timestamp;
      }
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const value = startValue + (endValue - startValue) * easeOutCubic(progress);
      setCurrent(value);
      if (progress < 1) {
        rafId = requestAnimationFrame(step);
      } else {
        previousTargetRef.current = endValue;
      }
    };
    rafId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafId);
  }, [safeTarget, duration]);
  return current;
};

const readPageFromUrl = paramName => {
  if (typeof window === 'undefined') {
    return 1;
  }
  const value = parseInt(new URLSearchParams(window.location.search).get(paramName), 10);
  return Number.isFinite(value) && value > 0 ? value : 1;
};
const useUrlPage = (paramName = 'page') => {
  const [page, setPage] = useState(() => readPageFromUrl(paramName));
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    if (page > 1) {
      params.set(paramName, String(page));
    } else {
      params.delete(paramName);
    }
    const query = params.toString();
    window.history.replaceState({}, '', query ? `?${query}` : window.location.pathname);
  }, [page, paramName]);
  const stripFromParams = useCallback(params => {
    params.delete(paramName);
    return params;
  }, [paramName]);
  return [page, setPage, stripFromParams];
};

const ColumnVisibilityContext = /*#__PURE__*/createContext$1({});

const ColumnVisibilityProvider = ({
  children,
  defaultVisibleColumns,
  columnsVisibilityOptions,
  resolveColumnId,
  storageKey,
  onUrlStateChange
}) => {
  const {
    visibleColumns,
    applyColumns
  } = useColumnVisibility({
    defaultVisibleColumns,
    columnsVisibilityOptions,
    resolveColumnId,
    storageKey,
    onUrlStateChange
  });
  const value = useMemo(() => ({
    visibleColumns,
    applyColumns,
    columnsVisibilityOptions
  }), [visibleColumns, applyColumns, columnsVisibilityOptions]);
  return /*#__PURE__*/jsx(ColumnVisibilityContext.Provider, {
    value: value,
    children: children
  });
};
const useColumnVisibilityContext = () => {
  const context = useContext(ColumnVisibilityContext);
  if (!context) {
    throw new Error('useCurrentHotel must be used within a CurrentHotelProvider');
  }
  return context;
};

const TranslationsContext = /*#__PURE__*/createContext$1({});

const CACHE_TTL_MINUTES = 30;
const CACHE_VERSION = '1.0';
const TranslationsProvider = ({
  children
}) => {
  const [translations, setTranslations] = useState({});
  const isCacheValid = useCallback(() => {
    try {
      const cacheMeta = sessionStorage.getItem('translations_meta');
      if (!cacheMeta) {
        return false;
      }
      const {
        timestamp,
        version
      } = JSON.parse(cacheMeta);
      if (version !== CACHE_VERSION) {
        return false;
      }
      const now = Date.now();
      const age = now - timestamp;
      const maxAge = CACHE_TTL_MINUTES * 60 * 1000;
      return age <= maxAge;
    } catch (e) {
      return false;
    }
  }, []);
  const saveToCache = useCallback(translationsData => {
    try {
      sessionStorage.setItem('translations', JSON.stringify(translationsData));
      sessionStorage.setItem('translations_meta', JSON.stringify({
        timestamp: Date.now(),
        version: CACHE_VERSION
      }));
    } catch (e) {
      console.warn('Failed to cache translations:', e);
    }
  }, []);
  const loadTranslations = useCallback(async (forceRefresh = false) => {
    if (!forceRefresh && isCacheValid()) {
      try {
        const cached = sessionStorage.getItem('translations');
        if (cached) {
          setTranslations(JSON.parse(cached));
          const cacheMeta = JSON.parse(sessionStorage.getItem('translations_meta'));
          const cacheAge = Date.now() - cacheMeta.timestamp;
          if (cacheAge > CACHE_TTL_MINUTES * 60 * 1000) {
            loadTranslations(true);
          }
          return JSON.parse(cached);
        }
      } catch (e) {
        console.warn('Failed to load cached translations:', e);
      }
    }
    try {
      const response = await axios.get(restUrls.loadTranslations);
      const translationsData = response.data.translations || {};
      setTranslations(translationsData);
      saveToCache(translationsData);
      return translationsData;
    } catch (error) {
      console.error('Failed to load translations:', error);
      if (!forceRefresh) {
        try {
          const cached = sessionStorage.getItem('translations');
          if (cached) {
            setTranslations(JSON.parse(cached));
            console.log('Using expired cache as fallback');
          }
        } catch (e) {
          console.warn('Failed to load expired cache:', e);
        }
      }
      throw error;
    }
  }, [isCacheValid, saveToCache]);
  useEffect(() => {
    loadTranslations();
  }, []);
  const translate = useCallback((key, search, replace, rawString = false) => {
    let translation = translations[key] ?? key;
    if (Array.isArray(search)) {
      for (let i in search) {
        translation = translation.replaceAll(search[i], replace[i]);
      }
    } else if (search instanceof String || typeof search === 'string') {
      translation = translation.replaceAll(search, replace);
    }
    return rawString ? translation : /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: translation
      }
    });
  }, [translations]);
  const t = translate;
  const value = useMemo(() => ({
    translate,
    t
  }), [translate]);
  return /*#__PURE__*/jsx(TranslationsContext.Provider, {
    value: value,
    children: children
  });
};
const useTranslations = () => {
  const context = useContext(TranslationsContext);
  if (!context) {
    throw new Error('useTranslations must be used within a TranslationsProvider');
  }
  return context;
};
const TText = ({
  k,
  search,
  replace,
  raw = false
}) => {
  const {
    translate
  } = useTranslations();
  return translate(k, search, replace, raw);
};

const FeatureFlagsContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$7 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const FeatureFlagsProvider = ({
  initFeatureFlags,
  children
}) => {
  const [featureFlags, setFeatureFlags] = useState(initFeatureFlags ? initFeatureFlags : null);
  const [loadingState, setLoadingState] = useState(initFeatureFlags ? dataLoadingStatus$7.success : dataLoadingStatus$7.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isCurrentHotelLoading
  } = useCurrentHotel();
  const loadFeatureFlags = useCallback(async () => {
    if (!currentHotel) {
      setFeatureFlags(null);
      setLoadingState(dataLoadingStatus$7.idle);
      return;
    }
    setLoadingState(dataLoadingStatus$7.loading);
    setError(null);
    try {
      const response = await axios.get(apiEndpoints.featureFlags);
      setFeatureFlags(response.data);
      setLoadingState(dataLoadingStatus$7.success);
      return response.data;
    } catch (error) {
      setFeatureFlags(null);
      setLoadingState(dataLoadingStatus$7.error);
      setError(error?.response?.data?.message || 'Failed to load feature flags');
    }
  }, [currentHotel]);
  const updateFeatureFlag = useCallback(async (featureFlagCode, toStatus) => {
    if (!currentHotel) {
      return;
    }
    try {
      const formData = new FormData();
      formData.append('featureFlagCode', featureFlagCode);
      formData.append('toStatus', toStatus ? '1' : '0');
      console.log(featureFlagCode, toStatus);
      await axios.post(apiEndpoints.saveFeatureFlags, formData);
      setFeatureFlags(prev => ({
        ...prev,
        [featureFlagCode]: toStatus
      }));
      setLoadingState(dataLoadingStatus$7.success);
    } catch (error) {
      setLoadingState(dataLoadingStatus$7.error);
      throw error;
    }
  }, [currentHotel]);
  useEffect(() => {
    if (initFeatureFlags) {
      return;
    }
    if (isCurrentHotelLoading) {
      return;
    }
    if (!currentHotel) {
      setFeatureFlags(null);
      setLoadingState(dataLoadingStatus$7.idle);
      setError(null);
      return;
    }
    loadFeatureFlags();
  }, [currentHotel, isCurrentHotelLoading, loadFeatureFlags, initFeatureFlags]);
  const isEnabled = useCallback(featureName => {
    if (!featureFlags) {
      return false;
    }
    return featureFlags[featureName] === true;
  }, [featureFlags]);
  const value = useMemo(() => ({
    featureFlags,
    loadFeatureFlags,
    isLoading: loadingState === dataLoadingStatus$7.loading,
    loadingState,
    error,
    isEnabled,
    hasFlags: !!featureFlags,
    updateFeatureFlag
  }), [featureFlags, loadFeatureFlags, loadingState, error, isEnabled, updateFeatureFlag]);
  return /*#__PURE__*/jsx(FeatureFlagsContext.Provider, {
    value: value,
    children: children
  });
};
const useFeatureFlags = () => {
  const context = useContext(FeatureFlagsContext);
  if (!context) {
    throw new Error('useFeatureFlags must be used within a FeatureFlagsProvider');
  }
  return context;
};

const RoomTypesListContext = /*#__PURE__*/createContext$1({});

const RefCollectContext = /*#__PURE__*/createContext$1(null);

const dataLoadingStatus$6 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const RoomTypesListProvider = ({
  initRoomTypesList = null,
  children
}) => {
  const [roomTypesList, setRoomTypesList] = useState(initRoomTypesList ? initRoomTypesList : {});
  const [loadingState, setLoadingState] = useState(initRoomTypesList ? dataLoadingStatus$6.success : dataLoadingStatus$6.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const refCollectorCtx = useContext(RefCollectContext);
  const loadRoomTypesList = useCallback(async () => {
    if (!currentHotel?.id) {
      setRoomTypesList({});
      setLoadingState(dataLoadingStatus$6.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$6.loading);
    setError(null);
    try {
      const response = await axios.get(`${apiEndpoints.roomTypes}?extended=true`);
      setRoomTypesList(response.data);
      setLoadingState(dataLoadingStatus$6.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load room types list:', error);
      setRoomTypesList({});
      setLoadingState(dataLoadingStatus$6.error);
      setError(error?.response?.data?.message || 'Failed to load room types');
    }
  }, [currentHotel?.id]);
  useEffect(() => {
    if (initRoomTypesList) {
      return;
    }
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setRoomTypesList({});
      setLoadingState(dataLoadingStatus$6.idle);
      setError(null);
      return;
    }
    loadRoomTypesList();
  }, [currentHotel?.id, isHotelLoading, loadRoomTypesList, initRoomTypesList]);
  const getRoomType = useCallback(roomTypeId => {
    if (refCollectorCtx) {
      return getSuspenseRef('room_type', roomTypeId, refCollectorCtx, roomTypesList);
    }
    return roomTypesList[roomTypeId] || null;
  }, [roomTypesList, refCollectorCtx]);
  const getRoomTypesByCategory = useCallback(category => {
    return Object.values(roomTypesList).filter(rt => rt.category === category);
  }, [roomTypesList]);
  const getRoomTypesArray = useCallback(() => {
    return Object.values(roomTypesList);
  }, [roomTypesList]);
  const getRoomTypesByStatus = useCallback(status => {
    return Object.values(roomTypesList).filter(rt => rt.status === status);
  }, [roomTypesList]);
  const updateRoomTypeById = useCallback((roomTypeId, field, value) => {
    const roomType = {
      ...roomTypesList[roomTypeId]
    };
    if (!roomType) {
      return;
    }
    roomType[field] = value;
    setRoomTypesList({
      ...roomTypesList,
      [roomTypeId]: roomType
    });
  }, [roomTypesList]);
  const value = useMemo(() => ({
    roomTypesList,
    reloadRoomTypesList: loadRoomTypesList,
    isLoading: loadingState === dataLoadingStatus$6.loading,
    loadingState,
    error,
    isReady: loadingState === dataLoadingStatus$6.success,
    hasData: Object.keys(roomTypesList).length > 0,
    isEmpty: Object.keys(roomTypesList).length === 0 && loadingState === dataLoadingStatus$6.success,
    getRoomType,
    getRoomTypesByCategory,
    getRoomTypesArray,
    getRoomTypesByStatus,
    updateRoomTypeById
  }), [roomTypesList, loadRoomTypesList, loadingState, error, getRoomType, getRoomTypesByCategory, getRoomTypesArray, getRoomTypesByStatus, updateRoomTypeById]);
  return /*#__PURE__*/jsx(RoomTypesListContext.Provider, {
    value: value,
    children: children
  });
};
const useRoomTypesList = () => {
  const context = useContext(RoomTypesListContext);
  if (!context) {
    throw new Error('useRoomTypesList must be used within a RoomTypesListProvider');
  }
  return context;
};

const ExtraTypesListContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$5 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const ExtraTypesListProvider = ({
  children
}) => {
  const [extraTypesList, setExtraTypesList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$5.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const refCollectorCtx = useContext(RefCollectContext);
  const loadExtraTypesList = useCallback(async () => {
    if (!currentHotel?.id) {
      setExtraTypesList({});
      setLoadingState(dataLoadingStatus$5.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$5.loading);
    setError(null);
    try {
      const response = await axios.get(`${apiEndpoints.extraTypes}?extended=true`);
      setExtraTypesList(response.data.extraTypes);
      setLoadingState(dataLoadingStatus$5.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load extra types list:', error);
      setExtraTypesList({});
      setLoadingState(dataLoadingStatus$5.error);
      setError(error?.response?.data?.message || 'Failed to load extra types');
    }
  }, [currentHotel?.id]);
  useEffect(() => {
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setExtraTypesList({});
      setLoadingState(dataLoadingStatus$5.idle);
      setError(null);
      return;
    }
    loadExtraTypesList();
  }, [currentHotel?.id, isHotelLoading, loadExtraTypesList]);
  const getExtraType = useCallback(extraTypeId => {
    if (refCollectorCtx) {
      return getSuspenseRef('extra_type', extraTypeId, refCollectorCtx, extraTypesList);
    }
    return extraTypesList[extraTypeId] || null;
  }, [extraTypesList, refCollectorCtx]);
  const getExtraTypesByCategory = useCallback(category => {
    return Object.values(extraTypesList).filter(et => et.category === category);
  }, [extraTypesList]);
  const getExtraTypesArray = useCallback(() => {
    return Object.values(extraTypesList);
  }, [extraTypesList]);
  const getExtraTypesByStatus = useCallback(status => {
    return Object.values(extraTypesList).filter(et => et.status === status);
  }, [extraTypesList]);
  const value = useMemo(() => ({
    extraTypesList,
    reloadExtraTypesList: loadExtraTypesList,
    isLoading: loadingState === dataLoadingStatus$5.loading,
    isReady: loadingState === dataLoadingStatus$5.success,
    loadingState,
    error,
    hasData: Object.keys(extraTypesList).length > 0,
    isEmpty: Object.keys(extraTypesList).length === 0 && loadingState === dataLoadingStatus$5.success,
    getExtraType,
    getExtraTypesByCategory,
    getExtraTypesArray,
    getExtraTypesByStatus
  }), [extraTypesList, loadingState, error, loadExtraTypesList, getExtraType, getExtraTypesByCategory, getExtraTypesArray, getExtraTypesByStatus]);
  return /*#__PURE__*/jsx(ExtraTypesListContext.Provider, {
    value: value,
    children: children
  });
};
const useExtraTypesList = () => {
  const context = useContext(ExtraTypesListContext);
  if (!context) {
    throw new Error('useExtraTypesList must be used within a ExtraTypesListProvider');
  }
  return context;
};

const BundlesListContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$4 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const BundlesListProvider = ({
  children
}) => {
  const [bundlesList, setBundlesList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$4.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const loadBundlesList = useCallback(async () => {
    if (!currentHotel?.id) {
      setBundlesList({});
      setLoadingState(dataLoadingStatus$4.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$4.loading);
    setError(null);
    try {
      // Deleted bundles are kept: past transactions still reference them, and consumers that only
      // care about live ones filter by status the same way they do for room and extra types
      const response = await axios.get(`${apiEndpoints.bundles}?include_deleted=true`);
      setBundlesList(response.data.bundles);
      setLoadingState(dataLoadingStatus$4.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load bundles list:', error);
      setBundlesList({});
      setLoadingState(dataLoadingStatus$4.error);
      setError(error?.response?.data?.message || 'Failed to load bundles');
    }
  }, [currentHotel?.id]);
  useEffect(() => {
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setBundlesList({});
      setLoadingState(dataLoadingStatus$4.idle);
      setError(null);
      return;
    }
    loadBundlesList();
  }, [currentHotel?.id, isHotelLoading, loadBundlesList]);
  const getBundle = useCallback(bundleId => {
    return bundlesList[bundleId] || null;
  }, [bundlesList]);
  const getBundlesArray = useCallback(() => {
    return Object.values(bundlesList);
  }, [bundlesList]);
  const getBundlesByStatus = useCallback(status => {
    return Object.values(bundlesList).filter(bundle => bundle.status === status);
  }, [bundlesList]);
  const value = useMemo(() => ({
    bundlesList,
    reloadBundlesList: loadBundlesList,
    isLoading: loadingState === dataLoadingStatus$4.loading,
    isReady: loadingState === dataLoadingStatus$4.success,
    loadingState,
    error,
    hasData: Object.keys(bundlesList).length > 0,
    isEmpty: Object.keys(bundlesList).length === 0 && loadingState === dataLoadingStatus$4.success,
    getBundle,
    getBundlesArray,
    getBundlesByStatus
  }), [bundlesList, loadingState, error, loadBundlesList, getBundle, getBundlesArray, getBundlesByStatus]);
  return /*#__PURE__*/jsx(BundlesListContext.Provider, {
    value: value,
    children: children
  });
};
const useBundlesList = () => {
  const context = useContext(BundlesListContext);
  if (!context) {
    throw new Error('useBundlesList must be used within a BundlesListProvider');
  }
  return context;
};

const MarketSegmentsListContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$3 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const MarketSegmentsListProvider = ({
  children
}) => {
  const [marketSegmentsList, setMarketSegmentsList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$3.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const loadMarketSegmentsList = useCallback(async () => {
    if (!currentHotel?.id) {
      setMarketSegmentsList({});
      setLoadingState(dataLoadingStatus$3.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$3.loading);
    setError(null);
    try {
      const response = await axios.get(apiEndpoints.marketSegments);
      setMarketSegmentsList(response.data);
      setLoadingState(dataLoadingStatus$3.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load market segments list:', error);
      setMarketSegmentsList({});
      setLoadingState(dataLoadingStatus$3.error);
      setError(error?.response?.data?.message || 'Failed to load market segments');
    }
  }, [currentHotel?.id]);
  useEffect(() => {
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setMarketSegmentsList({});
      setLoadingState(dataLoadingStatus$3.idle);
      setError(null);
      return;
    }
    loadMarketSegmentsList();
  }, [currentHotel?.id, isHotelLoading, loadMarketSegmentsList]);
  const getMarketSegment = useCallback(marketSegmentId => {
    return marketSegmentsList[marketSegmentId] || null;
  }, [marketSegmentsList]);
  const getMarketSegmentsArray = useCallback(() => {
    return Object.values(marketSegmentsList);
  }, [marketSegmentsList]);
  const value = useMemo(() => ({
    marketSegmentsList,
    reloadMarketSegmentsList: loadMarketSegmentsList,
    isLoading: loadingState === dataLoadingStatus$3.loading,
    isReady: loadingState === dataLoadingStatus$3.success,
    loadingState,
    error,
    hasData: Object.keys(marketSegmentsList).length > 0,
    isEmpty: Object.keys(marketSegmentsList).length === 0 && loadingState === dataLoadingStatus$3.success,
    getMarketSegment,
    getMarketSegmentsArray
  }), [marketSegmentsList, loadingState, error]);
  return /*#__PURE__*/jsx(MarketSegmentsListContext.Provider, {
    value: value,
    children: children
  });
};
const useMarketSegmentsList = () => {
  const context = useContext(MarketSegmentsListContext);
  if (!context) {
    throw new Error('useMarketSegmentsList must be used within a MarketSegmentsListProvider');
  }
  return context;
};

const RatePlansListContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$2 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const RatePlansListProvider = ({
  children
}) => {
  const [ratePlansList, setRatePlansList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$2.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const loadRatePlansList = useCallback(async () => {
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setRatePlansList({});
      setLoadingState(dataLoadingStatus$2.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$2.loading);
    setError(null);
    try {
      const response = await axios.get(apiEndpoints.ratePlans);
      setRatePlansList(response.data.ratePlans);
      setLoadingState(dataLoadingStatus$2.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load rate plans list:', error);
      setRatePlansList({});
      setLoadingState(dataLoadingStatus$2.error);
      setError(error?.response?.data?.message || 'Failed to load rate plans');
    }
  }, [currentHotel?.id, isHotelLoading]);
  useEffect(() => {
    if (!currentHotel?.id) {
      setRatePlansList({});
      setLoadingState(dataLoadingStatus$2.idle);
      setError(null);
      return;
    }
    loadRatePlansList();
  }, [currentHotel?.id, loadRatePlansList]);
  const getRatePlan = useCallback(ratePlanId => {
    return ratePlansList[ratePlanId] || null;
  }, [ratePlansList]);
  const getRatePlansArray = useCallback(() => {
    return Object.values(ratePlansList);
  }, [ratePlansList]);
  const value = useMemo(() => ({
    ratePlansList,
    reloadRatePlansList: loadRatePlansList,
    isLoading: loadingState === dataLoadingStatus$2.loading,
    isReady: loadingState === dataLoadingStatus$2.success,
    loadingState,
    error,
    hasData: Object.keys(ratePlansList).length > 0,
    isEmpty: Object.keys(ratePlansList).length === 0 && loadingState === dataLoadingStatus$2.success,
    getRatePlan,
    getRatePlansArray
  }), [ratePlansList, loadingState, error]);
  return /*#__PURE__*/jsx(RatePlansListContext.Provider, {
    value: value,
    children: children
  });
};
const useRatePlansList = () => {
  const context = useContext(RatePlansListContext);
  if (!context) {
    throw new Error('useRatePlansList must be used within a RatePlansListProvider');
  }
  return context;
};

const ReservationSourcesListContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus$1 = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const ReservationSourcesListProvider = ({
  children
}) => {
  const [reservationSourcesList, setReservationSourcesList] = useState({});
  const [loadingState, setLoadingState] = useState(dataLoadingStatus$1.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel,
    isLoading: isHotelLoading
  } = useCurrentHotel();
  const loadReservationSourcesList = useCallback(async () => {
    if (!currentHotel?.id) {
      setReservationSourcesList({});
      setLoadingState(dataLoadingStatus$1.idle);
      setError(null);
      return;
    }
    setLoadingState(dataLoadingStatus$1.loading);
    setError(null);
    try {
      const response = await axios.get(apiEndpoints.reservationSources);
      setReservationSourcesList(response.data);
      setLoadingState(dataLoadingStatus$1.success);
      return response.data;
    } catch (error) {
      console.error('Failed to load reservation sources list:', error);
      setReservationSourcesList({});
      setLoadingState(dataLoadingStatus$1.error);
      setError(error?.response?.data?.message || 'Failed to load reservation sources');
    }
  }, [currentHotel?.id]);
  useEffect(() => {
    if (isHotelLoading) {
      return;
    }
    if (!currentHotel?.id) {
      setReservationSourcesList({});
      setLoadingState(dataLoadingStatus$1.idle);
      setError(null);
      return;
    }
    loadReservationSourcesList();
  }, [currentHotel?.id, isHotelLoading, loadReservationSourcesList]);
  const getReservationSource = useCallback(reservationSourceId => {
    return reservationSourcesList[reservationSourceId] || null;
  }, [reservationSourcesList]);
  const getReservationSourcesArray = useCallback(() => {
    return Object.values(reservationSourcesList);
  }, [reservationSourcesList]);
  const value = useMemo(() => ({
    reservationSourcesList,
    reloadReservationSourcesList: loadReservationSourcesList,
    isLoading: loadingState === dataLoadingStatus$1.loading,
    isReady: loadingState === dataLoadingStatus$1.success,
    loadingState,
    error,
    hasData: Object.keys(reservationSourcesList).length > 0,
    isEmpty: Object.keys(reservationSourcesList).length === 0 && loadingState === dataLoadingStatus$1.success,
    getReservationSource,
    getReservationSourcesArray
  }), [reservationSourcesList, loadingState, error]);
  return /*#__PURE__*/jsx(ReservationSourcesListContext.Provider, {
    value: value,
    children: children
  });
};
const useReservationSourcesList = () => {
  const context = useContext(ReservationSourcesListContext);
  if (!context) {
    throw new Error('useReservationSourcesList must be used within a ReservationSourcesListProvider');
  }
  return context;
};

const LONG_FLIGHT_MS = 600;
const MAX_PARALLEL_FLIGHTS = 2;
const keyOf = (type, id) => `${type}|${id}`;
const parse$1 = key => {
  const [type, id] = key.split('|');
  return {
    type,
    id
  };
};
function RefCollectorProvider({
  children
}) {
  const needsRef = useRef(new Set());
  const inFlightRef = useRef(new Set());
  const flightsRef = useRef([]);
  const [tick, setTick] = useState(0);
  const emitterRef = useRef(new EventTarget());
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const reportNeed = useCallback(({
    type,
    id
  }) => {
    if (!type || !id) {
      return;
    }
    const key = keyOf(type, id);
    if (refCache.has(type, id)) {
      return;
    }
    if (inFlightRef.current.has(key)) {
      return;
    }
    needsRef.current.add(key);
    queueMicrotask(() => {
      setTick(t => t + 1);
    });
  }, []);
  const prefetch = useCallback(batch => {
    const filtered = batch.filter(({
      type,
      id
    }) => {
      if (!type || !id) {
        return false;
      }
      const key = keyOf(type, id);
      return !refCache.has(type, id) && !inFlightRef.current.has(key);
    });
    if (filtered.length > 0) {
      filtered.forEach(({
        type,
        id
      }) => {
        needsRef.current.add(keyOf(type, id));
      });
      setTick(t => t + 1);
    }
  }, []);
  const subscribe = useCallback((key, callback) => {
    const eventTarget = emitterRef.current;

    // Wrap callback to match Event API
    const handler = event => {
      callback(event.detail);
    };
    eventTarget.addEventListener(key, handler);

    // Return unsubscribe function
    return () => {
      eventTarget.removeEventListener(key, handler);
    };
  }, []);
  const startFlush = useCallback(async keys => {
    if (keys.length === 0) {
      return;
    }
    const takenSet = new Set(keys);
    keys.forEach(k => {
      inFlightRef.current.add(k);
      needsRef.current.delete(k);
    });
    flightsRef.current.push({
      startedAt: Date.now(),
      keys: takenSet
    });
    showLoading();
    try {
      await fetchRefs(keys.map(parse$1));
      keys.forEach(key => {
        const event = new CustomEvent(key, {
          detail: {
            key,
            success: true
          }
        });
        emitterRef.current.dispatchEvent(event);
      });
    } catch (err) {
      keys.forEach(key => {
        const event = new CustomEvent(key, {
          detail: {
            key,
            success: false,
            error: err
          }
        });
        emitterRef.current.dispatchEvent(event);
      });
    } finally {
      flightsRef.current = flightsRef.current.filter(f => f.keys !== takenSet);
      takenSet.forEach(k => inFlightRef.current.delete(k));
      if (flightsRef.current.length === 0) {
        hideLoading();
      }
      queueMicrotask(() => {
        setTick(t => t + 1);
      });
    }
  }, [showLoading, hideLoading]);
  useEffect(() => {
    if (needsRef.current.size === 0) {
      return;
    }
    if (flightsRef.current.length === 0) {
      const needs = Array.from(needsRef.current);
      startFlush(needs);
      return;
    }
    if (flightsRef.current.length >= MAX_PARALLEL_FLIGHTS) {
      return;
    }
    const oldest = flightsRef.current.reduce((m, f) => Math.min(m, f.startedAt), Infinity);
    if (Date.now() - oldest < LONG_FLIGHT_MS) {
      return;
    }
    const extra = [];
    for (const k of needsRef.current) {
      if (!inFlightRef.current.has(k)) extra.push(k);
    }
    if (extra.length > 0) {
      startFlush(extra);
    }
  }, [tick, startFlush]);
  const value = useMemo(() => ({
    reportNeed,
    prefetch,
    subscribe
  }), [reportNeed, prefetch, subscribe]);
  return /*#__PURE__*/jsx(RefCollectContext.Provider, {
    value: value,
    children: children
  });
}

const HotelLookupContext = /*#__PURE__*/createContext$1(null);
const HotelLookupProvider = ({
  children
}) => {
  const refCollectorCtx = useContext(RefCollectContext);
  const getHotel = useCallback(hotelId => {
    return getSuspenseRef('hotel', hotelId, refCollectorCtx);
  }, [refCollectorCtx]);
  const value = useMemo(() => ({
    getHotel
  }), [getHotel]);
  return /*#__PURE__*/jsx(HotelLookupContext.Provider, {
    value: value,
    children: children
  });
};
const useHotelLookup = () => {
  const context = useContext(HotelLookupContext);
  if (!context) {
    throw new Error('useHotelLookup must be used within a HotelLookupProvider');
  }
  return context;
};

const ResellerContext = /*#__PURE__*/createContext$1({});

const dataLoadingStatus = {
  idle: 'idle',
  loading: 'loading',
  success: 'success',
  error: 'error'
};
const ResellerProvider = ({
  children,
  initResellerId
}) => {
  const [resellerData, setResellerData] = useState(null);
  const [loadingState, setLoadingState] = useState(dataLoadingStatus.idle);
  const [error, setError] = useState(null);
  const {
    currentHotel
  } = useCurrentHotel();
  const loadResellerData = useCallback(async () => {
    let resellerId = initResellerId ?? currentHotel?.resellerId;
    if (!resellerId) {
      setResellerData(null);
      setLoadingState(dataLoadingStatus.success);
      resetWhiteLabelTheme();
      return;
    }
    setLoadingState(dataLoadingStatus.loading);
    setError(null);
    try {
      const response = await axios.get(`${apiEndpoints.resellerWhitelabel}?resellerId=${resellerId}`);
      const data = response.data;
      setResellerData(data);
      setLoadingState(dataLoadingStatus.success);
      if (data.colors && Object.entries(data.colors).length > 0) {
        changeWhitelabelTheme(data.colors);
        changeWhitelabelThemeV2(data.colors);
      }
      return data;
    } catch (error) {
      console.error('Failed to load reseller data:', error);
      setError(error?.response?.data?.message || 'Failed to load reseller configuration');
      setLoadingState(dataLoadingStatus.error);
      setResellerData(null);
      resetWhiteLabelTheme();
    }
  }, [initResellerId, currentHotel?.resellerId]);
  const fetchResellerEntity = useCallback(async resellerId => {
    if (!resellerId) {
      return null;
    }
    try {
      const {
        data
      } = await axios.get(`${apiEndpoints.reseller}/${resellerId}`);
      return data.reseller;
    } catch (error) {
      console.error('Failed to fetch reseller entity:', error);
      throw error;
    }
  }, []);
  useEffect(() => {
    loadResellerData();
  }, [loadResellerData]);
  const value = useMemo(() => ({
    // Data
    resellerData,
    resellerLogo: resellerData?.logo || null,
    resellerUrls: resellerData?.urls || null,
    resellerColors: resellerData?.colors || null,
    resellerId: initResellerId ?? currentHotel?.resellerId ?? 0,
    // State
    loadingState,
    isLoadingReseller: loadingState === dataLoadingStatus.loading,
    hasReseller: !!resellerData,
    error,
    // Methods
    loadResellerData,
    fetchResellerEntity
  }), [resellerData, initResellerId, currentHotel?.resellerId, loadingState, error, loadResellerData, fetchResellerEntity]);
  return /*#__PURE__*/jsx(ResellerContext.Provider, {
    value: value,
    children: children
  });
};
const useReseller = () => {
  const context = useContext(ResellerContext);
  if (!context) {
    throw new Error('useReseller must be used within a ResellerProvider');
  }
  return context;
};

const UserBehaviourTrackerProvider = ({
  children
}) => {
  const posthog = usePostHog();
  const {
    currentUser
  } = useCurrentUser();
  const {
    currentHotel
  } = useCurrentHotel();
  useEffect(() => {
    if (!import.meta.env.PROD) {
      return;
    }
    posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
      api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
      person_profiles: 'identified_only',
      autocapture: false,
      capture_pageview: false,
      capture_pageleave: false,
      persistence: 'localStorage+cookie',
      loaded: function (posthog) {
        if (currentUser) {
          posthog?.identify(currentUser.id, {
            email: currentUser.email,
            name: currentUser.name,
            division: currentUser.division,
            level: currentUser.level,
            department: currentUser.department
          });
        }
      }
    });
  }, [currentUser]);
  useEffect(() => {
    trackGroup(posthog, currentHotel);
  }, [currentHotel]);
  return /*#__PURE__*/jsx(PostHogProvider, {
    client: posthog,
    children: children
  });
};

const CrossPropertyRoomTypesListContext = /*#__PURE__*/createContext$1({});

var css_248z$1v = ".SidebarCard-module__sidebarCard___elIfu{align-items:flex-start;border-radius:var(--border-radius-medium);cursor:pointer;display:flex;gap:12px;margin:16px;padding:16px}.SidebarCard-module__sidebarCard___elIfu .SidebarCard-module__content___QLI65{display:flex;flex:1;flex-direction:column;gap:8px}.SidebarCard-module__sidebarCard___elIfu .SidebarCard-module__mainText___t5mZh{align-items:center;color:var(--white);display:flex;gap:10px}.SidebarCard-module__sidebarCard___elIfu .SidebarCard-module__description___uFLO8{color:var(--grey-20);font-size:var(--body-small-size)}.SidebarCard-module__sidebarCardCollapsed___5t70-{align-items:center;border-radius:var(--border-radius-medium);cursor:pointer;display:flex;flex-direction:column;justify-content:center;margin:8px;padding:8px}.SidebarCard-module__primary___Rm2r-{background:linear-gradient(135deg,var(--primary-color) 0,#0a1d37 100%)}.SidebarCard-module__secondary___9-LCS{background:linear-gradient(135deg,var(--secondary-color) 0,#0a1d37 100%)}@media (max-width:768px){.SidebarCard-module__sidebarCard___elIfu .SidebarCard-module__description___uFLO8{color:var(--white)}}";
var css$1t = {"sidebarCard":"SidebarCard-module__sidebarCard___elIfu","content":"SidebarCard-module__content___QLI65","mainText":"SidebarCard-module__mainText___t5mZh","description":"SidebarCard-module__description___uFLO8","sidebarCardCollapsed":"SidebarCard-module__sidebarCardCollapsed___5t70-","primary":"SidebarCard-module__primary___Rm2r-","secondary":"SidebarCard-module__secondary___9-LCS"};
styleInject(css_248z$1v);

const SidebarCard = ({
  variant = 'primary',
  icon,
  title,
  description,
  onClick,
  collapsedContent,
  isCollapsed = false,
  className = ''
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  if (isCollapsed && collapsedContent) {
    return /*#__PURE__*/jsx("div", {
      className: `${css$1t.sidebarCardCollapsed} ${css$1t[variant]} ${className}`,
      onClick: handleClick,
      children: collapsedContent
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: `${css$1t.sidebarCard} ${css$1t[variant]} ${className}`,
    onClick: handleClick,
    children: /*#__PURE__*/jsxs("div", {
      className: css$1t.content,
      children: [/*#__PURE__*/jsxs("h6", {
        className: css$1t.mainText,
        children: [icon, title]
      }), description && /*#__PURE__*/jsx("div", {
        className: css$1t.description,
        children: description
      })]
    })
  });
};
SidebarCard.propTypes = {
  variant: PropTypes.oneOf(['primary', 'secondary']),
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  onClick: PropTypes.func,
  collapsedContent: PropTypes.node,
  isCollapsed: PropTypes.bool,
  className: PropTypes.string
};

const DemoModeCard = () => {
  const {
    toggleDemoMode,
    isUserAllowed
  } = useDemoMode();
  const {
    isCollapsed
  } = useSidebar();
  if (!isUserAllowed) {
    return null;
  }
  const handleClick = () => {
    toggleDemoMode();
  };
  return /*#__PURE__*/jsx(SidebarCard, {
    variant: "secondary",
    onClick: handleClick,
    isCollapsed: isCollapsed,
    icon: /*#__PURE__*/jsx(ScreenIcon, {
      width: 18,
      height: 18,
      color: colors$1.white
    }),
    title: "Demo mode",
    collapsedContent: /*#__PURE__*/jsx(ScreenIcon, {
      width: 24,
      height: 24,
      color: colors$1.white
    })
  });
};

const DemoModeGuard = ({
  children,
  fallbackPath = 'dashboard'
}) => {
  const {
    isDemoMode,
    isOnDemoTestHotel,
    demoTestHotelId,
    shouldOpenInDemoTab
  } = useDemoMode();
  const {
    linkTo
  } = useCurrentHotel();
  const location = useLocation();
  useEffect(() => {
    if (shouldOpenInDemoTab) {
      const restOfPath = location.pathname.replace(/^\/\d+/, '');
      window.open(`/app/${demoTestHotelId}${restOfPath}`, '_blank');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (isOnDemoTestHotel) {
    return children || /*#__PURE__*/jsx(Outlet, {});
  }
  if (isDemoMode) {
    return /*#__PURE__*/jsx(Navigate, {
      to: linkTo(fallbackPath),
      replace: true
    });
  }
  return children || /*#__PURE__*/jsx(Outlet, {});
};

const ArrowSwitchHorizontal = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.3125 7.125L1.5 4.3125M1.5 4.3125L4.3125 1.5M1.5 4.3125H16.5M13.6875 10.875L16.5 13.6875M16.5 13.6875L13.6875 16.5M16.5 13.6875H1.5",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ArrowSwitchHorizontal.propTypes = {
  color: PropTypes.string
};

const DemoTestHotelsSection = ({
  toast
}) => {
  const posthog = usePostHog();
  const {
    demoTestHotelId,
    changeTestHotel
  } = useDemoMode();
  const [testHotels, setTestHotels] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    posthog.capture('demo_mode:test_hotel_section_open');
    const loadTestHotels = async () => {
      try {
        const response = await axios.get(apiEndpoints.loadTestHotels);
        setTestHotels(response.data.hotels || {});
      } catch (error) {
        toast?.error('Failed to load test hotels');
      } finally {
        setIsLoading(false);
      }
    };
    loadTestHotels();
  }, [posthog, toast]);
  const hotelsList = useMemo(() => Object.values(testHotels), [testHotels]);
  const handleClick = hotel => {
    if (Number(hotel.id) === demoTestHotelId) {
      return;
    }
    changeTestHotel(hotel);
  };
  if (isLoading) {
    return /*#__PURE__*/jsx("div", {
      style: {
        padding: '15px',
        textAlign: 'center'
      },
      children: /*#__PURE__*/jsx(InlineLoading, {})
    });
  }
  if (hotelsList.length <= 1) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx("div", {
      style: {
        padding: '10px 15px 0',
        borderTop: '1px solid var(--bg-dark)'
      },
      children: /*#__PURE__*/jsx(SectionTitle, {
        children: "Switch test hotel"
      })
    }), /*#__PURE__*/jsx("ul", {
      children: hotelsList.map(hotel => {
        const isCurrent = Number(hotel.id) === demoTestHotelId;
        return /*#__PURE__*/jsxs("li", {
          onClick: () => handleClick(hotel),
          style: isCurrent ? {
            opacity: 0.5,
            cursor: 'default'
          } : undefined,
          children: [/*#__PURE__*/jsx(ArrowSwitchHorizontal, {
            color: "var(--primary-color)",
            width: 25
          }), /*#__PURE__*/jsxs("span", {
            children: [hotel.name, isCurrent ? ' (current)' : '']
          })]
        }, hotel.id);
      })
    })]
  });
};

const LazyLoadingIndicator = () => {
  return /*#__PURE__*/jsx("div", {
    style: {
      height: '3px',
      width: '40px',
      background: `linear-gradient(90deg, ${colors$1.primaryColor}, ${colors$1.secondaryColor})`,
      borderRadius: '2px',
      animation: '1.5s ease-in-out infinite'
    }
  });
};

const HotelNameContent = ({
  id
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const {
    getHotel
  } = useHotelLookup();
  const resolved = id ? getHotel(id) : null;
  if (!resolved) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? `Hotel in ${resolved.city?.name ?? ''}` : resolved.name
  });
};
const HotelName = ({
  id
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(HotelNameContent, {
      id: id
    })
  });
};

const HotelShortNameContent = ({
  id
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const {
    getHotel
  } = useHotelLookup();
  const resolved = id ? getHotel(id) : null;
  if (!resolved) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? 'DEMO' : resolved.shortName
  });
};
const HotelShortName = ({
  id
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(HotelShortNameContent, {
      id: id
    })
  });
};

const GuestName = ({
  guestName
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? 'Demo Guest' : guestName ? guestName : '-'
  });
};

const AgentName = ({
  agentName
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? 'Demo User' : agentName ? agentName : '-'
  });
};

const EmailAddress = ({
  email
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? 'demo@mail.com' : email ? email : '-'
  });
};

const PhoneNumber = ({
  phoneNumber
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  return /*#__PURE__*/jsx(Fragment$1, {
    children: isDemoMode ? '+00 000 000 000' : phoneNumber ? phoneNumber : '-'
  });
};

const TimezoneContext = /*#__PURE__*/createContext$1({});

const TIMEZONE_OPTIONS = {
  UTC: 'utc',
  HOTEL: 'hotel',
  BROWSER: 'browser'
};
const STORAGE_KEY$1 = 'usg-timezone-preference';
const TimezoneProvider = ({
  children
}) => {
  const {
    currentHotel
  } = useCurrentHotel();
  const [timezonePreference, setTimezonePreference] = useState(() => localStorage.getItem(STORAGE_KEY$1) || TIMEZONE_OPTIONS.HOTEL);
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY$1, timezonePreference);
  }, [timezonePreference]);
  const hotelTimezone = currentHotel?.city?.timezone || 'UTC';
  const timezone = useMemo(() => {
    switch (timezonePreference) {
      case TIMEZONE_OPTIONS.UTC:
        return 'UTC';
      case TIMEZONE_OPTIONS.HOTEL:
        return hotelTimezone;
      case TIMEZONE_OPTIONS.BROWSER:
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      default:
        return 'UTC';
    }
  }, [timezonePreference, hotelTimezone]);
  const formatTz = useCallback((date, format) => {
    return formatDateTime(date, format, timezone);
  }, [timezone]);
  const value = useMemo(() => ({
    timezone,
    hotelTimezone,
    timezonePreference,
    setTimezonePreference,
    formatTz
  }), [timezone, hotelTimezone, timezonePreference, setTimezonePreference, formatTz]);
  return /*#__PURE__*/jsx(TimezoneContext.Provider, {
    value: value,
    children: children
  });
};
const useTimezone = () => {
  const context = useContext(TimezoneContext);
  if (!context) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
};

const TimezonePicker = ({
  label,
  size = 'small',
  style
}) => {
  const {
    timezonePreference,
    setTimezonePreference,
    hotelTimezone
  } = useTimezone();
  const browserTimezone = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);
  const options = useMemo(() => [{
    value: TIMEZONE_OPTIONS.UTC,
    label: 'UTC'
  }, {
    value: TIMEZONE_OPTIONS.HOTEL,
    label: `Hotel (${hotelTimezone})`
  }, {
    value: TIMEZONE_OPTIONS.BROWSER,
    label: `Browser (${browserTimezone})`
  }], [hotelTimezone, browserTimezone]);
  const handleChange = e => {
    setTimezonePreference(e.target.value);
  };
  return /*#__PURE__*/jsx(Dropdown, {
    label: label,
    value: timezonePreference,
    onChange: handleChange,
    options: options,
    size: size,
    style: style
  });
};

const PageContainerContext = /*#__PURE__*/createContext$1(null);
const usePageContainerContext = () => {
  return useContext(PageContainerContext);
};

const STORAGE_KEY = 'wideLayout';
const WideLayoutContext = /*#__PURE__*/createContext$1(null);
const getStoredPreferences = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {}
  return {};
};
const savePreferences = preferences => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(preferences));
  } catch {}
};
const getPageKey = pathname => {
  return pathname.replace(/\/\d+/g, '/:id').replace(/\/+$/, '').replace(/(\/:id)+$/, '') || '/';
};
const WideLayoutProvider = ({
  children
}) => {
  const [preferences, setPreferences] = useState(getStoredPreferences);
  const location = useLocation();
  const pageKey = getPageKey(location.pathname);
  const isWide = !!preferences[pageKey];
  useEffect(() => {
    savePreferences(preferences);
  }, [preferences]);
  const toggleWideLayout = useCallback(() => {
    setPreferences(previous => {
      const updated = {
        ...previous
      };
      if (updated[pageKey]) {
        delete updated[pageKey];
      } else {
        updated[pageKey] = true;
      }
      return updated;
    });
  }, [pageKey]);
  const value = useMemo(() => ({
    isWide,
    toggleWideLayout
  }), [isWide, toggleWideLayout]);
  const pageContainerValue = useMemo(() => ({
    wide: isWide
  }), [isWide]);
  return /*#__PURE__*/jsx(WideLayoutContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsx(PageContainerContext.Provider, {
      value: pageContainerValue,
      children: children
    })
  });
};
const useWideLayout = () => {
  const context = useContext(WideLayoutContext);
  if (!context) {
    throw new Error('useWideLayout must be used within a WideLayoutProvider');
  }
  return context;
};

const ImageAvatar = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M3.375 15.5624V14.1562C3.375 13.1206 4.21447 12.2812 5.25 12.2812H12.75C13.7855 12.2812 14.625 13.1206 14.625 14.1562V16.0312M3.375 16.5C2.33947 16.5 1.5 15.6164 1.5 14.5263V3.47368C1.5 2.38365 2.33947 1.5 3.375 1.5H14.625C15.6605 1.5 16.5 2.38365 16.5 3.47368V14.5263C16.5 15.6164 15.6605 16.5 14.625 16.5H3.375ZM11.3438 6.65616C11.3438 7.95058 10.2944 8.99991 9 8.99991C7.70558 8.99991 6.65625 7.95058 6.65625 6.65616C6.65625 5.36174 7.70558 4.31241 9 4.31241C10.2944 4.31241 11.3438 5.36174 11.3438 6.65616Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ImageAvatar.propTypes = {
  color: PropTypes.string
};

const Bold$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: color,
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.21 13c2.106 0 3.412-1.087 3.412-2.823 0-1.306-.984-2.283-2.324-2.386v-.055a2.176 2.176 0 0 0 1.852-2.14c0-1.51-1.162-2.46-3.014-2.46H3.843V13zM5.908 4.674h1.696c.963 0 1.517.451 1.517 1.244 0 .834-.629 1.32-1.73 1.32H5.908V4.673zm0 6.788V8.598h1.73c1.217 0 1.88.492 1.88 1.415 0 .943-.643 1.449-1.832 1.449H5.907z"
  })
});
Bold$1.propTypes = {
  color: PropTypes.string
};

const BulletList$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: color,
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    d: "M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
  })
});
BulletList$1.propTypes = {
  color: PropTypes.string
};

const ChevronLeft = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 7 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5.50016 9.1665L1.3335 4.99984L5.50016 0.833171",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ChevronLeft.propTypes = {
  color: PropTypes.string
};

const Component = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.49969 1.20724C8.776 0.930921 9.224 0.930922 9.50031 1.20724L11.5186 3.22548C11.7949 3.5018 11.7949 3.94979 11.5186 4.2261L9.50031 6.24435C9.224 6.52066 8.776 6.52066 8.49969 6.24435L6.48144 4.2261C6.20513 3.94979 6.20513 3.5018 6.48144 3.22548L8.49969 1.20724Z",
    stroke: color,
    strokeWidth: "1.66667"
  }), /*#__PURE__*/jsx("path", {
    d: "M13.2739 5.98144C13.5502 5.70513 13.9982 5.70513 14.2745 5.98144L16.2928 7.99969C16.5691 8.276 16.5691 8.724 16.2928 9.00031L14.2745 11.0186C13.9982 11.2949 13.5502 11.2949 13.2739 11.0186L11.2557 9.00031C10.9793 8.724 10.9793 8.276 11.2557 7.99969L13.2739 5.98144Z",
    stroke: color,
    strokeWidth: "1.66667"
  }), /*#__PURE__*/jsx("path", {
    d: "M3.72548 5.98144C4.0018 5.70513 4.44979 5.70513 4.7261 5.98144L6.74435 7.99969C7.02066 8.276 7.02066 8.724 6.74435 9.00031L4.7261 11.0186C4.44979 11.2949 4.0018 11.2949 3.72548 11.0186L1.70724 9.00031C1.43092 8.724 1.43092 8.276 1.70724 7.99969L3.72548 5.98144Z",
    stroke: color,
    strokeWidth: "1.66667"
  }), /*#__PURE__*/jsx("path", {
    d: "M8.49969 10.7556C8.776 10.4793 9.224 10.4793 9.50031 10.7557L11.5186 12.7739C11.7949 13.0502 11.7949 13.4982 11.5186 13.7745L9.50031 15.7928C9.224 16.0691 8.776 16.0691 8.49969 15.7928L6.48144 13.7745C6.20513 13.4982 6.20513 13.0502 6.48144 12.7739L8.49969 10.7556Z",
    stroke: color,
    strokeWidth: "1.66667"
  })]
});
Component.propTypes = {
  color: PropTypes.string
};

const ImageAdd = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 15 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M3.13167 12.9562L9.17072 7.27238L12.0126 10.1143M3.13167 12.9562H10.2364C11.4136 12.9562 12.3679 12.0019 12.3679 10.8248V7.27238M3.13167 12.9562C1.95452 12.9562 1.00024 12.0019 1.00024 10.8248V3.72C1.00024 2.54285 1.95452 1.58858 3.13167 1.58858H7.74976M11.6574 5.01906L11.6574 3.00953M11.6574 3.00953L11.6574 1M11.6574 3.00953L9.64785 3.00953M11.6574 3.00953L13.6669 3.00953M5.2631 4.78572C5.2631 5.3743 4.78596 5.85143 4.19739 5.85143C3.60881 5.85143 3.13167 5.3743 3.13167 4.78572C3.13167 4.19714 3.60881 3.72 4.19739 3.72C4.78596 3.72 5.2631 4.19714 5.2631 4.78572Z",
    stroke: color,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ImageAdd.propTypes = {
  color: PropTypes.string
};

const Italic$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: color,
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.991 11.674 9.53 4.455c.123-.595.246-.71 1.347-.807l.11-.52H7.211l-.11.52c1.06.096 1.128.212 1.005.807L6.57 11.674c-.123.595-.246.71-1.346.806l-.11.52h3.774l.11-.52c-1.06-.095-1.129-.211-1.006-.806z"
  })
});
Italic$1.propTypes = {
  color: PropTypes.string
};

const Key02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.5002 6.99977H6.60117M14.0009 17.5L8.4236 12.002C7.3443 12.4202 6.05478 12.256 4.85685 11.9055C2.00389 11.0709 0.377443 8.11445 1.22407 5.30204C2.07069 2.48963 5.06979 0.886291 7.92275 1.72088C10.7757 2.55548 12.4021 5.51196 11.5555 8.32437L11.4227 9.04548L17 14.5435V17.5H14.0009Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Key02.propTypes = {
  color: PropTypes.string
};

const Layers03 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M13.5 7.68525L17 9.47927L9 13.5799L1 9.47927L4.56397 7.65246M13.5 11.6054L17 13.3994L9 17.5L1 13.3994L4.56397 11.5726M9 1.5L17 5.60062L9 9.70124L1 5.60062L9 1.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Layers03.propTypes = {
  color: PropTypes.string
};

const Lightbulb01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.5 17H8.5M5 7H8M1.5 6C1.5 3.23858 3.73858 1 6.5 1C9.26142 1 11.5 3.23858 11.5 6C11.5 8.05032 10.2659 9.72844 8.5 10.5V13.5C8.5 14.0523 8.05228 14.5 7.5 14.5H5.5C4.94772 14.5 4.5 14.0523 4.5 13.5V10.584C2.7341 9.8124 1.5 8.05032 1.5 6Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Lightbulb01.propTypes = {
  color: PropTypes.string
};

const ZoomIn = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("circle", {
    cx: "10",
    cy: "10",
    r: "6.5",
    stroke: color,
    strokeWidth: "1.8"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 10H13M10 7V13",
    stroke: color,
    strokeWidth: "1.8",
    strokeLinecap: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.8 14.8L20 20",
    stroke: color,
    strokeWidth: "1.8",
    strokeLinecap: "round"
  })]
});
ZoomIn.propTypes = {
  color: PropTypes.string
};

const LightningFilled = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 13 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M0.907566 10.3596L6.73187 1.20716C6.95567 0.855476 7.50006 1.014 7.50006 1.43086V7.91667C7.50006 7.96269 7.53737 8 7.58339 8H11.6998C12.0369 8 12.2344 8.37945 12.0411 8.65561L6.25807 16.9171C6.02446 17.2509 5.50006 17.0856 5.50006 16.6782V11.0833C5.50006 11.0373 5.46275 11 5.41673 11H1.25909C0.930304 11 0.731048 10.637 0.907566 10.3596Z",
    stroke: color,
    strokeWidth: "1.66667"
  })
});
LightningFilled.propTypes = {
  color: PropTypes.string
};

const LinkAngled = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.14876 6.49213L2.28754 8.35334C1.59243 9.04845 1.1927 9.99425 1.20001 10.9883C1.20731 11.9823 1.5983 12.9338 2.32639 13.6395C3.03196 14.3676 3.98374 14.7585 4.97759 14.7658C5.99411 14.7733 6.91753 14.3961 7.61268 13.701L9.47389 11.8398M11.8512 9.50789L13.7125 7.64668C14.4076 6.95157 14.8073 6.00577 14.8 5.01175C14.7927 4.01774 14.4017 3.06617 13.6736 2.36056C12.9682 1.65516 12.0166 1.26415 11.0226 1.25684C10.0286 1.24954 9.08264 1.62658 8.38748 2.32171L6.52627 4.18292M5.17759 10.7726L10.7612 5.18901",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
LinkAngled.propTypes = {
  color: PropTypes.string
};

const Mail05 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.5 2.875V14.125C1.5 15.1605 2.33946 16 3.375 16H14.625C15.6605 16 16.5 15.1605 16.5 14.125V2.875M1.5 2.875C1.5 1.83947 2.33947 1 3.375 1H14.625C15.6605 1 16.5 1.83947 16.5 2.875M1.5 2.875C1.5 3.91053 2.33947 4.75 3.375 4.75H14.625C15.6605 4.75 16.5 3.91053 16.5 2.875M4.78125 10.375H8.53125M4.78125 13.1875H7.125",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Mail05.propTypes = {
  color: PropTypes.string
};

const Marker01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.5 16H5.59091M3.54545 8.82609V1H16.5L14.4545 4.91304L16.5 8.82609H3.54545ZM3.54545 8.82609V15.3478",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Marker01.propTypes = {
  color: PropTypes.string
};

const Plus01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7 1L7 13M13 7L1 7",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Plus01.propTypes = {
  color: PropTypes.string
};

const Plus02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6 1L6 11M11 6L1 6",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Plus02.propTypes = {
  color: PropTypes.string
};

const Plus03 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5 1L5 9M9 5L1 5",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Plus03.propTypes = {
  color: PropTypes.string
};

const Strike$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: color,
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.333 5.686c0 .31.083.581.27.814H5.166a2.8 2.8 0 0 1-.099-.76c0-1.627 1.436-2.768 3.48-2.768 1.969 0 3.39 1.175 3.445 2.85h-1.23c-.11-1.08-.964-1.743-2.25-1.743-1.23 0-2.18.602-2.18 1.607zm2.194 7.478c-2.153 0-3.589-1.107-3.705-2.81h1.23c.144 1.06 1.129 1.703 2.544 1.703 1.34 0 2.31-.705 2.31-1.675 0-.827-.547-1.374-1.914-1.675L8.046 8.5H1v-1h14v1h-3.504c.468.437.675.994.675 1.697 0 1.826-1.436 2.967-3.644 2.967"
  })
});
Strike$1.propTypes = {
  color: PropTypes.string
};

const Trash01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.33301 4.14706H14.6663M5.49967 1.5H10.4997M6.33301 12.9706V7.67647M9.66634 12.9706V7.67647M10.9163 16.5H5.08301C4.16253 16.5 3.41634 15.7099 3.41634 14.7353L3.03584 5.06614C3.01612 4.56486 3.3946 4.14706 3.86845 4.14706H12.1309C12.6047 4.14706 12.9832 4.56486 12.9635 5.06614L12.583 14.7353C12.583 15.7099 11.8368 16.5 10.9163 16.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Trash01.propTypes = {
  color: PropTypes.string
};

const Underline$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 16 16",
  fill: color,
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5.313 3.136h-1.23V9.54c0 2.105 1.47 3.623 3.917 3.623s3.917-1.518 3.917-3.623V3.136h-1.23v6.323c0 1.49-.978 2.57-2.687 2.57s-2.687-1.08-2.687-2.57zM12.5 15h-9v-1h9z"
  })
});
Underline$1.propTypes = {
  color: PropTypes.string
};

const Skip = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M12.8337 2.20978V15.7902M2.36371 1.70889L9.08354 8.49911C9.3573 8.77574 9.3573 9.22425 9.08354 9.50089L2.36371 16.2911C1.92209 16.7373 1.16699 16.4213 1.16699 15.7902L1.16699 2.20978C1.16699 1.5787 1.92209 1.26265 2.36371 1.70889Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Skip.propTypes = {
  color: PropTypes.string
};

const Edit03 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M9.49995 14.2929H14.4999M1.5 14.2929L5.13832 13.5598C5.33147 13.5209 5.50881 13.4258 5.6481 13.2864L13.7928 5.13722C14.1833 4.74651 14.1831 4.11318 13.7922 3.7228L12.0669 1.9994C11.6762 1.60918 11.0432 1.60945 10.6529 2L2.5073 10.15C2.36829 10.2891 2.27337 10.4661 2.23442 10.6589L1.5 14.2929Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Edit03.propTypes = {
  color: PropTypes.string
};

const Globe02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Z",
    stroke: color,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M2 12h20M12 2c2.5 2.8 3.9 6.3 3.9 10s-1.4 7.2-3.9 10c-2.5-2.8-3.9-6.3-3.9-10S9.5 4.8 12 2Z",
    stroke: color,
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
Globe02Icon.propTypes = {
  color: PropTypes.string
};

const ExpandWidthIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.83292 16.8335V0.833496M3.09973 10.8335L0.833008 8.65168M0.833008 8.65168L3.09973 6.46986M0.833008 8.65168H6.42858M14.5663 6.46986L16.833 8.65168M16.833 8.65168L14.5663 10.8335M16.833 8.65168L11.2374 8.65168",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ExpandWidthIcon.propTypes = {
  color: PropTypes.string
};

const CollapseWidthIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.83275 16.8335L8.83275 0.833496M4.16185 6.65168L6.42858 8.8335M6.42858 8.8335L4.16185 11.0153M6.42858 8.8335H0.833008M13.5042 11.0153L11.2374 8.8335M11.2374 8.8335L13.5042 6.65168M11.2374 8.8335L16.833 8.8335",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
CollapseWidthIcon.propTypes = {
  color: PropTypes.string
};

var css_248z$1u = ".IconButtonMenu-module__wrapper___1f56t{align-items:center;display:inline-flex;position:relative}.IconButtonMenu-module__trigger___b9Dvi{align-items:center;background:none;border:none;border-radius:var(--border-radius-small);cursor:pointer;display:flex;height:40px;justify-content:center;margin:0 -6px;padding:0;position:relative;transition:background-color .2s ease;width:32px}.IconButtonMenu-module__trigger___b9Dvi:hover{background-color:var(--bg-light)}.IconButtonMenu-module__trigger___b9Dvi svg{height:20px;width:20px}.IconButtonMenu-module__badge___4jM-u{background-color:var(--primary-color);border-radius:3px;bottom:1px;color:var(--white);font-size:9px;font-weight:700;line-height:1;padding:2px 3px;pointer-events:none;position:absolute;right:1px}.IconButtonMenu-module__menu___D89rk{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);box-shadow:var(--smoothShadow);min-width:220px;overflow:hidden;position:absolute;right:0;top:calc(100% + 4px);z-index:1000}.IconButtonMenu-module__menuHeader___cee7e{border-bottom:1px solid var(--bg-light-80);color:var(--grey-64);font-size:.7rem;font-weight:600;letter-spacing:.04em;padding:8px 15px 6px;text-transform:uppercase}.IconButtonMenu-module__menuItem___drFCA{align-items:center;background:none;border:none;color:var(--text);cursor:pointer;display:flex;font-size:var(--body-regular-size);gap:10px;justify-content:space-between;padding:10px 15px;text-align:left;text-decoration:none;transition:background-color .2s ease;width:100%}.IconButtonMenu-module__menuItem___drFCA:hover{background-color:var(--bg-light-48)}.IconButtonMenu-module__menuItemContent___jxOLb{display:flex;flex-direction:column;gap:1px;min-width:0}.IconButtonMenu-module__menuItemSub___dGham{color:var(--grey-64);font-size:.7rem}.IconButtonMenu-module__menuItemEnd___WWe7G{align-items:center;display:flex;flex-shrink:0}@media (max-width:768px){.IconButtonMenu-module__trigger___b9Dvi{height:35px;margin:0 -6px;width:32px}.IconButtonMenu-module__wrapperHeaderAligned___MV6l9{position:static}.IconButtonMenu-module__menuHeaderAligned___Vm7T1{left:auto;max-width:calc(100vw - 24px);min-width:min(300px,100vw - 24px);right:12px}}";
var css$1s = {"wrapper":"IconButtonMenu-module__wrapper___1f56t","trigger":"IconButtonMenu-module__trigger___b9Dvi","badge":"IconButtonMenu-module__badge___4jM-u","menu":"IconButtonMenu-module__menu___D89rk","menuHeader":"IconButtonMenu-module__menuHeader___cee7e","menuItem":"IconButtonMenu-module__menuItem___drFCA","menuItemContent":"IconButtonMenu-module__menuItemContent___jxOLb","menuItemSub":"IconButtonMenu-module__menuItemSub___dGham","menuItemEnd":"IconButtonMenu-module__menuItemEnd___WWe7G","wrapperHeaderAligned":"IconButtonMenu-module__wrapperHeaderAligned___MV6l9","menuHeaderAligned":"IconButtonMenu-module__menuHeaderAligned___Vm7T1"};
styleInject(css_248z$1u);

const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = event => {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

const IconButtonMenu = ({
  icon,
  title,
  label,
  badge,
  children,
  anchorToHeaderOnMobile = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, () => setIsOpen(false));
  const wrapperClassName = anchorToHeaderOnMobile ? `${css$1s.wrapper} ${css$1s.wrapperHeaderAligned}` : css$1s.wrapper;
  const menuClassName = anchorToHeaderOnMobile ? `${css$1s.menu} ${css$1s.menuHeaderAligned}` : css$1s.menu;
  return /*#__PURE__*/jsxs("div", {
    ref: wrapperRef,
    className: wrapperClassName,
    children: [/*#__PURE__*/jsxs("button", {
      className: css$1s.trigger,
      onClick: () => setIsOpen(!isOpen),
      "aria-label": label,
      title: label,
      children: [icon, badge && /*#__PURE__*/jsx("span", {
        className: css$1s.badge,
        children: badge
      })]
    }), isOpen && /*#__PURE__*/jsxs("div", {
      className: menuClassName,
      onClick: () => setIsOpen(false),
      children: [title && /*#__PURE__*/jsx("div", {
        className: css$1s.menuHeader,
        children: title
      }), children]
    })]
  });
};
const MenuItem = ({
  onClick,
  children,
  subtitle,
  endContent
}) => /*#__PURE__*/jsxs("button", {
  className: css$1s.menuItem,
  onClick: onClick,
  children: [/*#__PURE__*/jsxs("div", {
    className: css$1s.menuItemContent,
    children: [/*#__PURE__*/jsx("span", {
      children: children
    }), subtitle && /*#__PURE__*/jsx("span", {
      className: css$1s.menuItemSub,
      children: subtitle
    })]
  }), endContent && /*#__PURE__*/jsx("div", {
    className: css$1s.menuItemEnd,
    children: endContent
  })]
});
MenuItem.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  endContent: PropTypes.node
};
IconButtonMenu.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  badge: PropTypes.string,
  children: PropTypes.node,
  anchorToHeaderOnMobile: PropTypes.bool
};
IconButtonMenu.Item = MenuItem;

const CheckBroken = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C10.1767 1.5 11.2901 1.77099 12.2812 2.25397M15.0938 4.3125L8.53125 10.875L6.65625 9",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
CheckBroken.propTypes = {
  color: PropTypes.string
};

const Stars = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M12.3529 2L13.8782 6.12184L18 7.64706L13.8782 9.17228L12.3529 13.2941L10.8277 9.17228L6.70588 7.64706L10.8277 6.12184L12.3529 2Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.29412 11.4118L6.62647 13.3735L8.58824 14.7059L6.62647 16.0382L5.29412 18L3.96176 16.0382L2 14.7059L3.96176 13.3735L5.29412 11.4118Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })]
});
Stars.propTypes = {
  color: PropTypes.string
};

const Translation = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  fill: color,
  viewBox: "0 0 16 16",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M4.545 6.714 4.11 8H3l1.862-5h1.284L8 8H6.833l-.435-1.286zm1.634-.736L5.5 3.956h-.049l-.679 2.022z"
  }), /*#__PURE__*/jsx("path", {
    d: "M0 2a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v3h3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-3H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm7.138 9.995q.289.451.63.846c-.748.575-1.673 1.001-2.768 1.292.178.217.451.635.555.867 1.125-.359 2.08-.844 2.886-1.494.777.665 1.739 1.165 2.93 1.472.133-.254.414-.673.629-.89-1.125-.253-2.057-.694-2.82-1.284.681-.747 1.222-1.651 1.621-2.757H14V8h-3v1.047h.765c-.318.844-.74 1.546-1.272 2.13a6 6 0 0 1-.415-.492 2 2 0 0 1-.94.31"
  })]
});
Translation.propTypes = {
  color: PropTypes.string
};

const Save02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.78125 15.5625V11.3438C4.78125 10.826 5.20098 10.4062 5.71875 10.4062H12.2812C12.799 10.4062 13.2188 10.826 13.2188 11.3438V16.0312M13.2188 2.4375V4.3125C13.2187 4.83027 12.799 5.25 12.2812 5.25L5.71875 5.25C5.20098 5.25 4.78125 4.83027 4.78125 4.3125L4.78125 1.5M16.0293 4.77927L13.2207 1.97073C12.9193 1.66933 12.5105 1.5 12.0843 1.5H3.10714C2.21953 1.5 1.5 2.21953 1.5 3.10714V14.8929C1.5 15.7805 2.21953 16.5 3.10714 16.5H14.8929C15.7805 16.5 16.5 15.7805 16.5 14.8929V5.91569C16.5 5.48945 16.3307 5.08067 16.0293 4.77927Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Save02.propTypes = {
  color: PropTypes.string
};

const Search01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M12.1058 12.2L15.0001 15M14.0668 7.53333C14.0668 11.1416 11.1417 14.0667 7.53342 14.0667C3.92516 14.0667 1.00009 11.1416 1.00009 7.53333C1.00009 3.92507 3.92516 1 7.53342 1C11.1417 1 14.0668 3.92507 14.0668 7.53333Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Search01.propTypes = {
  color: PropTypes.string
};

const DownArrow = ({
  color = 'currentColor',
  width
}) => {
  return /*#__PURE__*/jsx("svg", {
    width: width,
    viewBox: "0 0 1024 1024",
    children: /*#__PURE__*/jsx("path", {
      fill: color,
      d: "M104.704 338.752a64 64 0 0 1 90.496 0l316.8 316.8 316.8-316.8a64 64 0 0 1 90.496 90.496L557.248 791.296a64 64 0 0 1-90.496 0L104.704 429.248a64 64 0 0 1 0-90.496z"
    })
  });
};
DownArrow.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string
};

const UpArrow = ({
  color = 'currentColor',
  width
}) => {
  return /*#__PURE__*/jsx("svg", {
    width: width,
    viewBox: "0 0 1024 1024",
    children: /*#__PURE__*/jsx("path", {
      fill: color,
      d: "M104.704 685.248a64 64 0 0 0 90.496 0l316.8-316.8 316.8 316.8a64 64 0 0 0 90.496-90.496L557.248 232.704a64 64 0 0 0-90.496 0L104.704 594.752a64 64 0 0 0 0 90.496z"
    })
  });
};
UpArrow.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string
};

const BankNote04 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "19",
  height: "15",
  viewBox: "0 0 19 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M1.49994 12.5684L1.50012 2.7152C1.50013 2.154 2.04363 1.75325 2.57976 1.91912L2.86981 2.00886C5.09648 2.69775 7.50381 2.69775 9.73048 2.00886C12.1645 1.25581 14.8073 1.32789 17.1895 2.2123L17.5001 2.32762L17.4999 12.9796C17.4999 13.1402 17.3398 13.2515 17.1893 13.1956V13.1956C14.8071 12.3112 12.1643 12.2391 9.73027 12.9922C7.50361 13.6811 5.09627 13.6811 2.86961 12.9922L1.49994 12.5684Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.4999 7.49219C11.4999 8.59676 10.6045 9.49219 9.49994 9.49219C8.39537 9.49219 7.49994 8.59676 7.49994 7.49219C7.49994 6.38762 8.39537 5.49219 9.49994 5.49219C10.6045 5.49219 11.4999 6.38762 11.4999 7.49219Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })]
});
BankNote04.propTypes = {
  color: PropTypes.string
};

const Mail03 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.93774 2.65449L8.50024 8.08035L15.5315 2.65449M6.54682 7.50134L1.93774 12.5197M15.0627 12.1086L10.4531 7.50134M2.87524 13.3346C1.83971 13.3346 1.00024 12.4513 1.00024 11.3616V3.64101C1.00024 2.55133 1.83971 1.66797 2.87524 1.66797H14.1252C15.1608 1.66797 16.0002 2.55133 16.0002 3.64101V11.3616C16.0002 12.4513 15.1608 13.3346 14.1252 13.3346H2.87524Z",
    stroke: "#002D6B",
    strokeWidth: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Mail03.propTypes = {
  color: PropTypes.string
};

const Data04 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M9.33368 14V9M15.7337 14.3C14.85 14.3 14.1337 15.0163 14.1337 15.9C14.1337 16.7837 14.85 17.5 15.7337 17.5C16.6173 17.5 17.3337 16.7837 17.3337 15.9C17.3337 15.0163 16.6173 14.3 15.7337 14.3ZM15.7337 14.3L15.7337 9.7C15.7337 9.25817 15.3755 8.9 14.9337 8.9H3.73368C3.29185 8.9 2.93368 9.25817 2.93368 9.7L2.93368 14.3M2.93368 14.3C2.05002 14.3 1.33368 15.0163 1.33368 15.9C1.33368 16.7837 2.05002 17.5 2.93368 17.5C3.81733 17.5 4.53368 16.7837 4.53368 15.9C4.53368 15.0163 3.81733 14.3 2.93368 14.3ZM9.33368 17.5C8.45002 17.5 7.73368 16.7837 7.73368 15.9C7.73368 15.0163 8.45002 14.3 9.33368 14.3C10.2173 14.3 10.9337 15.0163 10.9337 15.9C10.9337 16.7837 10.2173 17.5 9.33368 17.5ZM4.33368 5.5H14.3337C14.886 5.5 15.3337 5.05228 15.3337 4.5V2.5C15.3337 1.94772 14.886 1.5 14.3337 1.5H4.33368C3.78139 1.5 3.33368 1.94772 3.33368 2.5V4.5C3.33368 5.05228 3.78139 5.5 4.33368 5.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Data04.propTypes = {
  color: PropTypes.string
};

const Gear = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "19",
  viewBox: "0 0 17 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 5.33464L8.33337 1.16797L0.833374 5.33464V13.668L8.33337 17.8346L15.8334 13.668V5.33464ZM8.33337 12.2791C9.92768 12.2791 11.2201 11.0354 11.2201 9.5013C11.2201 7.96718 9.92768 6.72352 8.33337 6.72352C6.73907 6.72352 5.44662 7.96718 5.44662 9.5013C5.44662 11.0354 6.73907 12.2791 8.33337 12.2791Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })
});
Gear.propTypes = {
  color: PropTypes.string
};

const Bell02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5.7777 15.7424C6.36743 16.2135 7.14619 16.5 7.99992 16.5C8.85365 16.5 9.63241 16.2135 10.2221 15.7424M1.75628 13.3182C1.40494 13.3182 1.2087 12.7662 1.42123 12.4595C1.91439 11.7479 2.39038 10.7043 2.39038 9.44749L2.41072 7.62638C2.41072 4.24288 4.91309 1.5 7.99992 1.5C11.1322 1.5 13.6714 4.28328 13.6714 7.71662L13.6511 9.44749C13.6511 10.7129 14.1107 11.7623 14.5838 12.4742C14.7881 12.7816 14.5914 13.3182 14.2444 13.3182H1.75628Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Bell02Icon.propTypes = {
  color: PropTypes.string
};

const Bell03 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "19",
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.58798 14.5908L0.926464 14.084H0.926463L1.58798 14.5908ZM2.55713 11.8661L1.72379 11.8558V11.8661H2.55713ZM2.57747 10.2187L3.4108 10.229V10.2187H2.57747ZM14.7505 14.604L15.4221 14.1106L15.4221 14.1106L14.7505 14.604ZM13.8179 11.8661L12.9845 11.8553V11.8661H13.8179ZM13.8382 10.3003L14.6715 10.3112V10.3003H13.8382ZM1.58798 14.5908L2.24949 15.0976C2.81712 14.3567 3.39046 13.2389 3.39046 11.8661H2.55713H1.72379C1.72379 12.7671 1.34515 13.5375 0.926464 14.084L1.58798 14.5908ZM2.55713 11.8661L3.3904 11.8764L3.41074 10.229L2.57747 10.2187L1.7442 10.2084L1.72386 11.8558L2.55713 11.8661ZM14.7505 14.604L15.4221 14.1106C15.0214 13.5652 14.6512 12.7851 14.6512 11.8661H13.8179H12.9845C12.9845 13.2365 13.5334 14.3549 14.079 15.0974L14.7505 14.604ZM13.8179 11.8661L14.6511 11.8769L14.6715 10.3112L13.8382 10.3003L13.0049 10.2895L12.9846 11.8553L13.8179 11.8661ZM13.8382 10.3003H14.6715C14.6715 6.72762 11.7525 3.84341 8.16667 3.84341V4.67674V5.51007C10.8454 5.51007 13.0049 7.6614 13.0049 10.3003H13.8382ZM14.4111 15.3675V16.2008C15.0162 16.2008 15.3986 15.7791 15.5533 15.4188C15.7068 15.0612 15.7399 14.5432 15.4221 14.1106L14.7505 14.604L14.079 15.0974C13.9655 14.943 14.0023 14.8067 14.0218 14.7613C14.0425 14.7132 14.153 14.5342 14.4111 14.5342V15.3675ZM2.57747 10.2187H3.4108C3.4108 7.62485 5.53339 5.51007 8.16667 5.51007V4.67674V3.84341C4.62628 3.84341 1.74413 6.69107 1.74413 10.2187H2.57747ZM1.92303 15.3675V14.5342C2.18698 14.5342 2.2953 14.7195 2.31336 14.7629C2.33051 14.804 2.36872 14.942 2.24949 15.0976L1.58798 14.5908L0.926463 14.084C0.594712 14.517 0.624775 15.0433 0.774738 15.4035C0.925625 15.7659 1.30773 16.2008 1.92303 16.2008V15.3675ZM14.4111 15.3675V14.5342H1.92303V15.3675V16.2008H14.4111V15.3675ZM10.8333 15.3675H10C10 16.21 9.2414 17.0013 8.16667 17.0013V17.8346V18.668C10.0374 18.668 11.6667 17.2501 11.6667 15.3675H10.8333ZM8.16667 17.8346V17.0013C7.09193 17.0013 6.33333 16.21 6.33333 15.3675H5.5H4.66667C4.66667 17.2501 6.29589 18.668 8.16667 18.668V17.8346ZM9.94444 2.92235H9.11111C9.11111 3.42067 8.69871 3.84341 8.16667 3.84341V4.67674V5.51007C9.5983 5.51007 10.7778 4.36188 10.7778 2.92235H9.94444ZM8.16667 4.67674V3.84341C7.63462 3.84341 7.22222 3.42067 7.22222 2.92235H6.38889H5.55556C5.55556 4.36188 6.73503 5.51007 8.16667 5.51007V4.67674ZM6.38889 2.92235H7.22222C7.22222 2.42404 7.63462 2.0013 8.16667 2.0013V1.16797V0.334635C6.73503 0.334635 5.55556 1.48283 5.55556 2.92235H6.38889ZM8.16667 1.16797V2.0013C8.69871 2.0013 9.11111 2.42404 9.11111 2.92235H9.94444H10.7778C10.7778 1.48283 9.5983 0.334635 8.16667 0.334635V1.16797Z",
    fill: color
  })
});
Bell03.propTypes = {
  color: PropTypes.string
};

const Bell04Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M5.70077 18.0129L5.28411 17.2912H5.28411L5.70077 18.0129ZM4.9944 17.4818L4.16744 17.3789L4.16744 17.3789L4.9944 17.4818ZM4.43523 14.5107L3.70847 14.9186L3.71355 14.9274L4.43523 14.5107ZM3.59107 13.0065L4.31784 12.5986L4.31276 12.5899L3.59107 13.0065ZM16.8745 11.5618L17.2912 12.2835L16.8745 11.5618ZM16.7786 10.6942L17.1183 9.93324L17.1183 9.93324L16.7786 10.6942ZM14.5108 8.69355L13.7838 9.10096L13.7891 9.11022L14.5108 8.69355ZM13.7094 7.2634L14.4364 6.85599L14.4311 6.84673L13.7094 7.2634ZM5.69095 5.09442L5.27429 4.37273L5.69095 5.09442ZM10.9881 17.9428L11.4048 18.6645L10.9881 17.9428ZM4.9944 17.4818L5.82136 17.5847C5.94076 16.6248 5.8684 15.3263 5.15692 14.094L4.43523 14.5107L3.71355 14.9274C4.19235 15.7567 4.25662 16.662 4.16744 17.3789L4.9944 17.4818ZM4.43523 14.5107L5.16194 14.1028L4.31778 12.5987L3.59107 13.0065L2.86436 13.4144L3.70852 14.9185L4.43523 14.5107ZM16.7786 10.6942L17.1183 9.93324C16.4694 9.64354 15.7204 9.12199 15.2325 8.27688L14.5108 8.69355L13.7891 9.11022C14.4996 10.3409 15.5669 11.0659 16.4388 11.4551L16.7786 10.6942ZM14.5108 8.69355L15.2378 8.28617L14.4363 6.85602L13.7094 7.2634L12.9824 7.67078L13.7838 9.10093L14.5108 8.69355ZM13.7094 7.2634L14.4311 6.84673C12.577 3.6354 8.47873 2.52264 5.27429 4.37273L5.69095 5.09442L6.10762 5.8161C8.50844 4.42999 11.5901 5.25941 12.9877 7.68007L13.7094 7.2634ZM16.8745 11.5618L17.2912 12.2835C17.8257 11.9749 17.9416 11.4056 17.8932 11.0136C17.8449 10.6229 17.6117 10.1535 17.1183 9.93324L16.7786 10.6942L16.4388 11.4551C16.2738 11.3814 16.2438 11.2563 16.2391 11.2179C16.2342 11.1782 16.2338 10.9694 16.4579 10.8401L16.8745 11.5618ZM3.59107 13.0065L4.31276 12.5899C2.93879 10.2101 3.74748 7.17873 6.10762 5.8161L5.69095 5.09442L5.27429 4.37273C2.11053 6.19933 1.03892 10.2527 2.86938 13.4232L3.59107 13.0065ZM5.70077 18.0129L5.28411 17.2912C5.5132 17.159 5.69485 17.2703 5.72203 17.2912C5.74867 17.3118 5.84423 17.4008 5.82136 17.5847L4.9944 17.4818L4.16744 17.3789C4.09963 17.924 4.39119 18.3694 4.70367 18.6106C5.01667 18.8522 5.57398 19.0484 6.11744 18.7346L5.70077 18.0129ZM16.8745 11.5618L16.4579 10.8401L5.28411 17.2912L5.70077 18.0129L6.11744 18.7346L17.2912 12.2835L16.8745 11.5618ZM12.0826 14.3284L11.3609 14.745C11.8192 15.5387 11.5352 16.6647 10.5714 17.2211L10.9881 17.9428L11.4048 18.6645C13.0765 17.6993 13.7726 15.5889 12.8043 13.9117L12.0826 14.3284ZM10.9881 17.9428L10.5714 17.2211C9.60767 17.7776 8.49052 17.4605 8.0323 16.6668L7.31061 17.0835L6.58892 17.5002C7.55722 19.1773 9.733 19.6297 11.4048 18.6645L10.9881 17.9428ZM6.36325 2.58537L5.64156 3.00204C5.91865 3.48196 5.75421 4.09564 5.27429 4.37273L5.69095 5.09442L6.10762 5.8161C7.3847 5.07878 7.82226 3.44578 7.08494 2.1687L6.36325 2.58537ZM5.69095 5.09442L5.27429 4.37273C4.79436 4.64981 4.18068 4.48538 3.90359 4.00545L3.18191 4.42212L2.46022 4.83879C3.19754 6.11587 4.83054 6.55343 6.10762 5.8161L5.69095 5.09442ZM3.18191 4.42212L3.90359 4.00545C3.62651 3.52553 3.79094 2.91185 4.27087 2.63476L3.8542 1.91307L3.43754 1.19138C2.16045 1.92871 1.7229 3.5617 2.46022 4.83879L3.18191 4.42212ZM3.8542 1.91307L4.27087 2.63476C4.7508 2.35767 5.36448 2.52211 5.64156 3.00204L6.36325 2.58537L7.08494 2.1687C6.34761 0.891621 4.71462 0.45406 3.43754 1.19138L3.8542 1.91307Z",
    fill: color
  })
});
Bell04Icon.propTypes = {
  color: PropTypes.string
};

const MessageText02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.99976 5H11.9998M4.99976 9H8.99975M8.73889 12.8261L4.56497 17V12.8261H2.99976C1.89519 12.8261 0.999756 11.9307 0.999756 10.8261V3C0.999756 1.89543 1.89519 1 2.99976 1H14.9998C16.1043 1 16.9998 1.89543 16.9998 3V10.8261C16.9998 11.9307 16.1043 12.8261 14.9998 12.8261H8.73889Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
MessageText02.propTypes = {
  color: PropTypes.string
};

const Edit04 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7707 1.08925C11.0959 0.763787 11.6234 0.763565 11.949 1.08875L13.9102 3.04772C14.2359 3.37304 14.2361 3.90081 13.9107 4.2264L5.6125 12.5291C5.49643 12.6453 5.34864 12.7245 5.18769 12.757L1.5 13.5L2.24437 9.8167C2.27684 9.65608 2.35593 9.50859 2.47178 9.39268L10.7707 1.08925Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })
});
Edit04.propTypes = {
  color: PropTypes.string
};

const Filter = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "12",
  viewBox: "0 0 18 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M3.46154 6H14.5385M1 1H17M7.15385 11H10.8462",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Filter.propTypes = {
  color: PropTypes.string
};

const ArrowSwitchVertical = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 11 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.43945 2.46191L8.12695 0.774414M8.12695 0.774414L9.81445 2.46191M8.12695 0.774414L8.12695 9.77441M4.18945 8.08691L2.50195 9.77441M2.50195 9.77441L0.814453 8.08691M2.50195 9.77441L2.50195 0.774414",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ArrowSwitchVertical.propTypes = {
  color: PropTypes.string
};

const Home02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.75 17.9062H17.25M11.1887 1.74637L2.08867 7.90037C1.71935 8.15012 1.5 8.55443 1.5 8.9854V20.5029C1.5 21.6059 2.4402 22.5 3.6 22.5H20.4C21.5598 22.5 22.5 21.6059 22.5 20.5029V8.98539C22.5 8.55443 22.2806 8.15012 21.9113 7.90037L12.8113 1.74637C12.3256 1.41788 11.6744 1.41788 11.1887 1.74637Z",
    stroke: color,
    strokeWidth: "2.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Home02.propTypes = {
  color: PropTypes.string
};

const ArrowRefresh01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M2.6479 5.04167C3.80619 2.92445 5.97111 1.5 8.45069 1.5C11.2621 1.5 13.669 3.33119 14.6627 5.92708M4.6825 5.92708H1.33301V2.38542M14.1848 12.125C13.0265 14.2422 10.8616 15.6667 8.382 15.6667C5.57061 15.6667 3.16373 13.8355 2.16995 11.2396M12.1502 11.2396H15.4997V14.7813",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ArrowRefresh01.propTypes = {
  color: PropTypes.string
};

const Send01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M17.3282 1.44132L8.44157 10.328M2.49544 5.86272L16.3337 1.0617C17.1859 0.766038 18.0035 1.58364 17.7078 2.43584L12.9068 16.2741C12.5779 17.2221 11.2467 17.2481 10.881 16.3136L8.6836 10.698C8.57385 10.4176 8.35196 10.1957 8.0715 10.0859L2.45589 7.88852C1.52144 7.52286 1.54743 6.19162 2.49544 5.86272Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Send01.propTypes = {
  color: PropTypes.string
};

const LinkExternal = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "15",
  viewBox: "0 0 14 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.25 1.5H3.25C2.00736 1.5 1 2.50735 1 3.74999V11.25C1 12.4926 2.00736 13.5 3.25 13.5H10.75C11.9926 13.5 13 12.4926 13 11.25V8.24996M9.24963 1.50018L13 1.5M13 1.5V4.87507M13 1.5L6.62445 7.87478",
    stroke: color,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
LinkExternal.propTypes = {
  color: PropTypes.string
};

const ThinStar = ({
  color = 'currentColor',
  width = 16,
  height = 16,
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: width,
  height: height,
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M14 0C14 0 16.5 9.5 14 14C11.5 9.5 14 0 14 0Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M14 28C14 28 16.5 18.5 14 14C11.5 18.5 14 28 14 28Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M0 14C0 14 9.5 11.5 14 14C9.5 16.5 0 14 0 14Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M28 14C28 14 18.5 11.5 14 14C18.5 16.5 28 14 28 14Z",
    fill: color
  })]
});
ThinStar.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

const EyeOpen = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "800px",
  height: "800px",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
EyeOpen.propTypes = {
  color: PropTypes.string
};

const Email$1 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M2.90625 2.62533L8.46637 6.6172C8.78741 6.8477 9.21259 6.8477 9.53363 6.6172L15.0938 2.62533M3.375 12.8337H14.625C15.6605 12.8337 16.5 11.9631 16.5 10.8892V3.11144C16.5 2.03755 15.6605 1.16699 14.625 1.16699H3.375C2.33947 1.16699 1.5 2.03755 1.5 3.11144V10.8892C1.5 11.9631 2.33947 12.8337 3.375 12.8337Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Email$1.propTypes = {
  color: PropTypes.string
};

const ArrowLeft = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "14",
  viewBox: "0 0 16 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.88856 12.8327L1.33301 6.99935M1.33301 6.99935L6.88856 1.16602M1.33301 6.99935L14.6663 6.99935",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ArrowLeft.propTypes = {
  color: PropTypes.string
};

const Calendar01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.95833 6.42855H13.625M3.46627 1.5V2.78586M11.9583 1.5V2.78571M14.4583 5.03571V14.25C14.4583 15.4926 13.4634 16.5 12.2361 16.5H3.34722C2.11992 16.5 1.125 15.4926 1.125 14.25V5.03571C1.125 3.79307 2.11992 2.78571 3.34722 2.78571H12.2361C13.4634 2.78571 14.4583 3.79307 14.4583 5.03571Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Calendar01.propTypes = {
  color: PropTypes.string
};

const Server02 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M17.0004 4.5C17.0004 6.15685 13.4186 7.5 9.00036 7.5C4.58209 7.5 1.00037 6.15685 1.00037 4.5M17.0004 4.5C17.0004 2.84315 13.4186 1.5 9.00036 1.5C4.58209 1.5 1.00037 2.84315 1.00037 4.5M17.0004 4.5V13.5C17.0004 15.1569 13.4186 16.5 9.00036 16.5C4.58209 16.5 1.00037 15.1569 1.00037 13.5V4.5M17.0004 9C17.0004 10.6569 13.4186 12 9.00036 12C4.58209 12 1.00037 10.6569 1.00037 9",
    stroke: color,
    strokeWidth: "1.66667"
  })
});
Server02.propTypes = {
  color: PropTypes.string
};

const Settings = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3969 2.59689C10.0407 1.13437 7.95934 1.13437 7.60308 2.59689C7.54989 2.81666 7.44557 3.02077 7.29859 3.1926C7.15162 3.36443 6.96615 3.49914 6.75728 3.58575C6.54842 3.67237 6.32205 3.70845 6.0966 3.69106C5.87115 3.67366 5.653 3.60329 5.45989 3.48566C4.1736 2.70189 2.70168 4.17379 3.48545 5.46006C3.99172 6.2907 3.54264 7.37447 2.59761 7.60416C1.13413 7.95948 1.13413 10.0417 2.59761 10.3961C2.81744 10.4493 3.02159 10.5538 3.19342 10.7008C3.36526 10.8479 3.49993 11.0335 3.58646 11.2425C3.673 11.4515 3.70895 11.6779 3.6914 11.9034C3.67385 12.1289 3.60328 12.3471 3.48545 12.5402C2.70168 13.8264 4.1736 15.2983 5.45989 14.5146C5.65296 14.3967 5.87114 14.3262 6.09664 14.3086C6.32215 14.2911 6.54862 14.327 6.7576 14.4136C6.96658 14.5001 7.15217 14.6348 7.29925 14.8066C7.44634 14.9784 7.55076 15.1826 7.60402 15.4024C7.95934 16.8659 10.0416 16.8659 10.396 15.4024C10.4494 15.1827 10.5539 14.9787 10.7011 14.807C10.8482 14.6353 11.0337 14.5007 11.2427 14.4142C11.4516 14.3277 11.678 14.2917 11.9034 14.3091C12.1288 14.3266 12.347 14.397 12.5401 14.5146C13.8264 15.2983 15.2983 13.8264 14.5145 12.5402C14.3969 12.3471 14.3265 12.1289 14.3091 11.9035C14.2916 11.678 14.3276 11.4516 14.4141 11.2427C14.5006 11.0338 14.6352 10.8483 14.8069 10.7011C14.9787 10.554 15.1827 10.4495 15.4024 10.3961C16.8659 10.0408 16.8659 7.95854 15.4024 7.60416C15.1826 7.5509 14.9784 7.44648 14.8066 7.2994C14.6347 7.15231 14.5001 6.96673 14.4135 6.75775C14.327 6.54877 14.291 6.32231 14.3086 6.09681C14.3262 5.8713 14.3967 5.65313 14.5145 5.46006C15.2983 4.17379 13.8264 2.70189 12.5401 3.48566C12.347 3.60348 12.1289 3.67405 11.9034 3.6916C11.6778 3.70915 11.4514 3.6732 11.2424 3.58666C11.0334 3.50013 10.8478 3.36546 10.7007 3.19363C10.5537 3.0218 10.4492 2.81766 10.396 2.59783L10.3969 2.59689Z",
    stroke: color,
    strokeWidth: "1.66667"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.6667 9C10.6667 9.92047 9.92047 10.6667 9 10.6667C8.07953 10.6667 7.33333 9.92047 7.33333 9C7.33333 8.07953 8.07953 7.33333 9 7.33333C9.92047 7.33333 10.6667 8.07953 10.6667 9Z",
    stroke: color,
    strokeWidth: "1.66667"
  })]
});
Settings.propTypes = {
  color: PropTypes.string
};

const CheckSquareBroken = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M11.875 2.5H5.3125C3.7592 2.5 2.5 3.75919 2.5 5.31248V14.6875C2.5 16.2408 3.7592 17.5 5.3125 17.5H14.6875C16.2408 17.5 17.5 16.2408 17.5 14.6875V9.53121M16.5625 4.84374L10 11.4062L8.125 9.53121",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
CheckSquareBroken.propTypes = {
  color: PropTypes.string
};

const Disabled = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  fill: color,
  width: "15",
  viewBox: "0 0 329.328 329.328",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M164.666,0C73.871,0,0.004,73.871,0.004,164.672c0.009,90.792,73.876,164.656,164.662,164.656 c90.793,0,164.658-73.865,164.658-164.658C329.324,73.871,255.459,0,164.666,0z M164.666,30c31.734,0,60.933,11.042,83.975,29.477 L59.478,248.638c-18.431-23.04-29.471-52.237-29.474-83.967C30.004,90.413,90.413,30,164.666,30z M164.666,299.328 c-31.733,0-60.934-11.042-83.977-29.477L269.854,80.691c18.431,23.043,29.471,52.244,29.471,83.979 C299.324,238.921,238.917,299.328,164.666,299.328z"
  })
});
Disabled.propTypes = {
  color: PropTypes.string
};

const Download02 = ({
  color,
  ...props
}) => {
  return /*#__PURE__*/jsx("svg", {
    width: "16",
    height: "18",
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M1.33301 11.6703L1.33301 14.7438C1.33301 15.2095 1.5086 15.6562 1.82116 15.9856C2.13372 16.315 2.55765 16.5 2.99967 16.5H12.9997C13.4417 16.5 13.8656 16.315 14.1782 15.9856C14.4907 15.6562 14.6663 15.2095 14.6663 14.7438V11.6703M8.0006 1.5V11.4521M8.0006 11.4521L11.8101 7.64941M8.0006 11.4521L4.19108 7.64941",
      stroke: color,
      strokeWidth: "1.66667",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Download02.propTypes = {
  color: PropTypes.string
};

const SortVertical01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "8",
  height: "14",
  viewBox: "0 0 8 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7 9.99988L4 12.9999L1 9.99988M1 3.99988L4 0.999878L7 3.99988",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
SortVertical01.propTypes = {
  color: PropTypes.string
};

const Upload01 = ({
  color = 'currentColor',
  ...props
}) => {
  return /*#__PURE__*/jsx("svg", {
    width: "18",
    height: "14",
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M3.91071 9.85678C2.57931 9.85678 1.5 9.0236 1.5 7.80196C1.5 6.58032 2.57931 5.58998 3.91071 5.58998C4.00125 5.58998 4.09062 5.59456 4.17857 5.60348V5.58998H4.21173C4.18984 5.42895 4.17857 5.2649 4.17857 5.09843C4.17857 2.92662 6.09735 1.16602 8.46429 1.16602C10.0671 1.16602 11.4644 1.97336 12.1996 3.16903C12.3792 3.14478 12.563 3.13222 12.75 3.13222C14.8211 3.13222 16.5 4.67275 16.5 6.57308C16.5 8.13741 15.3623 9.32993 13.8047 9.72301M8.88164 12.8327V7.18752M8.88164 7.18752L6.42187 9.51566M8.88164 7.18752L11.3437 9.51565",
      stroke: color,
      strokeWidth: "1.66667",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
Upload01.propTypes = {
  color: PropTypes.string
};

const CopyLeft = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M16.6667 9.0625L16.6667 14.1667C16.6667 16.0076 15.1743 17.5 13.3334 17.5L8.22919 17.5M11.6667 2.50001L6.04169 2.5C5.00615 2.5 4.16669 3.33947 4.16669 4.375L4.16669 12.5C4.16669 13.5355 5.00615 14.375 6.04168 14.375L11.6667 14.375C12.7022 14.375 13.5417 13.5355 13.5417 12.5L13.5417 4.375C13.5417 3.33947 12.7022 2.50001 11.6667 2.50001Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
CopyLeft.propTypes = {
  color: PropTypes.string
};

const ReceiptLines = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.49994 5.5H11.4999M4.49994 9.5H11.4999M2.79994 1.5H13.1999C13.9179 1.5 14.4999 2.17157 14.4999 3V16.5L12.3333 15L10.1666 16.5L7.99994 15L5.83327 16.5L3.66661 15L1.49994 16.5V3C1.49994 2.17157 2.08197 1.5 2.79994 1.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ReceiptLines.propTypes = {
  color: PropTypes.string
};

const CardUp = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "14",
  viewBox: "0 0 20 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M11.7502 12.4823H3.75046C2.64591 12.4823 1.75049 11.5869 1.75046 10.4823L1.75024 2.98248C1.75021 1.87789 2.64565 0.982422 3.75024 0.982422H15.7498C16.8544 0.982422 17.7498 1.87734 17.7498 2.98193L17.7499 6.48242M2.24986 4.4823H17.2499M14.2499 10.5178L16.2951 8.4823M16.2951 8.4823L18.2499 10.4258M16.2951 8.4823L16.2951 13.0178",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
CardUp.propTypes = {
  color: PropTypes.string
};

const SmileyHappy = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.6 6.6V5.76667C6.13976 5.76667 5.76667 6.13976 5.76667 6.6H6.6ZM6.67969 6.6H7.51302C7.51302 6.13976 7.13992 5.76667 6.67969 5.76667V6.6ZM11.4 6.6V5.76667C10.9398 5.76667 10.5667 6.13976 10.5667 6.6H11.4ZM11.4708 6.6H12.3042C12.3042 6.13976 11.9311 5.76667 11.4708 5.76667V6.6ZM6.67969 6.66406V7.4974C7.13992 7.4974 7.51302 7.1243 7.51302 6.66406H6.67969ZM6.6 6.66406H5.76667C5.76667 7.1243 6.13976 7.4974 6.6 7.4974V6.66406ZM11.4708 6.66406V7.4974C11.9311 7.4974 12.3042 7.1243 12.3042 6.66406H11.4708ZM11.4 6.66406H10.5667C10.5667 7.1243 10.9398 7.4974 11.4 7.4974V6.66406ZM6.93519 10.994C6.69296 10.6027 6.17935 10.4818 5.78802 10.7241C5.39669 10.9663 5.27582 11.4799 5.51806 11.8712L6.93519 10.994ZM12.4819 11.8712C12.7242 11.4799 12.6033 10.9663 12.212 10.7241C11.8206 10.4818 11.307 10.6027 11.0648 10.994L12.4819 11.8712ZM16.1667 9C16.1667 12.958 12.958 16.1667 9 16.1667V17.8333C13.8785 17.8333 17.8333 13.8785 17.8333 9H16.1667ZM9 16.1667C5.04196 16.1667 1.83333 12.958 1.83333 9H0.166667C0.166667 13.8785 4.12148 17.8333 9 17.8333V16.1667ZM1.83333 9C1.83333 5.04196 5.04196 1.83333 9 1.83333V0.166667C4.12148 0.166667 0.166667 4.12148 0.166667 9H1.83333ZM9 1.83333C12.958 1.83333 16.1667 5.04196 16.1667 9H17.8333C17.8333 4.12148 13.8785 0.166667 9 0.166667V1.83333ZM6.6 7.43333H6.67969V5.76667H6.6V7.43333ZM11.4 7.43333H11.4708V5.76667H11.4V7.43333ZM5.84635 6.6V6.66406H7.51302V6.6H5.84635ZM6.67969 5.83073H6.6V7.4974H6.67969V5.83073ZM7.43333 6.66406V6.6H5.76667V6.66406H7.43333ZM10.6375 6.6V6.66406H12.3042V6.6H10.6375ZM11.4708 5.83073H11.4V7.4974H11.4708V5.83073ZM12.2333 6.66406V6.6H10.5667V6.66406H12.2333ZM9 12.1666C8.14185 12.1666 7.37697 11.7077 6.93519 10.994L5.51806 11.8712C6.24285 13.0421 7.52622 13.8333 9 13.8333V12.1666ZM11.0648 10.994C10.623 11.7077 9.85815 12.1666 9 12.1666V13.8333C10.4738 13.8333 11.7571 13.0421 12.4819 11.8712L11.0648 10.994Z",
    fill: color
  })
});
SmileyHappy.propTypes = {
  color: PropTypes.string
};

const SmileyNeutral = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.6 6.6V5.76667C6.13976 5.76667 5.76667 6.13976 5.76667 6.6H6.6ZM6.67969 6.6H7.51302C7.51302 6.13976 7.13992 5.76667 6.67969 5.76667V6.6ZM11.4 6.6V5.76667C10.9398 5.76667 10.5667 6.13976 10.5667 6.6H11.4ZM11.4708 6.6H12.3042C12.3042 6.13976 11.9311 5.76667 11.4708 5.76667V6.6ZM6.67969 6.66406V7.4974C7.13992 7.4974 7.51302 7.1243 7.51302 6.66406H6.67969ZM6.6 6.66406H5.76667C5.76667 7.1243 6.13976 7.4974 6.6 7.4974V6.66406ZM11.4708 6.66406V7.4974C11.9311 7.4974 12.3042 7.1243 12.3042 6.66406H11.4708ZM11.4 6.66406H10.5667C10.5667 7.1243 10.9398 7.4974 11.4 7.4974V6.66406ZM6.22663 10.5993C5.76639 10.5993 5.39329 10.9724 5.39329 11.4326C5.39329 11.8929 5.76639 12.266 6.22663 12.266V10.5993ZM11.7734 12.266C12.2336 12.266 12.6067 11.8929 12.6067 11.4326C12.6067 10.9724 12.2336 10.5993 11.7734 10.5993V12.266ZM16.1667 9C16.1667 12.958 12.958 16.1667 9 16.1667V17.8333C13.8785 17.8333 17.8333 13.8785 17.8333 9H16.1667ZM9 16.1667C5.04196 16.1667 1.83333 12.958 1.83333 9H0.166667C0.166667 13.8785 4.12148 17.8333 9 17.8333V16.1667ZM1.83333 9C1.83333 5.04196 5.04196 1.83333 9 1.83333V0.166667C4.12148 0.166667 0.166667 4.12148 0.166667 9H1.83333ZM9 1.83333C12.958 1.83333 16.1667 5.04196 16.1667 9H17.8333C17.8333 4.12148 13.8785 0.166667 9 0.166667V1.83333ZM6.6 7.43333H6.67969V5.76667H6.6V7.43333ZM11.4 7.43333H11.4708V5.76667H11.4V7.43333ZM5.84635 6.6V6.66406H7.51302V6.6H5.84635ZM6.67969 5.83073H6.6V7.4974H6.67969V5.83073ZM7.43333 6.66406V6.6H5.76667V6.66406H7.43333ZM10.6375 6.6V6.66406H12.3042V6.6H10.6375ZM11.4708 5.83073H11.4V7.4974H11.4708V5.83073ZM12.2333 6.66406V6.6H10.5667V6.66406H12.2333ZM11.7734 10.5993H6.22663V12.266H11.7734V10.5993Z",
    fill: color
  })
});
SmileyNeutral.propTypes = {
  color: PropTypes.string
};

const SmileySad = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.6 6.6V5.76667C6.13976 5.76667 5.76667 6.13976 5.76667 6.6H6.6ZM6.67969 6.6H7.51302C7.51302 6.13976 7.13992 5.76667 6.67969 5.76667V6.6ZM11.4 6.6V5.76667C10.9398 5.76667 10.5667 6.13976 10.5667 6.6H11.4ZM11.4708 6.6H12.3042C12.3042 6.13976 11.9311 5.76667 11.4708 5.76667V6.6ZM6.67969 6.66406V7.4974C7.13992 7.4974 7.51302 7.1243 7.51302 6.66406H6.67969ZM6.6 6.66406H5.76667C5.76667 7.1243 6.13976 7.4974 6.6 7.4974V6.66406ZM11.4708 6.66406V7.4974C11.9311 7.4974 12.3042 7.1243 12.3042 6.66406H11.4708ZM11.4 6.66406H10.5667C10.5667 7.1243 10.9398 7.4974 11.4 7.4974V6.66406ZM8.99994 11.0032V10.1699V11.0032ZM11.0647 13.0091C11.307 13.4004 11.8206 13.5213 12.2119 13.2791C12.6032 13.0368 12.7241 12.5232 12.4819 12.1319L11.0647 13.0091ZM5.51799 12.1319C5.27576 12.5232 5.39662 13.0368 5.78796 13.2791C6.17929 13.5213 6.69289 13.4004 6.93513 13.0091L5.51799 12.1319ZM16.1667 9C16.1667 12.958 12.958 16.1667 9 16.1667V17.8333C13.8785 17.8333 17.8333 13.8785 17.8333 9H16.1667ZM9 16.1667C5.04196 16.1667 1.83333 12.958 1.83333 9H0.166667C0.166667 13.8785 4.12148 17.8333 9 17.8333V16.1667ZM1.83333 9C1.83333 5.04196 5.04196 1.83333 9 1.83333V0.166667C4.12148 0.166667 0.166667 4.12148 0.166667 9H1.83333ZM9 1.83333C12.958 1.83333 16.1667 5.04196 16.1667 9H17.8333C17.8333 4.12148 13.8785 0.166667 9 0.166667V1.83333ZM6.6 7.43333H6.67969V5.76667H6.6V7.43333ZM11.4 7.43333H11.4708V5.76667H11.4V7.43333ZM5.84635 6.6V6.66406H7.51302V6.6H5.84635ZM6.67969 5.83073H6.6V7.4974H6.67969V5.83073ZM7.43333 6.66406V6.6H5.76667V6.66406H7.43333ZM10.6375 6.6V6.66406H12.3042V6.6H10.6375ZM11.4708 5.83073H11.4V7.4974H11.4708V5.83073ZM12.2333 6.66406V6.6H10.5667V6.66406H12.2333ZM8.99994 11.8365C9.85808 11.8365 10.623 12.2954 11.0647 13.0091L12.4819 12.1319C11.7571 10.961 10.4737 10.1699 8.99994 10.1699V11.8365ZM6.93513 13.0091C7.3769 12.2954 8.14179 11.8365 8.99994 11.8365V10.1699C7.52616 10.1699 6.24279 10.961 5.51799 12.1319L6.93513 13.0091Z",
    fill: color
  })
});
SmileySad.propTypes = {
  color: PropTypes.string
};

const Menu05 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "12",
  viewBox: "0 0 16 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.74967 11H14.6663M1.33301 6H14.6663M1.33301 1H14.6663",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Menu05.propTypes = {
  color: PropTypes.string
};

const MessageChat01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M14.8336 6.7487V2.9987C14.8336 2.07822 14.0874 1.33203 13.1669 1.33203H3.16691C2.24644 1.33203 1.50024 2.07822 1.50024 2.9987V9.52044C1.50024 10.4409 2.24644 11.1871 3.16691 11.1871H4.47126V14.6654L7.94952 11.1871H8.16691M12.4694 13.3248L14.6434 15.4987V13.3248H14.8336C15.7541 13.3248 16.5002 12.5786 16.5002 11.6581V8.83203C16.5002 7.91156 15.7541 7.16537 14.8336 7.16537H9.83358C8.9131 7.16537 8.16691 7.91156 8.16691 8.83203V11.6581C8.16691 12.5786 8.9131 13.3248 9.83358 13.3248H12.4694Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
MessageChat01.propTypes = {
  color: PropTypes.string
};

const Scan = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.33327 2H3.77772C2.79588 2 1.99994 2.79594 1.99994 3.77778V7.33333M7.33327 18H3.77772C2.79588 18 1.99994 17.2041 1.99994 16.2222V12.6667M12.6666 2H16.2222C17.204 2 17.9999 2.79594 17.9999 3.77778V7.33333M17.9999 12.6667V16.2222C17.9999 17.2041 17.204 18 16.2222 18H12.6666M1.99994 10.0002H17.9999",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Scan.propTypes = {
  color: PropTypes.string
};

const ImageIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.23976 9.68941L5.70106 9.0536L5.70105 9.05361L6.23976 9.68941ZM6.28102 9.6499L5.68728 9.06516L5.68663 9.06582L6.28102 9.6499ZM4.54531 11.1251L4.0066 10.4893L4.00659 10.4893L4.54531 11.1251ZM4.45248 11.2229L5.13649 11.6989L5.13649 11.6989L4.45248 11.2229ZM13.4473 9.74939L12.8702 10.3505H12.8702L13.4473 9.74939ZM12.0011 8.36106L11.424 8.96222L11.424 8.96222L12.0011 8.36106ZM11.4641 8.35729L10.8955 7.74807L10.8934 7.75005L11.4641 8.35729ZM8.78537 10.8749L9.35397 11.4841L9.35608 11.4821L8.78537 10.8749ZM8.24006 10.863L7.64342 11.4447L7.64461 11.446L8.24006 10.863ZM8.23302 10.8557L7.63581 11.4369L7.63638 11.4375L8.23302 10.8557ZM8.19474 10.8186L8.74035 10.1887L8.74034 10.1887L8.19474 10.8186ZM6.8898 9.68829L7.4354 9.05839L7.4354 9.05839L6.8898 9.68829ZM6.85137 9.65096L7.44878 9.06996L7.44821 9.06939L6.85137 9.65096ZM6.84449 9.6439L7.44134 9.06233L7.44021 9.06117L6.84449 9.6439ZM6.28843 9.64237L5.69588 9.05643L5.6947 9.05763L6.28843 9.64237ZM12.3746 4.78109V3.94776C11.9144 3.94776 11.5413 4.32086 11.5413 4.78109H12.3746ZM12.6427 4.78109H13.4761C13.4761 4.32086 13.103 3.94776 12.6427 3.94776V4.78109ZM12.6427 5.00815V5.84148C13.103 5.84148 13.4761 5.46838 13.4761 5.00815H12.6427ZM12.3746 5.00815H11.5413C11.5413 5.46838 11.9144 5.84148 12.3746 5.84148V5.00815ZM0.666667 4.3125V13.6875H2.33333V4.3125H0.666667ZM4.3125 17.3333H13.6875V15.6667H4.3125V17.3333ZM17.3333 13.6875V4.3125H15.6667V13.6875H17.3333ZM13.6875 0.666667H4.3125V2.33333H13.6875V0.666667ZM17.3333 4.3125C17.3333 2.29896 15.701 0.666667 13.6875 0.666667V2.33333C14.7806 2.33333 15.6667 3.21944 15.6667 4.3125H17.3333ZM13.6875 17.3333C15.701 17.3333 17.3333 15.701 17.3333 13.6875H15.6667C15.6667 14.7806 14.7806 15.6667 13.6875 15.6667V17.3333ZM0.666667 13.6875C0.666667 15.701 2.29896 17.3333 4.3125 17.3333V15.6667C3.21944 15.6667 2.33333 14.7806 2.33333 13.6875H0.666667ZM2.33333 4.3125C2.33333 3.21944 3.21944 2.33333 4.3125 2.33333V0.666667C2.29896 0.666667 0.666667 2.29896 0.666667 4.3125H2.33333ZM6.77846 10.3252C6.82686 10.2842 6.86655 10.243 6.87541 10.234L5.68663 9.06582C5.68302 9.0695 5.68134 9.0712 5.67993 9.07262C5.6787 9.07385 5.67887 9.07367 5.67989 9.07267C5.68176 9.07086 5.68936 9.06352 5.70106 9.0536L6.77846 10.3252ZM5.08401 11.7609L6.77847 10.3252L5.70105 9.05361L4.0066 10.4893L5.08401 11.7609ZM5.13649 11.6989C5.11867 11.7245 5.10281 11.742 5.09367 11.7514C5.0848 11.7605 5.08012 11.7642 5.08402 11.7609L4.00659 10.4893C3.94825 10.5388 3.85375 10.6243 3.76848 10.7469L5.13649 11.6989ZM5.14583 11.6691C5.14583 11.6798 5.14255 11.6901 5.13649 11.6989L3.76848 10.7469C3.58076 11.0166 3.47917 11.3382 3.47917 11.6691H5.14583ZM5.14583 13.2969V11.6691H3.47917V13.2969H5.14583ZM4.70313 12.8542C4.94762 12.8542 5.14583 13.0524 5.14583 13.2969H3.47917C3.47917 13.9729 4.02715 14.5208 4.70313 14.5208V12.8542ZM13.2969 12.8542H4.70313V14.5208H13.2969V12.8542ZM12.8542 13.2969C12.8542 13.0524 13.0524 12.8542 13.2969 12.8542V14.5208C13.9728 14.5208 14.5208 13.9729 14.5208 13.2969H12.8542ZM12.8542 10.313V13.2969H14.5208V10.313H12.8542ZM12.8702 10.3505C12.86 10.3407 12.8542 10.3272 12.8542 10.313H14.5208C14.5208 9.87333 14.3416 9.4527 14.0244 9.14824L12.8702 10.3505ZM11.424 8.96222L12.8702 10.3505L14.0244 9.14824L12.5782 7.75991L11.424 8.96222ZM12.0327 8.9665C11.8608 9.12689 11.5936 9.12501 11.424 8.96222L12.5782 7.75991C12.1094 7.30984 11.3706 7.30464 10.8955 7.74807L12.0327 8.9665ZM9.35608 11.4821L12.0348 8.96452L10.8934 7.75005L8.21466 10.2676L9.35608 11.4821ZM7.64461 11.446C8.10529 11.9165 8.86419 11.9412 9.35397 11.4841L8.21677 10.2657C8.39414 10.1001 8.66842 10.1093 8.8355 10.28L7.64461 11.446ZM7.63638 11.4375L7.64342 11.4447L8.83669 10.2812L8.82966 10.274L7.63638 11.4375ZM7.64914 11.4485C7.63831 11.4391 7.63126 11.4322 7.62954 11.4305C7.62859 11.4296 7.62845 11.4294 7.62959 11.4306C7.6309 11.4319 7.63246 11.4335 7.63581 11.4369L8.83022 10.2745C8.82201 10.2661 8.78511 10.2275 8.74035 10.1887L7.64914 11.4485ZM6.34421 10.3182L7.64915 11.4485L8.74034 10.1887L7.4354 9.05839L6.34421 10.3182ZM6.25396 10.2319C6.26224 10.2405 6.29926 10.2793 6.34421 10.3182L7.4354 9.05839C7.44626 9.06779 7.45333 9.07472 7.45506 9.07643C7.45602 9.07737 7.45617 9.07754 7.45503 9.07638C7.45371 9.07504 7.45215 9.07343 7.44878 9.06996L6.25396 10.2319ZM6.24765 10.2255L6.25453 10.2325L7.44821 9.06939L7.44134 9.06233L6.24765 10.2255ZM6.88098 10.2283C6.70646 10.4048 6.42256 10.4043 6.24878 10.2266L7.44021 9.06117C6.96234 8.57265 6.17578 8.57112 5.69588 9.05643L6.88098 10.2283ZM6.87475 10.2346L6.88217 10.2271L5.6947 9.05763L5.68728 9.06516L6.87475 10.2346ZM12.3746 5.61443H12.6427V3.94776H12.3746V5.61443ZM11.8094 4.78109V5.00815H13.4761V4.78109H11.8094ZM12.6427 4.17481H12.3746V5.84148H12.6427V4.17481ZM13.208 5.00815V4.78109H11.5413V5.00815H13.208Z",
    fill: color
  })
});
ImageIcon.propTypes = {
  color: PropTypes.string
};

const ThumbUpIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M10.6667 7.33333H14.6367C14.9207 7.33334 15.2001 7.40595 15.4482 7.54427C15.6963 7.68259 15.9049 7.88202 16.0543 8.12364C16.2036 8.36525 16.2888 8.64104 16.3016 8.9248C16.3144 9.20857 16.2545 9.4909 16.1275 9.745L13.2108 15.5783C13.0724 15.8554 12.8595 16.0884 12.596 16.2512C12.3325 16.414 12.0289 16.5001 11.7192 16.5H8.37167C8.23583 16.5 8.1 16.4833 7.9675 16.45L4.83333 15.6667M10.6667 7.33333V3.16667C10.6667 2.72464 10.4911 2.30072 10.1785 1.98816C9.86595 1.67559 9.44203 1.5 9 1.5H8.92083C8.50417 1.5 8.16667 1.8375 8.16667 2.25417C8.16667 2.84917 7.99083 3.43083 7.66 3.92583L4.83333 8.16667V15.6667M10.6667 7.33333H9M4.83333 15.6667H3.16667C2.72464 15.6667 2.30072 15.4911 1.98816 15.1785C1.67559 14.866 1.5 14.442 1.5 14V9C1.5 8.55797 1.67559 8.13405 1.98816 7.82149C2.30072 7.50893 2.72464 7.33333 3.16667 7.33333H5.25",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ThumbUpIcon.propTypes = {
  color: PropTypes.string
};

const ThumbDownIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M13.1654 2.33333L10.0321 1.55C9.89989 1.51687 9.76416 1.50008 9.6279 1.5H6.27957C5.96999 1.50001 5.66653 1.58624 5.40321 1.74903C5.13989 1.91183 4.92711 2.14474 4.78873 2.42167L1.87207 8.255C1.74509 8.5091 1.68517 8.79143 1.69799 9.0752C1.7108 9.35896 1.79593 9.63475 1.94529 9.87636C2.09466 10.118 2.30329 10.3174 2.5514 10.4557C2.7995 10.594 3.07884 10.6667 3.3629 10.6667H7.3329H8.99957M13.1654 2.33333L13.1662 9.83333L10.3396 14.0733C10.0087 14.5692 9.8329 15.1508 9.8329 15.7467C9.8329 16.1625 9.4954 16.5 9.07873 16.5H8.99873C8.55671 16.5 8.13278 16.3244 7.82022 16.0118C7.50766 15.6993 7.33207 15.2754 7.33207 14.8333V10.6667M13.1654 2.33333H14.8329C15.2749 2.33333 15.6989 2.50893 16.0114 2.82149C16.324 3.13405 16.4996 3.55797 16.4996 4V9C16.4996 9.44203 16.324 9.86595 16.0114 10.1785C15.6989 10.4911 15.2749 10.6667 14.8329 10.6667H12.7496",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ThumbDownIcon.propTypes = {
  color: PropTypes.string
};

const ColumnHorizontal01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M16.5002 14.8333C16.5002 15.7538 15.7643 16.5 14.8564 16.5L3.14408 16.5C2.23621 16.5 1.50024 15.7538 1.50024 14.8333L1.50024 12.3333C1.50024 11.4129 2.23621 10.6667 3.14408 10.6667L14.8564 10.6667C15.7643 10.6667 16.5002 11.4129 16.5002 12.3333V14.8333Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M16.5002 3.16667C16.5002 2.24619 15.7643 1.5 14.8564 1.5L3.14408 1.5C2.23621 1.5 1.50024 2.24619 1.50024 3.16667L1.50024 5.66667C1.50024 6.58714 2.23621 7.33333 3.14408 7.33333H14.8564C15.7643 7.33333 16.5002 6.58714 16.5002 5.66667V3.16667Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
ColumnHorizontal01Icon.propTypes = {
  color: PropTypes.string
};

const Lock02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M2.5 6.33333V5.57143C2.5 3.039 4.50714 1 7 1C9.49286 1 11.5 3.039 11.5 5.57143V6.33333M2.5 6.33333C1.675 6.33333 1 7.01905 1 7.85714V15.4762C1 16.3143 1.675 17 2.5 17H11.5C12.325 17 13 16.3143 13 15.4762V7.85714C13 7.01905 12.325 6.33333 11.5 6.33333M2.5 6.33333H11.5M7 12.5V10.5",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Lock02Icon.propTypes = {
  color: PropTypes.string
};

const LockOpen02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7 12.5V10.5M2.3125 5.57143C2.3125 3.039 4.31964 1 6.8125 1C8.36535 1 9.72974 1.7912 10.5379 3M2.5 6.33333C1.675 6.33333 1 7.01905 1 7.85714V15.4762C1 16.3143 1.675 17 2.5 17H11.5C12.325 17 13 16.3143 13 15.4762V7.85714C13 7.01905 12.325 6.33333 11.5 6.33333H2.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
LockOpen02Icon.propTypes = {
  color: PropTypes.string
};

const LearningNotStartedIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("circle", {
    cx: "10",
    cy: "10",
    r: "8",
    fill: "none",
    stroke: color,
    strokeWidth: "1.6"
  })
});
LearningNotStartedIcon.propTypes = {
  color: PropTypes.string
};

const RADIUS = 8;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const LearningInProgressIcon = ({
  color = 'currentColor',
  percent = 0,
  ...props
}) => {
  const safePercent = Math.max(0, Math.min(100, percent));
  const dash = safePercent / 100 * CIRCUMFERENCE;
  return /*#__PURE__*/jsxs("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/*#__PURE__*/jsx("circle", {
      cx: "10",
      cy: "10",
      r: RADIUS,
      fill: "none",
      stroke: color,
      strokeOpacity: "0.25",
      strokeWidth: "1.6"
    }), /*#__PURE__*/jsx("circle", {
      cx: "10",
      cy: "10",
      r: RADIUS,
      fill: "none",
      stroke: color,
      strokeWidth: "1.6",
      strokeLinecap: "round",
      strokeDasharray: `${dash} ${CIRCUMFERENCE}`,
      transform: "rotate(-90 10 10)"
    })]
  });
};
LearningInProgressIcon.propTypes = {
  color: PropTypes.string,
  percent: PropTypes.number
};

const LearningQuizPassedIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M10 1.6l2.6 5.3 5.8.8-4.2 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.6 7.7l5.8-.8z",
    fill: color
  })
});
LearningQuizPassedIcon.propTypes = {
  color: PropTypes.string
};

const CloseIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M10.6663 5.33301L5.33301 10.6663M10.6663 10.6663L5.33301 5.33301",
    stroke: "white",
    strokeWidth: "1.33333",
    strokeLinecap: "round"
  })]
});
CloseIcon.propTypes = {
  color: PropTypes.string
};

const CrossCircleIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M10.6663 5.33325L5.33301 10.6666M10.6663 10.6666L5.33301 5.33325",
    stroke: "white",
    strokeWidth: "1.33333",
    strokeLinecap: "round"
  })]
});
CrossCircleIcon.propTypes = {
  color: PropTypes.string
};

const CheckCircleIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M11.1998 5.6001L6.42679 10.4001L4.7998 8.76391",
    stroke: "white",
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
CheckCircleIcon.propTypes = {
  color: PropTypes.string
};

const ChevronUp = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "10",
  height: "6",
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M0.833008 5.15287L5.00035 1.33334L9.16634 5.15287",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ChevronUp.propTypes = {
  color: PropTypes.string
};

const ChevronDown = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "10",
  height: "6",
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M0.833008 1.33334L5.00035 5.15001L9.16634 1.33334",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ChevronDown.propTypes = {
  color: PropTypes.string
};

const StopwatchSnoozeIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "20",
  viewBox: "0 0 17 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M13.2177 5.71047L14.9568 3.97134M14.9568 3.97134L13.9134 2.92786M14.9568 3.97134L16.0003 5.01482M5.84446 9.09441H10.0836L5.84446 13.3335H10.0836M5.91699 1.66699H10.0837M15.0837 11.1908C15.0837 15.1357 11.9123 18.3337 8.00033 18.3337C4.08831 18.3337 0.916992 15.1357 0.916992 11.1908C0.916992 7.24591 4.08831 4.04794 8.00033 4.04794C11.9123 4.04794 15.0837 7.24591 15.0837 11.1908Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
StopwatchSnoozeIcon.propTypes = {
  color: PropTypes.string
};

const TrendUp01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "15",
  height: "9",
  viewBox: "0 0 15 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.09998 7.70005L4.68398 4.25389L7.75597 7.20774L13.9 1.30005M13.9 1.30005H9.29198M13.9 1.30005V5.73082",
    stroke: color,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
TrendUp01Icon.propTypes = {
  color: PropTypes.string
};

const TrendDown01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "9",
  viewBox: "0 0 16 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.59998 1.29995L5.18398 4.74611L8.25597 1.79226L14.4 7.69995M14.4 7.69995H9.79198M14.4 7.69995V3.26918",
    stroke: color,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
TrendDown01Icon.propTypes = {
  color: PropTypes.string
};

const Grid01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M14.8336 1.5C15.7541 1.5 16.5002 2.23597 16.5002 3.14383L16.5002 5.94994C16.5002 6.8578 15.7541 7.59377 14.8336 7.59377H12.3336C11.4131 7.59377 10.6669 6.8578 10.6669 5.94994L10.6669 3.14383C10.6669 2.23597 11.4131 1.5 12.3336 1.5L14.8336 1.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M3.16691 1.5C2.24644 1.5 1.50024 2.23597 1.50024 3.14383L1.50025 5.94994C1.50025 6.8578 2.24644 7.59377 3.16692 7.59377H5.66692C6.58739 7.59377 7.33358 6.8578 7.33358 5.94994L7.33358 3.14383C7.33358 2.23597 6.58738 1.5 5.66691 1.5L3.16691 1.5Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M14.8336 10.4063C15.7541 10.4063 16.5002 11.1422 16.5002 12.0501V14.8562C16.5002 15.764 15.7541 16.5 14.8336 16.5H12.3336C11.4131 16.5 10.6669 15.764 10.6669 14.8562L10.6669 12.0501C10.6669 11.1422 11.4131 10.4063 12.3336 10.4063H14.8336Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M3.16692 10.4063C2.24644 10.4063 1.50025 11.1422 1.50025 12.0501L1.50025 14.8562C1.50025 15.764 2.24644 16.5 3.16692 16.5H5.66692C6.58739 16.5 7.33359 15.764 7.33359 14.8562L7.33358 12.0501C7.33358 11.1422 6.58739 10.4063 5.66692 10.4063H3.16692Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
Grid01Icon.propTypes = {
  color: PropTypes.string
};

const BarChartSquare03Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M13.9999 14V9M9.99988 14V6M5.99988 14V12M3.99988 18C2.89531 18 1.99988 17.1046 1.99988 16V4C1.99988 2.89543 2.89531 2 3.99988 2H15.9999C17.1044 2 17.9999 2.89543 17.9999 4V16C17.9999 17.1046 17.1044 18 15.9999 18H3.99988Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
BarChartSquare03Icon.propTypes = {
  color: PropTypes.string
};

const ArrowRightIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "13",
  height: "11",
  viewBox: "0 0 13 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.13903 0.833008L11.5835 5.49967M11.5835 5.49967L7.13903 10.1663M11.5835 5.49967L0.916809 5.49967",
    stroke: color,
    strokeWidth: "1.33333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
ArrowRightIcon.propTypes = {
  color: PropTypes.string
};

const LineChartUp02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1 1V17H17M5 11.0001L8.5 7.5001L11 10.0001L15.5001 5.5",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
LineChartUp02Icon.propTypes = {
  color: PropTypes.string
};

const Hourglass03Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.375 1.5H13.0417M1.375 16.5H13.0417M11.5833 1.5V3.70602C11.5833 4.28118 11.385 4.83875 11.0218 5.28473L8.62591 8.22664C8.20181 8.74739 8.21188 9.48287 8.6501 9.99263L10.9791 12.7019C11.369 13.1554 11.5833 13.7336 11.5833 14.3316V16.5M2.83333 1.5V3.70602C2.83333 4.28118 3.03165 4.83875 3.39486 5.28473L5.79076 8.22664C6.21486 8.74739 6.20478 9.48287 5.76657 9.99263L3.43754 12.7019C3.0477 13.1554 2.83333 13.7336 2.83333 14.3316V16.5",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Hourglass03Icon.propTypes = {
  color: PropTypes.string
};

const MinusCircleContainedIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.1875 9H11.8125M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
MinusCircleContainedIcon.propTypes = {
  color: PropTypes.string
};

const Iphone01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.5 4.00001H9.5M1 3V15C1 16.1046 1.89543 17 3 17H11C12.1046 17 13 16.1046 13 15V3.00001C13 1.89544 12.1046 1.00001 11 1.00001L3 1C1.89543 0.999998 1 1.89543 1 3ZM7 13H7.07084V13.0641H7V13Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Iphone01Icon.propTypes = {
  color: PropTypes.string
};

const Target02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M16.5847 9.44118C16.5847 8.98094 16.2116 8.60784 15.7513 8.60784C15.2911 8.60784 14.918 8.98094 14.918 9.44118H16.5847ZM8.62567 3.21569C9.08591 3.21569 9.459 2.84259 9.459 2.38235C9.459 1.92212 9.08591 1.54902 8.62567 1.54902V3.21569ZM13.0218 9.44118C13.0218 8.98094 12.6487 8.60784 12.1885 8.60784C11.7283 8.60784 11.3552 8.98094 11.3552 9.44118H13.0218ZM8.62567 6.7451C9.08591 6.7451 9.459 6.372 9.459 5.91176C9.459 5.45153 9.08591 5.07843 8.62567 5.07843V6.7451ZM12.3613 6.77134C12.6882 6.44744 12.6907 5.91981 12.3668 5.59284C12.0429 5.26588 11.5153 5.26339 11.1883 5.58729L12.3613 6.77134ZM8.0392 8.70688C7.71223 9.03078 7.70974 9.55841 8.03364 9.88538C8.35754 10.2123 8.88517 10.2148 9.21214 9.89093L8.0392 8.70688ZM16.5 3.99567L17.0865 4.5877C17.3114 4.36492 17.3906 4.03397 17.291 3.73349C17.1914 3.43302 16.9302 3.21491 16.6168 3.17056L16.5 3.99567ZM13.6658 6.8033L13.4045 7.59461C13.7021 7.69287 14.0296 7.61588 14.2523 7.39533L13.6658 6.8033ZM11.1465 4.30763L10.56 3.7156C10.3342 3.93934 10.2553 4.27208 10.3567 4.5734L11.1465 4.30763ZM13.9807 1.5L14.8055 1.38106C14.7606 1.06954 14.544 0.809912 14.2456 0.709878C13.9471 0.609844 13.6178 0.686472 13.3942 0.907974L13.9807 1.5ZM11.7763 6.17938L10.9865 6.44515C11.0701 6.69374 11.2659 6.88845 11.515 6.97069L11.7763 6.17938ZM14.2956 3.68371L13.4708 3.80266C13.5237 4.16923 13.8121 4.45693 14.1788 4.50882L14.2956 3.68371ZM14.918 9.44118C14.918 12.872 12.1083 15.6667 8.62567 15.6667V17.3333C13.0139 17.3333 16.5847 13.8073 16.5847 9.44118H14.918ZM8.62567 15.6667C5.14309 15.6667 2.33333 12.872 2.33333 9.44118H0.666667C0.666667 13.8073 4.23746 17.3333 8.62567 17.3333V15.6667ZM2.33333 9.44118C2.33333 6.01032 5.14309 3.21569 8.62567 3.21569V1.54902C4.23746 1.54902 0.666667 5.07507 0.666667 9.44118H2.33333ZM11.3552 9.44118C11.3552 10.9228 10.1406 12.1373 8.62567 12.1373V13.8039C11.0462 13.8039 13.0218 11.858 13.0218 9.44118H11.3552ZM8.62567 12.1373C7.11079 12.1373 5.89617 10.9228 5.89617 9.44118H4.2295C4.2295 11.858 6.20516 13.8039 8.62567 13.8039V12.1373ZM5.89617 9.44118C5.89617 7.95956 7.11079 6.7451 8.62567 6.7451V5.07843C6.20516 5.07843 4.2295 7.02431 4.2295 9.44118H5.89617ZM11.1883 5.58729L8.0392 8.70688L9.21214 9.89093L12.3613 6.77134L11.1883 5.58729ZM15.9135 3.40365L13.0793 6.21127L14.2523 7.39533L17.0865 4.5877L15.9135 3.40365ZM11.733 4.89966L14.5672 2.09203L13.3942 0.907974L10.56 3.7156L11.733 4.89966ZM13.9271 6.01199L12.0376 5.38807L11.515 6.97069L13.4045 7.59461L13.9271 6.01199ZM12.5661 5.91362L11.9363 4.04186L10.3567 4.5734L10.9865 6.44515L12.5661 5.91362ZM13.1559 1.61894L13.4708 3.80266L15.1204 3.56477L14.8055 1.38106L13.1559 1.61894ZM14.1788 4.50882L16.3832 4.82078L16.6168 3.17056L14.4124 2.8586L14.1788 4.50882Z",
    fill: color
  })
});
Target02Icon.propTypes = {
  color: PropTypes.string
};

const Target04Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.33398 8.33301V7.49967C7.87375 7.49967 7.50065 7.87277 7.50065 8.33301H8.33398ZM8.4004 8.33301H9.23373C9.23373 7.87277 8.86063 7.49967 8.4004 7.49967V8.33301ZM8.4004 8.39307V9.2264C8.86063 9.2264 9.23373 8.8533 9.23373 8.39307H8.4004ZM8.33398 8.39307H7.50065C7.50065 8.8533 7.87375 9.2264 8.33398 9.2264V8.39307ZM15.834 8.33301H15.0007C15.0007 12.0149 12.0159 14.9997 8.33398 14.9997V15.833V16.6663C12.9364 16.6663 16.6673 12.9354 16.6673 8.33301H15.834ZM8.33398 15.833V14.9997C4.65209 14.9997 1.66732 12.0149 1.66732 8.33301H0.833984H0.000651062C0.000651062 12.9354 3.73161 16.6663 8.33398 16.6663V15.833ZM0.833984 8.33301H1.66732C1.66732 4.65111 4.65209 1.66634 8.33398 1.66634V0.833008V-0.000325501C3.73161 -0.000325501 0.000651062 3.73063 0.000651062 8.33301H0.833984ZM8.33398 0.833008V1.66634C12.0159 1.66634 15.0007 4.65111 15.0007 8.33301H15.834H16.6673C16.6673 3.73063 12.9364 -0.000325501 8.33398 -0.000325501V0.833008ZM12.084 8.33301H11.2507C11.2507 9.94384 9.94481 11.2497 8.33398 11.2497V12.083V12.9163C10.8653 12.9163 12.9173 10.8643 12.9173 8.33301H12.084ZM8.33398 12.083V11.2497C6.72315 11.2497 5.41732 9.94384 5.41732 8.33301H4.58398H3.75065C3.75065 10.8643 5.80268 12.9163 8.33398 12.9163V12.083ZM4.58398 8.33301H5.41732C5.41732 6.72218 6.72315 5.41634 8.33398 5.41634V4.58301V3.74967C5.80268 3.74967 3.75065 5.8017 3.75065 8.33301H4.58398ZM8.33398 4.58301V5.41634C9.94481 5.41634 11.2507 6.72218 11.2507 8.33301H12.084H12.9173C12.9173 5.8017 10.8653 3.74967 8.33398 3.74967V4.58301ZM8.33398 8.33301V9.16634H8.4004V8.33301V7.49967H8.33398V8.33301ZM8.4004 8.33301H7.56706V8.39307H8.4004H9.23373V8.33301H8.4004ZM8.4004 8.39307V7.55973H8.33398V8.39307V9.2264H8.4004V8.39307ZM8.33398 8.39307H9.16732V8.33301H8.33398H7.50065V8.39307H8.33398Z",
    fill: color
  })
});
Target04Icon.propTypes = {
  color: PropTypes.string
};

const UserProfileCircleIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M3.5 15C3.88431 14.5696 5.68421 12.5889 6.21167 12.5889H11.7887C12.553 12.5889 14.1133 14.2307 14.5 14.8095M17 9C17 13.4183 13.4183 17 9 17C4.58172 17 1 13.4183 1 9C1 4.58172 4.58172 1 9 1C13.4183 1 17 4.58172 17 9ZM11.8657 6.2733C11.8657 4.74704 10.5773 3.5 9.00024 3.5C7.42326 3.5 6.13478 4.74704 6.13478 6.2733C6.13478 7.79956 7.42326 9.0466 9.00024 9.0466C10.5772 9.0466 11.8657 7.79956 11.8657 6.2733Z",
    stroke: color,
    strokeWidth: "1.66667"
  })
});
UserProfileCircleIcon.propTypes = {
  color: PropTypes.string
};

const CaretIcon = ({
  width = 24,
  height,
  color = 'currentColor',
  ...props
}) => {
  const iconHeight = height || width;
  return /*#__PURE__*/jsx("svg", {
    width: width,
    height: iconHeight,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/jsx("path", {
      d: "M6 9L12 15L18 9",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

const LogoutIcon = ({
  width = 24,
  height,
  color = 'currentColor',
  ...props
}) => {
  const iconHeight = height || width;
  return /*#__PURE__*/jsxs("svg", {
    width: width,
    height: iconHeight,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [/*#__PURE__*/jsx("path", {
      d: "M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M16 17L21 12L16 7",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/jsx("path", {
      d: "M21 12H9",
      stroke: color,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};

const PieChart02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "18",
  height: "19",
  viewBox: "0 0 18 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.36274 17.304C12.5211 17.304 15.8922 13.933 15.8922 9.77458H8.36274L8.36279 2.24515C4.20439 2.24512 0.833334 5.61619 0.833334 9.77458C0.833334 13.933 4.20437 17.304 8.36274 17.304Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M11.6569 0.833252V6.40791H16.8333V6.00972C16.8333 3.15084 14.5157 0.833252 11.6569 0.833252Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
PieChart02Icon.propTypes = {
  color: PropTypes.string
};

const HelpCircleContainedIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.33252 12.0833V12.1162M6.45833 6.02491C6.45833 4.96982 7.2978 4.1145 8.33333 4.1145C9.36887 4.1145 10.2083 4.96982 10.2083 6.02491C10.2083 7.08001 9.36887 7.93533 8.33333 7.93533C8.33333 7.93533 8.33252 8.50554 8.33252 9.20894M15.8333 8.33325C15.8333 12.4754 12.4755 15.8333 8.33333 15.8333C4.1912 15.8333 0.833334 12.4754 0.833334 8.33325C0.833334 4.19112 4.1912 0.833252 8.33333 0.833252C12.4755 0.833252 15.8333 4.19112 15.8333 8.33325Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
HelpCircleContainedIcon.propTypes = {
  color: PropTypes.string
};

const CalendarCheckIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "16",
  height: "18",
  viewBox: "0 0 16 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M2.58333 6.42855H14.25M4.09127 1.5V2.78586M12.5833 1.5V2.78571M12.5833 2.78571H4.25C2.86929 2.78571 1.75 3.93697 1.75 5.35712V13.9286C1.75 15.3487 2.86929 16.5 4.25 16.5H12.5833C13.964 16.5 15.0833 15.3487 15.0833 13.9286L15.0833 5.35712C15.0833 3.93697 13.964 2.78571 12.5833 2.78571ZM6.33333 11.5714L7.58333 12.8571L10.5 9.85714",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
CalendarCheckIcon.propTypes = {
  color: PropTypes.string
};

const Marker02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "16",
  height: "19",
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M8.0001 17C8.0001 17 14.261 11.4348 14.261 7.26087C14.261 3.80309 11.4579 1 8.0001 1C4.54231 1 1.73923 3.80309 1.73923 7.26087C1.73923 11.4348 8.0001 17 8.0001 17Z",
    stroke: color,
    strokeWidth: "1.66667"
  }), /*#__PURE__*/jsx("path", {
    d: "M10.0004 7.00013C10.0004 8.1047 9.10492 9.00013 8.00035 9.00013C6.89578 9.00013 6.00035 8.1047 6.00035 7.00013C6.00035 5.89556 6.89578 5.00013 8.00035 5.00013C9.10492 5.00013 10.0004 5.89556 10.0004 7.00013Z",
    stroke: color,
    strokeWidth: "1.66667"
  })]
});
Marker02Icon.propTypes = {
  color: PropTypes.string
};

const PlaneIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M1.39771 11.8314L4.57842 13.4217L6.16877 16.6024L7.75912 15.0121V12.6265L10.5422 9.84341L12.9278 17L15.3133 14.6145L13.3254 7.06029L16.5061 3.87959C17.1648 3.22084 17.1648 2.15281 16.5061 1.49406C15.8473 0.835314 14.7793 0.835314 14.1205 1.49406L10.9398 4.67476L3.38565 2.68682L1.00012 5.07235L8.15671 7.45788L5.37359 10.241H2.98806L1.39771 11.8314Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
PlaneIcon.propTypes = {
  color: PropTypes.string
};

const TagIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M12.4613 5.21032L12.456 5.21029M15.1018 1.20941L10.2681 0.837594C9.8396 0.804629 9.41805 0.960571 9.11413 1.26449L1.26424 9.11438C0.689263 9.68936 0.689263 10.6216 1.26424 11.1966L6.46969 16.402C7.04467 16.977 7.9769 16.977 8.55187 16.402L16.4018 8.55212C16.7057 8.2482 16.8616 7.82665 16.8287 7.39811L16.4568 2.56448C16.4011 1.84042 15.8258 1.26511 15.1018 1.20941Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
TagIcon.propTypes = {
  color: PropTypes.string
};

const Gift01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
  ...props,
  children: [/*#__PURE__*/jsx("polyline", {
    points: "20 12 20 22 4 22 4 12"
  }), /*#__PURE__*/jsx("rect", {
    x: "2",
    y: "7",
    width: "20",
    height: "5"
  }), /*#__PURE__*/jsx("line", {
    x1: "12",
    y1: "22",
    x2: "12",
    y2: "7"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"
  })]
});
Gift01Icon.propTypes = {
  color: PropTypes.string
};

const MessageSquareIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.39822 16.833L8.57214 12.6591H15.1663C16.0868 12.6591 16.833 11.9129 16.833 10.9924V2.49967C16.833 1.5792 16.0868 0.833008 15.1663 0.833008H2.49967C1.5792 0.833008 0.833008 1.5792 0.833008 2.49968V10.9924C0.833008 11.9129 1.5792 12.6591 2.49967 12.6591H4.39822V16.833Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
MessageSquareIcon.propTypes = {
  color: PropTypes.string
};

const MessageSquareTypingIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M4.83301 6.9082V6.83301M8.83301 6.9082V6.83301M12.833 6.9082V6.83301M8.57214 12.6591L4.39822 16.833V12.6591H2.83301C1.72844 12.6591 0.833008 11.7637 0.833008 10.6591V2.83301C0.833008 1.72844 1.72844 0.833008 2.83301 0.833008H14.833C15.9376 0.833008 16.833 1.72844 16.833 2.83301V10.6591C16.833 11.7637 15.9376 12.6591 14.833 12.6591H8.57214Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
MessageSquareTypingIcon.propTypes = {
  color: PropTypes.string
};

const DotHorizontalIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "14",
  height: "3",
  viewBox: "0 0 14 3",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M3 1.5C3 2.32843 2.32843 3 1.5 3C0.671573 3 0 2.32843 0 1.5C0 0.671573 0.671573 0 1.5 0C2.32843 0 3 0.671573 3 1.5Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M8.5 1.5C8.5 2.32843 7.82843 3 7 3C6.17157 3 5.5 2.32843 5.5 1.5C5.5 0.671573 6.17157 0 7 0C7.82843 0 8.5 0.671573 8.5 1.5Z",
    fill: color
  }), /*#__PURE__*/jsx("path", {
    d: "M14 1.5C14 2.32843 13.3284 3 12.5 3C11.6716 3 11 2.32843 11 1.5C11 0.671573 11.6716 0 12.5 0C13.3284 0 14 0.671573 14 1.5Z",
    fill: color
  })]
});
DotHorizontalIcon.propTypes = {
  color: PropTypes.string
};

const Wallet01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M16.834 12.4335V13.2668C17.2942 13.2668 17.6673 12.8937 17.6673 12.4335H16.834ZM16.834 8.0335H17.6673C17.6673 7.57326 17.2942 7.20016 16.834 7.20016V8.0335ZM4.78335 3.73251C4.39621 3.98139 4.28412 4.49699 4.533 4.88413C4.78188 5.27127 5.29747 5.38336 5.68462 5.13448L4.78335 3.73251ZM10.834 0.833496L11.4918 0.321879C11.227 -0.0185747 10.7462 -0.100719 10.3834 0.132514L10.834 0.833496ZM12.9762 4.94511C13.2587 5.3084 13.7823 5.37385 14.1456 5.09129C14.5089 4.80873 14.5743 4.28517 14.2918 3.92188L12.9762 4.94511ZM16.834 12.4335V11.6002H14.234V12.4335V13.2668H16.834V12.4335ZM14.234 8.0335V8.86683H16.834V8.0335V7.20016H14.234V8.0335ZM16.834 8.0335H16.0006V12.4335H16.834H17.6673V8.0335H16.834ZM12.034 10.2335H12.8673C12.8673 9.47871 13.4792 8.86683 14.234 8.86683V8.0335V7.20016C12.5587 7.20016 11.2006 8.55823 11.2006 10.2335H12.034ZM14.234 12.4335V11.6002C13.4792 11.6002 12.8673 10.9883 12.8673 10.2335H12.034H11.2006C11.2006 11.9088 12.5587 13.2668 14.234 13.2668V12.4335ZM5.23398 4.4335L5.68462 5.13448L11.2846 1.53448L10.834 0.833496L10.3834 0.132514L4.78335 3.73251L5.23398 4.4335ZM10.834 0.833496L10.1762 1.34511L12.9762 4.94511L13.634 4.4335L14.2918 3.92188L11.4918 0.321879L10.834 0.833496ZM1.63398 4.4335V5.26683H15.234V4.4335V3.60016H1.63398V4.4335ZM15.234 16.4335V15.6002H1.63398V16.4335V17.2668H15.234V16.4335ZM0.833984 15.6335H1.66732V5.2335H0.833984H0.000651062V15.6335H0.833984ZM1.63398 16.4335V15.6002C1.65239 15.6002 1.66732 15.6151 1.66732 15.6335H0.833984H0.000651062C0.000651062 16.5356 0.731918 17.2668 1.63398 17.2668V16.4335ZM16.034 15.6335H15.2006C15.2006 15.6151 15.2156 15.6002 15.234 15.6002V16.4335V17.2668C16.136 17.2668 16.8673 16.5356 16.8673 15.6335H16.034ZM15.234 4.4335V5.26683C15.2156 5.26683 15.2006 5.2519 15.2006 5.2335H16.034H16.8673C16.8673 4.33143 16.136 3.60016 15.234 3.60016V4.4335ZM1.63398 4.4335V3.60016C0.731919 3.60016 0.000651062 4.33143 0.000651062 5.2335H0.833984H1.66732C1.66732 5.25191 1.65239 5.26683 1.63398 5.26683V4.4335ZM16.034 13.0335H15.2006V15.6335H16.034H16.8673V13.0335H16.034ZM16.034 5.2335H15.2006V7.3335H16.034H16.8673V5.2335H16.034Z",
    fill: color
  })
});
Wallet01Icon.propTypes = {
  color: PropTypes.string
};

const Layout02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M6.33301 0.833496V16.8335M9.83301 3.8335H12.833M9.83301 6.8335H12.833M9.83301 9.8335H10.333M3.83301 16.8335H13.833C15.4899 16.8335 16.833 15.4903 16.833 13.8335V3.8335C16.833 2.17664 15.4899 0.833496 13.833 0.833496H3.83301C2.17615 0.833496 0.833008 2.17664 0.833008 3.8335V13.8335C0.833008 15.4903 2.17615 16.8335 3.83301 16.8335Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
Layout02Icon.propTypes = {
  color: PropTypes.string
};

const Bag04Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "11",
  height: "12",
  viewBox: "0 0 11 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.1 3.8V2.3C7.1 1.30589 6.29411 0.5 5.3 0.5C4.30589 0.5 3.5 1.30589 3.5 2.3V3.8M1.66364 10.7H8.93636C9.57902 10.7 10.1 10.1887 10.1 9.55799L9.35454 3.49998C9.35454 2.86927 8.83357 2.35798 8.19091 2.35798H2.26364C1.62098 2.35798 1.1 2.86927 1.1 3.49998L0.5 9.55799C0.5 10.1887 1.02098 10.7 1.66364 10.7Z",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Bag04Icon.propTypes = {
  color: PropTypes.string
};

const StopCircleContainedIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "17",
  height: "17",
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M0.833008 8.33325C0.833008 4.19112 4.19087 0.833252 8.33301 0.833252C12.4751 0.833252 15.833 4.19112 15.833 8.33325C15.833 12.4754 12.4751 15.8333 8.33301 15.8333C4.19087 15.8333 0.833008 12.4754 0.833008 8.33325Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M5.52051 6.57544C5.52051 5.99295 5.99271 5.52075 6.5752 5.52075H10.0908C10.6733 5.52075 11.1455 5.99295 11.1455 6.57544V10.0911C11.1455 10.6736 10.6733 11.1458 10.0908 11.1458H6.5752C5.99271 11.1458 5.52051 10.6736 5.52051 10.0911V6.57544Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })]
});
StopCircleContainedIcon.propTypes = {
  color: PropTypes.string
};

const Play02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M11.8325 9.50778L11.3779 8.80939L11.3663 8.81695L11.3549 8.82489L11.8325 9.50778ZM11.8325 8.36096L11.3384 9.032L11.3756 9.05937L11.4156 9.08247L11.8325 8.36096ZM7.23636 4.97656L7.73048 4.30552L7.70697 4.2882L7.6823 4.27258L7.23636 4.97656ZM6.2728 5.48206L7.10613 5.47965L7.10611 5.47235L7.10596 5.46506L6.2728 5.48206ZM6.29207 12.1302L5.45874 12.1326L5.45881 12.1561L5.46021 12.1797L6.29207 12.1302ZM7.29096 12.6842L7.69448 13.4133L7.73274 13.3921L7.76857 13.367L7.29096 12.6842ZM3.83301 1.66659H13.833V-8.13603e-05H3.83301V1.66659ZM15.9997 3.83325V13.8333H17.6663V3.83325H15.9997ZM13.833 15.9999H3.83301V17.6666H13.833V15.9999ZM1.66634 13.8333V3.83325H-0.000325501V13.8333H1.66634ZM3.83301 15.9999C2.63639 15.9999 1.66634 15.0299 1.66634 13.8333H-0.000325501C-0.000325501 15.9503 1.71592 17.6666 3.83301 17.6666V15.9999ZM15.9997 13.8333C15.9997 15.0299 15.0296 15.9999 13.833 15.9999V17.6666C15.9501 17.6666 17.6663 15.9503 17.6663 13.8333H15.9997ZM13.833 1.66659C15.0296 1.66659 15.9997 2.63663 15.9997 3.83325H17.6663C17.6663 1.71616 15.9501 -8.13603e-05 13.833 -8.13603e-05V1.66659ZM3.83301 -8.13603e-05C1.71592 -8.13603e-05 -0.000325501 1.71616 -0.000325501 3.83325H1.66634C1.66634 2.63663 2.63639 1.66659 3.83301 1.66659V-8.13603e-05ZM12.2872 10.2062C12.6492 9.97052 13.1068 9.5502 13.1059 8.91666C13.105 8.26444 12.624 7.85587 12.2495 7.63945L11.4156 9.08247C11.5028 9.13288 11.5189 9.15909 11.5067 9.14362C11.4887 9.12068 11.4394 9.04171 11.4392 8.91893C11.4391 8.79922 11.4858 8.72876 11.4931 8.71889C11.4966 8.71412 11.471 8.74877 11.3779 8.80939L12.2872 10.2062ZM12.3267 7.68992L7.73048 4.30552L6.74224 5.64759L11.3384 9.032L12.3267 7.68992ZM7.6823 4.27258C7.29012 4.02415 6.73939 3.88182 6.21855 4.12501C5.65167 4.38969 5.42864 4.95988 5.43964 5.49907L7.10596 5.46506C7.10497 5.41626 7.11512 5.43203 7.08949 5.48107C7.06061 5.53633 7.0042 5.59756 6.92366 5.63517C6.7687 5.70752 6.70617 5.62716 6.79042 5.68053L7.6823 4.27258ZM5.43947 5.48448L5.45874 12.1326L7.1254 12.1277L7.10613 5.47965L5.43947 5.48448ZM5.46021 12.1797C5.48672 12.6249 5.64151 13.2185 6.2002 13.5169C6.75028 13.8107 7.32299 13.6189 7.69448 13.4133L6.88745 11.955C6.80485 12.0007 6.77238 12.0033 6.78542 12.0015C6.80514 11.9988 6.88652 11.994 6.98537 12.0468C7.0856 12.1003 7.12898 12.1731 7.13949 12.1955C7.14643 12.2102 7.12995 12.1817 7.12393 12.0806L5.46021 12.1797ZM7.76857 13.367L12.3101 10.1907L11.3549 8.82489L6.81335 12.0013L7.76857 13.367Z",
    fill: color
  })
});
Play02Icon.propTypes = {
  color: PropTypes.string
};

const Pause02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("rect", {
    x: "4",
    y: "3",
    width: "4",
    height: "14",
    rx: "1",
    fill: color
  }), /*#__PURE__*/jsx("rect", {
    x: "12",
    y: "3",
    width: "4",
    height: "14",
    rx: "1",
    fill: color
  })]
});
Pause02Icon.propTypes = {
  color: PropTypes.string
};

const Volume02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.54 8.46a5 5 0 0 1 0 7.07"
  }), /*#__PURE__*/jsx("path", {
    d: "M19.07 4.93a10 10 0 0 1 0 14.14"
  })]
});
Volume02Icon.propTypes = {
  color: PropTypes.string
};

const VolumeOff02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("polygon", {
    points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5"
  }), /*#__PURE__*/jsx("line", {
    x1: "23",
    y1: "9",
    x2: "17",
    y2: "15"
  }), /*#__PURE__*/jsx("line", {
    x1: "17",
    y1: "9",
    x2: "23",
    y2: "15"
  })]
});
VolumeOff02Icon.propTypes = {
  color: PropTypes.string
};

const ClosedCaptionsIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("rect", {
    x: "2",
    y: "5",
    width: "20",
    height: "14",
    rx: "2"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 11h3"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 14h2"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 11h3"
  }), /*#__PURE__*/jsx("path", {
    d: "M14 14h2"
  })]
});
ClosedCaptionsIcon.propTypes = {
  color: PropTypes.string
};

const Maximize01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 3H5a2 2 0 0 0-2 2v3"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 8V5a2 2 0 0 0-2-2h-3"
  }), /*#__PURE__*/jsx("path", {
    d: "M3 16v3a2 2 0 0 0 2 2h3"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 21h3a2 2 0 0 0 2-2v-3"
  })]
});
Maximize01Icon.propTypes = {
  color: PropTypes.string
};

const Minimize01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "20",
  height: "20",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: color,
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M8 3v3a2 2 0 0 1-2 2H3"
  }), /*#__PURE__*/jsx("path", {
    d: "M21 8h-3a2 2 0 0 1-2-2V3"
  }), /*#__PURE__*/jsx("path", {
    d: "M3 16h3a2 2 0 0 1 2 2v3"
  }), /*#__PURE__*/jsx("path", {
    d: "M16 21v-3a2 2 0 0 1 2-2h3"
  })]
});
Minimize01Icon.propTypes = {
  color: PropTypes.string
};

const Star02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M8.80068 1.09493C8.97282 0.746146 9.47018 0.746146 9.64231 1.09493L11.8707 5.61004C11.939 5.74854 12.0711 5.84454 12.224 5.86675L17.2067 6.59078C17.5916 6.64671 17.7453 7.11973 17.4668 7.39123L13.8613 10.9057C13.7507 11.0136 13.7002 11.1689 13.7263 11.3211L14.5774 16.2837C14.6432 16.6671 14.2408 16.9594 13.8965 16.7784L9.43987 14.4354C9.30316 14.3635 9.13983 14.3635 9.00312 14.4354L4.54645 16.7784C4.20217 16.9594 3.7998 16.6671 3.86555 16.2837L4.7167 11.3211C4.74281 11.1689 4.69234 11.0136 4.58174 10.9057L0.976213 7.39123C0.697689 7.11973 0.851382 6.64671 1.23629 6.59078L6.219 5.86675C6.37185 5.84454 6.50399 5.74854 6.57234 5.61004L8.80068 1.09493Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })
});
Star02Icon.propTypes = {
  color: PropTypes.string
};

const DiamondIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.59126 0.833557L5.88253 5.26074L8.83398 14.4501M8.83398 14.4501L11.8631 5.18307L10.232 0.833557M8.83398 14.4501L0.833984 5.33841M8.83398 14.4501L16.834 5.33841M0.833984 5.33841L4.25146 0.833557H13.4942L16.834 5.33841M0.833984 5.33841H16.834",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
DiamondIcon.propTypes = {
  color: PropTypes.string
};

const Star01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.90982 1.47675C8.22727 0.618835 9.44069 0.618834 9.75815 1.47675L11.3382 5.74686C11.438 6.01659 11.6507 6.22925 11.9204 6.32906L16.1905 7.90915C17.0485 8.2266 17.0485 9.44002 16.1905 9.75748L11.9204 11.3376C11.6507 11.4374 11.438 11.65 11.3382 11.9198L9.75815 16.1899C9.4407 17.0478 8.22727 17.0478 7.90982 16.1899L6.32973 11.9198C6.22992 11.65 6.01726 11.4374 5.74754 11.3376L1.47742 9.75748C0.619506 9.44002 0.619505 8.2266 1.47742 7.90915L5.74754 6.32906C6.01726 6.22925 6.22992 6.01659 6.32973 5.74687L7.90982 1.47675Z",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinejoin: "round"
  })
});
Star01Icon.propTypes = {
  color: PropTypes.string
};

const AwardAndTrophy04Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "76",
  height: "62",
  viewBox: "0 0 76 62",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M37.823 20.1876L40.973 26.5751L48.023 27.6001L42.923 32.5626L44.1355 39.5876L37.823 36.2751L31.523 39.5876L32.723 32.5626L27.623 27.6001L34.673 26.5751L37.823 20.1876Z",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M61.5445 35.1927C64.0281 21.9474 55.3039 9.19662 42.0586 6.71304C28.8133 4.22946 16.0625 12.9536 13.579 26.1989C11.0954 39.4442 19.8195 52.195 33.0648 54.6786C46.3101 57.1621 59.0609 48.438 61.5445 35.1927Z",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M15.25 20.8126H1.25L7.4 30.1376L1.25 39.8751H14.95",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M59.875 20.8126H73.875L67.725 30.1376L73.875 39.8751H60.175",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M12.123 15.8375C17.2355 7.1125 26.7105 1.25 37.5605 1.25C48.373 1.25 57.8105 7.075 62.9355 15.75",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M63.9863 43.725C59.1738 53.4625 49.1488 60.15 37.5613 60.15C26.0488 60.15 16.0863 53.55 11.2363 43.925",
    stroke: color,
    strokeWidth: "2.5",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
AwardAndTrophy04Icon.propTypes = {
  color: PropTypes.string
};

const Trophy01 = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("path", {
    d: "M7 4h10v8a5 5 0 0 1-10 0V4z",
    stroke: color,
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M17 4h3v2a3 3 0 0 1-3 3",
    stroke: color,
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M7 4H4v2a3 3 0 0 0 3 3",
    stroke: color,
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 17v3",
    stroke: color,
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/jsx("path", {
    d: "M8 20h8",
    stroke: color,
    strokeWidth: "1.75",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
Trophy01.propTypes = {
  color: PropTypes.string
};

const Inbox02Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M0.833008 8.45206V12.2616C0.833008 13.3136 1.67247 14.1663 2.70801 14.1663H13.958C14.9935 14.1663 15.833 13.3136 15.833 12.2616V8.45206M0.833008 8.45206L3.18927 2.06896C3.4637 1.32553 4.1633 0.833008 4.94488 0.833008H11.7211C12.5027 0.833008 13.2023 1.32553 13.4767 2.06896L15.833 8.45206M0.833008 8.45206H4.58301L5.83301 9.78539H10.833L12.083 8.45206H15.833",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })
});
Inbox02Icon.propTypes = {
  color: PropTypes.string
};

const EqualsIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "15",
  height: "9",
  viewBox: "0 0 15 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M14.1673 7.49992H0.833984M14.1673 0.833252H0.833984",
    stroke: color,
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
EqualsIcon.propTypes = {
  color: PropTypes.string
};

const X01Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M14.1673 0.833255L0.833984 14.1666M14.1673 14.1666L0.833985 0.833252",
    stroke: "#5C6EBB",
    strokeWidth: "1.66667",
    strokeLinecap: "round"
  })
});
X01Icon.propTypes = {
  color: PropTypes.string
};

const RoomIcon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "22",
  height: "16",
  viewBox: "0 0 22 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M9.40234 0C9.84519 7.68163e-05 10.2572 0.131382 10.6025 0.356445C10.9477 0.131639 11.3592 7.69142e-05 11.8018 0H17.8018C19.0178 0.000105396 20.0039 0.986082 20.0039 2.20215V5.04199C20.716 5.40676 21.204 6.14694 21.2041 7.00195V15.2041H0V7.00195C7.42953e-05 6.14694 0.488069 5.40676 1.2002 5.04199V2.20215C1.2002 0.986017 2.18621 0 3.40234 0H9.40234ZM2.20215 6.80371C2.09286 6.80371 2.00401 6.89269 2.00391 7.00195V13.2002H19.2002V7.00195C19.2001 6.89269 19.1112 6.80371 19.002 6.80371H2.20215ZM11.8018 2.00391C11.6945 2.00411 11.6066 2.08976 11.6035 2.19629C11.6035 2.19824 11.6045 2.20019 11.6045 2.20215V4.7998H18V2.20215C18 2.09286 17.911 2.00401 17.8018 2.00391H11.8018ZM3.40234 2.00391C3.29299 2.00391 3.2041 2.0928 3.2041 2.20215V4.7998H9.59961V2.19531C9.59598 2.08926 9.50922 2.00411 9.40234 2.00391H3.40234Z",
    fill: color
  })
});
RoomIcon.propTypes = {
  color: PropTypes.string
};

const AddSquare04Icon = ({
  color = 'currentColor',
  ...props
}) => /*#__PURE__*/jsx("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: /*#__PURE__*/jsx("path", {
    d: "M7.33268 3.66675C7.33268 3.29856 7.03421 3.00008 6.66602 3.00008C6.29783 3.00008 5.99935 3.29856 5.99935 3.66675L7.33268 3.66675ZM5.99935 9.66675C5.99935 10.0349 6.29783 10.3334 6.66602 10.3334C7.03421 10.3334 7.33268 10.0349 7.33268 9.66675H5.99935ZM9.66602 7.33341C10.0342 7.33341 10.3327 7.03494 10.3327 6.66675C10.3327 6.29856 10.0342 6.00008 9.66602 6.00008V7.33341ZM3.66602 6.00008C3.29783 6.00008 2.99935 6.29856 2.99935 6.66675C2.99935 7.03494 3.29783 7.33341 3.66602 7.33341V6.00008ZM12.666 6.66675H11.9993C11.9993 9.61227 9.61153 12.0001 6.66602 12.0001V12.6667V13.3334C10.3479 13.3334 13.3327 10.3486 13.3327 6.66675H12.666ZM6.66602 12.6667V12.0001C3.7205 12.0001 1.33268 9.61227 1.33268 6.66675H0.666016H-0.000651062C-0.000651062 10.3486 2.98412 13.3334 6.66602 13.3334V12.6667ZM0.666016 6.66675H1.33268C1.33268 3.72123 3.7205 1.33341 6.66602 1.33341V0.666748V8.13603e-05C2.98412 8.13603e-05 -0.000651062 2.98485 -0.000651062 6.66675H0.666016ZM6.66602 0.666748V1.33341C9.61153 1.33341 11.9993 3.72123 11.9993 6.66675H12.666H13.3327C13.3327 2.98485 10.3479 8.13603e-05 6.66602 8.13603e-05V0.666748ZM6.66602 3.66675L5.99935 3.66675L5.99935 6.66675H6.66602H7.33268L7.33268 3.66675L6.66602 3.66675ZM6.66602 6.66675H5.99935V9.66675H6.66602H7.33268V6.66675H6.66602ZM9.66602 6.66675V6.00008H6.66602V6.66675V7.33341H9.66602V6.66675ZM6.66602 6.66675V6.00008H3.66602V6.66675V7.33341H6.66602V6.66675Z",
    fill: color
  })
});
AddSquare04Icon.propTypes = {
  color: PropTypes.string
};

const SmileEmojiIcon = ({
  color = 'currentColor',
  ...props
}) => {
  return /*#__PURE__*/jsxs("svg", {
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: [/*#__PURE__*/jsx("path", {
      d: "M8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5C7 10.3284 7.67157 11 8.5 11Z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      d: "M17 9.5C17 10.3284 16.3284 11 15.5 11C14.6716 11 14 10.3284 14 9.5C14 8.67157 14.6716 8 15.5 8C16.3284 8 17 8.67157 17 9.5Z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      d: "M8.88875 13.5414C8.63822 13.0559 8.0431 12.8607 7.55301 13.1058C7.05903 13.3528 6.8588 13.9535 7.10579 14.4474C7.18825 14.6118 7.29326 14.7659 7.40334 14.9127C7.58615 15.1565 7.8621 15.4704 8.25052 15.7811C9.04005 16.4127 10.2573 17.0002 12.0002 17.0002C13.7431 17.0002 14.9604 16.4127 15.7499 15.7811C16.1383 15.4704 16.4143 15.1565 16.5971 14.9127C16.7076 14.7654 16.8081 14.6113 16.8941 14.4485C17.1387 13.961 16.9352 13.3497 16.4474 13.1058C15.9573 12.8607 15.3622 13.0559 15.1117 13.5414C15.0979 13.5663 14.9097 13.892 14.5005 14.2194C14.0401 14.5877 13.2573 15.0002 12.0002 15.0002C10.7431 15.0002 9.96038 14.5877 9.49991 14.2194C9.09071 13.892 8.90255 13.5663 8.88875 13.5414Z",
      fill: color
    }), /*#__PURE__*/jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 20.9932C7.03321 20.9932 3.00683 16.9668 3.00683 12C3.00683 7.03321 7.03321 3.00683 12 3.00683C16.9668 3.00683 20.9932 7.03321 20.9932 12C20.9932 16.9668 16.9668 20.9932 12 20.9932Z",
      fill: color
    })]
  });
};

const FlashcardIcon = ({
  color = 'currentColor',
  width = 20,
  height = 20,
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("rect", {
    x: "2",
    y: "6",
    width: "16",
    height: "12",
    rx: "2",
    stroke: color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/jsx("path", {
    d: "M6 6V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2",
    stroke: color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/jsx("line", {
    x1: "6",
    y1: "10",
    x2: "14",
    y2: "10",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  }), /*#__PURE__*/jsx("line", {
    x1: "6",
    y1: "13.5",
    x2: "11",
    y2: "13.5",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round"
  })]
});
FlashcardIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

const ClockIcon = ({
  color = 'currentColor',
  width = 20,
  height = 20,
  ...props
}) => /*#__PURE__*/jsxs("svg", {
  width: width,
  height: height,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props,
  children: [/*#__PURE__*/jsx("circle", {
    cx: "12",
    cy: "12",
    r: "9",
    stroke: color,
    strokeWidth: "1.5"
  }), /*#__PURE__*/jsx("path", {
    d: "M12 7v5l3.5 2",
    stroke: color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })]
});
ClockIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

const getVariantColors = variant => {
  switch (variant) {
    case 'success':
      return {
        color: 'white',
        backgroundColor: colors$1.success
      };
    case 'warning':
      return {
        color: colors$1.warning,
        backgroundColor: colors$1.warning10
      };
    case 'danger':
      return {
        color: 'white',
        backgroundColor: colors$1.danger
      };
    case 'info':
      return {
        color: 'white',
        backgroundColor: colors$1.primaryColor
      };
    case 'secondary':
      return {
        color: 'white',
        backgroundColor: colors$1.grey64
      };
    case 'primary':
      return {
        color: 'white',
        backgroundColor: colors$1.primaryColor
      };
    case 'disabled':
      return {
        color: colors$1.grey,
        backgroundColor: colors$1.disabled
      };
    default:
      return {
        color: 'white',
        backgroundColor: colors$1.primaryColor
      };
  }
};
const Badge = ({
  children,
  variant = 'primary',
  size = 'md',
  color,
  backgroundColor,
  style = {}
}) => {
  // Size mapping
  const sizeStyles = {
    sm: {
      minWidth: '16px',
      height: '16px',
      padding: '0 4px',
      fontSize: '10px'
    },
    md: {
      minWidth: '20px',
      height: '20px',
      padding: '0 6px',
      fontSize: 'var(--body-xs-size)'
    },
    lg: {
      minWidth: '24px',
      height: '24px',
      padding: '0 8px',
      fontSize: '12px'
    }
  };

  // Variant color mapping
  let variantColor = color;
  let variantBackgroundColor = backgroundColor;
  if (!color && !backgroundColor) {
    const variantColors = getVariantColors(variant);
    variantColor = variantColors.color;
    variantBackgroundColor = variantColors.backgroundColor;
  }
  const badgeStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '9999px',
    fontWeight: 600,
    lineHeight: 1,
    color: variantColor,
    backgroundColor: variantBackgroundColor,
    ...sizeStyles[size],
    ...style
  };
  return /*#__PURE__*/jsx("span", {
    style: badgeStyle,
    children: children
  });
};
Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'disabled']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  style: PropTypes.object
};

var css_248z$1t = ".DropdownButton-module__dropdownWrapper___tU19K{position:relative;width:fit-content}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__content___Ho56l{align-items:center;display:flex;gap:15px;line-height:1}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdown___kAoJ8{background-color:#fff;border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);box-shadow:0 4px 12px rgba(0,0,0,.1);min-width:160px;padding:4px 0;position:absolute;z-index:1000}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownArrow___ett69 svg{height:13px!important;width:13px!important}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownArrow___ett69.DropdownButton-module__small___3iKbG svg{height:11px!important;width:11px!important}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownBelow___ZxVSh{top:calc(100% + 4px)}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownAbove___0cokD{bottom:calc(100% + 4px)}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownAlignRight___rWAYq{right:0}.DropdownButton-module__dropdownWrapper___tU19K .DropdownButton-module__dropdownAlignLeft___37NF-{left:0}.DropdownButton-module__option___Sgyht{align-items:center;cursor:pointer;font-size:14px;gap:5px;justify-content:center;padding:8px 16px;text-align:left;white-space:nowrap}.DropdownButton-module__option___Sgyht:hover{background-color:var(--grey-8)}.DropdownButton-module__portalMenu___7Pb9y{background-color:#fff;border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);min-width:160px;padding:4px 0;position:fixed;z-index:100000}";
var css$1r = {"dropdownWrapper":"DropdownButton-module__dropdownWrapper___tU19K","content":"DropdownButton-module__content___Ho56l","dropdown":"DropdownButton-module__dropdown___kAoJ8","dropdownArrow":"DropdownButton-module__dropdownArrow___ett69","small":"DropdownButton-module__small___3iKbG","dropdownBelow":"DropdownButton-module__dropdownBelow___ZxVSh","dropdownAbove":"DropdownButton-module__dropdownAbove___0cokD","dropdownAlignRight":"DropdownButton-module__dropdownAlignRight___rWAYq","dropdownAlignLeft":"DropdownButton-module__dropdownAlignLeft___37NF-","option":"DropdownButton-module__option___Sgyht","portalMenu":"DropdownButton-module__portalMenu___7Pb9y"};
styleInject(css_248z$1t);

const DropdownButton = ({
  children,
  label,
  icon,
  position = 'below',
  align = 'right',
  disabled = false,
  className = '',
  variant,
  size,
  style,
  showExpandableArrows = true,
  menuInPortal = false,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [portalCoords, setPortalCoords] = useState(null);
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);

  // Close dropdown when clicking outside (accounting for a portaled menu that
  useEffect(() => {
    const handleClickOutside = event => {
      if (!isOpen) {
        return;
      }
      const inWrapper = wrapperRef.current && wrapperRef.current.contains(event.target);
      const inMenu = menuRef.current && menuRef.current.contains(event.target);
      if (!inWrapper && !inMenu) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const dropdownClasses = [css$1r.dropdown, position === 'above' ? css$1r.dropdownAbove : css$1r.dropdownBelow, align === 'left' ? css$1r.dropdownAlignLeft : css$1r.dropdownAlignRight].filter(Boolean).join(' ');
  const computePortalCoords = () => {
    const rect = wrapperRef.current?.getBoundingClientRect();
    if (!rect) {
      return null;
    }
    return {
      position: 'fixed',
      top: position === 'above' ? undefined : rect.bottom + 4,
      bottom: position === 'above' ? window.innerHeight - rect.top + 4 : undefined,
      left: align === 'left' ? rect.left : undefined,
      right: align === 'right' ? window.innerWidth - rect.right : undefined
    };
  };
  const onClick = e => {
    e.preventDefault();
    setIsOpen(prev => {
      const next = !prev;
      if (next && menuInPortal) {
        setPortalCoords(computePortalCoords());
      }
      return next;
    });
  };
  const onChildClick = () => {
    setIsOpen(false); // Close the dropdown when a child is clicked
  };
  return /*#__PURE__*/jsxs("div", {
    className: css$1r.dropdownWrapper,
    ref: wrapperRef,
    style: style,
    children: [/*#__PURE__*/jsx(Button$1, {
      ...props,
      disabled: disabled,
      className: className,
      onClick: onClick,
      icon: icon,
      iconPosition: "left",
      variant: variant,
      size: size,
      children: showExpandableArrows && /*#__PURE__*/jsxs("span", {
        className: css$1r.content,
        children: [label, /*#__PURE__*/jsx("span", {
          className: `${css$1r.dropdownArrow} ${size}`,
          children: position === 'above' ? /*#__PURE__*/jsx(ChevronUp, {
            width: "15px"
          }) : /*#__PURE__*/jsx(ChevronDown, {
            width: "15px"
          })
        })]
      })
    }), isOpen && !menuInPortal && /*#__PURE__*/jsx("div", {
      className: dropdownClasses,
      onClick: onChildClick,
      children: children
    }), isOpen && menuInPortal && portalCoords && /*#__PURE__*/createPortal(/*#__PURE__*/jsx("div", {
      ref: menuRef,
      className: css$1r.portalMenu,
      style: portalCoords,
      onClick: onChildClick,
      children: children
    }), document.body)]
  });
};
DropdownButton.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  icon: PropTypes.node,
  position: PropTypes.oneOf(['above', 'below']),
  align: PropTypes.oneOf(['left', 'right']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link', 'success', 'warning', 'danger']),
  size: PropTypes.oneOf(['small', 'default']),
  menuInPortal: PropTypes.bool
};

const ButtonDropdownItem = ({
  children,
  onClick,
  ...rest
}) => /*#__PURE__*/jsx("div", {
  className: css$1r.option,
  onClick: onClick,
  ...rest,
  children: children
});
ButtonDropdownItem.displayName = 'ButtonOption';
ButtonDropdownItem.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

var css_248z$1s = ".DeleteButton-module__deleteButton___4XDlm{background-color:transparent;border:none;color:var(--danger);cursor:pointer;font-size:1rem;padding:5px 7px!important;transition:all .2s ease}.DeleteButton-module__deleteButton___4XDlm svg{width:20px}.DeleteButton-module__deleteButton___4XDlm:hover{background-color:var(--danger-10)!important}";
var css$1q = {"deleteButton":"DeleteButton-module__deleteButton___4XDlm"};
styleInject(css_248z$1s);

const DeleteButton = ({
  onClick,
  color = 'var(--danger)',
  className = ''
}) => {
  return /*#__PURE__*/jsx(Button$1, {
    variant: "ghost",
    type: "button",
    onClick: onClick,
    className: `${css$1q.deleteButton} ${className}`,
    children: /*#__PURE__*/jsx(Trash01, {
      color: color
    })
  });
};

var css_248z$1r = ".SplitButton-module__splitButtonWrapper___xX4Y9{display:inline-flex;position:relative}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc{align-items:stretch;display:flex}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__mainButton___eWF6q{border-bottom-right-radius:0;border-right:none;border-top-right-radius:0}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA{align-items:center;border:1px solid transparent;border-bottom-right-radius:var(--border-radius-medium);border-left-color:hsla(0,0%,100%,.3);border-top-right-radius:var(--border-radius-medium);cursor:pointer;display:inline-flex;font-size:var(--button-text-size);font-weight:var(--button-text-weight);justify-content:center;padding:12px 10px;transition:all .2s ease-in-out}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__small___JuMzD{padding:8px}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__small___JuMzD .SplitButton-module__dropdownArrow___Hv-7e svg{height:11px!important;width:11px!important}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__primary___KAD4U{background-color:var(--button-primary);color:var(--button-primary-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__primary___KAD4U:hover:not(.SplitButton-module__disabled___zW9PP){background-color:var(--button-primary-hover-bg);color:var(--button-primary-hover-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__secondary___ISw8-{background-color:var(--button-secondary);color:var(--button-secondary-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__secondary___ISw8-:hover:not(.SplitButton-module__disabled___zW9PP){background-color:var(--button-secondary-hover-bg);color:var(--button-secondary-hover-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__tertiary___8gMAp{background-color:var(--button-tertiary);border-left:1px solid var(--button-tertiary-border-color);border:1px solid var(--button-tertiary-border-color);color:var(--button-tertiary-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__tertiary___8gMAp:hover:not(.SplitButton-module__disabled___zW9PP){background-color:var(--button-tertiary);border-color:var(--button-tertiary-hover-border-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__link___iHrQL{background-color:transparent;border:0;border-radius:0;color:var(--primary-50)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__link___iHrQL:hover:not(.SplitButton-module__disabled___zW9PP){color:var(--primary-20)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__ghost___XEzrf{background-color:transparent;color:var(--button-tertiary-color)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__ghost___XEzrf:hover:not(.SplitButton-module__disabled___zW9PP){background-color:var(--button-tertiary)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__success___VTjsq{background-color:var(--button-success);color:#fff}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__success___VTjsq:hover:not(.SplitButton-module__disabled___zW9PP){opacity:.9}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__danger___NfU6L{background-color:var(--button-danger);color:#fff}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__danger___NfU6L:hover:not(.SplitButton-module__disabled___zW9PP){opacity:.9}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__warning___pw2ac{background-color:var(--button-warning);color:#fff}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__warning___pw2ac:hover:not(.SplitButton-module__disabled___zW9PP){opacity:.9}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__info___KFxib{background-color:var(--button-info);color:#fff}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__info___KFxib:hover:not(.SplitButton-module__disabled___zW9PP){opacity:.9}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA.SplitButton-module__disabled___zW9PP{background-color:var(--button-disabled);border-color:var(--button-disabled-border-color);color:var(--button-disabled-color);cursor:not-allowed;pointer-events:none}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA .SplitButton-module__dropdownArrow___Hv-7e{align-items:center;display:flex;justify-content:center}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__buttonGroup___KdWfc .SplitButton-module__dropdownTrigger___OQhDA .SplitButton-module__dropdownArrow___Hv-7e svg{height:13px!important;width:13px!important}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__dropdown___kZPig{background-color:#fff;border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);box-shadow:0 4px 12px rgba(0,0,0,.1);min-width:160px;padding:4px 0;position:absolute;right:0;z-index:1000}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__dropdownBelow___sQQpL{top:calc(100% + 4px)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__dropdownAbove___wbvGB{bottom:calc(100% + 4px)}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__option___9DSip{cursor:pointer;font-size:14px;padding:8px 16px;transition:background-color .2s ease-in-out;white-space:nowrap}.SplitButton-module__splitButtonWrapper___xX4Y9 .SplitButton-module__option___9DSip:hover{background-color:var(--grey-8)}";
var css$1p = {"splitButtonWrapper":"SplitButton-module__splitButtonWrapper___xX4Y9","buttonGroup":"SplitButton-module__buttonGroup___KdWfc","mainButton":"SplitButton-module__mainButton___eWF6q","dropdownTrigger":"SplitButton-module__dropdownTrigger___OQhDA","small":"SplitButton-module__small___JuMzD","dropdownArrow":"SplitButton-module__dropdownArrow___Hv-7e","primary":"SplitButton-module__primary___KAD4U","disabled":"SplitButton-module__disabled___zW9PP","secondary":"SplitButton-module__secondary___ISw8-","tertiary":"SplitButton-module__tertiary___8gMAp","link":"SplitButton-module__link___iHrQL","ghost":"SplitButton-module__ghost___XEzrf","success":"SplitButton-module__success___VTjsq","danger":"SplitButton-module__danger___NfU6L","warning":"SplitButton-module__warning___pw2ac","info":"SplitButton-module__info___KFxib","dropdown":"SplitButton-module__dropdown___kZPig","dropdownBelow":"SplitButton-module__dropdownBelow___sQQpL","dropdownAbove":"SplitButton-module__dropdownAbove___wbvGB","option":"SplitButton-module__option___9DSip"};
styleInject(css_248z$1r);

const SplitButton = ({
  children,
  onClick,
  icon,
  variant = 'primary',
  size = 'default',
  disabled = false,
  className = '',
  options = [],
  position = 'below',
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = event => {
      if (isOpen && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleMainClick = e => {
    e.preventDefault();
    if (onClick && !disabled) {
      onClick();
    }
  };
  const handleDropdownToggle = e => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      setIsOpen(prev => !prev);
    }
  };
  const handleOptionClick = optionOnClick => {
    setIsOpen(false);
    if (optionOnClick) {
      optionOnClick();
    }
  };
  const dropdownClasses = [css$1p.dropdown, position === 'above' ? css$1p.dropdownAbove : css$1p.dropdownBelow].filter(Boolean).join(' ');
  const wrapperClasses = [css$1p.splitButtonWrapper, className].filter(Boolean).join(' ');
  return /*#__PURE__*/jsxs("div", {
    className: wrapperClasses,
    ref: wrapperRef,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$1p.buttonGroup,
      children: [/*#__PURE__*/jsx(Button$1, {
        ...props,
        variant: variant,
        size: size,
        disabled: disabled,
        onClick: handleMainClick,
        className: css$1p.mainButton,
        icon: icon,
        children: children
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        className: `${css$1p.dropdownTrigger} ${css$1p[variant]} ${css$1p[size]} ${disabled ? css$1p.disabled : ''}`,
        onClick: handleDropdownToggle,
        disabled: disabled,
        children: /*#__PURE__*/jsx("span", {
          className: css$1p.dropdownArrow,
          children: /*#__PURE__*/jsx(ChevronDown, {
            width: "15px"
          })
        })
      })]
    }), isOpen && options.length > 0 && /*#__PURE__*/jsx("div", {
      className: dropdownClasses,
      children: options.map((option, index) => /*#__PURE__*/jsx("div", {
        className: css$1p.option,
        onClick: () => handleOptionClick(option.onClick),
        children: option.label
      }, index))
    })]
  });
};
SplitButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node,
  variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link', 'success', 'warning', 'danger', 'ghost']),
  size: PropTypes.oneOf(['small', 'default']),
  disabled: PropTypes.bool,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    onClick: PropTypes.func.isRequired
  })),
  position: PropTypes.oneOf(['above', 'below'])
};

const TranslateButton = ({
  availableLanguages,
  selectedLanguage,
  onTranslateAll
}) => {
  const [selectedFromLanguageCode, setSelectedFromLanguageCode] = useState(null);
  const [showFromLanguageSelection, setShowFromLanguageSelection] = useState(false);
  const languageOptions = [];
  availableLanguages.forEach(lang => {
    if (lang[0] === selectedLanguage) {
      return;
    }
    if (!selectedFromLanguageCode) {
      setSelectedFromLanguageCode(lang[0]);
    }
    languageOptions.push({
      label: lang[0],
      value: lang[0]
    });
  });
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(Button$1, {
      size: "small",
      variant: "secondary",
      style: {
        marginBottom: 15
      },
      onClick: () => setShowFromLanguageSelection(!showFromLanguageSelection),
      icon: /*#__PURE__*/jsx(Translation, {}),
      children: "AI Translate"
    }), showFromLanguageSelection && /*#__PURE__*/jsxs(FlexContainer, {
      style: {
        marginBottom: 15
      },
      gap: 10,
      alignItems: "end",
      children: [/*#__PURE__*/jsx(Dropdown, {
        label: "Translate from",
        name: "translateFrom",
        style: {
          width: 135
        },
        placeholder: "Select language",
        value: selectedFromLanguageCode,
        options: languageOptions,
        onChange: e => setSelectedFromLanguageCode(e.target.value)
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        onClick: () => onTranslateAll(selectedFromLanguageCode, selectedLanguage),
        children: "Translate"
      })]
    })]
  });
};

var css_248z$1q = ".PageTitle-module__pageTitleContainer___nhnIz{align-items:center;display:flex;gap:10px;margin-bottom:16px}.PageTitle-module__pageTitleContainer___nhnIz h1{color:var(--primary-color);font-size:29px!important;font-weight:500!important;margin:0}.PageTitle-module__pageTitleContainer___nhnIz .PageTitle-module__icon___QIkSB{align-items:center;color:inherit;display:flex;font-size:24px;justify-content:center}.PageTitle-module__pageTitleContainer___nhnIz .PageTitle-module__icon___QIkSB svg{height:24px;width:24px}";
var css$1o = {"pageTitleContainer":"PageTitle-module__pageTitleContainer___nhnIz","icon":"PageTitle-module__icon___QIkSB"};
styleInject(css_248z$1q);

const PageTitle = ({
  children,
  align = 'left',
  color,
  icon,
  style
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$1o.pageTitleContainer,
    style: {
      justifyContent: align
    },
    children: [icon && /*#__PURE__*/jsx("span", {
      className: css$1o.icon,
      children: icon
    }), /*#__PURE__*/jsx("h1", {
      style: {
        color: color ? `${color} !important` : undefined,
        ...style
      },
      children: children
    })]
  });
};

var css_248z$1p = ".CardTitle-module__cardTitle___BglSm{align-items:center;color:var(--primary-color);display:flex;font-size:16px;font-weight:500;gap:8px;line-height:20px;margin-bottom:10px;min-width:0;width:100%}.CardTitle-module__cardTitle___BglSm .CardTitle-module__icon___ZKPxV{align-items:center;display:flex;flex-shrink:0;height:18px;justify-content:center;width:18px}.CardTitle-module__cardTitle___BglSm .CardTitle-module__icon___ZKPxV svg{color:inherit;height:100%;width:100%}.CardTitle-module__truncate___K1jyL{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
var css$1n = {"cardTitle":"CardTitle-module__cardTitle___BglSm","icon":"CardTitle-module__icon___ZKPxV","truncate":"CardTitle-module__truncate___K1jyL"};
styleInject(css_248z$1p);

const CardTitle = ({
  children,
  className,
  color,
  icon,
  truncate = false,
  ...props
}) => {
  const classNames = [css$1n.cardTitle, truncate ? css$1n.truncate : '', className || ''].filter(Boolean).join(' ');
  return /*#__PURE__*/jsxs("h5", {
    className: classNames,
    style: {
      color: color
    },
    ...props,
    children: [icon && /*#__PURE__*/jsx("span", {
      className: css$1n.icon,
      children: icon
    }), children]
  });
};

var css_248z$1o = ".SubTitle-module__subTitle___tSZlg{color:var(--primary-color)!important;margin:0;padding:10px 0}";
var css$1m = {"subTitle":"SubTitle-module__subTitle___tSZlg"};
styleInject(css_248z$1o);

const SubTitle = ({
  children,
  className,
  ...props
}) => {
  return /*#__PURE__*/jsx("h2", {
    className: `${css$1m.subTitle} ${className || ''}`,
    ...props,
    children: children
  });
};

var css_248z$1n = ".PageDescription-module__pageDescription___1Df-A{color:var(--grey-64);font-size:var(--body-regular-size);line-height:var(--body-regular-line-height);margin-bottom:20px}.PageDescription-module__pageDescription___1Df-A h4{margin-bottom:10px}.PageDescription-module__pageDescription___1Df-A ul{list-style-position:inside}.PageDescription-module__pageDescription___1Df-A ul ul{list-style-type:revert;padding-left:23px}";
var css$1l = {"pageDescription":"PageDescription-module__pageDescription___1Df-A"};
styleInject(css_248z$1n);

const PageDescription = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$1l.pageDescription,
    children: children
  });
};

var css_248z$1m = ".Text-module__text___XXjeA{margin:0}.Text-module__xs___cPxPp{font-size:var(--body-xs-size);line-height:var(--body-xs-line-height)}.Text-module__small___-48A8{font-size:var(--body-small-size);line-height:var(--body-small-line-height)}.Text-module__regular___F5quW{font-size:var(--body-regular-size);line-height:var(--body-regular-line-height)}.Text-module__colorText___m40l7{color:var(--text)}.Text-module__colorMuted___aCOTj{color:var(--grey-64)}.Text-module__colorPrimary___fnfAr{color:var(--primary-color)}.Text-module__colorSuccess___iUFzg{color:var(--success)}.Text-module__colorDanger___NeYq2{color:var(--danger)}.Text-module__colorWarning___HJpS8{color:var(--warning)}.Text-module__weightNormal___kQ4Qg{font-weight:400}.Text-module__weightSemibold___T9e34{font-weight:600}.Text-module__weightBold___6ql-d{font-weight:700}.Text-module__truncate___Ri7xm{display:block;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
var css$1k = {"text":"Text-module__text___XXjeA","xs":"Text-module__xs___cPxPp","small":"Text-module__small___-48A8","regular":"Text-module__regular___F5quW","colorText":"Text-module__colorText___m40l7","colorMuted":"Text-module__colorMuted___aCOTj","colorPrimary":"Text-module__colorPrimary___fnfAr","colorSuccess":"Text-module__colorSuccess___iUFzg","colorDanger":"Text-module__colorDanger___NeYq2","colorWarning":"Text-module__colorWarning___HJpS8","weightNormal":"Text-module__weightNormal___kQ4Qg","weightSemibold":"Text-module__weightSemibold___T9e34","weightBold":"Text-module__weightBold___6ql-d","truncate":"Text-module__truncate___Ri7xm"};
styleInject(css_248z$1m);

const SIZE_CLASS = {
  xs: css$1k.xs,
  small: css$1k.small,
  regular: css$1k.regular
};
const COLOR_CLASS = {
  text: css$1k.colorText,
  muted: css$1k.colorMuted,
  primary: css$1k.colorPrimary,
  success: css$1k.colorSuccess,
  danger: css$1k.colorDanger,
  warning: css$1k.colorWarning
};
const WEIGHT_CLASS = {
  normal: css$1k.weightNormal,
  semibold: css$1k.weightSemibold,
  bold: css$1k.weightBold
};
const Text$2 = ({
  children,
  size = 'regular',
  color = 'text',
  weight = 'normal',
  truncate = false,
  as: Tag = 'span',
  className,
  style,
  ...props
}) => {
  const classNames = [css$1k.text, SIZE_CLASS[size], COLOR_CLASS[color], WEIGHT_CLASS[weight], truncate && css$1k.truncate, className].filter(Boolean).join(' ');
  return /*#__PURE__*/jsx(Tag, {
    className: classNames,
    style: style,
    ...props,
    children: children
  });
};
Text$2.propTypes = {
  children: PropTypes.node,
  size: PropTypes.oneOf(['xs', 'small', 'regular']),
  color: PropTypes.oneOf(['text', 'muted', 'primary', 'success', 'danger', 'warning']),
  weight: PropTypes.oneOf(['normal', 'semibold', 'bold']),
  truncate: PropTypes.bool,
  as: PropTypes.elementType,
  className: PropTypes.string,
  style: PropTypes.object
};

var css_248z$1l = ".NoResultsFoundMessage-module__noResultsFoundSection___8oxqg{align-items:center;color:var(--text);display:flex;flex-direction:column;justify-content:center;margin-top:15px;padding:10px;text-align:center}.NoResultsFoundMessage-module__noResultsFoundSection___8oxqg .NoResultsFoundMessage-module__emoji___KCya7{font-size:25px;margin-bottom:10px}";
var css$1j = {"noResultsFoundSection":"NoResultsFoundMessage-module__noResultsFoundSection___8oxqg","emoji":"NoResultsFoundMessage-module__emoji___KCya7"};
styleInject(css_248z$1l);

const NoResultsFoundMessage = ({
  message = 'No results found...'
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$1j.noResultsFoundSection,
    children: [/*#__PURE__*/jsx("div", {
      className: css$1j.emoji,
      children: "\uD83D\uDD0D"
    }), /*#__PURE__*/jsx("h4", {
      children: message
    })]
  });
};
NoResultsFoundMessage.propTypes = {
  message: PropTypes.string
};

var css_248z$1k = ".SortableItemsModal-module__sortableList___Xndsm{list-style:none;margin:0;padding:8px 0}.SortableItemsModal-module__sortableRow___2XC7O{align-items:center;background-color:var(--white);border-top:1px solid var(--bg-dark);cursor:grab;display:flex;gap:12px;padding:8px 16px;transition:background-color .15s ease;user-select:none}.SortableItemsModal-module__sortableRow___2XC7O:first-child{border-top:none}.SortableItemsModal-module__sortableRow___2XC7O:hover{background-color:var(--bg-light)}.SortableItemsModal-module__sortableRow___2XC7O:active{cursor:grabbing}.SortableItemsModal-module__dragged___LgFOG{opacity:.4}.SortableItemsModal-module__dragOver___HObBE{background-color:var(--bg-light);box-shadow:inset 0 2px 0 0 var(--primary-color)}.SortableItemsModal-module__positionSelector___hATzG{flex-shrink:0}.SortableItemsModal-module__thumbnail___WBepk{border-radius:var(--border-radius-small);flex-shrink:0;height:40px;object-fit:cover;width:40px}.SortableItemsModal-module__thumbnailPlaceholder___NuYS3{align-items:center;background-color:var(--bg-light);color:var(--grey-64);display:flex;justify-content:center}.SortableItemsModal-module__itemTextBlock___bhEMc{flex:1;min-width:0}.SortableItemsModal-module__itemCode___0IMOd{letter-spacing:.04em;text-transform:uppercase}.SortableItemsModal-module__itemName___iPq9x{color:var(--text)}";
var css$1i = {"sortableList":"SortableItemsModal-module__sortableList___Xndsm","sortableRow":"SortableItemsModal-module__sortableRow___2XC7O","dragged":"SortableItemsModal-module__dragged___LgFOG","dragOver":"SortableItemsModal-module__dragOver___HObBE","positionSelector":"SortableItemsModal-module__positionSelector___hATzG","thumbnail":"SortableItemsModal-module__thumbnail___WBepk","thumbnailPlaceholder":"SortableItemsModal-module__thumbnailPlaceholder___NuYS3","itemTextBlock":"SortableItemsModal-module__itemTextBlock___bhEMc","itemCode":"SortableItemsModal-module__itemCode___0IMOd","itemName":"SortableItemsModal-module__itemName___iPq9x"};
styleInject(css_248z$1k);

const MODAL_WIDTH = 'min(540px, calc(100vw - 32px))';
const SortableItemsModal = ({
  open,
  onClose,
  onSave,
  onReorder,
  title,
  items,
  saving = false
}) => {
  const [orderedItems, setOrderedItems] = useState([]);
  useEffect(() => {
    if (open) {
      setOrderedItems(items.map((item, idx) => ({
        ...item,
        position: idx + 1
      })));
    }
  }, [open, items]);
  const handleDragSortChange = () => {
    if (onReorder) {
      onReorder({
        method: 'drag'
      });
    }
  };
  const {
    draggedIndex,
    dragOverIndex,
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDragEnd,
    onDragOver
  } = useDragAndDrop(orderedItems, setOrderedItems, handleDragSortChange, 'position');
  const handleSaveClick = () => {
    onSave(orderedItems);
  };
  const handlePositionChange = (fromIdx, toPosition) => {
    const toIdx = toPosition - 1;
    if (toIdx === fromIdx || toIdx < 0 || toIdx >= orderedItems.length) {
      return;
    }
    setOrderedItems(prev => {
      const next = [...prev];
      const [moved] = next.splice(fromIdx, 1);
      next.splice(toIdx, 0, moved);
      return next.map((item, i) => ({
        ...item,
        position: i + 1
      }));
    });
    if (onReorder) {
      onReorder({
        method: 'dropdown'
      });
    }
  };
  const footer = /*#__PURE__*/jsxs(ModalActions, {
    align: "right",
    children: [/*#__PURE__*/jsx(Button$1, {
      variant: "tertiary",
      onClick: onClose,
      disabled: saving,
      children: "Cancel"
    }), /*#__PURE__*/jsx(Button$1, {
      onClick: handleSaveClick,
      disabled: saving,
      children: "Save"
    })]
  });
  return /*#__PURE__*/jsx(Modal, {
    isOpen: open,
    onClose: onClose,
    title: title,
    stickyLayout: true,
    bodyPadding: false,
    footer: footer,
    style: {
      width: MODAL_WIDTH
    },
    children: orderedItems.length === 0 ? /*#__PURE__*/jsx(NoResultsFoundMessage, {}) : /*#__PURE__*/jsx("ul", {
      className: css$1i.sortableList,
      children: orderedItems.map((item, idx) => /*#__PURE__*/jsx(SortableRow, {
        item: item,
        idx: idx,
        totalCount: orderedItems.length,
        isDragged: draggedIndex === idx,
        isDragOver: dragOverIndex === idx,
        onDragStart: onDragStart,
        onDragEnter: onDragEnter,
        onDragLeave: onDragLeave,
        onDragEnd: onDragEnd,
        onDragOver: onDragOver,
        onPositionChange: handlePositionChange
      }, item.id))
    })
  });
};
const SortableRow = ({
  item,
  idx,
  totalCount,
  isDragged,
  isDragOver,
  onDragStart,
  onDragEnter,
  onDragLeave,
  onDragEnd,
  onDragOver,
  onPositionChange
}) => {
  const handleMouseDown = event => {
    event.stopPropagation();
    onDragStart(idx);
  };
  const handleTouchStart = event => {
    event.stopPropagation();
    onDragStart(idx);
  };
  const handleDragEnter = () => {
    onDragEnter(idx);
  };
  const handleDragLeave = () => {
    onDragLeave(idx);
  };
  const handleDragOver = event => {
    onDragOver(event, idx);
  };
  const handlePositionSelectChange = event => {
    onPositionChange(idx, parseInt(event.target.value, 10));
  };
  const rowClassName = [css$1i.sortableRow, isDragged ? css$1i.dragged : '', isDragOver ? css$1i.dragOver : ''].filter(Boolean).join(' ');
  return /*#__PURE__*/jsxs("li", {
    className: rowClassName,
    draggable: true,
    onMouseDown: handleMouseDown,
    onTouchStart: handleTouchStart,
    onDragEnter: handleDragEnter,
    onDragLeave: handleDragLeave,
    onDragEnd: onDragEnd,
    onDragOver: handleDragOver,
    children: [/*#__PURE__*/jsx(Text$2, {
      color: "primary",
      children: /*#__PURE__*/jsx(ArrowSwitchVertical, {})
    }), /*#__PURE__*/jsx(PositionSelect, {
      value: idx + 1,
      count: totalCount,
      onChange: handlePositionSelectChange
    }), /*#__PURE__*/jsx(SortableThumbnail, {
      thumbnailUrl: item.thumbnailUrl,
      name: item.name
    }), /*#__PURE__*/jsxs(FlexContainer, {
      flexDirection: "column",
      flexFlow: "column",
      gap: 2,
      className: css$1i.itemTextBlock,
      children: [/*#__PURE__*/jsx(Text$2, {
        size: "xs",
        color: "muted",
        weight: "semibold",
        className: css$1i.itemCode,
        children: item.code
      }), /*#__PURE__*/jsx(Text$2, {
        size: "small",
        weight: "semibold",
        truncate: true,
        className: css$1i.itemName,
        children: item.name
      })]
    })]
  });
};
const PositionSelect = ({
  value,
  count,
  onChange
}) => {
  const stopPropagation = event => {
    event.stopPropagation();
  };
  const options = Array.from({
    length: count
  }, (_, i) => ({
    value: i + 1,
    label: String(i + 1)
  }));
  return /*#__PURE__*/jsx("div", {
    className: css$1i.positionSelector,
    draggable: false,
    onMouseDown: stopPropagation,
    onTouchStart: stopPropagation,
    onClick: stopPropagation,
    children: /*#__PURE__*/jsx(Dropdown, {
      size: "small",
      value: value,
      onChange: onChange,
      options: options
    })
  });
};
const SortableThumbnail = ({
  thumbnailUrl,
  name
}) => {
  if (thumbnailUrl) {
    return /*#__PURE__*/jsx("img", {
      src: thumbnailUrl,
      alt: name || '',
      className: css$1i.thumbnail
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: `${css$1i.thumbnail} ${css$1i.thumbnailPlaceholder}`,
    "aria-label": name || '',
    children: /*#__PURE__*/jsx(ImageIcon, {})
  });
};
SortableItemsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onReorder: PropTypes.func,
  title: PropTypes.node.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    code: PropTypes.node,
    name: PropTypes.string,
    thumbnailUrl: PropTypes.string
  })).isRequired,
  saving: PropTypes.bool
};

var css_248z$1j = ".Card-module__card___LzN-3{background-color:var(--white);border-radius:var(--border-radius-medium);margin-bottom:20px;padding:15px}.Card-module__card___LzN-3 .Card-module__title___DzwNA{align-items:center;color:var(--primary-color);display:flex;gap:.5rem;width:100%}.Card-module__card___LzN-3 .Card-module__cardContent___IF-N9{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height)}.Card-module__card___LzN-3 ol,.Card-module__card___LzN-3 ul{margin-left:15px}.Card-module__pointer___VnML2{cursor:pointer}";
var css$1h = {"card":"Card-module__card___LzN-3","title":"Card-module__title___DzwNA","cardContent":"Card-module__cardContent___IF-N9","pointer":"Card-module__pointer___VnML2"};
styleInject(css_248z$1j);

const Card = ({
  icon,
  title,
  titleColor,
  titleAlign = 'left',
  isExpandable = false,
  className,
  children,
  style,
  backgroundColor,
  onClick
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const cardStyle = {
    ...style,
    ...(backgroundColor && {
      backgroundColor
    })
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1h.card} ${className}`,
    style: cardStyle,
    onClick: onClick,
    children: [title && /*#__PURE__*/jsx("div", {
      className: css$1h.title,
      style: {
        justifyContent: titleAlign
      },
      children: isExpandable ? /*#__PURE__*/jsxs(FlexContainer, {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [/*#__PURE__*/jsx(CardTitle, {
          icon: icon ? icon : null,
          color: titleColor,
          children: title
        }), /*#__PURE__*/jsx("div", {
          onClick: () => setIsExpanded(!isExpanded),
          className: css$1h.pointer,
          children: isExpanded ? /*#__PURE__*/jsx(UpArrow, {
            width: "20px"
          }) : /*#__PURE__*/jsx(DownArrow, {
            width: "20px"
          })
        })]
      }) : /*#__PURE__*/jsx(CardTitle, {
        icon: icon ? icon : null,
        color: titleColor,
        children: title
      })
    }), isExpanded && /*#__PURE__*/jsx("div", {
      className: css$1h.cardContent,
      children: children
    })]
  });
};
Card.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string || PropTypes.object,
  titleAlign: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  backgroundColor: PropTypes.string
};

var css_248z$1i = ".ImagesGallery-module__imagesGallery___iSD1k{position:relative;width:100%}.ImagesGallery-module__imageContainer___6orlw{border-radius:var(--border-radius-small);height:300px;overflow:hidden;position:relative;width:100%}.ImagesGallery-module__image___2qFM6{display:block;height:100%;object-fit:cover;width:100%}.ImagesGallery-module__navButton___NtUAh{align-items:center;background-color:hsla(0,0%,100%,.9);border:none;border-radius:50%;cursor:pointer;display:flex;height:36px;justify-content:center;left:12px;padding:0;position:absolute;top:50%;transform:translateY(-50%);transition:background-color .2s ease,opacity .2s ease;width:36px;z-index:2}.ImagesGallery-module__navButton___NtUAh:hover{background-color:#fff}.ImagesGallery-module__navButton___NtUAh:active{opacity:.8}.ImagesGallery-module__navButton___NtUAh svg{color:var(--text);height:20px;width:20px}.ImagesGallery-module__navButtonRight___EAJ3d{left:auto;right:12px}.ImagesGallery-module__imageCounter___wrh1e{align-items:center;background-color:rgba(0,0,0,.6);border-radius:var(--border-radius-small);bottom:12px;color:var(--white);display:flex;font-size:var(--body-small-size);font-weight:var(--font-weight-medium);gap:5px;padding:4px 12px;position:absolute;right:12px;z-index:2}.ImagesGallery-module__image___2qFM6{cursor:pointer;transition:opacity .2s ease}.ImagesGallery-module__fullscreenOverlay___T8lJ3{align-items:center;background-color:rgba(0,0,0,.85);bottom:0;display:flex;justify-content:center;left:0;padding:40px;position:fixed;right:0;top:0;z-index:999999!important}.ImagesGallery-module__fullscreenContainer___jZMs-{align-items:center;display:flex;height:100%;justify-content:center;max-height:90vh;max-width:90vw;position:relative;width:100%;z-index:999999}.ImagesGallery-module__fullscreenImage___izci7{border-radius:var(--border-radius-small);max-height:100%;max-width:100%;object-fit:contain}.ImagesGallery-module__fullscreenClose___0gPfc{cursor:pointer;height:44px;position:absolute;right:20px;top:20px;width:44px}.ImagesGallery-module__fullscreenNavButton___Hr-fw{align-items:center;background-color:rgba(0,0,0,.7);border:none;border-radius:50%;cursor:pointer;display:flex;height:35px;justify-content:center;left:20px;position:absolute;top:50%;transform:translateY(-50%);transition:background-color .2s ease;width:35px;z-index:10000}.ImagesGallery-module__fullscreenNavButton___Hr-fw:hover{background-color:hsla(0,0%,100%,.2)}.ImagesGallery-module__fullscreenNavButtonRight___j3z-S{left:auto;right:20px}.ImagesGallery-module__fullscreenCounter___DBL9o{background-color:rgba(0,0,0,.7);border-radius:var(--border-radius-small);bottom:20px;color:var(--white);font-size:var(--body-regular-size);font-weight:var(--font-weight-medium);left:50%;padding:8px 16px;position:absolute;transform:translateX(-50%);z-index:10000}";
var css$1g = {"imagesGallery":"ImagesGallery-module__imagesGallery___iSD1k","imageContainer":"ImagesGallery-module__imageContainer___6orlw","image":"ImagesGallery-module__image___2qFM6","navButton":"ImagesGallery-module__navButton___NtUAh","navButtonRight":"ImagesGallery-module__navButtonRight___EAJ3d","imageCounter":"ImagesGallery-module__imageCounter___wrh1e","fullscreenOverlay":"ImagesGallery-module__fullscreenOverlay___T8lJ3","fullscreenContainer":"ImagesGallery-module__fullscreenContainer___jZMs-","fullscreenImage":"ImagesGallery-module__fullscreenImage___izci7","fullscreenClose":"ImagesGallery-module__fullscreenClose___0gPfc","fullscreenNavButton":"ImagesGallery-module__fullscreenNavButton___Hr-fw","fullscreenNavButtonRight":"ImagesGallery-module__fullscreenNavButtonRight___j3z-S","fullscreenCounter":"ImagesGallery-module__fullscreenCounter___DBL9o"};
styleInject(css_248z$1i);

const ImagesGallery = ({
  images = [],
  imageVersion = '250s',
  fullscreenImageVersion = '640',
  alt = 'Gallery image',
  className = '',
  style = {}
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [fullscreenIndex, setFullscreenIndex] = useState(0);
  if (!images || images.length === 0) {
    return null;
  }
  const currentImage = images[currentIndex];
  const imageUrl = currentImage?.versions?.[imageVersion] || null;
  const hasMultipleImages = images.length > 1;
  const handlePrevious = e => {
    e.stopPropagation();
    setCurrentIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const handleNext = e => {
    e.stopPropagation();
    setCurrentIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  const handleImageClick = () => {
    setFullscreenIndex(currentIndex);
    setIsFullscreen(true);
  };
  const handleCloseFullscreen = () => {
    setIsFullscreen(false);
  };
  const handleFullscreenPrevious = e => {
    e.stopPropagation();
    setFullscreenIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
  };
  const handleFullscreenNext = e => {
    e.stopPropagation();
    setFullscreenIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
  };
  useEffect(() => {
    if (!isFullscreen) {
      return;
    }
    const handleEscapeKey = event => {
      if (event.key === 'Escape') {
        setIsFullscreen(false);
      }
    };
    const handleArrowKeys = event => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        setFullscreenIndex(prev => prev === 0 ? images.length - 1 : prev - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        setFullscreenIndex(prev => prev === images.length - 1 ? 0 : prev + 1);
      }
    };
    document.addEventListener('keydown', handleEscapeKey);
    document.addEventListener('keydown', handleArrowKeys);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
      document.removeEventListener('keydown', handleArrowKeys);
      document.body.style.overflow = '';
    };
  }, [isFullscreen, images.length]);
  if (!imageUrl) {
    return null;
  }
  const fullscreenImage = images[fullscreenIndex];
  const fullscreenImageUrl = fullscreenImage?.versions?.[fullscreenImageVersion] || fullscreenImage?.versions?.['640'] || fullscreenImage?.versions?.[imageVersion] || null;
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx("div", {
      className: `${css$1g.imagesGallery} ${className}`,
      style: style,
      children: /*#__PURE__*/jsxs("div", {
        className: css$1g.imageContainer,
        children: [/*#__PURE__*/jsx("img", {
          src: imageUrl,
          alt: alt,
          className: css$1g.image,
          onClick: handleImageClick
        }), hasMultipleImages && /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx("button", {
            type: "button",
            className: css$1g.navButton,
            onClick: handlePrevious,
            "aria-label": "Previous image",
            children: /*#__PURE__*/jsx(ChevronLeft, {
              color: colors$1.primaryColor
            })
          }), /*#__PURE__*/jsx("button", {
            type: "button",
            className: `${css$1g.navButton} ${css$1g.navButtonRight}`,
            onClick: handleNext,
            "aria-label": "Next image",
            children: /*#__PURE__*/jsx(ChevronRight, {
              color: colors$1.primaryColor
            })
          }), /*#__PURE__*/jsxs("div", {
            className: css$1g.imageCounter,
            children: [/*#__PURE__*/jsx(ImageIcon, {}), " ", currentIndex + 1, " / ", images.length]
          })]
        })]
      })
    }), isFullscreen && fullscreenImageUrl && /*#__PURE__*/createPortal(/*#__PURE__*/jsx("div", {
      className: css$1g.fullscreenOverlay,
      onClick: handleCloseFullscreen,
      children: /*#__PURE__*/jsxs("div", {
        className: css$1g.fullscreenContainer,
        onClick: e => e.stopPropagation(),
        children: [/*#__PURE__*/jsx("div", {
          className: css$1g.fullscreenClose,
          onClick: handleCloseFullscreen,
          children: /*#__PURE__*/jsx(X02, {
            color: colors$1.white
          })
        }), hasMultipleImages && /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx("button", {
            type: "button",
            className: css$1g.fullscreenNavButton,
            onClick: handleFullscreenPrevious,
            "aria-label": "Previous image",
            children: /*#__PURE__*/jsx(ChevronLeft, {})
          }), /*#__PURE__*/jsx("button", {
            type: "button",
            className: `${css$1g.fullscreenNavButton} ${css$1g.fullscreenNavButtonRight}`,
            onClick: handleFullscreenNext,
            "aria-label": "Next image",
            children: /*#__PURE__*/jsx(ChevronRight, {})
          }), /*#__PURE__*/jsxs("div", {
            className: css$1g.fullscreenCounter,
            children: [fullscreenIndex + 1, " / ", images.length]
          })]
        }), /*#__PURE__*/jsx("img", {
          src: fullscreenImageUrl,
          alt: alt,
          className: css$1g.fullscreenImage
        })]
      })
    }), document.body)]
  });
};
ImagesGallery.propTypes = {
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
    versions: PropTypes.objectOf(PropTypes.string)
  })),
  imageVersion: PropTypes.string,
  fullscreenImageVersion: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

var css_248z$1h = ".FixedBottomBar-module__fixedBar___oTkTB{align-items:center;background-color:var(--primary-10);bottom:0;display:flex;gap:12px;left:0;padding:12px 15px;position:fixed;right:0;transition:.5s;z-index:90!important}";
var css$1f = {"fixedBar":"FixedBottomBar-module__fixedBar___oTkTB"};
styleInject(css_248z$1h);

const FixedBottomBar = ({
  children,
  leftPosition
}) => {
  const defaultLeftPosition = useFixedBottomBarPosition();
  const finalLeftPosition = leftPosition ?? defaultLeftPosition;
  return /*#__PURE__*/jsx("div", {
    className: css$1f.fixedBar,
    style: {
      left: finalLeftPosition
    },
    children: children
  });
};
FixedBottomBar.propTypes = {
  children: PropTypes.node.isRequired,
  leftPosition: PropTypes.string
};

var css_248z$1g = ".StickyActionsBar-module__stickyBar___kTtI6{background-color:var(--bg-light-48);border:1px solid var(--grey-8);border-radius:8px;box-shadow:var(--smoothShadow);margin-bottom:12px;padding:12px 16px;position:sticky;top:85px;z-index:80}";
var css$1e = {"stickyBar":"StickyActionsBar-module__stickyBar___kTtI6"};
styleInject(css_248z$1g);

const StickyActionsBar = ({
  children,
  className,
  top
}) => {
  const inlineStyle = top != null ? {
    top
  } : undefined;
  const combinedClassName = className ? `${css$1e.stickyBar} ${className}` : css$1e.stickyBar;
  return /*#__PURE__*/jsx("div", {
    className: combinedClassName,
    style: inlineStyle,
    children: children
  });
};
StickyActionsBar.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var css_248z$1f = ".HotelSwitcher-module__hotelSwitcher___zvkzH{align-items:flex-start;background-color:rgba(var(--primary-color-rgb),.97);bottom:0;display:flex;justify-content:center;left:0;padding:20vh 20px 20px;position:fixed;right:0;top:0;z-index:1000}.HotelSwitcher-module__hotelSwitcher___zvkzH h1{color:var(--white)!important;margin-bottom:0!important}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__closeButton___6m3oj{align-items:center;cursor:pointer;display:flex;justify-content:center;padding:10px;position:fixed;right:20px;top:20px;transition:opacity .2s ease;z-index:1000}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__closeButton___6m3oj svg{height:24px;width:24px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv{max-width:600px;min-width:0;width:100%}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv>div{justify-content:center;margin-bottom:15px;text-align:center}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchInputWrapper___X1kNK{margin-bottom:18px;width:100%}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchInputWrapper___X1kNK input{height:48px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22{align-items:stretch;display:flex;flex-direction:column;position:relative;width:100%}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g{background-color:#fff;border-top-left-radius:var(--border-radius-small);border-top-right-radius:var(--border-radius-small)}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g>div:first-child{border-top-left-radius:var(--border-radius-small);border-top-right-radius:var(--border-radius-small)}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__spinnerWrapper___NXGlU{padding:15px;text-align:center}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__fullscreenResults___aVXqh{background:#fff;border-bottom-left-radius:var(--border-radius-small);border-bottom-right-radius:var(--border-radius-small);left:0;max-height:60vh;overflow-y:auto;padding-bottom:10px;position:absolute;right:0;top:100%}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__fullscreenResults___aVXqh .HotelSwitcher-module__selectedResult___7PY40{background-color:var(--bg-light)}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__fullscreenResults___aVXqh .HotelSwitcher-module__selectedResult___7PY40 li{background-color:var(--bg-light)!important}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__resultsCount___m-3uU{align-items:center;background:#fff;border-top-left-radius:var(--border-radius-small);border-top-right-radius:var(--border-radius-small);color:var(--primary-color);display:flex;font-size:16px;font-weight:600;gap:5px;padding:10px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul{list-style-type:none;margin:0;padding:0 10px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul li{align-items:center;border-bottom:1px solid var(--bg-dark)!important;color:var(--text);display:flex;gap:5px;padding:15px;transition:background-color .2s ease}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul li:last-child{border-bottom:none!important}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul li:hover{background:var(--bg-light);border-radius:var(--border-radius-small);cursor:pointer}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul li:active{background-color:var(--primary-20)!important}.HotelSwitcher-module__checkAllSection___6Pnar{align-items:center;display:flex;flex-direction:column;margin-bottom:20px;width:100%}.HotelSwitcher-module__checkAllButton___WMsBJ{background-color:var(--primary-color);border:none;border-radius:8px;color:#fff;cursor:pointer;font-weight:600;padding:12px 24px;transition:background-color .2s ease}.HotelSwitcher-module__checkAllButton___WMsBJ:hover{background-color:var(--primary-color)}.HotelSwitcher-module__separator___O8Uq4{align-items:center;display:flex;margin:20px 0 0;width:100%}.HotelSwitcher-module__separator___O8Uq4:after,.HotelSwitcher-module__separator___O8Uq4:before{background-color:hsla(0,0%,100%,.3);content:\"\";flex:1;height:2px}.HotelSwitcher-module__separator___O8Uq4 span{color:hsla(0,0%,100%,.7);font-size:14px;font-weight:500;padding:0 20px}@media (max-width:768px){.HotelSwitcher-module__hotelSwitcher___zvkzH{padding:15vh 16px 16px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__closeButton___6m3oj{right:16px;top:16px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__closeButton___6m3oj svg{height:20px;width:20px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv{max-width:100%}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchInputWrapper___X1kNK{margin-bottom:12px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchInputWrapper___X1kNK input{height:40px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__fullscreenResults___aVXqh{max-height:50vh}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv .HotelSwitcher-module__searchBoxContainer___9TE22 .HotelSwitcher-module__resultsWrapper___ps87g .HotelSwitcher-module__resultsCount___m-3uU{font-size:14px;padding:8px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul{padding:0 8px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul a li{padding:12px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul a li .HotelSwitcher-module__resultName___DEcU6{font-size:14px}.HotelSwitcher-module__hotelSwitcher___zvkzH .HotelSwitcher-module__hotelSwitcherContent___63rZv ul a li .HotelSwitcher-module__resultDate___gXorL{font-size:12px}}";
var css$1d = {"hotelSwitcher":"HotelSwitcher-module__hotelSwitcher___zvkzH","closeButton":"HotelSwitcher-module__closeButton___6m3oj","hotelSwitcherContent":"HotelSwitcher-module__hotelSwitcherContent___63rZv","searchInputWrapper":"HotelSwitcher-module__searchInputWrapper___X1kNK","searchBoxContainer":"HotelSwitcher-module__searchBoxContainer___9TE22","resultsWrapper":"HotelSwitcher-module__resultsWrapper___ps87g","spinnerWrapper":"HotelSwitcher-module__spinnerWrapper___NXGlU","fullscreenResults":"HotelSwitcher-module__fullscreenResults___aVXqh","selectedResult":"HotelSwitcher-module__selectedResult___7PY40","resultsCount":"HotelSwitcher-module__resultsCount___m-3uU","checkAllSection":"HotelSwitcher-module__checkAllSection___6Pnar","checkAllButton":"HotelSwitcher-module__checkAllButton___WMsBJ","separator":"HotelSwitcher-module__separator___O8Uq4","resultName":"HotelSwitcher-module__resultName___DEcU6","resultDate":"HotelSwitcher-module__resultDate___gXorL"};
styleInject(css_248z$1f);

var css_248z$1e = ".InputText-module__inputContainer___RFnJr{display:flex;flex-direction:column;width:100%}.InputText-module__inputContainer___RFnJr .InputText-module__label___D93Gb{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:5px;text-align:left}.InputText-module__inputContainer___RFnJr .InputText-module__label___D93Gb .InputText-module__required___ZZCgA{color:var(--danger);margin-left:.15rem}.InputText-module__inputContainer___RFnJr .InputText-module__inputWrapper___BgN24{align-items:center;display:flex;position:relative;width:100%}.InputText-module__inputContainer___RFnJr .InputText-module__iconContainer___VF2nq{align-items:center;color:var(--grey-64);display:flex;justify-content:center;left:10px;pointer-events:none;position:absolute;top:50%;transform:translateY(-50%)}.InputText-module__inputContainer___RFnJr .InputText-module__iconContainer___VF2nq svg{height:18px;width:18px}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;transition:all .2s ease;width:100%}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA.InputText-module__hasIcon___A975K{padding-left:35px}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA.InputText-module__small___wB-0F{padding:3px 5px}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA::placeholder{color:var(--grey-20)}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA:focus{background-color:var(--bg-light-48);outline:none}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA:disabled{background-color:var(--grey-8);color:var(--grey-20);cursor:not-allowed}.InputText-module__inputContainer___RFnJr .InputText-module__input___fHhqA.InputText-module__error___WD3Am{border-color:var(--danger)}.InputText-module__inputContainer___RFnJr .InputText-module__errorMessage___GsRdT{color:var(--danger);font-size:.75rem;margin-top:.2rem;text-align:left}";
var css$1c = {"inputContainer":"InputText-module__inputContainer___RFnJr","label":"InputText-module__label___D93Gb","required":"InputText-module__required___ZZCgA","inputWrapper":"InputText-module__inputWrapper___BgN24","iconContainer":"InputText-module__iconContainer___VF2nq","input":"InputText-module__input___fHhqA","hasIcon":"InputText-module__hasIcon___A975K","small":"InputText-module__small___wB-0F","error":"InputText-module__error___WD3Am","errorMessage":"InputText-module__errorMessage___GsRdT"};
styleInject(css_248z$1e);

const InputText = ({
  label,
  placeholder,
  value,
  onChange,
  error,
  type = 'text',
  required = false,
  disabled = false,
  autoComplete = true,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown,
  size,
  maxLength
}) => {
  const handleChange = e => {
    onChange(e);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1c.inputContainer} ${className}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$1c.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$1c.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$1c.inputWrapper,
      children: [icon && /*#__PURE__*/jsx("div", {
        className: css$1c.iconContainer,
        children: icon
      }), /*#__PURE__*/jsx("input", {
        type: type,
        value: value,
        onChange: handleChange,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        name: name,
        autoFocus: autoFocus,
        autoComplete: autoComplete ? 'on' : 'off',
        onKeyDown: onKeyDown,
        maxLength: maxLength,
        className: `${css$1c.input} ${error ? css$1c.error : ''} ${icon ? css$1c.hasIcon : ''} ${size === 'small' ? css$1c.small : ''}`,
        "data-error": !!error
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$1c.errorMessage,
      children: error
    })]
  });
};
InputText.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  type: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func,
  size: PropTypes.oneOf(['small']),
  maxLength: PropTypes.number
};

const HotelSwitcher = ({
  onClose,
  fetchHotels,
  onSwitchHotel,
  showAllHotelsButton = false,
  onAllHotelsClick,
  className = '',
  currentUser,
  linkTo,
  navigate,
  posthog,
  additionalSection
}) => {
  const [queryString, setQueryString] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);
  const [results, setResults] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  useEffect(() => {
    initHotelsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const delayTimeout = setTimeout(() => {
      searchHotels(queryString);
    }, 500);
    return () => clearTimeout(delayTimeout);
    // eslint-disable-next-line
  }, [queryString]);
  const initHotelsList = async () => {
    setShowSpinner(true);
    try {
      const response = await fetchHotels();
      setResults(response.data);
    } catch (error) {
      alert('There was an error while loading hotels list.');
    }
    setShowSpinner(false);
  };
  const handleSwitchHotel = async hotel => {
    try {
      await onSwitchHotel(hotel);
      onClose();
    } catch (error) {
      console.log(error);
      alert('There was an error while switching hotel.');
    }
  };
  const searchHotels = async searchQuery => {
    if (searchQuery.length < 3) {
      return;
    }
    setShowSpinner(true);
    try {
      const response = await fetchHotels(searchQuery);
      setResults(response.data);
    } catch (error) {
      alert('There was an error while loading hotels list.');
    }
    setShowSpinner(false);
  };
  const handleKeyDown = e => {
    if (e.key === 'Escape') {
      onClose();
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (results && results.length > 0) {
        setSelectedIndex(prevIndex => prevIndex < results.length - 1 ? prevIndex + 1 : prevIndex);
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (results && results.length > 0) {
        setSelectedIndex(prevIndex => prevIndex > 0 ? prevIndex - 1 : 0);
      }
    } else if (e.key === 'Enter' && selectedIndex >= 0 && results.length > 0) {
      e.preventDefault();
      const selectedHotel = results[selectedIndex];
      handleSwitchHotel(selectedHotel);
    }
  };
  const handleChange = e => {
    setQueryString(e.target.value);
    setSelectedIndex(-1);
    if (!e.target.value) {
      setResults(null);
    }
  };
  const handleCreateHotel = () => {
    posthog.capture('hotel_switcher:create_hotel_click');
    navigate('/hotels/create');
    onClose();
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1d.hotelSwitcher} ${className}`,
    children: [/*#__PURE__*/jsx("div", {
      className: css$1d.closeButton,
      onClick: onClose,
      children: /*#__PURE__*/jsx(X02, {
        width: 20,
        color: "white"
      })
    }), /*#__PURE__*/jsxs("div", {
      className: css$1d.hotelSwitcherContent,
      children: [showAllHotelsButton && /*#__PURE__*/jsxs("div", {
        className: css$1d.checkAllSection,
        children: [/*#__PURE__*/jsx(Button$1, {
          variant: "tertiary",
          className: css$1d.checkAllButton,
          onClick: onAllHotelsClick,
          children: "Check All Hotels"
        }), /*#__PURE__*/jsx("div", {
          className: css$1d.separator,
          children: /*#__PURE__*/jsx("span", {
            children: "or"
          })
        })]
      }), /*#__PURE__*/jsx(PageTitle, {
        icon: /*#__PURE__*/jsx(Home02, {
          color: "white"
        }),
        align: "center",
        children: "Switch Hotel"
      }), currentUser?.role === userRoles.RESELLER && /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(Button$1, {
          variant: "tertiary",
          size: "small",
          icon: /*#__PURE__*/jsx(Plus01, {}),
          onClick: handleCreateHotel,
          children: "Create Hotel"
        })
      }), /*#__PURE__*/jsx("div", {
        className: css$1d.searchInputWrapper,
        children: /*#__PURE__*/jsx(InputText, {
          autoFocus: true,
          placeholder: "Search Hotel",
          autoComplete: false,
          onChange: handleChange,
          onKeyDown: handleKeyDown,
          value: queryString,
          icon: /*#__PURE__*/jsx(Search01, {
            color: "var(--primary-color)"
          }),
          name: "hotel"
        })
      }), /*#__PURE__*/jsx("div", {
        className: css$1d.searchBoxContainer,
        children: /*#__PURE__*/jsxs("div", {
          className: css$1d.resultsWrapper,
          children: [showSpinner && /*#__PURE__*/jsx("div", {
            className: css$1d.spinnerWrapper,
            children: /*#__PURE__*/jsx(InlineLoading, {})
          }), /*#__PURE__*/jsxs(Fragment$1, {
            children: [results !== null && /*#__PURE__*/jsx(Fragment$1, {
              children: /*#__PURE__*/jsxs("h6", {
                className: css$1d.resultsCount,
                children: [/*#__PURE__*/jsx(Search01, {
                  width: 20
                }), results.length, " results found"]
              })
            }), /*#__PURE__*/jsxs("div", {
              className: css$1d.fullscreenResults,
              children: [/*#__PURE__*/jsx("ul", {
                children: results?.map((hotel, index) => {
                  let nameWithId = hotel.id > 0 ? `${hotel.name} - #${hotel.id}` : hotel.name;
                  return /*#__PURE__*/jsxs("li", {
                    onClick: () => handleSwitchHotel(hotel),
                    className: selectedIndex === index ? css$1d.selectedResult : '',
                    children: [/*#__PURE__*/jsx(ArrowSwitchHorizontal, {
                      color: "var(--primary-color)",
                      width: 25
                    }), /*#__PURE__*/jsx("span", {
                      dangerouslySetInnerHTML: {
                        __html: nameWithId
                      }
                    })]
                  }, hotel.id);
                })
              }), additionalSection]
            })]
          })]
        })
      })]
    })]
  });
};

var css_248z$1d = ".Table-module__table___-ZPCW{background-color:#fff;border-collapse:separate;border-spacing:0;color:var(--text);font-size:var(--body-regular-size);width:100%}.Table-module__table___-ZPCW.Table-module__tableResizable___TVK-a td,.Table-module__table___-ZPCW.Table-module__tableResizable___TVK-a th{border-right:1px solid var(--bg-dark)}.Table-module__table___-ZPCW.Table-module__tableResizable___TVK-a td:last-child,.Table-module__table___-ZPCW.Table-module__tableResizable___TVK-a th:last-child{border-right:0}.Table-module__table___-ZPCW.Table-module__tableFixed___vX48w{table-layout:fixed}.Table-module__table___-ZPCW.Table-module__tableFixed___vX48w td{overflow:hidden;text-overflow:ellipsis}.Table-module__table___-ZPCW.Table-module__align-left___79BzX td,.Table-module__table___-ZPCW.Table-module__align-left___79BzX th{text-align:left}.Table-module__table___-ZPCW.Table-module__align-center___LveTg td,.Table-module__table___-ZPCW.Table-module__align-center___LveTg th{text-align:center}.Table-module__table___-ZPCW.Table-module__align-right___HF6tw td,.Table-module__table___-ZPCW.Table-module__align-right___HF6tw th{text-align:right}.Table-module__table___-ZPCW thead svg{height:18px;width:18px}.Table-module__table___-ZPCW .Table-module__th___Su2vG{background-color:var(--white);border:0;border-bottom:1px solid var(--bg-dark)!important;color:var(--grey-64);font-size:var(--label-size);font-weight:var(--label-weight);line-height:var(--label-line-height);padding:14px!important;position:relative;text-transform:uppercase}.Table-module__table___-ZPCW .Table-module__th___Su2vG.Table-module__thSortable___IJTX7>svg{height:14px;margin-bottom:-1px;margin-left:3px;width:14px}.Table-module__table___-ZPCW .Table-module__th___Su2vG.Table-module__thResizable___Lf8lC{overflow:hidden}.Table-module__table___-ZPCW .Table-module__td___SH5q-{border-bottom:1px solid var(--bg-dark);padding:14px;transition:background .2s;vertical-align:middle}.Table-module__table___-ZPCW .Table-module__td___SH5q- svg{cursor:pointer;height:18px;width:18px}.Table-module__table___-ZPCW.Table-module__valign-top___p-gH- .Table-module__td___SH5q-{vertical-align:top}.Table-module__table___-ZPCW.Table-module__valign-bottom___969qw .Table-module__td___SH5q-{vertical-align:bottom}.Table-module__table___-ZPCW.Table-module__compact___2-UWr .Table-module__th___Su2vG{padding:5px!important}.Table-module__table___-ZPCW.Table-module__compact___2-UWr .Table-module__td___SH5q-{padding:5px}.Table-module__table___-ZPCW tbody tr{transition:background .2s}.Table-module__table___-ZPCW tbody tr:hover{background:var(--bg-light-48)}.Table-module__table___-ZPCW tbody tr:hover .Table-module__td___SH5q-.Table-module__sticky___lZPYH{background-color:var(--bg-light-48)}.Table-module__table___-ZPCW tbody tr.Table-module__invalidRow___yUz-P,.Table-module__table___-ZPCW tbody tr.Table-module__invalidRow___yUz-P .Table-module__td___SH5q-.Table-module__sticky___lZPYH{background-color:var(--danger-10)}.Table-module__table___-ZPCW tbody tr.Table-module__selectedRow___5M8Oj,.Table-module__table___-ZPCW tbody tr.Table-module__selectedRow___5M8Oj .Table-module__td___SH5q-.Table-module__sticky___lZPYH{background-color:var(--primary-10)}.Table-module__table___-ZPCW tbody tr.Table-module__clickableRow___9Z26-{cursor:pointer}.Table-module__table___-ZPCW .Table-module__td___SH5q-.Table-module__sticky___lZPYH,.Table-module__table___-ZPCW .Table-module__th___Su2vG.Table-module__sticky___lZPYH{background-color:var(--white);position:sticky;z-index:2}.Table-module__table___-ZPCW .Table-module__th___Su2vG.Table-module__sticky___lZPYH{z-index:3}.Table-module__scrollableTableWrapper___XagKt{overflow-x:auto;width:100%}@media (max-width:768px){.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO{display:block}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO thead{display:none}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO tbody{display:block}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO tr{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);display:block;margin-bottom:12px;padding:4px 0}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO .Table-module__td___SH5q-{align-items:center;border-bottom:1px solid var(--bg-light-80);display:flex;flex-wrap:wrap;gap:4px 12px;justify-content:space-between;margin:0 6px;padding:9px 8px;text-align:left!important}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO .Table-module__td___SH5q-:last-child{border-bottom:0}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO .Table-module__td___SH5q-:before{color:var(--grey-64);content:attr(data-label);flex-shrink:0;font-size:var(--label-size);font-weight:var(--label-weight);text-transform:uppercase}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO .Table-module__td___SH5q-:not([data-label]){display:block}.Table-module__table___-ZPCW.Table-module__tableSections___RRkdO .Table-module__td___SH5q-:not([data-label]):before{content:none}}.Table-module__resizeHandle___fw38d{cursor:col-resize;height:100%;position:absolute;right:0;top:0;transition:background-color .15s ease;user-select:none;width:6px;z-index:1}.Table-module__resizeHandle___fw38d:active,.Table-module__resizeHandle___fw38d:hover{background-color:var(--primary-color);opacity:.4}";
var css$1b = {"table":"Table-module__table___-ZPCW","tableResizable":"Table-module__tableResizable___TVK-a","tableFixed":"Table-module__tableFixed___vX48w","align-left":"Table-module__align-left___79BzX","align-center":"Table-module__align-center___LveTg","align-right":"Table-module__align-right___HF6tw","th":"Table-module__th___Su2vG","thSortable":"Table-module__thSortable___IJTX7","thResizable":"Table-module__thResizable___Lf8lC","td":"Table-module__td___SH5q-","valign-top":"Table-module__valign-top___p-gH-","valign-bottom":"Table-module__valign-bottom___969qw","compact":"Table-module__compact___2-UWr","sticky":"Table-module__sticky___lZPYH","invalidRow":"Table-module__invalidRow___yUz-P","selectedRow":"Table-module__selectedRow___5M8Oj","clickableRow":"Table-module__clickableRow___9Z26-","scrollableTableWrapper":"Table-module__scrollableTableWrapper___XagKt","tableSections":"Table-module__tableSections___RRkdO","resizeHandle":"Table-module__resizeHandle___fw38d"};
styleInject(css_248z$1d);

const TableContext = /*#__PURE__*/createContext$1({
  cellAlign: 'left',
  storageKey: undefined,
  columnWidths: {},
  setColumnWidth: () => {},
  setColumnWidths: () => {},
  ensureColumnsMeasured: () => {},
  headerLabels: [],
  mobileSections: false
});
const useTableContext = () => useContext(TableContext);
const TableProvider = ({
  cellAlign,
  storageKey,
  columnIds,
  fixedColumnWidths,
  tableRef,
  headerLabels = [],
  mobileSections = false,
  children
}) => {
  const [columnWidths, setColumnWidthsState] = useState(() => {
    if (!storageKey) {
      return {};
    }
    try {
      const stored = localStorage.getItem(storageKey);
      return stored ? JSON.parse(stored) : {};
    } catch {
      return {};
    }
  });
  const persist = useCallback(widths => {
    if (!storageKey) {
      return;
    }
    try {
      localStorage.setItem(storageKey, JSON.stringify(widths));
    } catch {
      // ignore
    }
  }, [storageKey]);
  const setColumnWidth = useCallback((columnId, width, shouldPersist = false) => {
    setColumnWidthsState(prev => {
      const next = {
        ...prev,
        [columnId]: width
      };
      if (shouldPersist) {
        persist(next);
      }
      return next;
    });
  }, [persist]);
  const setColumnWidths = useCallback((updates, shouldPersist = false) => {
    setColumnWidthsState(prev => {
      const next = {
        ...prev,
        ...updates
      };
      if (shouldPersist) {
        persist(next);
      }
      return next;
    });
  }, [persist]);
  const ensureColumnsMeasured = useCallback(() => {
    if (!columnIds || columnIds.length === 0 || !tableRef?.current) {
      return;
    }
    const measured = {};
    columnIds.forEach(id => {
      if (fixedColumnWidths && fixedColumnWidths[id] !== undefined) {
        return;
      }
      if (columnWidths[id] !== undefined) {
        return;
      }
      const th = tableRef.current.querySelector(`th[data-column-id="${id}"]`);
      if (th) {
        measured[id] = Math.round(th.getBoundingClientRect().width);
      }
    });
    if (Object.keys(measured).length > 0) {
      setColumnWidthsState(prev => ({
        ...prev,
        ...measured
      }));
    }
  }, [columnIds, columnWidths, tableRef, fixedColumnWidths]);
  return /*#__PURE__*/jsx(TableContext.Provider, {
    value: {
      cellAlign,
      storageKey,
      columnWidths,
      setColumnWidth,
      setColumnWidths,
      ensureColumnsMeasured,
      headerLabels,
      mobileSections
    },
    children: children
  });
};
TableProvider.propTypes = {
  cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
  storageKey: PropTypes.string,
  columnIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  fixedColumnWidths: PropTypes.object,
  tableRef: PropTypes.shape({
    current: PropTypes.any
  }),
  headerLabels: PropTypes.arrayOf(PropTypes.string),
  mobileSections: PropTypes.bool,
  children: PropTypes.node
};

const TableHead = ({
  children
}) => /*#__PURE__*/jsx("thead", {
  children: children
});

const TableRow = ({
  children,
  className = '',
  isInvalid,
  isSelected = false,
  draggable,
  onDragStart,
  onDragEnter,
  onDragEnd,
  onDragLeave,
  onDragOver,
  style,
  ...props
}) => {
  const {
    headerLabels,
    mobileSections
  } = useTableContext();
  const isClickable = props.onClick ?? false;
  let classes = className;
  if (isInvalid) {
    classes += ' ' + css$1b.invalidRow;
  }
  if (isSelected) {
    classes += ' ' + css$1b.selectedRow;
  }
  if (isClickable) {
    classes += ' ' + css$1b.clickableRow;
  }
  const labelledChildren = mobileSections && headerLabels.length > 0 ? React.Children.toArray(children).map((child, index) => /*#__PURE__*/React.isValidElement(child) && child.props.mobileLabel === undefined ? /*#__PURE__*/React.cloneElement(child, {
    mobileLabel: headerLabels[index] ?? ''
  }) : child) : children;
  return /*#__PURE__*/jsx("tr", {
    className: classes,
    draggable: draggable,
    onDragStart: onDragStart,
    onDragEnter: onDragEnter,
    onDragEnd: onDragEnd,
    onDragLeave: onDragLeave,
    onDragOver: onDragOver,
    style: style,
    ...props,
    children: labelledChildren
  });
};

const getNodeText = node => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(getNodeText).join('');
  }
  if (/*#__PURE__*/React.isValidElement(node) && node.props?.children !== undefined) {
    return getNodeText(node.props.children);
  }
  return '';
};
const collectHeaderLabels = children => {
  const labels = [];
  const head = React.Children.toArray(children).find(child => /*#__PURE__*/React.isValidElement(child) && child.type === TableHead);
  if (!head) {
    return labels;
  }
  React.Children.toArray(head.props.children).forEach(headChild => {
    if (! /*#__PURE__*/React.isValidElement(headChild)) {
      return;
    }
    if (headChild.type === TableRow) {
      React.Children.toArray(headChild.props.children).forEach(headerCell => {
        if (/*#__PURE__*/React.isValidElement(headerCell)) {
          const colSpan = parseInt(headerCell.props.colSpan, 10) || 1;
          const label = getNodeText(headerCell.props.children).trim();
          for (let i = 0; i < colSpan; i++) {
            labels.push(label);
          }
        }
      });
    } else {
      const colSpan = parseInt(headChild.props.colSpan, 10) || 1;
      const label = getNodeText(headChild.props.children).trim();
      for (let i = 0; i < colSpan; i++) {
        labels.push(label);
      }
    }
  });
  return labels;
};
const TableInner = ({
  children,
  className,
  cellAlign,
  cellVerticalAlign,
  compact,
  style,
  columnIds,
  fixedColumnWidths,
  tableRef,
  mobileSections
}) => {
  const {
    columnWidths
  } = useTableContext();
  const hasColumnIds = columnIds && columnIds.length > 0;
  const resolveWidth = id => {
    if (fixedColumnWidths && fixedColumnWidths[id] !== undefined) {
      return fixedColumnWidths[id];
    }
    return columnWidths[id];
  };
  const allMeasured = hasColumnIds && columnIds.every(id => resolveWidth(id) !== undefined);
  return /*#__PURE__*/jsxs("table", {
    ref: tableRef,
    className: `${css$1b.table} ${css$1b[`align-${cellAlign}`] || ''} ${css$1b[`valign-${cellVerticalAlign}`] || ''} ${compact ? css$1b.compact : ''} ${hasColumnIds ? css$1b.tableResizable : ''} ${allMeasured ? css$1b.tableFixed : ''} ${mobileSections ? css$1b.tableSections : ''} ${className}`.trim(),
    style: style,
    children: [allMeasured && /*#__PURE__*/jsx("colgroup", {
      children: columnIds.map(id => /*#__PURE__*/jsx("col", {
        style: {
          width: `${resolveWidth(id)}px`
        }
      }, id))
    }), children]
  });
};
const Table = ({
  children,
  className = '',
  cellAlign = 'left',
  cellVerticalAlign = 'middle',
  style,
  scrollable = false,
  mobileLayout = 'sections',
  compact = false,
  storageKey,
  columnIds,
  fixedColumnWidths
}) => {
  const tableRef = useRef(null);
  const mobileSections = mobileLayout === 'sections' && !scrollable;
  const headerLabels = mobileSections ? collectHeaderLabels(children) : [];
  const tableElement = /*#__PURE__*/jsx(TableProvider, {
    cellAlign: cellAlign,
    storageKey: storageKey,
    columnIds: columnIds,
    fixedColumnWidths: fixedColumnWidths,
    tableRef: tableRef,
    headerLabels: headerLabels,
    mobileSections: mobileSections,
    children: /*#__PURE__*/jsx(TableInner, {
      className: className,
      cellAlign: cellAlign,
      cellVerticalAlign: cellVerticalAlign,
      compact: compact,
      style: style,
      columnIds: columnIds,
      fixedColumnWidths: fixedColumnWidths,
      tableRef: tableRef,
      mobileSections: mobileSections,
      children: children
    })
  });
  if (scrollable || mobileLayout === 'scroll') {
    return /*#__PURE__*/jsx("div", {
      className: css$1b.scrollableTableWrapper,
      children: tableElement
    });
  }
  return tableElement;
};
Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
  cellVerticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  style: PropTypes.object,
  scrollable: PropTypes.bool,
  mobileLayout: PropTypes.oneOf(['sections', 'scroll']),
  compact: PropTypes.bool,
  storageKey: PropTypes.string,
  columnIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  fixedColumnWidths: PropTypes.object
};
TableInner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  cellAlign: PropTypes.oneOf(['left', 'center', 'right']),
  cellVerticalAlign: PropTypes.oneOf(['top', 'middle', 'bottom']),
  compact: PropTypes.bool,
  style: PropTypes.object,
  columnIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  fixedColumnWidths: PropTypes.object,
  tableRef: PropTypes.shape({
    current: PropTypes.any
  }),
  mobileSections: PropTypes.bool
};

const toPx = value => typeof value === 'number' ? `${value}px` : value;
const buildStickyStyle = ({
  sticky,
  stickyOffset,
  stickyTop,
  stickyRight
}) => {
  if (!sticky) {
    return null;
  }
  const style = {};
  if (stickyOffset != null) {
    style.left = toPx(stickyOffset);
  }
  if (stickyTop != null) {
    style.top = toPx(stickyTop);
  }
  if (stickyRight != null) {
    style.right = toPx(stickyRight);
  }
  // default to left:0 (the original API behavior).
  if (stickyOffset == null && stickyTop == null && stickyRight == null) {
    style.left = 0;
  }
  return style;
};

const TableCell = ({
  children,
  className = '',
  colSpan,
  rowSpan,
  align,
  style,
  sticky = false,
  stickyOffset,
  stickyTop,
  stickyRight,
  mobileLabel
}) => {
  const {
    cellAlign
  } = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const stickyStyle = buildStickyStyle({
    sticky,
    stickyOffset,
    stickyTop,
    stickyRight
  });
  return /*#__PURE__*/jsx("td", {
    "data-label": mobileLabel || undefined,
    className: `${css$1b.td} ${sticky ? css$1b.sticky : ''} ${className}`.trim(),
    style: {
      textAlign: finalAlign,
      ...stickyStyle,
      ...style
    },
    colSpan: colSpan,
    rowSpan: rowSpan,
    children: children
  });
};
TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  style: PropTypes.object,
  sticky: PropTypes.bool,
  stickyOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  mobileLabel: PropTypes.string
};

const MIN_COLUMN_WIDTH = 40;
const ColumnResizeHandle = ({
  columnId
}) => {
  const {
    setColumnWidth,
    ensureColumnsMeasured,
    storageKey
  } = useTableContext();
  const posthog = usePostHog();
  const startXRef = useRef(0);
  const startWidthRef = useRef(0);
  const activeDragRef = useRef(null);
  const stopDrag = useCallback(() => {
    const drag = activeDragRef.current;
    if (!drag) {
      return;
    }
    window.removeEventListener('mousemove', drag.handleMouseMove);
    window.removeEventListener('mouseup', drag.handleMouseUp);
    document.body.style.userSelect = drag.previousUserSelect;
    document.body.style.cursor = drag.previousCursor;
    activeDragRef.current = null;
  }, []);
  useEffect(() => {
    return () => {
      stopDrag();
    };
  }, [stopDrag]);
  const handleMouseDown = useCallback(event => {
    event.preventDefault();
    event.stopPropagation();
    const thElement = event.currentTarget.closest('th');
    if (!thElement) {
      return;
    }
    ensureColumnsMeasured();
    startXRef.current = event.clientX;
    startWidthRef.current = thElement.getBoundingClientRect().width;
    const previousUserSelect = document.body.style.userSelect;
    const previousCursor = document.body.style.cursor;
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
    const computeWidth = clientX => {
      const delta = clientX - startXRef.current;
      return Math.max(MIN_COLUMN_WIDTH, Math.round(startWidthRef.current + delta));
    };
    const handleMouseMove = moveEvent => {
      setColumnWidth(columnId, computeWidth(moveEvent.clientX), false);
    };
    const handleMouseUp = upEvent => {
      const finalWidth = computeWidth(upEvent.clientX);
      setColumnWidth(columnId, finalWidth, true);
      if (posthog && finalWidth !== Math.round(startWidthRef.current)) {
        posthog.capture('table:column_resize', {
          tableKey: storageKey,
          columnId,
          fromWidth: Math.round(startWidthRef.current),
          toWidth: finalWidth
        });
      }
      stopDrag();
    };
    activeDragRef.current = {
      handleMouseMove,
      handleMouseUp,
      previousUserSelect,
      previousCursor
    };
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
  }, [columnId, setColumnWidth, ensureColumnsMeasured, stopDrag, posthog, storageKey]);
  const handleClick = useCallback(event => {
    event.stopPropagation();
  }, []);
  return /*#__PURE__*/jsx("span", {
    className: css$1b.resizeHandle,
    onMouseDown: handleMouseDown,
    onClick: handleClick,
    role: "separator",
    "aria-orientation": "vertical",
    "aria-label": "Resize column"
  });
};
ColumnResizeHandle.propTypes = {
  columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

const TableHeader = ({
  width,
  children,
  style,
  align,
  className = '',
  rowSpan,
  colSpan,
  resizable = false,
  columnId,
  sticky = false,
  stickyOffset,
  stickyTop,
  stickyRight
}) => {
  const {
    cellAlign,
    columnWidths
  } = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const isLeaf = !colSpan || Number(colSpan) <= 1;
  const isResizable = resizable && isLeaf && columnId !== undefined && columnId !== null;
  const storedWidth = columnId !== undefined && columnId !== null ? columnWidths[columnId] : undefined;
  const appliedWidth = storedWidth ?? width;
  const stickyStyle = buildStickyStyle({
    sticky,
    stickyOffset,
    stickyTop,
    stickyRight
  });
  return /*#__PURE__*/jsxs("th", {
    "data-column-id": columnId ?? undefined,
    className: `${css$1b.th} ${isResizable ? css$1b.thResizable : ''} ${sticky ? css$1b.sticky : ''} ${className}`.trim(),
    style: {
      width: appliedWidth ?? undefined,
      textAlign: finalAlign,
      ...stickyStyle,
      ...style
    },
    rowSpan: rowSpan ?? undefined,
    colSpan: colSpan ?? undefined,
    children: [children, isResizable && /*#__PURE__*/jsx(ColumnResizeHandle, {
      columnId: columnId
    })]
  });
};
TableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  resizable: PropTypes.bool,
  columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sticky: PropTypes.bool,
  stickyOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyTop: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stickyRight: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

const DraggableTable = ({
  items = [],
  setItems,
  onSortChange,
  positionKey = 'position',
  isDraggable = true,
  tableHead,
  renderRow,
  children,
  className,
  ...tableProps
}) => {
  const {
    draggedIndex,
    dragOverIndex,
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDragEnd,
    onDragOver
  } = useDragAndDrop(items, setItems, onSortChange, positionKey);
  const dragProps = {
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDragEnd,
    onDragOver
  };
  return /*#__PURE__*/jsxs(Table, {
    ...tableProps,
    className: className,
    children: [tableHead && /*#__PURE__*/jsx(TableHead, {
      children: tableHead
    }), /*#__PURE__*/jsx("tbody", {
      children: renderRow ?
      // Use renderRow function if provided
      items.map((item, index) => {
        const isNewRow = !item.id;
        return renderRow(item, index, {
          ...dragProps,
          isDraggable: isDraggable && !isNewRow,
          isDragged: draggedIndex === index,
          isDragOver: dragOverIndex === index
        });
      }) : children
    })]
  });
};

const DraggableTableRow = ({
  isDraggable = true,
  index,
  isDragged = false,
  isDragOver = false,
  onDragStart,
  onDragEnter,
  onDragLeave,
  onDragEnd,
  onDragOver,
  children,
  ...rowProps
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const dragHandleRef = useRef(null);
  const handleDragStart = e => {
    if (dragHandleRef.current) {
      const rect = dragHandleRef.current.getBoundingClientRect();
      const dragImage = dragHandleRef.current.cloneNode(true);
      dragImage.style.position = 'absolute';
      dragImage.style.top = '-1000px';
      dragImage.style.left = '-1000px';
      dragImage.style.opacity = '0.8';
      dragImage.style.transform = 'rotate(5deg)';
      dragImage.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, rect.width / 2, rect.height / 2);
      setTimeout(() => {
        if (document.body.contains(dragImage)) {
          document.body.removeChild(dragImage);
        }
      }, 100);
    }
    onDragStart(index);
  };
  const getRowContentStyles = () => {
    const baseStyles = {
      transition: 'all 0.2s ease-in-out'
    };
    if (isDragged) {
      return {
        ...baseStyles,
        opacity: 0.3,
        transform: 'scale(0.98)',
        backgroundColor: colors$1.primary10
      };
    }
    if (isHovered && isDraggable) {
      return {
        ...baseStyles,
        backgroundColor: colors$1.bgLight80,
        transform: 'translateY(-1px)'
      };
    }
    return baseStyles;
  };
  const getDragHandleStyles = () => ({
    userSelect: 'none',
    fontSize: 18,
    display: 'inline-flex',
    alignItems: 'center',
    padding: '6px',
    borderRadius: '6px',
    transition: 'all 0.15s ease-in-out',
    color: isDraggable ? colors$1.primary50 : colors$1.grey20,
    opacity: isDraggable ? isHovered || isDragged ? 1 : 0.7 : 0.3,
    transform: isDraggable && (isHovered || isDragged) ? 'scale(1.15)' : 'scale(1)',
    backgroundColor: isDragged ? colors$1.primary10 : 'transparent',
    boxShadow: isDragged ? '0 2px 8px rgba(0, 0, 0, 0.15)' : 'none',
    cursor: isDraggable ? isDragged ? 'grabbing' : 'grab' : 'default'
  });
  return /*#__PURE__*/jsx(TableRow, {
    draggable: isDraggable,
    style: isDragOver ? {
      backgroundColor: colors$1.primary10,
      transition: 'all 0.2s ease-in-out'
    } : {
      cursor: 'grab'
    },
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    onDragStart: e => {
      e.stopPropagation();
      handleDragStart(e);
    },
    onDragEnter: e => {
      e.stopPropagation();
      onDragEnter(index, isDraggable);
    },
    onDragEnd: e => {
      e.stopPropagation();
      onDragEnd();
    },
    onDragLeave: e => {
      e.stopPropagation();
      if (onDragLeave) onDragLeave(index);
    },
    onDragOver: e => {
      e.preventDefault();
      e.stopPropagation();
      if (onDragOver) onDragOver(e, index, isDraggable);
    },
    ...rowProps,
    children: React.Children.map(children, (child, childIndex) => {
      const content = /*#__PURE__*/jsxs("div", {
        style: {
          ...getRowContentStyles(),
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        },
        children: [childIndex === 0 && isDraggable && /*#__PURE__*/jsx("span", {
          ref: dragHandleRef,
          style: getDragHandleStyles(),
          title: "Drag to reorder",
          children: /*#__PURE__*/jsx(ArrowSwitchVertical, {})
        }), child.props.children, childIndex === 0 && isDragOver && /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx("div", {
            style: {
              position: 'absolute',
              top: '-2px',
              left: 0,
              right: 0,
              height: '4px',
              backgroundColor: colors$1.primary50,
              borderRadius: '2px',
              boxShadow: '0 0 8px rgba(0, 0, 0, 0.2)',
              zIndex: 15,
              animation: 'dropIndicator 0.3s ease-out'
            }
          }), /*#__PURE__*/jsx("div", {
            style: {
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: colors$1.primary10,
              border: `2px dashed ${colors$1.primary50}`,
              borderRadius: '4px',
              zIndex: 1,
              animation: 'dropZone 0.3s ease-out'
            }
          })]
        })]
      });
      return /*#__PURE__*/React.cloneElement(child, {
        children: content
      });
    })
  });
};

const TableSortableHeader = ({
  width,
  children,
  style,
  sortable,
  onSortColumn,
  index,
  align,
  className = '',
  rowSpan,
  colSpan,
  resizable = false,
  columnId
}) => {
  const {
    cellAlign,
    columnWidths
  } = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';
  const isLeaf = !colSpan || Number(colSpan) <= 1;
  const isResizable = resizable && isLeaf && columnId !== undefined && columnId !== null;
  const storedWidth = columnId !== undefined && columnId !== null ? columnWidths[columnId] : undefined;
  const appliedWidth = storedWidth ?? width;
  const handleClick = () => {
    if (sortable) {
      onSortColumn(index);
    }
  };
  return /*#__PURE__*/jsxs("th", {
    "data-column-id": columnId ?? undefined,
    className: `${css$1b.th} ${sortable ? css$1b.thSortable : ''} ${isResizable ? css$1b.thResizable : ''} ${className}`.trim(),
    style: {
      width: appliedWidth ?? undefined,
      cursor: sortable ? 'pointer' : 'default',
      textAlign: finalAlign,
      ...style
    },
    onClick: sortable ? handleClick : undefined,
    rowSpan: rowSpan,
    colSpan: colSpan,
    children: [children, sortable && /*#__PURE__*/jsx(SortVertical01, {}), isResizable && /*#__PURE__*/jsx(ColumnResizeHandle, {
      columnId: columnId
    })]
  });
};
TableSortableHeader.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
  className: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  rowSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  colSpan: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sortable: PropTypes.bool,
  onSortColumn: PropTypes.func,
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  resizable: PropTypes.bool,
  columnId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var css_248z$1c = ".SidePanel-module__overlay___GWzAA{background:none;display:flex;height:100vh;justify-content:flex-end;left:0;position:fixed;right:0;top:66px;z-index:99}.SidePanel-module__overlay___GWzAA.SidePanel-module__leftPanel___egtBb{justify-content:flex-start!important}.SidePanel-module__overlay___GWzAA.SidePanel-module__overlayPassThrough___VlqIr{pointer-events:none}.SidePanel-module__overlay___GWzAA .SidePanel-module__panel___dXpZx{background:var(--white);box-shadow:0 0 15px var(--grey-8);display:flex;flex-direction:column;height:100vh;overflow-y:auto;padding:20px 20px 120px;position:relative;width:540px}.SidePanel-module__overlay___GWzAA .SidePanel-module__panel___dXpZx.SidePanel-module__panelPassThrough___EEmA2{pointer-events:auto}.SidePanel-module__overlay___GWzAA .SidePanel-module__panel___dXpZx .SidePanel-module__title___OhRr-{color:var(--primary-color);margin:0 0 24px;padding-right:30px;text-align:left}.SidePanel-module__overlay___GWzAA .SidePanel-module__panel___dXpZx .SidePanel-module__closeBtn___EYJ-L{background:none;border:none;border-radius:var(--border-radius-small);color:var(--grey-64);cursor:pointer;padding:3px 5px;position:absolute;right:20px;top:20px;width:25px;z-index:10}.SidePanel-module__overlay___GWzAA .SidePanel-module__panel___dXpZx .SidePanel-module__closeBtn___EYJ-L:hover{background-color:var(--bg-dark);transition:all .3s}";
var css$1a = {"overlay":"SidePanel-module__overlay___GWzAA","leftPanel":"SidePanel-module__leftPanel___egtBb","overlayPassThrough":"SidePanel-module__overlayPassThrough___VlqIr","panel":"SidePanel-module__panel___dXpZx","panelPassThrough":"SidePanel-module__panelPassThrough___EEmA2","title":"SidePanel-module__title___OhRr-","closeBtn":"SidePanel-module__closeBtn___EYJ-L"};
styleInject(css_248z$1c);

const SidePanel = ({
  open,
  onClose,
  title,
  width,
  children,
  className,
  position = 'right',
  leftOffset,
  autoLeftOffset = true,
  collapsedWidth = 70,
  expandedWidth = 250,
  zIndex = 99,
  topOffset,
  closeOnOverlayClick = true,
  closeOnOverlayClickExceptOn
}) => {
  // Automatically calculate left offset when position is 'left' and no explicit offset is provided
  const autoLeftOffsetValue = useSidePanelLeftOffset({
    enabled: position === 'left' && autoLeftOffset && leftOffset === undefined,
    collapsedWidth,
    expandedWidth
  });
  const useDocumentListener = Boolean(closeOnOverlayClickExceptOn) && closeOnOverlayClick;
  const isPassThrough = !closeOnOverlayClick || useDocumentListener;
  const panelRef = useRef(null);
  useEffect(() => {
    if (!open || !useDocumentListener) {
      return undefined;
    }
    const handleDocumentMouseDown = event => {
      if (!panelRef.current || panelRef.current.contains(event.target)) {
        return;
      }
      if (event.target.closest && event.target.closest(closeOnOverlayClickExceptOn)) {
        return;
      }
      onClose();
    };
    document.addEventListener('mousedown', handleDocumentMouseDown);
    return () => document.removeEventListener('mousedown', handleDocumentMouseDown);
  }, [open, useDocumentListener, closeOnOverlayClickExceptOn, onClose]);
  if (!open) {
    return null;
  }

  // Use explicit offset if provided, otherwise use auto-calculated offset
  const resolvedLeftOffset = leftOffset !== undefined ? leftOffset : autoLeftOffsetValue;
  const positionStyle = position === 'left' ? resolvedLeftOffset !== undefined ? {
    left: `${resolvedLeftOffset}px`,
    transition: 'left 0.3s ease'
  } : {
    left: '0px'
  } : {};
  const overlayStyle = {
    ...positionStyle,
    zIndex
  };
  if (topOffset !== undefined) {
    overlayStyle.top = `${topOffset}px`;
  }
  const overlayClassName = [css$1a.overlay, position === 'left' ? css$1a.leftPanel : '', isPassThrough ? css$1a.overlayPassThrough : ''].filter(Boolean).join(' ');
  const panelClassName = [css$1a.panel, className, isPassThrough ? css$1a.panelPassThrough : ''].filter(Boolean).join(' ');
  return /*#__PURE__*/jsx("div", {
    className: overlayClassName,
    style: overlayStyle,
    onClick: closeOnOverlayClick && !useDocumentListener ? onClose : undefined,
    children: /*#__PURE__*/jsxs("div", {
      ref: panelRef,
      className: panelClassName,
      style: {
        width: width ?? undefined
      },
      onClick: event => event.stopPropagation(),
      children: [/*#__PURE__*/jsx("button", {
        className: css$1a.closeBtn,
        onClick: onClose,
        "aria-label": "Close panel",
        children: /*#__PURE__*/jsx(X02, {
          color: colors$1.primaryColor,
          width: 12,
          height: 12
        })
      }), title && /*#__PURE__*/jsx("h2", {
        className: css$1a.title,
        children: title
      }), children]
    })
  });
};

var css_248z$1b = ".LineTabs-module__tabsWrapper___MTpRl{margin-bottom:15px;position:relative;width:100%}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa{border-bottom:2px solid var(--bg-dark);display:flex;overflow:auto;position:relative}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang{align-items:center;background:none;border:none;color:var(--primary-20);cursor:pointer;display:inline-flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);outline:none;padding:10px 25px;position:relative;text-align:left;text-transform:uppercase;transition:color .2s}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang .LineTabs-module__badge___IB5eD{align-items:center;background-color:var(--primary-20);border-radius:50px;box-sizing:border-box;color:#fff;display:inline-flex;font-size:var(--body-xxs-size);font-weight:var(--body-xxs-weight);height:20px;justify-content:center;line-height:var(--body-xxs-line-height);margin-left:10px;min-width:20px;padding:0 6px}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang .LineTabs-module__badge___IB5eD.LineTabs-module__hasCount___PvAWo{background-color:var(--danger)}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang.LineTabs-module__active___WLyTc{color:var(--primary-color)}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang.LineTabs-module__active___WLyTc .LineTabs-module__badge___IB5eD{background:var(--primary-color);color:#fff}.LineTabs-module__tabsWrapper___MTpRl .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang.LineTabs-module__active___WLyTc .LineTabs-module__badge___IB5eD.LineTabs-module__hasCount___PvAWo{background-color:var(--danger)}.LineTabs-module__tabsWrapper___MTpRl.LineTabs-module__fullWidth___hMKMm .LineTabs-module__tabs___ugvEa .LineTabs-module__tab___Vcang{flex:1;justify-content:center;min-width:max-content;text-align:center}.LineTabs-module__disabled___CgFq1{color:var(--grey-20);cursor:not-allowed}.LineTabs-module__icon___3H3iT{display:flex;margin-right:.5em}.LineTabs-module__underline___xzTi0{background:var(--primary-color);border-radius:1px;bottom:0;height:2px;position:absolute;transition:all .2s cubic-bezier(.4,0,.2,1);will-change:left,width}";
var css$19 = {"tabsWrapper":"LineTabs-module__tabsWrapper___MTpRl","tabs":"LineTabs-module__tabs___ugvEa","tab":"LineTabs-module__tab___Vcang","badge":"LineTabs-module__badge___IB5eD","hasCount":"LineTabs-module__hasCount___PvAWo","active":"LineTabs-module__active___WLyTc","fullWidth":"LineTabs-module__fullWidth___hMKMm","disabled":"LineTabs-module__disabled___CgFq1","icon":"LineTabs-module__icon___3H3iT","underline":"LineTabs-module__underline___xzTi0"};
styleInject(css_248z$1b);

const LineTabs = ({
  children,
  fullWidth = false
}) => {
  const [underlineStyle, setUnderlineStyle] = useState({});
  const tabsRef = useRef([]);

  // Only keep valid React elements (skip null/false from conditional rendering)
  const validChildren = React.Children.toArray(children).filter(child => /*#__PURE__*/React.isValidElement(child));

  // Find the active tab index for underline positioning
  const activeTabIndex = validChildren.findIndex(child => child.props.active);
  useEffect(() => {
    if (activeTabIndex >= 0 && tabsRef.current[activeTabIndex]) {
      const activeTab = tabsRef.current[activeTabIndex];
      const rect = activeTab.getBoundingClientRect();
      const parentRect = activeTab.parentElement.getBoundingClientRect();
      setUnderlineStyle({
        left: rect.left - parentRect.left,
        width: rect.width,
        transition: 'all 0.2s ease'
      });
    }
  }, [activeTabIndex, validChildren.length]);
  const childrenWithProps = validChildren.map((child, index) => /*#__PURE__*/React.cloneElement(child, {
    ref: el => tabsRef.current[index] = el
  }));
  return /*#__PURE__*/jsxs("div", {
    className: `${css$19.tabsWrapper} ${fullWidth ? css$19.fullWidth : ''}`,
    children: [/*#__PURE__*/jsx("div", {
      className: css$19.tabs,
      children: childrenWithProps
    }), /*#__PURE__*/jsx("div", {
      className: css$19.underline,
      style: underlineStyle
    })]
  });
};
LineTabs.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidth: PropTypes.bool
};

const LineTabItem = /*#__PURE__*/forwardRef(({
  label,
  icon,
  count,
  disabled,
  active,
  onClick
}, ref) => /*#__PURE__*/jsxs("button", {
  ref: ref,
  className: `${css$19.tab} ${active ? css$19.active : ''} ${disabled ? css$19.disabled : ''}`,
  disabled: disabled,
  onClick: () => !disabled && onClick && onClick(),
  type: "button",
  children: [icon && /*#__PURE__*/jsx("span", {
    className: css$19.icon,
    children: icon
  }), label && /*#__PURE__*/jsx("span", {
    children: label
  }), typeof count === 'number' && /*#__PURE__*/jsx("span", {
    className: `${css$19.badge} ${count > 0 ? css$19.hasCount : ''}`,
    children: count
  })]
}));
LineTabItem.displayName = 'LineTabItem';

var css_248z$1a = ".Label-module__label___meqL2.Label-module__tertiary___14C-B{border:1px solid var(--grey-20)}.Label-module__label___meqL2{align-items:center;border-radius:var(--border-radius-small);display:inline-flex;font-size:var(--label-size);font-weight:var(--label-weight);line-height:var(--label-line-height);padding:5px 10px;text-transform:uppercase;width:max-content}.Label-module__label___meqL2 .Label-module__labelIcon___-abdv{align-items:center;display:flex}.Label-module__label___meqL2 .Label-module__labelIcon___-abdv svg{height:auto;width:auto}.Label-module__label___meqL2 .Label-module__badge___rjG7r{align-items:center;border-radius:11px;display:inline-flex;font-size:14px;font-weight:500;height:22px;justify-content:center;margin-left:8px;min-width:22px;padding:0 6px}";
var css$18 = {"label":"Label-module__label___meqL2","tertiary":"Label-module__tertiary___14C-B","labelIcon":"Label-module__labelIcon___-abdv","badge":"Label-module__badge___rjG7r"};
styleInject(css_248z$1a);

const iconStyles = {
  marginRight: 8
};
const iconStylesRight = {
  marginLeft: 8,
  order: 1
};
const Label = ({
  variant = '',
  size = null,
  color = '#333',
  backgroundColor = '#eee',
  className,
  count,
  icon,
  iconPosition = 'left',
  iconColor,
  iconOnClick,
  badgeColor = 'white',
  badgeBackgroundColor,
  children,
  onClick,
  style = {}
}) => {
  // Size mapping - only applied when size is explicitly set
  const sizeStyles = {
    sm: {
      minWidth: '16px',
      height: '16px',
      padding: '0 4px',
      fontSize: '10px'
    },
    md: {
      minWidth: '20px',
      height: '20px',
      padding: '0 6px',
      fontSize: 'var(--body-xs-size)'
    },
    lg: {
      minWidth: '24px',
      height: '24px',
      padding: '0 8px',
      fontSize: '12px'
    }
  };
  if (variant === 'success') {
    color = colors$1.success;
    backgroundColor = colors$1.success20;
  } else if (variant === 'warning') {
    color = colors$1.warning;
    backgroundColor = colors$1.warning10;
  } else if (variant === 'danger') {
    color = colors$1.danger;
    backgroundColor = colors$1.danger20;
  } else if (variant === 'disabled') {
    color = colors$1.grey;
    backgroundColor = colors$1.disabled;
  } else if (variant === 'tertiary') {
    color = colors$1.text;
    backgroundColor = colors$1.white;
    className = className ?? css$18.tertiary;
  }
  return /*#__PURE__*/jsxs("span", {
    className: `${css$18.label} ${className}`,
    onClick: onClick,
    style: {
      cursor: onClick ? 'pointer' : null,
      color: color,
      backgroundColor: backgroundColor,
      ...(size && sizeStyles[size] ? sizeStyles[size] : {}),
      ...style
    },
    children: [iconPosition === 'left' && /*#__PURE__*/jsx(LabelIcon, {
      icon: icon,
      color: iconColor || color,
      onClick: iconOnClick,
      position: "left"
    }), /*#__PURE__*/jsx("span", {
      children: children
    }), typeof count === 'number' && /*#__PURE__*/jsx("span", {
      className: css$18.badge,
      style: {
        color: badgeColor || color,
        backgroundColor: badgeBackgroundColor || backgroundColor,
        fontSize: 11
      },
      children: count
    }), iconPosition === 'right' && /*#__PURE__*/jsx(LabelIcon, {
      icon: icon,
      color: iconColor || color,
      onClick: iconOnClick,
      position: "right"
    })]
  });
};
const LabelIcon = ({
  icon,
  color,
  onClick,
  position
}) => {
  if (!icon) return null;
  const IconComponent = icon;
  const iconStyle = position === 'right' ? iconStylesRight : iconStyles;
  return /*#__PURE__*/jsx("span", {
    className: css$18.labelIcon,
    style: {
      ...iconStyle,
      cursor: onClick ? 'pointer' : 'default'
    },
    onClick: e => {
      if (onClick) {
        e.stopPropagation();
        onClick(e);
      }
    },
    children: /*#__PURE__*/jsx(IconComponent, {
      color: color
    })
  });
};
Label.propTypes = {
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'disabled', 'tertiary']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  children: PropTypes.node.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  count: PropTypes.number,
  icon: PropTypes.func,
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconColor: PropTypes.string,
  iconOnClick: PropTypes.func,
  badgeColor: PropTypes.string,
  badgeBackgroundColor: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func
};

var css_248z$19 = ".Tooltip-module__tooltipWrapper___xyvC5{display:inline-block;position:relative}.Tooltip-module__tooltipWrapper___xyvC5:hover .Tooltip-module__tooltipBox___LbL1-{opacity:1;pointer-events:auto}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox___LbL1-{background:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);box-shadow:0 2px 8px 0 rgba(16,30,54,.1);box-sizing:border-box;color:var(--text);filter:drop-shadow(0 2px 8px rgba(16,30,54,.1));font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);opacity:0;padding:10px 15px;pointer-events:none;position:absolute;transition:opacity .18s cubic-bezier(.4,0,.2,1);white-space:pre-line;width:max-content;word-break:break-word;z-index:999}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox___LbL1-:before{border:6px solid transparent;content:\"\";height:0;position:absolute;width:0}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_bottom___h8P4-{left:50%;top:calc(100% + 8px);transform:translateX(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_bottom___h8P4-:before{border-bottom-color:var(--bg-dark);bottom:100%;left:50%;transform:translateX(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_bottom-end___QAi-d{left:auto;right:0;top:calc(100% + 8px);transform:none}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_bottom-end___QAi-d:before{border-bottom-color:var(--bg-dark);bottom:100%;left:auto;right:14px;transform:none}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_top___NzRiY{bottom:calc(100% + 8px);left:50%;transform:translateX(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_top___NzRiY:before{border-top-color:var(--bg-dark);left:50%;top:100%;transform:translateX(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_left___amHKm{right:calc(100% + 8px);top:50%;transform:translateY(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_left___amHKm:before{border-left-color:var(--bg-dark);left:100%;top:50%;transform:translateY(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_right___dAqYf{left:calc(100% + 8px);top:50%;transform:translateY(-50%)}.Tooltip-module__tooltipWrapper___xyvC5 .Tooltip-module__tooltipBox_right___dAqYf:before{border-right-color:var(--bg-dark);right:100%;top:50%;transform:translateY(-50%)}.Tooltip-module__tooltipBoxPortal___IUhhW{box-sizing:border-box;max-width:min(320px,100vw - 24px);position:fixed;white-space:pre-line;width:max-content;word-break:break-word;z-index:999}.Tooltip-module__chartTooltipBox___bJxRc,.Tooltip-module__tooltipBoxPortal___IUhhW{background:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);box-shadow:0 2px 8px 0 rgba(16,30,54,.1);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:10px 15px}";
var styles$k = {"tooltipWrapper":"Tooltip-module__tooltipWrapper___xyvC5","tooltipBox":"Tooltip-module__tooltipBox___LbL1-","tooltipBox_bottom":"Tooltip-module__tooltipBox_bottom___h8P4-","tooltipBox_bottom-end":"Tooltip-module__tooltipBox_bottom-end___QAi-d","tooltipBox_top":"Tooltip-module__tooltipBox_top___NzRiY","tooltipBox_left":"Tooltip-module__tooltipBox_left___amHKm","tooltipBox_right":"Tooltip-module__tooltipBox_right___dAqYf","tooltipBoxPortal":"Tooltip-module__tooltipBoxPortal___IUhhW","chartTooltipBox":"Tooltip-module__chartTooltipBox___bJxRc"};
styleInject(css_248z$19);

const portalPositionStyle = (position, rect) => {
  const centerX = rect.left + rect.width / 2;
  const centerY = rect.top + rect.height / 2;
  switch (position) {
    case 'top':
      return {
        top: rect.top,
        left: centerX,
        transform: 'translate(-50%, calc(-100% - 8px))'
      };
    case 'bottom-end':
      return {
        top: rect.bottom,
        left: rect.right,
        transform: 'translate(-100%, 8px)'
      };
    case 'left':
      return {
        top: centerY,
        left: rect.left,
        transform: 'translate(calc(-100% - 8px), -50%)'
      };
    case 'right':
      return {
        top: centerY,
        left: rect.right,
        transform: 'translate(8px, -50%)'
      };
    case 'bottom':
    default:
      return {
        top: rect.bottom,
        left: centerX,
        transform: 'translate(-50%, 8px)'
      };
  }
};
const Tooltip$1 = ({
  content,
  children,
  position = 'bottom',
  style,
  className,
  show = true,
  keepOnHover = false,
  maxWidth,
  portal = false
}) => {
  const [visible, setVisible] = useState(false);
  const [portalCoords, setPortalCoords] = useState(null);
  const wrapperRef = useRef(null);
  const timeoutRef = useRef();
  const hideTimeoutRef = useRef();
  const showTooltip = () => {
    if (show !== false) {
      clearTimeout(hideTimeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        if (portal && wrapperRef.current) {
          setPortalCoords(portalPositionStyle(position, wrapperRef.current.getBoundingClientRect()));
        }
        setVisible(true);
      }, 100);
    }
  };
  const hideTooltip = () => {
    clearTimeout(timeoutRef.current);
    if (keepOnHover) {
      hideTimeoutRef.current = setTimeout(() => setVisible(false), 100);
    } else {
      setVisible(false);
    }
  };
  const onTooltipEnter = () => {
    if (keepOnHover) {
      clearTimeout(hideTimeoutRef.current);
    }
  };
  const onTooltipLeave = () => {
    if (keepOnHover) {
      setVisible(false);
    }
  };
  useLayoutEffect(() => {
    if (!visible || !portal) {
      return undefined;
    }
    const hide = () => setVisible(false);
    window.addEventListener('scroll', hide, true);
    window.addEventListener('resize', hide);
    return () => {
      window.removeEventListener('scroll', hide, true);
      window.removeEventListener('resize', hide);
    };
  }, [visible, portal]);
  const tooltipBox = /*#__PURE__*/jsx("span", {
    className: `${styles$k.tooltipBox} ${portal ? styles$k.tooltipBoxPortal : styles$k[`tooltipBox_${position}`]}`,
    onMouseEnter: onTooltipEnter,
    onMouseLeave: onTooltipLeave,
    style: portal && portalCoords ? {
      top: portalCoords.top,
      left: portalCoords.left,
      transform: portalCoords.transform,
      ...(maxWidth ? {
        maxWidth
      } : {})
    } : maxWidth ? {
      maxWidth
    } : undefined,
    children: content
  });
  return /*#__PURE__*/jsxs("span", {
    ref: wrapperRef,
    className: `${styles$k.tooltipWrapper} ${className ?? ''}`,
    onMouseEnter: showTooltip,
    onMouseLeave: hideTooltip,
    style: style,
    children: [children, visible && show !== false && (portal ? /*#__PURE__*/createPortal(tooltipBox, document.body) : tooltipBox)]
  });
};

const LabelDelete = ({
  label,
  onDelete,
  style
}) => {
  const labelStyle = {
    maxWidth: '220px',
    ...style
  };
  const textStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'inline-block',
    maxWidth: '180px'
  };
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: label,
    position: "top",
    maxWidth: 260,
    children: /*#__PURE__*/jsx(Label, {
      color: colors$1.primaryColor,
      backgroundColor: colors$1.bgLight80,
      icon: Trash01,
      iconPosition: "right",
      iconColor: colors$1.danger,
      iconOnClick: () => onDelete(label),
      style: labelStyle,
      children: /*#__PURE__*/jsx("span", {
        style: textStyle,
        children: label
      })
    })
  });
};

var css_248z$18 = ".LabelDropdown-module__labelDropdownWrapper___ivtRa{display:inline-block;position:relative}.LabelDropdown-module__dropdownList___N4lzR{background-color:#fff;border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);box-shadow:0 4px 12px rgba(0,0,0,.1);left:0;list-style:none;margin:0;min-width:160px;padding:4px 0;position:absolute;top:calc(100% + 4px);z-index:1000}.LabelDropdown-module__dropdownItem___AE3Mv{color:var(--text);cursor:pointer;font-size:14px;padding:8px 16px;text-align:left;white-space:nowrap}.LabelDropdown-module__dropdownItem___AE3Mv:hover{background-color:var(--grey-8)}.LabelDropdown-module__dropdownItem___AE3Mv:first-child{border-top-left-radius:var(--border-radius-medium);border-top-right-radius:var(--border-radius-medium)}.LabelDropdown-module__dropdownItem___AE3Mv:last-child{border-bottom-left-radius:var(--border-radius-medium);border-bottom-right-radius:var(--border-radius-medium)}";
var css$17 = {"labelDropdownWrapper":"LabelDropdown-module__labelDropdownWrapper___ivtRa","dropdownList":"LabelDropdown-module__dropdownList___N4lzR","dropdownItem":"LabelDropdown-module__dropdownItem___AE3Mv"};
styleInject(css_248z$18);

const LabelDropdown = ({
  dropdownList = [],
  activeLabel,
  className = '',
  onValueChange,
  color,
  backgroundColor,
  variant
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = event => {
      if (isOpen && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  const handleLabelClick = e => {
    e.stopPropagation();
    if (dropdownList && dropdownList.length > 0) {
      setIsOpen(!isOpen);
    }
  };
  const handleOptionClick = item => {
    setIsOpen(false);
    if (onValueChange) {
      onValueChange(item);
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: css$17.labelDropdownWrapper,
    ref: wrapperRef,
    children: [/*#__PURE__*/jsx(Label, {
      className: className,
      onClick: handleLabelClick,
      icon: dropdownList && dropdownList.length > 0 ? () => /*#__PURE__*/jsx(ChevronDown, {
        width: 12,
        height: 12
      }) : null,
      iconPosition: "right",
      style: {
        cursor: dropdownList && dropdownList.length > 0 ? 'pointer' : 'default'
      },
      color: color,
      backgroundColor: backgroundColor,
      variant: variant,
      children: activeLabel
    }), isOpen && dropdownList && dropdownList.length > 0 && /*#__PURE__*/jsx("ul", {
      className: css$17.dropdownList,
      children: dropdownList.map(item => /*#__PURE__*/jsx("li", {
        className: css$17.dropdownItem,
        onClick: () => handleOptionClick(item),
        children: item.label
      }, item.value))
    })]
  });
};
LabelDropdown.propTypes = {
  dropdownList: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })),
  activeLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  onValueChange: PropTypes.func,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'warning', 'danger', 'disabled'])
};

const COLOR_SETS = {
  PRE_ARRIVAL: {
    backgroundColor: colors$1.preArrival10,
    color: colors$1.preArrival
  },
  ON_ARRIVAL: {
    backgroundColor: colors$1.onArrival10,
    color: colors$1.onArrival
  },
  IN_STAY: {
    backgroundColor: colors$1.inStay10,
    color: colors$1.inStay
  },
  DEFAULT: {
    backgroundColor: colors$1.grey20,
    color: colors$1.grey
  },
  SUCCESS: {
    backgroundColor: colors$1.success10,
    color: colors$1.success
  }
};
const TOUCHPOINTS = {
  AT_RESERVATION: {
    code: 'AR',
    label: 'At Reservation',
    program: 'PRE_ARRIVAL'
  },
  RESERVATION_CONFIRMATION: {
    code: 'RCO',
    label: 'Reservation Confirmation',
    program: 'PRE_ARRIVAL'
  },
  PRE_ARRIVAL_UPSELLING: {
    code: 'UP',
    label: 'Pre-arrival Upselling',
    program: 'PRE_ARRIVAL'
  },
  PRE_ARRIVAL_UPSELLING_REMINDER: {
    code: 'UR',
    label: 'Pre-arrival Upselling Reminder',
    program: 'PRE_ARRIVAL'
  },
  PRE_ARRIVAL_CONCIERGE: {
    code: 'CO',
    label: 'Pre-arrival Concierge',
    program: 'PRE_ARRIVAL'
  },
  ALTERNATIVE_UPGRADE: {
    code: 'AU',
    label: 'Alternative Upgrade',
    program: 'PRE_ARRIVAL'
  },
  REGISTRATION_CARD: {
    code: 'RC',
    label: 'Registration Card',
    program: 'PRE_ARRIVAL'
  },
  GUEST_RETARGETING: {
    code: 'GR',
    label: 'Guest Retargeting',
    program: 'PRE_ARRIVAL'
  },
  FRONT_DESK: {
    code: 'OA',
    label: 'On-Arrival',
    program: 'ON_ARRIVAL'
  },
  FIRST_INHOUSE: {
    code: 'IH',
    label: 'In-House',
    program: 'IN_STAY'
  },
  SECOND_INHOUSE: {
    code: 'IH',
    label: 'In-House',
    program: 'IN_STAY'
  },
  THIRD_INHOUSE: {
    code: 'IH',
    label: 'In-House',
    program: 'IN_STAY'
  },
  SPA: {
    code: 'SP',
    label: 'Spa',
    program: 'IN_STAY'
  },
  F_AND_B: {
    code: 'FB',
    label: 'F&B',
    program: 'IN_STAY'
  },
  INHOUSE_EXTRAS: {
    code: 'IH',
    label: 'In-house Extras',
    program: 'IN_STAY'
  },
  HOTEL_DIRECTORY: {
    code: 'HD',
    label: 'Hotel Directory',
    program: 'IN_STAY'
  },
  POST_STAY: {
    code: 'PS',
    label: 'Post-Stay',
    program: 'POST_STAY'
  },
  CANCELLATION: {
    code: 'CA',
    label: 'Cancellation',
    program: ''
  }
};
const toTitleCase = (value = '') => value.toLowerCase().split('_').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
const LabelTouchpoint = ({
  touchpoint,
  variant = 'default'
}) => {
  const normalized = (touchpoint || '').toString().toUpperCase();
  const tp = TOUCHPOINTS[normalized];
  const code = tp?.code || '-';
  const tooltipText = tp?.label || (normalized ? toTitleCase(normalized) : '-');
  let style = tp ? COLOR_SETS[tp.program] : COLOR_SETS.DEFAULT;
  switch (variant) {
    case 'default':
      break;
    case 'success':
      style = COLOR_SETS.SUCCESS;
      break;
    case 'neutral':
      style = COLOR_SETS.DEFAULT;
      break;
  }
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: tooltipText,
    position: "top",
    children: /*#__PURE__*/jsx(Label, {
      style: style,
      children: code
    })
  });
};

const reservationStatus = {
  CONFIRMED: 'CONFIRMED',
  DUE_IN: 'DUE_IN',
  INHOUSE: 'INHOUSE',
  CHECKEDOUT: 'CHECKEDOUT',
  CANCELLED: 'CANCELLED',
  NOSHOW: 'NOSHOW',
  TENTATIVE: 'TENTATIVE',
  DELETED: 'DELETED',
  TRANSFERRED: 'TRANSFERRED'
};
const transactionsStatus = {
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  EXPIRED: 'EXPIRED',
  REPLACED: 'REPLACED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  PENDING: 'PENDING'
};

const STATUS_STYLES = {
  [transactionsStatus.CONFIRMED]: {
    backgroundColor: colors$1.success10,
    color: colors$1.success
  },
  [transactionsStatus.CANCELLED]: {
    backgroundColor: colors$1.danger10,
    color: colors$1.danger
  },
  [transactionsStatus.EXPIRED]: {
    backgroundColor: colors$1.grey8,
    color: colors$1.grey
  },
  [transactionsStatus.REPLACED]: {
    backgroundColor: colors$1.warning10,
    color: colors$1.warning
  },
  [transactionsStatus.REJECTED]: {
    backgroundColor: colors$1.danger10,
    color: colors$1.danger
  },
  [transactionsStatus.PENDING]: {
    backgroundColor: colors$1.warning10,
    color: colors$1.warning
  },
  [transactionsStatus.ACCEPTED]: {
    backgroundColor: colors$1.success10,
    color: colors$1.success
  }
};
const DEFAULT_STYLE = {
  backgroundColor: colors$1.grey20,
  color: colors$1.grey
};
const LabelTransactionStatus = ({
  status
}) => {
  const normalized = typeof status === 'string' ? status.toUpperCase() : '';
  const style = STATUS_STYLES[normalized] || DEFAULT_STYLE;
  return /*#__PURE__*/jsx(Label, {
    style: {
      ...style
    },
    children: status
  });
};

const TruncatedList = ({
  items = [],
  maxVisible = 4,
  getLabel = item => item,
  getKey = (item, index) => index,
  emptyPlaceholder = '-',
  moreVariant = 'info',
  tooltipPosition = 'top'
}) => {
  if (!items || items.length === 0) {
    return emptyPlaceholder;
  }
  const visibleLabels = items.slice(0, maxVisible).map(getLabel).join(', ');
  const hiddenCount = items.length - maxVisible;
  if (hiddenCount <= 0) {
    return visibleLabels;
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    gap: "6px",
    alignItems: "center",
    children: [/*#__PURE__*/jsx("span", {
      children: visibleLabels
    }), /*#__PURE__*/jsx(Tooltip$1, {
      position: tooltipPosition,
      keepOnHover: true,
      content: /*#__PURE__*/jsx(FlexContainer, {
        flexDirection: "column",
        flexFlow: "column",
        gap: "4px",
        children: items.map((item, index) => /*#__PURE__*/jsx("span", {
          children: getLabel(item)
        }, getKey(item, index)))
      }),
      children: /*#__PURE__*/jsx(Label, {
        variant: moreVariant,
        children: `+${hiddenCount} more`
      })
    })]
  });
};
TruncatedList.propTypes = {
  items: PropTypes.array,
  maxVisible: PropTypes.number,
  getLabel: PropTypes.func,
  getKey: PropTypes.func,
  emptyPlaceholder: PropTypes.node,
  moreVariant: PropTypes.string,
  tooltipPosition: PropTypes.oneOf(['top', 'bottom', 'left', 'right', 'bottom-end'])
};

var css_248z$17 = ".IconWithBadge-module__iconWithBadge___gzu-k{cursor:pointer;display:inline-block;line-height:1;position:relative;vertical-align:middle}.IconWithBadge-module__iconWithBadge___gzu-k svg{height:20px;width:20px}.IconWithBadge-module__iconWithBadge___gzu-k .IconWithBadge-module__badge___y1I-G{align-items:center;background:var(--danger);border-radius:999px;box-shadow:0 2px 8px rgba(0,0,0,.08);color:var(--white);display:flex;font-size:12px;font-weight:600;height:18px;justify-content:center;min-width:18px;padding:0 4px;position:absolute;right:-8px;top:-8px}";
var css$16 = {"iconWithBadge":"IconWithBadge-module__iconWithBadge___gzu-k","badge":"IconWithBadge-module__badge___y1I-G"};
styleInject(css_248z$17);

const IconWithBadge = ({
  icon,
  count,
  onClick,
  className,
  style
}) => {
  return /*#__PURE__*/jsxs("span", {
    className: `${css$16.iconWithBadge} ${className || ''}`,
    onClick: onClick,
    style: style,
    children: [icon, count > 0 && /*#__PURE__*/jsx("span", {
      className: css$16.badge,
      children: count
    })]
  });
};

const NoResultsFoundCard = ({
  title,
  message,
  className,
  style
}) => {
  return /*#__PURE__*/jsx(Card, {
    title: title,
    className: className,
    style: style,
    children: /*#__PURE__*/jsx(NoResultsFoundMessage, {
      message: message
    })
  });
};
NoResultsFoundCard.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
};

var css_248z$16 = ".AppliedFilter-module__filterSummarySection___yo8g9{align-items:center;display:flex;gap:10px;margin-bottom:10px}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7{align-items:center;background-color:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);display:flex;padding:3px 8px}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7 svg{height:10px;width:10px}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7>span:first-letter{text-transform:capitalize}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7 .AppliedFilter-module__filterName___ClERJ{color:var(--primary-color);font-weight:600!important}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7 .AppliedFilter-module__filterArrow___wmcRu{margin-bottom:-1px;margin-left:3px;margin-right:3px;padding:0!important}.AppliedFilter-module__filterSummarySection___yo8g9 .AppliedFilter-module__appliedFilter___1dEK7 .AppliedFilter-module__filterClear___DfKGL{border-left:1px solid var(--bg-dark);cursor:pointer;margin-left:5px;padding-left:5px}";
var css$15 = {"filterSummarySection":"AppliedFilter-module__filterSummarySection___yo8g9","appliedFilter":"AppliedFilter-module__appliedFilter___1dEK7","filterName":"AppliedFilter-module__filterName___ClERJ","filterArrow":"AppliedFilter-module__filterArrow___wmcRu","filterClear":"AppliedFilter-module__filterClear___DfKGL"};
styleInject(css_248z$16);

const AppliedFiltersSummary = ({
  children
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$15.filterSummarySection,
    children: [/*#__PURE__*/jsx("span", {
      children: /*#__PURE__*/jsx(Filter, {
        color: "var(--primary-color)"
      })
    }), children]
  });
};

const AppliedFilter = ({
  name,
  value,
  onClear
}) => {
  if (!value || value === '') {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: css$15.appliedFilter,
    children: [/*#__PURE__*/jsx("span", {
      className: css$15.filterName,
      children: name
    }), /*#__PURE__*/jsx("span", {
      className: css$15.filterArrow,
      children: /*#__PURE__*/jsx(ChevronRight, {
        color: "var(--primary-color)"
      })
    }), /*#__PURE__*/jsx("span", {
      children: value.toLowerCase()
    }), /*#__PURE__*/jsx("span", {
      className: css$15.filterClear,
      onClick: () => onClear(''),
      children: /*#__PURE__*/jsx(X02, {
        color: "var(--text)"
      })
    })]
  });
};

var css_248z$15 = ".PillsTabs-module__pillsTabsWrapper___uKJt-{align-items:center;background:var(--bg-dark);border-radius:var(--border-radius-medium);display:flex;margin-bottom:20px;padding:2px;width:fit-content}.PillsTabs-module__pillsTabsWrapper___uKJt-.PillsTabs-module__fullWidth___KKMgk,.PillsTabs-module__pillsTabsWrapper___uKJt-.PillsTabs-module__fullWidth___KKMgk .PillsTabs-module__pillsTabs___GxgBj{width:100%}.PillsTabs-module__pillsTabsWrapper___uKJt-.PillsTabs-module__fullWidth___KKMgk .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t{flex:1;justify-content:center;min-width:max-content;text-align:center}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj{display:flex;gap:0}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t{background:transparent;border:none;cursor:pointer;font-size:var(--body-regular-size);line-height:var(--body-regular-line-height);outline:none;padding:5px 15px;text-align:center;transition:background .2s,color .2s}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t span{font-weight:600}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t .PillsTabs-module__badge___jGoZD{align-items:center;background-color:var(--primary-20);border-radius:999px;box-sizing:border-box;color:#fff;display:inline-flex;font-size:11px;font-weight:500;height:20px;justify-content:center;line-height:1;margin-left:6px;min-width:20px;padding:0 6px}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t .PillsTabs-module__badge___jGoZD.PillsTabs-module__hasCount___L1cG-{background-color:var(--danger)}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t:first-child{border-radius:var(--border-radius-small) 0 0 var(--border-radius-small)}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t:last-child{border-radius:0 var(--border-radius-small) var(--border-radius-small) 0}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t.PillsTabs-module__active___o379S{background:var(--white);color:var(--primary-color);z-index:1}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t.PillsTabs-module__active___o379S .PillsTabs-module__badge___jGoZD{background-color:var(--primary-color)}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t.PillsTabs-module__active___o379S .PillsTabs-module__badge___jGoZD.PillsTabs-module__hasCount___L1cG-{background-color:var(--danger)}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t.PillsTabs-module__blocked___a7Mgp{align-items:center;display:flex;gap:5px}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t:not(.PillsTabs-module__active___o379S){color:var(--primary-50)}@media (max-width:768px){.PillsTabs-module__pillsTabsWrapper___uKJt-{overflow-x:visible!important;padding:2px!important;width:100%!important}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj{display:flex!important;flex-direction:column!important;gap:4px!important;width:100%!important}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t{border-radius:var(--border-radius-small)!important;font-size:var(--body-small-size)!important;padding:8px 12px!important;text-align:left!important;white-space:normal!important;width:100%!important}.PillsTabs-module__pillsTabsWrapper___uKJt- .PillsTabs-module__pillsTabs___GxgBj .PillsTabs-module__pillTab___Oe53t .PillsTabs-module__badge___jGoZD{font-size:10px!important;height:18px!important;margin-left:4px!important;min-width:18px!important;padding:0 5px!important}}";
var css$14 = {"pillsTabsWrapper":"PillsTabs-module__pillsTabsWrapper___uKJt-","fullWidth":"PillsTabs-module__fullWidth___KKMgk","pillsTabs":"PillsTabs-module__pillsTabs___GxgBj","pillTab":"PillsTabs-module__pillTab___Oe53t","badge":"PillsTabs-module__badge___jGoZD","hasCount":"PillsTabs-module__hasCount___L1cG-","active":"PillsTabs-module__active___o379S","blocked":"PillsTabs-module__blocked___a7Mgp"};
styleInject(css_248z$15);

const PillsTabs = ({
  children,
  className,
  style,
  fullWidth = false
}) => {
  return /*#__PURE__*/jsx("div", {
    className: `${css$14.pillsTabsWrapper} ${fullWidth ? css$14.fullWidth : ''} ${className || ''}`,
    style: style,
    children: /*#__PURE__*/jsx("div", {
      className: css$14.pillsTabs,
      children: children
    })
  });
};
PillsTabs.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  fullWidth: PropTypes.bool
};

const PillsTabItem = ({
  label,
  isBlocked,
  blockedClick,
  active,
  count,
  onClick
}) => /*#__PURE__*/jsxs("button", {
  className: `${css$14.pillTab} ${active ? css$14.active : ''} ${isBlocked ? css$14.blocked : ''}`,
  onClick: () => !isBlocked ? onClick() : blockedClick(),
  type: "button",
  children: [isBlocked && /*#__PURE__*/jsx(Lock02Icon, {
    color: colors$1.primary50,
    width: 18,
    height: 18
  }), label && /*#__PURE__*/jsx("span", {
    children: label
  }), typeof count === 'number' && /*#__PURE__*/jsx("span", {
    className: `${css$14.badge} ${count > 0 ? css$14.hasCount : ''}`,
    children: count
  })]
});

var css_248z$14 = ".PillsTabsTabPanel-module__tabPanel___mK9HX{background-color:var(--white);border-radius:var(--border-radius-medium);margin-bottom:20px;padding:15px}.PillsTabsTabPanel-module__tabPanel___mK9HX .PillsTabsTabPanel-module__tabPanelContent___B41pC{color:var(--grey-64);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height)}";
var css$13 = {"tabPanel":"PillsTabsTabPanel-module__tabPanel___mK9HX","tabPanelContent":"PillsTabsTabPanel-module__tabPanelContent___B41pC"};
styleInject(css_248z$14);

const PillsTabsTabPanel = ({
  className,
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: `${css$13.tabPanel} ${className}`,
    children: /*#__PURE__*/jsx("div", {
      className: css$13.tabPanelContent,
      children: children
    })
  });
};

var css_248z$13 = ".PageContainer-module__pageContainer___9luba{margin:0 auto;max-width:1400px;padding:15px 0;transition:max-width .3s ease}.PageContainer-module__wide___0Vv4v{max-width:100%}";
var css$12 = {"pageContainer":"PageContainer-module__pageContainer___9luba","wide":"PageContainer-module__wide___0Vv4v"};
styleInject(css_248z$13);

const PageContainer = /*#__PURE__*/forwardRef(({
  children,
  className = '',
  wide,
  style,
  ...props
}, ref) => {
  const context = usePageContainerContext();
  const isWide = wide ?? context?.wide ?? false;
  return /*#__PURE__*/jsx("div", {
    ref: ref,
    className: `${css$12.pageContainer} ${isWide ? css$12.wide : ''} ${className}`,
    style: {
      ...style
    },
    ...props,
    children: children
  });
});
PageContainer.displayName = "PageContainer";

const PageActions = ({
  children,
  className = '',
  style,
  ...props
}) => /*#__PURE__*/jsx(FlexContainer, {
  gap: 10,
  className: className,
  style: {
    marginTop: '40px',
    ...style
  },
  ...props,
  children: children
});

var css_248z$12 = ".InlineFilters-module__inlineFilters___M3thT{align-items:center;display:flex;flex-wrap:wrap;gap:10px;margin-bottom:24px}.InlineFilters-module__inlineFilters___M3thT>div{margin-bottom:0;width:fit-content}.InlineFilters-module__inlineFilters___M3thT.InlineFilters-module__justifySpaceBetween___HePcz{justify-content:space-between}.InlineFilters-module__inlineFilters___M3thT.InlineFilters-module__alignItemsEnd___HbOJy{align-items:flex-end}";
var css$11 = {"inlineFilters":"InlineFilters-module__inlineFilters___M3thT","justifySpaceBetween":"InlineFilters-module__justifySpaceBetween___HePcz","alignItemsEnd":"InlineFilters-module__alignItemsEnd___HbOJy"};
styleInject(css_248z$12);

const InlineFilters = ({
  children,
  justify,
  align
}) => {
  return /*#__PURE__*/jsx("div", {
    className: [css$11.inlineFilters, justify === 'space-between' && css$11.justifySpaceBetween, align === 'end' && css$11.alignItemsEnd].filter(Boolean).join(' '),
    children: children
  });
};

var css_248z$11 = ".FilterBar-module__filtersBar___7CvdD{align-items:center;background:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-medium);display:flex;justify-content:space-between;margin-bottom:15px;padding:15px}.FilterBar-module__filtersBar___7CvdD.FilterBar-module__inlineInputsFiltersBar___uzsFQ{background-color:transparent;border:none;padding:0}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesSection___ktT6I{align-items:center;display:flex;flex:1;flex-wrap:wrap;gap:8px;min-width:0}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__buttonsSection___c-GL1{display:flex;gap:10px;position:relative}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__buttonsSection___c-GL1 .FilterBar-module__filterBtn___-tbsg{background:var(--primary-color);border-radius:4px;color:#fff;cursor:pointer;font-weight:500;padding:6px 18px;transition:background .2s}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__buttonsSection___c-GL1 .FilterBar-module__filterBtn___-tbsg:hover{background:var(--primary-20)}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW{align-items:center;display:flex;flex-wrap:wrap;gap:6px}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj{align-items:center;background:var(--primary-20);border-radius:var(--border-radius-small);color:var(--primary-color);cursor:pointer;display:inline-flex;font-size:var(--body-small-size);line-height:var(--body-small-line-height);margin-bottom:2px;margin-right:2px;padding:3px 10px;position:relative}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj .FilterBar-module__closeBtn___U0QLu{background:transparent;border:none;color:var(--primary-color);font-size:19px;line-height:1;margin-left:6px;padding:0 2px;transition:color .2s}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj .FilterBar-module__closeBtn___U0QLu:hover{color:var(--grey-64)}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeEditDropdown___nCAXi{display:inline-block}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeEditDropdown___nCAXi select{background:var(--primary-10);border:1px solid var(--primary-color);border-radius:var(--border-radius-small);color:var(--primary-color);outline:none;padding:2px 10px}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeDropdown___rW-Tr{background:var(--primary-10);border:1px solid var(--bg-dark);color:var(--primary-color);cursor:pointer;transition:background .2s}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeDropdown___rW-Tr:hover{background:var(--primary-20)}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeDropdown___rW-Tr select{background:transparent;border:none;color:var(--primary-color);cursor:pointer;font-family:inherit;font-size:var(--body-small-size)!important;line-height:var(--body-small-line-height);margin:0;outline:none;padding:0}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeDropdown___rW-Tr select:focus{outline:none}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badgeDropdown___rW-Tr select option{background:#fff;color:var(--primary-color);padding:4px 8px}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__chipPopover___pWxpe{animation:FilterBar-module__fadeInExportMenu___QElxF .16s;background:#fff;border:1px solid var(--bg-dark);border-radius:6px;box-shadow:0 4px 12px rgba(50,50,100,.11);left:0;margin-top:6px;padding:12px;position:absolute;top:100%;z-index:10}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__clearAllBtn___aYm-O{background:none;border:none;color:var(--grey-64);cursor:pointer;margin-left:10px;padding:0 3px}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__clearAllBtn___aYm-O:hover{text-decoration:underline}.FilterBar-module__exportDropdownMenu___vc7KO{animation:FilterBar-module__fadeInExportMenu___QElxF .16s;background:#fff;border:1px solid var(--bg-dark);border-radius:6px;box-shadow:0 4px 12px rgba(50,50,100,.11);display:flex;flex-direction:column;min-width:100px;position:absolute;right:0;top:110%;z-index:10}.FilterBar-module__exportDropdownMenu___vc7KO .FilterBar-module__exportDropdownItem___WH-dA{background:none;border:none;border-bottom:1px solid var(--bg-dark);color:var(--primary-color);cursor:pointer;padding:10px 14px;text-align:center}.FilterBar-module__exportDropdownMenu___vc7KO .FilterBar-module__exportDropdownItem___WH-dA:last-child{border-bottom:none}.FilterBar-module__exportDropdownMenu___vc7KO .FilterBar-module__exportDropdownItem___WH-dA:hover{background:var(--primary-10)}.FilterBar-module__columnsVisibilityMenu___cpo0c{animation:FilterBar-module__fadeInExportMenu___QElxF .16s;background:#fff;border:1px solid var(--bg-dark);border-radius:6px;box-shadow:0 4px 12px rgba(50,50,100,.11);display:flex;flex-direction:column;gap:20px;max-width:300px;min-width:300px;padding:20px;position:absolute;right:0;top:110%;z-index:10}.FilterBar-module__filtersPanel___fL5IH{background:#fff;box-shadow:-2px 0 16px rgba(50,50,100,.1);display:flex;flex-direction:column;height:calc(100% - 58px);pointer-events:none;position:fixed;right:-400px;top:0;transition:right .3s cubic-bezier(.25,.8,.25,1);width:360px;z-index:1200}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelHeader___SPrgJ{align-items:center;display:flex;justify-content:space-between;padding:15px 25px 0}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelHeader___SPrgJ h2{align-items:center;color:var(--primary-color);display:flex;gap:10px}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelHeader___SPrgJ .FilterBar-module__closeBtn___U0QLu{cursor:pointer}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelHeader___SPrgJ .FilterBar-module__closeBtn___U0QLu svg{height:12px;width:12px}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelBody___CW4P-{flex:1;overflow-y:auto;padding:15px 25px 0}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelBody___CW4P- .FilterBar-module__filterInputGroup___fhmCD{margin-bottom:20px}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelFooter___pbthP{padding:15px 25px}.FilterBar-module__filtersPanel___fL5IH .FilterBar-module__filtersPanelFooter___pbthP button{width:100%}.FilterBar-module__filtersPanelOpen___cS3te{pointer-events:auto;right:0;top:58px}@keyframes FilterBar-module__fadeInExportMenu___QElxF{0%{opacity:0;transform:translateY(-8px)}to{opacity:1;transform:none}}@media print{.FilterBar-module__noPrint___0s-td{display:none!important}}@media (max-width:768px){.FilterBar-module__filtersBar___7CvdD{align-items:stretch!important;flex-direction:column!important;gap:12px!important}.FilterBar-module__filtersBar___7CvdD>div:first-child{display:flex!important;flex-direction:column!important;gap:8px!important;width:100%!important}.FilterBar-module__filtersBar___7CvdD>span{display:none!important}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesSection___ktT6I{flex:none!important;width:100%!important}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesSection___ktT6I,.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW{align-items:stretch!important;flex-direction:column!important;gap:8px!important}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj{align-items:center!important;box-sizing:border-box;display:flex!important;flex-wrap:nowrap;justify-content:flex-start!important;margin-bottom:0!important;margin-right:0!important;padding-right:34px;white-space:nowrap;width:100%!important}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj select{appearance:none;-webkit-appearance:none}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__badgesWrap___t-9MW .FilterBar-module__badge___36AOj .FilterBar-module__closeBtn___U0QLu{flex:0 0 auto;margin-left:0;position:absolute;right:12px;top:50%;transform:translateY(-50%);width:10px}.FilterBar-module__filtersBar___7CvdD .FilterBar-module__buttonsSection___c-GL1{justify-content:flex-end!important;order:-1!important;width:100%!important}}";
var css$10 = {"filtersBar":"FilterBar-module__filtersBar___7CvdD","inlineInputsFiltersBar":"FilterBar-module__inlineInputsFiltersBar___uzsFQ","badgesSection":"FilterBar-module__badgesSection___ktT6I","buttonsSection":"FilterBar-module__buttonsSection___c-GL1","filterBtn":"FilterBar-module__filterBtn___-tbsg","badgesWrap":"FilterBar-module__badgesWrap___t-9MW","badge":"FilterBar-module__badge___36AOj","closeBtn":"FilterBar-module__closeBtn___U0QLu","badgeEditDropdown":"FilterBar-module__badgeEditDropdown___nCAXi","badgeDropdown":"FilterBar-module__badgeDropdown___rW-Tr","chipPopover":"FilterBar-module__chipPopover___pWxpe","fadeInExportMenu":"FilterBar-module__fadeInExportMenu___QElxF","clearAllBtn":"FilterBar-module__clearAllBtn___aYm-O","exportDropdownMenu":"FilterBar-module__exportDropdownMenu___vc7KO","exportDropdownItem":"FilterBar-module__exportDropdownItem___WH-dA","columnsVisibilityMenu":"FilterBar-module__columnsVisibilityMenu___cpo0c","filtersPanel":"FilterBar-module__filtersPanel___fL5IH","filtersPanelHeader":"FilterBar-module__filtersPanelHeader___SPrgJ","filtersPanelBody":"FilterBar-module__filtersPanelBody___CW4P-","filterInputGroup":"FilterBar-module__filterInputGroup___fhmCD","filtersPanelFooter":"FilterBar-module__filtersPanelFooter___pbthP","filtersPanelOpen":"FilterBar-module__filtersPanelOpen___cS3te","noPrint":"FilterBar-module__noPrint___0s-td"};
styleInject(css_248z$11);

var css_248z$10 = ".DateRangePicker-module__dateRangeContainer___AHUZF{align-items:flex-start;display:flex;gap:10px}.DateRangePicker-module__dateRangeContainer___AHUZF .DateRangePicker-module__dateInputWrapper___9ev0z{display:flex;flex-direction:column;min-width:140px}";
var css$$ = {"dateRangeContainer":"DateRangePicker-module__dateRangeContainer___AHUZF","dateInputWrapper":"DateRangePicker-module__dateInputWrapper___9ev0z"};
styleInject(css_248z$10);

var css_248z$$ = ".InputCalendar-module__inputContainer___GjbOW{display:flex;flex-direction:column;width:100%}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__label___-riAA{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__label___-riAA .InputCalendar-module__required___7mBrk{color:var(--danger);margin-left:.15rem}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk{align-items:center;display:flex;position:relative;width:100%}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__iconContainer___8J1Qb{align-items:center;color:var(--grey-64);cursor:pointer;display:flex;justify-content:center;left:10px;position:absolute;top:50%;transform:translateY(-50%);z-index:1}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__iconContainer___8J1Qb svg{height:18px;width:18px}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__iconContainer___8J1Qb:hover{opacity:.8}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-family:Just Sans,sans-serif;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;padding-left:38px!important;padding-right:0!important;text-align:left;transition:all .2s ease;width:100%}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT::-webkit-calendar-picker-indicator{cursor:pointer;height:100%;opacity:0;position:absolute;right:0;top:0;width:100%}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT::-webkit-inner-spin-button,.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT::placeholder{color:var(--grey-20)}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT:focus{background-color:var(--bg-light-48);outline:none}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT:disabled{background-color:var(--disabled);cursor:not-allowed}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT.InputCalendar-module__error___kiCjg{border-color:var(--danger)}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__inputWrapper___e-Mlk .InputCalendar-module__input___96XMT.InputCalendar-module__small___HX95r{padding:0 0 0 30px!important}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__errorMessage___li-5B{color:var(--danger);font-size:.75rem;margin-top:.2rem}.InputCalendar-module__inputContainer___GjbOW .InputCalendar-module__constraints___ugmcB{color:var(--darkGray);font-size:.75rem;margin-top:.5rem;text-align:left}";
var css$_ = {"inputContainer":"InputCalendar-module__inputContainer___GjbOW","label":"InputCalendar-module__label___-riAA","required":"InputCalendar-module__required___7mBrk","inputWrapper":"InputCalendar-module__inputWrapper___e-Mlk","iconContainer":"InputCalendar-module__iconContainer___8J1Qb","input":"InputCalendar-module__input___96XMT","error":"InputCalendar-module__error___kiCjg","small":"InputCalendar-module__small___HX95r","errorMessage":"InputCalendar-module__errorMessage___li-5B","constraints":"InputCalendar-module__constraints___ugmcB"};
styleInject(css_248z$$);

const InputCalendar = ({
  label,
  id,
  value,
  onChange,
  type,
  required = false,
  disabled = false,
  min,
  max,
  error,
  size,
  ...rest
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$_.inputContainer,
    children: [/*#__PURE__*/jsxs("label", {
      className: css$_.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$_.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$_.inputWrapper,
      children: [/*#__PURE__*/jsx("div", {
        className: css$_.iconContainer,
        children: /*#__PURE__*/jsx(Calendar01, {
          color: "var(--primary-color)"
        })
      }), /*#__PURE__*/jsx("input", {
        type: type ?? "date",
        id: id,
        value: value,
        onChange: onChange,
        min: min,
        max: max,
        disabled: disabled,
        className: `${css$_.input} ${error ? css$_.error : ''} ${size === 'small' ? css$_.small : ''}`,
        ...rest
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$_.errorMessage,
      children: error
    })]
  });
};
InputCalendar.propTypes = {
  label: PropTypes.string,
  type: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.oneOf(['small'])
};

const formatDate = date => {
  const parsedDate = typeof date === 'string' ? parseDate$2(date) : date;
  if (!isValid$1(parsedDate)) {
    return '';
  }
  return formatDate$1(parsedDate, 'yyyy-MM-dd');
};
const DateRangePicker = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  minDate,
  maxDate,
  size
}) => {
  const minBound = minDate ? formatDate(minDate) : undefined;
  const maxBound = maxDate ? formatDate(maxDate) : undefined;
  return /*#__PURE__*/jsxs("div", {
    className: css$$.dateRangeContainer,
    children: [/*#__PURE__*/jsx("div", {
      className: css$$.dateInputWrapper,
      children: /*#__PURE__*/jsx(InputCalendar, {
        label: "Start Date",
        value: formatDate(startDate),
        onChange: e => onStartDateChange(e.target.value),
        min: minBound,
        max: maxBound,
        size: size
      })
    }), /*#__PURE__*/jsx("div", {
      className: css$$.dateInputWrapper,
      children: /*#__PURE__*/jsx(InputCalendar, {
        label: "End Date",
        value: formatDate(endDate),
        onChange: e => onEndDateChange(e.target.value),
        min: formatDate(startDate) || minBound,
        max: maxBound,
        size: size
      })
    })]
  });
};

var css_248z$_ = ".ToggleSwitch-module__toggleSwitchLabel___jvSC8{align-items:center;cursor:pointer;display:flex;gap:10px}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__left___OMQlv{flex-direction:row-reverse}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__left___OMQlv span{margin:0}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__right___nbogj{flex-direction:row}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__right___nbogj span{margin:0}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__top___7-fTP{align-items:flex-start;flex-direction:column;gap:0;height:100%}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__top___7-fTP .ToggleSwitch-module__switchWrapper___UZPVi{flex:1}.ToggleSwitch-module__toggleSwitchLabel___jvSC8.ToggleSwitch-module__disabled___7Ixl3{cursor:not-allowed;opacity:.6}.ToggleSwitch-module__label___8hR-d{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:5px;text-align:left}.ToggleSwitch-module__label___8hR-d .ToggleSwitch-module__required___ZQhXK{color:var(--danger);margin-left:.15rem}.ToggleSwitch-module__switchWrapper___UZPVi{align-items:center;display:flex;position:relative}.ToggleSwitch-module__switchWrapper___UZPVi .ToggleSwitch-module__stateLabel___sSh1q{color:var(--grey-64);margin-left:5px!important}.ToggleSwitch-module__input___Cst1m{height:0;opacity:0;position:absolute;width:0}.ToggleSwitch-module__slider___W2xmZ{background:var(--bg-dark);border-radius:50px;box-sizing:border-box;display:inline-block;height:22px;position:relative;transition:background .2s;width:40px}.ToggleSwitch-module__slider___W2xmZ:before{background:#fff;border-radius:50%;content:\"\";height:18px;left:2px;position:absolute;top:2px;transition:transform .2s;width:18px}.ToggleSwitch-module__input___Cst1m:checked+.ToggleSwitch-module__slider___W2xmZ{background:var(--primary-color);border-color:var(--primary-color)}.ToggleSwitch-module__input___Cst1m:checked+.ToggleSwitch-module__slider___W2xmZ:before{transform:translateX(18px)}.ToggleSwitch-module__input___Cst1m:disabled+.ToggleSwitch-module__slider___W2xmZ{cursor:not-allowed;opacity:.5}";
var css$Z = {"toggleSwitchLabel":"ToggleSwitch-module__toggleSwitchLabel___jvSC8","left":"ToggleSwitch-module__left___OMQlv","right":"ToggleSwitch-module__right___nbogj","top":"ToggleSwitch-module__top___7-fTP","switchWrapper":"ToggleSwitch-module__switchWrapper___UZPVi","disabled":"ToggleSwitch-module__disabled___7Ixl3","label":"ToggleSwitch-module__label___8hR-d","required":"ToggleSwitch-module__required___ZQhXK","stateLabel":"ToggleSwitch-module__stateLabel___sSh1q","input":"ToggleSwitch-module__input___Cst1m","slider":"ToggleSwitch-module__slider___W2xmZ"};
styleInject(css_248z$_);

const ToggleSwitch = ({
  checked,
  onChange,
  label,
  className,
  labelPosition = 'right',
  required = false,
  disabled = false,
  activeLabel,
  inactiveLabel,
  ...props
}) => {
  const labelContent = /*#__PURE__*/jsxs(Fragment$1, {
    children: [label, required && /*#__PURE__*/jsx("span", {
      className: css$Z.required,
      children: "*"
    })]
  });
  return /*#__PURE__*/jsxs("label", {
    className: `${css$Z.toggleSwitchLabel} ${css$Z[labelPosition]} ${disabled ? css$Z.disabled : ''} ${className}`,
    children: [label && (labelPosition === 'left' || labelPosition === 'top') && /*#__PURE__*/jsx("span", {
      className: css$Z.label,
      children: labelContent
    }), /*#__PURE__*/jsxs("span", {
      className: css$Z.switchWrapper,
      children: [/*#__PURE__*/jsx("input", {
        type: "checkbox",
        checked: checked,
        onChange: e => !disabled && onChange?.(e.target.checked),
        disabled: disabled,
        className: css$Z.input,
        ...props
      }), /*#__PURE__*/jsx("span", {
        className: css$Z.slider
      }), activeLabel && inactiveLabel && /*#__PURE__*/jsx("span", {
        className: css$Z.stateLabel,
        children: checked ? activeLabel : inactiveLabel
      })]
    }), label && labelPosition === 'right' && /*#__PURE__*/jsx("span", {
      className: css$Z.label,
      children: labelContent
    })]
  });
};
ToggleSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelPosition: PropTypes.oneOf(['left', 'right', 'top']),
  required: PropTypes.bool,
  disabled: PropTypes.bool
};

var css_248z$Z = ".InputMonth-module__inputContainer___FleEP{display:flex;flex-direction:column;width:100%}.InputMonth-module__inputContainer___FleEP .InputMonth-module__label___lQmuC{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:5px;text-align:left}.InputMonth-module__inputContainer___FleEP .InputMonth-module__label___lQmuC .InputMonth-module__required___ykONw{color:var(--danger);margin-left:.15rem}.InputMonth-module__inputContainer___FleEP .InputMonth-module__inputWrapper___2GfYm{align-items:center;display:flex;position:relative;width:100%}.InputMonth-module__inputContainer___FleEP .InputMonth-module__iconContainer___RiFtB{align-items:center;color:var(--grey-64);display:flex;justify-content:center;left:10px;pointer-events:none;position:absolute;top:50%;transform:translateY(-50%)}.InputMonth-module__inputContainer___FleEP .InputMonth-module__iconContainer___RiFtB svg{height:18px;width:18px}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;transition:all .2s ease;width:100%}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX.InputMonth-module__hasIcon___aaPF2{padding-left:35px}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX::placeholder{color:var(--grey-20)}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX:focus{background-color:var(--bg-light-48);outline:none}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX:disabled{background-color:var(--grey-8);color:var(--grey-20);cursor:not-allowed}.InputMonth-module__inputContainer___FleEP .InputMonth-module__input___LRRHX.InputMonth-module__error___MolhC{border-color:var(--danger)}.InputMonth-module__inputContainer___FleEP .InputMonth-module__errorMessage___IW-7A{color:var(--danger);font-size:.75rem;margin-top:.2rem;text-align:left}";
var css$Y = {"inputContainer":"InputMonth-module__inputContainer___FleEP","label":"InputMonth-module__label___lQmuC","required":"InputMonth-module__required___ykONw","inputWrapper":"InputMonth-module__inputWrapper___2GfYm","iconContainer":"InputMonth-module__iconContainer___RiFtB","input":"InputMonth-module__input___LRRHX","hasIcon":"InputMonth-module__hasIcon___aaPF2","error":"InputMonth-module__error___MolhC","errorMessage":"InputMonth-module__errorMessage___IW-7A"};
styleInject(css_248z$Z);

const InputMonth = ({
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown
}) => {
  const handleChange = e => {
    onChange(e);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$Y.inputContainer} ${className}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$Y.label,
      htmlFor: name,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$Y.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$Y.inputWrapper,
      children: [icon && /*#__PURE__*/jsx("div", {
        className: css$Y.iconContainer,
        children: icon
      }), /*#__PURE__*/jsx("input", {
        type: "month",
        value: value || '',
        onChange: handleChange,
        disabled: disabled,
        required: required,
        name: name,
        id: name,
        autoFocus: autoFocus,
        onKeyDown: onKeyDown,
        className: `${css$Y.input} ${error ? css$Y.error : ''} ${icon ? css$Y.hasIcon : ''}`,
        "data-error": !!error
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$Y.errorMessage,
      children: error
    })]
  });
};
InputMonth.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func
};

var css_248z$Y = ".SearchableDropdown-module__dropdownContainer___nn6c9{display:flex;flex-direction:column;position:relative;width:100%}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__label___oYyZR{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__label___oYyZR .SearchableDropdown-module__required___D8fdT{color:var(--danger);margin-left:.15rem}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c{position:relative;width:100%}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c.SearchableDropdown-module__error___6NO2O .SearchableDropdown-module__input___dBUa2{border-color:var(--danger)}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c.SearchableDropdown-module__disabled___RzB0T{cursor:not-allowed;opacity:.7}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__input___dBUa2{background-color:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;transition:all .2s ease;width:100%}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__input___dBUa2:focus{background-color:var(--bg-light-48);outline:none}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__input___dBUa2.SearchableDropdown-module__disabled___RzB0T{background-color:var(--bg-light-80);cursor:not-allowed;opacity:.7}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__input___dBUa2::placeholder{color:var(--text)}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__optionsContainer___jKv5v{background-color:#fff;border:1px solid var(--bg-dark);border-radius:4px;left:0;margin-top:4px;max-height:200px;overflow-y:auto;position:absolute;right:0;top:100%;z-index:1000}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__optionsContainer___jKv5v .SearchableDropdown-module__option___G7hcO{cursor:pointer;padding:8px 12px;transition:background-color .2s}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__optionsContainer___jKv5v .SearchableDropdown-module__option___G7hcO:hover{background-color:var(--bg-light-48)}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__optionsContainer___jKv5v .SearchableDropdown-module__option___G7hcO.SearchableDropdown-module__selected___fk6Rb{background-color:var(--primary-10)}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__dropdown___G7v4c .SearchableDropdown-module__optionsContainer___jKv5v .SearchableDropdown-module__noOptions___Vw1nk{color:#6c757d;font-style:italic;padding:8px 12px}.SearchableDropdown-module__dropdownContainer___nn6c9 .SearchableDropdown-module__errorMessage___DH3s-{color:#dc3545;font-size:12px;margin-top:.2rem}";
var css$X = {"dropdownContainer":"SearchableDropdown-module__dropdownContainer___nn6c9","label":"SearchableDropdown-module__label___oYyZR","required":"SearchableDropdown-module__required___D8fdT","dropdown":"SearchableDropdown-module__dropdown___G7v4c","error":"SearchableDropdown-module__error___6NO2O","input":"SearchableDropdown-module__input___dBUa2","disabled":"SearchableDropdown-module__disabled___RzB0T","optionsContainer":"SearchableDropdown-module__optionsContainer___jKv5v","option":"SearchableDropdown-module__option___G7hcO","selected":"SearchableDropdown-module__selected___fk6Rb","noOptions":"SearchableDropdown-module__noOptions___Vw1nk","errorMessage":"SearchableDropdown-module__errorMessage___DH3s-"};
styleInject(css_248z$Y);

const SearchableDropdown = ({
  label,
  value,
  onChange,
  options = [],
  placeholder = 'Search and select an option',
  required = false,
  disabled = false,
  error = '',
  name,
  addSearchTerm = null
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const dropdownRef = useRef(null);
  useEffect(() => {
    const option = options.find(opt => opt.value === value);
    setSelectedOption(option);
  }, [value, options]);
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  const filteredOptions = options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
  const handleInputChange = e => {
    setSearchTerm(e.target.value);
    setIsOpen(true);
  };
  const handleOptionClick = option => {
    setSelectedOption(option);
    setSearchTerm('');
    setIsOpen(false);
    if (addSearchTerm) {
      addSearchTerm('');
    }
    onChange({
      target: {
        name,
        value: option.value
      }
    });
  };
  const handleAddSearchTerm = searchTerm => {
    setIsOpen(false);
    addSearchTerm(searchTerm);
  };
  return /*#__PURE__*/jsxs("div", {
    className: css$X.dropdownContainer,
    ref: dropdownRef,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$X.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$X.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: `${css$X.dropdown} ${error ? css$X.error : ''} ${disabled ? css$X.disabled : ''}`,
      children: [/*#__PURE__*/jsx("input", {
        type: "text",
        className: css$X.input,
        value: isOpen ? searchTerm : selectedOption ? selectedOption.label : '',
        onChange: handleInputChange,
        onFocus: () => setIsOpen(true),
        placeholder: selectedOption ? selectedOption.label : placeholder,
        disabled: disabled,
        required: required,
        name: name
      }), isOpen && !disabled && /*#__PURE__*/jsx("div", {
        className: css$X.optionsContainer,
        children: filteredOptions.length > 0 ? filteredOptions.map(option => /*#__PURE__*/jsx("div", {
          className: `${css$X.option} ${selectedOption?.value === option.value ? css$X.selected : ''} ${option.disabled ? css$X.disabledOption : ''}`,
          onClick: () => !option.disabled && handleOptionClick(option),
          children: option.label
        }, option.value)) : searchTerm.trim() && addSearchTerm ? /*#__PURE__*/jsxs("div", {
          className: css$X.option,
          onClick: () => handleAddSearchTerm(searchTerm),
          children: ["Select \"", searchTerm, "\""]
        }) : /*#__PURE__*/jsx("div", {
          className: css$X.noOptions,
          children: "No options found"
        })
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$X.errorMessage,
      children: error
    })]
  });
};
SearchableDropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string.isRequired
};

const FilterFormInput = ({
  filterItem,
  value,
  onChange,
  isInline = false
}) => {
  const properties = filterItem.props;
  const commonProps = {
    name: properties.name
  };
  if (isInline) {
    commonProps.size = 'small';
  }
  switch (properties.type) {
    case 'text':
      return /*#__PURE__*/jsx(InputText, {
        ...commonProps,
        value: value || '',
        placeholder: properties.placeholder,
        label: properties.label,
        onChange: e => onChange(e.target.value)
      });
    case 'dropdown':
      if (!properties.options) {
        return null;
      }
      return /*#__PURE__*/jsx(Dropdown, {
        ...commonProps,
        value: value || '',
        options: properties.options,
        label: properties.label,
        onChange: e => onChange(e.target.value)
      });
    case 'searchableDropdown':
      if (!properties.options) {
        return null;
      }
      return /*#__PURE__*/jsx(SearchableDropdown, {
        ...commonProps,
        value: value || '',
        options: properties.options,
        label: properties.label,
        placeholder: properties.placeholder,
        onChange: e => onChange(e.target.value)
      });
    case 'multiSelect':
      if (!properties.options) {
        return null;
      }
      const handleSelectAll = () => {
        const optionValues = properties.options.map(option => option.value);
        const selectedValues = Array.isArray(value) ? value : [];
        const isAllSelected = optionValues.length > 0 && optionValues.every(optionValue => selectedValues.includes(optionValue));
        const nextValue = isAllSelected ? [] : optionValues;
        onChange(nextValue);
      };
      return /*#__PURE__*/jsx(MultiSelect, {
        ...commonProps,
        value: value || [],
        options: properties.options,
        label: properties.label,
        onChange: e => onChange(e.target.value),
        onSelectAll: properties.enableSelectAll ? handleSelectAll : undefined
      });
    case 'dateRange':
      const dateRangeValue = value || {};
      return /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(DateRangePicker, {
          ...commonProps,
          startDate: dateRangeValue.startDate,
          endDate: dateRangeValue.endDate,
          minDate: properties.minDate,
          maxDate: properties.maxDate,
          onStartDateChange: date => onChange({
            ...dateRangeValue,
            startDate: date
          }),
          onEndDateChange: date => onChange({
            ...dateRangeValue,
            endDate: date
          })
        })
      });
    case 'date':
      return /*#__PURE__*/jsx(InputCalendar, {
        ...commonProps,
        value: value || '',
        label: properties.label,
        onChange: e => onChange(e.target.value)
      });
    case 'month':
      return /*#__PURE__*/jsx(InputMonth, {
        ...commonProps,
        value: value || '',
        label: properties.label,
        onChange: e => onChange(e.target.value)
      });
    case 'toggle':
      return /*#__PURE__*/jsx("div", {
        children: /*#__PURE__*/jsx(ToggleSwitch, {
          ...commonProps,
          checked: value || false,
          onChange: checked => onChange(checked),
          label: properties.label
        })
      });
    default:
      return null;
  }
};

const AppliedFilters = ({
  showInlineInputs,
  availableFilterItems,
  appliedFilters,
  onChange,
  onRemove,
  onClearAll,
  onDropdownChange,
  onAppliedFilterChipClick
}) => {
  if (showInlineInputs) {
    return /*#__PURE__*/jsx("div", {
      className: css$10.badgesSection,
      children: /*#__PURE__*/jsx(InlineInputs, {
        availableFilterItems: availableFilterItems,
        filters: appliedFilters,
        onChange: onChange
      })
    });
  }
  return /*#__PURE__*/jsx("div", {
    className: css$10.badgesSection,
    children: /*#__PURE__*/jsx(AppliedFilterChipsList, {
      availableFilterItems: availableFilterItems,
      appliedFilters: appliedFilters,
      onChange: onChange,
      onRemove: onRemove,
      onClearAll: onClearAll,
      onDropdownChange: onDropdownChange,
      onAppliedFilterChipClick: onAppliedFilterChipClick
    })
  });
};
const InlineInputs = ({
  availableFilterItems,
  filters,
  onChange
}) => /*#__PURE__*/jsx(Fragment$1, {
  children: availableFilterItems.map(filterItem => /*#__PURE__*/jsx("div", {
    children: /*#__PURE__*/jsx(FilterFormInput, {
      filterItem: filterItem,
      value: filters[filterItem.props.name],
      onChange: val => onChange(filterItem.props.name, val),
      isInline: true
    })
  }, filterItem.name))
});
const AppliedFilterChipsList = ({
  availableFilterItems,
  appliedFilters,
  onChange,
  onRemove,
  onClearAll,
  onDropdownChange,
  onAppliedFilterChipClick
}) => {
  const filterKeys = Object.keys(appliedFilters);
  const filterValues = Object.values(appliedFilters);
  if (filterValues.every(val => val === '')) {
    return /*#__PURE__*/jsx("span", {
      children: "No filters applied"
    });
  }
  return /*#__PURE__*/jsxs("div", {
    className: css$10.badgesWrap,
    children: [filterKeys.map(name => /*#__PURE__*/jsx(AppliedFilterChip, {
      availableFilterItems: availableFilterItems,
      appliedFilters: appliedFilters,
      name: name,
      onChange: onChange,
      onRemove: onRemove,
      onDropdownChange: onDropdownChange,
      onAppliedFilterChipClick: onAppliedFilterChipClick
    }, name)), filterKeys.length > 0 && /*#__PURE__*/jsx("button", {
      className: css$10.clearAllBtn,
      onClick: onClearAll,
      type: "button",
      children: "Clear all"
    })]
  });
};
const AppliedFilterChip = ({
  availableFilterItems,
  appliedFilters,
  name,
  onChange,
  onRemove,
  onDropdownChange,
  onAppliedFilterChipClick
}) => {
  const filterItem = availableFilterItems.find(def => def.props.name === name);
  let value = appliedFilters[name];
  if (!filterItem || !value) {
    return null;
  }
  const properties = filterItem.props;
  if (properties.type === 'dropdown' || properties.type === 'searchableDropdown') {
    return /*#__PURE__*/jsxs("span", {
      className: css$10.badge + ' ' + css$10.badgeDropdown,
      children: [properties.label, ":", ' ', /*#__PURE__*/jsx("select", {
        value: value,
        onChange: e => onDropdownChange(name, e.target.value),
        children: properties.options.map(opt => /*#__PURE__*/jsx("option", {
          value: opt.value,
          children: opt.label
        }, opt.value))
      }), /*#__PURE__*/jsx(RemoveButton, {
        onClick: () => onRemove(name)
      })]
    }, name);
  }
  if (properties.type === 'dateRange') {
    return /*#__PURE__*/jsx(DateRangeChip, {
      name: name,
      label: properties.label,
      value: value,
      onChange: onChange,
      onRemove: onRemove
    });
  }
  if (properties.type === 'toggle') {
    return /*#__PURE__*/jsxs("span", {
      className: css$10.badge,
      children: [/*#__PURE__*/jsxs("span", {
        onClick: onAppliedFilterChipClick,
        children: [properties.label, ": ", value ? 'Yes' : 'No']
      }), /*#__PURE__*/jsx(RemoveButton, {
        onClick: () => onRemove(name)
      })]
    }, name);
  }
  if (properties.type === 'multiSelect') {
    if (Array.isArray(value) && value.length === 0) {
      return null;
    }
    return /*#__PURE__*/jsx(MultiSelectChip, {
      name: name,
      label: properties.label,
      value: value,
      options: properties.options,
      enableSelectAll: properties.enableSelectAll,
      onChange: onChange,
      onRemove: onRemove
    });
  }
  return /*#__PURE__*/jsxs("span", {
    className: css$10.badge,
    children: [/*#__PURE__*/jsxs("span", {
      onClick: onAppliedFilterChipClick,
      children: [properties.label, ": ", value]
    }), /*#__PURE__*/jsx(RemoveButton, {
      onClick: () => onRemove(name)
    })]
  }, name);
};
const MultiSelectChip = ({
  name,
  label,
  value,
  options,
  enableSelectAll,
  onChange,
  onRemove
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);
  const valuesLookup = options.reduce((acc, option) => {
    acc[option.value] = option.label;
    return acc;
  }, {});
  const labels = value.map(val => valuesLookup[val]);
  const maxDisplayItems = 3;
  let displayLabel;
  if (labels.length > maxDisplayItems) {
    displayLabel = `${labels.slice(0, maxDisplayItems).join(', ')} & ${labels.length - maxDisplayItems} more`;
  } else {
    displayLabel = labels.join(', ');
  }
  const handleSelectAll = () => {
    const allValues = options.map(opt => opt.value);
    const isAllSelected = allValues.length > 0 && allValues.every(v => value.includes(v));
    onChange(name, isAllSelected ? [] : allValues);
  };
  return /*#__PURE__*/jsxs("span", {
    ref: ref,
    className: css$10.badge,
    style: {
      position: 'relative'
    },
    children: [/*#__PURE__*/jsxs("span", {
      onClick: () => setOpen(!open),
      children: [label, ": ", displayLabel]
    }), /*#__PURE__*/jsx(RemoveButton, {
      onClick: () => onRemove(name)
    }), open && /*#__PURE__*/jsx("div", {
      className: css$10.chipPopover,
      children: /*#__PURE__*/jsx(MultiSelect, {
        value: value || [],
        options: options,
        label: label,
        onChange: e => onChange(name, e.target.value),
        onSelectAll: enableSelectAll ? handleSelectAll : undefined,
        defaultOpen: true
      })
    })]
  });
};
const DateRangeChip = ({
  name,
  label,
  value,
  onChange,
  onRemove
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const startDate = value?.startDate ?? null;
  const endDate = value?.endDate ?? null;
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);
  if (!startDate || !endDate) {
    return null;
  }
  return /*#__PURE__*/jsxs("span", {
    ref: ref,
    className: css$10.badge,
    style: {
      position: 'relative'
    },
    children: [/*#__PURE__*/jsxs("span", {
      onClick: () => setOpen(!open),
      children: [label, ": ", startDate, " \u2192 ", endDate]
    }), /*#__PURE__*/jsx(RemoveButton, {
      onClick: () => onRemove(name)
    }), open && /*#__PURE__*/jsx("div", {
      className: css$10.chipPopover,
      children: /*#__PURE__*/jsx(DateRangePicker, {
        startDate: startDate,
        endDate: endDate,
        onStartDateChange: date => onChange(name, {
          ...value,
          startDate: date
        }),
        onEndDateChange: date => onChange(name, {
          ...value,
          endDate: date
        })
      })
    })]
  });
};
const RemoveButton = ({
  onClick
}) => {
  return /*#__PURE__*/jsx("button", {
    className: css$10.closeBtn,
    onClick: onClick,
    children: "\xD7"
  });
};

var css_248z$X = ".Backdrop-module__backdrop___sB-mT{animation:Backdrop-module__fadeInDrawerBg___vDKSI .2s;background:rgba(50,50,100,.12);cursor:pointer;height:100vh;left:0;position:fixed;top:0;width:100vw;z-index:1100}@keyframes Backdrop-module__fadeInDrawerBg___vDKSI{0%{opacity:0}to{opacity:1}}";
var css$W = {"backdrop":"Backdrop-module__backdrop___sB-mT","fadeInDrawerBg":"Backdrop-module__fadeInDrawerBg___vDKSI"};
styleInject(css_248z$X);

const Backdrop = ({
  onClick
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$W.backdrop,
    onClick: onClick
  });
};

const FiltersSidePanel = ({
  filtersPanelOpen,
  availableFilterItems,
  appliedFilters,
  onChange,
  onClose,
  onApply,
  showInlineInputs,
  quickFilters
}) => {
  useTrackedHotkeys('esc', onClose, 'filters:side_panel_close', {
    enabled: filtersPanelOpen
  });
  if (!filtersPanelOpen || showInlineInputs) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs("div", {
      className: `${css$10.filtersPanel} ${filtersPanelOpen ? css$10.filtersPanelOpen : ''}`,
      children: [/*#__PURE__*/jsxs("div", {
        className: css$10.filtersPanelHeader,
        children: [/*#__PURE__*/jsxs("h2", {
          children: [/*#__PURE__*/jsx(Filter, {}), "Filter"]
        }), /*#__PURE__*/jsx("span", {
          className: css$10.closeBtn,
          onClick: onClose,
          children: /*#__PURE__*/jsx(X02, {})
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: css$10.filtersPanelBody,
        children: [quickFilters && /*#__PURE__*/jsx("div", {
          style: {
            marginBottom: '12px'
          },
          children: quickFilters
        }), /*#__PURE__*/jsx(FiltersForm, {
          availableFilterItems: availableFilterItems,
          appliedFilters: appliedFilters,
          onChange: onChange
        })]
      }), /*#__PURE__*/jsx("div", {
        className: css$10.filtersPanelFooter,
        children: /*#__PURE__*/jsx(Button$1, {
          icon: /*#__PURE__*/jsx(ArrowRefresh01, {}),
          onClick: onApply,
          children: "Load"
        })
      })]
    }), /*#__PURE__*/jsx(Backdrop, {
      onClick: onClose
    })]
  });
};
const FiltersForm = ({
  availableFilterItems,
  appliedFilters,
  onChange
}) => {
  return /*#__PURE__*/jsx(Fragment$1, {
    children: availableFilterItems.map((filterItem, index) => {
      const properties = filterItem.props;
      // Use the filterItem's key if available, otherwise fall back to name
      const itemKey = filterItem.key || properties.name || `filter-${index}`;
      return /*#__PURE__*/jsx("div", {
        className: css$10.filterInputGroup,
        children: /*#__PURE__*/jsx(FilterFormInput, {
          filterItem: filterItem,
          value: appliedFilters[properties.name] ?? null,
          onChange: val => onChange(properties.name, val)
        })
      }, itemKey);
    })
  });
};

const FilterBarItem = ({
  name,
  label,
  type,
  placeholder,
  defaultValue = null,
  options,
  minDate,
  maxDate,
  children
}) => {
  // This component acts as a declarative config-only component.
  // No need to render anything here.
  return null;
};
FilterBarItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text', 'dropdown', 'searchableDropdown', 'dateRange', 'date', 'month', 'toggle', 'multiSelect']).isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.any,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool, PropTypes.array]).isRequired
  })),
  enableSelectAll: PropTypes.bool,
  children: PropTypes.node
};

const FilterBarPillButton = ({
  label,
  onClick,
  active
}) => {
  const baseStyle = {
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 'var(--border-radius-small)',
    padding: '3px 10px',
    fontSize: 'var(--body-small-size)',
    lineHeight: 'var(--body-small-line-height)',
    marginRight: '2px',
    marginBottom: '2px',
    border: '1px solid var(--grey-20)',
    background: 'white',
    color: 'inherit'
  };
  const activeStyle = {
    background: 'var(--grey-8)'
  };
  return /*#__PURE__*/jsx("button", {
    type: "button",
    onClick: onClick,
    "aria-pressed": !!active,
    style: {
      ...baseStyle,
      ...(active ? activeStyle : null)
    },
    children: label
  });
};
FilterBarPillButton.__IS_FILTER_BAR_PILL_BUTTON = true;

const isSameFilterValue = (a, b) => {
  if (a === b) {
    return true;
  }
  return JSON.stringify(a) === JSON.stringify(b);
};
const FiltersBarWithSidePanel = ({
  children,
  onChange,
  onApply,
  onUpdate,
  onPdfExport,
  onCsvExport,
  onPrint,
  onExportAll,
  onRefresh,
  className,
  trackingContext,
  posthog,
  externalAppliedFilters,
  onUrlStateChange,
  alwaysShowPanel = false,
  forceInline = false
}) => {
  const location = useLocation();
  const childrenArray = Children.toArray(children);
  const availableFilterItems = childrenArray.filter(child => child.type && child.type === FilterBarItem);
  const pillButtons = childrenArray.filter(child => child.type && (child.type === FilterBarPillButton || child.type.__IS_FILTER_BAR_PILL_BUTTON));
  const getDefaultValues = items => {
    return items.reduce((acc, child) => {
      if (child.props.defaultValue) {
        acc[child.props.name] = child.props.defaultValue;
      }
      return acc;
    }, {});
  };
  const initFilters = items => {
    const filtersFromUrl = readFiltersFromUrl();
    return filtersFromUrl || getDefaultValues(items);
  };
  const notifyUrlStateChange = useCallback(filters => {
    if (!onUrlStateChange) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const encodedFilters = encodeFilters(filters);
    if (params.get('filters') === encodedFilters) {
      return;
    }
    params.set('filters', encodedFilters);
    onUrlStateChange(params);
  }, [onUrlStateChange]);
  const [appliedFilters, setAppliedFilters] = useState(() => initFilters(availableFilterItems));
  const [filtersPanelOpen, setFiltersPanelOpen] = useState(false);
  const [exportOpen, setExportOpen] = useState(false);
  const exportBtnRef = useRef();
  const [panelFilters, setPanelFilters] = useState(appliedFilters);
  const capture = (action, properties = null) => {
    if (trackingContext) {
      posthog.capture(trackingContext + ':filters:' + action, properties);
    }
  };
  const openFiltersPanel = () => {
    setFiltersPanelOpen(true);
    setPanelFilters(appliedFilters);
    capture('panel_open');
  };
  const handleChange = (key, value) => {
    if (filtersPanelOpen) {
      let nextDraft = {
        ...panelFilters,
        [key]: value
      };
      if (onUpdate) {
        nextDraft = onUpdate(key, value, {
          ...panelFilters
        });
      }
      setPanelFilters(nextDraft);
      // If onUpdate is provided is enabled, call onChange so parent can react and update filter options
      if (onUpdate) {
        onChange(nextDraft);
      }
      return;
    }
    const next = {
      ...appliedFilters,
      [key]: value
    };
    setAppliedFilters(next);
    onChange(next);
    notifyUrlStateChange(next);
  };
  const handleApply = () => {
    capture('apply');
    const nextApplied = filtersPanelOpen ? panelFilters : appliedFilters;
    setAppliedFilters(nextApplied);
    if (onApply) {
      onApply(nextApplied);
    } else {
      onChange(nextApplied);
    }
    setFiltersPanelOpen(false);
    notifyUrlStateChange(nextApplied);
  };
  const handleClearAll = () => {
    capture('clear_all');
    setAppliedFilters({});
    onChange({});
    notifyUrlStateChange({});
  };
  const handleRemove = filterName => {
    capture('remove', {
      filter: filterName
    });
    const newFilters = {
      ...appliedFilters
    };
    delete newFilters[filterName];
    setAppliedFilters(newFilters);
    onChange(newFilters);
    notifyUrlStateChange(newFilters);
  };
  const handleAppliedFilterChipDropdownChange = (filterName, value) => {
    capture('inline_change', {
      filter: filterName
    });
    const newFilters = {
      ...appliedFilters
    };
    newFilters[filterName] = value;
    setAppliedFilters(newFilters);
    onChange(newFilters);
    notifyUrlStateChange(newFilters);
  };
  const handleExport = format => {
    capture('export', {
      format: format
    });
    setExportOpen(false);
    if (format === 'pdf' && onPdfExport) onPdfExport();
    if (format === 'csv' && onCsvExport) onCsvExport();
    if (format === 'print' && onPrint) onPrint();
    if (format === 'exportAll' && onExportAll) onExportAll();
  };
  useEffect(() => {
    if (!exportOpen) return;
    const handle = e => {
      if (exportBtnRef.current && !exportBtnRef.current.contains(e.target)) {
        setExportOpen(false);
      }
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [exportOpen]);
  const showInlineInputs = !alwaysShowPanel && (forceInline || Children.count(children) <= 1);
  const exportOptions = [onPdfExport && {
    value: 'pdf',
    label: 'PDF'
  }, onCsvExport && {
    value: 'csv',
    label: 'CSV'
  }, onPrint && {
    value: 'print',
    label: 'Print'
  }, onExportAll && {
    value: 'exportAll',
    label: 'Export All'
  }].filter(Boolean);
  useEffect(() => {
    // Only proceed if externalAppliedFilters is valid
    if (externalAppliedFilters) {
      const updatedFilters = {
        ...appliedFilters
      };
      let changed = false;
      Object.keys(externalAppliedFilters).forEach(key => {
        if (externalAppliedFilters[key] !== undefined && !isSameFilterValue(externalAppliedFilters[key], appliedFilters[key])) {
          updatedFilters[key] = externalAppliedFilters[key];
          changed = true;
        }
      });
      if (changed) {
        setAppliedFilters(updatedFilters);
        notifyUrlStateChange(updatedFilters);
      }
    }
  }, [externalAppliedFilters, appliedFilters, notifyUrlStateChange]);
  useEffect(() => {
    onChange(appliedFilters);
  }, []);
  const urlFilters = new URLSearchParams(location.search).get('filters');
  useEffect(() => {
    if (!onUrlStateChange) {
      return;
    }
    const restoredFilters = initFilters(availableFilterItems);
    if (encodeFilters(restoredFilters) === encodeFilters(appliedFilters)) {
      return;
    }
    setAppliedFilters(restoredFilters);
    setPanelFilters(restoredFilters);
    if (onApply) {
      onApply(restoredFilters);
    } else {
      onChange(restoredFilters);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlFilters]);

  // Keep side panel filters in sync with applied filters when panel is open
  useEffect(() => {
    if (filtersPanelOpen) {
      setPanelFilters(appliedFilters);
    }
  }, [appliedFilters, filtersPanelOpen]);
  const renderedPills = pillButtons.length > 0 ? /*#__PURE__*/jsx("div", {
    style: {
      display: 'flex',
      gap: '8px'
    },
    children: pillButtons.map((pill, idx) => /*#__PURE__*/React.cloneElement(pill, {
      key: idx
    }))
  }) : null;
  useTrackedHotkeys('f', openFiltersPanel, 'filters:side_panel_view', {
    enabled: !showInlineInputs
  });
  return /*#__PURE__*/jsxs("div", {
    className: className,
    children: [/*#__PURE__*/jsx(FiltersBar, {
      showInlineInputs: showInlineInputs,
      availableFilterItems: availableFilterItems,
      appliedFilters: appliedFilters,
      onChange: handleChange,
      onRemove: handleRemove,
      onClearAll: handleClearAll,
      onDropdownChange: handleAppliedFilterChipDropdownChange,
      openFiltersPanel: openFiltersPanel,
      exportOptions: exportOptions,
      handleExportOption: handleExport,
      onAppliedFilterChipClick: () => setFiltersPanelOpen(true),
      quickFilters: renderedPills,
      onRefresh: onRefresh
    }), /*#__PURE__*/jsx(FiltersSidePanel, {
      showInlineInputs: showInlineInputs,
      filtersPanelOpen: filtersPanelOpen,
      availableFilterItems: availableFilterItems,
      appliedFilters: panelFilters,
      onChange: handleChange,
      onClose: () => setFiltersPanelOpen(false),
      onApply: handleApply,
      quickFilters: renderedPills
    })]
  });
};
const FiltersBar = ({
  showInlineInputs,
  availableFilterItems,
  appliedFilters,
  onChange,
  onRemove,
  onClearAll,
  onDropdownChange,
  openFiltersPanel,
  exportOptions,
  handleExportOption,
  onAppliedFilterChipClick,
  quickFilters,
  onRefresh
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${css$10.filtersBar} ${showInlineInputs && css$10.inlineInputsFiltersBar}`,
    children: [quickFilters, quickFilters && /*#__PURE__*/jsx("span", {
      "aria-hidden": true,
      style: {
        width: '1px',
        alignSelf: 'stretch',
        background: 'var(--grey-8)',
        margin: '0 12px',
        display: 'inline-block',
        borderRadius: '1px',
        opacity: 0.9
      }
    }), /*#__PURE__*/jsx(AppliedFilters, {
      showInlineInputs: showInlineInputs,
      availableFilterItems: availableFilterItems,
      appliedFilters: appliedFilters,
      onChange: onChange,
      onRemove: onRemove,
      onClearAll: onClearAll,
      onDropdownChange: onDropdownChange,
      onAppliedFilterChipClick: onAppliedFilterChipClick
    }), /*#__PURE__*/jsx(FilterButtonsSection, {
      showInlineInputs: showInlineInputs,
      openFiltersPanel: openFiltersPanel,
      exportOptions: exportOptions,
      handleExportOption: handleExportOption,
      onRefresh: onRefresh
    })]
  });
};
const FilterButtonsSection = ({
  showInlineInputs,
  openFiltersPanel,
  exportOptions,
  handleExportOption,
  onRefresh
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${css$10.buttonsSection} ${css$10.noPrint}`,
    children: [!showInlineInputs && /*#__PURE__*/jsx(Button$1, {
      size: "small",
      onClick: openFiltersPanel,
      icon: /*#__PURE__*/jsx(Filter, {}),
      children: "Filters"
    }), /*#__PURE__*/jsx(ColumnVisibility, {}), exportOptions.length > 0 && /*#__PURE__*/jsx(ExportDropdown, {
      options: exportOptions,
      onSelect: handleExportOption
    }), onRefresh && /*#__PURE__*/jsx(Button$1, {
      size: "small",
      icon: /*#__PURE__*/jsx(ArrowRefresh01, {}),
      onClick: onRefresh,
      variant: "tertiary"
    })]
  });
};
const ExportDropdown = ({
  options,
  onSelect
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    children: [/*#__PURE__*/jsx(Button$1, {
      size: "small",
      variant: "tertiary",
      onClick: () => setOpen(prev => !prev),
      children: /*#__PURE__*/jsx(Download02, {
        color: "var(--grey-64)"
      })
    }), open && /*#__PURE__*/jsx("div", {
      className: css$10.exportDropdownMenu,
      role: "listbox",
      children: options.map(opt => /*#__PURE__*/jsx("button", {
        className: css$10.exportDropdownItem,
        onClick: () => {
          onSelect(opt.value);
          setOpen(false);
        },
        children: opt.label
      }, opt.value))
    })]
  });
};
const ColumnVisibility = () => {
  const {
    visibleColumns,
    applyColumns,
    columnsVisibilityOptions
  } = useColumnVisibilityContext();
  const [open, setOpen] = useState(false);
  const ref = useRef();
  const [selectedColumns, setSelectedColumns] = useState(visibleColumns);
  useEffect(() => {
    setSelectedColumns(visibleColumns);
  }, [visibleColumns]);
  useEffect(() => {
    if (!open) return;
    const handleClickOutside = e => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);
  if (!columnsVisibilityOptions?.length) {
    return null;
  }
  const onConfirmColumnVisibility = () => {
    applyColumns(selectedColumns);
    setOpen(false);
  };
  const handleSelectAllColumns = () => {
    setSelectedColumns(columnsVisibilityOptions.map(opt => opt.value));
  };
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    children: [/*#__PURE__*/jsx(Button$1, {
      size: "small",
      variant: "tertiary",
      onClick: () => setOpen(prev => !prev),
      children: /*#__PURE__*/jsx(ColumnHorizontal01Icon, {
        color: "var(--grey-64)"
      })
    }), open && /*#__PURE__*/jsxs("div", {
      className: css$10.columnsVisibilityMenu,
      children: [/*#__PURE__*/jsx(MultiSelect, {
        label: "Columns to show:",
        onChange: evt => setSelectedColumns(evt.target.value),
        value: selectedColumns,
        options: columnsVisibilityOptions,
        onSelectAll: handleSelectAllColumns
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        size: "small",
        onClick: onConfirmColumnVisibility,
        children: "Confirm"
      })]
    })]
  });
};
FiltersBarWithSidePanel.propTypes = {
  children: PropTypes.node.isRequired,
  appliedFilters: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string
  })])),
  onChange: PropTypes.func,
  onPdfExport: PropTypes.func,
  onCsvExport: PropTypes.func,
  onPrint: PropTypes.func,
  onExportAll: PropTypes.func,
  onRefresh: PropTypes.func,
  className: PropTypes.string,
  onUrlStateChange: PropTypes.func,
  alwaysShowPanel: PropTypes.bool,
  forceInline: PropTypes.bool
};

var css_248z$W = ".NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo{border-radius:var(--border-radius-medium);display:flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);gap:6px;line-height:var(--body-regular-line-height);padding:4px}.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo>li{background-color:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-medium);cursor:pointer;display:flex;padding:8px 17px}.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo>li.NumericPagination-module__activePageNumber___NG9Bk{border:1px solid var(--primary-color)}.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo>li:hover:not(.NumericPagination-module__activePageNumber___NG9Bk){background-color:var(--primary-10);color:inherit}.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo .NumericPagination-module__paginationNextButton___Ym-Ov,.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo .NumericPagination-module__paginationPrevButton___pj9bd{align-items:center;display:flex;justify-content:center}.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo .NumericPagination-module__paginationNextButton___Ym-Ov>svg,.NumericPagination-module__paginationContainer___Uvipu .NumericPagination-module__pagination___7ueyo .NumericPagination-module__paginationPrevButton___pj9bd>svg{height:11px;width:11px}";
var css$V = {"paginationContainer":"NumericPagination-module__paginationContainer___Uvipu","pagination":"NumericPagination-module__pagination___7ueyo","activePageNumber":"NumericPagination-module__activePageNumber___NG9Bk","paginationNextButton":"NumericPagination-module__paginationNextButton___Ym-Ov","paginationPrevButton":"NumericPagination-module__paginationPrevButton___pj9bd"};
styleInject(css_248z$W);

const NumericPagination = ({
  itemsPerPage,
  totalItems,
  paginate,
  previousPage,
  nextPage,
  currentPage,
  lastPageNumber
}) => {
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }
  if (totalItems <= itemsPerPage) {
    return null;
  }
  return /*#__PURE__*/jsx("div", {
    className: css$V.paginationContainer,
    children: /*#__PURE__*/jsxs("ul", {
      className: css$V.pagination,
      children: [currentPage !== 1 && /*#__PURE__*/jsx("li", {
        onClick: previousPage,
        className: css$V.paginationPrevButton,
        children: /*#__PURE__*/jsx(ChevronLeft, {})
      }), pageNumbers.map(number => /*#__PURE__*/jsx("li", {
        onClick: () => paginate(number),
        className: number === currentPage ? css$V.activePageNumber : '',
        children: number
      }, number)), currentPage !== lastPageNumber && /*#__PURE__*/jsx("li", {
        onClick: nextPage,
        className: css$V.paginationNextButton,
        children: /*#__PURE__*/jsx(ChevronRight, {})
      })]
    })
  });
};

var css_248z$V = ".Pagination-module__container___5JDI-{align-items:center;display:flex;gap:12px;justify-content:space-between;padding:4px 0}.Pagination-module__range___F71fx{align-items:center;color:var(--grey-64);display:inline-flex;font-size:var(--body-small-size);gap:6px}.Pagination-module__separator___sNur0{user-select:none}.Pagination-module__perPageSelect___GEluK{background:var(--white);border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);color:var(--text);cursor:pointer;font-size:var(--body-small-size);padding:4px 6px}.Pagination-module__perPageSelect___GEluK:focus{border-color:var(--primary-color);outline:none}.Pagination-module__controls___PxOEY{align-items:center;display:flex;gap:8px}.Pagination-module__jumpRow___FbT91{align-items:center;color:var(--grey-64);display:inline-flex;font-size:var(--body-small-size);gap:6px}.Pagination-module__jumpLabel___tgCIW{user-select:none}.Pagination-module__jumpInput___BkRp7{background:var(--white);border:1px solid var(--grey-20);border-radius:var(--border-radius-medium);color:var(--text);font-size:var(--body-small-size);padding:4px 6px;text-align:center;width:56px}.Pagination-module__jumpInput___BkRp7:focus{border-color:var(--primary-color);outline:none}";
var css$U = {"container":"Pagination-module__container___5JDI-","range":"Pagination-module__range___F71fx","separator":"Pagination-module__separator___sNur0","perPageSelect":"Pagination-module__perPageSelect___GEluK","controls":"Pagination-module__controls___PxOEY","jumpRow":"Pagination-module__jumpRow___FbT91","jumpLabel":"Pagination-module__jumpLabel___tgCIW","jumpInput":"Pagination-module__jumpInput___BkRp7"};
styleInject(css_248z$V);

let keyboardNavigationOwners = 0;
const DEFAULT_ITEMS_PER_PAGE_OPTIONS = [10, 30, 50, 100];
const Pagination = ({
  itemsPerPage,
  totalItems,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
  itemsPerPageOptions = DEFAULT_ITEMS_PER_PAGE_OPTIONS,
  enableKeyboardNavigation = false
}) => {
  const lastPageNumber = Math.max(1, Math.ceil(totalItems / itemsPerPage));
  const [draftPage, setDraftPage] = useState(String(currentPage));
  const showItemsPerPageSelector = typeof onItemsPerPageChange === 'function';
  const itemsPerPageSelectOptions = showItemsPerPageSelector ? Array.from(new Set([...itemsPerPageOptions, itemsPerPage])).sort((a, b) => a - b) : itemsPerPageOptions;
  useEffect(() => {
    setDraftPage(String(currentPage));
  }, [currentPage]);
  useEffect(() => {
    if (!enableKeyboardNavigation) {
      return undefined;
    }
    const isOwner = keyboardNavigationOwners === 0;
    keyboardNavigationOwners += 1;
    if (!isOwner) {
      return () => {
        keyboardNavigationOwners -= 1;
      };
    }
    const handleKeyDown = e => {
      if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) {
        return;
      }
      const tag = e.target?.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || e.target?.isContentEditable) {
        return;
      }
      if (e.key === 'ArrowLeft' && currentPage > 1) {
        e.preventDefault();
        onPageChange(currentPage - 1);
      } else if (e.key === 'ArrowRight' && currentPage < lastPageNumber) {
        e.preventDefault();
        onPageChange(currentPage + 1);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      keyboardNavigationOwners -= 1;
    };
  }, [enableKeyboardNavigation, currentPage, lastPageNumber, onPageChange]);
  if (totalItems <= itemsPerPage && !showItemsPerPageSelector) {
    return null;
  }
  const rangeStart = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const rangeEnd = Math.min(currentPage * itemsPerPage, totalItems);
  const showPageNavigation = totalItems > itemsPerPage;
  const goToPage = target => {
    const clamped = Math.min(lastPageNumber, Math.max(1, target));
    setDraftPage(String(clamped));
    if (clamped !== currentPage) {
      onPageChange(clamped);
    }
  };
  const handlePreviousPage = () => {
    goToPage(currentPage - 1);
  };
  const handleNextPage = () => {
    goToPage(currentPage + 1);
  };
  const handleJumpInputChange = e => {
    setDraftPage(e.target.value);
  };
  const handleJumpCommit = () => {
    const parsed = parseInt(draftPage, 10);
    if (Number.isFinite(parsed)) {
      goToPage(parsed);
    } else {
      setDraftPage(String(currentPage));
    }
  };
  const handleJumpKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleJumpCommit();
    }
  };
  const handleItemsPerPageChange = e => {
    const next = parseInt(e.target.value, 10);
    if (Number.isFinite(next) && next !== itemsPerPage) {
      onItemsPerPageChange(next);
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: css$U.container,
    children: [/*#__PURE__*/jsxs("span", {
      className: css$U.range,
      children: [rangeStart, "\u2013", rangeEnd, " of ", totalItems, showItemsPerPageSelector && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx("span", {
          className: css$U.separator,
          children: "\xB7"
        }), /*#__PURE__*/jsx("select", {
          className: css$U.perPageSelect,
          value: itemsPerPage,
          onChange: handleItemsPerPageChange,
          "aria-label": "Items per page",
          children: itemsPerPageSelectOptions.map(option => /*#__PURE__*/jsx("option", {
            value: option,
            children: option
          }, option))
        }), /*#__PURE__*/jsx("span", {
          className: css$U.jumpLabel,
          children: "per page"
        })]
      })]
    }), showPageNavigation && /*#__PURE__*/jsxs("div", {
      className: css$U.controls,
      children: [/*#__PURE__*/jsx(Button$1, {
        type: "button",
        variant: "tertiary",
        size: "small",
        icon: /*#__PURE__*/jsx(ChevronLeft, {}),
        onClick: handlePreviousPage,
        disabled: currentPage <= 1,
        children: "Previous"
      }), /*#__PURE__*/jsxs("span", {
        className: css$U.jumpRow,
        children: [/*#__PURE__*/jsx("span", {
          className: css$U.jumpLabel,
          children: "Page"
        }), /*#__PURE__*/jsx("input", {
          type: "number",
          min: 1,
          max: lastPageNumber,
          className: css$U.jumpInput,
          value: draftPage,
          onChange: handleJumpInputChange,
          onBlur: handleJumpCommit,
          onKeyDown: handleJumpKeyDown
        }), /*#__PURE__*/jsxs("span", {
          className: css$U.jumpLabel,
          children: ["of ", lastPageNumber]
        })]
      }), /*#__PURE__*/jsx(Button$1, {
        type: "button",
        variant: "tertiary",
        size: "small",
        icon: /*#__PURE__*/jsx(ChevronRight, {}),
        iconPosition: "right",
        onClick: handleNextPage,
        disabled: currentPage >= lastPageNumber,
        children: "Next"
      })]
    })]
  });
};
Pagination.propTypes = {
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  onItemsPerPageChange: PropTypes.func,
  itemsPerPageOptions: PropTypes.arrayOf(PropTypes.number),
  enableKeyboardNavigation: PropTypes.bool
};

var css_248z$U = ".SecondaryToolbar-module__secondaryToolbar___Ijdx0{align-items:flex-end;background:var(--bg-dark);border-radius:var(--border-radius-medium);display:flex;flex-wrap:wrap;gap:15px;justify-content:space-between;margin-bottom:16px;padding:15px}.SecondaryToolbar-module__secondaryToolbar___Ijdx0 .SecondaryToolbar-module__actionGroup___5HlR0{display:flex;flex-direction:column;gap:5px;min-width:0}.SecondaryToolbar-module__secondaryToolbar___Ijdx0 .SecondaryToolbar-module__actionGroup___5HlR0 .SecondaryToolbar-module__actionGroupLabel___Ihxo2{color:var(--grey-64);font-size:var(--body-xs-size);font-weight:600;text-transform:uppercase}.SecondaryToolbar-module__secondaryToolbar___Ijdx0 .SecondaryToolbar-module__actionGroup___5HlR0 .SecondaryToolbar-module__actionGroupButtons___upH1T{display:flex;flex-wrap:wrap;gap:8px}.SecondaryToolbar-module__secondaryToolbar___Ijdx0 .SecondaryToolbar-module__mainActions___-xCgS{display:flex;flex-wrap:wrap;gap:8px;margin-left:auto}@media (max-width:768px){.SecondaryToolbar-module__secondaryToolbar___Ijdx0{align-items:stretch;flex-direction:column;gap:12px}.SecondaryToolbar-module__mainActions___-xCgS{justify-content:stretch;margin-left:0}.SecondaryToolbar-module__actionGroupButtons___upH1T{justify-content:stretch}}@media (max-width:480px){.SecondaryToolbar-module__mainActions___-xCgS{margin-left:0!important}a,button{width:100%}a{display:block}a button{width:100%}}";
var css$T = {"secondaryToolbar":"SecondaryToolbar-module__secondaryToolbar___Ijdx0","actionGroup":"SecondaryToolbar-module__actionGroup___5HlR0","actionGroupLabel":"SecondaryToolbar-module__actionGroupLabel___Ihxo2","actionGroupButtons":"SecondaryToolbar-module__actionGroupButtons___upH1T","mainActions":"SecondaryToolbar-module__mainActions___-xCgS"};
styleInject(css_248z$U);

const SecondaryToolbar = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$T.secondaryToolbar,
    children: children
  });
};

const SecondaryToolbarActionGroup = ({
  name,
  children
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$T.actionGroup,
    children: [/*#__PURE__*/jsx("div", {
      className: css$T.actionGroupLabel,
      children: name
    }), /*#__PURE__*/jsx("div", {
      className: css$T.actionGroupButtons,
      children: children
    })]
  });
};

const SecondaryToolbarMainActions = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$T.mainActions,
    children: children
  });
};

var css_248z$T = ".Toolbar-module__toolbar___iaHys{display:flex;flex-wrap:nowrap;gap:5px;margin-top:0;min-width:min-content;padding:5px;position:relative}.Toolbar-module__toolbar___iaHys .Toolbar-module__active___Pcgcv{background-color:var(--primary-50)}.Toolbar-module__toolbar___iaHys button{flex-shrink:0;height:35px!important;margin-top:0!important}@media (max-width:768px){.Toolbar-module__toolbar___iaHys{max-width:100%;min-width:0;width:100%}}";
var css$S = {"toolbar":"Toolbar-module__toolbar___iaHys","active":"Toolbar-module__active___Pcgcv"};
styleInject(css_248z$T);

const Toolbar = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$S.toolbar,
    children: children
  });
};

// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function OrderedMap(content) {
  this.content = content;
}

OrderedMap.prototype = {
  constructor: OrderedMap,

  find: function(key) {
    for (var i = 0; i < this.content.length; i += 2)
      if (this.content[i] === key) return i
    return -1
  },

  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(key) {
    var found = this.find(key);
    return found == -1 ? undefined : this.content[found + 1]
  },

  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(key, value, newKey) {
    var self = newKey && newKey != key ? this.remove(newKey) : this;
    var found = self.find(key), content = self.content.slice();
    if (found == -1) {
      content.push(newKey || key, value);
    } else {
      content[found + 1] = value;
      if (newKey) content[found] = newKey;
    }
    return new OrderedMap(content)
  },

  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(key) {
    var found = this.find(key);
    if (found == -1) return this
    var content = this.content.slice();
    content.splice(found, 2);
    return new OrderedMap(content)
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(key, value) {
    return new OrderedMap([key, value].concat(this.remove(key).content))
  },

  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(key, value) {
    var content = this.remove(key).content.slice();
    content.push(key, value);
    return new OrderedMap(content)
  },

  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(place, key, value) {
    var without = this.remove(key), content = without.content.slice();
    var found = without.find(place);
    content.splice(found == -1 ? content.length : found, 0, key, value);
    return new OrderedMap(content)
  },

  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(f) {
    for (var i = 0; i < this.content.length; i += 2)
      f(this.content[i], this.content[i + 1]);
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(map.content.concat(this.subtract(map).content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(map) {
    map = OrderedMap.from(map);
    if (!map.size) return this
    return new OrderedMap(this.subtract(map).content.concat(map.content))
  },

  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(map) {
    var result = this;
    map = OrderedMap.from(map);
    for (var i = 0; i < map.content.length; i += 2)
      result = result.remove(map.content[i]);
    return result
  },

  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var result = {};
    this.forEach(function(key, value) { result[key] = value; });
    return result
  },

  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1
  }
};

// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
OrderedMap.from = function(value) {
  if (value instanceof OrderedMap) return value
  var content = [];
  if (value) for (var prop in value) content.push(prop, value[prop]);
  return new OrderedMap(content)
};

function findDiffStart(a, b, pos) {
    for (let i = 0;; i++) {
        if (i == a.childCount || i == b.childCount)
            return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB))
            return pos;
        if (childA.isText && childA.text != childB.text) {
            let tA = childA.text, tB = childB.text, j = 0;
            for (; tA[j] == tB[j]; j++)
                pos++;
            if (j && j < tA.length && j < tB.length && surrogateHigh(tA.charCodeAt(j - 1)) && surrogateLow(tA.charCodeAt(j)))
                pos--;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null)
                return inner;
        }
        pos += childA.nodeSize;
    }
}
function findDiffEnd(a, b, posA, posB) {
    for (let iA = a.childCount, iB = b.childCount;;) {
        if (iA == 0 || iB == 0)
            return iA == iB ? null : { a: posA, b: posB };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB))
            return { a: posA, b: posB };
        if (childA.isText && childA.text != childB.text) {
            let tA = childA.text, tB = childB.text, iA = tA.length, iB = tB.length;
            while (iA > 0 && iB > 0 && tA[iA - 1] == tB[iB - 1]) {
                iA--;
                iB--;
                posA--;
                posB--;
            }
            if (iA && iB && iA < tA.length && surrogateHigh(tA.charCodeAt(iA - 1)) && surrogateLow(tA.charCodeAt(iA))) {
                posA++;
                posB++;
            }
            return { a: posA, b: posB };
        }
        if (childA.content.size || childB.content.size) {
            let inner = findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner)
                return inner;
        }
        posA -= size;
        posB -= size;
    }
}
function surrogateLow(ch) { return ch >= 0xDC00 && ch < 0xE000; }
function surrogateHigh(ch) { return ch >= 0xD800 && ch < 0xDC00; }

/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/
class Fragment {
    /**
    @internal
    */
    constructor(
    /**
    The child nodes in this fragment.
    */
    content, size) {
        this.content = content;
        this.size = size || 0;
        if (size == null)
            for (let i = 0; i < content.length; i++)
                this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */
    nodesBetween(from, to, f, nodeStart = 0, parent) {
        for (let i = 0, pos = 0; pos < to; i++) {
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */
    descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */
    textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos) => {
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos)
                : !node.isLeaf ? ""
                    : leafText ? (typeof leafText === "function" ? leafText(node) : leafText)
                        : node.type.spec.leafText ? node.type.spec.leafText(node)
                            : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first)
                    first = false;
                else
                    text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */
    append(other) {
        if (!other.size)
            return this;
        if (!this.size)
            return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for (; i < other.content.length; i++)
            content.push(other.content[i]);
        return new Fragment(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */
    cut(from, to = this.size) {
        if (from == 0 && to == this.size)
            return this;
        let result = [], size = 0;
        if (to > from)
            for (let i = 0, pos = 0; pos < to; i++) {
                let child = this.content[i], end = pos + child.nodeSize;
                if (end > from) {
                    if (pos < from || end > to) {
                        if (child.isText)
                            child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                        else
                            child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                    }
                    result.push(child);
                    size += child.nodeSize;
                }
                pos = end;
            }
        return new Fragment(result, size);
    }
    /**
    @internal
    */
    cutByIndex(from, to) {
        if (from == to)
            return Fragment.empty;
        if (from == 0 && to == this.content.length)
            return this;
        return new Fragment(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */
    replaceChild(index, node) {
        let current = this.content[index];
        if (current == node)
            return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new Fragment(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */
    addToStart(node) {
        return new Fragment([node].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */
    addToEnd(node) {
        return new Fragment(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */
    eq(other) {
        if (this.content.length != other.content.length)
            return false;
        for (let i = 0; i < this.content.length; i++)
            if (!this.content[i].eq(other.content[i]))
                return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */
    get firstChild() { return this.content.length ? this.content[0] : null; }
    /**
    The last child of the fragment, or `null` if it is empty.
    */
    get lastChild() { return this.content.length ? this.content[this.content.length - 1] : null; }
    /**
    The number of child nodes in this fragment.
    */
    get childCount() { return this.content.length; }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */
    child(index) {
        let found = this.content[index];
        if (!found)
            throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */
    maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */
    forEach(f) {
        for (let i = 0, p = 0; i < this.content.length; i++) {
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */
    findDiffStart(other, pos = 0) {
        return findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */
    findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */
    findIndex(pos) {
        if (pos == 0)
            return retIndex(0, pos);
        if (pos == this.size)
            return retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0)
            throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for (let i = 0, curPos = 0;; i++) {
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos)
                    return retIndex(i + 1, end);
                return retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */
    toString() { return "<" + this.toStringInner() + ">"; }
    /**
    @internal
    */
    toStringInner() { return this.content.join(", "); }
    /**
    Create a JSON-serializeable representation of this fragment.
    */
    toJSON() {
        return this.content.length ? this.content.map(n => n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */
    static fromJSON(schema, value) {
        if (!value)
            return Fragment.empty;
        if (!Array.isArray(value))
            throw new RangeError("Invalid input for Fragment.fromJSON");
        return Fragment.fromArray(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */
    static fromArray(array) {
        if (!array.length)
            return Fragment.empty;
        let joined, size = 0;
        for (let i = 0; i < array.length; i++) {
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined)
                    joined = array.slice(0, i);
                joined[joined.length - 1] = node
                    .withText(joined[joined.length - 1].text + node.text);
            }
            else if (joined) {
                joined.push(node);
            }
        }
        return new Fragment(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */
    static from(nodes) {
        if (!nodes)
            return Fragment.empty;
        if (nodes instanceof Fragment)
            return nodes;
        if (Array.isArray(nodes))
            return this.fromArray(nodes);
        if (nodes.attrs)
            return new Fragment([nodes], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" +
            (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/
Fragment.empty = new Fragment([], 0);
const found = { index: 0, offset: 0 };
function retIndex(index, offset) {
    found.index = index;
    found.offset = offset;
    return found;
}

function compareDeep(a, b) {
    if (a === b)
        return true;
    if (!(a && typeof a == "object") ||
        !(b && typeof b == "object"))
        return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array)
        return false;
    if (array) {
        if (a.length != b.length)
            return false;
        for (let i = 0; i < a.length; i++)
            if (!compareDeep(a[i], b[i]))
                return false;
    }
    else {
        for (let p in a)
            if (!(p in b) || !compareDeep(a[p], b[p]))
                return false;
        for (let p in b)
            if (!(p in a))
                return false;
    }
    return true;
}

/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/
let Mark$1 = class Mark {
    /**
    @internal
    */
    constructor(
    /**
    The type of this mark.
    */
    type, 
    /**
    The attributes associated with this mark.
    */
    attrs) {
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */
    addToSet(set) {
        let copy, placed = false;
        for (let i = 0; i < set.length; i++) {
            let other = set[i];
            if (this.eq(other))
                return set;
            if (this.type.excludes(other.type)) {
                if (!copy)
                    copy = set.slice(0, i);
            }
            else if (other.type.excludes(this.type)) {
                return set;
            }
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy)
                        copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy)
                    copy.push(other);
            }
        }
        if (!copy)
            copy = set.slice();
        if (!placed)
            copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */
    removeFromSet(set) {
        for (let i = 0; i < set.length; i++)
            if (this.eq(set[i]))
                return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */
    isInSet(set) {
        for (let i = 0; i < set.length; i++)
            if (this.eq(set[i]))
                return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */
    eq(other) {
        return this == other ||
            (this.type == other.type && compareDeep(this.attrs, other.attrs));
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */
    toJSON() {
        let obj = { type: this.type.name };
        for (let _ in this.attrs) {
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */
    static fromJSON(schema, json) {
        if (!json)
            throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type)
            throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */
    static sameSet(a, b) {
        if (a == b)
            return true;
        if (a.length != b.length)
            return false;
        for (let i = 0; i < a.length; i++)
            if (!a[i].eq(b[i]))
                return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */
    static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0)
            return Mark.none;
        if (marks instanceof Mark)
            return [marks];
        let copy = marks.slice();
        copy.sort((a, b) => a.type.rank - b.type.rank);
        return copy;
    }
};
/**
The empty set of marks.
*/
Mark$1.none = [];

/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/
class ReplaceError extends Error {
}
/**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/
class Slice {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */
    constructor(
    /**
    The slice's content.
    */
    content, 
    /**
    The open depth at the start of the fragment.
    */
    openStart, 
    /**
    The open depth at the end.
    */
    openEnd) {
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */
    get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */
    insertAt(pos, fragment) {
        let content = insertInto(this.content, pos + this.openStart, fragment, this.openStart + 1, this.openEnd + 1);
        return content && new Slice(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */
    removeBetween(from, to) {
        return new Slice(removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */
    eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */
    toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */
    toJSON() {
        if (!this.content.size)
            return null;
        let json = { content: this.content.toJSON() };
        if (this.openStart > 0)
            json.openStart = this.openStart;
        if (this.openEnd > 0)
            json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */
    static fromJSON(schema, json) {
        if (!json)
            return Slice.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number")
            throw new RangeError("Invalid input for Slice.fromJSON");
        return new Slice(Fragment.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */
    static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for (let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)
            openStart++;
        for (let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)
            openEnd++;
        return new Slice(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/
Slice.empty = new Slice(Fragment.empty, 0, 0);
function removeRange(content, from, to) {
    let { index, offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText)
            throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo)
        throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy(removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function insertInto(content, dist, insert, openStart, openEnd, parent) {
    let { index, offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && openStart <= 0 && openEnd <= 0 && !parent.canReplace(index, index, insert))
            return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = insertInto(child.content, dist - offset - 1, insert, index == 0 ? openStart - 1 : 0, index == content.childCount - 1 ? openEnd - 1 : 0, child);
    return inner && content.replaceChild(index, child.copy(inner));
}
function replace($from, $to, slice) {
    if (slice.openStart > $from.depth)
        throw new ReplaceError("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd)
        throw new ReplaceError("Inconsistent open depths");
    return replaceOuter($from, $to, slice, 0);
}
function replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    }
    else if (!slice.content.size) {
        return close(node, replaceTwoWay($from, $to, depth));
    }
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) { // Simple, flat case
        let parent = $from.parent, content = parent.content;
        return close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    }
    else {
        let { start, end } = prepareSliceForReplace(slice, $from);
        return close(node, replaceThreeWay($from, start, end, $to, depth));
    }
}
function checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type))
        throw new ReplaceError("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function joinable$1($before, $after, depth) {
    let node = $before.node(depth);
    checkJoin(node, $after.node(depth));
    return node;
}
function addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last]))
        target[last] = child.withText(target[last].text + child.text);
    else
        target.push(child);
}
function addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) {
            startIndex++;
        }
        else if ($start.textOffset) {
            addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for (let i = startIndex; i < endIndex; i++)
        addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset)
        addNode($end.nodeBefore, target);
}
function close(node, content) {
    if (!node.type.validContent(content))
        throw new ReplaceError("Invalid content for node " + node.type.name);
    return node.copy(content);
}
function replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && joinable$1($from, $start, depth + 1);
    let openEnd = $to.depth > depth && joinable$1($end, $to, depth + 1);
    let content = [];
    addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        checkJoin(openStart, openEnd);
        addNode(close(openStart, replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    }
    else {
        if (openStart)
            addNode(close(openStart, replaceTwoWay($from, $start, depth + 1)), content);
        addRange($start, $end, depth, content);
        if (openEnd)
            addNode(close(openEnd, replaceTwoWay($end, $to, depth + 1)), content);
    }
    addRange($to, null, depth, content);
    return new Fragment(content);
}
function replaceTwoWay($from, $to, depth) {
    let content = [];
    addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = joinable$1($from, $to, depth + 1);
        addNode(close(type, replaceTwoWay($from, $to, depth + 1)), content);
    }
    addRange($to, null, depth, content);
    return new Fragment(content);
}
function prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for (let i = extra - 1; i >= 0; i--)
        node = $along.node(i).copy(Fragment.from(node));
    return { start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra) };
}

/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/
class ResolvedPos {
    /**
    @internal
    */
    constructor(
    /**
    The position that was resolved.
    */
    pos, 
    /**
    @internal
    */
    path, 
    /**
    The offset this position has into its parent node.
    */
    parentOffset) {
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */
    resolveDepth(val) {
        if (val == null)
            return this.depth;
        if (val < 0)
            return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */
    get parent() { return this.node(this.depth); }
    /**
    The root node in which the position was resolved.
    */
    get doc() { return this.node(0); }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */
    node(depth) { return this.path[this.resolveDepth(depth) * 3]; }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */
    index(depth) { return this.path[this.resolveDepth(depth) * 3 + 1]; }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */
    indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */
    start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */
    end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */
    before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth)
            throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */
    after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth)
            throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */
    get textOffset() { return this.pos - this.path[this.path.length - 1]; }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */
    get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount)
            return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */
    get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff)
            return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */
    posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for (let i = 0; i < index; i++)
            pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */
    marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0)
            return Mark$1.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset)
            return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for (var i = 0; i < marks.length; i++)
            if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks)))
                marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */
    marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline)
            return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for (var i = 0; i < marks.length; i++)
            if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks)))
                marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */
    sharedDepth(pos) {
        for (let depth = this.depth; depth > 0; depth--)
            if (this.start(depth) <= pos && this.end(depth) >= pos)
                return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */
    blockRange(other = this, pred) {
        if (other.pos < this.pos)
            return other.blockRange(this);
        for (let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)
            if (other.pos <= this.end(d) && (!pred || pred(this.node(d))))
                return new NodeRange(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */
    sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */
    max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */
    min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */
    toString() {
        let str = "";
        for (let i = 1; i <= this.depth; i++)
            str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */
    static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size))
            throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for (let node = doc;;) {
            let { index, offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem)
                break;
            node = node.child(index);
            if (node.isText)
                break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new ResolvedPos(pos, path, parentOffset);
    }
    /**
    @internal
    */
    static resolveCached(doc, pos) {
        let cache = resolveCache.get(doc);
        if (cache) {
            for (let i = 0; i < cache.elts.length; i++) {
                let elt = cache.elts[i];
                if (elt.pos == pos)
                    return elt;
            }
        }
        else {
            resolveCache.set(doc, cache = new ResolveCache);
        }
        let result = cache.elts[cache.i] = ResolvedPos.resolve(doc, pos);
        cache.i = (cache.i + 1) % resolveCacheSize;
        return result;
    }
}
class ResolveCache {
    constructor() {
        this.elts = [];
        this.i = 0;
    }
}
const resolveCacheSize = 12, resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/
class NodeRange {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */
    constructor(
    /**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */
    $from, 
    /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */
    $to, 
    /**
    The depth of the node that this range points into.
    */
    depth) {
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */
    get start() { return this.$from.before(this.depth + 1); }
    /**
    The position at the end of the range.
    */
    get end() { return this.$to.after(this.depth + 1); }
    /**
    The parent node that the range points into.
    */
    get parent() { return this.$from.node(this.depth); }
    /**
    The start index of the range in the parent node.
    */
    get startIndex() { return this.$from.index(this.depth); }
    /**
    The end index of the range in the parent node.
    */
    get endIndex() { return this.$to.indexAfter(this.depth); }
}

const emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/
let Node$1 = class Node {
    /**
    @internal
    */
    constructor(
    /**
    The type of node that this is.
    */
    type, 
    /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */
    attrs, 
    // A fragment holding the node's children.
    content, 
    /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */
    marks = Mark$1.none) {
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || Fragment.empty;
    }
    /**
    The array of this node's child nodes.
    */
    get children() { return this.content.content; }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */
    get nodeSize() { return this.isLeaf ? 1 : 2 + this.content.size; }
    /**
    The number of children that the node has.
    */
    get childCount() { return this.content.childCount; }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */
    child(index) { return this.content.child(index); }
    /**
    Get the child node at the given index, if it exists.
    */
    maybeChild(index) { return this.content.maybeChild(index); }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */
    forEach(f) { this.content.forEach(f); }
    /**
    Invoke a callback for all descendant nodes recursively overlapping
    the given two positions that are relative to start of this
    node's content. This includes all ancestors of the nodes
    containing the two positions. The callback is invoked with the
    node, its position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */
    nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */
    descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */
    get textContent() {
        return (this.isLeaf && this.type.spec.leafText)
            ? this.type.spec.leafText(this)
            : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
    */
    textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */
    get firstChild() { return this.content.firstChild; }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */
    get lastChild() { return this.content.lastChild; }
    /**
    Test whether two nodes represent the same piece of document.
    */
    eq(other) {
        return this == other || (this.sameMarkup(other) && this.content.eq(other.content));
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */
    sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */
    hasMarkup(type, attrs, marks) {
        return this.type == type &&
            compareDeep(this.attrs, attrs || type.defaultAttrs || emptyAttrs) &&
            Mark$1.sameSet(this.marks, marks || Mark$1.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */
    copy(content = null) {
        if (content == this.content)
            return this;
        return new Node(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */
    mark(marks) {
        return marks == this.marks ? this : new Node(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */
    cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size)
            return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */
    slice(from, to = this.content.size, includeParents = false) {
        if (from == to)
            return Slice.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new Slice(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */
    replace(from, to, slice) {
        return replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */
    nodeAt(pos) {
        for (let node = this;;) {
            let { index, offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node)
                return null;
            if (offset == pos || node.isText)
                return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */
    childAfter(pos) {
        let { index, offset } = this.content.findIndex(pos);
        return { node: this.content.maybeChild(index), index, offset };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */
    childBefore(pos) {
        if (pos == 0)
            return { node: null, index: 0, offset: 0 };
        let { index, offset } = this.content.findIndex(pos);
        if (offset < pos)
            return { node: this.content.child(index), index, offset };
        let node = this.content.child(index - 1);
        return { node, index: index - 1, offset: offset - node.nodeSize };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */
    resolve(pos) { return ResolvedPos.resolveCached(this, pos); }
    /**
    @internal
    */
    resolveNoCache(pos) { return ResolvedPos.resolve(this, pos); }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */
    rangeHasMark(from, to, type) {
        let found = false;
        if (to > from)
            this.nodesBetween(from, to, node => {
                if (type.isInSet(node.marks))
                    found = true;
                return !found;
            });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */
    get isBlock() { return this.type.isBlock; }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */
    get isTextblock() { return this.type.isTextblock; }
    /**
    True when this node allows inline content.
    */
    get inlineContent() { return this.type.inlineContent; }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */
    get isInline() { return this.type.isInline; }
    /**
    True when this is a text node.
    */
    get isText() { return this.type.isText; }
    /**
    True when this is a leaf node.
    */
    get isLeaf() { return this.type.isLeaf; }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */
    get isAtom() { return this.type.isAtom; }
    /**
    Return a string representation of this node for debugging
    purposes.
    */
    toString() {
        if (this.type.spec.toDebugString)
            return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size)
            name += "(" + this.content.toStringInner() + ")";
        return wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */
    contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match)
            throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */
    canReplace(from, to, replacement = Fragment.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd)
            return false;
        for (let i = start; i < end; i++)
            if (!this.type.allowsMarks(replacement.child(i).marks))
                return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */
    canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks))
            return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */
    canAppend(other) {
        if (other.content.size)
            return this.canReplace(this.childCount, this.childCount, other.content);
        else
            return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */
    check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = Mark$1.none;
        for (let i = 0; i < this.marks.length; i++) {
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!Mark$1.sameSet(copy, this.marks))
            throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map(m => m.type.name)}`);
        this.content.forEach(node => node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */
    toJSON() {
        let obj = { type: this.type.name };
        for (let _ in this.attrs) {
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size)
            obj.content = this.content.toJSON();
        if (this.marks.length)
            obj.marks = this.marks.map(n => n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */
    static fromJSON(schema, json) {
        if (!json)
            throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks))
                throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string")
                throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = Fragment.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
};
Node$1.prototype.text = undefined;
class TextNode extends Node$1 {
    /**
    @internal
    */
    constructor(type, attrs, content, marks) {
        super(type, attrs, null, marks);
        if (!content)
            throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString)
            return this.type.spec.toDebugString(this);
        return wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() { return this.text; }
    textBetween(from, to) { return this.text.slice(from, to); }
    get nodeSize() { return this.text.length; }
    mark(marks) {
        return marks == this.marks ? this : new TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text)
            return this;
        return new TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length)
            return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function wrapMarks(marks, str) {
    for (let i = marks.length - 1; i >= 0; i--)
        str = marks[i].type.name + "(" + str + ")";
    return str;
}

/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/
class ContentMatch {
    /**
    @internal
    */
    constructor(
    /**
    True when this match state represents a valid end of the node.
    */
    validEnd) {
        this.validEnd = validEnd;
        /**
        @internal
        */
        this.next = [];
        /**
        @internal
        */
        this.wrapCache = [];
    }
    /**
    @internal
    */
    static parse(string, nodeTypes) {
        let stream = new TokenStream(string, nodeTypes);
        if (stream.next == null)
            return ContentMatch.empty;
        let expr = parseExpr(stream);
        if (stream.next)
            stream.err("Unexpected trailing text");
        let match = dfa(nfa(expr));
        checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */
    matchType(type) {
        for (let i = 0; i < this.next.length; i++)
            if (this.next[i].type == type)
                return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */
    matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for (let i = start; cur && i < end; i++)
            cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */
    get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */
    get defaultType() {
        for (let i = 0; i < this.next.length; i++) {
            let { type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs()))
                return type;
        }
        return null;
    }
    /**
    @internal
    */
    compatible(other) {
        for (let i = 0; i < this.next.length; i++)
            for (let j = 0; j < other.next.length; j++)
                if (this.next[i].type == other.next[j].type)
                    return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */
    fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [this];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd))
                return Fragment.from(types.map(tp => tp.createAndFill()));
            for (let i = 0; i < match.next.length; i++) {
                let { type, next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found)
                        return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */
    findWrapping(target) {
        for (let i = 0; i < this.wrapCache.length; i += 2)
            if (this.wrapCache[i] == target)
                return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */
    computeWrapping(target) {
        let seen = Object.create(null), active = [{ match: this, type: null, via: null }];
        while (active.length) {
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for (let obj = current; obj.type; obj = obj.via)
                    result.push(obj.type);
                return result.reverse();
            }
            for (let i = 0; i < match.next.length; i++) {
                let { type, next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({ match: type.contentMatch, type, via: current });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */
    get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */
    edge(n) {
        if (n >= this.next.length)
            throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */
    toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for (let i = 0; i < m.next.length; i++)
                if (seen.indexOf(m.next[i].next) == -1)
                    scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i) => {
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for (let i = 0; i < m.next.length; i++)
                out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/
ContentMatch.empty = new ContentMatch(true);
class TokenStream {
    constructor(string, nodeTypes) {
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "")
            this.tokens.pop();
        if (this.tokens[0] == "")
            this.tokens.shift();
    }
    get next() { return this.tokens[this.pos]; }
    eat(tok) { return this.next == tok && (this.pos++ || true); }
    err(str) { throw new SyntaxError(str + " (in content expression '" + this.string + "')"); }
}
function parseExpr(stream) {
    let exprs = [];
    do {
        exprs.push(parseExprSeq(stream));
    } while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
}
function parseExprSeq(stream) {
    let exprs = [];
    do {
        exprs.push(parseExprSubscript(stream));
    } while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : { type: "seq", exprs };
}
function parseExprSubscript(stream) {
    let expr = parseExprAtom(stream);
    for (;;) {
        if (stream.eat("+"))
            expr = { type: "plus", expr };
        else if (stream.eat("*"))
            expr = { type: "star", expr };
        else if (stream.eat("?"))
            expr = { type: "opt", expr };
        else if (stream.eat("{"))
            expr = parseExprRange(stream, expr);
        else
            break;
    }
    return expr;
}
function parseNum(stream) {
    if (/\D/.test(stream.next))
        stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function parseExprRange(stream, expr) {
    let min = parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}")
            max = parseNum(stream);
        else
            max = -1;
    }
    if (!stream.eat("}"))
        stream.err("Unclosed braced range");
    return { type: "range", min, max, expr };
}
function resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type)
        return [type];
    let result = [];
    for (let typeName in types) {
        let type = types[typeName];
        if (type.isInGroup(name))
            result.push(type);
    }
    if (result.length == 0)
        stream.err("No node type or group '" + name + "' found");
    return result;
}
function parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = parseExpr(stream);
        if (!stream.eat(")"))
            stream.err("Missing closing paren");
        return expr;
    }
    else if (!/\W/.test(stream.next)) {
        let exprs = resolveName(stream, stream.next).map(type => {
            if (stream.inline == null)
                stream.inline = type.isInline;
            else if (stream.inline != type.isInline)
                stream.err("Mixing inline and block content");
            return { type: "name", value: type };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : { type: "choice", exprs };
    }
    else {
        stream.err("Unexpected token '" + stream.next + "'");
    }
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function nfa(expr) {
    let nfa = [[]];
    connect(compile(expr, 0), node());
    return nfa;
    function node() { return nfa.push([]) - 1; }
    function edge(from, to, term) {
        let edge = { term, to };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach(edge => edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") {
            return expr.exprs.reduce((out, expr) => out.concat(compile(expr, from)), []);
        }
        else if (expr.type == "seq") {
            for (let i = 0;; i++) {
                let next = compile(expr.exprs[i], from);
                if (i == expr.exprs.length - 1)
                    return next;
                connect(next, from = node());
            }
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [edge(loop)];
        }
        else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [edge(loop)];
        }
        else if (expr.type == "opt") {
            return [edge(from)].concat(compile(expr.expr, from));
        }
        else if (expr.type == "range") {
            let cur = from;
            for (let i = 0; i < expr.min; i++) {
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) {
                connect(compile(expr.expr, cur), cur);
            }
            else {
                for (let i = expr.min; i < expr.max; i++) {
                    let next = node();
                    edge(cur, next);
                    connect(compile(expr.expr, cur), next);
                    cur = next;
                }
            }
            return [edge(cur)];
        }
        else if (expr.type == "name") {
            return [edge(from, undefined, expr.value)];
        }
        else {
            throw new Error("Unknown expr type");
        }
    }
}
function cmp(a, b) { return b - a; }
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort(cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term)
            return scan(edges[0].to);
        result.push(node);
        for (let i = 0; i < edges.length; i++) {
            let { term, to } = edges[i];
            if (!term && result.indexOf(to) == -1)
                scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function dfa(nfa) {
    let labeled = Object.create(null);
    return explore(nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach(node => {
            nfa[node].forEach(({ term, to }) => {
                if (!term)
                    return;
                let set;
                for (let i = 0; i < out.length; i++)
                    if (out[i][0] == term)
                        set = out[i][1];
                nullFrom(nfa, to).forEach(node => {
                    if (!set)
                        out.push([term, set = []]);
                    if (set.indexOf(node) == -1)
                        set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new ContentMatch(states.indexOf(nfa.length - 1) > -1);
        for (let i = 0; i < out.length; i++) {
            let states = out[i][1].sort(cmp);
            state.next.push({ type: out[i][0], next: labeled[states.join(",")] || explore(states) });
        }
        return state;
    }
}
function checkForDeadEnds(match, stream) {
    for (let i = 0, work = [match]; i < work.length; i++) {
        let state = work[i], dead = !state.validEnd, nodes = [];
        for (let j = 0; j < state.next.length; j++) {
            let { type, next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs()))
                dead = false;
            if (work.indexOf(next) == -1)
                work.push(next);
        }
        if (dead)
            stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}

// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for (let attrName in attrs) {
        let attr = attrs[attrName];
        if (!attr.hasDefault)
            return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function computeAttrs(attrs, value) {
    let built = Object.create(null);
    for (let name in attrs) {
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault)
                given = attr.default;
            else
                throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function checkAttrs(attrs, values, type, name) {
    for (let attr in values)
        if (!(attr in attrs))
            throw new RangeError(`Unsupported attribute ${attr} for ${type} of type ${name}`);
    for (let attr in attrs) {
        if (attrs[attr].validate)
            attrs[attr].validate(values[attr]);
    }
}
function initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs)
        for (let name in attrs)
            result[name] = new Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/
let NodeType$1 = class NodeType {
    /**
    @internal
    */
    constructor(
    /**
    The name the node type has in this schema.
    */
    name, 
    /**
    A link back to the `Schema` the node type belongs to.
    */
    schema, 
    /**
    The spec that this type is based on
    */
    spec) {
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */
        this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = initAttrs(name, spec.attrs);
        this.defaultAttrs = defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */
    get isInline() { return !this.isBlock; }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */
    get isTextblock() { return this.isBlock && this.inlineContent; }
    /**
    True for node types that allow no content.
    */
    get isLeaf() { return this.contentMatch == ContentMatch.empty; }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */
    get isAtom() { return this.isLeaf || !!this.spec.atom; }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */
    isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */
    get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */
    hasRequiredAttrs() {
        for (let n in this.attrs)
            if (this.attrs[n].isRequired)
                return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */
    compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */
    computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs)
            return this.defaultAttrs;
        else
            return computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */
    create(attrs = null, content, marks) {
        if (this.isText)
            throw new Error("NodeType.create can't construct text nodes");
        return new Node$1(this, this.computeAttrs(attrs), Fragment.from(content), Mark$1.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */
    createChecked(attrs = null, content, marks) {
        content = Fragment.from(content);
        this.checkContent(content);
        return new Node$1(this, this.computeAttrs(attrs), content, Mark$1.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */
    createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = Fragment.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before)
                return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore(Fragment.empty, true);
        if (!after)
            return null;
        return new Node$1(this, attrs, content.append(after), Mark$1.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */
    validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd)
            return false;
        for (let i = 0; i < content.childCount; i++)
            if (!this.allowsMarks(content.child(i).marks))
                return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */
    checkContent(content) {
        if (!this.validContent(content))
            throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */
    checkAttrs(attrs) {
        checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */
    allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */
    allowsMarks(marks) {
        if (this.markSet == null)
            return true;
        for (let i = 0; i < marks.length; i++)
            if (!this.allowsMarkType(marks[i].type))
                return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */
    allowedMarks(marks) {
        if (this.markSet == null)
            return marks;
        let copy;
        for (let i = 0; i < marks.length; i++) {
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy)
                    copy = marks.slice(0, i);
            }
            else if (copy) {
                copy.push(marks[i]);
            }
        }
        return !copy ? marks : copy.length ? copy : Mark$1.none;
    }
    /**
    @internal
    */
    static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec) => result[name] = new NodeType(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType])
            throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text)
            throw new RangeError("Every schema needs a 'text' type");
        for (let _ in result.text.attrs)
            throw new RangeError("The text node type should not have attributes");
        return result;
    }
};
function validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value) => {
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0)
            throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class Attribute {
    constructor(typeName, attrName, options) {
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/
class MarkType {
    /**
    @internal
    */
    constructor(
    /**
    The name of the mark type.
    */
    name, 
    /**
    @internal
    */
    rank, 
    /**
    The schema that this mark type instance is part of.
    */
    schema, 
    /**
    The spec on which the type is based.
    */
    spec) {
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = defaultAttrs(this.attrs);
        this.instance = defaults ? new Mark$1(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */
    create(attrs = null) {
        if (!attrs && this.instance)
            return this.instance;
        return new Mark$1(this, computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */
    static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec) => result[name] = new MarkType(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */
    removeFromSet(set) {
        for (var i = 0; i < set.length; i++)
            if (set[i].type == this) {
                set = set.slice(0, i).concat(set.slice(i + 1));
                i--;
            }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */
    isInSet(set) {
        for (let i = 0; i < set.length; i++)
            if (set[i].type == this)
                return set[i];
    }
    /**
    @internal
    */
    checkAttrs(attrs) {
        checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */
    excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/
class Schema {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */
    constructor(spec) {
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */
        this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */
        this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for (let prop in spec)
            instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = OrderedMap.from(spec.nodes),
            instanceSpec.marks = OrderedMap.from(spec.marks || {}),
            this.nodes = NodeType$1.compile(this.spec.nodes, this);
        this.marks = MarkType.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for (let prop in this.nodes) {
            if (prop in this.marks)
                throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] ||
                (contentExprCache[contentExpr] = ContentMatch.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement)
                    throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf)
                    throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null :
                markExpr ? gatherMarks(this, markExpr.split(" ")) :
                    markExpr == "" || !type.inlineContent ? [] : null;
        }
        for (let prop in this.marks) {
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [type] : excl == "" ? [] : gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = json => Node$1.fromJSON(this, json);
        this.markFromJSON = json => Mark$1.fromJSON(this, json);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */
    node(type, attrs = null, content, marks) {
        if (typeof type == "string")
            type = this.nodeType(type);
        else if (!(type instanceof NodeType$1))
            throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this)
            throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */
    text(text, marks) {
        let type = this.nodes.text;
        return new TextNode(type, type.defaultAttrs, text, Mark$1.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */
    mark(type, attrs) {
        if (typeof type == "string")
            type = this.marks[type];
        return type.create(attrs);
    }
    /**
    @internal
    */
    nodeType(name) {
        let found = this.nodes[name];
        if (!found)
            throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function gatherMarks(schema, marks) {
    let found = [];
    for (let i = 0; i < marks.length; i++) {
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) {
            found.push(mark);
        }
        else {
            for (let prop in schema.marks) {
                let mark = schema.marks[prop];
                if (name == "_" || (mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1))
                    found.push(ok = mark);
            }
        }
        if (!ok)
            throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}

function isTagRule(rule) { return rule.tag != null; }
function isStyleRule(rule) { return rule.style != null; }
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/
class DOMParser {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */
    constructor(
    /**
    The schema into which the parser parses.
    */
    schema, 
    /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */
    rules) {
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */
        this.tags = [];
        /**
        @internal
        */
        this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach(rule => {
            if (isTagRule(rule)) {
                this.tags.push(rule);
            }
            else if (isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0)
                    matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some(r => {
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
                return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */
    parse(dom, options = {}) {
        let context = new ParseContext(this, options, false);
        context.addAll(dom, Mark$1.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */
    parseSlice(dom, options = {}) {
        let context = new ParseContext(this, options, true);
        context.addAll(dom, Mark$1.none, options.from, options.to);
        return Slice.maxOpen(context.finish());
    }
    /**
    @internal
    */
    matchTag(dom, context, after) {
        for (let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++) {
            let rule = this.tags[i];
            if (matches(dom, rule.tag) &&
                (rule.namespace === undefined || dom.namespaceURI == rule.namespace) &&
                (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false)
                        continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */
    matchStyle(prop, value, context, after) {
        for (let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++) {
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 ||
                rule.context && !context.matchesContext(rule.context) ||
                // Test that the style string either precisely matches the prop,
                // or has an '=' sign after the prop, followed by the given
                // value.
                style.length > prop.length &&
                    (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value))
                continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false)
                    continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */
    static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for (; i < result.length; i++) {
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority)
                    break;
            }
            result.splice(i, 0, rule);
        }
        for (let name in schema.marks) {
            let rules = schema.marks[name].spec.parseDOM;
            if (rules)
                rules.forEach(rule => {
                    insert(rule = copy(rule));
                    if (!(rule.mark || rule.ignore || rule.clearMark))
                        rule.mark = name;
                });
        }
        for (let name in schema.nodes) {
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules)
                rules.forEach(rule => {
                    insert(rule = copy(rule));
                    if (!(rule.node || rule.ignore || rule.mark))
                        rule.node = name;
                });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
    */
    static fromSchema(schema) {
        return schema.cached.domParser ||
            (schema.cached.domParser = new DOMParser(schema, DOMParser.schemaRules(schema)));
    }
}
const blockTags = {
    address: true, article: true, aside: true, blockquote: true, body: true, canvas: true,
    dd: true, div: true, dl: true, fieldset: true, figcaption: true, figure: true,
    footer: true, form: true, h1: true, h2: true, h3: true, h4: true, h5: true,
    h6: true, header: true, hgroup: true, hr: true, li: true, noscript: true, ol: true,
    output: true, p: true, pre: true, section: true, table: true, tfoot: true, ul: true
};
const ignoreTags = {
    head: true, noscript: true, object: true, script: true, style: true, title: true
};
const listTags = { ol: true, ul: true };
// Using a bitfield for node context options
const OPT_PRESERVE_WS = 1, OPT_PRESERVE_WS_FULL = 2, OPT_OPEN_LEFT = 4;
function wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null)
        return (preserveWhitespace ? OPT_PRESERVE_WS : 0) |
            (preserveWhitespace === "full" ? OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? OPT_PRESERVE_WS | OPT_PRESERVE_WS_FULL : base & ~OPT_OPEN_LEFT;
}
class NodeContext {
    constructor(type, attrs, marks, solid, match, options) {
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = Mark$1.none;
        this.match = match || (options & OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type)
                return [];
            let fill = this.type.contentMatch.fillBefore(Fragment.from(node));
            if (fill) {
                this.match = this.type.contentMatch.matchFragment(fill);
            }
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                }
                else {
                    return null;
                }
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & OPT_PRESERVE_WS)) { // Strip trailing whitespace
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length)
                    this.content.pop();
                else
                    this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = Fragment.from(this.content);
        if (!openEnd && this.match)
            content = content.append(this.match.fillBefore(Fragment.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type)
            return this.type.inlineContent;
        if (this.content.length)
            return this.content[0].isInline;
        return node.parentNode && !blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class ParseContext {
    constructor(
    // The parser we are using.
    parser, 
    // The options passed to this parse.
    options, isOpen) {
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? OPT_OPEN_LEFT : 0);
        if (topNode)
            topContext = new NodeContext(topNode.type, topNode.attrs, Mark$1.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen)
            topContext = new NodeContext(null, null, Mark$1.none, true, null, topOptions);
        else
            topContext = new NodeContext(parser.schema.topNodeType, null, Mark$1.none, true, null, topOptions);
        this.nodes = [topContext];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3)
            this.addTextNode(dom, marks);
        else if (dom.nodeType == 1)
            this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = (top.options & OPT_PRESERVE_WS_FULL) ? "full"
            : this.localPreserveWS || (top.options & OPT_PRESERVE_WS) > 0;
        let { schema } = this.parser;
        if (preserveWS === "full" ||
            top.inlineContext(dom) ||
            /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore ||
                        (domNodeBefore && domNodeBefore.nodeName == 'BR') ||
                        (nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)))
                        value = value.slice(1);
                }
            }
            else if (preserveWS === "full") {
                value = value.replace(/\r\n?/g, "\n");
            }
            else if (schema.linebreakReplacement && /[\r\n]/.test(value) && this.top.findWrapping(schema.linebreakReplacement.create())) {
                let lines = value.split(/\r?\n|\r/);
                for (let i = 0; i < lines.length; i++) {
                    if (i)
                        this.insertNode(schema.linebreakReplacement.create(), marks, true);
                    if (lines[i])
                        this.insertNode(schema.text(lines[i]), marks, !/\S/.test(lines[i]));
                }
                value = "";
            }
            else {
                value = value.replace(/\r?\n|\r/g, " ");
            }
            if (value)
                this.insertNode(schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        }
        else {
            this.findInside(dom);
        }
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace))
            this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if (listTags.hasOwnProperty(name) && this.parser.normalizeLists)
            normalizeList(dom);
        let rule = (this.options.ruleFromNode && this.options.ruleFromNode(dom)) ||
            (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        }
        else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent)
                this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType)
                dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if (blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type)
                    this.needsBlock = true;
            }
            else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks)
                this.addAll(dom, innerMarks);
            if (sync)
                this.sync(top);
            this.needsBlock = oldNeedsBlock;
        }
        else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks)
                this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent)
            this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent))
            this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length)
            for (let i = 0; i < this.parser.matchedStyles.length; i++) {
                let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
                if (value)
                    for (let after = undefined;;) {
                        let rule = this.parser.matchStyle(name, value, this, after);
                        if (!rule)
                            break;
                        if (rule.ignore)
                            return null;
                        if (rule.clearMark)
                            marks = marks.filter(m => !rule.clearMark(m));
                        else
                            marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                        if (rule.consuming === false)
                            after = rule;
                        else
                            break;
                    }
            }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            }
            else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) {
                this.leafFallback(dom, marks);
            }
        }
        else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) {
            this.findInside(dom);
        }
        else if (continueAfter) {
            this.addElement(dom, marks, continueAfter);
        }
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach(node => this.insertNode(node, marks, false));
        }
        else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string")
                contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function")
                contentDOM = rule.contentElement(dom);
            else if (rule.contentElement)
                contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn))
            this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for (let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index) {
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for (let depth = this.open, penalty = 0; depth >= 0; depth--) {
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length)
                    break;
            }
            if (cx.solid) {
                if (cautious)
                    break;
                penalty += 2;
            }
        }
        if (!route)
            return null;
        this.sync(sync);
        for (let i = 0; i < route.length; i++)
            marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block)
                marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match)
                top.match = top.match.matchType(node.type);
            let nodeMarks = Mark$1.none;
            for (let m of innerMarks.concat(node.marks))
                if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, node.type))
                    nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks)
            innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = wsOptionsFor(type, preserveWS, top.options);
        if ((top.options & OPT_OPEN_LEFT) && top.content.length == 0)
            options |= OPT_OPEN_LEFT;
        let applyMarks = Mark$1.none;
        marks = marks.filter(m => {
            if (top.type ? top.type.allowsMarkType(m.type) : markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for (; i > this.open; i--)
                this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for (let i = this.open; i >= 0; i--) {
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            }
            else if (this.localPreserveWS) {
                this.nodes[i].options |= OPT_PRESERVE_WS;
            }
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for (let i = this.open; i >= 0; i--) {
            let content = this.nodes[i].content;
            for (let j = content.length - 1; j >= 0; j--)
                pos += content[j].nodeSize;
            if (i)
                pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].node == parent && this.find[i].offset == offset)
                    this.find[i].pos = this.currentPos;
            }
    }
    findInside(parent) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node))
                    this.find[i].pos = this.currentPos;
            }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                    let pos = content.compareDocumentPosition(this.find[i].node);
                    if (pos & (before ? 2 : 4))
                        this.find[i].pos = this.currentPos;
                }
            }
    }
    findInText(textNode) {
        if (this.find)
            for (let i = 0; i < this.find.length; i++) {
                if (this.find[i].node == textNode)
                    this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
            }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1)
            return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth) => {
            for (; i >= 0; i--) {
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0)
                        continue;
                    for (; depth >= minDepth; depth--)
                        if (match(i - 1, depth))
                            return true;
                    return false;
                }
                else {
                    let next = depth > 0 || (depth == 0 && useRoot) ? this.nodes[depth].type
                        : option && depth >= minDepth ? option.node(depth - minDepth).type
                            : null;
                    if (!next || (next.name != part && !next.isInGroup(part)))
                        return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context)
            for (let d = $context.depth; d >= 0; d--) {
                let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
                if (deflt && deflt.isTextblock && deflt.defaultAttrs)
                    return deflt;
            }
        for (let name in this.parser.schema.nodes) {
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs)
                return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function normalizeList(dom) {
    for (let child = dom.firstChild, prevItem = null; child; child = child.nextSibling) {
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        }
        else if (name == "li") {
            prevItem = child;
        }
        else if (name) {
            prevItem = null;
        }
    }
}
// Apply a CSS selector.
function matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function copy(obj) {
    let copy = {};
    for (let prop in obj)
        copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for (let name in nodes) {
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType))
            continue;
        let seen = [], scan = (match) => {
            seen.push(match);
            for (let i = 0; i < match.edgeCount; i++) {
                let { type, next } = match.edge(i);
                if (type == nodeType)
                    return true;
                if (seen.indexOf(next) < 0 && scan(next))
                    return true;
            }
        };
        if (scan(parent.contentMatch))
            return true;
    }
}

/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/
class DOMSerializer {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */
    constructor(
    /**
    The node serialization functions.
    */
    nodes, 
    /**
    The mark serialization functions.
    */
    marks) {
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */
    serializeFragment(fragment, options = {}, target) {
        if (!target)
            target = doc$1(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach(node => {
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while (keep < active.length && rendered < node.marks.length) {
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false)
                        break;
                    keep++;
                    rendered++;
                }
                while (keep < active.length)
                    top = active.pop()[1];
                while (rendered < node.marks.length) {
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([add, top]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */
    serializeNodeInner(node, options) {
        if (node.isText)
            return doc$1(options).createTextNode(node.text);
        let { dom, contentDOM } = renderSpec(doc$1(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf)
                throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */
    serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for (let i = node.marks.length - 1; i >= 0; i--) {
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */
    serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && renderSpec(doc$1(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        // Kludge for backwards-compatibility with accidental original behavious
        if (typeof structure == "string")
            return { dom: doc.createTextNode(structure) };
        return renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */
    static fromSchema(schema) {
        return schema.cached.domSerializer ||
            (schema.cached.domSerializer = new DOMSerializer(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */
    static nodesFromSchema(schema) {
        let result = gatherToDOM(schema.nodes);
        if (!result.text)
            result.text = node => node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */
    static marksFromSchema(schema) {
        return gatherToDOM(schema.marks);
    }
}
function gatherToDOM(obj) {
    let result = {};
    for (let name in obj) {
        let toDOM = obj[name].spec.toDOM;
        if (toDOM)
            result[name] = toDOM;
    }
    return result;
}
function doc$1(options) {
    return options.document || window.document;
}
const suspiciousAttributeCache = new WeakMap();
function suspiciousAttributes(attrs) {
    let value = suspiciousAttributeCache.get(attrs);
    if (value === undefined)
        suspiciousAttributeCache.set(attrs, value = suspiciousAttributesInner(attrs));
    return value;
}
function suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result)
                        result = [];
                    result.push(value);
                }
                else {
                    for (let i = 0; i < value.length; i++)
                        scan(value[i]);
                }
            }
            else {
                for (let prop in value)
                    scan(value[prop]);
            }
        }
    }
    scan(attrs);
    return result;
}
function renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (structure.nodeType == 1)
        return { dom: structure };
    if (structure.dom && structure.dom.nodeType == 1)
        return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string")
        throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = suspiciousAttributes(blockArraysIn)) &&
        suspicious.indexOf(structure) > -1)
        throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = (xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName));
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for (let name in attrs)
            if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0)
                    dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else if (name == "style" && dom.style)
                    dom.style.cssText = attrs[name];
                else
                    dom.setAttribute(name, attrs[name]);
            }
    }
    for (let i = start; i < structure.length; i++) {
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start)
                throw new RangeError("Content hole must be the only child of its parent node");
            return { dom, contentDOM: dom };
        }
        else if (typeof child == "string") {
            dom.appendChild(doc.createTextNode(child));
        }
        else {
            let { dom: inner, contentDOM: innerContent } = renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM)
                    throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return { dom, contentDOM };
}

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const lower16 = 0xffff;
const factor16 = Math.pow(2, 16);
function makeRecover(index, offset) { return index + offset * factor16; }
function recoverIndex(value) { return value & lower16; }
function recoverOffset(value) { return (value - (value & lower16)) / factor16; }
const DEL_BEFORE = 1, DEL_AFTER = 2, DEL_ACROSS = 4, DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/
class MapResult {
    /**
    @internal
    */
    constructor(
    /**
    The mapped version of the position.
    */
    pos, 
    /**
    @internal
    */
    delInfo, 
    /**
    @internal
    */
    recover) {
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */
    get deleted() { return (this.delInfo & DEL_SIDE) > 0; }
    /**
    Tells you whether the token before the mapped position was deleted.
    */
    get deletedBefore() { return (this.delInfo & (DEL_BEFORE | DEL_ACROSS)) > 0; }
    /**
    True when the token after the mapped position was deleted.
    */
    get deletedAfter() { return (this.delInfo & (DEL_AFTER | DEL_ACROSS)) > 0; }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */
    get deletedAcross() { return (this.delInfo & DEL_ACROSS) > 0; }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/
class StepMap {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */
    constructor(
    /**
    @internal
    */
    ranges, 
    /**
    @internal
    */
    inverted = false) {
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && StepMap.empty)
            return StepMap.empty;
    }
    /**
    @internal
    */
    recover(value) {
        let diff = 0, index = recoverIndex(value);
        if (!this.inverted)
            for (let i = 0; i < index; i++)
                diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + recoverOffset(value);
    }
    mapResult(pos, assoc = 1) { return this._map(pos, assoc, false); }
    map(pos, assoc = 1) { return this._map(pos, assoc, true); }
    /**
    @internal
    */
    _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos)
                break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple)
                    return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : makeRecover(i / 3, pos - start);
                let del = pos == start ? DEL_AFTER : pos == end ? DEL_BEFORE : DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end)
                    del |= DEL_SIDE;
                return new MapResult(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new MapResult(pos + diff, 0, null);
    }
    /**
    @internal
    */
    touches(pos, recover) {
        let diff = 0, index = recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos)
                break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3)
                return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */
    forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for (let i = 0, diff = 0; i < this.ranges.length; i += 3) {
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */
    invert() {
        return new StepMap(this.ranges, !this.inverted);
    }
    /**
    @internal
    */
    toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */
    static offset(n) {
        return n == 0 ? StepMap.empty : new StepMap(n < 0 ? [0, -n, 0] : [0, 0, n]);
    }
}
/**
A StepMap that contains no changed ranges.
*/
StepMap.empty = new StepMap([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](https://prosemirror.net/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/
class Mapping {
    /**
    Create a new mapping with the given position maps.
    */
    constructor(maps, 
    /**
    @internal
    */
    mirror, 
    /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */
    from = 0, 
    /**
    The end position in the `maps` array.
    */
    to = maps ? maps.length : 0) {
        this.mirror = mirror;
        this.from = from;
        this.to = to;
        this._maps = maps || [];
        this.ownData = !(maps || mirror);
    }
    /**
    The step maps in this mapping.
    */
    get maps() { return this._maps; }
    /**
    Create a mapping that maps only through a part of this one.
    */
    slice(from = 0, to = this.maps.length) {
        return new Mapping(this._maps, this.mirror, from, to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */
    appendMap(map, mirrors) {
        if (!this.ownData) {
            this._maps = this._maps.slice();
            this.mirror = this.mirror && this.mirror.slice();
            this.ownData = true;
        }
        this.to = this._maps.push(map);
        if (mirrors != null)
            this.setMirror(this._maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */
    appendMapping(mapping) {
        for (let i = 0, startSize = this._maps.length; i < mapping._maps.length; i++) {
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */
    getMirror(n) {
        if (this.mirror)
            for (let i = 0; i < this.mirror.length; i++)
                if (this.mirror[i] == n)
                    return this.mirror[i + (i % 2 ? -1 : 1)];
    }
    /**
    @internal
    */
    setMirror(n, m) {
        if (!this.mirror)
            this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */
    appendMappingInverted(mapping) {
        for (let i = mapping.maps.length - 1, totalSize = this._maps.length + mapping._maps.length; i >= 0; i--) {
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping._maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */
    invert() {
        let inverse = new Mapping;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */
    map(pos, assoc = 1) {
        if (this.mirror)
            return this._map(pos, assoc, true);
        for (let i = this.from; i < this.to; i++)
            pos = this._maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */
    mapResult(pos, assoc = 1) { return this._map(pos, assoc, false); }
    /**
    @internal
    */
    _map(pos, assoc, simple) {
        let delInfo = 0;
        for (let i = this.from; i < this.to; i++) {
            let map = this._maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this._maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new MapResult(pos, delInfo, null);
    }
}

const stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/
class Step {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */
    getMap() { return StepMap.empty; }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */
    merge(other) { return null; }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */
    static fromJSON(schema, json) {
        if (!json || !json.stepType)
            throw new RangeError("Invalid input for Step.fromJSON");
        let type = stepsByID[json.stepType];
        if (!type)
            throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */
    static jsonID(id, stepClass) {
        if (id in stepsByID)
            throw new RangeError("Duplicate use of step JSON ID " + id);
        stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/
class StepResult {
    /**
    @internal
    */
    constructor(
    /**
    The transformed document, if successful.
    */
    doc, 
    /**
    The failure message, if unsuccessful.
    */
    failed) {
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */
    static ok(doc) { return new StepResult(doc, null); }
    /**
    Create a failed step result.
    */
    static fail(message) { return new StepResult(null, message); }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */
    static fromReplace(doc, from, to, slice) {
        try {
            return StepResult.ok(doc.replace(from, to, slice));
        }
        catch (e) {
            if (e instanceof ReplaceError)
                return StepResult.fail(e.message);
            throw e;
        }
    }
}

function mapFragment(fragment, f, parent) {
    let mapped = [];
    for (let i = 0; i < fragment.childCount; i++) {
        let child = fragment.child(i);
        if (child.content.size)
            child = child.copy(mapFragment(child.content, f, child));
        if (child.isInline)
            child = f(child, parent, i);
        mapped.push(child);
    }
    return Fragment.fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/
class AddMarkStep extends Step {
    /**
    Create a mark step.
    */
    constructor(
    /**
    The start of the marked range.
    */
    from, 
    /**
    The end of the marked range.
    */
    to, 
    /**
    The mark to add.
    */
    mark) {
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new Slice(mapFragment(oldSlice.content, (node, parent) => {
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type))
                return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new RemoveMarkStep(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos)
            return null;
        return new AddMarkStep(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof AddMarkStep &&
            other.mark.eq(this.mark) &&
            this.from <= other.to && this.to >= other.from)
            return new AddMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return { stepType: "addMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new AddMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("addMark", AddMarkStep);
/**
Remove a mark from all inline content between two positions.
*/
class RemoveMarkStep extends Step {
    /**
    Create a mark-removing step.
    */
    constructor(
    /**
    The start of the unmarked range.
    */
    from, 
    /**
    The end of the unmarked range.
    */
    to, 
    /**
    The mark to remove.
    */
    mark) {
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new Slice(mapFragment(oldSlice.content, node => {
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return StepResult.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new AddMarkStep(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos)
            return null;
        return new RemoveMarkStep(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof RemoveMarkStep &&
            other.mark.eq(this.mark) &&
            this.from <= other.to && this.to >= other.from)
            return new RemoveMarkStep(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return { stepType: "removeMark", mark: this.mark.toJSON(),
            from: this.from, to: this.to };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new RemoveMarkStep(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("removeMark", RemoveMarkStep);
/**
Add a mark to a specific node.
*/
class AddNodeMarkStep extends Step {
    /**
    Create a node mark step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The mark to add.
    */
    mark) {
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for (let i = 0; i < node.marks.length; i++)
                    if (!node.marks[i].isInSet(newSet))
                        return new AddNodeMarkStep(this.pos, node.marks[i]);
                return new AddNodeMarkStep(this.pos, this.mark);
            }
        }
        return new RemoveNodeMarkStep(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new AddNodeMarkStep(pos.pos, this.mark);
    }
    toJSON() {
        return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.pos != "number")
            throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new AddNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("addNodeMark", AddNodeMarkStep);
/**
Remove a mark from a specific node.
*/
class RemoveNodeMarkStep extends Step {
    /**
    Create a mark-removing step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The mark to remove.
    */
    mark) {
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks))
            return this;
        return new AddNodeMarkStep(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new RemoveNodeMarkStep(pos.pos, this.mark);
    }
    toJSON() {
        return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.pos != "number")
            throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new RemoveNodeMarkStep(json.pos, schema.markFromJSON(json.mark));
    }
}
Step.jsonID("removeNodeMark", RemoveNodeMarkStep);

/**
Replace a part of the document with a slice of new content.
*/
class ReplaceStep extends Step {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */
    constructor(
    /**
    The start position of the replaced range.
    */
    from, 
    /**
    The end position of the replaced range.
    */
    to, 
    /**
    The slice to insert.
    */
    slice, 
    /**
    @internal
    */
    structure = false) {
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && contentBetween(doc, this.from, this.to))
            return StepResult.fail("Structure replace would overwrite content");
        return StepResult.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new StepMap([this.from, this.to - this.from, this.slice.size]);
    }
    invert(doc) {
        return new ReplaceStep(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let to = mapping.mapResult(this.to, -1);
        let from = this.from == this.to && ReplaceStep.MAP_BIAS < 0 ? to : mapping.mapResult(this.from, 1);
        if (from.deletedAcross && to.deletedAcross)
            return null;
        return new ReplaceStep(from.pos, Math.max(from.pos, to.pos), this.slice, this.structure);
    }
    merge(other) {
        if (!(other instanceof ReplaceStep) || other.structure || this.structure)
            return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? Slice.empty
                : new Slice(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new ReplaceStep(this.from, this.to + (other.to - other.from), slice, this.structure);
        }
        else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? Slice.empty
                : new Slice(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new ReplaceStep(other.from, this.to, slice, this.structure);
        }
        else {
            return null;
        }
    }
    toJSON() {
        let json = { stepType: "replace", from: this.from, to: this.to };
        if (this.slice.size)
            json.slice = this.slice.toJSON();
        if (this.structure)
            json.structure = true;
        return json;
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number")
            throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new ReplaceStep(json.from, json.to, Slice.fromJSON(schema, json.slice), !!json.structure);
    }
}
/**
By default, for backwards compatibility, an inserting step
mapped over an insertion at that same position fill move after
the inserted content. In a collaborative editing situation, that
can make redone insertions appear in unexpected places. You can
set this to -1 to make such mapping keep the step before the
insertion instead.
*/
ReplaceStep.MAP_BIAS = 1;
Step.jsonID("replace", ReplaceStep);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/
class ReplaceAroundStep extends Step {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */
    constructor(
    /**
    The start position of the replaced range.
    */
    from, 
    /**
    The end position of the replaced range.
    */
    to, 
    /**
    The start of preserved range.
    */
    gapFrom, 
    /**
    The end of preserved range.
    */
    gapTo, 
    /**
    The slice to insert.
    */
    slice, 
    /**
    The position in the slice where the preserved range should be
    inserted.
    */
    insert, 
    /**
    @internal
    */
    structure = false) {
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && (contentBetween(doc, this.from, this.gapFrom) ||
            contentBetween(doc, this.gapTo, this.to)))
            return StepResult.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd)
            return StepResult.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted)
            return StepResult.fail("Content does not fit in gap");
        return StepResult.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new StepMap([this.from, this.gapFrom - this.from, this.insert,
            this.gapTo, this.to - this.gapTo, this.slice.size - this.insert]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new ReplaceAroundStep(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if ((from.deletedAcross && to.deletedAcross) || gapFrom < from.pos || gapTo > to.pos)
            return null;
        return new ReplaceAroundStep(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = { stepType: "replaceAround", from: this.from, to: this.to,
            gapFrom: this.gapFrom, gapTo: this.gapTo, insert: this.insert };
        if (this.slice.size)
            json.slice = this.slice.toJSON();
        if (this.structure)
            json.structure = true;
        return json;
    }
    /**
    @internal
    */
    static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" ||
            typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number")
            throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new ReplaceAroundStep(json.from, json.to, json.gapFrom, json.gapTo, Slice.fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
Step.jsonID("replaceAround", ReplaceAroundStep);
function contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while (dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount) {
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while (dist > 0) {
            if (!next || next.isLeaf)
                return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}

function addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent) => {
        if (!node.isInline)
            return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for (let i = 0; i < marks.length; i++) {
                if (!marks[i].isInSet(newSet)) {
                    if (removing && removing.to == start && removing.mark.eq(marks[i]))
                        removing.to = end;
                    else
                        removed.push(removing = new RemoveMarkStep(start, end, marks[i]));
                }
            }
            if (adding && adding.to == start)
                adding.to = end;
            else
                added.push(adding = new AddMarkStep(start, end, mark));
        }
    });
    removed.forEach(s => tr.step(s));
    added.forEach(s => tr.step(s));
}
function removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isInline)
            return;
        step++;
        let toRemove = null;
        if (mark instanceof MarkType) {
            let set = node.marks, found;
            while (found = mark.isInSet(set)) {
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        }
        else if (mark) {
            if (mark.isInSet(node.marks))
                toRemove = [mark];
        }
        else {
            toRemove = node.marks;
        }
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for (let i = 0; i < toRemove.length; i++) {
                let style = toRemove[i], found;
                for (let j = 0; j < matched.length; j++) {
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style))
                        found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                }
                else {
                    matched.push({ style, from: Math.max(pos, from), to: end, step });
                }
            }
        }
    });
    matched.forEach(m => tr.step(new RemoveMarkStep(m.from, m.to, m.style)));
}
function clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for (let i = 0; i < node.childCount; i++) {
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) {
            replSteps.push(new ReplaceStep(cur, end, Slice.empty));
        }
        else {
            match = allowed;
            for (let j = 0; j < child.marks.length; j++)
                if (!parentType.allowsMarkType(child.marks[j].type))
                    tr.step(new RemoveMarkStep(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while (m = newline.exec(child.text)) {
                    if (!slice)
                        slice = new Slice(Fragment.from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new ReplaceStep(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore(Fragment.empty, true);
        tr.replace(cur, cur, new Slice(fill, 0, 0));
    }
    for (let i = replSteps.length - 1; i >= 0; i--)
        tr.step(replSteps[i]);
}

function canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) &&
        (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/
function liftTarget(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for (let depth = range.depth, contentBefore = 0, contentAfter = 0;; --depth) {
        let node = range.$from.node(depth);
        let index = range.$from.index(depth) + contentBefore, endIndex = range.$to.indexAfter(depth) - contentAfter;
        if (depth < range.depth && node.canReplace(index, endIndex, content))
            return depth;
        if (depth == 0 || node.type.spec.isolating || !canCut(node, index, endIndex))
            break;
        if (index)
            contentBefore = 1;
        if (endIndex < node.childCount)
            contentAfter = 1;
    }
    return null;
}
function lift$2(tr, range, target) {
    let { $from, $to, depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = Fragment.empty, openStart = 0;
    for (let d = depth, splitting = false; d > target; d--)
        if (splitting || $from.index(d) > 0) {
            splitting = true;
            before = Fragment.from($from.node(d).copy(before));
            openStart++;
        }
        else {
            start--;
        }
    let after = Fragment.empty, openEnd = 0;
    for (let d = depth, splitting = false; d > target; d--)
        if (splitting || $to.after(d + 1) < $to.end(d)) {
            splitting = true;
            after = Fragment.from($to.node(d).copy(after));
            openEnd++;
        }
        else {
            end++;
        }
    tr.step(new ReplaceAroundStep(start, end, gapStart, gapEnd, new Slice(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/
function findWrapping(range, nodeType, attrs = null, innerRange = range) {
    let around = findWrappingOutside(range, nodeType);
    let inner = around && findWrappingInside(innerRange, nodeType);
    if (!inner)
        return null;
    return around.map(withAttrs)
        .concat({ type: nodeType, attrs }).concat(inner.map(withAttrs));
}
function withAttrs(type) { return { type, attrs: null }; }
function findWrappingOutside(range, type) {
    let { parent, startIndex, endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around)
        return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function findWrappingInside(range, type) {
    let { parent, startIndex, endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside)
        return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for (let i = startIndex; innerMatch && i < endIndex; i++)
        innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd)
        return null;
    return inside;
}
function wrap(tr, range, wrappers) {
    let content = Fragment.empty;
    for (let i = wrappers.length - 1; i >= 0; i--) {
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd)
                throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new ReplaceAroundStep(start, end, start, end, new Slice(content, 0, 0), wrappers.length, true));
}
function setBlockType$1(tr, from, to, type, attrs) {
    if (!type.isTextblock)
        throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos) => {
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) &&
            canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak)
                    convertNewlines = false;
                else if (!pre && supportLinebreak)
                    convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false)
                replaceLinebreaks(tr, node, pos, mapFrom);
            clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new ReplaceAroundStep(startM, endM, startM + 1, endM - 1, new Slice(Fragment.from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true)
                replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset) => {
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while (m = newline.exec(child.text)) {
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset) => {
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/
function setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node)
        throw new RangeError("No node at given position");
    if (!type)
        type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf)
        return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content))
        throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new ReplaceAroundStep(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new Slice(Fragment.from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/
function canSplit(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = (typesAfter && typesAfter[typesAfter.length - 1]) || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating ||
        !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) ||
        !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount)))
        return false;
    for (let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--) {
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating)
            return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild)
            rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = (typesAfter && typesAfter[i]) || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest))
            return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = Fragment.empty, after = Fragment.empty;
    for (let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--) {
        before = Fragment.from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = Fragment.from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new ReplaceStep(pos, pos, new Slice(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/
function canJoin(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return joinable($pos.nodeBefore, $pos.nodeAfter) &&
        $pos.parent.canReplace(index, index + 1);
}
function canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size)
        a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement } = a.type.schema;
    for (let i = 0; i < b.childCount; i++) {
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match)
            return false;
        if (!a.type.allowsMarks(child.marks))
            return false;
    }
    return match.validEnd;
}
function joinable(a, b) {
    return !!(a && b && !a.isLeaf && canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/
function joinPoint(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for (let d = $pos.depth;; d--) {
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        }
        else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        }
        else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && joinable(before, after) &&
            $pos.node(d).canReplace(index, index + 1))
            return pos;
        if (d == 0)
            break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak)
            convertNewlines = false;
        else if (!pre && supportLinebreak)
            convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent)
        clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new ReplaceStep(start, mapping.map(pos + depth, -1), Slice.empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/
function insertPoint(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType))
        return pos;
    if ($pos.parentOffset == 0)
        for (let d = $pos.depth - 1; d >= 0; d--) {
            let index = $pos.index(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType))
                return $pos.before(d + 1);
            if (index > 0)
                return null;
        }
    if ($pos.parentOffset == $pos.parent.content.size)
        for (let d = $pos.depth - 1; d >= 0; d--) {
            let index = $pos.indexAfter(d);
            if ($pos.node(d).canReplaceWith(index, index, nodeType))
                return $pos.after(d + 1);
            if (index < $pos.node(d).childCount)
                return null;
        }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/
function dropPoint(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size)
        return pos;
    let content = slice.content;
    for (let i = 0; i < slice.openStart; i++)
        content = content.firstChild.content;
    for (let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++) {
        for (let d = $pos.depth; d >= 0; d--) {
            let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
            let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
            let parent = $pos.node(d), fits = false;
            if (pass == 1) {
                fits = parent.canReplace(insertPos, insertPos, content);
            }
            else {
                let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
                fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
            }
            if (fits)
                return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
        }
    }
    return null;
}

/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/
function replaceStep(doc, from, to = from, slice = Slice.empty) {
    if (from == to && !slice.size)
        return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if (fitsTrivially($from, $to, slice))
        return new ReplaceStep(from, to, slice);
    return new Fitter($from, $to, slice).fit();
}
function fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() &&
        $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class Fitter {
    constructor($from, $to, unplaced) {
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = Fragment.empty;
        for (let i = 0; i <= $from.depth; i++) {
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for (let i = $from.depth; i > 0; i--)
            this.placed = Fragment.from($from.node(i).copy(this.placed));
    }
    get depth() { return this.frontier.length - 1; }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while (this.unplaced.size) {
            let fit = this.findFittable();
            if (fit)
                this.placeNodes(fit);
            else
                this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to)
            return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while (openStart && openEnd && content.childCount == 1) { // Normalize by dropping open parent nodes
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new Slice(content, openStart, openEnd);
        if (moveInline > -1)
            return new ReplaceAroundStep($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) // Don't generate no-op steps
            return new ReplaceStep($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for (let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++) {
            let node = cur.firstChild;
            if (cur.childCount > 1)
                openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for (let pass = 1; pass <= 2; pass++) {
            for (let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--) {
                let fragment, parent = null;
                if (sliceDepth) {
                    parent = contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                    fragment = parent.content;
                }
                else {
                    fragment = this.unplaced.content;
                }
                let first = fragment.firstChild;
                for (let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--) {
                    let { type, match } = this.frontier[frontierDepth], wrap, inject = null;
                    // In pass 1, if the next node matches, or there is no next
                    // node but the parents look compatible, we've found a
                    // place.
                    if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore(Fragment.from(first), false))
                        : parent && type.compatibleContent(parent.type)))
                        return { sliceDepth, frontierDepth, parent, inject };
                    // In pass 2, look for a set of wrapping nodes that make
                    // `first` fit here.
                    else if (pass == 2 && first && (wrap = match.findWrapping(first.type)))
                        return { sliceDepth, frontierDepth, parent, wrap };
                    // Don't continue looking further up if the parent node
                    // would fit here.
                    if (parent && match.matchType(parent.type))
                        break;
                }
            }
        }
    }
    openMore() {
        let { content, openStart, openEnd } = this.unplaced;
        if (maxOpen(content, -1) <= openStart)
            return false;
        if (this.unplaced.size > 1 && maxOpen(content, 1) > openEnd)
            openEnd++;
        this.unplaced = new Slice(content, openStart + 1, openEnd);
        return true;
    }
    dropNode() {
        let { content, openStart, openEnd } = this.unplaced;
        let inner = contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new Slice(dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        }
        else {
            this.unplaced = new Slice(dropFromFragment(content, openStart, 1), openStart, openEnd);
        }
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth, frontierDepth, parent, inject, wrap }) {
        while (this.depth > frontierDepth)
            this.closeFrontierNode();
        if (wrap)
            for (let i = 0; i < wrap.length; i++)
                this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match, type } = this.frontier[frontierDepth];
        if (inject) {
            for (let i = 0; i < inject.childCount; i++)
                add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = (fragment.size + sliceDepth) - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while (taken < fragment.childCount) {
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches)
                break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) { // Drop empty open nodes
                match = matches;
                add.push(closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd)
            openEndCount = -1;
        this.placed = addToFragment(this.placed, frontierDepth, Fragment.from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1)
            this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for (let i = 0, cur = fragment; i < openEndCount; i++) {
            let node = cur.lastChild;
            this.frontier.push({ type: node.type, match: node.contentMatchAt(node.childCount) });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new Slice(dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd)
            : sliceDepth == 0 ? Slice.empty
                : new Slice(dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock)
            return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) ||
            (this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth))
            return -1;
        let { depth } = this.$to, after = this.$to.after(depth);
        while (depth > 1 && after == this.$to.end(--depth))
            ++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for (let i = Math.min(this.depth, $to.depth); i >= 0; i--) {
            let { match, type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = contentAfterFits($to, i, type, match, dropInner);
            if (!fit)
                continue;
            for (let d = i - 1; d >= 0; d--) {
                let { match, type } = this.frontier[d];
                let matches = contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount)
                    continue scan;
            }
            return { depth: i, fit, move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close)
            return null;
        while (this.depth > close.depth)
            this.closeFrontierNode();
        if (close.fit.childCount)
            this.placed = addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for (let d = close.depth + 1; d <= $to.depth; d++) {
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = addToFragment(this.placed, this.depth, Fragment.from(type.create(attrs, content)));
        this.frontier.push({ type, match: type.contentMatch });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore(Fragment.empty, true);
        if (add.childCount)
            this.placed = addToFragment(this.placed, this.frontier.length, add);
    }
}
function dropFromFragment(fragment, depth, count) {
    if (depth == 0)
        return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy(dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function addToFragment(fragment, depth, content) {
    if (depth == 0)
        return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy(addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function contentAt(fragment, depth) {
    for (let i = 0; i < depth; i++)
        fragment = fragment.firstChild.content;
    return fragment;
}
function closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0)
        return node;
    let frag = node.content;
    if (openStart > 1)
        frag = frag.replaceChild(0, closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0)
            frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore(Fragment.empty, true));
    }
    return node.copy(frag);
}
function contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type))
        return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !invalidMarks(type, node.content, index) ? fit : null;
}
function invalidMarks(type, fragment, start) {
    for (let i = start; i < fragment.childCount; i++)
        if (!type.allowsMarks(fragment.child(i).marks))
            return true;
    return false;
}
function definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function maxOpen(frag, side) {
    for (let count = 0;; count++) {
        let ch = side < 0 ? frag.firstChild : frag.lastChild;
        if (!ch || ch.isAtom)
            return count;
        frag = ch.content;
    }
}
function replaceRange(tr, from, to, slice) {
    if (!slice.size)
        return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if (fitsTrivially($from, $to, slice))
        return tr.step(new ReplaceStep(from, to, slice));
    let targetDepths = coveredDepths($from, $to);
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0)
        targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for (let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--) {
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating)
            break;
        if (targetDepths.indexOf(d) > -1)
            preferredTarget = d;
        else if ($from.before(d) == pos)
            targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for (let content = slice.content, i = 0;; i++) {
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart)
            break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for (let d = preferredDepth - 1; d >= 0; d--) {
        let leftNode = leftNodes[d], def = definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1)))
            preferredDepth = d;
        else if (def || !leftNode.type.isTextblock)
            break;
    }
    for (let j = slice.openStart; j >= 0; j--) {
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert)
            continue;
        for (let i = 0; i < targetDepths.length; i++) {
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks))
                return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new Slice(closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for (let i = targetDepths.length - 1; i >= 0; i--) {
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps)
            break;
        let depth = targetDepths[i];
        if (depth < 0)
            continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy(closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore(Fragment.empty, true));
    }
    return fragment;
}
function replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = insertPoint(tr.doc, from, node.type);
        if (point != null)
            from = to = point;
    }
    tr.replaceRange(from, to, new Slice(Fragment.from(node), 0, 0));
}
function deleteRange$1(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    // When the deleted range spans from the start of one textblock to
    // the start of another one, move out of the start of both blocks.
    if ($from.parent.isTextblock && $to.parent.isTextblock && $from.start() != $to.start() &&
        $from.parentOffset == 0 && $to.parentOffset == 0) {
        let shared = $from.sharedDepth(to), isolated = false;
        for (let d = $from.depth; d > shared; d--)
            if ($from.node(d).type.spec.isolating)
                isolated = true;
        for (let d = $to.depth; d > shared; d--)
            if ($to.node(d).type.spec.isolating)
                isolated = true;
        if (!isolated) {
            for (let d = $from.depth; d > 0 && from == $from.start(d); d--)
                from = $from.before(d);
            for (let d = $to.depth; d > 0 && to == $to.start(d); d--)
                to = $to.before(d);
            $from = tr.doc.resolve(from);
            $to = tr.doc.resolve(to);
        }
    }
    let covered = coveredDepths($from, $to);
    for (let i = 0; i < covered.length; i++) {
        let depth = covered[i], last = i == covered.length - 1;
        if ((last && depth == 0) || $from.node(depth).type.contentMatch.validEnd)
            return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1))))
            return tr.delete($from.before(depth), $to.after(depth));
    }
    for (let d = 1; d <= $from.depth && d <= $to.depth; d++) {
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d &&
            $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1)))
            return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for (let d = minDepth; d >= 0; d--) {
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) ||
            $to.end(d) > $to.pos + ($to.depth - d) ||
            $from.node(d).type.spec.isolating ||
            $to.node(d).type.spec.isolating)
            break;
        if (start == $to.start(d) ||
            (d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent &&
                d && $to.start(d - 1) == start - 1))
            result.push(d);
    }
    return result;
}

/**
Update an attribute in a specific node.
*/
class AttrStep extends Step {
    /**
    Construct an attribute step.
    */
    constructor(
    /**
    The position of the target node.
    */
    pos, 
    /**
    The attribute to set.
    */
    attr, 
    // The attribute's new value.
    value) {
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node)
            return StepResult.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for (let name in node.attrs)
            attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return StepResult.fromReplace(doc, this.pos, this.pos + 1, new Slice(Fragment.from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return StepMap.empty;
    }
    invert(doc) {
        return new AttrStep(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new AttrStep(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string")
            throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new AttrStep(json.pos, json.attr, json.value);
    }
}
Step.jsonID("attr", AttrStep);
/**
Update an attribute in the doc node.
*/
class DocAttrStep extends Step {
    /**
    Construct an attribute step.
    */
    constructor(
    /**
    The attribute to set.
    */
    attr, 
    // The attribute's new value.
    value) {
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for (let name in doc.attrs)
            attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return StepResult.ok(updated);
    }
    getMap() {
        return StepMap.empty;
    }
    invert(doc) {
        return new DocAttrStep(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return { stepType: "docAttr", attr: this.attr, value: this.value };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string")
            throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new DocAttrStep(json.attr, json.value);
    }
}
Step.jsonID("docAttr", DocAttrStep);

/**
@internal
*/
let TransformError = class extends Error {
};
TransformError = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
TransformError.prototype = Object.create(Error.prototype);
TransformError.prototype.constructor = TransformError;
TransformError.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/
class Transform {
    /**
    Create a transform that starts with the given document.
    */
    constructor(
    /**
    The current document (the result of applying the steps in the
    transform).
    */
    doc) {
        this.doc = doc;
        /**
        The steps in this transform.
        */
        this.steps = [];
        /**
        The documents before each of the steps.
        */
        this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */
        this.mapping = new Mapping;
    }
    /**
    The starting document.
    */
    get before() { return this.docs.length ? this.docs[0] : this.doc; }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */
    step(step) {
        let result = this.maybeStep(step);
        if (result.failed)
            throw new TransformError(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */
    maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed)
            this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */
    get docChanged() {
        return this.steps.length > 0;
    }
    /**
    Return a single range, in post-transform document positions,
    that covers all content changed by this transform. Returns null
    if no replacements are made. Note that this will ignore changes
    that add/remove marks without replacing the underlying content.
    */
    changedRange() {
        let from = 1e9, to = -1e9;
        for (let i = 0; i < this.mapping.maps.length; i++) {
            let map = this.mapping.maps[i];
            if (i) {
                from = map.map(from, 1);
                to = map.map(to, -1);
            }
            map.forEach((_f, _t, fromB, toB) => {
                from = Math.min(from, fromB);
                to = Math.max(to, toB);
            });
        }
        return from == 1e9 ? null : { from, to };
    }
    /**
    @internal
    */
    addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */
    replace(from, to = from, slice = Slice.empty) {
        let step = replaceStep(this.doc, from, to, slice);
        if (step)
            this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */
    replaceWith(from, to, content) {
        return this.replace(from, to, new Slice(Fragment.from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */
    delete(from, to) {
        return this.replace(from, to, Slice.empty);
    }
    /**
    Insert the given content at the given position.
    */
    insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */
    replaceRange(from, to, slice) {
        replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */
    replaceRangeWith(from, to, node) {
        replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */
    deleteRange(from, to) {
        deleteRange$1(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */
    lift(range, target) {
        lift$2(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */
    join(pos, depth = 1) {
        join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */
    wrap(range, wrappers) {
        wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */
    setBlockType(from, to = from, type, attrs = null) {
        setBlockType$1(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */
    setNodeMarkup(pos, type, attrs = null, marks) {
        setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */
    setNodeAttribute(pos, attr, value) {
        this.step(new AttrStep(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */
    setDocAttribute(attr, value) {
        this.step(new DocAttrStep(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */
    addNodeMark(pos, mark) {
        this.step(new AddNodeMarkStep(pos, mark));
        return this;
    }
    /**
    Remove a mark (or all marks of the given type) from the node at
    position `pos`.
    */
    removeNodeMark(pos, mark) {
        let node = this.doc.nodeAt(pos);
        if (!node)
            throw new RangeError("No node at position " + pos);
        if (mark instanceof Mark$1) {
            if (mark.isInSet(node.marks))
                this.step(new RemoveNodeMarkStep(pos, mark));
        }
        else {
            let set = node.marks, found, steps = [];
            while (found = mark.isInSet(set)) {
                steps.push(new RemoveNodeMarkStep(pos, found));
                set = found.removeFromSet(set);
            }
            for (let i = steps.length - 1; i >= 0; i--)
                this.step(steps[i]);
        }
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split (with the outermost nodes coming first).
    */
    split(pos, depth = 1, typesAfter) {
        split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */
    addMark(from, to, mark) {
        addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */
    removeMark(from, to, mark) {
        removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */
    clearIncompatible(pos, parentType, match) {
        clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

const classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/
class Selection {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */
    constructor(
    /**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */
    $anchor, 
    /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */
    $head, ranges) {
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [new SelectionRange($anchor.min($head), $anchor.max($head))];
    }
    /**
    The selection's anchor, as an unresolved position.
    */
    get anchor() { return this.$anchor.pos; }
    /**
    The selection's head.
    */
    get head() { return this.$head.pos; }
    /**
    The lower bound of the selection's main range.
    */
    get from() { return this.$from.pos; }
    /**
    The upper bound of the selection's main range.
    */
    get to() { return this.$to.pos; }
    /**
    The resolved lower  bound of the selection's main range.
    */
    get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */
    get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */
    get empty() {
        let ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++)
            if (ranges[i].$from.pos != ranges[i].$to.pos)
                return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */
    content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */
    replace(tr, content = Slice.empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for (let i = 0; i < content.openEnd; i++) {
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let { $from, $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? Slice.empty : content);
            if (i == 0)
                selectionToInsertionEnd$1(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */
    replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for (let i = 0; i < ranges.length; i++) {
            let { $from, $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) {
                tr.deleteRange(from, to);
            }
            else {
                tr.replaceRangeWith(from, to, node);
                selectionToInsertionEnd$1(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */
    static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new TextSelection($pos)
            : findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner)
            return inner;
        for (let depth = $pos.depth - 1; depth >= 0; depth--) {
            let found = dir < 0
                ? findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly)
                : findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found)
                return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */
    static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new AllSelection($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */
    static atStart(doc) {
        return findSelectionIn(doc, doc, 0, 0, 1) || new AllSelection(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */
    static atEnd(doc) {
        return findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new AllSelection(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */
    static fromJSON(doc, json) {
        if (!json || !json.type)
            throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = classesById[json.type];
        if (!cls)
            throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */
    static jsonID(id, selectionClass) {
        if (id in classesById)
            throw new RangeError("Duplicate use of selection JSON ID " + id);
        classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */
    getBookmark() {
        return TextSelection.between(this.$anchor, this.$head).getBookmark();
    }
}
Selection.prototype.visible = true;
/**
Represents a selected range in a document.
*/
class SelectionRange {
    /**
    Create a range.
    */
    constructor(
    /**
    The lower bound of the range.
    */
    $from, 
    /**
    The upper bound of the range.
    */
    $to) {
        this.$from = $from;
        this.$to = $to;
    }
}
let warnedAboutTextSelection = false;
function checkTextSelection($pos) {
    if (!warnedAboutTextSelection && !$pos.parent.inlineContent) {
        warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/
class TextSelection extends Selection {
    /**
    Construct a text selection between the given points.
    */
    constructor($anchor, $head = $anchor) {
        checkTextSelection($anchor);
        checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */
    get $cursor() { return this.$anchor.pos == this.$head.pos ? this.$head : null; }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent)
            return Selection.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new TextSelection($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = Slice.empty) {
        super.replace(tr, content);
        if (content == Slice.empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks)
                tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof TextSelection && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return { type: "text", anchor: this.anchor, head: this.head };
    }
    /**
    @internal
    */
    static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number")
            throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new TextSelection(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */
    static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */
    static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos)
            bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = Selection.findFrom($head, bias, true) || Selection.findFrom($head, -bias, true);
            if (found)
                $head = found.$head;
            else
                return Selection.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) {
                $anchor = $head;
            }
            else {
                $anchor = (Selection.findFrom($anchor, -bias, true) || Selection.findFrom($anchor, bias, true)).$anchor;
                if (($anchor.pos < $head.pos) != (dPos < 0))
                    $anchor = $head;
            }
        }
        return new TextSelection($anchor, $head);
    }
}
Selection.jsonID("text", TextSelection);
class TextBookmark {
    constructor(anchor, head) {
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return TextSelection.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/
class NodeSelection extends Selection {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */
    constructor($pos) {
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted, pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted)
            return Selection.near($pos);
        return new NodeSelection($pos);
    }
    content() {
        return new Slice(Fragment.from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof NodeSelection && other.anchor == this.anchor;
    }
    toJSON() {
        return { type: "node", anchor: this.anchor };
    }
    getBookmark() { return new NodeBookmark(this.anchor); }
    /**
    @internal
    */
    static fromJSON(doc, json) {
        if (typeof json.anchor != "number")
            throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new NodeSelection(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */
    static create(doc, from) {
        return new NodeSelection(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */
    static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
NodeSelection.prototype.visible = false;
Selection.jsonID("node", NodeSelection);
class NodeBookmark {
    constructor(anchor) {
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted, pos } = mapping.mapResult(this.anchor);
        return deleted ? new TextBookmark(pos, pos) : new NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && NodeSelection.isSelectable(node))
            return new NodeSelection($pos);
        return Selection.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/
class AllSelection extends Selection {
    /**
    Create an all-selection over the given document.
    */
    constructor(doc) {
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = Slice.empty) {
        if (content == Slice.empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = Selection.atStart(tr.doc);
            if (!sel.eq(tr.selection))
                tr.setSelection(sel);
        }
        else {
            super.replace(tr, content);
        }
    }
    toJSON() { return { type: "all" }; }
    /**
    @internal
    */
    static fromJSON(doc) { return new AllSelection(doc); }
    map(doc) { return new AllSelection(doc); }
    eq(other) { return other instanceof AllSelection; }
    getBookmark() { return AllBookmark; }
}
Selection.jsonID("all", AllSelection);
const AllBookmark = {
    map() { return this; },
    resolve(doc) { return new AllSelection(doc); }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent)
        return TextSelection.create(doc, pos);
    for (let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir) {
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner)
                return inner;
        }
        else if (!text && NodeSelection.isSelectable(child)) {
            return NodeSelection.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        }
        pos += child.nodeSize * dir;
    }
    return null;
}
function selectionToInsertionEnd$1(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen)
        return;
    let step = tr.steps[last];
    if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep))
        return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo) => { if (end == null)
        end = newTo; });
    tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

const UPDATED_SEL = 1, UPDATED_MARKS = 2, UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/
class Transaction extends Transform {
    /**
    @internal
    */
    constructor(state) {
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */
    get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */
    setSelection(selection) {
        if (selection.$from.doc != this.doc)
            throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | UPDATED_SEL) & ~UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */
    get selectionSet() {
        return (this.updated & UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */
    setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */
    ensureMarks(marks) {
        if (!Mark$1.sameSet(this.storedMarks || this.selection.$from.marks(), marks))
            this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */
    addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */
    removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */
    get storedMarksSet() {
        return (this.updated & UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */
    addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */
    setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */
    replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */
    replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks)
            node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : (selection.$from.marksAcross(selection.$to) || Mark$1.none)));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */
    deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */
    insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text)
                return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        }
        else {
            if (to == null)
                to = from;
            if (!text)
                return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty && this.selection.to == from + text.length)
                this.setSelection(Selection.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */
    setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */
    getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */
    get isGeneric() {
        for (let _ in this.meta)
            return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */
    scrollIntoView() {
        this.updated |= UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */
    get scrolledIntoView() {
        return (this.updated & UPDATED_SCROLL) > 0;
    }
}

function bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class FieldDesc {
    constructor(name, desc, self) {
        this.name = name;
        this.init = bind(desc.init, self);
        this.apply = bind(desc.apply, self);
    }
}
const baseFields = [
    new FieldDesc("doc", {
        init(config) { return config.doc || config.schema.topNodeType.createAndFill(); },
        apply(tr) { return tr.doc; }
    }),
    new FieldDesc("selection", {
        init(config, instance) { return config.selection || Selection.atStart(instance.doc); },
        apply(tr) { return tr.selection; }
    }),
    new FieldDesc("storedMarks", {
        init(config) { return config.storedMarks || null; },
        apply(tr, _marks, _old, state) { return state.selection.$cursor ? tr.storedMarks : null; }
    }),
    new FieldDesc("scrollToSelection", {
        init() { return 0; },
        apply(tr, prev) { return tr.scrolledIntoView ? prev + 1 : prev; }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class Configuration {
    constructor(schema, plugins) {
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = baseFields.slice();
        if (plugins)
            plugins.forEach(plugin => {
                if (this.pluginsByKey[plugin.key])
                    throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
                this.plugins.push(plugin);
                this.pluginsByKey[plugin.key] = plugin;
                if (plugin.spec.state)
                    this.fields.push(new FieldDesc(plugin.key, plugin.spec.state, plugin));
            });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/
class EditorState {
    /**
    @internal
    */
    constructor(
    /**
    @internal
    */
    config) {
        this.config = config;
    }
    /**
    The schema of the state's document.
    */
    get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */
    get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */
    apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */
    filterTransaction(tr, ignore = -1) {
        for (let i = 0; i < this.config.plugins.length; i++)
            if (i != ignore) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this))
                    return false;
            }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */
    applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr))
            return { state: this, transactions: [] };
        let trs = [rootTr], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for (;;) {
            let haveNew = false;
            for (let i = 0; i < this.config.plugins.length; i++) {
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length &&
                        plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for (let j = 0; j < this.config.plugins.length; j++)
                                seen.push(j < i ? { state: newState, n: trs.length } : { state: this, n: 0 });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen)
                        seen[i] = { state: newState, n: trs.length };
                }
            }
            if (!haveNew)
                return { state: newState, transactions: trs };
        }
    }
    /**
    @internal
    */
    applyInner(tr) {
        if (!tr.before.eq(this.doc))
            throw new RangeError("Applying a mismatched transaction");
        let newInstance = new EditorState(this.config), fields = this.config.fields;
        for (let i = 0; i < fields.length; i++) {
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */
    get tr() { return new Transaction(this); }
    /**
    Create a new state.
    */
    static create(config) {
        let $config = new Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new EditorState($config);
        for (let i = 0; i < $config.fields.length; i++)
            instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */
    reconfigure(config) {
        let $config = new Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new EditorState($config);
        for (let i = 0; i < fields.length; i++) {
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */
    toJSON(pluginFields) {
        let result = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
        if (this.storedMarks)
            result.storedMarks = this.storedMarks.map(m => m.toJSON());
        if (pluginFields && typeof pluginFields == 'object')
            for (let prop in pluginFields) {
                if (prop == "doc" || prop == "selection")
                    throw new RangeError("The JSON fields `doc` and `selection` are reserved");
                let plugin = pluginFields[prop], state = plugin.spec.state;
                if (state && state.toJSON)
                    result[prop] = state.toJSON.call(plugin, this[plugin.key]);
            }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */
    static fromJSON(config, json, pluginFields) {
        if (!json)
            throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema)
            throw new RangeError("Required config field 'schema' missing");
        let $config = new Configuration(config.schema, config.plugins);
        let instance = new EditorState($config);
        $config.fields.forEach(field => {
            if (field.name == "doc") {
                instance.doc = Node$1.fromJSON(config.schema, json.doc);
            }
            else if (field.name == "selection") {
                instance.selection = Selection.fromJSON(instance.doc, json.selection);
            }
            else if (field.name == "storedMarks") {
                if (json.storedMarks)
                    instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            }
            else {
                if (pluginFields)
                    for (let prop in pluginFields) {
                        let plugin = pluginFields[prop], state = plugin.spec.state;
                        if (plugin.key == field.name && state && state.fromJSON &&
                            Object.prototype.hasOwnProperty.call(json, prop)) {
                            instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                            return;
                        }
                    }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}

function bindProps(obj, self, target) {
    for (let prop in obj) {
        let val = obj[prop];
        if (val instanceof Function)
            val = val.bind(self);
        else if (prop == "handleDOMEvents")
            val = bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/
class Plugin {
    /**
    Create a plugin.
    */
    constructor(
    /**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */
    spec) {
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */
        this.props = {};
        if (spec.props)
            bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */
    getState(state) { return state[this.key]; }
}
const keys = Object.create(null);
function createKey(name) {
    if (name in keys)
        return name + "$" + ++keys[name];
    keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/
class PluginKey {
    /**
    Create a plugin key.
    */
    constructor(name = "key") { this.key = createKey(name); }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */
    get(state) { return state.config.pluginsByKey[this.key]; }
    /**
    Get the plugin's state from an editor state.
    */
    getState(state) { return state[this.key]; }
}

const domIndex = function (node) {
    for (var index = 0;; index++) {
        node = node.previousSibling;
        if (!node)
            return index;
    }
};
const parentNode = function (node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const textRange = function (node, from, to) {
    let range = reusedRange || (reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const clearReusedRange = function () {
    reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const isEquivalentPosition = function (node, off, targetNode, targetOff) {
    return targetNode && (scanFor(node, off, targetNode, targetOff, -1) ||
        scanFor(node, off, targetNode, targetOff, 1));
};
const atomElements = /^(img|br|input|textarea|hr)$/i;
function scanFor(node, off, targetNode, targetOff, dir) {
    var _a;
    for (;;) {
        if (node == targetNode && off == targetOff)
            return true;
        if (off == (dir < 0 ? 0 : nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || hasBlockDesc(node) || atomElements.test(node.nodeName) ||
                node.contentEditable == "false")
                return false;
            off = domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        }
        else if (node.nodeType == 1) {
            let child = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (child.nodeType == 1 && child.contentEditable == "false") {
                if ((_a = child.pmViewDesc) === null || _a === void 0 ? void 0 : _a.ignoreForSelection)
                    off += dir;
                else
                    return false;
            }
            else {
                node = child;
                off = dir < 0 ? nodeSize(node) : 0;
            }
        }
        else {
            return false;
        }
    }
}
function nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function textNodeBefore$1(node, offset) {
    for (;;) {
        if (node.nodeType == 3 && offset)
            return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false")
                return null;
            node = node.childNodes[offset - 1];
            offset = nodeSize(node);
        }
        else if (node.parentNode && !hasBlockDesc(node)) {
            offset = domIndex(node);
            node = node.parentNode;
        }
        else {
            return null;
        }
    }
}
function textNodeAfter$1(node, offset) {
    for (;;) {
        if (node.nodeType == 3 && offset < node.nodeValue.length)
            return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false")
                return null;
            node = node.childNodes[offset];
            offset = 0;
        }
        else if (node.parentNode && !hasBlockDesc(node)) {
            offset = domIndex(node) + 1;
            node = node.parentNode;
        }
        else {
            return null;
        }
    }
}
function isOnEdge(node, offset, parent) {
    for (let atStart = offset == 0, atEnd = offset == nodeSize(node); atStart || atEnd;) {
        if (node == parent)
            return true;
        let index = domIndex(node);
        node = node.parentNode;
        if (!node)
            return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == nodeSize(node);
    }
}
function hasBlockDesc(dom) {
    let desc;
    for (let cur = dom; cur; cur = cur.parentNode)
        if (desc = cur.pmViewDesc)
            break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const selectionCollapsed = function (domSel) {
    return domSel.focusNode && isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function deepActiveElement(doc) {
    let elt = doc.activeElement;
    while (elt && elt.shadowRoot)
        elt = elt.shadowRoot.activeElement;
    return elt;
}
function caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) {
        try { // Firefox throws for this call in hard-to-predict circumstances (#994)
            let pos = doc.caretPositionFromPoint(x, y);
            // Clip the offset, because Chrome will return a text offset
            // into <input> nodes, which can't be treated as a regular DOM
            // offset
            if (pos)
                return { node: pos.offsetNode, offset: Math.min(nodeSize(pos.offsetNode), pos.offset) };
        }
        catch (_) { }
    }
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range)
            return { node: range.startContainer, offset: Math.min(nodeSize(range.startContainer), range.startOffset) };
    }
}

const nav = typeof navigator != "undefined" ? navigator : null;
const doc = typeof document != "undefined" ? document : null;
const agent = (nav && nav.userAgent) || "";
const ie_edge = /Edge\/(\d+)/.exec(agent);
const ie_upto10 = /MSIE \d/.exec(agent);
const ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(agent);
const ie$1 = !!(ie_upto10 || ie_11up || ie_edge);
const ie_version = ie_upto10 ? document.documentMode : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0;
const gecko = !ie$1 && /gecko\/(\d+)/i.test(agent);
gecko && +(/Firefox\/(\d+)/.exec(agent) || [0, 0])[1];
const _chrome = !ie$1 && /Chrome\/(\d+)/.exec(agent);
const chrome = !!_chrome;
const chrome_version = _chrome ? +_chrome[1] : 0;
const safari = !ie$1 && !!nav && /Apple Computer/.test(nav.vendor);
// Is true for both iOS and iPadOS for convenience
const ios = safari && (/Mobile\/\w+/.test(agent) || !!nav && nav.maxTouchPoints > 2);
const mac$2 = ios || (nav ? /Mac/.test(nav.platform) : false);
const windows$1 = nav ? /Win/.test(nav.platform) : false;
const android = /Android \d/.test(agent);
const webkit = !!doc && "webkitFontSmoothing" in doc.documentElement.style;
const webkit_version = webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;

function windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp)
        return {
            left: 0, right: vp.width,
            top: 0, bottom: vp.height
        };
    return { left: 0, right: doc.documentElement.clientWidth,
        top: 0, bottom: doc.documentElement.clientHeight };
}
function getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = (rect.width / node.offsetWidth) || 1;
    let scaleY = (rect.height / node.offsetHeight) || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return { left: rect.left, right: rect.left + node.clientWidth * scaleX,
        top: rect.top, bottom: rect.top + node.clientHeight * scaleY };
}
function scrollRectIntoView(view, rect, startDOM) {
    // Skip empty rects with all sides at 0, for example, when the element has no CSS box (display: none)
    if (!nonZero(rect) && rect.left == 0)
        return;
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for (let parent = startDOM || view.dom;;) {
        if (!parent)
            break;
        if (parent.nodeType != 1) {
            parent = parentNode(parent);
            continue;
        }
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? windowRect(doc) : clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + getSide(scrollThreshold, "top"))
            moveY = -(bounding.top - rect.top + getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - getSide(scrollThreshold, "bottom"))
            moveY = rect.bottom - rect.top > bounding.bottom - bounding.top
                ? rect.top + getSide(scrollMargin, "top") - bounding.top
                : rect.bottom - bounding.bottom + getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + getSide(scrollThreshold, "left"))
            moveX = -(bounding.left - rect.left + getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - getSide(scrollThreshold, "right"))
            moveX = rect.right - bounding.right + getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) {
                doc.defaultView.scrollBy(moveX, moveY);
            }
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY)
                    elt.scrollTop += moveY;
                if (moveX)
                    elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = { left: rect.left - dX, top: rect.top - dY, right: rect.right - dX, bottom: rect.bottom - dY };
            }
        }
        let pos = atTop ? "fixed" : getComputedStyle(parent).position;
        if (/^(fixed|sticky)$/.test(pos))
            break;
        parent = pos == "absolute" ? parent.offsetParent : parentNode(parent);
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for (let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5) {
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom))
            continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return { refDOM: refDOM, refTop: refTop, stack: scrollStack(view.dom) };
}
function scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for (let cur = dom; cur; cur = parentNode(cur)) {
        stack.push({ dom: cur, top: cur.scrollTop, left: cur.scrollLeft });
        if (dom == doc)
            break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function resetScrollPos({ refDOM, refTop, stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function restoreScrollStack(stack, dTop) {
    for (let i = 0; i < stack.length; i++) {
        let { dom, top, left } = stack[i];
        if (dom.scrollTop != top + dTop)
            dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left)
            dom.scrollLeft = left;
    }
}
let preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function focusPreventScroll(dom) {
    if (dom.setActive)
        return dom.setActive(); // in IE
    if (preventScrollSupported)
        return dom.focus(preventScrollSupported);
    let stored = scrollStack(dom);
    dom.focus(preventScrollSupported == null ? {
        get preventScroll() {
            preventScrollSupported = { preventScroll: true };
            return true;
        }
    } : undefined);
    if (!preventScrollSupported) {
        preventScrollSupported = false;
        restoreScrollStack(stored, 0);
    }
}
function findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for (let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++) {
        let rects;
        if (child.nodeType == 1)
            rects = child.getClientRects();
        else if (child.nodeType == 3)
            rects = textRange(child).getClientRects();
        else
            continue;
        for (let i = 0; i < rects.length; i++) {
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left
                    : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx)
                        offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            }
            else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = { left: Math.max(rect.left, Math.min(rect.right, coords.left)), top: rect.top };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top ||
                coords.left >= rect.left && coords.top >= rect.bottom))
                offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3)
        return findOffsetInText(closest, coordsClosest);
    if (!closest || (dxClosest && closest.nodeType == 1))
        return { node, offset };
    return findOffsetInNode(closest, coordsClosest);
}
function findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange(), result;
    for (let i = 0; i < len; i++) {
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = singleRect(range, 1);
        if (rect.top == rect.bottom)
            continue;
        if (inRect(coords, rect)) {
            result = { node, offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0) };
            break;
        }
    }
    range.detach();
    return result || { node, offset: 0 };
}
function inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 &&
        coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left)
        return parent;
    return dom;
}
function posFromElement(view, elt, coords) {
    let { node, offset } = findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for (let cur = node, sawBlock = false;;) {
        if (cur == view.dom)
            break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc)
            return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) &&
            // Ignore elements with zero-size bounding rectangles
            ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(desc.dom.nodeName)) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top)
                    outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top)
                    outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2
                    : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) {
        for (let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;) {
            let child = element.childNodes[i];
            if (child.nodeType == 1) {
                let rects = child.getClientRects();
                for (let j = 0; j < rects.length; j++) {
                    let rect = rects[j];
                    if (inRect(coords, rect))
                        return elementFromPoint(child, coords, rect);
                }
            }
            if ((i = (i + 1) % len) == startI)
                break;
        }
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = caretFromPoint(doc, coords.left, coords.top);
    if (caret)
        ({ node, offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc)
        .elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!inRect(coords, box))
            return null;
        elt = elementFromPoint(view.dom, coords, box);
        if (!elt)
            return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if (safari) {
        for (let p = elt; node && p; p = parentNode(p))
            if (p.draggable)
                node = undefined;
    }
    elt = targetKludge(elt, coords);
    if (node) {
        if (gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left &&
                    box.bottom > coords.top)
                    offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if (webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 &&
            prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top)
            offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 &&
            coords.top > node.lastChild.getBoundingClientRect().bottom)
            pos = view.state.doc.content.size;
        // Ignore positions directly after a BR, since caret*FromPoint
        // 'round up' positions that would be more accurately placed
        // before the BR node.
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR")
            pos = posFromCaret(view, node, offset, coords);
    }
    if (pos == null)
        pos = posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return { pos, inside: desc ? desc.posAtStart - desc.border : -1 };
}
function nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if (nonZero(first))
            return first;
    }
    return Array.prototype.find.call(rects, nonZero) || target.getBoundingClientRect();
}
const BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function coordsAtPos(view, pos, side) {
    let { node, offset, atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = webkit || gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && (BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = singleRect(textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if (gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = singleRect(textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = singleRect(textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top)
                        return flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        }
        else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            }
            else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            }
            else if (side < 0) {
                from--;
            }
            else {
                to++;
            }
            return flattenV(singleRect(textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1)
                return flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1)
                return flattenH(after.getBoundingClientRect(), true);
        }
        return flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? textRange(before, nodeSize(before) - (supportEmptyRange ? 0 : 1))
            // BR nodes tend to only return the rectangle before them.
            // Only use them if they are the last element in their parent
            : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target)
            return flattenV(singleRect(target, 1), false);
    }
    if (atom == null && offset < nodeSize(node)) {
        let after = node.childNodes[offset];
        while (after.pmViewDesc && after.pmViewDesc.ignoreForCoords)
            after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? textRange(after, 0, (supportEmptyRange ? 0 : 1))
            : after.nodeType == 1 ? after : null;
        if (target)
            return flattenV(singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return flattenV(singleRect(node.nodeType == 3 ? textRange(node) : node, -side), side >= 0);
}
function flattenV(rect, left) {
    if (rect.width == 0)
        return rect;
    let x = left ? rect.left : rect.right;
    return { top: rect.top, bottom: rect.bottom, left: x, right: x };
}
function flattenH(rect, top) {
    if (rect.height == 0)
        return rect;
    let y = top ? rect.top : rect.bottom;
    return { top: y, bottom: y, left: rect.left, right: rect.right };
}
function withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state)
        view.updateState(state);
    if (active != view.dom)
        view.focus();
    try {
        return f();
    }
    finally {
        if (viewState != state)
            view.updateState(viewState);
        if (active != view.dom && active)
            active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return withFlushedState(view, state, () => {
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for (;;) {
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest)
                break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = coordsAtPos(view, $pos.pos, 1);
        for (let child = dom.firstChild; child; child = child.nextSibling) {
            let boxes;
            if (child.nodeType == 1)
                boxes = child.getClientRects();
            else if (child.nodeType == 3)
                boxes = textRange(child, 0, child.nodeValue.length).getClientRects();
            else
                continue;
            for (let i = 0; i < boxes.length; i++) {
                let box = boxes[i];
                if (box.bottom > box.top + 1 &&
                    (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2
                        : box.bottom - coords.bottom > (coords.bottom - box.top) * 2))
                    return false;
            }
        }
        return true;
    });
}
const maybeRTL = /[\u0590-\u08ac]/;
function endOfTextblockHorizontal(view, state, dir) {
    let { $head } = state.selection;
    if (!$head.parent.isTextblock)
        return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel)
        return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!maybeRTL.test($head.parent.textContent) || !sel.modify)
        return dir == "left" || dir == "backward" ? atStart : atEnd;
    return withFlushedState(view, state, () => {
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode, anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) ||
            (oldNode == newNode && oldOff == newOff);
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend)
                sel.extend(oldNode, oldOff);
        }
        catch (_) { }
        if (oldBidiLevel != null)
            sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let cachedState = null;
let cachedDir = null;
let cachedResult = false;
function endOfTextblock(view, state, dir) {
    if (cachedState == state && cachedDir == dir)
        return cachedResult;
    cachedState = state;
    cachedDir = dir;
    return cachedResult = dir == "up" || dir == "down"
        ? endOfTextblockVertical(view, state, dir)
        : endOfTextblockHorizontal(view, state, dir);
}

// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const NOT_DIRTY = 0, CHILD_DIRTY = 1, CONTENT_DIRTY = 2, NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class ViewDesc {
    constructor(parent, children, dom, 
    // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM) {
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) { return false; }
    matchesMark(mark) { return false; }
    matchesNode(node, outerDeco, innerDeco) { return false; }
    matchesHack(nodeName) { return false; }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule(addedNodes) { return null; }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) { return false; }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for (let i = 0; i < this.children.length; i++)
            size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() { return 0; }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this)
            this.dom.pmViewDesc = undefined;
        for (let i = 0; i < this.children.length; i++)
            this.children[i].destroy();
    }
    posBeforeChild(child) {
        for (let i = 0, pos = this.posAtStart;; i++) {
            let cur = this.children[i];
            if (cur == child)
                return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) {
                    domBefore = dom.childNodes[offset - 1];
                }
                else {
                    while (dom.parentNode != this.contentDOM)
                        dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while (domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))
                    domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            }
            else {
                let domAfter, desc;
                if (dom == this.contentDOM) {
                    domAfter = dom.childNodes[offset];
                }
                else {
                    while (dom.parentNode != this.contentDOM)
                        dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while (domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))
                    domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) {
            atEnd = offset > domIndex(this.contentDOM);
        }
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) {
            atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        }
        else if (this.dom.firstChild) {
            if (offset == 0)
                for (let search = dom;; search = search.parentNode) {
                    if (search == this.dom) {
                        atEnd = false;
                        break;
                    }
                    if (search.previousSibling)
                        break;
                }
            if (atEnd == null && offset == dom.childNodes.length)
                for (let search = dom;; search = search.parentNode) {
                    if (search == this.dom) {
                        atEnd = true;
                        break;
                    }
                    if (search.nextSibling)
                        break;
                }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for (let first = true, cur = dom; cur; cur = cur.parentNode) {
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) &&
                    !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom))
                    first = false;
                else
                    return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for (let cur = desc; cur; cur = cur.parent)
            if (cur == this)
                return desc;
    }
    posFromDOM(dom, offset, bias) {
        for (let scan = dom; scan; scan = scan.parentNode) {
            let desc = this.getDesc(scan);
            if (desc)
                return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for (let i = 0, offset = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while (!child.border && child.children.length) {
                    for (let i = 0; i < child.children.length; i++) {
                        let inner = child.children[i];
                        if (inner.size) {
                            child = inner;
                            break;
                        }
                    }
                }
                return child;
            }
            if (pos < end)
                return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM)
            return { node: this.dom, offset: 0, atom: pos + 1 };
        // First find the position in the child array
        let i = 0, offset = 0;
        for (let curPos = 0; i < this.children.length; i++) {
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset)
            return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for (let prev; i && !(prev = this.children[i - 1]).size && prev instanceof WidgetViewDesc && prev.side >= 0; i--) { }
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for (;; i--, enter = false) {
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM)
                    break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom)
                return prev.domFromPos(prev.size, side);
            return { node: this.contentDOM, offset: prev ? domIndex(prev.dom) + 1 : 0 };
        }
        else {
            let next, enter = true;
            for (;; i++, enter = false) {
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM)
                    break;
            }
            if (next && enter && !next.border && !next.domAtom)
                return next.domFromPos(0, side);
            return { node: this.contentDOM, offset: next ? domIndex(next.dom) : this.contentDOM.childNodes.length };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0)
            return { node: this.contentDOM, from, to, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
        let fromOffset = -1, toOffset = -1;
        for (let offset = base, i = 0;; i++) {
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node &&
                    child.contentDOM && this.contentDOM.contains(child.contentDOM))
                    return child.parseRange(from, to, childBase);
                from = offset;
                for (let j = i; j > 0; j--) {
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1)
                    fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for (let j = i + 1; j < this.children.length; j++) {
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1)
                    toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return { node: this.contentDOM, from, to, fromOffset, toOffset };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length)
            return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node, offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length)
            throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for (let i = 0, offset = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end)
                return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if ((gecko || safari) && anchor == head) {
            let { node, offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) {
                    for (let scan = node, after; scan; scan = scan.parentNode) {
                        if (after = scan.nextSibling) {
                            if (after.nodeName == "BR")
                                anchorDOM = headDOM = { node: after.parentNode, offset: domIndex(after) + 1 };
                            break;
                        }
                        let desc = scan.pmViewDesc;
                        if (desc && desc.node && desc.node.isBlock)
                            break;
                    }
                }
            }
            else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if (gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false")
                force = true;
        }
        if (!(force || brKludge && safari) &&
            isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) &&
            isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset))
            return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !(brKludge && gecko)) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head)
                    domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            }
            catch (_) {
                // In some cases with Chrome the selection is empty after calling
                // collapse, even when it should be valid. This appears to be a bug, but
                // it is difficult to isolate. If this happens fallback to the old path
                // without using extend.
                // Similarly, this could crash on Safari if the editor is hidden, and
                // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for (let offset = 0, i = 0; i < this.children.length; i++) {
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? CONTENT_DIRTY : CHILD_DIRTY;
                    if (from == startInside && to == endInside &&
                        (child.contentLost || child.dom.parentNode != this.contentDOM))
                        child.dirty = NODE_DIRTY;
                    else
                        child.markDirty(from - startInside, to - startInside);
                    return;
                }
                else {
                    child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length
                        ? CONTENT_DIRTY : NODE_DIRTY;
                }
            }
            offset = end;
        }
        this.dirty = CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for (let node = this.parent; node; node = node.parent, level++) {
            let dirty = level == 1 ? CONTENT_DIRTY : CHILD_DIRTY;
            if (node.dirty < dirty)
                node.dirty = dirty;
        }
    }
    get domAtom() { return false; }
    get ignoreForCoords() { return false; }
    get ignoreForSelection() { return false; }
    isText(text) { return false; }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class WidgetViewDesc extends ViewDesc {
    constructor(parent, widget, view, pos) {
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function")
            dom = dom(view, () => {
                if (!self)
                    return pos;
                if (self.parent)
                    return self.parent.posBeforeChild(self);
            });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            if (!dom.hasAttribute("contenteditable"))
                dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() { return { ignore: true }; }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() { return true; }
    get ignoreForSelection() { return !!this.widget.type.spec.relaxedSide; }
    get side() { return this.widget.type.side; }
}
class CompositionViewDesc extends ViewDesc {
    constructor(parent, dom, textDOM, text) {
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() { return this.text.length; }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM)
            return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return { node: this.textDOM, offset: pos };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class MarkViewDesc extends ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec) {
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom)
            spec = DOMSerializer.renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if ((this.dirty & NODE_DIRTY) || this.mark.type.spec.reparseInView)
            return null;
        return { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
    }
    matchesMark(mark) { return this.dirty != NODE_DIRTY && this.mark.eq(mark); }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != NOT_DIRTY) {
            let parent = this.parent;
            while (!parent.node)
                parent = parent.parent;
            if (parent.dirty < this.dirty)
                parent.dirty = this.dirty;
            this.dirty = NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size)
            nodes = replaceNodes(nodes, to, size, view);
        if (from > 0)
            nodes = replaceNodes(nodes, 0, from, view);
        for (let i = 0; i < nodes.length; i++)
            nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy)
            this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class NodeViewDesc extends ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM) {
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, () => {
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj)
                return pos;
            if (descObj.parent)
                return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom)
                dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3)
                throw new RangeError("Text must be rendered as a DOM text node");
        }
        else if (!dom) {
            let spec = DOMSerializer.renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom, contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") { // Chrome gets confused by <br contenteditable=false>
            if (!dom.hasAttribute("contenteditable"))
                dom.contentEditable = "false";
            if (node.type.spec.draggable)
                dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = applyOuterDeco(dom, outerDeco, node);
        if (spec)
            return descObj = new CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec);
        else if (node.isText)
            return new TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM);
        else
            return new NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM);
    }
    parseRule(addedNodes) {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView)
            return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = { node: this.node.type.name, attrs: this.node.attrs };
        if (this.node.type.whitespace == "pre")
            rule.preserveWhitespace = "full";
        if (!this.contentDOM) {
            rule.getContent = () => this.node.content;
        }
        else if (!this.contentLost) {
            rule.contentElement = this.contentDOM;
        }
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for (let i = this.children.length - 1; i >= 0; i--) {
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) {
                let found = addedNodes &&
                    addedNodes.find(n => n.nodeType == 1 && addedNodes.indexOf(n.parentNode) < 0 && this.dom.contains(n));
                if (found)
                    rule.contentElement = found;
                else
                    rule.getContent = () => Fragment.empty;
            }
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == NOT_DIRTY && node.eq(this.node) &&
            sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() { return this.node.nodeSize; }
    get border() { return this.node.isLeaf ? 0 : 1; }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new ViewTreeUpdater(this, localComposition && localComposition.node, view);
        iterDeco(this.node, this.innerDeco, (widget, i, insideNode) => {
            if (widget.spec.marks)
                updater.syncToMarks(widget.spec.marks, inline, view, i);
            else if (widget.type.side >= 0 && !insideNode)
                updater.syncToMarks(i == this.node.childCount ? Mark$1.none : this.node.child(i).marks, inline, view, i);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i) => {
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view, i);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off &&
                view.state.selection.to < off + child.nodeSize &&
                (compIndex = updater.findIndexWithChild(composition.node)) > -1 &&
                updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else {
                // Add it as a new view
                updater.addNode(child, outerDeco, innerDeco, view, off);
            }
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view, 0);
        if (this.node.isTextblock)
            updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition)
                this.protectLocalComposition(view, localComposition);
            renderDescs(this.contentDOM, this.children, view);
            if (ios)
                iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from, to } = view.state.selection;
        if (!(view.state.selection instanceof TextSelection) || from < pos || to > pos + this.node.content.size)
            return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode))
            return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : { node: textNode, pos: textPos, text };
        }
        else {
            return { node: textNode, pos: -1, text: "" };
        }
    }
    protectLocalComposition(view, { node, pos, text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node))
            return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for (;; topNode = topNode.parentNode) {
            if (topNode.parentNode == this.contentDOM)
                break;
            while (topNode.previousSibling)
                topNode.parentNode.removeChild(topNode.previousSibling);
            while (topNode.nextSibling)
                topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc)
                topNode.pmViewDesc = undefined;
        }
        let desc = new CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY ||
            !node.sameMarkup(this.node))
            return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM)
            this.updateChildren(view, this.posAtStart);
        this.dirty = NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if (sameOuterDeco(outerDeco, this.outerDeco))
            return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = patchOuterDeco(this.dom, this.nodeDOM, computeOuterDeco(this.outerDeco, this.node, needsWrap), computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.add("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable)
                this.nodeDOM.draggable = true;
        }
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable)
                this.nodeDOM.removeAttribute("draggable");
        }
    }
    get domAtom() { return this.node.isAtom; }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    applyOuterDeco(dom, outerDeco, doc);
    let docView = new NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom);
    if (docView.contentDOM)
        docView.updateChildren(view, 0);
    return docView;
}
class TextViewDesc extends NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM) {
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while (skip && skip != this.dom && !skip.pmIsDeco)
            skip = skip.parentNode;
        return { skip: (skip || true) };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY || (this.dirty != NOT_DIRTY && !this.inParent()) ||
            !node.sameMarkup(this.node))
            return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM)
                view.trackWrites = null;
        }
        this.node = node;
        this.dirty = NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for (let n = this.nodeDOM; n; n = n.parentNode)
            if (n == parentDOM)
                return true;
        return false;
    }
    domFromPos(pos) {
        return { node: this.nodeDOM, offset: pos };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM)
            return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, _view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length))
            this.dirty = NODE_DIRTY;
    }
    get domAtom() { return false; }
    isText(text) { return this.node.text == text; }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class TrailingHackViewDesc extends ViewDesc {
    parseRule() { return { ignore: true }; }
    matchesHack(nodeName) { return this.dirty == NOT_DIRTY && this.dom.nodeName == nodeName; }
    get domAtom() { return true; }
    get ignoreForCoords() { return this.dom.nodeName == "IMG"; }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class CustomNodeViewDesc extends NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec) {
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == NODE_DIRTY)
            return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result)
                this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        }
        else if (!this.contentDOM && !node.isLeaf) {
            return false;
        }
        else {
            return super.update(node, outerDeco, innerDeco, view);
        }
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root)
            : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy)
            this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for (let i = 0; i < descs.length; i++) {
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while (childDOM != dom) {
                dom = rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        }
        else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while (dom) {
        dom = rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM)
        view.trackWrites = null;
}
const OuterDecoLevel = function (nodeName) {
    if (nodeName)
        this.nodeName = nodeName;
};
OuterDecoLevel.prototype = Object.create(null);
const noDeco = [new OuterDecoLevel];
function computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0)
        return noDeco;
    let top = needsWrap ? noDeco[0] : new OuterDecoLevel, result = [top];
    for (let i = 0; i < outerDeco.length; i++) {
        let attrs = outerDeco[i].type.attrs;
        if (!attrs)
            continue;
        if (attrs.nodeName)
            result.push(top = new OuterDecoLevel(attrs.nodeName));
        for (let name in attrs) {
            let val = attrs[name];
            if (val == null)
                continue;
            if (needsWrap && result.length == 1)
                result.push(top = new OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class")
                top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style")
                top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName")
                top[name] = val;
        }
    }
    return result;
}
function patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == noDeco && curComputed == noDeco)
        return nodeDOM;
    let curDOM = nodeDOM;
    for (let i = 0; i < curComputed.length; i++) {
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM &&
                (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) {
                curDOM = parent;
            }
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = noDeco[0];
                curDOM = parent;
            }
        }
        patchAttributes(curDOM, prev || noDeco[0], deco);
    }
    return curDOM;
}
function patchAttributes(dom, prev, cur) {
    for (let name in prev)
        if (name != "class" && name != "style" && name != "nodeName" && !(name in cur))
            dom.removeAttribute(name);
    for (let name in cur)
        if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name])
            dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for (let i = 0; i < prevList.length; i++)
            if (curList.indexOf(prevList[i]) == -1)
                dom.classList.remove(prevList[i]);
        for (let i = 0; i < curList.length; i++)
            if (prevList.indexOf(curList[i]) == -1)
                dom.classList.add(curList[i]);
        if (dom.classList.length == 0)
            dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while (m = prop.exec(prev.style))
                dom.style.removeProperty(m[1]);
        }
        if (cur.style)
            dom.style.cssText += cur.style;
    }
}
function applyOuterDeco(dom, deco, node) {
    return patchOuterDeco(dom, dom, noDeco, computeOuterDeco(deco, node, dom.nodeType != 1));
}
function sameOuterDeco(a, b) {
    if (a.length != b.length)
        return false;
    for (let i = 0; i < a.length; i++)
        if (!a[i].type.eq(b[i].type))
            return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class ViewTreeUpdater {
    constructor(top, lock, view) {
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end)
            return;
        for (let i = start; i < end; i++)
            this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view, parentIndex) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while (keep < maxKeep &&
            (keep == depth - 1 ? this.top : this.stack[(keep + 1) << 1])
                .matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)
            keep++;
        while (keep < depth) {
            this.destroyRest();
            this.top.dirty = NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while (depth < marks.length) {
            this.stack.push(this.top, this.index + 1);
            let found = -1, scanTo = this.top.children.length;
            if (parentIndex < this.preMatch.index)
                scanTo = Math.min(this.index + 3, scanTo);
            for (let i = this.index; i < scanTo; i++) {
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            // When nothing matches, try to update the mark view at this position
            // in place, so a custom mark view can adapt to a changed mark without
            // re-creating its DOM.
            if (found < 0 && this.index < this.top.children.length) {
                let cur = this.top.children[this.index];
                if (cur instanceof MarkViewDesc && cur.dirty != NODE_DIRTY &&
                    cur.mark.type == marks[depth].type && cur.spec.update &&
                    !this.isLocked(cur.dom) && cur.spec.update(marks[depth])) {
                    cur.mark = marks[depth];
                    found = this.index;
                    this.changed = true;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            }
            else {
                let markDesc = MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index &&
            (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top &&
            targetDesc.matchesNode(node, outerDeco, innerDeco)) {
            found = this.top.children.indexOf(targetDesc, this.index);
        }
        else {
            for (let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++) {
                let child = this.top.children[i];
                if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                    found = i;
                    break;
                }
            }
        }
        if (found < 0)
            return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == NODE_DIRTY && child.dom == child.contentDOM)
            child.dirty = CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view))
            return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for (;;) {
            let parent = domNode.parentNode;
            if (!parent)
                return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc)
                    for (let i = this.index; i < this.top.children.length; i++) {
                        if (this.top.children[i] == desc)
                            return i;
                    }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for (let i = this.index; i < this.top.children.length; i++) {
            let next = this.top.children[i];
            if (next instanceof NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index)
                    return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) &&
                    !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text &&
                        next.dirty != NODE_DIRTY && sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM)
                        this.changed = true;
                    this.index++;
                    return true;
                }
                else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length ||
            !next.node.content.eq(node.content) ||
            !sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco))
            return null;
        let wrapper = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)
                ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM)
            desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) &&
            (widget == next.widget || !next.widget.type.toDOM.parentNode)) {
            this.index++;
        }
        else {
            let desc = new WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while (lastChild instanceof MarkViewDesc) {
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
            !(lastChild instanceof TextViewDesc) ||
            /\n$/.test(lastChild.node.text) ||
            (this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text))) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if ((safari || chrome) && lastChild && lastChild.dom.contentEditable == "false")
                this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) {
            this.index++;
        }
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR")
                dom.className = "ProseMirror-trailingBreak";
            let hack = new TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top)
                parent.children.push(hack);
            else
                parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes.
function preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while (fI > 0) {
        let desc;
        for (;;) {
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                }
                else {
                    desc = next;
                    descI--;
                    break;
                }
            }
            else if (curDesc == parentDesc) {
                break outer;
            }
            else {
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node)
            continue;
        if (node != frag.child(fI - 1))
            break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return { index: fI, matched, matches: matches.reverse() };
}
function compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for (let i = 0; i < parent.childCount; i++) {
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for (let parentIndex = 0;;) {
        let widget, widgets;
        while (decoIndex < locals.length && locals[decoIndex].to == offset) {
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget)
                    widget = next;
                else
                    (widgets || (widgets = [widget])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort(compareSide);
                for (let i = 0; i < widgets.length; i++)
                    onWidget(widgets[i], parentIndex, !!restNode);
            }
            else {
                onWidget(widget, parentIndex, !!restNode);
            }
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        }
        else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        }
        else {
            break;
        }
        for (let i = 0; i < active.length; i++)
            if (active[i].to <= offset)
                active.splice(i--, 1);
        while (decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)
            active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt)
                cutAt = locals[decoIndex].from;
            for (let i = 0; i < active.length; i++)
                if (active[i].to < cutAt)
                    cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        }
        else {
            while (decoIndex < locals.length && locals[decoIndex].to < end)
                decoIndex++;
        }
        let outerDeco = child.isInline && !child.isLeaf ? active.filter(d => !d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function findTextInFragment(frag, text, from, to) {
    for (let i = 0, pos = 0; i < frag.childCount && pos <= to;) {
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText)
            continue;
        let str = child.text;
        while (i < frag.childCount) {
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText)
                break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text)
                return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from)
                return childStart + found;
            if (from == to && str.length >= (to + text.length) - childStart &&
                str.slice(to - childStart, to - childStart + text.length) == text)
                return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for (let i = 0, off = 0; i < nodes.length; i++) {
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) {
            result.push(child);
        }
        else {
            if (start < from)
                result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to)
                result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}

function selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode)
        return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0)
        return null;
    let $head = doc.resolve(head), anchor, selection;
    if (selectionCollapsed(domSel)) {
        anchor = head;
        while (nearestDesc && !nearestDesc.node)
            nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && NodeSelection.isSelectable(nearestDescNode) && nearestDesc.parent
            && !(nearestDescNode.isInline && isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new NodeSelection(head == pos ? $head : doc.resolve(pos));
        }
    }
    else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for (let i = 0; i < domSel.rangeCount; i++) {
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0)
                return null;
            [anchor, head] = max == view.state.selection.anchor ? [max, min] : [min, max];
            $head = doc.resolve(head);
        }
        else {
            anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        }
        if (anchor < 0)
            return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || (view.state.selection.head < $head.pos && !inWidget) ? 1 : -1;
        selection = selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() :
        hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    syncNodeSelection(view, sel);
    if (!editorOwnsSelection(view))
        return;
    // Need to delay selection normalization during a native selection
    // drag on Chrome, or it will cause further dragging to glitch.
    let mouseDown = view.input.mouseDown;
    if (!force && chrome && mouseDown) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode &&
            isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset) &&
            mouseDown.delaySelUpdate()) {
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) {
        selectCursorWrapper(view);
    }
    else {
        let { anchor, head } = sel, resetEditableFrom, resetEditableTo;
        if (brokenSelectBetweenUneditable && !(sel instanceof TextSelection)) {
            if (!sel.$from.parent.inlineContent)
                resetEditableFrom = temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent)
                resetEditableTo = temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if (brokenSelectBetweenUneditable) {
            if (resetEditableFrom)
                resetEditable(resetEditableFrom);
            if (resetEditableTo)
                resetEditable(resetEditableTo);
        }
        if (sel.visible) {
            view.dom.classList.remove("ProseMirror-hideselection");
        }
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document)
                removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const brokenSelectBetweenUneditable = safari || chrome && chrome_version < 63;
function temporarilyEditableNear(view, pos) {
    let { node, offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if (safari && after && after.contentEditable == "false")
        return setEditable(after);
    if ((!after || after.contentEditable == "false") &&
        (!before || before.contentEditable == "false")) {
        if (after)
            return setEditable(after);
        else if (before)
            return setEditable(before);
    }
}
function setEditable(element) {
    element.contentEditable = "true";
    if (safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = () => {
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(() => {
                if (!editorOwnsSelection(view) || view.state.selection.visible)
                    view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function selectCursorWrapper(view) {
    let domSel = view.domSelection();
    if (!domSel)
        return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img)
        domSel.collapse(node.parentNode, domIndex(node) + 1);
    else
        domSel.collapse(node, 0);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && ie$1 && ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function syncNodeSelection(view, sel) {
    if (sel instanceof NodeSelection) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            clearNodeSelection(view);
            if (desc)
                desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    }
    else {
        clearNodeSelection(view);
    }
}
// Clear all DOM statefulness of the last node selection.
function clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent)
            view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", f => f(view, $anchor, $head))
        || TextSelection.between($anchor, $head, bias);
}
function hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus())
        return false;
    return hasSelection(view);
}
function hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode)
        return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) &&
            (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    }
    catch (_) {
        return false;
    }
}
function anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}

function moveSelectionBlock(state, dir) {
    let { $anchor, $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && Selection.findFrom($start, dir);
}
function apply$1(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof TextSelection) {
        if (mods.indexOf("s") > -1) {
            let { $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf)
                return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return apply$1(view, new TextSelection(sel.$anchor, $newHead));
        }
        else if (!sel.empty) {
            return false;
        }
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = moveSelectionBlock(view.state, dir);
            if (next && (next instanceof NodeSelection))
                return apply$1(view, next);
            return false;
        }
        else if (!(mac$2 && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText)
                return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM))
                return false;
            if (NodeSelection.isSelectable(node)) {
                return apply$1(view, new NodeSelection(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            }
            else if (webkit) {
                // Chrome and Safari will introduce extra pointless cursor
                // positions around inline uneditable nodes, so we have to
                // take over and move the cursor past them (#937)
                return apply$1(view, new TextSelection(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            }
            else {
                return false;
            }
        }
    }
    else if (sel instanceof NodeSelection && sel.node.isInline) {
        return apply$1(view, new TextSelection(dir > 0 ? sel.$to : sel.$from));
    }
    else {
        let next = moveSelectionBlock(view.state, dir);
        if (next)
            return apply$1(view, next);
        return false;
    }
}
function nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function skipIgnoredNodes(view, dir) {
    return dir < 0 ? skipIgnoredNodesBefore(view) : skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node)
        return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if (gecko && node.nodeType == 1 && offset < nodeLen(node) && isIgnorable(node.childNodes[offset], -1))
        force = true;
    for (;;) {
        if (offset > 0) {
            if (node.nodeType != 1) {
                break;
            }
            else {
                let before = node.childNodes[offset - 1];
                if (isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                }
                else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                }
                else
                    break;
            }
        }
        else if (isBlockNode(node)) {
            break;
        }
        else {
            let prev = node.previousSibling;
            while (prev && isIgnorable(prev, -1)) {
                moveNode = node.parentNode;
                moveOffset = domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom)
                    break;
                offset = 0;
            }
            else {
                node = prev;
                offset = nodeLen(node);
            }
        }
    }
    if (force)
        setSelFocus(view, node, offset);
    else if (moveNode)
        setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node)
        return;
    let len = nodeLen(node);
    let moveNode, moveOffset;
    for (;;) {
        if (offset < len) {
            if (node.nodeType != 1)
                break;
            let after = node.childNodes[offset];
            if (isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            }
            else
                break;
        }
        else if (isBlockNode(node)) {
            break;
        }
        else {
            let next = node.nextSibling;
            while (next && isIgnorable(next, 1)) {
                moveNode = next.parentNode;
                moveOffset = domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom)
                    break;
                offset = len = 0;
            }
            else {
                node = next;
                offset = 0;
                len = nodeLen(node);
            }
        }
    }
    if (moveNode)
        setSelFocus(view, moveNode, moveOffset);
}
function isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function textNodeAfter(node, offset) {
    while (node && offset == node.childNodes.length && !hasBlockDesc(node)) {
        offset = domIndex(node) + 1;
        node = node.parentNode;
    }
    while (node && offset < node.childNodes.length) {
        let next = node.childNodes[offset];
        if (next.nodeType == 3)
            return next;
        if (next.nodeType == 1 && next.contentEditable == "false")
            break;
        node = next;
        offset = 0;
    }
}
function textNodeBefore(node, offset) {
    while (node && !offset && !hasBlockDesc(node)) {
        offset = domIndex(node);
        node = node.parentNode;
    }
    while (node && offset) {
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3)
            return next;
        if (next.nodeType == 1 && next.contentEditable == "false")
            break;
        node = next;
        offset = node.childNodes.length;
    }
}
function setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        }
        else if (before = textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel)
        return;
    if (selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    }
    else if (sel.extend) {
        sel.extend(node, offset);
    }
    view.domObserver.setCurSelection();
    let { state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(() => {
        if (view.state == state)
            selectionToDOM(view);
    }, 50);
}
function findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!(chrome || windows$1) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1)
                return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1)
                return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof TextSelection && !sel.empty || mods.indexOf("s") > -1)
        return false;
    if (mac$2 && mods.indexOf("m") > -1)
        return false;
    let { $from, $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = moveSelectionBlock(view.state, dir);
        if (next && (next instanceof NodeSelection))
            return apply$1(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof AllSelection ? Selection.near(side, dir) : Selection.findFrom(side, dir);
        return beyond ? apply$1(view, beyond) : false;
    }
    return false;
}
function stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof TextSelection))
        return true;
    let { $head, $anchor, empty } = view.state.selection;
    if (!$head.sameParent($anchor))
        return true;
    if (!empty)
        return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward"))
        return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0)
            tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else
            tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function safariDownArrowBug(view) {
    if (!safari || view.state.selection.$head.parentOffset > 0)
        return false;
    let { focusNode, focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 &&
        focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        switchEditable(view, child, "true");
        setTimeout(() => switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function getMods(event) {
    let result = "";
    if (event.ctrlKey)
        result += "c";
    if (event.metaKey)
        result += "m";
    if (event.altKey)
        result += "a";
    if (event.shiftKey)
        result += "s";
    return result;
}
function captureKeyDown(view, event) {
    let code = event.keyCode, mods = getMods(event);
    if (code == 8 || (mac$2 && code == 72 && mods == "c")) { // Backspace, Ctrl-h on Mac
        return stopNativeHorizontalDelete(view, -1) || skipIgnoredNodes(view, -1);
    }
    else if ((code == 46 && !event.shiftKey) || (mac$2 && code == 68 && mods == "c")) { // Delete, Ctrl-d on Mac
        return stopNativeHorizontalDelete(view, 1) || skipIgnoredNodes(view, 1);
    }
    else if (code == 13 || code == 27) { // Enter, Esc
        return true;
    }
    else if (code == 37 || (mac$2 && code == 66 && mods == "c")) { // Left arrow, Ctrl-b on Mac
        let dir = code == 37 ? (findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1) : -1;
        return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
    }
    else if (code == 39 || (mac$2 && code == 70 && mods == "c")) { // Right arrow, Ctrl-f on Mac
        let dir = code == 39 ? (findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1) : 1;
        return selectHorizontally(view, dir, mods) || skipIgnoredNodes(view, dir);
    }
    else if (code == 38 || (mac$2 && code == 80 && mods == "c")) { // Up arrow, Ctrl-p on Mac
        return selectVertically(view, -1, mods) || skipIgnoredNodes(view, -1);
    }
    else if (code == 40 || (mac$2 && code == 78 && mods == "c")) { // Down arrow, Ctrl-n on Mac
        return safariDownArrowBug(view) || selectVertically(view, 1, mods) || skipIgnoredNodes(view, 1);
    }
    else if (mods == (mac$2 ? "m" : "c") &&
        (code == 66 || code == 73 || code == 89 || code == 90)) { // Mod-[biyz]
        return true;
    }
    return false;
}

function serializeForClipboard(view, slice) {
    view.someProp("transformCopied", f => { slice = f(slice, view); });
    let context = [], { content, openStart, openEnd } = slice;
    while (openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1) {
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || DOMSerializer.fromSchema(view.state.schema);
    let doc = detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, { document: doc }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while (firstChild && firstChild.nodeType == 1 && (needsWrap = wrapMap[firstChild.nodeName.toLowerCase()])) {
        for (let i = needsWrap.length - 1; i >= 0; i--) {
            let wrapper = doc.createElement(needsWrap[i]);
            while (wrap.firstChild)
                wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1)
        firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", f => f(slice, view)) ||
        slice.content.textBetween(0, slice.content.size, "\n\n");
    return { dom: wrap, text, slice };
}
// Read a slice of content from the clipboard (or drop data).
function parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text)
        return null;
    let asText = !!text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", f => { text = f(text, inCode || plainText, view); });
        if (inCode) {
            slice = new Slice(Fragment.from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0);
            view.someProp("transformPasted", f => { slice = f(slice, view, true); });
            return slice;
        }
        let parsed = view.someProp("clipboardTextParser", f => f(text, $context, plainText, view));
        if (parsed) {
            slice = parsed;
        }
        else {
            let marks = $context.marks();
            let { schema } = view.state, serializer = DOMSerializer.fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach(block => {
                let p = dom.appendChild(document.createElement("p"));
                if (block)
                    p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    }
    else {
        view.someProp("transformPastedHTML", f => { html = f(html, view); });
        dom = readHTML(html);
        if (webkit)
            restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3])
        for (let i = +sliceData[3]; i > 0; i--) {
            let child = dom.firstChild;
            while (child && child.nodeType != 1)
                child = child.nextSibling;
            if (!child)
                break;
            dom = child;
        }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode(dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling &&
                    dom.parentNode && !inlineParents.test(dom.parentNode.nodeName))
                    return { ignore: true };
                return null;
            }
        });
    }
    if (sliceData) {
        slice = addContext(closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    }
    else { // HTML wasn't created by ProseMirror. Make sure top-level siblings are coherent
        slice = Slice.maxOpen(normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for (let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild) { }
            for (let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild) { }
            slice = closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", f => { slice = f(slice, view, asText); });
    return slice;
}
const inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2)
        return fragment;
    for (let d = $context.depth; d >= 0; d--) {
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach(node => {
            if (!result)
                return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap)
                return result = null;
            if (inLast = result.length && lastWrap.length && addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) {
                result[result.length - 1] = inLast;
            }
            else {
                if (result.length)
                    result[result.length - 1] = closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result)
            return Fragment.from(result);
    }
    return fragment;
}
function withWrappers(node, wrap, from = 0) {
    for (let i = wrap.length - 1; i >= from; i--)
        node = wrap[i].create(null, Fragment.from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner)
            return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1]))
            return sibling.copy(sibling.content.append(Fragment.from(withWrappers(node, wrap, depth + 1))));
    }
}
function closeRight(node, depth) {
    if (depth == 0)
        return node;
    let fragment = node.content.replaceChild(node.childCount - 1, closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true);
    return node.copy(fragment.append(fill));
}
function closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1)
        openEnd = 0;
    if (depth < to - 1)
        inner = closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from)
        inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner)
            : inner.append(node.contentMatchAt(node.childCount).fillBefore(Fragment.empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart)
        slice = new Slice(closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd)
        slice = new Slice(closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const wrapMap = {
    thead: ["table"],
    tbody: ["table"],
    tfoot: ["table"],
    caption: ["table"],
    colgroup: ["table"],
    col: ["table", "colgroup"],
    tr: ["table", "tbody"],
    td: ["table", "tbody", "tr"],
    th: ["table", "tbody", "tr"]
};
function detachedDoc() {
    return document.implementation.createHTMLDocument("title");
}
let _policy = null;
function maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes)
        return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!_policy) {
        if (_policy = trustedTypes.defaultPolicy)
            try {
                return _policy.createHTML(html);
            }
            catch (_a) { }
        _policy = trustedTypes.createPolicy("ProseMirrorClipboard", { createHTML: (s) => s });
    }
    return _policy.createHTML(html);
}
function readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas)
        html = html.slice(metas[0].length);
    let doc = detachedDoc(), elt = doc.body;
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && wrapMap[firstTag[1].toLowerCase()])
        html = wrap.map(n => "<" + n + ">").join("") + html + wrap.map(n => "</" + n + ">").reverse().join("");
    elt.innerHTML = maybeWrapTrusted(html);
    if (wrap)
        for (let i = 0; i < wrap.length; i++)
            elt = elt.querySelector(wrap[i]) || elt;
    // Inline styles defined in the pasted content, so that parse rules pick them up
    for (let i = 0; i < doc.styleSheets.length; i++) {
        let style = doc.styleSheets[i];
        for (let j = 0; j < style.rules.length; j++) {
            let rule = style.rules[j];
            if (rule instanceof CSSStyleRule) {
                let matches = elt.querySelectorAll(rule.selectorText);
                for (let k = 0; k < matches.length; k++)
                    matches[k].style.cssText += rule.style.cssText;
            }
        }
    }
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll(chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for (let i = 0; i < nodes.length; i++) {
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode)
            node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function addContext(slice, context) {
    if (!slice.size)
        return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    }
    catch (e) {
        return slice;
    }
    let { content, openStart, openEnd } = slice;
    for (let i = array.length - 2; i >= 0; i -= 2) {
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs())
            break;
        try {
            type.checkAttrs(array[i + 1]);
        }
        catch (e) {
            break;
        }
        content = Fragment.from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new Slice(content, openStart, openEnd);
}

// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const handlers = {};
const editHandlers = {};
const passiveHandlers = { touchstart: true, touchmove: true };
class InputState {
    constructor() {
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -2e8;
        this.compositionID = 1;
        this.badSafariComposition = false;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function initInput(view) {
    for (let event in handlers) {
        let handler = handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event) => {
            if (eventBelongsToView(view, event) && !runCustomHandler(view, event) &&
                (view.editable || !(event.type in editHandlers)))
                handler(view, event);
        }, passiveHandlers[event] ? { passive: true } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if (safari)
        view.dom.addEventListener("input", () => null);
    ensureListeners(view);
}
function setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function destroyInput(view) {
    if (view.input.mouseDown)
        view.input.mouseDown.done();
    view.domObserver.stop();
    for (let type in view.input.eventHandlers)
        view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function ensureListeners(view) {
    view.someProp("handleDOMEvents", currentHandlers => {
        for (let type in currentHandlers)
            if (!view.input.eventHandlers[type])
                view.dom.addEventListener(type, view.input.eventHandlers[type] = event => runCustomHandler(view, event));
    });
}
function runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", handlers => {
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function eventBelongsToView(view, event) {
    if (!event.bubbles)
        return true;
    if (event.defaultPrevented)
        return false;
    for (let node = event.target; node != view.dom; node = node.parentNode)
        if (!node || node.nodeType == 11 ||
            (node.pmViewDesc && node.pmViewDesc.stopEvent(event)))
            return false;
    return true;
}
function dispatchEvent(view, event) {
    if (!runCustomHandler(view, event) && handlers[event.type] &&
        (view.editable || !(event.type in editHandlers)))
        handlers[event.type](view, event);
}
editHandlers.keydown = (view, _event) => {
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if (inOrNearComposition(view))
        return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if (android && chrome && event.keyCode == 13)
        return;
    if (event.keyCode != 229)
        view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if (ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    }
    else if (view.someProp("handleKeyDown", f => f(view, event)) || captureKeyDown(view, event)) {
        event.preventDefault();
    }
    else {
        setSelectionOrigin(view, "key");
    }
};
editHandlers.keyup = (view, event) => {
    if (event.keyCode == 16)
        view.input.shiftKey = false;
};
editHandlers.keypress = (view, _event) => {
    let event = _event;
    if (inOrNearComposition(view) || !event.charCode ||
        event.ctrlKey && !event.altKey || mac$2 && event.metaKey)
        return;
    if (view.someProp("handleKeyPress", f => f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof TextSelection) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        let deflt = () => view.state.tr.insertText(text).scrollIntoView();
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", f => f(view, sel.$from.pos, sel.$to.pos, text, deflt)))
            view.dispatch(deflt());
        event.preventDefault();
    }
};
function eventCoords(event) { return { left: event.clientX, top: event.clientY }; }
function isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1)
        return false;
    let $pos = view.state.doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        if (view.someProp(propName, f => i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true)
            : f(view, pos, $pos.node(i), $pos.before(i), event, false)))
            return true;
    }
    return false;
}
function updateSelection(view, selection, origin) {
    if (!view.focused)
        view.focus();
    if (view.state.selection.eq(selection))
        return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer")
        tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function selectClickedLeaf(view, inside) {
    if (inside == -1)
        return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && NodeSelection.isSelectable(node)) {
        updateSelection(view, new NodeSelection($pos), "pointer");
        return true;
    }
    return false;
}
function selectClickedNode(view, inside) {
    if (inside == -1)
        return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof NodeSelection)
        selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if (NodeSelection.isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 &&
                i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos)
                selectAt = $pos.before(sel.$from.depth);
            else
                selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        updateSelection(view, NodeSelection.create(view.state.doc, selectAt), "pointer");
        return true;
    }
    else {
        return false;
    }
}
function handleSingleClick(view, pos, inside, event, selectNode) {
    return runHandlerOnContext(view, "handleClickOn", pos, inside, event) ||
        view.someProp("handleClick", f => f(view, pos, event)) ||
        (selectNode ? selectClickedNode(view, inside) : selectClickedLeaf(view, inside));
}
function handleDoubleClick(view, pos, inside, event) {
    return runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) ||
        view.someProp("handleDoubleClick", f => f(view, pos, event));
}
function handleTripleClick(view, pos, inside, event) {
    return runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) ||
        view.someProp("handleTripleClick", f => f(view, pos, event)) ||
        defaultTripleClick(view, inside, event);
}
function defaultTripleClick(view, inside, event) {
    if (event.button != 0)
        return false;
    let selection = selectionForTripleClick(view, inside, true), doc = view.state.doc;
    if (!selection)
        return false;
    updateSelection(view, selection, "pointer");
    if (selection instanceof TextSelection && doc.eq(view.state.doc))
        view.input.mouseDown = new TripleClickDrag(view, selection);
    return true;
}
function selectionForTripleClick(view, inside, selectNodes) {
    let doc = view.state.doc;
    if (inside == -1)
        return doc.inlineContent ? TextSelection.create(doc, 0, doc.content.size) : null;
    let $pos = doc.resolve(inside);
    for (let i = $pos.depth + 1; i > 0; i--) {
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent)
            return TextSelection.create(doc, nodePos + 1, nodePos + 1 + node.content.size);
        else if (selectNodes && NodeSelection.isSelectable(node))
            return NodeSelection.create(doc, nodePos);
    }
    return null;
}
function forceDOMFlush(view) {
    return endComposition(view);
}
const selectNodeModifier = mac$2 ? "metaKey" : "ctrlKey";
handlers.mousedown = (view, _event) => {
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && isNear(event, view.input.lastClick) && !event[selectNodeModifier] &&
        view.input.lastClick.button == event.button) {
        if (view.input.lastClick.type == "singleClick")
            type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick")
            type = "tripleClick";
    }
    view.input.lastClick = { time: now, x: event.clientX, y: event.clientY, type, button: event.button };
    if (view.input.mouseDown)
        view.input.mouseDown.done();
    let pos = view.posAtCoords(eventCoords(event));
    if (!pos)
        return;
    if (type == "singleClick") {
        view.input.mouseDown = new LeftMouseDown(view, pos, event, !!flushed);
    }
    else if ((type == "doubleClick" ? handleDoubleClick : handleTripleClick)(view, pos.pos, pos.inside, event)) {
        event.preventDefault();
    }
    else {
        setSelectionOrigin(view, "pointer");
    }
};
class MouseDown {
    constructor(view) {
        this.view = view;
        this.mightDrag = null;
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
    }
    up(event) {
        this.done();
    }
    move(event) {
        if (event.buttons == 0)
            this.done();
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.view.input.mouseDown == this)
            this.view.input.mouseDown = null;
    }
    delaySelUpdate() { return false; }
}
class LeftMouseDown extends MouseDown {
    constructor(view, pos, event, flushed) {
        super(view);
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        }
        else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.nodeDOM.nodeType == 1 ? targetDesc.nodeDOM : null;
        let { selection } = view.state;
        if (event.button == 0 &&
            (targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false ||
                selection instanceof NodeSelection && selection.from <= targetPos && selection.to > targetPos))
            this.mightDrag = {
                node: targetNode,
                pos: targetPos,
                addAttr: !!(this.target && !this.target.draggable),
                setUneditable: !!(this.target && gecko && !this.target.hasAttribute("contentEditable"))
            };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr)
                this.target.draggable = true;
            if (this.mightDrag.setUneditable)
                setTimeout(() => {
                    if (this.view.input.mouseDown == this)
                        this.target.setAttribute("contentEditable", "false");
                }, 20);
            this.view.domObserver.start();
        }
        setSelectionOrigin(view, "pointer");
    }
    done() {
        super.done();
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr)
                this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable)
                this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync)
            setTimeout(() => {
                if (!this.view.isDestroyed)
                    selectionToDOM(this.view);
            });
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target))
            return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc)
            pos = this.view.posAtCoords(eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) {
            setSelectionOrigin(this.view, "pointer");
        }
        else if (handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) {
            event.preventDefault();
        }
        else if (event.button == 0 &&
            (this.flushed ||
                // Safari ignores clicks on draggable elements
                (safari && this.mightDrag && !this.mightDrag.node.isAtom) ||
                // Chrome will sometimes treat a node selection as a
                // cursor, but still report that the node is selected
                // when asked through getSelection. You'll then get a
                // situation where clicking at the point where that
                // (hidden) cursor is doesn't change the selection, and
                // thus doesn't get a reaction from ProseMirror. This
                // works around that.
                (chrome && !this.view.state.selection.visible &&
                    Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2))) {
            updateSelection(this.view, Selection.near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        }
        else {
            setSelectionOrigin(this.view, "pointer");
        }
    }
    move(event) {
        this.updateAllowDefault(event);
        setSelectionOrigin(this.view, "pointer");
        super.move(event);
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 ||
            Math.abs(this.event.y - event.clientY) > 4))
            this.allowDefault = true;
    }
    delaySelUpdate() {
        if (!this.allowDefault)
            return false;
        this.delayedSelectionSync = true;
        return true;
    }
}
class TripleClickDrag extends MouseDown {
    constructor(view, startSelection) {
        super(view);
        this.startSelection = startSelection;
        this.startDoc = view.state.doc;
    }
    move(event) {
        if (event.buttons == 0 || this.view.isDestroyed || !this.view.state.doc.eq(this.startDoc)) {
            this.done();
            return;
        }
        event.preventDefault();
        setSelectionOrigin(this.view, "pointer");
        let pos = this.view.posAtCoords(eventCoords(event));
        let target = pos && selectionForTripleClick(this.view, pos.inside, false);
        if (!target)
            return;
        let { doc } = this.view.state, start = this.startSelection;
        let [anchor, head] = target.from < start.from ? [start.to, target.from] : [start.from, target.to];
        updateSelection(this.view, TextSelection.create(doc, anchor, head), "pointer");
    }
}
handlers.touchstart = view => {
    view.input.lastTouch = Date.now();
    forceDOMFlush(view);
    setSelectionOrigin(view, "pointer");
};
handlers.touchmove = view => {
    view.input.lastTouch = Date.now();
    setSelectionOrigin(view, "pointer");
};
handlers.contextmenu = view => forceDOMFlush(view);
function inOrNearComposition(view, event) {
    if (view.composing)
        return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if (safari && Math.abs(Date.now() - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -2e8;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const timeoutComposition = android ? 5000 : -1;
editHandlers.compositionstart = editHandlers.compositionupdate = view => {
    if (!view.composing) {
        view.domObserver.flush();
        let { state } = view, $pos = state.selection.$to;
        if (state.selection instanceof TextSelection &&
            (state.storedMarks ||
                (!$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some(m => m.type.spec.inclusive === false)) ||
                chrome && windows$1 && selectionBeforeUneditable(view))) { // Issue #1500
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            endComposition(view, true);
            view.markCursor = null;
        }
        else {
            endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if (gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for (let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;) {
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before)
                        break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel)
                            sel.collapse(before, before.nodeValue.length);
                        break;
                    }
                    else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    scheduleComposeEnd(view, timeoutComposition);
};
function selectionBeforeUneditable(view) {
    let { focusNode, focusOffset } = view.domSelectionRange();
    if (!focusNode || focusNode.nodeType != 1 || focusOffset >= focusNode.childNodes.length)
        return false;
    let next = focusNode.childNodes[focusOffset];
    return next.nodeType == 1 && next.contentEditable == "false";
}
editHandlers.compositionend = (view, event) => {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = Date.now();
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.badSafariComposition)
            view.domObserver.forceFlush();
        else if (view.input.compositionPendingChanges)
            Promise.resolve().then(() => view.domObserver.flush());
        view.input.compositionID++;
        scheduleComposeEnd(view, 20);
    }
};
function scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1)
        view.input.composingTimeout = setTimeout(() => endComposition(view), delay);
}
function clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = Date.now();
    }
    while (view.input.compositionNodes.length > 0)
        view.input.compositionNodes.pop().markParentsDirty();
}
function findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode)
        return null;
    let textBefore = textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged)
            return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) {
            return textAfter;
        }
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue)))
                return textAfter;
        }
    }
    return textBefore || textAfter;
}
/**
@internal
*/
function endComposition(view, restarting = false) {
    if (android && view.domObserver.flushingSoon >= 0)
        return;
    view.domObserver.forceFlush();
    clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = selectionFromDOM(view), cur = view.state.selection;
        if (sel && !sel.eq(cur))
            view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !cur.$from.node(cur.$from.sharedDepth(cur.to)).inlineContent)
            view.dispatch(view.state.tr.deleteSelection());
        else
            view.updateState(view.state);
        return true;
    }
    return false;
}
function captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode)
        return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(() => {
        if (wrap.parentNode)
            wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const brokenClipboardAPI = (ie$1 && ie_version < 15) ||
    (ios && webkit_version < 604);
handlers.copy = editHandlers.cut = (view, _event) => {
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty)
        return;
    // IE and Edge's clipboard interface is completely broken
    let data = brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom, text } = serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    }
    else {
        captureCopy(view, dom);
    }
    if (cut)
        view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function capturePaste(view, event) {
    if (!view.dom.parentNode)
        return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText)
        target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(() => {
        view.focus();
        if (target.parentNode)
            target.parentNode.removeChild(target);
        if (plainText)
            doPaste(view, target.value, null, plain, event);
        else
            doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function doPaste(view, text, html, preferPlain, event) {
    let slice = parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", f => f(view, event, slice || Slice.empty)))
        return true;
    if (!slice)
        return false;
    let singleNode = sliceSingleNode(slice);
    let tr = singleNode
        ? view.state.tr.replaceSelectionWith(singleNode, preferPlain)
        : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function getText$1(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text)
        return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
editHandlers.paste = (view, _event) => {
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !android)
        return;
    let data = brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && doPaste(view, getText$1(data), data.getData("text/html"), plain, event))
        event.preventDefault();
    else
        capturePaste(view, event);
};
class Dragging {
    constructor(slice, move, node) {
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const dragCopyModifier = mac$2 ? "altKey" : "ctrlKey";
function dragMoves(view, event) {
    let copy;
    view.someProp("dragCopies", test => { copy = copy || test(event); });
    return copy != null ? !copy : !event[dragCopyModifier];
}
handlers.dragstart = (view, _event) => {
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown)
        mouseDown.done();
    if (!event.dataTransfer)
        return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords(eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof NodeSelection ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) {
        node = NodeSelection.create(view.state.doc, mouseDown.mightDrag.pos);
    }
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView)
            node = NodeSelection.create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom, text, slice } = serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !chrome || chrome_version > 120)
        event.dataTransfer.clearData();
    event.dataTransfer.setData(brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://code.haverbeke.berlin/prosemirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!brokenClipboardAPI)
        event.dataTransfer.setData("text/plain", text);
    view.dragging = new Dragging(slice, dragMoves(view, event), node);
};
handlers.dragend = view => {
    let dragging = view.dragging;
    window.setTimeout(() => {
        if (view.dragging == dragging)
            view.dragging = null;
    }, 50);
};
editHandlers.dragover = editHandlers.dragenter = (_, e) => e.preventDefault();
editHandlers.drop = (view, event) => {
    try {
        handleDrop(view, event, view.dragging);
    }
    finally {
        view.dragging = null;
    }
};
function handleDrop(view, event, dragging) {
    if (!event.dataTransfer)
        return;
    let eventPos = view.posAtCoords(eventCoords(event));
    if (!eventPos)
        return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) {
        view.someProp("transformPasted", f => { slice = f(slice, view, false); });
    }
    else {
        slice = parseFromClipboard(view, getText$1(event.dataTransfer), brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    }
    let move = !!(dragging && dragMoves(view, event));
    if (view.someProp("handleDrop", f => f(view, event, slice || Slice.empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice)
        return;
    event.preventDefault();
    let insertPos = slice ? dropPoint(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null)
        insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node } = dragging;
        if (node)
            node.replace(tr);
        else
            tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode)
        tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else
        tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert))
        return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && NodeSelection.isSelectable(slice.content.firstChild) &&
        $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) {
        tr.setSelection(new NodeSelection($pos));
    }
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo) => end = newTo);
        tr.setSelection(selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
}
handlers.focus = view => {
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(() => {
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange()))
                selectionToDOM(view);
        }, 20);
    }
};
handlers.blur = (view, _event) => {
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget))
            view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
handlers.beforeinput = (view, _event) => {
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome and Firefox Android when after an uneditable node.
    if (android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount } = view.input;
        setTimeout(() => {
            if (view.input.domChangeCount != domChangeCount)
                return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", f => f(view, keyEvent(8, "Backspace"))))
                return;
            let { $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0)
                view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for (let prop in editHandlers)
    handlers[prop] = editHandlers[prop];

function compareObjs(a, b) {
    if (a == b)
        return true;
    for (let p in a)
        if (a[p] !== b[p])
            return false;
    for (let p in b)
        if (!(p in a))
            return false;
    return true;
}
class WidgetType {
    constructor(toDOM, spec) {
        this.toDOM = toDOM;
        this.spec = spec || noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos, deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new Decoration(pos - offset, pos - offset, this);
    }
    valid() { return true; }
    eq(other) {
        return this == other ||
            (other instanceof WidgetType &&
                (this.spec.key && this.spec.key == other.spec.key ||
                    this.toDOM == other.toDOM && compareObjs(this.spec, other.spec)));
    }
    destroy(node) {
        if (this.spec.destroy)
            this.spec.destroy(node);
    }
}
class InlineType {
    constructor(attrs, spec) {
        this.attrs = attrs;
        this.spec = spec || noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new Decoration(from, to, this);
    }
    valid(_, span) { return span.from < span.to; }
    eq(other) {
        return this == other ||
            (other instanceof InlineType && compareObjs(this.attrs, other.attrs) &&
                compareObjs(this.spec, other.spec));
    }
    static is(span) { return span.type instanceof InlineType; }
    destroy() { }
}
class NodeType {
    constructor(attrs, spec) {
        this.attrs = attrs;
        this.spec = spec || noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted)
            return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos)
            return null;
        return new Decoration(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index, offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other ||
            (other instanceof NodeType && compareObjs(this.attrs, other.attrs) &&
                compareObjs(this.spec, other.spec));
    }
    destroy() { }
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/
class Decoration {
    /**
    @internal
    */
    constructor(
    /**
    The start position of the decoration.
    */
    from, 
    /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */
    to, 
    /**
    @internal
    */
    type) {
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */
    copy(from, to) {
        return new Decoration(from, to, this.type);
    }
    /**
    @internal
    */
    eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */
    map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */
    static widget(pos, toDOM, spec) {
        return new Decoration(pos, pos, new WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */
    static inline(from, to, attrs, spec) {
        return new Decoration(from, to, new InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */
    static node(from, to, attrs, spec) {
        return new Decoration(from, to, new NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */
    get spec() { return this.type.spec; }
    /**
    @internal
    */
    get inline() { return this.type instanceof InlineType; }
    /**
    @internal
    */
    get widget() { return this.type instanceof WidgetType; }
}
const none = [], noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/
class DecorationSet {
    /**
    @internal
    */
    constructor(local, children) {
        this.local = local.length ? local : none;
        this.children = children.length ? children : none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */
    static create(doc, decorations) {
        return decorations.length ? buildTree(decorations, doc, 0, noSpec) : empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */
    find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for (let i = 0; i < this.local.length; i++) {
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec)))
                result.push(span.copy(span.from + offset, span.to + offset));
        }
        for (let i = 0; i < this.children.length; i += 3) {
            if (this.children[i] < end && this.children[i + 1] > start) {
                let childOff = this.children[i] + 1;
                this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
            }
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */
    map(mapping, doc, options) {
        if (this == empty || mapping.maps.length == 0)
            return this;
        return this.mapInner(mapping, doc, 0, 0, options || noSpec);
    }
    /**
    @internal
    */
    mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for (let i = 0; i < this.local.length; i++) {
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped))
                (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove)
                options.onRemove(this.local[i].spec);
        }
        if (this.children.length)
            return mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else
            return newLocal ? new DecorationSet(newLocal.sort(byPos), none) : empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */
    add(doc, decorations) {
        if (!decorations.length)
            return this;
        if (this == empty)
            return DecorationSet.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset) => {
            let baseOffset = childOffset + offset, found;
            if (!(found = takeSpansForNode(decorations, childNode, baseOffset)))
                return;
            if (!children)
                children = this.children.slice();
            while (childIndex < children.length && children[childIndex] < childOffset)
                childIndex += 3;
            if (children[childIndex] == childOffset)
                children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else
                children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, buildTree(found, childNode, baseOffset + 1, noSpec));
            childIndex += 3;
        });
        let local = moveSpans(childIndex ? withoutNulls(decorations) : decorations, -offset);
        for (let i = 0; i < local.length; i++)
            if (!local[i].type.valid(doc, local[i]))
                local.splice(i--, 1);
        return new DecorationSet(local.length ? this.local.concat(local).sort(byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */
    remove(decorations) {
        if (decorations.length == 0 || this == empty)
            return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for (let i = 0; i < children.length; i += 3) {
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for (let j = 0, span; j < decorations.length; j++)
                if (span = decorations[j]) {
                    if (span.from > from && span.to < to) {
                        decorations[j] = null;
                        (found || (found = [])).push(span);
                    }
                }
            if (!found)
                continue;
            if (children == this.children)
                children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != empty) {
                children[i + 2] = removed;
            }
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length)
            for (let i = 0, span; i < decorations.length; i++)
                if (span = decorations[i]) {
                    for (let j = 0; j < local.length; j++)
                        if (local[j].eq(span, offset)) {
                            if (local == this.local)
                                local = this.local.slice();
                            local.splice(j--, 1);
                        }
                }
        if (children == this.children && local == this.local)
            return this;
        return local.length || children.length ? new DecorationSet(local, children) : empty;
    }
    forChild(offset, node) {
        if (this == empty)
            return this;
        if (node.isLeaf)
            return DecorationSet.empty;
        let child, local;
        for (let i = 0; i < this.children.length; i += 3)
            if (this.children[i] >= offset) {
                if (this.children[i] == offset)
                    child = this.children[i + 2];
                break;
            }
        let start = offset + 1, end = start + node.content.size;
        for (let i = 0; i < this.local.length; i++) {
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && (dec.type instanceof InlineType)) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to)
                    (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new DecorationSet(local.sort(byPos), none);
            return child ? new DecorationGroup([localSet, child]) : localSet;
        }
        return child || empty;
    }
    /**
    @internal
    */
    eq(other) {
        if (this == other)
            return true;
        if (!(other instanceof DecorationSet) ||
            this.local.length != other.local.length ||
            this.children.length != other.children.length)
            return false;
        for (let i = 0; i < this.local.length; i++)
            if (!this.local[i].eq(other.local[i]))
                return false;
        for (let i = 0; i < this.children.length; i += 3)
            if (this.children[i] != other.children[i] ||
                this.children[i + 1] != other.children[i + 1] ||
                !this.children[i + 2].eq(other.children[i + 2]))
                return false;
        return true;
    }
    /**
    @internal
    */
    locals(node) {
        return removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */
    localsInner(node) {
        if (this == empty)
            return none;
        if (node.inlineContent || !this.local.some(InlineType.is))
            return this.local;
        let result = [];
        for (let i = 0; i < this.local.length; i++) {
            if (!(this.local[i].type instanceof InlineType))
                result.push(this.local[i]);
        }
        return result;
    }
    forEachSet(f) { f(this); }
}
/**
The empty set of decorations.
*/
DecorationSet.empty = new DecorationSet([], []);
/**
@internal
*/
DecorationSet.removeOverlap = removeOverlap;
const empty = DecorationSet.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class DecorationGroup {
    constructor(members) {
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map(member => member.map(mapping, doc, noSpec));
        return DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf)
            return DecorationSet.empty;
        let found = [];
        for (let i = 0; i < this.members.length; i++) {
            let result = this.members[i].forChild(offset, child);
            if (result == empty)
                continue;
            if (result instanceof DecorationGroup)
                found = found.concat(result.members);
            else
                found.push(result);
        }
        return DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof DecorationGroup) ||
            other.members.length != this.members.length)
            return false;
        for (let i = 0; i < this.members.length; i++)
            if (!this.members[i].eq(other.members[i]))
                return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for (let i = 0; i < this.members.length; i++) {
            let locals = this.members[i].localsInner(node);
            if (!locals.length)
                continue;
            if (!result) {
                result = locals;
            }
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for (let j = 0; j < locals.length; j++)
                    result.push(locals[j]);
            }
        }
        return result ? removeOverlap(sorted ? result : result.sort(byPos)) : none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch (members.length) {
            case 0: return empty;
            case 1: return members[0];
            default: return new DecorationGroup(members.every(m => m instanceof DecorationSet) ? members :
                members.reduce((r, m) => r.concat(m instanceof DecorationSet ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for (let i = 0; i < this.members.length; i++)
            this.members[i].forEachSet(f);
    }
}
function mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for (let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++) {
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd) => {
            let dSize = (newEnd - newStart) - (oldEnd - oldStart);
            for (let i = 0; i < children.length; i += 3) {
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved)
                    continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) {
                    children[i + 1] = oldStart <= start ? -2 : -1;
                }
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for (let i = 0; i < children.length; i += 3)
        if (children[i + 1] < 0) { // Touched nodes
            if (children[i + 1] == -2) {
                mustRebuild = true;
                children[i + 1] = -1;
                continue;
            }
            let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
            if (fromLocal < 0 || fromLocal >= node.content.size) {
                mustRebuild = true;
                continue;
            }
            // Must read oldChildren because children was tagged with -1
            let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
            let { index, offset: childOffset } = node.content.findIndex(fromLocal);
            let childNode = node.maybeChild(index);
            if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
                let mapped = children[i + 2]
                    .mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
                if (mapped != empty) {
                    children[i] = fromLocal;
                    children[i + 1] = toLocal;
                    children[i + 2] = mapped;
                }
                else {
                    children[i + 1] = -2;
                    mustRebuild = true;
                }
            }
            else {
                mustRebuild = true;
            }
        }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for (let i = 0; i < children.length; i += 3)
            if (children[i + 1] < 0) {
                children.splice(i, 3);
                i -= 3;
            }
        for (let i = 0, j = 0; i < built.children.length; i += 3) {
            let from = built.children[i];
            while (j < children.length && children[j] < from)
                j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new DecorationSet(newLocal.sort(byPos), children);
}
function moveSpans(spans, offset) {
    if (!offset || !spans.length)
        return spans;
    let result = [];
    for (let i = 0; i < spans.length; i++) {
        let span = spans[i];
        result.push(new Decoration(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for (let i = 0; i < set.local.length; i++) {
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped)
                decorations.push(mapped);
            else if (options.onRemove)
                options.onRemove(set.local[i].spec);
        }
        for (let i = 0; i < set.children.length; i += 3)
            gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for (let i = 0; i < children.length; i += 3)
        if (children[i + 1] == -1)
            gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function takeSpansForNode(spans, node, offset) {
    if (node.isLeaf)
        return null;
    let end = offset + node.nodeSize, found = null;
    for (let i = 0, span; i < spans.length; i++) {
        if ((span = spans[i]) && span.from > offset && span.to < end) {
            (found || (found = [])).push(span);
            spans[i] = null;
        }
    }
    return found;
}
function withoutNulls(array) {
    let result = [];
    for (let i = 0; i < array.length; i++)
        if (array[i] != null)
            result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart) => {
        let found = takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != empty)
                children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = moveSpans(hasNulls ? withoutNulls(spans) : spans, -offset).sort(byPos);
    for (let i = 0; i < locals.length; i++)
        if (!locals[i].type.valid(node, locals[i])) {
            if (options.onRemove)
                options.onRemove(locals[i].spec);
            locals.splice(i--, 1);
        }
    return locals.length || children.length ? new DecorationSet(locals, children) : empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function removeOverlap(spans) {
    let working = spans;
    for (let i = 0; i < working.length - 1; i++) {
        let span = working[i];
        if (span.from != span.to)
            for (let j = i + 1; j < working.length; j++) {
                let next = working[j];
                if (next.from == span.from) {
                    if (next.to != span.to) {
                        if (working == spans)
                            working = spans.slice();
                        // Followed by a partially overlapping larger span. Split that
                        // span.
                        working[j] = next.copy(next.from, span.to);
                        insertAhead(working, j + 1, next.copy(span.to, next.to));
                    }
                    continue;
                }
                else {
                    if (next.from < span.to) {
                        if (working == spans)
                            working = spans.slice();
                        // The end of this one overlaps with a subsequent span. Split
                        // this one.
                        working[i] = span.copy(span.from, next.from);
                        insertAhead(working, j, span.copy(next.from, span.to));
                    }
                    break;
                }
            }
    }
    return working;
}
function insertAhead(array, i, deco) {
    while (i < array.length && byPos(deco, array[i]) > 0)
        i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function viewDecorations(view) {
    let found = [];
    view.someProp("decorations", f => {
        let result = f(view.state);
        if (result && result != empty)
            found.push(result);
    });
    if (view.cursorWrapper)
        found.push(DecorationSet.create(view.state.doc, [view.cursorWrapper.deco]));
    return DecorationGroup.from(found);
}

const observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const useCharData = ie$1 && ie_version <= 11;
class SelectionState {
    constructor() {
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset &&
            sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class DOMObserver {
    constructor(view, handleDOMChange) {
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver &&
            new window.MutationObserver(mutations => {
                for (let i = 0; i < mutations.length; i++)
                    this.queue.push(mutations[i]);
                if (ie$1 && ie_version <= 11 && mutations.some(m => m.type == "childList" && m.removedNodes.length ||
                    m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) {
                    // IE11 will sometimes (on backspacing out a single character
                    // text node after a BR node) call the observer callback
                    // before actually updating the DOM, which will cause
                    // ProseMirror to miss the change (see #930)
                    this.flushSoon();
                }
                else if (safari && view.composing && mutations.some(m => m.type == "childList" && m.target.nodeName == "TR")) {
                    // Safari does weird stuff when finishing a composition in a
                    // table cell, which tends to involve inserting inappropriate
                    // nodes in the table row.
                    view.input.badSafariComposition = true;
                    this.flushSoon();
                }
                else {
                    this.flush();
                }
            });
        if (useCharData) {
            this.onCharData = e => {
                this.queue.push({ target: e.target, type: "characterData", oldValue: e.prevValue });
                this.flushSoon();
            };
        }
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0)
            this.flushingSoon = window.setTimeout(() => { this.flushingSoon = -1; this.flush(); }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, observeOptions);
        }
        if (this.onCharData)
            this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for (let i = 0; i < take.length; i++)
                    this.queue.push(take[i]);
                window.setTimeout(() => this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData)
            this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(() => this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!hasFocusAndSelection(this.view))
            return;
        if (this.suppressingSelectionUpdates)
            return selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if (ie$1 && ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
                return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode)
            return true;
        let ancestors = new Set, container;
        for (let scan = sel.focusNode; scan; scan = parentNode(scan))
            ancestors.add(scan);
        for (let scan = sel.anchorNode; scan; scan = parentNode(scan))
            if (ancestors.has(scan)) {
                container = scan;
                break;
            }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer)
            for (let mut of this.observer.takeRecords())
                this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view } = this;
        if (!view.docView || this.flushingSoon > -1)
            return;
        let mutations = this.pendingRecords();
        if (mutations.length)
            this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) {
            for (let i = 0; i < mutations.length; i++) {
                let result = this.registerMutation(mutations[i], added);
                if (result) {
                    from = from < 0 ? result.from : Math.min(result.from, from);
                    to = to < 0 ? result.to : Math.max(result.to, to);
                    if (result.typeOver)
                        typeOver = true;
                }
            }
        }
        if (added.some(n => n.nodeName == "BR") &&
            (view.input.lastKeyCode == 8 || view.input.lastKeyCode == 46 ||
                chrome && (view.composing || view.input.compositionEndedAt > Date.now() - 50) &&
                    mutations.some(m => m.type == "childList" && m.removedNodes.length))) {
            // Browsers sometimes insert a bogus break node if you
            // backspace out the last bit of text before an inline-flex node (#1552)
            for (let node of added)
                if (node.nodeName == "BR" && node.parentNode) {
                    let after = node.nextSibling;
                    while (after && after.nodeType == 1) {
                        if (after.contentEditable == "false") {
                            node.parentNode.removeChild(node);
                            break;
                        }
                        after = after.firstChild;
                    }
                }
        }
        else if (gecko && added.length) {
            let brs = added.filter(n => n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode)
                    b.remove();
                else
                    a.remove();
            }
            else {
                let { focusNode } = this.currentSelection;
                for (let br of brs) {
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || blockParent(view, focusNode) != parent))
                        br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 &&
            Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 &&
            selectionCollapsed(sel) && (readSel = selectionFromDOM(view)) &&
            readSel.eq(Selection.near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        }
        else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                checkCSS(view);
            }
            if (view.input.badSafariComposition) {
                view.input.badSafariComposition = false;
                fixUpBadSafariComposition(view, added);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty)
                view.updateState(view.state);
            else if (!this.currentSelection.eq(sel))
                selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1)
            return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" &&
            (desc == this.view.docView || mut.attributeName == "contenteditable" ||
                // Firefox sometimes fires spurious events for null/empty styles
                (mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))))
            return null;
        if (!desc || desc.ignoreMutation(mut))
            return null;
        if (mut.type == "childList") {
            for (let i = 0; i < mut.addedNodes.length; i++) {
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3)
                    this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target))
                return { from: desc.posBefore, to: desc.posAfter };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if (ie$1 && ie_version <= 11 && mut.addedNodes.length) {
                // IE11 gives us incorrect next/prev siblings for some
                // insertions, so if there are added nodes, recompute those
                for (let i = 0; i < mut.addedNodes.length; i++) {
                    let { previousSibling, nextSibling } = mut.addedNodes[i];
                    if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0)
                        prev = previousSibling;
                    if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0)
                        next = nextSibling;
                }
            }
            let fromOffset = prev && prev.parentNode == mut.target
                ? domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target
                ? domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return { from, to };
        }
        else if (mut.type == "attributes") {
            return { from: desc.posAtStart - desc.border, to: desc.posAtEnd + desc.border };
        }
        else { // "characterData"
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let cssChecked = new WeakMap();
let cssCheckWarned = false;
function checkCSS(view) {
    if (cssChecked.has(view))
        return;
    cssChecked.set(view, null);
    if (['normal', 'nowrap', 'pre-line'].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = gecko;
        if (cssCheckWarned)
            return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        cssCheckWarned = true;
    }
}
function rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if (isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset))
        [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
    return { anchorNode, anchorOffset, focusNode, focusOffset };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range)
            return rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? rangeToSelectionRange(view, found) : null;
}
function blockParent(view, node) {
    for (let p = node.parentNode; p && p != view.dom; p = p.parentNode) {
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock)
            return p;
    }
    return null;
}
// Kludge for a Safari bug where, on ending a composition in an
// otherwise empty table cell, it randomly moves the composed text
// into the table row around that cell, greatly confusing everything
// (#188).
function fixUpBadSafariComposition(view, addedNodes) {
    var _a;
    let { focusNode, focusOffset } = view.domSelectionRange();
    for (let node of addedNodes) {
        if (((_a = node.parentNode) === null || _a === void 0 ? void 0 : _a.nodeName) == "TR") {
            let nextCell = node.nextSibling;
            while (nextCell && (nextCell.nodeName != "TD" && nextCell.nodeName != "TH"))
                nextCell = nextCell.nextSibling;
            if (nextCell) {
                let parent = nextCell;
                for (;;) {
                    let first = parent.firstChild;
                    if (!first || first.nodeType != 1 || first.contentEditable == "false" ||
                        /^(BR|IMG)$/.test(first.nodeName))
                        break;
                    parent = first;
                }
                parent.insertBefore(node, parent.firstChild);
                if (focusNode == node)
                    view.domSelection().collapse(node, focusOffset);
            }
            else {
                node.parentNode.removeChild(node);
            }
        }
    }
}

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function parseBetween(view, from_, to_, addedNodes) {
    let { node: parent, fromOffset, toOffset, from, to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [{ node: anchor, offset: domSel.anchorOffset }];
        if (!selectionCollapsed(domSel))
            find.push({ node: domSel.focusNode, offset: domSel.focusOffset });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if (chrome && view.input.lastKeyCode === 8) {
        for (let off = toOffset; off > fromOffset; off--) {
            let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
            if (node.nodeName == "BR" && !desc) {
                toOffset = off;
                break;
            }
            if (!desc || desc.size)
                break;
        }
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: ruleFromNode(addedNodes),
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null)
            head = anchor;
        sel = { anchor: anchor + from, head: head + from };
    }
    return { doc, sel, from, to };
}
const ruleFromNode = (added) => (dom) => {
    let desc = dom.pmViewDesc;
    if (desc) {
        return desc.parseRule(added);
    }
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if (safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return { skip };
        }
        else if (dom.parentNode.lastChild == dom || safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) {
            return { ignore: true };
        }
    }
    else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) {
        return { ignore: true };
    }
    return null;
};
const isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if (chrome && android &&
                view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime &&
                view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter"))))
                return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer")
                tr.setMeta("pointer", true);
            else if (origin == "key")
                tr.scrollIntoView();
            if (compositionID)
                tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = parseBetween(view, from, to, addedNodes);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    }
    else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change)
        view.input.domChangeCount++;
    if ((ios && view.input.lastIOSEnter > Date.now() - 225 || android) &&
        addedNodes.some(n => n.nodeType == 1 && !isInline.test(n.nodeName)) &&
        (!change || change.endA >= change.endB) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof TextSelection && !sel.empty && sel.$head.sameParent(sel.$anchor) &&
            !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) {
            change = { start: sel.from, endA: sel.to, endB: sel.to };
        }
        else {
            if (parse.sel) {
                let sel = resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID)
                        tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to &&
        change.start == change.endB &&
        view.state.selection instanceof TextSelection) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 &&
            view.state.selection.from >= parse.from) {
            change.start = view.state.selection.from;
        }
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 &&
            view.state.selection.to <= parse.to) {
            change.endB += (view.state.selection.to - change.endA);
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if (ie$1 && ie_version <= 11 && change.endB == change.start + 1 &&
        change.endA == change.start && change.start > parse.from &&
        parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (((ios && view.input.lastIOSEnter > Date.now() - 225 &&
        (!inlineChange || addedNodes.some(n => n.nodeName == "DIV" || n.nodeName == "P"))) ||
        (!inlineChange && $from.pos < parse.doc.content.size &&
            (!$from.sameParent($to) || !$from.parent.inlineContent) &&
            $from.pos < $to.pos && !/\S/.test(parse.doc.textBetween($from.pos, $to.pos, "", "")))) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start &&
        looksLikeBackspace(doc, change.start, change.endA, $from, $to) &&
        view.someProp("handleKeyDown", f => f(view, keyEvent(8, "Backspace")))) {
        if (android && chrome)
            view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if (chrome && change.endB == change.start)
        view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if (android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth &&
        parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(() => {
            view.someProp("handleKeyDown", function (f) { return f(view, keyEvent(13, "Enter")); });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let mkTr = (base) => {
        let tr = base || view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
        if (parse.sel) {
            let sel = resolveSelection(view, tr.doc, parse.sel);
            // Chrome will sometimes, during composition, report the
            // selection in the wrong place. If it looks like that is
            // happening, don't update the selection.
            // Edge just doesn't move the cursor forward when you start typing
            // in an empty block or between br nodes.
            if (sel && !(chrome && view.composing && sel.empty &&
                (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) &&
                (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) ||
                ie$1 && sel.empty && sel.head == chFrom))
                tr.setSelection(sel);
        }
        if (compositionID)
            tr.setMeta("composition", compositionID);
        return tr.scrollIntoView();
    };
    let markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) { // Deletion
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if (ie$1 && ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(() => selectionToDOM(view), 20);
            }
            let tr = mkTr(view.state.tr.delete(chFrom, chTo));
            let marks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
            if (marks)
                tr.ensureMarks(marks);
            view.dispatch(tr);
        }
        else if ( // Adding or removing a mark
        change.endA == change.endB &&
            (markChange = isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            let tr = mkTr(view.state.tr);
            if (markChange.type == "add")
                tr.addMark(chFrom, chTo, markChange.mark);
            else
                tr.removeMark(chFrom, chTo, markChange.mark);
            view.dispatch(tr);
        }
        else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            let deflt = () => mkTr(view.state.tr.insertText(text, chFrom, chTo));
            if (!view.someProp("handleTextInput", f => f(view, chFrom, chTo, text, deflt)))
                view.dispatch(deflt());
        }
        else {
            view.dispatch(mkTr());
        }
    }
    else {
        view.dispatch(mkTr());
    }
}
function resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size)
        return null;
    return selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for (let i = 0; i < prevMarks.length; i++)
        added = prevMarks[i].removeFromSet(added);
    for (let i = 0; i < curMarks.length; i++)
        removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node) => node.mark(mark.addToSet(node.marks));
    }
    else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node) => node.mark(mark.removeFromSet(node.marks));
    }
    else {
        return null;
    }
    let updated = [];
    for (let i = 0; i < prev.childCount; i++)
        updated.push(update(prev.child(i)));
    if (Fragment.from(updated).eq(cur))
        return { mark, type };
}
function looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if ( // The content must have shrunk
    end - start <= $newEnd.pos - $newStart.pos ||
        // newEnd must point directly at or after the end of the block that newStart points into
        skipClosingAndOpening($newStart, true, false) < $newEnd.pos)
        return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock)
        return false;
    let $next = old.resolve(skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end ||
        skipClosingAndOpening($next, true, false) < end)
        return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while (depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)) {
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while (next && !next.isLeaf) {
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos), lenA = pos + a.size, lenB = pos + b.size;
    if (start == null)
        return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, lenA, lenB);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && lenA < lenB) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        endB = start + (endB - endA);
        endA = start;
    }
    else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        endA = start + (endA - endB);
        endB = start;
    }
    return { start, endA, endB };
}
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/
class EditorView {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */
    constructor(place, props) {
        this._root = null;
        /**
        @internal
        */
        this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */
        this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */
        this.markCursor = null;
        /**
        @internal
        */
        this.cursorWrapper = null;
        /**
        @internal
        */
        this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */
        this.input = new InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://code.haverbeke.berlin/prosemirror/prosemirror/issues/651)
        @internal
        */
        this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */
        this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach(checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = (place && place.mount) || document.createElement("div");
        if (place) {
            if (place.appendChild)
                place.appendChild(this.dom);
            else if (typeof place == "function")
                place(this.dom);
            else if (place.mount)
                this.mounted = true;
        }
        this.editable = getEditable(this);
        updateCursorWrapper(this);
        this.nodeViews = buildNodeViews(this);
        this.docView = docViewDesc(this.state.doc, computeDocDeco(this), viewDecorations(this), this.dom, this);
        this.domObserver = new DOMObserver(this, (from, to, typeOver, added) => readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */
    get composing() { return this.input.composing; }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */
    get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for (let name in prev)
                this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */
    update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents)
            ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach(checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */
    setProps(props) {
        let updated = {};
        for (let name in this._props)
            updated[name] = this._props[name];
        updated.state = this.state;
        for (let name in props)
            updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */
    updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = buildNodeViews(this);
            if (changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) {
            ensureListeners(this);
        }
        this.editable = getEditable(this);
        updateCursorWrapper(this);
        let innerDeco = viewDecorations(this), outerDeco = computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset"
            : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection))
            updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && (ie$1 || chrome) && !this.composing &&
                !prev.selection.empty && !state.selection.empty && selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = chrome ? (this.trackWrites = this.domSelectionRange().focusNode) : null;
                if (this.composing)
                    this.input.compositionNode = findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && (!this.trackWrites || !this.dom.contains(this.trackWrites)))
                    forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            let mouseDown = this.input.mouseDown;
            if (forceSelUpdate ||
                !(mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) &&
                    anchorInRightPlace(this) && mouseDown.delaySelUpdate())) {
                selectionToDOM(this, forceSelUpdate);
            }
            else {
                syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc))
            this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") {
            this.dom.scrollTop = 0;
        }
        else if (scroll == "to selection") {
            this.scrollToSelection();
        }
        else if (oldScrollPos) {
            resetScrollPos(oldScrollPos);
        }
    }
    /**
    @internal
    */
    scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", f => f(this))) ;
        else if (this.state.selection instanceof NodeSelection) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1)
                scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        }
        else {
            scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
        }
    }
    destroyPluginViews() {
        let view;
        while (view = this.pluginViews.pop())
            if (view.destroy)
                view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for (let i = 0; i < this.directPlugins.length; i++) {
                let plugin = this.directPlugins[i];
                if (plugin.spec.view)
                    this.pluginViews.push(plugin.spec.view(this));
            }
            for (let i = 0; i < this.state.plugins.length; i++) {
                let plugin = this.state.plugins[i];
                if (plugin.spec.view)
                    this.pluginViews.push(plugin.spec.view(this));
            }
        }
        else {
            for (let i = 0; i < this.pluginViews.length; i++) {
                let pluginView = this.pluginViews[i];
                if (pluginView.update)
                    pluginView.update(this, prevState);
            }
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (sel.from < this.state.doc.content.size && this.state.doc.nodeAt(sel.from) == sel.node) {
            found = sel.from;
        }
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && movedPos < this.state.doc.content.size && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node)
                found = movedPos;
        }
        this.dragging = new Dragging(dragging.slice, dragging.move, found < 0 ? undefined : NodeSelection.create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop))
            return value;
        for (let i = 0; i < this.directPlugins.length; i++) {
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop))
                return value;
        }
        let plugins = this.state.plugins;
        if (plugins)
            for (let i = 0; i < plugins.length; i++) {
                let prop = plugins[i].props[propName];
                if (prop != null && (value = f ? f(prop) : prop))
                    return value;
            }
    }
    /**
    Query whether the view has focus.
    */
    hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if (ie$1) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom)
                return true;
            if (!node || !this.dom.contains(node))
                return false;
            while (node && this.dom != node && this.dom.contains(node)) {
                if (node.contentEditable == 'false')
                    return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */
    focus() {
        this.domObserver.stop();
        if (this.editable)
            focusPreventScroll(this.dom);
        selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */
    get root() {
        let cached = this._root;
        if (cached == null)
            for (let search = this.dom.parentNode; search; search = search.parentNode) {
                if (search.nodeType == 9 || (search.nodeType == 11 && search.host)) {
                    if (!search.getSelection)
                        Object.getPrototypeOf(search).getSelection = () => search.ownerDocument.getSelection();
                    return this._root = search;
                }
            }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */
    updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */
    posAtCoords(coords) {
        return posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */
    coordsAtPos(pos, side = 1) {
        return coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */
    domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */
    nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */
    posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null)
            throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */
    endOfTextblock(dir, state) {
        return endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */
    pasteHTML(html, event) {
        return doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */
    pasteText(text, event) {
        return doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Serialize the given slice as it would be if it was copied from
    this editor. Returns a DOM element that contains a
    representation of the slice as its children, a textual
    representation, and the transformed slice (which can be
    different from the given input due to hooks like
    [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
    */
    serializeForClipboard(slice) {
        return serializeForClipboard(this, slice);
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */
    destroy() {
        if (!this.docView)
            return;
        destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], viewDecorations(this), this);
            this.dom.textContent = "";
        }
        else if (this.dom.parentNode) {
            this.dom.parentNode.removeChild(this.dom);
        }
        this.docView.destroy();
        this.docView = null;
        clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */
    get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */
    dispatchEvent(event) {
        return dispatchEvent(this, event);
    }
    /**
    @internal
    */
    domSelectionRange() {
        let sel = this.domSelection();
        if (!sel)
            return { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
        return safari && this.root.nodeType === 11 &&
            deepActiveElement(this.dom.ownerDocument) == this.dom && safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */
    domSelection() {
        return this.root.getSelection();
    }
}
EditorView.prototype.dispatch = function (tr) {
    let dispatchTransaction = this._props.dispatchTransaction;
    if (dispatchTransaction)
        dispatchTransaction.call(this, tr);
    else
        this.updateState(this.state.apply(tr));
};
function computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", value => {
        if (typeof value == "function")
            value = value(view.state);
        if (value)
            for (let attr in value) {
                if (attr == "class")
                    attrs.class += " " + value[attr];
                else if (attr == "style")
                    attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
                else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName")
                    attrs[attr] = String(value[attr]);
            }
    });
    if (!attrs.translate)
        attrs.translate = "no";
    return [Decoration.node(0, view.state.doc.content.size, attrs)];
}
function updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = { dom, deco: Decoration.widget(view.state.selection.from, dom, { raw: true, marks: view.markCursor }) };
    }
    else {
        view.cursorWrapper = null;
    }
}
function getEditable(view) {
    return !view.someProp("editable", value => value(view.state) === false);
}
function selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for (let prop in obj)
            if (!Object.prototype.hasOwnProperty.call(result, prop))
                result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for (let prop in a) {
        if (a[prop] != b[prop])
            return true;
        nA++;
    }
    for (let _ in b)
        nB++;
    return nA != nB;
}
function checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction)
        throw new RangeError("Plugins passed directly to the view must not have a state component");
}

var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};

var shift = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: "\""
};

var mac$1 = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);

// Fill in the digit keys
for (var i = 0; i < 10; i++) base[48 + i] = base[96 + i] = String(i);

// The function keys
for (var i = 1; i <= 24; i++) base[i + 111] = "F" + i;

// And the alphabetic keys
for (var i = 65; i <= 90; i++) {
  base[i] = String.fromCharCode(i + 32);
  shift[i] = String.fromCharCode(i);
}

// For each code that doesn't have a shift-equivalent, copy the base name
for (var code in base) if (!shift.hasOwnProperty(code)) shift[code] = base[code];

function keyName(event) {
  // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
  // On IE, shift effect is never included in `.key`.
  var ignoreKey = mac$1 && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey ||
      ie && event.shiftKey && event.key && event.key.length == 1 ||
      event.key == "Unidentified";
  var name = (!ignoreKey && event.key) ||
    (event.shiftKey ? shift : base)[event.keyCode] ||
    event.key || "Unidentified";
  // Edge sometimes produces wrong names (Issue #3)
  if (name == "Esc") name = "Escape";
  if (name == "Del") name = "Delete";
  // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
  if (name == "Left") name = "ArrowLeft";
  if (name == "Up") name = "ArrowUp";
  if (name == "Right") name = "ArrowRight";
  if (name == "Down") name = "ArrowDown";
  return name
}

const mac = typeof navigator != "undefined" && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
const windows = typeof navigator != "undefined" && /Win/.test(navigator.platform);
function normalizeKeyName$1(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space")
        result = " ";
    let alt, ctrl, shift, meta;
    for (let i = 0; i < parts.length - 1; i++) {
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod))
            meta = true;
        else if (/^a(lt)?$/i.test(mod))
            alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod))
            ctrl = true;
        else if (/^s(hift)?$/i.test(mod))
            shift = true;
        else if (/^mod$/i.test(mod)) {
            if (mac)
                meta = true;
            else
                ctrl = true;
        }
        else
            throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt)
        result = "Alt-" + result;
    if (ctrl)
        result = "Ctrl-" + result;
    if (meta)
        result = "Meta-" + result;
    if (shift)
        result = "Shift-" + result;
    return result;
}
function normalize(map) {
    let copy = Object.create(null);
    for (let prop in map)
        copy[normalizeKeyName$1(prop)] = map[prop];
    return copy;
}
function modifiers(name, event, shift = true) {
    if (event.altKey)
        name = "Alt-" + name;
    if (event.ctrlKey)
        name = "Ctrl-" + name;
    if (event.metaKey)
        name = "Meta-" + name;
    if (shift && event.shiftKey)
        name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/
function keymap(bindings) {
    return new Plugin({ props: { handleKeyDown: keydownHandler(bindings) } });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/
function keydownHandler(bindings) {
    let map = normalize(bindings);
    return function (view, event) {
        let name = keyName(event), baseName, direct = map[modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view))
            return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view))
                    return true;
            }
            if ((event.altKey || event.metaKey || event.ctrlKey) &&
                // Ctrl-Alt may be used for AltGr on Windows
                !(windows && event.ctrlKey && event.altKey) &&
                (baseName = base[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060, #1529.
                let fromCode = map[modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view))
                    return true;
            }
        }
        return false;
    };
}

/**
Delete the selection, if there is one.
*/
const deleteSelection$1 = (state, dispatch) => {
    if (state.selection.empty)
        return false;
    if (dispatch)
        dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function atBlockStart(state, view) {
    let { $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state)
        : $cursor.parentOffset > 0))
        return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/
const joinBackward$1 = (state, dispatch, view) => {
    let $cursor = atBlockStart(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && liftTarget(range);
        if (target == null)
            return false;
        if (dispatch)
            dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if (deleteBarrier(state, $cut, dispatch, -1))
        return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 &&
        (textblockAt(before, "end") || NodeSelection.isSelectable(before))) {
        for (let depth = $cursor.depth;; depth--) {
            let delStep = replaceStep(state.doc, $cursor.before(depth), $cursor.after(depth), Slice.empty);
            if (delStep && delStep.slice.size < delStep.to - delStep.from) {
                if (dispatch) {
                    let tr = state.tr.step(delStep);
                    tr.setSelection(textblockAt(before, "end")
                        ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1)
                        : NodeSelection.create(tr.doc, $cut.pos - before.nodeSize));
                    dispatch(tr.scrollIntoView());
                }
                return true;
            }
            if (depth == 1 || $cursor.node(depth - 1).childCount > 1)
                break;
        }
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch)
            dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/
const joinTextblockBackward$1 = (state, dispatch, view) => {
    let $cursor = atBlockStart(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutBefore($cursor);
    return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/
const joinTextblockForward$1 = (state, dispatch, view) => {
    let $cursor = atBlockEnd(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutAfter($cursor);
    return $cut ? joinTextblocksAround(state, $cut, dispatch) : false;
};
function joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for (; !beforeText.isTextblock; beforePos--) {
        if (beforeText.type.spec.isolating)
            return false;
        let child = beforeText.lastChild;
        if (!child)
            return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for (; !afterText.isTextblock; afterPos++) {
        if (afterText.type.spec.isolating)
            return false;
        let child = afterText.firstChild;
        if (!child)
            return false;
        afterText = child;
    }
    let step = replaceStep(state.doc, beforePos, afterPos, Slice.empty);
    if (!step || step.from != beforePos ||
        step instanceof ReplaceStep && step.slice.size >= afterPos - beforePos)
        return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection(TextSelection.create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function textblockAt(node, side, only = false) {
    for (let scan = node; scan; scan = (side == "start" ? scan.firstChild : scan.lastChild)) {
        if (scan.isTextblock)
            return true;
        if (only && scan.childCount != 1)
            return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/
const selectNodeBackward$1 = (state, dispatch, view) => {
    let { $head, empty } = state.selection, $cut = $head;
    if (!empty)
        return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0)
            return false;
        $cut = findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !NodeSelection.isSelectable(node))
        return false;
    if (dispatch)
        dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating)
        for (let i = $pos.depth - 1; i >= 0; i--) {
            if ($pos.index(i) > 0)
                return $pos.doc.resolve($pos.before(i + 1));
            if ($pos.node(i).type.spec.isolating)
                break;
        }
    return null;
}
function atBlockEnd(state, view) {
    let { $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state)
        : $cursor.parentOffset < $cursor.parent.content.size))
        return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/
const joinForward$1 = (state, dispatch, view) => {
    let $cursor = atBlockEnd(state, view);
    if (!$cursor)
        return false;
    let $cut = findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut)
        return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if (deleteBarrier(state, $cut, dispatch, 1))
        return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 &&
        (textblockAt(after, "start") || NodeSelection.isSelectable(after))) {
        let delStep = replaceStep(state.doc, $cursor.before(), $cursor.after(), Slice.empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection(textblockAt(after, "start") ? Selection.findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1)
                    : NodeSelection.create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch)
            dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/
const selectNodeForward$1 = (state, dispatch, view) => {
    let { $head, empty } = state.selection, $cut = $head;
    if (!empty)
        return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size)
            return false;
        $cut = findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !NodeSelection.isSelectable(node))
        return false;
    if (dispatch)
        dispatch(state.tr.setSelection(NodeSelection.create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating)
        for (let i = $pos.depth - 1; i >= 0; i--) {
            let parent = $pos.node(i);
            if ($pos.index(i) + 1 < parent.childCount)
                return $pos.doc.resolve($pos.after(i + 1));
            if (parent.type.spec.isolating)
                break;
        }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/
const joinUp$1 = (state, dispatch) => {
    let sel = state.selection, nodeSel = sel instanceof NodeSelection, point;
    if (nodeSel) {
        if (sel.node.isTextblock || !canJoin(state.doc, sel.from))
            return false;
        point = sel.from;
    }
    else {
        point = joinPoint(state.doc, sel.from, -1);
        if (point == null)
            return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel)
            tr.setSelection(NodeSelection.create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/
const joinDown$1 = (state, dispatch) => {
    let sel = state.selection, point;
    if (sel instanceof NodeSelection) {
        if (sel.node.isTextblock || !canJoin(state.doc, sel.to))
            return false;
        point = sel.to;
    }
    else {
        point = joinPoint(state.doc, sel.to, 1);
        if (point == null)
            return false;
    }
    if (dispatch)
        dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/
const lift$1 = (state, dispatch) => {
    let { $from, $to } = state.selection;
    let range = $from.blockRange($to), target = range && liftTarget(range);
    if (target == null)
        return false;
    if (dispatch)
        dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/
const newlineInCode$1 = (state, dispatch) => {
    let { $head, $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
        return false;
    if (dispatch)
        dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function defaultBlockAt$1(match) {
    for (let i = 0; i < match.edgeCount; i++) {
        let { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs())
            return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/
const exitCode$1 = (state, dispatch) => {
    let { $head, $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor))
        return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = defaultBlockAt$1(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type))
        return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/
const createParagraphNear$1 = (state, dispatch) => {
    let sel = state.selection, { $from, $to } = sel;
    if (sel instanceof AllSelection || $from.parent.inlineContent || $to.parent.inlineContent)
        return false;
    let type = defaultBlockAt$1($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock)
        return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection(TextSelection.create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/
const liftEmptyBlock$1 = (state, dispatch) => {
    let { $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size)
        return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if (canSplit(state.doc, before)) {
            if (dispatch)
                dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && liftTarget(range);
    if (target == null)
        return false;
    if (dispatch)
        dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/
const selectParentNode$1 = (state, dispatch) => {
    let { $from, to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0)
        return false;
    pos = $from.before(same);
    if (dispatch)
        dispatch(state.tr.setSelection(NodeSelection.create(state.doc, pos)));
    return true;
};
function joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type))
        return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch)
            dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || canJoin(state.doc, $pos.pos)))
        return false;
    if (dispatch)
        dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && joinMaybeClear(state, $cut, dispatch))
        return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter &&
        (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) &&
        match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = Fragment.empty;
            for (let i = conn.length - 1; i >= 0; i--)
                wrap = Fragment.from(conn[i].create(null, wrap));
            wrap = Fragment.from(before.copy(wrap));
            let tr = state.tr.step(new ReplaceAroundStep($cut.pos - 1, end, $cut.pos, end, new Slice(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type &&
                canJoin(tr.doc, $joinAt.pos))
                tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || (dir > 0 && isolated) ? null : Selection.findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && liftTarget(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch)
            dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && textblockAt(after, "start", true) && textblockAt(before, "end")) {
        let at = before, wrap = [];
        for (;;) {
            wrap.push(at);
            if (at.isTextblock)
                break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for (; !afterText.isTextblock; afterText = afterText.firstChild)
            afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = Fragment.empty;
                for (let i = wrap.length - 1; i >= 0; i--)
                    end = Fragment.from(wrap[i].copy(end));
                let tr = state.tr.step(new ReplaceAroundStep($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new Slice(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function selectTextblockSide(side) {
    return function (state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while ($pos.node(depth).isInline) {
            if (!depth)
                return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock)
            return false;
        if (dispatch)
            dispatch(state.tr.setSelection(TextSelection.create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/
const selectTextblockStart$1 = selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/
const selectTextblockEnd$1 = selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/
function wrapIn$1(nodeType, attrs = null) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && findWrapping(range, nodeType, attrs);
        if (!wrapping)
            return false;
        if (dispatch)
            dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/
function setBlockType(nodeType, attrs = null) {
    return function (state, dispatch) {
        let applicable = false;
        for (let i = 0; i < state.selection.ranges.length && !applicable; i++) {
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos) => {
                if (applicable)
                    return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs))
                    return;
                if (node.type == nodeType) {
                    applicable = true;
                }
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable)
            return false;
        if (dispatch) {
            let tr = state.tr;
            for (let i = 0; i < state.selection.ranges.length; i++) {
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform)
    // @ts-ignore
    : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;

/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/
function wrapInList$1(listType, attrs = null) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to);
        if (!range)
            return false;
        let tr = dispatch ? state.tr : null;
        if (!wrapRangeInList(tr, range, listType, attrs))
            return false;
        if (dispatch)
            dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Try to wrap the given node range in a list of the given type.
Return `true` when this is possible, `false` otherwise. When `tr`
is non-null, the wrapping is added to that transaction. When it is
`null`, the function only queries whether the wrapping is
possible.
*/
function wrapRangeInList(tr, range, listType, attrs = null) {
    let doJoin = false, outerRange = range, doc = range.$from.doc;
    // This is at the top of an existing list item
    if (range.depth >= 2 && range.$from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
        // Don't do anything if this is the top of the list
        if (range.$from.index(range.depth - 1) == 0)
            return false;
        let $insert = doc.resolve(range.start - 2);
        outerRange = new NodeRange($insert, $insert, range.depth);
        if (range.endIndex < range.parent.childCount)
            range = new NodeRange(range.$from, doc.resolve(range.$to.end(range.depth)), range.depth);
        doJoin = true;
    }
    let wrap = findWrapping(outerRange, listType, attrs, range);
    if (!wrap)
        return false;
    if (tr)
        doWrapInList(tr, range, wrap, doJoin, listType);
    return true;
}
function doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = Fragment.empty;
    for (let i = wrappers.length - 1; i >= 0; i--)
        content = Fragment.from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new ReplaceAroundStep(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new Slice(content, 0, 0), wrappers.length, true));
    let found = 0;
    for (let i = 0; i < wrappers.length; i++)
        if (wrappers[i].type == listType)
            found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for (let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false) {
        if (!first && canSplit(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/
function liftListItem$1(itemType) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to, node => node.childCount > 0 && node.firstChild.type == itemType);
        if (!range)
            return false;
        if (!dispatch)
            return true;
        if ($from.node(range.depth - 1).type == itemType) // Inside a parent list
            return liftToOuterList(state, dispatch, itemType, range);
        else // Outer list node
            return liftOutOfList(state, dispatch, range);
    };
}
function liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new ReplaceAroundStep(end - 1, endOfList, end, endOfList, new Slice(Fragment.from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new NodeRange(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = liftTarget(range);
    if (target == null)
        return false;
    tr.lift(range, target);
    let $after = tr.doc.resolve(tr.mapping.map(end, -1) - 1);
    if (canJoin(tr.doc, $after.pos) && $after.nodeBefore.type == $after.nodeAfter.type)
        tr.join($after.pos);
    dispatch(tr.scrollIntoView());
    return true;
}
function liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for (let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--) {
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize)
        return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? Fragment.empty : Fragment.from(list))))
        return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new ReplaceAroundStep(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new Slice((atStart ? Fragment.empty : Fragment.from(list.copy(Fragment.empty)))
        .append(atEnd ? Fragment.empty : Fragment.from(list.copy(Fragment.empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/
function sinkListItem$1(itemType) {
    return function (state, dispatch) {
        let { $from, $to } = state.selection;
        let range = $from.blockRange($to, node => node.childCount > 0 && node.firstChild.type == itemType);
        if (!range)
            return false;
        let startIndex = range.startIndex;
        if (startIndex == 0)
            return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType)
            return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = Fragment.from(nestedBefore ? itemType.create() : null);
            let slice = new Slice(Fragment.from(itemType.create(null, Fragment.from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true))
                .scrollIntoView());
        }
        return true;
    };
}

/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */
function createChainableState(config) {
    const { state, transaction } = config;
    let { selection } = transaction;
    let { doc } = transaction;
    let { storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks() {
            return storedMarks;
        },
        get selection() {
            return selection;
        },
        get doc() {
            return doc;
        },
        get tr() {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        },
    };
}

class CommandManager {
    constructor(props) {
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const { tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            const method = (...args) => {
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) {
                    view.dispatch(tr);
                }
                return callback;
            };
            return [name, method];
        }));
    }
    get chain() {
        return () => this.createChain();
    }
    get can() {
        return () => this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = () => {
            if (!hasStartTransaction
                && shouldDispatch
                && !tr.getMeta('preventDispatch')
                && !this.hasCustomState) {
                view.dispatch(tr);
            }
            return callbacks.every(callback => callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                const chainedCommand = (...args) => {
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [name, chainedCommand];
            })),
            run,
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands, state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
            return [name, (...args) => command(...args)({ ...props, dispatch: undefined })];
        }));
        return {
            ...formattedCommands,
            chain: () => this.createChain(tr, dispatch),
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands, editor, state } = this;
        const { view } = editor;
        const props = {
            tr,
            editor,
            view,
            state: createChainableState({
                state,
                transaction: tr,
            }),
            dispatch: shouldDispatch ? () => undefined : undefined,
            chain: () => this.createChain(tr, shouldDispatch),
            can: () => this.createCan(tr),
            get commands() {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command]) => {
                    return [name, (...args) => command(...args)(props)];
                }));
            },
        };
        return props;
    }
}

class EventEmitter {
    constructor() {
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) {
            this.callbacks[event] = [];
        }
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            callbacks.forEach(callback => callback.apply(this, args));
        }
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) {
                this.callbacks[event] = callbacks.filter(callback => callback !== fn);
            }
            else {
                delete this.callbacks[event];
            }
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args) => {
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}

/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */
function getExtensionField(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) {
        return getExtensionField(extension.parent, field, context);
    }
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent
                ? getExtensionField(extension.parent, field, context)
                : null,
        });
        return value;
    }
    return extension.config[field];
}

function splitExtensions(extensions) {
    const baseExtensions = extensions.filter(extension => extension.type === 'extension');
    const nodeExtensions = extensions.filter(extension => extension.type === 'node');
    const markExtensions = extensions.filter(extension => extension.type === 'mark');
    return {
        baseExtensions,
        nodeExtensions,
        markExtensions,
    };
}

/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */
function getAttributesFromExtensions(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const nodeAndMarkExtensions = [...nodeExtensions, ...markExtensions];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false,
    };
    extensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions,
        };
        const addGlobalAttributes = getExtensionField(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) {
            return;
        }
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach(globalAttribute => {
            globalAttribute.types.forEach(type => {
                Object
                    .entries(globalAttribute.attributes)
                    .forEach(([name, attribute]) => {
                    extensionAttributes.push({
                        type,
                        name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute,
                        },
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach(extension => {
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
        };
        const addAttributes = getExtensionField(extension, 'addAttributes', context);
        if (!addAttributes) {
            return;
        }
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object
            .entries(attributes)
            .forEach(([name, attribute]) => {
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute,
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') {
                mergedAttr.default = mergedAttr.default();
            }
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) {
                delete mergedAttr.default;
            }
            extensionAttributes.push({
                type: extension.name,
                name,
                attribute: mergedAttr,
            });
        });
    });
    return extensionAttributes;
}

function getNodeType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) {
            throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}

function mergeAttributes(...objects) {
    return objects
        .filter(item => !!item)
        .reduce((items, item) => {
        const mergedAttributes = { ...items };
        Object.entries(item).forEach(([key, value]) => {
            // Define a data property so untrusted input cannot change the merged object's prototype.
            if (key === '__proto__') {
                Object.defineProperty(mergedAttributes, key, {
                    configurable: true,
                    enumerable: true,
                    value,
                    writable: true,
                });
                return;
            }
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                const valueClasses = value ? String(value).split(' ') : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
                const insertClasses = valueClasses.filter(valueClass => !existingClasses.includes(valueClass));
                mergedAttributes[key] = [...existingClasses, ...insertClasses].join(' ');
            }
            else if (key === 'style') {
                const newStyles = value ? value.split(';').map((style) => style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map((style) => style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach(style => {
                    const [property, val] = style.split(':').map(part => part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val]) => `${property}: ${val}`).join('; ');
            }
            else {
                mergedAttributes[key] = value;
            }
        });
        return mergedAttributes;
    }, {});
}

function getRenderedAttributes(nodeOrMark, extensionAttributes) {
    return extensionAttributes
        .filter(attribute => attribute.type === nodeOrMark.type.name)
        .filter(item => item.attribute.rendered)
        .map(item => {
        if (!item.attribute.renderHTML) {
            return {
                [item.name]: nodeOrMark.attrs[item.name],
            };
        }
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    })
        .reduce((attributes, attribute) => mergeAttributes(attributes, attribute), {});
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function isFunction$1(value) {
    return typeof value === 'function';
}

/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */
function callOrReturn(value, context = undefined, ...props) {
    if (isFunction$1(value)) {
        if (context) {
            return value.bind(context)(...props);
        }
        return value(...props);
    }
    return value;
}

function isEmptyObject(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}

function fromString(value) {
    if (typeof value !== 'string') {
        return value;
    }
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) {
        return Number(value);
    }
    if (value === 'true') {
        return true;
    }
    if (value === 'false') {
        return false;
    }
    return value;
}

/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */
function injectExtensionAttributesToParseRule(parseRule, extensionAttributes) {
    if ('style' in parseRule) {
        return parseRule;
    }
    return {
        ...parseRule,
        getAttrs: (node) => {
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) {
                return false;
            }
            const newAttributes = extensionAttributes.reduce((items, item) => {
                const value = item.attribute.parseHTML
                    ? item.attribute.parseHTML(node)
                    : fromString((node).getAttribute(item.name));
                if (value === null || value === undefined) {
                    return items;
                }
                return {
                    ...items,
                    [item.name]: value,
                };
            }, {});
            return { ...oldAttributes, ...newAttributes };
        },
    };
}

function cleanUpSchemaItem(data) {
    return Object.fromEntries(
    // @ts-ignore
    Object.entries(data).filter(([key, value]) => {
        if (key === 'attrs' && isEmptyObject(value)) {
            return false;
        }
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */
function getSchemaByResolvedExtensions(extensions, editor) {
    var _a;
    const allAttributes = getAttributesFromExtensions(extensions);
    const { nodeExtensions, markExtensions } = splitExtensions(extensions);
    const topNode = (_a = nodeExtensions.find(extension => getExtensionField(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraNodeFields = extensions.reduce((fields, e) => {
            const extendNodeSchema = getExtensionField(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...(extendNodeSchema ? extendNodeSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraNodeFields,
            content: callOrReturn(getExtensionField(extension, 'content', context)),
            marks: callOrReturn(getExtensionField(extension, 'marks', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            inline: callOrReturn(getExtensionField(extension, 'inline', context)),
            atom: callOrReturn(getExtensionField(extension, 'atom', context)),
            selectable: callOrReturn(getExtensionField(extension, 'selectable', context)),
            draggable: callOrReturn(getExtensionField(extension, 'draggable', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            whitespace: callOrReturn(getExtensionField(extension, 'whitespace', context)),
            linebreakReplacement: callOrReturn(getExtensionField(extension, 'linebreakReplacement', context)),
            defining: callOrReturn(getExtensionField(extension, 'defining', context)),
            isolating: callOrReturn(getExtensionField(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = node => renderHTML({
                node,
                HTMLAttributes: getRenderedAttributes(node, extensionAttributes),
            });
        }
        const renderText = getExtensionField(extension, 'renderText', context);
        if (renderText) {
            schema.toText = renderText;
        }
        return [extension.name, schema];
    }));
    const marks = Object.fromEntries(markExtensions.map(extension => {
        const extensionAttributes = allAttributes.filter(attribute => attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor,
        };
        const extraMarkFields = extensions.reduce((fields, e) => {
            const extendMarkSchema = getExtensionField(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...(extendMarkSchema ? extendMarkSchema(extension) : {}),
            };
        }, {});
        const schema = cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: callOrReturn(getExtensionField(extension, 'inclusive', context)),
            excludes: callOrReturn(getExtensionField(extension, 'excludes', context)),
            group: callOrReturn(getExtensionField(extension, 'group', context)),
            spanning: callOrReturn(getExtensionField(extension, 'spanning', context)),
            code: callOrReturn(getExtensionField(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map(extensionAttribute => {
                var _a;
                return [extensionAttribute.name, { default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default }];
            })),
        });
        const parseHTML = callOrReturn(getExtensionField(extension, 'parseHTML', context));
        if (parseHTML) {
            schema.parseDOM = parseHTML.map(parseRule => injectExtensionAttributesToParseRule(parseRule, extensionAttributes));
        }
        const renderHTML = getExtensionField(extension, 'renderHTML', context);
        if (renderHTML) {
            schema.toDOM = mark => renderHTML({
                mark,
                HTMLAttributes: getRenderedAttributes(mark, extensionAttributes),
            });
        }
        return [extension.name, schema];
    }));
    return new Schema({
        topNode,
        nodes,
        marks,
    });
}

/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */
function getSchemaTypeByName(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}

function isExtensionRulesEnabled(extension, enabled) {
    if (Array.isArray(enabled)) {
        return enabled.some(enabledExtension => {
            const name = typeof enabledExtension === 'string'
                ? enabledExtension
                : enabledExtension.name;
            return name === extension.name;
        });
    }
    return enabled;
}

function getHTMLFromFragment(fragment, schema) {
    const documentFragment = DOMSerializer.fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}

/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */
const getTextContentFromNodes = ($from, maxMatch = 500) => {
    let textBefore = '';
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index) => {
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node,
            pos,
            parent,
            index,
        }))
            || node.textContent
            || '%leaf%';
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};

function isRegExp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}

class InputRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const inputRuleMatcherHandler = (text, find) => {
    if (isRegExp(find)) {
        return find.exec(text);
    }
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) {
        return null;
    }
    const result = [inputRuleMatch.text];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) {
            console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        }
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function run$1$1(config) {
    var _a;
    const { editor, from, to, text, rules, plugin, } = config;
    const { view } = editor;
    if (view.composing) {
        return false;
    }
    const $from = view.state.doc.resolve(from);
    if (
    // check for code node
    $from.parent.type.spec.code
        // check for code mark
        || !!((_a = ($from.nodeBefore || $from.nodeAfter)) === null || _a === void 0 ? void 0 : _a.marks.find(mark => mark.type.spec.code))) {
        return false;
    }
    let matched = false;
    const textBefore = getTextContentFromNodes($from) + text;
    rules.forEach(rule => {
        if (matched) {
            return;
        }
        const match = inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) {
            return;
        }
        const tr = view.state.tr;
        const state = createChainableState({
            state: view.state,
            transaction: tr,
        });
        const range = {
            from: from - (match[0].length - text.length),
            to,
        };
        const { commands, chain, can } = new CommandManager({
            editor,
            state,
        });
        const handler = rule.handler({
            state,
            range,
            match,
            commands,
            chain,
            can,
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) {
            return;
        }
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from,
            to,
            text,
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */
function inputRulesPlugin(props) {
    const { editor, rules } = props;
    const plugin = new Plugin({
        state: {
            init() {
                return null;
            },
            apply(tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) {
                    return stored;
                }
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta('applyInputRules');
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) {
                    setTimeout(() => {
                        let { text } = simulatedInputMeta;
                        if (typeof text === 'string') {
                            text = text;
                        }
                        else {
                            text = getHTMLFromFragment(Fragment.from(text), state.schema);
                        }
                        const { from } = simulatedInputMeta;
                        const to = from + text.length;
                        run$1$1({
                            editor,
                            from,
                            to,
                            text,
                            rules,
                            plugin,
                        });
                    });
                }
                return tr.selectionSet || tr.docChanged ? null : prev;
            },
        },
        props: {
            handleTextInput(view, from, to, text) {
                return run$1$1({
                    editor,
                    from,
                    to,
                    text,
                    rules,
                    plugin,
                });
            },
            handleDOMEvents: {
                compositionend: view => {
                    setTimeout(() => {
                        const { $cursor } = view.state.selection;
                        if ($cursor) {
                            run$1$1({
                                editor,
                                from: $cursor.pos,
                                to: $cursor.pos,
                                text: '',
                                rules,
                                plugin,
                            });
                        }
                    });
                    return false;
                },
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown(view, event) {
                if (event.key !== 'Enter') {
                    return false;
                }
                const { $cursor } = view.state.selection;
                if ($cursor) {
                    return run$1$1({
                        editor,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: '\n',
                        rules,
                        plugin,
                    });
                }
                return false;
            },
        },
        // @ts-ignore
        isInputRules: true,
    });
    return plugin;
}

// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function isPlainObject$3(value) {
    if (getType(value) !== 'Object') {
        return false;
    }
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}

function mergeDeep(target, source) {
    const output = { ...target };
    if (isPlainObject$3(target) && isPlainObject$3(source)) {
        Object.keys(source).forEach(key => {
            if (isPlainObject$3(source[key]) && isPlainObject$3(target[key])) {
                output[key] = mergeDeep(target[key], source[key]);
            }
            else {
                output[key] = source[key];
            }
        });
    }
    return output;
}

/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Mark {
    constructor(config = {}) {
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Mark(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Mark(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
    static handleExit({ editor, mark }) {
        const { tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) {
                return false;
            }
            const removeMark = currentMarks.find(m => (m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) {
                tr.removeStoredMark(removeMark);
            }
            tr.insertText(' ', currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}

function isNumber$1(value) {
    return typeof value === 'number';
}

/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
class PasteRule {
    constructor(config) {
        this.find = config.find;
        this.handler = config.handler;
    }
}
const pasteRuleMatcherHandler = (text, find, event) => {
    if (isRegExp(find)) {
        return [...text.matchAll(find)];
    }
    const matches = find(text, event);
    if (!matches) {
        return [];
    }
    return matches.map(pasteRuleMatch => {
        const result = [pasteRuleMatch.text];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) {
                console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            }
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function run$2(config) {
    const { editor, state, from, to, rule, pasteEvent, dropEvent, } = config;
    const { commands, chain, can } = new CommandManager({
        editor,
        state,
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (!node.isTextblock || node.type.spec.code) {
            return;
        }
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach(match => {
            if (match.index === undefined) {
                return;
            }
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end),
            };
            const handler = rule.handler({
                state,
                range,
                match,
                commands,
                chain,
                can,
                pasteEvent,
                dropEvent,
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every(handler => handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let tiptapDragFromOtherEditor = null;
const createClipboardPasteEvent = (text) => {
    var _a;
    const event = new ClipboardEvent('paste', {
        clipboardData: new DataTransfer(),
    });
    (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.setData('text/html', text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */
function pasteRulesPlugin(props) {
    const { editor, rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    }
    catch {
        dropEvent = null;
    }
    const processEvent = ({ state, from, to, rule, pasteEvt, }) => {
        const tr = state.tr;
        const chainableState = createChainableState({
            state,
            transaction: tr,
        });
        const handler = run$2({
            editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule,
            pasteEvent: pasteEvt,
            dropEvent,
        });
        if (!handler || !tr.steps.length) {
            return;
        }
        try {
            dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
        }
        catch {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
        return tr;
    };
    const plugins = rules.map(rule => {
        return new Plugin({
            // we register a global drag handler to track the current drag source element
            view(view) {
                const handleDragstart = (event) => {
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target))
                        ? view.dom.parentElement
                        : null;
                    if (dragSourceElement) {
                        tiptapDragFromOtherEditor = editor;
                    }
                };
                const handleDragend = () => {
                    if (tiptapDragFromOtherEditor) {
                        tiptapDragFromOtherEditor = null;
                    }
                };
                window.addEventListener('dragstart', handleDragstart);
                window.addEventListener('dragend', handleDragend);
                return {
                    destroy() {
                        window.removeEventListener('dragstart', handleDragstart);
                        window.removeEventListener('dragend', handleDragend);
                    },
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event) => {
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor === null || dragFromOtherEditor === void 0 ? void 0 : dragFromOtherEditor.isEditable) {
                                // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                                setTimeout(() => {
                                    const selection = dragFromOtherEditor.state.selection;
                                    if (selection) {
                                        dragFromOtherEditor.commands.deleteRange({ from: selection.from, to: selection.to });
                                    }
                                }, 10);
                            }
                        }
                        return false;
                    },
                    paste: (_view, event) => {
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    },
                },
            },
            appendTransaction: (transactions, oldState, state) => {
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta('applyPasteRules');
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) {
                    return;
                }
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text } = simulatedPasteMeta;
                    if (typeof text === 'string') {
                        text = text;
                    }
                    else {
                        text = getHTMLFromFragment(Fragment.from(text), state.schema);
                    }
                    const { from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = createClipboardPasteEvent(text);
                    return processEvent({
                        rule,
                        state,
                        from,
                        to: { b: to },
                        pasteEvt,
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!isNumber$1(from) || !to || from === to.b) {
                    return;
                }
                return processEvent({
                    rule,
                    state,
                    from,
                    to,
                    pasteEvt: pasteEvent,
                });
            },
        });
    });
    return plugins;
}

function findDuplicates(items) {
    const filtered = items.filter((el, index) => items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}

class ExtensionManager {
    constructor(extensions, editor) {
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = ExtensionManager.resolve(extensions);
        this.schema = getSchemaByResolvedExtensions(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */
    static resolve(extensions) {
        const resolvedExtensions = ExtensionManager.sort(ExtensionManager.flatten(extensions));
        const duplicatedNames = findDuplicates(resolvedExtensions.map(extension => extension.name));
        if (duplicatedNames.length) {
            console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames
                .map(item => `'${item}'`)
                .join(', ')}]. This can lead to issues.`);
        }
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */
    static flatten(extensions) {
        return (extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
            };
            const addExtensions = getExtensionField(extension, 'addExtensions', context);
            if (addExtensions) {
                return [extension, ...this.flatten(addExtensions())];
            }
            return extension;
        })
            // `Infinity` will break TypeScript so we set a number that is probably high enough
            .flat(10));
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */
    static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b) => {
            const priorityA = getExtensionField(a, 'priority') || defaultPriority;
            const priorityB = getExtensionField(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) {
                return -1;
            }
            if (priorityA < priorityB) {
                return 1;
            }
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */
    get commands() {
        return this.extensions.reduce((commands, extension) => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const addCommands = getExtensionField(extension, 'addCommands', context);
            if (!addCommands) {
                return commands;
            }
            return {
                ...commands,
                ...addCommands(),
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */
    get plugins() {
        const { editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = ExtensionManager.sort([...this.extensions].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions
            .map(extension => {
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            const plugins = [];
            const addKeyboardShortcuts = getExtensionField(extension, 'addKeyboardShortcuts', context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === 'mark' && getExtensionField(extension, 'exitable', context)) {
                defaultBindings.ArrowRight = () => Mark.handleExit({ editor, mark: extension });
            }
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method]) => {
                    return [shortcut, () => method({ editor })];
                }));
                defaultBindings = { ...defaultBindings, ...bindings };
            }
            const keyMapPlugin = keymap(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = getExtensionField(extension, 'addInputRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enableInputRules) && addInputRules) {
                inputRules.push(...addInputRules());
            }
            const addPasteRules = getExtensionField(extension, 'addPasteRules', context);
            if (isExtensionRulesEnabled(extension, editor.options.enablePasteRules) && addPasteRules) {
                pasteRules.push(...addPasteRules());
            }
            const addProseMirrorPlugins = getExtensionField(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        })
            .flat();
        return [
            inputRulesPlugin({
                editor,
                rules: inputRules,
            }),
            ...pasteRulesPlugin({
                editor,
                rules: pasteRules,
            }),
            ...allPlugins,
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */
    get attributes() {
        return getAttributesFromExtensions(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */
    get nodeViews() {
        const { editor } = this;
        const { nodeExtensions } = splitExtensions(this.extensions);
        return Object.fromEntries(nodeExtensions
            .filter(extension => !!getExtensionField(extension, 'addNodeView'))
            .map(extension => {
            const extensionAttributes = this.attributes.filter(attribute => attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor,
                type: getNodeType(extension.name, this.schema),
            };
            const addNodeView = getExtensionField(extension, 'addNodeView', context);
            if (!addNodeView) {
                return [];
            }
            const nodeview = (node, view, getPos, decorations, innerDecorations) => {
                const HTMLAttributes = getRenderedAttributes(node, extensionAttributes);
                return addNodeView()({
                    // pass-through
                    node,
                    view,
                    getPos: getPos,
                    decorations,
                    innerDecorations,
                    // tiptap-specific
                    editor,
                    extension,
                    HTMLAttributes,
                });
            };
            return [extension.name, nodeview];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */
    setupExtensions() {
        this.extensions.forEach(extension => {
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: getSchemaTypeByName(extension.name, this.schema),
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = callOrReturn(getExtensionField(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) {
                    this.splittableMarks.push(extension.name);
                }
            }
            const onBeforeCreate = getExtensionField(extension, 'onBeforeCreate', context);
            const onCreate = getExtensionField(extension, 'onCreate', context);
            const onUpdate = getExtensionField(extension, 'onUpdate', context);
            const onSelectionUpdate = getExtensionField(extension, 'onSelectionUpdate', context);
            const onTransaction = getExtensionField(extension, 'onTransaction', context);
            const onFocus = getExtensionField(extension, 'onFocus', context);
            const onBlur = getExtensionField(extension, 'onBlur', context);
            const onDestroy = getExtensionField(extension, 'onDestroy', context);
            if (onBeforeCreate) {
                this.editor.on('beforeCreate', onBeforeCreate);
            }
            if (onCreate) {
                this.editor.on('create', onCreate);
            }
            if (onUpdate) {
                this.editor.on('update', onUpdate);
            }
            if (onSelectionUpdate) {
                this.editor.on('selectionUpdate', onSelectionUpdate);
            }
            if (onTransaction) {
                this.editor.on('transaction', onTransaction);
            }
            if (onFocus) {
                this.editor.on('focus', onFocus);
            }
            if (onBlur) {
                this.editor.on('blur', onBlur);
            }
            if (onDestroy) {
                this.editor.on('destroy', onDestroy);
            }
        });
    }
}

/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Extension {
    constructor(config = {}) {
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Extension(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Extension({ ...this.config, ...extendedConfig });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */
function getTextBetween(startNode, range, options) {
    const { from, to } = range;
    const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
    let text = '';
    startNode.nodesBetween(from, to, (node, pos, parent, index) => {
        var _a;
        if (node.isBlock && pos > from) {
            text += blockSeparator;
        }
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) {
                text += textSerializer({
                    node,
                    pos,
                    parent,
                    index,
                    range,
                });
            }
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) {
            text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
        }
    });
    return text;
}

/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */
function getTextSerializersFromSchema(schema) {
    return Object.fromEntries(Object.entries(schema.nodes)
        .filter(([, node]) => node.spec.toText)
        .map(([name, node]) => [name, node.spec.toText]));
}

const ClipboardTextSerializer = Extension.create({
    name: 'clipboardTextSerializer',
    addOptions() {
        return {
            blockSeparator: undefined,
        };
    },
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: () => {
                        const { editor } = this;
                        const { state, schema } = editor;
                        const { doc, selection } = state;
                        const { ranges } = selection;
                        const from = Math.min(...ranges.map(range => range.$from.pos));
                        const to = Math.max(...ranges.map(range => range.$to.pos));
                        const textSerializers = getTextSerializersFromSchema(schema);
                        const range = { from, to };
                        return getTextBetween(doc, range, {
                            ...(this.options.blockSeparator !== undefined
                                ? { blockSeparator: this.options.blockSeparator }
                                : {}),
                            textSerializers,
                        });
                    },
                },
            }),
        ];
    },
});

const blur = () => ({ editor, view }) => {
    requestAnimationFrame(() => {
        var _a;
        if (!editor.isDestroyed) {
            view.dom.blur();
            // Browsers should remove the caret on blur but safari does not.
            // See: https://github.com/ueberdosis/tiptap/issues/2405
            (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 ? void 0 : _a.removeAllRanges();
        }
    });
    return true;
};

const clearContent = (emitUpdate = false) => ({ commands }) => {
    return commands.setContent('', emitUpdate);
};

const clearNodes = () => ({ state, tr, dispatch }) => {
    const { selection } = tr;
    const { ranges } = selection;
    if (!dispatch) {
        return true;
    }
    ranges.forEach(({ $from, $to }) => {
        state.doc.nodesBetween($from.pos, $to.pos, (node, pos) => {
            if (node.type.isText) {
                return;
            }
            const { doc, mapping } = tr;
            const $mappedFrom = doc.resolve(mapping.map(pos));
            const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
            const nodeRange = $mappedFrom.blockRange($mappedTo);
            if (!nodeRange) {
                return;
            }
            const targetLiftDepth = liftTarget(nodeRange);
            if (node.type.isTextblock) {
                const { defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                tr.setNodeMarkup(nodeRange.start, defaultType);
            }
            if (targetLiftDepth || targetLiftDepth === 0) {
                tr.lift(nodeRange, targetLiftDepth);
            }
        });
    });
    return true;
};

const command = fn => props => {
    return fn(props);
};

const createParagraphNear = () => ({ state, dispatch }) => {
    return createParagraphNear$1(state, dispatch);
};

const cut = (originRange, targetPos) => ({ editor, tr }) => {
    const { state } = editor;
    const contentSlice = state.doc.slice(originRange.from, originRange.to);
    tr.deleteRange(originRange.from, originRange.to);
    const newPos = tr.mapping.map(targetPos);
    tr.insert(newPos, contentSlice.content);
    tr.setSelection(new TextSelection(tr.doc.resolve(Math.max(newPos - 1, 0))));
    return true;
};

const deleteCurrentNode = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const currentNode = selection.$anchor.node();
    // if there is content inside the current node, break out of this command
    if (currentNode.content.size > 0) {
        return false;
    }
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === currentNode.type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const deleteNode = typeOrName => ({ tr, state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const $pos = tr.selection.$anchor;
    for (let depth = $pos.depth; depth > 0; depth -= 1) {
        const node = $pos.node(depth);
        if (node.type === type) {
            if (dispatch) {
                const from = $pos.before(depth);
                const to = $pos.after(depth);
                tr.delete(from, to).scrollIntoView();
            }
            return true;
        }
    }
    return false;
};

const deleteRange = range => ({ tr, dispatch }) => {
    const { from, to } = range;
    if (dispatch) {
        tr.delete(from, to);
    }
    return true;
};

const deleteSelection = () => ({ state, dispatch }) => {
    return deleteSelection$1(state, dispatch);
};

const enter = () => ({ commands }) => {
    return commands.keyboardShortcut('Enter');
};

const exitCode = () => ({ state, dispatch }) => {
    return exitCode$1(state, dispatch);
};

/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */
function objectIncludes(object1, object2, options = { strict: true }) {
    const keys = Object.keys(object2);
    if (!keys.length) {
        return true;
    }
    return keys.every(key => {
        if (options.strict) {
            return object2[key] === object1[key];
        }
        if (isRegExp(object2[key])) {
            return object2[key].test(object1[key]);
        }
        return object2[key] === object1[key];
    });
}

function findMarkInSet(marks, type, attributes = {}) {
    return marks.find(item => {
        return (item.type === type
            && objectIncludes(
            // Only check equality for the attributes that are provided
            Object.fromEntries(Object.keys(attributes).map(k => [k, item.attrs[k]])), attributes));
    });
}
function isMarkInSet(marks, type, attributes = {}) {
    return !!findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */
function getMarkRange(
/**
 * The position to get the mark range for.
 */
$pos, 
/**
 * The mark type to get the range for.
 */
type, 
/**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */
attributes) {
    var _a;
    if (!$pos || !type) {
        return;
    }
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        start = $pos.parent.childBefore($pos.parentOffset);
    }
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some(mark => mark.type === type)) {
        return;
    }
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = findMarkInSet([...start.node.marks], type, attributes);
    if (!mark) {
        return;
    }
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while (startIndex > 0
        && isMarkInSet([...$pos.parent.child(startIndex - 1).marks], type, attributes)) {
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while (endIndex < $pos.parent.childCount
        && isMarkInSet([...$pos.parent.child(endIndex).marks], type, attributes)) {
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos,
    };
}

function getMarkType(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) {
            throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        }
        return schema.marks[nameOrType];
    }
    return nameOrType;
}

const extendMarkRange = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const type = getMarkType(typeOrName, state.schema);
    const { doc, selection } = tr;
    const { $from, from, to } = selection;
    if (dispatch) {
        const range = getMarkRange($from, type, attributes);
        if (range && range.from <= from && range.to >= to) {
            const newSelection = TextSelection.create(doc, range.from, range.to);
            tr.setSelection(newSelection);
        }
    }
    return true;
};

const first = commands => props => {
    const items = typeof commands === 'function'
        ? commands(props)
        : commands;
    for (let i = 0; i < items.length; i += 1) {
        if (items[i](props)) {
            return true;
        }
    }
    return false;
};

function isTextSelection(value) {
    return value instanceof TextSelection;
}

function minMax(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}

function resolveFocusPosition(doc, position = null) {
    if (!position) {
        return null;
    }
    const selectionAtStart = Selection.atStart(doc);
    const selectionAtEnd = Selection.atEnd(doc);
    if (position === 'start' || position === true) {
        return selectionAtStart;
    }
    if (position === 'end') {
        return selectionAtEnd;
    }
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') {
        return TextSelection.create(doc, minMax(0, minPos, maxPos), minMax(doc.content.size, minPos, maxPos));
    }
    return TextSelection.create(doc, minMax(position, minPos, maxPos), minMax(position, minPos, maxPos));
}

function isAndroid() {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}

function isiOS() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
    ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
}

/**
 * Detects if the current browser is Safari (but not iOS Safari or Chrome).
 * @returns `true` if the browser is Safari, `false` otherwise.
 * @example
 * if (isSafari()) {
 *   // Safari-specific handling
 * }
 */
function isSafari() {
    return typeof navigator !== 'undefined' ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : false;
}

const focus = (position = null, options = {}) => ({ editor, view, tr, dispatch, }) => {
    options = {
        scrollIntoView: true,
        ...options,
    };
    const delayedFocus = () => {
        // focus within `requestAnimationFrame` breaks focus on iOS and Android
        // so we have to call this
        if (isiOS() || isAndroid()) {
            view.dom.focus();
        }
        // For React we have to focus asynchronously. Otherwise wild things happen.
        // see: https://github.com/ueberdosis/tiptap/issues/1520
        requestAnimationFrame(() => {
            if (!editor.isDestroyed) {
                view.focus();
                // Safari requires preventScroll to avoid the browser scrolling to the
                // top of the editor when focus is called before the selection is set.
                // We exclude iOS and Android since they are already handled above.
                // see: https://github.com/ueberdosis/tiptap/issues/7318
                if (isSafari() && !isiOS() && !isAndroid()) {
                    view.dom.focus({ preventScroll: true });
                }
            }
        });
    };
    if ((view.hasFocus() && position === null) || position === false) {
        return true;
    }
    // we don’t try to resolve a NodeSelection or CellSelection
    if (dispatch && position === null && !isTextSelection(editor.state.selection)) {
        delayedFocus();
        return true;
    }
    // pass through tr.doc instead of editor.state.doc
    // since transactions could change the editors state before this command has been run
    const selection = resolveFocusPosition(tr.doc, position) || editor.state.selection;
    const isSameSelection = editor.state.selection.eq(selection);
    if (dispatch) {
        if (!isSameSelection) {
            tr.setSelection(selection);
        }
        // `tr.setSelection` resets the stored marks
        // so we’ll restore them if the selection is the same as before
        if (isSameSelection && tr.storedMarks) {
            tr.setStoredMarks(tr.storedMarks);
        }
        delayedFocus();
    }
    return true;
};

const forEach = (items, fn) => props => {
    return items.every((item, index) => fn(item, { ...props, index }));
};

const insertContent = (value, options) => ({ tr, commands }) => {
    return commands.insertContentAt({ from: tr.selection.from, to: tr.selection.to }, value, options);
};

const removeWhitespaces = (node) => {
    const children = node.childNodes;
    for (let i = children.length - 1; i >= 0; i -= 1) {
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) {
            node.removeChild(child);
        }
        else if (child.nodeType === 1) {
            removeWhitespaces(child);
        }
    }
    return node;
};
function elementFromString(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
    return removeWhitespaces(html);
}

/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */
function createNodeFromContent(content, schema, options) {
    if (content instanceof Node$1 || content instanceof Fragment) {
        return content;
    }
    options = {
        slice: true,
        parseOptions: {},
        ...options,
    };
    const isJSONContent = typeof content === 'object' && content !== null;
    const isTextContent = typeof content === 'string';
    if (isJSONContent) {
        try {
            const isArrayContent = Array.isArray(content) && content.length > 0;
            // if the JSON Content is an array of nodes, create a fragment for each node
            if (isArrayContent) {
                return Fragment.fromArray(content.map(item => schema.nodeFromJSON(item)));
            }
            const node = schema.nodeFromJSON(content);
            if (options.errorOnInvalidContent) {
                node.check();
            }
            return node;
        }
        catch (error) {
            if (options.errorOnInvalidContent) {
                throw new Error('[tiptap error]: Invalid JSON content', { cause: error });
            }
            console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
            return createNodeFromContent('', schema, options);
        }
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = '';
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new Schema({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: 'inline*',
                        group: 'block',
                        parseDOM: [
                            {
                                tag: '*',
                                getAttrs: e => {
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === 'string' ? e : e.outerHTML;
                                    return null;
                                },
                            },
                        ],
                    },
                }),
            });
            if (options.slice) {
                DOMParser.fromSchema(contentCheckSchema).parseSlice(elementFromString(content), options.parseOptions);
            }
            else {
                DOMParser.fromSchema(contentCheckSchema).parse(elementFromString(content), options.parseOptions);
            }
            if (options.errorOnInvalidContent && hasInvalidContent) {
                throw new Error('[tiptap error]: Invalid HTML content', { cause: new Error(`Invalid element found: ${invalidContent}`) });
            }
        }
        const parser = DOMParser.fromSchema(schema);
        if (options.slice) {
            return parser.parseSlice(elementFromString(content), options.parseOptions).content;
        }
        return parser.parse(elementFromString(content), options.parseOptions);
    }
    return createNodeFromContent('', schema, options);
}

// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function selectionToInsertionEnd(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) {
        return;
    }
    const step = tr.steps[last];
    if (!(step instanceof ReplaceStep || step instanceof ReplaceAroundStep)) {
        return;
    }
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo) => {
        if (end === 0) {
            end = newTo;
        }
    });
    tr.setSelection(Selection.near(tr.doc.resolve(end), bias));
}

const isFragment = (nodeOrFragment) => {
    return !('type' in nodeOrFragment);
};
const insertContentAt = (position, value, options) => ({ tr, dispatch, editor }) => {
    var _a;
    if (dispatch) {
        options = {
            parseOptions: editor.options.parseOptions,
            updateSelection: true,
            applyInputRules: false,
            applyPasteRules: false,
            ...options,
        };
        let content;
        const emitContentError = (error) => {
            editor.emit('contentError', {
                editor,
                error,
                disableCollaboration: () => {
                    if (editor.storage.collaboration) {
                        editor.storage.collaboration.isDisabled = true;
                    }
                },
            });
        };
        const parseOptions = {
            preserveWhitespace: 'full',
            ...options.parseOptions,
        };
        // If `emitContentError` is enabled, we want to check the content for errors
        // but ignore them (do not remove the invalid content from the document)
        if (!options.errorOnInvalidContent && !editor.options.enableContentCheck && editor.options.emitContentError) {
            try {
                createNodeFromContent(value, editor.schema, {
                    parseOptions,
                    errorOnInvalidContent: true,
                });
            }
            catch (e) {
                emitContentError(e);
            }
        }
        try {
            content = createNodeFromContent(value, editor.schema, {
                parseOptions,
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
            });
        }
        catch (e) {
            emitContentError(e);
            return false;
        }
        let { from, to } = typeof position === 'number' ? { from: position, to: position } : { from: position.from, to: position.to };
        let isOnlyTextContent = true;
        let isOnlyBlockContent = true;
        const nodes = isFragment(content) ? content : [content];
        nodes.forEach(node => {
            // check if added node is valid
            node.check();
            isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
            isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
        });
        // check if we can replace the wrapping node by
        // the newly inserted content
        // example:
        // replace an empty paragraph by an inserted image
        // instead of inserting the image below the paragraph
        if (from === to && isOnlyBlockContent) {
            const { parent } = tr.doc.resolve(from);
            const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
            if (isEmptyTextBlock) {
                from -= 1;
                to += 1;
            }
        }
        let newContent;
        // if there is only plain text we have to use `insertText`
        // because this will keep the current marks
        if (isOnlyTextContent) {
            // if value is string, we can use it directly
            // otherwise if it is an array, we have to join it
            if (Array.isArray(value)) {
                newContent = value.map(v => v.text || '').join('');
            }
            else if (value instanceof Fragment) {
                let text = '';
                value.forEach(node => {
                    if (node.text) {
                        text += node.text;
                    }
                });
                newContent = text;
            }
            else if (typeof value === 'object' && !!value && !!value.text) {
                newContent = value.text;
            }
            else {
                newContent = value;
            }
            tr.insertText(newContent, from, to);
        }
        else {
            newContent = content;
            tr.replaceWith(from, to, newContent);
        }
        // set cursor at end of inserted content
        if (options.updateSelection) {
            selectionToInsertionEnd(tr, tr.steps.length - 1, -1);
        }
        if (options.applyInputRules) {
            tr.setMeta('applyInputRules', { from, text: newContent });
        }
        if (options.applyPasteRules) {
            tr.setMeta('applyPasteRules', { from, text: newContent });
        }
    }
    return true;
};

const joinUp = () => ({ state, dispatch }) => {
    return joinUp$1(state, dispatch);
};
const joinDown = () => ({ state, dispatch }) => {
    return joinDown$1(state, dispatch);
};
const joinBackward = () => ({ state, dispatch }) => {
    return joinBackward$1(state, dispatch);
};
const joinForward = () => ({ state, dispatch }) => {
    return joinForward$1(state, dispatch);
};

const joinItemBackward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = joinPoint(state.doc, state.selection.$from.pos, -1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const joinItemForward = () => ({ state, dispatch, tr, }) => {
    try {
        const point = joinPoint(state.doc, state.selection.$from.pos, +1);
        if (point === null || point === undefined) {
            return false;
        }
        tr.join(point, 2);
        if (dispatch) {
            dispatch(tr);
        }
        return true;
    }
    catch {
        return false;
    }
};

const joinTextblockBackward = () => ({ state, dispatch }) => {
    return joinTextblockBackward$1(state, dispatch);
};

const joinTextblockForward = () => ({ state, dispatch }) => {
    return joinTextblockForward$1(state, dispatch);
};

function isMacOS() {
    return typeof navigator !== 'undefined'
        ? /Mac/.test(navigator.platform)
        : false;
}

function normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') {
        result = ' ';
    }
    let alt;
    let ctrl;
    let shift;
    let meta;
    for (let i = 0; i < parts.length - 1; i += 1) {
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) {
            meta = true;
        }
        else if (/^a(lt)?$/i.test(mod)) {
            alt = true;
        }
        else if (/^(c|ctrl|control)$/i.test(mod)) {
            ctrl = true;
        }
        else if (/^s(hift)?$/i.test(mod)) {
            shift = true;
        }
        else if (/^mod$/i.test(mod)) {
            if (isiOS() || isMacOS()) {
                meta = true;
            }
            else {
                ctrl = true;
            }
        }
        else {
            throw new Error(`Unrecognized modifier name: ${mod}`);
        }
    }
    if (alt) {
        result = `Alt-${result}`;
    }
    if (ctrl) {
        result = `Ctrl-${result}`;
    }
    if (meta) {
        result = `Meta-${result}`;
    }
    if (shift) {
        result = `Shift-${result}`;
    }
    return result;
}
const keyboardShortcut = name => ({ editor, view, tr, dispatch, }) => {
    const keys = normalizeKeyName(name).split(/-(?!$)/);
    const key = keys.find(item => !['Alt', 'Ctrl', 'Meta', 'Shift'].includes(item));
    const event = new KeyboardEvent('keydown', {
        key: key === 'Space'
            ? ' '
            : key,
        altKey: keys.includes('Alt'),
        ctrlKey: keys.includes('Ctrl'),
        metaKey: keys.includes('Meta'),
        shiftKey: keys.includes('Shift'),
        bubbles: true,
        cancelable: true,
    });
    const capturedTransaction = editor.captureTransaction(() => {
        view.someProp('handleKeyDown', f => f(view, event));
    });
    capturedTransaction === null || capturedTransaction === void 0 ? void 0 : capturedTransaction.steps.forEach(step => {
        const newStep = step.map(tr.mapping);
        if (newStep && dispatch) {
            tr.maybeStep(newStep);
        }
    });
    return true;
};

function isNodeActive(state, typeOrName, attributes = {}) {
    const { from, to, empty } = state.selection;
    const type = typeOrName ? getNodeType(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos) => {
        if (node.isText) {
            return;
        }
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node,
            from: relativeFrom,
            to: relativeTo,
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges
        .filter(nodeRange => {
        if (!type) {
            return true;
        }
        return type.name === nodeRange.node.type.name;
    })
        .filter(nodeRange => objectIncludes(nodeRange.node.attrs, attributes, { strict: false }));
    if (empty) {
        return !!matchedNodeRanges.length;
    }
    const range = matchedNodeRanges.reduce((sum, nodeRange) => sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}

const lift = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (!isActive) {
        return false;
    }
    return lift$1(state, dispatch);
};

const liftEmptyBlock = () => ({ state, dispatch }) => {
    return liftEmptyBlock$1(state, dispatch);
};

const liftListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return liftListItem$1(type)(state, dispatch);
};

const newlineInCode = () => ({ state, dispatch }) => {
    return newlineInCode$1(state, dispatch);
};

/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */
function getSchemaTypeNameByName(name, schema) {
    if (schema.nodes[name]) {
        return 'node';
    }
    if (schema.marks[name]) {
        return 'mark';
    }
    return null;
}

/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */
function deleteProps(obj, propOrProps) {
    const props = typeof propOrProps === 'string'
        ? [propOrProps]
        : propOrProps;
    return Object
        .keys(obj)
        .reduce((newObj, prop) => {
        if (!props.includes(prop)) {
            newObj[prop] = obj[prop];
        }
        return newObj;
    }, {});
}

const resetAttributes = (typeOrName, attributes) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach(range => {
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos) => {
                if (nodeType && nodeType === node.type) {
                    tr.setNodeMarkup(pos, undefined, deleteProps(node.attrs, attributes));
                }
                if (markType && node.marks.length) {
                    node.marks.forEach(mark => {
                        if (markType === mark.type) {
                            tr.addMark(pos, pos + node.nodeSize, markType.create(deleteProps(mark.attrs, attributes)));
                        }
                    });
                }
            });
        });
    }
    return true;
};

const scrollIntoView = () => ({ tr, dispatch }) => {
    if (dispatch) {
        tr.scrollIntoView();
    }
    return true;
};

const selectAll = () => ({ tr, dispatch }) => {
    if (dispatch) {
        const selection = new AllSelection(tr.doc);
        tr.setSelection(selection);
    }
    return true;
};

const selectNodeBackward = () => ({ state, dispatch }) => {
    return selectNodeBackward$1(state, dispatch);
};

const selectNodeForward = () => ({ state, dispatch }) => {
    return selectNodeForward$1(state, dispatch);
};

const selectParentNode = () => ({ state, dispatch }) => {
    return selectParentNode$1(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockEnd = () => ({ state, dispatch }) => {
    return selectTextblockEnd$1(state, dispatch);
};

// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const selectTextblockStart = () => ({ state, dispatch }) => {
    return selectTextblockStart$1(state, dispatch);
};

/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */
function createDocument(content, schema, parseOptions = {}, options = {}) {
    return createNodeFromContent(content, schema, {
        slice: false,
        parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent,
    });
}

const setContent = (content, emitUpdate = false, parseOptions = {}, options = {}) => ({ editor, tr, dispatch, commands, }) => {
    var _a, _b;
    const { doc } = tr;
    // This is to keep backward compatibility with the previous behavior
    // TODO remove this in the next major version
    if (parseOptions.preserveWhitespace !== 'full') {
        const document = createDocument(content, editor.schema, parseOptions, {
            errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck,
        });
        if (dispatch) {
            tr.replaceWith(0, doc.content.size, document).setMeta('preventUpdate', !emitUpdate);
        }
        return true;
    }
    if (dispatch) {
        tr.setMeta('preventUpdate', !emitUpdate);
    }
    return commands.insertContentAt({ from: 0, to: doc.content.size }, content, {
        parseOptions,
        errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck,
    });
};

function getMarkAttributes(state, typeOrName) {
    const type = getMarkType(typeOrName, state.schema);
    const { from, to, empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) {
            marks.push(...state.storedMarks);
        }
        marks.push(...state.selection.$head.marks());
    }
    else {
        state.doc.nodesBetween(from, to, node => {
            marks.push(...node.marks);
        });
    }
    const mark = marks.find(markItem => markItem.type.name === type.name);
    if (!mark) {
        return {};
    }
    return { ...mark.attrs };
}

/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */
function combineTransactionSteps(oldDoc, transactions) {
    const transform = new Transform(oldDoc);
    transactions.forEach(transaction => {
        transaction.steps.forEach(step => {
            transform.step(step);
        });
    });
    return transform;
}

/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */
function defaultBlockAt(match) {
    for (let i = 0; i < match.edgeCount; i += 1) {
        const { type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) {
            return type;
        }
    }
    return null;
}

/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */
function findChildrenInRange(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos) => {
        if (predicate(child)) {
            nodesWithPos.push({
                node: child,
                pos,
            });
        }
    });
    return nodesWithPos;
}

/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */
function findParentNodeClosestToPos($pos, predicate) {
    for (let i = $pos.depth; i > 0; i -= 1) {
        const node = $pos.node(i);
        if (predicate(node)) {
            return {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node,
            };
        }
    }
}

/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */
function findParentNode(predicate) {
    return (selection) => findParentNodeClosestToPos(selection.$from, predicate);
}

/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */
function getText(node, options) {
    const range = {
        from: 0,
        to: node.content.size,
    };
    return getTextBetween(node, range, options);
}

function getNodeAttributes(state, typeOrName) {
    const type = getNodeType(typeOrName, state.schema);
    const { from, to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, node => {
        nodes.push(node);
    });
    const node = nodes.reverse().find(nodeItem => nodeItem.type.name === type.name);
    if (!node) {
        return {};
    }
    return { ...node.attrs };
}

/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */
function getAttributes(state, typeOrName) {
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') {
        return getNodeAttributes(state, typeOrName);
    }
    if (schemaType === 'mark') {
        return getMarkAttributes(state, typeOrName);
    }
    return {};
}

/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */
function removeDuplicates(array, by = JSON.stringify) {
    const seen = {};
    return array.filter(item => {
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key)
            ? false
            : (seen[key] = true);
    });
}

/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */
function simplifyChangedRanges(changes) {
    const uniqueChanges = removeDuplicates(changes);
    return uniqueChanges.length === 1
        ? uniqueChanges
        : uniqueChanges.filter((change, index) => {
            const rest = uniqueChanges.filter((_, i) => i !== index);
            return !rest.some(otherChange => {
                return change.oldRange.from >= otherChange.oldRange.from
                    && change.oldRange.to <= otherChange.oldRange.to
                    && change.newRange.from >= otherChange.newRange.from
                    && change.newRange.to <= otherChange.newRange.to;
            });
        });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */
function getChangedRanges(transform) {
    const { mapping, steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index) => {
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from, to } = steps[index];
            if (from === undefined || to === undefined) {
                return;
            }
            ranges.push({ from, to });
        }
        else {
            stepMap.forEach((from, to) => {
                ranges.push({ from, to });
            });
        }
        ranges.forEach(({ from, to }) => {
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd,
                },
                newRange: {
                    from: newStart,
                    to: newEnd,
                },
            });
        });
    });
    return simplifyChangedRanges(changes);
}

function getMarksBetween(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) {
        doc
            .resolve(from)
            .marks()
            .forEach(mark => {
            const $pos = doc.resolve(from);
            const range = getMarkRange($pos, mark.type);
            if (!range) {
                return;
            }
            marks.push({
                mark,
                ...range,
            });
        });
    }
    else {
        doc.nodesBetween(from, to, (node, pos) => {
            if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) {
                return;
            }
            marks.push(...node.marks.map(mark => ({
                from: pos,
                to: pos + node.nodeSize,
                mark,
            })));
        });
    }
    return marks;
}

/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */
function getSplittedAttributes(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object
        .entries(attributes)
        .filter(([name]) => {
        const extensionAttribute = extensionAttributes.find(item => {
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) {
            return false;
        }
        return extensionAttribute.attribute.keepOnSplit;
    }));
}

function isMarkActive(state, typeOrName, attributes = {}) {
    const { empty, ranges } = state.selection;
    const type = typeOrName ? getMarkType(typeOrName, state.schema) : null;
    if (empty) {
        return !!(state.storedMarks || state.selection.$from.marks())
            .filter(mark => {
            if (!type) {
                return true;
            }
            return type.name === mark.type.name;
        })
            .find(mark => objectIncludes(mark.attrs, attributes, { strict: false }));
    }
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from, $to }) => {
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos) => {
            if (!node.isText && !node.marks.length) {
                return;
            }
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map(mark => ({
                mark,
                from: relativeFrom,
                to: relativeTo,
            })));
        });
    });
    if (selectionRange === 0) {
        return false;
    }
    // calculate range of matched mark
    const matchedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return type.name === markRange.mark.type.name;
    })
        .filter(markRange => objectIncludes(markRange.mark.attrs, attributes, { strict: false }))
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges
        .filter(markRange => {
        if (!type) {
            return true;
        }
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    })
        .reduce((sum, markRange) => sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}

function isActive(state, name, attributes = {}) {
    if (!name) {
        return isNodeActive(state, null, attributes) || isMarkActive(state, null, attributes);
    }
    const schemaType = getSchemaTypeNameByName(name, state.schema);
    if (schemaType === 'node') {
        return isNodeActive(state, name, attributes);
    }
    if (schemaType === 'mark') {
        return isMarkActive(state, name, attributes);
    }
    return false;
}

function isList(name, extensions) {
    const { nodeExtensions } = splitExtensions(extensions);
    const extension = nodeExtensions.find(item => item.name === name);
    if (!extension) {
        return false;
    }
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage,
    };
    const group = callOrReturn(getExtensionField(extension, 'group', context));
    if (typeof group !== 'string') {
        return false;
    }
    return group.split(' ').includes('list');
}

/**
 * Returns true if the given prosemirror node is empty.
 */
function isNodeEmpty(node, { checkChildren = true, ignoreWhitespace = false, } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === 'hardBreak') {
            // Hard breaks are considered empty
            return true;
        }
        if (node.isText) {
            return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
        }
    }
    if (node.isText) {
        return !node.text;
    }
    if (node.isAtom || node.isLeaf) {
        return false;
    }
    if (node.content.childCount === 0) {
        return true;
    }
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach(childNode => {
            if (isContentEmpty === false) {
                // Exit early for perf
                return;
            }
            if (!isNodeEmpty(childNode, { ignoreWhitespace, checkChildren })) {
                isContentEmpty = false;
            }
        });
        return isContentEmpty;
    }
    return false;
}

function canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection } = tr;
    let cursor = null;
    if (isTextSelection(selection)) {
        cursor = selection.$cursor;
    }
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return (!!newMarkType.isInSet(currentMarks)
            || !currentMarks.some(mark => mark.type.excludes(newMarkType)));
    }
    const { ranges } = selection;
    return ranges.some(({ $from, $to }) => {
        let someNodeSupportsMark = $from.depth === 0
            ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType)
            : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent) => {
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) {
                return false;
            }
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks)
                    || !node.marks.some(otherMark => otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const setMark = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    const type = getMarkType(typeOrName, state.schema);
    if (dispatch) {
        if (empty) {
            const oldAttributes = getMarkAttributes(state, type);
            tr.addStoredMark(type.create({
                ...oldAttributes,
                ...attributes,
            }));
        }
        else {
            ranges.forEach(range => {
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos) => {
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find(mark => mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) {
                        node.marks.forEach(mark => {
                            if (type === mark.type) {
                                tr.addMark(trimmedFrom, trimmedTo, type.create({
                                    ...mark.attrs,
                                    ...attributes,
                                }));
                            }
                        });
                    }
                    else {
                        tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                    }
                });
            });
        }
    }
    return canSetMark(state, tr, type);
};

const setMeta = (key, value) => ({ tr }) => {
    tr.setMeta(key, value);
    return true;
};

const setNode = (typeOrName, attributes = {}) => ({ state, dispatch, chain }) => {
    const type = getNodeType(typeOrName, state.schema);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    // TODO: use a fallback like insertContent?
    if (!type.isTextblock) {
        console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
        return false;
    }
    return (chain()
        // try to convert node to default node if needed
        .command(({ commands }) => {
        const canSetBlock = setBlockType(type, { ...attributesToCopy, ...attributes })(state);
        if (canSetBlock) {
            return true;
        }
        return commands.clearNodes();
    })
        .command(({ state: updatedState }) => {
        return setBlockType(type, { ...attributesToCopy, ...attributes })(updatedState, dispatch);
    })
        .run());
};

const setNodeSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const from = minMax(position, 0, doc.content.size);
        const selection = NodeSelection.create(doc, from);
        tr.setSelection(selection);
    }
    return true;
};

const setTextSelection = position => ({ tr, dispatch }) => {
    if (dispatch) {
        const { doc } = tr;
        const { from, to } = typeof position === 'number' ? { from: position, to: position } : position;
        const minPos = TextSelection.atStart(doc).from;
        const maxPos = TextSelection.atEnd(doc).to;
        const resolvedFrom = minMax(from, minPos, maxPos);
        const resolvedEnd = minMax(to, minPos, maxPos);
        const selection = TextSelection.create(doc, resolvedFrom, resolvedEnd);
        tr.setSelection(selection);
    }
    return true;
};

const sinkListItem = typeOrName => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return sinkListItem$1(type)(state, dispatch);
};

function ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || (state.selection.$to.parentOffset && state.selection.$from.marks());
    if (marks) {
        const filteredMarks = marks.filter(mark => splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const splitBlock = ({ keepMarks = true } = {}) => ({ tr, state, dispatch, editor, }) => {
    const { selection, doc } = tr;
    const { $from, $to } = selection;
    const extensionAttributes = editor.extensionManager.attributes;
    const newAttributes = getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs);
    if (selection instanceof NodeSelection && selection.node.isBlock) {
        if (!$from.parentOffset || !canSplit(doc, $from.pos)) {
            return false;
        }
        if (dispatch) {
            if (keepMarks) {
                ensureMarks(state, editor.extensionManager.splittableMarks);
            }
            tr.split($from.pos).scrollIntoView();
        }
        return true;
    }
    if (!$from.parent.isBlock) {
        return false;
    }
    const atEnd = $to.parentOffset === $to.parent.content.size;
    const deflt = $from.depth === 0
        ? undefined
        : defaultBlockAt($from.node(-1).contentMatchAt($from.indexAfter(-1)));
    let types = atEnd && deflt
        ? [
            {
                type: deflt,
                attrs: newAttributes,
            },
        ]
        : undefined;
    let can = canSplit(tr.doc, tr.mapping.map($from.pos), 1, types);
    if (!types
        && !can
        && canSplit(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [{ type: deflt }] : undefined)) {
        can = true;
        types = deflt
            ? [
                {
                    type: deflt,
                    attrs: newAttributes,
                },
            ]
            : undefined;
    }
    if (dispatch) {
        if (can) {
            if (selection instanceof TextSelection) {
                tr.deleteSelection();
            }
            tr.split(tr.mapping.map($from.pos), 1, types);
            if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                const first = tr.mapping.map($from.before());
                const $first = tr.doc.resolve(first);
                if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) {
                    tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
        }
        if (keepMarks) {
            ensureMarks(state, editor.extensionManager.splittableMarks);
        }
        tr.scrollIntoView();
    }
    return can;
};

const splitListItem = (typeOrName, overrideAttrs = {}) => ({ tr, state, dispatch, editor, }) => {
    var _a;
    const type = getNodeType(typeOrName, state.schema);
    const { $from, $to } = state.selection;
    // @ts-ignore
    // eslint-disable-next-line
    const node = state.selection.node;
    if ((node && node.isBlock) || $from.depth < 2 || !$from.sameParent($to)) {
        return false;
    }
    const grandParent = $from.node(-1);
    if (grandParent.type !== type) {
        return false;
    }
    const extensionAttributes = editor.extensionManager.attributes;
    if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
        // In an empty block. If this is a nested list, the wrapping
        // list item should be split. Otherwise, bail out and let next
        // command handle lifting.
        if ($from.depth === 2
            || $from.node(-3).type !== type
            || $from.index(-2) !== $from.node(-2).childCount - 1) {
            return false;
        }
        if (dispatch) {
            let wrap = Fragment.empty;
            // eslint-disable-next-line
            const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
            // Build a fragment containing empty versions of the structure
            // from the outer list item to the parent node of the cursor
            for (let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1) {
                wrap = Fragment.from($from.node(d).copy(wrap));
            }
            // eslint-disable-next-line
            const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
            // Add a second list item with an empty default start node
            const newNextTypeAttributes = {
                ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
                ...overrideAttrs,
            };
            const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
            wrap = wrap.append(Fragment.from(type.createAndFill(null, nextType) || undefined));
            const start = $from.before($from.depth - (depthBefore - 1));
            tr.replace(start, $from.after(-depthAfter), new Slice(wrap, 4 - depthBefore, 0));
            let sel = -1;
            tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos) => {
                if (sel > -1) {
                    return false;
                }
                if (n.isTextblock && n.content.size === 0) {
                    sel = pos + 1;
                }
            });
            if (sel > -1) {
                tr.setSelection(TextSelection.near(tr.doc.resolve(sel)));
            }
            tr.scrollIntoView();
        }
        return true;
    }
    const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
    const newTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, grandParent.type.name, grandParent.attrs),
        ...overrideAttrs,
    };
    const newNextTypeAttributes = {
        ...getSplittedAttributes(extensionAttributes, $from.node().type.name, $from.node().attrs),
        ...overrideAttrs,
    };
    tr.delete($from.pos, $to.pos);
    const types = nextType
        ? [
            { type, attrs: newTypeAttributes },
            { type: nextType, attrs: newNextTypeAttributes },
        ]
        : [{ type, attrs: newTypeAttributes }];
    if (!canSplit(tr.doc, $from.pos, 2)) {
        return false;
    }
    if (dispatch) {
        const { selection, storedMarks } = state;
        const { splittableMarks } = editor.extensionManager;
        const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
        tr.split($from.pos, 2, types).scrollIntoView();
        if (!marks || !dispatch) {
            return true;
        }
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
    }
    return true;
};

const joinListBackwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) {
        return true;
    }
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && canJoin(tr.doc, list.pos);
    if (!canJoinBackwards) {
        return true;
    }
    tr.join(list.pos);
    return true;
};
const joinListForwards = (tr, listType) => {
    const list = findParentNode(node => node.type === listType)(tr.selection);
    if (!list) {
        return true;
    }
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) {
        return true;
    }
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && canJoin(tr.doc, after);
    if (!canJoinForwards) {
        return true;
    }
    tr.join(after);
    return true;
};
const toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {}) => ({ editor, tr, state, dispatch, chain, commands, can, }) => {
    const { extensions, splittableMarks } = editor.extensionManager;
    const listType = getNodeType(listTypeOrName, state.schema);
    const itemType = getNodeType(itemTypeOrName, state.schema);
    const { selection, storedMarks } = state;
    const { $from, $to } = selection;
    const range = $from.blockRange($to);
    const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
    if (!range) {
        return false;
    }
    const parentList = findParentNode(node => isList(node.type.name, extensions))(selection);
    if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
        // remove list
        if (parentList.node.type === listType) {
            return commands.liftListItem(itemType);
        }
        // change list type
        if (isList(parentList.node.type.name, extensions)
            && listType.validContent(parentList.node.content)
            && dispatch) {
            return chain()
                .command(() => {
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            })
                .command(() => joinListBackwards(tr, listType))
                .command(() => joinListForwards(tr, listType))
                .run();
        }
    }
    if (!keepMarks || !marks || !dispatch) {
        return chain()
            // try to convert node to default node if needed
            .command(() => {
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) {
                return true;
            }
            return commands.clearNodes();
        })
            .wrapInList(listType, attributes)
            .command(() => joinListBackwards(tr, listType))
            .command(() => joinListForwards(tr, listType))
            .run();
    }
    return (chain()
        // try to convert node to default node if needed
        .command(() => {
        const canWrapInList = can().wrapInList(listType, attributes);
        const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
        tr.ensureMarks(filteredMarks);
        if (canWrapInList) {
            return true;
        }
        return commands.clearNodes();
    })
        .wrapInList(listType, attributes)
        .command(() => joinListBackwards(tr, listType))
        .command(() => joinListForwards(tr, listType))
        .run());
};

const toggleMark = (typeOrName, attributes = {}, options = {}) => ({ state, commands }) => {
    const { extendEmptyMarkRange = false } = options;
    const type = getMarkType(typeOrName, state.schema);
    const isActive = isMarkActive(state, type, attributes);
    if (isActive) {
        return commands.unsetMark(type, { extendEmptyMarkRange });
    }
    return commands.setMark(type, attributes);
};

const toggleNode = (typeOrName, toggleTypeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const toggleType = getNodeType(toggleTypeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    let attributesToCopy;
    if (state.selection.$anchor.sameParent(state.selection.$head)) {
        // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
    }
    if (isActive) {
        return commands.setNode(toggleType, attributesToCopy);
    }
    // If the node is not active, we want to set the new node type with the given attributes
    // Copying over the attributes from the current node if the selection is pointing to a node of the same type
    return commands.setNode(type, { ...attributesToCopy, ...attributes });
};

const toggleWrap = (typeOrName, attributes = {}) => ({ state, commands }) => {
    const type = getNodeType(typeOrName, state.schema);
    const isActive = isNodeActive(state, type, attributes);
    if (isActive) {
        return commands.lift(type);
    }
    return commands.wrapIn(type, attributes);
};

const undoInputRule = () => ({ state, dispatch }) => {
    const plugins = state.plugins;
    for (let i = 0; i < plugins.length; i += 1) {
        const plugin = plugins[i];
        let undoable;
        // @ts-ignore
        // eslint-disable-next-line
        if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
            if (dispatch) {
                const tr = state.tr;
                const toUndo = undoable.transform;
                for (let j = toUndo.steps.length - 1; j >= 0; j -= 1) {
                    tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                }
                if (undoable.text) {
                    const marks = tr.doc.resolve(undoable.from).marks();
                    tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                }
                else {
                    tr.delete(undoable.from, undoable.to);
                }
            }
            return true;
        }
    }
    return false;
};

const unsetAllMarks = () => ({ tr, dispatch }) => {
    const { selection } = tr;
    const { empty, ranges } = selection;
    if (empty) {
        return true;
    }
    if (dispatch) {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
    }
    return true;
};

const unsetMark = (typeOrName, options = {}) => ({ tr, state, dispatch }) => {
    var _a;
    const { extendEmptyMarkRange = false } = options;
    const { selection } = tr;
    const type = getMarkType(typeOrName, state.schema);
    const { $from, empty, ranges } = selection;
    if (!dispatch) {
        return true;
    }
    if (empty && extendEmptyMarkRange) {
        let { from, to } = selection;
        const attrs = (_a = $from.marks().find(mark => mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
        const range = getMarkRange($from, type, attrs);
        if (range) {
            from = range.from;
            to = range.to;
        }
        tr.removeMark(from, to, type);
    }
    else {
        ranges.forEach(range => {
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
    }
    tr.removeStoredMark(type);
    return true;
};

const updateAttributes = (typeOrName, attributes = {}) => ({ tr, state, dispatch }) => {
    let nodeType = null;
    let markType = null;
    const schemaType = getSchemaTypeNameByName(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (!schemaType) {
        return false;
    }
    if (schemaType === 'node') {
        nodeType = getNodeType(typeOrName, state.schema);
    }
    if (schemaType === 'mark') {
        markType = getMarkType(typeOrName, state.schema);
    }
    if (dispatch) {
        tr.selection.ranges.forEach((range) => {
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                });
            }
            else {
                state.doc.nodesBetween(from, to, (node, pos) => {
                    if (pos < from && nodeType && nodeType === node.type) {
                        trimmedFrom = Math.max(pos, from);
                        trimmedTo = Math.min(pos + node.nodeSize, to);
                        lastPos = pos;
                        lastNode = node;
                    }
                    if (pos >= from && pos <= to) {
                        if (nodeType && nodeType === node.type) {
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                ...attributes,
                            });
                        }
                        if (markType && node.marks.length) {
                            node.marks.forEach((mark) => {
                                if (markType === mark.type) {
                                    const trimmedFrom2 = Math.max(pos, from);
                                    const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                                    tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                        ...mark.attrs,
                                        ...attributes,
                                    }));
                                }
                            });
                        }
                    }
                });
            }
            if (lastNode) {
                if (lastPos !== undefined) {
                    tr.setNodeMarkup(lastPos, undefined, {
                        ...lastNode.attrs,
                        ...attributes,
                    });
                }
                if (markType && lastNode.marks.length) {
                    lastNode.marks.forEach((mark) => {
                        if (markType === mark.type) {
                            tr.addMark(trimmedFrom, trimmedTo, markType.create({
                                ...mark.attrs,
                                ...attributes,
                            }));
                        }
                    });
                }
            }
        });
    }
    return true;
};

const wrapIn = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapIn$1(type, attributes)(state, dispatch);
};

const wrapInList = (typeOrName, attributes = {}) => ({ state, dispatch }) => {
    const type = getNodeType(typeOrName, state.schema);
    return wrapInList$1(type, attributes)(state, dispatch);
};

var commands = /*#__PURE__*/Object.freeze({
  __proto__: null,
  blur: blur,
  clearContent: clearContent,
  clearNodes: clearNodes,
  command: command,
  createParagraphNear: createParagraphNear,
  cut: cut,
  deleteCurrentNode: deleteCurrentNode,
  deleteNode: deleteNode,
  deleteRange: deleteRange,
  deleteSelection: deleteSelection,
  enter: enter,
  exitCode: exitCode,
  extendMarkRange: extendMarkRange,
  first: first,
  focus: focus,
  forEach: forEach,
  insertContent: insertContent,
  insertContentAt: insertContentAt,
  joinBackward: joinBackward,
  joinDown: joinDown,
  joinForward: joinForward,
  joinItemBackward: joinItemBackward,
  joinItemForward: joinItemForward,
  joinTextblockBackward: joinTextblockBackward,
  joinTextblockForward: joinTextblockForward,
  joinUp: joinUp,
  keyboardShortcut: keyboardShortcut,
  lift: lift,
  liftEmptyBlock: liftEmptyBlock,
  liftListItem: liftListItem,
  newlineInCode: newlineInCode,
  resetAttributes: resetAttributes,
  scrollIntoView: scrollIntoView,
  selectAll: selectAll,
  selectNodeBackward: selectNodeBackward,
  selectNodeForward: selectNodeForward,
  selectParentNode: selectParentNode,
  selectTextblockEnd: selectTextblockEnd,
  selectTextblockStart: selectTextblockStart,
  setContent: setContent,
  setMark: setMark,
  setMeta: setMeta,
  setNode: setNode,
  setNodeSelection: setNodeSelection,
  setTextSelection: setTextSelection,
  sinkListItem: sinkListItem,
  splitBlock: splitBlock,
  splitListItem: splitListItem,
  toggleList: toggleList,
  toggleMark: toggleMark,
  toggleNode: toggleNode,
  toggleWrap: toggleWrap,
  undoInputRule: undoInputRule,
  unsetAllMarks: unsetAllMarks,
  unsetMark: unsetMark,
  updateAttributes: updateAttributes,
  wrapIn: wrapIn,
  wrapInList: wrapInList
});

const Commands = Extension.create({
    name: 'commands',
    addCommands() {
        return {
            ...commands,
        };
    },
});

const Drop = Extension.create({
    name: 'drop',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tiptapDrop'),
                props: {
                    handleDrop: (_, e, slice, moved) => {
                        this.editor.emit('drop', {
                            editor: this.editor,
                            event: e,
                            slice,
                            moved,
                        });
                    },
                },
            }),
        ];
    },
});

const Editable = Extension.create({
    name: 'editable',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('editable'),
                props: {
                    editable: () => this.editor.options.editable,
                },
            }),
        ];
    },
});

const focusEventsPluginKey = new PluginKey('focusEvents');
const FocusEvents = Extension.create({
    name: 'focusEvents',
    addProseMirrorPlugins() {
        const { editor } = this;
        return [
            new Plugin({
                key: focusEventsPluginKey,
                props: {
                    handleDOMEvents: {
                        focus: (view, event) => {
                            editor.isFocused = true;
                            const transaction = editor.state.tr
                                .setMeta('focus', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event) => {
                            editor.isFocused = false;
                            const transaction = editor.state.tr
                                .setMeta('blur', { event })
                                .setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                    },
                },
            }),
        ];
    },
});

const Keymap = Extension.create({
    name: 'keymap',
    addKeyboardShortcuts() {
        const handleBackspace = () => this.editor.commands.first(({ commands }) => [
            () => commands.undoInputRule(),
            // maybe convert first text block node to default node
            () => commands.command(({ tr }) => {
                const { selection, doc } = tr;
                const { empty, $anchor } = selection;
                const { pos, parent } = $anchor;
                const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                const parentPos = $anchor.pos - $anchor.parentOffset;
                const isAtStart = (parentIsIsolating && $parentPos.parent.childCount === 1)
                    ? parentPos === $anchor.pos
                    : Selection.atStart(doc).from === pos;
                if (!empty
                    || !parent.type.isTextblock
                    || parent.textContent.length
                    || !isAtStart
                    || (isAtStart && $anchor.parent.type.name === 'paragraph') // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                ) {
                    return false;
                }
                return commands.clearNodes();
            }),
            () => commands.deleteSelection(),
            () => commands.joinBackward(),
            () => commands.selectNodeBackward(),
        ]);
        const handleDelete = () => this.editor.commands.first(({ commands }) => [
            () => commands.deleteSelection(),
            () => commands.deleteCurrentNode(),
            () => commands.joinForward(),
            () => commands.selectNodeForward(),
        ]);
        const handleEnter = () => this.editor.commands.first(({ commands }) => [
            () => commands.newlineInCode(),
            () => commands.createParagraphNear(),
            () => commands.liftEmptyBlock(),
            () => commands.splitBlock(),
        ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': () => this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': () => this.editor.commands.selectAll(),
        };
        const pcKeymap = {
            ...baseKeymap,
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': () => this.editor.commands.selectTextblockStart(),
            'Ctrl-e': () => this.editor.commands.selectTextblockEnd(),
        };
        if (isiOS() || isMacOS()) {
            return macKeymap;
        }
        return pcKeymap;
    },
    addProseMirrorPlugins() {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new Plugin({
                key: new PluginKey('clearDocument'),
                appendTransaction: (transactions, oldState, newState) => {
                    if (transactions.some(tr => tr.getMeta('composition'))) {
                        return;
                    }
                    const docChanges = transactions.some(transaction => transaction.docChanged)
                        && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some(transaction => transaction.getMeta('preventClearDocument'));
                    if (!docChanges || ignoreTr) {
                        return;
                    }
                    const { empty, from, to } = oldState.selection;
                    const allFrom = Selection.atStart(oldState.doc).from;
                    const allEnd = Selection.atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) {
                        return;
                    }
                    const isEmpty = isNodeEmpty(newState.doc);
                    if (!isEmpty) {
                        return;
                    }
                    const tr = newState.tr;
                    const state = createChainableState({
                        state: newState,
                        transaction: tr,
                    });
                    const { commands } = new CommandManager({
                        editor: this.editor,
                        state,
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) {
                        return;
                    }
                    return tr;
                },
            }),
        ];
    },
});

const Paste = Extension.create({
    name: 'paste',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tiptapPaste'),
                props: {
                    handlePaste: (_view, e, slice) => {
                        this.editor.emit('paste', {
                            editor: this.editor,
                            event: e,
                            slice,
                        });
                    },
                },
            }),
        ];
    },
});

const Tabindex = Extension.create({
    name: 'tabindex',
    addProseMirrorPlugins() {
        return [
            new Plugin({
                key: new PluginKey('tabindex'),
                props: {
                    attributes: () => (this.editor.isEditable ? { tabindex: '0' } : {}),
                },
            }),
        ];
    },
});

class NodePos {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null) {
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({ from, to }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) {
            return this.pos;
        }
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to,
        };
    }
    get to() {
        if (this.isBlock) {
            return this.pos + this.size;
        }
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) {
            return null;
        }
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new NodePos($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.from - 3);
        }
        return new NodePos($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) {
            $pos = this.resolvedPos.doc.resolve(this.to + 3);
        }
        return new NodePos($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset) => {
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            // Check if targetPos is within valid document range
            if (targetPos < 0 || targetPos > this.resolvedPos.doc.nodeSize - 2) {
                return;
            }
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) {
                return;
            }
            const childNodePos = new NodePos($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) {
                childNodePos.actualDepth = this.depth + 1;
            }
            children.push(new NodePos($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while (currentNode && !node) {
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for (let index = 0; index < attrKeys.length; index += 1) {
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) {
                            break;
                        }
                    }
                }
                else {
                    node = currentNode;
                }
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) {
            return nodes;
        }
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */
        this.children.forEach(childPos => {
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every(key => attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) {
                    nodes.push(childPos);
                }
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) {
                return;
            }
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes,
        });
        this.editor.view.dispatch(tr);
    }
}

const style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;

function createStyleTag(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ''}]`);
    if (tiptapStyleTag !== null) {
        return tiptapStyleTag;
    }
    const styleNode = document.createElement('style');
    if (nonce) {
        styleNode.setAttribute('nonce', nonce);
    }
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ''}`, '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}

class Editor extends EventEmitter {
    constructor(options = {}) {
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */
        this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            emitContentError: false,
            onBeforeCreate: () => null,
            onCreate: () => null,
            onUpdate: () => null,
            onSelectionUpdate: () => null,
            onTransaction: () => null,
            onFocus: () => null,
            onBlur: () => null,
            onDestroy: () => null,
            onContentError: ({ error }) => { throw error; },
            onPaste: () => null,
            onDrop: () => null,
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', { editor: this });
        this.on('contentError', this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        this.on('drop', ({ event, slice, moved }) => this.options.onDrop(event, slice, moved));
        this.on('paste', ({ event, slice }) => this.options.onPaste(event, slice));
        window.setTimeout(() => {
            if (this.isDestroyed) {
                return;
            }
            this.commands.focus(this.options.autofocus);
            this.emit('create', { editor: this });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */
    get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */
    get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */
    chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */
    can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */
    injectCSS() {
        if (this.options.injectCSS && document) {
            this.css = createStyleTag(style, this.options.injectNonce);
        }
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */
    setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options,
        };
        if (!this.view || !this.state || this.isDestroyed) {
            return;
        }
        if (this.options.editorProps) {
            this.view.setProps(this.options.editorProps);
        }
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */
    setEditable(editable, emitUpdate = true) {
        this.setOptions({ editable });
        if (emitUpdate) {
            this.emit('update', { editor: this, transaction: this.state.tr });
        }
    }
    /**
     * Returns whether the editor is editable.
     */
    get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */
    get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */
    registerPlugin(plugin, handlePlugins) {
        const plugins = isFunction$1(handlePlugins)
            ? handlePlugins(plugin, [...this.state.plugins])
            : [...this.state.plugins, plugin];
        const state = this.state.reconfigure({ plugins });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */
    unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) {
            return undefined;
        }
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach(nameOrPluginKey => {
            // @ts-ignore
            const name = typeof nameOrPluginKey === 'string' ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = plugins.filter(plugin => !plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) {
            // No plugin was removed, so we don’t need to update the state
            return undefined;
        }
        const state = this.state.reconfigure({
            plugins,
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */
    createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            Editable,
            ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator,
            }),
            Commands,
            FocusEvents,
            Keymap,
            Tabindex,
            Drop,
            Paste,
        ].filter(ext => {
            if (typeof this.options.enableCoreExtensions === 'object') {
                return this.options.enableCoreExtensions[ext.name] !== false;
            }
            return true;
        }) : [];
        const allExtensions = [...coreExtensions, ...this.options.extensions].filter(extension => {
            return ['extension', 'node', 'mark'].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */
    createCommandManager() {
        this.commandManager = new CommandManager({
            editor: this,
        });
    }
    /**
     * Creates a ProseMirror schema.
     */
    createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */
    createView() {
        var _a;
        let doc;
        try {
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
        }
        catch (e) {
            if (!(e instanceof Error) || !['[tiptap error]: Invalid JSON content', '[tiptap error]: Invalid HTML content'].includes(e.message)) {
                // Not the content error we were expecting
                throw e;
            }
            this.emit('contentError', {
                editor: this,
                error: e,
                disableCollaboration: () => {
                    if (this.storage.collaboration) {
                        this.storage.collaboration.isDisabled = true;
                    }
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter(extension => extension.name !== 'collaboration');
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                },
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = createDocument(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: false });
        }
        const selection = resolveFocusPosition(doc, this.options.autofocus);
        this.view = new EditorView(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: 'textbox',
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes,
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: EditorState.create({
                doc,
                selection: selection || undefined,
            }),
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins,
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */
    createNodeViews() {
        if (this.view.isDestroyed) {
            return;
        }
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews,
        });
    }
    /**
     * Prepend class name to element.
     */
    prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */
    dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) {
            return;
        }
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach(step => { var _a; return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step); });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit('beforeTransaction', {
            editor: this,
            transaction,
            nextState: state,
        });
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction,
        });
        if (selectionHasChanged) {
            this.emit('selectionUpdate', {
                editor: this,
                transaction,
            });
        }
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) {
            this.emit('focus', {
                editor: this,
                event: focus.event,
                transaction,
            });
        }
        if (blur) {
            this.emit('blur', {
                editor: this,
                event: blur.event,
                transaction,
            });
        }
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) {
            return;
        }
        this.emit('update', {
            editor: this,
            transaction,
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */
    getAttributes(nameOrType) {
        return getAttributes(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
        return isActive(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */
    getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */
    getHTML() {
        return getHTMLFromFragment(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */
    getText(options) {
        const { blockSeparator = '\n\n', textSerializers = {} } = options || {};
        return getText(this.state.doc, {
            blockSeparator,
            textSerializers: {
                ...getTextSerializersFromSchema(this.schema),
                ...textSerializers,
            },
        });
    }
    /**
     * Check if there is no content.
     */
    get isEmpty() {
        return isNodeEmpty(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */
    getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */
    destroy() {
        this.emit('destroy');
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) {
                delete dom.editor;
            }
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */
    get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new NodePos($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}

/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function markInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function textblockTypeInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match }) => {
            const $start = state.doc.resolve(range.from);
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) {
                return null;
            }
            state.tr
                .delete(range.from, range.to)
                .setBlockType(range.from, range.from, config.type, attributes);
        },
    });
}

/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */
function wrappingInputRule(config) {
    return new InputRule({
        find: config.find,
        handler: ({ state, range, match, chain, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && findWrapping(blockRange, config.type, attributes);
            if (!wrapping) {
                return null;
            }
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection, storedMarks } = state;
                const { splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || (selection.$to.parentOffset && selection.$from.marks());
                if (marks) {
                    const filteredMarks = marks.filter(mark => splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */
                const nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before
                && before.type === config.type
                && canJoin(tr.doc, range.from - 1)
                && (!config.joinPredicate || config.joinPredicate(match, before))) {
                tr.join(range.from - 1);
            }
        },
    });
}

/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */
class Node {
    constructor(config = {}) {
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {},
        };
        this.config = {
            ...this.config,
            ...config,
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        }
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) {
            this.options = callOrReturn(getExtensionField(this, 'addOptions', {
                name: this.name,
            }));
        }
        this.storage = callOrReturn(getExtensionField(this, 'addStorage', {
            name: this.name,
            options: this.options,
        })) || {};
    }
    static create(config = {}) {
        return new Node(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: () => {
                return mergeDeep(this.options, options);
            },
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new Node(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) {
            console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        }
        extension.options = callOrReturn(getExtensionField(extension, 'addOptions', {
            name: extension.name,
        }));
        extension.storage = callOrReturn(getExtensionField(extension, 'addStorage', {
            name: extension.name,
            options: extension.options,
        }));
        return extension;
    }
}

/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */
function markPasteRule(config) {
    return new PasteRule({
        find: config.find,
        handler: ({ state, range, match, pasteEvent, }) => {
            const attributes = callOrReturn(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) {
                return null;
            }
            const { tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = getMarksBetween(range.from, range.to, state.doc)
                    .filter(item => {
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find(type => type === config.type && type !== item.mark.type);
                })
                    .filter(item => item.to > textStart);
                if (excludedMarks.length) {
                    return null;
                }
                if (textEnd < range.to) {
                    tr.delete(textEnd, range.to);
                }
                if (textStart > range.from) {
                    tr.delete(range.from + startSpaces, textStart);
                }
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        },
    });
}

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var shim = {exports: {}};

var useSyncExternalStoreShim_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_production_min;

function requireUseSyncExternalStoreShim_production_min () {
	if (hasRequiredUseSyncExternalStoreShim_production_min) return useSyncExternalStoreShim_production_min;
	hasRequiredUseSyncExternalStoreShim_production_min = 1;
var e=React;function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c});},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c});})},[a]);p(d);return d}
	function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return !k(a,d)}catch(f){return !0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;useSyncExternalStoreShim_production_min.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;
	return useSyncExternalStoreShim_production_min;
}

var useSyncExternalStoreShim_development = {};

/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStoreShim_development;

function requireUseSyncExternalStoreShim_development () {
	if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
	hasRequiredUseSyncExternalStoreShim_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
	}
	          var React$1 = React;

	var ReactSharedInternals = React$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

	function error(format) {
	  {
	    {
	      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	        args[_key2 - 1] = arguments[_key2];
	      }

	      printWarning('error', format, args);
	    }
	  }
	}

	function printWarning(level, format, args) {
	  // When changing this logic, you might want to also
	  // update consoleWithStackDev.www.js as well.
	  {
	    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	    var stack = ReactDebugCurrentFrame.getStackAddendum();

	    if (stack !== '') {
	      format += '%s';
	      args = args.concat([stack]);
	    } // eslint-disable-next-line react-internal/safe-string-coercion


	    var argsWithFormat = args.map(function (item) {
	      return String(item);
	    }); // Careful: RN currently depends on this prefix

	    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	    // breaks IE9: https://github.com/facebook/react/issues/13610
	    // eslint-disable-next-line react-internal/no-production-logging

	    Function.prototype.apply.call(console[level], console, argsWithFormat);
	  }
	}

	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	  ;
	}

	var objectIs = typeof Object.is === 'function' ? Object.is : is;

	// dispatch for CommonJS interop named imports.

	var useState = React$1.useState,
	    useEffect = React$1.useEffect,
	    useLayoutEffect = React$1.useLayoutEffect,
	    useDebugValue = React$1.useDebugValue;
	var didWarnOld18Alpha = false;
	var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
	// because of a very particular set of implementation details and assumptions
	// -- change any one of them and it will break. The most important assumption
	// is that updates are always synchronous, because concurrent rendering is
	// only available in versions of React that also have a built-in
	// useSyncExternalStore API. And we only use this shim when the built-in API
	// does not exist.
	//
	// Do not assume that the clever hacks used by this hook also work in general.
	// The point of this shim is to replace the need for hacks by other libraries.

	function useSyncExternalStore(subscribe, getSnapshot, // Note: The shim does not use getServerSnapshot, because pre-18 versions of
	// React do not expose a way to check if we're hydrating. So users of the shim
	// will need to track that themselves and return the correct value
	// from `getSnapshot`.
	getServerSnapshot) {
	  {
	    if (!didWarnOld18Alpha) {
	      if (React$1.startTransition !== undefined) {
	        didWarnOld18Alpha = true;

	        error('You are using an outdated, pre-release alpha of React 18 that ' + 'does not support useSyncExternalStore. The ' + 'use-sync-external-store shim will not work correctly. Upgrade ' + 'to a newer pre-release.');
	      }
	    }
	  } // Read the current snapshot from the store on every render. Again, this
	  // breaks the rules of React, and only works here because of specific
	  // implementation details, most importantly that updates are
	  // always synchronous.


	  var value = getSnapshot();

	  {
	    if (!didWarnUncachedGetSnapshot) {
	      var cachedValue = getSnapshot();

	      if (!objectIs(value, cachedValue)) {
	        error('The result of getSnapshot should be cached to avoid an infinite loop');

	        didWarnUncachedGetSnapshot = true;
	      }
	    }
	  } // Because updates are synchronous, we don't queue them. Instead we force a
	  // re-render whenever the subscribed state changes by updating an some
	  // arbitrary useState hook. Then, during render, we call getSnapshot to read
	  // the current value.
	  //
	  // Because we don't actually use the state returned by the useState hook, we
	  // can save a bit of memory by storing other stuff in that slot.
	  //
	  // To implement the early bailout, we need to track some things on a mutable
	  // object. Usually, we would put that in a useRef hook, but we can stash it in
	  // our useState hook instead.
	  //
	  // To force a re-render, we call forceUpdate({inst}). That works because the
	  // new object always fails an equality check.


	  var _useState = useState({
	    inst: {
	      value: value,
	      getSnapshot: getSnapshot
	    }
	  }),
	      inst = _useState[0].inst,
	      forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
	  // in the layout phase so we can access it during the tearing check that
	  // happens on subscribe.


	  useLayoutEffect(function () {
	    inst.value = value;
	    inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
	    // commit phase if there was an interleaved mutation. In concurrent mode
	    // this can happen all the time, but even in synchronous mode, an earlier
	    // effect may have mutated the store.

	    if (checkIfSnapshotChanged(inst)) {
	      // Force a re-render.
	      forceUpdate({
	        inst: inst
	      });
	    }
	  }, [subscribe, value, getSnapshot]);
	  useEffect(function () {
	    // Check for changes right before subscribing. Subsequent changes will be
	    // detected in the subscription handler.
	    if (checkIfSnapshotChanged(inst)) {
	      // Force a re-render.
	      forceUpdate({
	        inst: inst
	      });
	    }

	    var handleStoreChange = function () {
	      // TODO: Because there is no cross-renderer API for batching updates, it's
	      // up to the consumer of this library to wrap their subscription event
	      // with unstable_batchedUpdates. Should we try to detect when this isn't
	      // the case and print a warning in development?
	      // The store changed. Check if the snapshot changed since the last time we
	      // read from the store.
	      if (checkIfSnapshotChanged(inst)) {
	        // Force a re-render.
	        forceUpdate({
	          inst: inst
	        });
	      }
	    }; // Subscribe to the store and return a clean-up function.


	    return subscribe(handleStoreChange);
	  }, [subscribe]);
	  useDebugValue(value);
	  return value;
	}

	function checkIfSnapshotChanged(inst) {
	  var latestGetSnapshot = inst.getSnapshot;
	  var prevValue = inst.value;

	  try {
	    var nextValue = latestGetSnapshot();
	    return !objectIs(prevValue, nextValue);
	  } catch (error) {
	    return true;
	  }
	}

	function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
	  // Note: The shim does not use getServerSnapshot, because pre-18 versions of
	  // React do not expose a way to check if we're hydrating. So users of the shim
	  // will need to track that themselves and return the correct value
	  // from `getSnapshot`.
	  return getSnapshot();
	}

	var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');

	var isServerEnvironment = !canUseDOM;

	var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
	var useSyncExternalStore$2 = React$1.useSyncExternalStore !== undefined ? React$1.useSyncExternalStore : shim;

	useSyncExternalStoreShim_development.useSyncExternalStore = useSyncExternalStore$2;
	          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
	}
	        
	  })();
	}
	return useSyncExternalStoreShim_development;
}

if (process.env.NODE_ENV === 'production') {
  shim.exports = requireUseSyncExternalStoreShim_production_min();
} else {
  shim.exports = requireUseSyncExternalStoreShim_development();
}

var shimExports = shim.exports;

const mergeRefs = (...refs) => {
    return (node) => {
        refs.forEach(ref => {
            if (typeof ref === 'function') {
                ref(node);
            }
            else if (ref) {
                ref.current = node;
            }
        });
    };
};
/**
 * This component renders all of the editor's node views.
 */
const Portals = ({ contentComponent, }) => {
    // For performance reasons, we render the node view portals on state changes only
    const renderers = shimExports.useSyncExternalStore(contentComponent.subscribe, contentComponent.getSnapshot, contentComponent.getServerSnapshot);
    // This allows us to directly render the portals without any additional wrapper
    return (React.createElement(React.Fragment, null, Object.values(renderers)));
};
function getInstance() {
    const subscribers = new Set();
    let renderers = {};
    return {
        /**
         * Subscribe to the editor instance's changes.
         */
        subscribe(callback) {
            subscribers.add(callback);
            return () => {
                subscribers.delete(callback);
            };
        },
        getSnapshot() {
            return renderers;
        },
        getServerSnapshot() {
            return renderers;
        },
        /**
         * Adds a new NodeView Renderer to the editor.
         */
        setRenderer(id, renderer) {
            renderers = {
                ...renderers,
                [id]: ReactDOM.createPortal(renderer.reactElement, renderer.element, id),
            };
            subscribers.forEach(subscriber => subscriber());
        },
        /**
         * Removes a NodeView Renderer from the editor.
         */
        removeRenderer(id) {
            const nextRenderers = { ...renderers };
            delete nextRenderers[id];
            renderers = nextRenderers;
            subscribers.forEach(subscriber => subscriber());
        },
    };
}
class PureEditorContent extends React.Component {
    constructor(props) {
        var _a;
        super(props);
        this.editorContentRef = React.createRef();
        this.initialized = false;
        this.state = {
            hasContentComponentInitialized: Boolean((_a = props.editor) === null || _a === void 0 ? void 0 : _a.contentComponent),
        };
    }
    componentDidMount() {
        this.init();
    }
    componentDidUpdate() {
        this.init();
    }
    init() {
        const editor = this.props.editor;
        if (editor && !editor.isDestroyed && editor.options.element) {
            if (editor.contentComponent) {
                return;
            }
            const element = this.editorContentRef.current;
            element.append(...editor.options.element.childNodes);
            editor.setOptions({
                element,
            });
            editor.contentComponent = getInstance();
            // Has the content component been initialized?
            if (!this.state.hasContentComponentInitialized) {
                // Subscribe to the content component
                this.unsubscribeToContentComponent = editor.contentComponent.subscribe(() => {
                    this.setState(prevState => {
                        if (!prevState.hasContentComponentInitialized) {
                            return {
                                hasContentComponentInitialized: true,
                            };
                        }
                        return prevState;
                    });
                    // Unsubscribe to previous content component
                    if (this.unsubscribeToContentComponent) {
                        this.unsubscribeToContentComponent();
                    }
                });
            }
            editor.createNodeViews();
            this.initialized = true;
        }
    }
    componentWillUnmount() {
        const editor = this.props.editor;
        if (!editor) {
            return;
        }
        this.initialized = false;
        if (!editor.isDestroyed) {
            editor.view.setProps({
                nodeViews: {},
            });
        }
        if (this.unsubscribeToContentComponent) {
            this.unsubscribeToContentComponent();
        }
        editor.contentComponent = null;
        if (!editor.options.element.firstChild) {
            return;
        }
        const newElement = document.createElement('div');
        newElement.append(...editor.options.element.childNodes);
        editor.setOptions({
            element: newElement,
        });
    }
    render() {
        const { editor, innerRef, ...rest } = this.props;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { ref: mergeRefs(innerRef, this.editorContentRef), ...rest }),
            (editor === null || editor === void 0 ? void 0 : editor.contentComponent) && React.createElement(Portals, { contentComponent: editor.contentComponent })));
    }
}
// EditorContent should be re-created whenever the Editor instance changes
const EditorContentWithKey = forwardRef((props, ref) => {
    const key = React.useMemo(() => {
        return Math.floor(Math.random() * 0xffffffff).toString();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.editor]);
    // Can't use JSX here because it conflicts with the type definition of Vue's JSX, so use createElement
    return React.createElement(PureEditorContent, {
        key,
        innerRef: ref,
        ...props,
    });
});
const EditorContent = React.memo(EditorContentWithKey);

var react = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }


    if ((a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      for (i of a.entries())
        if (!equal(i[1], b.get(i[0]))) return false;
      return true;
    }

    if ((a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      for (i of a.entries())
        if (!b.has(i[0])) return false;
      return true;
    }

    if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }


    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        continue;
      }

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

var deepEqual = /*@__PURE__*/getDefaultExportFromCjs(react);

var withSelector = {exports: {}};

var withSelector_production_min = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredWithSelector_production_min;

function requireWithSelector_production_min () {
	if (hasRequiredWithSelector_production_min) return withSelector_production_min;
	hasRequiredWithSelector_production_min = 1;
var h=React,n=shimExports;function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
	withSelector_production_min.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f;}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return [function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
	u(function(){f.hasValue=!0;f.value=d;},[d]);w(d);return d};
	return withSelector_production_min;
}

var withSelector_development = {};

/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredWithSelector_development;

function requireWithSelector_development () {
	if (hasRequiredWithSelector_development) return withSelector_development;
	hasRequiredWithSelector_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
	}
	          var React$1 = React;
	var shim = shimExports;

	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
	  ;
	}

	var objectIs = typeof Object.is === 'function' ? Object.is : is;

	var useSyncExternalStore = shim.useSyncExternalStore;

	// for CommonJS interop.

	var useRef = React$1.useRef,
	    useEffect = React$1.useEffect,
	    useMemo = React$1.useMemo,
	    useDebugValue = React$1.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.

	function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
	  // Use this to track the rendered snapshot.
	  var instRef = useRef(null);
	  var inst;

	  if (instRef.current === null) {
	    inst = {
	      hasValue: false,
	      value: null
	    };
	    instRef.current = inst;
	  } else {
	    inst = instRef.current;
	  }

	  var _useMemo = useMemo(function () {
	    // Track the memoized state using closure variables that are local to this
	    // memoized instance of a getSnapshot function. Intentionally not using a
	    // useRef hook, because that state would be shared across all concurrent
	    // copies of the hook/component.
	    var hasMemo = false;
	    var memoizedSnapshot;
	    var memoizedSelection;

	    var memoizedSelector = function (nextSnapshot) {
	      if (!hasMemo) {
	        // The first time the hook is called, there is no memoized result.
	        hasMemo = true;
	        memoizedSnapshot = nextSnapshot;

	        var _nextSelection = selector(nextSnapshot);

	        if (isEqual !== undefined) {
	          // Even if the selector has changed, the currently rendered selection
	          // may be equal to the new selection. We should attempt to reuse the
	          // current value if possible, to preserve downstream memoizations.
	          if (inst.hasValue) {
	            var currentSelection = inst.value;

	            if (isEqual(currentSelection, _nextSelection)) {
	              memoizedSelection = currentSelection;
	              return currentSelection;
	            }
	          }
	        }

	        memoizedSelection = _nextSelection;
	        return _nextSelection;
	      } // We may be able to reuse the previous invocation's result.


	      // We may be able to reuse the previous invocation's result.
	      var prevSnapshot = memoizedSnapshot;
	      var prevSelection = memoizedSelection;

	      if (objectIs(prevSnapshot, nextSnapshot)) {
	        // The snapshot is the same as last time. Reuse the previous selection.
	        return prevSelection;
	      } // The snapshot has changed, so we need to compute a new selection.


	      // The snapshot has changed, so we need to compute a new selection.
	      var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
	      // has changed. If it hasn't, return the previous selection. That signals
	      // to React that the selections are conceptually equal, and we can bail
	      // out of rendering.

	      // If a custom isEqual function is provided, use that to check if the data
	      // has changed. If it hasn't, return the previous selection. That signals
	      // to React that the selections are conceptually equal, and we can bail
	      // out of rendering.
	      if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) {
	        return prevSelection;
	      }

	      memoizedSnapshot = nextSnapshot;
	      memoizedSelection = nextSelection;
	      return nextSelection;
	    }; // Assigning this to a constant so that Flow knows it can't change.


	    // Assigning this to a constant so that Flow knows it can't change.
	    var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;

	    var getSnapshotWithSelector = function () {
	      return memoizedSelector(getSnapshot());
	    };

	    var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function () {
	      return memoizedSelector(maybeGetServerSnapshot());
	    };
	    return [getSnapshotWithSelector, getServerSnapshotWithSelector];
	  }, [getSnapshot, getServerSnapshot, selector, isEqual]),
	      getSelection = _useMemo[0],
	      getServerSelection = _useMemo[1];

	  var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
	  useEffect(function () {
	    inst.hasValue = true;
	    inst.value = value;
	  }, [value]);
	  useDebugValue(value);
	  return value;
	}

	withSelector_development.useSyncExternalStoreWithSelector = useSyncExternalStoreWithSelector;
	          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop ===
	    'function'
	) {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
	}
	        
	  })();
	}
	return withSelector_development;
}

if (process.env.NODE_ENV === 'production') {
  withSelector.exports = requireWithSelector_production_min();
} else {
  withSelector.exports = requireWithSelector_development();
}

var withSelectorExports = withSelector.exports;

const useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
/**
 * To synchronize the editor instance with the component state,
 * we need to create a separate instance that is not affected by the component re-renders.
 */
class EditorStateManager {
    constructor(initialEditor) {
        this.transactionNumber = 0;
        this.lastTransactionNumber = 0;
        this.subscribers = new Set();
        this.editor = initialEditor;
        this.lastSnapshot = { editor: initialEditor, transactionNumber: 0 };
        this.getSnapshot = this.getSnapshot.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.watch = this.watch.bind(this);
        this.subscribe = this.subscribe.bind(this);
    }
    /**
     * Get the current editor instance.
     */
    getSnapshot() {
        if (this.transactionNumber === this.lastTransactionNumber) {
            return this.lastSnapshot;
        }
        this.lastTransactionNumber = this.transactionNumber;
        this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber };
        return this.lastSnapshot;
    }
    /**
     * Always disable the editor on the server-side.
     */
    getServerSnapshot() {
        return { editor: null, transactionNumber: 0 };
    }
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(callback) {
        this.subscribers.add(callback);
        return () => {
            this.subscribers.delete(callback);
        };
    }
    /**
     * Watch the editor instance for changes.
     */
    watch(nextEditor) {
        this.editor = nextEditor;
        if (this.editor) {
            /**
             * This will force a re-render when the editor state changes.
             * This is to support things like `editor.can().toggleBold()` in components that `useEditor`.
             * This could be more efficient, but it's a good trade-off for now.
             */
            const fn = () => {
                this.transactionNumber += 1;
                this.subscribers.forEach(callback => callback());
            };
            const currentEditor = this.editor;
            currentEditor.on('transaction', fn);
            return () => {
                currentEditor.off('transaction', fn);
            };
        }
        return undefined;
    }
}
/**
 * This hook allows you to watch for changes on the editor instance.
 * It will allow you to select a part of the editor state and re-render the component when it changes.
 * @example
 * ```tsx
 * const editor = useEditor({...options})
 * const { currentSelection } = useEditorState({
 *  editor,
 *  selector: snapshot => ({ currentSelection: snapshot.editor.state.selection }),
 * })
 */
function useEditorState(options) {
    var _a;
    const [editorStateManager] = useState(() => new EditorStateManager(options.editor));
    // Using the `useSyncExternalStore` hook to sync the editor instance with the component state
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(editorStateManager.subscribe, editorStateManager.getSnapshot, editorStateManager.getServerSnapshot, options.selector, (_a = options.equalityFn) !== null && _a !== void 0 ? _a : deepEqual);
    useIsomorphicLayoutEffect$1(() => {
        return editorStateManager.watch(options.editor);
    }, [options.editor, editorStateManager]);
    useDebugValue(selectedState);
    return selectedState;
}

const isDev = process.env.NODE_ENV !== 'production';
const isSSR = typeof window === 'undefined';
const isNext = isSSR || Boolean(typeof window !== 'undefined' && window.next);
/**
 * This class handles the creation, destruction, and re-creation of the editor instance.
 */
class EditorInstanceManager {
    constructor(options) {
        /**
         * The current editor instance.
         */
        this.editor = null;
        /**
         * The subscriptions to notify when the editor instance
         * has been created or destroyed.
         */
        this.subscriptions = new Set();
        /**
         * Whether the editor has been mounted.
         */
        this.isComponentMounted = false;
        /**
         * The most recent dependencies array.
         */
        this.previousDeps = null;
        /**
         * The unique instance ID. This is used to identify the editor instance. And will be re-generated for each new instance.
         */
        this.instanceId = '';
        this.options = options;
        this.subscriptions = new Set();
        this.setEditor(this.getInitialEditor());
        this.scheduleDestroy();
        this.getEditor = this.getEditor.bind(this);
        this.getServerSnapshot = this.getServerSnapshot.bind(this);
        this.subscribe = this.subscribe.bind(this);
        this.refreshEditorInstance = this.refreshEditorInstance.bind(this);
        this.scheduleDestroy = this.scheduleDestroy.bind(this);
        this.onRender = this.onRender.bind(this);
        this.createEditor = this.createEditor.bind(this);
    }
    setEditor(editor) {
        this.editor = editor;
        this.instanceId = Math.random().toString(36).slice(2, 9);
        // Notify all subscribers that the editor instance has been created
        this.subscriptions.forEach(cb => cb());
    }
    getInitialEditor() {
        if (this.options.current.immediatelyRender === undefined) {
            if (isSSR || isNext) {
                // TODO in the next major release, we should throw an error here
                if (isDev) {
                    /**
                     * Throw an error in development, to make sure the developer is aware that tiptap cannot be SSR'd
                     * and that they need to set `immediatelyRender` to `false` to avoid hydration mismatches.
                     */
                    console.warn('Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches.');
                }
                // Best faith effort in production, run the code in the legacy mode to avoid hydration mismatches and errors in production
                return null;
            }
            // Default to immediately rendering when client-side rendering
            return this.createEditor();
        }
        if (this.options.current.immediatelyRender && isSSR && isDev) {
            // Warn in development, to make sure the developer is aware that tiptap cannot be SSR'd, set `immediatelyRender` to `false` to avoid hydration mismatches.
            throw new Error('Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.');
        }
        if (this.options.current.immediatelyRender) {
            return this.createEditor();
        }
        return null;
    }
    /**
     * Create a new editor instance. And attach event listeners.
     */
    createEditor() {
        const optionsToApply = {
            ...this.options.current,
            // Always call the most recent version of the callback function by default
            onBeforeCreate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onBeforeCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onBlur: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onBlur) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onCreate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onCreate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onDestroy: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onDestroy) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onFocus: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onFocus) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onSelectionUpdate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onSelectionUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onTransaction: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onTransaction) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onUpdate: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onUpdate) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onContentError: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onContentError) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onDrop: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onDrop) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
            onPaste: (...args) => { var _a, _b; return (_b = (_a = this.options.current).onPaste) === null || _b === void 0 ? void 0 : _b.call(_a, ...args); },
        };
        const editor = new Editor(optionsToApply);
        // no need to keep track of the event listeners, they will be removed when the editor is destroyed
        return editor;
    }
    /**
     * Get the current editor instance.
     */
    getEditor() {
        return this.editor;
    }
    /**
     * Always disable the editor on the server-side.
     */
    getServerSnapshot() {
        return null;
    }
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(onStoreChange) {
        this.subscriptions.add(onStoreChange);
        return () => {
            this.subscriptions.delete(onStoreChange);
        };
    }
    static compareOptions(a, b) {
        return Object.keys(a).every(key => {
            if (['onCreate', 'onBeforeCreate', 'onDestroy', 'onUpdate', 'onTransaction', 'onFocus', 'onBlur', 'onSelectionUpdate', 'onContentError', 'onDrop', 'onPaste'].includes(key)) {
                // we don't want to compare callbacks, they are always different and only registered once
                return true;
            }
            // We often encourage putting extensions inlined in the options object, so we will do a slightly deeper comparison here
            if (key === 'extensions' && a.extensions && b.extensions) {
                if (a.extensions.length !== b.extensions.length) {
                    return false;
                }
                return a.extensions.every((extension, index) => {
                    var _a;
                    if (extension !== ((_a = b.extensions) === null || _a === void 0 ? void 0 : _a[index])) {
                        return false;
                    }
                    return true;
                });
            }
            if (a[key] !== b[key]) {
                // if any of the options have changed, we should update the editor options
                return false;
            }
            return true;
        });
    }
    /**
     * On each render, we will create, update, or destroy the editor instance.
     * @param deps The dependencies to watch for changes
     * @returns A cleanup function
     */
    onRender(deps) {
        // The returned callback will run on each render
        return () => {
            this.isComponentMounted = true;
            // Cleanup any scheduled destructions, since we are currently rendering
            clearTimeout(this.scheduledDestructionTimeout);
            if (this.editor && !this.editor.isDestroyed && deps.length === 0) {
                // if the editor does exist & deps are empty, we don't need to re-initialize the editor generally
                if (!EditorInstanceManager.compareOptions(this.options.current, this.editor.options)) {
                    // But, the options are different, so we need to update the editor options
                    // Still, this is faster than re-creating the editor
                    this.editor.setOptions({
                        ...this.options.current,
                        editable: this.editor.isEditable,
                    });
                }
            }
            else {
                // When the editor:
                // - does not yet exist
                // - is destroyed
                // - the deps array changes
                // We need to destroy the editor instance and re-initialize it
                this.refreshEditorInstance(deps);
            }
            return () => {
                this.isComponentMounted = false;
                this.scheduleDestroy();
            };
        };
    }
    /**
     * Recreate the editor instance if the dependencies have changed.
     */
    refreshEditorInstance(deps) {
        if (this.editor && !this.editor.isDestroyed) {
            // Editor instance already exists
            if (this.previousDeps === null) {
                // If lastDeps has not yet been initialized, reuse the current editor instance
                this.previousDeps = deps;
                return;
            }
            const depsAreEqual = this.previousDeps.length === deps.length
                && this.previousDeps.every((dep, index) => dep === deps[index]);
            if (depsAreEqual) {
                // deps exist and are equal, no need to recreate
                return;
            }
        }
        if (this.editor && !this.editor.isDestroyed) {
            // Destroy the editor instance if it exists
            this.editor.destroy();
        }
        this.setEditor(this.createEditor());
        // Update the lastDeps to the current deps
        this.previousDeps = deps;
    }
    /**
     * Schedule the destruction of the editor instance.
     * This will only destroy the editor if it was not mounted on the next tick.
     * This is to avoid destroying the editor instance when it's actually still mounted.
     */
    scheduleDestroy() {
        const currentInstanceId = this.instanceId;
        const currentEditor = this.editor;
        // Wait two ticks to see if the component is still mounted
        this.scheduledDestructionTimeout = setTimeout(() => {
            if (this.isComponentMounted && this.instanceId === currentInstanceId) {
                // If still mounted on the following tick, with the same instanceId, do not destroy the editor
                if (currentEditor) {
                    // just re-apply options as they might have changed
                    currentEditor.setOptions(this.options.current);
                }
                return;
            }
            if (currentEditor && !currentEditor.isDestroyed) {
                currentEditor.destroy();
                if (this.instanceId === currentInstanceId) {
                    this.setEditor(null);
                }
            }
            // This allows the effect to run again between ticks
            // which may save us from having to re-create the editor
        }, 1);
    }
}
function useEditor(options = {}, deps = []) {
    const mostRecentOptions = useRef(options);
    mostRecentOptions.current = options;
    const [instanceManager] = useState(() => new EditorInstanceManager(mostRecentOptions));
    const editor = shimExports.useSyncExternalStore(instanceManager.subscribe, instanceManager.getEditor, instanceManager.getServerSnapshot);
    useDebugValue(editor);
    // This effect will handle creating/updating the editor instance
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(instanceManager.onRender(deps));
    // The default behavior is to re-render on each transaction
    // This is legacy behavior that will be removed in future versions
    useEditorState({
        editor,
        selector: ({ transactionNumber }) => {
            if (options.shouldRerenderOnTransaction === false) {
                // This will prevent the editor from re-rendering on each transaction
                return null;
            }
            // This will avoid re-rendering on the first transaction when `immediatelyRender` is set to `true`
            if (options.immediatelyRender && transactionNumber === 0) {
                return 0;
            }
            return transactionNumber + 1;
        },
    });
    return editor;
}

const EditorContext = createContext$1({
    editor: null,
});
const EditorConsumer = EditorContext.Consumer;
/**
 * A hook to get the current editor instance.
 */
const useCurrentEditor = () => useContext(EditorContext);
/**
 * This is the provider component for the editor.
 * It allows the editor to be accessible across the entire component tree
 * with `useCurrentEditor`.
 */
function EditorProvider({ children, slotAfter, slotBefore, editorContainerProps = {}, ...editorOptions }) {
    const editor = useEditor(editorOptions);
    if (!editor) {
        return null;
    }
    return (React.createElement(EditorContext.Provider, { value: { editor } },
        slotBefore,
        React.createElement(EditorConsumer, null, ({ editor: currentEditor }) => (React.createElement(EditorContent, { editor: currentEditor, ...editorContainerProps }))),
        children,
        slotAfter));
}

const ReactNodeViewContext = createContext$1({
    onDragStart: undefined,
});
const useReactNodeView = () => useContext(ReactNodeViewContext);

React.forwardRef((props, ref) => {
    const { onDragStart } = useReactNodeView();
    const Tag = props.as || 'div';
    return (
    // @ts-ignore
    React.createElement(Tag, { ...props, ref: ref, "data-node-view-wrapper": "", onDragStart: onDragStart, style: {
            whiteSpace: 'normal',
            ...props.style,
        } }));
});

/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */
const Document$1 = Node.create({
    name: 'doc',
    topNode: true,
    content: 'block+',
});

/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */
const Paragraph = Node.create({
    name: 'paragraph',
    priority: 1000,
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML() {
        return [
            { tag: 'p' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setParagraph: () => ({ commands }) => {
                return commands.setNode(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Alt-0': () => this.editor.commands.setParagraph(),
        };
    },
});

/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */
const Text$1 = Node.create({
    name: 'text',
    group: 'inline',
});

/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */
const Heading = Node.create({
    name: 'heading',
    addOptions() {
        return {
            levels: [1, 2, 3, 4, 5, 6],
            HTMLAttributes: {},
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes() {
        return {
            level: {
                default: 1,
                rendered: false,
            },
        };
    },
    parseHTML() {
        return this.options.levels
            .map((level) => ({
            tag: `h${level}`,
            attrs: { level },
        }));
    },
    renderHTML({ node, HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel
            ? node.attrs.level
            : this.options.levels[0];
        return [`h${level}`, mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.setNode(this.name, attributes);
            },
            toggleHeading: attributes => ({ commands }) => {
                if (!this.options.levels.includes(attributes.level)) {
                    return false;
                }
                return commands.toggleNode(this.name, 'paragraph', attributes);
            },
        };
    },
    addKeyboardShortcuts() {
        return this.options.levels.reduce((items, level) => ({
            ...items,
            ...{
                [`Mod-Alt-${level}`]: () => this.editor.commands.toggleHeading({ level }),
            },
        }), {});
    },
    addInputRules() {
        return this.options.levels.map(level => {
            return textblockTypeInputRule({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level,
                },
            });
        });
    },
});

const ListItemName = 'listItem';
const TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */
const inputRegex$1 = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */
const BulletList = Node.create({
    name: 'bulletList',
    addOptions() {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false,
        };
    },
    group: 'block list',
    content() {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML() {
        return [
            { tag: 'ul' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['ul', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            toggleBulletList: () => ({ commands, chain }) => {
                if (this.options.keepAttributes) {
                    return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(ListItemName, this.editor.getAttributes(TextStyleName)).run();
                }
                return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-8': () => this.editor.commands.toggleBulletList(),
        };
    },
    addInputRules() {
        let inputRule = wrappingInputRule({
            find: inputRegex$1,
            type: this.type,
        });
        if (this.options.keepMarks || this.options.keepAttributes) {
            inputRule = wrappingInputRule({
                find: inputRegex$1,
                type: this.type,
                keepMarks: this.options.keepMarks,
                keepAttributes: this.options.keepAttributes,
                getAttributes: () => { return this.editor.getAttributes(TextStyleName); },
                editor: this.editor,
            });
        }
        return [
            inputRule,
        ];
    },
});

/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */
const ListItem = Node.create({
    name: 'listItem',
    addOptions() {
        return {
            HTMLAttributes: {},
            bulletListTypeName: 'bulletList',
            orderedListTypeName: 'orderedList',
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML() {
        return [
            {
                tag: 'li',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addKeyboardShortcuts() {
        return {
            Enter: () => this.editor.commands.splitListItem(this.name),
            Tab: () => this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': () => this.editor.commands.liftListItem(this.name),
        };
    },
});

var GOOD_LEAF_SIZE = 200;

// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var RopeSequence = function RopeSequence () {};

RopeSequence.prototype.append = function append (other) {
  if (!other.length) { return this }
  other = RopeSequence.from(other);

  return (!this.length && other) ||
    (other.length < GOOD_LEAF_SIZE && this.leafAppend(other)) ||
    (this.length < GOOD_LEAF_SIZE && other.leafPrepend(this)) ||
    this.appendInner(other)
};

// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
RopeSequence.prototype.prepend = function prepend (other) {
  if (!other.length) { return this }
  return RopeSequence.from(other).append(this)
};

RopeSequence.prototype.appendInner = function appendInner (other) {
  return new Append(this, other)
};

// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
RopeSequence.prototype.slice = function slice (from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from >= to) { return RopeSequence.empty }
  return this.sliceInner(Math.max(0, from), Math.min(this.length, to))
};

// :: (number) → T
// Retrieve the element at the given position from this rope.
RopeSequence.prototype.get = function get (i) {
  if (i < 0 || i >= this.length) { return undefined }
  return this.getInner(i)
};

// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
RopeSequence.prototype.forEach = function forEach (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  if (from <= to)
    { this.forEachInner(f, from, to, 0); }
  else
    { this.forEachInvertedInner(f, from, to, 0); }
};

// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
RopeSequence.prototype.map = function map (f, from, to) {
    if ( from === void 0 ) from = 0;
    if ( to === void 0 ) to = this.length;

  var result = [];
  this.forEach(function (elt, i) { return result.push(f(elt, i)); }, from, to);
  return result
};

// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
RopeSequence.from = function from (values) {
  if (values instanceof RopeSequence) { return values }
  return values && values.length ? new Leaf(values) : RopeSequence.empty
};

var Leaf = /*@__PURE__*/(function (RopeSequence) {
  function Leaf(values) {
    RopeSequence.call(this);
    this.values = values;
  }

  if ( RopeSequence ) Leaf.__proto__ = RopeSequence;
  Leaf.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Leaf.prototype.constructor = Leaf;

  var prototypeAccessors = { length: { configurable: true },depth: { configurable: true } };

  Leaf.prototype.flatten = function flatten () {
    return this.values
  };

  Leaf.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    return new Leaf(this.values.slice(from, to))
  };

  Leaf.prototype.getInner = function getInner (i) {
    return this.values[i]
  };

  Leaf.prototype.forEachInner = function forEachInner (f, from, to, start) {
    for (var i = from; i < to; i++)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    for (var i = from - 1; i >= to; i--)
      { if (f(this.values[i], start + i) === false) { return false } }
  };

  Leaf.prototype.leafAppend = function leafAppend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(this.values.concat(other.flatten())) }
  };

  Leaf.prototype.leafPrepend = function leafPrepend (other) {
    if (this.length + other.length <= GOOD_LEAF_SIZE)
      { return new Leaf(other.flatten().concat(this.values)) }
  };

  prototypeAccessors.length.get = function () { return this.values.length };

  prototypeAccessors.depth.get = function () { return 0 };

  Object.defineProperties( Leaf.prototype, prototypeAccessors );

  return Leaf;
}(RopeSequence));

// :: RopeSequence
// The empty rope sequence.
RopeSequence.empty = new Leaf([]);

var Append = /*@__PURE__*/(function (RopeSequence) {
  function Append(left, right) {
    RopeSequence.call(this);
    this.left = left;
    this.right = right;
    this.length = left.length + right.length;
    this.depth = Math.max(left.depth, right.depth) + 1;
  }

  if ( RopeSequence ) Append.__proto__ = RopeSequence;
  Append.prototype = Object.create( RopeSequence && RopeSequence.prototype );
  Append.prototype.constructor = Append;

  Append.prototype.flatten = function flatten () {
    return this.left.flatten().concat(this.right.flatten())
  };

  Append.prototype.getInner = function getInner (i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length)
  };

  Append.prototype.forEachInner = function forEachInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from < leftLen &&
        this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false)
      { return false }
    if (to > leftLen &&
        this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false)
      { return false }
  };

  Append.prototype.forEachInvertedInner = function forEachInvertedInner (f, from, to, start) {
    var leftLen = this.left.length;
    if (from > leftLen &&
        this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false)
      { return false }
    if (to < leftLen &&
        this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false)
      { return false }
  };

  Append.prototype.sliceInner = function sliceInner (from, to) {
    if (from == 0 && to == this.length) { return this }
    var leftLen = this.left.length;
    if (to <= leftLen) { return this.left.slice(from, to) }
    if (from >= leftLen) { return this.right.slice(from - leftLen, to - leftLen) }
    return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen))
  };

  Append.prototype.leafAppend = function leafAppend (other) {
    var inner = this.right.leafAppend(other);
    if (inner) { return new Append(this.left, inner) }
  };

  Append.prototype.leafPrepend = function leafPrepend (other) {
    var inner = this.left.leafPrepend(other);
    if (inner) { return new Append(inner, this.right) }
  };

  Append.prototype.appendInner = function appendInner (other) {
    if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1)
      { return new Append(this.left, new Append(this.right, other)) }
    return new Append(this, other)
  };

  return Append;
}(RopeSequence));

// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const max_empty_items = 500;
class Branch {
    constructor(items, eventCount) {
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0)
            return null;
        let end = this.items.length;
        for (;; end--) {
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i) => {
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map)
                    remap.appendMap(map, mapFrom);
            }
            else {
                transform.maybeStep(item.step);
            }
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return { remaining: remaining, transform, selection: selection };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for (let i = 0; i < transform.steps.length; i++) {
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i)
                    newItems.pop();
                else
                    oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems)
                lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > DEPTH_OVERFLOW) {
            oldItems = cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new Mapping;
        this.items.forEach((item, i) => {
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from
                ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0)
            return this;
        return new Branch(this.items.append(array.map(map => new Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount)
            return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach(item => { if (item.selection)
            eventCount--; }, start);
        let iRebased = rebasedCount;
        this.items.forEach(item => {
            let pos = mapping.getMirror(--iRebased);
            if (pos == null)
                return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection)
                    eventCount++;
                rebasedItems.push(new Item(map, step, selection));
            }
            else {
                rebasedItems.push(new Item(map));
            }
        }, start);
        let newMaps = [];
        for (let i = rebasedCount; i < newUntil; i++)
            newMaps.push(new Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new Branch(items, eventCount);
        if (branch.emptyItemCount() > max_empty_items)
            branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach(item => { if (!item.step)
            count++; });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i) => {
            if (i >= upto) {
                items.push(item);
                if (item.selection)
                    events++;
            }
            else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map)
                    remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection)
                        events++;
                    let newItem = new Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem))
                        items[last] = merged;
                    else
                        items.push(newItem);
                }
            }
            else if (item.map) {
                mapFrom--;
            }
        }, this.items.length, 0);
        return new Branch(RopeSequence.from(items.reverse()), events);
    }
}
Branch.empty = new Branch(RopeSequence.empty, 0);
function cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i) => {
        if (item.selection && (n-- == 0)) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class Item {
    constructor(
    // The (forward) step map for this item.
    map, 
    // The inverted step
    step, 
    // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, 
    // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset) {
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step)
                return new Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition) {
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta(historyKey), rebased;
    if (historyTr)
        return historyTr.historyState;
    if (tr.getMeta(closeHistoryKey))
        history = new HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) {
        return history;
    }
    else if (appended && appended.getMeta(historyKey)) {
        if (appended.getMeta(historyKey).redo)
            return new HistoryState(history.done.addTransform(tr, undefined, options, mustPreserveItems(state)), history.undone, rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else
            return new HistoryState(history.done, history.undone.addTransform(tr, undefined, options, mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    }
    else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 ||
            (!appended && history.prevComposition != composition &&
                (history.prevTime < (tr.time || 0) - options.newGroupDelay || !isAdjacentTo(tr, history.prevRanges)));
        let prevRanges = appended ? mapRanges(history.prevRanges, tr.mapping) : rangesFor(tr.mapping.maps);
        return new HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, mustPreserveItems(state)), Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    }
    else if (rebased = tr.getMeta("rebased")) {
        // Used by the collab module to tell the history that some of its
        // content has been rebased.
        return new HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    }
    else {
        return new HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    }
}
function isAdjacentTo(transform, prevRanges) {
    if (!prevRanges)
        return false;
    if (!transform.docChanged)
        return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end) => {
        for (let i = 0; i < prevRanges.length; i += 2)
            if (start <= prevRanges[i + 1] && end >= prevRanges[i])
                adjacent = true;
    });
    return adjacent;
}
function rangesFor(maps) {
    let result = [];
    for (let i = maps.length - 1; i >= 0 && result.length == 0; i--)
        maps[i].forEach((_from, _to, from, to) => result.push(from, to));
    return result;
}
function mapRanges(ranges, mapping) {
    if (!ranges)
        return null;
    let result = [];
    for (let i = 0; i < ranges.length; i += 2) {
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to)
            result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function histTransaction(history, state, redo) {
    let preserveItems = mustPreserveItems(state);
    let histOptions = historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop)
        return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta(historyKey, { redo, historyState: newHist });
}
let cachedPreserveItems = false, cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function mustPreserveItems(state) {
    let plugins = state.plugins;
    if (cachedPreserveItemsPlugins != plugins) {
        cachedPreserveItems = false;
        cachedPreserveItemsPlugins = plugins;
        for (let i = 0; i < plugins.length; i++)
            if (plugins[i].spec.historyPreserveItems) {
                cachedPreserveItems = true;
                break;
            }
    }
    return cachedPreserveItems;
}
const historyKey = new PluginKey("history");
const closeHistoryKey = new PluginKey("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/
function history(config = {}) {
    config = { depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500 };
    return new Plugin({
        key: historyKey,
        state: {
            init() {
                return new HistoryState(Branch.empty, Branch.empty, null, 0, -1);
            },
            apply(tr, hist, state) {
                return applyTransaction(hist, state, tr, config);
            }
        },
        config,
        props: {
            handleDOMEvents: {
                beforeinput(view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? undo : inputType == "historyRedo" ? redo : null;
                    if (!command || !view.editable)
                        return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function buildCommand(redo, scroll) {
    return (state, dispatch) => {
        let hist = historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0)
            return false;
        if (dispatch) {
            let tr = histTransaction(hist, state, redo);
            if (tr)
                dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/
const undo = buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/
const redo = buildCommand(true, true);

/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */
const History = Extension.create({
    name: 'history',
    addOptions() {
        return {
            depth: 100,
            newGroupDelay: 500,
        };
    },
    addCommands() {
        return {
            undo: () => ({ state, dispatch }) => {
                return undo(state, dispatch);
            },
            redo: () => ({ state, dispatch }) => {
                return redo(state, dispatch);
            },
        };
    },
    addProseMirrorPlugins() {
        return [
            history(this.options),
        ];
    },
    addKeyboardShortcuts() {
        return {
            'Mod-z': () => this.editor.commands.undo(),
            'Shift-Mod-z': () => this.editor.commands.redo(),
            'Mod-y': () => this.editor.commands.redo(),
            // Russian keyboard layouts
            'Mod-я': () => this.editor.commands.undo(),
            'Shift-Mod-я': () => this.editor.commands.redo(),
        };
    },
});

/**
 * Matches bold text via `**` as input.
 */
const starInputRegex$1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */
const starPasteRegex$1 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */
const underscoreInputRegex$1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */
const underscorePasteRegex$1 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */
const Bold = Mark.create({
    name: 'bold',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'strong',
            },
            {
                tag: 'b',
                getAttrs: node => node.style.fontWeight !== 'normal' && null,
            },
            {
                style: 'font-weight=400',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-weight',
                getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['strong', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setBold: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleBold: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetBold: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-b': () => this.editor.commands.toggleBold(),
            'Mod-B': () => this.editor.commands.toggleBold(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegex$1,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegex$1,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegex$1,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegex$1,
                type: this.type,
            }),
        ];
    },
});

/**
 * Matches an italic to a *italic* on input.
 */
const starInputRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */
const starPasteRegex = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */
const underscoreInputRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */
const underscorePasteRegex = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */
const Italic = Mark.create({
    name: 'italic',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'em',
            },
            {
                tag: 'i',
                getAttrs: node => node.style.fontStyle !== 'normal' && null,
            },
            {
                style: 'font-style=normal',
                clearMark: mark => mark.type.name === this.name,
            },
            {
                style: 'font-style=italic',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setItalic: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleItalic: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetItalic: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-i': () => this.editor.commands.toggleItalic(),
            'Mod-I': () => this.editor.commands.toggleItalic(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: starInputRegex,
                type: this.type,
            }),
            markInputRule({
                find: underscoreInputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: starPasteRegex,
                type: this.type,
            }),
            markPasteRule({
                find: underscorePasteRegex,
                type: this.type,
            }),
        ];
    },
});

/**
 * This extension allows you to create underline text.
 * @see https://www.tiptap.dev/api/marks/underline
 */
const Underline = Mark.create({
    name: 'underline',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 'u',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('underline') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['u', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setUnderline: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleUnderline: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetUnderline: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-u': () => this.editor.commands.toggleUnderline(),
            'Mod-U': () => this.editor.commands.toggleUnderline(),
        };
    },
});

/**
 * Matches a strike to a ~~strike~~ on input.
 */
const inputRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */
const pasteRegex = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */
const Strike = Mark.create({
    name: 'strike',
    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },
    parseHTML() {
        return [
            {
                tag: 's',
            },
            {
                tag: 'del',
            },
            {
                tag: 'strike',
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: style => (style.includes('line-through') ? {} : false),
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['s', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setStrike: () => ({ commands }) => {
                return commands.setMark(this.name);
            },
            toggleStrike: () => ({ commands }) => {
                return commands.toggleMark(this.name);
            },
            unsetStrike: () => ({ commands }) => {
                return commands.unsetMark(this.name);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Shift-s': () => this.editor.commands.toggleStrike(),
        };
    },
    addInputRules() {
        return [
            markInputRule({
                find: inputRegex,
                type: this.type,
            }),
        ];
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: pasteRegex,
                type: this.type,
            }),
        ];
    },
});

/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */
const HardBreak = Node.create({
    name: 'hardBreak',
    addOptions() {
        return {
            keepMarks: true,
            HTMLAttributes: {},
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    linebreakReplacement: true,
    parseHTML() {
        return [
            { tag: 'br' },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['br', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
    renderText() {
        return '\n';
    },
    addCommands() {
        return {
            setHardBreak: () => ({ commands, chain, state, editor, }) => {
                return commands.first([
                    () => commands.exitCode(),
                    () => commands.command(() => {
                        const { selection, storedMarks } = state;
                        if (selection.$from.parent.type.spec.isolating) {
                            return false;
                        }
                        const { keepMarks } = this.options;
                        const { splittableMarks } = editor.extensionManager;
                        const marks = storedMarks
                            || (selection.$to.parentOffset && selection.$from.marks());
                        return chain()
                            .insertContent({ type: this.name })
                            .command(({ tr, dispatch }) => {
                            if (dispatch && marks && keepMarks) {
                                const filteredMarks = marks
                                    .filter(mark => splittableMarks.includes(mark.type.name));
                                tr.ensureMarks(filteredMarks);
                            }
                            return true;
                        })
                            .run();
                    }),
                ]);
            },
        };
    },
    addKeyboardShortcuts() {
        return {
            'Mod-Enter': () => this.editor.commands.setHardBreak(),
            'Shift-Enter': () => this.editor.commands.setHardBreak(),
        };
    },
});

var css_248z$S = ".BaseEditor-module__baseEditorWrapper___DnfOQ{display:flex;flex-direction:column;margin-bottom:1rem;width:100%}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__label___yB5VB{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.2rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__label___yB5VB .BaseEditor-module__required___g-AIi{color:var(--danger);margin-left:.15rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB{border:2px solid var(--bg-light-80);border-radius:var(--border-radius-small);transition:all .2s ease}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB>:first-child{background-color:var(--bg-light-80);border-bottom:2px solid var(--bg-light-80)}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB:focus-within{background-color:var(--bg-light-48)}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB.BaseEditor-module__error___RlqDR{border-color:var(--danger)}@media (max-width:768px){.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB{overflow:hidden}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB>:first-child{-webkit-overflow-scrolling:touch;max-width:100%;overflow-x:auto;overflow-y:hidden;position:relative;width:100%}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB>:first-child::-webkit-scrollbar{height:4px}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB>:first-child::-webkit-scrollbar-track{background:var(--bg-light-80)}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB>:first-child::-webkit-scrollbar-thumb{background:var(--grey-64);border-radius:2px}}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__errorMessage___3Zz2m{color:var(--danger);font-size:.75rem;margin-top:.2rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB p{padding:0}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB .tiptap.ProseMirror{height:100px;max-height:200px;outline:none;overflow-y:auto;padding:.6rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB ol,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB ul{margin:1rem 1rem 1rem .4rem;padding:0 1rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB ol li p,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB ul li p{margin-bottom:.25em;margin-top:.25em}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h1,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h2,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h3,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h4,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h5,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h6{text-wrap:pretty;line-height:1.1;margin-top:2.5rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h1,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h2{margin-bottom:1.5rem;margin-top:3.5rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h1{font-size:1.4rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h2{font-size:1.2rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h3{font-size:1.1rem}.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h4,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h5,.BaseEditor-module__baseEditorWrapper___DnfOQ .BaseEditor-module__baseEditor___3OaoB h6{font-size:1rem}";
var css$R = {"baseEditorWrapper":"BaseEditor-module__baseEditorWrapper___DnfOQ","label":"BaseEditor-module__label___yB5VB","required":"BaseEditor-module__required___g-AIi","baseEditor":"BaseEditor-module__baseEditor___3OaoB","error":"BaseEditor-module__error___RlqDR","errorMessage":"BaseEditor-module__errorMessage___3Zz2m"};
styleInject(css_248z$S);

// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const encodedTlds = 'aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2odyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rck0msd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2oodside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2';
// Internationalized domain names containing non-ASCII
const encodedUtlds = 'ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2';

/**
 * Finite State Machine generation utilities
 */

/**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */

/**
 * @typedef {{ [group: string]: true }} Flags
 */

// Keys in scanner Collections instances
const numeric = 'numeric';
const ascii = 'ascii';
const alpha$1 = 'alpha';
const asciinumeric = 'asciinumeric';
const alphanumeric = 'alphanumeric';
const domain = 'domain';
const emoji = 'emoji';
const scheme = 'scheme';
const slashscheme = 'slashscheme';
const whitespace = 'whitespace';

/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */
function registerGroup(name, groups) {
  if (!(name in groups)) {
    groups[name] = [];
  }
  return groups[name];
}

/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */
function addToGroups(t, flags, groups) {
  if (flags[numeric]) {
    flags[asciinumeric] = true;
    flags[alphanumeric] = true;
  }
  if (flags[ascii]) {
    flags[asciinumeric] = true;
    flags[alpha$1] = true;
  }
  if (flags[asciinumeric]) {
    flags[alphanumeric] = true;
  }
  if (flags[alpha$1]) {
    flags[alphanumeric] = true;
  }
  if (flags[alphanumeric]) {
    flags[domain] = true;
  }
  if (flags[emoji]) {
    flags[domain] = true;
  }
  for (const k in flags) {
    const group = registerGroup(k, groups);
    if (group.indexOf(t) < 0) {
      group.push(t);
    }
  }
}

/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */
function flagsForToken(t, groups) {
  const result = {};
  for (const c in groups) {
    if (groups[c].indexOf(t) >= 0) {
      result[c] = true;
    }
  }
  return result;
}

/**
 * @template T
 * @typedef {null | T } Transition
 */

/**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */
function State(token = null) {
  // this.n = null; // DEBUG: State name
  /** @type {{ [input: string]: State<T> }} j */
  this.j = {}; // IMPLEMENTATION 1
  // this.j = []; // IMPLEMENTATION 2
  /** @type {[RegExp, State<T>][]} jr */
  this.jr = [];
  /** @type {?State<T>} jd */
  this.jd = null;
  /** @type {?T} t */
  this.t = token;
}

/**
 * Scanner token groups
 * @type Collections<string>
 */
State.groups = {};
State.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(input) {
    const state = this;
    const nextState = state.j[input];
    if (nextState) {
      return nextState;
    }
    for (let i = 0; i < state.jr.length; i++) {
      const regex = state.jr[i][0];
      const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
      if (nextState && regex.test(input)) {
        return nextState;
      }
    }
    // Nowhere left to jump! Return default, if any
    return state.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(input, exactOnly = false) {
    return exactOnly ? input in this.j : !!this.go(input);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(inputs, next, flags, groups) {
    for (let i = 0; i < inputs.length; i++) {
      this.tt(inputs[i], next, flags, groups);
    }
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(regexp, next, flags, groups) {
    groups = groups || State.groups;
    let nextState;
    if (next && next.j) {
      nextState = next;
    } else {
      // Token with maybe token groups
      nextState = new State(next);
      if (flags && groups) {
        addToGroups(next, flags, groups);
      }
    }
    this.jr.push([regexp, nextState]);
    return nextState;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(input, next, flags, groups) {
    let state = this;
    const len = input.length;
    if (!len) {
      return state;
    }
    for (let i = 0; i < len - 1; i++) {
      state = state.tt(input[i]);
    }
    return state.tt(input[len - 1], next, flags, groups);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(input, next, flags, groups) {
    groups = groups || State.groups;
    const state = this;

    // Check if existing state given, just a basic transition
    if (next && next.j) {
      state.j[input] = next;
      return next;
    }
    const t = next;

    // Take the transition with the usual default mechanisms and use that as
    // a template for creating the next state
    let nextState,
      templateState = state.go(input);
    if (templateState) {
      nextState = new State();
      Object.assign(nextState.j, templateState.j);
      nextState.jr.push.apply(nextState.jr, templateState.jr);
      nextState.jd = templateState.jd;
      nextState.t = templateState.t;
    } else {
      nextState = new State();
    }
    if (t) {
      // Ensure newly token is in the same groups as the old token
      if (groups) {
        if (nextState.t && typeof nextState.t === 'string') {
          const allFlags = Object.assign(flagsForToken(nextState.t, groups), flags);
          addToGroups(t, allFlags, groups);
        } else if (flags) {
          addToGroups(t, flags, groups);
        }
      }
      nextState.t = t; // overwrite anything that was previously there
    }
    state.j[input] = nextState;
    return nextState;
  }
};

// Helper functions to improve minification (not exported outside linkifyjs module)

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ta = (state, input, next, flags, groups) => state.ta(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const tr = (state, regexp, next, flags, groups) => state.tr(regexp, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */
const ts = (state, input, next, flags, groups) => state.ts(input, next, flags, groups);

/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */
const tt = (state, input, next, flags, groups) => state.tt(input, next, flags, groups);

/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/

// A valid web domain token
const WORD = 'WORD'; // only contains a-z
const UWORD = 'UWORD'; // contains letters other than a-z, used for IDN
const ASCIINUMERICAL = 'ASCIINUMERICAL'; // contains a-z, 0-9
const ALPHANUMERICAL = 'ALPHANUMERICAL'; // contains numbers and letters other than a-z, used for IDN

// Special case of word
const LOCALHOST = 'LOCALHOST';

// Valid top-level domain, special case of WORD (see tlds.js)
const TLD = 'TLD';

// Valid IDN TLD, special case of UWORD (see tlds.js)
const UTLD = 'UTLD';

// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const SCHEME = 'SCHEME';

// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const SLASH_SCHEME = 'SLASH_SCHEME';

// Any sequence of digits 0-9
const NUM = 'NUM';

// Any number of consecutive whitespace characters that are not newline
const WS = 'WS';

// New line (unix style)
const NL = 'NL'; // \n

// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const OPENBRACE = 'OPENBRACE'; // {
const CLOSEBRACE = 'CLOSEBRACE'; // }
const OPENBRACKET = 'OPENBRACKET'; // [
const CLOSEBRACKET = 'CLOSEBRACKET'; // ]
const OPENPAREN = 'OPENPAREN'; // (
const CLOSEPAREN = 'CLOSEPAREN'; // )
const OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <
const CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >
const FULLWIDTHLEFTPAREN = 'FULLWIDTHLEFTPAREN'; // （
const FULLWIDTHRIGHTPAREN = 'FULLWIDTHRIGHTPAREN'; // ）
const LEFTCORNERBRACKET = 'LEFTCORNERBRACKET'; // 「
const RIGHTCORNERBRACKET = 'RIGHTCORNERBRACKET'; // 」
const LEFTWHITECORNERBRACKET = 'LEFTWHITECORNERBRACKET'; // 『
const RIGHTWHITECORNERBRACKET = 'RIGHTWHITECORNERBRACKET'; // 』
const FULLWIDTHLESSTHAN = 'FULLWIDTHLESSTHAN'; // ＜
const FULLWIDTHGREATERTHAN = 'FULLWIDTHGREATERTHAN'; // ＞

// Various symbols
const AMPERSAND = 'AMPERSAND'; // &
const APOSTROPHE = 'APOSTROPHE'; // '
const ASTERISK = 'ASTERISK'; // *
const AT = 'AT'; // @
const BACKSLASH = 'BACKSLASH'; // \
const BACKTICK = 'BACKTICK'; // `
const CARET = 'CARET'; // ^
const COLON = 'COLON'; // :
const COMMA = 'COMMA'; // ,
const DOLLAR = 'DOLLAR'; // $
const DOT = 'DOT'; // .
const EQUALS = 'EQUALS'; // =
const EXCLAMATION = 'EXCLAMATION'; // !
const HYPHEN = 'HYPHEN'; // -
const PERCENT = 'PERCENT'; // %
const PIPE = 'PIPE'; // |
const PLUS = 'PLUS'; // +
const POUND = 'POUND'; // #
const QUERY = 'QUERY'; // ?
const QUOTE = 'QUOTE'; // "
const FULLWIDTHMIDDLEDOT = 'FULLWIDTHMIDDLEDOT'; // ・

const SEMI = 'SEMI'; // ;
const SLASH = 'SLASH'; // /
const TILDE = 'TILDE'; // ~
const UNDERSCORE = 'UNDERSCORE'; // _

// Emoji symbol
const EMOJI$1 = 'EMOJI';

// Default token - anything that is not one of the above
const SYM = 'SYM';

var tk = /*#__PURE__*/Object.freeze({
	__proto__: null,
	ALPHANUMERICAL: ALPHANUMERICAL,
	AMPERSAND: AMPERSAND,
	APOSTROPHE: APOSTROPHE,
	ASCIINUMERICAL: ASCIINUMERICAL,
	ASTERISK: ASTERISK,
	AT: AT,
	BACKSLASH: BACKSLASH,
	BACKTICK: BACKTICK,
	CARET: CARET,
	CLOSEANGLEBRACKET: CLOSEANGLEBRACKET,
	CLOSEBRACE: CLOSEBRACE,
	CLOSEBRACKET: CLOSEBRACKET,
	CLOSEPAREN: CLOSEPAREN,
	COLON: COLON,
	COMMA: COMMA,
	DOLLAR: DOLLAR,
	DOT: DOT,
	EMOJI: EMOJI$1,
	EQUALS: EQUALS,
	EXCLAMATION: EXCLAMATION,
	FULLWIDTHGREATERTHAN: FULLWIDTHGREATERTHAN,
	FULLWIDTHLEFTPAREN: FULLWIDTHLEFTPAREN,
	FULLWIDTHLESSTHAN: FULLWIDTHLESSTHAN,
	FULLWIDTHMIDDLEDOT: FULLWIDTHMIDDLEDOT,
	FULLWIDTHRIGHTPAREN: FULLWIDTHRIGHTPAREN,
	HYPHEN: HYPHEN,
	LEFTCORNERBRACKET: LEFTCORNERBRACKET,
	LEFTWHITECORNERBRACKET: LEFTWHITECORNERBRACKET,
	LOCALHOST: LOCALHOST,
	NL: NL,
	NUM: NUM,
	OPENANGLEBRACKET: OPENANGLEBRACKET,
	OPENBRACE: OPENBRACE,
	OPENBRACKET: OPENBRACKET,
	OPENPAREN: OPENPAREN,
	PERCENT: PERCENT,
	PIPE: PIPE,
	PLUS: PLUS,
	POUND: POUND,
	QUERY: QUERY,
	QUOTE: QUOTE,
	RIGHTCORNERBRACKET: RIGHTCORNERBRACKET,
	RIGHTWHITECORNERBRACKET: RIGHTWHITECORNERBRACKET,
	SCHEME: SCHEME,
	SEMI: SEMI,
	SLASH: SLASH,
	SLASH_SCHEME: SLASH_SCHEME,
	SYM: SYM,
	TILDE: TILDE,
	TLD: TLD,
	UNDERSCORE: UNDERSCORE,
	UTLD: UTLD,
	UWORD: UWORD,
	WORD: WORD,
	WS: WS
});

// Note that these two Unicode ones expand into a really big one with Babel
const ASCII_LETTER = /[a-z]/;
const LETTER = /\p{L}/u; // Any Unicode character with letter data type
const EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const DIGIT = /\d/;
const SPACE = /\s/;

/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/

const CR = '\r'; // carriage-return character
const LF = '\n'; // line-feed character
const EMOJI_VARIATION = '\ufe0f'; // Variation selector, follows heart and others
const EMOJI_JOINER = '\u200d'; // zero-width joiner
const OBJECT_REPLACEMENT = '\ufffc'; // whitespace placeholder that sometimes appears in rich text editors

let tlds = null,
  utlds = null; // don't change so only have to be computed once

/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */

/**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */

/**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */
function init$2(customSchemes = []) {
  // Frequently used states (name argument removed during minification)
  /** @type Collections<string> */
  const groups = {}; // of tokens
  State.groups = groups;
  /** @type State<string> */
  const Start = new State();
  if (tlds == null) {
    tlds = decodeTlds(encodedTlds);
  }
  if (utlds == null) {
    utlds = decodeTlds(encodedUtlds);
  }

  // States for special URL symbols that accept immediately after start
  tt(Start, "'", APOSTROPHE);
  tt(Start, '{', OPENBRACE);
  tt(Start, '}', CLOSEBRACE);
  tt(Start, '[', OPENBRACKET);
  tt(Start, ']', CLOSEBRACKET);
  tt(Start, '(', OPENPAREN);
  tt(Start, ')', CLOSEPAREN);
  tt(Start, '<', OPENANGLEBRACKET);
  tt(Start, '>', CLOSEANGLEBRACKET);
  tt(Start, '（', FULLWIDTHLEFTPAREN);
  tt(Start, '）', FULLWIDTHRIGHTPAREN);
  tt(Start, '「', LEFTCORNERBRACKET);
  tt(Start, '」', RIGHTCORNERBRACKET);
  tt(Start, '『', LEFTWHITECORNERBRACKET);
  tt(Start, '』', RIGHTWHITECORNERBRACKET);
  tt(Start, '＜', FULLWIDTHLESSTHAN);
  tt(Start, '＞', FULLWIDTHGREATERTHAN);
  tt(Start, '&', AMPERSAND);
  tt(Start, '*', ASTERISK);
  tt(Start, '@', AT);
  tt(Start, '`', BACKTICK);
  tt(Start, '^', CARET);
  tt(Start, ':', COLON);
  tt(Start, ',', COMMA);
  tt(Start, '$', DOLLAR);
  tt(Start, '.', DOT);
  tt(Start, '=', EQUALS);
  tt(Start, '!', EXCLAMATION);
  tt(Start, '-', HYPHEN);
  tt(Start, '%', PERCENT);
  tt(Start, '|', PIPE);
  tt(Start, '+', PLUS);
  tt(Start, '#', POUND);
  tt(Start, '?', QUERY);
  tt(Start, '"', QUOTE);
  tt(Start, '/', SLASH);
  tt(Start, ';', SEMI);
  tt(Start, '~', TILDE);
  tt(Start, '_', UNDERSCORE);
  tt(Start, '\\', BACKSLASH);
  tt(Start, '・', FULLWIDTHMIDDLEDOT);
  const Num = tr(Start, DIGIT, NUM, {
    [numeric]: true
  });
  tr(Num, DIGIT, Num);
  const Asciinumeric = tr(Num, ASCII_LETTER, ASCIINUMERICAL, {
    [asciinumeric]: true
  });
  const Alphanumeric = tr(Num, LETTER, ALPHANUMERICAL, {
    [alphanumeric]: true
  });

  // State which emits a word token
  const Word = tr(Start, ASCII_LETTER, WORD, {
    [ascii]: true
  });
  tr(Word, DIGIT, Asciinumeric);
  tr(Word, ASCII_LETTER, Word);
  tr(Asciinumeric, DIGIT, Asciinumeric);
  tr(Asciinumeric, ASCII_LETTER, Asciinumeric);

  // Same as previous, but specific to non-fsm.ascii alphabet words
  const UWord = tr(Start, LETTER, UWORD, {
    [alpha$1]: true
  });
  tr(UWord, ASCII_LETTER); // Non-accepting
  tr(UWord, DIGIT, Alphanumeric);
  tr(UWord, LETTER, UWord);
  tr(Alphanumeric, DIGIT, Alphanumeric);
  tr(Alphanumeric, ASCII_LETTER); // Non-accepting
  tr(Alphanumeric, LETTER, Alphanumeric); // Non-accepting

  // Whitespace jumps
  // Tokens of only non-newline whitespace are arbitrarily long
  // If any whitespace except newline, more whitespace!
  const Nl = tt(Start, LF, NL, {
    [whitespace]: true
  });
  const Cr = tt(Start, CR, WS, {
    [whitespace]: true
  });
  const Ws = tr(Start, SPACE, WS, {
    [whitespace]: true
  });
  tt(Start, OBJECT_REPLACEMENT, Ws);
  tt(Cr, LF, Nl); // \r\n
  tt(Cr, OBJECT_REPLACEMENT, Ws);
  tr(Cr, SPACE, Ws);
  tt(Ws, CR); // non-accepting state to avoid mixing whitespaces
  tt(Ws, LF); // non-accepting state to avoid mixing whitespaces
  tr(Ws, SPACE, Ws);
  tt(Ws, OBJECT_REPLACEMENT, Ws);

  // Emoji tokens. They are not grouped by the scanner except in cases where a
  // zero-width joiner is present
  const Emoji = tr(Start, EMOJI, EMOJI$1, {
    [emoji]: true
  });
  tt(Emoji, '#'); // no transition, emoji regex seems to match #
  tr(Emoji, EMOJI, Emoji);
  tt(Emoji, EMOJI_VARIATION, Emoji);
  // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy

  const EmojiJoiner = tt(Emoji, EMOJI_JOINER);
  tt(EmojiJoiner, '#');
  tr(EmojiJoiner, EMOJI, Emoji);
  // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy

  // Generates states for top-level domains
  // Note that this is most accurate when tlds are in alphabetical order
  const wordjr = [[ASCII_LETTER, Word], [DIGIT, Asciinumeric]];
  const uwordjr = [[ASCII_LETTER, null], [LETTER, UWord], [DIGIT, Alphanumeric]];
  for (let i = 0; i < tlds.length; i++) {
    fastts(Start, tlds[i], TLD, WORD, wordjr);
  }
  for (let i = 0; i < utlds.length; i++) {
    fastts(Start, utlds[i], UTLD, UWORD, uwordjr);
  }
  addToGroups(TLD, {
    tld: true,
    ascii: true
  }, groups);
  addToGroups(UTLD, {
    utld: true,
    alpha: true
  }, groups);

  // Collect the states generated by different protocols. NOTE: If any new TLDs
  // get added that are also protocols, set the token to be the same as the
  // protocol to ensure parsing works as expected.
  fastts(Start, 'file', SCHEME, WORD, wordjr);
  fastts(Start, 'mailto', SCHEME, WORD, wordjr);
  fastts(Start, 'http', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'https', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftp', SLASH_SCHEME, WORD, wordjr);
  fastts(Start, 'ftps', SLASH_SCHEME, WORD, wordjr);
  addToGroups(SCHEME, {
    scheme: true,
    ascii: true
  }, groups);
  addToGroups(SLASH_SCHEME, {
    slashscheme: true,
    ascii: true
  }, groups);

  // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
  customSchemes = customSchemes.sort((a, b) => a[0] > b[0] ? 1 : -1);
  for (let i = 0; i < customSchemes.length; i++) {
    const sch = customSchemes[i][0];
    const optionalSlashSlash = customSchemes[i][1];
    const flags = optionalSlashSlash ? {
      [scheme]: true
    } : {
      [slashscheme]: true
    };
    if (sch.indexOf('-') >= 0) {
      flags[domain] = true;
    } else if (!ASCII_LETTER.test(sch)) {
      flags[numeric] = true; // numbers only
    } else if (DIGIT.test(sch)) {
      flags[asciinumeric] = true;
    } else {
      flags[ascii] = true;
    }
    ts(Start, sch, sch, flags);
  }

  // Localhost token
  ts(Start, 'localhost', LOCALHOST, {
    ascii: true
  });

  // Set default transition for start state (some symbol)
  Start.jd = new State(SYM);
  return {
    start: Start,
    tokens: Object.assign({
      groups
    }, tk)
  };
}

/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/
function run$1(start, str) {
  // State machine is not case sensitive, so input is tokenized in lowercased
  // form (still returns regular case). Uses selective `toLowerCase` because
  // lowercasing the entire string causes the length and character position to
  // vary in some non-English strings with V8-based runtimes.
  const iterable = stringToArray(str.replace(/[A-Z]/g, c => c.toLowerCase()));
  const charCount = iterable.length; // <= len if there are emojis, etc
  const tokens = []; // return value

  // cursor through the string itself, accounting for characters that have
  // width with length 2 such as emojis
  let cursor = 0;

  // Cursor through the array-representation of the string
  let charCursor = 0;

  // Tokenize the string
  while (charCursor < charCount) {
    let state = start;
    let nextState = null;
    let tokenLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    let charsSinceAccepts = -1;
    while (charCursor < charCount && (nextState = state.go(iterable[charCursor]))) {
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        charsSinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts += iterable[charCursor].length;
        charsSinceAccepts++;
      }
      tokenLength += iterable[charCursor].length;
      cursor += iterable[charCursor].length;
      charCursor++;
    }

    // Roll back to the latest accepting state
    cursor -= sinceAccepts;
    charCursor -= charsSinceAccepts;
    tokenLength -= sinceAccepts;

    // No more jumps, just make a new token from the last accepting one
    tokens.push({
      t: latestAccepting.t,
      // token type/name
      v: str.slice(cursor - tokenLength, cursor),
      // string value
      s: cursor - tokenLength,
      // start index
      e: cursor // end index (excluding)
    });
  }
  return tokens;
}

/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */
function stringToArray(str) {
  const result = [];
  const len = str.length;
  let index = 0;
  while (index < len) {
    let first = str.charCodeAt(index);
    let second;
    let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
    : str.slice(index, index + 2); // two-index characters
    result.push(char);
    index += char.length;
  }
  return result;
}

/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */
function fastts(state, input, t, defaultt, jr) {
  let next;
  const len = input.length;
  for (let i = 0; i < len - 1; i++) {
    const char = input[i];
    if (state.j[char]) {
      next = state.j[char];
    } else {
      next = new State(defaultt);
      next.jr = jr.slice();
      state.j[char] = next;
    }
    state = next;
  }
  next = new State(t);
  next.jr = jr.slice();
  state.j[input[len - 1]] = next;
  return next;
}

/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */
function decodeTlds(encoded) {
  const words = [];
  const stack = [];
  let i = 0;
  let digits = '0123456789';
  while (i < encoded.length) {
    let popDigitCount = 0;
    while (digits.indexOf(encoded[i + popDigitCount]) >= 0) {
      popDigitCount++; // encountered some digits, have to pop to go one level up trie
    }
    if (popDigitCount > 0) {
      words.push(stack.join('')); // whatever preceded the pop digits must be a word
      for (let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--) {
        stack.pop();
      }
      i += popDigitCount;
    } else {
      stack.push(encoded[i]); // drop down a level into the trie
      i++;
    }
  }
  return words;
}

/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */

/**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */

/**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */

/**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */

/**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */

/**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */

/**
 * @type Required<Opts>
 */
const defaults$1 = {
  defaultProtocol: 'http',
  events: null,
  format: noop$2,
  formatHref: noop$2,
  nl2br: false,
  tagName: 'a',
  target: null,
  rel: null,
  validate: true,
  truncate: Infinity,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};

/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */
function Options(opts, defaultRender = null) {
  let o = Object.assign({}, defaults$1);
  if (opts) {
    o = Object.assign(o, opts instanceof Options ? opts.o : opts);
  }

  // Ensure all ignored tags are uppercase
  const ignoredTags = o.ignoreTags;
  const uppercaseIgnoredTags = [];
  for (let i = 0; i < ignoredTags.length; i++) {
    uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
  }
  /** @protected */
  this.o = o;
  if (defaultRender) {
    this.defaultRender = defaultRender;
  }
  this.ignoreTags = uppercaseIgnoredTags;
}
Options.prototype = {
  o: defaults$1,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(ir) {
    return ir;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(token) {
    return this.get('validate', token.toString(), token);
  },
  // Private methods

  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(key, operator, token) {
    const isCallable = operator != null;
    let option = this.o[key];
    if (!option) {
      return option;
    }
    if (typeof option === 'object') {
      option = token.t in option ? option[token.t] : defaults$1[key];
      if (typeof option === 'function' && isCallable) {
        option = option(operator, token);
      }
    } else if (typeof option === 'function' && isCallable) {
      option = option(operator, token.t, token);
    }
    return option;
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(key, operator, token) {
    let obj = this.o[key];
    if (typeof obj === 'function' && operator != null) {
      obj = obj(operator, token.t, token);
    }
    return obj;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(token) {
    const ir = token.render(this); // intermediate representation
    const renderFn = this.get('render', null, token) || this.defaultRender;
    return renderFn(ir, token.t, token);
  }
};
function noop$2(val) {
  return val;
}

/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/

/**
 * @param {string} value
 * @param {Token[]} tokens
 */
function MultiToken(value, tokens) {
  this.t = 'token';
  this.v = value;
  this.tk = tokens;
}

/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */
MultiToken.prototype = {
  isLink: false,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(scheme) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(options) {
    const val = this.toString();
    const truncate = options.get('truncate', val, this);
    const formatted = options.get('format', val, this);
    return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + '…' : formatted;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(options) {
    return options.get('formatHref', this.toHref(options.get('defaultProtocol')), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(protocol = defaults$1.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(protocol),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(options) {
    return {
      type: this.t,
      value: this.toFormattedString(options),
      isLink: this.isLink,
      href: this.toFormattedHref(options),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(options) {
    return options.get('validate', this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(options) {
    const token = this;
    const href = this.toHref(options.get('defaultProtocol'));
    const formattedHref = options.get('formatHref', href, this);
    const tagName = options.get('tagName', href, token);
    const content = this.toFormattedString(options);
    const attributes = {};
    const className = options.get('className', href, token);
    const target = options.get('target', href, token);
    const rel = options.get('rel', href, token);
    const attrs = options.getObj('attributes', href, token);
    const eventListeners = options.getObj('events', href, token);
    attributes.href = formattedHref;
    if (className) {
      attributes.class = className;
    }
    if (target) {
      attributes.target = target;
    }
    if (rel) {
      attributes.rel = rel;
    }
    if (attrs) {
      Object.assign(attributes, attrs);
    }
    return {
      tagName,
      attributes,
      content,
      eventListeners
    };
  }
};

/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */
function createTokenClass(type, props) {
  class Token extends MultiToken {
    constructor(value, tokens) {
      super(value, tokens);
      this.t = type;
    }
  }
  for (const p in props) {
    Token.prototype[p] = props[p];
  }
  Token.t = type;
  return Token;
}

/**
	Represents a list of tokens making up a valid email address
*/
const Email = createTokenClass('email', {
  isLink: true,
  toHref() {
    return 'mailto:' + this.toString();
  }
});

/**
	Represents some plain text
*/
const Text = createTokenClass('text');

/**
	Multi-linebreak token - represents a line break
	@class Nl
*/
const Nl = createTokenClass('nl');

/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/
const Url = createTokenClass('url', {
  isLink: true,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(scheme = defaults$1.defaultProtocol) {
    // Check if already has a prefix scheme
    return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const tokens = this.tk;
    return tokens.length >= 2 && tokens[0].t !== LOCALHOST && tokens[1].t === COLON;
  }
});

/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/

const makeState = arg => new State(arg);

/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */
function init$1({
  groups
}) {
  // Types of characters the URL can definitely end in
  const qsAccepting = groups.domain.concat([AMPERSAND, ASTERISK, AT, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, NUM, PERCENT, PIPE, PLUS, POUND, SLASH, SYM, TILDE, UNDERSCORE]);

  // Types of tokens that can follow a URL and be part of the query string
  // but cannot be the very last characters
  // Characters that cannot appear in the URL at all should be excluded
  const qsNonAccepting = [APOSTROPHE, COLON, COMMA, DOT, EXCLAMATION, PERCENT, QUERY, QUOTE, SEMI, OPENANGLEBRACKET, CLOSEANGLEBRACKET, OPENBRACE, CLOSEBRACE, CLOSEBRACKET, OPENBRACKET, OPENPAREN, CLOSEPAREN, FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN, LEFTCORNERBRACKET, RIGHTCORNERBRACKET, LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET, FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN];

  // For addresses without the mailto prefix
  // Tokens allowed in the localpart of the email
  const localpartAccepting = [AMPERSAND, APOSTROPHE, ASTERISK, BACKSLASH, BACKTICK, CARET, DOLLAR, EQUALS, HYPHEN, OPENBRACE, CLOSEBRACE, PERCENT, PIPE, PLUS, POUND, QUERY, SLASH, SYM, TILDE, UNDERSCORE];

  // The universal starting state.
  /**
   * @type State<Token>
   */
  const Start = makeState();
  const Localpart = tt(Start, TILDE); // Local part of the email address
  ta(Localpart, localpartAccepting, Localpart);
  ta(Localpart, groups.domain, Localpart);
  const Domain = makeState(),
    Scheme = makeState(),
    SlashScheme = makeState();
  ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
  ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
  ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'

  ta(Domain, localpartAccepting, Localpart);
  ta(Domain, groups.domain, Domain);
  const LocalpartAt = tt(Domain, AT); // Local part of the email address plus @

  tt(Localpart, AT, LocalpartAt); // close to an email address now

  // Local part of an email address can be e.g. 'http' or 'mailto'
  tt(Scheme, AT, LocalpartAt);
  tt(SlashScheme, AT, LocalpartAt);
  const LocalpartDot = tt(Localpart, DOT); // Local part of the email address plus '.' (localpart cannot end in .)
  ta(LocalpartDot, localpartAccepting, Localpart);
  ta(LocalpartDot, groups.domain, Localpart);
  const EmailDomain = makeState();
  ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
  ta(EmailDomain, groups.domain, EmailDomain);
  const EmailDomainDot = tt(EmailDomain, DOT); // domain followed by DOT
  ta(EmailDomainDot, groups.domain, EmailDomain);
  const Email$1 = makeState(Email); // Possible email address (could have more tlds)
  ta(EmailDomainDot, groups.tld, Email$1);
  ta(EmailDomainDot, groups.utld, Email$1);
  tt(LocalpartAt, LOCALHOST, Email$1);

  // Hyphen can jump back to a domain name
  const EmailDomainHyphen = tt(EmailDomain, HYPHEN); // parsed string starts with local email info + @ with a potential domain name
  tt(EmailDomainHyphen, HYPHEN, EmailDomainHyphen);
  ta(EmailDomainHyphen, groups.domain, EmailDomain);
  ta(Email$1, groups.domain, EmailDomain);
  tt(Email$1, DOT, EmailDomainDot);
  tt(Email$1, HYPHEN, EmailDomainHyphen);

  // Account for dots and hyphens. Hyphens are usually parts of domain names
  // (but not TLDs)
  const DomainHyphen = tt(Domain, HYPHEN); // domain followed by hyphen
  const DomainDot = tt(Domain, DOT); // domain followed by DOT
  tt(DomainHyphen, HYPHEN, DomainHyphen);
  ta(DomainHyphen, groups.domain, Domain);
  ta(DomainDot, localpartAccepting, Localpart);
  ta(DomainDot, groups.domain, Domain);
  const DomainDotTld = makeState(Url); // Simplest possible URL with no query string
  ta(DomainDot, groups.tld, DomainDotTld);
  ta(DomainDot, groups.utld, DomainDotTld);
  ta(DomainDotTld, groups.domain, Domain);
  ta(DomainDotTld, localpartAccepting, Localpart);
  tt(DomainDotTld, DOT, DomainDot);
  tt(DomainDotTld, HYPHEN, DomainHyphen);
  tt(DomainDotTld, AT, LocalpartAt);
  const DomainDotTldColon = tt(DomainDotTld, COLON); // URL followed by colon (potential port number here)
  const DomainDotTldColonPort = makeState(Url); // TLD followed by a port number
  ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);

  // Long URL with optional port and maybe query string
  const Url$1 = makeState(Url);

  // URL with extra symbols at the end, followed by an opening bracket
  const UrlNonaccept = makeState(); // URL followed by some symbols (will not be part of the final URL)

  // Query strings
  ta(Url$1, qsAccepting, Url$1);
  ta(Url$1, qsNonAccepting, UrlNonaccept);
  ta(UrlNonaccept, qsAccepting, Url$1);
  ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);

  // Become real URLs after `SLASH` or `COLON NUM SLASH`
  // Here works with or without scheme:// prefix
  tt(DomainDotTld, SLASH, Url$1);
  tt(DomainDotTldColonPort, SLASH, Url$1);

  // Note that domains that begin with schemes are treated slighly differently
  const SchemeColon = tt(Scheme, COLON); // e.g., 'mailto:'
  const SlashSchemeColon = tt(SlashScheme, COLON); // e.g., 'http:'
  const SlashSchemeColonSlash = tt(SlashSchemeColon, SLASH); // e.g., 'http:/'

  const UriPrefix = tt(SlashSchemeColonSlash, SLASH); // e.g., 'http://'

  // Scheme states can transition to domain states
  ta(Scheme, groups.domain, Domain);
  tt(Scheme, DOT, DomainDot);
  tt(Scheme, HYPHEN, DomainHyphen);
  ta(SlashScheme, groups.domain, Domain);
  tt(SlashScheme, DOT, DomainDot);
  tt(SlashScheme, HYPHEN, DomainHyphen);

  // Force URL with scheme prefix followed by anything sane
  ta(SchemeColon, groups.domain, Url$1);
  tt(SchemeColon, SLASH, Url$1);
  tt(SchemeColon, QUERY, Url$1);
  ta(UriPrefix, groups.domain, Url$1);
  ta(UriPrefix, qsAccepting, Url$1);
  tt(UriPrefix, SLASH, Url$1);
  const bracketPairs = [[OPENBRACE, CLOSEBRACE],
  // {}
  [OPENBRACKET, CLOSEBRACKET],
  // []
  [OPENPAREN, CLOSEPAREN],
  // ()
  [OPENANGLEBRACKET, CLOSEANGLEBRACKET],
  // <>
  [FULLWIDTHLEFTPAREN, FULLWIDTHRIGHTPAREN],
  // （）
  [LEFTCORNERBRACKET, RIGHTCORNERBRACKET],
  // 「」
  [LEFTWHITECORNERBRACKET, RIGHTWHITECORNERBRACKET],
  // 『』
  [FULLWIDTHLESSTHAN, FULLWIDTHGREATERTHAN] // ＜＞
  ];
  for (let i = 0; i < bracketPairs.length; i++) {
    const [OPEN, CLOSE] = bracketPairs[i];
    const UrlOpen = tt(Url$1, OPEN); // URL followed by open bracket

    // Continue not accepting for open brackets
    tt(UrlNonaccept, OPEN, UrlOpen);

    // URL that begins with an opening bracket, followed by a symbols.
    // Note that the final state can still be `UrlOpen` (if the URL has a
    // single opening bracket for some reason).
    const UrlOpenQ = makeState(Url);
    ta(UrlOpen, qsAccepting, UrlOpenQ);
    const UrlOpenSyms = makeState(); // UrlOpen followed by some symbols it cannot end it
    ta(UrlOpen, qsNonAccepting, UrlOpenSyms);

    // Closing bracket component. This character WILL be included in the URL.
    // Must come after qsNonAccepting (which includes all close-bracket tokens)
    // so that CLOSE -> Url wins over CLOSE -> UrlOpenSyms.
    tt(UrlOpen, CLOSE, Url$1);

    // URL that begins with an opening bracket, followed by some symbols
    ta(UrlOpenQ, qsAccepting, UrlOpenQ);
    ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
    ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
    ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);

    // Close brace/bracket to become regular URL
    tt(UrlOpenQ, CLOSE, Url$1);
    tt(UrlOpenSyms, CLOSE, Url$1);
  }
  tt(Start, LOCALHOST, DomainDotTld); // localhost is a valid URL state
  tt(Start, NL, Nl); // single new line

  return {
    start: Start,
    tokens: tk
  };
}

/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */
function run(start, input, tokens) {
  let len = tokens.length;
  let cursor = 0;
  let multis = [];
  let textTokens = [];
  while (cursor < len) {
    let state = start;
    let secondState = null;
    let nextState = null;
    let multiLength = 0;
    let latestAccepting = null;
    let sinceAccepts = -1;
    while (cursor < len && !(secondState = state.go(tokens[cursor].t))) {
      // Starting tokens with nowhere to jump to.
      // Consider these to be just plain text
      textTokens.push(tokens[cursor++]);
    }
    while (cursor < len && (nextState = secondState || state.go(tokens[cursor].t))) {
      // Get the next state
      secondState = null;
      state = nextState;

      // Keep track of the latest accepting state
      if (state.accepts()) {
        sinceAccepts = 0;
        latestAccepting = state;
      } else if (sinceAccepts >= 0) {
        sinceAccepts++;
      }
      cursor++;
      multiLength++;
    }
    if (sinceAccepts < 0) {
      // No accepting state was found, part of a regular text token add
      // the first text token to the text tokens array and try again from
      // the next
      cursor -= multiLength;
      if (cursor < len) {
        textTokens.push(tokens[cursor]);
        cursor++;
      }
    } else {
      // Accepting state!
      // First close off the textTokens (if available)
      if (textTokens.length > 0) {
        multis.push(initMultiToken(Text, input, textTokens));
        textTokens = [];
      }

      // Roll back to the latest accepting state
      cursor -= sinceAccepts;
      multiLength -= sinceAccepts;

      // Create a new multitoken
      const Multi = latestAccepting.t;
      const subtokens = tokens.slice(cursor - multiLength, cursor);
      multis.push(initMultiToken(Multi, input, subtokens));
    }
  }

  // Finally close off the textTokens (if available)
  if (textTokens.length > 0) {
    multis.push(initMultiToken(Text, input, textTokens));
  }
  return multis;
}

/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */
function initMultiToken(Multi, input, tokens) {
  const startIdx = tokens[0].s;
  const endIdx = tokens[tokens.length - 1].e;
  const value = input.slice(startIdx, endIdx);
  return new Multi(value, tokens);
}

const warn = typeof console !== 'undefined' && console && console.warn || (() => {});
const warnAdvice = 'until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.';

// Side-effect initialization state
const INIT = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: false
};

/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */

/**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */

/**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */

/**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */

/**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */
function reset() {
  State.groups = {};
  INIT.scanner = null;
  INIT.parser = null;
  INIT.tokenQueue = [];
  INIT.pluginQueue = [];
  INIT.customSchemes = [];
  INIT.initialized = false;
  return INIT;
}

/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} scheme
 * @param {boolean} [optionalSlashSlash]
 */
function registerCustomProtocol(scheme, optionalSlashSlash = false) {
  if (INIT.initialized) {
    warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${warnAdvice}`);
  }
  if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) {
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  }
  INIT.customSchemes.push([scheme, optionalSlashSlash]);
}

/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */
function init() {
  // Initialize scanner state machine and plugins
  INIT.scanner = init$2(INIT.customSchemes);
  for (let i = 0; i < INIT.tokenQueue.length; i++) {
    INIT.tokenQueue[i][1]({
      scanner: INIT.scanner
    });
  }

  // Initialize parser state machine and plugins
  INIT.parser = init$1(INIT.scanner.tokens);
  for (let i = 0; i < INIT.pluginQueue.length; i++) {
    INIT.pluginQueue[i][1]({
      scanner: INIT.scanner,
      parser: INIT.parser
    });
  }
  INIT.initialized = true;
  return INIT;
}

/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */
function tokenize(str) {
  if (!INIT.initialized) {
    init();
  }
  return run(INIT.parser.start, str, run$1(INIT.scanner.start, str));
}
tokenize.scan = run$1; // for testing

/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */
function find(str, type = null, opts = null) {
  if (type && typeof type === 'object') {
    if (opts) {
      throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
    }
    opts = type;
    type = null;
  }
  const options = new Options(opts);
  const tokens = tokenize(str);
  const filtered = [];
  for (let i = 0; i < tokens.length; i++) {
    const token = tokens[i];
    if (token.isLink && (!type || token.t === type) && options.check(token)) {
      filtered.push(token.toFormattedObject(options));
    }
  }
  return filtered;
}

// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.ts
const UNICODE_WHITESPACE_PATTERN = '[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]';
const UNICODE_WHITESPACE_REGEX = new RegExp(UNICODE_WHITESPACE_PATTERN);
const UNICODE_WHITESPACE_REGEX_END = new RegExp(`${UNICODE_WHITESPACE_PATTERN}$`);
const UNICODE_WHITESPACE_REGEX_GLOBAL = new RegExp(UNICODE_WHITESPACE_PATTERN, 'g');

/**
 * Check if the provided tokens form a valid link structure, which can either be a single link token
 * or a link token surrounded by parentheses or square brackets.
 *
 * This ensures that only complete and valid text is hyperlinked, preventing cases where a valid
 * top-level domain (TLD) is immediately followed by an invalid character, like a number. For
 * example, with the `find` method from Linkify, entering `example.com1` would result in
 * `example.com` being linked and the trailing `1` left as plain text. By using the `tokenize`
 * method, we can perform more comprehensive validation on the input text.
 */
function isValidLinkStructure(tokens) {
    if (tokens.length === 1) {
        return tokens[0].isLink;
    }
    if (tokens.length === 3 && tokens[1].isLink) {
        return ['()', '[]'].includes(tokens[0].value + tokens[2].value);
    }
    return false;
}
/**
 * This plugin allows you to automatically add links to your editor.
 * @param options The plugin options
 * @returns The plugin instance
 */
function autolink(options) {
    return new Plugin({
        key: new PluginKey('autolink'),
        appendTransaction: (transactions, oldState, newState) => {
            /**
             * Does the transaction change the document?
             */
            const docChanges = transactions.some(transaction => transaction.docChanged) && !oldState.doc.eq(newState.doc);
            /**
             * Prevent autolink if the transaction is not a document change or if the transaction has the meta `preventAutolink`.
             */
            const preventAutolink = transactions.some(transaction => transaction.getMeta('preventAutolink'));
            /**
             * Prevent autolink if the transaction is not a document change
             * or if the transaction has the meta `preventAutolink`.
             */
            if (!docChanges || preventAutolink) {
                return;
            }
            const { tr } = newState;
            const transform = combineTransactionSteps(oldState.doc, [...transactions]);
            const changes = getChangedRanges(transform);
            changes.forEach(({ newRange }) => {
                // Now let’s see if we can add new links.
                const nodesInChangedRanges = findChildrenInRange(newState.doc, newRange, node => node.isTextblock);
                let textBlock;
                let textBeforeWhitespace;
                if (nodesInChangedRanges.length > 1) {
                    // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
                }
                else if (nodesInChangedRanges.length) {
                    const endText = newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ');
                    if (!UNICODE_WHITESPACE_REGEX_END.test(endText)) {
                        return;
                    }
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
                }
                if (textBlock && textBeforeWhitespace) {
                    const wordsBeforeWhitespace = textBeforeWhitespace.split(UNICODE_WHITESPACE_REGEX).filter(Boolean);
                    if (wordsBeforeWhitespace.length <= 0) {
                        return false;
                    }
                    const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
                    const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
                    if (!lastWordBeforeSpace) {
                        return false;
                    }
                    const linksBeforeSpace = tokenize(lastWordBeforeSpace).map(t => t.toObject(options.defaultProtocol));
                    if (!isValidLinkStructure(linksBeforeSpace)) {
                        return false;
                    }
                    linksBeforeSpace
                        .filter(link => link.isLink)
                        // Calculate link position.
                        .map(link => ({
                        ...link,
                        from: lastWordAndBlockOffset + link.start + 1,
                        to: lastWordAndBlockOffset + link.end + 1,
                    }))
                        // ignore link inside code mark
                        .filter(link => {
                        if (!newState.schema.marks.code) {
                            return true;
                        }
                        return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
                    })
                        // validate link
                        .filter(link => options.validate(link.value))
                        // check whether should autolink
                        .filter(link => options.shouldAutoLink(link.value))
                        // Add link mark.
                        .forEach(link => {
                        if (getMarksBetween(link.from, link.to, newState.doc).some(item => item.mark.type === options.type)) {
                            return;
                        }
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href,
                        }));
                    });
                }
            });
            if (!tr.steps.length) {
                return;
            }
            return tr;
        },
    });
}

function clickHandler(options) {
    return new Plugin({
        key: new PluginKey('handleClickLink'),
        props: {
            handleClick: (view, pos, event) => {
                var _a, _b;
                if (event.button !== 0) {
                    return false;
                }
                if (!view.editable) {
                    return false;
                }
                let a = event.target;
                const els = [];
                while (a.nodeName !== 'DIV') {
                    els.push(a);
                    a = a.parentNode;
                }
                if (!els.find(value => value.nodeName === 'A')) {
                    return false;
                }
                const attrs = getAttributes(view.state, options.type.name);
                const link = event.target;
                const href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
                const target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;
                if (link && href) {
                    window.open(href, target);
                    return true;
                }
                return false;
            },
        },
    });
}

function pasteHandler(options) {
    return new Plugin({
        key: new PluginKey('handlePasteLink'),
        props: {
            handlePaste: (view, event, slice) => {
                const { state } = view;
                const { selection } = state;
                const { empty } = selection;
                if (empty) {
                    return false;
                }
                let textContent = '';
                slice.content.forEach(node => {
                    textContent += node.textContent;
                });
                const link = find(textContent, { defaultProtocol: options.defaultProtocol }).find(item => item.isLink && item.value === textContent);
                if (!textContent || !link) {
                    return false;
                }
                return options.editor.commands.setMark(options.type, {
                    href: link.href,
                });
            },
        },
    });
}
function isAllowedUri(uri, protocols) {
    const allowedProtocols = [
        'http',
        'https',
        'ftp',
        'ftps',
        'mailto',
        'tel',
        'callto',
        'sms',
        'cid',
        'xmpp',
    ];
    if (protocols) {
        protocols.forEach(protocol => {
            const nextProtocol = typeof protocol === 'string' ? protocol : protocol.scheme;
            if (nextProtocol) {
                allowedProtocols.push(nextProtocol);
            }
        });
    }
    return (!uri
        || uri.replace(UNICODE_WHITESPACE_REGEX_GLOBAL, '').match(new RegExp(
        // eslint-disable-next-line no-useless-escape
        `^(?:(?:${allowedProtocols.join('|')}):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))`, 'i')));
}
/**
 * This extension allows you to create links.
 * @see https://www.tiptap.dev/api/marks/link
 */
const Link = Mark.create({
    name: 'link',
    priority: 1000,
    keepOnSplit: false,
    exitable: true,
    onCreate() {
        if (this.options.validate && !this.options.shouldAutoLink) {
            // Copy the validate function to the shouldAutoLink option
            this.options.shouldAutoLink = this.options.validate;
            console.warn('The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.');
        }
        this.options.protocols.forEach(protocol => {
            if (typeof protocol === 'string') {
                registerCustomProtocol(protocol);
                return;
            }
            registerCustomProtocol(protocol.scheme, protocol.optionalSlashes);
        });
    },
    onDestroy() {
        reset();
    },
    inclusive() {
        return this.options.autolink;
    },
    addOptions() {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            protocols: [],
            defaultProtocol: 'http',
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer nofollow',
                class: null,
            },
            isAllowedUri: (url, ctx) => !!isAllowedUri(url, ctx.protocols),
            validate: url => !!url,
            shouldAutoLink: url => !!url,
        };
    },
    addAttributes() {
        return {
            href: {
                default: null,
                parseHTML(element) {
                    return element.getAttribute('href');
                },
            },
            target: {
                default: this.options.HTMLAttributes.target,
            },
            rel: {
                default: this.options.HTMLAttributes.rel,
            },
            class: {
                default: this.options.HTMLAttributes.class,
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'a[href]',
                getAttrs: dom => {
                    const href = dom.getAttribute('href');
                    // prevent XSS attacks
                    if (!href
                        || !this.options.isAllowedUri(href, {
                            defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                            protocols: this.options.protocols,
                            defaultProtocol: this.options.defaultProtocol,
                        })) {
                        return false;
                    }
                    return null;
                },
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        // prevent XSS attacks
        if (!this.options.isAllowedUri(HTMLAttributes.href, {
            defaultValidate: href => !!isAllowedUri(href, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol,
        })) {
            // strip out the href
            return [
                'a',
                mergeAttributes(this.options.HTMLAttributes, { ...HTMLAttributes, href: '' }),
                0,
            ];
        }
        return ['a', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
    addCommands() {
        return {
            setLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain().setMark(this.name, attributes).setMeta('preventAutolink', true).run();
            },
            toggleLink: attributes => ({ chain }) => {
                const { href } = attributes;
                if (!this.options.isAllowedUri(href, {
                    defaultValidate: url => !!isAllowedUri(url, this.options.protocols),
                    protocols: this.options.protocols,
                    defaultProtocol: this.options.defaultProtocol,
                })) {
                    return false;
                }
                return chain()
                    .toggleMark(this.name, attributes, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
            unsetLink: () => ({ chain }) => {
                return chain()
                    .unsetMark(this.name, { extendEmptyMarkRange: true })
                    .setMeta('preventAutolink', true)
                    .run();
            },
        };
    },
    addPasteRules() {
        return [
            markPasteRule({
                find: text => {
                    const foundLinks = [];
                    if (text) {
                        const { protocols, defaultProtocol } = this.options;
                        const links = find(text).filter(item => item.isLink
                            && this.options.isAllowedUri(item.value, {
                                defaultValidate: href => !!isAllowedUri(href, protocols),
                                protocols,
                                defaultProtocol,
                            }));
                        if (links.length) {
                            links.forEach(link => foundLinks.push({
                                text: link.value,
                                data: {
                                    href: link.href,
                                },
                                index: link.start,
                            }));
                        }
                    }
                    return foundLinks;
                },
                type: this.type,
                getAttributes: match => {
                    var _a;
                    return {
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href,
                    };
                },
            }),
        ];
    },
    addProseMirrorPlugins() {
        const plugins = [];
        const { protocols, defaultProtocol } = this.options;
        if (this.options.autolink) {
            plugins.push(autolink({
                type: this.type,
                defaultProtocol: this.options.defaultProtocol,
                validate: url => this.options.isAllowedUri(url, {
                    defaultValidate: href => !!isAllowedUri(href, protocols),
                    protocols,
                    defaultProtocol,
                }),
                shouldAutoLink: this.options.shouldAutoLink,
            }));
        }
        if (this.options.openOnClick === true) {
            plugins.push(clickHandler({
                type: this.type,
            }));
        }
        if (this.options.linkOnPaste) {
            plugins.push(pasteHandler({
                editor: this.editor,
                defaultProtocol: this.options.defaultProtocol,
                type: this.type,
            }));
        }
        return plugins;
    },
});

const extensions = [Document$1, Paragraph, Text$1, Heading, BulletList, ListItem, History, Bold, Italic, Underline, Strike, HardBreak, Link];
const ExternalContentHandler = ({
  content
}) => {
  const {
    editor
  } = useCurrentEditor();
  const lastExternalContentRef = useRef(content);
  useEffect(() => {
    if (editor && content !== lastExternalContentRef.current) {
      const currentEditorContent = editor.getHTML();

      // Only update if the content is actually different from what's in the editor
      if (content !== currentEditorContent) {
        editor.commands.setContent(content);
      }
      lastExternalContentRef.current = content;
    }
  }, [editor, content]);
  return null;
};
const BaseEditor = ({
  label,
  toolbar,
  content,
  onChange,
  textDirection,
  error,
  required
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$R.baseEditorWrapper,
    dir: textDirection,
    children: [/*#__PURE__*/jsxs("label", {
      className: css$R.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$R.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: `${css$R.baseEditor} ${error ? css$R.error : ''}`,
      "data-error": !!error,
      children: /*#__PURE__*/jsx(EditorProvider, {
        onUpdate: ({
          editor
        }) => {
          onChange(editor?.getHTML());
        },
        slotBefore: toolbar,
        extensions: extensions,
        content: content,
        children: /*#__PURE__*/jsx(ExternalContentHandler, {
          content: content
        })
      })
    }), error && /*#__PURE__*/jsx("span", {
      className: css$R.errorMessage,
      children: error
    })]
  });
};

const BoldButton = () => {
  const {
    editor
  } = useCurrentEditor();
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "top",
    content: "Bold",
    children: /*#__PURE__*/jsx(Button$1, {
      size: "small",
      className: editor.isActive('bold') ? css$S.active : '',
      disabled: !editor.can().chain().focus().toggleBold().run(),
      onClick: () => editor.chain().focus().toggleBold().run(),
      icon: /*#__PURE__*/jsx(Bold$1, {})
    })
  });
};

const ItalicButton = () => {
  const {
    editor
  } = useCurrentEditor();
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "top",
    content: "Italic",
    children: /*#__PURE__*/jsx(Button$1, {
      size: "small",
      onClick: () => editor.chain().focus().toggleItalic().run(),
      disabled: !editor.can().chain().focus().toggleItalic().run(),
      className: editor.isActive('italic') ? css$S.active : '',
      icon: /*#__PURE__*/jsx(Italic$1, {})
    })
  });
};

const UnderlineButton = () => {
  const {
    editor
  } = useCurrentEditor();
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "top",
    content: "Underline",
    children: /*#__PURE__*/jsx(Button$1, {
      size: "small",
      onClick: () => editor.chain().focus().toggleUnderline().run(),
      disabled: !editor.can().chain().focus().toggleUnderline().run(),
      className: editor.isActive('underline') ? css$S.active : '',
      icon: /*#__PURE__*/jsx(Underline$1, {})
    })
  });
};

const StrikeButton = () => {
  const {
    editor
  } = useCurrentEditor();
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "top",
    content: "Strike",
    children: /*#__PURE__*/jsx(Button$1, {
      size: "small",
      onClick: () => editor.chain().focus().toggleStrike().run(),
      disabled: !editor.can().chain().focus().toggleStrike().run(),
      className: editor.isActive('strike') ? css$S.active : '',
      icon: /*#__PURE__*/jsx(Strike$1, {})
    })
  });
};

const BulletListButton = () => {
  const {
    editor
  } = useCurrentEditor();
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "top",
    content: "Bullet List",
    children: /*#__PURE__*/jsx(Button$1, {
      size: "small",
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      disabled: !editor.can().chain().focus().toggleBulletList().run(),
      className: editor.isActive('bulletList') ? css$S.active : '',
      icon: /*#__PURE__*/jsx(BulletList$1, {})
    })
  });
};

var css_248z$R = ".RecommendedTextSection-module__recommendedTextSection___GFRnr{background-color:var(--bg-light);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);left:5px;padding:10px;position:absolute;top:45px;width:98%;z-index:9}.RecommendedTextSection-module__recommendedTextSection___GFRnr>b{font-size:var(--body-regular-size)}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__selectSection___VMPrv{align-items:end;display:flex;gap:10px;margin-bottom:1rem;width:fit-content}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__selectSection___VMPrv>div{margin-bottom:0}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__selectSection___VMPrv select{height:36px;width:150px}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__buttonsSection___L--96{display:flex;gap:10px}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__recommendedTextWrapper___FYIrl{margin-bottom:10px;word-break:break-word}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__recommendedTextWrapper___FYIrl b:first-child{display:block;margin-bottom:10px}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__recommendedTextWrapper___FYIrl ul{padding-left:15px}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__recommendedTextWrapper___FYIrl ul li{margin-bottom:5px}.RecommendedTextSection-module__recommendedTextSection___GFRnr .RecommendedTextSection-module__resetButtons___9fLEL{font-size:var(--body-small-size);height:36px;width:unset}";
var css$Q = {"recommendedTextSection":"RecommendedTextSection-module__recommendedTextSection___GFRnr","selectSection":"RecommendedTextSection-module__selectSection___VMPrv","buttonsSection":"RecommendedTextSection-module__buttonsSection___L--96","recommendedTextWrapper":"RecommendedTextSection-module__recommendedTextWrapper___FYIrl","resetButtons":"RecommendedTextSection-module__resetButtons___9fLEL"};
styleInject(css_248z$R);

const BaseImproveWithAIButton = ({
  onGetRecommendedText,
  recommendedText,
  onAcceptRecommendedText,
  onIgnoreRecommendedText,
  onAcceptAndApplyToAllRecommendedText,
  className
}) => {
  const {
    editor
  } = useCurrentEditor();
  const handleAcceptAction = e => {
    editor.commands.setContent(recommendedText);
    onAcceptRecommendedText(e);
  };
  const handleAcceptAndApplyToAllAction = e => {
    onAcceptAndApplyToAllRecommendedText(e);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(Button$1, {
      size: "small",
      variant: "secondary",
      onClick: onGetRecommendedText,
      className: className,
      icon: /*#__PURE__*/jsx(Stars, {}),
      children: "AI Optimise"
    }), /*#__PURE__*/jsx(RecommendedTextSection, {
      recommendedText: recommendedText,
      onAcceptAction: handleAcceptAction,
      onIgnoreAction: onIgnoreRecommendedText,
      ...(onAcceptAndApplyToAllRecommendedText && {
        onAcceptAndApplyToAllAction: handleAcceptAndApplyToAllAction
      })
    })]
  });
};
const RecommendedTextSection = ({
  recommendedText,
  onAcceptAction,
  onIgnoreAction,
  onAcceptAndApplyToAllAction
}) => {
  const [typingIsCompleted, setTypingIsCompleted] = useState(false);
  if (!recommendedText) {
    return null;
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: /*#__PURE__*/jsxs("div", {
      className: css$Q.recommendedTextSection,
      children: [/*#__PURE__*/jsx("b", {
        children: "We recommend this description:"
      }), /*#__PURE__*/jsx(Typewriter, {
        text: recommendedText,
        speed: 10,
        onCompletedTyping: () => setTypingIsCompleted(true)
      }), typingIsCompleted && /*#__PURE__*/jsxs("div", {
        className: css$Q.buttonsSection,
        children: [/*#__PURE__*/jsx(Button$1, {
          className: css$Q.resetButtons,
          variant: "primary",
          size: "small",
          onClick: e => onAcceptAction(e),
          children: "Accept"
        }), onAcceptAndApplyToAllAction && /*#__PURE__*/jsx(Button$1, {
          className: css$Q.resetButtons,
          variant: "primary",
          size: "small",
          onClick: e => onAcceptAndApplyToAllAction(e),
          children: "Accept & Apply To All"
        }), /*#__PURE__*/jsx(Button$1, {
          className: css$Q.resetButtons,
          variant: "tertiary",
          size: "small",
          onClick: onIgnoreAction,
          children: "Ignore"
        })]
      })]
    })
  });
};
const useTypewriter = (text, speed = 30) => {
  const [index, setIndex] = useState(0);
  const [typingHasCompleted, setTypingHasCompleted] = useState(false);
  useEffect(() => {
    setIndex(0);
    setTypingHasCompleted(false);
  }, [text, speed]);
  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setIndex(index + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else if (text.length > 0) {
      setTypingHasCompleted(true);
    }
  }, [index, text, speed]);
  return {
    displayText: text.slice(0, index),
    typingHasCompleted
  };
};
const Typewriter = ({
  text,
  speed,
  onCompletedTyping
}) => {
  const displayText = useTypewriter(text, speed);
  if (displayText.typingHasCompleted) {
    onCompletedTyping();
  }
  return /*#__PURE__*/jsx("div", {
    className: css$Q.recommendedTextWrapper,
    dangerouslySetInnerHTML: {
      __html: displayText.displayText
    }
  });
};

const TranslateWithAIButton = ({
  onGetTranslatedText,
  translatedText,
  onAcceptTranslatedText,
  onIgnoreTranslatedText,
  availableLanguages,
  showTranslatedSection,
  handleTranslateWithAIAction
}) => {
  const {
    editor
  } = useCurrentEditor();
  const handleAcceptAction = e => {
    editor.commands.setContent(translatedText);
    onAcceptTranslatedText(e);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(Button$1, {
      size: "small",
      variant: "secondary",
      onClick: handleTranslateWithAIAction,
      icon: /*#__PURE__*/jsx(Translation, {}),
      children: "AI Translate"
    }), /*#__PURE__*/jsx(TranslatedTextSection, {
      translatedText: translatedText,
      onAcceptAction: handleAcceptAction,
      onIgnoreAction: onIgnoreTranslatedText,
      showTranslatedSection: showTranslatedSection,
      availableLanguages: availableLanguages,
      onGetTranslatedText: onGetTranslatedText,
      onCloseTranslateSection: onIgnoreTranslatedText
    })]
  });
};
const TranslatedTextSection = ({
  translatedText,
  onAcceptAction,
  onIgnoreAction,
  showTranslatedSection,
  availableLanguages,
  onGetTranslatedText,
  onCloseTranslateSection
}) => {
  const [selectedFromLanguageCode, setSelectedFromLanguageCode] = useState('');
  const [showInLineLoading, setShowInLineLoading] = useState(false);
  useEffect(() => {
    if (availableLanguages.length === 1) {
      setSelectedFromLanguageCode(availableLanguages[0].value);
    }
  }, [availableLanguages]);
  if (showTranslatedSection === false || availableLanguages.length === 0) {
    return null;
  }
  const handleGetTranslatedText = async () => {
    if (selectedFromLanguageCode.length > 0) {
      setShowInLineLoading(true);
      await onGetTranslatedText(selectedFromLanguageCode);
      setShowInLineLoading(false);
    }
  };
  return /*#__PURE__*/jsx(Fragment$1, {
    children: /*#__PURE__*/jsxs("div", {
      className: css$Q.recommendedTextSection,
      children: [/*#__PURE__*/jsxs("div", {
        className: css$Q.selectSection,
        children: [/*#__PURE__*/jsx(Dropdown, {
          label: "Translate from",
          name: "translateFrom",
          value: selectedFromLanguageCode,
          options: availableLanguages,
          onChange: e => setSelectedFromLanguageCode(e.target.value)
        }), /*#__PURE__*/jsx("div", {
          className: css$Q.buttonsSection,
          children: showInLineLoading ? /*#__PURE__*/jsx(InlineLoading, {}) : /*#__PURE__*/jsxs(Fragment$1, {
            children: [/*#__PURE__*/jsx(Button$1, {
              className: css$Q.resetButtons,
              variant: "primary",
              onClick: handleGetTranslatedText,
              children: availableLanguages.length ? 'Translate' : 'Confirm'
            }), /*#__PURE__*/jsx(Button$1, {
              className: css$Q.resetButtons,
              variant: "tertiary",
              onClick: onCloseTranslateSection,
              children: "Close"
            })]
          })
        })]
      }), translatedText && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx("b", {
          children: "Translation generated:"
        }), /*#__PURE__*/jsx("div", {
          className: css$Q.recommendedTextWrapper,
          dangerouslySetInnerHTML: {
            __html: translatedText
          }
        }), /*#__PURE__*/jsxs("div", {
          className: css$Q.buttonsSection,
          children: [/*#__PURE__*/jsx(Button$1, {
            className: css$Q.resetButtons,
            variant: "primary",
            size: "small",
            onClick: e => onAcceptAction(e),
            children: "Accept"
          }), /*#__PURE__*/jsx(Button$1, {
            className: css$Q.resetButtons,
            variant: "tertiary",
            size: "small",
            onClick: onIgnoreAction,
            children: "Ignore"
          })]
        })]
      })]
    })
  });
};

var css_248z$Q = ".Description-module__aiButton___tttYm{background-image:linear-gradient(to bottom right,var(--primary-color),var(--primary-20))!important}";
var css$P = {"aiButton":"Description-module__aiButton___tttYm"};
styleInject(css_248z$Q);

const Description = ({
  label,
  content = '',
  onChange,
  error,
  required,
  showImproveButton,
  onGetImprovedText,
  onAcceptImprovedText,
  showTranslateButton,
  onGetTranslatedText,
  onAcceptTranslatedText,
  availableLanguages,
  onAcceptAndApplyToAll,
  posthog
}) => {
  return /*#__PURE__*/jsx(BaseEditor, {
    label: label,
    content: content,
    onChange: onChange,
    toolbar: /*#__PURE__*/jsx(DescriptionEditorToolbar, {
      showImproveButton: showImproveButton,
      onGetImprovedText: onGetImprovedText,
      onAcceptImprovedText: onAcceptImprovedText,
      showTranslateButton: showTranslateButton,
      onGetTranslatedText: onGetTranslatedText,
      onAcceptTranslatedText: onAcceptTranslatedText,
      availableLanguages: availableLanguages,
      onAcceptAndApplyToAll: onAcceptAndApplyToAll,
      posthog: posthog
    }),
    error: error,
    required: required
  });
};
const DescriptionEditorToolbar = ({
  showImproveButton,
  onGetImprovedText,
  onAcceptImprovedText,
  showTranslateButton,
  onGetTranslatedText,
  onAcceptTranslatedText,
  availableLanguages,
  onAcceptAndApplyToAll,
  posthog
}) => {
  const [improvedText, setImprovedText] = useState('');
  const [translatedText, setTranslatedText] = useState('');
  const [showInLineLoading, setShowInLineLoading] = useState(false);
  const [showTranslatedSection, setShowTranslatedSection] = useState(false);
  const handleGetImprovedText = async e => {
    e.preventDefault();
    setShowInLineLoading(true);
    setShowTranslatedSection(false);
    setTranslatedText('');
    setImprovedText(await onGetImprovedText());
    setShowInLineLoading(false);
  };
  const handleAcceptImprovedText = e => {
    e.preventDefault();
    onAcceptImprovedText(improvedText);
    setImprovedText('');
  };
  const handleAcceptAndApplyToAll = e => {
    e.preventDefault();
    onAcceptAndApplyToAll(improvedText);
    setImprovedText('');
  };
  const handleIgnoreImprovedText = () => {
    setImprovedText('');
    posthog.capture('onboarding:description_improved_with_genai_ignored');
  };
  const handleGetTranslatedText = async language => {
    setShowTranslatedSection(true);
    setTranslatedText(await onGetTranslatedText(language));
  };
  const handleAcceptTranslatedText = e => {
    e.preventDefault();
    onAcceptTranslatedText(translatedText);
    setTranslatedText('');
    setShowTranslatedSection(false);
  };
  const handleTranslateWithAIAction = () => {
    setShowTranslatedSection(true);
    setImprovedText('');
  };
  const handleIgnoreTranslatedText = () => {
    setTranslatedText('');
    setShowTranslatedSection(false);
    posthog.capture('onboarding:description_translate_with_genai_ignored');
  };
  return /*#__PURE__*/jsxs(Toolbar, {
    children: [/*#__PURE__*/jsx(BoldButton, {}), /*#__PURE__*/jsx(ItalicButton, {}), /*#__PURE__*/jsx(UnderlineButton, {}), /*#__PURE__*/jsx(StrikeButton, {}), /*#__PURE__*/jsx(BulletListButton, {}), showImproveButton && /*#__PURE__*/jsx(Fragment$1, {
      children: showInLineLoading ? /*#__PURE__*/jsx(InlineLoading, {}) : /*#__PURE__*/jsx(BaseImproveWithAIButton, {
        onGetRecommendedText: handleGetImprovedText,
        recommendedText: improvedText,
        onAcceptRecommendedText: handleAcceptImprovedText,
        onIgnoreRecommendedText: handleIgnoreImprovedText,
        onAcceptAndApplyToAllRecommendedText: handleAcceptAndApplyToAll,
        className: css$P.aiButton
      })
    }), showTranslateButton && /*#__PURE__*/jsx(TranslateWithAIButton, {
      onGetTranslatedText: handleGetTranslatedText,
      translatedText: translatedText,
      onAcceptTranslatedText: handleAcceptTranslatedText,
      onIgnoreTranslatedText: handleIgnoreTranslatedText,
      availableLanguages: availableLanguages,
      showTranslatedSection: showTranslatedSection,
      handleTranslateWithAIAction: handleTranslateWithAIAction
    })]
  });
};

const getInitials = name => {
  if (!name) return '';
  const parts = name.split(/[ ,]+/);
  return parts.filter(Boolean).map(word => word[0].toUpperCase()).slice(0, 2).join('');
};
const Avatar = ({
  name,
  src,
  size = 35,
  borderColor,
  alt
}) => {
  const sizeValue = typeof size === 'number' ? `${size}px` : size;
  const containerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: sizeValue,
    height: sizeValue,
    borderRadius: '50%',
    color: 'var(--grey-64)',
    backgroundColor: 'var(--bg-light)',
    fontWeight: 'var(--body-small-weight)',
    fontSize: 'var(--body-small-size)',
    overflow: 'hidden',
    ...(borderColor && {
      border: `2px solid ${borderColor}`
    })
  };
  if (src) {
    return /*#__PURE__*/jsx("img", {
      src: src,
      alt: alt || name || 'Avatar',
      style: {
        width: sizeValue,
        height: sizeValue,
        borderRadius: '50%',
        objectFit: 'cover',
        ...(borderColor && {
          border: `2px solid ${borderColor}`
        })
      }
    });
  }
  if (!name) return null;
  const initials = getInitials(name);
  return /*#__PURE__*/jsx("div", {
    style: containerStyle,
    children: initials
  });
};
Avatar.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderColor: PropTypes.string,
  alt: PropTypes.string
};

var css_248z$P = ".TrendIndicator-module__trendRow___I50tT.TrendIndicator-module__vertical___70GwB{display:flex;flex-direction:column;gap:5px}.TrendIndicator-module__trendRow___I50tT .TrendIndicator-module__comparisonText___3hZ4I{color:var(--grey-64);font-size:var(--body-small-size);line-height:var(--body-small-line-height)}";
var css$O = {"trendRow":"TrendIndicator-module__trendRow___I50tT","vertical":"TrendIndicator-module__vertical___70GwB","comparisonText":"TrendIndicator-module__comparisonText___3hZ4I"};
styleInject(css_248z$P);

const TrendIndicator = ({
  trendValue,
  isPercentage = true,
  comparisonText,
  className,
  layout = 'horizontal',
  suffix = '',
  trend = null
}) => {
  const isZeroTrend = trend !== null ? trend === 0 : trendValue === 0;
  const isPositiveTrend = trend !== null ? trend === 1 : trendValue > 0;
  const isNegativeTrend = trend !== null ? trend === -1 : trendValue < 0;
  const trendBgColor = isZeroTrend ? colors$1.warning10 : isPositiveTrend ? colors$1.success10 : colors$1.danger10;
  const trendColor = isZeroTrend ? colors$1.warning : isPositiveTrend ? colors$1.success : colors$1.danger;

  // Absolute value for formatting
  const absValue = Math.abs(trendValue);

  // Format value for display
  const displayValue = isPercentage ? `${Math.round(absValue)}%` : formatCompactNumber(absValue);

  // Add negative sign if trend is negative and append suffix
  // Only add negative sign if using automatic trend detection (trend prop not provided)
  const signedDisplayValue = trend === null && isNegativeTrend ? `-${displayValue}` : displayValue;
  const finalDisplayValue = suffix ? `${signedDisplayValue}${suffix}` : signedDisplayValue;
  if (layout === 'vertical') {
    return /*#__PURE__*/jsxs("div", {
      className: `${css$O.trendRow} ${css$O.vertical} ${className || ''}`,
      children: [/*#__PURE__*/jsxs(FlexContainer, {
        alignItems: "center",
        gap: 5,
        children: [/*#__PURE__*/jsx(Label, {
          backgroundColor: trendBgColor,
          color: trendColor,
          children: finalDisplayValue
        }), isZeroTrend && /*#__PURE__*/jsx(ArrowRightIcon, {
          width: 16,
          height: 16,
          color: trendColor
        }), isPositiveTrend && !isZeroTrend && /*#__PURE__*/jsx(TrendUp01Icon, {
          width: 16,
          height: 16,
          color: trendColor
        }), isNegativeTrend && /*#__PURE__*/jsx(TrendDown01Icon, {
          width: 16,
          height: 16,
          color: trendColor
        })]
      }), comparisonText && /*#__PURE__*/jsxs("span", {
        className: css$O.comparisonText,
        children: ["than ", comparisonText]
      })]
    });
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    alignItems: "center",
    gap: "10px",
    className: `${css$O.trendRow} ${className || ''}`,
    children: [/*#__PURE__*/jsx(Label, {
      backgroundColor: trendBgColor,
      color: trendColor,
      children: finalDisplayValue
    }), isZeroTrend && /*#__PURE__*/jsx(ArrowRightIcon, {
      width: 16,
      height: 16,
      color: trendColor
    }), isPositiveTrend && !isZeroTrend && /*#__PURE__*/jsx(TrendUp01Icon, {
      width: 16,
      height: 16,
      color: trendColor
    }), isNegativeTrend && /*#__PURE__*/jsx(TrendDown01Icon, {
      width: 16,
      height: 16,
      color: trendColor
    }), comparisonText && /*#__PURE__*/jsxs("span", {
      className: css$O.comparisonText,
      children: ["than ", comparisonText]
    })]
  });
};
TrendIndicator.propTypes = {
  trendValue: PropTypes.number.isRequired,
  isPercentage: PropTypes.bool,
  comparisonText: PropTypes.string,
  className: PropTypes.string,
  layout: PropTypes.oneOf(['horizontal', 'vertical']),
  suffix: PropTypes.string,
  trend: PropTypes.oneOf([-1, 0, 1])
};

var css_248z$O = ".MetricBox-module__metricBox___RqXbV{background-color:var(--bg-light-80);border-radius:var(--border-radius-small);flex:1;padding:10px 15px;width:100%}.MetricBox-module__inline___swKB1{align-items:center;display:flex;gap:16px;justify-content:space-between;margin-bottom:10px}.MetricBox-module__inline___swKB1 .MetricBox-module__header___YHNc4{margin-bottom:0}.MetricBox-module__stacked___nAhZb{background-color:var(--bg-light-48);display:flex;flex-direction:column}.MetricBox-module__stacked___nAhZb .MetricBox-module__header___YHNc4{margin-bottom:5px}.MetricBox-module__header___YHNc4{align-items:center;display:flex;gap:6px}.MetricBox-module__icon___JLsoe{align-items:center;display:flex;flex-shrink:0}.MetricBox-module__title___qfaFs{color:var(--grey-64);font-size:var(--body-xs-size);font-weight:600;letter-spacing:.3px;text-transform:uppercase}.MetricBox-module__valueRow___rS2W-{align-items:center;display:flex;gap:6px}.MetricBox-module__value___dPdlK{color:var(--primary-color);font-size:20px;font-weight:600}.MetricBox-module__success___UIXtn{background-color:var(--success-10)}.MetricBox-module__danger___l4Vv8{background-color:var(--danger-10)}.MetricBox-module__warning___ETOYJ{background-color:var(--warning-10)}.MetricBox-module__info___UhQs6{background-color:var(--info-10)}.MetricBox-module__accent___K51kQ{background-color:var(--accent-10)}";
var css$N = {"metricBox":"MetricBox-module__metricBox___RqXbV","inline":"MetricBox-module__inline___swKB1","header":"MetricBox-module__header___YHNc4","stacked":"MetricBox-module__stacked___nAhZb","icon":"MetricBox-module__icon___JLsoe","title":"MetricBox-module__title___qfaFs","valueRow":"MetricBox-module__valueRow___rS2W-","value":"MetricBox-module__value___dPdlK","success":"MetricBox-module__success___UIXtn","danger":"MetricBox-module__danger___l4Vv8","warning":"MetricBox-module__warning___ETOYJ","info":"MetricBox-module__info___UhQs6","accent":"MetricBox-module__accent___K51kQ"};
styleInject(css_248z$O);

const VARIANT_COLORS = {
  success: 'var(--success)',
  danger: 'var(--danger)',
  warning: 'var(--warning)',
  info: 'var(--info)',
  accent: 'var(--accent)'
};
const formatPercentageValue = percentageValue => {
  if (typeof percentageValue === 'number') {
    return formatPercentage(percentageValue);
  }
  if (typeof percentageValue !== 'string') {
    return null;
  }
  const trimmedValue = percentageValue.trim();
  return trimmedValue === '' ? null : trimmedValue;
};
const MetricBox = ({
  title,
  icon,
  className,
  style,
  bgColor,
  fontColor,
  variant,
  value,
  percentageValue,
  layout = 'inline'
}) => {
  const isStacked = layout === 'stacked';
  const variantClass = variant ? css$N[variant] : '';
  const customStyles = !variant ? {
    backgroundColor: bgColor,
    color: fontColor
  } : {};
  const mergedStyles = {
    ...customStyles,
    ...style
  };
  const valueColor = variant ? VARIANT_COLORS[variant] : 'var(--primary-color)';
  const formattedPercentageValue = formatPercentageValue(percentageValue);
  return /*#__PURE__*/jsxs("div", {
    className: `${css$N.metricBox} ${isStacked ? css$N.stacked : css$N.inline} ${variantClass} ${className || ''}`,
    style: mergedStyles,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$N.header,
      children: [icon && /*#__PURE__*/jsx("span", {
        className: css$N.icon,
        style: {
          color: valueColor
        },
        children: icon
      }), /*#__PURE__*/jsx("span", {
        className: css$N.title,
        children: title
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$N.valueRow,
      children: [/*#__PURE__*/jsx("span", {
        className: css$N.value,
        style: isStacked ? {
          color: valueColor
        } : undefined,
        children: value
      }), formattedPercentageValue && /*#__PURE__*/jsx(Label, {
        size: "md",
        color: colors$1.grey64,
        backgroundColor: colors$1.white,
        children: formattedPercentageValue
      })]
    })]
  });
};
MetricBox.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.node]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  bgColor: PropTypes.string,
  fontColor: PropTypes.string,
  variant: PropTypes.oneOf(['success', 'danger', 'warning', 'info', 'accent']),
  percentageValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  layout: PropTypes.oneOf(['inline', 'stacked'])
};

const AnimatedCount = ({
  target,
  duration,
  format,
  animate = true
}) => {
  const animated = useCountUp(target ?? 0, duration);
  const value = animate ? animated : target ?? 0;
  const rounded = Math.round(value);
  return /*#__PURE__*/jsx(Fragment$1, {
    children: format ? format(rounded) : rounded
  });
};
AnimatedCount.propTypes = {
  target: PropTypes.number,
  duration: PropTypes.number,
  format: PropTypes.func,
  animate: PropTypes.bool
};

const AnimatedMoney = ({
  target,
  currency,
  duration,
  compact,
  animate = true,
  showDecimals = true
}) => {
  const animated = useCountUp(target ?? 0, duration);
  const value = animate ? animated : target ?? 0;
  return /*#__PURE__*/jsx(Fragment$1, {
    children: formatCurrency(Math.round(value), currency, compact, showDecimals)
  });
};
AnimatedMoney.propTypes = {
  target: PropTypes.number,
  currency: PropTypes.string,
  duration: PropTypes.number,
  compact: PropTypes.bool,
  animate: PropTypes.bool,
  showDecimals: PropTypes.bool
};

var css_248z$N = ".KeyAreaBox-module__keyAreaItem___aCEVP{align-items:center;background:var(--bg-light-80);border-radius:var(--border-radius-medium);cursor:pointer;display:flex;gap:10px;min-height:52px;padding:10px;position:relative}.KeyAreaBox-module__icon___qdu35{display:inline-flex}.KeyAreaBox-module__label___L8wvH{color:var(--primary-color);font-size:var(--label-size);font-weight:var(--label-weight);line-height:var(--label-line-height)}.KeyAreaBox-module__counts___-pnbE{display:block;height:32px;margin-top:2px;position:absolute;right:10px;top:50%;transform:translateY(-50%);width:56px}.KeyAreaBox-module__count___XjqWh{align-items:center;border:2px solid var(--bg-light-80);border-radius:50%;color:var(--white);display:flex;font-size:var(--body-small-size);font-weight:var(--body-small-weight);height:28px;justify-content:center;line-height:var(--body-small-line-height);position:absolute;top:0;width:28px}.KeyAreaBox-module__HIGH___VI-rZ{background:var(--danger)}.KeyAreaBox-module__MEDIUM___5nGBd{background:var(--warning)}.KeyAreaBox-module__LOW___lX9Id{background:var(--in-stay)}.KeyAreaBox-module__neutral___wkgGC{background:var(--primary-10)}";
var css$M = {"keyAreaItem":"KeyAreaBox-module__keyAreaItem___aCEVP","icon":"KeyAreaBox-module__icon___qdu35","label":"KeyAreaBox-module__label___L8wvH","counts":"KeyAreaBox-module__counts___-pnbE","count":"KeyAreaBox-module__count___XjqWh","HIGH":"KeyAreaBox-module__HIGH___VI-rZ","MEDIUM":"KeyAreaBox-module__MEDIUM___5nGBd","LOW":"KeyAreaBox-module__LOW___lX9Id","neutral":"KeyAreaBox-module__neutral___wkgGC"};
styleInject(css_248z$N);

const KeyAreaBox = ({
  icon,
  label,
  counts,
  onClick,
  onSeverityBadgeClick,
  categoryValue
}) => {
  const countItems = [{
    type: 'HIGH',
    value: counts?.HIGH ?? 0
  }, {
    type: 'MEDIUM',
    value: counts?.MEDIUM ?? 0
  }, {
    type: 'LOW',
    value: counts?.LOW ?? 0
  }];
  const allZero = countItems.every(item => item.value === 0);
  const items = allZero ? [{
    type: 'neutral',
    value: 0
  }] : countItems;
  const reversedItems = [...items].reverse();
  return /*#__PURE__*/jsxs("div", {
    className: css$M.keyAreaItem,
    onClick: onClick,
    children: [/*#__PURE__*/jsx("span", {
      className: css$M.icon,
      children: icon
    }), /*#__PURE__*/jsx("span", {
      className: css$M.label,
      children: label
    }), /*#__PURE__*/jsx("div", {
      className: css$M.counts,
      children: reversedItems.map((item, index) => /*#__PURE__*/jsx("span", {
        className: `${css$M.count} ${css$M[item.type]}`,
        onClick: item.value !== 0 && onSeverityBadgeClick ? event => {
          event.stopPropagation();
          onSeverityBadgeClick(item.type, categoryValue);
        } : undefined,
        style: {
          right: `${index * 20}px`,
          zIndex: index
        },
        children: item.value
      }, `${label}-${item.type}`))
    })]
  });
};
KeyAreaBox.propTypes = {
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  counts: PropTypes.shape({
    HIGH: PropTypes.number,
    MEDIUM: PropTypes.number,
    LOW: PropTypes.number
  }),
  onClick: PropTypes.func,
  onSeverityBadgeClick: PropTypes.func,
  categoryValue: PropTypes.string
};

const ProgramLetter = ({
  program,
  color,
  backgroundColor
}) => {
  const baseStyle = {
    padding: '3px 10px',
    borderRadius: 'var(--border-radius-small)'
  };
  const programStyles = {
    A: {
      color: colors$1.preArrival,
      backgroundColor: colors$1.preArrival10
    },
    B: {
      color: colors$1.onArrival,
      backgroundColor: colors$1.onArrival10
    },
    C: {
      color: colors$1.inStay,
      backgroundColor: colors$1.inStay10
    }
  };
  const programStyle = programStyles[program];
  if (!programStyle) return null;
  return /*#__PURE__*/jsx("span", {
    style: {
      ...baseStyle,
      color: color || programStyle.color,
      backgroundColor: backgroundColor || programStyle.backgroundColor
    },
    children: program
  });
};

var css_248z$M = ".ExpandableItem-module__item___FQGfc{background-color:var(--bg-light-80);border-radius:var(--border-radius-medium);margin-bottom:10px;padding:10px}.ExpandableItem-module__item___FQGfc h5{margin-bottom:0!important}.ExpandableItem-module__item___FQGfc .ExpandableItem-module__title___AFRdh{align-items:center;cursor:pointer;display:flex;gap:.5rem;justify-content:space-between}.ExpandableItem-module__item___FQGfc .ExpandableItem-module__title___AFRdh h5{margin-bottom:0!important}.ExpandableItem-module__item___FQGfc .ExpandableItem-module__title___AFRdh .ExpandableItem-module__itemIcon___-lA9D{align-items:center;display:inline-flex;justify-content:center}.ExpandableItem-module__item___FQGfc .ExpandableItem-module__title___AFRdh svg{height:15px;width:15px}.ExpandableItem-module__item___FQGfc .ExpandableItem-module__itemContent___CWTG1{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);margin-top:10px}";
var css$L = {"item":"ExpandableItem-module__item___FQGfc","title":"ExpandableItem-module__title___AFRdh","itemIcon":"ExpandableItem-module__itemIcon___-lA9D","itemContent":"ExpandableItem-module__itemContent___CWTG1"};
styleInject(css_248z$M);

const ExpandableItem = ({
  icon,
  title,
  titleColor,
  expanded = false,
  className,
  children,
  style
}) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  return /*#__PURE__*/jsxs("div", {
    className: `${css$L.item} ${className}`,
    style: style,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$L.title,
      onClick: () => setIsExpanded(!isExpanded),
      children: [icon && /*#__PURE__*/jsx("div", {
        className: css$L.itemIcon,
        children: icon
      }), title && /*#__PURE__*/jsx(CardTitle, {
        color: titleColor,
        children: title
      }), /*#__PURE__*/jsx("span", {
        children: isExpanded ? /*#__PURE__*/jsx(UpArrow, {
          color: colors$1.primaryColor
        }) : /*#__PURE__*/jsx(DownArrow, {
          color: colors$1.primaryColor
        })
      })]
    }), isExpanded && /*#__PURE__*/jsx("div", {
      className: css$L.itemContent,
      children: children
    })]
  });
};
ExpandableItem.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.node
};

var css_248z$L = ".SplitLayout-module__splitLayout___nunxS{background-color:var(--white);border-radius:var(--border-radius-medium);display:flex;gap:10px;margin-bottom:20px;min-height:700px;padding:5px}@media (max-width:912px){.SplitLayout-module__splitLayout___nunxS{display:block}}";
var css$K = {"splitLayout":"SplitLayout-module__splitLayout___nunxS"};
styleInject(css_248z$L);

const SplitLayout = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$K.splitLayout,
    children: children
  });
};

var css_248z$K = ".LeftLayoutSection-module__item___JG5xj{min-width:340px}@media (max-width:912px){.LeftLayoutSection-module__item___JG5xj{width:100%}}";
var css$J = {"item":"LeftLayoutSection-module__item___JG5xj"};
styleInject(css_248z$K);

const LeftLayoutSection = ({
  children,
  style,
  className = ''
}) => {
  return /*#__PURE__*/jsx("div", {
    className: `${css$J.item} ${className}`.trim(),
    style: style,
    children: children
  });
};

var css_248z$J = ".RightLayoutSection-module__item___kzGIs{border-radius:var(--border-radius-medium);width:100%}";
var css$I = {"item":"RightLayoutSection-module__item___kzGIs"};
styleInject(css_248z$J);

const RightLayoutSection = ({
  children,
  style,
  className = ''
}) => {
  return /*#__PURE__*/jsx("div", {
    className: `${css$I.item} ${className}`.trim(),
    style: style,
    children: children
  });
};

const NotificationsBadge = ({
  count
}) => {
  if ((count ?? 0) <= 0) {
    return null;
  }
  return /*#__PURE__*/jsx(Badge, {
    variant: "danger",
    "aria-label": `Notifications: ${count}`,
    children: count
  });
};
NotificationsBadge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

var css_248z$I = ".ExpandableButton-module__wrapper___JGkpB{cursor:pointer}";
var css$H = {"wrapper":"ExpandableButton-module__wrapper___JGkpB"};
styleInject(css_248z$I);

const ExpandableButton = ({
  isExpanded,
  onChange,
  width = '20px',
  color = 'var(--primary-color)'
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$H.wrapper,
    onClick: onChange,
    children: isExpanded ? /*#__PURE__*/jsx(UpArrow, {
      width: width,
      color: color
    }) : /*#__PURE__*/jsx(DownArrow, {
      width: width,
      color: color
    })
  });
};

var css_248z$H = ".ReservationProfile-module__sectionTitle___nt0bw{background-color:var(--bg-light-80);border-radius:var(--border-radius-small);color:var(--primary-color);margin-bottom:10px;padding:10px 15px}.ReservationProfile-module__tableTitle___UUNJO{border-top-left-radius:var(--border-radius-small);border-top-right-radius:var(--border-radius-small);color:var(--grey-64);font-size:var(--body-small-size);padding:10px 15px;text-transform:uppercase}.ReservationProfile-module__partialUpgradeCaption___evdJ-{display:block}.ReservationProfile-module__partialUpgradeWarning___r29sI{margin:10px 0}";
var css$G = {"sectionTitle":"ReservationProfile-module__sectionTitle___nt0bw","tableTitle":"ReservationProfile-module__tableTitle___UUNJO","partialUpgradeCaption":"ReservationProfile-module__partialUpgradeCaption___evdJ-","partialUpgradeWarning":"ReservationProfile-module__partialUpgradeWarning___r29sI"};
styleInject(css_248z$H);

const ReservationProfileSectionTitle = ({
  color,
  bgColor,
  children
}) => {
  return /*#__PURE__*/jsx("h5", {
    className: css$G.sectionTitle,
    style: {
      color: color,
      backgroundColor: bgColor
    },
    children: children
  });
};

var css_248z$G = ".DetailRow-module__detailRow___B5udn{border-bottom:1px solid var(--bg-dark);flex:1!important;padding:10px 15px!important}.DetailRow-module__detailRow___B5udn label{color:var(--grey-64);font-size:var(--label-size);font-weight:var(--label-weight);text-transform:uppercase}.DetailRow-module__detailRow___B5udn>span{color:var(--text);display:flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight)}.DetailRow-module__detailRow___B5udn>span button{margin-left:3px;padding:0}.DetailRow-module__detailRow___B5udn>span button svg{height:14px;width:14px}";
var css$F = {"detailRow":"DetailRow-module__detailRow___B5udn"};
styleInject(css_248z$G);

const DetailRow = ({
  label,
  value,
  icon,
  iconClick
}) => {
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: css$F.detailRow,
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/jsx("label", {
      children: label
    }), /*#__PURE__*/jsxs("span", {
      children: [value ?? '-', /*#__PURE__*/jsx(Button$1, {
        variant: "ghost",
        size: "small",
        onClick: iconClick,
        children: icon
      })]
    })]
  });
};

const ReservationProfileTableTitle = ({
  backgroundColor,
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$G.tableTitle,
    style: {
      backgroundColor: backgroundColor
    },
    children: children
  });
};

const ReinstateUpsellButton = ({
  onClick
}) => {
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: "Reinstate",
    position: "top",
    children: /*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      onClick: onClick,
      children: /*#__PURE__*/jsx(ArrowRefresh01, {})
    })
  });
};

const AcceptUpsellButton = ({
  onClick
}) => {
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: "Accept",
    position: "top",
    children: /*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      onClick: onClick,
      children: /*#__PURE__*/jsx(CheckCircleIcon, {
        color: colors$1.success
      })
    })
  });
};

const DenyUpsellButton = ({
  onClick
}) => {
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: "Deny",
    position: "top",
    children: /*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      onClick: onClick,
      children: /*#__PURE__*/jsx(CrossCircleIcon, {
        color: colors$1.danger
      })
    })
  });
};

const EditUpsellButton = ({
  onClick
}) => {
  return /*#__PURE__*/jsx(Tooltip$1, {
    content: "Edit",
    position: "top",
    children: /*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      onClick: onClick,
      children: /*#__PURE__*/jsx(Edit04, {})
    })
  });
};

var css_248z$F = ".TextArea-module__textAreaContainer___yFyjQ{display:flex;flex-direction:column;width:100%}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__label___vaktG{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__label___vaktG .TextArea-module__required___-aoXC{color:var(--danger);margin-left:.15rem}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textAreaWrapper___WzC-c{align-items:center;display:flex;position:relative;width:100%}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textArea___4dkXM{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-family:Just Sans,sans-serif!important;font-size:var(--body-regular-size)!important;font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;resize:vertical;transition:all .2s ease;width:100%}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textArea___4dkXM::placeholder{color:var(--grey-20)}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textArea___4dkXM:focus{background-color:var(--bg-light-48);outline:none}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textArea___4dkXM:disabled{background-color:var(--grey-8);cursor:not-allowed}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__textArea___4dkXM.TextArea-module__error___HlUbE{border-color:var(--danger)}.TextArea-module__textAreaContainer___yFyjQ .TextArea-module__errorMessage___6NdBp{color:var(--danger);font-size:.75rem;margin-top:.2rem;text-align:left}";
var css$E = {"textAreaContainer":"TextArea-module__textAreaContainer___yFyjQ","label":"TextArea-module__label___vaktG","required":"TextArea-module__required___-aoXC","textAreaWrapper":"TextArea-module__textAreaWrapper___WzC-c","textArea":"TextArea-module__textArea___4dkXM","error":"TextArea-module__error___HlUbE","errorMessage":"TextArea-module__errorMessage___6NdBp"};
styleInject(css_248z$F);

const TextArea = /*#__PURE__*/forwardRef(({
  label,
  placeholder,
  value,
  onChange,
  onKeyDown,
  error,
  required = false,
  disabled = false,
  className = '',
  name,
  rows = 4,
  autoGrow = false,
  maxHeight
}, ref) => {
  const internalRef = useRef(null);
  const setRef = node => {
    internalRef.current = node;
    if (typeof ref === 'function') {
      ref(node);
    } else if (ref) {
      ref.current = node;
    }
  };
  const resize = () => {
    const el = internalRef.current;
    if (!el) {
      return;
    }
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight}px`;
  };
  useLayoutEffect(() => {
    if (!autoGrow) {
      return;
    }
    resize();
  }, [value, autoGrow]);
  const handleChange = e => {
    onChange(e);
  };
  const handleKeyDown = e => {
    if (onKeyDown) {
      onKeyDown(e);
    }
  };
  const autoGrowStyle = autoGrow ? {
    resize: 'none',
    overflowY: maxHeight ? 'auto' : 'hidden',
    ...(maxHeight ? {
      maxHeight
    } : {})
  } : undefined;
  return /*#__PURE__*/jsxs("div", {
    className: `${css$E.textAreaContainer} ${className}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$E.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$E.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsx("div", {
      className: css$E.textAreaWrapper,
      children: /*#__PURE__*/jsx("textarea", {
        ref: setRef,
        value: value,
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        name: name,
        rows: rows,
        style: autoGrowStyle,
        className: `${css$E.textArea} ${error ? css$E.error : ''}`,
        "data-error": !!error
      })
    }), error && /*#__PURE__*/jsx("span", {
      className: css$E.errorMessage,
      children: error
    })]
  });
});
TextArea.displayName = 'TextArea';
TextArea.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  rows: PropTypes.number,
  autoGrow: PropTypes.bool,
  maxHeight: PropTypes.string
};

var css_248z$E = ".EditableRemarks-module__editableRemarks___TmkQG{background-color:var(--bg-light-80);border-radius:var(--border-radius-small);color:var(--primary-color);margin:20px 0;padding:10px 15px}.EditableRemarks-module__editableRemarks___TmkQG h5{margin:0}.EditableRemarks-module__editableRemarks___TmkQG button{padding:5px}.EditableRemarks-module__editableRemarks___TmkQG textarea{margin-bottom:10px}.EditableRemarks-module__editableRemarks___TmkQG .EditableRemarks-module__notesText___Xz5bE{color:var(--text);font-size:var(--body-regular-size)}";
var css$D = {"editableRemarks":"EditableRemarks-module__editableRemarks___TmkQG","notesText":"EditableRemarks-module__notesText___Xz5bE"};
styleInject(css_248z$E);

const EditableRemarks = ({
  reservationId,
  notes = '',
  onSave,
  apiUrl,
  formDataFieldName = 'remarks',
  type = 'GENERAL',
  title,
  isEditable = true,
  className = '',
  rows = 3,
  toast,
  posthog
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const originalNotes = notes || '';
  const [notesText, setNotesText] = useState(originalNotes);
  const [isEditingNotes, setEditingNotes] = useState(false);
  useEffect(() => {
    setNotesText(notes || '');
  }, [notes]);
  const displayTitle = typeof title === 'function' ? title(type) : title || 'Remarks';
  const submitRemarks = async () => {
    if (!apiUrl) {
      return;
    }
    try {
      posthog.capture('reservation_profile:remarks_save');
      showLoading();
      const formData = new FormData();
      formData.append(formDataFieldName, notesText);
      formData.append('type', type);
      const url = typeof apiUrl === 'function' ? apiUrl(reservationId) : apiUrl;
      await axios.post(url, formData);
      toast.success(`${displayTitle} have been saved`);
      setEditingNotes(false);
      if (onSave) {
        onSave();
      }
    } catch (error) {
      console.error(error);
      toast.error('There was an error while trying to save the remarks');
    } finally {
      hideLoading();
    }
  };
  const onEditRemarksClick = () => {
    posthog.capture('reservation_profile:remarks_edit_click');
    setEditingNotes(true);
  };
  const onCancelRemarksClick = () => {
    posthog.capture('reservation_profile:remarks_edit_cancel');
    setEditingNotes(false);
    setNotesText(originalNotes);
  };
  if (!isEditable && !notesText) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: `${css$D.editableRemarks} ${className}`,
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      justifyContent: "space-between",
      alignItems: "center",
      children: [/*#__PURE__*/jsx("h5", {
        children: displayTitle
      }), isEditable && /*#__PURE__*/jsx(Button$1, {
        variant: "ghost",
        onClick: onEditRemarksClick,
        children: /*#__PURE__*/jsx(Edit04, {
          color: colors$1.primaryColor
        })
      })]
    }), !isEditingNotes ? /*#__PURE__*/jsx("div", {
      className: css$D.notesText,
      children: notesText || ''
    }) : /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx(TextArea, {
        name: "internalRemark",
        value: notesText,
        onChange: event => setNotesText(event.target.value),
        rows: rows
      }), /*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        children: [/*#__PURE__*/jsx(Button$1, {
          onClick: submitRemarks,
          size: "small",
          children: "Save"
        }), /*#__PURE__*/jsx(Button$1, {
          variant: "tertiary",
          size: "small",
          onClick: onCancelRemarksClick,
          children: "Close"
        })]
      })]
    })]
  });
};
EditableRemarks.propTypes = {
  reservationId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  notes: PropTypes.string,
  onSave: PropTypes.func,
  apiUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  formDataFieldName: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  isEditable: PropTypes.bool,
  className: PropTypes.string,
  rows: PropTypes.number
};

const UpsellGuruLogo = ({
  width,
  color,
  className
}) => {
  return /*#__PURE__*/jsxs("svg", {
    width: width,
    viewBox: "0 0 968 120",
    fill: "none",
    className: className,
    children: [/*#__PURE__*/jsxs("g", {
      clipPath: "url(#clip0_321_1343)",
      children: [/*#__PURE__*/jsx("path", {
        d: "M91.06 106.5C82.2 115.22 69.1899 119.58 52.0399 119.58C34.8899 119.58 21.8799 115.19 13.0099 106.41C4.13995 97.6304 -0.290039 85.8604 -0.290039 71.0904V1.15039H24.74V70.2104C24.74 78.5804 27.1099 85.2404 31.8699 90.1804C36.6199 95.1204 43.3399 97.5904 52.0399 97.5904C60.7399 97.5904 67.4199 95.1204 72.1199 90.1804C76.8099 85.2404 79.16 78.5804 79.16 70.2104V1.15039H104.37V70.9104C104.37 85.9104 99.94 97.7704 91.07 106.49L91.06 106.5Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M141.87 117.49H117.1V1.16016H171.52C183.73 1.16016 193.29 4.73017 200.21 11.8902C207.13 19.0402 210.59 27.9602 210.59 38.6602C210.59 49.3602 207.1 58.1401 200.13 65.3401C193.15 72.5501 183.62 76.1501 171.53 76.1501H141.88V117.49H141.87ZM168.21 54.3502C173.21 54.3502 177.31 52.9301 180.51 50.0801C183.71 47.2301 185.31 43.4302 185.31 38.6602C185.31 33.8902 183.71 30.0901 180.51 27.2401C177.31 24.3901 173.21 22.9702 168.21 22.9702H141.87V54.3601H168.21V54.3502Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M260.97 119.58C240.27 119.58 223.88 113.42 211.79 101.09L225.22 82.2597C235.22 92.7197 247.54 97.9597 262.19 97.9597C268.58 97.9597 273.55 96.7097 277.1 94.2097C280.65 91.7097 282.42 88.6597 282.42 85.0497C282.42 81.9097 280.76 79.2897 277.45 77.1997C274.14 75.1097 270.01 73.5997 265.07 72.6697C260.13 71.7397 254.75 70.3997 248.94 68.6597C243.12 66.9197 237.75 64.9397 232.81 62.7297C227.87 60.5197 223.74 57.0297 220.43 52.2697C217.12 47.4997 215.46 41.6897 215.46 34.8297C215.46 24.8297 219.47 16.4297 227.49 9.6297C235.51 2.8297 246.21 -0.570312 259.58 -0.570312C278.07 -0.570312 293.18 4.83969 304.93 15.6497L291.15 33.7897C281.96 25.2997 270.68 21.0597 257.32 21.0597C252.09 21.0597 248.02 22.1097 245.11 24.1997C242.2 26.2897 240.75 29.1397 240.75 32.7497C240.75 35.5397 242.41 37.8997 245.72 39.8097C249.04 41.7297 253.16 43.1497 258.1 44.0797C263.04 45.0097 268.39 46.3797 274.14 48.1797C279.9 49.9797 285.24 52.0197 290.19 54.2797C295.13 56.5497 299.26 60.0997 302.57 64.9197C305.88 69.7497 307.54 75.5297 307.54 82.2697C307.54 93.4297 303.56 102.44 295.59 109.3C287.63 116.16 276.08 119.59 260.97 119.59V119.58Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M392.57 116.28H314.02V2.36035H392.57V23.7104H337.65V47.7904H391.4V69.1404H337.65V94.9304H392.57V116.28Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M469.48 116.28H398.66V2.36035H422.38V94.9304H469.48V116.28Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M547.38 116.28H476.56V2.36035H500.28V94.9304H547.38V116.28Z",
        fill: color ?? '#002D6B'
      }), /*#__PURE__*/jsx("path", {
        d: "M606.72 116.97C590 116.97 575.93 111.57 564.51 100.76C553.09 89.9498 547.37 75.8798 547.37 58.5498C547.37 41.2198 553.08 27.0298 564.51 16.3398C575.93 5.64981 590.01 0.299805 606.72 0.299805C627 0.299805 642.39 8.68981 652.86 25.4598L633.13 36.2698C630.45 31.9898 626.8 28.4798 622.18 25.7198C617.55 22.9598 612.4 21.5798 606.71 21.5798C596.57 21.5798 588.21 25.0698 581.63 32.0498C575.05 39.0298 571.77 47.8698 571.77 58.5598C571.77 69.2498 575.06 78.0898 581.63 85.0698C588.21 92.0498 596.56 95.5398 606.71 95.5398C611.39 95.5398 615.91 94.6998 620.25 93.0098C624.6 91.3198 627.99 89.2898 630.45 86.9298V73.4198H601.03V52.4798H654.19V95.7098C641.59 109.89 625.77 116.99 606.71 116.99L606.72 116.97Z",
        fill: color ?? '#5C6EBB'
      }), /*#__PURE__*/jsx("path", {
        d: "M749.19 105.63C740.81 114.35 728.52 118.71 712.31 118.71C696.1 118.71 683.8 114.32 675.42 105.54C667.04 96.7603 662.85 84.9903 662.85 70.2203V0.280273H686.51V69.3403C686.51 77.7103 688.75 84.3703 693.25 89.3103C697.74 94.2503 704.09 96.7203 712.31 96.7203C720.53 96.7203 726.85 94.2503 731.29 89.3103C735.73 84.3703 737.94 77.7103 737.94 69.3403V0.280273H761.76V70.0403C761.76 85.0403 757.57 96.9003 749.19 105.62V105.63Z",
        fill: color ?? '#5C6EBB'
      }), /*#__PURE__*/jsx("path", {
        d: "M955.72 105.63C947.34 114.35 935.05 118.71 918.84 118.71C902.63 118.71 890.33 114.32 881.95 105.54C873.57 96.7603 869.38 84.9903 869.38 70.2203V0.280273H893.04V69.3403C893.04 77.7103 895.28 84.3703 899.78 89.3103C904.27 94.2503 910.62 96.7203 918.84 96.7203C927.06 96.7203 933.38 94.2503 937.82 89.3103C942.26 84.3703 944.47 77.7103 944.47 69.3403V0.280273H968.29V70.0403C968.29 85.0403 964.1 96.9003 955.72 105.62V105.63Z",
        fill: color ?? '#5C6EBB'
      }), /*#__PURE__*/jsx("path", {
        d: "M864.44 116.62H836.01L813.16 75.28H795.02V116.62H770.25V0.290039H824.67C836.65 0.290039 846.15 3.78003 853.19 10.75C860.22 17.73 863.74 26.74 863.74 37.78C863.74 47.31 861.27 55.05 856.33 60.98C851.39 66.91 845.37 70.69 838.28 72.32L864.44 116.62ZM821.02 53.48C826.13 53.48 830.32 52.06 833.58 49.21C836.83 46.36 838.46 42.56 838.46 37.79C838.46 33.02 836.83 29.22 833.58 26.37C830.32 23.52 826.14 22.1 821.02 22.1H795.03V53.49H821.02V53.48Z",
        fill: color ?? '#5C6EBB'
      })]
    }), /*#__PURE__*/jsx("defs", {
      children: /*#__PURE__*/jsx("clipPath", {
        id: "clip0_321_1343",
        children: /*#__PURE__*/jsx("rect", {
          width: "968",
          height: "120",
          fill: "white"
        })
      })
    })]
  });
};

var css_248z$D = ".StatusLegend-module__legend___4jmS5{padding-bottom:20px}.StatusLegend-module__items___ehIQL{flex-wrap:nowrap!important}@media (max-width:768px){.StatusLegend-module__items___ehIQL{flex-wrap:wrap!important;gap:8px 16px!important}.StatusLegend-module__items___ehIQL>*{flex:0 0 calc(50% - 8px)}}";
var css$C = {"legend":"StatusLegend-module__legend___4jmS5","items":"StatusLegend-module__items___ehIQL"};
styleInject(css_248z$D);

const StatusLegend = ({
  children
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css$C.legend,
    children: /*#__PURE__*/jsx(FlexContainer, {
      alignItems: "center",
      gap: 16,
      flexFlow: "wrap",
      className: css$C.items,
      children: children
    })
  });
};

var css_248z$C = ".StatusBox-module__statusBox___P-Fdt{border-radius:3px;display:inline-block;flex-shrink:0;height:12px;width:12px}";
var css$B = {"statusBox":"StatusBox-module__statusBox___P-Fdt"};
styleInject(css_248z$C);

const StatusBox = ({
  color,
  label
}) => /*#__PURE__*/jsx("span", {
  className: css$B.statusBox,
  style: {
    backgroundColor: color
  },
  title: label,
  "aria-label": label
});
StatusBox.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string
};

var css_248z$B = ".StatusLegendItem-module__item___f5jfF{align-items:center;background:transparent;border:none;border-radius:var(--border-radius-small);color:inherit;display:inline-flex;font:inherit;gap:8px;padding:4px 8px}.StatusLegendItem-module__item___f5jfF.StatusLegendItem-module__clickable___gsOlf{cursor:pointer;transition:background-color .2s ease,box-shadow .2s ease}.StatusLegendItem-module__item___f5jfF.StatusLegendItem-module__clickable___gsOlf:hover{background-color:var(--bg-light-48)}.StatusLegendItem-module__item___f5jfF.StatusLegendItem-module__active___fw3pY{background-color:var(--bg-light-48);box-shadow:0 0 0 2px var(--primary-color)}.StatusLegendItem-module__iconSlot___dSt49{align-items:center;display:flex;flex-shrink:0;justify-content:center}.StatusLegendItem-module__label___Uwsjo{color:var(--grey-64);font-size:var(--body-regular-size);white-space:nowrap}@media (max-width:768px){.StatusLegendItem-module__label___Uwsjo{font-size:var(--body-xs-size)}}";
var css$A = {"item":"StatusLegendItem-module__item___f5jfF","clickable":"StatusLegendItem-module__clickable___gsOlf","active":"StatusLegendItem-module__active___fw3pY","iconSlot":"StatusLegendItem-module__iconSlot___dSt49","label":"StatusLegendItem-module__label___Uwsjo"};
styleInject(css_248z$B);

const StatusLegendItem = ({
  label,
  color,
  icon,
  isActive = false,
  onClick
}) => {
  const isClickable = !!onClick;
  const itemClassName = [css$A.item, isClickable ? css$A.clickable : '', isActive ? css$A.active : ''].filter(Boolean).join(' ');
  const visual = icon ? /*#__PURE__*/jsx("span", {
    className: css$A.iconSlot,
    children: icon
  }) : /*#__PURE__*/jsx(StatusBox, {
    color: color
  });
  if (isClickable) {
    return /*#__PURE__*/jsxs("button", {
      type: "button",
      className: itemClassName,
      onClick: onClick,
      children: [visual, /*#__PURE__*/jsx("span", {
        className: css$A.label,
        children: label
      })]
    });
  }
  return /*#__PURE__*/jsxs("div", {
    className: itemClassName,
    children: [visual, /*#__PURE__*/jsx("span", {
      className: css$A.label,
      children: label
    })]
  });
};

var css_248z$A = ".ProgressBar-module__track___vjybM{background:var(--bg-dark);border-radius:3px;overflow:hidden;width:100%}.ProgressBar-module__fill___MAyGB{background:var(--primary-color);border-radius:3px;height:100%;transition:width .3s ease}";
var css$z = {"track":"ProgressBar-module__track___vjybM","fill":"ProgressBar-module__fill___MAyGB"};
styleInject(css_248z$A);

const ProgressBar = ({
  value,
  max = 100,
  height = 6,
  color
}) => {
  const percentage = max > 0 ? Math.min(value / max * 100, 100) : 0;
  return /*#__PURE__*/jsx("div", {
    className: css$z.track,
    style: {
      height
    },
    children: /*#__PURE__*/jsx("div", {
      className: css$z.fill,
      style: {
        width: `${percentage}%`,
        backgroundColor: color || undefined
      }
    })
  });
};

const hotelNamePlain = (name, city, isDemoMode) => {
  return isDemoMode ? city?.name ? `Hotel in ${city?.name}` : 'Demo Hotel' : name;
};

const INTERACTION_LABELS = {
  EMAIL_SENT: {
    text: 'Email Sent',
    backgroundColor: colors$1.tips20,
    color: colors$1.tips
  },
  EMAIL_OPENED: {
    text: 'Email Open',
    backgroundColor: colors$1.tips20,
    color: colors$1.tips
  },
  EMAIL_CLICKED: {
    text: 'Email Clicked',
    variant: 'warning'
  },
  ROOM_UPGRADE_PENDING: {
    text: 'Pending Room',
    variant: 'warning'
  },
  EXTRA_SERVICES_PENDING: {
    text: 'Pending Extra',
    variant: 'warning'
  },
  UPGRADE_CONFIRMED: {
    text: 'Confirmed Room',
    variant: 'success'
  },
  UPGRADE_DENIED: {
    text: 'Denied Room',
    variant: 'danger'
  },
  TRANSACTION: {
    text: 'Transaction',
    variant: 'success'
  }
};
const PreArrivalInteractionLabel = ({
  preArrivalInteraction,
  abandonedCart,
  reservation
}) => {
  if (!preArrivalInteraction) {
    return null;
  }
  if (preArrivalInteraction === 'ABANDONED_CART' && abandonedCart) {
    return /*#__PURE__*/jsx(AbandonedCartInteraction, {
      abandonedCart: abandonedCart,
      reservation: reservation
    });
  }
  const config = INTERACTION_LABELS[preArrivalInteraction];
  if (!config) {
    return null;
  }
  if (config.variant) {
    return /*#__PURE__*/jsx(Label, {
      variant: config.variant,
      children: config.text
    });
  }
  return /*#__PURE__*/jsx(Label, {
    backgroundColor: config.backgroundColor,
    color: config.color,
    children: config.text
  });
};
const AbandonedCartInteraction = ({
  abandonedCart,
  reservation
}) => {
  const {
    currentHotel
  } = useCurrentHotel();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx("span", {
      style: {
        cursor: 'pointer'
      },
      onClick: handleOpenModal,
      children: /*#__PURE__*/jsxs(FlexContainer, {
        alignItems: "center",
        children: [/*#__PURE__*/jsx(Label, {
          variant: "danger",
          children: "Abandoned Cart"
        }), /*#__PURE__*/jsx(InformationCircleContained, {
          color: colors$1.grey64
        })]
      })
    }), isModalOpen && /*#__PURE__*/jsxs(Modal, {
      title: "Abandoned Cart Items",
      onClose: handleCloseModal,
      isOpen: true,
      children: [abandonedCart.upgrades && abandonedCart.upgrades.length > 0 && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(CardTitle, {
          children: "Room Upgrades"
        }), abandonedCart.upgrades.map((item, index) => /*#__PURE__*/jsxs("p", {
          style: {
            marginBottom: '10px'
          },
          children: ["- ", item.name, " - ", /*#__PURE__*/jsx("b", {
            children: formatCurrency(item.amount, currentHotel?.currency)
          }), "\xA0(", formatCurrency(item.amount / (reservation?.nights || 1), currentHotel?.currency), " /per night)"]
        }, index))]
      }), abandonedCart.extras && abandonedCart.extras.length > 0 && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(CardTitle, {
          children: "Extra Services"
        }), abandonedCart.extras.map((item, index) => /*#__PURE__*/jsxs("p", {
          style: {
            marginBottom: '10px'
          },
          children: [/*#__PURE__*/jsxs("b", {
            children: [item.quantity, "x"]
          }), " ", item.name, item.variation && /*#__PURE__*/jsx(Label, {
            backgroundColor: colors$1.primary20,
            color: colors$1.primaryColor,
            children: item.variation.name
          }), ' ', "- ", /*#__PURE__*/jsx("b", {
            children: formatCurrency(item.price, currentHotel?.currency)
          })]
        }, index))]
      })]
    })]
  });
};
PreArrivalInteractionLabel.propTypes = {
  preArrivalInteraction: PropTypes.string,
  abandonedCart: PropTypes.object,
  reservation: PropTypes.object
};

var css_248z$z = ".ReservationProfileDetails-module__reservationDetails___0S9IA{flex:1}.ReservationProfileDetails-module__reservationDetails___0S9IA>label{margin-bottom:0!important}.ReservationProfileDetails-module__detailPair___9ziGy{width:100%}.ReservationProfileDetails-module__noWrap___ynDnz{white-space:nowrap}@media (max-width:768px){.ReservationProfileDetails-module__reservationDetails___0S9IA{flex:1 1 100%!important;width:100%}.ReservationProfileDetails-module__detailPair___9ziGy{flex-direction:column!important;gap:0!important}}";
var css$y = {"reservationDetails":"ReservationProfileDetails-module__reservationDetails___0S9IA","detailPair":"ReservationProfileDetails-module__detailPair___9ziGy","noWrap":"ReservationProfileDetails-module__noWrap___ynDnz"};
styleInject(css_248z$z);

/*! @license DOMPurify 3.4.15 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.15/LICENSE */

function _arrayLikeToArray$3(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles$2(r) {
  if (Array.isArray(r)) return r;
}
function _iterableToArrayLimit$2(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = true,
      o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) ; else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = true, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray$2(r, e) {
  return _arrayWithHoles$2(r) || _iterableToArrayLimit$2(r, e) || _unsupportedIterableToArray$3(r, e) || _nonIterableRest$2();
}
function _unsupportedIterableToArray$3(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$3(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0;
  }
}

const entries = Object.entries,
  setPrototypeOf = Object.setPrototypeOf,
  isFrozen = Object.isFrozen,
  getPrototypeOf = Object.getPrototypeOf,
  getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
let freeze = Object.freeze,
  seal = Object.seal,
  create = Object.create; // eslint-disable-line import/no-mutable-exports
let _ref = typeof Reflect !== 'undefined' && Reflect,
  apply = _ref.apply,
  construct = _ref.construct;
if (!freeze) {
  freeze = function freeze(x) {
    return x;
  };
}
if (!seal) {
  seal = function seal(x) {
    return x;
  };
}
if (!apply) {
  apply = function apply(func, thisArg) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }
    return func.apply(thisArg, args);
  };
}
if (!construct) {
  construct = function construct(Func) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return new Func(...args);
  };
}
const arrayForEach = unapply(Array.prototype.forEach);
const arrayLastIndexOf = unapply(Array.prototype.lastIndexOf);
const arrayPop = unapply(Array.prototype.pop);
const arrayPush = unapply(Array.prototype.push);
const arraySplice = unapply(Array.prototype.splice);
const arrayIsArray = Array.isArray;
const stringToLowerCase = unapply(String.prototype.toLowerCase);
const stringToString = unapply(String.prototype.toString);
const stringMatch = unapply(String.prototype.match);
const stringReplace = unapply(String.prototype.replace);
const stringIndexOf = unapply(String.prototype.indexOf);
const stringTrim = unapply(String.prototype.trim);
const numberToString = unapply(Number.prototype.toString);
const booleanToString = unapply(Boolean.prototype.toString);
const bigintToString = typeof BigInt === 'undefined' ? null : unapply(BigInt.prototype.toString);
const symbolToString = typeof Symbol === 'undefined' ? null : unapply(Symbol.prototype.toString);
const objectHasOwnProperty = unapply(Object.prototype.hasOwnProperty);
const objectToString = unapply(Object.prototype.toString);
const regExpTest = unapply(RegExp.prototype.test);
const typeErrorCreate = unconstruct(TypeError);
/**
 * Creates a new function that calls the given function with a specified thisArg and arguments.
 *
 * @param func - The function to be wrapped and called.
 * @returns A new function that calls the given function with a specified thisArg and arguments.
 */
function unapply(func) {
  return function (thisArg) {
    if (thisArg instanceof RegExp) {
      thisArg.lastIndex = 0;
    }
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return apply(func, thisArg, args);
  };
}
/**
 * Creates a new function that constructs an instance of the given constructor function with the provided arguments.
 *
 * @param func - The constructor function to be wrapped and called.
 * @returns A new function that constructs an instance of the given constructor function with the provided arguments.
 */
function unconstruct(Func) {
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return construct(Func, args);
  };
}
/**
 * Add properties to a lookup table
 *
 * @param set - The set to which elements will be added.
 * @param array - The array containing elements to be added to the set.
 * @param transformCaseFunc - An optional function to transform the case of each element before adding to the set.
 * @returns The modified set with added elements.
 */
function addToSet(set, array) {
  let transformCaseFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : stringToLowerCase;
  if (setPrototypeOf) {
    // Make 'in' and truthy checks like Boolean(set.constructor)
    // independent of any properties defined on Object.prototype.
    // Prevent prototype setters from intercepting set as a this value.
    setPrototypeOf(set, null);
  }
  if (!arrayIsArray(array)) {
    return set;
  }
  let l = array.length;
  while (l--) {
    let element = array[l];
    if (typeof element === 'string') {
      const lcElement = transformCaseFunc(element);
      if (lcElement !== element) {
        // Config presets (e.g. tags.js, attrs.js) are immutable.
        if (!isFrozen(array)) {
          array[l] = lcElement;
        }
        element = lcElement;
      }
    }
    set[element] = true;
  }
  return set;
}
/**
 * Clean up an array to harden against CSPP
 *
 * @param array - The array to be cleaned.
 * @returns The cleaned version of the array
 */
function cleanArray(array) {
  for (let index = 0; index < array.length; index++) {
    const isPropertyExist = objectHasOwnProperty(array, index);
    if (!isPropertyExist) {
      array[index] = null;
    }
  }
  return array;
}
/**
 * Shallow clone an object
 *
 * @param object - The object to be cloned.
 * @returns A new object that copies the original.
 */
function clone$2(object) {
  const newObject = create(null);
  for (const _ref2 of entries(object)) {
    var _ref3 = _slicedToArray$2(_ref2, 2);
    const property = _ref3[0];
    const value = _ref3[1];
    const isPropertyExist = objectHasOwnProperty(object, property);
    if (isPropertyExist) {
      if (arrayIsArray(value)) {
        newObject[property] = cleanArray(value);
      } else if (value && typeof value === 'object' && value.constructor === Object) {
        newObject[property] = clone$2(value);
      } else {
        newObject[property] = value;
      }
    }
  }
  return newObject;
}
/**
 * Convert non-node values into strings without depending on direct property access.
 *
 * @param value - The value to stringify.
 * @returns A string representation of the provided value.
 */
function stringifyValue(value) {
  switch (typeof value) {
    case 'string':
      {
        return value;
      }
    case 'number':
      {
        return numberToString(value);
      }
    case 'boolean':
      {
        return booleanToString(value);
      }
    case 'bigint':
      {
        return bigintToString ? bigintToString(value) : '0';
      }
    case 'symbol':
      {
        return symbolToString ? symbolToString(value) : 'Symbol()';
      }
    case 'undefined':
      {
        return objectToString(value);
      }
    case 'function':
    case 'object':
      {
        if (value === null) {
          return objectToString(value);
        }
        const valueAsRecord = value;
        const valueToString = lookupGetter(valueAsRecord, 'toString');
        if (typeof valueToString === 'function') {
          const stringified = valueToString(valueAsRecord);
          return typeof stringified === 'string' ? stringified : objectToString(stringified);
        }
        return objectToString(value);
      }
    default:
      {
        return objectToString(value);
      }
  }
}
/**
 * This method automatically checks if the prop is function or getter and behaves accordingly.
 *
 * @param object - The object to look up the getter function in its prototype chain.
 * @param prop - The property name for which to find the getter function.
 * @returns The getter function found in the prototype chain or a fallback function.
 */
function lookupGetter(object, prop) {
  while (object !== null) {
    const desc = getOwnPropertyDescriptor(object, prop);
    if (desc) {
      if (desc.get) {
        return unapply(desc.get);
      }
      if (typeof desc.value === 'function') {
        return unapply(desc.value);
      }
    }
    object = getPrototypeOf(object);
  }
  function fallbackValue() {
    return null;
  }
  return fallbackValue;
}
function isRegex(value) {
  try {
    regExpTest(value, '');
    return true;
  } catch (_unused) {
    return false;
  }
}

const html$1 = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'search', 'section', 'select', 'shadow', 'slot', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);
const svg$1 = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'enterkeyhint', 'exportparts', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'inputmode', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'part', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);
const svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feDropShadow', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);
// List of SVG elements that are disallowed by default.
// We still need to know them so that we can do namespace
// checks properly in case one wants to add them to
// allow-list.
const svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);
const mathMl$1 = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover', 'mprescripts']);
// Similarly to SVG, we want to know all MathML elements,
// even those that we disallow by default.
const mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);
const text = freeze(['#text']);

const html = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'command', 'commandfor', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'exportparts', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inert', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'nonce', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'part', 'pattern', 'placeholder', 'playsinline', 'popover', 'popovertarget', 'popovertargetaction', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'slot', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'wrap', 'xmlns']);
const svg = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'amplitude', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dominant-baseline', 'dur', 'edgemode', 'elevation', 'end', 'exponent', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'intercept', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'mask-type', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'pointer-events', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'slope', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'tablevalues', 'targetx', 'targety', 'transform', 'transform-origin', 'text-anchor', 'text-decoration', 'text-orientation', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'vector-effect', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);
const mathMl = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnalign', 'columnlines', 'columnspacing', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lquote', 'lspace', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);
const xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

const MUSTACHE_EXPR = seal(/{{[\w\W]*|^[\w\W]*}}/g);
const ERB_EXPR = seal(/<%[\w\W]*|^[\w\W]*%>/g);
const TMPLIT_EXPR = seal(/\${[\w\W]*/g);
const DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
const ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
const IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
);
const IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
const ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
);
const DOCTYPE_NAME = seal(/^html$/i);
const CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
// Markup-significant character probes used by _sanitizeElements.
// Shared module-level instances are safe despite the sticky /g flags:
// unapply() resets lastIndex for RegExp receivers before every call.
const ELEMENT_MARKUP_PROBE = seal(/<[/\w!]/g);
const COMMENT_MARKUP_PROBE = seal(/<[/\w]/g);
const FALLBACK_TAG_CLOSE = seal(/<\/no(script|embed|frames)/i);
const SELF_CLOSING_TAG = seal(/\/>/i);

// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType
const NODE_TYPE = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12 // Deprecated
};
/* HTML-namespace elements whose child text nodes are serialized *literally*
   (unescaped) by the HTML fragment-serialization algorithm. Two reparse-mXSS
   shapes ride on that literal serialization:
     (a) an element child - a tree the HTML parser can never build, but the DOM
         API and an XML/XHTML parse can - after which a `</tag>`-bearing text
         sibling breaks the element open on reparse; and
     (b) text-only content that already carries the element's OWN end tag, e.g.
         `<style>...</style><img onerror=x>` built as a node, which the literal
         serializer emits verbatim for the HTML parser to re-open.
   Shape (a) is handled by the firstElementChild branch in _isUnsafeNode; shape
   (b) by the LITERAL_TEXT_CLOSE probe. Both read textContent (the raw-serialized
   form for these elements) rather than innerHTML, because an XML/XHTML working
   document serializes innerHTML with `<` escaped, which silently blinds the
   innerHTML-based probes (rule 1's second probe and FALLBACK_TAG_CLOSE) there.
   `script` is never allow-listed, but is kept here so the guard matches the
   serializer's own literal-text list exactly. */
const LITERAL_TEXT_ELEMENT_NAMES = ['style', 'script', 'xmp', 'iframe', 'noembed', 'noframes', 'plaintext', 'noscript'];
const LITERAL_TEXT_ELEMENTS = freeze(addToSet({}, LITERAL_TEXT_ELEMENT_NAMES));
/* Per-element end-tag matcher. On an HTML reparse the ONLY token that
   terminates a literal-text element's raw content is its own end tag; a foreign
   literal-text close (e.g. `</xmp>` sitting inside `<style>`) does not break
   out, so matching is per-element, not a shared alternation. The lookahead
   requires an HTML tag-name terminator (whitespace, `/` or `>`) so a longer
   name such as `</styles` is not mistaken for `</style`. */
const LITERAL_TEXT_CLOSE = function () {
  const map = {};
  arrayForEach(LITERAL_TEXT_ELEMENT_NAMES, name => {
    map[name] = seal(new RegExp('</' + name + '(?=[\\t\\n\\f\\r />])', 'i'));
  });
  return freeze(map);
}();
const getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};
/**
 * Creates a no-op policy for internal use only.
 * Don't export this function outside this module!
 * @param trustedTypes The policy factory.
 * @param purifyHostElement The Script element used to load DOMPurify (to determine policy name suffix).
 * @return The policy created (or null, if Trusted Types
 * are not supported or creating the policy failed).
 */
const _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, purifyHostElement) {
  if (typeof trustedTypes !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
    return null;
  }
  // Allow the callers to control the unique policy name
  // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
  // Policy creation with duplicate names throws in Trusted Types.
  let suffix = null;
  const ATTR_NAME = 'data-tt-policy-suffix';
  if (purifyHostElement && purifyHostElement.hasAttribute(ATTR_NAME)) {
    suffix = purifyHostElement.getAttribute(ATTR_NAME);
  }
  const policyName = 'dompurify' + (suffix ? '#' + suffix : '');
  try {
    return trustedTypes.createPolicy(policyName, {
      createHTML(html) {
        return html;
      },
      createScriptURL(scriptUrl) {
        return scriptUrl;
      }
    });
  } catch (_) {
    // Policy creation failed (most likely another DOMPurify script has
    // already run). Skip creating the policy, as this will only cause errors
    // if TT are enforced.
    console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
    return null;
  }
};
const _createHooksMap = function _createHooksMap() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
/**
 * Resolve a set-valued configuration option: a fresh set built from
 * cfg[key] when it is an own array property (seeded with a clone of
 * options.base when given, case-normalized via options.transform),
 * the fallback set otherwise.
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param fallback the set to use when the option is absent or not an array
 * @param options transform and optional base set to merge into
 * @returns the resolved set
 */
const _resolveSetOption = function _resolveSetOption(cfg, key, fallback, options) {
  return objectHasOwnProperty(cfg, key) && arrayIsArray(cfg[key]) ? addToSet(options.base ? clone$2(options.base) : {}, cfg[key], options.transform) : fallback;
};
/**
 * Resolve an object-valued configuration option: a prototype-free clone
 * of cfg[key] when it is an own, truthy object property, else a fresh
 * fallback built by makeFallback (fresh on every parse, so a previous
 * parse can never leak state into the next one).
 *
 * @param cfg the cloned, prototype-free configuration object
 * @param key the configuration property to read
 * @param makeFallback builds the fallback value when the option is absent
 * @returns the resolved object
 */
const _resolveObjectOption = function _resolveObjectOption(cfg, key, makeFallback) {
  const value = objectHasOwnProperty(cfg, key) ? cfg[key] : undefined;
  return value && typeof value === 'object' ? clone$2(value) : makeFallback();
};
function createDOMPurify() {
  let window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
  const DOMPurify = root => createDOMPurify(root);
  DOMPurify.version = '3.4.15';
  DOMPurify.removed = [];
  if (!window || !window.document || window.document.nodeType !== NODE_TYPE.document || !window.Element) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;
    return DOMPurify;
  }
  let document = window.document;
  const originalDocument = document;
  const currentScript = originalDocument.currentScript;
  window.DocumentFragment;
    const HTMLTemplateElement = window.HTMLTemplateElement,
    Node = window.Node,
    Element = window.Element,
    NodeFilter = window.NodeFilter,
    _window$NamedNodeMap = window.NamedNodeMap;
    _window$NamedNodeMap === void 0 ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap;
    window.HTMLFormElement;
    const DOMParser = window.DOMParser,
    trustedTypes = window.trustedTypes;
  const ElementPrototype = Element.prototype;
  const cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
  const remove = lookupGetter(ElementPrototype, 'remove');
  // Clobber-safe Attr-node removal. On an HTMLFormElement a descendant named
  // "removeAttributeNode" shadows the prototype method via
  // [LegacyOverrideBuiltIns], so element.removeAttributeNode(attr) throws.
  // Calling the cached Element.prototype method with the element as the
  // receiver removes the exact live Attr node regardless of the shadowing.
  const removeAttributeNode = lookupGetter(ElementPrototype, 'removeAttributeNode');
  const getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
  const getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
  const getParentNode = lookupGetter(ElementPrototype, 'parentNode');
  const getShadowRoot = lookupGetter(ElementPrototype, 'shadowRoot');
  const getAttributes = lookupGetter(ElementPrototype, 'attributes');
  const getNodeType = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeType') : null;
  const getNodeName = Node && Node.prototype ? lookupGetter(Node.prototype, 'nodeName') : null;
  const getOwnerDocument = Node && Node.prototype ? lookupGetter(Node.prototype, 'ownerDocument') : null;
  /* Clobber-safe nodeType / nodeName reads through the cached Node.prototype
     getters, with a direct-property fallback for environments that lack
     Node.prototype. Sites that need a different fallback (e.g. _isClobbered
     returns early on a null name) intentionally keep their own reads. */
  const _readNodeType = function _readNodeType(node) {
    return getNodeType ? getNodeType(node) : node.nodeType;
  };
  const _readNodeName = function _readNodeName(node) {
    return getNodeName ? getNodeName(node) : node.nodeName;
  };
  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.
  if (typeof HTMLTemplateElement === 'function') {
    const template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }
  let trustedTypesPolicy;
  let emptyHTML = '';
  // The instance's own internal Trusted Types policy. Unlike a caller-supplied
  // `TRUSTED_TYPES_POLICY`, this is created at most once — Trusted Types throws
  // on duplicate policy names — and is the only policy allowed to persist
  // across configurations and survive `clearConfig()`.
  let defaultTrustedTypesPolicy;
  let defaultTrustedTypesPolicyResolved = false;
  // Tracks whether we are already inside a call to the configured Trusted Types
  // policy (`createHTML` or `createScriptURL`). If a supplied policy callback
  // itself calls `DOMPurify.sanitize` (the cause of #1422), `sanitize` would
  // re-enter the policy and recurse until the stack overflows. We detect that
  // re-entry and throw a clear, actionable error instead. The guard is shared
  // across both callbacks, because either one re-entering `sanitize` triggers
  // the same unbounded recursion.
  let IN_TRUSTED_TYPES_POLICY = 0;
  const _assertNotInTrustedTypesPolicy = function _assertNotInTrustedTypesPolicy() {
    if (IN_TRUSTED_TYPES_POLICY > 0) {
      throw typeErrorCreate('A configured TRUSTED_TYPES_POLICY callback (createHTML or ' + 'createScriptURL) must not call DOMPurify.sanitize, as that causes ' + 'infinite recursion. Do not pass a policy whose callbacks wrap ' + 'DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted ' + 'Types" section of the README.');
    }
  };
  const _createTrustedHTML = function _createTrustedHTML(html) {
    _assertNotInTrustedTypesPolicy();
    IN_TRUSTED_TYPES_POLICY++;
    try {
      return trustedTypesPolicy.createHTML(html);
    } finally {
      IN_TRUSTED_TYPES_POLICY--;
    }
  };
  const _createTrustedScriptURL = function _createTrustedScriptURL(scriptUrl) {
    _assertNotInTrustedTypesPolicy();
    IN_TRUSTED_TYPES_POLICY++;
    try {
      return trustedTypesPolicy.createScriptURL(scriptUrl);
    } finally {
      IN_TRUSTED_TYPES_POLICY--;
    }
  };
  // Lazily resolve (and cache) the instance's internal default policy.
  // Resolution is attempted at most once: a successful `createPolicy` cannot be
  // repeated (Trusted Types throws on duplicate names), and a failed or
  // unsupported attempt must not be retried on every parse.
  const _getDefaultTrustedTypesPolicy = function _getDefaultTrustedTypesPolicy() {
    if (!defaultTrustedTypesPolicyResolved) {
      defaultTrustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, currentScript);
      defaultTrustedTypesPolicyResolved = true;
    }
    return defaultTrustedTypesPolicy;
  };
  const _document = document,
    implementation = _document.implementation,
    createNodeIterator = _document.createNodeIterator,
    createDocumentFragment = _document.createDocumentFragment,
    getElementsByTagName = _document.getElementsByTagName;
  const importNode = originalDocument.importNode;
  let hooks = _createHooksMap();
  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = typeof entries === 'function' && typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined;
  const MUSTACHE_EXPR$1 = MUSTACHE_EXPR,
    ERB_EXPR$1 = ERB_EXPR,
    TMPLIT_EXPR$1 = TMPLIT_EXPR,
    DATA_ATTR$1 = DATA_ATTR,
    ARIA_ATTR$1 = ARIA_ATTR,
    IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA,
    ATTR_WHITESPACE$1 = ATTR_WHITESPACE,
    CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
  let IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */
  /* allowed element names */
  let ALLOWED_TAGS = null;
  const DEFAULT_ALLOWED_TAGS = addToSet({}, [...html$1, ...svg$1, ...svgFilters, ...mathMl$1, ...text]);
  /* Allowed attribute names */
  let ALLOWED_ATTR = null;
  const DEFAULT_ALLOWED_ATTR = addToSet({}, [...html, ...svg, ...mathMl, ...xml]);
  /*
   * Configure how DOMPurify should handle custom elements and their attributes as well as customized built-in elements.
   * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
   * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
   * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
   */
  let CUSTOM_ELEMENT_HANDLING = Object.seal(create(null, {
    tagNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeNameCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: false
    }
  }));
  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  let FORBID_TAGS = null;
  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  let FORBID_ATTR = null;
  /* Config object to store ADD_TAGS/ADD_ATTR functions (when used as functions) */
  const EXTRA_ELEMENT_HANDLING = Object.seal(create(null, {
    tagCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    },
    attributeCheck: {
      writable: true,
      configurable: false,
      enumerable: true,
      value: null
    }
  }));
  /* Decide if ARIA attributes are okay */
  let ALLOW_ARIA_ATTR = true;
  /* Decide if custom data attributes are okay */
  let ALLOW_DATA_ATTR = true;
  /* Decide if unknown protocols are okay */
  let ALLOW_UNKNOWN_PROTOCOLS = false;
  /* Decide if self-closing tags in attributes are allowed.
   * Usually removed due to a mXSS issue in jQuery 3.0 */
  let ALLOW_SELF_CLOSE_IN_ATTR = true;
  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  let SAFE_FOR_TEMPLATES = false;
  /* Output should be safe even for XML used within HTML and alike.
   * This means, DOMPurify removes comments when containing risky content.
   */
  let SAFE_FOR_XML = true;
  /* Decide if document with <html>... should be returned */
  let WHOLE_DOCUMENT = false;
  /* Track whether config is already set on this instance of DOMPurify. */
  let SET_CONFIG = false;
  /* Pristine allowlist bindings captured at setConfig() time. On the
   * persistent-config path sanitize() restores the sets from these before
   * the per-walk hook clone-guard, so a hook's in-call widening cannot
   * carry across calls. Null until setConfig() is called; reset by
   * clearConfig(). */
  let SET_CONFIG_ALLOWED_TAGS = null;
  let SET_CONFIG_ALLOWED_ATTR = null;
  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  let FORCE_BODY = false;
  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
   * string (or a TrustedHTML object if Trusted Types are supported).
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  let RETURN_DOM = false;
  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
   * string  (or a TrustedHTML object if Trusted Types are supported) */
  let RETURN_DOM_FRAGMENT = false;
  /* Try to return a Trusted Type object instead of a string, return a string in
   * case Trusted Types are not supported  */
  let RETURN_TRUSTED_TYPE = false;
  /* Output should be free from DOM clobbering attacks?
   * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
   */
  let SANITIZE_DOM = true;
  /* Achieve full DOM Clobbering protection by isolating the namespace of named
   * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
   *
   * HTML/DOM spec rules that enable DOM Clobbering:
   *   - Named Access on Window (§7.3.3)
   *   - DOM Tree Accessors (§3.1.5)
   *   - Form Element Parent-Child Relations (§4.10.3)
   *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
   *   - HTMLCollection (§4.2.10.2)
   *
   * Namespace isolation is implemented by prefixing `id` and `name` attributes
   * with a constant string, i.e., `user-content-`
   */
  let SANITIZE_NAMED_PROPS = false;
  const SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
  /* Keep element content when removing element? */
  let KEEP_CONTENT = true;
  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  let IN_PLACE = false;
  /* Allow usage of profiles like html, svg and mathMl */
  let USE_PROFILES = {};
  /* Tags to ignore content of when KEEP_CONTENT is true */
  let FORBID_CONTENTS = null;
  const DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script',
  // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
  // the UA (customizable <select>) — including any on* handlers — and the
  // engine re-mirrors synchronously whenever a removal changes which
  // option/selectedcontent is current, even inside DOMPurify's inert
  // DOMParser document. Hoisting its children on removal re-inserts a fresh
  // mirror target ahead of the walk, which the engine refills, looping
  // forever (DoS) and amplifying output. Dropping its content on removal
  // (rather than hoisting) breaks that cascade; the content is a duplicate
  // of the option, which is sanitized on its own. See campaign-3 F1/F6.
  'selectedcontent', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);
  /* Tags that are safe for data: URIs */
  let DATA_URI_TAGS = null;
  const DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);
  /* Attributes safe for values like "javascript:" */
  let URI_SAFE_ATTRIBUTES = null;
  const DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);
  const MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
  const SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
  const HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
  /* Document namespace */
  let NAMESPACE = HTML_NAMESPACE;
  let IS_EMPTY_INPUT = false;
  /* Allowed XHTML+XML namespaces */
  let ALLOWED_NAMESPACES = null;
  const DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [MATHML_NAMESPACE, SVG_NAMESPACE, HTML_NAMESPACE], stringToString);
  const DEFAULT_MATHML_TEXT_INTEGRATION_POINTS = freeze(['mi', 'mo', 'mn', 'ms', 'mtext']);
  let MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS);
  const DEFAULT_HTML_INTEGRATION_POINTS = freeze(['annotation-xml']);
  let HTML_INTEGRATION_POINTS = addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS);
  // Certain elements are allowed in both SVG and HTML
  // namespace. We need to specify them explicitly
  // so that they don't get erroneously deleted from
  // HTML namespace.
  const COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, ['title', 'style', 'font', 'a', 'script']);
  /* Parsing of strict XHTML documents */
  let PARSER_MEDIA_TYPE = null;
  const SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
  const DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
  let transformCaseFunc = null;
  /* Keep a reference to config to pass to hooks */
  let CONFIG = null;
  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */
  const formElement = document.createElement('form');
  const isRegexOrFunction = function isRegexOrFunction(testValue) {
    return testValue instanceof RegExp || testValue instanceof Function;
  };
  /**
   * _parseConfig
   *
   * @param cfg optional config literal
   */
  // eslint-disable-next-line complexity
  const _parseConfig = function _parseConfig() {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (CONFIG && CONFIG === cfg) {
      return;
    }
    /* Shield configuration object from tampering */
    if (!cfg || typeof cfg !== 'object') {
      cfg = {};
    }
    /* Shield configuration object from prototype pollution */
    cfg = clone$2(cfg);
    PARSER_MEDIA_TYPE =
    // eslint-disable-next-line unicorn/prefer-includes
    SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? DEFAULT_PARSER_MEDIA_TYPE : cfg.PARSER_MEDIA_TYPE;
    // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
    transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
    /* Set configuration parameters */
    ALLOWED_TAGS = _resolveSetOption(cfg, 'ALLOWED_TAGS', DEFAULT_ALLOWED_TAGS, {
      transform: transformCaseFunc
    });
    ALLOWED_ATTR = _resolveSetOption(cfg, 'ALLOWED_ATTR', DEFAULT_ALLOWED_ATTR, {
      transform: transformCaseFunc
    });
    ALLOWED_NAMESPACES = _resolveSetOption(cfg, 'ALLOWED_NAMESPACES', DEFAULT_ALLOWED_NAMESPACES, {
      transform: stringToString
    });
    URI_SAFE_ATTRIBUTES = _resolveSetOption(cfg, 'ADD_URI_SAFE_ATTR', DEFAULT_URI_SAFE_ATTRIBUTES, {
      transform: transformCaseFunc,
      base: DEFAULT_URI_SAFE_ATTRIBUTES
    });
    DATA_URI_TAGS = _resolveSetOption(cfg, 'ADD_DATA_URI_TAGS', DEFAULT_DATA_URI_TAGS, {
      transform: transformCaseFunc,
      base: DEFAULT_DATA_URI_TAGS
    });
    FORBID_CONTENTS = _resolveSetOption(cfg, 'FORBID_CONTENTS', DEFAULT_FORBID_CONTENTS, {
      transform: transformCaseFunc
    });
    FORBID_TAGS = _resolveSetOption(cfg, 'FORBID_TAGS', clone$2({}), {
      transform: transformCaseFunc
    });
    FORBID_ATTR = _resolveSetOption(cfg, 'FORBID_ATTR', clone$2({}), {
      transform: transformCaseFunc
    });
    USE_PROFILES = objectHasOwnProperty(cfg, 'USE_PROFILES') ? cfg.USE_PROFILES && typeof cfg.USE_PROFILES === 'object' ? clone$2(cfg.USE_PROFILES) : cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false
    IS_ALLOWED_URI$1 = isRegex(cfg.ALLOWED_URI_REGEXP) ? cfg.ALLOWED_URI_REGEXP : IS_ALLOWED_URI; // Default regexp
    NAMESPACE = typeof cfg.NAMESPACE === 'string' ? cfg.NAMESPACE : HTML_NAMESPACE; // Default HTML namespace
    MATHML_TEXT_INTEGRATION_POINTS = _resolveObjectOption(cfg, 'MATHML_TEXT_INTEGRATION_POINTS', () => addToSet({}, DEFAULT_MATHML_TEXT_INTEGRATION_POINTS) // Default built-in map
    );
    HTML_INTEGRATION_POINTS = _resolveObjectOption(cfg, 'HTML_INTEGRATION_POINTS', () => addToSet({}, DEFAULT_HTML_INTEGRATION_POINTS) // Default built-in map
    );
    const customElementHandling = _resolveObjectOption(cfg, 'CUSTOM_ELEMENT_HANDLING', () => create(null));
    CUSTOM_ELEMENT_HANDLING = create(null);
    if (objectHasOwnProperty(customElementHandling, 'tagNameCheck') && isRegexOrFunction(customElementHandling.tagNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.tagNameCheck = customElementHandling.tagNameCheck; // Default undefined
    }
    if (objectHasOwnProperty(customElementHandling, 'attributeNameCheck') && isRegexOrFunction(customElementHandling.attributeNameCheck)) {
      CUSTOM_ELEMENT_HANDLING.attributeNameCheck = customElementHandling.attributeNameCheck; // Default undefined
    }
    if (objectHasOwnProperty(customElementHandling, 'allowCustomizedBuiltInElements') && typeof customElementHandling.allowCustomizedBuiltInElements === 'boolean') {
      CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = customElementHandling.allowCustomizedBuiltInElements; // Default undefined
    }
    seal(CUSTOM_ELEMENT_HANDLING);
    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }
    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }
    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, text);
      ALLOWED_ATTR = create(null);
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html$1);
        addToSet(ALLOWED_ATTR, html);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg$1);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl$1);
        addToSet(ALLOWED_ATTR, mathMl);
        addToSet(ALLOWED_ATTR, xml);
      }
    }
    /* Always reset function-based ADD_TAGS / ADD_ATTR checks to prevent
     * leaking across calls when switching from function to array config */
    EXTRA_ELEMENT_HANDLING.tagCheck = null;
    EXTRA_ELEMENT_HANDLING.attributeCheck = null;
    /* Merge configuration parameters */
    if (objectHasOwnProperty(cfg, 'ADD_TAGS')) {
      if (typeof cfg.ADD_TAGS === 'function') {
        EXTRA_ELEMENT_HANDLING.tagCheck = cfg.ADD_TAGS;
      } else if (arrayIsArray(cfg.ADD_TAGS)) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone$2(ALLOWED_TAGS);
        }
        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, 'ADD_ATTR')) {
      if (typeof cfg.ADD_ATTR === 'function') {
        EXTRA_ELEMENT_HANDLING.attributeCheck = cfg.ADD_ATTR;
      } else if (arrayIsArray(cfg.ADD_ATTR)) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone$2(ALLOWED_ATTR);
        }
        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
      }
    }
    if (objectHasOwnProperty(cfg, 'ADD_FORBID_CONTENTS') && arrayIsArray(cfg.ADD_FORBID_CONTENTS)) {
      if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
        FORBID_CONTENTS = clone$2(FORBID_CONTENTS);
      }
      addToSet(FORBID_CONTENTS, cfg.ADD_FORBID_CONTENTS, transformCaseFunc);
    }
    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }
    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }
    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
      delete FORBID_TAGS.tbody;
    }
    // Re-derive the active Trusted Types policy from this configuration on
    // every parse. The active policy must never be sticky closure state that
    // outlives the config that set it: a caller-supplied policy left in place
    // after `clearConfig()` — or after a later call that supplied none, or
    // `TRUSTED_TYPES_POLICY: null` — could sign a subsequent "default"
    // `RETURN_TRUSTED_TYPE` result with a foreign, possibly unsafe policy.
    // See GHSA-vxr8-fq34-vvx9.
    if (cfg.TRUSTED_TYPES_POLICY) {
      if (typeof cfg.TRUSTED_TYPES_POLICY.createHTML !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      }
      if (typeof cfg.TRUSTED_TYPES_POLICY.createScriptURL !== 'function') {
        throw typeErrorCreate('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      }
      // A caller-supplied policy applies to this configuration only.
      const previousTrustedTypesPolicy = trustedTypesPolicy;
      trustedTypesPolicy = cfg.TRUSTED_TYPES_POLICY;
      // Sign local variables required by `sanitize`. If the supplied policy's
      // `createHTML` is circular (i.e. it calls `DOMPurify.sanitize`), this
      // throws via the re-entrancy guard. Restore the previous policy first so
      // the instance is not left in a poisoned state. See #1422.
      try {
        emptyHTML = _createTrustedHTML('');
      } catch (error) {
        trustedTypesPolicy = previousTrustedTypesPolicy;
        throw error;
      }
    } else if (cfg.TRUSTED_TYPES_POLICY === null) {
      // Explicit opt-out for this call: perform no Trusted Types signing and
      // create nothing (so a strict `trusted-types` CSP that disallows a
      // `dompurify` policy can still call `sanitize` from inside its own
      // policy — see #1422). Resetting to `undefined` rather than a sticky
      // `null` also drops any previously retained caller policy, so it cannot
      // resurface on a later call, while still allowing the next config-less
      // call to restore the internal default policy. See GHSA-vxr8-fq34-vvx9.
      trustedTypesPolicy = undefined;
      emptyHTML = '';
    } else {
      // No policy supplied: keep the currently active policy if one is set — a
      // previously supplied policy is intentionally sticky across config-less
      // calls — otherwise fall back to the instance's own internal policy,
      // created at most once. (A policy supplied for a *single* call still
      // lingers by design; what must not linger is a policy whose configuration
      // has been torn down via `clearConfig()`, which restores the default.)
      if (trustedTypesPolicy === undefined) {
        trustedTypesPolicy = _getDefaultTrustedTypesPolicy();
      }
      // Sign internal variables only when a policy is active. A falsy policy
      // (Trusted Types unsupported, creation failed, or an explicit opt-out)
      // leaves `emptyHTML` as a plain string, so we never call `.createHTML` on
      // a non-policy and throw. See #1422.
      if (trustedTypesPolicy && typeof emptyHTML === 'string') {
        emptyHTML = _createTrustedHTML('');
      }
    }
    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (freeze) {
      freeze(cfg);
    }
    CONFIG = cfg;
  };
  /* Keep track of all possible SVG and MathML tags
   * so that we can perform the namespace checks
   * correctly. */
  const ALL_SVG_TAGS = addToSet({}, [...svg$1, ...svgFilters, ...svgDisallowed]);
  const ALL_MATHML_TAGS = addToSet({}, [...mathMl$1, ...mathMlDisallowed]);
  /**
   * Namespace rules for an element in the SVG namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */
  const _checkSvgNamespace = function _checkSvgNamespace(tagName, parent, parentTagName) {
    // The only way to switch from HTML namespace to SVG
    // is via <svg>. If it happens via any other tag, then
    // it should be killed.
    if (parent.namespaceURI === HTML_NAMESPACE) {
      return tagName === 'svg';
    }
    // The only way to switch from MathML to SVG is via <svg>
    // if the parent is either <annotation-xml> or a MathML
    // text integration point.
    if (parent.namespaceURI === MATHML_NAMESPACE) {
      return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
    }
    // We only allow elements that are defined in SVG
    // spec. All others are disallowed in SVG namespace.
    return Boolean(ALL_SVG_TAGS[tagName]);
  };
  /**
   * Namespace rules for an element in the MathML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */
  const _checkMathMlNamespace = function _checkMathMlNamespace(tagName, parent, parentTagName) {
    // The only way to switch from HTML namespace to MathML
    // is via <math>. If it happens via any other tag, then
    // it should be killed.
    if (parent.namespaceURI === HTML_NAMESPACE) {
      return tagName === 'math';
    }
    // The only way to switch from SVG to MathML is via
    // <math> and HTML integration points
    if (parent.namespaceURI === SVG_NAMESPACE) {
      return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
    }
    // We only allow elements that are defined in MathML
    // spec. All others are disallowed in MathML namespace.
    return Boolean(ALL_MATHML_TAGS[tagName]);
  };
  /**
   * Namespace rules for an element in the HTML namespace.
   *
   * @param tagName the element's lowercase tag name
   * @param parent the (possibly simulated) parent node
   * @param parentTagName the parent's lowercase tag name
   * @returns true if a spec-compliant parser could produce this element
   */
  const _checkHtmlNamespace = function _checkHtmlNamespace(tagName, parent, parentTagName) {
    // The only way to switch from SVG to HTML is via
    // HTML integration points, and from MathML to HTML
    // is via MathML text integration points
    if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
      return false;
    }
    if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
      return false;
    }
    // We disallow tags that are specific for MathML
    // or SVG and should never appear in HTML namespace
    return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
  };
  /**
   * @param element a DOM element whose namespace is being checked
   * @returns Return false if the element has a
   *  namespace that a spec-compliant parser would never
   *  return. Return true otherwise.
   */
  const _checkValidNamespace = function _checkValidNamespace(element) {
    let parent = getParentNode(element);
    // In JSDOM, if we're inside shadow DOM, then parentNode
    // can be null. We just simulate parent in this case.
    if (!parent || !parent.tagName) {
      parent = {
        namespaceURI: NAMESPACE,
        tagName: 'template'
      };
    }
    const tagName = stringToLowerCase(element.tagName);
    const parentTagName = stringToLowerCase(parent.tagName);
    if (!ALLOWED_NAMESPACES[element.namespaceURI]) {
      return false;
    }
    if (element.namespaceURI === SVG_NAMESPACE) {
      return _checkSvgNamespace(tagName, parent, parentTagName);
    }
    if (element.namespaceURI === MATHML_NAMESPACE) {
      return _checkMathMlNamespace(tagName, parent, parentTagName);
    }
    if (element.namespaceURI === HTML_NAMESPACE) {
      return _checkHtmlNamespace(tagName, parent, parentTagName);
    }
    // For XHTML and XML documents that support custom namespaces
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) {
      return true;
    }
    // The code should never reach this place (this means
    // that the element somehow got namespace that is not
    // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
    // Return false just in case.
    return false;
  };
  /**
   * _forceRemove
   *
   * @param node a DOM node
   */
  const _forceRemove = function _forceRemove(node) {
    arrayPush(DOMPurify.removed, {
      element: node
    });
    try {
      // eslint-disable-next-line unicorn/prefer-dom-node-remove
      getParentNode(node).removeChild(node);
    } catch (_) {
      /* The normal detach failed — this is reached for a parentless node
         (getParentNode() is null, so .removeChild throws). Element.prototype
         .remove() is itself a spec no-op on a parentless node, so a recorded
         "removal" would otherwise hand the caller back an intact,
         payload-bearing node (e.g. a detached IN_PLACE root the mXSS canary or
         the style-with-element-child rule decided to kill). Fail closed by
         throwing — exactly as a clobbered root does at the IN_PLACE entry —
         rather than trying to "neutralize" the node via its own methods.
         Neutralizing would mean calling getAttributeNames()/removeAttribute()
         on the node, both of which a <form> root can clobber via a named child
         (and _isClobbered does not even probe getAttributeNames), so the
         neutralize step could itself be silently defeated, leaving the payload
         intact. A throw touches only the cached, clobber-safe remove() and
         getParentNode(). Generalizes GHSA-r47g-fvhr-h676 (clobbered-form root)
         to every root-kill reason. REPORT-3.
                This lives inside the catch, so it never fires for a normally-removed
         in-tree node: those have a parent, removeChild() succeeds, and the
         catch is not entered. Only a kept (parentless) root reaches here. */
      remove(node);
      if (!getParentNode(node)) {
        throw typeErrorCreate('a node selected for removal could not be detached from its tree ' + 'and cannot be safely returned; refusing to sanitize in place');
      }
    }
  };
  /**
   * _stripAttributeNode
   *
   * Remove a single Attr node case/namespace-exactly on an attribute-teardown
   * path. Name-based removeAttribute() ASCII-lowercases its lookup key for an
   * HTML element in an HTML document and so silently misses a case-preserved
   * handler (e.g. `ONERROR` off an XML/XHTML import) - the same defect
   * _removeAttribute() was fixed for, which a name-based call would reintroduce
   * on these IN_PLACE teardown paths. Unlike _removeAttribute this does not
   * record into DOMPurify.removed: the neutralize passes intentionally do not
   * book-keep. A clobbered/detached node falls back to best-effort name-based
   * removal.
   *
   * @param element the element to strip the attribute from
   * @param attribute the Attr node to remove
   * @param name the attribute's name, for the fallback path
   */
  const _stripAttributeNode = function _stripAttributeNode(element, attribute, name) {
    try {
      removeAttributeNode(element, attribute);
    } catch (_) {
      try {
        element.removeAttribute(name);
      } catch (_) {}
    }
  };
  /**
   * _neutralizeRoot
   *
   * Fail-closed teardown of an in-place root after the sanitize walk aborts
   * (campaign-3 F2). An internal throw mid-walk — e.g. a page-registered
   * custom element's reaction detaches a node so `_forceRemove`'s deliberate
   * parentless guard throws, or any other re-entrant engine mutation — would
   * otherwise leave the caller's *live* tree half-sanitized, with everything
   * after the abort point still carrying its handlers. There is no safe way
   * to resume the walk (the tree mutated under us), so we strip the root bare:
   * remove every child and every attribute, then let the caller's catch see
   * the original error. Clobber-safe (cached `remove`/`childNodes`/`attributes`
   * getters; the root was already clobber-pre-flighted at the IN_PLACE entry).
   *
   * @param root the in-place root to empty
   */
  const _neutralizeRoot = function _neutralizeRoot(root) {
    /* Strip every disallowed attribute (on* handlers included) off the whole
       subtree BEFORE detaching anything. Detaching first would hand back
       handler-bearing originals (e.g. an already-loading `<img onerror>`)
       whose queued resource event still fires in page scope after we throw.
       Clobber-safe reads; a doomed clobbered node's own attributes are
       irrelevant while its non-clobbered descendants are reached and scrubbed. */
    _neutralizeSubtree(root);
    const childNodes = getChildNodes(root);
    if (childNodes) {
      const snapshot = [];
      arrayForEach(childNodes, child => {
        arrayPush(snapshot, child);
      });
      arrayForEach(snapshot, child => {
        try {
          remove(child);
        } catch (_) {
          /* Best-effort teardown; a still-attached child is handled below */
        }
      });
    }
    const attributes = getAttributes(root);
    if (attributes) {
      for (let i = attributes.length - 1; i >= 0; --i) {
        const attribute = attributes[i];
        const name = attribute && attribute.name;
        if (typeof name === 'string') {
          _stripAttributeNode(root, attribute, name);
        }
      }
    }
  };
  /**
   * _removeAttribute
   *
   * Name-based getAttributeNode()/removeAttribute() ASCII-lowercase their
   * lookup key for HTML elements in an HTML document, so they silently miss an
   * attribute whose stored qualified name still contains uppercase ASCII
   * letters. That happens when the node came from a case-preserving source
   * (an XML/XHTML document imported via importNode(), or createAttributeNS()),
   * where e.g. `ONERROR` survives the walk: the policy check lowercases to
   * `onerror` and rejects it, but `removeAttribute('ONERROR')` looks up
   * `onerror` and finds nothing. Remove the exact Attr node instead, which is
   * case- and namespace-exact, and fall back to name-based removal only when
   * the caller could not supply the node.
   *
   * @param name an Attribute name
   * @param element a DOM node
   * @param attr the exact Attr node to remove, when the caller has it
   */
  const _removeAttribute = function _removeAttribute(name, element, attr) {
    if (!attr) {
      try {
        attr = element.getAttributeNode(name);
      } catch (_) {
        attr = null;
      }
    }
    arrayPush(DOMPurify.removed, {
      attribute: attr || null,
      from: element
    });
    try {
      if (attr) {
        removeAttributeNode(element, attr);
      } else {
        element.removeAttribute(name);
      }
    } catch (_) {
      /* Clobbered or already-detached node - best-effort fall back to a
         name-based removal so the "is" handling below still runs. Note this
         fallback ASCII-lowercases its lookup key in an HTML document and so
         cannot reach a case-preserved attribute name; the cached
         removeAttributeNode() above is what removes those, and a clobbered
         form is already removed wholesale by _isClobbered() before reaching
         here. */
      try {
        element.removeAttribute(name);
      } catch (_) {}
    }
    // We void attribute values for unremovable "is" attributes
    if (name === 'is') {
      if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
        try {
          _forceRemove(element);
        } catch (_) {}
      } else {
        try {
          element.setAttribute(name, '');
        } catch (_) {}
      }
    }
  };
  /**
   * _stripDisallowedAttributes
   *
   * Removes every attribute the active configuration does not allow from a
   * single element, using the same allowlist as the main attribute pass (so
   * `on*` handlers go, but no `/^on/` blocklist is introduced). Used only to
   * neutralise nodes that are being discarded from an in-place tree.
   *
   * @param element the element to strip
   */
  const _stripDisallowedAttributes = function _stripDisallowedAttributes(element) {
    const attributes = getAttributes(element);
    if (!attributes) {
      return;
    }
    for (let i = attributes.length - 1; i >= 0; --i) {
      const attribute = attributes[i];
      const name = attribute && attribute.name;
      if (typeof name !== 'string' || ALLOWED_ATTR[transformCaseFunc(name)]) {
        continue;
      }
      _stripAttributeNode(element, attribute, name);
    }
  };
  /**
   * _neutralizeSubtree
   *
   * Completes the audit-5 F1 fix across every removal path. The KEEP_CONTENT
   * move-hoist neutralises only disallowed-tag removals; clobber, mXSS-canary,
   * namespace, comment, processing-instruction and KEEP_CONTENT:false removals
   * all drop their subtree wholesale via `_forceRemove`. On the IN_PLACE path
   * those dropped nodes are detached from the caller's LIVE tree but a
   * handler-bearing original among them (an `<img onerror>`/`<video>` that was
   * loading) keeps its queued resource event, which fires in page scope after
   * sanitize returns. This walks a removed subtree and strips every attribute
   * the active configuration does not allow — so `on*` handlers are cancelled
   * through the SAME allowlist that governs kept nodes, not a separate `/^on/`
   * blocklist. Run synchronously before sanitize returns, i.e. before any
   * queued event can fire. Hook-free by design: these nodes leave the output,
   * so firing attribute hooks for them would be surprising. Clobber-safe reads;
   * a doomed clobbered node may shadow `removeAttribute` (its own attributes are
   * irrelevant — it is discarded — while its non-clobbered descendants, e.g.
   * the `<img>`, are reached and scrubbed).
   *
   * @param root the root of a removed subtree to neutralise
   */
  const _neutralizeSubtree = function _neutralizeSubtree(root) {
    const stack = [root];
    while (stack.length > 0) {
      const node = stack.pop();
      const nodeType = _readNodeType(node);
      if (nodeType === NODE_TYPE.element) {
        _stripDisallowedAttributes(node);
      }
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push(childNodes[i]);
        }
      }
    }
  };
  /**
   * _neutralizePatchLinkage
   *
   * IN_PLACE entry pre-pass (declarative-partial-updates / streaming
   * hardening, https://github.com/WICG/declarative-partial-updates).
   *
   * The main walk strips patch linkage (`for`/`patchsrc`) and removes range
   * markers (PIs / markup comments) node-by-node, in document order, AS it
   * reaches each node. On a live in-place root that leaves a window: from the
   * moment the root is connected until the walk arrives at a given node, that
   * node's linkage is live. A patch applied on connection/stream can fire as
   * a microtask during the walk and inject or teleport an unsanitized DOM
   * range into a region the iterator has already passed and will not revisit,
   * so the post-return "tree is sanitized" contract is violated. Sweep the
   * whole tree once up front and sever every linkage before the walk begins,
   * closing that window.
   *
   * This CANNOT undo a patch that already fired before sanitize ran — that is
   * the irreducible "do not IN_PLACE a live-connected attacker tree" caveat —
   * but it closes everything from sanitize-start onward. Gated on SAFE_FOR_XML
   * to group with the rest of the declarative-partial-updates handling and
   * stay overridable, consistent with the codebase.
   *
   * Clobber-safe traversal (cached childNodes getter); per-node try/catch so a
   * clobbered root cannot defeat the sweep of its non-clobbered descendants.
   *
   * NOTE (pending real-Chrome confirmation, see test/declarative-patch-probe
   * .html Q1): this mirrors the existing policy of keeping `for` on
   * <label>/<output>. If the shipping feature can drive a patch through a
   * surviving `for`-on-label/output + `id` pair, this pre-pass and the
   * attribute check at _isBasicCustomElement's caller must additionally drop
   * that pair on the IN_PLACE path. Left as-is until the taxonomy is verified.
   *
   * @param root the in-place root to sweep
   */
  /**
   * Central policy for declarative-partial-updates patch-linkage attributes,
   * shared by the _neutralizePatchLinkage pre-pass and _isValidAttribute so
   * the two sites cannot drift: `patchsrc` always links, `for` links
   * everywhere except on <label>/<output>, and the whole policy is gated on
   * SAFE_FOR_XML (see the rationale block in _isValidAttribute).
   *
   * @param lcName the transformCaseFunc'd attribute name
   * @param lcTag the transformCaseFunc'd tag name of the carrying element
   * @return true if the attribute is patch linkage and must be dropped
   */
  const _isPatchLinkageAttribute = function _isPatchLinkageAttribute(lcName, lcTag) {
    if (!SAFE_FOR_XML) {
      return false;
    }
    if (lcName === 'patchsrc') {
      return true;
    }
    return lcName === 'for' && lcTag !== 'label' && lcTag !== 'output';
  };
  const _neutralizePatchLinkage = function _neutralizePatchLinkage(root) {
    if (!SAFE_FOR_XML) {
      return;
    }
    const stack = [root];
    while (stack.length > 0) {
      const node = stack.pop();
      const nodeType = _readNodeType(node);
      /* Remove range markers (the target side of a patch linkage): every
         processing instruction, and any markup-bearing comment. */
      if (nodeType === NODE_TYPE.processingInstruction || nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, node.data)) {
        try {
          remove(node);
        } catch (_) {
          /* Best-effort */
        }
        continue;
      }
      /* Strip patch-source attributes (the source side) off elements. */
      if (nodeType === NODE_TYPE.element) {
        const element = node;
        const lcTag = transformCaseFunc(_readNodeName(node));
        try {
          if (element.hasAttribute && element.hasAttribute('patchsrc')) {
            element.removeAttribute('patchsrc');
          }
          if (element.hasAttribute && element.hasAttribute('for') && _isPatchLinkageAttribute('for', lcTag)) {
            element.removeAttribute('for');
          }
        } catch (_) {
          /* Clobbered removeAttribute/hasAttribute on a doomed node — ignore */
        }
      }
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push(childNodes[i]);
        }
      }
    }
  };
  /**
   * _initDocument
   *
   * @param dirty - a string of dirty markup
   * @return a DOM, filled with the dirty markup
   */
  const _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    let doc = null;
    let leadingWhitespace = null;
    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    } else {
      /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
      const matches = stringMatch(dirty, /^[\r\n\t ]+/);
      leadingWhitespace = matches && matches[0];
    }
    if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) {
      // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
      dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
    }
    const dirtyPayload = trustedTypesPolicy ? _createTrustedHTML(dirty) : dirty;
    /*
     * Use the DOMParser API by default, fallback later if needs be
     * DOMParser not work for svg when has multiple root element.
     */
    if (NAMESPACE === HTML_NAMESPACE) {
      try {
        doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
      } catch (_) {}
    }
    /* Use createHTMLDocument in case DOMParser is not available */
    if (!doc || !doc.documentElement) {
      doc = implementation.createDocument(NAMESPACE, 'template', null);
      try {
        doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
      } catch (_) {
        // Syntax error if dirtyPayload is invalid xml
      }
    }
    const body = doc.body || doc.documentElement;
    if (dirty && leadingWhitespace) {
      body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
    }
    /* Work on whole document or just its body */
    if (NAMESPACE === HTML_NAMESPACE) {
      return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
    }
    return WHOLE_DOCUMENT ? doc.documentElement : body;
  };
  /**
   * Creates a NodeIterator object that you can use to traverse filtered lists of nodes or elements in a document.
   *
   * @param root The root element or node to start traversing on.
   * @return The created NodeIterator
   */
  const _createNodeIterator = function _createNodeIterator(root) {
    /* Read ownerDocument through the cached Node.prototype getter, never the
       direct property. HTMLFormElement has [LegacyOverrideBuiltIns], so a
       clobbering child (<input name="ownerDocument"> or a form-associated
       external input) shadows the prototype getter and makes a direct read
       return that <input>. createNodeIterator.call(<input>, ...) then throws
       "Illegal invocation", and on the IN_PLACE path that throw lands before
       the walk's fail-closed barrier - leaving the caller's live tree, with
       any already-armed handler in it, un-neutralized. The cached getter
       returns the real Document regardless of the clobber. */
    const doc = getOwnerDocument ? getOwnerDocument(root) : root.ownerDocument;
    return createNodeIterator.call(doc || root, root,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null);
  };
  /**
   * Replace template expression syntax (mustache, ERB, template
   * literal) with a space; shared by all SAFE_FOR_TEMPLATES scrub
   * sites. Order matters: mustache, then ERB, then template literal.
   *
   * @param value the string to scrub
   * @returns the scrubbed string
   */
  const _stripTemplateExpressions = function _stripTemplateExpressions(value) {
    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
    value = stringReplace(value, ERB_EXPR$1, ' ');
    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
    return value;
  };
  /**
   * Strip template-engine expressions ({{...}}, ${...}, <%...%>) from the
   * character data of an element subtree. Used as the final safety net for
   * SAFE_FOR_TEMPLATES on every DOM-returning code path so that expressions
   * which only form after text-node normalization (e.g. fragments split across
   * stripped elements) cannot survive into a template-evaluating framework.
   *
   * Walks text/comment/CDATA/processing-instruction nodes and mutates `.data`
   * in place rather than round-tripping through innerHTML. This preserves
   * descendant node references (important for IN_PLACE callers), avoids a
   * serialize/reparse cycle, and reads literal character data — which means
   * `<%...%>` in text content matches the ERB regex against its real bytes
   * instead of the HTML-entity-escaped form innerHTML would produce.
   *
   * Attribute values are not visited here; SAFE_FOR_TEMPLATES handling for
   * attributes is performed during the per-node `_sanitizeAttributes` pass.
   *
   * @param node The root element whose character data should be scrubbed.
   */
  const _scrubTemplateExpressions2 = function _scrubTemplateExpressions(node) {
    var _node$querySelectorAl;
    node.normalize();
    /* Clobber-safe ownerDocument read, same reasoning as _createNodeIterator:
       under SAFE_FOR_TEMPLATES this runs on the live IN_PLACE root, which may
       carry a form-named-getter override of ownerDocument. */
    const doc = getOwnerDocument ? getOwnerDocument(node) : node.ownerDocument;
    const walker = createNodeIterator.call(doc || node, node,
    // eslint-disable-next-line no-bitwise
    NodeFilter.SHOW_TEXT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_CDATA_SECTION | NodeFilter.SHOW_PROCESSING_INSTRUCTION, null);
    let currentNode = walker.nextNode();
    while (currentNode) {
      currentNode.data = _stripTemplateExpressions(currentNode.data);
      currentNode = walker.nextNode();
    }
    // NodeIterator does not descend into <template>.content per the DOM spec,
    // so we must explicitly recurse into each template's content fragment,
    // mirroring the approach used by _sanitizeShadowDOM.
    const templates = (_node$querySelectorAl = node.querySelectorAll) === null || _node$querySelectorAl === void 0 ? void 0 : _node$querySelectorAl.call(node, 'template');
    if (templates) {
      arrayForEach(templates, tmpl => {
        if (_isDocumentFragment(tmpl.content)) {
          _scrubTemplateExpressions2(tmpl.content);
        }
      });
    }
  };
  /**
   * _isClobbered
   *
   * Detect DOM-clobbering on HTMLFormElement nodes. Form is the only HTML
   * interface with [LegacyOverrideBuiltIns]; a descendant element with a
   * `name` attribute matching a prototype property shadows that property
   * on direct reads. We use this check at the IN_PLACE entry-point and
   * during attribute sanitization to refuse clobbered forms.
   *
   * @param element element to check for clobbering attacks
   * @return true if clobbered, false if safe
   */
  const _isClobbered = function _isClobbered(element) {
    // Realm-independent tag-name probe. If we can't determine the tag
    // name at all, we can't reason about clobbering — return false
    // (the caller's other defences still apply).
    const realTagName = getNodeName ? getNodeName(element) : null;
    if (typeof realTagName !== 'string') {
      return false;
    }
    if (transformCaseFunc(realTagName) !== 'form') {
      return false;
    }
    return typeof element.nodeName !== 'string' || typeof element.textContent !== 'string' || typeof element.removeChild !== 'function' ||
    // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    element.attributes !== getAttributes(element) || typeof element.removeAttribute !== 'function' ||
    // A form descendant named "removeAttributeNode" or "getAttributeNode"
    // shadows these Attr-node methods via [LegacyOverrideBuiltIns].
    // _removeAttribute() / _stripAttributeNode() reach for
    // element.removeAttributeNode(attr) first; when it is shadowed the call
    // throws and the name-based fallback element.removeAttribute(name)
    // ASCII-lowercases its lookup key in an HTML document, silently missing
    // a case-preserved event-handler attribute (e.g. an ONANIMATIONSTART
    // that reached the sanitizer through an XML/XHTML parse). Flag the form
    // so it is removed wholesale, exactly as for the other shadowed methods.
    typeof element.removeAttributeNode !== 'function' || typeof element.getAttributeNode !== 'function' || typeof element.setAttribute !== 'function' || typeof element.namespaceURI !== 'string' || typeof element.insertBefore !== 'function' || typeof element.hasChildNodes !== 'function' ||
    // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    element.nodeType !== getNodeType(element) ||
    // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    element.childNodes !== getChildNodes(element);
  };
  /**
   * Checks whether the given value is a DocumentFragment from any realm.
   *
   * The realm-independent replacement reads `nodeType` through the cached
   * Node.prototype getter and compares to the DOCUMENT_FRAGMENT_NODE
   * constant (11). nodeType is a numeric value resolved from the node's
   * internal slot, identical across realms for the same kind of node.
   *
   * @param value object to check
   * @return true if value is a DocumentFragment-shaped node from any realm
   */
  const _isDocumentFragment = function _isDocumentFragment(value) {
    if (!getNodeType || typeof value !== 'object' || value === null) {
      return false;
    }
    try {
      return getNodeType(value) === NODE_TYPE.documentFragment;
    } catch (_) {
      return false;
    }
  };
  /**
   * Checks whether the given object is a DOM node, including nodes that
   * originate from a different window/realm (e.g. an iframe's
   * contentDocument). The previous `value instanceof Node` check was
   * realm-bound: nodes from a different window failed it, causing
   * sanitize() to silently stringify them and reset IN_PLACE to false,
   * returning the original node unsanitized. See GHSA-4w3q-35jp-p934.
   *
   * @param value object to check whether it's a DOM node
   * @return true if value is a DOM node from any realm
   */
  const _isNode = function _isNode(value) {
    if (!getNodeType || typeof value !== 'object' || value === null) {
      return false;
    }
    try {
      return typeof getNodeType(value) === 'number';
    } catch (_) {
      return false;
    }
  };
  function _executeHooks(hooks, currentNode, data) {
    if (hooks.length === 0) {
      return;
    }
    arrayForEach(hooks, hook => {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  }
  /**
   * Structural-threat checks that condemn a node regardless of the
   * allowlists: mXSS via namespace confusion, risky CSS construction,
   * processing instructions, markup-bearing comments. Pure predicate;
   * the caller removes. Check order is load-bearing.
   *
   * @param currentNode the node to inspect
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node must be removed
   */
  const _isUnsafeNode = function _isUnsafeNode(currentNode, tagName) {
    /* Detect mXSS attempts abusing namespace confusion */
    if (SAFE_FOR_XML && currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.textContent) && regExpTest(ELEMENT_MARKUP_PROBE, currentNode.innerHTML)) {
      return true;
    }
    /* Remove rawtext/literal-text elements whose literal serialization
       re-opens markup on an HTML reparse - shapes (a) and (b) documented at
       LITERAL_TEXT_ELEMENTS. Both are invisible to rule 1 above (which
       self-disables once there is an element child, and whose second probe
       reads the innerHTML an XML/XHTML document serializes escaped), which
       is why both probes here read textContent instead. Previously only
       `style`-with-element-child was covered; every element in
       LITERAL_TEXT_ELEMENTS shares this literal serialization and is
       equally affected. */
    if (SAFE_FOR_XML && currentNode.namespaceURI === HTML_NAMESPACE && LITERAL_TEXT_ELEMENTS[tagName] && (_isNode(currentNode.firstElementChild) || typeof currentNode.textContent === 'string' && regExpTest(LITERAL_TEXT_CLOSE[tagName], currentNode.textContent))) {
      return true;
    }
    /* Remove any occurrence of processing instructions */
    if (currentNode.nodeType === NODE_TYPE.processingInstruction) {
      return true;
    }
    /* Remove any kind of possibly harmful comments */
    if (SAFE_FOR_XML && currentNode.nodeType === NODE_TYPE.comment && regExpTest(COMMENT_MARKUP_PROBE, currentNode.data)) {
      return true;
    }
    return false;
  };
  /**
   * Evaluate a CUSTOM_ELEMENT_HANDLING check (a RegExp or a predicate
   * function, per the validation in _parseConfig) against a name.
   * Additional arguments are forwarded to predicate functions - the
   * attributeNameCheck predicate receives the tag name as its second
   * argument. A null/absent check never matches.
   *
   * @param check the configured tagNameCheck / attributeNameCheck value
   * @param name the name to test
   * @param args extra arguments forwarded to a predicate function
   * @return true if the check matches the name
   */
  const _matchesNameCheck = function _matchesNameCheck(check, name) {
    if (check instanceof RegExp) {
      return regExpTest(check, name);
    }
    if (check instanceof Function) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }
      return Boolean(check(name, ...args));
    }
    return false;
  };
  /**
   * Handle a node whose tag is forbidden or not allowlisted: keep
   * allowed custom elements (false return exits _sanitizeElements
   * early - the namespace and fallback-tag removal checks are
   * intentionally skipped for kept custom elements), else hoist
   * content per KEEP_CONTENT and remove.
   *
   * A kept custom element is the ONLY case in which this function
   * returns false, so the caller uses that return value to run the
   * afterSanitizeElements hook on the kept element and keep the
   * element-hook lifecycle consistent with normal allowlisted
   * elements (GHSA-c2j3-45gr-mqc4).
   *
   * @param currentNode the disallowed node
   * @param tagName the node's transformCaseFunc'd tag name
   * @return true if the node was removed, false if kept
   */
  const _sanitizeDisallowedNode = function _sanitizeDisallowedNode(currentNode, tagName, root) {
    /* Check if we have a custom element to handle */
    if (!FORBID_TAGS[tagName] && _isBasicCustomElement(tagName) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) {
      return false;
    }
    /* Keep content except for bad-listed elements.
         Use the cached prototype getters exclusively — the previous code
         had `|| currentNode.parentNode` / `|| currentNode.childNodes`
         fallbacks, but the cached getters always return the canonical
         value (or null for a real parent-less node), so the fallback
         path was dead in safe cases and a clobbering surface in unsafe
         ones. Falsy cached results stay falsy; the `if (childNodes &&
         parentNode)` check already gates correctly. */
    if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
      const parentNode = getParentNode(currentNode);
      const childNodes = getChildNodes(currentNode);
      if (childNodes && parentNode) {
        const childCount = childNodes.length;
        /* Hoist by moving each child up one level rather than deep-cloning
             it. Moving transfers every descendant exactly once, so a chain of
             nested disallowed elements costs O(n) instead of the O(n^2) that
             re-cloning the shrinking subtree at each level produced; it also
             empties the removed original, so `DOMPurify.removed` no longer
             pins whole subtrees. Moving preserves the in-place guarantee too:
             an original carrying already-queued resource events (`<img
             onerror>`, `<video>`/`<audio>` error, lazy/`onload`, …) is
             relocated and sanitised rather than left detached but still armed.
                      The sole case that must clone is removing the walk root itself.
             The result is serialised from the root's subtree, so a restrictive
             ALLOWED_TAGS that strips the root (`body` on the string path) must
             leave the content inside it, which only cloning does. In IN_PLACE
             the root is pre-validated as an allowed tag and so is never removed
             here, so that path always takes the move branch.
                      `childNodes` is live; a tail-to-head walk keeps `childNodes[i]`
             valid whether we move (drops the trailing entry) or clone (leaves
             the list intact). */
        for (let i = childCount - 1; i >= 0; --i) {
          const hoisted = currentNode === root ? cloneNode(childNodes[i], true) : childNodes[i];
          parentNode.insertBefore(hoisted, getNextSibling(currentNode));
        }
      }
    }
    _forceRemove(currentNode);
    return true;
  };
  /**
   * Fork a hook-mutable allowlist off its shared binding the first time a
   * (possibly lazily-installed) uponSanitize* hook is about to see it, so the
   * hook cannot widen the per-instance default or the setConfig binding by
   * reference and leak past the call. Returns the set unchanged once it is
   * already call-local, so repeated calls across elements are idempotent.
   *
   * @param hookList the uponSanitize* hook array for this event
   * @param set the current ALLOWED_TAGS / ALLOWED_ATTR binding
   * @param defaultSet the per-instance DEFAULT_ALLOWED_* constant
   * @param setConfigSet the captured setConfig() binding, or null
   * @return a call-local clone if a hook is present and set is still shared,
   *   else set unchanged
   */
  const _forkSharedAllowlist = function _forkSharedAllowlist(hookList, set, defaultSet, setConfigSet) {
    if (hookList.length === 0) {
      return set;
    }
    return set === defaultSet || set === setConfigSet ? clone$2(set) : set;
  };
  /**
   * Shared guard for a node that a hook has detached from the walk tree,
   * used after each element-hook site in _sanitizeElements. Detaching is a
   * long-standing user pattern (issue #469; draw.io-style foreignObject
   * filtering). Per the cached, unclobberable parentNode getter the node is
   * genuinely out of the tree, so it can reach neither the serialized
   * output nor an IN_PLACE live tree; treat it as removed and stop
   * processing it. Without this guard, the unsafe-node / namespace checks
   * would call _forceRemove on a parentless node and hit the REPORT-3
   * fail-closed throw — which exists for nodes DOMPurify wants gone but
   * *cannot* detach (clobbered / parentless roots), the opposite of a node
   * that is already safely gone. The walk root is exempt: a detached
   * IN_PLACE root is legitimate input and must still be fully sanitized,
   * and a kill-decision on it must keep hitting the REPORT-3 throw.
   *
   * Nodes detached by hooks stay the hook's responsibility for placement:
   * they are not recorded in DOMPurify.removed, so the post-walk IN_PLACE
   * pass (which iterates DOMPurify.removed) does not reach them. But a
   * hook-detached subtree can still hold a queued resource-event handler -
   * e.g. an <img onload> that began loading when the caller built the live
   * tree - which fires in page scope after sanitize returns even though the
   * handler never reached the returned tree. That is the audit-5 F1 hazard,
   * and the documented node.remove() hook pattern walks straight into it.
   * So on the IN_PLACE path we neutralize the detached subtree inline,
   * stripping its non-allow-listed attributes before returning, exactly as
   * the post-walk pass does for _forceRemove'd subtrees.
   *
   * @param currentNode the node a hook may have detached
   * @param root the current walk root
   * @return true if the node is detached and now handled, false otherwise
   */
  const _handleHookDetachedNode = function _handleHookDetachedNode(currentNode, root) {
    if (currentNode === root || getParentNode(currentNode) !== null) {
      return false;
    }
    if (IN_PLACE) {
      _neutralizeSubtree(currentNode);
    }
    return true;
  };
  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   * @param currentNode to check for permission to exist
   * @return true if node was killed, false if left alive
   */
  const _sanitizeElements = function _sanitizeElements(currentNode, root) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeElements, currentNode, null);
    /* A hook may have detached the node - treat it as removed (see
       _handleHookDetachedNode for the full rationale). */
    if (_handleHookDetachedNode(currentNode, root)) {
      return true;
    }
    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Now let's check the element's type and name */
    const tagName = transformCaseFunc(_readNodeName(currentNode));
    /* Close the pre-walk clone-guard's timing gap: an uponSanitizeElement
       hook may have been installed after that guard sampled the hook arrays
       (e.g. lazily from beforeSanitizeElements), leaving ALLOWED_TAGS still
       aliasing a shared binding that a widening hook would mutate by
       reference. Fork it before exposing it to the hook. */
    ALLOWED_TAGS = _forkSharedAllowlist(hooks.uponSanitizeElement, ALLOWED_TAGS, DEFAULT_ALLOWED_TAGS, SET_CONFIG_ALLOWED_TAGS);
    /* Execute a hook if present */
    _executeHooks(hooks.uponSanitizeElement, currentNode, {
      tagName,
      allowedTags: ALLOWED_TAGS
    });
    /* The uponSanitizeElement hook may have detached the node, exactly as
       above (see _handleHookDetachedNode for the full rationale). */
    if (_handleHookDetachedNode(currentNode, root)) {
      return true;
    }
    /* Remove mXSS vectors, processing instructions and risky comments */
    if (_isUnsafeNode(currentNode, tagName)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Remove element if anything forbids its presence */
    if (FORBID_TAGS[tagName] || !(EXTRA_ELEMENT_HANDLING.tagCheck instanceof Function && EXTRA_ELEMENT_HANDLING.tagCheck(tagName)) && !ALLOWED_TAGS[tagName]) {
      const removed = _sanitizeDisallowedNode(currentNode, tagName, root);
      /* A false return means the node is a custom element kept via
         CUSTOM_ELEMENT_HANDLING - the only keep path through
         _sanitizeDisallowedNode. Run afterSanitizeElements on it so the
         element-hook lifecycle matches normal allowlisted elements: a
         security policy applied in this hook (e.g. stripping an attribute
         from every surviving element) must not silently skip kept custom
         elements (GHSA-c2j3-45gr-mqc4). This mirrors the normal-element
         tail below - the hook runs, then the walker's subsequent
         _sanitizeAttributes pass sanitizes the element's attributes. The
         deliberately skipped namespace and fallback-tag removal checks stay
         skipped; they are removal decisions, not the hook contract. */
      if (removed === false) {
        _executeHooks(hooks.afterSanitizeElements, currentNode, null);
      }
      return removed;
    }
    /* Check whether element has a valid namespace.
       Realm-safe check (GHSA-hpcv-96wg-7vj8): use the cached Node.prototype
       nodeType getter rather than `instanceof Element`, which is realm-
       bound and short-circuits to false for any node minted in a different
       realm — letting a foreign-realm element with a forbidden namespace
       slip past the namespace check entirely. */
    const nt = _readNodeType(currentNode);
    if (nt === NODE_TYPE.element && !_checkValidNamespace(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Make sure that older browsers don't get fallback-tag mXSS */
    if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(FALLBACK_TAG_CLOSE, currentNode.innerHTML)) {
      _forceRemove(currentNode);
      return true;
    }
    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === NODE_TYPE.text) {
      /* Get the element's text content */
      const content = _stripTemplateExpressions(currentNode.textContent);
      if (currentNode.textContent !== content) {
        arrayPush(DOMPurify.removed, {
          element: currentNode.cloneNode()
        });
        currentNode.textContent = content;
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeElements, currentNode, null);
    return false;
  };
  /**
   * _isValidAttribute
   *
   * @param lcTag Lowercase tag name of containing element.
   * @param lcName Lowercase attribute name.
   * @param value Attribute value.
   * @return Returns true if `value` is valid, otherwise false.
   */
  // eslint-disable-next-line complexity
  const _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* FORBID_ATTR must always win, even if ADD_ATTR predicate would allow it */
    if (FORBID_ATTR[lcName]) {
      return false;
    }
    /* Reject declarative-partial-updates patch-linkage attributes
       (https://github.com/WICG/declarative-partial-updates).
            Empirical note (Chrome 150, verified — see
       test/declarative-patch-probe-v3.html): expansion is NOT applied after
       sanitization. For the string path it fires during sanitize()'s own
       parse, so the walk sees and sanitizes the fully materialized expanded
       tree — teleports into MathML/SVG integration points included; a
       weaponized `<template for>`->`<img onerror>` comes back with the handler
       stripped. For the IN_PLACE path it fires on connection, before the walk.
       Either way DOMPurify is NOT blind to the patch.
            This removal is therefore defense-in-depth rather than the sole barrier:
       it prevents live linkage from surviving into the OUTPUT and re-expanding
       in the caller's context, and keeps behaviour deterministic if a future
       engine defers expansion. `for` is legitimate only on <label>/<output>;
       anywhere else (notably <template for>) it links the element to a patch
       target and teleports or removes an arbitrary DOM range by id/marker name.
       `patchsrc` fetches remote markup and is treated as a script-loading
       mechanism (CSP). Gated on SAFE_FOR_XML so the removal groups with the
       other structural-threat checks and stays overridable, consistent with
       the rest of the codebase. PI range markers are already removed by
       _isUnsafeNode. */
    if (_isPatchLinkageAttribute(lcName, lcTag)) {
      return false;
    }
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }
    const nameIsPermitted = ALLOWED_ATTR[lcName] || EXTRA_ELEMENT_HANDLING.attributeCheck instanceof Function && EXTRA_ELEMENT_HANDLING.attributeCheck(lcName, lcTag);
    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && regExpTest(DATA_ATTR$1, lcName)) {
      return true;
    }
    /* Allow valid aria-* attributes, the value is always URI safe */
    if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) {
      return true;
    }
    /* A name outside the allowlist is acceptable on custom-element terms
       only. The value checks below are intentionally skipped in that case:
       if the user supplied a tagNameCheck we also allow derived custom
       elements using the same test, and attributes passing the configured
       attributeNameCheck are allowed as custom elements define these at
       their own discretion. */
    if (!nameIsPermitted) {
      return (
        // Condition a) covers a basically valid custom element tag name whose
        // tag passes the configured tagNameCheck and whose attribute name
        // passes the configured attributeNameCheck ...
        _isBasicCustomElement(lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName, lcTag) ||
        // Condition b) covers an `is` attribute whose value passes the
        // configured tagNameCheck while customized built-in elements are
        // allowed.
        lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && _matchesNameCheck(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value)
      );
    }
    /* Check value is safe. First, is attr inert? If so, is safe */
    if (URI_SAFE_ATTRIBUTES[lcName]) {
      return true;
    }
    /* Check no script, data or unknown possibly unsafe URI
        unless we know URI values are safe for that attribute */
    if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) {
      return true;
    }
    /* Keep image data URIs alive if src/xlink:href is allowed */
    /* Further prevent gadget XSS for dynamically built script tags */
    if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) {
      return true;
    }
    /* Allow unknown protocols: This provides support for links that
        are handled by protocol handlers which may be unknown ahead of
        time, e.g. fb:, spotify: */
    if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) {
      return true;
    }
    /* Only an empty (binary) value remains safe at this point;
       anything else is presumed unsafe, do not add it back */
    return !value;
  };
  /* Names the HTML spec reserves from valid-custom-element-name; these must
   * never be treated as basic custom elements even when a permissive
   * CUSTOM_ELEMENT_HANDLING.tagNameCheck is configured. */
  const RESERVED_CUSTOM_ELEMENT_NAMES = addToSet({}, ['annotation-xml', 'color-profile', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'missing-glyph']);
  /**
   * _isBasicCustomElement
   * checks if at least one dash is included in tagName, and it's not the first char
   * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
   *
   * @param tagName name of the tag of the node to sanitize
   * @returns Returns true if the tag name meets the basic criteria for a custom element, otherwise false.
   */
  const _isBasicCustomElement = function _isBasicCustomElement(tagName) {
    return !RESERVED_CUSTOM_ELEMENT_NAMES[stringToLowerCase(tagName)] && regExpTest(CUSTOM_ELEMENT$1, tagName);
  };
  /**
   * Wrap an attribute value in the matching Trusted Types object when
   * the active policy requires it. Namespaced attributes pass through
   * unchanged (no TT support yet, see
   * https://bugs.chromium.org/p/chromium/issues/detail?id=1305293).
   *
   * @param lcTag lowercase tag name of the containing element
   * @param lcName lowercase attribute name
   * @param namespaceURI the attribute's namespace, if any
   * @param value the attribute value to wrap
   * @return the value, wrapped when Trusted Types demand it
   */
  const _applyTrustedTypesToAttribute = function _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value) {
    if (trustedTypesPolicy && typeof trustedTypes === 'object' && typeof trustedTypes.getAttributeType === 'function' && !namespaceURI) {
      switch (trustedTypes.getAttributeType(lcTag, lcName)) {
        case 'TrustedHTML':
          {
            return _createTrustedHTML(value);
          }
        case 'TrustedScriptURL':
          {
            return _createTrustedScriptURL(value);
          }
      }
    }
    return value;
  };
  /**
   * Write a modified attribute value back onto the element. On
   * success, re-probe for clobbering introduced by the new value and
   * remove the element when found; otherwise, when this writeback is the
   * recreate half of the SANITIZE_NAMED_PROPS remove-and-recreate, pop the
   * removal entry that path recorded so it does not show as removed. On
   * failure, remove the attribute instead.
   *
   * Returns true only on a clean write (the value was set and the new value
   * introduced no clobbering). The caller uses that, together with its own
   * knowledge of whether this attribute pushed a DOMPurify.removed record, to
   * decide whether to pop that record. The pop must happen ONLY for the
   * named-prop remove-and-recreate; popping on any other value change (trim,
   * template scrubbing, Trusted Types) would consume an unrelated _forceRemove
   * subtree-cleanup record and let that detached subtree keep a live event
   * handler through the IN_PLACE neutralization pass (SO-001).
   *
   * @param currentNode the element carrying the attribute
   * @param name the attribute name as present on the element
   * @param namespaceURI the attribute's namespace, if any
   * @param value the new attribute value
   * @return true if the value was written without introducing clobbering
   */
  const _setAttributeValue = function _setAttributeValue(currentNode, name, namespaceURI, value) {
    try {
      if (namespaceURI) {
        currentNode.setAttributeNS(namespaceURI, name, value);
      } else {
        /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
        currentNode.setAttribute(name, value);
      }
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return false;
      }
      return true;
    } catch (_) {
      _removeAttribute(name, currentNode);
      return false;
    }
  };
  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param currentNode to sanitize
   */
  // eslint-disable-next-line complexity
  const _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeAttributes, currentNode, null);
    const attributes = currentNode.attributes;
    /* Check if we have attributes; if not we might have a text node */
    if (!attributes || _isClobbered(currentNode)) {
      return;
    }
    /* Same lazy-install guard as uponSanitizeElement (see there): fork the
       attribute allowlist off its shared binding before a hook can see it. */
    ALLOWED_ATTR = _forkSharedAllowlist(hooks.uponSanitizeAttribute, ALLOWED_ATTR, DEFAULT_ALLOWED_ATTR, SET_CONFIG_ALLOWED_ATTR);
    const hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR,
      forceKeepAttr: undefined
    };
    let l = attributes.length;
    const lcTag = transformCaseFunc(currentNode.nodeName);
    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      const attr = attributes[l];
      const name = attr.name,
        namespaceURI = attr.namespaceURI,
        attrValue = attr.value;
      const lcName = transformCaseFunc(name);
      const initValue = attrValue;
      let value = name === 'value' ? initValue : stringTrim(initValue);
      /* Tracks whether this specific attribute pushed a DOMPurify.removed
         record that a later _setAttributeValue() writeback is expected to pop
         back off (the SANITIZE_NAMED_PROPS remove-and-recreate below is the
         only path that does). A value that merely changed via trim, template
         scrubbing, or Trusted Types pushes no such record, so its writeback
         must NOT pop — otherwise it consumes an unrelated _forceRemove subtree
         record and that detached subtree escapes the IN_PLACE handler-
         neutralization pass (SO-001). */
      let recreatedNamedProp = false;
      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
      _executeHooks(hooks.uponSanitizeAttribute, currentNode, hookEvent);
      value = hookEvent.attrValue;
      /* Full DOM Clobbering protection via namespace isolation,
       * Prefix id and name attributes with `user-content-`
       */
      if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name') && stringIndexOf(value, SANITIZE_NAMED_PROPS_PREFIX) !== 0) {
        // Remove the attribute with this value
        _removeAttribute(name, currentNode, attr);
        // Prefix the value and later re-create the attribute with the sanitized value
        value = SANITIZE_NAMED_PROPS_PREFIX + value;
        // This attribute owns the record just pushed; its recreate writeback
        // is the one allowed to pop it back off.
        recreatedNamedProp = true;
      }
      // Else: already prefixed, leave the attribute alone — the prefix is
      // itself the clobbering protection, and re-applying it is incorrect.
      /* Work around a security issue with comments inside attributes */
      if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, value)) {
        _removeAttribute(name, currentNode, attr);
        continue;
      }
      /* Make sure we cannot easily use animated hrefs, even if animations are allowed */
      if (lcName === 'attributename' && stringMatch(value, 'href')) {
        _removeAttribute(name, currentNode, attr);
        continue;
      }
      /* Did the hooks force-keep the attribute? */
      if (hookEvent.forceKeepAttr) {
        continue;
      }
      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        _removeAttribute(name, currentNode, attr);
        continue;
      }
      /* Work around a security issue in jQuery 3.0 */
      if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(SELF_CLOSING_TAG, value)) {
        _removeAttribute(name, currentNode, attr);
        continue;
      }
      /* Sanitize attribute content to be template-safe */
      if (SAFE_FOR_TEMPLATES) {
        value = _stripTemplateExpressions(value);
      }
      /* Is `value` valid for this attribute? */
      if (!_isValidAttribute(lcTag, lcName, value)) {
        _removeAttribute(name, currentNode, attr);
        continue;
      }
      /* Handle attributes that require Trusted Types */
      value = _applyTrustedTypesToAttribute(lcTag, lcName, namespaceURI, value);
      /* Handle invalid data-* attribute set by try-catching it */
      if (value !== initValue) {
        const cleanWrite = _setAttributeValue(currentNode, name, namespaceURI, value);
        /* Only the named-prop remove-and-recreate owns a DOMPurify.removed
           record to pop; a plain trim/template/Trusted-Types writeback owns
           none, so popping here would drop an unrelated subtree's cleanup
           record (SO-001). */
        if (cleanWrite && recreatedNamedProp) {
          arrayPop(DOMPurify.removed);
        }
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeAttributes, currentNode, null);
  };
  /**
   * _sanitizeShadowDOM
   *
   * @param fragment to iterate over recursively
   */
  const _sanitizeShadowDOM2 = function _sanitizeShadowDOM(fragment) {
    let shadowNode = null;
    const shadowIterator = _createNodeIterator(fragment);
    /* Execute a hook if present */
    _executeHooks(hooks.beforeSanitizeShadowDOM, fragment, null);
    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHooks(hooks.uponSanitizeShadowNode, shadowNode, null);
      /* Sanitize tags and elements */
      _sanitizeElements(shadowNode, fragment);
      /* Check attributes next */
      _sanitizeAttributes(shadowNode);
      /* Deep shadow DOM detected.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): use nodeType against the
         DOCUMENT_FRAGMENT_NODE constant rather than instanceof, so we
         recurse into <template>.content from foreign realms too. */
      if (_isDocumentFragment(shadowNode.content)) {
        _sanitizeShadowDOM2(shadowNode.content);
      }
      /* An element iterated here may itself host an attached
         shadow root. The default NodeIterator does not enter shadow
         trees, so a shadow root nested inside template.content was
         previously reached by no walk at all (the pre-pass at
         _sanitizeAttachedShadowRoots descends via childNodes, which
         doesn't enter template.content; the template-content recursion
         above iterates the content but never inspected shadowRoot).
         Walk it explicitly. The nodeType guard avoids reading
         shadowRoot off text / comment / CDATA / PI nodes that the
         iterator also surfaces. */
      if (_readNodeType(shadowNode) === NODE_TYPE.element) {
        const innerSr = getShadowRoot(shadowNode);
        if (_isDocumentFragment(innerSr)) {
          _sanitizeAttachedShadowRoots(innerSr);
          _sanitizeShadowDOM2(innerSr);
        }
      }
    }
    /* Execute a hook if present */
    _executeHooks(hooks.afterSanitizeShadowDOM, fragment, null);
  };
  /**
   * _sanitizeAttachedShadowRoots
   *
   * Walks `root` and feeds every attached shadow root we encounter into
   * the existing _sanitizeShadowDOM pipeline. The default node iterator
   * does not descend into shadow trees, so nodes inside an attached
   * shadow root would otherwise be skipped entirely.
   *
   * Two real input paths put attached shadow roots in front of us:
   *   1. IN_PLACE on a DOM node that already has shadow roots attached.
   *   2. DOM-node input where importNode(dirty, true) deep-clones the
   *      shadow root because it was created with `clonable: true`.
   *
   * This pass runs once, up front, so the main iteration loop (and the
   * existing _sanitizeShadowDOM template-content recursion) stay
   * untouched — string-input paths are not affected.
   *
   * @param root the subtree root to walk for attached shadow roots
   */
  const _sanitizeAttachedShadowRoots = function _sanitizeAttachedShadowRoots(root) {
    /* Iterative (explicit stack) rather than per-child recursion. DOM APIs
       impose no depth cap, so an attacker-shaped tree (JSON/CRDT/editor data
       built straight into the DOM — the IN_PLACE surface) deeper than the JS
       call-stack budget would otherwise overflow native recursion here and
       throw at the IN_PLACE entry pre-pass, before a single node is
       sanitized, leaving the caller's live tree untouched (fail-open). See
       campaign-3 F4. A heap stack keeps depth off the call stack.
            Each work item is either a node to descend into, or a deferred
       `_sanitizeShadowDOM` for an already-walked shadow root. The deferred
       form preserves the original post-order discipline: a shadow root's
       nested shadow roots are discovered before the outer shadow is
       sanitized (which may remove hosts). Pushes are in reverse of the
       desired processing order (LIFO): template content, then children, then
       the shadow-sanitize, then the shadow walk — so the order matches the
       previous recursion exactly. */
    const stack = [{
      node: root,
      shadow: null
    }];
    while (stack.length > 0) {
      const item = stack.pop();
      /* Deferred shadow-DOM sanitisation: runs after its subtree was walked. */
      if (item.shadow) {
        _sanitizeShadowDOM2(item.shadow);
        continue;
      }
      const node = item.node;
      const nodeType = _readNodeType(node);
      const isElement = nodeType === NODE_TYPE.element;
      /* (pushed last → processed first) Children, snapshotted in reverse so
         the first child is processed first. Snapshotting matters because a
         hook may detach siblings mid-walk. */
      const childNodes = getChildNodes(node);
      if (childNodes) {
        for (let i = childNodes.length - 1; i >= 0; --i) {
          stack.push({
            node: childNodes[i],
            shadow: null
          });
        }
      }
      /* (pushed before children → processed after them, matching the old
         "template content last" order) When the node is a <template>,
         descend into its content. */
      if (isElement) {
        const rootName = getNodeName ? getNodeName(node) : null;
        if (typeof rootName === 'string' && transformCaseFunc(rootName) === 'template') {
          const content = node.content;
          if (_isDocumentFragment(content)) {
            stack.push({
              node: content,
              shadow: null
            });
          }
        }
      }
      /* Shadow root (processed first): walk its subtree, then sanitise it.
         Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
         rather than `instanceof DocumentFragment`, which is realm-bound and
         silently skipped foreign-realm shadow roots (e.g.
         iframe.contentDocument attachShadow). */
      if (isElement) {
        const sr = getShadowRoot(node);
        if (_isDocumentFragment(sr)) {
          /* Push the deferred sanitise first so it pops after the shadow
             walk we push next, i.e. nested shadow roots are discovered
             before this one is sanitised. */
          stack.push({
            node: null,
            shadow: sr
          }, {
            node: sr,
            shadow: null
          });
        }
      }
    }
  };
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty) {
    let cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let body = null;
    let importedNode = null;
    let currentNode = null;
    let returnNode = null;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    IS_EMPTY_INPUT = !dirty;
    if (IS_EMPTY_INPUT) {
      dirty = '<!-->';
    }
    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      dirty = stringifyValue(dirty);
      if (typeof dirty !== 'string') {
        throw typeErrorCreate('dirty is not a string, aborting');
      }
    }
    /* Return dirty HTML if DOMPurify cannot run */
    if (!DOMPurify.isSupported) {
      return dirty;
    }
    /* Assign config vars */
    if (SET_CONFIG) {
      /* Persistent setConfig() path: _parseConfig is skipped, so the sets are
       * not re-derived per call. Restore them from the pristine bindings
       * captured at setConfig() time so a previous call's hook clone (mutated
       * below) does not carry over. */
      ALLOWED_TAGS = SET_CONFIG_ALLOWED_TAGS;
      ALLOWED_ATTR = SET_CONFIG_ALLOWED_ATTR;
    } else {
      _parseConfig(cfg);
    }
    /* Clone the hook-mutable allowlists before the walk whenever an
     * uponSanitize* hook is registered. The hook event exposes ALLOWED_TAGS
     * and ALLOWED_ATTR by reference (as allowedTags / allowedAttributes), so
     * a hook that widens them would otherwise mutate the shared set
     * permanently: across later calls and across every element. Cloning per
     * walk keeps documented in-call widening working while scoping it to the
     * call. A single guard for both config paths - the per-call path rebinds
     * the sets in _parseConfig each call, the persistent path restores them
     * from the captured bindings just above - so the two cannot diverge. */
    if (hooks.uponSanitizeElement.length > 0 || hooks.uponSanitizeAttribute.length > 0) {
      ALLOWED_TAGS = clone$2(ALLOWED_TAGS);
    }
    if (hooks.uponSanitizeAttribute.length > 0) {
      ALLOWED_ATTR = clone$2(ALLOWED_ATTR);
    }
    /* Clean up removed elements */
    DOMPurify.removed = [];
    /* Resolve IN_PLACE for this call without mutating persistent config.
       Writing the IN_PLACE closure variable here leaks under setConfig(),
       where _parseConfig is skipped on later calls: a single string call would
       disable in-place mode for every subsequent node call, returning a
       sanitized copy while leaving the caller's node — which in-place callers
       keep using and whose return value they ignore — unsanitized. REPORT-2. */
    const inPlace = IN_PLACE && typeof dirty !== 'string' && _isNode(dirty);
    if (inPlace) {
      /* Declarative-partial-updates / streaming pre-pass: sever every patch
         linkage across the live tree BEFORE the walk, so no patch can fire
         mid-walk and inject into an already-processed region. Runs first, so
         it also covers the forbidden/clobbered roots that throw below. */
      _neutralizePatchLinkage(dirty);
      /* Do some early pre-sanitization to avoid unsafe root nodes.
         Read nodeName through the cached prototype getter — a clobbering
         child named "nodeName" on the form root would otherwise shadow
         the property and let this check skip the root-allowlist
         validation entirely. */
      const nn = _readNodeName(dirty);
      if (typeof nn === 'string') {
        const tagName = transformCaseFunc(nn);
        if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
          /* Fail closed on a live root: neutralize handlers/children before
             throwing, exactly as the mid-walk abort path does. */
          _neutralizeRoot(dirty);
          throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
        }
      }
      /* Pre-flight the root through _isClobbered. The iterator-driven
         removal path can not detach a parent-less root: _forceRemove
         falls through to Element.prototype.remove(), which per spec
         is a no-op on a node with no parent. A clobbered root would
         then survive the main loop with its attributes uninspected,
         because _sanitizeAttributes early-returns on _isClobbered. The
         result would be an attacker-controlled form, complete with any
         event-handler attributes the caller passed in, handed back to
         the application unsanitized. Refuse to sanitize such a root
         the same way we refuse a forbidden tag. GHSA-r47g-fvhr-h676. */
      if (_isClobbered(dirty)) {
        /* Fail closed on a live clobbered root before throwing.
           _neutralizeRoot's reads are clobber-safe (cached getters); the
           form's non-clobbered descendants, e.g. an armed <img>, are scrubbed. */
        _neutralizeRoot(dirty);
        throw typeErrorCreate('root node is clobbered and cannot be sanitized in-place');
      }
      /* Sanitize attached shadow roots before the main iterator runs.
         The iterator does not descend into shadow trees. Same fail-closed
         barrier as the main walk (campaign-3 F2): a custom-element reaction
         inside a shadow root could abort this pre-pass before the walk runs,
         which would otherwise leave the entire live tree unsanitized. */
      try {
        _sanitizeAttachedShadowRoots(dirty);
      } catch (error) {
        _neutralizeRoot(dirty);
        throw error;
      }
    } else if (_isNode(dirty)) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!---->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === NODE_TYPE.element && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else if (importedNode.nodeName === 'HTML') {
        body = importedNode;
      } else {
        // eslint-disable-next-line unicorn/prefer-dom-node-append
        body.appendChild(importedNode);
      }
      /* Clonable shadow roots are deep-cloned by importNode(); sanitize
         them before the main iterator runs, since the iterator does not
         descend into shadow trees. The walk routes every read through a
         cached prototype getter so clobbering descendants on a form root
         cannot hide a shadow host from this pass.
                Traverse from `body`, not `importedNode`: when importedNode is a
         DocumentFragment, the appendChild() above moves its children into
         `body` and leaves the fragment empty, so walking importedNode would
         scan nothing and miss every attached shadow host now under `body`
         (SO-003). In the BODY/HTML branches `body === importedNode`, so this
         is equivalent there; in the element branch `body` contains the
         appended element and its descendants. `body` covers all three. */
      _sanitizeAttachedShadowRoots(body);
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
      // eslint-disable-next-line unicorn/prefer-includes
      dirty.indexOf('<') === -1) {
        return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(dirty) : dirty;
      }
      /* Initialize the document to work on */
      body = _initDocument(dirty);
      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
      }
    }
    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }
    /* Get node iterator */
    const walkRoot = inPlace ? dirty : body;
    /* Now start iterating over the created document.
       The walk runs inside an exception barrier (campaign-3 F2): a re-entrant
       engine/custom-element mutation can detach a node mid-walk so
       `_forceRemove`'s parentless guard throws, aborting the loop. Without the
       barrier the caller's in-place tree would be left half-sanitized with the
       unvisited tail still armed. _createNodeIterator itself is inside the
       barrier too: constructing the iterator dereferences the root's document,
       and any failure there (e.g. an exotic/clobbered root) must still fail
       closed rather than skip the neutralize. On any throw we fail closed -
       strip the in-place root bare - then rethrow so the existing throw
       contract is preserved. (String/DOM-copy paths never return the partial
       body, so the propagating throw is already fail-closed there.) */
    try {
      const nodeIterator = _createNodeIterator(walkRoot);
      while (currentNode = nodeIterator.nextNode()) {
        /* Sanitize tags and elements */
        _sanitizeElements(currentNode, walkRoot);
        /* Check attributes next */
        _sanitizeAttributes(currentNode);
        /* Shadow DOM detected, sanitize it.
           Realm-safe check (GHSA-hpcv-96wg-7vj8): nodeType-based detection
           instead of instanceof, so foreign-realm <template>.content is
           walked correctly. */
        if (_isDocumentFragment(currentNode.content)) {
          _sanitizeShadowDOM2(currentNode.content);
        }
      }
    } catch (error) {
      if (inPlace) {
        _neutralizeRoot(dirty);
        /* Nodes _forceRemove'd earlier in the aborted walk are already
           detached from the root, so _neutralizeRoot's subtree pass does not
           reach them. Defuse them too, mirroring the success-path loop below. */
        arrayForEach(DOMPurify.removed, entry => {
          if (entry.element) {
            _neutralizeSubtree(entry.element);
          }
        });
      }
      throw error;
    }
    /* If we sanitized `dirty` in-place, return it. */
    if (inPlace) {
      /* Fail-closed completion of the audit-5 F1 fix: every node removed from
         the caller's live tree is detached but may still hold a queued
         resource-event handler that fires in page scope after we return. The
         move-hoist covers only disallowed-tag KEEP_CONTENT removals; strip the
         non-allow-listed attributes off every other removed subtree (clobber,
         mXSS, namespace, comments, KEEP_CONTENT:false, …) so those handlers are
         cancelled before any event can fire. Runs synchronously, pre-return. */
      arrayForEach(DOMPurify.removed, entry => {
        if (entry.element) {
          _neutralizeSubtree(entry.element);
        }
      });
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions2(dirty);
      }
      return dirty;
    }
    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (SAFE_FOR_TEMPLATES) {
        _scrubTemplateExpressions2(body);
      }
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);
        while (body.firstChild) {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }
      if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmode) {
        /*
          AdoptNode() is not used because internal state is not reset
          (e.g. the past names map of a HTMLFormElement), this is safe
          in theory but we would rather not risk another attack vector.
          The state that is cloned by importNode() is explicitly defined
          by the specs.
        */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }
      return returnNode;
    }
    let serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
    /* Serialize doctype if allowed */
    if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) {
      serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
    }
    /* Sanitize final string template-safe */
    if (SAFE_FOR_TEMPLATES) {
      serializedHTML = _stripTemplateExpressions(serializedHTML);
    }
    return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? _createTrustedHTML(serializedHTML) : serializedHTML;
  };
  DOMPurify.setConfig = function () {
    let cfg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _parseConfig(cfg);
    SET_CONFIG = true;
    SET_CONFIG_ALLOWED_TAGS = ALLOWED_TAGS;
    SET_CONFIG_ALLOWED_ATTR = ALLOWED_ATTR;
  };
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
    SET_CONFIG_ALLOWED_TAGS = null;
    SET_CONFIG_ALLOWED_ATTR = null;
    // Drop any caller-supplied Trusted Types policy so it cannot poison later
    // `RETURN_TRUSTED_TYPE` output. The internal default policy (cached, and
    // never recreated — Trusted Types throws on duplicate names) is restored by
    // the next `_parseConfig`. See GHSA-vxr8-fq34-vvx9.
    trustedTypesPolicy = defaultTrustedTypesPolicy;
    emptyHTML = '';
  };
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    const lcTag = transformCaseFunc(tag);
    const lcName = transformCaseFunc(attr);
    return _isValidAttribute(lcTag, lcName, value);
  };
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    /* Reject unknown entry points. Without this, a non-hook key (e.g.
     * '__proto__') indexes off the prototype chain rather than a real
     * hook array, and arrayPush then writes to Object.prototype. Guard
     * with an own-property check against the known hook names. */
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return;
    }
    arrayPush(hooks[entryPoint], hookFunction);
  };
  DOMPurify.removeHook = function (entryPoint, hookFunction) {
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return undefined;
    }
    if (hookFunction !== undefined) {
      const index = arrayLastIndexOf(hooks[entryPoint], hookFunction);
      return index === -1 ? undefined : arraySplice(hooks[entryPoint], index, 1)[0];
    }
    return arrayPop(hooks[entryPoint]);
  };
  DOMPurify.removeHooks = function (entryPoint) {
    if (!objectHasOwnProperty(hooks, entryPoint)) {
      return;
    }
    hooks[entryPoint] = [];
  };
  DOMPurify.removeAllHooks = function () {
    hooks = _createHooksMap();
  };
  return DOMPurify;
}
var purify = createDOMPurify();

const RoomTypeCodeContent = ({
  id,
  roomType: roomTypeProp
}) => {
  const {
    getRoomType
  } = useContext(RoomTypesListContext);
  const {
    crossPropertyRoomTypesList
  } = useContext(CrossPropertyRoomTypesListContext);
  let roomType = roomTypeProp;
  if (!roomType && id) {
    roomType = crossPropertyRoomTypesList?.[id] ?? getRoomType(id);
  }
  if (!roomType) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  if (roomType.hotelShortName) {
    const code = purify.sanitize(roomType.code + '-+-' + roomType.hotelShortName);
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx("div", {
        dangerouslySetInnerHTML: {
          __html: code
        }
      }), /*#__PURE__*/jsx(Tooltip$1, {
        content: "Cross Property",
        position: "top",
        children: /*#__PURE__*/jsx(Label, {
          backgroundColor: colors$1.primary10,
          color: colors$1.primaryColor,
          children: "CP"
        })
      })]
    });
  }
  return /*#__PURE__*/jsx("span", {
    dangerouslySetInnerHTML: {
      __html: purify.sanitize(roomType.code)
    }
  });
};
const RoomTypeCode = ({
  id,
  roomType
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(RoomTypeCodeContent, {
      id: id,
      roomType: roomType
    })
  });
};

const EXCLUDED_METADATA_KEYS = ['reservationDailyRates'];
const formatMetadataKey = key => {
  const spaced = key.replace(/([A-Z])/g, ' $1');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
};
const shouldShowMetadataEntry = key => {
  if (EXCLUDED_METADATA_KEYS.includes(key)) {
    return false;
  }
  if (key.includes('Opportunity')) {
    return false;
  }
  return true;
};
const ReservationProfileDetails = ({
  reservationProfile,
  onEditDatesClick
}) => {
  const checkinDisplay = formatDate$1(reservationProfile.checkin, 'd MMM');
  const checkoutDisplay = formatDate$1(reservationProfile.checkout, 'd MMM');
  return /*#__PURE__*/jsxs("div", {
    className: css$y.reservationDetails,
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      children: "Reservation Details"
    }), /*#__PURE__*/jsxs(FlexContainer, {
      gap: 15,
      justifyContent: "space-between",
      className: css$y.detailPair,
      children: [/*#__PURE__*/jsx(DetailRow, {
        label: "Check In",
        value: /*#__PURE__*/jsx("span", {
          className: css$y.noWrap,
          children: checkinDisplay
        }),
        icon: onEditDatesClick ? /*#__PURE__*/jsx(Edit04, {}) : undefined,
        iconClick: onEditDatesClick
      }), /*#__PURE__*/jsx(DetailRow, {
        label: "Check Out",
        value: /*#__PURE__*/jsx("span", {
          className: css$y.noWrap,
          children: checkoutDisplay
        }),
        icon: onEditDatesClick ? /*#__PURE__*/jsx(Edit04, {}) : undefined,
        iconClick: onEditDatesClick
      })]
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Current Room Type",
      value: /*#__PURE__*/jsx(RoomTypeCode, {
        id: reservationProfile.roomTypeId
      })
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Booked Room Type",
      value: /*#__PURE__*/jsx(RoomTypeCode, {
        id: reservationProfile.bookedRoomTypeId
      })
    }), /*#__PURE__*/jsxs(FlexContainer, {
      gap: 15,
      justifyContent: "space-between",
      className: css$y.detailPair,
      children: [/*#__PURE__*/jsx(DetailRow, {
        label: "Adults",
        value: reservationProfile.adults
      }), /*#__PURE__*/jsx(DetailRow, {
        label: "Children",
        value: reservationProfile.children
      })]
    }), reservationProfile.metadata && /*#__PURE__*/jsx(FlexContainer, {
      gap: 15,
      className: css$y.detailPair,
      children: Object.entries(reservationProfile.metadata).map(([key, value]) => {
        if (!shouldShowMetadataEntry(key)) {
          return null;
        }
        return /*#__PURE__*/jsx(DetailRow, {
          label: formatMetadataKey(key),
          value: value
        }, key);
      })
    })]
  });
};
ReservationProfileDetails.propTypes = {
  reservationProfile: PropTypes.shape({
    checkin: PropTypes.string,
    checkout: PropTypes.string,
    roomTypeId: PropTypes.number,
    bookedRoomTypeId: PropTypes.number,
    adults: PropTypes.number,
    children: PropTypes.number,
    metadata: PropTypes.object
  }).isRequired,
  onEditDatesClick: PropTypes.func
};

const VARIANT_MAP$1 = {
  CONFIRMED: 'success',
  CANCELLED: 'danger',
  TENTATIVE: 'warning'
};
const ReservationStatusLabel = ({
  status
}) => {
  const variant = VARIANT_MAP$1[status];
  if (variant) {
    return /*#__PURE__*/jsx(Label, {
      variant: variant,
      children: status
    });
  }
  return /*#__PURE__*/jsx(Label, {
    backgroundColor: colors$1.grey20,
    color: colors$1.grey,
    children: status
  });
};
ReservationStatusLabel.propTypes = {
  status: PropTypes.string
};

const VARIANT_MAP = {
  UPSELL: 'success',
  PendingRequest: 'warning',
  REJECTED: 'danger',
  EXPIRED: 'danger'
};
const CUSTOM_STYLE_MAP = {
  CANCELLED: {
    backgroundColor: colors$1.warning,
    color: 'white'
  },
  OPENED: {
    backgroundColor: colors$1.tips20,
    color: colors$1.tips
  },
  CLICKED: {
    backgroundColor: colors$1.tips20,
    color: colors$1.tips
  },
  SENT: {
    backgroundColor: colors$1.tips,
    color: 'white'
  },
  IMPORTED: {
    backgroundColor: colors$1.grey64,
    color: 'white'
  },
  INCOMPLETE: {
    backgroundColor: colors$1.grey8,
    color: colors$1.grey
  },
  BLOCKED: {
    backgroundColor: colors$1.grey,
    color: 'white'
  }
};
const UpsellingBlockerCode = ({
  error
}) => {
  if (!error) {
    return null;
  }
  const readableError = error.split('_').join(' ');
  const abbreviation = error.split('_').map(word => word[0]).join('');
  return /*#__PURE__*/jsx(Tooltip$1, {
    position: "left",
    content: readableError,
    children: /*#__PURE__*/jsx(Label, {
      variant: "danger",
      style: {
        fontSize: '9px',
        fontWeight: 'bold'
      },
      children: abbreviation
    })
  });
};
const UpsellStatusLabel = ({
  status,
  upsellingBlocker
}) => {
  const variant = VARIANT_MAP[status];
  if (variant) {
    return /*#__PURE__*/jsx(Label, {
      variant: variant,
      children: status === 'PendingRequest' ? 'PENDING' : status
    });
  }
  const customStyle = CUSTOM_STYLE_MAP[status];
  if (customStyle) {
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx(Label, {
        backgroundColor: customStyle.backgroundColor,
        color: customStyle.color,
        children: status
      }), status === 'BLOCKED' && /*#__PURE__*/jsx(UpsellingBlockerCode, {
        error: upsellingBlocker
      })]
    });
  }
  return /*#__PURE__*/jsx(Label, {
    backgroundColor: colors$1.grey20,
    color: colors$1.grey,
    children: status
  });
};
UpsellStatusLabel.propTypes = {
  status: PropTypes.string,
  upsellingBlocker: PropTypes.string
};

const ReservationProfileStatus = ({
  reservationProfile,
  upsellTotal,
  showUpsellStatus = true
}) => {
  const hasPreArrivalInteraction = !!reservationProfile.preArrivalInteraction;
  const totalAmount = upsellTotal?.total ?? 0;
  const totalCurrency = upsellTotal?.currency ?? reservationProfile.upsellSummary?.currency ?? 'EUR';
  const totalHighlightStyle = {
    backgroundColor: colors$1.success10,
    color: colors$1.success
  };
  const fields = [{
    label: 'Res. Status',
    content: /*#__PURE__*/jsx(ReservationStatusLabel, {
      status: reservationProfile.reservationStatus
    })
  }, {
    label: 'Res. ID',
    content: reservationProfile.channelReference
  }, {
    label: 'Language',
    content: reservationProfile.guest?.language || '-'
  }];
  if (showUpsellStatus) {
    fields.push({
      label: 'Upsell Status',
      content: /*#__PURE__*/jsx(UpsellStatusLabel, {
        status: reservationProfile.status,
        upsellingBlocker: reservationProfile.upsellingBlocker
      })
    });
  } else if (hasPreArrivalInteraction) {
    fields.push({
      label: 'Pre-Arrival Interaction',
      content: /*#__PURE__*/jsx(PreArrivalInteractionLabel, {
        preArrivalInteraction: reservationProfile.preArrivalInteraction,
        abandonedCart: reservationProfile.abandonedCart,
        reservation: reservationProfile
      })
    });
  }
  fields.push({
    label: 'Total',
    content: totalAmount > 0 ? formatCurrency(totalAmount, totalCurrency) : '-',
    highlight: totalAmount > 0
  });
  return /*#__PURE__*/jsxs(Table, {
    cellAlign: "center",
    style: {
      marginBottom: 20
    },
    children: [/*#__PURE__*/jsx(TableHead, {
      children: fields.map(field => /*#__PURE__*/jsx(TableHeader, {
        children: field.label
      }, field.label))
    }), /*#__PURE__*/jsx("tbody", {
      children: /*#__PURE__*/jsx(TableRow, {
        children: fields.map(field => /*#__PURE__*/jsx(TableCell, {
          style: field.highlight ? totalHighlightStyle : undefined,
          children: field.content
        }, field.label))
      })
    })]
  });
};
ReservationProfileStatus.propTypes = {
  reservationProfile: PropTypes.shape({
    reservationStatus: PropTypes.string,
    status: PropTypes.string,
    channelReference: PropTypes.string,
    upsellingBlocker: PropTypes.string,
    preArrivalInteraction: PropTypes.string,
    abandonedCart: PropTypes.object,
    upsellSummary: PropTypes.shape({
      currency: PropTypes.string
    }),
    guest: PropTypes.shape({
      language: PropTypes.string
    })
  }).isRequired,
  upsellTotal: PropTypes.shape({
    total: PropTypes.number,
    currency: PropTypes.string
  })
};

const ReservationSegmentationDetails = ({
  reservationProfile
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$y.reservationDetails,
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      children: "Segmentation"
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Rate Code",
      value: reservationProfile.ratePlan
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Market Segment",
      value: reservationProfile.marketSegment
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Source",
      value: reservationProfile.reservationSource
    }), /*#__PURE__*/jsx(DetailRow, {
      label: "Membership Level",
      value: reservationProfile.guest?.membershipLevel
    })]
  });
};
ReservationSegmentationDetails.propTypes = {
  reservationProfile: PropTypes.shape({
    ratePlan: PropTypes.string,
    marketSegment: PropTypes.string,
    reservationSource: PropTypes.string,
    guest: PropTypes.shape({
      membershipLevel: PropTypes.string
    })
  }).isRequired
};

const ReservationProfileEmails = ({
  reservationProfile,
  mailLogs,
  onSendEmail,
  sendableEmails
}) => {
  const {
    formatTz
  } = useTimezone();
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(Table, {
      style: {
        marginBottom: '20px'
      },
      children: [/*#__PURE__*/jsxs(TableHead, {
        children: [/*#__PURE__*/jsx(TableHeader, {
          children: "Email Type"
        }), /*#__PURE__*/jsx(TableHeader, {
          align: "right",
          children: "Sent"
        }), /*#__PURE__*/jsx(TableHeader, {
          children: "Recipient"
        }), /*#__PURE__*/jsx(TableHeader, {
          align: "center",
          children: "Opened"
        })]
      }), /*#__PURE__*/jsx("tbody", {
        children: Object.values(mailLogs || {}).map(logEvent => /*#__PURE__*/jsx(ProfileMailLogRow, {
          logEvent: logEvent,
          upgradableRoomTypeCodes: reservationProfile.upgradableRoomTypeCodes,
          formatTz: formatTz
        }, logEvent.id))
      })]
    }), onSendEmail && sendableEmails && /*#__PURE__*/jsx(DropdownButton, {
      label: "Send Email",
      icon: /*#__PURE__*/jsx(Send01, {}),
      position: "above",
      align: "left",
      children: sendableEmails.map(email => {
        const handleSendEmail = () => onSendEmail(email.type);
        return /*#__PURE__*/jsx(ButtonDropdownItem, {
          onClick: handleSendEmail,
          children: email.name
        }, email.type);
      })
    })]
  });
};
const ProfileMailLogRow = ({
  logEvent,
  upgradableRoomTypeCodes,
  formatTz
}) => {
  const formatString = str => {
    if (!str) {
      return '';
    }
    return str.replace(/_/g, ' ').split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(TableRow, {
      children: [/*#__PURE__*/jsx(TableCell, {
        children: formatString(logEvent.template_name)
      }), /*#__PURE__*/jsx(TableCell, {
        align: "right",
        children: formatTz(logEvent.created_at, 'dd MMM HH:mm:ss')
      }), /*#__PURE__*/jsxs(TableCell, {
        children: [logEvent.recipient_type, logEvent.recipient && /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("small", {
            children: logEvent.recipient
          })]
        })]
      }), /*#__PURE__*/jsx(TableCell, {
        align: "center",
        children: /*#__PURE__*/jsx(EmailOpenStatusLabel, {
          isOpened: logEvent.opened
        })
      })]
    }), logEvent.isUpselling && logEvent.recipient_type !== 'hotel' && /*#__PURE__*/jsx(TableRow, {
      children: /*#__PURE__*/jsxs(TableCell, {
        colSpan: 4,
        style: {
          textAlign: 'left'
        },
        children: [logEvent.offered_rooms && /*#__PURE__*/jsxs("p", {
          children: ["Room Upgrade Offers: ", /*#__PURE__*/jsx("strong", {
            children: Array.isArray(upgradableRoomTypeCodes) ? upgradableRoomTypeCodes.join(', ') : upgradableRoomTypeCodes
          })]
        }), Array.isArray(logEvent.offered_extras) && logEvent.offered_extras.length > 0 && /*#__PURE__*/jsxs("p", {
          children: ["Offered Extras: ", /*#__PURE__*/jsx("strong", {
            children: logEvent.offered_extras.join(', ')
          }), ".", Array.isArray(logEvent.excluded_extras) && logEvent.excluded_extras.length > 0 && /*#__PURE__*/jsxs(Fragment$1, {
            children: [" Excluded: ", /*#__PURE__*/jsx("strong", {
              children: logEvent.excluded_extras.join(', ')
            })]
          })]
        })]
      })
    })]
  });
};
const EmailOpenStatusLabel = ({
  isOpened
}) => {
  if (isOpened) {
    return /*#__PURE__*/jsx(Label, {
      variant: "success",
      children: "Yes"
    });
  }
  return /*#__PURE__*/jsx(Label, {
    variant: "danger",
    children: "No"
  });
};

const ReservationProfileLogs = ({
  reservationProfile,
  reservationEvents
}) => {
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(Table, {
      children: [/*#__PURE__*/jsxs(TableHead, {
        children: [/*#__PURE__*/jsx(TableHeader, {
          width: 180,
          children: "Date/Time"
        }), /*#__PURE__*/jsx(TableHeader, {
          children: "Event"
        })]
      }), /*#__PURE__*/jsx("tbody", {
        children: reservationEvents && reservationEvents.map(logEvent => /*#__PURE__*/jsx(ProfileLogsRow, {
          logEvent: logEvent
        }, logEvent.id))
      })]
    }), reservationProfile.channelIntegrationLog && reservationProfile.channelIntegrationLog.length > 0 && /*#__PURE__*/jsxs(Table, {
      style: {
        marginTop: 20
      },
      children: [/*#__PURE__*/jsxs(TableHead, {
        children: [/*#__PURE__*/jsx(TableHeader, {
          children: "Date/Time"
        }), /*#__PURE__*/jsx(TableHeader, {
          children: "Action"
        })]
      }), /*#__PURE__*/jsx("tbody", {
        children: reservationProfile.channelIntegrationLog.map(logEvent => /*#__PURE__*/jsx(ChannelIntegrationRow, {
          logEvent: logEvent
        }, logEvent.id))
      })]
    })]
  });
};
const ProfileLogsRow = ({
  logEvent
}) => {
  const {
    formatTz
  } = useTimezone();
  return /*#__PURE__*/jsxs(TableRow, {
    children: [/*#__PURE__*/jsx(TableCell, {
      children: formatTz(logEvent.timestamp, 'dd MMM yy HH:mm:ss')
    }), /*#__PURE__*/jsx(TableCell, {
      children: logEvent.description
    })]
  });
};
const ChannelIntegrationRow = ({
  logEvent
}) => {
  const {
    formatTz
  } = useTimezone();
  const prettyAction = (logEvent.action || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  return /*#__PURE__*/jsxs(TableRow, {
    children: [/*#__PURE__*/jsx(TableCell, {
      children: formatTz(logEvent.createdAt, 'dd MMM yy HH:mm:ss')
    }), /*#__PURE__*/jsx(TableCell, {
      children: prettyAction
    })]
  });
};

const calculateUpsellTotal = (reservationProfile, bookedExtras, roomUpgrades) => {
  let total = 0;
  let currency = reservationProfile?.upsellSummary?.currency || 'EUR';
  if (bookedExtras) {
    bookedExtras.forEach(extra => {
      if (extra.status === bookedExtraStatus.CONFIRMED) {
        total += extra.totalPrice || 0;
        if (extra.currency) {
          currency = extra.currency;
        }
      }
    });
  }
  if (roomUpgrades) {
    roomUpgrades.forEach(upgrade => {
      if (upgrade.status === roomUpgradesStatus.CONFIRMED) {
        total += upgrade.amount || 0;
        if (upgrade.currency) {
          currency = upgrade.currency;
        }
      }
    });
  }
  return {
    total,
    currency
  };
};

const ExtraTypeCodeContent = ({
  id,
  extraType: extraTypeProp,
  variationId,
  variation: variationProp
}) => {
  const {
    getExtraType
  } = useContext(ExtraTypesListContext);
  const extraType = extraTypeProp ?? (id ? getExtraType(id) : null);
  if (!extraType) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  const variation = variationProp ?? (variationId ? extraType.variations?.[variationId] ?? null : null);
  let code = isNaN(extraType.code) ? extraType.code : extraType.name;
  if (variation) {
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: [/*#__PURE__*/jsx("span", {
        dangerouslySetInnerHTML: {
          __html: purify.sanitize(code)
        }
      }), "\xA0", /*#__PURE__*/jsx("small", {
        dangerouslySetInnerHTML: {
          __html: `[${purify.sanitize(variation.code)}]`
        }
      })]
    });
  }
  return /*#__PURE__*/jsx("span", {
    dangerouslySetInnerHTML: {
      __html: purify.sanitize(code)
    }
  });
};
const ExtraTypeCode = ({
  id,
  extraType,
  variationId,
  variation
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(ExtraTypeCodeContent, {
      id: extraType ? undefined : id,
      extraType: extraType,
      variationId: variation ? undefined : variationId,
      variation: variation
    })
  });
};

const ExtraTypeVariationCodeContent = ({
  id,
  variationId
}) => {
  const {
    getExtraType
  } = useContext(ExtraTypesListContext);
  if (!id) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  const extraType = getExtraType(id);
  if (!extraType) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  let variation = null;
  if (variationId) {
    variation = extraType.variations[variationId] ?? null;
  }
  if (variation) {
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: ["[", variation.code, "]"]
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: "-"
  });
};
const ExtraTypeVariationCode = ({
  id,
  variationId
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(ExtraTypeVariationCodeContent, {
      id: id,
      variationId: variationId
    })
  });
};

const BundleManagedHint = () => /*#__PURE__*/jsx(FlexContainer, {
  justifyContent: "center",
  children: /*#__PURE__*/jsx(Tooltip$1, {
    content: "Managed as part of the bundle",
    position: "left",
    children: /*#__PURE__*/jsx(InformationCircleContained, {})
  })
});

const BundleIncludesCaption = ({
  bookedExtras
}) => /*#__PURE__*/jsxs("span", {
  children: ["Includes", ' ', bookedExtras.map((bookedExtra, index) => /*#__PURE__*/jsxs(React.Fragment, {
    children: [/*#__PURE__*/jsx(ExtraTypeCode, {
      id: bookedExtra.extraTypeId
    }), bookedExtra.quantity > 1 ? ` x${bookedExtra.quantity}` : '', index < bookedExtras.length - 1 ? ', ' : '']
  }, `${bookedExtra.extraTypeId}-${index}`))]
});
BundleIncludesCaption.propTypes = {
  bookedExtras: PropTypes.arrayOf(PropTypes.shape({
    extraTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    quantity: PropTypes.number
  })).isRequired
};

const BundlePartOfUpgradeCaption = ({
  roomTypeId
}) => /*#__PURE__*/jsxs("span", {
  children: ["Part of ", /*#__PURE__*/jsx(RoomTypeCode, {
    id: roomTypeId
  }), " upgrade"]
});
BundlePartOfUpgradeCaption.propTypes = {
  roomTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};

var css_248z$y = "@media (max-width:768px){.BundleMarker-module__bundleMarkerCell___41D0K{align-items:flex-start!important;flex:1 1 auto!important;min-width:0!important}.BundleMarker-module__bundleMarkerRow___Nt9-x{justify-content:flex-start!important}}";
var css$x = {"bundleMarkerCell":"BundleMarker-module__bundleMarkerCell___41D0K","bundleMarkerRow":"BundleMarker-module__bundleMarkerRow___Nt9-x"};
styleInject(css_248z$y);

const ICON_STYLE = {
  flexShrink: 0,
  width: 15,
  height: 15,
  cursor: 'default'
};
const TOOLTIP_ICON_STYLE = {
  display: 'flex',
  alignItems: 'center'
};
const TOOLTIP_TEXT_STYLE = {
  minWidth: 0,
  display: 'block'
};
const TOOLTIP_MAX_WIDTH = 240;
const CaptionText = ({
  children
}) => /*#__PURE__*/jsx(Text$2, {
  size: "xs",
  color: "muted",
  children: children
});
CaptionText.propTypes = {
  children: PropTypes.node.isRequired
};
const resolveCaption = (roomTypeId, bookedExtras) => {
  if (roomTypeId) {
    return /*#__PURE__*/jsx(BundlePartOfUpgradeCaption, {
      roomTypeId: roomTypeId
    });
  }
  if (bookedExtras?.length > 0) {
    return /*#__PURE__*/jsx(BundleIncludesCaption, {
      bookedExtras: bookedExtras
    });
  }
  return null;
};
const BundleMarker = ({
  roomTypeId = null,
  bookedExtras = [],
  captionPlacement = 'below',
  children
}) => {
  const icon = /*#__PURE__*/jsx(Gift01Icon, {
    color: colors$1.preArrival,
    style: ICON_STYLE
  });
  const caption = resolveCaption(roomTypeId, bookedExtras);
  if (captionPlacement === 'tooltip') {
    return /*#__PURE__*/jsxs(FlexContainer, {
      gap: 6,
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      children: [/*#__PURE__*/jsx(Tooltip$1, {
        content: caption,
        show: Boolean(caption),
        position: "top",
        portal: true,
        maxWidth: TOOLTIP_MAX_WIDTH,
        style: TOOLTIP_ICON_STYLE,
        children: icon
      }), /*#__PURE__*/jsx(Text$2, {
        truncate: true,
        children: children
      })]
    });
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: css$x.bundleMarkerCell,
    flexDirection: "column",
    flexFlow: "column",
    gap: 2,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      className: css$x.bundleMarkerRow,
      gap: 6,
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      children: [icon, /*#__PURE__*/jsx(Tooltip$1, {
        content: children,
        position: "top",
        portal: true,
        maxWidth: TOOLTIP_MAX_WIDTH,
        style: TOOLTIP_TEXT_STYLE,
        children: /*#__PURE__*/jsx(Text$2, {
          truncate: true,
          children: children
        })
      })]
    }), caption && /*#__PURE__*/jsx(CaptionText, {
      children: caption
    })]
  });
};
BundleMarker.propTypes = {
  roomTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  bookedExtras: PropTypes.arrayOf(PropTypes.shape({
    extraTypeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    quantity: PropTypes.number
  })),
  captionPlacement: PropTypes.oneOf(['below', 'tooltip']),
  children: PropTypes.node.isRequired
};

const BookedExtraDynamicPricing = ({
  dynamicPricingDetails
}) => {
  if (!dynamicPricingDetails) {
    return null;
  }
  let dynamicPricingDescription = dynamicPricingDetails.range.roomRatePercentage + '% of room rate @ ';
  dynamicPricingDescription += formatCurrency(dynamicPricingDetails.roomTypePrice.amount, dynamicPricingDetails.roomTypePrice.currency);
  return /*#__PURE__*/jsxs("div", {
    style: {
      whiteSpace: 'normal'
    },
    children: [/*#__PURE__*/jsx(Label, {
      backgroundColor: colors$1.primary10,
      color: colors$1.primaryColor,
      style: {
        marginTop: '10px'
      },
      children: dynamicPricingDetails.variationName
    }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("small", {
      children: dynamicPricingDescription
    })]
  });
};

const statusTextMap = {
  [transactionsStatus$1.CONFIRMED]: 'Confirmed',
  [transactionsStatus$1.REJECTED]: 'Rejected',
  [transactionsStatus$1.CANCELLED]: 'Cancelled'
};
const BookedExtrasTable = ({
  bookedExtras,
  bundleByBookedExtraId,
  allowAmendments,
  loadReservationProfile,
  onChangeBookedExtraStatus,
  program,
  readOnly = false,
  toast
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const {
    usersList
  } = useUsersList();
  const showBookedExtraAmendPricePrompt = async bookedExtra => {
    let newPrice;
    while (true) {
      newPrice = prompt(`Please indicate new extra price, per entire stay, 1 item (${bookedExtra.currency})`, bookedExtra.price);
      if (newPrice === null) {
        return false;
      }
      if (newPrice.trim() === '') {
        alert('Please indicate a price');
        continue;
      }
      newPrice = parseFloat(newPrice);
      if (isNaN(newPrice)) {
        alert('Invalid price');
        continue;
      }
      break;
    }
    let newQuantity;
    while (true) {
      newQuantity = prompt('Please indicate a quantity (0 = remove extra)', bookedExtra.quantity);
      if (newQuantity === null) {
        return false;
      }
      if (newQuantity.trim() === '') {
        alert('Please indicate a quantity');
        continue;
      }
      newQuantity = parseInt(newQuantity, 10);
      if (isNaN(newQuantity)) {
        alert('Invalid quantity');
        continue;
      }
      if (newQuantity === 0 && !window.confirm('Do you really want to remove this booked extra?')) {
        return false;
      }
      break;
    }
    let newTotalQuantity;
    while (true) {
      newTotalQuantity = prompt('Please indicate total quantity', bookedExtra.quantity);
      if (newTotalQuantity === null) {
        return false;
      }
      if (newTotalQuantity.trim() === '') {
        alert('Please indicate a quantity');
        continue;
      }
      newTotalQuantity = parseInt(newTotalQuantity, 10);
      if (isNaN(newTotalQuantity)) {
        alert('Invalid quantity');
        continue;
      }
      if (newTotalQuantity === 0 && !window.confirm('Do you really want to remove this booked extra?')) {
        return false;
      }
      break;
    }
    try {
      showLoading();
      const bookedExtraNewQtyAndPrice = new FormData();
      bookedExtraNewQtyAndPrice.append('newPrice', newPrice);
      bookedExtraNewQtyAndPrice.append('newQuantity', newQuantity);
      bookedExtraNewQtyAndPrice.append('newTotalQuantity', newTotalQuantity);
      await axios.post(`${apiEndpoints.bookedExtraAmend}/${bookedExtra.id}.json`, bookedExtraNewQtyAndPrice);
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to amend the booked extra price.');
    } finally {
      hideLoading();
    }
  };
  let titleBackgroundColor;
  switch (program) {
    case programs.A:
      titleBackgroundColor = colors$1.preArrival10;
      break;
    case programs.B:
      titleBackgroundColor = colors$1.onArrival10;
      break;
    case programs.C:
      titleBackgroundColor = colors$1.inStay10;
      break;
    default:
      titleBackgroundColor = colors$1.bgDark;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileTableTitle, {
      backgroundColor: titleBackgroundColor,
      children: "Extras"
    }), /*#__PURE__*/jsx("div", {
      className: css$G.tableWrapper,
      children: /*#__PURE__*/jsxs(Table, {
        cellAlign: "center",
        children: [/*#__PURE__*/jsx(TableHead, {
          children: /*#__PURE__*/jsxs(TableRow, {
            children: [/*#__PURE__*/jsx(TableHeader, {
              className: css$G.upsellCell,
              children: "Extra"
            }), /*#__PURE__*/jsx(TableHeader, {
              children: "Qty"
            }), /*#__PURE__*/jsx(TableHeader, {
              align: "right",
              children: "Price p/ Unit"
            }), /*#__PURE__*/jsx(TableHeader, {
              align: "right",
              children: "Total Price"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.statusCell,
              children: "Status"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.actionsCell,
              children: "Amendments"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.userCell
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: bookedExtras.map(bookedExtra => /*#__PURE__*/jsx(BookedExtraRow, {
            bookedExtra: bookedExtra,
            bundle: bundleByBookedExtraId?.[bookedExtra.id],
            usersList: usersList,
            allowAmendments: allowAmendments,
            onChangeBookedExtraStatus: onChangeBookedExtraStatus,
            showBookedExtraAmendPricePrompt: showBookedExtraAmendPricePrompt,
            readOnly: readOnly
          }, bookedExtra.id))
        })]
      })
    })]
  });
};
const BookedExtraRow = ({
  bookedExtra,
  bundle,
  usersList,
  allowAmendments,
  onChangeBookedExtraStatus,
  showBookedExtraAmendPricePrompt,
  readOnly = false
}) => {
  const isBundled = Boolean(bundle);
  const isCancelledOrRejected = bookedExtra.status === bookedExtraStatus.CANCELLED || bookedExtra.status === bookedExtraStatus.REJECTED;
  const canReinstate = !isBundled && isCancelledOrRejected && allowAmendments;
  const canEdit = !isBundled && allowAmendments && !isCancelledOrRejected && bookedExtra.status !== bookedExtraStatus.PENDING;
  const handleAccept = () => {
    onChangeBookedExtraStatus(bookedExtra, bookedExtraStatus.CONFIRMED, false);
  };
  const handleDeny = () => {
    onChangeBookedExtraStatus(bookedExtra, bookedExtraStatus.REJECTED, false);
  };
  const handleReinstate = () => {
    onChangeBookedExtraStatus(bookedExtra, bookedExtraStatus.ACCEPTED, true);
  };
  const handleEdit = () => {
    showBookedExtraAmendPricePrompt(bookedExtra);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(TableRow, {
      children: [/*#__PURE__*/jsxs(TableCell, {
        className: css$G.ellipsisOverflow,
        children: [isBundled ? /*#__PURE__*/jsx(BundleMarker, {
          roomTypeId: bundle.roomTypeId,
          children: /*#__PURE__*/jsx(ExtraTypeCode, {
            id: bookedExtra.extraTypeId
          })
        }) : /*#__PURE__*/jsx("span", {
          children: /*#__PURE__*/jsx(ExtraTypeCode, {
            id: bookedExtra.extraTypeId
          })
        }), bookedExtra.extraTypeVariationId && /*#__PURE__*/jsx("div", {
          children: /*#__PURE__*/jsx(Label, {
            backgroundColor: colors$1.primary10,
            color: colors$1.primaryColor,
            style: {
              marginTop: '10px'
            },
            children: /*#__PURE__*/jsx(ExtraTypeVariationCode, {
              id: bookedExtra.extraTypeId,
              variationId: bookedExtra.extraTypeVariationId
            })
          })
        }), bookedExtra?.dynamicPricingDetails && /*#__PURE__*/jsx(BookedExtraDynamicPricing, {
          dynamicPricingDetails: bookedExtra?.dynamicPricingDetails
        })]
      }), /*#__PURE__*/jsx(TableCell, {
        className: css$G.qtyColumn,
        children: bookedExtra.quantity
      }), /*#__PURE__*/jsx(BookedExtraPriceCell, {
        value: bookedExtra.price,
        bookedExtra: bookedExtra,
        currency: bookedExtra.currency
      }), /*#__PURE__*/jsx(BookedExtraPriceCell, {
        value: bookedExtra.totalPrice,
        bookedExtra: bookedExtra,
        currency: bookedExtra.currency
      }), /*#__PURE__*/jsx(TableCell, {
        className: css$G.statusCell,
        children: !readOnly && !isBundled && bookedExtra.status === bookedExtraStatus.PENDING ? /*#__PURE__*/jsxs(FlexContainer, {
          gap: 10,
          justifyContent: "center",
          children: [/*#__PURE__*/jsx(AcceptUpsellButton, {
            onClick: handleAccept
          }), /*#__PURE__*/jsx(DenyUpsellButton, {
            onClick: handleDeny
          })]
        }) : /*#__PURE__*/jsx(LabelTransactionStatus, {
          status: bookedExtra.status
        })
      }), /*#__PURE__*/jsx(TableCell, {
        className: css$G.actionsCell,
        children: isBundled && allowAmendments ? /*#__PURE__*/jsx(BundleManagedHint, {}) : /*#__PURE__*/jsxs(FlexContainer, {
          gap: 10,
          justifyContent: "center",
          children: [canReinstate && /*#__PURE__*/jsx(ReinstateUpsellButton, {
            onClick: handleReinstate
          }), canEdit && /*#__PURE__*/jsx(EditUpsellButton, {
            onClick: handleEdit
          })]
        })
      }), /*#__PURE__*/jsx(TableCell, {
        className: css$G.userCell,
        children: /*#__PURE__*/jsx(BookedExtraAdditionalInformationCell, {
          bookedExtra: bookedExtra,
          usersList: usersList
        })
      })]
    }), bookedExtra.dayTime && /*#__PURE__*/jsx(TableRow, {
      style: {
        background: colors$1.bgLight48
      },
      children: /*#__PURE__*/jsx(TableCell, {
        align: "left",
        colSpan: 7,
        style: {
          padding: '6px 12px'
        },
        children: /*#__PURE__*/jsxs("small", {
          children: [/*#__PURE__*/jsx("b", {
            children: "Date/Time:"
          }), " ", formatDateTimeNoConversion(bookedExtra.dayTime, 'dd MMM HH:mm')]
        })
      })
    }), bookedExtra.customQuestionAnswers?.length > 0 && /*#__PURE__*/jsx(TableRow, {
      style: {
        background: colors$1.bgLight48
      },
      children: /*#__PURE__*/jsx(TableCell, {
        align: "left",
        colSpan: 7,
        style: {
          padding: '6px 12px'
        },
        children: bookedExtra.customQuestionAnswers.map(question => /*#__PURE__*/jsxs("small", {
          style: {
            display: 'block'
          },
          children: [/*#__PURE__*/jsxs("b", {
            children: [question.question.textInEng, ":"]
          }), " ", question.answer]
        }, question.id))
      })
    })]
  });
};
const BookedExtraAdditionalInformationCell = ({
  bookedExtra,
  usersList
}) => {
  if (!bookedExtra.addedToReservationAt && !bookedExtra.userId) {
    return null;
  }
  return /*#__PURE__*/jsx(FlexContainer, {
    justifyContent: "center",
    children: /*#__PURE__*/jsx(Tooltip$1, {
      content: /*#__PURE__*/jsx(BookedExtraTransactionInfoTooltip, {
        bookedExtra: bookedExtra,
        usersList: usersList
      }),
      position: "left",
      children: usersList[bookedExtra.userId] ? /*#__PURE__*/jsx(Avatar, {
        name: usersList[bookedExtra.userId].fullName
      }) : /*#__PURE__*/jsx(InformationCircleContained, {})
    })
  });
};
const BookedExtraTransactionInfoTooltip = ({
  usersList,
  bookedExtra
}) => {
  const {
    formatTz
  } = useTimezone();
  if (!bookedExtra) {
    return null;
  }
  const user = usersList[bookedExtra.userId] ?? null;
  const prettyAddedToReservationAt = bookedExtra.addedToReservationAt ? formatTz(bookedExtra.addedToReservationAt) : null;
  const addedToReservationByUser = bookedExtra.addedToReservationByUserId ? usersList[bookedExtra.addedToReservationByUserId] : null;
  const addedToReservationByUserFullName = addedToReservationByUser ? addedToReservationByUser.fullName : null;
  return /*#__PURE__*/jsxs("div", {
    style: {
      textAlign: "left"
    },
    children: [user && statusTextMap[bookedExtra.status] && /*#__PURE__*/jsxs("div", {
      children: [statusTextMap[bookedExtra.status], " by ", user.fullName]
    }), bookedExtra.status === transactionsStatus$1.CONFIRMED && prettyAddedToReservationAt && /*#__PURE__*/jsxs("div", {
      children: ["Posted to PMS by ", addedToReservationByUserFullName ?? 'system', " on ", prettyAddedToReservationAt, "."]
    })]
  });
};
const BookedExtraPriceCell = ({
  value,
  currency
}) => /*#__PURE__*/jsx(TableCell, {
  align: "right",
  children: formatCurrency(value, currency)
});

const UpgradeBidActions = ({
  upgradeBid,
  isBundled = false,
  allowAmendments,
  onPendingAccept,
  onReject,
  onAmendReject,
  onEditPrice,
  onAmendAccept,
  onReinstate
}) => {
  if (upgradeBid.status === upgradeBidsStatus.PENDING) {
    return /*#__PURE__*/jsxs(FlexContainer, {
      gap: 10,
      justifyContent: "center",
      children: [/*#__PURE__*/jsx(AcceptUpsellButton, {
        onClick: () => onPendingAccept(upgradeBid)
      }), /*#__PURE__*/jsx(DenyUpsellButton, {
        onClick: () => onReject(upgradeBid)
      })]
    });
  }
  if (isBundled) {
    return allowAmendments ? /*#__PURE__*/jsx(BundleManagedHint, {}) : null;
  }
  if (allowAmendments) {
    switch (upgradeBid.status) {
      case upgradeBidsStatus.ACCEPTED:
        return /*#__PURE__*/jsxs(FlexContainer, {
          gap: 10,
          justifyContent: "center",
          children: [/*#__PURE__*/jsx(DenyUpsellButton, {
            onClick: () => onAmendReject(upgradeBid)
          }), /*#__PURE__*/jsx(EditUpsellButton, {
            onClick: () => onEditPrice(upgradeBid)
          })]
        });
      case upgradeBidsStatus.REJECTED:
        return /*#__PURE__*/jsx(AcceptUpsellButton, {
          onClick: () => onAmendAccept(upgradeBid)
        });
      case upgradeBidsStatus.CANCELLED:
        return /*#__PURE__*/jsx(ReinstateUpsellButton, {
          onClick: () => onReinstate(upgradeBid)
        });
      default:
        return null;
    }
  }
  return null;
};

const RoomUpgradeTransactionInfoTooltip = ({
  transaction
}) => {
  const {
    usersList
  } = useUsersList();
  if (!transaction || !transaction?.userId || !usersList[transaction?.userId]) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsxs("span", {
        style: {
          textTransform: 'capitalize'
        },
        children: [transaction.status, " "]
      }), "by ", usersList[transaction.userId]?.fullName, "."]
    }), transaction.denied_reason && /*#__PURE__*/jsxs(Fragment$1, {
      children: ["Rejection Reason: ", transaction.denied_reason, ". "]
    })]
  });
};

const DynamicPricingTable = ({
  reservation,
  upgradeBid
}) => {
  const dynamicPricingDetails = upgradeBid.dynamicPricingDetails;
  if (!dynamicPricingDetails || !dynamicPricingDetails.biddingRoomTypePrices || Object.keys(dynamicPricingDetails.biddingRoomTypePrices).length === 0) {
    return null;
  }
  const dates = Object.keys(dynamicPricingDetails.biddingRoomTypePrices);
  return /*#__PURE__*/jsx(TableRow, {
    children: /*#__PURE__*/jsxs(TableCell, {
      colSpan: 5,
      className: css$G.transactionRecordNotes,
      children: [/*#__PURE__*/jsx(CardTitle, {
        style: {
          marginBottom: '10px'
        },
        children: "Dynamic Pricing"
      }), /*#__PURE__*/jsx("div", {
        className: css$G.tableWrapper,
        children: /*#__PURE__*/jsxs(Table, {
          cellAlign: "center",
          className: css$G.dynamicPricingTable,
          mobileLayout: "scroll",
          children: [/*#__PURE__*/jsx(TableHead, {
            children: /*#__PURE__*/jsxs(TableRow, {
              children: [/*#__PURE__*/jsx(TableHeader, {
                className: css$G.noWrapCell,
                children: "Room Type"
              }), dates.map(date => /*#__PURE__*/jsx(TableHeader, {
                align: "right",
                className: css$G.noWrapCell,
                children: formatDate$1(date, 'dd MMM')
              }, date))]
            })
          }), /*#__PURE__*/jsxs("tbody", {
            children: [/*#__PURE__*/jsxs(TableRow, {
              children: [/*#__PURE__*/jsx(TableCell, {
                className: css$G.noWrapCell,
                children: /*#__PURE__*/jsx(RoomTypeCode, {
                  id: reservation.bookedRoomTypeId
                })
              }), dates.map(date => /*#__PURE__*/jsx(TableCell, {
                align: "right",
                className: css$G.noWrapCell,
                children: formatCurrency(dynamicPricingDetails.bookedRoomTypePrices[date], upgradeBid.currency)
              }, date))]
            }), /*#__PURE__*/jsxs(TableRow, {
              children: [/*#__PURE__*/jsxs(TableCell, {
                className: css$G.noWrapCell,
                children: [/*#__PURE__*/jsx(RoomTypeCode, {
                  id: upgradeBid.toRoomTypeId
                }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("small", {
                  children: "Availability"
                })]
              }), dates.map(date => /*#__PURE__*/jsxs(TableCell, {
                align: "right",
                className: css$G.noWrapCell,
                children: [formatCurrency(dynamicPricingDetails.biddingRoomTypePrices[date], upgradeBid.currency), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("small", {
                  children: dynamicPricingDetails.biddingRoomTypeAvailability[date]
                })]
              }, date))]
            })]
          })]
        })
      })]
    })
  });
};

const RoomAvailabilityTable = ({
  upgradeBid,
  rawUpsellStatus,
  posthog
}) => {
  const {
    formatTz
  } = useTimezone();
  const [selectedAvailabilityIndex, setSelectedAvailabilityIndex] = useState(null);
  const hasAvailabilityData = upgradeBid.currentAvailability !== null || upgradeBid.availableRoomsAtCreation !== null || upgradeBid.availableRoomsAtDecision !== null || upgradeBid.availableRoomsAtCheckin !== null || upgradeBid.availableRoomsAtCheckout !== null;
  const shouldShowAvailability = upgradeBid.status === upgradeBidsStatus.PENDING || upgradeBid.status === upgradeBidsStatus.BYPASSED || rawUpsellStatus === 'REJECTED' && upgradeBid.status === upgradeBidsStatus.EXPIRED || rawUpsellStatus === 'REJECTED' && upgradeBid.status === upgradeBidsStatus.REJECTED || rawUpsellStatus === 'ACCEPTED' && upgradeBid.status === upgradeBidsStatus.ACCEPTED;
  if (!hasAvailabilityData || !shouldShowAvailability) {
    return null;
  }
  const isPending = upgradeBid.status === upgradeBidsStatus.PENDING;
  const headers = [];
  const data = [];
  const availabilityDetails = [];
  if (upgradeBid.availableRoomsAtCreation !== null) {
    headers.push('At Bid Creation');
    data.push(upgradeBid.availableRoomsAtCreation);
    availabilityDetails.push(upgradeBid.roomTypeAvailabilityDetails[roomAvailabilityCapturePoint.AT_CREATION]);
  }
  if (isPending && upgradeBid.currentAvailability !== null) {
    headers.push('Current');
    data.push(upgradeBid.currentAvailability);
    availabilityDetails.push(upgradeBid.roomTypeAvailabilityDetails[roomAvailabilityCapturePoint.CURRENT]);
  }
  if (upgradeBid.availableRoomsAtDecision !== null) {
    headers.push('At Bid Decision');
    data.push(upgradeBid.availableRoomsAtDecision);
    availabilityDetails.push(upgradeBid.roomTypeAvailabilityDetails[roomAvailabilityCapturePoint.AT_DECISION]);
  }
  if (upgradeBid.availableRoomsAtCheckin !== null) {
    headers.push('At Checkin');
    data.push(upgradeBid.availableRoomsAtCheckin);
    availabilityDetails.push(upgradeBid.roomTypeAvailabilityDetails[roomAvailabilityCapturePoint.AT_CHECKIN]);
  }
  if (upgradeBid.availableRoomsAtCheckout !== null) {
    headers.push('At Checkout');
    data.push(upgradeBid.availableRoomsAtCheckout);
    availabilityDetails.push(upgradeBid.roomTypeAvailabilityDetails[roomAvailabilityCapturePoint.AT_CHECKOUT]);
  }
  const handleShowAvailabilityDetails = index => {
    posthog?.capture('reservation_profile:room_availability_details_toggle');
    setSelectedAvailabilityIndex(index === selectedAvailabilityIndex ? null : index);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(TableRow, {
      children: /*#__PURE__*/jsxs(TableCell, {
        colSpan: 5,
        className: css$G.transactionRecordNotes,
        children: [/*#__PURE__*/jsxs(CardTitle, {
          children: [/*#__PURE__*/jsx(RoomTypeCode, {
            id: upgradeBid.toRoomTypeId
          }), " Room Availability"]
        }), upgradeBid.currentAvailabilityLastUpdated !== null && /*#__PURE__*/jsxs("p", {
          style: {
            marginBottom: '10px'
          },
          children: ["Last availability update at:", /*#__PURE__*/jsxs("b", {
            children: [" ", formatTz(upgradeBid.currentAvailabilityLastUpdated, 'dd MMM HH:mm')]
          })]
        }), /*#__PURE__*/jsx("div", {
          className: css$G.tableWrapper,
          children: /*#__PURE__*/jsxs(Table, {
            cellAlign: "right",
            children: [/*#__PURE__*/jsx(TableHead, {
              children: /*#__PURE__*/jsx(TableRow, {
                children: headers.map((header, index) => /*#__PURE__*/jsx(TableHeader, {
                  children: header
                }, index))
              })
            }), /*#__PURE__*/jsx("tbody", {
              children: /*#__PURE__*/jsx(TableRow, {
                children: data.map((value, index) => /*#__PURE__*/jsx(TableCell, {
                  children: /*#__PURE__*/jsx(Button$1, {
                    variant: "ghost",
                    onClick: () => handleShowAvailabilityDetails(index),
                    children: value
                  })
                }, index))
              })
            })]
          })
        })]
      })
    }), selectedAvailabilityIndex !== null && availabilityDetails[selectedAvailabilityIndex] && /*#__PURE__*/jsx(TableRow, {
      children: /*#__PURE__*/jsx(TableCell, {
        colSpan: 5,
        children: /*#__PURE__*/jsx(RoomAvailabilityDetails, {
          title: headers[selectedAvailabilityIndex],
          availabilityDetails: availabilityDetails[selectedAvailabilityIndex]
        })
      })
    })]
  });
};
const RoomAvailabilityDetails = ({
  title,
  availabilityDetails
}) => {
  const entries = Object.entries(availabilityDetails);
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(CardTitle, {
      children: title
    }), /*#__PURE__*/jsxs(Table, {
      children: [/*#__PURE__*/jsx(TableHead, {
        children: /*#__PURE__*/jsx(TableRow, {
          children: entries.map(([date]) => /*#__PURE__*/jsx(TableHeader, {
            children: formatDateTime(date, 'dd MMM')
          }, date))
        })
      }), /*#__PURE__*/jsx("tbody", {
        children: /*#__PURE__*/jsx(TableRow, {
          children: entries.map(([date, availability]) => /*#__PURE__*/jsx(TableCell, {
            children: availability
          }, date))
        })
      })]
    })]
  });
};

var css_248z$x = ".InputNumber-module__inputContainer___ECrz3{display:flex;flex-direction:column;width:100%}.InputNumber-module__inputContainer___ECrz3.InputNumber-module__label-left___agscv{align-items:center;flex-direction:row;flex-wrap:wrap;gap:.3rem 1rem}.InputNumber-module__inputContainer___ECrz3.InputNumber-module__label-left___agscv .InputNumber-module__label___-xT76{flex-shrink:0;margin-bottom:0}.InputNumber-module__inputContainer___ECrz3.InputNumber-module__label-left___agscv .InputNumber-module__inputWrapper___qJzQW{flex:1}.InputNumber-module__inputContainer___ECrz3.InputNumber-module__label-left___agscv .InputNumber-module__errorMessage___LeuxG{flex-basis:100%}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__label___-xT76{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__label___-xT76 .InputNumber-module__required___PxQRF{color:var(--danger);margin-left:.15rem}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW{align-items:center;display:flex;position:relative;width:100%}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__affix___z6eQp{color:var(--darkGray);font-size:var(--body-regular-size);pointer-events:none;position:absolute;user-select:none;z-index:1}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__affix___z6eQp:first-child{align-items:center;color:var(--grey-64);display:flex;justify-content:center;left:1rem;pointer-events:none;position:absolute;top:50%;transform:translateY(-50%)}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__suffix___dZq2t{align-items:center;color:var(--grey-64);display:flex;justify-content:center;pointer-events:none;position:absolute;right:5px;top:50%;transform:translateY(-50%);z-index:1}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;text-align:right;transition:all .2s ease;width:100%!important}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z::-webkit-inner-spin-button,.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z::placeholder{color:var(--grey-20)}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z:focus{background-color:var(--bg-light-48);outline:none}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z:disabled{background-color:var(--disabled);cursor:not-allowed}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z.InputNumber-module__error___GyuC-{border-color:var(--danger)}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z.InputNumber-module__hasPrefix___m7T4Z{padding-left:25px!important}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__inputWrapper___qJzQW .InputNumber-module__input___D600z.InputNumber-module__hasSuffix___DtF5T{padding-right:25px!important}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__errorMessage___LeuxG{color:var(--danger);font-size:.75rem;margin-top:.2rem}.InputNumber-module__inputContainer___ECrz3 .InputNumber-module__constraints___OaXRB{color:var(--darkGray);font-size:.75rem;margin-top:.5rem;text-align:left}";
var css$w = {"inputContainer":"InputNumber-module__inputContainer___ECrz3","label-left":"InputNumber-module__label-left___agscv","label":"InputNumber-module__label___-xT76","inputWrapper":"InputNumber-module__inputWrapper___qJzQW","errorMessage":"InputNumber-module__errorMessage___LeuxG","required":"InputNumber-module__required___PxQRF","affix":"InputNumber-module__affix___z6eQp","suffix":"InputNumber-module__suffix___dZq2t","input":"InputNumber-module__input___D600z","error":"InputNumber-module__error___GyuC-","hasPrefix":"InputNumber-module__hasPrefix___m7T4Z","hasSuffix":"InputNumber-module__hasSuffix___DtF5T","constraints":"InputNumber-module__constraints___OaXRB"};
styleInject(css_248z$x);

const InputNumber = ({
  label,
  inputMode = 'decimal',
  name,
  placeholder,
  value,
  onChange,
  error,
  invalid = false,
  min,
  max,
  step = 1,
  required = false,
  disabled = false,
  className = '',
  prefix,
  suffix,
  allowDecimals = true,
  labelPosition = 'top'
}) => {
  const handleChange = e => {
    const newValue = e.target.value;
    if (newValue === '') {
      onChange(e);
      return;
    }
    const isValidNumber = allowDecimals ? /^-?\d*\.?\d*$/.test(newValue) : /^-?\d*$/.test(newValue);
    if (!isValidNumber) return;
    const numValue = parseFloat(newValue);
    if (min !== undefined && numValue < min || max !== undefined && numValue > max) {
      return;
    }
    onChange(e);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$w.inputContainer} ${className} ${css$w[`label-${labelPosition}`]}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$w.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$w.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$w.inputWrapper,
      children: [prefix && /*#__PURE__*/jsx("span", {
        className: css$w.affix,
        children: prefix
      }), /*#__PURE__*/jsx("input", {
        type: "number",
        inputMode: inputMode,
        value: value,
        onChange: handleChange,
        placeholder: placeholder,
        disabled: disabled,
        required: required,
        min: min,
        max: max,
        name: name,
        step: step,
        className: `${css$w.input} ${error || invalid ? css$w.error : ''} ${prefix ? css$w.hasPrefix : ''} ${suffix ? css$w.hasSuffix : ''}`,
        "data-error": !!(error || invalid)
      }), suffix && /*#__PURE__*/jsx("span", {
        className: `${css$w.affix} ${css$w.suffix}`,
        children: suffix
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$w.errorMessage,
      children: error
    })]
  });
};
InputNumber.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  invalid: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  allowDecimals: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['top', 'left'])
};

const alternativeUpgradeOfferConditionOptions = [{
  label: 'Entire Stay',
  value: 'ENTIRE_STAY'
}, {
  label: 'First # Nights',
  value: 'FIRST'
}, {
  label: 'Last # Nights',
  value: 'LAST'
}, {
  label: 'Custom',
  value: 'CUSTOM'
}];
const AlternativeUpgradeOfferModal = ({
  reservationProfile,
  roomTypesList,
  upgradeBid,
  onModalClose,
  loadReservationProfile,
  posthog
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [roomTypeToUpgradeId, setRoomTypeToUpgradeId] = useState('');
  const [alternativeUpgradeOfferPrice, setAlternativeUpgradeOfferPrice] = useState(0);
  const [alternativeUpgradeOfferCondition, setAlternativeUpgradeOfferCondition] = useState('ENTIRE_STAY');
  const [alternativeUpgradeOfferNights, setAlternativeUpgradeOfferNights] = useState(0);
  const [alternativeUpgradeOfferCustomCondition, setAlternativeUpgradeOfferCustomCondition] = useState('');
  const bookedRoomType = roomTypesList?.[reservationProfile?.bookedRoomTypeId];
  let roomsToUpgrade = useMemo(() => Object.values(roomTypesList).filter(upgrade => upgrade.position > bookedRoomType?.position), [roomTypesList, bookedRoomType]);
  const roomsToUpgradeOptions = roomsToUpgrade.map(upgrade => {
    return {
      label: upgrade.code,
      value: upgrade.id
    };
  });
  useEffect(() => {
    setRoomTypeToUpgradeId(roomsToUpgrade[0]?.id);
  }, [roomsToUpgrade]);
  const submitAlternativeUpgradeForm = async () => {
    try {
      posthog?.capture('reservation_profile:upsells:alternative_upgrade_save');
      showLoading();
      let standardConditions;
      if (alternativeUpgradeOfferCondition === 'CUSTOM') {
        standardConditions = 0;
      } else if (alternativeUpgradeOfferCondition === 'ENTIRE_STAY') {
        standardConditions = reservationProfile.nights;
      } else {
        standardConditions = alternativeUpgradeOfferNights;
      }
      const alternativeUpgradeFormData = new FormData();
      alternativeUpgradeFormData.append('fromUpgradeId', upgradeBid.id);
      alternativeUpgradeFormData.append('roomTypeId', roomTypeToUpgradeId);
      alternativeUpgradeFormData.append('price', alternativeUpgradeOfferPrice);
      alternativeUpgradeFormData.append('conditions', alternativeUpgradeOfferCondition);
      alternativeUpgradeFormData.append('standardConditions', standardConditions);
      alternativeUpgradeFormData.append('customConditions', alternativeUpgradeOfferCustomCondition);
      await axios.post(apiEndpoints.alternativeUpgrades, alternativeUpgradeFormData);
      onModalClose();
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      alert('There was an error while trying to save the alternative upgrade offer');
    } finally {
      hideLoading();
    }
  };
  const onCancelClick = () => {
    posthog?.capture('reservation_profile:upsells:alternative_upgrade_cancel');
    onModalClose();
  };
  return /*#__PURE__*/jsxs(Modal, {
    title: "Alternative Upgrade",
    onClose: onModalClose,
    isOpen: true,
    style: {
      minWidth: '350px'
    },
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      gap: 20,
      style: {
        marginBottom: '20px'
      },
      flexFlow: "column",
      children: [/*#__PURE__*/jsx(Dropdown, {
        label: "Upgrade To",
        value: roomTypeToUpgradeId,
        options: roomsToUpgradeOptions,
        onChange: e => setRoomTypeToUpgradeId(e.target.value)
      }), /*#__PURE__*/jsx(InputNumber, {
        placeholder: "0",
        label: `Price (${upgradeBid.currency})`,
        name: "alternativeUpgradeOfferPrice",
        min: 0,
        step: 1,
        value: alternativeUpgradeOfferPrice,
        onChange: e => setAlternativeUpgradeOfferPrice(e.target.value)
      }), reservationProfile.nights > 1 && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx(Dropdown, {
          label: "Conditions",
          value: alternativeUpgradeOfferCondition,
          options: alternativeUpgradeOfferConditionOptions,
          onChange: e => setAlternativeUpgradeOfferCondition(e.target.value)
        }), (alternativeUpgradeOfferCondition === 'LAST' || alternativeUpgradeOfferCondition === 'FIRST') && /*#__PURE__*/jsx(InputNumber, {
          placeholder: "0",
          label: "Nights",
          name: "alternativeUpgradeOfferNights",
          min: 0,
          max: reservationProfile.nights - 1,
          step: 1,
          value: alternativeUpgradeOfferNights,
          onChange: e => setAlternativeUpgradeOfferNights(e.target.value)
        })]
      }), alternativeUpgradeOfferCondition === 'CUSTOM' && /*#__PURE__*/jsx(TextArea, {
        id: "customCondition",
        label: "Conditions",
        resize: "vertical",
        value: alternativeUpgradeOfferCustomCondition,
        onChange: e => setAlternativeUpgradeOfferCustomCondition(e.target.value)
      })]
    }), /*#__PURE__*/jsxs(FlexContainer, {
      justifyContent: "flex-end",
      gap: 10,
      style: {
        marginTop: '1.5rem'
      },
      children: [/*#__PURE__*/jsx(Button$1, {
        variant: "tertiary",
        onClick: onCancelClick,
        children: "Cancel"
      }), /*#__PURE__*/jsx(Button$1, {
        onClick: submitAlternativeUpgradeForm,
        children: "Save"
      })]
    })]
  });
};

const RejectBidModal = ({
  reservationProfile,
  roomTypesList,
  upgradeBid,
  bundleId = null,
  onModalClose,
  loadReservationProfile,
  toast,
  posthog
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [optionSelected, setOptionSelected] = useState('');
  const [showAlternativeUpgradeOfferModal, setShowAlternativeUpgradeOfferModal] = useState(false);
  const [errors, setErrors] = useState({});
  const {
    isEnabled
  } = useFeatureFlags();
  const isMandatory = isEnabled(featureFlagsCodes.REQUIRE_UPGRADE_BID_REJECTION_REASON);
  const rejectQuestion = bundleId ? 'Do you really want to REJECT this bid and its bundled extra(s)?' : 'Do you really want to REJECT this bid?';
  const bidCancellationOptions = [{
    label: isMandatory ? 'Select Rejection Reason (Mandatory)' : 'Rejection Reason',
    value: ''
  }, ...upgradeBidRejectionReasons];
  const handleShowModals = () => {
    posthog?.capture('reservation_profile:upsells:cancel_bid_modal_close');
    onModalClose();
    setShowAlternativeUpgradeOfferModal(false);
  };
  const validateForm = () => {
    const errors = {};
    if (isEnabled(featureFlagsCodes.REQUIRE_UPGRADE_BID_REJECTION_REASON) && !optionSelected) {
      errors.denied_reason = 'Please select a reason';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleRejectWithAvailabilityCheck = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const roomTypeId = upgradeBid?.roomTypeId || upgradeBid?.room_type?.id;
      if (!roomTypeId) {
        return submitRejectUpgradeBid();
      }
      showLoading();
      const from = formatDate$1(reservationProfile.checkin, 'yyyy-MM-dd');
      const to = formatDate$1(reservationProfile.checkout, 'yyyy-MM-dd');
      const availabilityResponse = await axios.get(apiEndpoints.roomTypeAvailabilityHasAvailability(roomTypeId), {
        params: {
          fromDate: from,
          toDate: to
        }
      });
      const hasAvailability = availabilityResponse?.data?.hasAvailability;
      if (hasAvailability) {
        let confirmationText = 'Are you sure that you want to reject this offer although there is still availability for the requested room type?';
        if (differenceInDays(new Date(reservationProfile.checkin), new Date()) > 2) {
          const bestPractice = 'Best Practice: Wait until closer to arrival date before rejecting an offer. ';
          confirmationText = bestPractice + confirmationText;
        }
        const proceed = window.confirm(confirmationText);
        if (!proceed) {
          return;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      hideLoading();
    }
    return submitRejectUpgradeBid();
  };
  const handleDismiss = () => {
    posthog?.capture('reservation_profile:upsells:reject_modal_close', {
      isBundled: Boolean(bundleId)
    });
    onModalClose();
  };
  const submitRejectBundle = async () => {
    posthog?.capture('reservation_profile:bundles:change_status', {
      decision: reservationBundleDecision.DECLINE,
      source: 'reject_bid_modal'
    });
    const rejectBundleFormData = new FormData();
    rejectBundleFormData.append('reservation_id', reservationProfile.id);
    rejectBundleFormData.append('decision', reservationBundleDecision.DECLINE);
    rejectBundleFormData.append('denied_reason', optionSelected);
    await axios.post(`${restUrls.reservationBundleChangeStatus}/${bundleId}.json`, rejectBundleFormData);
  };
  const submitRejectBid = async () => {
    posthog?.capture('reservation_profile:upsells:reject_bid_submit');
    const rejectUpgradeBidFormData = new FormData();
    rejectUpgradeBidFormData.append('to_status', upgradeBidsStatus.REJECTED);
    rejectUpgradeBidFormData.append('denied_reason', optionSelected);
    await axios.post(`${apiEndpoints.upgradeBidChangeStatus}/${upgradeBid.id}.json`, rejectUpgradeBidFormData);
  };
  const submitRejectUpgradeBid = async () => {
    try {
      showLoading();
      if (bundleId) {
        await submitRejectBundle();
      } else {
        await submitRejectBid();
      }
      onModalClose();
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to reject this bid.');
    } finally {
      hideLoading();
    }
  };
  return /*#__PURE__*/jsx(Fragment$1, {
    children: !showAlternativeUpgradeOfferModal ? /*#__PURE__*/jsxs(Modal, {
      title: "Rejecting a Bid",
      onClose: handleDismiss,
      isOpen: true,
      children: [/*#__PURE__*/jsx("p", {
        children: differenceInDays(new Date(reservationProfile.checkin), new Date()) >= 3 ? /*#__PURE__*/jsxs(Fragment$1, {
          children: [/*#__PURE__*/jsx("b", {
            children: "Best Practice:"
          }), " Wait until closer to arrival date before rejecting an offer.", /*#__PURE__*/jsx("b", {
            children: rejectQuestion
          })]
        }) : /*#__PURE__*/jsx("b", {
          children: rejectQuestion
        })
      }), /*#__PURE__*/jsx(Dropdown, {
        label: "Reject Reason",
        value: optionSelected,
        options: bidCancellationOptions,
        onChange: e => setOptionSelected(e.target.value),
        style: {
          marginBottom: '20px'
        },
        error: errors?.denied_reason
      }), /*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        children: [/*#__PURE__*/jsx(Button$1, {
          variant: "tertiary",
          onClick: handleDismiss,
          children: "Cancel"
        }), /*#__PURE__*/jsx(Button$1, {
          variant: "danger",
          onClick: handleRejectWithAvailabilityCheck,
          children: "Reject"
        }), !bundleId && isEnabled(featureFlagsCodes.ALTERNATIVE_UPGRADES) && /*#__PURE__*/jsx(Button$1, {
          onClick: () => setShowAlternativeUpgradeOfferModal(true),
          children: "Offer Alternative Upgrade"
        })]
      })]
    }) : /*#__PURE__*/jsx(AlternativeUpgradeOfferModal, {
      reservationProfile: reservationProfile,
      roomTypesList: roomTypesList,
      upgradeBid: upgradeBid,
      loadReservationProfile: loadReservationProfile,
      onModalClose: handleShowModals,
      posthog: posthog
    })
  });
};

const PreArrivalUpsells = ({
  reservationProfile,
  bookedExtras,
  upgradeBids,
  bundleByUpgradeBidId,
  bundleByBookedExtraId,
  roomTypesList,
  currentUser,
  onChangeUpgradeBidStatus,
  onChangeBookedExtraStatus,
  onChangeBundleStatus,
  loadReservationProfile,
  readOnly = false,
  toast,
  posthog
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const preArrivalExtras = useMemo(() => Object.values(bookedExtras || {}).filter(extra => extra.touchpoint && (extra.touchpoint.includes('PRE_ARRIVAL') || extra.touchpoint.includes('GUEST_RETARGETING'))), [bookedExtras]);
  if (preArrivalExtras.length === 0 && Object.values(upgradeBids || {}).length === 0) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      bgColor: colors$1.preArrival,
      color: colors$1.white,
      children: "Pre-Arrival"
    }), reservationProfile && reservationProfile.alternativeUpgrade && /*#__PURE__*/jsx(AlternativeUpgradeTable, {
      alternativeUpgrade: reservationProfile.alternativeUpgrade
    }), reservationProfile && Object.values(upgradeBids).length !== 0 && /*#__PURE__*/jsx(UpgradeBidsTable, {
      reservation: reservationProfile,
      roomTypesList: roomTypesList,
      upgradeBids: upgradeBids,
      bundleByUpgradeBidId: bundleByUpgradeBidId,
      allowAmendments: !readOnly && currentUser?.role === 'ADMIN',
      onChangeUpgradeBidStatus: onChangeUpgradeBidStatus,
      onChangeBundleStatus: onChangeBundleStatus,
      loadReservationProfile: loadReservationProfile,
      showLoading: showLoading,
      hideLoading: hideLoading,
      readOnly: readOnly,
      toast: toast,
      posthog: posthog
    }), preArrivalExtras.length !== 0 && /*#__PURE__*/jsx(BookedExtrasTable, {
      bookedExtras: preArrivalExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      allowAmendments: !readOnly && currentUser?.role === 'ADMIN',
      onChangeBookedExtraStatus: onChangeBookedExtraStatus,
      readOnly: readOnly,
      loadReservationProfile: loadReservationProfile,
      program: programs.A,
      toast: toast
    })]
  });
};
const AlternativeUpgradeTable = ({
  alternativeUpgrade
}) => {
  const alternativeUpgradeTableCols = ['Room Offered', 'Conditions', 'Amount', 'Status'];
  const showConditionType = conditionType => {
    switch (conditionType) {
      case 'ENTIRE_STAY':
        return 'Entire Stay';
      case 'FIRST':
        return `First ${alternativeUpgrade.conditionsNights ?? '-'} night(s)`;
      case 'LAST':
        return `Last ${alternativeUpgrade.conditionsNights ?? '-'} night(s)`;
      case 'CUSTOM':
        return alternativeUpgrade.customConditions;
      default:
        return '-';
    }
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx("div", {
      children: "Alternative Upgrade Offered"
    }), /*#__PURE__*/jsx("div", {
      className: css$G.tableWrapper,
      children: /*#__PURE__*/jsxs(Table, {
        children: [/*#__PURE__*/jsx(TableHead, {
          children: /*#__PURE__*/jsx(TableRow, {
            children: alternativeUpgradeTableCols.map(col => /*#__PURE__*/jsx(TableHeader, {
              children: col
            }, col))
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: /*#__PURE__*/jsxs(TableRow, {
            children: [/*#__PURE__*/jsx(TableCell, {
              children: /*#__PURE__*/jsx(RoomTypeCode, {
                id: alternativeUpgrade.roomTypeId
              })
            }), /*#__PURE__*/jsx(TableCell, {
              children: showConditionType(alternativeUpgrade.conditionsType)
            }), /*#__PURE__*/jsxs(TableCell, {
              children: [/*#__PURE__*/jsx("b", {
                children: formatCurrency(alternativeUpgrade.amount, alternativeUpgrade.currency)
              }), /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsxs("small", {
                children: ["(", formatCurrency(alternativeUpgrade.amountPerNight, alternativeUpgrade.currency), "/night)"]
              })]
            }), /*#__PURE__*/jsx(TableCell, {
              children: /*#__PURE__*/jsx(LabelTransactionStatus, {
                status: alternativeUpgrade.status
              })
            })]
          })
        })]
      })
    })]
  });
};
const UpgradeBidsTable = ({
  reservation,
  roomTypesList,
  upgradeBids,
  bundleByUpgradeBidId,
  allowAmendments,
  onChangeUpgradeBidStatus,
  onChangeBundleStatus,
  loadReservationProfile,
  readOnly = false,
  toast,
  posthog
}) => {
  const {
    usersList
  } = useUsersList();
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [selectedUpgradeBid, setSelectedUpgradeBid] = useState(null);
  let actionCol = '';
  if (!readOnly) {
    if (reservation.status === 'PENDING') {
      actionCol = 'Actions';
    } else if (allowAmendments) {
      actionCol = 'Amendments';
    }
  }
  const showUpgradeBidAmendPricePrompt = async (upgradeBidId, currentPrice) => {
    posthog?.capture('reservation_profile:upsells:amend_price_click');
    let newUpgradeBidPrice = prompt('Please indicate new upgrade price', currentPrice);
    if (newUpgradeBidPrice === null) {
      return false;
    }
    if (newUpgradeBidPrice.trim() === '') {
      alert('Please indicate a price');
      return false;
    }
    newUpgradeBidPrice = parseFloat(newUpgradeBidPrice);
    if (isNaN(newUpgradeBidPrice)) {
      alert('Invalid price');
      return false;
    }
    try {
      showLoading();
      const upgradeBidsNewPriceForm = new FormData();
      upgradeBidsNewPriceForm.append('new_price', newUpgradeBidPrice);
      await axios.post(`${apiEndpoints.upgradeBidAmendPrice}/${upgradeBidId}.json`, upgradeBidsNewPriceForm);
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to amend the booked extra price.');
    } finally {
      hideLoading();
    }
    return false;
  };
  const handleRejectBidAction = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:reject_click');
    setSelectedUpgradeBid(upgradeBid);
  };
  const handlePendingAcceptClick = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:accept_click');
    const bundle = bundleByUpgradeBidId?.[upgradeBid.id];
    if (bundle) {
      onChangeBundleStatus(bundle.bundleId, reservationBundleDecision.ACCEPT);
      return;
    }
    onChangeUpgradeBidStatus(upgradeBid.id, upgradeBidsStatus.ACCEPTED, false);
  };
  const handleAmendRejectClick = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:reject_click');
    onChangeUpgradeBidStatus(upgradeBid.id, upgradeBidsStatus.REJECTED, true);
  };
  const handleEditPriceClick = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:amend_price_click');
    showUpgradeBidAmendPricePrompt(upgradeBid.id, upgradeBid.amount);
  };
  const handleAmendAcceptClick = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:accept_click');
    onChangeUpgradeBidStatus(upgradeBid.id, upgradeBidsStatus.ACCEPTED, true);
  };
  const handleReinstateClick = upgradeBid => {
    posthog?.capture('reservation_profile:upsells:reinstate_click');
    onChangeUpgradeBidStatus(upgradeBid.id, upgradeBidsStatus.ACCEPTED, true);
  };
  const handleRejectModalClose = () => {
    setSelectedUpgradeBid(null);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileTableTitle, {
      backgroundColor: colors$1.preArrival10,
      children: "Room Upgrades"
    }), /*#__PURE__*/jsx("div", {
      className: css$G.tableWrapper,
      children: /*#__PURE__*/jsxs(Table, {
        cellAlign: "center",
        children: [/*#__PURE__*/jsx(TableHead, {
          children: /*#__PURE__*/jsxs(TableRow, {
            children: [/*#__PURE__*/jsx(TableHeader, {
              className: css$G.upsellCell,
              children: "Room"
            }), /*#__PURE__*/jsx(TableHeader, {
              align: "right",
              children: "Upsell Amount"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.statusCell,
              children: "Status"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.actionsCell,
              children: actionCol
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.userCell
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: Object.values(upgradeBids).map(upgradeBid => {
            const bundle = bundleByUpgradeBidId?.[upgradeBid.id];
            return /*#__PURE__*/jsxs(React.Fragment, {
              children: [/*#__PURE__*/jsxs(TableRow, {
                children: [/*#__PURE__*/jsx(TableCell, {
                  className: css$G.ellipsisOverflow,
                  children: bundle && bundle.extras.length > 0 ? /*#__PURE__*/jsx(BundleMarker, {
                    bookedExtras: bundle.extras,
                    children: /*#__PURE__*/jsx(RoomTypeCode, {
                      id: upgradeBid.toRoomTypeId
                    })
                  }) : /*#__PURE__*/jsx(RoomTypeCode, {
                    id: upgradeBid.toRoomTypeId
                  })
                }), /*#__PURE__*/jsxs(TableCell, {
                  align: "right",
                  style: {
                    backgroundColor: `var(--bid-strength-${upgradeBid.strength}-bg)`,
                    color: `var(--bid-strength-${upgradeBid.strength})`
                  },
                  children: [formatCurrency(upgradeBid.amount, upgradeBid.currency), /*#__PURE__*/jsx("br", {}), reservation.nights > 1 && upgradeBid.amountPerNight && /*#__PURE__*/jsxs("small", {
                    children: ["(", formatCurrency(upgradeBid.amountPerNight, upgradeBid.currency), "/night)"]
                  })]
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.statusCell,
                  children: upgradeBid.status && /*#__PURE__*/jsx(LabelTransactionStatus, {
                    status: upgradeBid.status
                  })
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.actionsCell,
                  children: !readOnly && /*#__PURE__*/jsx(UpgradeBidActions, {
                    upgradeBid: upgradeBid,
                    isBundled: Boolean(bundle),
                    allowAmendments: allowAmendments,
                    onPendingAccept: handlePendingAcceptClick,
                    onReject: handleRejectBidAction,
                    onAmendReject: handleAmendRejectClick,
                    onEditPrice: handleEditPriceClick,
                    onAmendAccept: handleAmendAcceptClick,
                    onReinstate: handleReinstateClick
                  })
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.userCell,
                  children: upgradeBid.userId && /*#__PURE__*/jsx(Tooltip$1, {
                    content: /*#__PURE__*/jsx(RoomUpgradeTransactionInfoTooltip, {
                      transaction: upgradeBid
                    }),
                    position: "left",
                    children: /*#__PURE__*/jsx(Avatar, {
                      name: usersList[upgradeBid.userId]?.fullName
                    })
                  })
                })]
              }), upgradeBid.dynamicPricingDetails && /*#__PURE__*/jsx(DynamicPricingTable, {
                upgradeBid: upgradeBid,
                reservation: reservation
              }), /*#__PURE__*/jsx(RoomAvailabilityTable, {
                upgradeBid: upgradeBid,
                rawUpsellStatus: reservation.rawUpsellStatus,
                posthog: posthog
              })]
            }, upgradeBid.id);
          })
        })]
      })
    }), selectedUpgradeBid && /*#__PURE__*/jsx(RejectBidModal, {
      reservationProfile: reservation,
      roomTypesList: roomTypesList,
      upgradeBid: selectedUpgradeBid,
      bundleId: bundleByUpgradeBidId?.[selectedUpgradeBid.id]?.bundleId ?? null,
      onModalClose: handleRejectModalClose,
      loadReservationProfile: loadReservationProfile,
      toast: toast,
      posthog: posthog
    })]
  });
};

const RegCardUpsells = ({
  bookedExtras,
  bundleByBookedExtraId,
  reservationEvents,
  currentUser,
  onChangeBookedExtraStatus,
  loadReservationProfile
}) => {
  if (!bookedExtras || !Object.values(bookedExtras).find(extra => extra.touchpoint === touchpoints.REGISTRATION_CARD)) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      bgColor: colors$1.preArrival,
      color: colors$1.white,
      children: "Registration Card"
    }), /*#__PURE__*/jsxs(FlexContainer, {
      gap: 30,
      style: {
        marginBottom: '15px'
      },
      children: [reservationEvents && reservationEvents.hasSubmittedRegistrationCard && /*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        alignItems: "center",
        children: [/*#__PURE__*/jsx("label", {
          children: "Status: "
        }), /*#__PURE__*/jsx(Label, {
          variant: "success",
          style: {
            justifyContent: 'center'
          },
          children: "SUBMITTED"
        })]
      }), reservationEvents && reservationEvents.emailEvents?.REGISTRATION_CARD && /*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        alignItems: "center",
        children: [/*#__PURE__*/jsx("label", {
          children: "Email Status: "
        }), reservationEvents && reservationEvents.emailEvents?.REGISTRATION_CARD.clicked ? /*#__PURE__*/jsx(Label, {
          variant: "success",
          children: "Clicked"
        }) : /*#__PURE__*/jsx(Label, {
          variant: "warning",
          children: "Not Clicked"
        })]
      })]
    }), bookedExtras && Object.values(bookedExtras).length !== 0 && /*#__PURE__*/jsx(BookedExtrasTable, {
      bookedExtras: Object.values(bookedExtras).filter(extra => extra.touchpoint === touchpoints.REGISTRATION_CARD),
      bundleByBookedExtraId: bundleByBookedExtraId,
      allowAmendments: currentUser?.role === 'ADMIN',
      onChangeBookedExtraStatus: onChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      program: programs.A
    })]
  });
};

const PartialUpgradeCaption = ({
  nights,
  stayNights,
  startDate,
  endDate,
  showNights = true,
  className
}) => {
  if (!isPartialUpgrade(nights, stayNights)) {
    return null;
  }
  const parts = [];
  if (showNights) {
    parts.push(formatNights(Number(nights)));
  }
  if (startDate && endDate) {
    parts.push(`${formatDate$1(startDate, 'dd MMM')} → ${formatDate$1(endDate, 'dd MMM')}`);
  }
  if (parts.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx(Text$2, {
    as: "small",
    size: "xs",
    color: "muted",
    className: className,
    children: parts.join(' · ')
  });
};
PartialUpgradeCaption.propTypes = {
  nights: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stayNights: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  showNights: PropTypes.bool,
  className: PropTypes.string
};

const INACTIVE_UPGRADE_STATUSES = [roomUpgradesStatus.CANCELLED, roomUpgradesStatus.REPLACED];
const needsManualRoomMove = (roomUpgrade, reservation) => {
  return isPartialUpgrade(roomUpgrade.nights, reservation?.nights) && !INACTIVE_UPGRADE_STATUSES.includes(roomUpgrade.status);
};
const OnArrivalUpsells = ({
  reservationProfile,
  bookedExtras,
  bundleByBookedExtraId,
  roomUpgrades,
  currentUser,
  roomTypesList,
  onChangeUpgradeBidStatus,
  onChangeBookedExtraStatus,
  loadReservationProfile
}) => {
  const programBRoomUpgrades = Object.values(roomUpgrades ?? {}).filter(b => programBTouchpoints.includes(b.touchpoint));
  const programBBookedExtras = Object.values(bookedExtras ?? {}).filter(b => programBTouchpoints.includes(b.touchpoint));
  const showManualRoomMoveWarning = programBRoomUpgrades.some(roomUpgrade => needsManualRoomMove(roomUpgrade, reservationProfile));
  if (programBRoomUpgrades.length === 0 && programBBookedExtras.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      bgColor: colors$1.onArrival,
      color: colors$1.white,
      children: "On-Arrival"
    }), showManualRoomMoveWarning && /*#__PURE__*/jsx(Alert, {
      variant: "warning",
      title: "Partial room upgrade",
      className: css$G.partialUpgradeWarning,
      children: "This reservation has an upgrade covering only part of the stay. The room move must be made manually in the PMS."
    }), programBRoomUpgrades.length !== 0 && /*#__PURE__*/jsx(RoomUpgrades, {
      reservation: reservationProfile,
      roomTypesList: roomTypesList,
      roomUpgrades: programBRoomUpgrades,
      allowAmendments: currentUser?.role === 'ADMIN',
      onChangeUpgradeBidStatus: onChangeUpgradeBidStatus,
      loadReservationProfile: loadReservationProfile
    }), programBBookedExtras.length !== 0 && /*#__PURE__*/jsx(BookedExtrasTable, {
      bookedExtras: programBBookedExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      allowAmendments: currentUser?.role === 'ADMIN',
      onChangeBookedExtraStatus: onChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      program: programs.B
    })]
  });
};
const RoomUpgrades = ({
  reservation,
  roomUpgrades
}) => {
  const {
    usersList
  } = useUsersList();
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileTableTitle, {
      backgroundColor: colors$1.onArrival10,
      children: "Room Upgrades"
    }), /*#__PURE__*/jsx("div", {
      className: css$G.tableWrapper,
      children: /*#__PURE__*/jsxs(Table, {
        cellAlign: "center",
        children: [/*#__PURE__*/jsx(TableHead, {
          children: /*#__PURE__*/jsxs(TableRow, {
            children: [/*#__PURE__*/jsx(TableHeader, {
              className: css$G.upsellCell,
              children: "From Room Type"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.upsellCell,
              children: "To Room Type"
            }), /*#__PURE__*/jsx(TableHeader, {
              align: "right",
              children: "Upgrade Amount"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.statusCell,
              children: "Status"
            }), /*#__PURE__*/jsx(TableHeader, {
              className: css$G.userCell
            })]
          })
        }), /*#__PURE__*/jsx("tbody", {
          children: Object.values(roomUpgrades).map(roomUpgrade => {
            return /*#__PURE__*/jsx(React.Fragment, {
              children: /*#__PURE__*/jsxs(TableRow, {
                children: [/*#__PURE__*/jsx(TableCell, {
                  className: css$G.ellipsisOverflow,
                  children: /*#__PURE__*/jsx(RoomTypeCode, {
                    id: roomUpgrade.fromRoomTypeId
                  })
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.ellipsisOverflow,
                  children: /*#__PURE__*/jsx(RoomTypeCode, {
                    id: roomUpgrade.toRoomTypeId
                  })
                }), /*#__PURE__*/jsxs(TableCell, {
                  align: "right",
                  children: [formatCurrency(roomUpgrade.amount, roomUpgrade.currency), /*#__PURE__*/jsx("br", {}), reservation.nights > 1 && roomUpgrade.amountPerNight && /*#__PURE__*/jsxs(Text$2, {
                    as: "small",
                    size: "xs",
                    color: "muted",
                    children: ["(", formatCurrency(roomUpgrade.amountPerNight, roomUpgrade.currency), "/night)"]
                  }), /*#__PURE__*/jsx(PartialUpgradeCaption, {
                    nights: roomUpgrade.nights,
                    stayNights: reservation.nights,
                    startDate: roomUpgrade.startDate,
                    endDate: roomUpgrade.endDate,
                    className: css$G.partialUpgradeCaption
                  })]
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.statusCell,
                  children: /*#__PURE__*/jsx(LabelTransactionStatus, {
                    status: roomUpgrade.status
                  })
                }), /*#__PURE__*/jsx(TableCell, {
                  className: css$G.userCell,
                  children: roomUpgrade.userId && /*#__PURE__*/jsx(FlexContainer, {
                    justifyContent: "center",
                    children: /*#__PURE__*/jsx(Tooltip$1, {
                      content: /*#__PURE__*/jsx(RoomUpgradeTransactionInfoTooltip, {
                        transaction: roomUpgrade
                      }),
                      position: "left",
                      children: /*#__PURE__*/jsx(Avatar, {
                        name: usersList[roomUpgrade.userId]?.fullName
                      })
                    })
                  })
                })]
              })
            }, roomUpgrade.id);
          })
        })]
      })
    })]
  });
};

const InHouseUpsells = ({
  bookedExtras,
  bundleByBookedExtraId,
  currentUser,
  onChangeBookedExtraStatus,
  loadReservationProfile
}) => {
  const inStayExtras = Object.values(bookedExtras || {}).filter(extra => extra.touchpoint === touchpoints.INHOUSE_EXTRAS || extra.touchpoint === touchpoints.HOTEL_DIRECTORY);
  if (inStayExtras.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(ReservationProfileSectionTitle, {
      bgColor: colors$1.inStay,
      color: colors$1.white,
      children: "In-Stay"
    }), /*#__PURE__*/jsx(BookedExtrasTable, {
      bookedExtras: inStayExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      allowAmendments: currentUser?.role === 'ADMIN',
      onChangeBookedExtraStatus: onChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      program: programs.C
    })]
  });
};

const ReservationProfileUpsells = ({
  reservationProfile,
  loadReservationProfile,
  bookedExtras,
  upgradeBids,
  roomUpgrades,
  bundles,
  reservationEvents,
  readOnly = false,
  toast,
  posthog,
  showUpsellingBlocker = true
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const {
    roomTypesList
  } = useRoomTypesList();
  const {
    currentUser
  } = useCurrentUser();
  const {
    bundleByUpgradeBidId,
    bundleByBookedExtraId
  } = useMemo(() => {
    const byUpgradeBidId = {};
    const byBookedExtraId = {};
    const bookedExtrasById = {};
    Object.values(bookedExtras || {}).forEach(bookedExtra => {
      bookedExtrasById[bookedExtra.id] = bookedExtra;
    });
    const upgradeBidsById = {};
    Object.values(upgradeBids || {}).forEach(upgradeBid => {
      upgradeBidsById[upgradeBid.id] = upgradeBid;
    });
    (bundles || []).forEach(bundle => {
      const bundleUpgradeBid = (bundle.upgradeBidIds || []).map(id => upgradeBidsById[id]).filter(Boolean)[0] || null;
      const roomTypeId = bundleUpgradeBid?.toRoomTypeId ?? bundle.roomTypeId ?? null;
      const bundleExtras = (bundle.bookedExtraIds || []).map(id => bookedExtrasById[id]).filter(Boolean).map(bookedExtra => ({
        extraTypeId: bookedExtra.extraTypeId,
        quantity: bookedExtra.quantity
      }));
      const extras = bundleExtras.length > 0 ? bundleExtras : bundle.extraTypeId ? [{
        extraTypeId: bundle.extraTypeId,
        quantity: 1
      }] : [];
      (bundle.upgradeBidIds || []).forEach(id => {
        byUpgradeBidId[id] = {
          bundleId: bundle.id,
          extras
        };
      });
      (bundle.bookedExtraIds || []).forEach(id => {
        byBookedExtraId[id] = {
          bundleId: bundle.id,
          roomTypeId
        };
      });
    });
    return {
      bundleByUpgradeBidId: byUpgradeBidId,
      bundleByBookedExtraId: byBookedExtraId
    };
  }, [bundles, bookedExtras, upgradeBids]);
  const handleChangeBundleStatus = async (bundleId, decision) => {
    const confirmMessage = decision === reservationBundleDecision.ACCEPT ? 'Do you really want to accept this room upgrade and its bundled extra(s)?' : 'Do you really want to reject this room upgrade and its bundled extra(s)?';
    const successMessage = decision === reservationBundleDecision.ACCEPT ? 'Bundle accepted!' : 'Bundle rejected!';
    if (!window.confirm(confirmMessage)) {
      return;
    }
    try {
      posthog?.capture('reservation_profile:bundles:change_status', {
        decision,
        source: 'room_upgrade_row'
      });
      showLoading();
      const bundleDecisionForm = new FormData();
      bundleDecisionForm.append('reservation_id', reservationProfile.id);
      bundleDecisionForm.append('decision', decision);
      await axios.post(`${restUrls.reservationBundleChangeStatus}/${bundleId}.json`, bundleDecisionForm);
      toast?.success(successMessage);
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to change the bundle status.');
    } finally {
      hideLoading();
    }
  };
  const handleChangeUpgradeBidStatus = async (upgradeBidId, toUpgradeBidStatus, isAmendment) => {
    const confirmMessage = toUpgradeBidStatus === upgradeBidsStatus.ACCEPTED ? isAmendment ? 'Do you really want to reinstate this room upgrade?' : 'Do you really want to accept this bid?' : 'Do you really want to reject this bid?';
    const successMessage = toUpgradeBidStatus === upgradeBidsStatus.ACCEPTED ? isAmendment ? 'Room upgrade reinstated!' : 'Upgrade bid accepted!' : 'Upgrade bid rejected!';
    if (!window.confirm(confirmMessage)) {
      return;
    }
    try {
      posthog?.capture('reservation_profile:upsells:change_upgrade_bid_status', {
        status: toUpgradeBidStatus
      });
      showLoading();
      const upgradeBidsNewStatusForm = new FormData();
      upgradeBidsNewStatusForm.append('to_status', toUpgradeBidStatus);
      const upgradeBidsNewStatusFormUrl = isAmendment ? apiEndpoints.upgradeBidReinstateStatus : apiEndpoints.upgradeBidChangeStatus;
      await axios.post(`${upgradeBidsNewStatusFormUrl}/${upgradeBidId}.json`, upgradeBidsNewStatusForm);
      toast?.success(successMessage);
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to change the upgrade bid status.');
    } finally {
      hideLoading();
    }
  };
  const handleChangeBookedExtraStatus = async (bookedExtra, toBookedExtraStatus, isAmendment) => {
    const confirmMessage = toBookedExtraStatus === bookedExtraStatus.CONFIRMED || toBookedExtraStatus === bookedExtraStatus.ACCEPTED ? isAmendment ? 'Do you really want to reinstate this extra?' : 'Do you really want to accept this booked extra?' : 'Do you really want to reject this booked extra?';
    const successMessage = toBookedExtraStatus === bookedExtraStatus.CONFIRMED || toBookedExtraStatus === bookedExtraStatus.ACCEPTED ? isAmendment ? 'Extra reinstated!' : 'Booked extra accepted!' : 'Booked extra rejected!';
    if (!window.confirm(confirmMessage)) {
      return;
    }
    try {
      posthog?.capture('reservation_profile:upsells:change_booked_extra_status', {
        status: toBookedExtraStatus
      });
      showLoading();
      const bookedExtraNewStatusForm = new FormData();
      bookedExtraNewStatusForm.append('to_status', toBookedExtraStatus);
      const bookedExtraNewStatusFormUrl = isAmendment ? apiEndpoints.bookedExtraReinstateStatus : apiEndpoints.bookedExtraChangeStatus;
      await axios.post(`${bookedExtraNewStatusFormUrl}/${bookedExtra.id}.json`, bookedExtraNewStatusForm);
      toast?.success(successMessage);
      loadReservationProfile();
    } catch (error) {
      console.error(error);
      toast?.error('There was an error while trying to change the booked extra status.');
    } finally {
      hideLoading();
    }
  };
  return /*#__PURE__*/jsxs("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    },
    children: [showUpsellingBlocker && reservationProfile.upsellingBlocker && /*#__PURE__*/jsx(Alert, {
      variant: "danger",
      title: "Pre-Arrival Upselling Blocker",
      children: reservationProfile.upsellingBlocker
    }), /*#__PURE__*/jsx(PreArrivalUpsells, {
      reservationProfile: reservationProfile,
      bookedExtras: bookedExtras,
      upgradeBids: upgradeBids,
      bundleByUpgradeBidId: bundleByUpgradeBidId,
      bundleByBookedExtraId: bundleByBookedExtraId,
      roomUpgrades: roomUpgrades,
      roomTypesList: roomTypesList,
      currentUser: readOnly ? null : currentUser,
      onChangeUpgradeBidStatus: readOnly ? null : handleChangeUpgradeBidStatus,
      onChangeBookedExtraStatus: readOnly ? null : handleChangeBookedExtraStatus,
      onChangeBundleStatus: readOnly ? null : handleChangeBundleStatus,
      loadReservationProfile: loadReservationProfile,
      readOnly: readOnly,
      toast: toast,
      posthog: posthog
    }), /*#__PURE__*/jsx(RegCardUpsells, {
      reservationProfile: reservationProfile,
      bookedExtras: bookedExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      reservationEvents: reservationEvents,
      currentUser: readOnly ? null : currentUser,
      onChangeBookedExtraStatus: readOnly ? null : handleChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      readOnly: readOnly
    }), /*#__PURE__*/jsx(OnArrivalUpsells, {
      reservationProfile: reservationProfile,
      bookedExtras: bookedExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      roomUpgrades: roomUpgrades,
      currentUser: readOnly ? null : currentUser,
      roomTypesList: roomTypesList,
      onChangeUpgradeBidStatus: readOnly ? null : handleChangeUpgradeBidStatus,
      onChangeBookedExtraStatus: readOnly ? null : handleChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      readOnly: readOnly
    }), /*#__PURE__*/jsx(InHouseUpsells, {
      reservationProfile: reservationProfile,
      bookedExtras: bookedExtras,
      bundleByBookedExtraId: bundleByBookedExtraId,
      currentUser: readOnly ? null : currentUser,
      onChangeBookedExtraStatus: readOnly ? null : handleChangeBookedExtraStatus,
      loadReservationProfile: loadReservationProfile,
      readOnly: readOnly
    })]
  });
};

const ReservationProfileRegCard = ({
  reservationProfile,
  reservationEvents,
  posthog,
  QRCodeComponent
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [regCardUrl, setRegCardUrl] = useState('');
  const [showQRCodeModal, setShowQRCodeModal] = useState(false);
  const loadRegCardLink = async () => {
    showLoading();
    try {
      const response = await axios.get(`${apiEndpoints.regCardLink}/${reservationProfile.id}.json`);
      setRegCardUrl(response.data.url);
      hideLoading();
    } catch (error) {
      alert('There was an error getting the registration card link.');
      hideLoading();
    }
  };
  useEffect(() => {
    loadRegCardLink();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleCloseQRCodeModalClick = () => {
    posthog?.capture('reservation_profile:reg_card:qr_modal_close');
    setShowQRCodeModal(false);
  };
  const handleShowQRCodeModalClick = () => {
    posthog?.capture('reservation_profile:reg_card:qr_modal_open');
    setShowQRCodeModal(true);
  };
  if (!reservationProfile.hasSubmittedRegistrationCard) {
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: [reservationProfile.hasSubmittedRegistrationCard && /*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        alignItems: "center",
        children: [/*#__PURE__*/jsx(CardTitle, {
          icon: /*#__PURE__*/jsx(Scan, {}),
          children: "Registration Card Status:"
        }), /*#__PURE__*/jsx(Label, {
          variant: "success",
          children: "Submitted"
        })]
      }), /*#__PURE__*/jsx(OpenRegCardButton, {
        onShowQRCodeModalClick: handleShowQRCodeModalClick
      }), showQRCodeModal && QRCodeComponent && /*#__PURE__*/jsx(QRCodeModal, {
        regCardUrl: regCardUrl,
        onCloseQRCodeModalClick: handleCloseQRCodeModalClick,
        QRCodeComponent: QRCodeComponent
      })]
    });
  }
  if (reservationEvents.hasSubmittedRegistrationCard) {
    return /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx(CardTitle, {
        children: "Main Guest"
      }), reservationProfile.submittedRegistrationCard.guestsRegistrationCards.length > 1 && /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx(CardTitle, {
          children: "Other Guests"
        }), /*#__PURE__*/jsx("ul", {
          children: reservationProfile.submittedRegistrationCard.guestsRegistrationCards.map(otherGuest => /*#__PURE__*/jsx("li", {
            children: otherGuest
          }, otherGuest.id))
        })]
      })]
    });
  }
};
const QRCodeModal = ({
  regCardUrl,
  onCloseQRCodeModalClick,
  QRCodeComponent
}) => {
  return /*#__PURE__*/jsx(Modal, {
    isOpen: true,
    onClose: onCloseQRCodeModalClick,
    title: "Scan QR Code With Your Device",
    style: {
      width: '400px'
    },
    children: /*#__PURE__*/jsx(FlexContainer, {
      justifyContent: "center",
      children: regCardUrl && /*#__PURE__*/jsx(QRCodeComponent, {
        size: 256,
        value: regCardUrl
      })
    })
  });
};
const OpenRegCardButton = ({
  onShowQRCodeModalClick
}) => {
  return /*#__PURE__*/jsx(FlexContainer, {
    justifyContent: "center",
    style: {
      marginTop: '20px'
    },
    children: /*#__PURE__*/jsx(Button$1, {
      variant: "tertiary",
      icon: /*#__PURE__*/jsx(Scan, {}),
      onClick: onShowQRCodeModalClick,
      children: "Generate Registration Card"
    })
  });
};

var css_248z$w = ".LearningCard-module__learningCard___9siqt{cursor:pointer;display:flex;flex-direction:column;overflow:hidden;padding:0!important;transition:transform .2s ease,box-shadow .2s ease}.LearningCard-module__learningCard___9siqt:hover{box-shadow:0 4px 12px rgba(0,0,0,.12);transform:translateY(-2px)}.LearningCard-module__learningCard___9siqt .LearningCard-module__cardHeader___uiaxR{padding:8px 10px!important}.LearningCard-module__learningCard___9siqt .LearningCard-module__bannerTitle___ZXM8v{color:var(--white);font-size:var(--body-small-size)!important;font-weight:var(--font-weight-semibold);margin:0;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.LearningCard-module__learningCard___9siqt .LearningCard-module__badge___jcYFM{flex-shrink:0}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageWrapper___-oUO-{height:160px;overflow:hidden;position:relative}.LearningCard-module__learningCard___9siqt .LearningCard-module__image___NAimN{height:100%;object-fit:cover;width:100%}.LearningCard-module__learningCard___9siqt .LearningCard-module__statusChip___4cCzl{border-radius:999px;box-shadow:0 1px 3px rgba(0,0,0,.18);color:var(--white);font-size:var(--body-xs-size);font-weight:var(--font-weight-semibold);line-height:var(--body-xs-line-height);padding:4px 10px;position:absolute;right:10px;top:10px}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageTopRight___r0nRH{align-items:center;display:flex;justify-content:center;position:absolute;right:10px;top:10px;z-index:2}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageBottomLeft___2rQd6{background-color:rgba(0,0,0,.7);border-radius:var(--border-radius-small);bottom:8px;color:var(--white);font-size:var(--body-xs-size);font-weight:var(--font-weight-semibold);left:8px;line-height:var(--body-xs-line-height);padding:2px 8px;position:absolute;z-index:2}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageCenterOverlay___GjyvE{align-items:center;background-color:rgba(0,0,0,.55);border-radius:50%;color:var(--white);display:flex;height:56px;justify-content:center;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:56px;z-index:3}.LearningCard-module__learningCard___9siqt .LearningCard-module__moduleLabelRow___jmJzc{padding:12px 16px}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayBody___A3sSH{display:flex;flex:1;flex-direction:column;gap:6px;padding:12px 14px 4px}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayTitleRow___hdHrL{flex-wrap:nowrap!important}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayTitle___mgYje{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--font-weight-semibold);margin:0;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayDescription___cdc5n{-webkit-line-clamp:2;-webkit-box-orient:vertical;color:var(--grey-64);display:-webkit-box;font-size:var(--body-small-size);line-height:var(--body-small-line-height);margin:0;overflow:hidden}.LearningCard-module__learningCard___9siqt .LearningCard-module__actions___9LhX2{padding:12px 16px!important}.LearningCard-module__learningCard___9siqt .LearningCard-module__inactiveMessage___X97DL{color:var(--grey-64);font-size:var(--body-small-size);font-style:italic;padding:12px 16px;text-align:center}.LearningCard-module__learningCard___9siqt.LearningCard-module__inactive___37K84 .LearningCard-module__imageWrapper___-oUO-{filter:grayscale(100%);opacity:.6}@media (max-width:768px){.LearningCard-module__learningCard___9siqt .LearningCard-module__bannerTitle___ZXM8v{font-size:var(--body-xs-size)}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageWrapper___-oUO-{height:120px}.LearningCard-module__learningCard___9siqt .LearningCard-module__imageCenterOverlay___GjyvE{height:44px;width:44px}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayTitle___mgYje{font-size:var(--body-small-size)}.LearningCard-module__learningCard___9siqt .LearningCard-module__overlayDescription___cdc5n{font-size:var(--body-xs-size)}}";
var css$v = {"learningCard":"LearningCard-module__learningCard___9siqt","cardHeader":"LearningCard-module__cardHeader___uiaxR","bannerTitle":"LearningCard-module__bannerTitle___ZXM8v","badge":"LearningCard-module__badge___jcYFM","imageWrapper":"LearningCard-module__imageWrapper___-oUO-","image":"LearningCard-module__image___NAimN","statusChip":"LearningCard-module__statusChip___4cCzl","imageTopRight":"LearningCard-module__imageTopRight___r0nRH","imageBottomLeft":"LearningCard-module__imageBottomLeft___2rQd6","imageCenterOverlay":"LearningCard-module__imageCenterOverlay___GjyvE","moduleLabelRow":"LearningCard-module__moduleLabelRow___jmJzc","overlayBody":"LearningCard-module__overlayBody___A3sSH","overlayTitleRow":"LearningCard-module__overlayTitleRow___hdHrL","overlayTitle":"LearningCard-module__overlayTitle___mgYje","overlayDescription":"LearningCard-module__overlayDescription___cdc5n","actions":"LearningCard-module__actions___9LhX2","inactiveMessage":"LearningCard-module__inactiveMessage___X97DL","inactive":"LearningCard-module__inactive___37K84"};
styleInject(css_248z$w);

const LEARNING_CARD_VARIANT = {
  BANNER: 'banner',
  OVERLAY: 'overlay'
};
const LearningCard = ({
  variant = LEARNING_CARD_VARIANT.BANNER,
  title,
  description,
  badge,
  imageUrl,
  imageAlt,
  statusColor,
  statusLabel,
  imageBottomLeft,
  imageTopRight,
  centerOverlay,
  moduleLabel,
  isInactive = false,
  inactiveMessage,
  onClick,
  className = '',
  children
}) => {
  const stopBubble = event => event.stopPropagation();
  const cardClassName = `${css$v.learningCard} ${css$v[variant]} ${isInactive ? css$v.inactive : ''} ${className}`.trim();
  const isOverlay = variant === LEARNING_CARD_VARIANT.OVERLAY;
  const handleCardClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return /*#__PURE__*/jsxs(Card, {
    className: cardClassName,
    onClick: handleCardClick,
    children: [!isOverlay && /*#__PURE__*/jsx(LearningCardBanner, {
      title: title,
      badge: badge,
      statusColor: statusColor
    }), /*#__PURE__*/jsxs("div", {
      className: css$v.imageWrapper,
      children: [imageUrl && /*#__PURE__*/jsx("img", {
        src: imageUrl,
        alt: imageAlt || '',
        className: css$v.image,
        loading: "lazy"
      }), isOverlay && statusLabel && /*#__PURE__*/jsx("span", {
        className: css$v.statusChip,
        style: {
          backgroundColor: statusColor
        },
        children: statusLabel
      }), !isOverlay && imageTopRight && /*#__PURE__*/jsx("span", {
        className: css$v.imageTopRight,
        children: imageTopRight
      }), !isOverlay && imageBottomLeft && /*#__PURE__*/jsx("span", {
        className: css$v.imageBottomLeft,
        children: imageBottomLeft
      }), centerOverlay && /*#__PURE__*/jsx("span", {
        className: css$v.imageCenterOverlay,
        children: centerOverlay
      })]
    }), isOverlay && /*#__PURE__*/jsx(LearningCardOverlayBody, {
      title: title,
      description: description,
      badge: badge
    }), !isOverlay && moduleLabel && /*#__PURE__*/jsx("div", {
      className: css$v.moduleLabelRow,
      children: moduleLabel
    }), isInactive ? inactiveMessage && /*#__PURE__*/jsx("div", {
      className: css$v.inactiveMessage,
      children: inactiveMessage
    }) : children && /*#__PURE__*/jsx(FlexContainer, {
      gap: 6,
      className: css$v.actions,
      onClick: stopBubble,
      children: children
    })]
  });
};
const LearningCardBanner = ({
  title,
  badge,
  statusColor
}) => {
  const headerStyle = statusColor ? {
    backgroundColor: statusColor
  } : undefined;
  return /*#__PURE__*/jsxs(FlexContainer, {
    justifyContent: "space-between",
    alignItems: "center",
    className: css$v.cardHeader,
    style: headerStyle,
    children: [/*#__PURE__*/jsx("h3", {
      className: css$v.bannerTitle,
      children: title
    }), badge && /*#__PURE__*/jsx("span", {
      className: css$v.badge,
      children: badge
    })]
  });
};
const LearningCardOverlayBody = ({
  title,
  description,
  badge
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$v.overlayBody,
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      alignItems: "center",
      justifyContent: "space-between",
      gap: 8,
      className: css$v.overlayTitleRow,
      children: [/*#__PURE__*/jsx("h3", {
        className: css$v.overlayTitle,
        children: title
      }), badge && /*#__PURE__*/jsx("span", {
        className: css$v.badge,
        children: badge
      })]
    }), description && /*#__PURE__*/jsx("p", {
      className: css$v.overlayDescription,
      children: description
    })]
  });
};

var css_248z$v = ".QuizPassedBadge-module__badge___2oRIH{align-items:center;background-color:var(--gold);border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.18);color:var(--white);display:flex;flex-shrink:0;justify-content:center}";
var css$u = {"badge":"QuizPassedBadge-module__badge___2oRIH"};
styleInject(css_248z$v);

const QuizPassedBadge = ({
  size = 28
}) => {
  const iconSize = Math.round(size * 0.6);
  return /*#__PURE__*/jsx("span", {
    className: css$u.badge,
    style: {
      width: size,
      height: size
    },
    children: /*#__PURE__*/jsx(Trophy01, {
      width: iconSize,
      height: iconSize
    })
  });
};

var css_248z$u = ".Breadcrumbs-module__breadcrumbs___R-ku-{align-items:center;color:var(--grey-64);display:flex;flex-wrap:wrap;font-size:var(--body-small-size);gap:8px;margin-bottom:12px}.Breadcrumbs-module__separator___KChd-{color:var(--grey-64);font-weight:var(--font-weight-light)}.Breadcrumbs-module__link___B1vub{color:var(--primary-color);text-decoration:none;transition:opacity .2s ease}.Breadcrumbs-module__link___B1vub:hover{opacity:.8}.Breadcrumbs-module__item___ECyrs{color:var(--grey-64)}.Breadcrumbs-module__current___ilnF5{color:var(--secondary-color);font-weight:var(--font-weight-medium)}@media (max-width:480px){.Breadcrumbs-module__breadcrumbs___R-ku-{font-size:var(--body-xs-size)}}";
var css$t = {"breadcrumbs":"Breadcrumbs-module__breadcrumbs___R-ku-","separator":"Breadcrumbs-module__separator___KChd-","link":"Breadcrumbs-module__link___B1vub","item":"Breadcrumbs-module__item___ECyrs","current":"Breadcrumbs-module__current___ilnF5"};
styleInject(css_248z$u);

const Breadcrumbs = ({
  items
}) => {
  if (!items || items.length === 0) {
    return null;
  }
  return /*#__PURE__*/jsx("nav", {
    className: css$t.breadcrumbs,
    "aria-label": "Breadcrumb",
    children: items.map((item, index) => {
      const isLast = index === items.length - 1;
      return /*#__PURE__*/jsxs(React.Fragment, {
        children: [index > 0 && /*#__PURE__*/jsx("span", {
          className: css$t.separator,
          children: "/"
        }), /*#__PURE__*/jsx(BreadcrumbsSegment, {
          item: item,
          isLast: isLast
        })]
      }, item.to || item.label);
    })
  });
};
const BreadcrumbsSegment = ({
  item,
  isLast
}) => {
  if (isLast) {
    return /*#__PURE__*/jsx("span", {
      className: css$t.current,
      children: item.label
    });
  }
  if (item.to) {
    return /*#__PURE__*/jsx(NavLink, {
      to: item.to,
      className: css$t.link,
      onClick: item.onClick,
      children: item.label
    });
  }
  return /*#__PURE__*/jsx("span", {
    className: css$t.item,
    children: item.label
  });
};
Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.node.isRequired,
    to: PropTypes.string,
    onClick: PropTypes.func
  })).isRequired
};

var css_248z$t = ".AsyncSearchableDropdown-module__dropdownContainer___Xs5c6{display:flex;flex-direction:column;position:relative;width:100%}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__label___SzFzl{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__label___SzFzl .AsyncSearchableDropdown-module__required___iE5wd{color:var(--danger);margin-left:.15rem}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76{position:relative;width:100%}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76.AsyncSearchableDropdown-module__error___xs4yo .AsyncSearchableDropdown-module__input___yIvot{border-color:var(--danger)}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76.AsyncSearchableDropdown-module__disabled___4APAJ{cursor:not-allowed;opacity:.7}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__input___yIvot{background-color:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;transition:all .2s ease;width:100%}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__input___yIvot:focus{background-color:var(--bg-light-48);outline:none}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__input___yIvot.AsyncSearchableDropdown-module__disabled___4APAJ{background-color:var(--bg-light-80);cursor:not-allowed;opacity:.7}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__input___yIvot::placeholder{color:var(--text)}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__optionsContainer___I0WkH{background-color:#fff;border:1px solid var(--bg-dark);border-radius:4px;left:0;margin-top:4px;max-height:200px;overflow-y:auto;position:absolute;right:0;top:100%;z-index:1000}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__optionsContainer___I0WkH .AsyncSearchableDropdown-module__option___h-iS5{cursor:pointer;padding:8px 12px;transition:background-color .2s}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__optionsContainer___I0WkH .AsyncSearchableDropdown-module__option___h-iS5:hover{background-color:var(--bg-light-48)}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__optionsContainer___I0WkH .AsyncSearchableDropdown-module__option___h-iS5.AsyncSearchableDropdown-module__selected___Qgpxj{background-color:var(--primary-10)}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__dropdown___RuO76 .AsyncSearchableDropdown-module__optionsContainer___I0WkH .AsyncSearchableDropdown-module__noOptions___8b3DE{color:#6c757d;font-style:italic;padding:8px 12px}.AsyncSearchableDropdown-module__dropdownContainer___Xs5c6 .AsyncSearchableDropdown-module__errorMessage___TI8t5{color:#dc3545;font-size:12px;margin-top:.2rem}";
var css$s = {"dropdownContainer":"AsyncSearchableDropdown-module__dropdownContainer___Xs5c6","label":"AsyncSearchableDropdown-module__label___SzFzl","required":"AsyncSearchableDropdown-module__required___iE5wd","dropdown":"AsyncSearchableDropdown-module__dropdown___RuO76","error":"AsyncSearchableDropdown-module__error___xs4yo","input":"AsyncSearchableDropdown-module__input___yIvot","disabled":"AsyncSearchableDropdown-module__disabled___4APAJ","optionsContainer":"AsyncSearchableDropdown-module__optionsContainer___I0WkH","option":"AsyncSearchableDropdown-module__option___h-iS5","selected":"AsyncSearchableDropdown-module__selected___Qgpxj","noOptions":"AsyncSearchableDropdown-module__noOptions___8b3DE","errorMessage":"AsyncSearchableDropdown-module__errorMessage___TI8t5"};
styleInject(css_248z$t);

const AsyncSearchableDropdown = ({
  label,
  value,
  onChange,
  loadOptions,
  fixedOptions = [],
  defaultOption = null,
  placeholder = 'Search and select an option',
  required = false,
  disabled = false,
  error = '',
  name,
  minChars = 0,
  debounceMs = 300,
  noOptionsText = 'No options found'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownRef = useRef(null);
  const loadOptionsRef = useRef(loadOptions);
  const requestIdRef = useRef(0);
  useEffect(() => {
    loadOptionsRef.current = loadOptions;
  }, [loadOptions]);
  useClickOutside(dropdownRef, () => setIsOpen(false));
  useEffect(() => {
    const option = [defaultOption, ...fixedOptions].find(opt => opt && opt.value === value);
    setSelectedOption(option || null);
  }, [value, defaultOption, fixedOptions]);
  const fetchOptions = useCallback(async query => {
    const requestId = ++requestIdRef.current;
    setIsLoading(true);
    try {
      const result = await loadOptionsRef.current(query);
      if (requestId === requestIdRef.current) {
        setOptions(Array.isArray(result) ? result : []);
      }
    } catch (e) {
      if (requestId === requestIdRef.current) {
        setOptions([]);
      }
    } finally {
      if (requestId === requestIdRef.current) {
        setIsLoading(false);
      }
    }
  }, []);
  useEffect(() => {
    if (!isOpen) {
      return;
    }
    if (searchTerm.length < minChars) {
      setOptions([]);
      setIsLoading(false);
      return;
    }
    const handle = setTimeout(() => {
      fetchOptions(searchTerm);
    }, debounceMs);
    return () => clearTimeout(handle);
  }, [searchTerm, isOpen, minChars, debounceMs, fetchOptions]);
  const handleInputChange = event => {
    setSearchTerm(event.target.value);
    setIsOpen(true);
  };
  const handleOptionClick = option => {
    setSelectedOption(option);
    setSearchTerm('');
    setIsOpen(false);
    onChange({
      target: {
        name,
        value: option.value
      }
    }, option);
  };
  const visibleOptions = [...fixedOptions, ...options];
  const showHint = searchTerm.length < minChars;
  return /*#__PURE__*/jsxs("div", {
    className: css$s.dropdownContainer,
    ref: dropdownRef,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$s.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$s.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: `${css$s.dropdown} ${error ? css$s.error : ''} ${disabled ? css$s.disabled : ''}`,
      children: [/*#__PURE__*/jsx("input", {
        type: "text",
        className: css$s.input,
        value: isOpen ? searchTerm : selectedOption ? selectedOption.label : '',
        onChange: handleInputChange,
        onFocus: () => setIsOpen(true),
        placeholder: selectedOption ? selectedOption.label : placeholder,
        disabled: disabled,
        required: required,
        name: name
      }), isOpen && !disabled && /*#__PURE__*/jsxs("div", {
        className: css$s.optionsContainer,
        children: [fixedOptions.map(option => /*#__PURE__*/jsx("div", {
          className: `${css$s.option} ${selectedOption?.value === option.value ? css$s.selected : ''}`,
          onClick: () => handleOptionClick(option),
          children: option.label
        }, `fixed-${option.value}`)), isLoading ? /*#__PURE__*/jsx("div", {
          className: css$s.noOptions,
          children: "Loading\u2026"
        }) : showHint ? /*#__PURE__*/jsxs("div", {
          className: css$s.noOptions,
          children: ["Type at least ", minChars, " characters to search"]
        }) : options.length > 0 ? options.map(option => /*#__PURE__*/jsx("div", {
          className: `${css$s.option} ${selectedOption?.value === option.value ? css$s.selected : ''}`,
          onClick: () => handleOptionClick(option),
          children: option.label
        }, option.value)) : visibleOptions.length === 0 ? /*#__PURE__*/jsx("div", {
          className: css$s.noOptions,
          children: noOptionsText
        }) : null]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$s.errorMessage,
      children: error
    })]
  });
};
AsyncSearchableDropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  loadOptions: PropTypes.func.isRequired,
  fixedOptions: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })),
  defaultOption: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  }),
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  name: PropTypes.string.isRequired,
  minChars: PropTypes.number,
  debounceMs: PropTypes.number,
  noOptionsText: PropTypes.string
};

var css_248z$s = ".LogoUpload-module__logoUpload___7rn-m{align-items:center;display:flex;gap:3rem;margin-bottom:1rem;width:100%}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__label___p0JmR{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__label___p0JmR .LogoUpload-module__required___ZPifd{color:var(--danger);margin-left:.15rem}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__uploadSection___AFD3h{align-items:center;display:flex;flex:1;gap:1rem}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__dropzone___PnGa7{align-items:center;border:2px dashed var(--primary-10);border-radius:var(--border-radius-small);cursor:pointer;display:flex;flex:1;justify-content:center;padding:1rem;transition:all .2s ease}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__dropzone___PnGa7:hover{background-color:var(--bg-light-48)}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__dropzone___PnGa7.LogoUpload-module__error___kh8UP{border-color:var(--danger)}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__content___PnGCg{text-align:center}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__content___PnGCg .LogoUpload-module__uploadText___VLo7I{color:var(--grey-64);font-size:var(--body-xs-size);line-height:var(--body-xs-line-height)}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__content___PnGCg .LogoUpload-module__clickText___kpNPt{color:var(--text);font-weight:var(--body-xs-weight);text-decoration:underline}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__content___PnGCg .LogoUpload-module__supportText___zOgnw{color:var(--grey-64);font-size:var(--body-xs-size);margin-top:.5rem}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__preview___3KO9P{align-items:center;background-color:var(--white);border:1px solid var(--bg-dark);border-radius:50%;display:flex;flex-shrink:0;height:105px;justify-content:center;overflow:hidden;position:relative;width:105px}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__placeholder___oZ8OJ{color:var(--grey-64);font-size:var(--body-xs-size);left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);width:100%}.LogoUpload-module__logoUpload___7rn-m .LogoUpload-module__logoImage___6Ya4h{height:100%;object-fit:contain;width:100%}.LogoUpload-module__errorMessage___14Sr6{color:var(--danger);display:block;font-size:.75rem;margin-top:.2rem}";
var css$r = {"logoUpload":"LogoUpload-module__logoUpload___7rn-m","label":"LogoUpload-module__label___p0JmR","required":"LogoUpload-module__required___ZPifd","uploadSection":"LogoUpload-module__uploadSection___AFD3h","dropzone":"LogoUpload-module__dropzone___PnGa7","error":"LogoUpload-module__error___kh8UP","content":"LogoUpload-module__content___PnGCg","uploadText":"LogoUpload-module__uploadText___VLo7I","clickText":"LogoUpload-module__clickText___kpNPt","supportText":"LogoUpload-module__supportText___zOgnw","preview":"LogoUpload-module__preview___3KO9P","placeholder":"LogoUpload-module__placeholder___oZ8OJ","logoImage":"LogoUpload-module__logoImage___6Ya4h","errorMessage":"LogoUpload-module__errorMessage___14Sr6"};
styleInject(css_248z$s);

const LogoUpload = ({
  onImageChange,
  initialImage,
  logoText = 'Hotel Logo',
  label,
  required,
  error
}) => {
  const [image, setImage] = useState(initialImage);
  const fileInputRef = useRef(null);
  useEffect(() => {
    if (typeof initialImage.preview === 'string') {
      setImage(initialImage);
    }
  }, [initialImage]);
  const handleFile = useCallback(file => {
    if (!file) return;
    if (file.type !== 'image/png' && file.type !== 'image/jpeg' && file.type !== 'image/jpg') {
      return;
    }
    const preview = URL.createObjectURL(file);
    const newImage = {
      file: file,
      preview: preview
    };
    setImage(newImage);
    onImageChange?.(file);
  }, [onImageChange]);
  const handleClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const handleFileInputChange = useCallback(e => {
    handleFile(e.target.files[0]);
  }, [handleFile]);
  const handleDrop = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files?.length) {
      handleFile(e.dataTransfer.files[0]);
    }
  }, [handleFile]);
  const handleDragOver = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/jsxs("div", {
    className: css$r.logoUpload,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$r.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$r.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$r.uploadSection,
      children: [/*#__PURE__*/jsx("div", {
        className: css$r.preview,
        children: image?.preview ? /*#__PURE__*/jsx("img", {
          src: image.preview,
          alt: "Hotel logo preview",
          className: css$r.logoImage
        }) : /*#__PURE__*/jsx("div", {
          className: css$r.placeholder,
          children: logoText
        })
      }), /*#__PURE__*/jsxs("div", {
        className: `${css$r.dropzone} ${error ? css$r.error : ''}`,
        onClick: handleClick,
        onDrop: handleDrop,
        onDragOver: handleDragOver,
        "data-error": !!error,
        children: [/*#__PURE__*/jsx("input", {
          ref: fileInputRef,
          type: "file",
          accept: "image/png,image/jpeg",
          onChange: handleFileInputChange,
          style: {
            display: 'none'
          }
        }), /*#__PURE__*/jsxs("div", {
          className: css$r.content,
          children: [/*#__PURE__*/jsx(ImageAdd, {
            width: 24,
            color: "var(--primary-color)"
          }), /*#__PURE__*/jsxs("div", {
            className: css$r.uploadText,
            children: [/*#__PURE__*/jsx("span", {
              className: css$r.clickText,
              children: "Click to upload"
            }), " or drag and drop", /*#__PURE__*/jsx("div", {
              className: css$r.supportText,
              children: "PNG or JPG (max. 1000x1000px)"
            })]
          })]
        })]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$r.errorMessage,
      children: error
    })]
  });
};
LogoUpload.propTypes = {
  onImageChange: PropTypes.func.isRequired,
  initialImage: PropTypes.shape({
    preview: PropTypes.string.isRequired
  }),
  error: PropTypes.string
};

const TargetingListSection = ({
  title,
  hint,
  items,
  onAdd,
  onRemove
}) => {
  const [inputValue, setInputValue] = useState('');
  const handleAdd = () => {
    if (!inputValue.trim()) {
      return;
    }
    onAdd(inputValue.trim());
    setInputValue('');
  };
  const handleKeyPress = evt => {
    if (evt.key === 'Enter') {
      evt.preventDefault();
      handleAdd();
    }
  };
  return /*#__PURE__*/jsxs("div", {
    children: [title && /*#__PURE__*/jsxs(FlexContainer, {
      gap: 8,
      alignItems: "center",
      children: [/*#__PURE__*/jsx(CardTitle, {
        style: {
          width: 'auto'
        },
        children: title
      }), hint]
    }), /*#__PURE__*/jsxs(FlexContainer, {
      gap: 10,
      flexFlow: "column",
      style: {
        marginTop: title ? '10px' : 0
      },
      children: [/*#__PURE__*/jsxs(FlexContainer, {
        gap: 10,
        children: [/*#__PURE__*/jsx("div", {
          style: {
            flex: '1 1 auto'
          },
          children: /*#__PURE__*/jsx(InputText, {
            value: inputValue,
            onChange: e => setInputValue(e.target.value),
            onKeyPress: handleKeyPress
          })
        }), /*#__PURE__*/jsx(Button$1, {
          variant: "tertiary",
          icon: /*#__PURE__*/jsx(Plus03, {}),
          onClick: handleAdd,
          children: "Add"
        })]
      }), /*#__PURE__*/jsx(FlexContainer, {
        gap: 10,
        flexFlow: "wrap",
        children: items?.map(item => /*#__PURE__*/jsx(LabelDelete, {
          label: item,
          onDelete: () => onRemove(item),
          style: {
            textTransform: 'none'
          }
        }, item))
      })]
    })]
  });
};

var css_248z$r = ".QuantityInput-module__quantityInputContainer___UIn7x{display:flex;flex-direction:column;gap:4px}.QuantityInput-module__quantityInputContainer___UIn7x .QuantityInput-module__label___DSuV8{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:0!important;text-align:left}.QuantityInput-module__quantityInputContainer___UIn7x .QuantityInput-module__label___DSuV8 .QuantityInput-module__required___hkNsO{color:var(--danger);margin-left:.15rem}.QuantityInput-module__controls___eXsi-{align-items:center;background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);display:flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);justify-content:space-between;line-height:var(--body-regular-line-height);padding:.6rem 0;transition:all .2s ease}.QuantityInput-module__button___Uq110{align-items:center;background:transparent;border:none;border-radius:6px;cursor:pointer;display:inline-flex;height:24px;justify-content:center;padding:0;width:24px}.QuantityInput-module__button___Uq110 svg{height:16px;width:16px}.QuantityInput-module__button___Uq110:disabled{cursor:not-allowed;opacity:.5}.QuantityInput-module__input___l9CY7{-moz-appearance:textfield;background:transparent;border:none;flex:1;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);min-width:0;padding:0!important;text-align:center}.QuantityInput-module__input___l9CY7::-webkit-inner-spin-button,.QuantityInput-module__input___l9CY7::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}";
var css$q = {"quantityInputContainer":"QuantityInput-module__quantityInputContainer___UIn7x","label":"QuantityInput-module__label___DSuV8","required":"QuantityInput-module__required___hkNsO","controls":"QuantityInput-module__controls___eXsi-","button":"QuantityInput-module__button___Uq110","input":"QuantityInput-module__input___l9CY7"};
styleInject(css_248z$r);

const QuantityInput = ({
  label,
  name,
  value,
  onChange,
  min = 0,
  max,
  step = 1,
  disabled = false,
  className = ''
}) => {
  const handleChange = newValue => {
    if (disabled) {
      return;
    }
    if (newValue === '' || isNaN(newValue)) {
      onChange({
        target: {
          name,
          value: ''
        }
      });
      return;
    }
    let numericValue = parseInt(newValue, 10);
    if (isNaN(numericValue)) {
      return;
    }
    if (min !== undefined && numericValue < min) {
      numericValue = min;
    }
    if (max !== undefined && numericValue > max) {
      numericValue = max;
    }
    onChange({
      target: {
        name,
        value: numericValue
      }
    });
  };
  const handleDecrease = () => {
    const current = parseInt(value || 0, 10);
    const next = current - step;
    if (min !== undefined && next < min) {
      if (min === 0) {
        handleChange('');
        return;
      }
      handleChange(min);
      return;
    }
    handleChange(next);
  };
  const handleIncrease = () => {
    const current = parseInt(value || 0, 10);
    const next = current + step;
    handleChange(next);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$q.quantityInputContainer} ${className}`,
    children: [label && /*#__PURE__*/jsx("label", {
      className: css$q.label,
      children: label
    }), /*#__PURE__*/jsxs("div", {
      className: css$q.controls,
      children: [/*#__PURE__*/jsx("button", {
        type: "button",
        className: css$q.button,
        onClick: handleDecrease,
        disabled: disabled,
        children: /*#__PURE__*/jsx(MinusCircleContainedIcon, {
          color: colors$1.bgDark
        })
      }), /*#__PURE__*/jsx("input", {
        type: "number",
        name: name,
        className: css$q.input,
        value: value || '',
        onChange: e => handleChange(e.target.value),
        disabled: disabled
      }), /*#__PURE__*/jsx("button", {
        type: "button",
        className: css$q.button,
        onClick: handleIncrease,
        disabled: disabled,
        children: /*#__PURE__*/jsx(AddSquare04Icon, {
          color: colors$1.bgDark
        })
      })]
    })]
  });
};
QuantityInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  className: PropTypes.string
};

var css_248z$q = ".FormGroup-module__formGroupOuterParent___kmpnY{background-color:var(--white);border:1px solid var(--bg-light-80);border-radius:var(--border-radius-medium);margin-bottom:20px;padding:20px}.FormGroup-module__formGroupOuterParent___kmpnY p{font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height)}.FormGroup-module__formGroupInnerChild___5v65f{background-color:var(--bg-light-80);border-radius:var(--border-radius-small);margin-bottom:20px;padding:15px}.FormGroup-module__formGroupInnerChild___5v65f .FormGroup-module__formGroupInnerChildForm___fX9Fj{background-color:#fff;border-radius:var(--border-radius-small);padding:15px}.FormGroup-module__formGroupInnerChild___5v65f .FormGroup-module__formGroupInnerChildForm___fX9Fj ol,.FormGroup-module__formGroupInnerChild___5v65f .FormGroup-module__formGroupInnerChildForm___fX9Fj ul{margin-left:15px}.FormGroup-module__header___ctWaO{align-items:flex-start;display:flex;justify-content:space-between}.FormGroup-module__noTitleHeader___t8wj8{align-items:center;display:flex;justify-content:flex-end}.FormGroup-module__header___ctWaO .FormGroup-module__formGroupTitle___c8QgK,.FormGroup-module__noTitleHeader___t8wj8 .FormGroup-module__formGroupTitle___c8QgK{color:var(--primary-color);font-size:var(--body-regular-size)!important;font-weight:var(--body-regular-weight)!important;margin-bottom:15px}.FormGroup-module__header___ctWaO .FormGroup-module__removeButton___HoP-I,.FormGroup-module__noTitleHeader___t8wj8 .FormGroup-module__removeButton___HoP-I{background-color:transparent;border:none;color:var(--danger);cursor:pointer;font-size:1rem;transition:all .2s ease}.FormGroup-module__header___ctWaO .FormGroup-module__removeButton___HoP-I svg,.FormGroup-module__noTitleHeader___t8wj8 .FormGroup-module__removeButton___HoP-I svg{width:20px}.FormGroup-module__header___ctWaO .FormGroup-module__removeButton___HoP-I:hover,.FormGroup-module__noTitleHeader___t8wj8 .FormGroup-module__removeButton___HoP-I:hover{opacity:.8}.FormGroup-module__removeButton___HoP-I{background-color:transparent;border:none;color:var(--danger);cursor:pointer;font-size:1rem;transition:all .2s ease}.FormGroup-module__removeButton___HoP-I svg{width:20px}.FormGroup-module__removeButton___HoP-I:hover{opacity:.8}";
var css$p = {"formGroupOuterParent":"FormGroup-module__formGroupOuterParent___kmpnY","formGroupInnerChild":"FormGroup-module__formGroupInnerChild___5v65f","formGroupInnerChildForm":"FormGroup-module__formGroupInnerChildForm___fX9Fj","header":"FormGroup-module__header___ctWaO","noTitleHeader":"FormGroup-module__noTitleHeader___t8wj8","formGroupTitle":"FormGroup-module__formGroupTitle___c8QgK","removeButton":"FormGroup-module__removeButton___HoP-I"};
styleInject(css_248z$q);

const FormGroupOuterParent = ({
  title,
  className,
  children,
  onRemove
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${className} ${css$p.formGroupOuterParent}`,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$p.header,
      children: [title && /*#__PURE__*/jsx("h5", {
        className: css$p.formGroupTitle,
        children: title
      }), onRemove && /*#__PURE__*/jsx(DeleteButton, {
        onClick: onRemove
      })]
    }), /*#__PURE__*/jsx("div", {
      children: children
    })]
  });
};
FormGroupOuterParent.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool
};

const FormGroupInnerChild = ({
  title,
  className,
  children,
  onRemove,
  style
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${className} ${css$p.formGroupInnerChild}`,
    style: style,
    children: [/*#__PURE__*/jsxs("div", {
      className: title ? css$p.header : css$p.noTitleHeader,
      children: [title && /*#__PURE__*/jsx("h5", {
        className: css$p.formGroupTitle,
        children: title
      }), onRemove && /*#__PURE__*/jsx(DeleteButton, {
        onClick: onRemove
      })]
    }), /*#__PURE__*/jsx("div", {
      className: css$p.formGroupInnerChildForm,
      children: children
    })]
  });
};
FormGroupInnerChild.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onRemove: PropTypes.func,
  showRemove: PropTypes.bool
};

const LinkButton = () => {
  const {
    editor
  } = useCurrentEditor();
  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes('link').href;
    const url = window.prompt('URL', previousUrl);

    // cancelled
    if (url === null) {
      return;
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink().run();
      return;
    }

    // update link
    try {
      editor.chain().focus().extendMarkRange('link').setLink({
        href: url
      }).run();
    } catch (e) {
      console.log(e);
    }
  }, [editor]);
  return /*#__PURE__*/jsx(Fragment$1, {
    children: /*#__PURE__*/jsx(Tooltip$1, {
      position: "top",
      content: "Add link",
      children: /*#__PURE__*/jsx(Button$1, {
        size: "small",
        onClick: setLink,
        className: editor.isActive('link') ? css$S.active : '',
        children: /*#__PURE__*/jsx(LinkAngled, {})
      })
    })
  });
};

var css_248z$p = ".ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__label___txZGJ{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);text-align:left}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__label___txZGJ .ColorPicker-module__required___B3bKL{color:var(--danger);margin-left:.15rem}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF{align-items:center;background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);display:flex;font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);gap:.5rem;line-height:var(--body-regular-line-height);margin-top:.3rem;padding:.6rem;position:relative;transition:all .2s ease;width:100%}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__selectedColor___hmjyL{border:1px solid var(--grey-20);border-radius:var(--border-radius-small);cursor:pointer;height:20px;overflow:hidden;position:relative;width:20px}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__selectedColor___hmjyL .ColorPicker-module__colorInput___YLIxY{border-radius:var(--border-radius-small);cursor:pointer;height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__hashPrefix___gT7dz{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height)}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__hexInput___J9NTl{background:none;border:none;color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);height:fit-content!important;line-height:var(--body-regular-line-height);padding:0;text-transform:uppercase;width:90px}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__hexInput___J9NTl::placeholder{color:var(--grey-64)}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__hexInput___J9NTl:focus{outline:none}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__colorPickerWrapper___I2vcF .ColorPicker-module__hexInput___J9NTl:disabled{color:var(--grey-64);cursor:not-allowed}.ColorPicker-module__colorPickerContainer___Cjgjt .ColorPicker-module__error___0Jrsh{color:var(--danger);display:block;font-size:.75rem;margin-top:.2rem}";
var css$o = {"colorPickerContainer":"ColorPicker-module__colorPickerContainer___Cjgjt","label":"ColorPicker-module__label___txZGJ","required":"ColorPicker-module__required___B3bKL","colorPickerWrapper":"ColorPicker-module__colorPickerWrapper___I2vcF","selectedColor":"ColorPicker-module__selectedColor___hmjyL","colorInput":"ColorPicker-module__colorInput___YLIxY","hashPrefix":"ColorPicker-module__hashPrefix___gT7dz","hexInput":"ColorPicker-module__hexInput___J9NTl","error":"ColorPicker-module__error___0Jrsh"};
styleInject(css_248z$p);

const ColorPicker = ({
  label,
  value,
  onChange,
  required = false,
  disabled = false,
  error = ''
}) => {
  // Normalize value by removing # prefix if present
  const normalizedValue = value && typeof value === 'string' ? value.replace(/^#/, '') : value || '';
  const handleColorChange = e => {
    let hexValue = String(e.target.value);
    if (hexValue.startsWith('#')) {
      hexValue = hexValue.substring(1);
    }
    onChange(hexValue);
  };
  const handleHexInputChange = e => {
    let hexValue = String(e.target.value);
    if (hexValue.startsWith('#')) {
      hexValue = hexValue.substring(1);
    }
    // Validate hex color format
    if (hexValue === '' || /^[0-9A-Fa-f]{0,6}$/.test(hexValue)) {
      onChange(hexValue);
    }
  };
  let valueWithLeadingHash = '';
  if (normalizedValue) {
    valueWithLeadingHash = `#${normalizedValue}`;
  }
  return /*#__PURE__*/jsxs("div", {
    className: css$o.colorPickerContainer,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$o.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$o.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$o.colorPickerWrapper,
      children: [/*#__PURE__*/jsx("div", {
        className: css$o.selectedColor,
        style: {
          backgroundColor: valueWithLeadingHash || '#ffffff'
        },
        children: /*#__PURE__*/jsx("input", {
          type: "color",
          value: valueWithLeadingHash,
          onChange: handleColorChange,
          disabled: disabled,
          className: css$o.colorInput
        })
      }), /*#__PURE__*/jsx("span", {
        className: css$o.hashPrefix,
        children: normalizedValue ? '#' : ''
      }), /*#__PURE__*/jsx("input", {
        type: "text",
        className: css$o.hexInput,
        value: normalizedValue,
        onChange: handleHexInputChange,
        disabled: disabled,
        maxLength: 6,
        placeholder: ""
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$o.error,
      children: error
    })]
  });
};
ColorPicker.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.string
};

var css_248z$o = ".Checkbox-module__checkboxWrapper___j6p6q{align-items:center;display:flex;gap:.5rem}.Checkbox-module__checkboxWrapper___j6p6q input[type=checkbox]{appearance:none;-webkit-appearance:none;border:2px solid var(--bg-dark);border-radius:4px;cursor:pointer;height:1.2rem;position:relative;transition:all .2s ease;width:1.2rem}.Checkbox-module__checkboxWrapper___j6p6q input[type=checkbox]:checked{background-color:var(--primary-color);border-color:var(--primary-color)}.Checkbox-module__checkboxWrapper___j6p6q input[type=checkbox]:checked:after{border:solid #fff;border-width:0 2px 2px 0;content:\"\";height:7px;left:5px;position:absolute;top:2px;transform:rotate(45deg);width:3px}.Checkbox-module__checkboxWrapper___j6p6q input[type=checkbox]:not(:checked):hover{background-color:var(--primary-10);border-color:var(--primary-color)}.Checkbox-module__checkboxWrapper___j6p6q label{color:var(--grey-64);cursor:pointer;font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height)}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__top___eCjL0{align-items:start;flex-direction:column;gap:1rem;height:70px}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__bottom___KOvxJ{align-items:start;flex-direction:column-reverse;gap:1rem;height:70px}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__left___W1yq8{flex-direction:row-reverse}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__error___r4DoK input[type=checkbox]{border-color:var(--danger)}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__disabled___1IGeu{opacity:.5}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__disabled___1IGeu input[type=checkbox]{border-color:var(--grey-20);cursor:not-allowed}.Checkbox-module__checkboxWrapper___j6p6q.Checkbox-module__disabled___1IGeu label{cursor:not-allowed}.Checkbox-module__errorMessage___Irgjr{color:var(--danger);font-size:var(--body-xs-size);margin-top:.3rem}";
var css$n = {"checkboxWrapper":"Checkbox-module__checkboxWrapper___j6p6q","top":"Checkbox-module__top___eCjL0","bottom":"Checkbox-module__bottom___KOvxJ","left":"Checkbox-module__left___W1yq8","error":"Checkbox-module__error___r4DoK","disabled":"Checkbox-module__disabled___1IGeu","errorMessage":"Checkbox-module__errorMessage___Irgjr"};
styleInject(css_248z$o);

const Checkbox = ({
  id,
  label,
  checked,
  onChange,
  error,
  errorMessage = 'This field is required',
  className,
  labelPosition = 'right',
  disabled = false
}) => {
  const labelNode = label ? /*#__PURE__*/jsx("label", {
    htmlFor: id,
    children: label
  }) : null;
  const wrapperClassName = [css$n.checkboxWrapper, className, error ? css$n.error : '', disabled ? css$n.disabled : '', labelPosition === 'top' ? css$n.top : '', labelPosition === 'left' ? css$n.left : '', labelPosition === 'bottom' ? css$n.bottom : ''].filter(Boolean).join(' ');
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs("div", {
      className: wrapperClassName,
      children: [(labelPosition === 'top' || labelPosition === 'left') && labelNode, /*#__PURE__*/jsx("input", {
        type: "checkbox",
        id: id,
        checked: checked,
        onChange: onChange,
        disabled: disabled
      }), (labelPosition === 'right' || labelPosition === 'bottom') && labelNode]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$n.errorMessage,
      children: errorMessage
    })]
  });
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const COMMON_MIME_TYPES = new Map([
    // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
    ['1km', 'application/vnd.1000minds.decision-model+xml'],
    ['3dml', 'text/vnd.in3d.3dml'],
    ['3ds', 'image/x-3ds'],
    ['3g2', 'video/3gpp2'],
    ['3gp', 'video/3gp'],
    ['3gpp', 'video/3gpp'],
    ['3mf', 'model/3mf'],
    ['7z', 'application/x-7z-compressed'],
    ['7zip', 'application/x-7z-compressed'],
    ['123', 'application/vnd.lotus-1-2-3'],
    ['aab', 'application/x-authorware-bin'],
    ['aac', 'audio/x-acc'],
    ['aam', 'application/x-authorware-map'],
    ['aas', 'application/x-authorware-seg'],
    ['abw', 'application/x-abiword'],
    ['ac', 'application/vnd.nokia.n-gage.ac+xml'],
    ['ac3', 'audio/ac3'],
    ['acc', 'application/vnd.americandynamics.acc'],
    ['ace', 'application/x-ace-compressed'],
    ['acu', 'application/vnd.acucobol'],
    ['acutc', 'application/vnd.acucorp'],
    ['adp', 'audio/adpcm'],
    ['aep', 'application/vnd.audiograph'],
    ['afm', 'application/x-font-type1'],
    ['afp', 'application/vnd.ibm.modcap'],
    ['ahead', 'application/vnd.ahead.space'],
    ['ai', 'application/pdf'],
    ['aif', 'audio/x-aiff'],
    ['aifc', 'audio/x-aiff'],
    ['aiff', 'audio/x-aiff'],
    ['air', 'application/vnd.adobe.air-application-installer-package+zip'],
    ['ait', 'application/vnd.dvb.ait'],
    ['ami', 'application/vnd.amiga.ami'],
    ['amr', 'audio/amr'],
    ['apk', 'application/vnd.android.package-archive'],
    ['apng', 'image/apng'],
    ['appcache', 'text/cache-manifest'],
    ['application', 'application/x-ms-application'],
    ['apr', 'application/vnd.lotus-approach'],
    ['arc', 'application/x-freearc'],
    ['arj', 'application/x-arj'],
    ['asc', 'application/pgp-signature'],
    ['asf', 'video/x-ms-asf'],
    ['asm', 'text/x-asm'],
    ['aso', 'application/vnd.accpac.simply.aso'],
    ['asx', 'video/x-ms-asf'],
    ['atc', 'application/vnd.acucorp'],
    ['atom', 'application/atom+xml'],
    ['atomcat', 'application/atomcat+xml'],
    ['atomdeleted', 'application/atomdeleted+xml'],
    ['atomsvc', 'application/atomsvc+xml'],
    ['atx', 'application/vnd.antix.game-component'],
    ['au', 'audio/x-au'],
    ['avi', 'video/x-msvideo'],
    ['avif', 'image/avif'],
    ['aw', 'application/applixware'],
    ['azf', 'application/vnd.airzip.filesecure.azf'],
    ['azs', 'application/vnd.airzip.filesecure.azs'],
    ['azv', 'image/vnd.airzip.accelerator.azv'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['b16', 'image/vnd.pco.b16'],
    ['bat', 'application/x-msdownload'],
    ['bcpio', 'application/x-bcpio'],
    ['bdf', 'application/x-font-bdf'],
    ['bdm', 'application/vnd.syncml.dm+wbxml'],
    ['bdoc', 'application/x-bdoc'],
    ['bed', 'application/vnd.realvnc.bed'],
    ['bh2', 'application/vnd.fujitsu.oasysprs'],
    ['bin', 'application/octet-stream'],
    ['blb', 'application/x-blorb'],
    ['blorb', 'application/x-blorb'],
    ['bmi', 'application/vnd.bmi'],
    ['bmml', 'application/vnd.balsamiq.bmml+xml'],
    ['bmp', 'image/bmp'],
    ['book', 'application/vnd.framemaker'],
    ['box', 'application/vnd.previewsystems.box'],
    ['boz', 'application/x-bzip2'],
    ['bpk', 'application/octet-stream'],
    ['bpmn', 'application/octet-stream'],
    ['bsp', 'model/vnd.valve.source.compiled-map'],
    ['btif', 'image/prs.btif'],
    ['buffer', 'application/octet-stream'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['c', 'text/x-c'],
    ['c4d', 'application/vnd.clonk.c4group'],
    ['c4f', 'application/vnd.clonk.c4group'],
    ['c4g', 'application/vnd.clonk.c4group'],
    ['c4p', 'application/vnd.clonk.c4group'],
    ['c4u', 'application/vnd.clonk.c4group'],
    ['c11amc', 'application/vnd.cluetrust.cartomobile-config'],
    ['c11amz', 'application/vnd.cluetrust.cartomobile-config-pkg'],
    ['cab', 'application/vnd.ms-cab-compressed'],
    ['caf', 'audio/x-caf'],
    ['cap', 'application/vnd.tcpdump.pcap'],
    ['car', 'application/vnd.curl.car'],
    ['cat', 'application/vnd.ms-pki.seccat'],
    ['cb7', 'application/x-cbr'],
    ['cba', 'application/x-cbr'],
    ['cbr', 'application/x-cbr'],
    ['cbt', 'application/x-cbr'],
    ['cbz', 'application/x-cbr'],
    ['cc', 'text/x-c'],
    ['cco', 'application/x-cocoa'],
    ['cct', 'application/x-director'],
    ['ccxml', 'application/ccxml+xml'],
    ['cdbcmsg', 'application/vnd.contact.cmsg'],
    ['cda', 'application/x-cdf'],
    ['cdf', 'application/x-netcdf'],
    ['cdfx', 'application/cdfx+xml'],
    ['cdkey', 'application/vnd.mediastation.cdkey'],
    ['cdmia', 'application/cdmi-capability'],
    ['cdmic', 'application/cdmi-container'],
    ['cdmid', 'application/cdmi-domain'],
    ['cdmio', 'application/cdmi-object'],
    ['cdmiq', 'application/cdmi-queue'],
    ['cdr', 'application/cdr'],
    ['cdx', 'chemical/x-cdx'],
    ['cdxml', 'application/vnd.chemdraw+xml'],
    ['cdy', 'application/vnd.cinderella'],
    ['cer', 'application/pkix-cert'],
    ['cfs', 'application/x-cfs-compressed'],
    ['cgm', 'image/cgm'],
    ['chat', 'application/x-chat'],
    ['chm', 'application/vnd.ms-htmlhelp'],
    ['chrt', 'application/vnd.kde.kchart'],
    ['cif', 'chemical/x-cif'],
    ['cii', 'application/vnd.anser-web-certificate-issue-initiation'],
    ['cil', 'application/vnd.ms-artgalry'],
    ['cjs', 'application/node'],
    ['cla', 'application/vnd.claymore'],
    ['class', 'application/octet-stream'],
    ['clkk', 'application/vnd.crick.clicker.keyboard'],
    ['clkp', 'application/vnd.crick.clicker.palette'],
    ['clkt', 'application/vnd.crick.clicker.template'],
    ['clkw', 'application/vnd.crick.clicker.wordbank'],
    ['clkx', 'application/vnd.crick.clicker'],
    ['clp', 'application/x-msclip'],
    ['cmc', 'application/vnd.cosmocaller'],
    ['cmdf', 'chemical/x-cmdf'],
    ['cml', 'chemical/x-cml'],
    ['cmp', 'application/vnd.yellowriver-custom-menu'],
    ['cmx', 'image/x-cmx'],
    ['cod', 'application/vnd.rim.cod'],
    ['coffee', 'text/coffeescript'],
    ['com', 'application/x-msdownload'],
    ['conf', 'text/plain'],
    ['cpio', 'application/x-cpio'],
    ['cpp', 'text/x-c'],
    ['cpt', 'application/mac-compactpro'],
    ['crd', 'application/x-mscardfile'],
    ['crl', 'application/pkix-crl'],
    ['crt', 'application/x-x509-ca-cert'],
    ['crx', 'application/x-chrome-extension'],
    ['cryptonote', 'application/vnd.rig.cryptonote'],
    ['csh', 'application/x-csh'],
    ['csl', 'application/vnd.citationstyles.style+xml'],
    ['csml', 'chemical/x-csml'],
    ['csp', 'application/vnd.commonspace'],
    ['csr', 'application/octet-stream'],
    ['css', 'text/css'],
    ['cst', 'application/x-director'],
    ['csv', 'text/csv'],
    ['cu', 'application/cu-seeme'],
    ['curl', 'text/vnd.curl'],
    ['cww', 'application/prs.cww'],
    ['cxt', 'application/x-director'],
    ['cxx', 'text/x-c'],
    ['dae', 'model/vnd.collada+xml'],
    ['daf', 'application/vnd.mobius.daf'],
    ['dart', 'application/vnd.dart'],
    ['dataless', 'application/vnd.fdsn.seed'],
    ['davmount', 'application/davmount+xml'],
    ['dbf', 'application/vnd.dbf'],
    ['dbk', 'application/docbook+xml'],
    ['dcr', 'application/x-director'],
    ['dcurl', 'text/vnd.curl.dcurl'],
    ['dd2', 'application/vnd.oma.dd2+xml'],
    ['ddd', 'application/vnd.fujixerox.ddd'],
    ['ddf', 'application/vnd.syncml.dmddf+xml'],
    ['dds', 'image/vnd.ms-dds'],
    ['deb', 'application/x-debian-package'],
    ['def', 'text/plain'],
    ['deploy', 'application/octet-stream'],
    ['der', 'application/x-x509-ca-cert'],
    ['dfac', 'application/vnd.dreamfactory'],
    ['dgc', 'application/x-dgc-compressed'],
    ['dic', 'text/x-c'],
    ['dir', 'application/x-director'],
    ['dis', 'application/vnd.mobius.dis'],
    ['disposition-notification', 'message/disposition-notification'],
    ['dist', 'application/octet-stream'],
    ['distz', 'application/octet-stream'],
    ['djv', 'image/vnd.djvu'],
    ['djvu', 'image/vnd.djvu'],
    ['dll', 'application/octet-stream'],
    ['dmg', 'application/x-apple-diskimage'],
    ['dmn', 'application/octet-stream'],
    ['dmp', 'application/vnd.tcpdump.pcap'],
    ['dms', 'application/octet-stream'],
    ['dna', 'application/vnd.dna'],
    ['doc', 'application/msword'],
    ['docm', 'application/vnd.ms-word.template.macroEnabled.12'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['dot', 'application/msword'],
    ['dotm', 'application/vnd.ms-word.template.macroEnabled.12'],
    ['dotx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.template'],
    ['dp', 'application/vnd.osgi.dp'],
    ['dpg', 'application/vnd.dpgraph'],
    ['dra', 'audio/vnd.dra'],
    ['drle', 'image/dicom-rle'],
    ['dsc', 'text/prs.lines.tag'],
    ['dssc', 'application/dssc+der'],
    ['dtb', 'application/x-dtbook+xml'],
    ['dtd', 'application/xml-dtd'],
    ['dts', 'audio/vnd.dts'],
    ['dtshd', 'audio/vnd.dts.hd'],
    ['dump', 'application/octet-stream'],
    ['dvb', 'video/vnd.dvb.file'],
    ['dvi', 'application/x-dvi'],
    ['dwd', 'application/atsc-dwd+xml'],
    ['dwf', 'model/vnd.dwf'],
    ['dwg', 'image/vnd.dwg'],
    ['dxf', 'image/vnd.dxf'],
    ['dxp', 'application/vnd.spotfire.dxp'],
    ['dxr', 'application/x-director'],
    ['ear', 'application/java-archive'],
    ['ecelp4800', 'audio/vnd.nuera.ecelp4800'],
    ['ecelp7470', 'audio/vnd.nuera.ecelp7470'],
    ['ecelp9600', 'audio/vnd.nuera.ecelp9600'],
    ['ecma', 'application/ecmascript'],
    ['edm', 'application/vnd.novadigm.edm'],
    ['edx', 'application/vnd.novadigm.edx'],
    ['efif', 'application/vnd.picsel'],
    ['ei6', 'application/vnd.pg.osasli'],
    ['elc', 'application/octet-stream'],
    ['emf', 'image/emf'],
    ['eml', 'message/rfc822'],
    ['emma', 'application/emma+xml'],
    ['emotionml', 'application/emotionml+xml'],
    ['emz', 'application/x-msmetafile'],
    ['eol', 'audio/vnd.digital-winds'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['eps', 'application/postscript'],
    ['epub', 'application/epub+zip'],
    ['es', 'application/ecmascript'],
    ['es3', 'application/vnd.eszigno3+xml'],
    ['esa', 'application/vnd.osgi.subsystem'],
    ['esf', 'application/vnd.epson.esf'],
    ['et3', 'application/vnd.eszigno3+xml'],
    ['etx', 'text/x-setext'],
    ['eva', 'application/x-eva'],
    ['evy', 'application/x-envoy'],
    ['exe', 'application/octet-stream'],
    ['exi', 'application/exi'],
    ['exp', 'application/express'],
    ['exr', 'image/aces'],
    ['ext', 'application/vnd.novadigm.ext'],
    ['ez', 'application/andrew-inset'],
    ['ez2', 'application/vnd.ezpix-album'],
    ['ez3', 'application/vnd.ezpix-package'],
    ['f', 'text/x-fortran'],
    ['f4v', 'video/mp4'],
    ['f77', 'text/x-fortran'],
    ['f90', 'text/x-fortran'],
    ['fbs', 'image/vnd.fastbidsheet'],
    ['fcdt', 'application/vnd.adobe.formscentral.fcdt'],
    ['fcs', 'application/vnd.isac.fcs'],
    ['fdf', 'application/vnd.fdf'],
    ['fdt', 'application/fdt+xml'],
    ['fe_launch', 'application/vnd.denovo.fcselayout-link'],
    ['fg5', 'application/vnd.fujitsu.oasysgp'],
    ['fgd', 'application/x-director'],
    ['fh', 'image/x-freehand'],
    ['fh4', 'image/x-freehand'],
    ['fh5', 'image/x-freehand'],
    ['fh7', 'image/x-freehand'],
    ['fhc', 'image/x-freehand'],
    ['fig', 'application/x-xfig'],
    ['fits', 'image/fits'],
    ['flac', 'audio/x-flac'],
    ['fli', 'video/x-fli'],
    ['flo', 'application/vnd.micrografx.flo'],
    ['flv', 'video/x-flv'],
    ['flw', 'application/vnd.kde.kivio'],
    ['flx', 'text/vnd.fmi.flexstor'],
    ['fly', 'text/vnd.fly'],
    ['fm', 'application/vnd.framemaker'],
    ['fnc', 'application/vnd.frogans.fnc'],
    ['fo', 'application/vnd.software602.filler.form+xml'],
    ['for', 'text/x-fortran'],
    ['fpx', 'image/vnd.fpx'],
    ['frame', 'application/vnd.framemaker'],
    ['fsc', 'application/vnd.fsc.weblaunch'],
    ['fst', 'image/vnd.fst'],
    ['ftc', 'application/vnd.fluxtime.clip'],
    ['fti', 'application/vnd.anser-web-funds-transfer-initiation'],
    ['fvt', 'video/vnd.fvt'],
    ['fxp', 'application/vnd.adobe.fxp'],
    ['fxpl', 'application/vnd.adobe.fxp'],
    ['fzs', 'application/vnd.fuzzysheet'],
    ['g2w', 'application/vnd.geoplan'],
    ['g3', 'image/g3fax'],
    ['g3w', 'application/vnd.geospace'],
    ['gac', 'application/vnd.groove-account'],
    ['gam', 'application/x-tads'],
    ['gbr', 'application/rpki-ghostbusters'],
    ['gca', 'application/x-gca-compressed'],
    ['gdl', 'model/vnd.gdl'],
    ['gdoc', 'application/vnd.google-apps.document'],
    ['geo', 'application/vnd.dynageo'],
    ['geojson', 'application/geo+json'],
    ['gex', 'application/vnd.geometry-explorer'],
    ['ggb', 'application/vnd.geogebra.file'],
    ['ggt', 'application/vnd.geogebra.tool'],
    ['ghf', 'application/vnd.groove-help'],
    ['gif', 'image/gif'],
    ['gim', 'application/vnd.groove-identity-message'],
    ['glb', 'model/gltf-binary'],
    ['gltf', 'model/gltf+json'],
    ['gml', 'application/gml+xml'],
    ['gmx', 'application/vnd.gmx'],
    ['gnumeric', 'application/x-gnumeric'],
    ['gpg', 'application/gpg-keys'],
    ['gph', 'application/vnd.flographit'],
    ['gpx', 'application/gpx+xml'],
    ['gqf', 'application/vnd.grafeq'],
    ['gqs', 'application/vnd.grafeq'],
    ['gram', 'application/srgs'],
    ['gramps', 'application/x-gramps-xml'],
    ['gre', 'application/vnd.geometry-explorer'],
    ['grv', 'application/vnd.groove-injector'],
    ['grxml', 'application/srgs+xml'],
    ['gsf', 'application/x-font-ghostscript'],
    ['gsheet', 'application/vnd.google-apps.spreadsheet'],
    ['gslides', 'application/vnd.google-apps.presentation'],
    ['gtar', 'application/x-gtar'],
    ['gtm', 'application/vnd.groove-tool-message'],
    ['gtw', 'model/vnd.gtw'],
    ['gv', 'text/vnd.graphviz'],
    ['gxf', 'application/gxf'],
    ['gxt', 'application/vnd.geonext'],
    ['gz', 'application/gzip'],
    ['gzip', 'application/gzip'],
    ['h', 'text/x-c'],
    ['h261', 'video/h261'],
    ['h263', 'video/h263'],
    ['h264', 'video/h264'],
    ['hal', 'application/vnd.hal+xml'],
    ['hbci', 'application/vnd.hbci'],
    ['hbs', 'text/x-handlebars-template'],
    ['hdd', 'application/x-virtualbox-hdd'],
    ['hdf', 'application/x-hdf'],
    ['heic', 'image/heic'],
    ['heics', 'image/heic-sequence'],
    ['heif', 'image/heif'],
    ['heifs', 'image/heif-sequence'],
    ['hej2', 'image/hej2k'],
    ['held', 'application/atsc-held+xml'],
    ['hh', 'text/x-c'],
    ['hjson', 'application/hjson'],
    ['hlp', 'application/winhlp'],
    ['hpgl', 'application/vnd.hp-hpgl'],
    ['hpid', 'application/vnd.hp-hpid'],
    ['hps', 'application/vnd.hp-hps'],
    ['hqx', 'application/mac-binhex40'],
    ['hsj2', 'image/hsj2'],
    ['htc', 'text/x-component'],
    ['htke', 'application/vnd.kenameaapp'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['hvd', 'application/vnd.yamaha.hv-dic'],
    ['hvp', 'application/vnd.yamaha.hv-voice'],
    ['hvs', 'application/vnd.yamaha.hv-script'],
    ['i2g', 'application/vnd.intergeo'],
    ['icc', 'application/vnd.iccprofile'],
    ['ice', 'x-conference/x-cooltalk'],
    ['icm', 'application/vnd.iccprofile'],
    ['ico', 'image/x-icon'],
    ['ics', 'text/calendar'],
    ['ief', 'image/ief'],
    ['ifb', 'text/calendar'],
    ['ifm', 'application/vnd.shana.informed.formdata'],
    ['iges', 'model/iges'],
    ['igl', 'application/vnd.igloader'],
    ['igm', 'application/vnd.insors.igm'],
    ['igs', 'model/iges'],
    ['igx', 'application/vnd.micrografx.igx'],
    ['iif', 'application/vnd.shana.informed.interchange'],
    ['img', 'application/octet-stream'],
    ['imp', 'application/vnd.accpac.simply.imp'],
    ['ims', 'application/vnd.ms-ims'],
    ['in', 'text/plain'],
    ['ini', 'text/plain'],
    ['ink', 'application/inkml+xml'],
    ['inkml', 'application/inkml+xml'],
    ['install', 'application/x-install-instructions'],
    ['iota', 'application/vnd.astraea-software.iota'],
    ['ipfix', 'application/ipfix'],
    ['ipk', 'application/vnd.shana.informed.package'],
    ['irm', 'application/vnd.ibm.rights-management'],
    ['irp', 'application/vnd.irepository.package+xml'],
    ['iso', 'application/x-iso9660-image'],
    ['itp', 'application/vnd.shana.informed.formtemplate'],
    ['its', 'application/its+xml'],
    ['ivp', 'application/vnd.immervision-ivp'],
    ['ivu', 'application/vnd.immervision-ivu'],
    ['jad', 'text/vnd.sun.j2me.app-descriptor'],
    ['jade', 'text/jade'],
    ['jam', 'application/vnd.jam'],
    ['jar', 'application/java-archive'],
    ['jardiff', 'application/x-java-archive-diff'],
    ['java', 'text/x-java-source'],
    ['jhc', 'image/jphc'],
    ['jisp', 'application/vnd.jisp'],
    ['jls', 'image/jls'],
    ['jlt', 'application/vnd.hp-jlyt'],
    ['jng', 'image/x-jng'],
    ['jnlp', 'application/x-java-jnlp-file'],
    ['joda', 'application/vnd.joost.joda-archive'],
    ['jp2', 'image/jp2'],
    ['jpe', 'image/jpeg'],
    ['jpeg', 'image/jpeg'],
    ['jpf', 'image/jpx'],
    ['jpg', 'image/jpeg'],
    ['jpg2', 'image/jp2'],
    ['jpgm', 'video/jpm'],
    ['jpgv', 'video/jpeg'],
    ['jph', 'image/jph'],
    ['jpm', 'video/jpm'],
    ['jpx', 'image/jpx'],
    ['js', 'application/javascript'],
    ['json', 'application/json'],
    ['json5', 'application/json5'],
    ['jsonld', 'application/ld+json'],
    // https://jsonlines.org/
    ['jsonl', 'application/jsonl'],
    ['jsonml', 'application/jsonml+json'],
    ['jsx', 'text/jsx'],
    ['jxr', 'image/jxr'],
    ['jxra', 'image/jxra'],
    ['jxrs', 'image/jxrs'],
    ['jxs', 'image/jxs'],
    ['jxsc', 'image/jxsc'],
    ['jxsi', 'image/jxsi'],
    ['jxss', 'image/jxss'],
    ['kar', 'audio/midi'],
    ['karbon', 'application/vnd.kde.karbon'],
    ['kdb', 'application/octet-stream'],
    ['kdbx', 'application/x-keepass2'],
    ['key', 'application/x-iwork-keynote-sffkey'],
    ['kfo', 'application/vnd.kde.kformula'],
    ['kia', 'application/vnd.kidspiration'],
    ['kml', 'application/vnd.google-earth.kml+xml'],
    ['kmz', 'application/vnd.google-earth.kmz'],
    ['kne', 'application/vnd.kinar'],
    ['knp', 'application/vnd.kinar'],
    ['kon', 'application/vnd.kde.kontour'],
    ['kpr', 'application/vnd.kde.kpresenter'],
    ['kpt', 'application/vnd.kde.kpresenter'],
    ['kpxx', 'application/vnd.ds-keypoint'],
    ['ksp', 'application/vnd.kde.kspread'],
    ['ktr', 'application/vnd.kahootz'],
    ['ktx', 'image/ktx'],
    ['ktx2', 'image/ktx2'],
    ['ktz', 'application/vnd.kahootz'],
    ['kwd', 'application/vnd.kde.kword'],
    ['kwt', 'application/vnd.kde.kword'],
    ['lasxml', 'application/vnd.las.las+xml'],
    ['latex', 'application/x-latex'],
    ['lbd', 'application/vnd.llamagraphics.life-balance.desktop'],
    ['lbe', 'application/vnd.llamagraphics.life-balance.exchange+xml'],
    ['les', 'application/vnd.hhe.lesson-player'],
    ['less', 'text/less'],
    ['lgr', 'application/lgr+xml'],
    ['lha', 'application/octet-stream'],
    ['link66', 'application/vnd.route66.link66+xml'],
    ['list', 'text/plain'],
    ['list3820', 'application/vnd.ibm.modcap'],
    ['listafp', 'application/vnd.ibm.modcap'],
    ['litcoffee', 'text/coffeescript'],
    ['lnk', 'application/x-ms-shortcut'],
    ['log', 'text/plain'],
    ['lostxml', 'application/lost+xml'],
    ['lrf', 'application/octet-stream'],
    ['lrm', 'application/vnd.ms-lrm'],
    ['ltf', 'application/vnd.frogans.ltf'],
    ['lua', 'text/x-lua'],
    ['luac', 'application/x-lua-bytecode'],
    ['lvp', 'audio/vnd.lucent.voice'],
    ['lwp', 'application/vnd.lotus-wordpro'],
    ['lzh', 'application/octet-stream'],
    ['m1v', 'video/mpeg'],
    ['m2a', 'audio/mpeg'],
    ['m2v', 'video/mpeg'],
    ['m3a', 'audio/mpeg'],
    ['m3u', 'text/plain'],
    ['m3u8', 'application/vnd.apple.mpegurl'],
    ['m4a', 'audio/x-m4a'],
    ['m4p', 'application/mp4'],
    ['m4s', 'video/iso.segment'],
    ['m4u', 'application/vnd.mpegurl'],
    ['m4v', 'video/x-m4v'],
    ['m13', 'application/x-msmediaview'],
    ['m14', 'application/x-msmediaview'],
    ['m21', 'application/mp21'],
    ['ma', 'application/mathematica'],
    ['mads', 'application/mads+xml'],
    ['maei', 'application/mmt-aei+xml'],
    ['mag', 'application/vnd.ecowin.chart'],
    ['maker', 'application/vnd.framemaker'],
    ['man', 'text/troff'],
    ['manifest', 'text/cache-manifest'],
    ['map', 'application/json'],
    ['mar', 'application/octet-stream'],
    ['markdown', 'text/markdown'],
    ['mathml', 'application/mathml+xml'],
    ['mb', 'application/mathematica'],
    ['mbk', 'application/vnd.mobius.mbk'],
    ['mbox', 'application/mbox'],
    ['mc1', 'application/vnd.medcalcdata'],
    ['mcd', 'application/vnd.mcd'],
    ['mcurl', 'text/vnd.curl.mcurl'],
    ['md', 'text/markdown'],
    ['mdb', 'application/x-msaccess'],
    ['mdi', 'image/vnd.ms-modi'],
    ['mdx', 'text/mdx'],
    ['me', 'text/troff'],
    ['mesh', 'model/mesh'],
    ['meta4', 'application/metalink4+xml'],
    ['metalink', 'application/metalink+xml'],
    ['mets', 'application/mets+xml'],
    ['mfm', 'application/vnd.mfmp'],
    ['mft', 'application/rpki-manifest'],
    ['mgp', 'application/vnd.osgeo.mapguide.package'],
    ['mgz', 'application/vnd.proteus.magazine'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mie', 'application/x-mie'],
    ['mif', 'application/vnd.mif'],
    ['mime', 'message/rfc822'],
    ['mj2', 'video/mj2'],
    ['mjp2', 'video/mj2'],
    ['mjs', 'application/javascript'],
    ['mk3d', 'video/x-matroska'],
    ['mka', 'audio/x-matroska'],
    ['mkd', 'text/x-markdown'],
    ['mks', 'video/x-matroska'],
    ['mkv', 'video/x-matroska'],
    ['mlp', 'application/vnd.dolby.mlp'],
    ['mmd', 'application/vnd.chipnuts.karaoke-mmd'],
    ['mmf', 'application/vnd.smaf'],
    ['mml', 'text/mathml'],
    ['mmr', 'image/vnd.fujixerox.edmics-mmr'],
    ['mng', 'video/x-mng'],
    ['mny', 'application/x-msmoney'],
    ['mobi', 'application/x-mobipocket-ebook'],
    ['mods', 'application/mods+xml'],
    ['mov', 'video/quicktime'],
    ['movie', 'video/x-sgi-movie'],
    ['mp2', 'audio/mpeg'],
    ['mp2a', 'audio/mpeg'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mp4a', 'audio/mp4'],
    ['mp4s', 'application/mp4'],
    ['mp4v', 'video/mp4'],
    ['mp21', 'application/mp21'],
    ['mpc', 'application/vnd.mophun.certificate'],
    ['mpd', 'application/dash+xml'],
    ['mpe', 'video/mpeg'],
    ['mpeg', 'video/mpeg'],
    ['mpg', 'video/mpeg'],
    ['mpg4', 'video/mp4'],
    ['mpga', 'audio/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['mpm', 'application/vnd.blueice.multipass'],
    ['mpn', 'application/vnd.mophun.application'],
    ['mpp', 'application/vnd.ms-project'],
    ['mpt', 'application/vnd.ms-project'],
    ['mpy', 'application/vnd.ibm.minipay'],
    ['mqy', 'application/vnd.mobius.mqy'],
    ['mrc', 'application/marc'],
    ['mrcx', 'application/marcxml+xml'],
    ['ms', 'text/troff'],
    ['mscml', 'application/mediaservercontrol+xml'],
    ['mseed', 'application/vnd.fdsn.mseed'],
    ['mseq', 'application/vnd.mseq'],
    ['msf', 'application/vnd.epson.msf'],
    ['msg', 'application/vnd.ms-outlook'],
    ['msh', 'model/mesh'],
    ['msi', 'application/x-msdownload'],
    ['msl', 'application/vnd.mobius.msl'],
    ['msm', 'application/octet-stream'],
    ['msp', 'application/octet-stream'],
    ['msty', 'application/vnd.muvee.style'],
    ['mtl', 'model/mtl'],
    ['mts', 'model/vnd.mts'],
    ['mus', 'application/vnd.musician'],
    ['musd', 'application/mmt-usd+xml'],
    ['musicxml', 'application/vnd.recordare.musicxml+xml'],
    ['mvb', 'application/x-msmediaview'],
    ['mvt', 'application/vnd.mapbox-vector-tile'],
    ['mwf', 'application/vnd.mfer'],
    ['mxf', 'application/mxf'],
    ['mxl', 'application/vnd.recordare.musicxml'],
    ['mxmf', 'audio/mobile-xmf'],
    ['mxml', 'application/xv+xml'],
    ['mxs', 'application/vnd.triscape.mxs'],
    ['mxu', 'video/vnd.mpegurl'],
    ['n-gage', 'application/vnd.nokia.n-gage.symbian.install'],
    ['n3', 'text/n3'],
    ['nb', 'application/mathematica'],
    ['nbp', 'application/vnd.wolfram.player'],
    ['nc', 'application/x-netcdf'],
    ['ncx', 'application/x-dtbncx+xml'],
    ['nfo', 'text/x-nfo'],
    ['ngdat', 'application/vnd.nokia.n-gage.data'],
    ['nitf', 'application/vnd.nitf'],
    ['nlu', 'application/vnd.neurolanguage.nlu'],
    ['nml', 'application/vnd.enliven'],
    ['nnd', 'application/vnd.noblenet-directory'],
    ['nns', 'application/vnd.noblenet-sealer'],
    ['nnw', 'application/vnd.noblenet-web'],
    ['npx', 'image/vnd.net-fpx'],
    ['nq', 'application/n-quads'],
    ['nsc', 'application/x-conference'],
    ['nsf', 'application/vnd.lotus-notes'],
    ['nt', 'application/n-triples'],
    ['ntf', 'application/vnd.nitf'],
    ['numbers', 'application/x-iwork-numbers-sffnumbers'],
    ['nzb', 'application/x-nzb'],
    ['oa2', 'application/vnd.fujitsu.oasys2'],
    ['oa3', 'application/vnd.fujitsu.oasys3'],
    ['oas', 'application/vnd.fujitsu.oasys'],
    ['obd', 'application/x-msbinder'],
    ['obgx', 'application/vnd.openblox.game+xml'],
    ['obj', 'model/obj'],
    ['oda', 'application/oda'],
    ['odb', 'application/vnd.oasis.opendocument.database'],
    ['odc', 'application/vnd.oasis.opendocument.chart'],
    ['odf', 'application/vnd.oasis.opendocument.formula'],
    ['odft', 'application/vnd.oasis.opendocument.formula-template'],
    ['odg', 'application/vnd.oasis.opendocument.graphics'],
    ['odi', 'application/vnd.oasis.opendocument.image'],
    ['odm', 'application/vnd.oasis.opendocument.text-master'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogex', 'model/vnd.opengex'],
    ['ogg', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['omdoc', 'application/omdoc+xml'],
    ['onepkg', 'application/onenote'],
    ['onetmp', 'application/onenote'],
    ['onetoc', 'application/onenote'],
    ['onetoc2', 'application/onenote'],
    ['opf', 'application/oebps-package+xml'],
    ['opml', 'text/x-opml'],
    ['oprc', 'application/vnd.palm'],
    ['opus', 'audio/ogg'],
    ['org', 'text/x-org'],
    ['osf', 'application/vnd.yamaha.openscoreformat'],
    ['osfpvg', 'application/vnd.yamaha.openscoreformat.osfpvg+xml'],
    ['osm', 'application/vnd.openstreetmap.data+xml'],
    ['otc', 'application/vnd.oasis.opendocument.chart-template'],
    ['otf', 'font/otf'],
    ['otg', 'application/vnd.oasis.opendocument.graphics-template'],
    ['oth', 'application/vnd.oasis.opendocument.text-web'],
    ['oti', 'application/vnd.oasis.opendocument.image-template'],
    ['otp', 'application/vnd.oasis.opendocument.presentation-template'],
    ['ots', 'application/vnd.oasis.opendocument.spreadsheet-template'],
    ['ott', 'application/vnd.oasis.opendocument.text-template'],
    ['ova', 'application/x-virtualbox-ova'],
    ['ovf', 'application/x-virtualbox-ovf'],
    ['owl', 'application/rdf+xml'],
    ['oxps', 'application/oxps'],
    ['oxt', 'application/vnd.openofficeorg.extension'],
    ['p', 'text/x-pascal'],
    ['p7a', 'application/x-pkcs7-signature'],
    ['p7b', 'application/x-pkcs7-certificates'],
    ['p7c', 'application/pkcs7-mime'],
    ['p7m', 'application/pkcs7-mime'],
    ['p7r', 'application/x-pkcs7-certreqresp'],
    ['p7s', 'application/pkcs7-signature'],
    ['p8', 'application/pkcs8'],
    ['p10', 'application/x-pkcs10'],
    ['p12', 'application/x-pkcs12'],
    ['pac', 'application/x-ns-proxy-autoconfig'],
    ['pages', 'application/x-iwork-pages-sffpages'],
    ['pas', 'text/x-pascal'],
    ['paw', 'application/vnd.pawaafile'],
    ['pbd', 'application/vnd.powerbuilder6'],
    ['pbm', 'image/x-portable-bitmap'],
    ['pcap', 'application/vnd.tcpdump.pcap'],
    ['pcf', 'application/x-font-pcf'],
    ['pcl', 'application/vnd.hp-pcl'],
    ['pclxl', 'application/vnd.hp-pclxl'],
    ['pct', 'image/x-pict'],
    ['pcurl', 'application/vnd.curl.pcurl'],
    ['pcx', 'image/x-pcx'],
    ['pdb', 'application/x-pilot'],
    ['pde', 'text/x-processing'],
    ['pdf', 'application/pdf'],
    ['pem', 'application/x-x509-user-cert'],
    ['pfa', 'application/x-font-type1'],
    ['pfb', 'application/x-font-type1'],
    ['pfm', 'application/x-font-type1'],
    ['pfr', 'application/font-tdpfr'],
    ['pfx', 'application/x-pkcs12'],
    ['pgm', 'image/x-portable-graymap'],
    ['pgn', 'application/x-chess-pgn'],
    ['pgp', 'application/pgp'],
    ['php', 'application/x-httpd-php'],
    ['php3', 'application/x-httpd-php'],
    ['php4', 'application/x-httpd-php'],
    ['phps', 'application/x-httpd-php-source'],
    ['phtml', 'application/x-httpd-php'],
    ['pic', 'image/x-pict'],
    ['pkg', 'application/octet-stream'],
    ['pki', 'application/pkixcmp'],
    ['pkipath', 'application/pkix-pkipath'],
    ['pkpass', 'application/vnd.apple.pkpass'],
    ['pl', 'application/x-perl'],
    ['plb', 'application/vnd.3gpp.pic-bw-large'],
    ['plc', 'application/vnd.mobius.plc'],
    ['plf', 'application/vnd.pocketlearn'],
    ['pls', 'application/pls+xml'],
    ['pm', 'application/x-perl'],
    ['pml', 'application/vnd.ctc-posml'],
    ['png', 'image/png'],
    ['pnm', 'image/x-portable-anymap'],
    ['portpkg', 'application/vnd.macports.portpkg'],
    ['pot', 'application/vnd.ms-powerpoint'],
    ['potm', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
    ['potx', 'application/vnd.openxmlformats-officedocument.presentationml.template'],
    ['ppa', 'application/vnd.ms-powerpoint'],
    ['ppam', 'application/vnd.ms-powerpoint.addin.macroEnabled.12'],
    ['ppd', 'application/vnd.cups-ppd'],
    ['ppm', 'image/x-portable-pixmap'],
    ['pps', 'application/vnd.ms-powerpoint'],
    ['ppsm', 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'],
    ['ppsx', 'application/vnd.openxmlformats-officedocument.presentationml.slideshow'],
    ['ppt', 'application/powerpoint'],
    ['pptm', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['pqa', 'application/vnd.palm'],
    ['prc', 'application/x-pilot'],
    ['pre', 'application/vnd.lotus-freelance'],
    ['prf', 'application/pics-rules'],
    ['provx', 'application/provenance+xml'],
    ['ps', 'application/postscript'],
    ['psb', 'application/vnd.3gpp.pic-bw-small'],
    ['psd', 'application/x-photoshop'],
    ['psf', 'application/x-font-linux-psf'],
    ['pskcxml', 'application/pskc+xml'],
    ['pti', 'image/prs.pti'],
    ['ptid', 'application/vnd.pvi.ptid1'],
    ['pub', 'application/x-mspublisher'],
    ['pvb', 'application/vnd.3gpp.pic-bw-var'],
    ['pwn', 'application/vnd.3m.post-it-notes'],
    ['pya', 'audio/vnd.ms-playready.media.pya'],
    ['pyv', 'video/vnd.ms-playready.media.pyv'],
    ['qam', 'application/vnd.epson.quickanime'],
    ['qbo', 'application/vnd.intu.qbo'],
    ['qfx', 'application/vnd.intu.qfx'],
    ['qps', 'application/vnd.publishare-delta-tree'],
    ['qt', 'video/quicktime'],
    ['qwd', 'application/vnd.quark.quarkxpress'],
    ['qwt', 'application/vnd.quark.quarkxpress'],
    ['qxb', 'application/vnd.quark.quarkxpress'],
    ['qxd', 'application/vnd.quark.quarkxpress'],
    ['qxl', 'application/vnd.quark.quarkxpress'],
    ['qxt', 'application/vnd.quark.quarkxpress'],
    ['ra', 'audio/x-realaudio'],
    ['ram', 'audio/x-pn-realaudio'],
    ['raml', 'application/raml+yaml'],
    ['rapd', 'application/route-apd+xml'],
    ['rar', 'application/x-rar'],
    ['ras', 'image/x-cmu-raster'],
    ['rcprofile', 'application/vnd.ipunplugged.rcprofile'],
    ['rdf', 'application/rdf+xml'],
    ['rdz', 'application/vnd.data-vision.rdz'],
    ['relo', 'application/p2p-overlay+xml'],
    ['rep', 'application/vnd.businessobjects'],
    ['res', 'application/x-dtbresource+xml'],
    ['rgb', 'image/x-rgb'],
    ['rif', 'application/reginfo+xml'],
    ['rip', 'audio/vnd.rip'],
    ['ris', 'application/x-research-info-systems'],
    ['rl', 'application/resource-lists+xml'],
    ['rlc', 'image/vnd.fujixerox.edmics-rlc'],
    ['rld', 'application/resource-lists-diff+xml'],
    ['rm', 'audio/x-pn-realaudio'],
    ['rmi', 'audio/midi'],
    ['rmp', 'audio/x-pn-realaudio-plugin'],
    ['rms', 'application/vnd.jcp.javame.midlet-rms'],
    ['rmvb', 'application/vnd.rn-realmedia-vbr'],
    ['rnc', 'application/relax-ng-compact-syntax'],
    ['rng', 'application/xml'],
    ['roa', 'application/rpki-roa'],
    ['roff', 'text/troff'],
    ['rp9', 'application/vnd.cloanto.rp9'],
    ['rpm', 'audio/x-pn-realaudio-plugin'],
    ['rpss', 'application/vnd.nokia.radio-presets'],
    ['rpst', 'application/vnd.nokia.radio-preset'],
    ['rq', 'application/sparql-query'],
    ['rs', 'application/rls-services+xml'],
    ['rsa', 'application/x-pkcs7'],
    ['rsat', 'application/atsc-rsat+xml'],
    ['rsd', 'application/rsd+xml'],
    ['rsheet', 'application/urc-ressheet+xml'],
    ['rss', 'application/rss+xml'],
    ['rtf', 'text/rtf'],
    ['rtx', 'text/richtext'],
    ['run', 'application/x-makeself'],
    ['rusd', 'application/route-usd+xml'],
    ['rv', 'video/vnd.rn-realvideo'],
    ['s', 'text/x-asm'],
    ['s3m', 'audio/s3m'],
    ['saf', 'application/vnd.yamaha.smaf-audio'],
    ['sass', 'text/x-sass'],
    ['sbml', 'application/sbml+xml'],
    ['sc', 'application/vnd.ibm.secure-container'],
    ['scd', 'application/x-msschedule'],
    ['scm', 'application/vnd.lotus-screencam'],
    ['scq', 'application/scvp-cv-request'],
    ['scs', 'application/scvp-cv-response'],
    ['scss', 'text/x-scss'],
    ['scurl', 'text/vnd.curl.scurl'],
    ['sda', 'application/vnd.stardivision.draw'],
    ['sdc', 'application/vnd.stardivision.calc'],
    ['sdd', 'application/vnd.stardivision.impress'],
    ['sdkd', 'application/vnd.solent.sdkm+xml'],
    ['sdkm', 'application/vnd.solent.sdkm+xml'],
    ['sdp', 'application/sdp'],
    ['sdw', 'application/vnd.stardivision.writer'],
    ['sea', 'application/octet-stream'],
    ['see', 'application/vnd.seemail'],
    ['seed', 'application/vnd.fdsn.seed'],
    ['sema', 'application/vnd.sema'],
    ['semd', 'application/vnd.semd'],
    ['semf', 'application/vnd.semf'],
    ['senmlx', 'application/senml+xml'],
    ['sensmlx', 'application/sensml+xml'],
    ['ser', 'application/java-serialized-object'],
    ['setpay', 'application/set-payment-initiation'],
    ['setreg', 'application/set-registration-initiation'],
    ['sfd-hdstx', 'application/vnd.hydrostatix.sof-data'],
    ['sfs', 'application/vnd.spotfire.sfs'],
    ['sfv', 'text/x-sfv'],
    ['sgi', 'image/sgi'],
    ['sgl', 'application/vnd.stardivision.writer-global'],
    ['sgm', 'text/sgml'],
    ['sgml', 'text/sgml'],
    ['sh', 'application/x-sh'],
    ['shar', 'application/x-shar'],
    ['shex', 'text/shex'],
    ['shf', 'application/shf+xml'],
    ['shtml', 'text/html'],
    ['sid', 'image/x-mrsid-image'],
    ['sieve', 'application/sieve'],
    ['sig', 'application/pgp-signature'],
    ['sil', 'audio/silk'],
    ['silo', 'model/mesh'],
    ['sis', 'application/vnd.symbian.install'],
    ['sisx', 'application/vnd.symbian.install'],
    ['sit', 'application/x-stuffit'],
    ['sitx', 'application/x-stuffitx'],
    ['siv', 'application/sieve'],
    ['skd', 'application/vnd.koan'],
    ['skm', 'application/vnd.koan'],
    ['skp', 'application/vnd.koan'],
    ['skt', 'application/vnd.koan'],
    ['sldm', 'application/vnd.ms-powerpoint.slide.macroenabled.12'],
    ['sldx', 'application/vnd.openxmlformats-officedocument.presentationml.slide'],
    ['slim', 'text/slim'],
    ['slm', 'text/slim'],
    ['sls', 'application/route-s-tsid+xml'],
    ['slt', 'application/vnd.epson.salt'],
    ['sm', 'application/vnd.stepmania.stepchart'],
    ['smf', 'application/vnd.stardivision.math'],
    ['smi', 'application/smil'],
    ['smil', 'application/smil'],
    ['smv', 'video/x-smv'],
    ['smzip', 'application/vnd.stepmania.package'],
    ['snd', 'audio/basic'],
    ['snf', 'application/x-font-snf'],
    ['so', 'application/octet-stream'],
    ['spc', 'application/x-pkcs7-certificates'],
    ['spdx', 'text/spdx'],
    ['spf', 'application/vnd.yamaha.smaf-phrase'],
    ['spl', 'application/x-futuresplash'],
    ['spot', 'text/vnd.in3d.spot'],
    ['spp', 'application/scvp-vp-response'],
    ['spq', 'application/scvp-vp-request'],
    ['spx', 'audio/ogg'],
    ['sql', 'application/x-sql'],
    ['src', 'application/x-wais-source'],
    ['srt', 'application/x-subrip'],
    ['sru', 'application/sru+xml'],
    ['srx', 'application/sparql-results+xml'],
    ['ssdl', 'application/ssdl+xml'],
    ['sse', 'application/vnd.kodak-descriptor'],
    ['ssf', 'application/vnd.epson.ssf'],
    ['ssml', 'application/ssml+xml'],
    ['sst', 'application/octet-stream'],
    ['st', 'application/vnd.sailingtracker.track'],
    ['stc', 'application/vnd.sun.xml.calc.template'],
    ['std', 'application/vnd.sun.xml.draw.template'],
    ['stf', 'application/vnd.wt.stf'],
    ['sti', 'application/vnd.sun.xml.impress.template'],
    ['stk', 'application/hyperstudio'],
    ['stl', 'model/stl'],
    ['stpx', 'model/step+xml'],
    ['stpxz', 'model/step-xml+zip'],
    ['stpz', 'model/step+zip'],
    ['str', 'application/vnd.pg.format'],
    ['stw', 'application/vnd.sun.xml.writer.template'],
    ['styl', 'text/stylus'],
    ['stylus', 'text/stylus'],
    ['sub', 'text/vnd.dvb.subtitle'],
    ['sus', 'application/vnd.sus-calendar'],
    ['susp', 'application/vnd.sus-calendar'],
    ['sv4cpio', 'application/x-sv4cpio'],
    ['sv4crc', 'application/x-sv4crc'],
    ['svc', 'application/vnd.dvb.service'],
    ['svd', 'application/vnd.svd'],
    ['svg', 'image/svg+xml'],
    ['svgz', 'image/svg+xml'],
    ['swa', 'application/x-director'],
    ['swf', 'application/x-shockwave-flash'],
    ['swi', 'application/vnd.aristanetworks.swi'],
    ['swidtag', 'application/swid+xml'],
    ['sxc', 'application/vnd.sun.xml.calc'],
    ['sxd', 'application/vnd.sun.xml.draw'],
    ['sxg', 'application/vnd.sun.xml.writer.global'],
    ['sxi', 'application/vnd.sun.xml.impress'],
    ['sxm', 'application/vnd.sun.xml.math'],
    ['sxw', 'application/vnd.sun.xml.writer'],
    ['t', 'text/troff'],
    ['t3', 'application/x-t3vm-image'],
    ['t38', 'image/t38'],
    ['taglet', 'application/vnd.mynfc'],
    ['tao', 'application/vnd.tao.intent-module-archive'],
    ['tap', 'image/vnd.tencent.tap'],
    ['tar', 'application/x-tar'],
    ['tcap', 'application/vnd.3gpp2.tcap'],
    ['tcl', 'application/x-tcl'],
    ['td', 'application/urc-targetdesc+xml'],
    ['teacher', 'application/vnd.smart.teacher'],
    ['tei', 'application/tei+xml'],
    ['teicorpus', 'application/tei+xml'],
    ['tex', 'application/x-tex'],
    ['texi', 'application/x-texinfo'],
    ['texinfo', 'application/x-texinfo'],
    ['text', 'text/plain'],
    ['tfi', 'application/thraud+xml'],
    ['tfm', 'application/x-tex-tfm'],
    ['tfx', 'image/tiff-fx'],
    ['tga', 'image/x-tga'],
    ['tgz', 'application/x-tar'],
    ['thmx', 'application/vnd.ms-officetheme'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['tk', 'application/x-tcl'],
    ['tmo', 'application/vnd.tmobile-livetv'],
    ['toml', 'application/toml'],
    ['torrent', 'application/x-bittorrent'],
    ['tpl', 'application/vnd.groove-tool-template'],
    ['tpt', 'application/vnd.trid.tpt'],
    ['tr', 'text/troff'],
    ['tra', 'application/vnd.trueapp'],
    ['trig', 'application/trig'],
    ['trm', 'application/x-msterminal'],
    ['ts', 'video/mp2t'],
    ['tsd', 'application/timestamped-data'],
    ['tsv', 'text/tab-separated-values'],
    ['ttc', 'font/collection'],
    ['ttf', 'font/ttf'],
    ['ttl', 'text/turtle'],
    ['ttml', 'application/ttml+xml'],
    ['twd', 'application/vnd.simtech-mindmapper'],
    ['twds', 'application/vnd.simtech-mindmapper'],
    ['txd', 'application/vnd.genomatix.tuxedo'],
    ['txf', 'application/vnd.mobius.txf'],
    ['txt', 'text/plain'],
    ['u8dsn', 'message/global-delivery-status'],
    ['u8hdr', 'message/global-headers'],
    ['u8mdn', 'message/global-disposition-notification'],
    ['u8msg', 'message/global'],
    ['u32', 'application/x-authorware-bin'],
    ['ubj', 'application/ubjson'],
    ['udeb', 'application/x-debian-package'],
    ['ufd', 'application/vnd.ufdl'],
    ['ufdl', 'application/vnd.ufdl'],
    ['ulx', 'application/x-glulx'],
    ['umj', 'application/vnd.umajin'],
    ['unityweb', 'application/vnd.unity'],
    ['uoml', 'application/vnd.uoml+xml'],
    ['uri', 'text/uri-list'],
    ['uris', 'text/uri-list'],
    ['urls', 'text/uri-list'],
    ['usdz', 'model/vnd.usdz+zip'],
    ['ustar', 'application/x-ustar'],
    ['utz', 'application/vnd.uiq.theme'],
    ['uu', 'text/x-uuencode'],
    ['uva', 'audio/vnd.dece.audio'],
    ['uvd', 'application/vnd.dece.data'],
    ['uvf', 'application/vnd.dece.data'],
    ['uvg', 'image/vnd.dece.graphic'],
    ['uvh', 'video/vnd.dece.hd'],
    ['uvi', 'image/vnd.dece.graphic'],
    ['uvm', 'video/vnd.dece.mobile'],
    ['uvp', 'video/vnd.dece.pd'],
    ['uvs', 'video/vnd.dece.sd'],
    ['uvt', 'application/vnd.dece.ttml+xml'],
    ['uvu', 'video/vnd.uvvu.mp4'],
    ['uvv', 'video/vnd.dece.video'],
    ['uvva', 'audio/vnd.dece.audio'],
    ['uvvd', 'application/vnd.dece.data'],
    ['uvvf', 'application/vnd.dece.data'],
    ['uvvg', 'image/vnd.dece.graphic'],
    ['uvvh', 'video/vnd.dece.hd'],
    ['uvvi', 'image/vnd.dece.graphic'],
    ['uvvm', 'video/vnd.dece.mobile'],
    ['uvvp', 'video/vnd.dece.pd'],
    ['uvvs', 'video/vnd.dece.sd'],
    ['uvvt', 'application/vnd.dece.ttml+xml'],
    ['uvvu', 'video/vnd.uvvu.mp4'],
    ['uvvv', 'video/vnd.dece.video'],
    ['uvvx', 'application/vnd.dece.unspecified'],
    ['uvvz', 'application/vnd.dece.zip'],
    ['uvx', 'application/vnd.dece.unspecified'],
    ['uvz', 'application/vnd.dece.zip'],
    ['vbox', 'application/x-virtualbox-vbox'],
    ['vbox-extpack', 'application/x-virtualbox-vbox-extpack'],
    ['vcard', 'text/vcard'],
    ['vcd', 'application/x-cdlink'],
    ['vcf', 'text/x-vcard'],
    ['vcg', 'application/vnd.groove-vcard'],
    ['vcs', 'text/x-vcalendar'],
    ['vcx', 'application/vnd.vcx'],
    ['vdi', 'application/x-virtualbox-vdi'],
    ['vds', 'model/vnd.sap.vds'],
    ['vhd', 'application/x-virtualbox-vhd'],
    ['vis', 'application/vnd.visionary'],
    ['viv', 'video/vnd.vivo'],
    ['vlc', 'application/videolan'],
    ['vmdk', 'application/x-virtualbox-vmdk'],
    ['vob', 'video/x-ms-vob'],
    ['vor', 'application/vnd.stardivision.writer'],
    ['vox', 'application/x-authorware-bin'],
    ['vrml', 'model/vrml'],
    ['vsd', 'application/vnd.visio'],
    ['vsf', 'application/vnd.vsf'],
    ['vss', 'application/vnd.visio'],
    ['vst', 'application/vnd.visio'],
    ['vsw', 'application/vnd.visio'],
    ['vtf', 'image/vnd.valve.source.texture'],
    ['vtt', 'text/vtt'],
    ['vtu', 'model/vnd.vtu'],
    ['vxml', 'application/voicexml+xml'],
    ['w3d', 'application/x-director'],
    ['wad', 'application/x-doom'],
    ['wadl', 'application/vnd.sun.wadl+xml'],
    ['war', 'application/java-archive'],
    ['wasm', 'application/wasm'],
    ['wav', 'audio/x-wav'],
    ['wax', 'audio/x-ms-wax'],
    ['wbmp', 'image/vnd.wap.wbmp'],
    ['wbs', 'application/vnd.criticaltools.wbs+xml'],
    ['wbxml', 'application/wbxml'],
    ['wcm', 'application/vnd.ms-works'],
    ['wdb', 'application/vnd.ms-works'],
    ['wdp', 'image/vnd.ms-photo'],
    ['weba', 'audio/webm'],
    ['webapp', 'application/x-web-app-manifest+json'],
    ['webm', 'video/webm'],
    ['webmanifest', 'application/manifest+json'],
    ['webp', 'image/webp'],
    ['wg', 'application/vnd.pmi.widget'],
    ['wgt', 'application/widget'],
    ['wks', 'application/vnd.ms-works'],
    ['wm', 'video/x-ms-wm'],
    ['wma', 'audio/x-ms-wma'],
    ['wmd', 'application/x-ms-wmd'],
    ['wmf', 'image/wmf'],
    ['wml', 'text/vnd.wap.wml'],
    ['wmlc', 'application/wmlc'],
    ['wmls', 'text/vnd.wap.wmlscript'],
    ['wmlsc', 'application/vnd.wap.wmlscriptc'],
    ['wmv', 'video/x-ms-wmv'],
    ['wmx', 'video/x-ms-wmx'],
    ['wmz', 'application/x-msmetafile'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['word', 'application/msword'],
    ['wpd', 'application/vnd.wordperfect'],
    ['wpl', 'application/vnd.ms-wpl'],
    ['wps', 'application/vnd.ms-works'],
    ['wqd', 'application/vnd.wqd'],
    ['wri', 'application/x-mswrite'],
    ['wrl', 'model/vrml'],
    ['wsc', 'message/vnd.wfa.wsc'],
    ['wsdl', 'application/wsdl+xml'],
    ['wspolicy', 'application/wspolicy+xml'],
    ['wtb', 'application/vnd.webturbo'],
    ['wvx', 'video/x-ms-wvx'],
    ['x3d', 'model/x3d+xml'],
    ['x3db', 'model/x3d+fastinfoset'],
    ['x3dbz', 'model/x3d+binary'],
    ['x3dv', 'model/x3d-vrml'],
    ['x3dvz', 'model/x3d+vrml'],
    ['x3dz', 'model/x3d+xml'],
    ['x32', 'application/x-authorware-bin'],
    ['x_b', 'model/vnd.parasolid.transmit.binary'],
    ['x_t', 'model/vnd.parasolid.transmit.text'],
    ['xaml', 'application/xaml+xml'],
    ['xap', 'application/x-silverlight-app'],
    ['xar', 'application/vnd.xara'],
    ['xav', 'application/xcap-att+xml'],
    ['xbap', 'application/x-ms-xbap'],
    ['xbd', 'application/vnd.fujixerox.docuworks.binder'],
    ['xbm', 'image/x-xbitmap'],
    ['xca', 'application/xcap-caps+xml'],
    ['xcs', 'application/calendar+xml'],
    ['xdf', 'application/xcap-diff+xml'],
    ['xdm', 'application/vnd.syncml.dm+xml'],
    ['xdp', 'application/vnd.adobe.xdp+xml'],
    ['xdssc', 'application/dssc+xml'],
    ['xdw', 'application/vnd.fujixerox.docuworks'],
    ['xel', 'application/xcap-el+xml'],
    ['xenc', 'application/xenc+xml'],
    ['xer', 'application/patch-ops-error+xml'],
    ['xfdf', 'application/vnd.adobe.xfdf'],
    ['xfdl', 'application/vnd.xfdl'],
    ['xht', 'application/xhtml+xml'],
    ['xhtml', 'application/xhtml+xml'],
    ['xhvml', 'application/xv+xml'],
    ['xif', 'image/vnd.xiff'],
    ['xl', 'application/excel'],
    ['xla', 'application/vnd.ms-excel'],
    ['xlam', 'application/vnd.ms-excel.addin.macroEnabled.12'],
    ['xlc', 'application/vnd.ms-excel'],
    ['xlf', 'application/xliff+xml'],
    ['xlm', 'application/vnd.ms-excel'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsb', 'application/vnd.ms-excel.sheet.binary.macroEnabled.12'],
    ['xlsm', 'application/vnd.ms-excel.sheet.macroEnabled.12'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xlt', 'application/vnd.ms-excel'],
    ['xltm', 'application/vnd.ms-excel.template.macroEnabled.12'],
    ['xltx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'],
    ['xlw', 'application/vnd.ms-excel'],
    ['xm', 'audio/xm'],
    ['xml', 'application/xml'],
    ['xns', 'application/xcap-ns+xml'],
    ['xo', 'application/vnd.olpc-sugar'],
    ['xop', 'application/xop+xml'],
    ['xpi', 'application/x-xpinstall'],
    ['xpl', 'application/xproc+xml'],
    ['xpm', 'image/x-xpixmap'],
    ['xpr', 'application/vnd.is-xpr'],
    ['xps', 'application/vnd.ms-xpsdocument'],
    ['xpw', 'application/vnd.intercon.formnet'],
    ['xpx', 'application/vnd.intercon.formnet'],
    ['xsd', 'application/xml'],
    ['xsl', 'application/xml'],
    ['xslt', 'application/xslt+xml'],
    ['xsm', 'application/vnd.syncml+xml'],
    ['xspf', 'application/xspf+xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['xvm', 'application/xv+xml'],
    ['xvml', 'application/xv+xml'],
    ['xwd', 'image/x-xwindowdump'],
    ['xyz', 'chemical/x-xyz'],
    ['xz', 'application/x-xz'],
    ['yaml', 'text/yaml'],
    ['yang', 'application/yang'],
    ['yin', 'application/yin+xml'],
    ['yml', 'text/yaml'],
    ['ymp', 'text/x-suse-ymp'],
    ['z', 'application/x-compress'],
    ['z1', 'application/x-zmachine'],
    ['z2', 'application/x-zmachine'],
    ['z3', 'application/x-zmachine'],
    ['z4', 'application/x-zmachine'],
    ['z5', 'application/x-zmachine'],
    ['z6', 'application/x-zmachine'],
    ['z7', 'application/x-zmachine'],
    ['z8', 'application/x-zmachine'],
    ['zaz', 'application/vnd.zzazz.deck+xml'],
    ['zip', 'application/zip'],
    ['zir', 'application/vnd.zul'],
    ['zirz', 'application/vnd.zul'],
    ['zmm', 'application/vnd.handheld-entertainment+xml'],
    ['zsh', 'text/x-scriptzsh']
]);
function toFileWithPath(file, path, h) {
    const f = withMimeType(file);
    const { webkitRelativePath } = file;
    const p = typeof path === 'string'
        ? path
        // If <input webkitdirectory> is set,
        // the File will have a {webkitRelativePath} property
        // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
        : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
            ? webkitRelativePath
            : `./${file.name}`;
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        setObjProp(f, 'path', p);
    }
    if (h !== undefined) {
        Object.defineProperty(f, 'handle', {
            value: h,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    // Always populate a relative path so that even electron apps have access to a relativePath value
    setObjProp(f, 'relativePath', p);
    return f;
}
function withMimeType(file) {
    const { name } = file;
    const hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        const ext = name.split('.')
            .pop().toLowerCase();
        const type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}
function setObjProp(f, key, value) {
    Object.defineProperty(f, key, {
        value,
        writable: false,
        configurable: false,
        enumerable: true
    });
}

const FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store', // macOs
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function* () {
        if (isObject$1(evt) && isDataTransfer(evt.dataTransfer)) {
            return getDataTransferFiles(evt.dataTransfer, evt.type);
        }
        else if (isChangeEvt(evt)) {
            return getInputFiles(evt);
        }
        else if (Array.isArray(evt) && evt.every(item => 'getFile' in item && typeof item.getFile === 'function')) {
            return getFsHandleFiles(evt);
        }
        return [];
    });
}
function isDataTransfer(value) {
    return isObject$1(value);
}
function isChangeEvt(value) {
    return isObject$1(value) && isObject$1(value.target);
}
function isObject$1(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(file => toFileWithPath(file));
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function* () {
        const files = yield Promise.all(handles.map(h => h.getFile()));
        return files.map(file => toFileWithPath(file));
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function* () {
        // IE11 does not support dataTransfer.items
        // See https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/items#Browser_compatibility
        if (dt.items) {
            const items = fromList(dt.items)
                .filter(item => item.kind === 'file');
            // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
            // only 'dragstart' and 'drop' has access to the data (source node)
            if (type !== 'drop') {
                return items;
            }
            const files = yield Promise.all(items.map(toFilePromises));
            return noIgnoredFiles(flatten(files));
        }
        return noIgnoredFiles(fromList(dt.files)
            .map(file => toFileWithPath(file)));
    });
}
function noIgnoredFiles(files) {
    return files.filter(file => FILES_TO_IGNORE.indexOf(file.name) === -1);
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    const files = [];
    // tslint:disable: prefer-for-of
    for (let i = 0; i < items.length; i++) {
        const file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    const entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item, entry);
}
function flatten(items) {
    return items.reduce((acc, files) => [
        ...acc,
        ...(Array.isArray(files) ? flatten(files) : [files])
    ], []);
}
function fromDataTransferItem(item, entry) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        // Check if we're in a secure context; due to a bug in Chrome (as far as we know)
        // the browser crashes when calling this API (yet to be confirmed as a consistent behaviour).
        //
        // See:
        // - https://issues.chromium.org/issues/40186242
        // - https://github.com/react-dropzone/react-dropzone/issues/1397
        if (globalThis.isSecureContext && typeof item.getAsFileSystemHandle === 'function') {
            const h = yield item.getAsFileSystemHandle();
            if (h === null) {
                throw new Error(`${item} is not a File`);
            }
            // It seems that the handle can be `undefined` (see https://github.com/react-dropzone/file-selector/issues/120),
            // so we check if it isn't; if it is, the code path continues to the next API (`getAsFile`).
            if (h !== undefined) {
                const file = yield h.getFile();
                file.handle = h;
                return toFileWithPath(file);
            }
        }
        const file = item.getAsFile();
        if (!file) {
            throw new Error(`${item} is not a File`);
        }
        const fwp = toFileWithPath(file, (_a = entry === null || entry === void 0 ? void 0 : entry.fullPath) !== null && _a !== void 0 ? _a : undefined);
        return fwp;
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function* () {
        return entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry);
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    const reader = entry.createReader();
    return new Promise((resolve, reject) => {
        const entries = [];
        function readEntries() {
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries((batch) => __awaiter(this, void 0, void 0, function* () {
                if (!batch.length) {
                    // Done reading directory
                    try {
                        const files = yield Promise.all(entries);
                        resolve(files);
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    const items = Promise.all(batch.map(fromEntry));
                    entries.push(items);
                    // Continue reading
                    readEntries();
                }
            }), (err) => {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            entry.file((file) => {
                const fwp = toFileWithPath(file, entry.fullPath);
                resolve(fwp);
            }, (err) => {
                reject(err);
            });
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');

    if (acceptedFilesArray.length === 0) {
      return true;
    }

    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$2(arr); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }
var accepts = typeof _default === "function" ? _default : _default.default; // Error codes

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";
/**
 *
 * @param {string} accept
 */

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr() {
  var accept = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var acceptArr = accept.split(",");
  var msg = acceptArr.length > 1 ? "one of ".concat(acceptArr.join(", ")) : acceptArr[0];
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(msg)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
};
/**
 * Check if the given file is a DataTransferItem with an empty type.
 *
 * During drag events, browsers may return DataTransferItem objects instead of File objects.
 * Some browsers (e.g., Chrome) return an empty MIME type for certain file types (like .md files)
 * on DataTransferItem during drag events, even though the type is correctly set during drop.
 *
 * This function detects such cases by checking for:
 * 1. Empty type string
 * 2. Presence of getAsFile method (indicates it's a DataTransferItem, not a File)
 *
 * We accept these during drag to provide proper UI feedback, while maintaining
 * strict validation during drop when real File objects are available.
 *
 * @param {File | DataTransferItem} file
 * @returns {boolean}
 */

function isDataTransferItemWithEmptyType(file) {
  return file.type === "" && typeof file.getAsFile === "function";
}
/**
 * Check if file is accepted.
 *
 * Firefox versions prior to 53 return a bogus MIME type for every file drag,
 * so dragovers with that MIME type will always be accepted.
 *
 * Chrome/other browsers may return an empty MIME type for files during drag events,
 * so we accept those as well (we'll validate properly on drop).
 *
 * @param {File} file
 * @param {string} accept
 * @returns
 */

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || accepts(file, accept) || isDataTransferItemWithEmptyType(file);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || v === "application/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded$2 = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded$2);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(Fragment$2, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {boolean} params.isDragGlobal Files are being dragged anywhere on the document
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: PropTypes.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {boolean} isDragGlobal Files are being dragged anywhere on the document
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  isDragGlobal: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop$1;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop$1;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = useRef([]);
  var globalDragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Track global drag state for document-level drag events

  useEffect(function () {
    var onDocumentDragEnter = function onDocumentDragEnter(event) {
      globalDragTargetsRef.current = [].concat(_toConsumableArray(globalDragTargetsRef.current), [event.target]);

      if (isEvtWithFiles(event)) {
        dispatch({
          isDragGlobal: true,
          type: "setDragGlobal"
        });
      }
    };

    var onDocumentDragLeave = function onDocumentDragLeave(event) {
      // Only deactivate once we've left all children
      globalDragTargetsRef.current = globalDragTargetsRef.current.filter(function (el) {
        return el !== event.target && el !== null;
      });

      if (globalDragTargetsRef.current.length > 0) {
        return;
      }

      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    var onDocumentDragEnd = function onDocumentDragEnd() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    var onDocumentDropGlobal = function onDocumentDropGlobal() {
      globalDragTargetsRef.current = [];
      dispatch({
        isDragGlobal: false,
        type: "setDragGlobal"
      });
    };

    document.addEventListener("dragenter", onDocumentDragEnter, false);
    document.addEventListener("dragleave", onDocumentDragLeave, false);
    document.addEventListener("dragend", onDocumentDragEnd, false);
    document.addEventListener("drop", onDocumentDropGlobal, false);
    return function () {
      document.removeEventListener("dragenter", onDocumentDragEnter);
      document.removeEventListener("dragleave", onDocumentDragLeave);
      document.removeEventListener("dragend", onDocumentDragEnd);
      document.removeEventListener("drop", onDocumentDropGlobal);
    };
  }, [rootRef]); // Auto focus the root when autoFocus is true

  useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      isDragReject: fileRejections.length > 0,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections,
        isDragReject: action.isDragReject
      });

    case "setDragGlobal":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragGlobal: action.isDragGlobal
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop$1() {}

var css_248z$n = ".FileUpload-module__fileUpload___OQz-f{margin:0 auto 20px;width:100%}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__label___K8yqR{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);text-align:left}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__label___K8yqR .FileUpload-module__required___ojZsv{color:var(--danger);margin-left:.15rem}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__uploaderContainer___NQWvh{align-items:flex-start;display:flex;flex-wrap:wrap;gap:1rem;margin-top:.3rem}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ,.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz{border-radius:var(--border-radius-medium);flex-shrink:0;height:95px;overflow:hidden;position:relative;width:145px}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz{transition:all .2s ease}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz img{height:100%;object-fit:cover;width:100%}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz .FileUpload-module__deleteButton___vSxIj{align-items:center;backdrop-filter:blur(4px);background-color:hsla(0,0%,100%,.9);border:none;border-radius:50%;color:var(--danger);cursor:pointer;display:flex;font-size:18px;height:24px;justify-content:center;position:absolute;right:8px;top:8px;transition:all .2s ease;width:24px}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz .FileUpload-module__deleteButton___vSxIj:hover{background-color:var(--bg-light-48)}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz .FileUpload-module__dragHandle___x2z13{align-items:center;backdrop-filter:blur(4px);background-color:hsla(0,0%,100%,.9);border:none;border-radius:50%;cursor:grab;display:flex;height:24px;justify-content:center;position:absolute;right:40px;top:8px;transition:all .2s ease;width:24px}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz .FileUpload-module__dragHandle___x2z13:hover{background-color:var(--bg-light-48);transform:scale(1.1)}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz .FileUpload-module__dragHandle___x2z13:active{cursor:grabbing}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz.FileUpload-module__dragging___IDDgr{opacity:.5;transform:rotate(5deg);z-index:1000}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__previewItem___OVrUz.FileUpload-module__dragOver___d8CYs{background-color:var(--bg-light-48);border:2px dashed var(--primary-color)}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ{align-items:center;border:1px dashed var(--bg-dark);cursor:pointer;display:flex;justify-content:center;padding:5px;text-align:center;transition:all .3s ease;width:max-content}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ.FileUpload-module__active___6EIRz,.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ:hover{background-color:var(--bg-light-48)}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ.FileUpload-module__error___6Sxor{border-color:var(--danger)}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__dropzone___h88GQ p{color:var(--grey-64);font-size:16px;margin:0}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__content___mIrzR{text-align:center}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__content___mIrzR .FileUpload-module__uploadText___VE6Zm{color:var(--grey-64);font-size:var(--body-xxs-size);line-height:var(--body-xxs-line-height);margin-top:.3rem}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__content___mIrzR .FileUpload-module__clickText___s2bCn{color:var(--text);font-weight:var(--body-xxs-weight);text-decoration:underline}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__content___mIrzR .FileUpload-module__supportText___PinF1{color:var(--grey-64);font-size:var(--body-xxs-size);margin-top:.5rem}.FileUpload-module__fileUpload___OQz-f .FileUpload-module__errorMessage___RaPMH{color:var(--danger);display:block;font-size:.75rem;margin-top:.2rem}";
var css$m = {"fileUpload":"FileUpload-module__fileUpload___OQz-f","label":"FileUpload-module__label___K8yqR","required":"FileUpload-module__required___ojZsv","uploaderContainer":"FileUpload-module__uploaderContainer___NQWvh","previewItem":"FileUpload-module__previewItem___OVrUz","dropzone":"FileUpload-module__dropzone___h88GQ","deleteButton":"FileUpload-module__deleteButton___vSxIj","dragHandle":"FileUpload-module__dragHandle___x2z13","dragging":"FileUpload-module__dragging___IDDgr","dragOver":"FileUpload-module__dragOver___d8CYs","active":"FileUpload-module__active___6EIRz","error":"FileUpload-module__error___6Sxor","content":"FileUpload-module__content___mIrzR","uploadText":"FileUpload-module__uploadText___VE6Zm","clickText":"FileUpload-module__clickText___s2bCn","supportText":"FileUpload-module__supportText___PinF1","errorMessage":"FileUpload-module__errorMessage___RaPMH"};
styleInject(css_248z$n);

const ImageUpload = ({
  onImagesChange,
  images = [],
  label,
  required = false,
  maxImages = 10,
  error,
  onImageDelete,
  imgClassName,
  enableDragAndDrop = false,
  onSortChange
}) => {
  const fileInputRef = useRef(null);
  const hideDropzone = images.length >= maxImages;
  const {
    draggedIndex,
    dragOverIndex,
    onDragStart,
    onDragEnter,
    onDragLeave,
    onDragEnd,
    onDragOver
  } = useDragAndDrop(images, onImagesChange, onSortChange);
  const handleFiles = useCallback(files => {
    const newImages = Array.from(files).filter(file => file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg').map(file => {
      const preview = URL.createObjectURL(file);
      return {
        file: file,
        preview: preview
      };
    });
    const updatedImages = maxImages === 1 ? newImages.slice(0, 1) : [...images, ...newImages].slice(0, maxImages);
    onImagesChange?.(updatedImages);
  }, [onImagesChange, maxImages]);
  const onDrop = useCallback(acceptedFiles => {
    handleFiles(acceptedFiles);
  }, [handleFiles]);
  const handleClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const handleFileInputChange = useCallback(e => {
    handleFiles(e.target.files);
  }, [handleFiles]);
  const {
    getRootProps,
    isDragActive
  } = useDropzone({
    onDrop,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpg', '.jpeg']
    },
    noClick: true
  });
  const deleteImage = async index => {
    try {
      const newImages = [...images];
      if (newImages[index] && newImages[index].id) {
        await onImageDelete(newImages[index].id);
      }
      URL.revokeObjectURL(newImages[index].preview);
      newImages.splice(index, 1);
      onImagesChange?.(newImages);
    } catch (error) {
      console.log(error);
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: css$m.fileUpload,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$m.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$m.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$m.uploaderContainer,
      children: [images.map((image, index) => {
        const isFile = image.preview instanceof File || image instanceof Blob;
        const isDragging = draggedIndex === index;
        const isDragOver = dragOverIndex === index;
        const isDraggable = enableDragAndDrop && images.length > 1;
        return /*#__PURE__*/jsxs("div", {
          className: `${css$m.previewItem} ${imgClassName} ${isDragging ? css$m.dragging : ''} ${isDragOver ? css$m.dragOver : ''}`,
          draggable: isDraggable,
          onDragStart: () => isDraggable && onDragStart(index),
          onDragEnter: e => isDraggable && onDragEnter(index),
          onDragLeave: () => isDraggable && onDragLeave(index),
          onDragEnd: () => isDraggable && onDragEnd(),
          onDragOver: e => isDraggable && onDragOver(e, index),
          style: {
            cursor: isDraggable ? 'move' : 'default',
            opacity: isDragging ? 0.5 : 1
          },
          children: [/*#__PURE__*/jsx("img", {
            src: isFile ? URL.createObjectURL(image.preview) : image.preview,
            alt: `Preview ${index + 1}`
          }), /*#__PURE__*/jsx("button", {
            type: "button",
            className: css$m.deleteButton,
            onClick: e => {
              e.stopPropagation();
              deleteImage(index);
            },
            children: /*#__PURE__*/jsx(Trash01, {
              color: "var(--danger)",
              width: 14
            })
          }), isDraggable && /*#__PURE__*/jsx("button", {
            type: "button",
            className: css$m.dragHandle,
            onMouseDown: e => {
              e.stopPropagation();
            },
            children: /*#__PURE__*/jsx(ArrowSwitchVertical, {
              color: colors$1.grey64,
              width: 14
            })
          })]
        }, image.id || image.preview);
      }), !hideDropzone && /*#__PURE__*/jsxs("div", {
        ...getRootProps(),
        className: `${css$m.dropzone} ${imgClassName} ${isDragActive ? css$m.active : ''} ${error ? css$m.error : ''}`,
        onClick: handleClick,
        "data-error": !!error,
        children: [/*#__PURE__*/jsx("input", {
          ref: fileInputRef,
          type: "file",
          multiple: maxImages > 1,
          accept: "image/png,image/jpeg",
          onChange: handleFileInputChange,
          style: {
            display: 'none'
          },
          required: required && images.length === 0
        }), isDragActive ? /*#__PURE__*/jsx("p", {
          children: "Drop the images here..."
        }) : /*#__PURE__*/jsxs("div", {
          className: css$m.content,
          children: [/*#__PURE__*/jsx(ImageAdd, {
            width: 20,
            color: "var(--primary-color)"
          }), /*#__PURE__*/jsxs("div", {
            className: css$m.uploadText,
            children: [/*#__PURE__*/jsx("span", {
              className: css$m.clickText,
              children: "Click to upload"
            }), " or drag and drop", /*#__PURE__*/jsx("div", {
              className: css$m.supportText,
              children: "PNG or JPG"
            })]
          })]
        })]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$m.errorMessage,
      children: error
    })]
  });
};
ImageUpload.propTypes = {
  onImagesChange: PropTypes.func.isRequired,
  images: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.any,
    preview: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File), PropTypes.instanceOf(Blob)]),
    file: PropTypes.instanceOf(File)
  })),
  label: PropTypes.string,
  required: PropTypes.bool,
  maxImages: PropTypes.number,
  error: PropTypes.string,
  onImageDelete: PropTypes.func,
  imgClassName: PropTypes.string,
  enableDragAndDrop: PropTypes.bool,
  onSortChange: PropTypes.func
};

const RowContext = /*#__PURE__*/createContext$1(null);
const useRow = () => useContext(RowContext);

var css_248z$m = ".MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .tiptap.ProseMirror{height:250px!important;max-height:250px!important}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__addControls___BDVOc{align-items:center;display:flex;gap:5px;margin-bottom:15px;width:250px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu{display:flex;flex-wrap:wrap;gap:8px;overflow-x:auto;padding-bottom:8px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF{align-items:center;background:none;border:1px solid transparent;border-radius:var(--border-radius-small);cursor:pointer;display:flex;flex-direction:row;gap:8px;min-width:auto;padding:8px 16px;transition:all .2s ease;white-space:nowrap}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF:hover{background-color:var(--bg-light-48)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF.MultiLanguageInputGroup-module__active___k7lRS{background-color:var(--primary-color);color:var(--white)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__languageName___0EDgm{font-size:var(--body-regular-size);font-weight:var(--body-regular-weight)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__fieldCounter___pkJGZ{background-color:rgba(0,0,0,.1);border-radius:var(--border-radius-small);font-size:var(--body-xs-size);font-weight:var(--body-regular-weight);line-height:1;min-width:24px;opacity:.8;padding:2px 6px;text-align:center}.MultiLanguageInputGroup-module__active___k7lRS .MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__fieldCounter___pkJGZ{background-color:var(--grey-8)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5{background-color:var(--white);border:1px solid var(--grey-8);border-radius:var(--border-radius-medium);margin-bottom:10px;padding:16px;transition:all .3s ease}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageForm___fzovX>div:not(:last-child){margin-bottom:15px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageForm___fzovX label>div{align-items:baseline!important}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5.MultiLanguageInputGroup-module__visible___7gPmE{max-height:none;opacity:1;overflow:visible}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5.MultiLanguageInputGroup-module__hidden___sRWNm{border:none;margin-bottom:0;max-height:0;opacity:0;overflow:hidden;padding:0 16px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j{align-items:center;display:flex;justify-content:space-between;margin-bottom:10px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j h4{align-items:center;color:var(--primary-color);display:flex;font-size:var(--label-size);font-weight:var(--label-weight);gap:8px;line-height:var(--label-line-height);margin:0}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j .MultiLanguageInputGroup-module__removeButton___lQqjX{background:none;border:none;border-radius:var(--border-radius-small);color:var(--danger);cursor:pointer;font-size:var(--body-xs-size);font-weight:var(--label-weight);padding:4px 8px;transition:background-color .2s ease}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j .MultiLanguageInputGroup-module__removeButton___lQqjX svg{height:20px;width:20px}@media (max-width:768px){.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu{-ms-overflow-style:none;gap:6px;padding-bottom:12px;scrollbar-width:none}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu::-webkit-scrollbar{display:none}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF{gap:6px;padding:10px 12px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__languageName___0EDgm{font-size:var(--body-small-size)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5.MultiLanguageInputGroup-module__hidden___sRWNm{padding:0 16px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j .MultiLanguageInputGroup-module__removeButton___lQqjX{font-size:var(--body-small-size);min-height:36px;padding:8px 12px}}@media (max-width:480px){.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu{gap:4px;margin-bottom:16px;padding:0 4px 12px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF{gap:4px;padding:8px 10px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__languageName___0EDgm{font-size:var(--body-xs-size)}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageTabs___I7pXu .MultiLanguageInputGroup-module__tabButton___-EoiF .MultiLanguageInputGroup-module__fieldCounter___pkJGZ{font-size:10px;min-width:20px;padding:1px 4px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5{margin-bottom:16px;padding:12px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5.MultiLanguageInputGroup-module__hidden___sRWNm{padding:0 12px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j{align-items:flex-start;flex-direction:column;gap:12px;margin-bottom:16px;padding-bottom:12px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j h4{font-size:var(--body-regular-size);gap:6px}.MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8- .MultiLanguageInputGroup-module__languageSection___YZ4s5 .MultiLanguageInputGroup-module__languageHeader___cF17j .MultiLanguageInputGroup-module__removeButton___lQqjX{font-size:var(--body-xs-size);min-height:32px;padding:6px 10px}}";
var css$l = {"multiLanguageInputGroup":"MultiLanguageInputGroup-module__multiLanguageInputGroup___kPa8-","addControls":"MultiLanguageInputGroup-module__addControls___BDVOc","languageTabs":"MultiLanguageInputGroup-module__languageTabs___I7pXu","tabButton":"MultiLanguageInputGroup-module__tabButton___-EoiF","active":"MultiLanguageInputGroup-module__active___k7lRS","languageName":"MultiLanguageInputGroup-module__languageName___0EDgm","fieldCounter":"MultiLanguageInputGroup-module__fieldCounter___pkJGZ","languageSection":"MultiLanguageInputGroup-module__languageSection___YZ4s5","languageForm":"MultiLanguageInputGroup-module__languageForm___fzovX","visible":"MultiLanguageInputGroup-module__visible___7gPmE","hidden":"MultiLanguageInputGroup-module__hidden___sRWNm","languageHeader":"MultiLanguageInputGroup-module__languageHeader___cF17j","removeButton":"MultiLanguageInputGroup-module__removeButton___lQqjX"};
styleInject(css_248z$m);

const ImproveButton = ({
  selectedLanguage,
  onImproveAll
}) => {
  return /*#__PURE__*/jsx(Button$1, {
    size: "small",
    variant: "secondary",
    style: {
      marginBottom: 15
    },
    onClick: () => onImproveAll(selectedLanguage),
    icon: /*#__PURE__*/jsx(Stars, {}),
    children: "AI Improve"
  });
};

const MultiLanguageInputGroup = ({
  value,
  onChange,
  availableLanguages = [],
  fields = [],
  showAddLanguage = true,
  showDelete = true,
  showTranslateButton = false,
  showImproveButton = false,
  onTranslateAll,
  onImproveAll,
  className,
  children
}) => {
  const [activeTab, setActiveTab] = useState(() => {
    const firstLanguage = Object.keys(value)[0] ?? availableLanguages[0] ?? 'EN';
    return firstLanguage || 'all';
  });
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const buildInitialRow = () => {
    return Object.fromEntries(fields.map(field => [field, '']));
  };
  const add = language => {
    if (!language || value[language]) return;
    onChange({
      ...value,
      [language]: buildInitialRow()
    });
    setActiveTab(language);
    setSelectedLanguage('');
  };
  const remove = language => {
    const {
      [language]: _omit,
      ...rest
    } = value;
    onChange(rest);
    if (activeTab === language) {
      const remainingLanguages = Object.keys(rest);
      setActiveTab(remainingLanguages[0] || 'all');
    }
  };
  const setField = (language, name, newValue) => {
    onChange({
      ...value,
      [language]: {
        ...value[language],
        [name]: newValue
      }
    });
  };
  const getFilledFieldsCount = language => {
    const row = value[language];
    if (!row) {
      return 0;
    }
    let count = 0;
    for (let i in fields) {
      let value = row[fields[i]];
      if (value !== null && typeof value === 'object') {
        count += 1;
      } else {
        count += value && value.trim() !== '' ? 1 : 0;
      }
    }
    return count;
  };
  if (Object.keys(value).length === 0) {
    value[availableLanguages[0] ?? 'EN'] = buildInitialRow();
  }
  const languageEntries = Object.entries(value);
  const unused = availableLanguages.filter(l => !value[l]);
  return /*#__PURE__*/jsxs("div", {
    className: `${css$l.multiLanguageInputGroup} ${className}`,
    children: [showAddLanguage && /*#__PURE__*/jsxs("div", {
      className: css$l.addControls,
      children: [/*#__PURE__*/jsx(Dropdown, {
        name: "language-selector",
        value: selectedLanguage,
        onChange: e => setSelectedLanguage(e.target.value),
        options: unused.map(l => ({
          value: l,
          label: l.toUpperCase()
        })),
        placeholder: "Select language"
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "tertiary",
        icon: /*#__PURE__*/jsx(Plus03, {}),
        onClick: () => selectedLanguage && add(selectedLanguage),
        disabled: !selectedLanguage,
        children: "Add"
      })]
    }), languageEntries.length > 0 && /*#__PURE__*/jsxs("div", {
      className: css$l.languageTabs,
      children: [languageEntries.map(([language]) => {
        const filledCount = getFilledFieldsCount(language);
        const totalCount = fields.length;
        return /*#__PURE__*/jsxs("button", {
          className: `${css$l.tabButton} ${activeTab === language ? css$l.active : ''}`,
          onClick: () => setActiveTab(language),
          type: "button",
          children: [/*#__PURE__*/jsx("span", {
            className: css$l.languageName,
            children: language.toUpperCase()
          }), /*#__PURE__*/jsxs("span", {
            className: css$l.fieldCounter,
            children: [filledCount, "/", totalCount]
          })]
        }, language);
      }), languageEntries.length > 1 && /*#__PURE__*/jsx("button", {
        className: `${css$l.tabButton} ${activeTab === 'all' ? css$l.active : ''}`,
        onClick: () => setActiveTab('all'),
        type: "button",
        children: /*#__PURE__*/jsx("span", {
          className: css$l.languageName,
          children: "Show All"
        })
      })]
    }), showTranslateButton && languageEntries.length > 1 && activeTab !== 'all' && /*#__PURE__*/jsx(TranslateButton, {
      availableLanguages: languageEntries,
      selectedLanguage: activeTab,
      onTranslateAll: onTranslateAll
    }), showImproveButton && activeTab !== 'all' && /*#__PURE__*/jsx(ImproveButton, {
      selectedLanguage: activeTab,
      onImproveAll: onImproveAll
    }), languageEntries.map(([language, row]) => {
      const isVisible = activeTab === 'all' || activeTab === language;
      return /*#__PURE__*/jsx(RowContext.Provider, {
        value: {
          language,
          row,
          setField: (name, v) => setField(language, name, v),
          remove
        },
        children: /*#__PURE__*/jsxs("div", {
          className: `${css$l.languageSection} ${isVisible ? css$l.visible : css$l.hidden}`,
          children: [/*#__PURE__*/jsxs("div", {
            className: css$l.languageHeader,
            children: [/*#__PURE__*/jsx("div", {
              children: activeTab === 'all' && /*#__PURE__*/jsx("h4", {
                children: language.toUpperCase()
              })
            }), showDelete && /*#__PURE__*/jsx(DeleteButton, {
              onClick: () => remove(language)
            })]
          }), /*#__PURE__*/jsx("div", {
            className: css$l.languageForm,
            children: children
          })]
        })
      }, language);
    })]
  });
};

const FileUpload = ({
  onFilesChange,
  files = [],
  label,
  required = false,
  maxFiles = 10,
  error,
  onFileDelete,
  fileClassName,
  accept
}) => {
  const fileInputRef = useRef(null);
  const handleFiles = useCallback(files => {
    const newFiles = Array.from(files).filter(file => Object.hasOwn(accept, file.type)).map(file => {
      let previewUrl = URL.createObjectURL(file);
      return {
        file: file,
        previewUrl: previewUrl
      };
    });
    const updatedFiles = maxFiles === 1 ? newFiles.slice(0, 1) : [...files, ...newFiles].slice(0, maxFiles);
    onFilesChange?.(updatedFiles);
  }, [onFilesChange, maxFiles]);
  const onDrop = useCallback(acceptedFiles => {
    handleFiles(acceptedFiles);
  }, [handleFiles]);
  const handleClick = useCallback(() => {
    fileInputRef.current?.click();
  }, []);
  const handleFileInputChange = useCallback(e => {
    handleFiles(e.target.files);
  }, [handleFiles]);
  const {
    getRootProps,
    isDragActive
  } = useDropzone({
    onDrop,
    accept: accept,
    noClick: true
  });
  const deleteFile = async index => {
    try {
      const newFiles = [...files];
      if (newFiles[index] && newFiles[index].id) {
        await onFileDelete(newFiles[index].id);
      }
      newFiles.splice(index, 1);
      onFilesChange?.(newFiles);
    } catch (error) {
      console.log(error);
    }
  };
  const openFile = fileUrl => {
    window.open(fileUrl);
  };
  const supportedFileTypes = [...new Set(Object.values(accept).flat())].join(', ');
  return /*#__PURE__*/jsxs("div", {
    className: css$m.fileUpload,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$m.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$m.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$m.uploaderContainer,
      children: [files.map((file, index) => {
        return /*#__PURE__*/jsxs("div", {
          className: `${css$m.previewItem} ${fileClassName}`,
          children: [/*#__PURE__*/jsxs(Button$1, {
            variant: "ghost",
            size: "small",
            onClick: () => openFile(file.previewUrl),
            children: [/*#__PURE__*/jsx(EyeOpen, {}), " View"]
          }), /*#__PURE__*/jsx("button", {
            type: "button",
            className: css$m.deleteButton,
            onClick: e => {
              e.stopPropagation();
              deleteFile(index);
            },
            children: /*#__PURE__*/jsx(Trash01, {
              color: "var(--danger)",
              width: 14
            })
          }), file.file && /*#__PURE__*/jsx(FlexContainer, {
            children: file.file.name
          })]
        }, index);
      }), /*#__PURE__*/jsxs("div", {
        ...getRootProps(),
        className: `${css$m.dropzone} ${fileClassName} ${isDragActive ? css$m.active : ''} ${error ? css$m.error : ''}`,
        onClick: handleClick,
        "data-error": !!error,
        children: [/*#__PURE__*/jsx("input", {
          ref: fileInputRef,
          type: "file",
          multiple: maxFiles > 1,
          accept: accept,
          onChange: handleFileInputChange,
          style: {
            display: 'none'
          },
          required: required && files.length === 0
        }), isDragActive ? /*#__PURE__*/jsx("p", {
          children: "Drop files here..."
        }) : /*#__PURE__*/jsxs("div", {
          className: css$m.content,
          children: [/*#__PURE__*/jsx(ImageAdd, {
            width: 20,
            color: "var(--primary-color)"
          }), /*#__PURE__*/jsxs("div", {
            className: css$m.uploadText,
            children: [/*#__PURE__*/jsx("span", {
              className: css$m.clickText,
              children: "Click to upload"
            }), " or drag and drop", /*#__PURE__*/jsxs("div", {
              className: css$m.supportText,
              children: ["Supported files: ", supportedFileTypes]
            })]
          })]
        })]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$m.errorMessage,
      children: error
    })]
  });
};
FileUpload.propTypes = {
  onFilesChange: PropTypes.func.isRequired,
  files: PropTypes.arrayOf(PropTypes.string),
  label: PropTypes.string,
  required: PropTypes.bool,
  maxFiles: PropTypes.number,
  error: PropTypes.string,
  accept: PropTypes.object.isRequired
};

const MultiLanguageInput = ({
  name,
  as = 'input',
  placeholder,
  getPlaceholder,
  label,
  getLabel,
  required = false,
  disabled = false,
  rows = 4,
  toolbar,
  ...rest
}) => {
  const {
    language,
    row,
    setField
  } = useRow();
  const current = row[name] ?? '';
  const {
    formError,
    ...restProps
  } = rest;
  const error = formError ? formError(language, row) : rest.error;
  const resolvedPlaceholder = getPlaceholder ? getPlaceholder(language) : placeholder;
  const handleChange = e => {
    const newValue = e.target.value;
    setField(name, newValue);
    if (rest.onInputChange) {
      rest.onInputChange(language, name, newValue);
    }
  };
  const handleEditorChange = newValue => {
    setField(name, newValue);
    if (rest.onInputChange) {
      rest.onInputChange(language, name, newValue);
    }
  };
  const handleFileChange = files => {
    setField(name, files[0] ?? null);
    if (rest.onInputChange) {
      rest.onInputChange(language, name, files[0] ?? null);
    }
  };
  const handleImageChange = images => {
    setField(name, images[0] ?? null);
    if (rest.onInputChange) {
      rest.onInputChange(language, name, images[0] ?? null);
    }
  };
  if (as === 'textarea') {
    return /*#__PURE__*/jsx(TextArea, {
      name: name,
      value: current,
      onChange: handleChange,
      placeholder: resolvedPlaceholder,
      label: getLabel ? getLabel(language) : label,
      required: required,
      disabled: disabled,
      rows: rows,
      error: error,
      ...restProps
    });
  }
  if (as === 'editor') {
    toolbar = toolbar ?? /*#__PURE__*/jsxs(Toolbar, {
      children: [/*#__PURE__*/jsx(BoldButton, {}), /*#__PURE__*/jsx(ItalicButton, {}), /*#__PURE__*/jsx(UnderlineButton, {}), /*#__PURE__*/jsx(StrikeButton, {}), /*#__PURE__*/jsx(BulletListButton, {}), /*#__PURE__*/jsx(LinkButton, {})]
    });
    return /*#__PURE__*/jsx(BaseEditor, {
      label: getLabel ? getLabel(language) : label,
      content: current,
      onChange: handleEditorChange,
      error: error,
      ...restProps,
      toolbar: toolbar
    });
  }
  if (as === 'description') {
    const descriptionProps = {
      label,
      content: current,
      onChange: handleEditorChange,
      required,
      disabled,
      ...restProps
    };
    if (rest.onGetImprovedText) {
      descriptionProps.onGetImprovedText = () => rest.onGetImprovedText(language, row);
    }
    if (rest.onAcceptImprovedText) {
      descriptionProps.onAcceptImprovedText = value => rest.onAcceptImprovedText(language, value);
    }
    if (rest.onGetTranslatedText) {
      descriptionProps.onGetTranslatedText = fromLanguage => rest.onGetTranslatedText(fromLanguage, language, row);
    }
    if (rest.onAcceptTranslatedText) {
      descriptionProps.onAcceptTranslatedText = value => rest.onAcceptTranslatedText(language, value);
    }
    if (rest.onAcceptAndApplyToAll) {
      descriptionProps.onAcceptAndApplyToAll = value => rest.onAcceptAndApplyToAll(language, value);
    }
    if (rest.availableLanguages) {
      descriptionProps.availableLanguages = rest.availableLanguages(language, row);
    }
    descriptionProps.error = error;
    if (rest.showImproveButton) {
      descriptionProps.showImproveButton = rest.showImproveButton(language, row);
    }
    return /*#__PURE__*/jsx(Description, {
      ...descriptionProps
    });
  }
  if (as === 'file') {
    let files = current ? [current] : [];
    return /*#__PURE__*/jsx(FileUpload, {
      onFilesChange: handleFileChange,
      onFileDelete: handleFileChange,
      name: name,
      maxFiles: 1,
      files: files,
      placeholder: resolvedPlaceholder,
      label: label,
      required: required,
      disabled: disabled,
      error: error,
      ...restProps
    });
  }
  if (as === 'image') {
    let images = current ? [current] : [];
    return /*#__PURE__*/jsx(ImageUpload, {
      onImagesChange: handleImageChange,
      onImageDelete: handleImageChange,
      name: name,
      maxImages: 1,
      images: images,
      placeholder: resolvedPlaceholder,
      label: label,
      required: required,
      disabled: disabled,
      error: error,
      ...restProps
    });
  }
  return /*#__PURE__*/jsx(InputText, {
    name: name,
    value: current,
    onChange: handleChange,
    placeholder: resolvedPlaceholder,
    label: getLabel ? getLabel(language) : label,
    required: required,
    disabled: disabled,
    type: as === 'input' ? 'text' : as,
    error: error,
    ...restProps
  });
};

const ContentSuggestionsSidePanel = ({
  isOpen,
  onClose,
  suggestedText,
  onAcceptField,
  onAcceptAll
}) => {
  return /*#__PURE__*/jsxs(SidePanel, {
    open: isOpen,
    onClose: onClose,
    title: "Content Suggestions",
    children: [Object.entries(suggestedText || {}).map(([key, value]) => /*#__PURE__*/jsxs("div", {
      style: {
        marginBottom: 15
      },
      children: [/*#__PURE__*/jsx("label", {
        children: key
      }), /*#__PURE__*/jsx("div", {
        children: value
      }), /*#__PURE__*/jsx(FlexContainer, {
        justifyContent: "flex-end",
        children: /*#__PURE__*/jsx(Button$1, {
          size: "small",
          variant: "tertiary",
          onClick: () => onAcceptField(key),
          children: "Accept"
        })
      }), /*#__PURE__*/jsx("hr", {
        style: {
          marginTop: 15,
          borderColor: colors$1.bgLight80
        }
      })]
    }, key)), /*#__PURE__*/jsx(FlexContainer, {
      justifyContent: "flex-end",
      children: /*#__PURE__*/jsx(Button$1, {
        size: "small",
        onClick: onAcceptAll,
        children: "Accept All"
      })
    })]
  });
};

var css_248z$l = ".InputRadio-module__radioInput___jvJJ3{align-items:center;display:flex;gap:.3rem;justify-content:flex-start}.InputRadio-module__radioInput___jvJJ3 input[type=radio]{margin:0}.InputRadio-module__radioInput___jvJJ3 .InputRadio-module__label___IxV-9{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin:0;text-align:left}";
var css$k = {"radioInput":"InputRadio-module__radioInput___jvJJ3","label":"InputRadio-module__label___IxV-9"};
styleInject(css_248z$l);

const InputRadio = ({
  id,
  name,
  label,
  value,
  defaultChecked
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `radio ${css$k.radioInput}`,
    children: [/*#__PURE__*/jsx("input", {
      id: id,
      name: name,
      type: "radio",
      defaultChecked: defaultChecked,
      value: value
    }), label && /*#__PURE__*/jsx("label", {
      htmlFor: id,
      className: `radio-label ${css$k.label}`,
      children: label
    })]
  });
};

var css_248z$k = ".Slider-module__sliderContainer___vG1Ct{display:flex;flex-direction:column;gap:15px;width:100%}.Slider-module__sliderContainer___vG1Ct.Slider-module__label-left___P5lsi{align-items:center;flex-direction:row;gap:5px}.Slider-module__sliderContainer___vG1Ct.Slider-module__label-left___P5lsi .Slider-module__label___R8Xfa{flex-shrink:0;margin-bottom:0}.Slider-module__sliderContainer___vG1Ct.Slider-module__label-left___P5lsi .Slider-module__sliderWrapper___IN6vO{flex:1}.Slider-module__sliderContainer___vG1Ct .Slider-module__label___R8Xfa{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:.3rem;text-align:left}.Slider-module__sliderContainer___vG1Ct .Slider-module__label___R8Xfa .Slider-module__required___BeKx2{color:var(--danger);margin-left:.15rem}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO{align-items:center;display:flex;width:100%}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF{-webkit-appearance:none;appearance:none;background:linear-gradient(to right,var(--primary-color) 0,var(--primary-color) var(--slider-progress,0),var(--bg-dark) var(--slider-progress,0),var(--bg-dark) 100%);border-radius:5px;cursor:pointer;height:10px;outline:none;transition:background .15s ease;width:100%}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;background:var(--white);border:2px solid var(--primary-color);border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:pointer;height:18px;transition:transform .15s ease;width:18px}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF::-webkit-slider-thumb:hover{transform:scale(1.15)}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF::-moz-range-thumb{background:var(--white);border:2px solid var(--primary-color);border-radius:50%;box-shadow:0 1px 3px rgba(0,0,0,.2);cursor:pointer;height:18px;margin-top:-4px;transition:transform .15s ease;width:18px}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF::-moz-range-thumb:hover{transform:scale(1.15)}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF:disabled{cursor:not-allowed;opacity:.5}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF:disabled::-webkit-slider-thumb{cursor:not-allowed}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF:disabled::-moz-range-thumb{cursor:not-allowed}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF.Slider-module__error___pDbrX{background:linear-gradient(to right,var(--danger) 0,var(--danger) var(--slider-progress,0),var(--bg-dark) var(--slider-progress,0),var(--bg-dark) 100%)}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF.Slider-module__error___pDbrX::-webkit-slider-thumb{background:var(--white);border-color:var(--danger)}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__slider___yWXaF.Slider-module__error___pDbrX::-moz-range-thumb{background:var(--white);border-color:var(--danger)}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__valueDisplay___GIUNK{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);min-width:3rem;text-align:right;white-space:nowrap}.Slider-module__sliderContainer___vG1Ct .Slider-module__sliderWrapper___IN6vO .Slider-module__valueDisplay___GIUNK .Slider-module__suffix___7UfZi{color:var(--grey-64);margin-left:.15rem}.Slider-module__sliderContainer___vG1Ct .Slider-module__errorMessage___o0sl7{color:var(--danger);font-size:.75rem;margin-top:.2rem}";
var css$j = {"sliderContainer":"Slider-module__sliderContainer___vG1Ct","label-left":"Slider-module__label-left___P5lsi","label":"Slider-module__label___R8Xfa","sliderWrapper":"Slider-module__sliderWrapper___IN6vO","required":"Slider-module__required___BeKx2","slider":"Slider-module__slider___yWXaF","error":"Slider-module__error___pDbrX","valueDisplay":"Slider-module__valueDisplay___GIUNK","suffix":"Slider-module__suffix___7UfZi","errorMessage":"Slider-module__errorMessage___o0sl7"};
styleInject(css_248z$k);

const Slider = ({
  label,
  name,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  disabled = false,
  required = false,
  error,
  suffix,
  className = '',
  showValue = true,
  labelPosition = 'top'
}) => {
  const handleChange = e => {
    onChange(e);
  };
  const percentage = (value - min) / (max - min) * 100;
  return /*#__PURE__*/jsxs("div", {
    className: `${css$j.sliderContainer} ${className} ${css$j[`label-${labelPosition}`]}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$j.label,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$j.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$j.sliderWrapper,
      children: [/*#__PURE__*/jsx("input", {
        type: "range",
        value: value,
        onChange: handleChange,
        min: min,
        max: max,
        step: step,
        disabled: disabled,
        name: name,
        className: `${css$j.slider} ${error ? css$j.error : ''}`,
        style: {
          '--slider-progress': `${percentage}%`
        }
      }), showValue && /*#__PURE__*/jsxs("span", {
        className: css$j.valueDisplay,
        children: [value, suffix && /*#__PURE__*/jsx("span", {
          className: css$j.suffix,
          children: suffix
        })]
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$j.errorMessage,
      children: error
    })]
  });
};
Slider.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  suffix: PropTypes.string,
  className: PropTypes.string,
  showValue: PropTypes.bool,
  labelPosition: PropTypes.oneOf(['top', 'left'])
};

var css_248z$j = ".FocalPointPicker-module__container___NtMAJ{border-radius:var(--border-radius-medium);display:inline-block;max-width:100%;overflow:hidden;position:relative}.FocalPointPicker-module__imageWrapper___TPgdX{border-radius:var(--border-radius-medium) var(--border-radius-medium) 0 0;cursor:crosshair;overflow:hidden;position:relative}.FocalPointPicker-module__imageWrapper___TPgdX:hover .FocalPointPicker-module__overlay___olZ2S{opacity:1}.FocalPointPicker-module__image___yg3t4{-webkit-user-drag:none;display:block;max-height:340px;max-width:100%;user-select:none}.FocalPointPicker-module__overlay___olZ2S{background:linear-gradient(180deg,rgba(var(--primary-color-rgb),.01) 0,rgba(var(--primary-color-rgb),.04) 100%);inset:0;opacity:0;pointer-events:none;position:absolute;transition:opacity .2s ease}.FocalPointPicker-module__hintBadge___6mKOw{backdrop-filter:blur(6px);background:var(--grey);border-radius:20px;bottom:12px;color:var(--white);font-size:.75rem;font-weight:500;left:50%;letter-spacing:.01em;opacity:.85;padding:6px 14px;pointer-events:none;position:absolute;transform:translateX(-50%);transition:opacity .25s ease;white-space:nowrap;z-index:2}.FocalPointPicker-module__imageWrapper___TPgdX:hover .FocalPointPicker-module__hintBadge___6mKOw{opacity:1}.FocalPointPicker-module__pin___jejWq{height:28px;pointer-events:none;position:absolute;transform:translate(-50%,-50%);width:28px;z-index:1}.FocalPointPicker-module__pinRing___n68OG{animation:FocalPointPicker-module__pinPulse___Y2Bdl 2.4s ease-in-out infinite;border:2.5px solid var(--white);border-radius:50%;box-shadow:var(--smoothShadow);inset:0;position:absolute}.FocalPointPicker-module__pinDot___hP-VZ{background-color:var(--primary-color);border-radius:50%;height:10px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%);width:10px}.FocalPointPicker-module__pinGhost___aT58Q .FocalPointPicker-module__pinRing___n68OG{animation:none;border-color:var(--grey-20)}.FocalPointPicker-module__pinGhost___aT58Q .FocalPointPicker-module__pinDot___hP-VZ{background-color:var(--grey-20)}.FocalPointPicker-module__crosshairH___ClhZn,.FocalPointPicker-module__crosshairV___TOKA9{pointer-events:none;position:absolute;z-index:0}.FocalPointPicker-module__crosshairH___ClhZn{background:linear-gradient(90deg,transparent 0,var(--grey-20) 30%,var(--grey-20) 70%,transparent 100%);height:1px;left:0;right:0;top:50%;transform:translateY(-50%)}.FocalPointPicker-module__crosshairV___TOKA9{background:linear-gradient(180deg,transparent 0,var(--grey-20) 30%,var(--grey-20) 70%,transparent 100%);bottom:0;left:50%;top:0;transform:translateX(-50%);width:1px}.FocalPointPicker-module__footer___zXGHD{align-items:center;background:var(--bg-light-80);border:1px solid var(--grey-8);border-radius:0 0 var(--border-radius-medium) var(--border-radius-medium);border-top:none;color:var(--grey-64);display:flex;font-size:.75rem;gap:8px;justify-content:space-between;padding:7px 12px}.FocalPointPicker-module__footerLeft___vUPCA{align-items:center;display:flex;gap:6px}.FocalPointPicker-module__footerIcon___Sw1LK{flex-shrink:0;opacity:.5}.FocalPointPicker-module__coordinates___Uas-0{align-items:center;background:var(--bg-light);border:1px solid var(--grey-8);border-radius:var(--border-radius-small);color:var(--grey-64);display:flex;font-family:SF Mono,Menlo,Consolas,monospace;font-size:.7rem;gap:8px;padding:2px 8px}.FocalPointPicker-module__notSet___waoFx{color:var(--grey-64);font-size:.7rem;font-style:italic}.FocalPointPicker-module__resetButton___W3AvM{align-items:center;background:none;border:1px solid var(--grey-8);border-radius:var(--border-radius-small);color:var(--grey-64);cursor:pointer;display:inline-flex;font-size:.7rem;gap:4px;padding:2px 8px;transition:all .15s ease;white-space:nowrap}.FocalPointPicker-module__resetButton___W3AvM:hover{background:var(--bg-light);border-color:var(--primary-color);color:var(--primary-color)}@keyframes FocalPointPicker-module__pinPulse___Y2Bdl{0%,to{box-shadow:var(--smoothShadow),0 0 0 0 transparent}50%{box-shadow:var(--smoothShadow),0 0 0 5px rgba(var(--primary-color-rgb),.12)}}";
var css$i = {"container":"FocalPointPicker-module__container___NtMAJ","imageWrapper":"FocalPointPicker-module__imageWrapper___TPgdX","overlay":"FocalPointPicker-module__overlay___olZ2S","image":"FocalPointPicker-module__image___yg3t4","hintBadge":"FocalPointPicker-module__hintBadge___6mKOw","pin":"FocalPointPicker-module__pin___jejWq","pinRing":"FocalPointPicker-module__pinRing___n68OG","pinPulse":"FocalPointPicker-module__pinPulse___Y2Bdl","pinDot":"FocalPointPicker-module__pinDot___hP-VZ","pinGhost":"FocalPointPicker-module__pinGhost___aT58Q","crosshairH":"FocalPointPicker-module__crosshairH___ClhZn","crosshairV":"FocalPointPicker-module__crosshairV___TOKA9","footer":"FocalPointPicker-module__footer___zXGHD","footerLeft":"FocalPointPicker-module__footerLeft___vUPCA","footerIcon":"FocalPointPicker-module__footerIcon___Sw1LK","coordinates":"FocalPointPicker-module__coordinates___Uas-0","notSet":"FocalPointPicker-module__notSet___waoFx","resetButton":"FocalPointPicker-module__resetButton___W3AvM"};
styleInject(css_248z$j);

const FocalPointPicker = ({
  imageSrc,
  focalPoint,
  onChange,
  helperText
}) => {
  const imageRef = useRef(null);
  const [isHovering, setIsHovering] = useState(false);
  const [hoverPosition, setHoverPosition] = useState(null);
  const handleClick = e => {
    const rect = imageRef.current.getBoundingClientRect();
    const x = Math.round((e.clientX - rect.left) / rect.width * 100) / 100;
    const y = Math.round((e.clientY - rect.top) / rect.height * 100) / 100;
    onChange({
      x,
      y
    });
  };
  const handleMouseMove = e => {
    const rect = imageRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    setHoverPosition({
      x,
      y
    });
  };
  const handleReset = () => {
    onChange(null);
  };
  if (!imageSrc) {
    return null;
  }
  const hintText = focalPoint ? 'Click to reposition the focal point' : 'Click to place the focal point';
  return /*#__PURE__*/jsxs("div", {
    className: css$i.container,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$i.imageWrapper,
      onMouseEnter: () => setIsHovering(true),
      onMouseLeave: () => {
        setIsHovering(false);
        setHoverPosition(null);
      },
      onMouseMove: handleMouseMove,
      onClick: handleClick,
      children: [/*#__PURE__*/jsx("img", {
        ref: imageRef,
        src: imageSrc,
        alt: "",
        className: css$i.image
      }), /*#__PURE__*/jsx("div", {
        className: css$i.overlay
      }), /*#__PURE__*/jsx("div", {
        className: css$i.hintBadge,
        children: hintText
      }), isHovering && hoverPosition && !focalPoint && /*#__PURE__*/jsxs("div", {
        className: `${css$i.pin} ${css$i.pinGhost}`,
        style: {
          left: `${hoverPosition.x}%`,
          top: `${hoverPosition.y}%`
        },
        children: [/*#__PURE__*/jsx("div", {
          className: css$i.crosshairH
        }), /*#__PURE__*/jsx("div", {
          className: css$i.crosshairV
        }), /*#__PURE__*/jsx("div", {
          className: css$i.pinRing
        }), /*#__PURE__*/jsx("div", {
          className: css$i.pinDot
        })]
      }), focalPoint && /*#__PURE__*/jsxs("div", {
        className: css$i.pin,
        style: {
          left: `${focalPoint.x * 100}%`,
          top: `${focalPoint.y * 100}%`
        },
        children: [/*#__PURE__*/jsx("div", {
          className: css$i.crosshairH
        }), /*#__PURE__*/jsx("div", {
          className: css$i.crosshairV
        }), /*#__PURE__*/jsx("div", {
          className: css$i.pinRing
        }), /*#__PURE__*/jsx("div", {
          className: css$i.pinDot
        })]
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$i.footer,
      children: [/*#__PURE__*/jsxs("div", {
        className: css$i.footerLeft,
        children: [/*#__PURE__*/jsx(Target04Icon, {
          width: 14,
          color: colors$1.grey64,
          className: css$i.footerIcon
        }), /*#__PURE__*/jsx("span", {
          children: helperText || 'Focal point'
        })]
      }), focalPoint ? /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsxs("span", {
          className: css$i.coordinates,
          children: [Math.round(focalPoint.x * 100), "%, ", Math.round(focalPoint.y * 100), "%"]
        }), /*#__PURE__*/jsx("button", {
          type: "button",
          className: css$i.resetButton,
          onClick: handleReset,
          children: "Reset"
        })]
      }) : /*#__PURE__*/jsx("span", {
        className: css$i.notSet,
        children: "Not set"
      })]
    })]
  });
};
FocalPointPicker.propTypes = {
  imageSrc: PropTypes.string,
  focalPoint: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),
  onChange: PropTypes.func.isRequired,
  helperText: PropTypes.string
};

var css_248z$i = ".InputTime-module__inputContainer___fQVqf{display:flex;flex-direction:column;width:100%}.InputTime-module__inputContainer___fQVqf .InputTime-module__label___ACa0i{color:var(--grey-64);font-size:var(--body-small-size);font-weight:var(--body-small-weight);line-height:var(--body-small-line-height);margin-bottom:5px;text-align:left}.InputTime-module__inputContainer___fQVqf .InputTime-module__label___ACa0i .InputTime-module__required___SAczx{color:var(--danger);margin-left:.15rem}.InputTime-module__inputContainer___fQVqf .InputTime-module__inputWrapper___9rMDR{align-items:center;display:flex;position:relative;width:100%}.InputTime-module__inputContainer___fQVqf .InputTime-module__iconContainer___lEZd2{align-items:center;color:var(--grey-64);display:flex;justify-content:center;left:10px;pointer-events:none;position:absolute;top:50%;transform:translateY(-50%)}.InputTime-module__inputContainer___fQVqf .InputTime-module__iconContainer___lEZd2 svg{height:18px;width:18px}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-{background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height);padding:.6rem;transition:all .2s ease;width:100%}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-.InputTime-module__hasIcon___ttpbQ{padding-left:35px}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-::placeholder{color:var(--grey-20)}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-:focus{background-color:var(--bg-light-48);outline:none}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-:disabled{background-color:var(--grey-8);color:var(--grey-20);cursor:not-allowed}.InputTime-module__inputContainer___fQVqf .InputTime-module__input___exbN-.InputTime-module__error___ny-1O{border-color:var(--danger)}.InputTime-module__inputContainer___fQVqf .InputTime-module__errorMessage___pVybA{color:var(--danger);font-size:.75rem;margin-top:.2rem;text-align:left}";
var css$h = {"inputContainer":"InputTime-module__inputContainer___fQVqf","label":"InputTime-module__label___ACa0i","required":"InputTime-module__required___SAczx","inputWrapper":"InputTime-module__inputWrapper___9rMDR","iconContainer":"InputTime-module__iconContainer___lEZd2","input":"InputTime-module__input___exbN-","hasIcon":"InputTime-module__hasIcon___ttpbQ","error":"InputTime-module__error___ny-1O","errorMessage":"InputTime-module__errorMessage___pVybA"};
styleInject(css_248z$i);

const InputTime = ({
  label,
  value,
  onChange,
  error,
  required = false,
  disabled = false,
  className = '',
  name,
  icon,
  autoFocus = false,
  onKeyDown
}) => {
  const handleChange = e => {
    onChange(e);
  };
  return /*#__PURE__*/jsxs("div", {
    className: `${css$h.inputContainer} ${className}`,
    children: [label && /*#__PURE__*/jsxs("label", {
      className: css$h.label,
      htmlFor: name,
      children: [label, required && /*#__PURE__*/jsx("span", {
        className: css$h.required,
        children: "*"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$h.inputWrapper,
      children: [icon && /*#__PURE__*/jsx("div", {
        className: css$h.iconContainer,
        children: icon
      }), /*#__PURE__*/jsx("input", {
        type: "time",
        value: value || '',
        onChange: handleChange,
        disabled: disabled,
        required: required,
        name: name,
        id: name,
        autoFocus: autoFocus,
        onKeyDown: onKeyDown,
        className: `${css$h.input} ${error ? css$h.error : ''} ${icon ? css$h.hasIcon : ''}`,
        "data-error": !!error
      })]
    }), error && /*#__PURE__*/jsx("span", {
      className: css$h.errorMessage,
      children: error
    })]
  });
};
InputTime.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node,
  autoFocus: PropTypes.bool,
  onKeyDown: PropTypes.func
};

/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function round(v) {
  return v + 0.5 | 0;
}
const lim = (v, l, h) => Math.max(Math.min(v, h), l);
function p2b(v) {
  return lim(round(v * 2.55), 0, 255);
}
function n2b(v) {
  return lim(round(v * 255), 0, 255);
}
function b2n(v) {
  return lim(round(v / 2.55) / 100, 0, 1);
}
function n2p(v) {
  return lim(round(v * 100), 0, 100);
}

const map$1 = {0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15};
const hex = [...'0123456789ABCDEF'];
const h1 = b => hex[b & 0xF];
const h2 = b => hex[(b & 0xF0) >> 4] + hex[b & 0xF];
const eq = b => ((b & 0xF0) >> 4) === (b & 0xF);
const isShort = v => eq(v.r) && eq(v.g) && eq(v.b) && eq(v.a);
function hexParse(str) {
  var len = str.length;
  var ret;
  if (str[0] === '#') {
    if (len === 4 || len === 5) {
      ret = {
        r: 255 & map$1[str[1]] * 17,
        g: 255 & map$1[str[2]] * 17,
        b: 255 & map$1[str[3]] * 17,
        a: len === 5 ? map$1[str[4]] * 17 : 255
      };
    } else if (len === 7 || len === 9) {
      ret = {
        r: map$1[str[1]] << 4 | map$1[str[2]],
        g: map$1[str[3]] << 4 | map$1[str[4]],
        b: map$1[str[5]] << 4 | map$1[str[6]],
        a: len === 9 ? (map$1[str[7]] << 4 | map$1[str[8]]) : 255
      };
    }
  }
  return ret;
}
const alpha = (a, f) => a < 255 ? f(a) : '';
function hexString(v) {
  var f = isShort(v) ? h1 : h2;
  return v
    ? '#' + f(v.r) + f(v.g) + f(v.b) + alpha(v.a, f)
    : undefined;
}

const HUE_RE = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function hsl2rgbn(h, s, l) {
  const a = s * Math.min(l, 1 - l);
  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  return [f(0), f(8), f(4)];
}
function hsv2rgbn(h, s, v) {
  const f = (n, k = (n + h / 60) % 6) => v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
  return [f(5), f(3), f(1)];
}
function hwb2rgbn(h, w, b) {
  const rgb = hsl2rgbn(h, 1, 0.5);
  let i;
  if (w + b > 1) {
    i = 1 / (w + b);
    w *= i;
    b *= i;
  }
  for (i = 0; i < 3; i++) {
    rgb[i] *= 1 - w - b;
    rgb[i] += w;
  }
  return rgb;
}
function hueValue(r, g, b, d, max) {
  if (r === max) {
    return ((g - b) / d) + (g < b ? 6 : 0);
  }
  if (g === max) {
    return (b - r) / d + 2;
  }
  return (r - g) / d + 4;
}
function rgb2hsl(v) {
  const range = 255;
  const r = v.r / range;
  const g = v.g / range;
  const b = v.b / range;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  let h, s, d;
  if (max !== min) {
    d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    h = hueValue(r, g, b, d, max);
    h = h * 60 + 0.5;
  }
  return [h | 0, s || 0, l];
}
function calln(f, a, b, c) {
  return (
    Array.isArray(a)
      ? f(a[0], a[1], a[2])
      : f(a, b, c)
  ).map(n2b);
}
function hsl2rgb(h, s, l) {
  return calln(hsl2rgbn, h, s, l);
}
function hwb2rgb(h, w, b) {
  return calln(hwb2rgbn, h, w, b);
}
function hsv2rgb(h, s, v) {
  return calln(hsv2rgbn, h, s, v);
}
function hue(h) {
  return (h % 360 + 360) % 360;
}
function hueParse(str) {
  const m = HUE_RE.exec(str);
  let a = 255;
  let v;
  if (!m) {
    return;
  }
  if (m[5] !== v) {
    a = m[6] ? p2b(+m[5]) : n2b(+m[5]);
  }
  const h = hue(+m[2]);
  const p1 = +m[3] / 100;
  const p2 = +m[4] / 100;
  if (m[1] === 'hwb') {
    v = hwb2rgb(h, p1, p2);
  } else if (m[1] === 'hsv') {
    v = hsv2rgb(h, p1, p2);
  } else {
    v = hsl2rgb(h, p1, p2);
  }
  return {
    r: v[0],
    g: v[1],
    b: v[2],
    a: a
  };
}
function rotate(v, deg) {
  var h = rgb2hsl(v);
  h[0] = hue(h[0] + deg);
  h = hsl2rgb(h);
  v.r = h[0];
  v.g = h[1];
  v.b = h[2];
}
function hslString(v) {
  if (!v) {
    return;
  }
  const a = rgb2hsl(v);
  const h = a[0];
  const s = n2p(a[1]);
  const l = n2p(a[2]);
  return v.a < 255
    ? `hsla(${h}, ${s}%, ${l}%, ${b2n(v.a)})`
    : `hsl(${h}, ${s}%, ${l}%)`;
}

const map = {
	x: 'dark',
	Z: 'light',
	Y: 're',
	X: 'blu',
	W: 'gr',
	V: 'medium',
	U: 'slate',
	A: 'ee',
	T: 'ol',
	S: 'or',
	B: 'ra',
	C: 'lateg',
	D: 'ights',
	R: 'in',
	Q: 'turquois',
	E: 'hi',
	P: 'ro',
	O: 'al',
	N: 'le',
	M: 'de',
	L: 'yello',
	F: 'en',
	K: 'ch',
	G: 'arks',
	H: 'ea',
	I: 'ightg',
	J: 'wh'
};
const names$1 = {
	OiceXe: 'f0f8ff',
	antiquewEte: 'faebd7',
	aqua: 'ffff',
	aquamarRe: '7fffd4',
	azuY: 'f0ffff',
	beige: 'f5f5dc',
	bisque: 'ffe4c4',
	black: '0',
	blanKedOmond: 'ffebcd',
	Xe: 'ff',
	XeviTet: '8a2be2',
	bPwn: 'a52a2a',
	burlywood: 'deb887',
	caMtXe: '5f9ea0',
	KartYuse: '7fff00',
	KocTate: 'd2691e',
	cSO: 'ff7f50',
	cSnflowerXe: '6495ed',
	cSnsilk: 'fff8dc',
	crimson: 'dc143c',
	cyan: 'ffff',
	xXe: '8b',
	xcyan: '8b8b',
	xgTMnPd: 'b8860b',
	xWay: 'a9a9a9',
	xgYF: '6400',
	xgYy: 'a9a9a9',
	xkhaki: 'bdb76b',
	xmagFta: '8b008b',
	xTivegYF: '556b2f',
	xSange: 'ff8c00',
	xScEd: '9932cc',
	xYd: '8b0000',
	xsOmon: 'e9967a',
	xsHgYF: '8fbc8f',
	xUXe: '483d8b',
	xUWay: '2f4f4f',
	xUgYy: '2f4f4f',
	xQe: 'ced1',
	xviTet: '9400d3',
	dAppRk: 'ff1493',
	dApskyXe: 'bfff',
	dimWay: '696969',
	dimgYy: '696969',
	dodgerXe: '1e90ff',
	fiYbrick: 'b22222',
	flSOwEte: 'fffaf0',
	foYstWAn: '228b22',
	fuKsia: 'ff00ff',
	gaRsbSo: 'dcdcdc',
	ghostwEte: 'f8f8ff',
	gTd: 'ffd700',
	gTMnPd: 'daa520',
	Way: '808080',
	gYF: '8000',
	gYFLw: 'adff2f',
	gYy: '808080',
	honeyMw: 'f0fff0',
	hotpRk: 'ff69b4',
	RdianYd: 'cd5c5c',
	Rdigo: '4b0082',
	ivSy: 'fffff0',
	khaki: 'f0e68c',
	lavFMr: 'e6e6fa',
	lavFMrXsh: 'fff0f5',
	lawngYF: '7cfc00',
	NmoncEffon: 'fffacd',
	ZXe: 'add8e6',
	ZcSO: 'f08080',
	Zcyan: 'e0ffff',
	ZgTMnPdLw: 'fafad2',
	ZWay: 'd3d3d3',
	ZgYF: '90ee90',
	ZgYy: 'd3d3d3',
	ZpRk: 'ffb6c1',
	ZsOmon: 'ffa07a',
	ZsHgYF: '20b2aa',
	ZskyXe: '87cefa',
	ZUWay: '778899',
	ZUgYy: '778899',
	ZstAlXe: 'b0c4de',
	ZLw: 'ffffe0',
	lime: 'ff00',
	limegYF: '32cd32',
	lRF: 'faf0e6',
	magFta: 'ff00ff',
	maPon: '800000',
	VaquamarRe: '66cdaa',
	VXe: 'cd',
	VScEd: 'ba55d3',
	VpurpN: '9370db',
	VsHgYF: '3cb371',
	VUXe: '7b68ee',
	VsprRggYF: 'fa9a',
	VQe: '48d1cc',
	VviTetYd: 'c71585',
	midnightXe: '191970',
	mRtcYam: 'f5fffa',
	mistyPse: 'ffe4e1',
	moccasR: 'ffe4b5',
	navajowEte: 'ffdead',
	navy: '80',
	Tdlace: 'fdf5e6',
	Tive: '808000',
	TivedBb: '6b8e23',
	Sange: 'ffa500',
	SangeYd: 'ff4500',
	ScEd: 'da70d6',
	pOegTMnPd: 'eee8aa',
	pOegYF: '98fb98',
	pOeQe: 'afeeee',
	pOeviTetYd: 'db7093',
	papayawEp: 'ffefd5',
	pHKpuff: 'ffdab9',
	peru: 'cd853f',
	pRk: 'ffc0cb',
	plum: 'dda0dd',
	powMrXe: 'b0e0e6',
	purpN: '800080',
	YbeccapurpN: '663399',
	Yd: 'ff0000',
	Psybrown: 'bc8f8f',
	PyOXe: '4169e1',
	saddNbPwn: '8b4513',
	sOmon: 'fa8072',
	sandybPwn: 'f4a460',
	sHgYF: '2e8b57',
	sHshell: 'fff5ee',
	siFna: 'a0522d',
	silver: 'c0c0c0',
	skyXe: '87ceeb',
	UXe: '6a5acd',
	UWay: '708090',
	UgYy: '708090',
	snow: 'fffafa',
	sprRggYF: 'ff7f',
	stAlXe: '4682b4',
	tan: 'd2b48c',
	teO: '8080',
	tEstN: 'd8bfd8',
	tomato: 'ff6347',
	Qe: '40e0d0',
	viTet: 'ee82ee',
	JHt: 'f5deb3',
	wEte: 'ffffff',
	wEtesmoke: 'f5f5f5',
	Lw: 'ffff00',
	LwgYF: '9acd32'
};
function unpack() {
  const unpacked = {};
  const keys = Object.keys(names$1);
  const tkeys = Object.keys(map);
  let i, j, k, ok, nk;
  for (i = 0; i < keys.length; i++) {
    ok = nk = keys[i];
    for (j = 0; j < tkeys.length; j++) {
      k = tkeys[j];
      nk = nk.replace(k, map[k]);
    }
    k = parseInt(names$1[ok], 16);
    unpacked[nk] = [k >> 16 & 0xFF, k >> 8 & 0xFF, k & 0xFF];
  }
  return unpacked;
}

let names;
function nameParse(str) {
  if (!names) {
    names = unpack();
    names.transparent = [0, 0, 0, 0];
  }
  const a = names[str.toLowerCase()];
  return a && {
    r: a[0],
    g: a[1],
    b: a[2],
    a: a.length === 4 ? a[3] : 255
  };
}

const RGB_RE = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function rgbParse(str) {
  const m = RGB_RE.exec(str);
  let a = 255;
  let r, g, b;
  if (!m) {
    return;
  }
  if (m[7] !== r) {
    const v = +m[7];
    a = m[8] ? p2b(v) : lim(v * 255, 0, 255);
  }
  r = +m[1];
  g = +m[3];
  b = +m[5];
  r = 255 & (m[2] ? p2b(r) : lim(r, 0, 255));
  g = 255 & (m[4] ? p2b(g) : lim(g, 0, 255));
  b = 255 & (m[6] ? p2b(b) : lim(b, 0, 255));
  return {
    r: r,
    g: g,
    b: b,
    a: a
  };
}
function rgbString(v) {
  return v && (
    v.a < 255
      ? `rgba(${v.r}, ${v.g}, ${v.b}, ${b2n(v.a)})`
      : `rgb(${v.r}, ${v.g}, ${v.b})`
  );
}

const to = v => v <= 0.0031308 ? v * 12.92 : Math.pow(v, 1.0 / 2.4) * 1.055 - 0.055;
const from = v => v <= 0.04045 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
function interpolate$1(rgb1, rgb2, t) {
  const r = from(b2n(rgb1.r));
  const g = from(b2n(rgb1.g));
  const b = from(b2n(rgb1.b));
  return {
    r: n2b(to(r + t * (from(b2n(rgb2.r)) - r))),
    g: n2b(to(g + t * (from(b2n(rgb2.g)) - g))),
    b: n2b(to(b + t * (from(b2n(rgb2.b)) - b))),
    a: rgb1.a + t * (rgb2.a - rgb1.a)
  };
}

function modHSL(v, i, ratio) {
  if (v) {
    let tmp = rgb2hsl(v);
    tmp[i] = Math.max(0, Math.min(tmp[i] + tmp[i] * ratio, i === 0 ? 360 : 1));
    tmp = hsl2rgb(tmp);
    v.r = tmp[0];
    v.g = tmp[1];
    v.b = tmp[2];
  }
}
function clone$1(v, proto) {
  return v ? Object.assign(proto || {}, v) : v;
}
function fromObject(input) {
  var v = {r: 0, g: 0, b: 0, a: 255};
  if (Array.isArray(input)) {
    if (input.length >= 3) {
      v = {r: input[0], g: input[1], b: input[2], a: 255};
      if (input.length > 3) {
        v.a = n2b(input[3]);
      }
    }
  } else {
    v = clone$1(input, {r: 0, g: 0, b: 0, a: 1});
    v.a = n2b(v.a);
  }
  return v;
}
function functionParse(str) {
  if (str.charAt(0) === 'r') {
    return rgbParse(str);
  }
  return hueParse(str);
}
class Color {
  constructor(input) {
    if (input instanceof Color) {
      return input;
    }
    const type = typeof input;
    let v;
    if (type === 'object') {
      v = fromObject(input);
    } else if (type === 'string') {
      v = hexParse(input) || nameParse(input) || functionParse(input);
    }
    this._rgb = v;
    this._valid = !!v;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var v = clone$1(this._rgb);
    if (v) {
      v.a = b2n(v.a);
    }
    return v;
  }
  set rgb(obj) {
    this._rgb = fromObject(obj);
  }
  rgbString() {
    return this._valid ? rgbString(this._rgb) : undefined;
  }
  hexString() {
    return this._valid ? hexString(this._rgb) : undefined;
  }
  hslString() {
    return this._valid ? hslString(this._rgb) : undefined;
  }
  mix(color, weight) {
    if (color) {
      const c1 = this.rgb;
      const c2 = color.rgb;
      let w2;
      const p = weight === w2 ? 0.5 : weight;
      const w = 2 * p - 1;
      const a = c1.a - c2.a;
      const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
      w2 = 1 - w1;
      c1.r = 0xFF & w1 * c1.r + w2 * c2.r + 0.5;
      c1.g = 0xFF & w1 * c1.g + w2 * c2.g + 0.5;
      c1.b = 0xFF & w1 * c1.b + w2 * c2.b + 0.5;
      c1.a = p * c1.a + (1 - p) * c2.a;
      this.rgb = c1;
    }
    return this;
  }
  interpolate(color, t) {
    if (color) {
      this._rgb = interpolate$1(this._rgb, color._rgb, t);
    }
    return this;
  }
  clone() {
    return new Color(this.rgb);
  }
  alpha(a) {
    this._rgb.a = n2b(a);
    return this;
  }
  clearer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 - ratio;
    return this;
  }
  greyscale() {
    const rgb = this._rgb;
    const val = round(rgb.r * 0.3 + rgb.g * 0.59 + rgb.b * 0.11);
    rgb.r = rgb.g = rgb.b = val;
    return this;
  }
  opaquer(ratio) {
    const rgb = this._rgb;
    rgb.a *= 1 + ratio;
    return this;
  }
  negate() {
    const v = this._rgb;
    v.r = 255 - v.r;
    v.g = 255 - v.g;
    v.b = 255 - v.b;
    return this;
  }
  lighten(ratio) {
    modHSL(this._rgb, 2, ratio);
    return this;
  }
  darken(ratio) {
    modHSL(this._rgb, 2, -ratio);
    return this;
  }
  saturate(ratio) {
    modHSL(this._rgb, 1, ratio);
    return this;
  }
  desaturate(ratio) {
    modHSL(this._rgb, 1, -ratio);
    return this;
  }
  rotate(deg) {
    rotate(this._rgb, deg);
    return this;
  }
}

/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */

/**
 * @namespace Chart.helpers
 */ /**
 * An empty function that can be used, for example, for optional callback.
 */ function noop() {
/* noop */ }
/**
 * Returns a unique id, sequentially generated from a global variable.
 */ const uid = (()=>{
    let id = 0;
    return ()=>id++;
})();
/**
 * Returns true if `value` is neither null nor undefined, else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isNullOrUndef(value) {
    return value === null || value === undefined;
}
/**
 * Returns true if `value` is an array (including typed arrays), else returns false.
 * @param value - The value to test.
 * @function
 */ function isArray(value) {
    if (Array.isArray && Array.isArray(value)) {
        return true;
    }
    const type = Object.prototype.toString.call(value);
    if (type.slice(0, 7) === '[object' && type.slice(-6) === 'Array]') {
        return true;
    }
    return false;
}
/**
 * Returns true if `value` is an object (excluding null), else returns false.
 * @param value - The value to test.
 * @since 2.7.0
 */ function isObject(value) {
    return value !== null && Object.prototype.toString.call(value) === '[object Object]';
}
/**
 * Returns true if `value` is a finite number, else returns false
 * @param value  - The value to test.
 */ function isNumberFinite(value) {
    return (typeof value === 'number' || value instanceof Number) && isFinite(+value);
}
/**
 * Returns `value` if finite, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is not finite.
 */ function finiteOrDefault(value, defaultValue) {
    return isNumberFinite(value) ? value : defaultValue;
}
/**
 * Returns `value` if defined, else returns `defaultValue`.
 * @param value - The value to return if defined.
 * @param defaultValue - The value to return if `value` is undefined.
 */ function valueOrDefault(value, defaultValue) {
    return typeof value === 'undefined' ? defaultValue : value;
}
const toPercentage = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 : +value / dimension;
const toDimension = (value, dimension)=>typeof value === 'string' && value.endsWith('%') ? parseFloat(value) / 100 * dimension : +value;
/**
 * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
 * value returned by `fn`. If `fn` is not a function, this method returns undefined.
 * @param fn - The function to call.
 * @param args - The arguments with which `fn` should be called.
 * @param [thisArg] - The value of `this` provided for the call to `fn`.
 */ function callback(fn, args, thisArg) {
    if (fn && typeof fn.call === 'function') {
        return fn.apply(thisArg, args);
    }
}
function each(loopable, fn, thisArg, reverse) {
    let i, len, keys;
    if (isArray(loopable)) {
        len = loopable.length;
        if (reverse) {
            for(i = len - 1; i >= 0; i--){
                fn.call(thisArg, loopable[i], i);
            }
        } else {
            for(i = 0; i < len; i++){
                fn.call(thisArg, loopable[i], i);
            }
        }
    } else if (isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for(i = 0; i < len; i++){
            fn.call(thisArg, loopable[keys[i]], keys[i]);
        }
    }
}
/**
 * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
 * @param a0 - The array to compare
 * @param a1 - The array to compare
 * @private
 */ function _elementsEqual(a0, a1) {
    let i, ilen, v0, v1;
    if (!a0 || !a1 || a0.length !== a1.length) {
        return false;
    }
    for(i = 0, ilen = a0.length; i < ilen; ++i){
        v0 = a0[i];
        v1 = a1[i];
        if (v0.datasetIndex !== v1.datasetIndex || v0.index !== v1.index) {
            return false;
        }
    }
    return true;
}
/**
 * Returns a deep copy of `source` without keeping references on objects and arrays.
 * @param source - The value to clone.
 */ function clone(source) {
    if (isArray(source)) {
        return source.map(clone);
    }
    if (isObject(source)) {
        const target = Object.create(null);
        const keys = Object.keys(source);
        const klen = keys.length;
        let k = 0;
        for(; k < klen; ++k){
            target[keys[k]] = clone(source[keys[k]]);
        }
        return target;
    }
    return source;
}
function isValidKey(key) {
    return [
        '__proto__',
        'prototype',
        'constructor'
    ].indexOf(key) === -1;
}
/**
 * The default merger when Chart.helpers.merge is called without merger option.
 * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
 * @private
 */ function _merger(key, target, source, options) {
    if (!isValidKey(key)) {
        return;
    }
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        merge(tval, sval, options);
    } else {
        target[key] = clone(sval);
    }
}
function merge(target, source, options) {
    const sources = isArray(source) ? source : [
        source
    ];
    const ilen = sources.length;
    if (!isObject(target)) {
        return target;
    }
    options = options || {};
    const merger = options.merger || _merger;
    let current;
    for(let i = 0; i < ilen; ++i){
        current = sources[i];
        if (!isObject(current)) {
            continue;
        }
        const keys = Object.keys(current);
        for(let k = 0, klen = keys.length; k < klen; ++k){
            merger(keys[k], target, current, options);
        }
    }
    return target;
}
function mergeIf(target, source) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return merge(target, source, {
        merger: _mergerIf
    });
}
/**
 * Merges source[key] in target[key] only if target[key] is undefined.
 * @private
 */ function _mergerIf(key, target, source) {
    if (!isValidKey(key)) {
        return;
    }
    const tval = target[key];
    const sval = source[key];
    if (isObject(tval) && isObject(sval)) {
        mergeIf(tval, sval);
    } else if (!Object.prototype.hasOwnProperty.call(target, key)) {
        target[key] = clone(sval);
    }
}
// resolveObjectKey resolver cache
const keyResolvers = {
    // Chart.helpers.core resolveObjectKey should resolve empty key to root object
    '': (v)=>v,
    // default resolvers
    x: (o)=>o.x,
    y: (o)=>o.y
};
/**
 * @private
 */ function _splitKey(key) {
    const parts = key.split('.');
    const keys = [];
    let tmp = '';
    for (const part of parts){
        tmp += part;
        if (tmp.endsWith('\\')) {
            tmp = tmp.slice(0, -1) + '.';
        } else {
            keys.push(tmp);
            tmp = '';
        }
    }
    return keys;
}
function _getKeyResolver(key) {
    const keys = _splitKey(key);
    return (obj)=>{
        for (const k of keys){
            if (k === '') {
                break;
            }
            obj = obj && obj[k];
        }
        return obj;
    };
}
function resolveObjectKey(obj, key) {
    const resolver = keyResolvers[key] || (keyResolvers[key] = _getKeyResolver(key));
    return resolver(obj);
}
/**
 * @private
 */ function _capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
const defined = (value)=>typeof value !== 'undefined';
const isFunction = (value)=>typeof value === 'function';
// Adapted from https://stackoverflow.com/questions/31128855/comparing-ecma6-sets-for-equality#31129384
const setsEqual = (a, b)=>{
    if (a.size !== b.size) {
        return false;
    }
    for (const item of a){
        if (!b.has(item)) {
            return false;
        }
    }
    return true;
};
/**
 * @param e - The event
 * @private
 */ function _isClickEvent(e) {
    return e.type === 'mouseup' || e.type === 'click' || e.type === 'contextmenu';
}

/**
 * @alias Chart.helpers.math
 * @namespace
 */ const PI = Math.PI;
const TAU = 2 * PI;
const PITAU = TAU + PI;
const INFINITY = Number.POSITIVE_INFINITY;
const RAD_PER_DEG = PI / 180;
const HALF_PI = PI / 2;
const QUARTER_PI = PI / 4;
const TWO_THIRDS_PI = PI * 2 / 3;
const log10 = Math.log10;
const sign = Math.sign;
function almostEquals(x, y, epsilon) {
    return Math.abs(x - y) < epsilon;
}
/**
 * Implementation of the nice number algorithm used in determining where axis labels will go
 */ function niceNum(range) {
    const roundedRange = Math.round(range);
    range = almostEquals(range, roundedRange, range / 1000) ? roundedRange : range;
    const niceRange = Math.pow(10, Math.floor(log10(range)));
    const fraction = range / niceRange;
    const niceFraction = fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10;
    return niceFraction * niceRange;
}
/**
 * Returns an array of factors sorted from 1 to sqrt(value)
 * @private
 */ function _factorize(value) {
    const result = [];
    const sqrt = Math.sqrt(value);
    let i;
    for(i = 1; i < sqrt; i++){
        if (value % i === 0) {
            result.push(i);
            result.push(value / i);
        }
    }
    if (sqrt === (sqrt | 0)) {
        result.push(sqrt);
    }
    result.sort((a, b)=>a - b).pop();
    return result;
}
/**
 * Verifies that attempting to coerce n to string or number won't throw a TypeError.
 */ function isNonPrimitive(n) {
    return typeof n === 'symbol' || typeof n === 'object' && n !== null && !(Symbol.toPrimitive in n || 'toString' in n || 'valueOf' in n);
}
function isNumber(n) {
    return !isNonPrimitive(n) && !isNaN(parseFloat(n)) && isFinite(n);
}
function almostWhole(x, epsilon) {
    const rounded = Math.round(x);
    return rounded - epsilon <= x && rounded + epsilon >= x;
}
/**
 * @private
 */ function _setMinAndMaxByKey(array, target, property) {
    let i, ilen, value;
    for(i = 0, ilen = array.length; i < ilen; i++){
        value = array[i][property];
        if (!isNaN(value)) {
            target.min = Math.min(target.min, value);
            target.max = Math.max(target.max, value);
        }
    }
}
function toRadians(degrees) {
    return degrees * (PI / 180);
}
function toDegrees(radians) {
    return radians * (180 / PI);
}
/**
 * Returns the number of decimal places
 * i.e. the number of digits after the decimal point, of the value of this Number.
 * @param x - A number.
 * @returns The number of decimal places.
 * @private
 */ function _decimalPlaces(x) {
    if (!isNumberFinite(x)) {
        return;
    }
    let e = 1;
    let p = 0;
    while(Math.round(x * e) / e !== x){
        e *= 10;
        p++;
    }
    return p;
}
// Gets the angle from vertical upright to the point about a centre.
function getAngleFromPoint(centrePoint, anglePoint) {
    const distanceFromXCenter = anglePoint.x - centrePoint.x;
    const distanceFromYCenter = anglePoint.y - centrePoint.y;
    const radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
    let angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
    if (angle < -0.5 * PI) {
        angle += TAU; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
    }
    return {
        angle,
        distance: radialDistanceFromCenter
    };
}
function distanceBetweenPoints(pt1, pt2) {
    return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
}
/**
 * Shortest distance between angles, in either direction.
 * @private
 */ function _angleDiff(a, b) {
    return (a - b + PITAU) % TAU - PI;
}
/**
 * Normalize angle to be between 0 and 2*PI
 * @private
 */ function _normalizeAngle(a) {
    return (a % TAU + TAU) % TAU;
}
/**
 * @private
 */ function _angleBetween(angle, start, end, sameAngleIsFullCircle) {
    const a = _normalizeAngle(angle);
    const s = _normalizeAngle(start);
    const e = _normalizeAngle(end);
    const angleToStart = _normalizeAngle(s - a);
    const angleToEnd = _normalizeAngle(e - a);
    const startToAngle = _normalizeAngle(a - s);
    const endToAngle = _normalizeAngle(a - e);
    return a === s || a === e || sameAngleIsFullCircle && s === e || angleToStart > angleToEnd && startToAngle < endToAngle;
}
/**
 * Limit `value` between `min` and `max`
 * @param value
 * @param min
 * @param max
 * @private
 */ function _limitValue(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * @param {number} value
 * @private
 */ function _int16Range(value) {
    return _limitValue(value, -32768, 32767);
}
/**
 * @param value
 * @param start
 * @param end
 * @param [epsilon]
 * @private
 */ function _isBetween(value, start, end, epsilon = 1e-6) {
    return value >= Math.min(start, end) - epsilon && value <= Math.max(start, end) + epsilon;
}

function _lookup(table, value, cmp) {
    cmp = cmp || ((index)=>table[index] < value);
    let hi = table.length - 1;
    let lo = 0;
    let mid;
    while(hi - lo > 1){
        mid = lo + hi >> 1;
        if (cmp(mid)) {
            lo = mid;
        } else {
            hi = mid;
        }
    }
    return {
        lo,
        hi
    };
}
/**
 * Binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @param last - lookup last index
 * @private
 */ const _lookupByKey = (table, key, value, last)=>_lookup(table, value, last ? (index)=>{
        const ti = table[index][key];
        return ti < value || ti === value && table[index + 1][key] === value;
    } : (index)=>table[index][key] < value);
/**
 * Reverse binary search
 * @param table - the table search. must be sorted!
 * @param key - property name for the value in each entry
 * @param value - value to find
 * @private
 */ const _rlookupByKey = (table, key, value)=>_lookup(table, value, (index)=>table[index][key] >= value);
/**
 * Return subset of `values` between `min` and `max` inclusive.
 * Values are assumed to be in sorted order.
 * @param values - sorted array of values
 * @param min - min value
 * @param max - max value
 */ function _filterBetween(values, min, max) {
    let start = 0;
    let end = values.length;
    while(start < end && values[start] < min){
        start++;
    }
    while(end > start && values[end - 1] > max){
        end--;
    }
    return start > 0 || end < values.length ? values.slice(start, end) : values;
}
const arrayEvents = [
    'push',
    'pop',
    'shift',
    'splice',
    'unshift'
];
function listenArrayEvents(array, listener) {
    if (array._chartjs) {
        array._chartjs.listeners.push(listener);
        return;
    }
    Object.defineProperty(array, '_chartjs', {
        configurable: true,
        enumerable: false,
        value: {
            listeners: [
                listener
            ]
        }
    });
    arrayEvents.forEach((key)=>{
        const method = '_onData' + _capitalize(key);
        const base = array[key];
        Object.defineProperty(array, key, {
            configurable: true,
            enumerable: false,
            value (...args) {
                const res = base.apply(this, args);
                array._chartjs.listeners.forEach((object)=>{
                    if (typeof object[method] === 'function') {
                        object[method](...args);
                    }
                });
                return res;
            }
        });
    });
}
function unlistenArrayEvents(array, listener) {
    const stub = array._chartjs;
    if (!stub) {
        return;
    }
    const listeners = stub.listeners;
    const index = listeners.indexOf(listener);
    if (index !== -1) {
        listeners.splice(index, 1);
    }
    if (listeners.length > 0) {
        return;
    }
    arrayEvents.forEach((key)=>{
        delete array[key];
    });
    delete array._chartjs;
}
/**
 * @param items
 */ function _arrayUnique(items) {
    const set = new Set(items);
    if (set.size === items.length) {
        return items;
    }
    return Array.from(set);
}
/**
* Request animation polyfill
*/ const requestAnimFrame = function() {
    if (typeof window === 'undefined') {
        return function(callback) {
            return callback();
        };
    }
    return window.requestAnimationFrame;
}();
/**
 * Throttles calling `fn` once per animation frame
 * Latest arguments are used on the actual call
 */ function throttled(fn, thisArg) {
    let argsToUse = [];
    let ticking = false;
    return function(...args) {
        // Save the args for use later
        argsToUse = args;
        if (!ticking) {
            ticking = true;
            requestAnimFrame.call(window, ()=>{
                ticking = false;
                fn.apply(thisArg, argsToUse);
            });
        }
    };
}
/**
 * Debounces calling `fn` for `delay` ms
 */ function debounce(fn, delay) {
    let timeout;
    return function(...args) {
        if (delay) {
            clearTimeout(timeout);
            timeout = setTimeout(fn, delay, args);
        } else {
            fn.apply(this, args);
        }
        return delay;
    };
}
/**
 * Converts 'start' to 'left', 'end' to 'right' and others to 'center'
 * @private
 */ const _toLeftRightCenter = (align)=>align === 'start' ? 'left' : align === 'end' ? 'right' : 'center';
/**
 * Returns `start`, `end` or `(start + end) / 2` depending on `align`. Defaults to `center`
 * @private
 */ const _alignStartEnd = (align, start, end)=>align === 'start' ? start : align === 'end' ? end : (start + end) / 2;
/**
 * Returns `left`, `right` or `(left + right) / 2` depending on `align`. Defaults to `left`
 * @private
 */ const _textX = (align, left, right, rtl)=>{
    const check = rtl ? 'left' : 'right';
    return align === check ? right : align === 'center' ? (left + right) / 2 : left;
};
/**
 * Return start and count of visible points.
 * @private
 */ function _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled) {
    const pointCount = points.length;
    let start = 0;
    let count = pointCount;
    if (meta._sorted) {
        const { iScale , vScale , _parsed  } = meta;
        const spanGaps = meta.dataset ? meta.dataset.options ? meta.dataset.options.spanGaps : null : null;
        const axis = iScale.axis;
        const { min , max , minDefined , maxDefined  } = iScale.getUserBounds();
        if (minDefined) {
            start = Math.min(// @ts-expect-error Need to type _parsed
            _lookupByKey(_parsed, axis, min).lo, // @ts-expect-error Need to fix types on _lookupByKey
            animationsDisabled ? pointCount : _lookupByKey(points, axis, iScale.getPixelForValue(min)).lo);
            if (spanGaps) {
                const distanceToDefinedLo = _parsed.slice(0, start + 1).reverse().findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                start -= Math.max(0, distanceToDefinedLo);
            }
            start = _limitValue(start, 0, pointCount - 1);
        }
        if (maxDefined) {
            let end = Math.max(// @ts-expect-error Need to type _parsed
            _lookupByKey(_parsed, iScale.axis, max, true).hi + 1, // @ts-expect-error Need to fix types on _lookupByKey
            animationsDisabled ? 0 : _lookupByKey(points, axis, iScale.getPixelForValue(max), true).hi + 1);
            if (spanGaps) {
                const distanceToDefinedHi = _parsed.slice(end - 1).findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                end += Math.max(0, distanceToDefinedHi);
            }
            count = _limitValue(end, start, pointCount) - start;
        } else {
            count = pointCount - start;
        }
    }
    return {
        start,
        count
    };
}
/**
 * Checks if the scale ranges have changed.
 * @param {object} meta - dataset meta.
 * @returns {boolean}
 * @private
 */ function _scaleRangesChanged(meta) {
    const { xScale , yScale , _scaleRanges  } = meta;
    const newRanges = {
        xmin: xScale.min,
        xmax: xScale.max,
        ymin: yScale.min,
        ymax: yScale.max
    };
    if (!_scaleRanges) {
        meta._scaleRanges = newRanges;
        return true;
    }
    const changed = _scaleRanges.xmin !== xScale.min || _scaleRanges.xmax !== xScale.max || _scaleRanges.ymin !== yScale.min || _scaleRanges.ymax !== yScale.max;
    Object.assign(_scaleRanges, newRanges);
    return changed;
}

const atEdge = (t)=>t === 0 || t === 1;
const elasticIn = (t, s, p)=>-(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * TAU / p));
const elasticOut = (t, s, p)=>Math.pow(2, -10 * t) * Math.sin((t - s) * TAU / p) + 1;
/**
 * Easing functions adapted from Robert Penner's easing equations.
 * @namespace Chart.helpers.easing.effects
 * @see http://www.robertpenner.com/easing/
 */ const effects = {
    linear: (t)=>t,
    easeInQuad: (t)=>t * t,
    easeOutQuad: (t)=>-t * (t - 2),
    easeInOutQuad: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
    easeInCubic: (t)=>t * t * t,
    easeOutCubic: (t)=>(t -= 1) * t * t + 1,
    easeInOutCubic: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
    easeInQuart: (t)=>t * t * t * t,
    easeOutQuart: (t)=>-((t -= 1) * t * t * t - 1),
    easeInOutQuart: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
    easeInQuint: (t)=>t * t * t * t * t,
    easeOutQuint: (t)=>(t -= 1) * t * t * t * t + 1,
    easeInOutQuint: (t)=>(t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
    easeInSine: (t)=>-Math.cos(t * HALF_PI) + 1,
    easeOutSine: (t)=>Math.sin(t * HALF_PI),
    easeInOutSine: (t)=>-0.5 * (Math.cos(PI * t) - 1),
    easeInExpo: (t)=>t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
    easeOutExpo: (t)=>t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
    easeInOutExpo: (t)=>atEdge(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
    easeInCirc: (t)=>t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
    easeOutCirc: (t)=>Math.sqrt(1 - (t -= 1) * t),
    easeInOutCirc: (t)=>(t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
    easeInElastic: (t)=>atEdge(t) ? t : elasticIn(t, 0.075, 0.3),
    easeOutElastic: (t)=>atEdge(t) ? t : elasticOut(t, 0.075, 0.3),
    easeInOutElastic (t) {
        const s = 0.1125;
        const p = 0.45;
        return atEdge(t) ? t : t < 0.5 ? 0.5 * elasticIn(t * 2, s, p) : 0.5 + 0.5 * elasticOut(t * 2 - 1, s, p);
    },
    easeInBack (t) {
        const s = 1.70158;
        return t * t * ((s + 1) * t - s);
    },
    easeOutBack (t) {
        const s = 1.70158;
        return (t -= 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack (t) {
        let s = 1.70158;
        if ((t /= 0.5) < 1) {
            return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
        }
        return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: (t)=>1 - effects.easeOutBounce(1 - t),
    easeOutBounce (t) {
        const m = 7.5625;
        const d = 2.75;
        if (t < 1 / d) {
            return m * t * t;
        }
        if (t < 2 / d) {
            return m * (t -= 1.5 / d) * t + 0.75;
        }
        if (t < 2.5 / d) {
            return m * (t -= 2.25 / d) * t + 0.9375;
        }
        return m * (t -= 2.625 / d) * t + 0.984375;
    },
    easeInOutBounce: (t)=>t < 0.5 ? effects.easeInBounce(t * 2) * 0.5 : effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};

function isPatternOrGradient(value) {
    if (value && typeof value === 'object') {
        const type = value.toString();
        return type === '[object CanvasPattern]' || type === '[object CanvasGradient]';
    }
    return false;
}
function color(value) {
    return isPatternOrGradient(value) ? value : new Color(value);
}
function getHoverColor(value) {
    return isPatternOrGradient(value) ? value : new Color(value).saturate(0.5).darken(0.1).hexString();
}

const numbers = [
    'x',
    'y',
    'borderWidth',
    'radius',
    'tension'
];
const colors = [
    'color',
    'borderColor',
    'backgroundColor'
];
function applyAnimationsDefaults(defaults) {
    defaults.set('animation', {
        delay: undefined,
        duration: 1000,
        easing: 'easeOutQuart',
        fn: undefined,
        from: undefined,
        loop: undefined,
        to: undefined,
        type: undefined
    });
    defaults.describe('animation', {
        _fallback: false,
        _indexable: false,
        _scriptable: (name)=>name !== 'onProgress' && name !== 'onComplete' && name !== 'fn'
    });
    defaults.set('animations', {
        colors: {
            type: 'color',
            properties: colors
        },
        numbers: {
            type: 'number',
            properties: numbers
        }
    });
    defaults.describe('animations', {
        _fallback: 'animation'
    });
    defaults.set('transitions', {
        active: {
            animation: {
                duration: 400
            }
        },
        resize: {
            animation: {
                duration: 0
            }
        },
        show: {
            animations: {
                colors: {
                    from: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    duration: 0
                }
            }
        },
        hide: {
            animations: {
                colors: {
                    to: 'transparent'
                },
                visible: {
                    type: 'boolean',
                    easing: 'linear',
                    fn: (v)=>v | 0
                }
            }
        }
    });
}

function applyLayoutsDefaults(defaults) {
    defaults.set('layout', {
        autoPadding: true,
        padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    });
}

const intlCache = new Map();
function getNumberFormat(locale, options) {
    options = options || {};
    const cacheKey = locale + JSON.stringify(options);
    let formatter = intlCache.get(cacheKey);
    if (!formatter) {
        formatter = new Intl.NumberFormat(locale, options);
        intlCache.set(cacheKey, formatter);
    }
    return formatter;
}
function formatNumber(num, locale, options) {
    return getNumberFormat(locale, options).format(num);
}

const formatters = {
 values (value) {
        return isArray(value) ?  value : '' + value;
    },
 numeric (tickValue, index, ticks) {
        if (tickValue === 0) {
            return '0';
        }
        const locale = this.chart.options.locale;
        let notation;
        let delta = tickValue;
        if (ticks.length > 1) {
            const maxTick = Math.max(Math.abs(ticks[0].value), Math.abs(ticks[ticks.length - 1].value));
            if (maxTick < 1e-4 || maxTick > 1e+15) {
                notation = 'scientific';
            }
            delta = calculateDelta(tickValue, ticks);
        }
        const logDelta = log10(Math.abs(delta));
        const numDecimal = isNaN(logDelta) ? 1 : Math.max(Math.min(-1 * Math.floor(logDelta), 20), 0);
        const options = {
            notation,
            minimumFractionDigits: numDecimal,
            maximumFractionDigits: numDecimal
        };
        Object.assign(options, this.options.ticks.format);
        return formatNumber(tickValue, locale, options);
    },
 logarithmic (tickValue, index, ticks) {
        if (tickValue === 0) {
            return '0';
        }
        const remain = ticks[index].significand || tickValue / Math.pow(10, Math.floor(log10(tickValue)));
        if ([
            1,
            2,
            3,
            5,
            10,
            15
        ].includes(remain) || index > 0.8 * ticks.length) {
            return formatters.numeric.call(this, tickValue, index, ticks);
        }
        return '';
    }
};
function calculateDelta(tickValue, ticks) {
    let delta = ticks.length > 3 ? ticks[2].value - ticks[1].value : ticks[1].value - ticks[0].value;
    if (Math.abs(delta) >= 1 && tickValue !== Math.floor(tickValue)) {
        delta = tickValue - Math.floor(tickValue);
    }
    return delta;
}
 var Ticks = {
    formatters
};

function applyScaleDefaults(defaults) {
    defaults.set('scale', {
        display: true,
        offset: false,
        reverse: false,
        beginAtZero: false,
 bounds: 'ticks',
        clip: true,
 grace: 0,
        grid: {
            display: true,
            lineWidth: 1,
            drawOnChartArea: true,
            drawTicks: true,
            tickLength: 8,
            tickWidth: (_ctx, options)=>options.lineWidth,
            tickColor: (_ctx, options)=>options.color,
            offset: false
        },
        border: {
            display: true,
            dash: [],
            dashOffset: 0.0,
            width: 1
        },
        title: {
            display: false,
            text: '',
            padding: {
                top: 4,
                bottom: 4
            }
        },
        ticks: {
            minRotation: 0,
            maxRotation: 50,
            mirror: false,
            textStrokeWidth: 0,
            textStrokeColor: '',
            padding: 3,
            display: true,
            autoSkip: true,
            autoSkipPadding: 3,
            labelOffset: 0,
            callback: Ticks.formatters.values,
            minor: {},
            major: {},
            align: 'center',
            crossAlign: 'near',
            showLabelBackdrop: false,
            backdropColor: 'rgba(255, 255, 255, 0.75)',
            backdropPadding: 2
        }
    });
    defaults.route('scale.ticks', 'color', '', 'color');
    defaults.route('scale.grid', 'color', '', 'borderColor');
    defaults.route('scale.border', 'color', '', 'borderColor');
    defaults.route('scale.title', 'color', '', 'color');
    defaults.describe('scale', {
        _fallback: false,
        _scriptable: (name)=>!name.startsWith('before') && !name.startsWith('after') && name !== 'callback' && name !== 'parser',
        _indexable: (name)=>name !== 'borderDash' && name !== 'tickBorderDash' && name !== 'dash'
    });
    defaults.describe('scales', {
        _fallback: 'scale'
    });
    defaults.describe('scale.ticks', {
        _scriptable: (name)=>name !== 'backdropPadding' && name !== 'callback',
        _indexable: (name)=>name !== 'backdropPadding'
    });
}

const overrides = Object.create(null);
const descriptors = Object.create(null);
 function getScope$1(node, key) {
    if (!key) {
        return node;
    }
    const keys = key.split('.');
    for(let i = 0, n = keys.length; i < n; ++i){
        const k = keys[i];
        node = node[k] || (node[k] = Object.create(null));
    }
    return node;
}
function set(root, scope, values) {
    if (typeof scope === 'string') {
        return merge(getScope$1(root, scope), values);
    }
    return merge(getScope$1(root, ''), scope);
}
 class Defaults {
    constructor(_descriptors, _appliers){
        this.animation = undefined;
        this.backgroundColor = 'rgba(0,0,0,0.1)';
        this.borderColor = 'rgba(0,0,0,0.1)';
        this.color = '#666';
        this.datasets = {};
        this.devicePixelRatio = (context)=>context.chart.platform.getDevicePixelRatio();
        this.elements = {};
        this.events = [
            'mousemove',
            'mouseout',
            'click',
            'touchstart',
            'touchmove'
        ];
        this.font = {
            family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            size: 12,
            style: 'normal',
            lineHeight: 1.2,
            weight: null
        };
        this.hover = {};
        this.hoverBackgroundColor = (ctx, options)=>getHoverColor(options.backgroundColor);
        this.hoverBorderColor = (ctx, options)=>getHoverColor(options.borderColor);
        this.hoverColor = (ctx, options)=>getHoverColor(options.color);
        this.indexAxis = 'x';
        this.interaction = {
            mode: 'nearest',
            intersect: true,
            includeInvisible: false
        };
        this.maintainAspectRatio = true;
        this.onHover = null;
        this.onClick = null;
        this.parsing = true;
        this.plugins = {};
        this.responsive = true;
        this.scale = undefined;
        this.scales = {};
        this.showLine = true;
        this.drawActiveElementsOnTop = true;
        this.describe(_descriptors);
        this.apply(_appliers);
    }
 set(scope, values) {
        return set(this, scope, values);
    }
 get(scope) {
        return getScope$1(this, scope);
    }
 describe(scope, values) {
        return set(descriptors, scope, values);
    }
    override(scope, values) {
        return set(overrides, scope, values);
    }
 route(scope, name, targetScope, targetName) {
        const scopeObject = getScope$1(this, scope);
        const targetScopeObject = getScope$1(this, targetScope);
        const privateName = '_' + name;
        Object.defineProperties(scopeObject, {
            [privateName]: {
                value: scopeObject[name],
                writable: true
            },
            [name]: {
                enumerable: true,
                get () {
                    const local = this[privateName];
                    const target = targetScopeObject[targetName];
                    if (isObject(local)) {
                        return Object.assign({}, target, local);
                    }
                    return valueOrDefault(local, target);
                },
                set (value) {
                    this[privateName] = value;
                }
            }
        });
    }
    apply(appliers) {
        appliers.forEach((apply)=>apply(this));
    }
}
var defaults = /* #__PURE__ */ new Defaults({
    _scriptable: (name)=>!name.startsWith('on'),
    _indexable: (name)=>name !== 'events',
    hover: {
        _fallback: 'interaction'
    },
    interaction: {
        _scriptable: false,
        _indexable: false
    }
}, [
    applyAnimationsDefaults,
    applyLayoutsDefaults,
    applyScaleDefaults
]);

/**
 * Converts the given font object into a CSS font string.
 * @param font - A font object.
 * @return The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
 * @private
 */ function toFontString(font) {
    if (!font || isNullOrUndef(font.size) || isNullOrUndef(font.family)) {
        return null;
    }
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
}
/**
 * @private
 */ function _measureText(ctx, data, gc, longest, string) {
    let textWidth = data[string];
    if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
    }
    if (textWidth > longest) {
        longest = textWidth;
    }
    return longest;
}
/**
 * @private
 */ // eslint-disable-next-line complexity
function _longestText(ctx, font, arrayOfThings, cache) {
    cache = cache || {};
    let data = cache.data = cache.data || {};
    let gc = cache.garbageCollect = cache.garbageCollect || [];
    if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
    }
    ctx.save();
    ctx.font = font;
    let longest = 0;
    const ilen = arrayOfThings.length;
    let i, j, jlen, thing, nestedThing;
    for(i = 0; i < ilen; i++){
        thing = arrayOfThings[i];
        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && !isArray(thing)) {
            longest = _measureText(ctx, data, gc, longest, thing);
        } else if (isArray(thing)) {
            // if it is an array lets measure each element
            // to do maybe simplify this function a bit so we can do this more recursively?
            for(j = 0, jlen = thing.length; j < jlen; j++){
                nestedThing = thing[j];
                // Undefined strings and arrays should not be measured
                if (nestedThing !== undefined && nestedThing !== null && !isArray(nestedThing)) {
                    longest = _measureText(ctx, data, gc, longest, nestedThing);
                }
            }
        }
    }
    ctx.restore();
    const gcLen = gc.length / 2;
    if (gcLen > arrayOfThings.length) {
        for(i = 0; i < gcLen; i++){
            delete data[gc[i]];
        }
        gc.splice(0, gcLen);
    }
    return longest;
}
/**
 * Returns the aligned pixel value to avoid anti-aliasing blur
 * @param chart - The chart instance.
 * @param pixel - A pixel value.
 * @param width - The width of the element.
 * @returns The aligned pixel value.
 * @private
 */ function _alignPixel(chart, pixel, width) {
    const devicePixelRatio = chart.currentDevicePixelRatio;
    const halfWidth = width !== 0 ? Math.max(width / 2, 0.5) : 0;
    return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
}
/**
 * Clears the entire canvas.
 */ function clearCanvas(canvas, ctx) {
    if (!ctx && !canvas) {
        return;
    }
    ctx = ctx || canvas.getContext('2d');
    ctx.save();
    // canvas.width and canvas.height do not consider the canvas transform,
    // while clearRect does
    ctx.resetTransform();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.restore();
}
function drawPoint(ctx, options, x, y) {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    drawPointLegend(ctx, options, x, y, null);
}
// eslint-disable-next-line complexity
function drawPointLegend(ctx, options, x, y, w) {
    let type, xOffset, yOffset, size, cornerRadius, width, xOffsetW, yOffsetW;
    const style = options.pointStyle;
    const rotation = options.rotation;
    const radius = options.radius;
    let rad = (rotation || 0) * RAD_PER_DEG;
    if (style && typeof style === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
            ctx.save();
            ctx.translate(x, y);
            ctx.rotate(rad);
            ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
            ctx.restore();
            return;
        }
    }
    if (isNaN(radius) || radius <= 0) {
        return;
    }
    ctx.beginPath();
    switch(style){
        // Default includes circle
        default:
            if (w) {
                ctx.ellipse(x, y, w / 2, radius, 0, 0, TAU);
            } else {
                ctx.arc(x, y, radius, 0, TAU);
            }
            ctx.closePath();
            break;
        case 'triangle':
            width = w ? w / 2 : radius;
            ctx.moveTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            rad += TWO_THIRDS_PI;
            ctx.lineTo(x + Math.sin(rad) * width, y - Math.cos(rad) * radius);
            ctx.closePath();
            break;
        case 'rectRounded':
            // NOTE: the rounded rect implementation changed to use `arc` instead of
            // `quadraticCurveTo` since it generates better results when rect is
            // almost a circle. 0.516 (instead of 0.5) produces results with visually
            // closer proportion to the previous impl and it is inscribed in the
            // circle with `radius`. For more details, see the following PRs:
            // https://github.com/chartjs/Chart.js/issues/5597
            // https://github.com/chartjs/Chart.js/issues/5858
            cornerRadius = radius * 0.516;
            size = radius - cornerRadius;
            xOffset = Math.cos(rad + QUARTER_PI) * size;
            xOffsetW = Math.cos(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            yOffset = Math.sin(rad + QUARTER_PI) * size;
            yOffsetW = Math.sin(rad + QUARTER_PI) * (w ? w / 2 - cornerRadius : size);
            ctx.arc(x - xOffsetW, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
            ctx.arc(x + yOffsetW, y - xOffset, cornerRadius, rad - HALF_PI, rad);
            ctx.arc(x + xOffsetW, y + yOffset, cornerRadius, rad, rad + HALF_PI);
            ctx.arc(x - yOffsetW, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
            ctx.closePath();
            break;
        case 'rect':
            if (!rotation) {
                size = Math.SQRT1_2 * radius;
                width = w ? w / 2 : size;
                ctx.rect(x - width, y - size, 2 * width, 2 * size);
                break;
            }
            rad += QUARTER_PI;
        /* falls through */ case 'rectRot':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            ctx.closePath();
            break;
        case 'crossRot':
            rad += QUARTER_PI;
        /* falls through */ case 'cross':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'star':
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            rad += QUARTER_PI;
            xOffsetW = Math.cos(rad) * (w ? w / 2 : radius);
            xOffset = Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            yOffsetW = Math.sin(rad) * (w ? w / 2 : radius);
            ctx.moveTo(x - xOffsetW, y - yOffset);
            ctx.lineTo(x + xOffsetW, y + yOffset);
            ctx.moveTo(x + yOffsetW, y - xOffset);
            ctx.lineTo(x - yOffsetW, y + xOffset);
            break;
        case 'line':
            xOffset = w ? w / 2 : Math.cos(rad) * radius;
            yOffset = Math.sin(rad) * radius;
            ctx.moveTo(x - xOffset, y - yOffset);
            ctx.lineTo(x + xOffset, y + yOffset);
            break;
        case 'dash':
            ctx.moveTo(x, y);
            ctx.lineTo(x + Math.cos(rad) * (w ? w / 2 : radius), y + Math.sin(rad) * radius);
            break;
        case false:
            ctx.closePath();
            break;
    }
    ctx.fill();
    if (options.borderWidth > 0) {
        ctx.stroke();
    }
}
/**
 * Returns true if the point is inside the rectangle
 * @param point - The point to test
 * @param area - The rectangle
 * @param margin - allowed margin
 * @private
 */ function _isPointInArea(point, area, margin) {
    margin = margin || 0.5; // margin - default is to match rounded decimals
    return !area || point && point.x > area.left - margin && point.x < area.right + margin && point.y > area.top - margin && point.y < area.bottom + margin;
}
function clipArea(ctx, area) {
    ctx.save();
    ctx.beginPath();
    ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
    ctx.clip();
}
function unclipArea(ctx) {
    ctx.restore();
}
/**
 * @private
 */ function _steppedLineTo(ctx, previous, target, flip, mode) {
    if (!previous) {
        return ctx.lineTo(target.x, target.y);
    }
    if (mode === 'middle') {
        const midpoint = (previous.x + target.x) / 2.0;
        ctx.lineTo(midpoint, previous.y);
        ctx.lineTo(midpoint, target.y);
    } else if (mode === 'after' !== !!flip) {
        ctx.lineTo(previous.x, target.y);
    } else {
        ctx.lineTo(target.x, previous.y);
    }
    ctx.lineTo(target.x, target.y);
}
/**
 * @private
 */ function _bezierCurveTo(ctx, previous, target, flip) {
    if (!previous) {
        return ctx.lineTo(target.x, target.y);
    }
    ctx.bezierCurveTo(flip ? previous.cp1x : previous.cp2x, flip ? previous.cp1y : previous.cp2y, flip ? target.cp2x : target.cp1x, flip ? target.cp2y : target.cp1y, target.x, target.y);
}
function setRenderOpts(ctx, opts) {
    if (opts.translation) {
        ctx.translate(opts.translation[0], opts.translation[1]);
    }
    if (!isNullOrUndef(opts.rotation)) {
        ctx.rotate(opts.rotation);
    }
    if (opts.color) {
        ctx.fillStyle = opts.color;
    }
    if (opts.textAlign) {
        ctx.textAlign = opts.textAlign;
    }
    if (opts.textBaseline) {
        ctx.textBaseline = opts.textBaseline;
    }
}
function decorateText(ctx, x, y, line, opts) {
    if (opts.strikethrough || opts.underline) {
        /**
     * Now that IE11 support has been dropped, we can use more
     * of the TextMetrics object. The actual bounding boxes
     * are unflagged in Chrome, Firefox, Edge, and Safari so they
     * can be safely used.
     * See https://developer.mozilla.org/en-US/docs/Web/API/TextMetrics#Browser_compatibility
     */ const metrics = ctx.measureText(line);
        const left = x - metrics.actualBoundingBoxLeft;
        const right = x + metrics.actualBoundingBoxRight;
        const top = y - metrics.actualBoundingBoxAscent;
        const bottom = y + metrics.actualBoundingBoxDescent;
        const yDecoration = opts.strikethrough ? (top + bottom) / 2 : bottom;
        ctx.strokeStyle = ctx.fillStyle;
        ctx.beginPath();
        ctx.lineWidth = opts.decorationWidth || 2;
        ctx.moveTo(left, yDecoration);
        ctx.lineTo(right, yDecoration);
        ctx.stroke();
    }
}
function drawBackdrop(ctx, opts) {
    const oldColor = ctx.fillStyle;
    ctx.fillStyle = opts.color;
    ctx.fillRect(opts.left, opts.top, opts.width, opts.height);
    ctx.fillStyle = oldColor;
}
/**
 * Render text onto the canvas
 */ function renderText(ctx, text, x, y, font, opts = {}) {
    const lines = isArray(text) ? text : [
        text
    ];
    const stroke = opts.strokeWidth > 0 && opts.strokeColor !== '';
    let i, line;
    ctx.save();
    ctx.font = font.string;
    setRenderOpts(ctx, opts);
    for(i = 0; i < lines.length; ++i){
        line = lines[i];
        if (opts.backdrop) {
            drawBackdrop(ctx, opts.backdrop);
        }
        if (stroke) {
            if (opts.strokeColor) {
                ctx.strokeStyle = opts.strokeColor;
            }
            if (!isNullOrUndef(opts.strokeWidth)) {
                ctx.lineWidth = opts.strokeWidth;
            }
            ctx.strokeText(line, x, y, opts.maxWidth);
        }
        ctx.fillText(line, x, y, opts.maxWidth);
        decorateText(ctx, x, y, line, opts);
        y += Number(font.lineHeight);
    }
    ctx.restore();
}
/**
 * Add a path of a rectangle with rounded corners to the current sub-path
 * @param ctx - Context
 * @param rect - Bounding rect
 */ function addRoundedRectPath(ctx, rect) {
    const { x , y , w , h , radius  } = rect;
    // top left arc
    ctx.arc(x + radius.topLeft, y + radius.topLeft, radius.topLeft, 1.5 * PI, PI, true);
    // line from top left to bottom left
    ctx.lineTo(x, y + h - radius.bottomLeft);
    // bottom left arc
    ctx.arc(x + radius.bottomLeft, y + h - radius.bottomLeft, radius.bottomLeft, PI, HALF_PI, true);
    // line from bottom left to bottom right
    ctx.lineTo(x + w - radius.bottomRight, y + h);
    // bottom right arc
    ctx.arc(x + w - radius.bottomRight, y + h - radius.bottomRight, radius.bottomRight, HALF_PI, 0, true);
    // line from bottom right to top right
    ctx.lineTo(x + w, y + radius.topRight);
    // top right arc
    ctx.arc(x + w - radius.topRight, y + radius.topRight, radius.topRight, 0, -HALF_PI, true);
    // line from top right to top left
    ctx.lineTo(x + radius.topLeft, y);
}

const LINE_HEIGHT = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/;
const FONT_STYLE = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
/**
 * @alias Chart.helpers.options
 * @namespace
 */ /**
 * Converts the given line height `value` in pixels for a specific font `size`.
 * @param value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
 * @param size - The font size (in pixels) used to resolve relative `value`.
 * @returns The effective line height in pixels (size * 1.2 if value is invalid).
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
 * @since 2.7.0
 */ function toLineHeight(value, size) {
    const matches = ('' + value).match(LINE_HEIGHT);
    if (!matches || matches[1] === 'normal') {
        return size * 1.2;
    }
    value = +matches[2];
    switch(matches[3]){
        case 'px':
            return value;
        case '%':
            value /= 100;
            break;
    }
    return size * value;
}
const numberOrZero = (v)=>+v || 0;
function _readValueToProps(value, props) {
    const ret = {};
    const objProps = isObject(props);
    const keys = objProps ? Object.keys(props) : props;
    const read = isObject(value) ? objProps ? (prop)=>valueOrDefault(value[prop], value[props[prop]]) : (prop)=>value[prop] : ()=>value;
    for (const prop of keys){
        ret[prop] = numberOrZero(read(prop));
    }
    return ret;
}
/**
 * Converts the given value into a TRBL object.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left)
 * @since 3.0.0
 */ function toTRBL(value) {
    return _readValueToProps(value, {
        top: 'y',
        right: 'x',
        bottom: 'y',
        left: 'x'
    });
}
/**
 * Converts the given value into a TRBL corners object (similar with css border-radius).
 * @param value - If a number, set the value to all TRBL corner components,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 * @returns The TRBL corner values (topLeft, topRight, bottomLeft, bottomRight)
 * @since 3.0.0
 */ function toTRBLCorners(value) {
    return _readValueToProps(value, [
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight'
    ]);
}
/**
 * Converts the given value into a padding object with pre-computed width/height.
 * @param value - If a number, set the value to all TRBL component,
 *  else, if an object, use defined properties and sets undefined ones to 0.
 *  x / y are shorthands for same value for left/right and top/bottom.
 * @returns The padding values (top, right, bottom, left, width, height)
 * @since 2.7.0
 */ function toPadding(value) {
    const obj = toTRBL(value);
    obj.width = obj.left + obj.right;
    obj.height = obj.top + obj.bottom;
    return obj;
}
/**
 * Parses font options and returns the font object.
 * @param options - A object that contains font options to be parsed.
 * @param fallback - A object that contains fallback font options.
 * @return The font object.
 * @private
 */ function toFont(options, fallback) {
    options = options || {};
    fallback = fallback || defaults.font;
    let size = valueOrDefault(options.size, fallback.size);
    if (typeof size === 'string') {
        size = parseInt(size, 10);
    }
    let style = valueOrDefault(options.style, fallback.style);
    if (style && !('' + style).match(FONT_STYLE)) {
        console.warn('Invalid font style specified: "' + style + '"');
        style = undefined;
    }
    const font = {
        family: valueOrDefault(options.family, fallback.family),
        lineHeight: toLineHeight(valueOrDefault(options.lineHeight, fallback.lineHeight), size),
        size,
        style,
        weight: valueOrDefault(options.weight, fallback.weight),
        string: ''
    };
    font.string = toFontString(font);
    return font;
}
/**
 * Evaluates the given `inputs` sequentially and returns the first defined value.
 * @param inputs - An array of values, falling back to the last value.
 * @param context - If defined and the current value is a function, the value
 * is called with `context` as first argument and the result becomes the new input.
 * @param index - If defined and the current value is an array, the value
 * at `index` become the new input.
 * @param info - object to return information about resolution in
 * @param info.cacheable - Will be set to `false` if option is not cacheable.
 * @since 2.7.0
 */ function resolve(inputs, context, index, info) {
    let cacheable = true;
    let i, ilen, value;
    for(i = 0, ilen = inputs.length; i < ilen; ++i){
        value = inputs[i];
        if (value === undefined) {
            continue;
        }
        if (context !== undefined && typeof value === 'function') {
            value = value(context);
            cacheable = false;
        }
        if (index !== undefined && isArray(value)) {
            value = value[index % value.length];
            cacheable = false;
        }
        if (value !== undefined) {
            if (info && !cacheable) {
                info.cacheable = false;
            }
            return value;
        }
    }
}
/**
 * @param minmax
 * @param grace
 * @param beginAtZero
 * @private
 */ function _addGrace(minmax, grace, beginAtZero) {
    const { min , max  } = minmax;
    const change = toDimension(grace, (max - min) / 2);
    const keepZero = (value, add)=>beginAtZero && value === 0 ? 0 : value + add;
    return {
        min: keepZero(min, -Math.abs(change)),
        max: keepZero(max, change)
    };
}
function createContext(parentContext, context) {
    return Object.assign(Object.create(parentContext), context);
}

/**
 * Creates a Proxy for resolving raw values for options.
 * @param scopes - The option scopes to look for values, in resolution order
 * @param prefixes - The prefixes for values, in resolution order.
 * @param rootScopes - The root option scopes
 * @param fallback - Parent scopes fallback
 * @param getTarget - callback for getting the target for changed values
 * @returns Proxy
 * @private
 */ function _createResolver(scopes, prefixes = [
    ''
], rootScopes, fallback, getTarget = ()=>scopes[0]) {
    const finalRootScopes = rootScopes || scopes;
    if (typeof fallback === 'undefined') {
        fallback = _resolve('_fallback', scopes);
    }
    const cache = {
        [Symbol.toStringTag]: 'Object',
        _cacheable: true,
        _scopes: scopes,
        _rootScopes: finalRootScopes,
        _fallback: fallback,
        _getTarget: getTarget,
        override: (scope)=>_createResolver([
                scope,
                ...scopes
            ], prefixes, finalRootScopes, fallback)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete target._keys; // remove cached keys
            delete scopes[0][prop]; // remove from top level scope
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop) {
            return _cached(target, prop, ()=>_resolveWithPrefixes(prop, prefixes, scopes, target));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return Reflect.getOwnPropertyDescriptor(target._scopes[0], prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(scopes[0]);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return getKeysFromAllScopes(target).includes(prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys (target) {
            return getKeysFromAllScopes(target);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            const storage = target._storage || (target._storage = getTarget());
            target[prop] = storage[prop] = value; // set to top level scope + cache
            delete target._keys; // remove cached keys
            return true;
        }
    });
}
/**
 * Returns an Proxy for resolving option values with context.
 * @param proxy - The Proxy returned by `_createResolver`
 * @param context - Context object for scriptable/indexable options
 * @param subProxy - The proxy provided for scriptable options
 * @param descriptorDefaults - Defaults for descriptors
 * @private
 */ function _attachContext(proxy, context, subProxy, descriptorDefaults) {
    const cache = {
        _cacheable: false,
        _proxy: proxy,
        _context: context,
        _subProxy: subProxy,
        _stack: new Set(),
        _descriptors: _descriptors(proxy, descriptorDefaults),
        setContext: (ctx)=>_attachContext(proxy, ctx, subProxy, descriptorDefaults),
        override: (scope)=>_attachContext(proxy.override(scope), context, subProxy, descriptorDefaults)
    };
    return new Proxy(cache, {
        /**
     * A trap for the delete operator.
     */ deleteProperty (target, prop) {
            delete target[prop]; // remove from cache
            delete proxy[prop]; // remove from proxy
            return true;
        },
        /**
     * A trap for getting property values.
     */ get (target, prop, receiver) {
            return _cached(target, prop, ()=>_resolveWithContext(target, prop, receiver));
        },
        /**
     * A trap for Object.getOwnPropertyDescriptor.
     * Also used by Object.hasOwnProperty.
     */ getOwnPropertyDescriptor (target, prop) {
            return target._descriptors.allKeys ? Reflect.has(proxy, prop) ? {
                enumerable: true,
                configurable: true
            } : undefined : Reflect.getOwnPropertyDescriptor(proxy, prop);
        },
        /**
     * A trap for Object.getPrototypeOf.
     */ getPrototypeOf () {
            return Reflect.getPrototypeOf(proxy);
        },
        /**
     * A trap for the in operator.
     */ has (target, prop) {
            return Reflect.has(proxy, prop);
        },
        /**
     * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
     */ ownKeys () {
            return Reflect.ownKeys(proxy);
        },
        /**
     * A trap for setting property values.
     */ set (target, prop, value) {
            proxy[prop] = value; // set to proxy
            delete target[prop]; // remove from cache
            return true;
        }
    });
}
/**
 * @private
 */ function _descriptors(proxy, defaults = {
    scriptable: true,
    indexable: true
}) {
    const { _scriptable =defaults.scriptable , _indexable =defaults.indexable , _allKeys =defaults.allKeys  } = proxy;
    return {
        allKeys: _allKeys,
        scriptable: _scriptable,
        indexable: _indexable,
        isScriptable: isFunction(_scriptable) ? _scriptable : ()=>_scriptable,
        isIndexable: isFunction(_indexable) ? _indexable : ()=>_indexable
    };
}
const readKey = (prefix, name)=>prefix ? prefix + _capitalize(name) : name;
const needsSubResolver = (prop, value)=>isObject(value) && prop !== 'adapters' && (Object.getPrototypeOf(value) === null || value.constructor === Object);
function _cached(target, prop, resolve) {
    if (Object.prototype.hasOwnProperty.call(target, prop) || prop === 'constructor') {
        return target[prop];
    }
    const value = resolve();
    // cache the resolved value
    target[prop] = value;
    return value;
}
function _resolveWithContext(target, prop, receiver) {
    const { _proxy , _context , _subProxy , _descriptors: descriptors  } = target;
    let value = _proxy[prop]; // resolve from proxy
    // resolve with context
    if (isFunction(value) && descriptors.isScriptable(prop)) {
        value = _resolveScriptable(prop, value, target, receiver);
    }
    if (isArray(value) && value.length) {
        value = _resolveArray(prop, value, target, descriptors.isIndexable);
    }
    if (needsSubResolver(prop, value)) {
        // if the resolved value is an object, create a sub resolver for it
        value = _attachContext(value, _context, _subProxy && _subProxy[prop], descriptors);
    }
    return value;
}
function _resolveScriptable(prop, getValue, target, receiver) {
    const { _proxy , _context , _subProxy , _stack  } = target;
    if (_stack.has(prop)) {
        throw new Error('Recursion detected: ' + Array.from(_stack).join('->') + '->' + prop);
    }
    _stack.add(prop);
    let value = getValue(_context, _subProxy || receiver);
    _stack.delete(prop);
    if (needsSubResolver(prop, value)) {
        // When scriptable option returns an object, create a resolver on that.
        value = createSubResolver(_proxy._scopes, _proxy, prop, value);
    }
    return value;
}
function _resolveArray(prop, value, target, isIndexable) {
    const { _proxy , _context , _subProxy , _descriptors: descriptors  } = target;
    if (typeof _context.index !== 'undefined' && isIndexable(prop)) {
        return value[_context.index % value.length];
    } else if (isObject(value[0])) {
        // Array of objects, return array or resolvers
        const arr = value;
        const scopes = _proxy._scopes.filter((s)=>s !== arr);
        value = [];
        for (const item of arr){
            const resolver = createSubResolver(scopes, _proxy, prop, item);
            value.push(_attachContext(resolver, _context, _subProxy && _subProxy[prop], descriptors));
        }
    }
    return value;
}
function resolveFallback(fallback, prop, value) {
    return isFunction(fallback) ? fallback(prop, value) : fallback;
}
const getScope = (key, parent)=>key === true ? parent : typeof key === 'string' ? resolveObjectKey(parent, key) : undefined;
function addScopes(set, parentScopes, key, parentFallback, value) {
    for (const parent of parentScopes){
        const scope = getScope(key, parent);
        if (scope) {
            set.add(scope);
            const fallback = resolveFallback(scope._fallback, key, value);
            if (typeof fallback !== 'undefined' && fallback !== key && fallback !== parentFallback) {
                // When we reach the descriptor that defines a new _fallback, return that.
                // The fallback will resume to that new scope.
                return fallback;
            }
        } else if (scope === false && typeof parentFallback !== 'undefined' && key !== parentFallback) {
            // Fallback to `false` results to `false`, when falling back to different key.
            // For example `interaction` from `hover` or `plugins.tooltip` and `animation` from `animations`
            return null;
        }
    }
    return false;
}
function createSubResolver(parentScopes, resolver, prop, value) {
    const rootScopes = resolver._rootScopes;
    const fallback = resolveFallback(resolver._fallback, prop, value);
    const allScopes = [
        ...parentScopes,
        ...rootScopes
    ];
    const set = new Set();
    set.add(value);
    let key = addScopesFromKey(set, allScopes, prop, fallback || prop, value);
    if (key === null) {
        return false;
    }
    if (typeof fallback !== 'undefined' && fallback !== prop) {
        key = addScopesFromKey(set, allScopes, fallback, key, value);
        if (key === null) {
            return false;
        }
    }
    return _createResolver(Array.from(set), [
        ''
    ], rootScopes, fallback, ()=>subGetTarget(resolver, prop, value));
}
function addScopesFromKey(set, allScopes, key, fallback, item) {
    while(key){
        key = addScopes(set, allScopes, key, fallback, item);
    }
    return key;
}
function subGetTarget(resolver, prop, value) {
    const parent = resolver._getTarget();
    if (!(prop in parent)) {
        parent[prop] = {};
    }
    const target = parent[prop];
    if (isArray(target) && isObject(value)) {
        // For array of objects, the object is used to store updated values
        return value;
    }
    return target || {};
}
function _resolveWithPrefixes(prop, prefixes, scopes, proxy) {
    let value;
    for (const prefix of prefixes){
        value = _resolve(readKey(prefix, prop), scopes);
        if (typeof value !== 'undefined') {
            return needsSubResolver(prop, value) ? createSubResolver(scopes, proxy, prop, value) : value;
        }
    }
}
function _resolve(key, scopes) {
    for (const scope of scopes){
        if (!scope) {
            continue;
        }
        const value = scope[key];
        if (typeof value !== 'undefined') {
            return value;
        }
    }
}
function getKeysFromAllScopes(target) {
    let keys = target._keys;
    if (!keys) {
        keys = target._keys = resolveKeysFromAllScopes(target._scopes);
    }
    return keys;
}
function resolveKeysFromAllScopes(scopes) {
    const set = new Set();
    for (const scope of scopes){
        for (const key of Object.keys(scope).filter((k)=>!k.startsWith('_'))){
            set.add(key);
        }
    }
    return Array.from(set);
}

const EPSILON = Number.EPSILON || 1e-14;
const getPoint = (points, i)=>i < points.length && !points[i].skip && points[i];
const getValueAxis = (indexAxis)=>indexAxis === 'x' ? 'y' : 'x';
function splineCurve(firstPoint, middlePoint, afterPoint, t) {
    // Props to Rob Spencer at scaled innovation for his post on splining between points
    // http://scaledinnovation.com/analytics/splines/aboutSplines.html
    // This function must also respect "skipped" points
    const previous = firstPoint.skip ? middlePoint : firstPoint;
    const current = middlePoint;
    const next = afterPoint.skip ? middlePoint : afterPoint;
    const d01 = distanceBetweenPoints(current, previous);
    const d12 = distanceBetweenPoints(next, current);
    let s01 = d01 / (d01 + d12);
    let s12 = d12 / (d01 + d12);
    // If all points are the same, s01 & s02 will be inf
    s01 = isNaN(s01) ? 0 : s01;
    s12 = isNaN(s12) ? 0 : s12;
    const fa = t * s01; // scaling factor for triangle Ta
    const fb = t * s12;
    return {
        previous: {
            x: current.x - fa * (next.x - previous.x),
            y: current.y - fa * (next.y - previous.y)
        },
        next: {
            x: current.x + fb * (next.x - previous.x),
            y: current.y + fb * (next.y - previous.y)
        }
    };
}
/**
 * Adjust tangents to ensure monotonic properties
 */ function monotoneAdjust(points, deltaK, mK) {
    const pointsLen = points.length;
    let alphaK, betaK, tauK, squaredMagnitude, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen - 1; ++i){
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent || !pointAfter) {
            continue;
        }
        if (almostEquals(deltaK[i], 0, EPSILON)) {
            mK[i] = mK[i + 1] = 0;
            continue;
        }
        alphaK = mK[i] / deltaK[i];
        betaK = mK[i + 1] / deltaK[i];
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) {
            continue;
        }
        tauK = 3 / Math.sqrt(squaredMagnitude);
        mK[i] = alphaK * tauK * deltaK[i];
        mK[i + 1] = betaK * tauK * deltaK[i];
    }
}
function monotoneCompute(points, mK, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    let delta, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(let i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) {
            continue;
        }
        const iPixel = pointCurrent[indexAxis];
        const vPixel = pointCurrent[valueAxis];
        if (pointBefore) {
            delta = (iPixel - pointBefore[indexAxis]) / 3;
            pointCurrent[`cp1${indexAxis}`] = iPixel - delta;
            pointCurrent[`cp1${valueAxis}`] = vPixel - delta * mK[i];
        }
        if (pointAfter) {
            delta = (pointAfter[indexAxis] - iPixel) / 3;
            pointCurrent[`cp2${indexAxis}`] = iPixel + delta;
            pointCurrent[`cp2${valueAxis}`] = vPixel + delta * mK[i];
        }
    }
}
/**
 * This function calculates Bézier control points in a similar way than |splineCurve|,
 * but preserves monotonicity of the provided data and ensures no local extremums are added
 * between the dataset discrete points due to the interpolation.
 * See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation
 */ function splineCurveMonotone(points, indexAxis = 'x') {
    const valueAxis = getValueAxis(indexAxis);
    const pointsLen = points.length;
    const deltaK = Array(pointsLen).fill(0);
    const mK = Array(pointsLen);
    // Calculate slopes (deltaK) and initialize tangents (mK)
    let i, pointBefore, pointCurrent;
    let pointAfter = getPoint(points, 0);
    for(i = 0; i < pointsLen; ++i){
        pointBefore = pointCurrent;
        pointCurrent = pointAfter;
        pointAfter = getPoint(points, i + 1);
        if (!pointCurrent) {
            continue;
        }
        if (pointAfter) {
            const slopeDelta = pointAfter[indexAxis] - pointCurrent[indexAxis];
            // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
            deltaK[i] = slopeDelta !== 0 ? (pointAfter[valueAxis] - pointCurrent[valueAxis]) / slopeDelta : 0;
        }
        mK[i] = !pointBefore ? deltaK[i] : !pointAfter ? deltaK[i - 1] : sign(deltaK[i - 1]) !== sign(deltaK[i]) ? 0 : (deltaK[i - 1] + deltaK[i]) / 2;
    }
    monotoneAdjust(points, deltaK, mK);
    monotoneCompute(points, mK, indexAxis);
}
function capControlPoint(pt, min, max) {
    return Math.max(Math.min(pt, max), min);
}
function capBezierPoints(points, area) {
    let i, ilen, point, inArea, inAreaPrev;
    let inAreaNext = _isPointInArea(points[0], area);
    for(i = 0, ilen = points.length; i < ilen; ++i){
        inAreaPrev = inArea;
        inArea = inAreaNext;
        inAreaNext = i < ilen - 1 && _isPointInArea(points[i + 1], area);
        if (!inArea) {
            continue;
        }
        point = points[i];
        if (inAreaPrev) {
            point.cp1x = capControlPoint(point.cp1x, area.left, area.right);
            point.cp1y = capControlPoint(point.cp1y, area.top, area.bottom);
        }
        if (inAreaNext) {
            point.cp2x = capControlPoint(point.cp2x, area.left, area.right);
            point.cp2y = capControlPoint(point.cp2y, area.top, area.bottom);
        }
    }
}
/**
 * @private
 */ function _updateBezierControlPoints(points, options, area, loop, indexAxis) {
    let i, ilen, point, controlPoints;
    // Only consider points that are drawn in case the spanGaps option is used
    if (options.spanGaps) {
        points = points.filter((pt)=>!pt.skip);
    }
    if (options.cubicInterpolationMode === 'monotone') {
        splineCurveMonotone(points, indexAxis);
    } else {
        let prev = loop ? points[points.length - 1] : points[0];
        for(i = 0, ilen = points.length; i < ilen; ++i){
            point = points[i];
            controlPoints = splineCurve(prev, point, points[Math.min(i + 1, ilen - (loop ? 0 : 1)) % ilen], options.tension);
            point.cp1x = controlPoints.previous.x;
            point.cp1y = controlPoints.previous.y;
            point.cp2x = controlPoints.next.x;
            point.cp2y = controlPoints.next.y;
            prev = point;
        }
    }
    if (options.capBezierPoints) {
        capBezierPoints(points, area);
    }
}

/**
 * @private
 */ function _isDomSupported() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * @private
 */ function _getParentNode(domNode) {
    let parent = domNode.parentNode;
    if (parent && parent.toString() === '[object ShadowRoot]') {
        parent = parent.host;
    }
    return parent;
}
/**
 * convert max-width/max-height values that may be percentages into a number
 * @private
 */ function parseMaxStyle(styleValue, node, parentProperty) {
    let valueInPixels;
    if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) {
            // percentage * size in dimension
            valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
        }
    } else {
        valueInPixels = styleValue;
    }
    return valueInPixels;
}
const getComputedStyle$1 = (element)=>element.ownerDocument.defaultView.getComputedStyle(element, null);
function getStyle(el, property) {
    return getComputedStyle$1(el).getPropertyValue(property);
}
const positions = [
    'top',
    'right',
    'bottom',
    'left'
];
function getPositionedStyle(styles, style, suffix) {
    const result = {};
    suffix = suffix ? '-' + suffix : '';
    for(let i = 0; i < 4; i++){
        const pos = positions[i];
        result[pos] = parseFloat(styles[style + '-' + pos + suffix]) || 0;
    }
    result.width = result.left + result.right;
    result.height = result.top + result.bottom;
    return result;
}
const useOffsetPos = (x, y, target)=>(x > 0 || y > 0) && (!target || !target.shadowRoot);
/**
 * @param e
 * @param canvas
 * @returns Canvas position
 */ function getCanvasPosition(e, canvas) {
    const touches = e.touches;
    const source = touches && touches.length ? touches[0] : e;
    const { offsetX , offsetY  } = source;
    let box = false;
    let x, y;
    if (useOffsetPos(offsetX, offsetY, e.target)) {
        x = offsetX;
        y = offsetY;
    } else {
        const rect = canvas.getBoundingClientRect();
        x = source.clientX - rect.left;
        y = source.clientY - rect.top;
        box = true;
    }
    return {
        x,
        y,
        box
    };
}
/**
 * Gets an event's x, y coordinates, relative to the chart area
 * @param event
 * @param chart
 * @returns x and y coordinates of the event
 */ function getRelativePosition(event, chart) {
    if ('native' in event) {
        return event;
    }
    const { canvas , currentDevicePixelRatio  } = chart;
    const style = getComputedStyle$1(canvas);
    const borderBox = style.boxSizing === 'border-box';
    const paddings = getPositionedStyle(style, 'padding');
    const borders = getPositionedStyle(style, 'border', 'width');
    const { x , y , box  } = getCanvasPosition(event, canvas);
    const xOffset = paddings.left + (box && borders.left);
    const yOffset = paddings.top + (box && borders.top);
    let { width , height  } = chart;
    if (borderBox) {
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    return {
        x: Math.round((x - xOffset) / width * canvas.width / currentDevicePixelRatio),
        y: Math.round((y - yOffset) / height * canvas.height / currentDevicePixelRatio)
    };
}
function getContainerSize(canvas, width, height) {
    let maxWidth, maxHeight;
    if (width === undefined || height === undefined) {
        const container = canvas && _getParentNode(canvas);
        if (!container) {
            width = canvas.clientWidth;
            height = canvas.clientHeight;
        } else {
            const rect = container.getBoundingClientRect(); // this is the border box of the container
            const containerStyle = getComputedStyle$1(container);
            const containerBorder = getPositionedStyle(containerStyle, 'border', 'width');
            const containerPadding = getPositionedStyle(containerStyle, 'padding');
            width = rect.width - containerPadding.width - containerBorder.width;
            height = rect.height - containerPadding.height - containerBorder.height;
            maxWidth = parseMaxStyle(containerStyle.maxWidth, container, 'clientWidth');
            maxHeight = parseMaxStyle(containerStyle.maxHeight, container, 'clientHeight');
        }
    }
    return {
        width,
        height,
        maxWidth: maxWidth || INFINITY,
        maxHeight: maxHeight || INFINITY
    };
}
const round1 = (v)=>Math.round(v * 10) / 10;
// eslint-disable-next-line complexity
function getMaximumSize(canvas, bbWidth, bbHeight, aspectRatio) {
    const style = getComputedStyle$1(canvas);
    const margins = getPositionedStyle(style, 'margin');
    const maxWidth = parseMaxStyle(style.maxWidth, canvas, 'clientWidth') || INFINITY;
    const maxHeight = parseMaxStyle(style.maxHeight, canvas, 'clientHeight') || INFINITY;
    const containerSize = getContainerSize(canvas, bbWidth, bbHeight);
    let { width , height  } = containerSize;
    if (style.boxSizing === 'content-box') {
        const borders = getPositionedStyle(style, 'border', 'width');
        const paddings = getPositionedStyle(style, 'padding');
        width -= paddings.width + borders.width;
        height -= paddings.height + borders.height;
    }
    width = Math.max(0, width - margins.width);
    height = Math.max(0, aspectRatio ? width / aspectRatio : height - margins.height);
    width = round1(Math.min(width, maxWidth, containerSize.maxWidth));
    height = round1(Math.min(height, maxHeight, containerSize.maxHeight));
    if (width && !height) {
        // https://github.com/chartjs/Chart.js/issues/4659
        // If the canvas has width, but no height, default to aspectRatio of 2 (canvas default)
        height = round1(width / 2);
    }
    const maintainHeight = bbWidth !== undefined || bbHeight !== undefined;
    if (maintainHeight && aspectRatio && containerSize.height && height > containerSize.height) {
        height = containerSize.height;
        width = round1(Math.floor(height * aspectRatio));
    }
    return {
        width,
        height
    };
}
/**
 * @param chart
 * @param forceRatio
 * @param forceStyle
 * @returns True if the canvas context size or transformation has changed.
 */ function retinaScale(chart, forceRatio, forceStyle) {
    const pixelRatio = forceRatio || 1;
    const deviceHeight = round1(chart.height * pixelRatio);
    const deviceWidth = round1(chart.width * pixelRatio);
    chart.height = round1(chart.height);
    chart.width = round1(chart.width);
    const canvas = chart.canvas;
    // If no style has been set on the canvas, the render size is used as display size,
    // making the chart visually bigger, so let's enforce it to the "correct" values.
    // See https://github.com/chartjs/Chart.js/issues/3575
    if (canvas.style && (forceStyle || !canvas.style.height && !canvas.style.width)) {
        canvas.style.height = `${chart.height}px`;
        canvas.style.width = `${chart.width}px`;
    }
    if (chart.currentDevicePixelRatio !== pixelRatio || canvas.height !== deviceHeight || canvas.width !== deviceWidth) {
        chart.currentDevicePixelRatio = pixelRatio;
        canvas.height = deviceHeight;
        canvas.width = deviceWidth;
        chart.ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        return true;
    }
    return false;
}
/**
 * Detects support for options object argument in addEventListener.
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
 * @private
 */ const supportsEventListenerOptions = function() {
    let passiveSupported = false;
    try {
        const options = {
            get passive () {
                passiveSupported = true;
                return false;
            }
        };
        if (_isDomSupported()) {
            window.addEventListener('test', null, options);
            window.removeEventListener('test', null, options);
        }
    } catch (e) {
    // continue regardless of error
    }
    return passiveSupported;
}();
/**
 * The "used" size is the final value of a dimension property after all calculations have
 * been performed. This method uses the computed style of `element` but returns undefined
 * if the computed style is not expressed in pixels. That can happen in some cases where
 * `element` has a size relative to its parent and this last one is not yet displayed,
 * for example because of `display: none` on a parent node.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
 * @returns Size in pixels or undefined if unknown.
 */ function readUsedSize(element, property) {
    const value = getStyle(element, property);
    const matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? +matches[1] : undefined;
}

/**
 * @private
 */ function _pointInLine(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: p1.y + t * (p2.y - p1.y)
    };
}
/**
 * @private
 */ function _steppedInterpolation(p1, p2, t, mode) {
    return {
        x: p1.x + t * (p2.x - p1.x),
        y: mode === 'middle' ? t < 0.5 ? p1.y : p2.y : mode === 'after' ? t < 1 ? p1.y : p2.y : t > 0 ? p2.y : p1.y
    };
}
/**
 * @private
 */ function _bezierInterpolation(p1, p2, t, mode) {
    const cp1 = {
        x: p1.cp2x,
        y: p1.cp2y
    };
    const cp2 = {
        x: p2.cp1x,
        y: p2.cp1y
    };
    const a = _pointInLine(p1, cp1, t);
    const b = _pointInLine(cp1, cp2, t);
    const c = _pointInLine(cp2, p2, t);
    const d = _pointInLine(a, b, t);
    const e = _pointInLine(b, c, t);
    return _pointInLine(d, e, t);
}

const getRightToLeftAdapter = function(rectX, width) {
    return {
        x (x) {
            return rectX + rectX + width - x;
        },
        setWidth (w) {
            width = w;
        },
        textAlign (align) {
            if (align === 'center') {
                return align;
            }
            return align === 'right' ? 'left' : 'right';
        },
        xPlus (x, value) {
            return x - value;
        },
        leftForLtr (x, itemWidth) {
            return x - itemWidth;
        }
    };
};
const getLeftToRightAdapter = function() {
    return {
        x (x) {
            return x;
        },
        setWidth (w) {},
        textAlign (align) {
            return align;
        },
        xPlus (x, value) {
            return x + value;
        },
        leftForLtr (x, _itemWidth) {
            return x;
        }
    };
};
function getRtlAdapter(rtl, rectX, width) {
    return rtl ? getRightToLeftAdapter(rectX, width) : getLeftToRightAdapter();
}
function overrideTextDirection(ctx, direction) {
    let style, original;
    if (direction === 'ltr' || direction === 'rtl') {
        style = ctx.canvas.style;
        original = [
            style.getPropertyValue('direction'),
            style.getPropertyPriority('direction')
        ];
        style.setProperty('direction', direction, 'important');
        ctx.prevTextDirection = original;
    }
}
function restoreTextDirection(ctx, original) {
    if (original !== undefined) {
        delete ctx.prevTextDirection;
        ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
}

function propertyFn(property) {
    if (property === 'angle') {
        return {
            between: _angleBetween,
            compare: _angleDiff,
            normalize: _normalizeAngle
        };
    }
    return {
        between: _isBetween,
        compare: (a, b)=>a - b,
        normalize: (x)=>x
    };
}
function normalizeSegment({ start , end , count , loop , style  }) {
    return {
        start: start % count,
        end: end % count,
        loop: loop && (end - start + 1) % count === 0,
        style
    };
}
function getSegment(segment, points, bounds) {
    const { property , start: startBound , end: endBound  } = bounds;
    const { between , normalize  } = propertyFn(property);
    const count = points.length;
    let { start , end , loop  } = segment;
    let i, ilen;
    if (loop) {
        start += count;
        end += count;
        for(i = 0, ilen = count; i < ilen; ++i){
            if (!between(normalize(points[start % count][property]), startBound, endBound)) {
                break;
            }
            start--;
            end--;
        }
        start %= count;
        end %= count;
    }
    if (end < start) {
        end += count;
    }
    return {
        start,
        end,
        loop,
        style: segment.style
    };
}
 function _boundSegment(segment, points, bounds) {
    if (!bounds) {
        return [
            segment
        ];
    }
    const { property , start: startBound , end: endBound  } = bounds;
    const count = points.length;
    const { compare , between , normalize  } = propertyFn(property);
    const { start , end , loop , style  } = getSegment(segment, points, bounds);
    const result = [];
    let inside = false;
    let subStart = null;
    let value, point, prevValue;
    const startIsBefore = ()=>between(startBound, prevValue, value) && compare(startBound, prevValue) !== 0;
    const endIsBefore = ()=>compare(endBound, value) === 0 || between(endBound, prevValue, value);
    const shouldStart = ()=>inside || startIsBefore();
    const shouldStop = ()=>!inside || endIsBefore();
    for(let i = start, prev = start; i <= end; ++i){
        point = points[i % count];
        if (point.skip) {
            continue;
        }
        value = normalize(point[property]);
        if (value === prevValue) {
            continue;
        }
        inside = between(value, startBound, endBound);
        if (subStart === null && shouldStart()) {
            subStart = compare(value, startBound) === 0 ? i : prev;
        }
        if (subStart !== null && shouldStop()) {
            result.push(normalizeSegment({
                start: subStart,
                end: i,
                loop,
                count,
                style
            }));
            subStart = null;
        }
        prev = i;
        prevValue = value;
    }
    if (subStart !== null) {
        result.push(normalizeSegment({
            start: subStart,
            end,
            loop,
            count,
            style
        }));
    }
    return result;
}
 function _boundSegments(line, bounds) {
    const result = [];
    const segments = line.segments;
    for(let i = 0; i < segments.length; i++){
        const sub = _boundSegment(segments[i], line.points, bounds);
        if (sub.length) {
            result.push(...sub);
        }
    }
    return result;
}
 function findStartAndEnd(points, count, loop, spanGaps) {
    let start = 0;
    let end = count - 1;
    if (loop && !spanGaps) {
        while(start < count && !points[start].skip){
            start++;
        }
    }
    while(start < count && points[start].skip){
        start++;
    }
    start %= count;
    if (loop) {
        end += start;
    }
    while(end > start && points[end % count].skip){
        end--;
    }
    end %= count;
    return {
        start,
        end
    };
}
 function solidSegments(points, start, max, loop) {
    const count = points.length;
    const result = [];
    let last = start;
    let prev = points[start];
    let end;
    for(end = start + 1; end <= max; ++end){
        const cur = points[end % count];
        if (cur.skip || cur.stop) {
            if (!prev.skip) {
                loop = false;
                result.push({
                    start: start % count,
                    end: (end - 1) % count,
                    loop
                });
                start = last = cur.stop ? end : null;
            }
        } else {
            last = end;
            if (prev.skip) {
                start = end;
            }
        }
        prev = cur;
    }
    if (last !== null) {
        result.push({
            start: start % count,
            end: last % count,
            loop
        });
    }
    return result;
}
 function _computeSegments(line, segmentOptions) {
    const points = line.points;
    const spanGaps = line.options.spanGaps;
    const count = points.length;
    if (!count) {
        return [];
    }
    const loop = !!line._loop;
    const { start , end  } = findStartAndEnd(points, count, loop, spanGaps);
    if (spanGaps === true) {
        return splitByStyles(line, [
            {
                start,
                end,
                loop
            }
        ], points, segmentOptions);
    }
    const max = end < start ? end + count : end;
    const completeLoop = !!line._fullLoop && start === 0 && end === count - 1;
    return splitByStyles(line, solidSegments(points, start, max, completeLoop), points, segmentOptions);
}
 function splitByStyles(line, segments, points, segmentOptions) {
    if (!segmentOptions || !segmentOptions.setContext || !points) {
        return segments;
    }
    return doSplitByStyles(line, segments, points, segmentOptions);
}
 function doSplitByStyles(line, segments, points, segmentOptions) {
    const chartContext = line._chart.getContext();
    const baseStyle = readStyle(line.options);
    const { _datasetIndex: datasetIndex , options: { spanGaps  }  } = line;
    const count = points.length;
    const result = [];
    let prevStyle = baseStyle;
    let start = segments[0].start;
    let i = start;
    function addStyle(s, e, l, st) {
        const dir = spanGaps ? -1 : 1;
        if (s === e) {
            return;
        }
        s += count;
        while(points[s % count].skip){
            s -= dir;
        }
        while(points[e % count].skip){
            e += dir;
        }
        if (s % count !== e % count) {
            result.push({
                start: s % count,
                end: e % count,
                loop: l,
                style: st
            });
            prevStyle = st;
            start = e % count;
        }
    }
    for (const segment of segments){
        start = spanGaps ? start : segment.start;
        let prev = points[start % count];
        let style;
        for(i = start + 1; i <= segment.end; i++){
            const pt = points[i % count];
            style = readStyle(segmentOptions.setContext(createContext(chartContext, {
                type: 'segment',
                p0: prev,
                p1: pt,
                p0DataIndex: (i - 1) % count,
                p1DataIndex: i % count,
                datasetIndex
            })));
            if (styleChanged(style, prevStyle)) {
                addStyle(start, i - 1, segment.loop, prevStyle);
            }
            prev = pt;
            prevStyle = style;
        }
        if (start < i - 1) {
            addStyle(start, i - 1, segment.loop, prevStyle);
        }
    }
    return result;
}
function readStyle(options) {
    return {
        backgroundColor: options.backgroundColor,
        borderCapStyle: options.borderCapStyle,
        borderDash: options.borderDash,
        borderDashOffset: options.borderDashOffset,
        borderJoinStyle: options.borderJoinStyle,
        borderWidth: options.borderWidth,
        borderColor: options.borderColor
    };
}
function styleChanged(style, prevStyle) {
    if (!prevStyle) {
        return false;
    }
    const cache = [];
    const replacer = function(key, value) {
        if (!isPatternOrGradient(value)) {
            return value;
        }
        if (!cache.includes(value)) {
            cache.push(value);
        }
        return cache.indexOf(value);
    };
    return JSON.stringify(style, replacer) !== JSON.stringify(prevStyle, replacer);
}

function getSizeForArea(scale, chartArea, field) {
    return scale.options.clip ? scale[field] : chartArea[field];
}
function getDatasetArea(meta, chartArea) {
    const { xScale , yScale  } = meta;
    if (xScale && yScale) {
        return {
            left: getSizeForArea(xScale, chartArea, 'left'),
            right: getSizeForArea(xScale, chartArea, 'right'),
            top: getSizeForArea(yScale, chartArea, 'top'),
            bottom: getSizeForArea(yScale, chartArea, 'bottom')
        };
    }
    return chartArea;
}
function getDatasetClipArea(chart, meta) {
    const clip = meta._clip;
    if (clip.disabled) {
        return false;
    }
    const area = getDatasetArea(meta, chart.chartArea);
    return {
        left: clip.left === false ? 0 : area.left - (clip.left === true ? 0 : clip.left),
        right: clip.right === false ? chart.width : area.right + (clip.right === true ? 0 : clip.right),
        top: clip.top === false ? 0 : area.top - (clip.top === true ? 0 : clip.top),
        bottom: clip.bottom === false ? chart.height : area.bottom + (clip.bottom === true ? 0 : clip.bottom)
    };
}

/*!
 * Chart.js v4.5.1
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */

class Animator {
    constructor(){
        this._request = null;
        this._charts = new Map();
        this._running = false;
        this._lastDate = undefined;
    }
 _notify(chart, anims, date, type) {
        const callbacks = anims.listeners[type];
        const numSteps = anims.duration;
        callbacks.forEach((fn)=>fn({
                chart,
                initial: anims.initial,
                numSteps,
                currentStep: Math.min(date - anims.start, numSteps)
            }));
    }
 _refresh() {
        if (this._request) {
            return;
        }
        this._running = true;
        this._request = requestAnimFrame.call(window, ()=>{
            this._update();
            this._request = null;
            if (this._running) {
                this._refresh();
            }
        });
    }
 _update(date = Date.now()) {
        let remaining = 0;
        this._charts.forEach((anims, chart)=>{
            if (!anims.running || !anims.items.length) {
                return;
            }
            const items = anims.items;
            let i = items.length - 1;
            let draw = false;
            let item;
            for(; i >= 0; --i){
                item = items[i];
                if (item._active) {
                    if (item._total > anims.duration) {
                        anims.duration = item._total;
                    }
                    item.tick(date);
                    draw = true;
                } else {
                    items[i] = items[items.length - 1];
                    items.pop();
                }
            }
            if (draw) {
                chart.draw();
                this._notify(chart, anims, date, 'progress');
            }
            if (!items.length) {
                anims.running = false;
                this._notify(chart, anims, date, 'complete');
                anims.initial = false;
            }
            remaining += items.length;
        });
        this._lastDate = date;
        if (remaining === 0) {
            this._running = false;
        }
    }
 _getAnims(chart) {
        const charts = this._charts;
        let anims = charts.get(chart);
        if (!anims) {
            anims = {
                running: false,
                initial: true,
                items: [],
                listeners: {
                    complete: [],
                    progress: []
                }
            };
            charts.set(chart, anims);
        }
        return anims;
    }
 listen(chart, event, cb) {
        this._getAnims(chart).listeners[event].push(cb);
    }
 add(chart, items) {
        if (!items || !items.length) {
            return;
        }
        this._getAnims(chart).items.push(...items);
    }
 has(chart) {
        return this._getAnims(chart).items.length > 0;
    }
 start(chart) {
        const anims = this._charts.get(chart);
        if (!anims) {
            return;
        }
        anims.running = true;
        anims.start = Date.now();
        anims.duration = anims.items.reduce((acc, cur)=>Math.max(acc, cur._duration), 0);
        this._refresh();
    }
    running(chart) {
        if (!this._running) {
            return false;
        }
        const anims = this._charts.get(chart);
        if (!anims || !anims.running || !anims.items.length) {
            return false;
        }
        return true;
    }
 stop(chart) {
        const anims = this._charts.get(chart);
        if (!anims || !anims.items.length) {
            return;
        }
        const items = anims.items;
        let i = items.length - 1;
        for(; i >= 0; --i){
            items[i].cancel();
        }
        anims.items = [];
        this._notify(chart, anims, Date.now(), 'complete');
    }
 remove(chart) {
        return this._charts.delete(chart);
    }
}
var animator = /* #__PURE__ */ new Animator();

const transparent = 'transparent';
const interpolators = {
    boolean (from, to, factor) {
        return factor > 0.5 ? to : from;
    },
 color (from, to, factor) {
        const c0 = color(from || transparent);
        const c1 = c0.valid && color(to || transparent);
        return c1 && c1.valid ? c1.mix(c0, factor).hexString() : to;
    },
    number (from, to, factor) {
        return from + (to - from) * factor;
    }
};
class Animation {
    constructor(cfg, target, prop, to){
        const currentValue = target[prop];
        to = resolve([
            cfg.to,
            to,
            currentValue,
            cfg.from
        ]);
        const from = resolve([
            cfg.from,
            currentValue,
            to
        ]);
        this._active = true;
        this._fn = cfg.fn || interpolators[cfg.type || typeof from];
        this._easing = effects[cfg.easing] || effects.linear;
        this._start = Math.floor(Date.now() + (cfg.delay || 0));
        this._duration = this._total = Math.floor(cfg.duration);
        this._loop = !!cfg.loop;
        this._target = target;
        this._prop = prop;
        this._from = from;
        this._to = to;
        this._promises = undefined;
    }
    active() {
        return this._active;
    }
    update(cfg, to, date) {
        if (this._active) {
            this._notify(false);
            const currentValue = this._target[this._prop];
            const elapsed = date - this._start;
            const remain = this._duration - elapsed;
            this._start = date;
            this._duration = Math.floor(Math.max(remain, cfg.duration));
            this._total += elapsed;
            this._loop = !!cfg.loop;
            this._to = resolve([
                cfg.to,
                to,
                currentValue,
                cfg.from
            ]);
            this._from = resolve([
                cfg.from,
                currentValue,
                to
            ]);
        }
    }
    cancel() {
        if (this._active) {
            this.tick(Date.now());
            this._active = false;
            this._notify(false);
        }
    }
    tick(date) {
        const elapsed = date - this._start;
        const duration = this._duration;
        const prop = this._prop;
        const from = this._from;
        const loop = this._loop;
        const to = this._to;
        let factor;
        this._active = from !== to && (loop || elapsed < duration);
        if (!this._active) {
            this._target[prop] = to;
            this._notify(true);
            return;
        }
        if (elapsed < 0) {
            this._target[prop] = from;
            return;
        }
        factor = elapsed / duration % 2;
        factor = loop && factor > 1 ? 2 - factor : factor;
        factor = this._easing(Math.min(1, Math.max(0, factor)));
        this._target[prop] = this._fn(from, to, factor);
    }
    wait() {
        const promises = this._promises || (this._promises = []);
        return new Promise((res, rej)=>{
            promises.push({
                res,
                rej
            });
        });
    }
    _notify(resolved) {
        const method = resolved ? 'res' : 'rej';
        const promises = this._promises || [];
        for(let i = 0; i < promises.length; i++){
            promises[i][method]();
        }
    }
}

class Animations {
    constructor(chart, config){
        this._chart = chart;
        this._properties = new Map();
        this.configure(config);
    }
    configure(config) {
        if (!isObject(config)) {
            return;
        }
        const animationOptions = Object.keys(defaults.animation);
        const animatedProps = this._properties;
        Object.getOwnPropertyNames(config).forEach((key)=>{
            const cfg = config[key];
            if (!isObject(cfg)) {
                return;
            }
            const resolved = {};
            for (const option of animationOptions){
                resolved[option] = cfg[option];
            }
            (isArray(cfg.properties) && cfg.properties || [
                key
            ]).forEach((prop)=>{
                if (prop === key || !animatedProps.has(prop)) {
                    animatedProps.set(prop, resolved);
                }
            });
        });
    }
 _animateOptions(target, values) {
        const newOptions = values.options;
        const options = resolveTargetOptions(target, newOptions);
        if (!options) {
            return [];
        }
        const animations = this._createAnimations(options, newOptions);
        if (newOptions.$shared) {
            awaitAll(target.options.$animations, newOptions).then(()=>{
                target.options = newOptions;
            }, ()=>{
            });
        }
        return animations;
    }
 _createAnimations(target, values) {
        const animatedProps = this._properties;
        const animations = [];
        const running = target.$animations || (target.$animations = {});
        const props = Object.keys(values);
        const date = Date.now();
        let i;
        for(i = props.length - 1; i >= 0; --i){
            const prop = props[i];
            if (prop.charAt(0) === '$') {
                continue;
            }
            if (prop === 'options') {
                animations.push(...this._animateOptions(target, values));
                continue;
            }
            const value = values[prop];
            let animation = running[prop];
            const cfg = animatedProps.get(prop);
            if (animation) {
                if (cfg && animation.active()) {
                    animation.update(cfg, value, date);
                    continue;
                } else {
                    animation.cancel();
                }
            }
            if (!cfg || !cfg.duration) {
                target[prop] = value;
                continue;
            }
            running[prop] = animation = new Animation(cfg, target, prop, value);
            animations.push(animation);
        }
        return animations;
    }
 update(target, values) {
        if (this._properties.size === 0) {
            Object.assign(target, values);
            return;
        }
        const animations = this._createAnimations(target, values);
        if (animations.length) {
            animator.add(this._chart, animations);
            return true;
        }
    }
}
function awaitAll(animations, properties) {
    const running = [];
    const keys = Object.keys(properties);
    for(let i = 0; i < keys.length; i++){
        const anim = animations[keys[i]];
        if (anim && anim.active()) {
            running.push(anim.wait());
        }
    }
    return Promise.all(running);
}
function resolveTargetOptions(target, newOptions) {
    if (!newOptions) {
        return;
    }
    let options = target.options;
    if (!options) {
        target.options = newOptions;
        return;
    }
    if (options.$shared) {
        target.options = options = Object.assign({}, options, {
            $shared: false,
            $animations: {}
        });
    }
    return options;
}

function scaleClip(scale, allowedOverflow) {
    const opts = scale && scale.options || {};
    const reverse = opts.reverse;
    const min = opts.min === undefined ? allowedOverflow : 0;
    const max = opts.max === undefined ? allowedOverflow : 0;
    return {
        start: reverse ? max : min,
        end: reverse ? min : max
    };
}
function defaultClip(xScale, yScale, allowedOverflow) {
    if (allowedOverflow === false) {
        return false;
    }
    const x = scaleClip(xScale, allowedOverflow);
    const y = scaleClip(yScale, allowedOverflow);
    return {
        top: y.end,
        right: x.end,
        bottom: y.start,
        left: x.start
    };
}
function toClip(value) {
    let t, r, b, l;
    if (isObject(value)) {
        t = value.top;
        r = value.right;
        b = value.bottom;
        l = value.left;
    } else {
        t = r = b = l = value;
    }
    return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        disabled: value === false
    };
}
function getSortedDatasetIndices(chart, filterVisible) {
    const keys = [];
    const metasets = chart._getSortedDatasetMetas(filterVisible);
    let i, ilen;
    for(i = 0, ilen = metasets.length; i < ilen; ++i){
        keys.push(metasets[i].index);
    }
    return keys;
}
function applyStack(stack, value, dsIndex, options = {}) {
    const keys = stack.keys;
    const singleMode = options.mode === 'single';
    let i, ilen, datasetIndex, otherValue;
    if (value === null) {
        return;
    }
    let found = false;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        datasetIndex = +keys[i];
        if (datasetIndex === dsIndex) {
            found = true;
            if (options.all) {
                continue;
            }
            break;
        }
        otherValue = stack.values[datasetIndex];
        if (isNumberFinite(otherValue) && (singleMode || value === 0 || sign(value) === sign(otherValue))) {
            value += otherValue;
        }
    }
    if (!found && !options.all) {
        return 0;
    }
    return value;
}
function convertObjectDataToArray(data, meta) {
    const { iScale , vScale  } = meta;
    const iAxisKey = iScale.axis === 'x' ? 'x' : 'y';
    const vAxisKey = vScale.axis === 'x' ? 'x' : 'y';
    const keys = Object.keys(data);
    const adata = new Array(keys.length);
    let i, ilen, key;
    for(i = 0, ilen = keys.length; i < ilen; ++i){
        key = keys[i];
        adata[i] = {
            [iAxisKey]: key,
            [vAxisKey]: data[key]
        };
    }
    return adata;
}
function isStacked(scale, meta) {
    const stacked = scale && scale.options.stacked;
    return stacked || stacked === undefined && meta.stack !== undefined;
}
function getStackKey(indexScale, valueScale, meta) {
    return `${indexScale.id}.${valueScale.id}.${meta.stack || meta.type}`;
}
function getUserBounds(scale) {
    const { min , max , minDefined , maxDefined  } = scale.getUserBounds();
    return {
        min: minDefined ? min : Number.NEGATIVE_INFINITY,
        max: maxDefined ? max : Number.POSITIVE_INFINITY
    };
}
function getOrCreateStack(stacks, stackKey, indexValue) {
    const subStack = stacks[stackKey] || (stacks[stackKey] = {});
    return subStack[indexValue] || (subStack[indexValue] = {});
}
function getLastIndexInStack(stack, vScale, positive, type) {
    for (const meta of vScale.getMatchingVisibleMetas(type).reverse()){
        const value = stack[meta.index];
        if (positive && value > 0 || !positive && value < 0) {
            return meta.index;
        }
    }
    return null;
}
function updateStacks(controller, parsed) {
    const { chart , _cachedMeta: meta  } = controller;
    const stacks = chart._stacks || (chart._stacks = {});
    const { iScale , vScale , index: datasetIndex  } = meta;
    const iAxis = iScale.axis;
    const vAxis = vScale.axis;
    const key = getStackKey(iScale, vScale, meta);
    const ilen = parsed.length;
    let stack;
    for(let i = 0; i < ilen; ++i){
        const item = parsed[i];
        const { [iAxis]: index , [vAxis]: value  } = item;
        const itemStacks = item._stacks || (item._stacks = {});
        stack = itemStacks[vAxis] = getOrCreateStack(stacks, key, index);
        stack[datasetIndex] = value;
        stack._top = getLastIndexInStack(stack, vScale, true, meta.type);
        stack._bottom = getLastIndexInStack(stack, vScale, false, meta.type);
        const visualValues = stack._visualValues || (stack._visualValues = {});
        visualValues[datasetIndex] = value;
    }
}
function getFirstScaleId(chart, axis) {
    const scales = chart.scales;
    return Object.keys(scales).filter((key)=>scales[key].axis === axis).shift();
}
function createDatasetContext(parent, index) {
    return createContext(parent, {
        active: false,
        dataset: undefined,
        datasetIndex: index,
        index,
        mode: 'default',
        type: 'dataset'
    });
}
function createDataContext(parent, index, element) {
    return createContext(parent, {
        active: false,
        dataIndex: index,
        parsed: undefined,
        raw: undefined,
        element,
        index,
        mode: 'default',
        type: 'data'
    });
}
function clearStacks(meta, items) {
    const datasetIndex = meta.controller.index;
    const axis = meta.vScale && meta.vScale.axis;
    if (!axis) {
        return;
    }
    items = items || meta._parsed;
    for (const parsed of items){
        const stacks = parsed._stacks;
        if (!stacks || stacks[axis] === undefined || stacks[axis][datasetIndex] === undefined) {
            return;
        }
        delete stacks[axis][datasetIndex];
        if (stacks[axis]._visualValues !== undefined && stacks[axis]._visualValues[datasetIndex] !== undefined) {
            delete stacks[axis]._visualValues[datasetIndex];
        }
    }
}
const isDirectUpdateMode = (mode)=>mode === 'reset' || mode === 'none';
const cloneIfNotShared = (cached, shared)=>shared ? cached : Object.assign({}, cached);
const createStack = (canStack, meta, chart)=>canStack && !meta.hidden && meta._stacked && {
        keys: getSortedDatasetIndices(chart, true),
        values: null
    };
class DatasetController {
 static defaults = {};
 static datasetElementType = null;
 static dataElementType = null;
 constructor(chart, datasetIndex){
        this.chart = chart;
        this._ctx = chart.ctx;
        this.index = datasetIndex;
        this._cachedDataOpts = {};
        this._cachedMeta = this.getMeta();
        this._type = this._cachedMeta.type;
        this.options = undefined;
         this._parsing = false;
        this._data = undefined;
        this._objectData = undefined;
        this._sharedOptions = undefined;
        this._drawStart = undefined;
        this._drawCount = undefined;
        this.enableOptionSharing = false;
        this.supportsDecimation = false;
        this.$context = undefined;
        this._syncList = [];
        this.datasetElementType = new.target.datasetElementType;
        this.dataElementType = new.target.dataElementType;
        this.initialize();
    }
    initialize() {
        const meta = this._cachedMeta;
        this.configure();
        this.linkScales();
        meta._stacked = isStacked(meta.vScale, meta);
        this.addElements();
        if (this.options.fill && !this.chart.isPluginEnabled('filler')) {
            console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
        }
    }
    updateIndex(datasetIndex) {
        if (this.index !== datasetIndex) {
            clearStacks(this._cachedMeta);
        }
        this.index = datasetIndex;
    }
    linkScales() {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        const chooseId = (axis, x, y, r)=>axis === 'x' ? x : axis === 'r' ? r : y;
        const xid = meta.xAxisID = valueOrDefault(dataset.xAxisID, getFirstScaleId(chart, 'x'));
        const yid = meta.yAxisID = valueOrDefault(dataset.yAxisID, getFirstScaleId(chart, 'y'));
        const rid = meta.rAxisID = valueOrDefault(dataset.rAxisID, getFirstScaleId(chart, 'r'));
        const indexAxis = meta.indexAxis;
        const iid = meta.iAxisID = chooseId(indexAxis, xid, yid, rid);
        const vid = meta.vAxisID = chooseId(indexAxis, yid, xid, rid);
        meta.xScale = this.getScaleForId(xid);
        meta.yScale = this.getScaleForId(yid);
        meta.rScale = this.getScaleForId(rid);
        meta.iScale = this.getScaleForId(iid);
        meta.vScale = this.getScaleForId(vid);
    }
    getDataset() {
        return this.chart.data.datasets[this.index];
    }
    getMeta() {
        return this.chart.getDatasetMeta(this.index);
    }
 getScaleForId(scaleID) {
        return this.chart.scales[scaleID];
    }
 _getOtherScale(scale) {
        const meta = this._cachedMeta;
        return scale === meta.iScale ? meta.vScale : meta.iScale;
    }
    reset() {
        this._update('reset');
    }
 _destroy() {
        const meta = this._cachedMeta;
        if (this._data) {
            unlistenArrayEvents(this._data, this);
        }
        if (meta._stacked) {
            clearStacks(meta);
        }
    }
 _dataCheck() {
        const dataset = this.getDataset();
        const data = dataset.data || (dataset.data = []);
        const _data = this._data;
        if (isObject(data)) {
            const meta = this._cachedMeta;
            this._data = convertObjectDataToArray(data, meta);
        } else if (_data !== data) {
            if (_data) {
                unlistenArrayEvents(_data, this);
                const meta = this._cachedMeta;
                clearStacks(meta);
                meta._parsed = [];
            }
            if (data && Object.isExtensible(data)) {
                listenArrayEvents(data, this);
            }
            this._syncList = [];
            this._data = data;
        }
    }
    addElements() {
        const meta = this._cachedMeta;
        this._dataCheck();
        if (this.datasetElementType) {
            meta.dataset = new this.datasetElementType();
        }
    }
    buildOrUpdateElements(resetNewElements) {
        const meta = this._cachedMeta;
        const dataset = this.getDataset();
        let stackChanged = false;
        this._dataCheck();
        const oldStacked = meta._stacked;
        meta._stacked = isStacked(meta.vScale, meta);
        if (meta.stack !== dataset.stack) {
            stackChanged = true;
            clearStacks(meta);
            meta.stack = dataset.stack;
        }
        this._resyncElements(resetNewElements);
        if (stackChanged || oldStacked !== meta._stacked) {
            updateStacks(this, meta._parsed);
            meta._stacked = isStacked(meta.vScale, meta);
        }
    }
 configure() {
        const config = this.chart.config;
        const scopeKeys = config.datasetScopeKeys(this._type);
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys, true);
        this.options = config.createResolver(scopes, this.getContext());
        this._parsing = this.options.parsing;
        this._cachedDataOpts = {};
    }
 parse(start, count) {
        const { _cachedMeta: meta , _data: data  } = this;
        const { iScale , _stacked  } = meta;
        const iAxis = iScale.axis;
        let sorted = start === 0 && count === data.length ? true : meta._sorted;
        let prev = start > 0 && meta._parsed[start - 1];
        let i, cur, parsed;
        if (this._parsing === false) {
            meta._parsed = data;
            meta._sorted = true;
            parsed = data;
        } else {
            if (isArray(data[start])) {
                parsed = this.parseArrayData(meta, data, start, count);
            } else if (isObject(data[start])) {
                parsed = this.parseObjectData(meta, data, start, count);
            } else {
                parsed = this.parsePrimitiveData(meta, data, start, count);
            }
            const isNotInOrderComparedToPrev = ()=>cur[iAxis] === null || prev && cur[iAxis] < prev[iAxis];
            for(i = 0; i < count; ++i){
                meta._parsed[i + start] = cur = parsed[i];
                if (sorted) {
                    if (isNotInOrderComparedToPrev()) {
                        sorted = false;
                    }
                    prev = cur;
                }
            }
            meta._sorted = sorted;
        }
        if (_stacked) {
            updateStacks(this, parsed);
        }
    }
 parsePrimitiveData(meta, data, start, count) {
        const { iScale , vScale  } = meta;
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const labels = iScale.getLabels();
        const singleScale = iScale === vScale;
        const parsed = new Array(count);
        let i, ilen, index;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            parsed[i] = {
                [iAxis]: singleScale || iScale.parse(labels[index], index),
                [vAxis]: vScale.parse(data[index], index)
            };
        }
        return parsed;
    }
 parseArrayData(meta, data, start, count) {
        const { xScale , yScale  } = meta;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(item[0], index),
                y: yScale.parse(item[1], index)
            };
        }
        return parsed;
    }
 parseObjectData(meta, data, start, count) {
        const { xScale , yScale  } = meta;
        const { xAxisKey ='x' , yAxisKey ='y'  } = this._parsing;
        const parsed = new Array(count);
        let i, ilen, index, item;
        for(i = 0, ilen = count; i < ilen; ++i){
            index = i + start;
            item = data[index];
            parsed[i] = {
                x: xScale.parse(resolveObjectKey(item, xAxisKey), index),
                y: yScale.parse(resolveObjectKey(item, yAxisKey), index)
            };
        }
        return parsed;
    }
 getParsed(index) {
        return this._cachedMeta._parsed[index];
    }
 getDataElement(index) {
        return this._cachedMeta.data[index];
    }
 applyStack(scale, parsed, mode) {
        const chart = this.chart;
        const meta = this._cachedMeta;
        const value = parsed[scale.axis];
        const stack = {
            keys: getSortedDatasetIndices(chart, true),
            values: parsed._stacks[scale.axis]._visualValues
        };
        return applyStack(stack, value, meta.index, {
            mode
        });
    }
 updateRangeFromParsed(range, scale, parsed, stack) {
        const parsedValue = parsed[scale.axis];
        let value = parsedValue === null ? NaN : parsedValue;
        const values = stack && parsed._stacks[scale.axis];
        if (stack && values) {
            stack.values = values;
            value = applyStack(stack, parsedValue, this._cachedMeta.index);
        }
        range.min = Math.min(range.min, value);
        range.max = Math.max(range.max, value);
    }
 getMinMax(scale, canStack) {
        const meta = this._cachedMeta;
        const _parsed = meta._parsed;
        const sorted = meta._sorted && scale === meta.iScale;
        const ilen = _parsed.length;
        const otherScale = this._getOtherScale(scale);
        const stack = createStack(canStack, meta, this.chart);
        const range = {
            min: Number.POSITIVE_INFINITY,
            max: Number.NEGATIVE_INFINITY
        };
        const { min: otherMin , max: otherMax  } = getUserBounds(otherScale);
        let i, parsed;
        function _skip() {
            parsed = _parsed[i];
            const otherValue = parsed[otherScale.axis];
            return !isNumberFinite(parsed[scale.axis]) || otherMin > otherValue || otherMax < otherValue;
        }
        for(i = 0; i < ilen; ++i){
            if (_skip()) {
                continue;
            }
            this.updateRangeFromParsed(range, scale, parsed, stack);
            if (sorted) {
                break;
            }
        }
        if (sorted) {
            for(i = ilen - 1; i >= 0; --i){
                if (_skip()) {
                    continue;
                }
                this.updateRangeFromParsed(range, scale, parsed, stack);
                break;
            }
        }
        return range;
    }
    getAllParsedValues(scale) {
        const parsed = this._cachedMeta._parsed;
        const values = [];
        let i, ilen, value;
        for(i = 0, ilen = parsed.length; i < ilen; ++i){
            value = parsed[i][scale.axis];
            if (isNumberFinite(value)) {
                values.push(value);
            }
        }
        return values;
    }
 getMaxOverflow() {
        return false;
    }
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const vScale = meta.vScale;
        const parsed = this.getParsed(index);
        return {
            label: iScale ? '' + iScale.getLabelForValue(parsed[iScale.axis]) : '',
            value: vScale ? '' + vScale.getLabelForValue(parsed[vScale.axis]) : ''
        };
    }
 _update(mode) {
        const meta = this._cachedMeta;
        this.update(mode || 'default');
        meta._clip = toClip(valueOrDefault(this.options.clip, defaultClip(meta.xScale, meta.yScale, this.getMaxOverflow())));
    }
 update(mode) {}
    draw() {
        const ctx = this._ctx;
        const chart = this.chart;
        const meta = this._cachedMeta;
        const elements = meta.data || [];
        const area = chart.chartArea;
        const active = [];
        const start = this._drawStart || 0;
        const count = this._drawCount || elements.length - start;
        const drawActiveElementsOnTop = this.options.drawActiveElementsOnTop;
        let i;
        if (meta.dataset) {
            meta.dataset.draw(ctx, area, start, count);
        }
        for(i = start; i < start + count; ++i){
            const element = elements[i];
            if (element.hidden) {
                continue;
            }
            if (element.active && drawActiveElementsOnTop) {
                active.push(element);
            } else {
                element.draw(ctx, area);
            }
        }
        for(i = 0; i < active.length; ++i){
            active[i].draw(ctx, area);
        }
    }
 getStyle(index, active) {
        const mode = active ? 'active' : 'default';
        return index === undefined && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(mode) : this.resolveDataElementOptions(index || 0, mode);
    }
 getContext(index, active, mode) {
        const dataset = this.getDataset();
        let context;
        if (index >= 0 && index < this._cachedMeta.data.length) {
            const element = this._cachedMeta.data[index];
            context = element.$context || (element.$context = createDataContext(this.getContext(), index, element));
            context.parsed = this.getParsed(index);
            context.raw = dataset.data[index];
            context.index = context.dataIndex = index;
        } else {
            context = this.$context || (this.$context = createDatasetContext(this.chart.getContext(), this.index));
            context.dataset = dataset;
            context.index = context.datasetIndex = this.index;
        }
        context.active = !!active;
        context.mode = mode;
        return context;
    }
 resolveDatasetElementOptions(mode) {
        return this._resolveElementOptions(this.datasetElementType.id, mode);
    }
 resolveDataElementOptions(index, mode) {
        return this._resolveElementOptions(this.dataElementType.id, mode, index);
    }
 _resolveElementOptions(elementType, mode = 'default', index) {
        const active = mode === 'active';
        const cache = this._cachedDataOpts;
        const cacheKey = elementType + '-' + mode;
        const cached = cache[cacheKey];
        const sharing = this.enableOptionSharing && defined(index);
        if (cached) {
            return cloneIfNotShared(cached, sharing);
        }
        const config = this.chart.config;
        const scopeKeys = config.datasetElementScopeKeys(this._type, elementType);
        const prefixes = active ? [
            `${elementType}Hover`,
            'hover',
            elementType,
            ''
        ] : [
            elementType,
            ''
        ];
        const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
        const names = Object.keys(defaults.elements[elementType]);
        const context = ()=>this.getContext(index, active, mode);
        const values = config.resolveNamedOptions(scopes, names, context, prefixes);
        if (values.$shared) {
            values.$shared = sharing;
            cache[cacheKey] = Object.freeze(cloneIfNotShared(values, sharing));
        }
        return values;
    }
 _resolveAnimations(index, transition, active) {
        const chart = this.chart;
        const cache = this._cachedDataOpts;
        const cacheKey = `animation-${transition}`;
        const cached = cache[cacheKey];
        if (cached) {
            return cached;
        }
        let options;
        if (chart.options.animation !== false) {
            const config = this.chart.config;
            const scopeKeys = config.datasetAnimationScopeKeys(this._type, transition);
            const scopes = config.getOptionScopes(this.getDataset(), scopeKeys);
            options = config.createResolver(scopes, this.getContext(index, active, transition));
        }
        const animations = new Animations(chart, options && options.animations);
        if (options && options._cacheable) {
            cache[cacheKey] = Object.freeze(animations);
        }
        return animations;
    }
 getSharedOptions(options) {
        if (!options.$shared) {
            return;
        }
        return this._sharedOptions || (this._sharedOptions = Object.assign({}, options));
    }
 includeOptions(mode, sharedOptions) {
        return !sharedOptions || isDirectUpdateMode(mode) || this.chart._animationsDisabled;
    }
 _getSharedOptions(start, mode) {
        const firstOpts = this.resolveDataElementOptions(start, mode);
        const previouslySharedOptions = this._sharedOptions;
        const sharedOptions = this.getSharedOptions(firstOpts);
        const includeOptions = this.includeOptions(mode, sharedOptions) || sharedOptions !== previouslySharedOptions;
        this.updateSharedOptions(sharedOptions, mode, firstOpts);
        return {
            sharedOptions,
            includeOptions
        };
    }
 updateElement(element, index, properties, mode) {
        if (isDirectUpdateMode(mode)) {
            Object.assign(element, properties);
        } else {
            this._resolveAnimations(index, mode).update(element, properties);
        }
    }
 updateSharedOptions(sharedOptions, mode, newOptions) {
        if (sharedOptions && !isDirectUpdateMode(mode)) {
            this._resolveAnimations(undefined, mode).update(sharedOptions, newOptions);
        }
    }
 _setStyle(element, index, mode, active) {
        element.active = active;
        const options = this.getStyle(index, active);
        this._resolveAnimations(index, mode, active).update(element, {
            options: !active && this.getSharedOptions(options) || options
        });
    }
    removeHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', false);
    }
    setHoverStyle(element, datasetIndex, index) {
        this._setStyle(element, index, 'active', true);
    }
 _removeDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) {
            this._setStyle(element, undefined, 'active', false);
        }
    }
 _setDatasetHoverStyle() {
        const element = this._cachedMeta.dataset;
        if (element) {
            this._setStyle(element, undefined, 'active', true);
        }
    }
 _resyncElements(resetNewElements) {
        const data = this._data;
        const elements = this._cachedMeta.data;
        for (const [method, arg1, arg2] of this._syncList){
            this[method](arg1, arg2);
        }
        this._syncList = [];
        const numMeta = elements.length;
        const numData = data.length;
        const count = Math.min(numData, numMeta);
        if (count) {
            this.parse(0, count);
        }
        if (numData > numMeta) {
            this._insertElements(numMeta, numData - numMeta, resetNewElements);
        } else if (numData < numMeta) {
            this._removeElements(numData, numMeta - numData);
        }
    }
 _insertElements(start, count, resetNewElements = true) {
        const meta = this._cachedMeta;
        const data = meta.data;
        const end = start + count;
        let i;
        const move = (arr)=>{
            arr.length += count;
            for(i = arr.length - 1; i >= end; i--){
                arr[i] = arr[i - count];
            }
        };
        move(data);
        for(i = start; i < end; ++i){
            data[i] = new this.dataElementType();
        }
        if (this._parsing) {
            move(meta._parsed);
        }
        this.parse(start, count);
        if (resetNewElements) {
            this.updateElements(data, start, count, 'reset');
        }
    }
    updateElements(element, start, count, mode) {}
 _removeElements(start, count) {
        const meta = this._cachedMeta;
        if (this._parsing) {
            const removed = meta._parsed.splice(start, count);
            if (meta._stacked) {
                clearStacks(meta, removed);
            }
        }
        meta.data.splice(start, count);
    }
 _sync(args) {
        if (this._parsing) {
            this._syncList.push(args);
        } else {
            const [method, arg1, arg2] = args;
            this[method](arg1, arg2);
        }
        this.chart._dataChanges.push([
            this.index,
            ...args
        ]);
    }
    _onDataPush() {
        const count = arguments.length;
        this._sync([
            '_insertElements',
            this.getDataset().data.length - count,
            count
        ]);
    }
    _onDataPop() {
        this._sync([
            '_removeElements',
            this._cachedMeta.data.length - 1,
            1
        ]);
    }
    _onDataShift() {
        this._sync([
            '_removeElements',
            0,
            1
        ]);
    }
    _onDataSplice(start, count) {
        if (count) {
            this._sync([
                '_removeElements',
                start,
                count
            ]);
        }
        const newCount = arguments.length - 2;
        if (newCount) {
            this._sync([
                '_insertElements',
                start,
                newCount
            ]);
        }
    }
    _onDataUnshift() {
        this._sync([
            '_insertElements',
            0,
            arguments.length
        ]);
    }
}

function getAllScaleValues(scale, type) {
    if (!scale._cache.$bar) {
        const visibleMetas = scale.getMatchingVisibleMetas(type);
        let values = [];
        for(let i = 0, ilen = visibleMetas.length; i < ilen; i++){
            values = values.concat(visibleMetas[i].controller.getAllParsedValues(scale));
        }
        scale._cache.$bar = _arrayUnique(values.sort((a, b)=>a - b));
    }
    return scale._cache.$bar;
}
 function computeMinSampleSize(meta) {
    const scale = meta.iScale;
    const values = getAllScaleValues(scale, meta.type);
    let min = scale._length;
    let i, ilen, curr, prev;
    const updateMinAndPrev = ()=>{
        if (curr === 32767 || curr === -32768) {
            return;
        }
        if (defined(prev)) {
            min = Math.min(min, Math.abs(curr - prev) || min);
        }
        prev = curr;
    };
    for(i = 0, ilen = values.length; i < ilen; ++i){
        curr = scale.getPixelForValue(values[i]);
        updateMinAndPrev();
    }
    prev = undefined;
    for(i = 0, ilen = scale.ticks.length; i < ilen; ++i){
        curr = scale.getPixelForTick(i);
        updateMinAndPrev();
    }
    return min;
}
 function computeFitCategoryTraits(index, ruler, options, stackCount) {
    const thickness = options.barThickness;
    let size, ratio;
    if (isNullOrUndef(thickness)) {
        size = ruler.min * options.categoryPercentage;
        ratio = options.barPercentage;
    } else {
        size = thickness * stackCount;
        ratio = 1;
    }
    return {
        chunk: size / stackCount,
        ratio,
        start: ruler.pixels[index] - size / 2
    };
}
 function computeFlexCategoryTraits(index, ruler, options, stackCount) {
    const pixels = ruler.pixels;
    const curr = pixels[index];
    let prev = index > 0 ? pixels[index - 1] : null;
    let next = index < pixels.length - 1 ? pixels[index + 1] : null;
    const percent = options.categoryPercentage;
    if (prev === null) {
        prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    }
    if (next === null) {
        next = curr + curr - prev;
    }
    const start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    const size = Math.abs(next - prev) / 2 * percent;
    return {
        chunk: size / stackCount,
        ratio: options.barPercentage,
        start
    };
}
function parseFloatBar(entry, item, vScale, i) {
    const startValue = vScale.parse(entry[0], i);
    const endValue = vScale.parse(entry[1], i);
    const min = Math.min(startValue, endValue);
    const max = Math.max(startValue, endValue);
    let barStart = min;
    let barEnd = max;
    if (Math.abs(min) > Math.abs(max)) {
        barStart = max;
        barEnd = min;
    }
    item[vScale.axis] = barEnd;
    item._custom = {
        barStart,
        barEnd,
        start: startValue,
        end: endValue,
        min,
        max
    };
}
function parseValue(entry, item, vScale, i) {
    if (isArray(entry)) {
        parseFloatBar(entry, item, vScale, i);
    } else {
        item[vScale.axis] = vScale.parse(entry, i);
    }
    return item;
}
function parseArrayOrPrimitive(meta, data, start, count) {
    const iScale = meta.iScale;
    const vScale = meta.vScale;
    const labels = iScale.getLabels();
    const singleScale = iScale === vScale;
    const parsed = [];
    let i, ilen, item, entry;
    for(i = start, ilen = start + count; i < ilen; ++i){
        entry = data[i];
        item = {};
        item[iScale.axis] = singleScale || iScale.parse(labels[i], i);
        parsed.push(parseValue(entry, item, vScale, i));
    }
    return parsed;
}
function isFloatBar(custom) {
    return custom && custom.barStart !== undefined && custom.barEnd !== undefined;
}
function barSign(size, vScale, actualBase) {
    if (size !== 0) {
        return sign(size);
    }
    return (vScale.isHorizontal() ? 1 : -1) * (vScale.min >= actualBase ? 1 : -1);
}
function borderProps(properties) {
    let reverse, start, end, top, bottom;
    if (properties.horizontal) {
        reverse = properties.base > properties.x;
        start = 'left';
        end = 'right';
    } else {
        reverse = properties.base < properties.y;
        start = 'bottom';
        end = 'top';
    }
    if (reverse) {
        top = 'end';
        bottom = 'start';
    } else {
        top = 'start';
        bottom = 'end';
    }
    return {
        start,
        end,
        reverse,
        top,
        bottom
    };
}
function setBorderSkipped(properties, options, stack, index) {
    let edge = options.borderSkipped;
    const res = {};
    if (!edge) {
        properties.borderSkipped = res;
        return;
    }
    if (edge === true) {
        properties.borderSkipped = {
            top: true,
            right: true,
            bottom: true,
            left: true
        };
        return;
    }
    const { start , end , reverse , top , bottom  } = borderProps(properties);
    if (edge === 'middle' && stack) {
        properties.enableBorderRadius = true;
        if ((stack._top || 0) === index) {
            edge = top;
        } else if ((stack._bottom || 0) === index) {
            edge = bottom;
        } else {
            res[parseEdge(bottom, start, end, reverse)] = true;
            edge = top;
        }
    }
    res[parseEdge(edge, start, end, reverse)] = true;
    properties.borderSkipped = res;
}
function parseEdge(edge, a, b, reverse) {
    if (reverse) {
        edge = swap(edge, a, b);
        edge = startEnd(edge, b, a);
    } else {
        edge = startEnd(edge, a, b);
    }
    return edge;
}
function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
}
function startEnd(v, start, end) {
    return v === 'start' ? start : v === 'end' ? end : v;
}
function setInflateAmount(properties, { inflateAmount  }, ratio) {
    properties.inflateAmount = inflateAmount === 'auto' ? ratio === 1 ? 0.33 : 0 : inflateAmount;
}
class BarController extends DatasetController {
    static id = 'bar';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'bar',
        categoryPercentage: 0.8,
        barPercentage: 0.9,
        grouped: true,
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'base',
                    'width',
                    'height'
                ]
            }
        }
    };
 static overrides = {
        scales: {
            _index_: {
                type: 'category',
                offset: true,
                grid: {
                    offset: true
                }
            },
            _value_: {
                type: 'linear',
                beginAtZero: true
            }
        }
    };
 parsePrimitiveData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
 parseArrayData(meta, data, start, count) {
        return parseArrayOrPrimitive(meta, data, start, count);
    }
 parseObjectData(meta, data, start, count) {
        const { iScale , vScale  } = meta;
        const { xAxisKey ='x' , yAxisKey ='y'  } = this._parsing;
        const iAxisKey = iScale.axis === 'x' ? xAxisKey : yAxisKey;
        const vAxisKey = vScale.axis === 'x' ? xAxisKey : yAxisKey;
        const parsed = [];
        let i, ilen, item, obj;
        for(i = start, ilen = start + count; i < ilen; ++i){
            obj = data[i];
            item = {};
            item[iScale.axis] = iScale.parse(resolveObjectKey(obj, iAxisKey), i);
            parsed.push(parseValue(resolveObjectKey(obj, vAxisKey), item, vScale, i));
        }
        return parsed;
    }
 updateRangeFromParsed(range, scale, parsed, stack) {
        super.updateRangeFromParsed(range, scale, parsed, stack);
        const custom = parsed._custom;
        if (custom && scale === this._cachedMeta.vScale) {
            range.min = Math.min(range.min, custom.min);
            range.max = Math.max(range.max, custom.max);
        }
    }
 getMaxOverflow() {
        return 0;
    }
 getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const { iScale , vScale  } = meta;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const value = isFloatBar(custom) ? '[' + custom.start + ', ' + custom.end + ']' : '' + vScale.getLabelForValue(parsed[vScale.axis]);
        return {
            label: '' + iScale.getLabelForValue(parsed[iScale.axis]),
            value
        };
    }
    initialize() {
        this.enableOptionSharing = true;
        super.initialize();
        const meta = this._cachedMeta;
        meta.stack = this.getDataset().stack;
    }
    update(mode) {
        const meta = this._cachedMeta;
        this.updateElements(meta.data, 0, meta.data.length, mode);
    }
    updateElements(bars, start, count, mode) {
        const reset = mode === 'reset';
        const { index , _cachedMeta: { vScale  }  } = this;
        const base = vScale.getBasePixel();
        const horizontal = vScale.isHorizontal();
        const ruler = this._getRuler();
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        for(let i = start; i < start + count; i++){
            const parsed = this.getParsed(i);
            const vpixels = reset || isNullOrUndef(parsed[vScale.axis]) ? {
                base,
                head: base
            } : this._calculateBarValuePixels(i);
            const ipixels = this._calculateBarIndexPixels(i, ruler);
            const stack = (parsed._stacks || {})[vScale.axis];
            const properties = {
                horizontal,
                base: vpixels.base,
                enableBorderRadius: !stack || isFloatBar(parsed._custom) || index === stack._top || index === stack._bottom,
                x: horizontal ? vpixels.head : ipixels.center,
                y: horizontal ? ipixels.center : vpixels.head,
                height: horizontal ? ipixels.size : Math.abs(vpixels.size),
                width: horizontal ? Math.abs(vpixels.size) : ipixels.size
            };
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, bars[i].active ? 'active' : mode);
            }
            const options = properties.options || bars[i].options;
            setBorderSkipped(properties, options, stack, index);
            setInflateAmount(properties, options, ruler.ratio);
            this.updateElement(bars[i], i, properties, mode);
        }
    }
 _getStacks(last, dataIndex) {
        const { iScale  } = this._cachedMeta;
        const metasets = iScale.getMatchingVisibleMetas(this._type).filter((meta)=>meta.controller.options.grouped);
        const stacked = iScale.options.stacked;
        const stacks = [];
        const currentParsed = this._cachedMeta.controller.getParsed(dataIndex);
        const iScaleValue = currentParsed && currentParsed[iScale.axis];
        const skipNull = (meta)=>{
            const parsed = meta._parsed.find((item)=>item[iScale.axis] === iScaleValue);
            const val = parsed && parsed[meta.vScale.axis];
            if (isNullOrUndef(val) || isNaN(val)) {
                return true;
            }
        };
        for (const meta of metasets){
            if (dataIndex !== undefined && skipNull(meta)) {
                continue;
            }
            if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
                stacks.push(meta.stack);
            }
            if (meta.index === last) {
                break;
            }
        }
        if (!stacks.length) {
            stacks.push(undefined);
        }
        return stacks;
    }
 _getStackCount(index) {
        return this._getStacks(undefined, index).length;
    }
    _getAxisCount() {
        return this._getAxis().length;
    }
    getFirstScaleIdForIndexAxis() {
        const scales = this.chart.scales;
        const indexScaleId = this.chart.options.indexAxis;
        return Object.keys(scales).filter((key)=>scales[key].axis === indexScaleId).shift();
    }
    _getAxis() {
        const axis = {};
        const firstScaleAxisId = this.getFirstScaleIdForIndexAxis();
        for (const dataset of this.chart.data.datasets){
            axis[valueOrDefault(this.chart.options.indexAxis === 'x' ? dataset.xAxisID : dataset.yAxisID, firstScaleAxisId)] = true;
        }
        return Object.keys(axis);
    }
 _getStackIndex(datasetIndex, name, dataIndex) {
        const stacks = this._getStacks(datasetIndex, dataIndex);
        const index = name !== undefined ? stacks.indexOf(name) : -1;
        return index === -1 ? stacks.length - 1 : index;
    }
 _getRuler() {
        const opts = this.options;
        const meta = this._cachedMeta;
        const iScale = meta.iScale;
        const pixels = [];
        let i, ilen;
        for(i = 0, ilen = meta.data.length; i < ilen; ++i){
            pixels.push(iScale.getPixelForValue(this.getParsed(i)[iScale.axis], i));
        }
        const barThickness = opts.barThickness;
        const min = barThickness || computeMinSampleSize(meta);
        return {
            min,
            pixels,
            start: iScale._startPixel,
            end: iScale._endPixel,
            stackCount: this._getStackCount(),
            scale: iScale,
            grouped: opts.grouped,
            ratio: barThickness ? 1 : opts.categoryPercentage * opts.barPercentage
        };
    }
 _calculateBarValuePixels(index) {
        const { _cachedMeta: { vScale , _stacked , index: datasetIndex  } , options: { base: baseValue , minBarLength  }  } = this;
        const actualBase = baseValue || 0;
        const parsed = this.getParsed(index);
        const custom = parsed._custom;
        const floating = isFloatBar(custom);
        let value = parsed[vScale.axis];
        let start = 0;
        let length = _stacked ? this.applyStack(vScale, parsed, _stacked) : value;
        let head, size;
        if (length !== value) {
            start = length - value;
            length = value;
        }
        if (floating) {
            value = custom.barStart;
            length = custom.barEnd - custom.barStart;
            if (value !== 0 && sign(value) !== sign(custom.barEnd)) {
                start = 0;
            }
            start += value;
        }
        const startValue = !isNullOrUndef(baseValue) && !floating ? baseValue : start;
        let base = vScale.getPixelForValue(startValue);
        if (this.chart.getDataVisibility(index)) {
            head = vScale.getPixelForValue(start + length);
        } else {
            head = base;
        }
        size = head - base;
        if (Math.abs(size) < minBarLength) {
            size = barSign(size, vScale, actualBase) * minBarLength;
            if (value === actualBase) {
                base -= size / 2;
            }
            const startPixel = vScale.getPixelForDecimal(0);
            const endPixel = vScale.getPixelForDecimal(1);
            const min = Math.min(startPixel, endPixel);
            const max = Math.max(startPixel, endPixel);
            base = Math.max(Math.min(base, max), min);
            head = base + size;
            if (_stacked && !floating) {
                parsed._stacks[vScale.axis]._visualValues[datasetIndex] = vScale.getValueForPixel(head) - vScale.getValueForPixel(base);
            }
        }
        if (base === vScale.getPixelForValue(actualBase)) {
            const halfGrid = sign(size) * vScale.getLineWidthForValue(actualBase) / 2;
            base += halfGrid;
            size -= halfGrid;
        }
        return {
            size,
            base,
            head,
            center: head + size / 2
        };
    }
 _calculateBarIndexPixels(index, ruler) {
        const scale = ruler.scale;
        const options = this.options;
        const skipNull = options.skipNull;
        const maxBarThickness = valueOrDefault(options.maxBarThickness, Infinity);
        let center, size;
        const axisCount = this._getAxisCount();
        if (ruler.grouped) {
            const stackCount = skipNull ? this._getStackCount(index) : ruler.stackCount;
            const range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options, stackCount * axisCount) : computeFitCategoryTraits(index, ruler, options, stackCount * axisCount);
            const axisID = this.chart.options.indexAxis === 'x' ? this.getDataset().xAxisID : this.getDataset().yAxisID;
            const axisNumber = this._getAxis().indexOf(valueOrDefault(axisID, this.getFirstScaleIdForIndexAxis()));
            const stackIndex = this._getStackIndex(this.index, this._cachedMeta.stack, skipNull ? index : undefined) + axisNumber;
            center = range.start + range.chunk * stackIndex + range.chunk / 2;
            size = Math.min(maxBarThickness, range.chunk * range.ratio);
        } else {
            center = scale.getPixelForValue(this.getParsed(index)[scale.axis], index);
            size = Math.min(maxBarThickness, ruler.min * ruler.ratio);
        }
        return {
            base: center - size / 2,
            head: center + size / 2,
            center,
            size
        };
    }
    draw() {
        const meta = this._cachedMeta;
        const vScale = meta.vScale;
        const rects = meta.data;
        const ilen = rects.length;
        let i = 0;
        for(; i < ilen; ++i){
            if (this.getParsed(i)[vScale.axis] !== null && !rects[i].hidden) {
                rects[i].draw(this._ctx);
            }
        }
    }
}

function getRatioAndOffset(rotation, circumference, cutout) {
    let ratioX = 1;
    let ratioY = 1;
    let offsetX = 0;
    let offsetY = 0;
    if (circumference < TAU) {
        const startAngle = rotation;
        const endAngle = startAngle + circumference;
        const startX = Math.cos(startAngle);
        const startY = Math.sin(startAngle);
        const endX = Math.cos(endAngle);
        const endY = Math.sin(endAngle);
        const calcMax = (angle, a, b)=>_angleBetween(angle, startAngle, endAngle, true) ? 1 : Math.max(a, a * cutout, b, b * cutout);
        const calcMin = (angle, a, b)=>_angleBetween(angle, startAngle, endAngle, true) ? -1 : Math.min(a, a * cutout, b, b * cutout);
        const maxX = calcMax(0, startX, endX);
        const maxY = calcMax(HALF_PI, startY, endY);
        const minX = calcMin(PI, startX, endX);
        const minY = calcMin(PI + HALF_PI, startY, endY);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
    }
    return {
        ratioX,
        ratioY,
        offsetX,
        offsetY
    };
}
class DoughnutController extends DatasetController {
    static id = 'doughnut';
 static defaults = {
        datasetElementType: false,
        dataElementType: 'arc',
        animation: {
            animateRotate: true,
            animateScale: false
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'circumference',
                    'endAngle',
                    'innerRadius',
                    'outerRadius',
                    'startAngle',
                    'x',
                    'y',
                    'offset',
                    'borderWidth',
                    'spacing'
                ]
            }
        },
        cutout: '50%',
        rotation: 0,
        circumference: 360,
        radius: '100%',
        spacing: 0,
        indexAxis: 'r'
    };
    static descriptors = {
        _scriptable: (name)=>name !== 'spacing',
        _indexable: (name)=>name !== 'spacing' && !name.startsWith('borderDash') && !name.startsWith('hoverBorderDash')
    };
 static overrides = {
        aspectRatio: 1,
        plugins: {
            legend: {
                labels: {
                    generateLabels (chart) {
                        const data = chart.data;
                        const { labels: { pointStyle , textAlign , color , useBorderRadius , borderRadius  }  } = chart.legend.options;
                        if (data.labels.length && data.datasets.length) {
                            return data.labels.map((label, i)=>{
                                const meta = chart.getDatasetMeta(0);
                                const style = meta.controller.getStyle(i);
                                return {
                                    text: label,
                                    fillStyle: style.backgroundColor,
                                    fontColor: color,
                                    hidden: !chart.getDataVisibility(i),
                                    lineDash: style.borderDash,
                                    lineDashOffset: style.borderDashOffset,
                                    lineJoin: style.borderJoinStyle,
                                    lineWidth: style.borderWidth,
                                    strokeStyle: style.borderColor,
                                    textAlign: textAlign,
                                    pointStyle: pointStyle,
                                    borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                                    index: i
                                };
                            });
                        }
                        return [];
                    }
                },
                onClick (e, legendItem, legend) {
                    legend.chart.toggleDataVisibility(legendItem.index);
                    legend.chart.update();
                }
            }
        }
    };
    constructor(chart, datasetIndex){
        super(chart, datasetIndex);
        this.enableOptionSharing = true;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.offsetX = undefined;
        this.offsetY = undefined;
    }
    linkScales() {}
 parse(start, count) {
        const data = this.getDataset().data;
        const meta = this._cachedMeta;
        if (this._parsing === false) {
            meta._parsed = data;
        } else {
            let getter = (i)=>+data[i];
            if (isObject(data[start])) {
                const { key ='value'  } = this._parsing;
                getter = (i)=>+resolveObjectKey(data[i], key);
            }
            let i, ilen;
            for(i = start, ilen = start + count; i < ilen; ++i){
                meta._parsed[i] = getter(i);
            }
        }
    }
 _getRotation() {
        return toRadians(this.options.rotation - 90);
    }
 _getCircumference() {
        return toRadians(this.options.circumference);
    }
 _getRotationExtents() {
        let min = TAU;
        let max = -TAU;
        for(let i = 0; i < this.chart.data.datasets.length; ++i){
            if (this.chart.isDatasetVisible(i) && this.chart.getDatasetMeta(i).type === this._type) {
                const controller = this.chart.getDatasetMeta(i).controller;
                const rotation = controller._getRotation();
                const circumference = controller._getCircumference();
                min = Math.min(min, rotation);
                max = Math.max(max, rotation + circumference);
            }
        }
        return {
            rotation: min,
            circumference: max - min
        };
    }
 update(mode) {
        const chart = this.chart;
        const { chartArea  } = chart;
        const meta = this._cachedMeta;
        const arcs = meta.data;
        const spacing = this.getMaxBorderWidth() + this.getMaxOffset(arcs) + this.options.spacing;
        const maxSize = Math.max((Math.min(chartArea.width, chartArea.height) - spacing) / 2, 0);
        const cutout = Math.min(toPercentage(this.options.cutout, maxSize), 1);
        const chartWeight = this._getRingWeight(this.index);
        const { circumference , rotation  } = this._getRotationExtents();
        const { ratioX , ratioY , offsetX , offsetY  } = getRatioAndOffset(rotation, circumference, cutout);
        const maxWidth = (chartArea.width - spacing) / ratioX;
        const maxHeight = (chartArea.height - spacing) / ratioY;
        const maxRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
        const outerRadius = toDimension(this.options.radius, maxRadius);
        const innerRadius = Math.max(outerRadius * cutout, 0);
        const radiusLength = (outerRadius - innerRadius) / this._getVisibleDatasetWeightTotal();
        this.offsetX = offsetX * outerRadius;
        this.offsetY = offsetY * outerRadius;
        meta.total = this.calculateTotal();
        this.outerRadius = outerRadius - radiusLength * this._getRingWeightOffset(this.index);
        this.innerRadius = Math.max(this.outerRadius - radiusLength * chartWeight, 0);
        this.updateElements(arcs, 0, arcs.length, mode);
    }
 _circumference(i, reset) {
        const opts = this.options;
        const meta = this._cachedMeta;
        const circumference = this._getCircumference();
        if (reset && opts.animation.animateRotate || !this.chart.getDataVisibility(i) || meta._parsed[i] === null || meta.data[i].hidden) {
            return 0;
        }
        return this.calculateCircumference(meta._parsed[i] * circumference / TAU);
    }
    updateElements(arcs, start, count, mode) {
        const reset = mode === 'reset';
        const chart = this.chart;
        const chartArea = chart.chartArea;
        const opts = chart.options;
        const animationOpts = opts.animation;
        const centerX = (chartArea.left + chartArea.right) / 2;
        const centerY = (chartArea.top + chartArea.bottom) / 2;
        const animateScale = reset && animationOpts.animateScale;
        const innerRadius = animateScale ? 0 : this.innerRadius;
        const outerRadius = animateScale ? 0 : this.outerRadius;
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        let startAngle = this._getRotation();
        let i;
        for(i = 0; i < start; ++i){
            startAngle += this._circumference(i, reset);
        }
        for(i = start; i < start + count; ++i){
            const circumference = this._circumference(i, reset);
            const arc = arcs[i];
            const properties = {
                x: centerX + this.offsetX,
                y: centerY + this.offsetY,
                startAngle,
                endAngle: startAngle + circumference,
                circumference,
                outerRadius,
                innerRadius
            };
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, arc.active ? 'active' : mode);
            }
            startAngle += circumference;
            this.updateElement(arc, i, properties, mode);
        }
    }
    calculateTotal() {
        const meta = this._cachedMeta;
        const metaData = meta.data;
        let total = 0;
        let i;
        for(i = 0; i < metaData.length; i++){
            const value = meta._parsed[i];
            if (value !== null && !isNaN(value) && this.chart.getDataVisibility(i) && !metaData[i].hidden) {
                total += Math.abs(value);
            }
        }
        return total;
    }
    calculateCircumference(value) {
        const total = this._cachedMeta.total;
        if (total > 0 && !isNaN(value)) {
            return TAU * (Math.abs(value) / total);
        }
        return 0;
    }
    getLabelAndValue(index) {
        const meta = this._cachedMeta;
        const chart = this.chart;
        const labels = chart.data.labels || [];
        const value = formatNumber(meta._parsed[index], chart.options.locale);
        return {
            label: labels[index] || '',
            value
        };
    }
    getMaxBorderWidth(arcs) {
        let max = 0;
        const chart = this.chart;
        let i, ilen, meta, controller, options;
        if (!arcs) {
            for(i = 0, ilen = chart.data.datasets.length; i < ilen; ++i){
                if (chart.isDatasetVisible(i)) {
                    meta = chart.getDatasetMeta(i);
                    arcs = meta.data;
                    controller = meta.controller;
                    break;
                }
            }
        }
        if (!arcs) {
            return 0;
        }
        for(i = 0, ilen = arcs.length; i < ilen; ++i){
            options = controller.resolveDataElementOptions(i);
            if (options.borderAlign !== 'inner') {
                max = Math.max(max, options.borderWidth || 0, options.hoverBorderWidth || 0);
            }
        }
        return max;
    }
    getMaxOffset(arcs) {
        let max = 0;
        for(let i = 0, ilen = arcs.length; i < ilen; ++i){
            const options = this.resolveDataElementOptions(i);
            max = Math.max(max, options.offset || 0, options.hoverOffset || 0);
        }
        return max;
    }
 _getRingWeightOffset(datasetIndex) {
        let ringWeightOffset = 0;
        for(let i = 0; i < datasetIndex; ++i){
            if (this.chart.isDatasetVisible(i)) {
                ringWeightOffset += this._getRingWeight(i);
            }
        }
        return ringWeightOffset;
    }
 _getRingWeight(datasetIndex) {
        return Math.max(valueOrDefault(this.chart.data.datasets[datasetIndex].weight, 1), 0);
    }
 _getVisibleDatasetWeightTotal() {
        return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
    }
}

class LineController extends DatasetController {
    static id = 'line';
 static defaults = {
        datasetElementType: 'line',
        dataElementType: 'point',
        showLine: true,
        spanGaps: false
    };
 static overrides = {
        scales: {
            _index_: {
                type: 'category'
            },
            _value_: {
                type: 'linear'
            }
        }
    };
    initialize() {
        this.enableOptionSharing = true;
        this.supportsDecimation = true;
        super.initialize();
    }
    update(mode) {
        const meta = this._cachedMeta;
        const { dataset: line , data: points = [] , _dataset  } = meta;
        const animationsDisabled = this.chart._animationsDisabled;
        let { start , count  } = _getStartAndCountOfVisiblePoints(meta, points, animationsDisabled);
        this._drawStart = start;
        this._drawCount = count;
        if (_scaleRangesChanged(meta)) {
            start = 0;
            count = points.length;
        }
        line._chart = this.chart;
        line._datasetIndex = this.index;
        line._decimated = !!_dataset._decimated;
        line.points = points;
        const options = this.resolveDatasetElementOptions(mode);
        if (!this.options.showLine) {
            options.borderWidth = 0;
        }
        options.segment = this.options.segment;
        this.updateElement(line, undefined, {
            animated: !animationsDisabled,
            options
        }, mode);
        this.updateElements(points, start, count, mode);
    }
    updateElements(points, start, count, mode) {
        const reset = mode === 'reset';
        const { iScale , vScale , _stacked , _dataset  } = this._cachedMeta;
        const { sharedOptions , includeOptions  } = this._getSharedOptions(start, mode);
        const iAxis = iScale.axis;
        const vAxis = vScale.axis;
        const { spanGaps , segment  } = this.options;
        const maxGapLength = isNumber(spanGaps) ? spanGaps : Number.POSITIVE_INFINITY;
        const directUpdate = this.chart._animationsDisabled || reset || mode === 'none';
        const end = start + count;
        const pointsCount = points.length;
        let prevParsed = start > 0 && this.getParsed(start - 1);
        for(let i = 0; i < pointsCount; ++i){
            const point = points[i];
            const properties = directUpdate ? point : {};
            if (i < start || i >= end) {
                properties.skip = true;
                continue;
            }
            const parsed = this.getParsed(i);
            const nullData = isNullOrUndef(parsed[vAxis]);
            const iPixel = properties[iAxis] = iScale.getPixelForValue(parsed[iAxis], i);
            const vPixel = properties[vAxis] = reset || nullData ? vScale.getBasePixel() : vScale.getPixelForValue(_stacked ? this.applyStack(vScale, parsed, _stacked) : parsed[vAxis], i);
            properties.skip = isNaN(iPixel) || isNaN(vPixel) || nullData;
            properties.stop = i > 0 && Math.abs(parsed[iAxis] - prevParsed[iAxis]) > maxGapLength;
            if (segment) {
                properties.parsed = parsed;
                properties.raw = _dataset.data[i];
            }
            if (includeOptions) {
                properties.options = sharedOptions || this.resolveDataElementOptions(i, point.active ? 'active' : mode);
            }
            if (!directUpdate) {
                this.updateElement(point, i, properties, mode);
            }
            prevParsed = parsed;
        }
    }
 getMaxOverflow() {
        const meta = this._cachedMeta;
        const dataset = meta.dataset;
        const border = dataset.options && dataset.options.borderWidth || 0;
        const data = meta.data || [];
        if (!data.length) {
            return border;
        }
        const firstPoint = data[0].size(this.resolveDataElementOptions(0));
        const lastPoint = data[data.length - 1].size(this.resolveDataElementOptions(data.length - 1));
        return Math.max(border, firstPoint, lastPoint) / 2;
    }
    draw() {
        const meta = this._cachedMeta;
        meta.dataset.updateControlPoints(this.chart.chartArea, meta.iScale.axis);
        super.draw();
    }
}

/**
 * @namespace Chart._adapters
 * @since 2.8.0
 * @private
 */ function abstract() {
    throw new Error('This method is not implemented: Check that a complete date adapter is provided.');
}
/**
 * Date adapter (current used by the time scale)
 * @namespace Chart._adapters._date
 * @memberof Chart._adapters
 * @private
 */ class DateAdapterBase {
    /**
   * Override default date adapter methods.
   * Accepts type parameter to define options type.
   * @example
   * Chart._adapters._date.override<{myAdapterOption: string}>({
   *   init() {
   *     console.log(this.options.myAdapterOption);
   *   }
   * })
   */ static override(members) {
        Object.assign(DateAdapterBase.prototype, members);
    }
    options;
    constructor(options){
        this.options = options || {};
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    init() {}
    formats() {
        return abstract();
    }
    parse() {
        return abstract();
    }
    format() {
        return abstract();
    }
    add() {
        return abstract();
    }
    diff() {
        return abstract();
    }
    startOf() {
        return abstract();
    }
    endOf() {
        return abstract();
    }
}
var adapters = {
    _date: DateAdapterBase
};

function binarySearch(metaset, axis, value, intersect) {
    const { controller , data , _sorted  } = metaset;
    const iScale = controller._cachedMeta.iScale;
    const spanGaps = metaset.dataset ? metaset.dataset.options ? metaset.dataset.options.spanGaps : null : null;
    if (iScale && axis === iScale.axis && axis !== 'r' && _sorted && data.length) {
        const lookupMethod = iScale._reversePixels ? _rlookupByKey : _lookupByKey;
        if (!intersect) {
            const result = lookupMethod(data, axis, value);
            if (spanGaps) {
                const { vScale  } = controller._cachedMeta;
                const { _parsed  } = metaset;
                const distanceToDefinedLo = _parsed.slice(0, result.lo + 1).reverse().findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                result.lo -= Math.max(0, distanceToDefinedLo);
                const distanceToDefinedHi = _parsed.slice(result.hi).findIndex((point)=>!isNullOrUndef(point[vScale.axis]));
                result.hi += Math.max(0, distanceToDefinedHi);
            }
            return result;
        } else if (controller._sharedOptions) {
            const el = data[0];
            const range = typeof el.getRange === 'function' && el.getRange(axis);
            if (range) {
                const start = lookupMethod(data, axis, value - range);
                const end = lookupMethod(data, axis, value + range);
                return {
                    lo: start.lo,
                    hi: end.hi
                };
            }
        }
    }
    return {
        lo: 0,
        hi: data.length - 1
    };
}
 function evaluateInteractionItems(chart, axis, position, handler, intersect) {
    const metasets = chart.getSortedVisibleDatasetMetas();
    const value = position[axis];
    for(let i = 0, ilen = metasets.length; i < ilen; ++i){
        const { index , data  } = metasets[i];
        const { lo , hi  } = binarySearch(metasets[i], axis, value, intersect);
        for(let j = lo; j <= hi; ++j){
            const element = data[j];
            if (!element.skip) {
                handler(element, index, j);
            }
        }
    }
}
 function getDistanceMetricForAxis(axis) {
    const useX = axis.indexOf('x') !== -1;
    const useY = axis.indexOf('y') !== -1;
    return function(pt1, pt2) {
        const deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
        const deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
        return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
}
 function getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) {
    const items = [];
    if (!includeInvisible && !chart.isPointInArea(position)) {
        return items;
    }
    const evaluationFunc = function(element, datasetIndex, index) {
        if (!includeInvisible && !_isPointInArea(element, chart.chartArea, 0)) {
            return;
        }
        if (element.inRange(position.x, position.y, useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    };
    evaluateInteractionItems(chart, axis, position, evaluationFunc, true);
    return items;
}
 function getNearestRadialItems(chart, position, axis, useFinalPosition) {
    let items = [];
    function evaluationFunc(element, datasetIndex, index) {
        const { startAngle , endAngle  } = element.getProps([
            'startAngle',
            'endAngle'
        ], useFinalPosition);
        const { angle  } = getAngleFromPoint(element, {
            x: position.x,
            y: position.y
        });
        if (_angleBetween(angle, startAngle, endAngle)) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
 function getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    let items = [];
    const distanceMetric = getDistanceMetricForAxis(axis);
    let minDistance = Number.POSITIVE_INFINITY;
    function evaluationFunc(element, datasetIndex, index) {
        const inRange = element.inRange(position.x, position.y, useFinalPosition);
        if (intersect && !inRange) {
            return;
        }
        const center = element.getCenterPoint(useFinalPosition);
        const pointInArea = !!includeInvisible || chart.isPointInArea(center);
        if (!pointInArea && !inRange) {
            return;
        }
        const distance = distanceMetric(position, center);
        if (distance < minDistance) {
            items = [
                {
                    element,
                    datasetIndex,
                    index
                }
            ];
            minDistance = distance;
        } else if (distance === minDistance) {
            items.push({
                element,
                datasetIndex,
                index
            });
        }
    }
    evaluateInteractionItems(chart, axis, position, evaluationFunc);
    return items;
}
 function getNearestItems(chart, position, axis, intersect, useFinalPosition, includeInvisible) {
    if (!includeInvisible && !chart.isPointInArea(position)) {
        return [];
    }
    return axis === 'r' && !intersect ? getNearestRadialItems(chart, position, axis, useFinalPosition) : getNearestCartesianItems(chart, position, axis, intersect, useFinalPosition, includeInvisible);
}
 function getAxisItems(chart, position, axis, intersect, useFinalPosition) {
    const items = [];
    const rangeMethod = axis === 'x' ? 'inXRange' : 'inYRange';
    let intersectsItem = false;
    evaluateInteractionItems(chart, axis, position, (element, datasetIndex, index)=>{
        if (element[rangeMethod] && element[rangeMethod](position[axis], useFinalPosition)) {
            items.push({
                element,
                datasetIndex,
                index
            });
            intersectsItem = intersectsItem || element.inRange(position.x, position.y, useFinalPosition);
        }
    });
    if (intersect && !intersectsItem) {
        return [];
    }
    return items;
}
 var Interaction = {
    evaluateInteractionItems,
    modes: {
 index (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'x';
            const includeInvisible = options.includeInvisible || false;
            const items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            const elements = [];
            if (!items.length) {
                return [];
            }
            chart.getSortedVisibleDatasetMetas().forEach((meta)=>{
                const index = items[0].index;
                const element = meta.data[index];
                if (element && !element.skip) {
                    elements.push({
                        element,
                        datasetIndex: meta.index,
                        index
                    });
                }
            });
            return elements;
        },
 dataset (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            let items = options.intersect ? getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible) : getNearestItems(chart, position, axis, false, useFinalPosition, includeInvisible);
            if (items.length > 0) {
                const datasetIndex = items[0].datasetIndex;
                const data = chart.getDatasetMeta(datasetIndex).data;
                items = [];
                for(let i = 0; i < data.length; ++i){
                    items.push({
                        element: data[i],
                        datasetIndex,
                        index: i
                    });
                }
            }
            return items;
        },
 point (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getIntersectItems(chart, position, axis, useFinalPosition, includeInvisible);
        },
 nearest (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            const axis = options.axis || 'xy';
            const includeInvisible = options.includeInvisible || false;
            return getNearestItems(chart, position, axis, options.intersect, useFinalPosition, includeInvisible);
        },
 x (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            return getAxisItems(chart, position, 'x', options.intersect, useFinalPosition);
        },
 y (chart, e, options, useFinalPosition) {
            const position = getRelativePosition(e, chart);
            return getAxisItems(chart, position, 'y', options.intersect, useFinalPosition);
        }
    }
};

const STATIC_POSITIONS = [
    'left',
    'top',
    'right',
    'bottom'
];
function filterByPosition(array, position) {
    return array.filter((v)=>v.pos === position);
}
function filterDynamicPositionByAxis(array, axis) {
    return array.filter((v)=>STATIC_POSITIONS.indexOf(v.pos) === -1 && v.box.axis === axis);
}
function sortByWeight(array, reverse) {
    return array.sort((a, b)=>{
        const v0 = reverse ? b : a;
        const v1 = reverse ? a : b;
        return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
}
function wrapBoxes(boxes) {
    const layoutBoxes = [];
    let i, ilen, box, pos, stack, stackWeight;
    for(i = 0, ilen = (boxes || []).length; i < ilen; ++i){
        box = boxes[i];
        ({ position: pos , options: { stack , stackWeight =1  }  } = box);
        layoutBoxes.push({
            index: i,
            box,
            pos,
            horizontal: box.isHorizontal(),
            weight: box.weight,
            stack: stack && pos + stack,
            stackWeight
        });
    }
    return layoutBoxes;
}
function buildStacks(layouts) {
    const stacks = {};
    for (const wrap of layouts){
        const { stack , pos , stackWeight  } = wrap;
        if (!stack || !STATIC_POSITIONS.includes(pos)) {
            continue;
        }
        const _stack = stacks[stack] || (stacks[stack] = {
            count: 0,
            placed: 0,
            weight: 0,
            size: 0
        });
        _stack.count++;
        _stack.weight += stackWeight;
    }
    return stacks;
}
 function setLayoutDims(layouts, params) {
    const stacks = buildStacks(layouts);
    const { vBoxMaxWidth , hBoxMaxHeight  } = params;
    let i, ilen, layout;
    for(i = 0, ilen = layouts.length; i < ilen; ++i){
        layout = layouts[i];
        const { fullSize  } = layout.box;
        const stack = stacks[layout.stack];
        const factor = stack && layout.stackWeight / stack.weight;
        if (layout.horizontal) {
            layout.width = factor ? factor * vBoxMaxWidth : fullSize && params.availableWidth;
            layout.height = hBoxMaxHeight;
        } else {
            layout.width = vBoxMaxWidth;
            layout.height = factor ? factor * hBoxMaxHeight : fullSize && params.availableHeight;
        }
    }
    return stacks;
}
function buildLayoutBoxes(boxes) {
    const layoutBoxes = wrapBoxes(boxes);
    const fullSize = sortByWeight(layoutBoxes.filter((wrap)=>wrap.box.fullSize), true);
    const left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    const right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    const top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    const bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    const centerHorizontal = filterDynamicPositionByAxis(layoutBoxes, 'x');
    const centerVertical = filterDynamicPositionByAxis(layoutBoxes, 'y');
    return {
        fullSize,
        leftAndTop: left.concat(top),
        rightAndBottom: right.concat(centerVertical).concat(bottom).concat(centerHorizontal),
        chartArea: filterByPosition(layoutBoxes, 'chartArea'),
        vertical: left.concat(right).concat(centerVertical),
        horizontal: top.concat(bottom).concat(centerHorizontal)
    };
}
function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
}
function updateMaxPadding(maxPadding, boxPadding) {
    maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
    maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
    maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
    maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
}
function updateDims(chartArea, params, layout, stacks) {
    const { pos , box  } = layout;
    const maxPadding = chartArea.maxPadding;
    if (!isObject(pos)) {
        if (layout.size) {
            chartArea[pos] -= layout.size;
        }
        const stack = stacks[layout.stack] || {
            size: 0,
            count: 1
        };
        stack.size = Math.max(stack.size, layout.horizontal ? box.height : box.width);
        layout.size = stack.size / stack.count;
        chartArea[pos] += layout.size;
    }
    if (box.getPadding) {
        updateMaxPadding(maxPadding, box.getPadding());
    }
    const newWidth = Math.max(0, params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right'));
    const newHeight = Math.max(0, params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom'));
    const widthChanged = newWidth !== chartArea.w;
    const heightChanged = newHeight !== chartArea.h;
    chartArea.w = newWidth;
    chartArea.h = newHeight;
    return layout.horizontal ? {
        same: widthChanged,
        other: heightChanged
    } : {
        same: heightChanged,
        other: widthChanged
    };
}
function handleMaxPadding(chartArea) {
    const maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
        const change = Math.max(maxPadding[pos] - chartArea[pos], 0);
        chartArea[pos] += change;
        return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
}
function getMargins(horizontal, chartArea) {
    const maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
        const margin = {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
        positions.forEach((pos)=>{
            margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
        });
        return margin;
    }
    return horizontal ? marginForPositions([
        'left',
        'right'
    ]) : marginForPositions([
        'top',
        'bottom'
    ]);
}
function fitBoxes(boxes, chartArea, params, stacks) {
    const refitBoxes = [];
    let i, ilen, layout, box, refit, changed;
    for(i = 0, ilen = boxes.length, refit = 0; i < ilen; ++i){
        layout = boxes[i];
        box = layout.box;
        box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
        const { same , other  } = updateDims(chartArea, params, layout, stacks);
        refit |= same && refitBoxes.length;
        changed = changed || other;
        if (!box.fullSize) {
            refitBoxes.push(layout);
        }
    }
    return refit && fitBoxes(refitBoxes, chartArea, params, stacks) || changed;
}
function setBoxDims(box, left, top, width, height) {
    box.top = top;
    box.left = left;
    box.right = left + width;
    box.bottom = top + height;
    box.width = width;
    box.height = height;
}
function placeBoxes(boxes, chartArea, params, stacks) {
    const userPadding = params.padding;
    let { x , y  } = chartArea;
    for (const layout of boxes){
        const box = layout.box;
        const stack = stacks[layout.stack] || {
            count: 1,
            placed: 0,
            weight: 1
        };
        const weight = layout.stackWeight / stack.weight || 1;
        if (layout.horizontal) {
            const width = chartArea.w * weight;
            const height = stack.size || box.height;
            if (defined(stack.start)) {
                y = stack.start;
            }
            if (box.fullSize) {
                setBoxDims(box, userPadding.left, y, params.outerWidth - userPadding.right - userPadding.left, height);
            } else {
                setBoxDims(box, chartArea.left + stack.placed, y, width, height);
            }
            stack.start = y;
            stack.placed += width;
            y = box.bottom;
        } else {
            const height = chartArea.h * weight;
            const width = stack.size || box.width;
            if (defined(stack.start)) {
                x = stack.start;
            }
            if (box.fullSize) {
                setBoxDims(box, x, userPadding.top, width, params.outerHeight - userPadding.bottom - userPadding.top);
            } else {
                setBoxDims(box, x, chartArea.top + stack.placed, width, height);
            }
            stack.start = x;
            stack.placed += height;
            x = box.right;
        }
    }
    chartArea.x = x;
    chartArea.y = y;
}
var layouts = {
 addBox (chart, item) {
        if (!chart.boxes) {
            chart.boxes = [];
        }
        item.fullSize = item.fullSize || false;
        item.position = item.position || 'top';
        item.weight = item.weight || 0;
        item._layers = item._layers || function() {
            return [
                {
                    z: 0,
                    draw (chartArea) {
                        item.draw(chartArea);
                    }
                }
            ];
        };
        chart.boxes.push(item);
    },
 removeBox (chart, layoutItem) {
        const index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
        if (index !== -1) {
            chart.boxes.splice(index, 1);
        }
    },
 configure (chart, item, options) {
        item.fullSize = options.fullSize;
        item.position = options.position;
        item.weight = options.weight;
    },
 update (chart, width, height, minPadding) {
        if (!chart) {
            return;
        }
        const padding = toPadding(chart.options.layout.padding);
        const availableWidth = Math.max(width - padding.width, 0);
        const availableHeight = Math.max(height - padding.height, 0);
        const boxes = buildLayoutBoxes(chart.boxes);
        const verticalBoxes = boxes.vertical;
        const horizontalBoxes = boxes.horizontal;
        each(chart.boxes, (box)=>{
            if (typeof box.beforeLayout === 'function') {
                box.beforeLayout();
            }
        });
        const visibleVerticalBoxCount = verticalBoxes.reduce((total, wrap)=>wrap.box.options && wrap.box.options.display === false ? total : total + 1, 0) || 1;
        const params = Object.freeze({
            outerWidth: width,
            outerHeight: height,
            padding,
            availableWidth,
            availableHeight,
            vBoxMaxWidth: availableWidth / 2 / visibleVerticalBoxCount,
            hBoxMaxHeight: availableHeight / 2
        });
        const maxPadding = Object.assign({}, padding);
        updateMaxPadding(maxPadding, toPadding(minPadding));
        const chartArea = Object.assign({
            maxPadding,
            w: availableWidth,
            h: availableHeight,
            x: padding.left,
            y: padding.top
        }, padding);
        const stacks = setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);
        fitBoxes(boxes.fullSize, chartArea, params, stacks);
        fitBoxes(verticalBoxes, chartArea, params, stacks);
        if (fitBoxes(horizontalBoxes, chartArea, params, stacks)) {
            fitBoxes(verticalBoxes, chartArea, params, stacks);
        }
        handleMaxPadding(chartArea);
        placeBoxes(boxes.leftAndTop, chartArea, params, stacks);
        chartArea.x += chartArea.w;
        chartArea.y += chartArea.h;
        placeBoxes(boxes.rightAndBottom, chartArea, params, stacks);
        chart.chartArea = {
            left: chartArea.left,
            top: chartArea.top,
            right: chartArea.left + chartArea.w,
            bottom: chartArea.top + chartArea.h,
            height: chartArea.h,
            width: chartArea.w
        };
        each(boxes.chartArea, (layout)=>{
            const box = layout.box;
            Object.assign(box, chart.chartArea);
            box.update(chartArea.w, chartArea.h, {
                left: 0,
                top: 0,
                right: 0,
                bottom: 0
            });
        });
    }
};

class BasePlatform {
 acquireContext(canvas, aspectRatio) {}
 releaseContext(context) {
        return false;
    }
 addEventListener(chart, type, listener) {}
 removeEventListener(chart, type, listener) {}
 getDevicePixelRatio() {
        return 1;
    }
 getMaximumSize(element, width, height, aspectRatio) {
        width = Math.max(0, width || element.width);
        height = height || element.height;
        return {
            width,
            height: Math.max(0, aspectRatio ? Math.floor(width / aspectRatio) : height)
        };
    }
 isAttached(canvas) {
        return true;
    }
 updateConfig(config) {
    }
}

class BasicPlatform extends BasePlatform {
    acquireContext(item) {
        return item && item.getContext && item.getContext('2d') || null;
    }
    updateConfig(config) {
        config.options.animation = false;
    }
}

const EXPANDO_KEY = '$chartjs';
 const EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
};
const isNullOrEmpty = (value)=>value === null || value === '';
 function initCanvas(canvas, aspectRatio) {
    const style = canvas.style;
    const renderHeight = canvas.getAttribute('height');
    const renderWidth = canvas.getAttribute('width');
    canvas[EXPANDO_KEY] = {
        initial: {
            height: renderHeight,
            width: renderWidth,
            style: {
                display: style.display,
                height: style.height,
                width: style.width
            }
        }
    };
    style.display = style.display || 'block';
    style.boxSizing = style.boxSizing || 'border-box';
    if (isNullOrEmpty(renderWidth)) {
        const displayWidth = readUsedSize(canvas, 'width');
        if (displayWidth !== undefined) {
            canvas.width = displayWidth;
        }
    }
    if (isNullOrEmpty(renderHeight)) {
        if (canvas.style.height === '') {
            canvas.height = canvas.width / (aspectRatio || 2);
        } else {
            const displayHeight = readUsedSize(canvas, 'height');
            if (displayHeight !== undefined) {
                canvas.height = displayHeight;
            }
        }
    }
    return canvas;
}
const eventListenerOptions = supportsEventListenerOptions ? {
    passive: true
} : false;
function addListener(node, type, listener) {
    if (node) {
        node.addEventListener(type, listener, eventListenerOptions);
    }
}
function removeListener(chart, type, listener) {
    if (chart && chart.canvas) {
        chart.canvas.removeEventListener(type, listener, eventListenerOptions);
    }
}
function fromNativeEvent(event, chart) {
    const type = EVENT_TYPES[event.type] || event.type;
    const { x , y  } = getRelativePosition(event, chart);
    return {
        type,
        chart,
        native: event,
        x: x !== undefined ? x : null,
        y: y !== undefined ? y : null
    };
}
function nodeListContains(nodeList, canvas) {
    for (const node of nodeList){
        if (node === canvas || node.contains(canvas)) {
            return true;
        }
    }
}
function createAttachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.addedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.removedNodes, canvas);
        }
        if (trigger) {
            listener();
        }
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
function createDetachObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const observer = new MutationObserver((entries)=>{
        let trigger = false;
        for (const entry of entries){
            trigger = trigger || nodeListContains(entry.removedNodes, canvas);
            trigger = trigger && !nodeListContains(entry.addedNodes, canvas);
        }
        if (trigger) {
            listener();
        }
    });
    observer.observe(document, {
        childList: true,
        subtree: true
    });
    return observer;
}
const drpListeningCharts = new Map();
let oldDevicePixelRatio = 0;
function onWindowResize() {
    const dpr = window.devicePixelRatio;
    if (dpr === oldDevicePixelRatio) {
        return;
    }
    oldDevicePixelRatio = dpr;
    drpListeningCharts.forEach((resize, chart)=>{
        if (chart.currentDevicePixelRatio !== dpr) {
            resize();
        }
    });
}
function listenDevicePixelRatioChanges(chart, resize) {
    if (!drpListeningCharts.size) {
        window.addEventListener('resize', onWindowResize);
    }
    drpListeningCharts.set(chart, resize);
}
function unlistenDevicePixelRatioChanges(chart) {
    drpListeningCharts.delete(chart);
    if (!drpListeningCharts.size) {
        window.removeEventListener('resize', onWindowResize);
    }
}
function createResizeObserver(chart, type, listener) {
    const canvas = chart.canvas;
    const container = canvas && _getParentNode(canvas);
    if (!container) {
        return;
    }
    const resize = throttled((width, height)=>{
        const w = container.clientWidth;
        listener(width, height);
        if (w < container.clientWidth) {
            listener();
        }
    }, window);
    const observer = new ResizeObserver((entries)=>{
        const entry = entries[0];
        const width = entry.contentRect.width;
        const height = entry.contentRect.height;
        if (width === 0 && height === 0) {
            return;
        }
        resize(width, height);
    });
    observer.observe(container);
    listenDevicePixelRatioChanges(chart, resize);
    return observer;
}
function releaseObserver(chart, type, observer) {
    if (observer) {
        observer.disconnect();
    }
    if (type === 'resize') {
        unlistenDevicePixelRatioChanges(chart);
    }
}
function createProxyAndListen(chart, type, listener) {
    const canvas = chart.canvas;
    const proxy = throttled((event)=>{
        if (chart.ctx !== null) {
            listener(fromNativeEvent(event, chart));
        }
    }, chart);
    addListener(canvas, type, proxy);
    return proxy;
}
 class DomPlatform extends BasePlatform {
 acquireContext(canvas, aspectRatio) {
        const context = canvas && canvas.getContext && canvas.getContext('2d');
        if (context && context.canvas === canvas) {
            initCanvas(canvas, aspectRatio);
            return context;
        }
        return null;
    }
 releaseContext(context) {
        const canvas = context.canvas;
        if (!canvas[EXPANDO_KEY]) {
            return false;
        }
        const initial = canvas[EXPANDO_KEY].initial;
        [
            'height',
            'width'
        ].forEach((prop)=>{
            const value = initial[prop];
            if (isNullOrUndef(value)) {
                canvas.removeAttribute(prop);
            } else {
                canvas.setAttribute(prop, value);
            }
        });
        const style = initial.style || {};
        Object.keys(style).forEach((key)=>{
            canvas.style[key] = style[key];
        });
        canvas.width = canvas.width;
        delete canvas[EXPANDO_KEY];
        return true;
    }
 addEventListener(chart, type, listener) {
        this.removeEventListener(chart, type);
        const proxies = chart.$proxies || (chart.$proxies = {});
        const handlers = {
            attach: createAttachObserver,
            detach: createDetachObserver,
            resize: createResizeObserver
        };
        const handler = handlers[type] || createProxyAndListen;
        proxies[type] = handler(chart, type, listener);
    }
 removeEventListener(chart, type) {
        const proxies = chart.$proxies || (chart.$proxies = {});
        const proxy = proxies[type];
        if (!proxy) {
            return;
        }
        const handlers = {
            attach: releaseObserver,
            detach: releaseObserver,
            resize: releaseObserver
        };
        const handler = handlers[type] || removeListener;
        handler(chart, type, proxy);
        proxies[type] = undefined;
    }
    getDevicePixelRatio() {
        return window.devicePixelRatio;
    }
 getMaximumSize(canvas, width, height, aspectRatio) {
        return getMaximumSize(canvas, width, height, aspectRatio);
    }
 isAttached(canvas) {
        const container = canvas && _getParentNode(canvas);
        return !!(container && container.isConnected);
    }
}

function _detectPlatform(canvas) {
    if (!_isDomSupported() || typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
        return BasicPlatform;
    }
    return DomPlatform;
}

class Element {
    static defaults = {};
    static defaultRoutes = undefined;
    x;
    y;
    active = false;
    options;
    $animations;
    tooltipPosition(useFinalPosition) {
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    hasValue() {
        return isNumber(this.x) && isNumber(this.y);
    }
    getProps(props, final) {
        const anims = this.$animations;
        if (!final || !anims) {
            // let's not create an object, if not needed
            return this;
        }
        const ret = {};
        props.forEach((prop)=>{
            ret[prop] = anims[prop] && anims[prop].active() ? anims[prop]._to : this[prop];
        });
        return ret;
    }
}

function autoSkip(scale, ticks) {
    const tickOpts = scale.options.ticks;
    const determinedMaxTicks = determineMaxTicks(scale);
    const ticksLimit = Math.min(tickOpts.maxTicksLimit || determinedMaxTicks, determinedMaxTicks);
    const majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
    const numMajorIndices = majorIndices.length;
    const first = majorIndices[0];
    const last = majorIndices[numMajorIndices - 1];
    const newTicks = [];
    if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, newTicks, majorIndices, numMajorIndices / ticksLimit);
        return newTicks;
    }
    const spacing = calculateSpacing(majorIndices, ticks, ticksLimit);
    if (numMajorIndices > 0) {
        let i, ilen;
        const avgMajorSpacing = numMajorIndices > 1 ? Math.round((last - first) / (numMajorIndices - 1)) : null;
        skip(ticks, newTicks, spacing, isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        for(i = 0, ilen = numMajorIndices - 1; i < ilen; i++){
            skip(ticks, newTicks, spacing, majorIndices[i], majorIndices[i + 1]);
        }
        skip(ticks, newTicks, spacing, last, isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return newTicks;
    }
    skip(ticks, newTicks, spacing);
    return newTicks;
}
function determineMaxTicks(scale) {
    const offset = scale.options.offset;
    const tickLength = scale._tickSize();
    const maxScale = scale._length / tickLength + (offset ? 0 : 1);
    const maxChart = scale._maxLength / tickLength;
    return Math.floor(Math.min(maxScale, maxChart));
}
 function calculateSpacing(majorIndices, ticks, ticksLimit) {
    const evenMajorSpacing = getEvenSpacing(majorIndices);
    const spacing = ticks.length / ticksLimit;
    if (!evenMajorSpacing) {
        return Math.max(spacing, 1);
    }
    const factors = _factorize(evenMajorSpacing);
    for(let i = 0, ilen = factors.length - 1; i < ilen; i++){
        const factor = factors[i];
        if (factor > spacing) {
            return factor;
        }
    }
    return Math.max(spacing, 1);
}
 function getMajorIndices(ticks) {
    const result = [];
    let i, ilen;
    for(i = 0, ilen = ticks.length; i < ilen; i++){
        if (ticks[i].major) {
            result.push(i);
        }
    }
    return result;
}
 function skipMajors(ticks, newTicks, majorIndices, spacing) {
    let count = 0;
    let next = majorIndices[0];
    let i;
    spacing = Math.ceil(spacing);
    for(i = 0; i < ticks.length; i++){
        if (i === next) {
            newTicks.push(ticks[i]);
            count++;
            next = majorIndices[count * spacing];
        }
    }
}
 function skip(ticks, newTicks, spacing, majorStart, majorEnd) {
    const start = valueOrDefault(majorStart, 0);
    const end = Math.min(valueOrDefault(majorEnd, ticks.length), ticks.length);
    let count = 0;
    let length, i, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
        length = majorEnd - majorStart;
        spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while(next < 0){
        count++;
        next = Math.round(start + count * spacing);
    }
    for(i = Math.max(start, 0); i < end; i++){
        if (i === next) {
            newTicks.push(ticks[i]);
            count++;
            next = Math.round(start + count * spacing);
        }
    }
}
 function getEvenSpacing(arr) {
    const len = arr.length;
    let i, diff;
    if (len < 2) {
        return false;
    }
    for(diff = arr[0], i = 1; i < len; ++i){
        if (arr[i] - arr[i - 1] !== diff) {
            return false;
        }
    }
    return diff;
}

const reverseAlign = (align)=>align === 'left' ? 'right' : align === 'right' ? 'left' : align;
const offsetFromEdge = (scale, edge, offset)=>edge === 'top' || edge === 'left' ? scale[edge] + offset : scale[edge] - offset;
const getTicksLimit = (ticksLength, maxTicksLimit)=>Math.min(maxTicksLimit || ticksLength, ticksLength);
 function sample(arr, numItems) {
    const result = [];
    const increment = arr.length / numItems;
    const len = arr.length;
    let i = 0;
    for(; i < len; i += increment){
        result.push(arr[Math.floor(i)]);
    }
    return result;
}
 function getPixelForGridLine(scale, index, offsetGridLines) {
    const length = scale.ticks.length;
    const validIndex = Math.min(index, length - 1);
    const start = scale._startPixel;
    const end = scale._endPixel;
    const epsilon = 1e-6;
    let lineValue = scale.getPixelForTick(validIndex);
    let offset;
    if (offsetGridLines) {
        if (length === 1) {
            offset = Math.max(lineValue - start, end - lineValue);
        } else if (index === 0) {
            offset = (scale.getPixelForTick(1) - lineValue) / 2;
        } else {
            offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
        }
        lineValue += validIndex < index ? offset : -offset;
        if (lineValue < start - epsilon || lineValue > end + epsilon) {
            return;
        }
    }
    return lineValue;
}
 function garbageCollect(caches, length) {
    each(caches, (cache)=>{
        const gc = cache.gc;
        const gcLen = gc.length / 2;
        let i;
        if (gcLen > length) {
            for(i = 0; i < gcLen; ++i){
                delete cache.data[gc[i]];
            }
            gc.splice(0, gcLen);
        }
    });
}
 function getTickMarkLength(options) {
    return options.drawTicks ? options.tickLength : 0;
}
 function getTitleHeight(options, fallback) {
    if (!options.display) {
        return 0;
    }
    const font = toFont(options.font, fallback);
    const padding = toPadding(options.padding);
    const lines = isArray(options.text) ? options.text.length : 1;
    return lines * font.lineHeight + padding.height;
}
function createScaleContext(parent, scale) {
    return createContext(parent, {
        scale,
        type: 'scale'
    });
}
function createTickContext(parent, index, tick) {
    return createContext(parent, {
        tick,
        index,
        type: 'tick'
    });
}
function titleAlign(align, position, reverse) {
     let ret = _toLeftRightCenter(align);
    if (reverse && position !== 'right' || !reverse && position === 'right') {
        ret = reverseAlign(ret);
    }
    return ret;
}
function titleArgs(scale, offset, position, align) {
    const { top , left , bottom , right , chart  } = scale;
    const { chartArea , scales  } = chart;
    let rotation = 0;
    let maxWidth, titleX, titleY;
    const height = bottom - top;
    const width = right - left;
    if (scale.isHorizontal()) {
        titleX = _alignStartEnd(align, left, right);
        if (isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleY = scales[positionAxisID].getPixelForValue(value) + height - offset;
        } else if (position === 'center') {
            titleY = (chartArea.bottom + chartArea.top) / 2 + height - offset;
        } else {
            titleY = offsetFromEdge(scale, position, offset);
        }
        maxWidth = right - left;
    } else {
        if (isObject(position)) {
            const positionAxisID = Object.keys(position)[0];
            const value = position[positionAxisID];
            titleX = scales[positionAxisID].getPixelForValue(value) - width + offset;
        } else if (position === 'center') {
            titleX = (chartArea.left + chartArea.right) / 2 - width + offset;
        } else {
            titleX = offsetFromEdge(scale, position, offset);
        }
        titleY = _alignStartEnd(align, bottom, top);
        rotation = position === 'left' ? -HALF_PI : HALF_PI;
    }
    return {
        titleX,
        titleY,
        maxWidth,
        rotation
    };
}
class Scale extends Element {
    constructor(cfg){
        super();
         this.id = cfg.id;
         this.type = cfg.type;
         this.options = undefined;
         this.ctx = cfg.ctx;
         this.chart = cfg.chart;
         this.top = undefined;
         this.bottom = undefined;
         this.left = undefined;
         this.right = undefined;
         this.width = undefined;
         this.height = undefined;
        this._margins = {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
         this.maxWidth = undefined;
         this.maxHeight = undefined;
         this.paddingTop = undefined;
         this.paddingBottom = undefined;
         this.paddingLeft = undefined;
         this.paddingRight = undefined;
         this.axis = undefined;
         this.labelRotation = undefined;
        this.min = undefined;
        this.max = undefined;
        this._range = undefined;
         this.ticks = [];
         this._gridLineItems = null;
         this._labelItems = null;
         this._labelSizes = null;
        this._length = 0;
        this._maxLength = 0;
        this._longestTextCache = {};
         this._startPixel = undefined;
         this._endPixel = undefined;
        this._reversePixels = false;
        this._userMax = undefined;
        this._userMin = undefined;
        this._suggestedMax = undefined;
        this._suggestedMin = undefined;
        this._ticksLength = 0;
        this._borderValue = 0;
        this._cache = {};
        this._dataLimitsCached = false;
        this.$context = undefined;
    }
 init(options) {
        this.options = options.setContext(this.getContext());
        this.axis = options.axis;
        this._userMin = this.parse(options.min);
        this._userMax = this.parse(options.max);
        this._suggestedMin = this.parse(options.suggestedMin);
        this._suggestedMax = this.parse(options.suggestedMax);
    }
 parse(raw, index) {
        return raw;
    }
 getUserBounds() {
        let { _userMin , _userMax , _suggestedMin , _suggestedMax  } = this;
        _userMin = finiteOrDefault(_userMin, Number.POSITIVE_INFINITY);
        _userMax = finiteOrDefault(_userMax, Number.NEGATIVE_INFINITY);
        _suggestedMin = finiteOrDefault(_suggestedMin, Number.POSITIVE_INFINITY);
        _suggestedMax = finiteOrDefault(_suggestedMax, Number.NEGATIVE_INFINITY);
        return {
            min: finiteOrDefault(_userMin, _suggestedMin),
            max: finiteOrDefault(_userMax, _suggestedMax),
            minDefined: isNumberFinite(_userMin),
            maxDefined: isNumberFinite(_userMax)
        };
    }
 getMinMax(canStack) {
        let { min , max , minDefined , maxDefined  } = this.getUserBounds();
        let range;
        if (minDefined && maxDefined) {
            return {
                min,
                max
            };
        }
        const metas = this.getMatchingVisibleMetas();
        for(let i = 0, ilen = metas.length; i < ilen; ++i){
            range = metas[i].controller.getMinMax(this, canStack);
            if (!minDefined) {
                min = Math.min(min, range.min);
            }
            if (!maxDefined) {
                max = Math.max(max, range.max);
            }
        }
        min = maxDefined && min > max ? max : min;
        max = minDefined && min > max ? min : max;
        return {
            min: finiteOrDefault(min, finiteOrDefault(max, min)),
            max: finiteOrDefault(max, finiteOrDefault(min, max))
        };
    }
 getPadding() {
        return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0
        };
    }
 getTicks() {
        return this.ticks;
    }
 getLabels() {
        const data = this.chart.data;
        return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    }
 getLabelItems(chartArea = this.chart.chartArea) {
        const items = this._labelItems || (this._labelItems = this._computeLabelItems(chartArea));
        return items;
    }
    beforeLayout() {
        this._cache = {};
        this._dataLimitsCached = false;
    }
    beforeUpdate() {
        callback(this.options.beforeUpdate, [
            this
        ]);
    }
 update(maxWidth, maxHeight, margins) {
        const { beginAtZero , grace , ticks: tickOpts  } = this.options;
        const sampleSize = tickOpts.sampleSize;
        this.beforeUpdate();
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins = Object.assign({
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        }, margins);
        this.ticks = null;
        this._labelSizes = null;
        this._gridLineItems = null;
        this._labelItems = null;
        this.beforeSetDimensions();
        this.setDimensions();
        this.afterSetDimensions();
        this._maxLength = this.isHorizontal() ? this.width + margins.left + margins.right : this.height + margins.top + margins.bottom;
        if (!this._dataLimitsCached) {
            this.beforeDataLimits();
            this.determineDataLimits();
            this.afterDataLimits();
            this._range = _addGrace(this, grace, beginAtZero);
            this._dataLimitsCached = true;
        }
        this.beforeBuildTicks();
        this.ticks = this.buildTicks() || [];
        this.afterBuildTicks();
        const samplingEnabled = sampleSize < this.ticks.length;
        this._convertTicksToLabels(samplingEnabled ? sample(this.ticks, sampleSize) : this.ticks);
        this.configure();
        this.beforeCalculateLabelRotation();
        this.calculateLabelRotation();
        this.afterCalculateLabelRotation();
        if (tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto')) {
            this.ticks = autoSkip(this, this.ticks);
            this._labelSizes = null;
            this.afterAutoSkip();
        }
        if (samplingEnabled) {
            this._convertTicksToLabels(this.ticks);
        }
        this.beforeFit();
        this.fit();
        this.afterFit();
        this.afterUpdate();
    }
 configure() {
        let reversePixels = this.options.reverse;
        let startPixel, endPixel;
        if (this.isHorizontal()) {
            startPixel = this.left;
            endPixel = this.right;
        } else {
            startPixel = this.top;
            endPixel = this.bottom;
            reversePixels = !reversePixels;
        }
        this._startPixel = startPixel;
        this._endPixel = endPixel;
        this._reversePixels = reversePixels;
        this._length = endPixel - startPixel;
        this._alignToPixels = this.options.alignToPixels;
    }
    afterUpdate() {
        callback(this.options.afterUpdate, [
            this
        ]);
    }
    beforeSetDimensions() {
        callback(this.options.beforeSetDimensions, [
            this
        ]);
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = 0;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = 0;
            this.bottom = this.height;
        }
        this.paddingLeft = 0;
        this.paddingTop = 0;
        this.paddingRight = 0;
        this.paddingBottom = 0;
    }
    afterSetDimensions() {
        callback(this.options.afterSetDimensions, [
            this
        ]);
    }
    _callHooks(name) {
        this.chart.notifyPlugins(name, this.getContext());
        callback(this.options[name], [
            this
        ]);
    }
    beforeDataLimits() {
        this._callHooks('beforeDataLimits');
    }
    determineDataLimits() {}
    afterDataLimits() {
        this._callHooks('afterDataLimits');
    }
    beforeBuildTicks() {
        this._callHooks('beforeBuildTicks');
    }
 buildTicks() {
        return [];
    }
    afterBuildTicks() {
        this._callHooks('afterBuildTicks');
    }
    beforeTickToLabelConversion() {
        callback(this.options.beforeTickToLabelConversion, [
            this
        ]);
    }
 generateTickLabels(ticks) {
        const tickOpts = this.options.ticks;
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            tick = ticks[i];
            tick.label = callback(tickOpts.callback, [
                tick.value,
                i,
                ticks
            ], this);
        }
    }
    afterTickToLabelConversion() {
        callback(this.options.afterTickToLabelConversion, [
            this
        ]);
    }
    beforeCalculateLabelRotation() {
        callback(this.options.beforeCalculateLabelRotation, [
            this
        ]);
    }
    calculateLabelRotation() {
        const options = this.options;
        const tickOpts = options.ticks;
        const numTicks = getTicksLimit(this.ticks.length, options.ticks.maxTicksLimit);
        const minRotation = tickOpts.minRotation || 0;
        const maxRotation = tickOpts.maxRotation;
        let labelRotation = minRotation;
        let tickWidth, maxHeight, maxLabelDiagonal;
        if (!this._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !this.isHorizontal()) {
            this.labelRotation = minRotation;
            return;
        }
        const labelSizes = this._getLabelSizes();
        const maxLabelWidth = labelSizes.widest.width;
        const maxLabelHeight = labelSizes.highest.height;
        const maxWidth = _limitValue(this.chart.width - maxLabelWidth, 0, this.maxWidth);
        tickWidth = options.offset ? this.maxWidth / numTicks : maxWidth / (numTicks - 1);
        if (maxLabelWidth + 6 > tickWidth) {
            tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
            maxHeight = this.maxHeight - getTickMarkLength(options.grid) - tickOpts.padding - getTitleHeight(options.title, this.chart.options.font);
            maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
            labelRotation = toDegrees(Math.min(Math.asin(_limitValue((labelSizes.highest.height + 6) / tickWidth, -1, 1)), Math.asin(_limitValue(maxHeight / maxLabelDiagonal, -1, 1)) - Math.asin(_limitValue(maxLabelHeight / maxLabelDiagonal, -1, 1))));
            labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
        }
        this.labelRotation = labelRotation;
    }
    afterCalculateLabelRotation() {
        callback(this.options.afterCalculateLabelRotation, [
            this
        ]);
    }
    afterAutoSkip() {}
    beforeFit() {
        callback(this.options.beforeFit, [
            this
        ]);
    }
    fit() {
        const minSize = {
            width: 0,
            height: 0
        };
        const { chart , options: { ticks: tickOpts , title: titleOpts , grid: gridOpts  }  } = this;
        const display = this._isVisible();
        const isHorizontal = this.isHorizontal();
        if (display) {
            const titleHeight = getTitleHeight(titleOpts, chart.options.font);
            if (isHorizontal) {
                minSize.width = this.maxWidth;
                minSize.height = getTickMarkLength(gridOpts) + titleHeight;
            } else {
                minSize.height = this.maxHeight;
                minSize.width = getTickMarkLength(gridOpts) + titleHeight;
            }
            if (tickOpts.display && this.ticks.length) {
                const { first , last , widest , highest  } = this._getLabelSizes();
                const tickPadding = tickOpts.padding * 2;
                const angleRadians = toRadians(this.labelRotation);
                const cos = Math.cos(angleRadians);
                const sin = Math.sin(angleRadians);
                if (isHorizontal) {
                    const labelHeight = tickOpts.mirror ? 0 : sin * widest.width + cos * highest.height;
                    minSize.height = Math.min(this.maxHeight, minSize.height + labelHeight + tickPadding);
                } else {
                    const labelWidth = tickOpts.mirror ? 0 : cos * widest.width + sin * highest.height;
                    minSize.width = Math.min(this.maxWidth, minSize.width + labelWidth + tickPadding);
                }
                this._calculatePadding(first, last, sin, cos);
            }
        }
        this._handleMargins();
        if (isHorizontal) {
            this.width = this._length = chart.width - this._margins.left - this._margins.right;
            this.height = minSize.height;
        } else {
            this.width = minSize.width;
            this.height = this._length = chart.height - this._margins.top - this._margins.bottom;
        }
    }
    _calculatePadding(first, last, sin, cos) {
        const { ticks: { align , padding  } , position  } = this.options;
        const isRotated = this.labelRotation !== 0;
        const labelsBelowTicks = position !== 'top' && this.axis === 'x';
        if (this.isHorizontal()) {
            const offsetLeft = this.getPixelForTick(0) - this.left;
            const offsetRight = this.right - this.getPixelForTick(this.ticks.length - 1);
            let paddingLeft = 0;
            let paddingRight = 0;
            if (isRotated) {
                if (labelsBelowTicks) {
                    paddingLeft = cos * first.width;
                    paddingRight = sin * last.height;
                } else {
                    paddingLeft = sin * first.height;
                    paddingRight = cos * last.width;
                }
            } else if (align === 'start') {
                paddingRight = last.width;
            } else if (align === 'end') {
                paddingLeft = first.width;
            } else if (align !== 'inner') {
                paddingLeft = first.width / 2;
                paddingRight = last.width / 2;
            }
            this.paddingLeft = Math.max((paddingLeft - offsetLeft + padding) * this.width / (this.width - offsetLeft), 0);
            this.paddingRight = Math.max((paddingRight - offsetRight + padding) * this.width / (this.width - offsetRight), 0);
        } else {
            let paddingTop = last.height / 2;
            let paddingBottom = first.height / 2;
            if (align === 'start') {
                paddingTop = 0;
                paddingBottom = first.height;
            } else if (align === 'end') {
                paddingTop = last.height;
                paddingBottom = 0;
            }
            this.paddingTop = paddingTop + padding;
            this.paddingBottom = paddingBottom + padding;
        }
    }
 _handleMargins() {
        if (this._margins) {
            this._margins.left = Math.max(this.paddingLeft, this._margins.left);
            this._margins.top = Math.max(this.paddingTop, this._margins.top);
            this._margins.right = Math.max(this.paddingRight, this._margins.right);
            this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom);
        }
    }
    afterFit() {
        callback(this.options.afterFit, [
            this
        ]);
    }
 isHorizontal() {
        const { axis , position  } = this.options;
        return position === 'top' || position === 'bottom' || axis === 'x';
    }
 isFullSize() {
        return this.options.fullSize;
    }
 _convertTicksToLabels(ticks) {
        this.beforeTickToLabelConversion();
        this.generateTickLabels(ticks);
        let i, ilen;
        for(i = 0, ilen = ticks.length; i < ilen; i++){
            if (isNullOrUndef(ticks[i].label)) {
                ticks.splice(i, 1);
                ilen--;
                i--;
            }
        }
        this.afterTickToLabelConversion();
    }
 _getLabelSizes() {
        let labelSizes = this._labelSizes;
        if (!labelSizes) {
            const sampleSize = this.options.ticks.sampleSize;
            let ticks = this.ticks;
            if (sampleSize < ticks.length) {
                ticks = sample(ticks, sampleSize);
            }
            this._labelSizes = labelSizes = this._computeLabelSizes(ticks, ticks.length, this.options.ticks.maxTicksLimit);
        }
        return labelSizes;
    }
 _computeLabelSizes(ticks, length, maxTicksLimit) {
        const { ctx , _longestTextCache: caches  } = this;
        const widths = [];
        const heights = [];
        const increment = Math.floor(length / getTicksLimit(length, maxTicksLimit));
        let widestLabelSize = 0;
        let highestLabelSize = 0;
        let i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel;
        for(i = 0; i < length; i += increment){
            label = ticks[i].label;
            tickFont = this._resolveTickFontOptions(i);
            ctx.font = fontString = tickFont.string;
            cache = caches[fontString] = caches[fontString] || {
                data: {},
                gc: []
            };
            lineHeight = tickFont.lineHeight;
            width = height = 0;
            if (!isNullOrUndef(label) && !isArray(label)) {
                width = _measureText(ctx, cache.data, cache.gc, width, label);
                height = lineHeight;
            } else if (isArray(label)) {
                for(j = 0, jlen = label.length; j < jlen; ++j){
                    nestedLabel =  label[j];
                    if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
                        width = _measureText(ctx, cache.data, cache.gc, width, nestedLabel);
                        height += lineHeight;
                    }
                }
            }
            widths.push(width);
            heights.push(height);
            widestLabelSize = Math.max(width, widestLabelSize);
            highestLabelSize = Math.max(height, highestLabelSize);
        }
        garbageCollect(caches, length);
        const widest = widths.indexOf(widestLabelSize);
        const highest = heights.indexOf(highestLabelSize);
        const valueAt = (idx)=>({
                width: widths[idx] || 0,
                height: heights[idx] || 0
            });
        return {
            first: valueAt(0),
            last: valueAt(length - 1),
            widest: valueAt(widest),
            highest: valueAt(highest),
            widths,
            heights
        };
    }
 getLabelForValue(value) {
        return value;
    }
 getPixelForValue(value, index) {
        return NaN;
    }
 getValueForPixel(pixel) {}
 getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) {
            return null;
        }
        return this.getPixelForValue(ticks[index].value);
    }
 getPixelForDecimal(decimal) {
        if (this._reversePixels) {
            decimal = 1 - decimal;
        }
        const pixel = this._startPixel + decimal * this._length;
        return _int16Range(this._alignToPixels ? _alignPixel(this.chart, pixel, 0) : pixel);
    }
 getDecimalForPixel(pixel) {
        const decimal = (pixel - this._startPixel) / this._length;
        return this._reversePixels ? 1 - decimal : decimal;
    }
 getBasePixel() {
        return this.getPixelForValue(this.getBaseValue());
    }
 getBaseValue() {
        const { min , max  } = this;
        return min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    }
 getContext(index) {
        const ticks = this.ticks || [];
        if (index >= 0 && index < ticks.length) {
            const tick = ticks[index];
            return tick.$context || (tick.$context = createTickContext(this.getContext(), index, tick));
        }
        return this.$context || (this.$context = createScaleContext(this.chart.getContext(), this));
    }
 _tickSize() {
        const optionTicks = this.options.ticks;
        const rot = toRadians(this.labelRotation);
        const cos = Math.abs(Math.cos(rot));
        const sin = Math.abs(Math.sin(rot));
        const labelSizes = this._getLabelSizes();
        const padding = optionTicks.autoSkipPadding || 0;
        const w = labelSizes ? labelSizes.widest.width + padding : 0;
        const h = labelSizes ? labelSizes.highest.height + padding : 0;
        return this.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    }
 _isVisible() {
        const display = this.options.display;
        if (display !== 'auto') {
            return !!display;
        }
        return this.getMatchingVisibleMetas().length > 0;
    }
 _computeGridLineItems(chartArea) {
        const axis = this.axis;
        const chart = this.chart;
        const options = this.options;
        const { grid , position , border  } = options;
        const offset = grid.offset;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const ticksLength = ticks.length + (offset ? 1 : 0);
        const tl = getTickMarkLength(grid);
        const items = [];
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = borderOpts.display ? borderOpts.width : 0;
        const axisHalfWidth = axisWidth / 2;
        const alignBorderValue = function(pixel) {
            return _alignPixel(chart, pixel, axisWidth);
        };
        let borderValue, i, lineValue, alignedLineValue;
        let tx1, ty1, tx2, ty2, x1, y1, x2, y2;
        if (position === 'top') {
            borderValue = alignBorderValue(this.bottom);
            ty1 = this.bottom - tl;
            ty2 = borderValue - axisHalfWidth;
            y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
            y2 = chartArea.bottom;
        } else if (position === 'bottom') {
            borderValue = alignBorderValue(this.top);
            y1 = chartArea.top;
            y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
            ty1 = borderValue + axisHalfWidth;
            ty2 = this.top + tl;
        } else if (position === 'left') {
            borderValue = alignBorderValue(this.right);
            tx1 = this.right - tl;
            tx2 = borderValue - axisHalfWidth;
            x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
            x2 = chartArea.right;
        } else if (position === 'right') {
            borderValue = alignBorderValue(this.left);
            x1 = chartArea.left;
            x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
            tx1 = borderValue + axisHalfWidth;
            tx2 = this.left + tl;
        } else if (axis === 'x') {
            if (position === 'center') {
                borderValue = alignBorderValue((chartArea.top + chartArea.bottom) / 2 + 0.5);
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            y1 = chartArea.top;
            y2 = chartArea.bottom;
            ty1 = borderValue + axisHalfWidth;
            ty2 = ty1 + tl;
        } else if (axis === 'y') {
            if (position === 'center') {
                borderValue = alignBorderValue((chartArea.left + chartArea.right) / 2);
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                borderValue = alignBorderValue(this.chart.scales[positionAxisID].getPixelForValue(value));
            }
            tx1 = borderValue - axisHalfWidth;
            tx2 = tx1 - tl;
            x1 = chartArea.left;
            x2 = chartArea.right;
        }
        const limit = valueOrDefault(options.ticks.maxTicksLimit, ticksLength);
        const step = Math.max(1, Math.ceil(ticksLength / limit));
        for(i = 0; i < ticksLength; i += step){
            const context = this.getContext(i);
            const optsAtIndex = grid.setContext(context);
            const optsAtIndexBorder = border.setContext(context);
            const lineWidth = optsAtIndex.lineWidth;
            const lineColor = optsAtIndex.color;
            const borderDash = optsAtIndexBorder.dash || [];
            const borderDashOffset = optsAtIndexBorder.dashOffset;
            const tickWidth = optsAtIndex.tickWidth;
            const tickColor = optsAtIndex.tickColor;
            const tickBorderDash = optsAtIndex.tickBorderDash || [];
            const tickBorderDashOffset = optsAtIndex.tickBorderDashOffset;
            lineValue = getPixelForGridLine(this, i, offset);
            if (lineValue === undefined) {
                continue;
            }
            alignedLineValue = _alignPixel(chart, lineValue, lineWidth);
            if (isHorizontal) {
                tx1 = tx2 = x1 = x2 = alignedLineValue;
            } else {
                ty1 = ty2 = y1 = y2 = alignedLineValue;
            }
            items.push({
                tx1,
                ty1,
                tx2,
                ty2,
                x1,
                y1,
                x2,
                y2,
                width: lineWidth,
                color: lineColor,
                borderDash,
                borderDashOffset,
                tickWidth,
                tickColor,
                tickBorderDash,
                tickBorderDashOffset
            });
        }
        this._ticksLength = ticksLength;
        this._borderValue = borderValue;
        return items;
    }
 _computeLabelItems(chartArea) {
        const axis = this.axis;
        const options = this.options;
        const { position , ticks: optionTicks  } = options;
        const isHorizontal = this.isHorizontal();
        const ticks = this.ticks;
        const { align , crossAlign , padding , mirror  } = optionTicks;
        const tl = getTickMarkLength(options.grid);
        const tickAndPadding = tl + padding;
        const hTickAndPadding = mirror ? -padding : tickAndPadding;
        const rotation = -toRadians(this.labelRotation);
        const items = [];
        let i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
        let textBaseline = 'middle';
        if (position === 'top') {
            y = this.bottom - hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'bottom') {
            y = this.top + hTickAndPadding;
            textAlign = this._getXAxisLabelAlignment();
        } else if (position === 'left') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (position === 'right') {
            const ret = this._getYAxisLabelAlignment(tl);
            textAlign = ret.textAlign;
            x = ret.x;
        } else if (axis === 'x') {
            if (position === 'center') {
                y = (chartArea.top + chartArea.bottom) / 2 + tickAndPadding;
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                y = this.chart.scales[positionAxisID].getPixelForValue(value) + tickAndPadding;
            }
            textAlign = this._getXAxisLabelAlignment();
        } else if (axis === 'y') {
            if (position === 'center') {
                x = (chartArea.left + chartArea.right) / 2 - tickAndPadding;
            } else if (isObject(position)) {
                const positionAxisID = Object.keys(position)[0];
                const value = position[positionAxisID];
                x = this.chart.scales[positionAxisID].getPixelForValue(value);
            }
            textAlign = this._getYAxisLabelAlignment(tl).textAlign;
        }
        if (axis === 'y') {
            if (align === 'start') {
                textBaseline = 'top';
            } else if (align === 'end') {
                textBaseline = 'bottom';
            }
        }
        const labelSizes = this._getLabelSizes();
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            label = tick.label;
            const optsAtIndex = optionTicks.setContext(this.getContext(i));
            pixel = this.getPixelForTick(i) + optionTicks.labelOffset;
            font = this._resolveTickFontOptions(i);
            lineHeight = font.lineHeight;
            lineCount = isArray(label) ? label.length : 1;
            const halfCount = lineCount / 2;
            const color = optsAtIndex.color;
            const strokeColor = optsAtIndex.textStrokeColor;
            const strokeWidth = optsAtIndex.textStrokeWidth;
            let tickTextAlign = textAlign;
            if (isHorizontal) {
                x = pixel;
                if (textAlign === 'inner') {
                    if (i === ilen - 1) {
                        tickTextAlign = !this.options.reverse ? 'right' : 'left';
                    } else if (i === 0) {
                        tickTextAlign = !this.options.reverse ? 'left' : 'right';
                    } else {
                        tickTextAlign = 'center';
                    }
                }
                if (position === 'top') {
                    if (crossAlign === 'near' || rotation !== 0) {
                        textOffset = -lineCount * lineHeight + lineHeight / 2;
                    } else if (crossAlign === 'center') {
                        textOffset = -labelSizes.highest.height / 2 - halfCount * lineHeight + lineHeight;
                    } else {
                        textOffset = -labelSizes.highest.height + lineHeight / 2;
                    }
                } else {
                    if (crossAlign === 'near' || rotation !== 0) {
                        textOffset = lineHeight / 2;
                    } else if (crossAlign === 'center') {
                        textOffset = labelSizes.highest.height / 2 - halfCount * lineHeight;
                    } else {
                        textOffset = labelSizes.highest.height - lineCount * lineHeight;
                    }
                }
                if (mirror) {
                    textOffset *= -1;
                }
                if (rotation !== 0 && !optsAtIndex.showLabelBackdrop) {
                    x += lineHeight / 2 * Math.sin(rotation);
                }
            } else {
                y = pixel;
                textOffset = (1 - lineCount) * lineHeight / 2;
            }
            let backdrop;
            if (optsAtIndex.showLabelBackdrop) {
                const labelPadding = toPadding(optsAtIndex.backdropPadding);
                const height = labelSizes.heights[i];
                const width = labelSizes.widths[i];
                let top = textOffset - labelPadding.top;
                let left = 0 - labelPadding.left;
                switch(textBaseline){
                    case 'middle':
                        top -= height / 2;
                        break;
                    case 'bottom':
                        top -= height;
                        break;
                }
                switch(textAlign){
                    case 'center':
                        left -= width / 2;
                        break;
                    case 'right':
                        left -= width;
                        break;
                    case 'inner':
                        if (i === ilen - 1) {
                            left -= width;
                        } else if (i > 0) {
                            left -= width / 2;
                        }
                        break;
                }
                backdrop = {
                    left,
                    top,
                    width: width + labelPadding.width,
                    height: height + labelPadding.height,
                    color: optsAtIndex.backdropColor
                };
            }
            items.push({
                label,
                font,
                textOffset,
                options: {
                    rotation,
                    color,
                    strokeColor,
                    strokeWidth,
                    textAlign: tickTextAlign,
                    textBaseline,
                    translation: [
                        x,
                        y
                    ],
                    backdrop
                }
            });
        }
        return items;
    }
    _getXAxisLabelAlignment() {
        const { position , ticks  } = this.options;
        const rotation = -toRadians(this.labelRotation);
        if (rotation) {
            return position === 'top' ? 'left' : 'right';
        }
        let align = 'center';
        if (ticks.align === 'start') {
            align = 'left';
        } else if (ticks.align === 'end') {
            align = 'right';
        } else if (ticks.align === 'inner') {
            align = 'inner';
        }
        return align;
    }
    _getYAxisLabelAlignment(tl) {
        const { position , ticks: { crossAlign , mirror , padding  }  } = this.options;
        const labelSizes = this._getLabelSizes();
        const tickAndPadding = tl + padding;
        const widest = labelSizes.widest.width;
        let textAlign;
        let x;
        if (position === 'left') {
            if (mirror) {
                x = this.right + padding;
                if (crossAlign === 'near') {
                    textAlign = 'left';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x += widest;
                }
            } else {
                x = this.right - tickAndPadding;
                if (crossAlign === 'near') {
                    textAlign = 'right';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x = this.left;
                }
            }
        } else if (position === 'right') {
            if (mirror) {
                x = this.left + padding;
                if (crossAlign === 'near') {
                    textAlign = 'right';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x -= widest / 2;
                } else {
                    textAlign = 'left';
                    x -= widest;
                }
            } else {
                x = this.left + tickAndPadding;
                if (crossAlign === 'near') {
                    textAlign = 'left';
                } else if (crossAlign === 'center') {
                    textAlign = 'center';
                    x += widest / 2;
                } else {
                    textAlign = 'right';
                    x = this.right;
                }
            }
        } else {
            textAlign = 'right';
        }
        return {
            textAlign,
            x
        };
    }
 _computeLabelArea() {
        if (this.options.ticks.mirror) {
            return;
        }
        const chart = this.chart;
        const position = this.options.position;
        if (position === 'left' || position === 'right') {
            return {
                top: 0,
                left: this.left,
                bottom: chart.height,
                right: this.right
            };
        }
        if (position === 'top' || position === 'bottom') {
            return {
                top: this.top,
                left: 0,
                bottom: this.bottom,
                right: chart.width
            };
        }
    }
 drawBackground() {
        const { ctx , options: { backgroundColor  } , left , top , width , height  } = this;
        if (backgroundColor) {
            ctx.save();
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(left, top, width, height);
            ctx.restore();
        }
    }
    getLineWidthForValue(value) {
        const grid = this.options.grid;
        if (!this._isVisible() || !grid.display) {
            return 0;
        }
        const ticks = this.ticks;
        const index = ticks.findIndex((t)=>t.value === value);
        if (index >= 0) {
            const opts = grid.setContext(this.getContext(index));
            return opts.lineWidth;
        }
        return 0;
    }
 drawGrid(chartArea) {
        const grid = this.options.grid;
        const ctx = this.ctx;
        const items = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(chartArea));
        let i, ilen;
        const drawLine = (p1, p2, style)=>{
            if (!style.width || !style.color) {
                return;
            }
            ctx.save();
            ctx.lineWidth = style.width;
            ctx.strokeStyle = style.color;
            ctx.setLineDash(style.borderDash || []);
            ctx.lineDashOffset = style.borderDashOffset;
            ctx.beginPath();
            ctx.moveTo(p1.x, p1.y);
            ctx.lineTo(p2.x, p2.y);
            ctx.stroke();
            ctx.restore();
        };
        if (grid.display) {
            for(i = 0, ilen = items.length; i < ilen; ++i){
                const item = items[i];
                if (grid.drawOnChartArea) {
                    drawLine({
                        x: item.x1,
                        y: item.y1
                    }, {
                        x: item.x2,
                        y: item.y2
                    }, item);
                }
                if (grid.drawTicks) {
                    drawLine({
                        x: item.tx1,
                        y: item.ty1
                    }, {
                        x: item.tx2,
                        y: item.ty2
                    }, {
                        color: item.tickColor,
                        width: item.tickWidth,
                        borderDash: item.tickBorderDash,
                        borderDashOffset: item.tickBorderDashOffset
                    });
                }
            }
        }
    }
 drawBorder() {
        const { chart , ctx , options: { border , grid  }  } = this;
        const borderOpts = border.setContext(this.getContext());
        const axisWidth = border.display ? borderOpts.width : 0;
        if (!axisWidth) {
            return;
        }
        const lastLineWidth = grid.setContext(this.getContext(0)).lineWidth;
        const borderValue = this._borderValue;
        let x1, x2, y1, y2;
        if (this.isHorizontal()) {
            x1 = _alignPixel(chart, this.left, axisWidth) - axisWidth / 2;
            x2 = _alignPixel(chart, this.right, lastLineWidth) + lastLineWidth / 2;
            y1 = y2 = borderValue;
        } else {
            y1 = _alignPixel(chart, this.top, axisWidth) - axisWidth / 2;
            y2 = _alignPixel(chart, this.bottom, lastLineWidth) + lastLineWidth / 2;
            x1 = x2 = borderValue;
        }
        ctx.save();
        ctx.lineWidth = borderOpts.width;
        ctx.strokeStyle = borderOpts.color;
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
        ctx.restore();
    }
 drawLabels(chartArea) {
        const optionTicks = this.options.ticks;
        if (!optionTicks.display) {
            return;
        }
        const ctx = this.ctx;
        const area = this._computeLabelArea();
        if (area) {
            clipArea(ctx, area);
        }
        const items = this.getLabelItems(chartArea);
        for (const item of items){
            const renderTextOptions = item.options;
            const tickFont = item.font;
            const label = item.label;
            const y = item.textOffset;
            renderText(ctx, label, 0, y, tickFont, renderTextOptions);
        }
        if (area) {
            unclipArea(ctx);
        }
    }
 drawTitle() {
        const { ctx , options: { position , title , reverse  }  } = this;
        if (!title.display) {
            return;
        }
        const font = toFont(title.font);
        const padding = toPadding(title.padding);
        const align = title.align;
        let offset = font.lineHeight / 2;
        if (position === 'bottom' || position === 'center' || isObject(position)) {
            offset += padding.bottom;
            if (isArray(title.text)) {
                offset += font.lineHeight * (title.text.length - 1);
            }
        } else {
            offset += padding.top;
        }
        const { titleX , titleY , maxWidth , rotation  } = titleArgs(this, offset, position, align);
        renderText(ctx, title.text, 0, 0, font, {
            color: title.color,
            maxWidth,
            rotation,
            textAlign: titleAlign(align, position, reverse),
            textBaseline: 'middle',
            translation: [
                titleX,
                titleY
            ]
        });
    }
    draw(chartArea) {
        if (!this._isVisible()) {
            return;
        }
        this.drawBackground();
        this.drawGrid(chartArea);
        this.drawBorder();
        this.drawTitle();
        this.drawLabels(chartArea);
    }
 _layers() {
        const opts = this.options;
        const tz = opts.ticks && opts.ticks.z || 0;
        const gz = valueOrDefault(opts.grid && opts.grid.z, -1);
        const bz = valueOrDefault(opts.border && opts.border.z, 0);
        if (!this._isVisible() || this.draw !== Scale.prototype.draw) {
            return [
                {
                    z: tz,
                    draw: (chartArea)=>{
                        this.draw(chartArea);
                    }
                }
            ];
        }
        return [
            {
                z: gz,
                draw: (chartArea)=>{
                    this.drawBackground();
                    this.drawGrid(chartArea);
                    this.drawTitle();
                }
            },
            {
                z: bz,
                draw: ()=>{
                    this.drawBorder();
                }
            },
            {
                z: tz,
                draw: (chartArea)=>{
                    this.drawLabels(chartArea);
                }
            }
        ];
    }
 getMatchingVisibleMetas(type) {
        const metas = this.chart.getSortedVisibleDatasetMetas();
        const axisID = this.axis + 'AxisID';
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            const meta = metas[i];
            if (meta[axisID] === this.id && (!type || meta.type === type)) {
                result.push(meta);
            }
        }
        return result;
    }
 _resolveTickFontOptions(index) {
        const opts = this.options.ticks.setContext(this.getContext(index));
        return toFont(opts.font);
    }
 _maxDigits() {
        const fontSize = this._resolveTickFontOptions(0).lineHeight;
        return (this.isHorizontal() ? this.width : this.height) / fontSize;
    }
}

class TypedRegistry {
    constructor(type, scope, override){
        this.type = type;
        this.scope = scope;
        this.override = override;
        this.items = Object.create(null);
    }
    isForType(type) {
        return Object.prototype.isPrototypeOf.call(this.type.prototype, type.prototype);
    }
 register(item) {
        const proto = Object.getPrototypeOf(item);
        let parentScope;
        if (isIChartComponent(proto)) {
            parentScope = this.register(proto);
        }
        const items = this.items;
        const id = item.id;
        const scope = this.scope + '.' + id;
        if (!id) {
            throw new Error('class does not have id: ' + item);
        }
        if (id in items) {
            return scope;
        }
        items[id] = item;
        registerDefaults(item, scope, parentScope);
        if (this.override) {
            defaults.override(item.id, item.overrides);
        }
        return scope;
    }
 get(id) {
        return this.items[id];
    }
 unregister(item) {
        const items = this.items;
        const id = item.id;
        const scope = this.scope;
        if (id in items) {
            delete items[id];
        }
        if (scope && id in defaults[scope]) {
            delete defaults[scope][id];
            if (this.override) {
                delete overrides[id];
            }
        }
    }
}
function registerDefaults(item, scope, parentScope) {
    const itemDefaults = merge(Object.create(null), [
        parentScope ? defaults.get(parentScope) : {},
        defaults.get(scope),
        item.defaults
    ]);
    defaults.set(scope, itemDefaults);
    if (item.defaultRoutes) {
        routeDefaults(scope, item.defaultRoutes);
    }
    if (item.descriptors) {
        defaults.describe(scope, item.descriptors);
    }
}
function routeDefaults(scope, routes) {
    Object.keys(routes).forEach((property)=>{
        const propertyParts = property.split('.');
        const sourceName = propertyParts.pop();
        const sourceScope = [
            scope
        ].concat(propertyParts).join('.');
        const parts = routes[property].split('.');
        const targetName = parts.pop();
        const targetScope = parts.join('.');
        defaults.route(sourceScope, sourceName, targetScope, targetName);
    });
}
function isIChartComponent(proto) {
    return 'id' in proto && 'defaults' in proto;
}

class Registry {
    constructor(){
        this.controllers = new TypedRegistry(DatasetController, 'datasets', true);
        this.elements = new TypedRegistry(Element, 'elements');
        this.plugins = new TypedRegistry(Object, 'plugins');
        this.scales = new TypedRegistry(Scale, 'scales');
        this._typedRegistries = [
            this.controllers,
            this.scales,
            this.elements
        ];
    }
 add(...args) {
        this._each('register', args);
    }
    remove(...args) {
        this._each('unregister', args);
    }
 addControllers(...args) {
        this._each('register', args, this.controllers);
    }
 addElements(...args) {
        this._each('register', args, this.elements);
    }
 addPlugins(...args) {
        this._each('register', args, this.plugins);
    }
 addScales(...args) {
        this._each('register', args, this.scales);
    }
 getController(id) {
        return this._get(id, this.controllers, 'controller');
    }
 getElement(id) {
        return this._get(id, this.elements, 'element');
    }
 getPlugin(id) {
        return this._get(id, this.plugins, 'plugin');
    }
 getScale(id) {
        return this._get(id, this.scales, 'scale');
    }
 removeControllers(...args) {
        this._each('unregister', args, this.controllers);
    }
 removeElements(...args) {
        this._each('unregister', args, this.elements);
    }
 removePlugins(...args) {
        this._each('unregister', args, this.plugins);
    }
 removeScales(...args) {
        this._each('unregister', args, this.scales);
    }
 _each(method, args, typedRegistry) {
        [
            ...args
        ].forEach((arg)=>{
            const reg = typedRegistry || this._getRegistryForType(arg);
            if (typedRegistry || reg.isForType(arg) || reg === this.plugins && arg.id) {
                this._exec(method, reg, arg);
            } else {
                each(arg, (item)=>{
                    const itemReg = typedRegistry || this._getRegistryForType(item);
                    this._exec(method, itemReg, item);
                });
            }
        });
    }
 _exec(method, registry, component) {
        const camelMethod = _capitalize(method);
        callback(component['before' + camelMethod], [], component);
        registry[method](component);
        callback(component['after' + camelMethod], [], component);
    }
 _getRegistryForType(type) {
        for(let i = 0; i < this._typedRegistries.length; i++){
            const reg = this._typedRegistries[i];
            if (reg.isForType(type)) {
                return reg;
            }
        }
        return this.plugins;
    }
 _get(id, typedRegistry, type) {
        const item = typedRegistry.get(id);
        if (item === undefined) {
            throw new Error('"' + id + '" is not a registered ' + type + '.');
        }
        return item;
    }
}
var registry = /* #__PURE__ */ new Registry();

class PluginService {
    constructor(){
        this._init = undefined;
    }
 notify(chart, hook, args, filter) {
        if (hook === 'beforeInit') {
            this._init = this._createDescriptors(chart, true);
            this._notify(this._init, chart, 'install');
        }
        if (this._init === undefined) {
            return;
        }
        const descriptors = filter ? this._descriptors(chart).filter(filter) : this._descriptors(chart);
        const result = this._notify(descriptors, chart, hook, args);
        if (hook === 'afterDestroy') {
            this._notify(descriptors, chart, 'stop');
            this._notify(this._init, chart, 'uninstall');
            this._init = undefined;
        }
        return result;
    }
 _notify(descriptors, chart, hook, args) {
        args = args || {};
        for (const descriptor of descriptors){
            const plugin = descriptor.plugin;
            const method = plugin[hook];
            const params = [
                chart,
                args,
                descriptor.options
            ];
            if (callback(method, params, plugin) === false && args.cancelable) {
                return false;
            }
        }
        return true;
    }
    invalidate() {
        if (!isNullOrUndef(this._cache)) {
            this._oldCache = this._cache;
            this._cache = undefined;
        }
    }
 _descriptors(chart) {
        if (this._cache) {
            return this._cache;
        }
        const descriptors = this._cache = this._createDescriptors(chart);
        this._notifyStateChanges(chart);
        return descriptors;
    }
    _createDescriptors(chart, all) {
        const config = chart && chart.config;
        const options = valueOrDefault(config.options && config.options.plugins, {});
        const plugins = allPlugins(config);
        return options === false && !all ? [] : createDescriptors(chart, plugins, options, all);
    }
 _notifyStateChanges(chart) {
        const previousDescriptors = this._oldCache || [];
        const descriptors = this._cache;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.plugin.id === y.plugin.id));
        this._notify(diff(previousDescriptors, descriptors), chart, 'stop');
        this._notify(diff(descriptors, previousDescriptors), chart, 'start');
    }
}
 function allPlugins(config) {
    const localIds = {};
    const plugins = [];
    const keys = Object.keys(registry.plugins.items);
    for(let i = 0; i < keys.length; i++){
        plugins.push(registry.getPlugin(keys[i]));
    }
    const local = config.plugins || [];
    for(let i = 0; i < local.length; i++){
        const plugin = local[i];
        if (plugins.indexOf(plugin) === -1) {
            plugins.push(plugin);
            localIds[plugin.id] = true;
        }
    }
    return {
        plugins,
        localIds
    };
}
function getOpts(options, all) {
    if (!all && options === false) {
        return null;
    }
    if (options === true) {
        return {};
    }
    return options;
}
function createDescriptors(chart, { plugins , localIds  }, options, all) {
    const result = [];
    const context = chart.getContext();
    for (const plugin of plugins){
        const id = plugin.id;
        const opts = getOpts(options[id], all);
        if (opts === null) {
            continue;
        }
        result.push({
            plugin,
            options: pluginOpts(chart.config, {
                plugin,
                local: localIds[id]
            }, opts, context)
        });
    }
    return result;
}
function pluginOpts(config, { plugin , local  }, opts, context) {
    const keys = config.pluginScopeKeys(plugin);
    const scopes = config.getOptionScopes(opts, keys);
    if (local && plugin.defaults) {
        scopes.push(plugin.defaults);
    }
    return config.createResolver(scopes, context, [
        ''
    ], {
        scriptable: false,
        indexable: false,
        allKeys: true
    });
}

function getIndexAxis(type, options) {
    const datasetDefaults = defaults.datasets[type] || {};
    const datasetOptions = (options.datasets || {})[type] || {};
    return datasetOptions.indexAxis || options.indexAxis || datasetDefaults.indexAxis || 'x';
}
function getAxisFromDefaultScaleID(id, indexAxis) {
    let axis = id;
    if (id === '_index_') {
        axis = indexAxis;
    } else if (id === '_value_') {
        axis = indexAxis === 'x' ? 'y' : 'x';
    }
    return axis;
}
function getDefaultScaleIDFromAxis(axis, indexAxis) {
    return axis === indexAxis ? '_index_' : '_value_';
}
function idMatchesAxis(id) {
    if (id === 'x' || id === 'y' || id === 'r') {
        return id;
    }
}
function axisFromPosition(position) {
    if (position === 'top' || position === 'bottom') {
        return 'x';
    }
    if (position === 'left' || position === 'right') {
        return 'y';
    }
}
function determineAxis(id, ...scaleOptions) {
    if (idMatchesAxis(id)) {
        return id;
    }
    for (const opts of scaleOptions){
        const axis = opts.axis || axisFromPosition(opts.position) || id.length > 1 && idMatchesAxis(id[0].toLowerCase());
        if (axis) {
            return axis;
        }
    }
    throw new Error(`Cannot determine type of '${id}' axis. Please provide 'axis' or 'position' option.`);
}
function getAxisFromDataset(id, axis, dataset) {
    if (dataset[axis + 'AxisID'] === id) {
        return {
            axis
        };
    }
}
function retrieveAxisFromDatasets(id, config) {
    if (config.data && config.data.datasets) {
        const boundDs = config.data.datasets.filter((d)=>d.xAxisID === id || d.yAxisID === id);
        if (boundDs.length) {
            return getAxisFromDataset(id, 'x', boundDs[0]) || getAxisFromDataset(id, 'y', boundDs[0]);
        }
    }
    return {};
}
function mergeScaleConfig(config, options) {
    const chartDefaults = overrides[config.type] || {
        scales: {}
    };
    const configScales = options.scales || {};
    const chartIndexAxis = getIndexAxis(config.type, options);
    const scales = Object.create(null);
    Object.keys(configScales).forEach((id)=>{
        const scaleConf = configScales[id];
        if (!isObject(scaleConf)) {
            return console.error(`Invalid scale configuration for scale: ${id}`);
        }
        if (scaleConf._proxy) {
            return console.warn(`Ignoring resolver passed as options for scale: ${id}`);
        }
        const axis = determineAxis(id, scaleConf, retrieveAxisFromDatasets(id, config), defaults.scales[scaleConf.type]);
        const defaultId = getDefaultScaleIDFromAxis(axis, chartIndexAxis);
        const defaultScaleOptions = chartDefaults.scales || {};
        scales[id] = mergeIf(Object.create(null), [
            {
                axis
            },
            scaleConf,
            defaultScaleOptions[axis],
            defaultScaleOptions[defaultId]
        ]);
    });
    config.data.datasets.forEach((dataset)=>{
        const type = dataset.type || config.type;
        const indexAxis = dataset.indexAxis || getIndexAxis(type, options);
        const datasetDefaults = overrides[type] || {};
        const defaultScaleOptions = datasetDefaults.scales || {};
        Object.keys(defaultScaleOptions).forEach((defaultID)=>{
            const axis = getAxisFromDefaultScaleID(defaultID, indexAxis);
            const id = dataset[axis + 'AxisID'] || axis;
            scales[id] = scales[id] || Object.create(null);
            mergeIf(scales[id], [
                {
                    axis
                },
                configScales[id],
                defaultScaleOptions[defaultID]
            ]);
        });
    });
    Object.keys(scales).forEach((key)=>{
        const scale = scales[key];
        mergeIf(scale, [
            defaults.scales[scale.type],
            defaults.scale
        ]);
    });
    return scales;
}
function initOptions(config) {
    const options = config.options || (config.options = {});
    options.plugins = valueOrDefault(options.plugins, {});
    options.scales = mergeScaleConfig(config, options);
}
function initData(data) {
    data = data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    return data;
}
function initConfig(config) {
    config = config || {};
    config.data = initData(config.data);
    initOptions(config);
    return config;
}
const keyCache = new Map();
const keysCached = new Set();
function cachedKeys(cacheKey, generate) {
    let keys = keyCache.get(cacheKey);
    if (!keys) {
        keys = generate();
        keyCache.set(cacheKey, keys);
        keysCached.add(keys);
    }
    return keys;
}
const addIfFound = (set, obj, key)=>{
    const opts = resolveObjectKey(obj, key);
    if (opts !== undefined) {
        set.add(opts);
    }
};
class Config {
    constructor(config){
        this._config = initConfig(config);
        this._scopeCache = new Map();
        this._resolverCache = new Map();
    }
    get platform() {
        return this._config.platform;
    }
    get type() {
        return this._config.type;
    }
    set type(type) {
        this._config.type = type;
    }
    get data() {
        return this._config.data;
    }
    set data(data) {
        this._config.data = initData(data);
    }
    get options() {
        return this._config.options;
    }
    set options(options) {
        this._config.options = options;
    }
    get plugins() {
        return this._config.plugins;
    }
    update() {
        const config = this._config;
        this.clearCache();
        initOptions(config);
    }
    clearCache() {
        this._scopeCache.clear();
        this._resolverCache.clear();
    }
 datasetScopeKeys(datasetType) {
        return cachedKeys(datasetType, ()=>[
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
 datasetAnimationScopeKeys(datasetType, transition) {
        return cachedKeys(`${datasetType}.transition.${transition}`, ()=>[
                [
                    `datasets.${datasetType}.transitions.${transition}`,
                    `transitions.${transition}`
                ],
                [
                    `datasets.${datasetType}`,
                    ''
                ]
            ]);
    }
 datasetElementScopeKeys(datasetType, elementType) {
        return cachedKeys(`${datasetType}-${elementType}`, ()=>[
                [
                    `datasets.${datasetType}.elements.${elementType}`,
                    `datasets.${datasetType}`,
                    `elements.${elementType}`,
                    ''
                ]
            ]);
    }
 pluginScopeKeys(plugin) {
        const id = plugin.id;
        const type = this.type;
        return cachedKeys(`${type}-plugin-${id}`, ()=>[
                [
                    `plugins.${id}`,
                    ...plugin.additionalOptionScopes || []
                ]
            ]);
    }
 _cachedScopes(mainScope, resetCache) {
        const _scopeCache = this._scopeCache;
        let cache = _scopeCache.get(mainScope);
        if (!cache || resetCache) {
            cache = new Map();
            _scopeCache.set(mainScope, cache);
        }
        return cache;
    }
 getOptionScopes(mainScope, keyLists, resetCache) {
        const { options , type  } = this;
        const cache = this._cachedScopes(mainScope, resetCache);
        const cached = cache.get(keyLists);
        if (cached) {
            return cached;
        }
        const scopes = new Set();
        keyLists.forEach((keys)=>{
            if (mainScope) {
                scopes.add(mainScope);
                keys.forEach((key)=>addIfFound(scopes, mainScope, key));
            }
            keys.forEach((key)=>addIfFound(scopes, options, key));
            keys.forEach((key)=>addIfFound(scopes, overrides[type] || {}, key));
            keys.forEach((key)=>addIfFound(scopes, defaults, key));
            keys.forEach((key)=>addIfFound(scopes, descriptors, key));
        });
        const array = Array.from(scopes);
        if (array.length === 0) {
            array.push(Object.create(null));
        }
        if (keysCached.has(keyLists)) {
            cache.set(keyLists, array);
        }
        return array;
    }
 chartOptionScopes() {
        const { options , type  } = this;
        return [
            options,
            overrides[type] || {},
            defaults.datasets[type] || {},
            {
                type
            },
            defaults,
            descriptors
        ];
    }
 resolveNamedOptions(scopes, names, context, prefixes = [
        ''
    ]) {
        const result = {
            $shared: true
        };
        const { resolver , subPrefixes  } = getResolver(this._resolverCache, scopes, prefixes);
        let options = resolver;
        if (needContext(resolver, names)) {
            result.$shared = false;
            context = isFunction(context) ? context() : context;
            const subResolver = this.createResolver(scopes, context, subPrefixes);
            options = _attachContext(resolver, context, subResolver);
        }
        for (const prop of names){
            result[prop] = options[prop];
        }
        return result;
    }
 createResolver(scopes, context, prefixes = [
        ''
    ], descriptorDefaults) {
        const { resolver  } = getResolver(this._resolverCache, scopes, prefixes);
        return isObject(context) ? _attachContext(resolver, context, undefined, descriptorDefaults) : resolver;
    }
}
function getResolver(resolverCache, scopes, prefixes) {
    let cache = resolverCache.get(scopes);
    if (!cache) {
        cache = new Map();
        resolverCache.set(scopes, cache);
    }
    const cacheKey = prefixes.join();
    let cached = cache.get(cacheKey);
    if (!cached) {
        const resolver = _createResolver(scopes, prefixes);
        cached = {
            resolver,
            subPrefixes: prefixes.filter((p)=>!p.toLowerCase().includes('hover'))
        };
        cache.set(cacheKey, cached);
    }
    return cached;
}
const hasFunction = (value)=>isObject(value) && Object.getOwnPropertyNames(value).some((key)=>isFunction(value[key]));
function needContext(proxy, names) {
    const { isScriptable , isIndexable  } = _descriptors(proxy);
    for (const prop of names){
        const scriptable = isScriptable(prop);
        const indexable = isIndexable(prop);
        const value = (indexable || scriptable) && proxy[prop];
        if (scriptable && (isFunction(value) || hasFunction(value)) || indexable && isArray(value)) {
            return true;
        }
    }
    return false;
}

var version = "4.5.1";

const KNOWN_POSITIONS = [
    'top',
    'bottom',
    'left',
    'right',
    'chartArea'
];
function positionIsHorizontal(position, axis) {
    return position === 'top' || position === 'bottom' || KNOWN_POSITIONS.indexOf(position) === -1 && axis === 'x';
}
function compare2Level(l1, l2) {
    return function(a, b) {
        return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
}
function onAnimationsComplete(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    chart.notifyPlugins('afterRender');
    callback(animationOptions && animationOptions.onComplete, [
        context
    ], chart);
}
function onAnimationProgress(context) {
    const chart = context.chart;
    const animationOptions = chart.options.animation;
    callback(animationOptions && animationOptions.onProgress, [
        context
    ], chart);
}
 function getCanvas(item) {
    if (_isDomSupported() && typeof item === 'string') {
        item = document.getElementById(item);
    } else if (item && item.length) {
        item = item[0];
    }
    if (item && item.canvas) {
        item = item.canvas;
    }
    return item;
}
const instances = {};
const getChart = (key)=>{
    const canvas = getCanvas(key);
    return Object.values(instances).filter((c)=>c.canvas === canvas).pop();
};
function moveNumericKeys(obj, start, move) {
    const keys = Object.keys(obj);
    for (const key of keys){
        const intKey = +key;
        if (intKey >= start) {
            const value = obj[key];
            delete obj[key];
            if (move > 0 || intKey > start) {
                obj[intKey + move] = value;
            }
        }
    }
}
 function determineLastEvent(e, lastEvent, inChartArea, isClick) {
    if (!inChartArea || e.type === 'mouseout') {
        return null;
    }
    if (isClick) {
        return lastEvent;
    }
    return e;
}
class Chart {
    static defaults = defaults;
    static instances = instances;
    static overrides = overrides;
    static registry = registry;
    static version = version;
    static getChart = getChart;
    static register(...items) {
        registry.add(...items);
        invalidatePlugins();
    }
    static unregister(...items) {
        registry.remove(...items);
        invalidatePlugins();
    }
    constructor(item, userConfig){
        const config = this.config = new Config(userConfig);
        const initialCanvas = getCanvas(item);
        const existingChart = getChart(initialCanvas);
        if (existingChart) {
            throw new Error('Canvas is already in use. Chart with ID \'' + existingChart.id + '\'' + ' must be destroyed before the canvas with ID \'' + existingChart.canvas.id + '\' can be reused.');
        }
        const options = config.createResolver(config.chartOptionScopes(), this.getContext());
        this.platform = new (config.platform || _detectPlatform(initialCanvas))();
        this.platform.updateConfig(config);
        const context = this.platform.acquireContext(initialCanvas, options.aspectRatio);
        const canvas = context && context.canvas;
        const height = canvas && canvas.height;
        const width = canvas && canvas.width;
        this.id = uid();
        this.ctx = context;
        this.canvas = canvas;
        this.width = width;
        this.height = height;
        this._options = options;
        this._aspectRatio = this.aspectRatio;
        this._layers = [];
        this._metasets = [];
        this._stacks = undefined;
        this.boxes = [];
        this.currentDevicePixelRatio = undefined;
        this.chartArea = undefined;
        this._active = [];
        this._lastEvent = undefined;
        this._listeners = {};
         this._responsiveListeners = undefined;
        this._sortedMetasets = [];
        this.scales = {};
        this._plugins = new PluginService();
        this.$proxies = {};
        this._hiddenIndices = {};
        this.attached = false;
        this._animationsDisabled = undefined;
        this.$context = undefined;
        this._doResize = debounce((mode)=>this.update(mode), options.resizeDelay || 0);
        this._dataChanges = [];
        instances[this.id] = this;
        if (!context || !canvas) {
            console.error("Failed to create chart: can't acquire context from the given item");
            return;
        }
        animator.listen(this, 'complete', onAnimationsComplete);
        animator.listen(this, 'progress', onAnimationProgress);
        this._initialize();
        if (this.attached) {
            this.update();
        }
    }
    get aspectRatio() {
        const { options: { aspectRatio , maintainAspectRatio  } , width , height , _aspectRatio  } = this;
        if (!isNullOrUndef(aspectRatio)) {
            return aspectRatio;
        }
        if (maintainAspectRatio && _aspectRatio) {
            return _aspectRatio;
        }
        return height ? width / height : null;
    }
    get data() {
        return this.config.data;
    }
    set data(data) {
        this.config.data = data;
    }
    get options() {
        return this._options;
    }
    set options(options) {
        this.config.options = options;
    }
    get registry() {
        return registry;
    }
 _initialize() {
        this.notifyPlugins('beforeInit');
        if (this.options.responsive) {
            this.resize();
        } else {
            retinaScale(this, this.options.devicePixelRatio);
        }
        this.bindEvents();
        this.notifyPlugins('afterInit');
        return this;
    }
    clear() {
        clearCanvas(this.canvas, this.ctx);
        return this;
    }
    stop() {
        animator.stop(this);
        return this;
    }
 resize(width, height) {
        if (!animator.running(this)) {
            this._resize(width, height);
        } else {
            this._resizeBeforeDraw = {
                width,
                height
            };
        }
    }
    _resize(width, height) {
        const options = this.options;
        const canvas = this.canvas;
        const aspectRatio = options.maintainAspectRatio && this.aspectRatio;
        const newSize = this.platform.getMaximumSize(canvas, width, height, aspectRatio);
        const newRatio = options.devicePixelRatio || this.platform.getDevicePixelRatio();
        const mode = this.width ? 'resize' : 'attach';
        this.width = newSize.width;
        this.height = newSize.height;
        this._aspectRatio = this.aspectRatio;
        if (!retinaScale(this, newRatio, true)) {
            return;
        }
        this.notifyPlugins('resize', {
            size: newSize
        });
        callback(options.onResize, [
            this,
            newSize
        ], this);
        if (this.attached) {
            if (this._doResize(mode)) {
                this.render();
            }
        }
    }
    ensureScalesHaveIDs() {
        const options = this.options;
        const scalesOptions = options.scales || {};
        each(scalesOptions, (axisOptions, axisID)=>{
            axisOptions.id = axisID;
        });
    }
 buildOrUpdateScales() {
        const options = this.options;
        const scaleOpts = options.scales;
        const scales = this.scales;
        const updated = Object.keys(scales).reduce((obj, id)=>{
            obj[id] = false;
            return obj;
        }, {});
        let items = [];
        if (scaleOpts) {
            items = items.concat(Object.keys(scaleOpts).map((id)=>{
                const scaleOptions = scaleOpts[id];
                const axis = determineAxis(id, scaleOptions);
                const isRadial = axis === 'r';
                const isHorizontal = axis === 'x';
                return {
                    options: scaleOptions,
                    dposition: isRadial ? 'chartArea' : isHorizontal ? 'bottom' : 'left',
                    dtype: isRadial ? 'radialLinear' : isHorizontal ? 'category' : 'linear'
                };
            }));
        }
        each(items, (item)=>{
            const scaleOptions = item.options;
            const id = scaleOptions.id;
            const axis = determineAxis(id, scaleOptions);
            const scaleType = valueOrDefault(scaleOptions.type, item.dtype);
            if (scaleOptions.position === undefined || positionIsHorizontal(scaleOptions.position, axis) !== positionIsHorizontal(item.dposition)) {
                scaleOptions.position = item.dposition;
            }
            updated[id] = true;
            let scale = null;
            if (id in scales && scales[id].type === scaleType) {
                scale = scales[id];
            } else {
                const scaleClass = registry.getScale(scaleType);
                scale = new scaleClass({
                    id,
                    type: scaleType,
                    ctx: this.ctx,
                    chart: this
                });
                scales[scale.id] = scale;
            }
            scale.init(scaleOptions, options);
        });
        each(updated, (hasUpdated, id)=>{
            if (!hasUpdated) {
                delete scales[id];
            }
        });
        each(scales, (scale)=>{
            layouts.configure(this, scale, scale.options);
            layouts.addBox(this, scale);
        });
    }
 _updateMetasets() {
        const metasets = this._metasets;
        const numData = this.data.datasets.length;
        const numMeta = metasets.length;
        metasets.sort((a, b)=>a.index - b.index);
        if (numMeta > numData) {
            for(let i = numData; i < numMeta; ++i){
                this._destroyDatasetMeta(i);
            }
            metasets.splice(numData, numMeta - numData);
        }
        this._sortedMetasets = metasets.slice(0).sort(compare2Level('order', 'index'));
    }
 _removeUnreferencedMetasets() {
        const { _metasets: metasets , data: { datasets  }  } = this;
        if (metasets.length > datasets.length) {
            delete this._stacks;
        }
        metasets.forEach((meta, index)=>{
            if (datasets.filter((x)=>x === meta._dataset).length === 0) {
                this._destroyDatasetMeta(index);
            }
        });
    }
    buildOrUpdateControllers() {
        const newControllers = [];
        const datasets = this.data.datasets;
        let i, ilen;
        this._removeUnreferencedMetasets();
        for(i = 0, ilen = datasets.length; i < ilen; i++){
            const dataset = datasets[i];
            let meta = this.getDatasetMeta(i);
            const type = dataset.type || this.config.type;
            if (meta.type && meta.type !== type) {
                this._destroyDatasetMeta(i);
                meta = this.getDatasetMeta(i);
            }
            meta.type = type;
            meta.indexAxis = dataset.indexAxis || getIndexAxis(type, this.options);
            meta.order = dataset.order || 0;
            meta.index = i;
            meta.label = '' + dataset.label;
            meta.visible = this.isDatasetVisible(i);
            if (meta.controller) {
                meta.controller.updateIndex(i);
                meta.controller.linkScales();
            } else {
                const ControllerClass = registry.getController(type);
                const { datasetElementType , dataElementType  } = defaults.datasets[type];
                Object.assign(ControllerClass, {
                    dataElementType: registry.getElement(dataElementType),
                    datasetElementType: datasetElementType && registry.getElement(datasetElementType)
                });
                meta.controller = new ControllerClass(this, i);
                newControllers.push(meta.controller);
            }
        }
        this._updateMetasets();
        return newControllers;
    }
 _resetElements() {
        each(this.data.datasets, (dataset, datasetIndex)=>{
            this.getDatasetMeta(datasetIndex).controller.reset();
        }, this);
    }
 reset() {
        this._resetElements();
        this.notifyPlugins('reset');
    }
    update(mode) {
        const config = this.config;
        config.update();
        const options = this._options = config.createResolver(config.chartOptionScopes(), this.getContext());
        const animsDisabled = this._animationsDisabled = !options.animation;
        this._updateScales();
        this._checkEventBindings();
        this._updateHiddenIndices();
        this._plugins.invalidate();
        if (this.notifyPlugins('beforeUpdate', {
            mode,
            cancelable: true
        }) === false) {
            return;
        }
        const newControllers = this.buildOrUpdateControllers();
        this.notifyPlugins('beforeElementsUpdate');
        let minPadding = 0;
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; i++){
            const { controller  } = this.getDatasetMeta(i);
            const reset = !animsDisabled && newControllers.indexOf(controller) === -1;
            controller.buildOrUpdateElements(reset);
            minPadding = Math.max(+controller.getMaxOverflow(), minPadding);
        }
        minPadding = this._minPadding = options.layout.autoPadding ? minPadding : 0;
        this._updateLayout(minPadding);
        if (!animsDisabled) {
            each(newControllers, (controller)=>{
                controller.reset();
            });
        }
        this._updateDatasets(mode);
        this.notifyPlugins('afterUpdate', {
            mode
        });
        this._layers.sort(compare2Level('z', '_idx'));
        const { _active , _lastEvent  } = this;
        if (_lastEvent) {
            this._eventHandler(_lastEvent, true);
        } else if (_active.length) {
            this._updateHoverStyles(_active, _active, true);
        }
        this.render();
    }
 _updateScales() {
        each(this.scales, (scale)=>{
            layouts.removeBox(this, scale);
        });
        this.ensureScalesHaveIDs();
        this.buildOrUpdateScales();
    }
 _checkEventBindings() {
        const options = this.options;
        const existingEvents = new Set(Object.keys(this._listeners));
        const newEvents = new Set(options.events);
        if (!setsEqual(existingEvents, newEvents) || !!this._responsiveListeners !== options.responsive) {
            this.unbindEvents();
            this.bindEvents();
        }
    }
 _updateHiddenIndices() {
        const { _hiddenIndices  } = this;
        const changes = this._getUniformDataChanges() || [];
        for (const { method , start , count  } of changes){
            const move = method === '_removeElements' ? -count : count;
            moveNumericKeys(_hiddenIndices, start, move);
        }
    }
 _getUniformDataChanges() {
        const _dataChanges = this._dataChanges;
        if (!_dataChanges || !_dataChanges.length) {
            return;
        }
        this._dataChanges = [];
        const datasetCount = this.data.datasets.length;
        const makeSet = (idx)=>new Set(_dataChanges.filter((c)=>c[0] === idx).map((c, i)=>i + ',' + c.splice(1).join(',')));
        const changeSet = makeSet(0);
        for(let i = 1; i < datasetCount; i++){
            if (!setsEqual(changeSet, makeSet(i))) {
                return;
            }
        }
        return Array.from(changeSet).map((c)=>c.split(',')).map((a)=>({
                method: a[1],
                start: +a[2],
                count: +a[3]
            }));
    }
 _updateLayout(minPadding) {
        if (this.notifyPlugins('beforeLayout', {
            cancelable: true
        }) === false) {
            return;
        }
        layouts.update(this, this.width, this.height, minPadding);
        const area = this.chartArea;
        const noArea = area.width <= 0 || area.height <= 0;
        this._layers = [];
        each(this.boxes, (box)=>{
            if (noArea && box.position === 'chartArea') {
                return;
            }
            if (box.configure) {
                box.configure();
            }
            this._layers.push(...box._layers());
        }, this);
        this._layers.forEach((item, index)=>{
            item._idx = index;
        });
        this.notifyPlugins('afterLayout');
    }
 _updateDatasets(mode) {
        if (this.notifyPlugins('beforeDatasetsUpdate', {
            mode,
            cancelable: true
        }) === false) {
            return;
        }
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this.getDatasetMeta(i).controller.configure();
        }
        for(let i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this._updateDataset(i, isFunction(mode) ? mode({
                datasetIndex: i
            }) : mode);
        }
        this.notifyPlugins('afterDatasetsUpdate', {
            mode
        });
    }
 _updateDataset(index, mode) {
        const meta = this.getDatasetMeta(index);
        const args = {
            meta,
            index,
            mode,
            cancelable: true
        };
        if (this.notifyPlugins('beforeDatasetUpdate', args) === false) {
            return;
        }
        meta.controller._update(mode);
        args.cancelable = false;
        this.notifyPlugins('afterDatasetUpdate', args);
    }
    render() {
        if (this.notifyPlugins('beforeRender', {
            cancelable: true
        }) === false) {
            return;
        }
        if (animator.has(this)) {
            if (this.attached && !animator.running(this)) {
                animator.start(this);
            }
        } else {
            this.draw();
            onAnimationsComplete({
                chart: this
            });
        }
    }
    draw() {
        let i;
        if (this._resizeBeforeDraw) {
            const { width , height  } = this._resizeBeforeDraw;
            this._resizeBeforeDraw = null;
            this._resize(width, height);
        }
        this.clear();
        if (this.width <= 0 || this.height <= 0) {
            return;
        }
        if (this.notifyPlugins('beforeDraw', {
            cancelable: true
        }) === false) {
            return;
        }
        const layers = this._layers;
        for(i = 0; i < layers.length && layers[i].z <= 0; ++i){
            layers[i].draw(this.chartArea);
        }
        this._drawDatasets();
        for(; i < layers.length; ++i){
            layers[i].draw(this.chartArea);
        }
        this.notifyPlugins('afterDraw');
    }
 _getSortedDatasetMetas(filterVisible) {
        const metasets = this._sortedMetasets;
        const result = [];
        let i, ilen;
        for(i = 0, ilen = metasets.length; i < ilen; ++i){
            const meta = metasets[i];
            if (!filterVisible || meta.visible) {
                result.push(meta);
            }
        }
        return result;
    }
 getSortedVisibleDatasetMetas() {
        return this._getSortedDatasetMetas(true);
    }
 _drawDatasets() {
        if (this.notifyPlugins('beforeDatasetsDraw', {
            cancelable: true
        }) === false) {
            return;
        }
        const metasets = this.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            this._drawDataset(metasets[i]);
        }
        this.notifyPlugins('afterDatasetsDraw');
    }
 _drawDataset(meta) {
        const ctx = this.ctx;
        const args = {
            meta,
            index: meta.index,
            cancelable: true
        };
        const clip = getDatasetClipArea(this, meta);
        if (this.notifyPlugins('beforeDatasetDraw', args) === false) {
            return;
        }
        if (clip) {
            clipArea(ctx, clip);
        }
        meta.controller.draw();
        if (clip) {
            unclipArea(ctx);
        }
        args.cancelable = false;
        this.notifyPlugins('afterDatasetDraw', args);
    }
 isPointInArea(point) {
        return _isPointInArea(point, this.chartArea, this._minPadding);
    }
    getElementsAtEventForMode(e, mode, options, useFinalPosition) {
        const method = Interaction.modes[mode];
        if (typeof method === 'function') {
            return method(this, e, options, useFinalPosition);
        }
        return [];
    }
    getDatasetMeta(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        const metasets = this._metasets;
        let meta = metasets.filter((x)=>x && x._dataset === dataset).pop();
        if (!meta) {
            meta = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: dataset && dataset.order || 0,
                index: datasetIndex,
                _dataset: dataset,
                _parsed: [],
                _sorted: false
            };
            metasets.push(meta);
        }
        return meta;
    }
    getContext() {
        return this.$context || (this.$context = createContext(null, {
            chart: this,
            type: 'chart'
        }));
    }
    getVisibleDatasetCount() {
        return this.getSortedVisibleDatasetMetas().length;
    }
    isDatasetVisible(datasetIndex) {
        const dataset = this.data.datasets[datasetIndex];
        if (!dataset) {
            return false;
        }
        const meta = this.getDatasetMeta(datasetIndex);
        return typeof meta.hidden === 'boolean' ? !meta.hidden : !dataset.hidden;
    }
    setDatasetVisibility(datasetIndex, visible) {
        const meta = this.getDatasetMeta(datasetIndex);
        meta.hidden = !visible;
    }
    toggleDataVisibility(index) {
        this._hiddenIndices[index] = !this._hiddenIndices[index];
    }
    getDataVisibility(index) {
        return !this._hiddenIndices[index];
    }
 _updateVisibility(datasetIndex, dataIndex, visible) {
        const mode = visible ? 'show' : 'hide';
        const meta = this.getDatasetMeta(datasetIndex);
        const anims = meta.controller._resolveAnimations(undefined, mode);
        if (defined(dataIndex)) {
            meta.data[dataIndex].hidden = !visible;
            this.update();
        } else {
            this.setDatasetVisibility(datasetIndex, visible);
            anims.update(meta, {
                visible
            });
            this.update((ctx)=>ctx.datasetIndex === datasetIndex ? mode : undefined);
        }
    }
    hide(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, false);
    }
    show(datasetIndex, dataIndex) {
        this._updateVisibility(datasetIndex, dataIndex, true);
    }
 _destroyDatasetMeta(datasetIndex) {
        const meta = this._metasets[datasetIndex];
        if (meta && meta.controller) {
            meta.controller._destroy();
        }
        delete this._metasets[datasetIndex];
    }
    _stop() {
        let i, ilen;
        this.stop();
        animator.remove(this);
        for(i = 0, ilen = this.data.datasets.length; i < ilen; ++i){
            this._destroyDatasetMeta(i);
        }
    }
    destroy() {
        this.notifyPlugins('beforeDestroy');
        const { canvas , ctx  } = this;
        this._stop();
        this.config.clearCache();
        if (canvas) {
            this.unbindEvents();
            clearCanvas(canvas, ctx);
            this.platform.releaseContext(ctx);
            this.canvas = null;
            this.ctx = null;
        }
        delete instances[this.id];
        this.notifyPlugins('afterDestroy');
    }
    toBase64Image(...args) {
        return this.canvas.toDataURL(...args);
    }
 bindEvents() {
        this.bindUserEvents();
        if (this.options.responsive) {
            this.bindResponsiveEvents();
        } else {
            this.attached = true;
        }
    }
 bindUserEvents() {
        const listeners = this._listeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const listener = (e, x, y)=>{
            e.offsetX = x;
            e.offsetY = y;
            this._eventHandler(e);
        };
        each(this.options.events, (type)=>_add(type, listener));
    }
 bindResponsiveEvents() {
        if (!this._responsiveListeners) {
            this._responsiveListeners = {};
        }
        const listeners = this._responsiveListeners;
        const platform = this.platform;
        const _add = (type, listener)=>{
            platform.addEventListener(this, type, listener);
            listeners[type] = listener;
        };
        const _remove = (type, listener)=>{
            if (listeners[type]) {
                platform.removeEventListener(this, type, listener);
                delete listeners[type];
            }
        };
        const listener = (width, height)=>{
            if (this.canvas) {
                this.resize(width, height);
            }
        };
        let detached;
        const attached = ()=>{
            _remove('attach', attached);
            this.attached = true;
            this.resize();
            _add('resize', listener);
            _add('detach', detached);
        };
        detached = ()=>{
            this.attached = false;
            _remove('resize', listener);
            this._stop();
            this._resize(0, 0);
            _add('attach', attached);
        };
        if (platform.isAttached(this.canvas)) {
            attached();
        } else {
            detached();
        }
    }
 unbindEvents() {
        each(this._listeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._listeners = {};
        each(this._responsiveListeners, (listener, type)=>{
            this.platform.removeEventListener(this, type, listener);
        });
        this._responsiveListeners = undefined;
    }
    updateHoverStyle(items, mode, enabled) {
        const prefix = enabled ? 'set' : 'remove';
        let meta, item, i, ilen;
        if (mode === 'dataset') {
            meta = this.getDatasetMeta(items[0].datasetIndex);
            meta.controller['_' + prefix + 'DatasetHoverStyle']();
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            item = items[i];
            const controller = item && this.getDatasetMeta(item.datasetIndex).controller;
            if (controller) {
                controller[prefix + 'HoverStyle'](item.element, item.datasetIndex, item.index);
            }
        }
    }
 getActiveElements() {
        return this._active || [];
    }
 setActiveElements(activeElements) {
        const lastActive = this._active || [];
        const active = activeElements.map(({ datasetIndex , index  })=>{
            const meta = this.getDatasetMeta(datasetIndex);
            if (!meta) {
                throw new Error('No dataset found at index ' + datasetIndex);
            }
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !_elementsEqual(active, lastActive);
        if (changed) {
            this._active = active;
            this._lastEvent = null;
            this._updateHoverStyles(active, lastActive);
        }
    }
 notifyPlugins(hook, args, filter) {
        return this._plugins.notify(this, hook, args, filter);
    }
 isPluginEnabled(pluginId) {
        return this._plugins._cache.filter((p)=>p.plugin.id === pluginId).length === 1;
    }
 _updateHoverStyles(active, lastActive, replay) {
        const hoverOptions = this.options.hover;
        const diff = (a, b)=>a.filter((x)=>!b.some((y)=>x.datasetIndex === y.datasetIndex && x.index === y.index));
        const deactivated = diff(lastActive, active);
        const activated = replay ? active : diff(active, lastActive);
        if (deactivated.length) {
            this.updateHoverStyle(deactivated, hoverOptions.mode, false);
        }
        if (activated.length && hoverOptions.mode) {
            this.updateHoverStyle(activated, hoverOptions.mode, true);
        }
    }
 _eventHandler(e, replay) {
        const args = {
            event: e,
            replay,
            cancelable: true,
            inChartArea: this.isPointInArea(e)
        };
        const eventFilter = (plugin)=>(plugin.options.events || this.options.events).includes(e.native.type);
        if (this.notifyPlugins('beforeEvent', args, eventFilter) === false) {
            return;
        }
        const changed = this._handleEvent(e, replay, args.inChartArea);
        args.cancelable = false;
        this.notifyPlugins('afterEvent', args, eventFilter);
        if (changed || args.changed) {
            this.render();
        }
        return this;
    }
 _handleEvent(e, replay, inChartArea) {
        const { _active: lastActive = [] , options  } = this;
        const useFinalPosition = replay;
        const active = this._getActiveElements(e, lastActive, inChartArea, useFinalPosition);
        const isClick = _isClickEvent(e);
        const lastEvent = determineLastEvent(e, this._lastEvent, inChartArea, isClick);
        if (inChartArea) {
            this._lastEvent = null;
            callback(options.onHover, [
                e,
                active,
                this
            ], this);
            if (isClick) {
                callback(options.onClick, [
                    e,
                    active,
                    this
                ], this);
            }
        }
        const changed = !_elementsEqual(active, lastActive);
        if (changed || replay) {
            this._active = active;
            this._updateHoverStyles(active, lastActive, replay);
        }
        this._lastEvent = lastEvent;
        return changed;
    }
 _getActiveElements(e, lastActive, inChartArea, useFinalPosition) {
        if (e.type === 'mouseout') {
            return [];
        }
        if (!inChartArea) {
            return lastActive;
        }
        const hoverOptions = this.options.hover;
        return this.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions, useFinalPosition);
    }
}
function invalidatePlugins() {
    return each(Chart.instances, (chart)=>chart._plugins.invalidate());
}

function clipSelf(ctx, element, endAngle) {
    const { startAngle , x , y , outerRadius , innerRadius , options  } = element;
    const { borderWidth , borderJoinStyle  } = options;
    const outerAngleClip = Math.min(borderWidth / outerRadius, _normalizeAngle(startAngle - endAngle));
    ctx.beginPath();
    ctx.arc(x, y, outerRadius - borderWidth / 2, startAngle + outerAngleClip / 2, endAngle - outerAngleClip / 2);
    if (innerRadius > 0) {
        const innerAngleClip = Math.min(borderWidth / innerRadius, _normalizeAngle(startAngle - endAngle));
        ctx.arc(x, y, innerRadius + borderWidth / 2, endAngle - innerAngleClip / 2, startAngle + innerAngleClip / 2, true);
    } else {
        const clipWidth = Math.min(borderWidth / 2, outerRadius * _normalizeAngle(startAngle - endAngle));
        if (borderJoinStyle === 'round') {
            ctx.arc(x, y, clipWidth, endAngle - PI / 2, startAngle + PI / 2, true);
        } else if (borderJoinStyle === 'bevel') {
            const r = 2 * clipWidth * clipWidth;
            const endX = -r * Math.cos(endAngle + PI / 2) + x;
            const endY = -r * Math.sin(endAngle + PI / 2) + y;
            const startX = r * Math.cos(startAngle + PI / 2) + x;
            const startY = r * Math.sin(startAngle + PI / 2) + y;
            ctx.lineTo(endX, endY);
            ctx.lineTo(startX, startY);
        }
    }
    ctx.closePath();
    ctx.moveTo(0, 0);
    ctx.rect(0, 0, ctx.canvas.width, ctx.canvas.height);
    ctx.clip('evenodd');
}
function clipArc(ctx, element, endAngle) {
    const { startAngle , pixelMargin , x , y , outerRadius , innerRadius  } = element;
    let angleMargin = pixelMargin / outerRadius;
    // Draw an inner border by clipping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (innerRadius > pixelMargin) {
        angleMargin = pixelMargin / innerRadius;
        ctx.arc(x, y, innerRadius, endAngle + angleMargin, startAngle - angleMargin, true);
    } else {
        ctx.arc(x, y, pixelMargin, endAngle + HALF_PI, startAngle - HALF_PI);
    }
    ctx.closePath();
    ctx.clip();
}
function toRadiusCorners(value) {
    return _readValueToProps(value, [
        'outerStart',
        'outerEnd',
        'innerStart',
        'innerEnd'
    ]);
}
/**
 * Parse border radius from the provided options
 */ function parseBorderRadius$1(arc, innerRadius, outerRadius, angleDelta) {
    const o = toRadiusCorners(arc.options.borderRadius);
    const halfThickness = (outerRadius - innerRadius) / 2;
    const innerLimit = Math.min(halfThickness, angleDelta * innerRadius / 2);
    // Outer limits are complicated. We want to compute the available angular distance at
    // a radius of outerRadius - borderRadius because for small angular distances, this term limits.
    // We compute at r = outerRadius - borderRadius because this circle defines the center of the border corners.
    //
    // If the borderRadius is large, that value can become negative.
    // This causes the outer borders to lose their radius entirely, which is rather unexpected. To solve that, if borderRadius > outerRadius
    // we know that the thickness term will dominate and compute the limits at that point
    const computeOuterLimit = (val)=>{
        const outerArcLimit = (outerRadius - Math.min(halfThickness, val)) * angleDelta / 2;
        return _limitValue(val, 0, Math.min(halfThickness, outerArcLimit));
    };
    return {
        outerStart: computeOuterLimit(o.outerStart),
        outerEnd: computeOuterLimit(o.outerEnd),
        innerStart: _limitValue(o.innerStart, 0, innerLimit),
        innerEnd: _limitValue(o.innerEnd, 0, innerLimit)
    };
}
/**
 * Convert (r, 𝜃) to (x, y)
 */ function rThetaToXY(r, theta, x, y) {
    return {
        x: x + r * Math.cos(theta),
        y: y + r * Math.sin(theta)
    };
}
/**
 * Path the arc, respecting border radius by separating into left and right halves.
 *
 *   Start      End
 *
 *    1--->a--->2    Outer
 *   /           \
 *   8           3
 *   |           |
 *   |           |
 *   7           4
 *   \           /
 *    6<---b<---5    Inner
 */ function pathArc(ctx, element, offset, spacing, end, circular) {
    const { x , y , startAngle: start , pixelMargin , innerRadius: innerR  } = element;
    const outerRadius = Math.max(element.outerRadius + spacing + offset - pixelMargin, 0);
    const innerRadius = innerR > 0 ? innerR + spacing + offset + pixelMargin : 0;
    let spacingOffset = 0;
    const alpha = end - start;
    if (spacing) {
        // When spacing is present, it is the same for all items
        // So we adjust the start and end angle of the arc such that
        // the distance is the same as it would be without the spacing
        const noSpacingInnerRadius = innerR > 0 ? innerR - spacing : 0;
        const noSpacingOuterRadius = outerRadius > 0 ? outerRadius - spacing : 0;
        const avNogSpacingRadius = (noSpacingInnerRadius + noSpacingOuterRadius) / 2;
        const adjustedAngle = avNogSpacingRadius !== 0 ? alpha * avNogSpacingRadius / (avNogSpacingRadius + spacing) : alpha;
        spacingOffset = (alpha - adjustedAngle) / 2;
    }
    const beta = Math.max(0.001, alpha * outerRadius - offset / PI) / outerRadius;
    const angleOffset = (alpha - beta) / 2;
    const startAngle = start + angleOffset + spacingOffset;
    const endAngle = end - angleOffset - spacingOffset;
    const { outerStart , outerEnd , innerStart , innerEnd  } = parseBorderRadius$1(element, innerRadius, outerRadius, endAngle - startAngle);
    const outerStartAdjustedRadius = outerRadius - outerStart;
    const outerEndAdjustedRadius = outerRadius - outerEnd;
    const outerStartAdjustedAngle = startAngle + outerStart / outerStartAdjustedRadius;
    const outerEndAdjustedAngle = endAngle - outerEnd / outerEndAdjustedRadius;
    const innerStartAdjustedRadius = innerRadius + innerStart;
    const innerEndAdjustedRadius = innerRadius + innerEnd;
    const innerStartAdjustedAngle = startAngle + innerStart / innerStartAdjustedRadius;
    const innerEndAdjustedAngle = endAngle - innerEnd / innerEndAdjustedRadius;
    ctx.beginPath();
    if (circular) {
        // The first arc segments from point 1 to point a to point 2
        const outerMidAdjustedAngle = (outerStartAdjustedAngle + outerEndAdjustedAngle) / 2;
        ctx.arc(x, y, outerRadius, outerStartAdjustedAngle, outerMidAdjustedAngle);
        ctx.arc(x, y, outerRadius, outerMidAdjustedAngle, outerEndAdjustedAngle);
        // The corner segment from point 2 to point 3
        if (outerEnd > 0) {
            const pCenter = rThetaToXY(outerEndAdjustedRadius, outerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerEnd, outerEndAdjustedAngle, endAngle + HALF_PI);
        }
        // The line from point 3 to point 4
        const p4 = rThetaToXY(innerEndAdjustedRadius, endAngle, x, y);
        ctx.lineTo(p4.x, p4.y);
        // The corner segment from point 4 to point 5
        if (innerEnd > 0) {
            const pCenter = rThetaToXY(innerEndAdjustedRadius, innerEndAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerEnd, endAngle + HALF_PI, innerEndAdjustedAngle + Math.PI);
        }
        // The inner arc from point 5 to point b to point 6
        const innerMidAdjustedAngle = (endAngle - innerEnd / innerRadius + (startAngle + innerStart / innerRadius)) / 2;
        ctx.arc(x, y, innerRadius, endAngle - innerEnd / innerRadius, innerMidAdjustedAngle, true);
        ctx.arc(x, y, innerRadius, innerMidAdjustedAngle, startAngle + innerStart / innerRadius, true);
        // The corner segment from point 6 to point 7
        if (innerStart > 0) {
            const pCenter = rThetaToXY(innerStartAdjustedRadius, innerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, innerStart, innerStartAdjustedAngle + Math.PI, startAngle - HALF_PI);
        }
        // The line from point 7 to point 8
        const p8 = rThetaToXY(outerStartAdjustedRadius, startAngle, x, y);
        ctx.lineTo(p8.x, p8.y);
        // The corner segment from point 8 to point 1
        if (outerStart > 0) {
            const pCenter = rThetaToXY(outerStartAdjustedRadius, outerStartAdjustedAngle, x, y);
            ctx.arc(pCenter.x, pCenter.y, outerStart, startAngle - HALF_PI, outerStartAdjustedAngle);
        }
    } else {
        ctx.moveTo(x, y);
        const outerStartX = Math.cos(outerStartAdjustedAngle) * outerRadius + x;
        const outerStartY = Math.sin(outerStartAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerStartX, outerStartY);
        const outerEndX = Math.cos(outerEndAdjustedAngle) * outerRadius + x;
        const outerEndY = Math.sin(outerEndAdjustedAngle) * outerRadius + y;
        ctx.lineTo(outerEndX, outerEndY);
    }
    ctx.closePath();
}
function drawArc(ctx, element, offset, spacing, circular) {
    const { fullCircles , startAngle , circumference  } = element;
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i){
            ctx.fill();
        }
        if (!isNaN(circumference)) {
            endAngle = startAngle + (circumference % TAU || TAU);
        }
    }
    pathArc(ctx, element, offset, spacing, endAngle, circular);
    ctx.fill();
    return endAngle;
}
function drawBorder(ctx, element, offset, spacing, circular) {
    const { fullCircles , startAngle , circumference , options  } = element;
    const { borderWidth , borderJoinStyle , borderDash , borderDashOffset , borderRadius  } = options;
    const inner = options.borderAlign === 'inner';
    if (!borderWidth) {
        return;
    }
    ctx.setLineDash(borderDash || []);
    ctx.lineDashOffset = borderDashOffset;
    if (inner) {
        ctx.lineWidth = borderWidth * 2;
        ctx.lineJoin = borderJoinStyle || 'round';
    } else {
        ctx.lineWidth = borderWidth;
        ctx.lineJoin = borderJoinStyle || 'bevel';
    }
    let endAngle = element.endAngle;
    if (fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        for(let i = 0; i < fullCircles; ++i){
            ctx.stroke();
        }
        if (!isNaN(circumference)) {
            endAngle = startAngle + (circumference % TAU || TAU);
        }
    }
    if (inner) {
        clipArc(ctx, element, endAngle);
    }
    if (options.selfJoin && endAngle - startAngle >= PI && borderRadius === 0 && borderJoinStyle !== 'miter') {
        clipSelf(ctx, element, endAngle);
    }
    if (!fullCircles) {
        pathArc(ctx, element, offset, spacing, endAngle, circular);
        ctx.stroke();
    }
}
class ArcElement extends Element {
    static id = 'arc';
    static defaults = {
        borderAlign: 'center',
        borderColor: '#fff',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: undefined,
        borderRadius: 0,
        borderWidth: 2,
        offset: 0,
        spacing: 0,
        angle: undefined,
        circular: true,
        selfJoin: false
    };
    static defaultRoutes = {
        backgroundColor: 'backgroundColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash'
    };
    circumference;
    endAngle;
    fullCircles;
    innerRadius;
    outerRadius;
    pixelMargin;
    startAngle;
    constructor(cfg){
        super();
        this.options = undefined;
        this.circumference = undefined;
        this.startAngle = undefined;
        this.endAngle = undefined;
        this.innerRadius = undefined;
        this.outerRadius = undefined;
        this.pixelMargin = 0;
        this.fullCircles = 0;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    inRange(chartX, chartY, useFinalPosition) {
        const point = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        const { angle , distance  } = getAngleFromPoint(point, {
            x: chartX,
            y: chartY
        });
        const { startAngle , endAngle , innerRadius , outerRadius , circumference  } = this.getProps([
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius',
            'circumference'
        ], useFinalPosition);
        const rAdjust = (this.options.spacing + this.options.borderWidth) / 2;
        const _circumference = valueOrDefault(circumference, endAngle - startAngle);
        const nonZeroBetween = _angleBetween(angle, startAngle, endAngle) && startAngle !== endAngle;
        const betweenAngles = _circumference >= TAU || nonZeroBetween;
        const withinRadius = _isBetween(distance, innerRadius + rAdjust, outerRadius + rAdjust);
        return betweenAngles && withinRadius;
    }
    getCenterPoint(useFinalPosition) {
        const { x , y , startAngle , endAngle , innerRadius , outerRadius  } = this.getProps([
            'x',
            'y',
            'startAngle',
            'endAngle',
            'innerRadius',
            'outerRadius'
        ], useFinalPosition);
        const { offset , spacing  } = this.options;
        const halfAngle = (startAngle + endAngle) / 2;
        const halfRadius = (innerRadius + outerRadius + spacing + offset) / 2;
        return {
            x: x + Math.cos(halfAngle) * halfRadius,
            y: y + Math.sin(halfAngle) * halfRadius
        };
    }
    tooltipPosition(useFinalPosition) {
        return this.getCenterPoint(useFinalPosition);
    }
    draw(ctx) {
        const { options , circumference  } = this;
        const offset = (options.offset || 0) / 4;
        const spacing = (options.spacing || 0) / 2;
        const circular = options.circular;
        this.pixelMargin = options.borderAlign === 'inner' ? 0.33 : 0;
        this.fullCircles = circumference > TAU ? Math.floor(circumference / TAU) : 0;
        if (circumference === 0 || this.innerRadius < 0 || this.outerRadius < 0) {
            return;
        }
        ctx.save();
        const halfAngle = (this.startAngle + this.endAngle) / 2;
        ctx.translate(Math.cos(halfAngle) * offset, Math.sin(halfAngle) * offset);
        const fix = 1 - Math.sin(Math.min(PI, circumference || 0));
        const radiusOffset = offset * fix;
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        drawArc(ctx, this, radiusOffset, spacing, circular);
        drawBorder(ctx, this, radiusOffset, spacing, circular);
        ctx.restore();
    }
}

function setStyle(ctx, options, style = options) {
    ctx.lineCap = valueOrDefault(style.borderCapStyle, options.borderCapStyle);
    ctx.setLineDash(valueOrDefault(style.borderDash, options.borderDash));
    ctx.lineDashOffset = valueOrDefault(style.borderDashOffset, options.borderDashOffset);
    ctx.lineJoin = valueOrDefault(style.borderJoinStyle, options.borderJoinStyle);
    ctx.lineWidth = valueOrDefault(style.borderWidth, options.borderWidth);
    ctx.strokeStyle = valueOrDefault(style.borderColor, options.borderColor);
}
function lineTo(ctx, previous, target) {
    ctx.lineTo(target.x, target.y);
}
 function getLineMethod(options) {
    if (options.stepped) {
        return _steppedLineTo;
    }
    if (options.tension || options.cubicInterpolationMode === 'monotone') {
        return _bezierCurveTo;
    }
    return lineTo;
}
function pathVars(points, segment, params = {}) {
    const count = points.length;
    const { start: paramsStart = 0 , end: paramsEnd = count - 1  } = params;
    const { start: segmentStart , end: segmentEnd  } = segment;
    const start = Math.max(paramsStart, segmentStart);
    const end = Math.min(paramsEnd, segmentEnd);
    const outside = paramsStart < segmentStart && paramsEnd < segmentStart || paramsStart > segmentEnd && paramsEnd > segmentEnd;
    return {
        count,
        start,
        loop: segment.loop,
        ilen: end < start && !outside ? count + end - start : end - start
    };
}
 function pathSegment(ctx, line, segment, params) {
    const { points , options  } = line;
    const { count , start , loop , ilen  } = pathVars(points, segment, params);
    const lineMethod = getLineMethod(options);
    let { move =true , reverse  } = params || {};
    let i, point, prev;
    for(i = 0; i <= ilen; ++i){
        point = points[(start + (reverse ? ilen - i : i)) % count];
        if (point.skip) {
            continue;
        } else if (move) {
            ctx.moveTo(point.x, point.y);
            move = false;
        } else {
            lineMethod(ctx, prev, point, reverse, options.stepped);
        }
        prev = point;
    }
    if (loop) {
        point = points[(start + (reverse ? ilen : 0)) % count];
        lineMethod(ctx, prev, point, reverse, options.stepped);
    }
    return !!loop;
}
 function fastPathSegment(ctx, line, segment, params) {
    const points = line.points;
    const { count , start , ilen  } = pathVars(points, segment, params);
    const { move =true , reverse  } = params || {};
    let avgX = 0;
    let countX = 0;
    let i, point, prevX, minY, maxY, lastY;
    const pointIndex = (index)=>(start + (reverse ? ilen - index : index)) % count;
    const drawX = ()=>{
        if (minY !== maxY) {
            ctx.lineTo(avgX, maxY);
            ctx.lineTo(avgX, minY);
            ctx.lineTo(avgX, lastY);
        }
    };
    if (move) {
        point = points[pointIndex(0)];
        ctx.moveTo(point.x, point.y);
    }
    for(i = 0; i <= ilen; ++i){
        point = points[pointIndex(i)];
        if (point.skip) {
            continue;
        }
        const x = point.x;
        const y = point.y;
        const truncX = x | 0;
        if (truncX === prevX) {
            if (y < minY) {
                minY = y;
            } else if (y > maxY) {
                maxY = y;
            }
            avgX = (countX * avgX + x) / ++countX;
        } else {
            drawX();
            ctx.lineTo(x, y);
            prevX = truncX;
            countX = 0;
            minY = maxY = y;
        }
        lastY = y;
    }
    drawX();
}
 function _getSegmentMethod(line) {
    const opts = line.options;
    const borderDash = opts.borderDash && opts.borderDash.length;
    const useFastPath = !line._decimated && !line._loop && !opts.tension && opts.cubicInterpolationMode !== 'monotone' && !opts.stepped && !borderDash;
    return useFastPath ? fastPathSegment : pathSegment;
}
 function _getInterpolationMethod(options) {
    if (options.stepped) {
        return _steppedInterpolation;
    }
    if (options.tension || options.cubicInterpolationMode === 'monotone') {
        return _bezierInterpolation;
    }
    return _pointInLine;
}
function strokePathWithCache(ctx, line, start, count) {
    let path = line._path;
    if (!path) {
        path = line._path = new Path2D();
        if (line.path(path, start, count)) {
            path.closePath();
        }
    }
    setStyle(ctx, line.options);
    ctx.stroke(path);
}
function strokePathDirect(ctx, line, start, count) {
    const { segments , options  } = line;
    const segmentMethod = _getSegmentMethod(line);
    for (const segment of segments){
        setStyle(ctx, options, segment.style);
        ctx.beginPath();
        if (segmentMethod(ctx, line, segment, {
            start,
            end: start + count - 1
        })) {
            ctx.closePath();
        }
        ctx.stroke();
    }
}
const usePath2D = typeof Path2D === 'function';
function draw(ctx, line, start, count) {
    if (usePath2D && !line.options.segment) {
        strokePathWithCache(ctx, line, start, count);
    } else {
        strokePathDirect(ctx, line, start, count);
    }
}
class LineElement extends Element {
    static id = 'line';
 static defaults = {
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0,
        borderJoinStyle: 'miter',
        borderWidth: 3,
        capBezierPoints: true,
        cubicInterpolationMode: 'default',
        fill: false,
        spanGaps: false,
        stepped: false,
        tension: 0
    };
 static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    static descriptors = {
        _scriptable: true,
        _indexable: (name)=>name !== 'borderDash' && name !== 'fill'
    };
    constructor(cfg){
        super();
        this.animated = true;
        this.options = undefined;
        this._chart = undefined;
        this._loop = undefined;
        this._fullLoop = undefined;
        this._path = undefined;
        this._points = undefined;
        this._segments = undefined;
        this._decimated = false;
        this._pointsUpdated = false;
        this._datasetIndex = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    updateControlPoints(chartArea, indexAxis) {
        const options = this.options;
        if ((options.tension || options.cubicInterpolationMode === 'monotone') && !options.stepped && !this._pointsUpdated) {
            const loop = options.spanGaps ? this._loop : this._fullLoop;
            _updateBezierControlPoints(this._points, options, chartArea, loop, indexAxis);
            this._pointsUpdated = true;
        }
    }
    set points(points) {
        this._points = points;
        delete this._segments;
        delete this._path;
        this._pointsUpdated = false;
    }
    get points() {
        return this._points;
    }
    get segments() {
        return this._segments || (this._segments = _computeSegments(this, this.options.segment));
    }
 first() {
        const segments = this.segments;
        const points = this.points;
        return segments.length && points[segments[0].start];
    }
 last() {
        const segments = this.segments;
        const points = this.points;
        const count = segments.length;
        return count && points[segments[count - 1].end];
    }
 interpolate(point, property) {
        const options = this.options;
        const value = point[property];
        const points = this.points;
        const segments = _boundSegments(this, {
            property,
            start: value,
            end: value
        });
        if (!segments.length) {
            return;
        }
        const result = [];
        const _interpolate = _getInterpolationMethod(options);
        let i, ilen;
        for(i = 0, ilen = segments.length; i < ilen; ++i){
            const { start , end  } = segments[i];
            const p1 = points[start];
            const p2 = points[end];
            if (p1 === p2) {
                result.push(p1);
                continue;
            }
            const t = Math.abs((value - p1[property]) / (p2[property] - p1[property]));
            const interpolated = _interpolate(p1, p2, t, options.stepped);
            interpolated[property] = point[property];
            result.push(interpolated);
        }
        return result.length === 1 ? result[0] : result;
    }
 pathSegment(ctx, segment, params) {
        const segmentMethod = _getSegmentMethod(this);
        return segmentMethod(ctx, this, segment, params);
    }
 path(ctx, start, count) {
        const segments = this.segments;
        const segmentMethod = _getSegmentMethod(this);
        let loop = this._loop;
        start = start || 0;
        count = count || this.points.length - start;
        for (const segment of segments){
            loop &= segmentMethod(ctx, this, segment, {
                start,
                end: start + count - 1
            });
        }
        return !!loop;
    }
 draw(ctx, chartArea, start, count) {
        const options = this.options || {};
        const points = this.points || [];
        if (points.length && options.borderWidth) {
            ctx.save();
            draw(ctx, this, start, count);
            ctx.restore();
        }
        if (this.animated) {
            this._pointsUpdated = false;
            this._path = undefined;
        }
    }
}

function inRange$1(el, pos, axis, useFinalPosition) {
    const options = el.options;
    const { [axis]: value  } = el.getProps([
        axis
    ], useFinalPosition);
    return Math.abs(pos - value) < options.radius + options.hitRadius;
}
class PointElement extends Element {
    static id = 'point';
    parsed;
    skip;
    stop;
    /**
   * @type {any}
   */ static defaults = {
        borderWidth: 1,
        hitRadius: 1,
        hoverBorderWidth: 1,
        hoverRadius: 4,
        pointStyle: 'circle',
        radius: 3,
        rotation: 0
    };
    /**
   * @type {any}
   */ static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.parsed = undefined;
        this.skip = undefined;
        this.stop = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        const options = this.options;
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return Math.pow(mouseX - x, 2) + Math.pow(mouseY - y, 2) < Math.pow(options.hitRadius + options.radius, 2);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange$1(this, mouseX, 'x', useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange$1(this, mouseY, 'y', useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x , y  } = this.getProps([
            'x',
            'y'
        ], useFinalPosition);
        return {
            x,
            y
        };
    }
    size(options) {
        options = options || this.options || {};
        let radius = options.radius || 0;
        radius = Math.max(radius, radius && options.hoverRadius || 0);
        const borderWidth = radius && options.borderWidth || 0;
        return (radius + borderWidth) * 2;
    }
    draw(ctx, area) {
        const options = this.options;
        if (this.skip || options.radius < 0.1 || !_isPointInArea(this, area, this.size(options) / 2)) {
            return;
        }
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.fillStyle = options.backgroundColor;
        drawPoint(ctx, options, this.x, this.y);
    }
    getRange() {
        const options = this.options || {};
        // @ts-expect-error Fallbacks should never be hit in practice
        return options.radius + options.hitRadius;
    }
}

function getBarBounds(bar, useFinalPosition) {
    const { x , y , base , width , height  } =  bar.getProps([
        'x',
        'y',
        'base',
        'width',
        'height'
    ], useFinalPosition);
    let left, right, top, bottom, half;
    if (bar.horizontal) {
        half = height / 2;
        left = Math.min(x, base);
        right = Math.max(x, base);
        top = y - half;
        bottom = y + half;
    } else {
        half = width / 2;
        left = x - half;
        right = x + half;
        top = Math.min(y, base);
        bottom = Math.max(y, base);
    }
    return {
        left,
        top,
        right,
        bottom
    };
}
function skipOrLimit(skip, value, min, max) {
    return skip ? 0 : _limitValue(value, min, max);
}
function parseBorderWidth(bar, maxW, maxH) {
    const value = bar.options.borderWidth;
    const skip = bar.borderSkipped;
    const o = toTRBL(value);
    return {
        t: skipOrLimit(skip.top, o.top, 0, maxH),
        r: skipOrLimit(skip.right, o.right, 0, maxW),
        b: skipOrLimit(skip.bottom, o.bottom, 0, maxH),
        l: skipOrLimit(skip.left, o.left, 0, maxW)
    };
}
function parseBorderRadius(bar, maxW, maxH) {
    const { enableBorderRadius  } = bar.getProps([
        'enableBorderRadius'
    ]);
    const value = bar.options.borderRadius;
    const o = toTRBLCorners(value);
    const maxR = Math.min(maxW, maxH);
    const skip = bar.borderSkipped;
    const enableBorder = enableBorderRadius || isObject(value);
    return {
        topLeft: skipOrLimit(!enableBorder || skip.top || skip.left, o.topLeft, 0, maxR),
        topRight: skipOrLimit(!enableBorder || skip.top || skip.right, o.topRight, 0, maxR),
        bottomLeft: skipOrLimit(!enableBorder || skip.bottom || skip.left, o.bottomLeft, 0, maxR),
        bottomRight: skipOrLimit(!enableBorder || skip.bottom || skip.right, o.bottomRight, 0, maxR)
    };
}
function boundingRects(bar) {
    const bounds = getBarBounds(bar);
    const width = bounds.right - bounds.left;
    const height = bounds.bottom - bounds.top;
    const border = parseBorderWidth(bar, width / 2, height / 2);
    const radius = parseBorderRadius(bar, width / 2, height / 2);
    return {
        outer: {
            x: bounds.left,
            y: bounds.top,
            w: width,
            h: height,
            radius
        },
        inner: {
            x: bounds.left + border.l,
            y: bounds.top + border.t,
            w: width - border.l - border.r,
            h: height - border.t - border.b,
            radius: {
                topLeft: Math.max(0, radius.topLeft - Math.max(border.t, border.l)),
                topRight: Math.max(0, radius.topRight - Math.max(border.t, border.r)),
                bottomLeft: Math.max(0, radius.bottomLeft - Math.max(border.b, border.l)),
                bottomRight: Math.max(0, radius.bottomRight - Math.max(border.b, border.r))
            }
        }
    };
}
function inRange(bar, x, y, useFinalPosition) {
    const skipX = x === null;
    const skipY = y === null;
    const skipBoth = skipX && skipY;
    const bounds = bar && !skipBoth && getBarBounds(bar, useFinalPosition);
    return bounds && (skipX || _isBetween(x, bounds.left, bounds.right)) && (skipY || _isBetween(y, bounds.top, bounds.bottom));
}
function hasRadius(radius) {
    return radius.topLeft || radius.topRight || radius.bottomLeft || radius.bottomRight;
}
 function addNormalRectPath(ctx, rect) {
    ctx.rect(rect.x, rect.y, rect.w, rect.h);
}
function inflateRect(rect, amount, refRect = {}) {
    const x = rect.x !== refRect.x ? -amount : 0;
    const y = rect.y !== refRect.y ? -amount : 0;
    const w = (rect.x + rect.w !== refRect.x + refRect.w ? amount : 0) - x;
    const h = (rect.y + rect.h !== refRect.y + refRect.h ? amount : 0) - y;
    return {
        x: rect.x + x,
        y: rect.y + y,
        w: rect.w + w,
        h: rect.h + h,
        radius: rect.radius
    };
}
class BarElement extends Element {
    static id = 'bar';
 static defaults = {
        borderSkipped: 'start',
        borderWidth: 0,
        borderRadius: 0,
        inflateAmount: 'auto',
        pointStyle: undefined
    };
 static defaultRoutes = {
        backgroundColor: 'backgroundColor',
        borderColor: 'borderColor'
    };
    constructor(cfg){
        super();
        this.options = undefined;
        this.horizontal = undefined;
        this.base = undefined;
        this.width = undefined;
        this.height = undefined;
        this.inflateAmount = undefined;
        if (cfg) {
            Object.assign(this, cfg);
        }
    }
    draw(ctx) {
        const { inflateAmount , options: { borderColor , backgroundColor  }  } = this;
        const { inner , outer  } = boundingRects(this);
        const addRectPath = hasRadius(outer.radius) ? addRoundedRectPath : addNormalRectPath;
        ctx.save();
        if (outer.w !== inner.w || outer.h !== inner.h) {
            ctx.beginPath();
            addRectPath(ctx, inflateRect(outer, inflateAmount, inner));
            ctx.clip();
            addRectPath(ctx, inflateRect(inner, -inflateAmount, outer));
            ctx.fillStyle = borderColor;
            ctx.fill('evenodd');
        }
        ctx.beginPath();
        addRectPath(ctx, inflateRect(inner, inflateAmount));
        ctx.fillStyle = backgroundColor;
        ctx.fill();
        ctx.restore();
    }
    inRange(mouseX, mouseY, useFinalPosition) {
        return inRange(this, mouseX, mouseY, useFinalPosition);
    }
    inXRange(mouseX, useFinalPosition) {
        return inRange(this, mouseX, null, useFinalPosition);
    }
    inYRange(mouseY, useFinalPosition) {
        return inRange(this, null, mouseY, useFinalPosition);
    }
    getCenterPoint(useFinalPosition) {
        const { x , y , base , horizontal  } =  this.getProps([
            'x',
            'y',
            'base',
            'horizontal'
        ], useFinalPosition);
        return {
            x: horizontal ? (x + base) / 2 : x,
            y: horizontal ? y : (y + base) / 2
        };
    }
    getRange(axis) {
        return axis === 'x' ? this.width / 2 : this.height / 2;
    }
}

function _segments(line, target, property) {
    const segments = line.segments;
    const points = line.points;
    const tpoints = target.points;
    const parts = [];
    for (const segment of segments){
        let { start , end  } = segment;
        end = _findSegmentEnd(start, end, points);
        const bounds = _getBounds(property, points[start], points[end], segment.loop);
        if (!target.segments) {
            parts.push({
                source: segment,
                target: bounds,
                start: points[start],
                end: points[end]
            });
            continue;
        }
        const targetSegments = _boundSegments(target, bounds);
        for (const tgt of targetSegments){
            const subBounds = _getBounds(property, tpoints[tgt.start], tpoints[tgt.end], tgt.loop);
            const fillSources = _boundSegment(segment, points, subBounds);
            for (const fillSource of fillSources){
                parts.push({
                    source: fillSource,
                    target: tgt,
                    start: {
                        [property]: _getEdge(bounds, subBounds, 'start', Math.max)
                    },
                    end: {
                        [property]: _getEdge(bounds, subBounds, 'end', Math.min)
                    }
                });
            }
        }
    }
    return parts;
}
function _getBounds(property, first, last, loop) {
    if (loop) {
        return;
    }
    let start = first[property];
    let end = last[property];
    if (property === 'angle') {
        start = _normalizeAngle(start);
        end = _normalizeAngle(end);
    }
    return {
        property,
        start,
        end
    };
}
function _pointsFromSegments(boundary, line) {
    const { x =null , y =null  } = boundary || {};
    const linePoints = line.points;
    const points = [];
    line.segments.forEach(({ start , end  })=>{
        end = _findSegmentEnd(start, end, linePoints);
        const first = linePoints[start];
        const last = linePoints[end];
        if (y !== null) {
            points.push({
                x: first.x,
                y
            });
            points.push({
                x: last.x,
                y
            });
        } else if (x !== null) {
            points.push({
                x,
                y: first.y
            });
            points.push({
                x,
                y: last.y
            });
        }
    });
    return points;
}
function _findSegmentEnd(start, end, points) {
    for(; end > start; end--){
        const point = points[end];
        if (!isNaN(point.x) && !isNaN(point.y)) {
            break;
        }
    }
    return end;
}
function _getEdge(a, b, prop, fn) {
    if (a && b) {
        return fn(a[prop], b[prop]);
    }
    return a ? a[prop] : b ? b[prop] : 0;
}

function _createBoundaryLine(boundary, line) {
    let points = [];
    let _loop = false;
    if (isArray(boundary)) {
        _loop = true;
        points = boundary;
    } else {
        points = _pointsFromSegments(boundary, line);
    }
    return points.length ? new LineElement({
        points,
        options: {
            tension: 0
        },
        _loop,
        _fullLoop: _loop
    }) : null;
}
function _shouldApplyFill(source) {
    return source && source.fill !== false;
}

function _resolveTarget(sources, index, propagate) {
    const source = sources[index];
    let fill = source.fill;
    const visited = [
        index
    ];
    let target;
    if (!propagate) {
        return fill;
    }
    while(fill !== false && visited.indexOf(fill) === -1){
        if (!isNumberFinite(fill)) {
            return fill;
        }
        target = sources[fill];
        if (!target) {
            return false;
        }
        if (target.visible) {
            return fill;
        }
        visited.push(fill);
        fill = target.fill;
    }
    return false;
}
 function _decodeFill(line, index, count) {
     const fill = parseFillOption(line);
    if (isObject(fill)) {
        return isNaN(fill.value) ? false : fill;
    }
    let target = parseFloat(fill);
    if (isNumberFinite(target) && Math.floor(target) === target) {
        return decodeTargetIndex(fill[0], index, target, count);
    }
    return [
        'origin',
        'start',
        'end',
        'stack',
        'shape'
    ].indexOf(fill) >= 0 && fill;
}
function decodeTargetIndex(firstCh, index, target, count) {
    if (firstCh === '-' || firstCh === '+') {
        target = index + target;
    }
    if (target === index || target < 0 || target >= count) {
        return false;
    }
    return target;
}
 function _getTargetPixel(fill, scale) {
    let pixel = null;
    if (fill === 'start') {
        pixel = scale.bottom;
    } else if (fill === 'end') {
        pixel = scale.top;
    } else if (isObject(fill)) {
        pixel = scale.getPixelForValue(fill.value);
    } else if (scale.getBasePixel) {
        pixel = scale.getBasePixel();
    }
    return pixel;
}
 function _getTargetValue(fill, scale, startValue) {
    let value;
    if (fill === 'start') {
        value = startValue;
    } else if (fill === 'end') {
        value = scale.options.reverse ? scale.min : scale.max;
    } else if (isObject(fill)) {
        value = fill.value;
    } else {
        value = scale.getBaseValue();
    }
    return value;
}
 function parseFillOption(line) {
    const options = line.options;
    const fillOption = options.fill;
    let fill = valueOrDefault(fillOption && fillOption.target, fillOption);
    if (fill === undefined) {
        fill = !!options.backgroundColor;
    }
    if (fill === false || fill === null) {
        return false;
    }
    if (fill === true) {
        return 'origin';
    }
    return fill;
}

function _buildStackLine(source) {
    const { scale , index , line  } = source;
    const points = [];
    const segments = line.segments;
    const sourcePoints = line.points;
    const linesBelow = getLinesBelow(scale, index);
    linesBelow.push(_createBoundaryLine({
        x: null,
        y: scale.bottom
    }, line));
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        for(let j = segment.start; j <= segment.end; j++){
            addPointsBelow(points, sourcePoints[j], linesBelow);
        }
    }
    return new LineElement({
        points,
        options: {}
    });
}
 function getLinesBelow(scale, index) {
    const below = [];
    const metas = scale.getMatchingVisibleMetas('line');
    for(let i = 0; i < metas.length; i++){
        const meta = metas[i];
        if (meta.index === index) {
            break;
        }
        if (!meta.hidden) {
            below.unshift(meta.dataset);
        }
    }
    return below;
}
 function addPointsBelow(points, sourcePoint, linesBelow) {
    const postponed = [];
    for(let j = 0; j < linesBelow.length; j++){
        const line = linesBelow[j];
        const { first , last , point  } = findPoint(line, sourcePoint, 'x');
        if (!point || first && last) {
            continue;
        }
        if (first) {
            postponed.unshift(point);
        } else {
            points.push(point);
            if (!last) {
                break;
            }
        }
    }
    points.push(...postponed);
}
 function findPoint(line, sourcePoint, property) {
    const point = line.interpolate(sourcePoint, property);
    if (!point) {
        return {};
    }
    const pointValue = point[property];
    const segments = line.segments;
    const linePoints = line.points;
    let first = false;
    let last = false;
    for(let i = 0; i < segments.length; i++){
        const segment = segments[i];
        const firstValue = linePoints[segment.start][property];
        const lastValue = linePoints[segment.end][property];
        if (_isBetween(pointValue, firstValue, lastValue)) {
            first = pointValue === firstValue;
            last = pointValue === lastValue;
            break;
        }
    }
    return {
        first,
        last,
        point
    };
}

class simpleArc {
    constructor(opts){
        this.x = opts.x;
        this.y = opts.y;
        this.radius = opts.radius;
    }
    pathSegment(ctx, bounds, opts) {
        const { x , y , radius  } = this;
        bounds = bounds || {
            start: 0,
            end: TAU
        };
        ctx.arc(x, y, radius, bounds.end, bounds.start, true);
        return !opts.bounds;
    }
    interpolate(point) {
        const { x , y , radius  } = this;
        const angle = point.angle;
        return {
            x: x + Math.cos(angle) * radius,
            y: y + Math.sin(angle) * radius,
            angle
        };
    }
}

function _getTarget(source) {
    const { chart , fill , line  } = source;
    if (isNumberFinite(fill)) {
        return getLineByIndex(chart, fill);
    }
    if (fill === 'stack') {
        return _buildStackLine(source);
    }
    if (fill === 'shape') {
        return true;
    }
    const boundary = computeBoundary(source);
    if (boundary instanceof simpleArc) {
        return boundary;
    }
    return _createBoundaryLine(boundary, line);
}
 function getLineByIndex(chart, index) {
    const meta = chart.getDatasetMeta(index);
    const visible = meta && chart.isDatasetVisible(index);
    return visible ? meta.dataset : null;
}
function computeBoundary(source) {
    const scale = source.scale || {};
    if (scale.getPointPositionForValue) {
        return computeCircularBoundary(source);
    }
    return computeLinearBoundary(source);
}
function computeLinearBoundary(source) {
    const { scale ={} , fill  } = source;
    const pixel = _getTargetPixel(fill, scale);
    if (isNumberFinite(pixel)) {
        const horizontal = scale.isHorizontal();
        return {
            x: horizontal ? pixel : null,
            y: horizontal ? null : pixel
        };
    }
    return null;
}
function computeCircularBoundary(source) {
    const { scale , fill  } = source;
    const options = scale.options;
    const length = scale.getLabels().length;
    const start = options.reverse ? scale.max : scale.min;
    const value = _getTargetValue(fill, scale, start);
    const target = [];
    if (options.grid.circular) {
        const center = scale.getPointPositionForValue(0, start);
        return new simpleArc({
            x: center.x,
            y: center.y,
            radius: scale.getDistanceFromCenterForValue(value)
        });
    }
    for(let i = 0; i < length; ++i){
        target.push(scale.getPointPositionForValue(i, value));
    }
    return target;
}

function _drawfill(ctx, source, area) {
    const target = _getTarget(source);
    const { chart , index , line , scale , axis  } = source;
    const lineOpts = line.options;
    const fillOption = lineOpts.fill;
    const color = lineOpts.backgroundColor;
    const { above =color , below =color  } = fillOption || {};
    const meta = chart.getDatasetMeta(index);
    const clip = getDatasetClipArea(chart, meta);
    if (target && line.points.length) {
        clipArea(ctx, area);
        doFill(ctx, {
            line,
            target,
            above,
            below,
            area,
            scale,
            axis,
            clip
        });
        unclipArea(ctx);
    }
}
function doFill(ctx, cfg) {
    const { line , target , above , below , area , scale , clip  } = cfg;
    const property = line._loop ? 'angle' : cfg.axis;
    ctx.save();
    let fillColor = below;
    if (below !== above) {
        if (property === 'x') {
            clipVertical(ctx, target, area.top);
            fill(ctx, {
                line,
                target,
                color: above,
                scale,
                property,
                clip
            });
            ctx.restore();
            ctx.save();
            clipVertical(ctx, target, area.bottom);
        } else if (property === 'y') {
            clipHorizontal(ctx, target, area.left);
            fill(ctx, {
                line,
                target,
                color: below,
                scale,
                property,
                clip
            });
            ctx.restore();
            ctx.save();
            clipHorizontal(ctx, target, area.right);
            fillColor = above;
        }
    }
    fill(ctx, {
        line,
        target,
        color: fillColor,
        scale,
        property,
        clip
    });
    ctx.restore();
}
function clipVertical(ctx, target, clipY) {
    const { segments , points  } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start , end  } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(firstPoint.x, clipY);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) {
            ctx.closePath();
        } else {
            ctx.lineTo(lastPoint.x, clipY);
        }
    }
    ctx.lineTo(target.first().x, clipY);
    ctx.closePath();
    ctx.clip();
}
function clipHorizontal(ctx, target, clipX) {
    const { segments , points  } = target;
    let first = true;
    let lineLoop = false;
    ctx.beginPath();
    for (const segment of segments){
        const { start , end  } = segment;
        const firstPoint = points[start];
        const lastPoint = points[_findSegmentEnd(start, end, points)];
        if (first) {
            ctx.moveTo(firstPoint.x, firstPoint.y);
            first = false;
        } else {
            ctx.lineTo(clipX, firstPoint.y);
            ctx.lineTo(firstPoint.x, firstPoint.y);
        }
        lineLoop = !!target.pathSegment(ctx, segment, {
            move: lineLoop
        });
        if (lineLoop) {
            ctx.closePath();
        } else {
            ctx.lineTo(clipX, lastPoint.y);
        }
    }
    ctx.lineTo(clipX, target.first().y);
    ctx.closePath();
    ctx.clip();
}
function fill(ctx, cfg) {
    const { line , target , property , color , scale , clip  } = cfg;
    const segments = _segments(line, target, property);
    for (const { source: src , target: tgt , start , end  } of segments){
        const { style: { backgroundColor =color  } = {}  } = src;
        const notShape = target !== true;
        ctx.save();
        ctx.fillStyle = backgroundColor;
        clipBounds(ctx, scale, clip, notShape && _getBounds(property, start, end));
        ctx.beginPath();
        const lineLoop = !!line.pathSegment(ctx, src);
        let loop;
        if (notShape) {
            if (lineLoop) {
                ctx.closePath();
            } else {
                interpolatedLineTo(ctx, target, end, property);
            }
            const targetLoop = !!target.pathSegment(ctx, tgt, {
                move: lineLoop,
                reverse: true
            });
            loop = lineLoop && targetLoop;
            if (!loop) {
                interpolatedLineTo(ctx, target, start, property);
            }
        }
        ctx.closePath();
        ctx.fill(loop ? 'evenodd' : 'nonzero');
        ctx.restore();
    }
}
function clipBounds(ctx, scale, clip, bounds) {
    const chartArea = scale.chart.chartArea;
    const { property , start , end  } = bounds || {};
    if (property === 'x' || property === 'y') {
        let left, top, right, bottom;
        if (property === 'x') {
            left = start;
            top = chartArea.top;
            right = end;
            bottom = chartArea.bottom;
        } else {
            left = chartArea.left;
            top = start;
            right = chartArea.right;
            bottom = end;
        }
        ctx.beginPath();
        if (clip) {
            left = Math.max(left, clip.left);
            right = Math.min(right, clip.right);
            top = Math.max(top, clip.top);
            bottom = Math.min(bottom, clip.bottom);
        }
        ctx.rect(left, top, right - left, bottom - top);
        ctx.clip();
    }
}
function interpolatedLineTo(ctx, target, point, property) {
    const interpolatedPoint = target.interpolate(point, property);
    if (interpolatedPoint) {
        ctx.lineTo(interpolatedPoint.x, interpolatedPoint.y);
    }
}

var index = {
    id: 'filler',
    afterDatasetsUpdate (chart, _args, options) {
        const count = (chart.data.datasets || []).length;
        const sources = [];
        let meta, i, line, source;
        for(i = 0; i < count; ++i){
            meta = chart.getDatasetMeta(i);
            line = meta.dataset;
            source = null;
            if (line && line.options && line instanceof LineElement) {
                source = {
                    visible: chart.isDatasetVisible(i),
                    index: i,
                    fill: _decodeFill(line, i, count),
                    chart,
                    axis: meta.controller.options.indexAxis,
                    scale: meta.vScale,
                    line
                };
            }
            meta.$filler = source;
            sources.push(source);
        }
        for(i = 0; i < count; ++i){
            source = sources[i];
            if (!source || source.fill === false) {
                continue;
            }
            source.fill = _resolveTarget(sources, i, options.propagate);
        }
    },
    beforeDraw (chart, _args, options) {
        const draw = options.drawTime === 'beforeDraw';
        const metasets = chart.getSortedVisibleDatasetMetas();
        const area = chart.chartArea;
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (!source) {
                continue;
            }
            source.line.updateControlPoints(area, source.axis);
            if (draw && source.fill) {
                _drawfill(chart.ctx, source, area);
            }
        }
    },
    beforeDatasetsDraw (chart, _args, options) {
        if (options.drawTime !== 'beforeDatasetsDraw') {
            return;
        }
        const metasets = chart.getSortedVisibleDatasetMetas();
        for(let i = metasets.length - 1; i >= 0; --i){
            const source = metasets[i].$filler;
            if (_shouldApplyFill(source)) {
                _drawfill(chart.ctx, source, chart.chartArea);
            }
        }
    },
    beforeDatasetDraw (chart, args, options) {
        const source = args.meta.$filler;
        if (!_shouldApplyFill(source) || options.drawTime !== 'beforeDatasetDraw') {
            return;
        }
        _drawfill(chart.ctx, source, chart.chartArea);
    },
    defaults: {
        propagate: true,
        drawTime: 'beforeDatasetDraw'
    }
};

const getBoxSize = (labelOpts, fontSize)=>{
    let { boxHeight =fontSize , boxWidth =fontSize  } = labelOpts;
    if (labelOpts.usePointStyle) {
        boxHeight = Math.min(boxHeight, fontSize);
        boxWidth = labelOpts.pointStyleWidth || Math.min(boxWidth, fontSize);
    }
    return {
        boxWidth,
        boxHeight,
        itemHeight: Math.max(fontSize, boxHeight)
    };
};
const itemsEqual = (a, b)=>a !== null && b !== null && a.datasetIndex === b.datasetIndex && a.index === b.index;
class Legend extends Element {
 constructor(config){
        super();
        this._added = false;
        this.legendHitBoxes = [];
 this._hoveredItem = null;
        this.doughnutMode = false;
        this.chart = config.chart;
        this.options = config.options;
        this.ctx = config.ctx;
        this.legendItems = undefined;
        this.columnSizes = undefined;
        this.lineWidths = undefined;
        this.maxHeight = undefined;
        this.maxWidth = undefined;
        this.top = undefined;
        this.bottom = undefined;
        this.left = undefined;
        this.right = undefined;
        this.height = undefined;
        this.width = undefined;
        this._margins = undefined;
        this.position = undefined;
        this.weight = undefined;
        this.fullSize = undefined;
    }
    update(maxWidth, maxHeight, margins) {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
        this._margins = margins;
        this.setDimensions();
        this.buildLabels();
        this.fit();
    }
    setDimensions() {
        if (this.isHorizontal()) {
            this.width = this.maxWidth;
            this.left = this._margins.left;
            this.right = this.width;
        } else {
            this.height = this.maxHeight;
            this.top = this._margins.top;
            this.bottom = this.height;
        }
    }
    buildLabels() {
        const labelOpts = this.options.labels || {};
        let legendItems = callback(labelOpts.generateLabels, [
            this.chart
        ], this) || [];
        if (labelOpts.filter) {
            legendItems = legendItems.filter((item)=>labelOpts.filter(item, this.chart.data));
        }
        if (labelOpts.sort) {
            legendItems = legendItems.sort((a, b)=>labelOpts.sort(a, b, this.chart.data));
        }
        if (this.options.reverse) {
            legendItems.reverse();
        }
        this.legendItems = legendItems;
    }
    fit() {
        const { options , ctx  } = this;
        if (!options.display) {
            this.width = this.height = 0;
            return;
        }
        const labelOpts = options.labels;
        const labelFont = toFont(labelOpts.font);
        const fontSize = labelFont.size;
        const titleHeight = this._computeTitleHeight();
        const { boxWidth , itemHeight  } = getBoxSize(labelOpts, fontSize);
        let width, height;
        ctx.font = labelFont.string;
        if (this.isHorizontal()) {
            width = this.maxWidth;
            height = this._fitRows(titleHeight, fontSize, boxWidth, itemHeight) + 10;
        } else {
            height = this.maxHeight;
            width = this._fitCols(titleHeight, labelFont, boxWidth, itemHeight) + 10;
        }
        this.width = Math.min(width, options.maxWidth || this.maxWidth);
        this.height = Math.min(height, options.maxHeight || this.maxHeight);
    }
 _fitRows(titleHeight, fontSize, boxWidth, itemHeight) {
        const { ctx , maxWidth , options: { labels: { padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const lineWidths = this.lineWidths = [
            0
        ];
        const lineHeight = itemHeight + padding;
        let totalHeight = titleHeight;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        let row = -1;
        let top = -lineHeight;
        this.legendItems.forEach((legendItem, i)=>{
            const itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
            if (i === 0 || lineWidths[lineWidths.length - 1] + itemWidth + 2 * padding > maxWidth) {
                totalHeight += lineHeight;
                lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
                top += lineHeight;
                row++;
            }
            hitboxes[i] = {
                left: 0,
                top,
                row,
                width: itemWidth,
                height: itemHeight
            };
            lineWidths[lineWidths.length - 1] += itemWidth + padding;
        });
        return totalHeight;
    }
    _fitCols(titleHeight, labelFont, boxWidth, _itemHeight) {
        const { ctx , maxHeight , options: { labels: { padding  }  }  } = this;
        const hitboxes = this.legendHitBoxes = [];
        const columnSizes = this.columnSizes = [];
        const heightLimit = maxHeight - titleHeight;
        let totalWidth = padding;
        let currentColWidth = 0;
        let currentColHeight = 0;
        let left = 0;
        let col = 0;
        this.legendItems.forEach((legendItem, i)=>{
            const { itemWidth , itemHeight  } = calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight);
            if (i > 0 && currentColHeight + itemHeight + 2 * padding > heightLimit) {
                totalWidth += currentColWidth + padding;
                columnSizes.push({
                    width: currentColWidth,
                    height: currentColHeight
                });
                left += currentColWidth + padding;
                col++;
                currentColWidth = currentColHeight = 0;
            }
            hitboxes[i] = {
                left,
                top: currentColHeight,
                col,
                width: itemWidth,
                height: itemHeight
            };
            currentColWidth = Math.max(currentColWidth, itemWidth);
            currentColHeight += itemHeight + padding;
        });
        totalWidth += currentColWidth;
        columnSizes.push({
            width: currentColWidth,
            height: currentColHeight
        });
        return totalWidth;
    }
    adjustHitBoxes() {
        if (!this.options.display) {
            return;
        }
        const titleHeight = this._computeTitleHeight();
        const { legendHitBoxes: hitboxes , options: { align , labels: { padding  } , rtl  }  } = this;
        const rtlHelper = getRtlAdapter(rtl, this.left, this.width);
        if (this.isHorizontal()) {
            let row = 0;
            let left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
            for (const hitbox of hitboxes){
                if (row !== hitbox.row) {
                    row = hitbox.row;
                    left = _alignStartEnd(align, this.left + padding, this.right - this.lineWidths[row]);
                }
                hitbox.top += this.top + titleHeight + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(left), hitbox.width);
                left += hitbox.width + padding;
            }
        } else {
            let col = 0;
            let top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
            for (const hitbox of hitboxes){
                if (hitbox.col !== col) {
                    col = hitbox.col;
                    top = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - this.columnSizes[col].height);
                }
                hitbox.top = top;
                hitbox.left += this.left + padding;
                hitbox.left = rtlHelper.leftForLtr(rtlHelper.x(hitbox.left), hitbox.width);
                top += hitbox.height + padding;
            }
        }
    }
    isHorizontal() {
        return this.options.position === 'top' || this.options.position === 'bottom';
    }
    draw() {
        if (this.options.display) {
            const ctx = this.ctx;
            clipArea(ctx, this);
            this._draw();
            unclipArea(ctx);
        }
    }
 _draw() {
        const { options: opts , columnSizes , lineWidths , ctx  } = this;
        const { align , labels: labelOpts  } = opts;
        const defaultColor = defaults.color;
        const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
        const labelFont = toFont(labelOpts.font);
        const { padding  } = labelOpts;
        const fontSize = labelFont.size;
        const halfFontSize = fontSize / 2;
        let cursor;
        this.drawTitle();
        ctx.textAlign = rtlHelper.textAlign('left');
        ctx.textBaseline = 'middle';
        ctx.lineWidth = 0.5;
        ctx.font = labelFont.string;
        const { boxWidth , boxHeight , itemHeight  } = getBoxSize(labelOpts, fontSize);
        const drawLegendBox = function(x, y, legendItem) {
            if (isNaN(boxWidth) || boxWidth <= 0 || isNaN(boxHeight) || boxHeight < 0) {
                return;
            }
            ctx.save();
            const lineWidth = valueOrDefault(legendItem.lineWidth, 1);
            ctx.fillStyle = valueOrDefault(legendItem.fillStyle, defaultColor);
            ctx.lineCap = valueOrDefault(legendItem.lineCap, 'butt');
            ctx.lineDashOffset = valueOrDefault(legendItem.lineDashOffset, 0);
            ctx.lineJoin = valueOrDefault(legendItem.lineJoin, 'miter');
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = valueOrDefault(legendItem.strokeStyle, defaultColor);
            ctx.setLineDash(valueOrDefault(legendItem.lineDash, []));
            if (labelOpts.usePointStyle) {
                const drawOptions = {
                    radius: boxHeight * Math.SQRT2 / 2,
                    pointStyle: legendItem.pointStyle,
                    rotation: legendItem.rotation,
                    borderWidth: lineWidth
                };
                const centerX = rtlHelper.xPlus(x, boxWidth / 2);
                const centerY = y + halfFontSize;
                drawPointLegend(ctx, drawOptions, centerX, centerY, labelOpts.pointStyleWidth && boxWidth);
            } else {
                const yBoxTop = y + Math.max((fontSize - boxHeight) / 2, 0);
                const xBoxLeft = rtlHelper.leftForLtr(x, boxWidth);
                const borderRadius = toTRBLCorners(legendItem.borderRadius);
                ctx.beginPath();
                if (Object.values(borderRadius).some((v)=>v !== 0)) {
                    addRoundedRectPath(ctx, {
                        x: xBoxLeft,
                        y: yBoxTop,
                        w: boxWidth,
                        h: boxHeight,
                        radius: borderRadius
                    });
                } else {
                    ctx.rect(xBoxLeft, yBoxTop, boxWidth, boxHeight);
                }
                ctx.fill();
                if (lineWidth !== 0) {
                    ctx.stroke();
                }
            }
            ctx.restore();
        };
        const fillText = function(x, y, legendItem) {
            renderText(ctx, legendItem.text, x, y + itemHeight / 2, labelFont, {
                strikethrough: legendItem.hidden,
                textAlign: rtlHelper.textAlign(legendItem.textAlign)
            });
        };
        const isHorizontal = this.isHorizontal();
        const titleHeight = this._computeTitleHeight();
        if (isHorizontal) {
            cursor = {
                x: _alignStartEnd(align, this.left + padding, this.right - lineWidths[0]),
                y: this.top + padding + titleHeight,
                line: 0
            };
        } else {
            cursor = {
                x: this.left + padding,
                y: _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[0].height),
                line: 0
            };
        }
        overrideTextDirection(this.ctx, opts.textDirection);
        const lineHeight = itemHeight + padding;
        this.legendItems.forEach((legendItem, i)=>{
            ctx.strokeStyle = legendItem.fontColor;
            ctx.fillStyle = legendItem.fontColor;
            const textWidth = ctx.measureText(legendItem.text).width;
            const textAlign = rtlHelper.textAlign(legendItem.textAlign || (legendItem.textAlign = labelOpts.textAlign));
            const width = boxWidth + halfFontSize + textWidth;
            let x = cursor.x;
            let y = cursor.y;
            rtlHelper.setWidth(this.width);
            if (isHorizontal) {
                if (i > 0 && x + width + padding > this.right) {
                    y = cursor.y += lineHeight;
                    cursor.line++;
                    x = cursor.x = _alignStartEnd(align, this.left + padding, this.right - lineWidths[cursor.line]);
                }
            } else if (i > 0 && y + lineHeight > this.bottom) {
                x = cursor.x = x + columnSizes[cursor.line].width + padding;
                cursor.line++;
                y = cursor.y = _alignStartEnd(align, this.top + titleHeight + padding, this.bottom - columnSizes[cursor.line].height);
            }
            const realX = rtlHelper.x(x);
            drawLegendBox(realX, y, legendItem);
            x = _textX(textAlign, x + boxWidth + halfFontSize, isHorizontal ? x + width : this.right, opts.rtl);
            fillText(rtlHelper.x(x), y, legendItem);
            if (isHorizontal) {
                cursor.x += width + padding;
            } else if (typeof legendItem.text !== 'string') {
                const fontLineHeight = labelFont.lineHeight;
                cursor.y += calculateLegendItemHeight(legendItem, fontLineHeight) + padding;
            } else {
                cursor.y += lineHeight;
            }
        });
        restoreTextDirection(this.ctx, opts.textDirection);
    }
 drawTitle() {
        const opts = this.options;
        const titleOpts = opts.title;
        const titleFont = toFont(titleOpts.font);
        const titlePadding = toPadding(titleOpts.padding);
        if (!titleOpts.display) {
            return;
        }
        const rtlHelper = getRtlAdapter(opts.rtl, this.left, this.width);
        const ctx = this.ctx;
        const position = titleOpts.position;
        const halfFontSize = titleFont.size / 2;
        const topPaddingPlusHalfFontSize = titlePadding.top + halfFontSize;
        let y;
        let left = this.left;
        let maxWidth = this.width;
        if (this.isHorizontal()) {
            maxWidth = Math.max(...this.lineWidths);
            y = this.top + topPaddingPlusHalfFontSize;
            left = _alignStartEnd(opts.align, left, this.right - maxWidth);
        } else {
            const maxHeight = this.columnSizes.reduce((acc, size)=>Math.max(acc, size.height), 0);
            y = topPaddingPlusHalfFontSize + _alignStartEnd(opts.align, this.top, this.bottom - maxHeight - opts.labels.padding - this._computeTitleHeight());
        }
        const x = _alignStartEnd(position, left, left + maxWidth);
        ctx.textAlign = rtlHelper.textAlign(_toLeftRightCenter(position));
        ctx.textBaseline = 'middle';
        ctx.strokeStyle = titleOpts.color;
        ctx.fillStyle = titleOpts.color;
        ctx.font = titleFont.string;
        renderText(ctx, titleOpts.text, x, y, titleFont);
    }
 _computeTitleHeight() {
        const titleOpts = this.options.title;
        const titleFont = toFont(titleOpts.font);
        const titlePadding = toPadding(titleOpts.padding);
        return titleOpts.display ? titleFont.lineHeight + titlePadding.height : 0;
    }
 _getLegendItemAt(x, y) {
        let i, hitBox, lh;
        if (_isBetween(x, this.left, this.right) && _isBetween(y, this.top, this.bottom)) {
            lh = this.legendHitBoxes;
            for(i = 0; i < lh.length; ++i){
                hitBox = lh[i];
                if (_isBetween(x, hitBox.left, hitBox.left + hitBox.width) && _isBetween(y, hitBox.top, hitBox.top + hitBox.height)) {
                    return this.legendItems[i];
                }
            }
        }
        return null;
    }
 handleEvent(e) {
        const opts = this.options;
        if (!isListened(e.type, opts)) {
            return;
        }
        const hoveredItem = this._getLegendItemAt(e.x, e.y);
        if (e.type === 'mousemove' || e.type === 'mouseout') {
            const previous = this._hoveredItem;
            const sameItem = itemsEqual(previous, hoveredItem);
            if (previous && !sameItem) {
                callback(opts.onLeave, [
                    e,
                    previous,
                    this
                ], this);
            }
            this._hoveredItem = hoveredItem;
            if (hoveredItem && !sameItem) {
                callback(opts.onHover, [
                    e,
                    hoveredItem,
                    this
                ], this);
            }
        } else if (hoveredItem) {
            callback(opts.onClick, [
                e,
                hoveredItem,
                this
            ], this);
        }
    }
}
function calculateItemSize(boxWidth, labelFont, ctx, legendItem, _itemHeight) {
    const itemWidth = calculateItemWidth(legendItem, boxWidth, labelFont, ctx);
    const itemHeight = calculateItemHeight(_itemHeight, legendItem, labelFont.lineHeight);
    return {
        itemWidth,
        itemHeight
    };
}
function calculateItemWidth(legendItem, boxWidth, labelFont, ctx) {
    let legendItemText = legendItem.text;
    if (legendItemText && typeof legendItemText !== 'string') {
        legendItemText = legendItemText.reduce((a, b)=>a.length > b.length ? a : b);
    }
    return boxWidth + labelFont.size / 2 + ctx.measureText(legendItemText).width;
}
function calculateItemHeight(_itemHeight, legendItem, fontLineHeight) {
    let itemHeight = _itemHeight;
    if (typeof legendItem.text !== 'string') {
        itemHeight = calculateLegendItemHeight(legendItem, fontLineHeight);
    }
    return itemHeight;
}
function calculateLegendItemHeight(legendItem, fontLineHeight) {
    const labelHeight = legendItem.text ? legendItem.text.length : 0;
    return fontLineHeight * labelHeight;
}
function isListened(type, opts) {
    if ((type === 'mousemove' || type === 'mouseout') && (opts.onHover || opts.onLeave)) {
        return true;
    }
    if (opts.onClick && (type === 'click' || type === 'mouseup')) {
        return true;
    }
    return false;
}
var plugin_legend = {
    id: 'legend',
 _element: Legend,
    start (chart, _args, options) {
        const legend = chart.legend = new Legend({
            ctx: chart.ctx,
            options,
            chart
        });
        layouts.configure(chart, legend, options);
        layouts.addBox(chart, legend);
    },
    stop (chart) {
        layouts.removeBox(chart, chart.legend);
        delete chart.legend;
    },
    beforeUpdate (chart, _args, options) {
        const legend = chart.legend;
        layouts.configure(chart, legend, options);
        legend.options = options;
    },
    afterUpdate (chart) {
        const legend = chart.legend;
        legend.buildLabels();
        legend.adjustHitBoxes();
    },
    afterEvent (chart, args) {
        if (!args.replay) {
            chart.legend.handleEvent(args.event);
        }
    },
    defaults: {
        display: true,
        position: 'top',
        align: 'center',
        fullSize: true,
        reverse: false,
        weight: 1000,
        onClick (e, legendItem, legend) {
            const index = legendItem.datasetIndex;
            const ci = legend.chart;
            if (ci.isDatasetVisible(index)) {
                ci.hide(index);
                legendItem.hidden = true;
            } else {
                ci.show(index);
                legendItem.hidden = false;
            }
        },
        onHover: null,
        onLeave: null,
        labels: {
            color: (ctx)=>ctx.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels (chart) {
                const datasets = chart.data.datasets;
                const { labels: { usePointStyle , pointStyle , textAlign , color , useBorderRadius , borderRadius  }  } = chart.legend.options;
                return chart._getSortedDatasetMetas().map((meta)=>{
                    const style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
                    const borderWidth = toPadding(style.borderWidth);
                    return {
                        text: datasets[meta.index].label,
                        fillStyle: style.backgroundColor,
                        fontColor: color,
                        hidden: !meta.visible,
                        lineCap: style.borderCapStyle,
                        lineDash: style.borderDash,
                        lineDashOffset: style.borderDashOffset,
                        lineJoin: style.borderJoinStyle,
                        lineWidth: (borderWidth.width + borderWidth.height) / 4,
                        strokeStyle: style.borderColor,
                        pointStyle: pointStyle || style.pointStyle,
                        rotation: style.rotation,
                        textAlign: textAlign || style.textAlign,
                        borderRadius: useBorderRadius && (borderRadius || style.borderRadius),
                        datasetIndex: meta.index
                    };
                }, this);
            }
        },
        title: {
            color: (ctx)=>ctx.chart.options.color,
            display: false,
            position: 'center',
            text: ''
        }
    },
    descriptors: {
        _scriptable: (name)=>!name.startsWith('on'),
        labels: {
            _scriptable: (name)=>![
                    'generateLabels',
                    'filter',
                    'sort'
                ].includes(name)
        }
    }
};

const positioners = {
 average (items) {
        if (!items.length) {
            return false;
        }
        let i, len;
        let xSet = new Set();
        let y = 0;
        let count = 0;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const pos = el.tooltipPosition();
                xSet.add(pos.x);
                y += pos.y;
                ++count;
            }
        }
        if (count === 0 || xSet.size === 0) {
            return false;
        }
        const xAverage = [
            ...xSet
        ].reduce((a, b)=>a + b) / xSet.size;
        return {
            x: xAverage,
            y: y / count
        };
    },
 nearest (items, eventPosition) {
        if (!items.length) {
            return false;
        }
        let x = eventPosition.x;
        let y = eventPosition.y;
        let minDistance = Number.POSITIVE_INFINITY;
        let i, len, nearestElement;
        for(i = 0, len = items.length; i < len; ++i){
            const el = items[i].element;
            if (el && el.hasValue()) {
                const center = el.getCenterPoint();
                const d = distanceBetweenPoints(eventPosition, center);
                if (d < minDistance) {
                    minDistance = d;
                    nearestElement = el;
                }
            }
        }
        if (nearestElement) {
            const tp = nearestElement.tooltipPosition();
            x = tp.x;
            y = tp.y;
        }
        return {
            x,
            y
        };
    }
};
function pushOrConcat(base, toPush) {
    if (toPush) {
        if (isArray(toPush)) {
            Array.prototype.push.apply(base, toPush);
        } else {
            base.push(toPush);
        }
    }
    return base;
}
 function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
        return str.split('\n');
    }
    return str;
}
 function createTooltipItem(chart, item) {
    const { element , datasetIndex , index  } = item;
    const controller = chart.getDatasetMeta(datasetIndex).controller;
    const { label , value  } = controller.getLabelAndValue(index);
    return {
        chart,
        label,
        parsed: controller.getParsed(index),
        raw: chart.data.datasets[datasetIndex].data[index],
        formattedValue: value,
        dataset: controller.getDataset(),
        dataIndex: index,
        datasetIndex,
        element
    };
}
 function getTooltipSize(tooltip, options) {
    const ctx = tooltip.chart.ctx;
    const { body , footer , title  } = tooltip;
    const { boxWidth , boxHeight  } = options;
    const bodyFont = toFont(options.bodyFont);
    const titleFont = toFont(options.titleFont);
    const footerFont = toFont(options.footerFont);
    const titleLineCount = title.length;
    const footerLineCount = footer.length;
    const bodyLineItemCount = body.length;
    const padding = toPadding(options.padding);
    let height = padding.height;
    let width = 0;
    let combinedBodyLength = body.reduce((count, bodyItem)=>count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length, 0);
    combinedBodyLength += tooltip.beforeBody.length + tooltip.afterBody.length;
    if (titleLineCount) {
        height += titleLineCount * titleFont.lineHeight + (titleLineCount - 1) * options.titleSpacing + options.titleMarginBottom;
    }
    if (combinedBodyLength) {
        const bodyLineHeight = options.displayColors ? Math.max(boxHeight, bodyFont.lineHeight) : bodyFont.lineHeight;
        height += bodyLineItemCount * bodyLineHeight + (combinedBodyLength - bodyLineItemCount) * bodyFont.lineHeight + (combinedBodyLength - 1) * options.bodySpacing;
    }
    if (footerLineCount) {
        height += options.footerMarginTop + footerLineCount * footerFont.lineHeight + (footerLineCount - 1) * options.footerSpacing;
    }
    let widthPadding = 0;
    const maxLineWidth = function(line) {
        width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.save();
    ctx.font = titleFont.string;
    each(tooltip.title, maxLineWidth);
    ctx.font = bodyFont.string;
    each(tooltip.beforeBody.concat(tooltip.afterBody), maxLineWidth);
    widthPadding = options.displayColors ? boxWidth + 2 + options.boxPadding : 0;
    each(body, (bodyItem)=>{
        each(bodyItem.before, maxLineWidth);
        each(bodyItem.lines, maxLineWidth);
        each(bodyItem.after, maxLineWidth);
    });
    widthPadding = 0;
    ctx.font = footerFont.string;
    each(tooltip.footer, maxLineWidth);
    ctx.restore();
    width += padding.width;
    return {
        width,
        height
    };
}
function determineYAlign(chart, size) {
    const { y , height  } = size;
    if (y < height / 2) {
        return 'top';
    } else if (y > chart.height - height / 2) {
        return 'bottom';
    }
    return 'center';
}
function doesNotFitWithAlign(xAlign, chart, options, size) {
    const { x , width  } = size;
    const caret = options.caretSize + options.caretPadding;
    if (xAlign === 'left' && x + width + caret > chart.width) {
        return true;
    }
    if (xAlign === 'right' && x - width - caret < 0) {
        return true;
    }
}
function determineXAlign(chart, options, size, yAlign) {
    const { x , width  } = size;
    const { width: chartWidth , chartArea: { left , right  }  } = chart;
    let xAlign = 'center';
    if (yAlign === 'center') {
        xAlign = x <= (left + right) / 2 ? 'left' : 'right';
    } else if (x <= width / 2) {
        xAlign = 'left';
    } else if (x >= chartWidth - width / 2) {
        xAlign = 'right';
    }
    if (doesNotFitWithAlign(xAlign, chart, options, size)) {
        xAlign = 'center';
    }
    return xAlign;
}
 function determineAlignment(chart, options, size) {
    const yAlign = size.yAlign || options.yAlign || determineYAlign(chart, size);
    return {
        xAlign: size.xAlign || options.xAlign || determineXAlign(chart, options, size, yAlign),
        yAlign
    };
}
function alignX(size, xAlign) {
    let { x , width  } = size;
    if (xAlign === 'right') {
        x -= width;
    } else if (xAlign === 'center') {
        x -= width / 2;
    }
    return x;
}
function alignY(size, yAlign, paddingAndSize) {
    let { y , height  } = size;
    if (yAlign === 'top') {
        y += paddingAndSize;
    } else if (yAlign === 'bottom') {
        y -= height + paddingAndSize;
    } else {
        y -= height / 2;
    }
    return y;
}
 function getBackgroundPoint(options, size, alignment, chart) {
    const { caretSize , caretPadding , cornerRadius  } = options;
    const { xAlign , yAlign  } = alignment;
    const paddingAndSize = caretSize + caretPadding;
    const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(cornerRadius);
    let x = alignX(size, xAlign);
    const y = alignY(size, yAlign, paddingAndSize);
    if (yAlign === 'center') {
        if (xAlign === 'left') {
            x += paddingAndSize;
        } else if (xAlign === 'right') {
            x -= paddingAndSize;
        }
    } else if (xAlign === 'left') {
        x -= Math.max(topLeft, bottomLeft) + caretSize;
    } else if (xAlign === 'right') {
        x += Math.max(topRight, bottomRight) + caretSize;
    }
    return {
        x: _limitValue(x, 0, chart.width - size.width),
        y: _limitValue(y, 0, chart.height - size.height)
    };
}
function getAlignedX(tooltip, align, options) {
    const padding = toPadding(options.padding);
    return align === 'center' ? tooltip.x + tooltip.width / 2 : align === 'right' ? tooltip.x + tooltip.width - padding.right : tooltip.x + padding.left;
}
 function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
}
function createTooltipContext(parent, tooltip, tooltipItems) {
    return createContext(parent, {
        tooltip,
        tooltipItems,
        type: 'tooltip'
    });
}
function overrideCallbacks(callbacks, context) {
    const override = context && context.dataset && context.dataset.tooltip && context.dataset.tooltip.callbacks;
    return override ? callbacks.override(override) : callbacks;
}
const defaultCallbacks = {
    beforeTitle: noop,
    title (tooltipItems) {
        if (tooltipItems.length > 0) {
            const item = tooltipItems[0];
            const labels = item.chart.data.labels;
            const labelCount = labels ? labels.length : 0;
            if (this && this.options && this.options.mode === 'dataset') {
                return item.dataset.label || '';
            } else if (item.label) {
                return item.label;
            } else if (labelCount > 0 && item.dataIndex < labelCount) {
                return labels[item.dataIndex];
            }
        }
        return '';
    },
    afterTitle: noop,
    beforeBody: noop,
    beforeLabel: noop,
    label (tooltipItem) {
        if (this && this.options && this.options.mode === 'dataset') {
            return tooltipItem.label + ': ' + tooltipItem.formattedValue || tooltipItem.formattedValue;
        }
        let label = tooltipItem.dataset.label || '';
        if (label) {
            label += ': ';
        }
        const value = tooltipItem.formattedValue;
        if (!isNullOrUndef(value)) {
            label += value;
        }
        return label;
    },
    labelColor (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            borderColor: options.borderColor,
            backgroundColor: options.backgroundColor,
            borderWidth: options.borderWidth,
            borderDash: options.borderDash,
            borderDashOffset: options.borderDashOffset,
            borderRadius: 0
        };
    },
    labelTextColor () {
        return this.options.bodyColor;
    },
    labelPointStyle (tooltipItem) {
        const meta = tooltipItem.chart.getDatasetMeta(tooltipItem.datasetIndex);
        const options = meta.controller.getStyle(tooltipItem.dataIndex);
        return {
            pointStyle: options.pointStyle,
            rotation: options.rotation
        };
    },
    afterLabel: noop,
    afterBody: noop,
    beforeFooter: noop,
    footer: noop,
    afterFooter: noop
};
 function invokeCallbackWithFallback(callbacks, name, ctx, arg) {
    const result = callbacks[name].call(ctx, arg);
    if (typeof result === 'undefined') {
        return defaultCallbacks[name].call(ctx, arg);
    }
    return result;
}
class Tooltip extends Element {
 static positioners = positioners;
    constructor(config){
        super();
        this.opacity = 0;
        this._active = [];
        this._eventPosition = undefined;
        this._size = undefined;
        this._cachedAnimations = undefined;
        this._tooltipItems = [];
        this.$animations = undefined;
        this.$context = undefined;
        this.chart = config.chart;
        this.options = config.options;
        this.dataPoints = undefined;
        this.title = undefined;
        this.beforeBody = undefined;
        this.body = undefined;
        this.afterBody = undefined;
        this.footer = undefined;
        this.xAlign = undefined;
        this.yAlign = undefined;
        this.x = undefined;
        this.y = undefined;
        this.height = undefined;
        this.width = undefined;
        this.caretX = undefined;
        this.caretY = undefined;
        this.labelColors = undefined;
        this.labelPointStyles = undefined;
        this.labelTextColors = undefined;
    }
    initialize(options) {
        this.options = options;
        this._cachedAnimations = undefined;
        this.$context = undefined;
    }
 _resolveAnimations() {
        const cached = this._cachedAnimations;
        if (cached) {
            return cached;
        }
        const chart = this.chart;
        const options = this.options.setContext(this.getContext());
        const opts = options.enabled && chart.options.animation && options.animations;
        const animations = new Animations(this.chart, opts);
        if (opts._cacheable) {
            this._cachedAnimations = Object.freeze(animations);
        }
        return animations;
    }
 getContext() {
        return this.$context || (this.$context = createTooltipContext(this.chart.getContext(), this, this._tooltipItems));
    }
    getTitle(context, options) {
        const { callbacks  } = options;
        const beforeTitle = invokeCallbackWithFallback(callbacks, 'beforeTitle', this, context);
        const title = invokeCallbackWithFallback(callbacks, 'title', this, context);
        const afterTitle = invokeCallbackWithFallback(callbacks, 'afterTitle', this, context);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeTitle));
        lines = pushOrConcat(lines, splitNewlines(title));
        lines = pushOrConcat(lines, splitNewlines(afterTitle));
        return lines;
    }
    getBeforeBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'beforeBody', this, tooltipItems));
    }
    getBody(tooltipItems, options) {
        const { callbacks  } = options;
        const bodyItems = [];
        each(tooltipItems, (context)=>{
            const bodyItem = {
                before: [],
                lines: [],
                after: []
            };
            const scoped = overrideCallbacks(callbacks, context);
            pushOrConcat(bodyItem.before, splitNewlines(invokeCallbackWithFallback(scoped, 'beforeLabel', this, context)));
            pushOrConcat(bodyItem.lines, invokeCallbackWithFallback(scoped, 'label', this, context));
            pushOrConcat(bodyItem.after, splitNewlines(invokeCallbackWithFallback(scoped, 'afterLabel', this, context)));
            bodyItems.push(bodyItem);
        });
        return bodyItems;
    }
    getAfterBody(tooltipItems, options) {
        return getBeforeAfterBodyLines(invokeCallbackWithFallback(options.callbacks, 'afterBody', this, tooltipItems));
    }
    getFooter(tooltipItems, options) {
        const { callbacks  } = options;
        const beforeFooter = invokeCallbackWithFallback(callbacks, 'beforeFooter', this, tooltipItems);
        const footer = invokeCallbackWithFallback(callbacks, 'footer', this, tooltipItems);
        const afterFooter = invokeCallbackWithFallback(callbacks, 'afterFooter', this, tooltipItems);
        let lines = [];
        lines = pushOrConcat(lines, splitNewlines(beforeFooter));
        lines = pushOrConcat(lines, splitNewlines(footer));
        lines = pushOrConcat(lines, splitNewlines(afterFooter));
        return lines;
    }
 _createItems(options) {
        const active = this._active;
        const data = this.chart.data;
        const labelColors = [];
        const labelPointStyles = [];
        const labelTextColors = [];
        let tooltipItems = [];
        let i, len;
        for(i = 0, len = active.length; i < len; ++i){
            tooltipItems.push(createTooltipItem(this.chart, active[i]));
        }
        if (options.filter) {
            tooltipItems = tooltipItems.filter((element, index, array)=>options.filter(element, index, array, data));
        }
        if (options.itemSort) {
            tooltipItems = tooltipItems.sort((a, b)=>options.itemSort(a, b, data));
        }
        each(tooltipItems, (context)=>{
            const scoped = overrideCallbacks(options.callbacks, context);
            labelColors.push(invokeCallbackWithFallback(scoped, 'labelColor', this, context));
            labelPointStyles.push(invokeCallbackWithFallback(scoped, 'labelPointStyle', this, context));
            labelTextColors.push(invokeCallbackWithFallback(scoped, 'labelTextColor', this, context));
        });
        this.labelColors = labelColors;
        this.labelPointStyles = labelPointStyles;
        this.labelTextColors = labelTextColors;
        this.dataPoints = tooltipItems;
        return tooltipItems;
    }
    update(changed, replay) {
        const options = this.options.setContext(this.getContext());
        const active = this._active;
        let properties;
        let tooltipItems = [];
        if (!active.length) {
            if (this.opacity !== 0) {
                properties = {
                    opacity: 0
                };
            }
        } else {
            const position = positioners[options.position].call(this, active, this._eventPosition);
            tooltipItems = this._createItems(options);
            this.title = this.getTitle(tooltipItems, options);
            this.beforeBody = this.getBeforeBody(tooltipItems, options);
            this.body = this.getBody(tooltipItems, options);
            this.afterBody = this.getAfterBody(tooltipItems, options);
            this.footer = this.getFooter(tooltipItems, options);
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, size);
            const alignment = determineAlignment(this.chart, options, positionAndSize);
            const backgroundPoint = getBackgroundPoint(options, positionAndSize, alignment, this.chart);
            this.xAlign = alignment.xAlign;
            this.yAlign = alignment.yAlign;
            properties = {
                opacity: 1,
                x: backgroundPoint.x,
                y: backgroundPoint.y,
                width: size.width,
                height: size.height,
                caretX: position.x,
                caretY: position.y
            };
        }
        this._tooltipItems = tooltipItems;
        this.$context = undefined;
        if (properties) {
            this._resolveAnimations().update(this, properties);
        }
        if (changed && options.external) {
            options.external.call(this, {
                chart: this.chart,
                tooltip: this,
                replay
            });
        }
    }
    drawCaret(tooltipPoint, ctx, size, options) {
        const caretPosition = this.getCaretPosition(tooltipPoint, size, options);
        ctx.lineTo(caretPosition.x1, caretPosition.y1);
        ctx.lineTo(caretPosition.x2, caretPosition.y2);
        ctx.lineTo(caretPosition.x3, caretPosition.y3);
    }
    getCaretPosition(tooltipPoint, size, options) {
        const { xAlign , yAlign  } = this;
        const { caretSize , cornerRadius  } = options;
        const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(cornerRadius);
        const { x: ptX , y: ptY  } = tooltipPoint;
        const { width , height  } = size;
        let x1, x2, x3, y1, y2, y3;
        if (yAlign === 'center') {
            y2 = ptY + height / 2;
            if (xAlign === 'left') {
                x1 = ptX;
                x2 = x1 - caretSize;
                y1 = y2 + caretSize;
                y3 = y2 - caretSize;
            } else {
                x1 = ptX + width;
                x2 = x1 + caretSize;
                y1 = y2 - caretSize;
                y3 = y2 + caretSize;
            }
            x3 = x1;
        } else {
            if (xAlign === 'left') {
                x2 = ptX + Math.max(topLeft, bottomLeft) + caretSize;
            } else if (xAlign === 'right') {
                x2 = ptX + width - Math.max(topRight, bottomRight) - caretSize;
            } else {
                x2 = this.caretX;
            }
            if (yAlign === 'top') {
                y1 = ptY;
                y2 = y1 - caretSize;
                x1 = x2 - caretSize;
                x3 = x2 + caretSize;
            } else {
                y1 = ptY + height;
                y2 = y1 + caretSize;
                x1 = x2 + caretSize;
                x3 = x2 - caretSize;
            }
            y3 = y1;
        }
        return {
            x1,
            x2,
            x3,
            y1,
            y2,
            y3
        };
    }
    drawTitle(pt, ctx, options) {
        const title = this.title;
        const length = title.length;
        let titleFont, titleSpacing, i;
        if (length) {
            const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.titleAlign, options);
            ctx.textAlign = rtlHelper.textAlign(options.titleAlign);
            ctx.textBaseline = 'middle';
            titleFont = toFont(options.titleFont);
            titleSpacing = options.titleSpacing;
            ctx.fillStyle = options.titleColor;
            ctx.font = titleFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFont.lineHeight / 2);
                pt.y += titleFont.lineHeight + titleSpacing;
                if (i + 1 === length) {
                    pt.y += options.titleMarginBottom - titleSpacing;
                }
            }
        }
    }
 _drawColorBox(ctx, pt, i, rtlHelper, options) {
        const labelColor = this.labelColors[i];
        const labelPointStyle = this.labelPointStyles[i];
        const { boxHeight , boxWidth  } = options;
        const bodyFont = toFont(options.bodyFont);
        const colorX = getAlignedX(this, 'left', options);
        const rtlColorX = rtlHelper.x(colorX);
        const yOffSet = boxHeight < bodyFont.lineHeight ? (bodyFont.lineHeight - boxHeight) / 2 : 0;
        const colorY = pt.y + yOffSet;
        if (options.usePointStyle) {
            const drawOptions = {
                radius: Math.min(boxWidth, boxHeight) / 2,
                pointStyle: labelPointStyle.pointStyle,
                rotation: labelPointStyle.rotation,
                borderWidth: 1
            };
            const centerX = rtlHelper.leftForLtr(rtlColorX, boxWidth) + boxWidth / 2;
            const centerY = colorY + boxHeight / 2;
            ctx.strokeStyle = options.multiKeyBackground;
            ctx.fillStyle = options.multiKeyBackground;
            drawPoint(ctx, drawOptions, centerX, centerY);
            ctx.strokeStyle = labelColor.borderColor;
            ctx.fillStyle = labelColor.backgroundColor;
            drawPoint(ctx, drawOptions, centerX, centerY);
        } else {
            ctx.lineWidth = isObject(labelColor.borderWidth) ? Math.max(...Object.values(labelColor.borderWidth)) : labelColor.borderWidth || 1;
            ctx.strokeStyle = labelColor.borderColor;
            ctx.setLineDash(labelColor.borderDash || []);
            ctx.lineDashOffset = labelColor.borderDashOffset || 0;
            const outerX = rtlHelper.leftForLtr(rtlColorX, boxWidth);
            const innerX = rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), boxWidth - 2);
            const borderRadius = toTRBLCorners(labelColor.borderRadius);
            if (Object.values(borderRadius).some((v)=>v !== 0)) {
                ctx.beginPath();
                ctx.fillStyle = options.multiKeyBackground;
                addRoundedRectPath(ctx, {
                    x: outerX,
                    y: colorY,
                    w: boxWidth,
                    h: boxHeight,
                    radius: borderRadius
                });
                ctx.fill();
                ctx.stroke();
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.beginPath();
                addRoundedRectPath(ctx, {
                    x: innerX,
                    y: colorY + 1,
                    w: boxWidth - 2,
                    h: boxHeight - 2,
                    radius: borderRadius
                });
                ctx.fill();
            } else {
                ctx.fillStyle = options.multiKeyBackground;
                ctx.fillRect(outerX, colorY, boxWidth, boxHeight);
                ctx.strokeRect(outerX, colorY, boxWidth, boxHeight);
                ctx.fillStyle = labelColor.backgroundColor;
                ctx.fillRect(innerX, colorY + 1, boxWidth - 2, boxHeight - 2);
            }
        }
        ctx.fillStyle = this.labelTextColors[i];
    }
    drawBody(pt, ctx, options) {
        const { body  } = this;
        const { bodySpacing , bodyAlign , displayColors , boxHeight , boxWidth , boxPadding  } = options;
        const bodyFont = toFont(options.bodyFont);
        let bodyLineHeight = bodyFont.lineHeight;
        let xLinePadding = 0;
        const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
        const fillLineOfText = function(line) {
            ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyLineHeight / 2);
            pt.y += bodyLineHeight + bodySpacing;
        };
        const bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
        let bodyItem, textColor, lines, i, j, ilen, jlen;
        ctx.textAlign = bodyAlign;
        ctx.textBaseline = 'middle';
        ctx.font = bodyFont.string;
        pt.x = getAlignedX(this, bodyAlignForCalculation, options);
        ctx.fillStyle = options.bodyColor;
        each(this.beforeBody, fillLineOfText);
        xLinePadding = displayColors && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? boxWidth / 2 + boxPadding : boxWidth + 2 + boxPadding : 0;
        for(i = 0, ilen = body.length; i < ilen; ++i){
            bodyItem = body[i];
            textColor = this.labelTextColors[i];
            ctx.fillStyle = textColor;
            each(bodyItem.before, fillLineOfText);
            lines = bodyItem.lines;
            if (displayColors && lines.length) {
                this._drawColorBox(ctx, pt, i, rtlHelper, options);
                bodyLineHeight = Math.max(bodyFont.lineHeight, boxHeight);
            }
            for(j = 0, jlen = lines.length; j < jlen; ++j){
                fillLineOfText(lines[j]);
                bodyLineHeight = bodyFont.lineHeight;
            }
            each(bodyItem.after, fillLineOfText);
        }
        xLinePadding = 0;
        bodyLineHeight = bodyFont.lineHeight;
        each(this.afterBody, fillLineOfText);
        pt.y -= bodySpacing;
    }
    drawFooter(pt, ctx, options) {
        const footer = this.footer;
        const length = footer.length;
        let footerFont, i;
        if (length) {
            const rtlHelper = getRtlAdapter(options.rtl, this.x, this.width);
            pt.x = getAlignedX(this, options.footerAlign, options);
            pt.y += options.footerMarginTop;
            ctx.textAlign = rtlHelper.textAlign(options.footerAlign);
            ctx.textBaseline = 'middle';
            footerFont = toFont(options.footerFont);
            ctx.fillStyle = options.footerColor;
            ctx.font = footerFont.string;
            for(i = 0; i < length; ++i){
                ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFont.lineHeight / 2);
                pt.y += footerFont.lineHeight + options.footerSpacing;
            }
        }
    }
    drawBackground(pt, ctx, tooltipSize, options) {
        const { xAlign , yAlign  } = this;
        const { x , y  } = pt;
        const { width , height  } = tooltipSize;
        const { topLeft , topRight , bottomLeft , bottomRight  } = toTRBLCorners(options.cornerRadius);
        ctx.fillStyle = options.backgroundColor;
        ctx.strokeStyle = options.borderColor;
        ctx.lineWidth = options.borderWidth;
        ctx.beginPath();
        ctx.moveTo(x + topLeft, y);
        if (yAlign === 'top') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + width - topRight, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + topRight);
        if (yAlign === 'center' && xAlign === 'right') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + width, y + height - bottomRight);
        ctx.quadraticCurveTo(x + width, y + height, x + width - bottomRight, y + height);
        if (yAlign === 'bottom') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x + bottomLeft, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - bottomLeft);
        if (yAlign === 'center' && xAlign === 'left') {
            this.drawCaret(pt, ctx, tooltipSize, options);
        }
        ctx.lineTo(x, y + topLeft);
        ctx.quadraticCurveTo(x, y, x + topLeft, y);
        ctx.closePath();
        ctx.fill();
        if (options.borderWidth > 0) {
            ctx.stroke();
        }
    }
 _updateAnimationTarget(options) {
        const chart = this.chart;
        const anims = this.$animations;
        const animX = anims && anims.x;
        const animY = anims && anims.y;
        if (animX || animY) {
            const position = positioners[options.position].call(this, this._active, this._eventPosition);
            if (!position) {
                return;
            }
            const size = this._size = getTooltipSize(this, options);
            const positionAndSize = Object.assign({}, position, this._size);
            const alignment = determineAlignment(chart, options, positionAndSize);
            const point = getBackgroundPoint(options, positionAndSize, alignment, chart);
            if (animX._to !== point.x || animY._to !== point.y) {
                this.xAlign = alignment.xAlign;
                this.yAlign = alignment.yAlign;
                this.width = size.width;
                this.height = size.height;
                this.caretX = position.x;
                this.caretY = position.y;
                this._resolveAnimations().update(this, point);
            }
        }
    }
 _willRender() {
        return !!this.opacity;
    }
    draw(ctx) {
        const options = this.options.setContext(this.getContext());
        let opacity = this.opacity;
        if (!opacity) {
            return;
        }
        this._updateAnimationTarget(options);
        const tooltipSize = {
            width: this.width,
            height: this.height
        };
        const pt = {
            x: this.x,
            y: this.y
        };
        opacity = Math.abs(opacity) < 1e-3 ? 0 : opacity;
        const padding = toPadding(options.padding);
        const hasTooltipContent = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
        if (options.enabled && hasTooltipContent) {
            ctx.save();
            ctx.globalAlpha = opacity;
            this.drawBackground(pt, ctx, tooltipSize, options);
            overrideTextDirection(ctx, options.textDirection);
            pt.y += padding.top;
            this.drawTitle(pt, ctx, options);
            this.drawBody(pt, ctx, options);
            this.drawFooter(pt, ctx, options);
            restoreTextDirection(ctx, options.textDirection);
            ctx.restore();
        }
    }
 getActiveElements() {
        return this._active || [];
    }
 setActiveElements(activeElements, eventPosition) {
        const lastActive = this._active;
        const active = activeElements.map(({ datasetIndex , index  })=>{
            const meta = this.chart.getDatasetMeta(datasetIndex);
            if (!meta) {
                throw new Error('Cannot find a dataset at index ' + datasetIndex);
            }
            return {
                datasetIndex,
                element: meta.data[index],
                index
            };
        });
        const changed = !_elementsEqual(lastActive, active);
        const positionChanged = this._positionChanged(active, eventPosition);
        if (changed || positionChanged) {
            this._active = active;
            this._eventPosition = eventPosition;
            this._ignoreReplayEvents = true;
            this.update(true);
        }
    }
 handleEvent(e, replay, inChartArea = true) {
        if (replay && this._ignoreReplayEvents) {
            return false;
        }
        this._ignoreReplayEvents = false;
        const options = this.options;
        const lastActive = this._active || [];
        const active = this._getActiveElements(e, lastActive, replay, inChartArea);
        const positionChanged = this._positionChanged(active, e);
        const changed = replay || !_elementsEqual(active, lastActive) || positionChanged;
        if (changed) {
            this._active = active;
            if (options.enabled || options.external) {
                this._eventPosition = {
                    x: e.x,
                    y: e.y
                };
                this.update(true, replay);
            }
        }
        return changed;
    }
 _getActiveElements(e, lastActive, replay, inChartArea) {
        const options = this.options;
        if (e.type === 'mouseout') {
            return [];
        }
        if (!inChartArea) {
            return lastActive.filter((i)=>this.chart.data.datasets[i.datasetIndex] && this.chart.getDatasetMeta(i.datasetIndex).controller.getParsed(i.index) !== undefined);
        }
        const active = this.chart.getElementsAtEventForMode(e, options.mode, options, replay);
        if (options.reverse) {
            active.reverse();
        }
        return active;
    }
 _positionChanged(active, e) {
        const { caretX , caretY , options  } = this;
        const position = positioners[options.position].call(this, active, e);
        return position !== false && (caretX !== position.x || caretY !== position.y);
    }
}
var plugin_tooltip = {
    id: 'tooltip',
    _element: Tooltip,
    positioners,
    afterInit (chart, _args, options) {
        if (options) {
            chart.tooltip = new Tooltip({
                chart,
                options
            });
        }
    },
    beforeUpdate (chart, _args, options) {
        if (chart.tooltip) {
            chart.tooltip.initialize(options);
        }
    },
    reset (chart, _args, options) {
        if (chart.tooltip) {
            chart.tooltip.initialize(options);
        }
    },
    afterDraw (chart) {
        const tooltip = chart.tooltip;
        if (tooltip && tooltip._willRender()) {
            const args = {
                tooltip
            };
            if (chart.notifyPlugins('beforeTooltipDraw', {
                ...args,
                cancelable: true
            }) === false) {
                return;
            }
            tooltip.draw(chart.ctx);
            chart.notifyPlugins('afterTooltipDraw', args);
        }
    },
    afterEvent (chart, args) {
        if (chart.tooltip) {
            const useFinalPosition = args.replay;
            if (chart.tooltip.handleEvent(args.event, useFinalPosition, args.inChartArea)) {
                args.changed = true;
            }
        }
    },
    defaults: {
        enabled: true,
        external: null,
        position: 'average',
        backgroundColor: 'rgba(0,0,0,0.8)',
        titleColor: '#fff',
        titleFont: {
            weight: 'bold'
        },
        titleSpacing: 2,
        titleMarginBottom: 6,
        titleAlign: 'left',
        bodyColor: '#fff',
        bodySpacing: 2,
        bodyFont: {},
        bodyAlign: 'left',
        footerColor: '#fff',
        footerSpacing: 2,
        footerMarginTop: 6,
        footerFont: {
            weight: 'bold'
        },
        footerAlign: 'left',
        padding: 6,
        caretPadding: 2,
        caretSize: 5,
        cornerRadius: 6,
        boxHeight: (ctx, opts)=>opts.bodyFont.size,
        boxWidth: (ctx, opts)=>opts.bodyFont.size,
        multiKeyBackground: '#fff',
        displayColors: true,
        boxPadding: 0,
        borderColor: 'rgba(0,0,0,0)',
        borderWidth: 0,
        animation: {
            duration: 400,
            easing: 'easeOutQuart'
        },
        animations: {
            numbers: {
                type: 'number',
                properties: [
                    'x',
                    'y',
                    'width',
                    'height',
                    'caretX',
                    'caretY'
                ]
            },
            opacity: {
                easing: 'linear',
                duration: 200
            }
        },
        callbacks: defaultCallbacks
    },
    defaultRoutes: {
        bodyFont: 'font',
        footerFont: 'font',
        titleFont: 'font'
    },
    descriptors: {
        _scriptable: (name)=>name !== 'filter' && name !== 'itemSort' && name !== 'external',
        _indexable: false,
        callbacks: {
            _scriptable: false,
            _indexable: false
        },
        animation: {
            _fallback: false
        },
        animations: {
            _fallback: 'animation'
        }
    },
    additionalOptionScopes: [
        'interaction'
    ]
};

const addIfString = (labels, raw, index, addedLabels)=>{
    if (typeof raw === 'string') {
        index = labels.push(raw) - 1;
        addedLabels.unshift({
            index,
            label: raw
        });
    } else if (isNaN(raw)) {
        index = null;
    }
    return index;
};
function findOrAddLabel(labels, raw, index, addedLabels) {
    const first = labels.indexOf(raw);
    if (first === -1) {
        return addIfString(labels, raw, index, addedLabels);
    }
    const last = labels.lastIndexOf(raw);
    return first !== last ? index : first;
}
const validIndex = (index, max)=>index === null ? null : _limitValue(Math.round(index), 0, max);
function _getLabelForValue(value) {
    const labels = this.getLabels();
    if (value >= 0 && value < labels.length) {
        return labels[value];
    }
    return value;
}
class CategoryScale extends Scale {
    static id = 'category';
 static defaults = {
        ticks: {
            callback: _getLabelForValue
        }
    };
    constructor(cfg){
        super(cfg);
         this._startValue = undefined;
        this._valueRange = 0;
        this._addedLabels = [];
    }
    init(scaleOptions) {
        const added = this._addedLabels;
        if (added.length) {
            const labels = this.getLabels();
            for (const { index , label  } of added){
                if (labels[index] === label) {
                    labels.splice(index, 1);
                }
            }
            this._addedLabels = [];
        }
        super.init(scaleOptions);
    }
    parse(raw, index) {
        if (isNullOrUndef(raw)) {
            return null;
        }
        const labels = this.getLabels();
        index = isFinite(index) && labels[index] === raw ? index : findOrAddLabel(labels, raw, valueOrDefault(index, raw), this._addedLabels);
        return validIndex(index, labels.length - 1);
    }
    determineDataLimits() {
        const { minDefined , maxDefined  } = this.getUserBounds();
        let { min , max  } = this.getMinMax(true);
        if (this.options.bounds === 'ticks') {
            if (!minDefined) {
                min = 0;
            }
            if (!maxDefined) {
                max = this.getLabels().length - 1;
            }
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const min = this.min;
        const max = this.max;
        const offset = this.options.offset;
        const ticks = [];
        let labels = this.getLabels();
        labels = min === 0 && max === labels.length - 1 ? labels : labels.slice(min, max + 1);
        this._valueRange = Math.max(labels.length - (offset ? 0 : 1), 1);
        this._startValue = this.min - (offset ? 0.5 : 0);
        for(let value = min; value <= max; value++){
            ticks.push({
                value
            });
        }
        return ticks;
    }
    getLabelForValue(value) {
        return _getLabelForValue.call(this, value);
    }
 configure() {
        super.configure();
        if (!this.isHorizontal()) {
            this._reversePixels = !this._reversePixels;
        }
    }
    getPixelForValue(value) {
        if (typeof value !== 'number') {
            value = this.parse(value);
        }
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getPixelForTick(index) {
        const ticks = this.ticks;
        if (index < 0 || index > ticks.length - 1) {
            return null;
        }
        return this.getPixelForValue(ticks[index].value);
    }
    getValueForPixel(pixel) {
        return Math.round(this._startValue + this.getDecimalForPixel(pixel) * this._valueRange);
    }
    getBasePixel() {
        return this.bottom;
    }
}

function generateTicks$1(generationOptions, dataRange) {
    const ticks = [];
    const MIN_SPACING = 1e-14;
    const { bounds , step , min , max , precision , count , maxTicks , maxDigits , includeBounds  } = generationOptions;
    const unit = step || 1;
    const maxSpaces = maxTicks - 1;
    const { min: rmin , max: rmax  } = dataRange;
    const minDefined = !isNullOrUndef(min);
    const maxDefined = !isNullOrUndef(max);
    const countDefined = !isNullOrUndef(count);
    const minSpacing = (rmax - rmin) / (maxDigits + 1);
    let spacing = niceNum((rmax - rmin) / maxSpaces / unit) * unit;
    let factor, niceMin, niceMax, numSpaces;
    if (spacing < MIN_SPACING && !minDefined && !maxDefined) {
        return [
            {
                value: rmin
            },
            {
                value: rmax
            }
        ];
    }
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxSpaces) {
        spacing = niceNum(numSpaces * spacing / maxSpaces / unit) * unit;
    }
    if (!isNullOrUndef(precision)) {
        factor = Math.pow(10, precision);
        spacing = Math.ceil(spacing * factor) / factor;
    }
    if (bounds === 'ticks') {
        niceMin = Math.floor(rmin / spacing) * spacing;
        niceMax = Math.ceil(rmax / spacing) * spacing;
    } else {
        niceMin = rmin;
        niceMax = rmax;
    }
    if (minDefined && maxDefined && step && almostWhole((max - min) / step, spacing / 1000)) {
        numSpaces = Math.round(Math.min((max - min) / spacing, maxTicks));
        spacing = (max - min) / numSpaces;
        niceMin = min;
        niceMax = max;
    } else if (countDefined) {
        niceMin = minDefined ? min : niceMin;
        niceMax = maxDefined ? max : niceMax;
        numSpaces = count - 1;
        spacing = (niceMax - niceMin) / numSpaces;
    } else {
        numSpaces = (niceMax - niceMin) / spacing;
        if (almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
            numSpaces = Math.round(numSpaces);
        } else {
            numSpaces = Math.ceil(numSpaces);
        }
    }
    const decimalPlaces = Math.max(_decimalPlaces(spacing), _decimalPlaces(niceMin));
    factor = Math.pow(10, isNullOrUndef(precision) ? decimalPlaces : precision);
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    let j = 0;
    if (minDefined) {
        if (includeBounds && niceMin !== min) {
            ticks.push({
                value: min
            });
            if (niceMin < min) {
                j++;
            }
            if (almostEquals(Math.round((niceMin + j * spacing) * factor) / factor, min, relativeLabelSize(min, minSpacing, generationOptions))) {
                j++;
            }
        } else if (niceMin < min) {
            j++;
        }
    }
    for(; j < numSpaces; ++j){
        const tickValue = Math.round((niceMin + j * spacing) * factor) / factor;
        if (maxDefined && tickValue > max) {
            break;
        }
        ticks.push({
            value: tickValue
        });
    }
    if (maxDefined && includeBounds && niceMax !== max) {
        if (ticks.length && almostEquals(ticks[ticks.length - 1].value, max, relativeLabelSize(max, minSpacing, generationOptions))) {
            ticks[ticks.length - 1].value = max;
        } else {
            ticks.push({
                value: max
            });
        }
    } else if (!maxDefined || niceMax === max) {
        ticks.push({
            value: niceMax
        });
    }
    return ticks;
}
function relativeLabelSize(value, minSpacing, { horizontal , minRotation  }) {
    const rad = toRadians(minRotation);
    const ratio = (horizontal ? Math.sin(rad) : Math.cos(rad)) || 0.001;
    const length = 0.75 * minSpacing * ('' + value).length;
    return Math.min(minSpacing / ratio, length);
}
class LinearScaleBase extends Scale {
    constructor(cfg){
        super(cfg);
         this.start = undefined;
         this.end = undefined;
         this._startValue = undefined;
         this._endValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        if (isNullOrUndef(raw)) {
            return null;
        }
        if ((typeof raw === 'number' || raw instanceof Number) && !isFinite(+raw)) {
            return null;
        }
        return +raw;
    }
    handleTickRangeOptions() {
        const { beginAtZero  } = this.options;
        const { minDefined , maxDefined  } = this.getUserBounds();
        let { min , max  } = this;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (beginAtZero) {
            const minSign = sign(min);
            const maxSign = sign(max);
            if (minSign < 0 && maxSign < 0) {
                setMax(0);
            } else if (minSign > 0 && maxSign > 0) {
                setMin(0);
            }
        }
        if (min === max) {
            let offset = max === 0 ? 1 : Math.abs(max * 0.05);
            setMax(max + offset);
            if (!beginAtZero) {
                setMin(min - offset);
            }
        }
        this.min = min;
        this.max = max;
    }
    getTickLimit() {
        const tickOpts = this.options.ticks;
        let { maxTicksLimit , stepSize  } = tickOpts;
        let maxTicks;
        if (stepSize) {
            maxTicks = Math.ceil(this.max / stepSize) - Math.floor(this.min / stepSize) + 1;
            if (maxTicks > 1000) {
                console.warn(`scales.${this.id}.ticks.stepSize: ${stepSize} would result generating up to ${maxTicks} ticks. Limiting to 1000.`);
                maxTicks = 1000;
            }
        } else {
            maxTicks = this.computeTickLimit();
            maxTicksLimit = maxTicksLimit || 11;
        }
        if (maxTicksLimit) {
            maxTicks = Math.min(maxTicksLimit, maxTicks);
        }
        return maxTicks;
    }
 computeTickLimit() {
        return Number.POSITIVE_INFINITY;
    }
    buildTicks() {
        const opts = this.options;
        const tickOpts = opts.ticks;
        let maxTicks = this.getTickLimit();
        maxTicks = Math.max(2, maxTicks);
        const numericGeneratorOptions = {
            maxTicks,
            bounds: opts.bounds,
            min: opts.min,
            max: opts.max,
            precision: tickOpts.precision,
            step: tickOpts.stepSize,
            count: tickOpts.count,
            maxDigits: this._maxDigits(),
            horizontal: this.isHorizontal(),
            minRotation: tickOpts.minRotation || 0,
            includeBounds: tickOpts.includeBounds !== false
        };
        const dataRange = this._range || this;
        const ticks = generateTicks$1(numericGeneratorOptions, dataRange);
        if (opts.bounds === 'ticks') {
            _setMinAndMaxByKey(ticks, this, 'value');
        }
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
 configure() {
        const ticks = this.ticks;
        let start = this.min;
        let end = this.max;
        super.configure();
        if (this.options.offset && ticks.length) {
            const offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
            start -= offset;
            end += offset;
        }
        this._startValue = start;
        this._endValue = end;
        this._valueRange = end - start;
    }
    getLabelForValue(value) {
        return formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
}

class LinearScale extends LinearScaleBase {
    static id = 'linear';
 static defaults = {
        ticks: {
            callback: Ticks.formatters.numeric
        }
    };
    determineDataLimits() {
        const { min , max  } = this.getMinMax(true);
        this.min = isNumberFinite(min) ? min : 0;
        this.max = isNumberFinite(max) ? max : 1;
        this.handleTickRangeOptions();
    }
 computeTickLimit() {
        const horizontal = this.isHorizontal();
        const length = horizontal ? this.width : this.height;
        const minRotation = toRadians(this.options.ticks.minRotation);
        const ratio = (horizontal ? Math.sin(minRotation) : Math.cos(minRotation)) || 0.001;
        const tickFont = this._resolveTickFontOptions(0);
        return Math.ceil(length / Math.min(40, tickFont.lineHeight / ratio));
    }
    getPixelForValue(value) {
        return value === null ? NaN : this.getPixelForDecimal((value - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    }
}

const log10Floor = (v)=>Math.floor(log10(v));
const changeExponent = (v, m)=>Math.pow(10, log10Floor(v) + m);
function isMajor(tickVal) {
    const remain = tickVal / Math.pow(10, log10Floor(tickVal));
    return remain === 1;
}
function steps(min, max, rangeExp) {
    const rangeStep = Math.pow(10, rangeExp);
    const start = Math.floor(min / rangeStep);
    const end = Math.ceil(max / rangeStep);
    return end - start;
}
function startExp(min, max) {
    const range = max - min;
    let rangeExp = log10Floor(range);
    while(steps(min, max, rangeExp) > 10){
        rangeExp++;
    }
    while(steps(min, max, rangeExp) < 10){
        rangeExp--;
    }
    return Math.min(rangeExp, log10Floor(min));
}
 function generateTicks(generationOptions, { min , max  }) {
    min = finiteOrDefault(generationOptions.min, min);
    const ticks = [];
    const minExp = log10Floor(min);
    let exp = startExp(min, max);
    let precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    const stepSize = Math.pow(10, exp);
    const base = minExp > exp ? Math.pow(10, minExp) : 0;
    const start = Math.round((min - base) * precision) / precision;
    const offset = Math.floor((min - base) / stepSize / 10) * stepSize * 10;
    let significand = Math.floor((start - offset) / Math.pow(10, exp));
    let value = finiteOrDefault(generationOptions.min, Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision);
    while(value < max){
        ticks.push({
            value,
            major: isMajor(value),
            significand
        });
        if (significand >= 10) {
            significand = significand < 15 ? 15 : 20;
        } else {
            significand++;
        }
        if (significand >= 20) {
            exp++;
            significand = 2;
            precision = exp >= 0 ? 1 : precision;
        }
        value = Math.round((base + offset + significand * Math.pow(10, exp)) * precision) / precision;
    }
    const lastTick = finiteOrDefault(generationOptions.max, value);
    ticks.push({
        value: lastTick,
        major: isMajor(lastTick),
        significand
    });
    return ticks;
}
class LogarithmicScale extends Scale {
    static id = 'logarithmic';
 static defaults = {
        ticks: {
            callback: Ticks.formatters.logarithmic,
            major: {
                enabled: true
            }
        }
    };
    constructor(cfg){
        super(cfg);
         this.start = undefined;
         this.end = undefined;
         this._startValue = undefined;
        this._valueRange = 0;
    }
    parse(raw, index) {
        const value = LinearScaleBase.prototype.parse.apply(this, [
            raw,
            index
        ]);
        if (value === 0) {
            this._zero = true;
            return undefined;
        }
        return isNumberFinite(value) && value > 0 ? value : null;
    }
    determineDataLimits() {
        const { min , max  } = this.getMinMax(true);
        this.min = isNumberFinite(min) ? Math.max(0, min) : null;
        this.max = isNumberFinite(max) ? Math.max(0, max) : null;
        if (this.options.beginAtZero) {
            this._zero = true;
        }
        if (this._zero && this.min !== this._suggestedMin && !isNumberFinite(this._userMin)) {
            this.min = min === changeExponent(this.min, 0) ? changeExponent(this.min, -1) : changeExponent(this.min, 0);
        }
        this.handleTickRangeOptions();
    }
    handleTickRangeOptions() {
        const { minDefined , maxDefined  } = this.getUserBounds();
        let min = this.min;
        let max = this.max;
        const setMin = (v)=>min = minDefined ? min : v;
        const setMax = (v)=>max = maxDefined ? max : v;
        if (min === max) {
            if (min <= 0) {
                setMin(1);
                setMax(10);
            } else {
                setMin(changeExponent(min, -1));
                setMax(changeExponent(max, +1));
            }
        }
        if (min <= 0) {
            setMin(changeExponent(max, -1));
        }
        if (max <= 0) {
            setMax(changeExponent(min, +1));
        }
        this.min = min;
        this.max = max;
    }
    buildTicks() {
        const opts = this.options;
        const generationOptions = {
            min: this._userMin,
            max: this._userMax
        };
        const ticks = generateTicks(generationOptions, this);
        if (opts.bounds === 'ticks') {
            _setMinAndMaxByKey(ticks, this, 'value');
        }
        if (opts.reverse) {
            ticks.reverse();
            this.start = this.max;
            this.end = this.min;
        } else {
            this.start = this.min;
            this.end = this.max;
        }
        return ticks;
    }
 getLabelForValue(value) {
        return value === undefined ? '0' : formatNumber(value, this.chart.options.locale, this.options.ticks.format);
    }
 configure() {
        const start = this.min;
        super.configure();
        this._startValue = log10(start);
        this._valueRange = log10(this.max) - log10(start);
    }
    getPixelForValue(value) {
        if (value === undefined || value === 0) {
            value = this.min;
        }
        if (value === null || isNaN(value)) {
            return NaN;
        }
        return this.getPixelForDecimal(value === this.min ? 0 : (log10(value) - this._startValue) / this._valueRange);
    }
    getValueForPixel(pixel) {
        const decimal = this.getDecimalForPixel(pixel);
        return Math.pow(10, this._startValue + decimal * this._valueRange);
    }
}

function getTickBackdropHeight(opts) {
    const tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
        const padding = toPadding(tickOpts.backdropPadding);
        return valueOrDefault(tickOpts.font && tickOpts.font.size, defaults.font.size) + padding.height;
    }
    return 0;
}
function measureLabelSize(ctx, font, label) {
    label = isArray(label) ? label : [
        label
    ];
    return {
        w: _longestText(ctx, font.string, label),
        h: label.length * font.lineHeight
    };
}
function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) {
        return {
            start: pos - size / 2,
            end: pos + size / 2
        };
    } else if (angle < min || angle > max) {
        return {
            start: pos - size,
            end: pos
        };
    }
    return {
        start: pos,
        end: pos + size
    };
}
 function fitWithPointLabels(scale) {
    const orig = {
        l: scale.left + scale._padding.left,
        r: scale.right - scale._padding.right,
        t: scale.top + scale._padding.top,
        b: scale.bottom - scale._padding.bottom
    };
    const limits = Object.assign({}, orig);
    const labelSizes = [];
    const padding = [];
    const valueCount = scale._pointLabels.length;
    const pointLabelOpts = scale.options.pointLabels;
    const additionalAngle = pointLabelOpts.centerPointLabels ? PI / valueCount : 0;
    for(let i = 0; i < valueCount; i++){
        const opts = pointLabelOpts.setContext(scale.getPointLabelContext(i));
        padding[i] = opts.padding;
        const pointPosition = scale.getPointPosition(i, scale.drawingArea + padding[i], additionalAngle);
        const plFont = toFont(opts.font);
        const textSize = measureLabelSize(scale.ctx, plFont, scale._pointLabels[i]);
        labelSizes[i] = textSize;
        const angleRadians = _normalizeAngle(scale.getIndexAngle(i) + additionalAngle);
        const angle = Math.round(toDegrees(angleRadians));
        const hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
        const vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
        updateLimits(limits, orig, angleRadians, hLimits, vLimits);
    }
    scale.setCenterPoint(orig.l - limits.l, limits.r - orig.r, orig.t - limits.t, limits.b - orig.b);
    scale._pointLabelItems = buildPointLabelItems(scale, labelSizes, padding);
}
function updateLimits(limits, orig, angle, hLimits, vLimits) {
    const sin = Math.abs(Math.sin(angle));
    const cos = Math.abs(Math.cos(angle));
    let x = 0;
    let y = 0;
    if (hLimits.start < orig.l) {
        x = (orig.l - hLimits.start) / sin;
        limits.l = Math.min(limits.l, orig.l - x);
    } else if (hLimits.end > orig.r) {
        x = (hLimits.end - orig.r) / sin;
        limits.r = Math.max(limits.r, orig.r + x);
    }
    if (vLimits.start < orig.t) {
        y = (orig.t - vLimits.start) / cos;
        limits.t = Math.min(limits.t, orig.t - y);
    } else if (vLimits.end > orig.b) {
        y = (vLimits.end - orig.b) / cos;
        limits.b = Math.max(limits.b, orig.b + y);
    }
}
function createPointLabelItem(scale, index, itemOpts) {
    const outerDistance = scale.drawingArea;
    const { extra , additionalAngle , padding , size  } = itemOpts;
    const pointLabelPosition = scale.getPointPosition(index, outerDistance + extra + padding, additionalAngle);
    const angle = Math.round(toDegrees(_normalizeAngle(pointLabelPosition.angle + HALF_PI)));
    const y = yForAngle(pointLabelPosition.y, size.h, angle);
    const textAlign = getTextAlignForAngle(angle);
    const left = leftForTextAlign(pointLabelPosition.x, size.w, textAlign);
    return {
        visible: true,
        x: pointLabelPosition.x,
        y,
        textAlign,
        left,
        top: y,
        right: left + size.w,
        bottom: y + size.h
    };
}
function isNotOverlapped(item, area) {
    if (!area) {
        return true;
    }
    const { left , top , right , bottom  } = item;
    const apexesInArea = _isPointInArea({
        x: left,
        y: top
    }, area) || _isPointInArea({
        x: left,
        y: bottom
    }, area) || _isPointInArea({
        x: right,
        y: top
    }, area) || _isPointInArea({
        x: right,
        y: bottom
    }, area);
    return !apexesInArea;
}
function buildPointLabelItems(scale, labelSizes, padding) {
    const items = [];
    const valueCount = scale._pointLabels.length;
    const opts = scale.options;
    const { centerPointLabels , display  } = opts.pointLabels;
    const itemOpts = {
        extra: getTickBackdropHeight(opts) / 2,
        additionalAngle: centerPointLabels ? PI / valueCount : 0
    };
    let area;
    for(let i = 0; i < valueCount; i++){
        itemOpts.padding = padding[i];
        itemOpts.size = labelSizes[i];
        const item = createPointLabelItem(scale, i, itemOpts);
        items.push(item);
        if (display === 'auto') {
            item.visible = isNotOverlapped(item, area);
            if (item.visible) {
                area = item;
            }
        }
    }
    return items;
}
function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) {
        return 'center';
    } else if (angle < 180) {
        return 'left';
    }
    return 'right';
}
function leftForTextAlign(x, w, align) {
    if (align === 'right') {
        x -= w;
    } else if (align === 'center') {
        x -= w / 2;
    }
    return x;
}
function yForAngle(y, h, angle) {
    if (angle === 90 || angle === 270) {
        y -= h / 2;
    } else if (angle > 270 || angle < 90) {
        y -= h;
    }
    return y;
}
function drawPointLabelBox(ctx, opts, item) {
    const { left , top , right , bottom  } = item;
    const { backdropColor  } = opts;
    if (!isNullOrUndef(backdropColor)) {
        const borderRadius = toTRBLCorners(opts.borderRadius);
        const padding = toPadding(opts.backdropPadding);
        ctx.fillStyle = backdropColor;
        const backdropLeft = left - padding.left;
        const backdropTop = top - padding.top;
        const backdropWidth = right - left + padding.width;
        const backdropHeight = bottom - top + padding.height;
        if (Object.values(borderRadius).some((v)=>v !== 0)) {
            ctx.beginPath();
            addRoundedRectPath(ctx, {
                x: backdropLeft,
                y: backdropTop,
                w: backdropWidth,
                h: backdropHeight,
                radius: borderRadius
            });
            ctx.fill();
        } else {
            ctx.fillRect(backdropLeft, backdropTop, backdropWidth, backdropHeight);
        }
    }
}
function drawPointLabels(scale, labelCount) {
    const { ctx , options: { pointLabels  }  } = scale;
    for(let i = labelCount - 1; i >= 0; i--){
        const item = scale._pointLabelItems[i];
        if (!item.visible) {
            continue;
        }
        const optsAtIndex = pointLabels.setContext(scale.getPointLabelContext(i));
        drawPointLabelBox(ctx, optsAtIndex, item);
        const plFont = toFont(optsAtIndex.font);
        const { x , y , textAlign  } = item;
        renderText(ctx, scale._pointLabels[i], x, y + plFont.lineHeight / 2, plFont, {
            color: optsAtIndex.color,
            textAlign: textAlign,
            textBaseline: 'middle'
        });
    }
}
function pathRadiusLine(scale, radius, circular, labelCount) {
    const { ctx  } = scale;
    if (circular) {
        ctx.arc(scale.xCenter, scale.yCenter, radius, 0, TAU);
    } else {
        let pointPosition = scale.getPointPosition(0, radius);
        ctx.moveTo(pointPosition.x, pointPosition.y);
        for(let i = 1; i < labelCount; i++){
            pointPosition = scale.getPointPosition(i, radius);
            ctx.lineTo(pointPosition.x, pointPosition.y);
        }
    }
}
function drawRadiusLine(scale, gridLineOpts, radius, labelCount, borderOpts) {
    const ctx = scale.ctx;
    const circular = gridLineOpts.circular;
    const { color , lineWidth  } = gridLineOpts;
    if (!circular && !labelCount || !color || !lineWidth || radius < 0) {
        return;
    }
    ctx.save();
    ctx.strokeStyle = color;
    ctx.lineWidth = lineWidth;
    ctx.setLineDash(borderOpts.dash || []);
    ctx.lineDashOffset = borderOpts.dashOffset;
    ctx.beginPath();
    pathRadiusLine(scale, radius, circular, labelCount);
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
}
function createPointLabelContext(parent, index, label) {
    return createContext(parent, {
        label,
        index,
        type: 'pointLabel'
    });
}
class RadialLinearScale extends LinearScaleBase {
    static id = 'radialLinear';
 static defaults = {
        display: true,
        animate: true,
        position: 'chartArea',
        angleLines: {
            display: true,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0.0
        },
        grid: {
            circular: false
        },
        startAngle: 0,
        ticks: {
            showLabelBackdrop: true,
            callback: Ticks.formatters.numeric
        },
        pointLabels: {
            backdropColor: undefined,
            backdropPadding: 2,
            display: true,
            font: {
                size: 10
            },
            callback (label) {
                return label;
            },
            padding: 5,
            centerPointLabels: false
        }
    };
    static defaultRoutes = {
        'angleLines.color': 'borderColor',
        'pointLabels.color': 'color',
        'ticks.color': 'color'
    };
    static descriptors = {
        angleLines: {
            _fallback: 'grid'
        }
    };
    constructor(cfg){
        super(cfg);
         this.xCenter = undefined;
         this.yCenter = undefined;
         this.drawingArea = undefined;
         this._pointLabels = [];
        this._pointLabelItems = [];
    }
    setDimensions() {
        const padding = this._padding = toPadding(getTickBackdropHeight(this.options) / 2);
        const w = this.width = this.maxWidth - padding.width;
        const h = this.height = this.maxHeight - padding.height;
        this.xCenter = Math.floor(this.left + w / 2 + padding.left);
        this.yCenter = Math.floor(this.top + h / 2 + padding.top);
        this.drawingArea = Math.floor(Math.min(w, h) / 2);
    }
    determineDataLimits() {
        const { min , max  } = this.getMinMax(false);
        this.min = isNumberFinite(min) && !isNaN(min) ? min : 0;
        this.max = isNumberFinite(max) && !isNaN(max) ? max : 0;
        this.handleTickRangeOptions();
    }
 computeTickLimit() {
        return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    }
    generateTickLabels(ticks) {
        LinearScaleBase.prototype.generateTickLabels.call(this, ticks);
        this._pointLabels = this.getLabels().map((value, index)=>{
            const label = callback(this.options.pointLabels.callback, [
                value,
                index
            ], this);
            return label || label === 0 ? label : '';
        }).filter((v, i)=>this.chart.getDataVisibility(i));
    }
    fit() {
        const opts = this.options;
        if (opts.display && opts.pointLabels.display) {
            fitWithPointLabels(this);
        } else {
            this.setCenterPoint(0, 0, 0, 0);
        }
    }
    setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
        this.xCenter += Math.floor((leftMovement - rightMovement) / 2);
        this.yCenter += Math.floor((topMovement - bottomMovement) / 2);
        this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(leftMovement, rightMovement, topMovement, bottomMovement));
    }
    getIndexAngle(index) {
        const angleMultiplier = TAU / (this._pointLabels.length || 1);
        const startAngle = this.options.startAngle || 0;
        return _normalizeAngle(index * angleMultiplier + toRadians(startAngle));
    }
    getDistanceFromCenterForValue(value) {
        if (isNullOrUndef(value)) {
            return NaN;
        }
        const scalingFactor = this.drawingArea / (this.max - this.min);
        if (this.options.reverse) {
            return (this.max - value) * scalingFactor;
        }
        return (value - this.min) * scalingFactor;
    }
    getValueForDistanceFromCenter(distance) {
        if (isNullOrUndef(distance)) {
            return NaN;
        }
        const scaledDistance = distance / (this.drawingArea / (this.max - this.min));
        return this.options.reverse ? this.max - scaledDistance : this.min + scaledDistance;
    }
    getPointLabelContext(index) {
        const pointLabels = this._pointLabels || [];
        if (index >= 0 && index < pointLabels.length) {
            const pointLabel = pointLabels[index];
            return createPointLabelContext(this.getContext(), index, pointLabel);
        }
    }
    getPointPosition(index, distanceFromCenter, additionalAngle = 0) {
        const angle = this.getIndexAngle(index) - HALF_PI + additionalAngle;
        return {
            x: Math.cos(angle) * distanceFromCenter + this.xCenter,
            y: Math.sin(angle) * distanceFromCenter + this.yCenter,
            angle
        };
    }
    getPointPositionForValue(index, value) {
        return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    }
    getBasePosition(index) {
        return this.getPointPositionForValue(index || 0, this.getBaseValue());
    }
    getPointLabelPosition(index) {
        const { left , top , right , bottom  } = this._pointLabelItems[index];
        return {
            left,
            top,
            right,
            bottom
        };
    }
 drawBackground() {
        const { backgroundColor , grid: { circular  }  } = this.options;
        if (backgroundColor) {
            const ctx = this.ctx;
            ctx.save();
            ctx.beginPath();
            pathRadiusLine(this, this.getDistanceFromCenterForValue(this._endValue), circular, this._pointLabels.length);
            ctx.closePath();
            ctx.fillStyle = backgroundColor;
            ctx.fill();
            ctx.restore();
        }
    }
 drawGrid() {
        const ctx = this.ctx;
        const opts = this.options;
        const { angleLines , grid , border  } = opts;
        const labelCount = this._pointLabels.length;
        let i, offset, position;
        if (opts.pointLabels.display) {
            drawPointLabels(this, labelCount);
        }
        if (grid.display) {
            this.ticks.forEach((tick, index)=>{
                if (index !== 0 || index === 0 && this.min < 0) {
                    offset = this.getDistanceFromCenterForValue(tick.value);
                    const context = this.getContext(index);
                    const optsAtIndex = grid.setContext(context);
                    const optsAtIndexBorder = border.setContext(context);
                    drawRadiusLine(this, optsAtIndex, offset, labelCount, optsAtIndexBorder);
                }
            });
        }
        if (angleLines.display) {
            ctx.save();
            for(i = labelCount - 1; i >= 0; i--){
                const optsAtIndex = angleLines.setContext(this.getPointLabelContext(i));
                const { color , lineWidth  } = optsAtIndex;
                if (!lineWidth || !color) {
                    continue;
                }
                ctx.lineWidth = lineWidth;
                ctx.strokeStyle = color;
                ctx.setLineDash(optsAtIndex.borderDash);
                ctx.lineDashOffset = optsAtIndex.borderDashOffset;
                offset = this.getDistanceFromCenterForValue(opts.reverse ? this.min : this.max);
                position = this.getPointPosition(i, offset);
                ctx.beginPath();
                ctx.moveTo(this.xCenter, this.yCenter);
                ctx.lineTo(position.x, position.y);
                ctx.stroke();
            }
            ctx.restore();
        }
    }
 drawBorder() {}
 drawLabels() {
        const ctx = this.ctx;
        const opts = this.options;
        const tickOpts = opts.ticks;
        if (!tickOpts.display) {
            return;
        }
        const startAngle = this.getIndexAngle(0);
        let offset, width;
        ctx.save();
        ctx.translate(this.xCenter, this.yCenter);
        ctx.rotate(startAngle);
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        this.ticks.forEach((tick, index)=>{
            if (index === 0 && this.min >= 0 && !opts.reverse) {
                return;
            }
            const optsAtIndex = tickOpts.setContext(this.getContext(index));
            const tickFont = toFont(optsAtIndex.font);
            offset = this.getDistanceFromCenterForValue(this.ticks[index].value);
            if (optsAtIndex.showLabelBackdrop) {
                ctx.font = tickFont.string;
                width = ctx.measureText(tick.label).width;
                ctx.fillStyle = optsAtIndex.backdropColor;
                const padding = toPadding(optsAtIndex.backdropPadding);
                ctx.fillRect(-width / 2 - padding.left, -offset - tickFont.size / 2 - padding.top, width + padding.width, tickFont.size + padding.height);
            }
            renderText(ctx, tick.label, 0, -offset, tickFont, {
                color: optsAtIndex.color,
                strokeColor: optsAtIndex.textStrokeColor,
                strokeWidth: optsAtIndex.textStrokeWidth
            });
        });
        ctx.restore();
    }
 drawTitle() {}
}

const INTERVALS = {
    millisecond: {
        common: true,
        size: 1,
        steps: 1000
    },
    second: {
        common: true,
        size: 1000,
        steps: 60
    },
    minute: {
        common: true,
        size: 60000,
        steps: 60
    },
    hour: {
        common: true,
        size: 3600000,
        steps: 24
    },
    day: {
        common: true,
        size: 86400000,
        steps: 30
    },
    week: {
        common: false,
        size: 604800000,
        steps: 4
    },
    month: {
        common: true,
        size: 2.628e9,
        steps: 12
    },
    quarter: {
        common: false,
        size: 7.884e9,
        steps: 4
    },
    year: {
        common: true,
        size: 3.154e10
    }
};
 const UNITS =  /* #__PURE__ */ Object.keys(INTERVALS);
 function sorter(a, b) {
    return a - b;
}
 function parse(scale, input) {
    if (isNullOrUndef(input)) {
        return null;
    }
    const adapter = scale._adapter;
    const { parser , round , isoWeekday  } = scale._parseOpts;
    let value = input;
    if (typeof parser === 'function') {
        value = parser(value);
    }
    if (!isNumberFinite(value)) {
        value = typeof parser === 'string' ? adapter.parse(value, parser) : adapter.parse(value);
    }
    if (value === null) {
        return null;
    }
    if (round) {
        value = round === 'week' && (isNumber(isoWeekday) || isoWeekday === true) ? adapter.startOf(value, 'isoWeek', isoWeekday) : adapter.startOf(value, round);
    }
    return +value;
}
 function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    const ilen = UNITS.length;
    for(let i = UNITS.indexOf(minUnit); i < ilen - 1; ++i){
        const interval = INTERVALS[UNITS[i]];
        const factor = interval.steps ? interval.steps : Number.MAX_SAFE_INTEGER;
        if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
            return UNITS[i];
        }
    }
    return UNITS[ilen - 1];
}
 function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    for(let i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--){
        const unit = UNITS[i];
        if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
            return unit;
        }
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
}
 function determineMajorUnit(unit) {
    for(let i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i){
        if (INTERVALS[UNITS[i]].common) {
            return UNITS[i];
        }
    }
}
 function addTick(ticks, time, timestamps) {
    if (!timestamps) {
        ticks[time] = true;
    } else if (timestamps.length) {
        const { lo , hi  } = _lookup(timestamps, time);
        const timestamp = timestamps[lo] >= time ? timestamps[lo] : timestamps[hi];
        ticks[timestamp] = true;
    }
}
 function setMajorTicks(scale, ticks, map, majorUnit) {
    const adapter = scale._adapter;
    const first = +adapter.startOf(ticks[0].value, majorUnit);
    const last = ticks[ticks.length - 1].value;
    let major, index;
    for(major = first; major <= last; major = +adapter.add(major, 1, majorUnit)){
        index = map[major];
        if (index >= 0) {
            ticks[index].major = true;
        }
    }
    return ticks;
}
 function ticksFromTimestamps(scale, values, majorUnit) {
    const ticks = [];
     const map = {};
    const ilen = values.length;
    let i, value;
    for(i = 0; i < ilen; ++i){
        value = values[i];
        map[value] = i;
        ticks.push({
            value,
            major: false
        });
    }
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
}
class TimeScale extends Scale {
    static id = 'time';
 static defaults = {
 bounds: 'data',
        adapters: {},
        time: {
            parser: false,
            unit: false,
            round: false,
            isoWeekday: false,
            minUnit: 'millisecond',
            displayFormats: {}
        },
        ticks: {
 source: 'auto',
            callback: false,
            major: {
                enabled: false
            }
        }
    };
 constructor(props){
        super(props);
         this._cache = {
            data: [],
            labels: [],
            all: []
        };
         this._unit = 'day';
         this._majorUnit = undefined;
        this._offsets = {};
        this._normalized = false;
        this._parseOpts = undefined;
    }
    init(scaleOpts, opts = {}) {
        const time = scaleOpts.time || (scaleOpts.time = {});
         const adapter = this._adapter = new adapters._date(scaleOpts.adapters.date);
        adapter.init(opts);
        mergeIf(time.displayFormats, adapter.formats());
        this._parseOpts = {
            parser: time.parser,
            round: time.round,
            isoWeekday: time.isoWeekday
        };
        super.init(scaleOpts);
        this._normalized = opts.normalized;
    }
 parse(raw, index) {
        if (raw === undefined) {
            return null;
        }
        return parse(this, raw);
    }
    beforeLayout() {
        super.beforeLayout();
        this._cache = {
            data: [],
            labels: [],
            all: []
        };
    }
    determineDataLimits() {
        const options = this.options;
        const adapter = this._adapter;
        const unit = options.time.unit || 'day';
        let { min , max , minDefined , maxDefined  } = this.getUserBounds();
 function _applyBounds(bounds) {
            if (!minDefined && !isNaN(bounds.min)) {
                min = Math.min(min, bounds.min);
            }
            if (!maxDefined && !isNaN(bounds.max)) {
                max = Math.max(max, bounds.max);
            }
        }
        if (!minDefined || !maxDefined) {
            _applyBounds(this._getLabelBounds());
            if (options.bounds !== 'ticks' || options.ticks.source !== 'labels') {
                _applyBounds(this.getMinMax(false));
            }
        }
        min = isNumberFinite(min) && !isNaN(min) ? min : +adapter.startOf(Date.now(), unit);
        max = isNumberFinite(max) && !isNaN(max) ? max : +adapter.endOf(Date.now(), unit) + 1;
        this.min = Math.min(min, max - 1);
        this.max = Math.max(min + 1, max);
    }
 _getLabelBounds() {
        const arr = this.getLabelTimestamps();
        let min = Number.POSITIVE_INFINITY;
        let max = Number.NEGATIVE_INFINITY;
        if (arr.length) {
            min = arr[0];
            max = arr[arr.length - 1];
        }
        return {
            min,
            max
        };
    }
 buildTicks() {
        const options = this.options;
        const timeOpts = options.time;
        const tickOpts = options.ticks;
        const timestamps = tickOpts.source === 'labels' ? this.getLabelTimestamps() : this._generate();
        if (options.bounds === 'ticks' && timestamps.length) {
            this.min = this._userMin || timestamps[0];
            this.max = this._userMax || timestamps[timestamps.length - 1];
        }
        const min = this.min;
        const max = this.max;
        const ticks = _filterBetween(timestamps, min, max);
        this._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, this.min, this.max, this._getLabelCapacity(min)) : determineUnitForFormatting(this, ticks.length, timeOpts.minUnit, this.min, this.max));
        this._majorUnit = !tickOpts.major.enabled || this._unit === 'year' ? undefined : determineMajorUnit(this._unit);
        this.initOffsets(timestamps);
        if (options.reverse) {
            ticks.reverse();
        }
        return ticksFromTimestamps(this, ticks, this._majorUnit);
    }
    afterAutoSkip() {
        if (this.options.offsetAfterAutoskip) {
            this.initOffsets(this.ticks.map((tick)=>+tick.value));
        }
    }
 initOffsets(timestamps = []) {
        let start = 0;
        let end = 0;
        let first, last;
        if (this.options.offset && timestamps.length) {
            first = this.getDecimalForValue(timestamps[0]);
            if (timestamps.length === 1) {
                start = 1 - first;
            } else {
                start = (this.getDecimalForValue(timestamps[1]) - first) / 2;
            }
            last = this.getDecimalForValue(timestamps[timestamps.length - 1]);
            if (timestamps.length === 1) {
                end = last;
            } else {
                end = (last - this.getDecimalForValue(timestamps[timestamps.length - 2])) / 2;
            }
        }
        const limit = timestamps.length < 3 ? 0.5 : 0.25;
        start = _limitValue(start, 0, limit);
        end = _limitValue(end, 0, limit);
        this._offsets = {
            start,
            end,
            factor: 1 / (start + 1 + end)
        };
    }
 _generate() {
        const adapter = this._adapter;
        const min = this.min;
        const max = this.max;
        const options = this.options;
        const timeOpts = options.time;
        const minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, this._getLabelCapacity(min));
        const stepSize = valueOrDefault(options.ticks.stepSize, 1);
        const weekday = minor === 'week' ? timeOpts.isoWeekday : false;
        const hasWeekday = isNumber(weekday) || weekday === true;
        const ticks = {};
        let first = min;
        let time, count;
        if (hasWeekday) {
            first = +adapter.startOf(first, 'isoWeek', weekday);
        }
        first = +adapter.startOf(first, hasWeekday ? 'day' : minor);
        if (adapter.diff(max, min, minor) > 100000 * stepSize) {
            throw new Error(min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor);
        }
        const timestamps = options.ticks.source === 'data' && this.getDataTimestamps();
        for(time = first, count = 0; time < max; time = +adapter.add(time, stepSize, minor), count++){
            addTick(ticks, time, timestamps);
        }
        if (time === max || options.bounds === 'ticks' || count === 1) {
            addTick(ticks, time, timestamps);
        }
        return Object.keys(ticks).sort(sorter).map((x)=>+x);
    }
 getLabelForValue(value) {
        const adapter = this._adapter;
        const timeOpts = this.options.time;
        if (timeOpts.tooltipFormat) {
            return adapter.format(value, timeOpts.tooltipFormat);
        }
        return adapter.format(value, timeOpts.displayFormats.datetime);
    }
 format(value, format) {
        const options = this.options;
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const fmt = format || formats[unit];
        return this._adapter.format(value, fmt);
    }
 _tickFormatFunction(time, index, ticks, format) {
        const options = this.options;
        const formatter = options.ticks.callback;
        if (formatter) {
            return callback(formatter, [
                time,
                index,
                ticks
            ], this);
        }
        const formats = options.time.displayFormats;
        const unit = this._unit;
        const majorUnit = this._majorUnit;
        const minorFormat = unit && formats[unit];
        const majorFormat = majorUnit && formats[majorUnit];
        const tick = ticks[index];
        const major = majorUnit && majorFormat && tick && tick.major;
        return this._adapter.format(time, format || (major ? majorFormat : minorFormat));
    }
 generateTickLabels(ticks) {
        let i, ilen, tick;
        for(i = 0, ilen = ticks.length; i < ilen; ++i){
            tick = ticks[i];
            tick.label = this._tickFormatFunction(tick.value, i, ticks);
        }
    }
 getDecimalForValue(value) {
        return value === null ? NaN : (value - this.min) / (this.max - this.min);
    }
 getPixelForValue(value) {
        const offsets = this._offsets;
        const pos = this.getDecimalForValue(value);
        return this.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    }
 getValueForPixel(pixel) {
        const offsets = this._offsets;
        const pos = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return this.min + pos * (this.max - this.min);
    }
 _getLabelSize(label) {
        const ticksOpts = this.options.ticks;
        const tickLabelWidth = this.ctx.measureText(label).width;
        const angle = toRadians(this.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
        const cosRotation = Math.cos(angle);
        const sinRotation = Math.sin(angle);
        const tickFontSize = this._resolveTickFontOptions(0).size;
        return {
            w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
            h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
        };
    }
 _getLabelCapacity(exampleTime) {
        const timeOpts = this.options.time;
        const displayFormats = timeOpts.displayFormats;
        const format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
        const exampleLabel = this._tickFormatFunction(exampleTime, 0, ticksFromTimestamps(this, [
            exampleTime
        ], this._majorUnit), format);
        const size = this._getLabelSize(exampleLabel);
        const capacity = Math.floor(this.isHorizontal() ? this.width / size.w : this.height / size.h) - 1;
        return capacity > 0 ? capacity : 1;
    }
 getDataTimestamps() {
        let timestamps = this._cache.data || [];
        let i, ilen;
        if (timestamps.length) {
            return timestamps;
        }
        const metas = this.getMatchingVisibleMetas();
        if (this._normalized && metas.length) {
            return this._cache.data = metas[0].controller.getAllParsedValues(this);
        }
        for(i = 0, ilen = metas.length; i < ilen; ++i){
            timestamps = timestamps.concat(metas[i].controller.getAllParsedValues(this));
        }
        return this._cache.data = this.normalize(timestamps);
    }
 getLabelTimestamps() {
        const timestamps = this._cache.labels || [];
        let i, ilen;
        if (timestamps.length) {
            return timestamps;
        }
        const labels = this.getLabels();
        for(i = 0, ilen = labels.length; i < ilen; ++i){
            timestamps.push(parse(this, labels[i]));
        }
        return this._cache.labels = this._normalized ? timestamps : this.normalize(timestamps);
    }
 normalize(values) {
        return _arrayUnique(values.sort(sorter));
    }
}

function interpolate(table, val, reverse) {
    let lo = 0;
    let hi = table.length - 1;
    let prevSource, nextSource, prevTarget, nextTarget;
    if (reverse) {
        if (val >= table[lo].pos && val <= table[hi].pos) {
            ({ lo , hi  } = _lookupByKey(table, 'pos', val));
        }
        ({ pos: prevSource , time: prevTarget  } = table[lo]);
        ({ pos: nextSource , time: nextTarget  } = table[hi]);
    } else {
        if (val >= table[lo].time && val <= table[hi].time) {
            ({ lo , hi  } = _lookupByKey(table, 'time', val));
        }
        ({ time: prevSource , pos: prevTarget  } = table[lo]);
        ({ time: nextSource , pos: nextTarget  } = table[hi]);
    }
    const span = nextSource - prevSource;
    return span ? prevTarget + (nextTarget - prevTarget) * (val - prevSource) / span : prevTarget;
}
class TimeSeriesScale extends TimeScale {
    static id = 'timeseries';
 static defaults = TimeScale.defaults;
 constructor(props){
        super(props);
         this._table = [];
         this._minPos = undefined;
         this._tableRange = undefined;
    }
 initOffsets() {
        const timestamps = this._getTimestampsForTable();
        const table = this._table = this.buildLookupTable(timestamps);
        this._minPos = interpolate(table, this.min);
        this._tableRange = interpolate(table, this.max) - this._minPos;
        super.initOffsets(timestamps);
    }
 buildLookupTable(timestamps) {
        const { min , max  } = this;
        const items = [];
        const table = [];
        let i, ilen, prev, curr, next;
        for(i = 0, ilen = timestamps.length; i < ilen; ++i){
            curr = timestamps[i];
            if (curr >= min && curr <= max) {
                items.push(curr);
            }
        }
        if (items.length < 2) {
            return [
                {
                    time: min,
                    pos: 0
                },
                {
                    time: max,
                    pos: 1
                }
            ];
        }
        for(i = 0, ilen = items.length; i < ilen; ++i){
            next = items[i + 1];
            prev = items[i - 1];
            curr = items[i];
            if (Math.round((next + prev) / 2) !== curr) {
                table.push({
                    time: curr,
                    pos: i / (ilen - 1)
                });
            }
        }
        return table;
    }
 _generate() {
        const min = this.min;
        const max = this.max;
        let timestamps = super.getDataTimestamps();
        if (!timestamps.includes(min) || !timestamps.length) {
            timestamps.splice(0, 0, min);
        }
        if (!timestamps.includes(max) || timestamps.length === 1) {
            timestamps.push(max);
        }
        return timestamps.sort((a, b)=>a - b);
    }
 _getTimestampsForTable() {
        let timestamps = this._cache.all || [];
        if (timestamps.length) {
            return timestamps;
        }
        const data = this.getDataTimestamps();
        const label = this.getLabelTimestamps();
        if (data.length && label.length) {
            timestamps = this.normalize(data.concat(label));
        } else {
            timestamps = data.length ? data : label;
        }
        timestamps = this._cache.all = timestamps;
        return timestamps;
    }
 getDecimalForValue(value) {
        return (interpolate(this._table, value) - this._minPos) / this._tableRange;
    }
 getValueForPixel(pixel) {
        const offsets = this._offsets;
        const decimal = this.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
        return interpolate(this._table, decimal * this._tableRange + this._minPos, true);
    }
}

const ChartTooltip = ({
  visible,
  x,
  y,
  content,
  className = '',
  style = {}
}) => {
  const tooltipRef = useRef(null);
  const [position, setPosition] = useState({
    left: x,
    top: y,
    transformX: '-10%',
    transformY: '-50%'
  });
  useEffect(() => {
    if (!visible || !tooltipRef.current) return;
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!tooltipRef.current) return;
        const tooltip = tooltipRef.current;
        const tooltipRect = tooltip.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const padding = 10;
        let transformX = '-10%';
        let transformY = '-50%';
        let left = x;
        let top = y;
        const tooltipWidth = tooltipRect.width;
        const tooltipHeight = tooltipRect.height;
        const defaultRight = x + tooltipWidth * 0.9;
        const defaultLeft = x - tooltipWidth * 0.1;
        const defaultBottom = y + tooltipHeight * 0.5;
        const defaultTop = y - tooltipHeight * 0.5;
        if (defaultRight > viewportWidth - padding) {
          transformX = '-100%';
          left = x - 10;
        } else if (defaultLeft < padding) {
          transformX = '0%';
          left = x + 10;
        }
        if (defaultBottom > viewportHeight - padding) {
          transformY = '-100%';
          top = y - 10;
        } else if (defaultTop < padding) {
          transformY = '0%';
          top = y + 10;
        }
        setPosition({
          left,
          top,
          transformX,
          transformY
        });
      });
    });
  }, [visible, x, y]);
  if (!visible) return null;
  return /*#__PURE__*/jsx("div", {
    ref: tooltipRef,
    className: `${styles$k.tooltipBox} ${className} ${styles$k.chartTooltipBox}`,
    style: {
      position: 'fixed',
      left: position.left,
      top: position.top,
      pointerEvents: 'none',
      zIndex: 10,
      transform: `translate(${position.transformX}, ${position.transformY})`,
      ...style
    },
    children: content
  });
};
ChartTooltip.propTypes = {
  visible: PropTypes.bool.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  content: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

Chart.register(DoughnutController, ArcElement, plugin_tooltip, plugin_legend);
const DoughnutChart = ({
  data,
  labels,
  colors,
  width = 200,
  height = 200,
  thickness = 70,
  showLegend = false,
  centerText = null,
  valueFormatter
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const valueFormatterRef = useRef(valueFormatter);
  valueFormatterRef.current = valueFormatter;
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: '',
    value: '',
    color: ''
  });

  // Track mouse position over the canvas
  useEffect(() => {
    const canvas = chartRef.current;
    if (!canvas) return;
    const handleMouseMove = e => {
      if (!tooltip.visible) return;
      setTooltip(prev => ({
        ...prev,
        x: e.clientX,
        // Use viewport coordinates for fixed positioning
        y: e.clientY
      }));
    };
    canvas.addEventListener('mousemove', handleMouseMove);
    return () => {
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [tooltip.visible]);
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    const ctx = chartRef.current.getContext('2d');
    chartInstance.current = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [{
          data,
          backgroundColor: colors,
          borderWidth: 0
        }]
      },
      options: {
        cutout: `${thickness}%`,
        plugins: {
          legend: {
            display: false // We'll create a custom legend
          },
          tooltip: {
            enabled: false,
            external: context => {
              const tooltipModel = context.tooltip;
              if (tooltipModel.opacity === 0) {
                setTooltip(prev => ({
                  ...prev,
                  visible: false
                }));
                return;
              }
              if (tooltipModel.dataPoints && tooltipModel.dataPoints.length > 0) {
                const dp = tooltipModel.dataPoints[0];
                setTooltip(prev => ({
                  ...prev,
                  visible: true,
                  label: dp.label,
                  value: valueFormatterRef.current ? valueFormatterRef.current(dp.raw) : dp.raw,
                  color: dp.element.options.backgroundColor
                }));
              }
            }
          }
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    return () => {
      chartInstance.current && chartInstance.current.destroy();
    };
  }, [data, labels, colors, thickness, showLegend]);
  return /*#__PURE__*/jsxs("div", {
    style: {
      position: 'relative',
      width,
      height
    },
    children: [/*#__PURE__*/jsx("canvas", {
      ref: chartRef,
      width: width,
      height: height
    }), centerText && /*#__PURE__*/jsxs("div", {
      style: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        pointerEvents: 'none'
      },
      children: [/*#__PURE__*/jsx("div", {
        style: {
          fontSize: '28px',
          fontWeight: 'bold',
          color: 'var(--primary-color)',
          lineHeight: 1
        },
        children: centerText.number
      }), /*#__PURE__*/jsx("div", {
        style: {
          fontSize: '14px',
          color: 'var(--grey-64)',
          marginTop: '4px'
        },
        children: centerText.label
      })]
    }), showLegend && /*#__PURE__*/jsx("div", {
      style: {
        position: 'absolute',
        right: '-140px',
        top: '50%',
        transform: 'translateY(-50%)',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        minWidth: '120px'
      },
      children: labels.map((label, index) => /*#__PURE__*/jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        },
        children: [/*#__PURE__*/jsx("div", {
          style: {
            width: '14px',
            height: '14px',
            backgroundColor: colors[index],
            borderRadius: '4px',
            flexShrink: 0
          }
        }), /*#__PURE__*/jsx("span", {
          style: {
            fontSize: '12px',
            color: 'var(--grey-64)',
            whiteSpace: 'nowrap'
          },
          children: label
        })]
      }, index))
    }), /*#__PURE__*/jsx(ChartTooltip, {
      visible: tooltip.visible,
      x: tooltip.x,
      y: tooltip.y,
      content: /*#__PURE__*/jsxs("div", {
        style: {
          display: 'flex',
          alignItems: 'center',
          minWidth: 90
        },
        children: [/*#__PURE__*/jsx("span", {
          style: {
            display: 'inline-block',
            width: 14,
            height: 14,
            background: tooltip.color,
            borderRadius: 4,
            marginRight: 12
          }
        }), /*#__PURE__*/jsx("span", {
          style: {
            color: 'var(--grey-64)',
            marginRight: 12
          },
          children: tooltip.label
        }), /*#__PURE__*/jsx("span", {
          style: {
            color: 'var(--primary-color)'
          },
          children: tooltip.value
        })]
      })
    })]
  });
};
DoughnutChart.propTypes = {
  /** Array of data values for the chart segments */
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  /** Array of labels for each segment */
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Array of colors for each segment */
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Width of the chart in pixels */
  width: PropTypes.number,
  /** Height of the chart in pixels */
  height: PropTypes.number,
  /** Thickness of the doughnut (0-100) where lower values make it thicker */
  thickness: PropTypes.number,
  /** Whether to show the legend */
  showLegend: PropTypes.bool,
  /** Center text to display in the doughnut hole */
  centerText: PropTypes.shape({
    number: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }),
  valueFormatter: PropTypes.func
};
DoughnutChart.defaultProps = {
  width: 200,
  height: 200,
  thickness: 70,
  showLegend: false
};

var css_248z$h = ".BarsChartTooltipContent-module__tooltipContainer___dt2sT{min-width:150px}.BarsChartTooltipContent-module__monthLabel___q52OP{color:var(--grey-64);font-size:12px;font-weight:500;margin-bottom:8px}.BarsChartTooltipContent-module__dataPointRow___dVaN6{align-items:center;display:flex;font-size:12px;justify-content:space-between;margin-bottom:4px}.BarsChartTooltipContent-module__dataPointRowTotal___aotIQ{border-top:1px solid var(--bg-dark);margin-bottom:0;padding-top:8px}.BarsChartTooltipContent-module__dataPointLabelContainer___3GZRU{align-items:center;display:flex}.BarsChartTooltipContent-module__colorIndicator___gNQG-{border-radius:4px;display:inline-block;flex-shrink:0;height:14px;margin-right:8px;width:14px}.BarsChartTooltipContent-module__dataPointLabel___nGEis{color:var(--grey-64);font-weight:400}.BarsChartTooltipContent-module__dataPointLabelTotal___vKYZC{color:var(--text);font-weight:600}.BarsChartTooltipContent-module__dataPointValue___M9NOg{color:var(--primary-color);font-weight:500;margin-left:12px}.BarsChartTooltipContent-module__dataPointValueTotal___d9Ce6{font-weight:600}.BarsChartTooltipContent-module__singleDataPointContainer___fo93s{align-items:center;display:flex;min-width:90px}.BarsChartTooltipContent-module__singleDataPointLabel___WQDIO{color:var(--grey-64);margin-right:12px}.BarsChartTooltipContent-module__singleDataPointValue___NVjr3{color:var(--primary-color)}";
var css$g = {"tooltipContainer":"BarsChartTooltipContent-module__tooltipContainer___dt2sT","monthLabel":"BarsChartTooltipContent-module__monthLabel___q52OP","dataPointRow":"BarsChartTooltipContent-module__dataPointRow___dVaN6","dataPointRowTotal":"BarsChartTooltipContent-module__dataPointRowTotal___aotIQ","dataPointLabelContainer":"BarsChartTooltipContent-module__dataPointLabelContainer___3GZRU","colorIndicator":"BarsChartTooltipContent-module__colorIndicator___gNQG-","dataPointLabel":"BarsChartTooltipContent-module__dataPointLabel___nGEis","dataPointLabelTotal":"BarsChartTooltipContent-module__dataPointLabelTotal___vKYZC","dataPointValue":"BarsChartTooltipContent-module__dataPointValue___M9NOg","dataPointValueTotal":"BarsChartTooltipContent-module__dataPointValueTotal___d9Ce6","singleDataPointContainer":"BarsChartTooltipContent-module__singleDataPointContainer___fo93s","singleDataPointLabel":"BarsChartTooltipContent-module__singleDataPointLabel___WQDIO","singleDataPointValue":"BarsChartTooltipContent-module__singleDataPointValue___NVjr3"};
styleInject(css_248z$h);

const BarsChartTooltipContent = ({
  allDataPoints = [],
  monthLabel = '',
  label = '',
  value = '',
  color = '',
  tooltipWidth = null
}) => {
  // Multi-data point tooltip (stacked charts)
  if (allDataPoints && allDataPoints.length > 0) {
    return /*#__PURE__*/jsxs("div", {
      className: css$g.tooltipContainer,
      style: tooltipWidth ? {
        width: tooltipWidth
      } : undefined,
      children: [monthLabel && /*#__PURE__*/jsx("div", {
        className: css$g.monthLabel,
        children: monthLabel
      }), allDataPoints.map((dp, index) => /*#__PURE__*/jsxs("div", {
        className: `${css$g.dataPointRow} ${dp.isTotal ? css$g.dataPointRowTotal : ''}`,
        children: [/*#__PURE__*/jsxs("div", {
          className: css$g.dataPointLabelContainer,
          children: [!dp.isTotal && /*#__PURE__*/jsx("span", {
            className: css$g.colorIndicator,
            style: {
              background: dp.color
            }
          }), /*#__PURE__*/jsx("span", {
            className: `${css$g.dataPointLabel} ${dp.isTotal ? css$g.dataPointLabelTotal : ''}`,
            children: dp.label
          })]
        }), /*#__PURE__*/jsx("span", {
          className: `${css$g.dataPointValue} ${dp.isTotal ? css$g.dataPointValueTotal : ''}`,
          children: dp.value
        })]
      }, index))]
    });
  }

  // Single data point tooltip (non-stacked charts)
  return /*#__PURE__*/jsxs("div", {
    className: css$g.singleDataPointContainer,
    children: [/*#__PURE__*/jsx("span", {
      className: css$g.colorIndicator,
      style: {
        background: color
      }
    }), /*#__PURE__*/jsx("span", {
      className: css$g.singleDataPointLabel,
      children: label
    }), /*#__PURE__*/jsx("span", {
      className: css$g.singleDataPointValue,
      children: value
    })]
  });
};
BarsChartTooltipContent.propTypes = {
  allDataPoints: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    color: PropTypes.string,
    isTotal: PropTypes.bool
  })),
  monthLabel: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  tooltipWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

Chart.register(BarController, BarElement, CategoryScale, LinearScale, plugin_tooltip, plugin_legend);
const BORDER_RADIUS = 6;
const isPlainObject$2 = val => val !== null && typeof val === 'object' && val.constructor === Object;
const deepMerge$2 = (target = {}, source = {}) => {
  const out = {
    ...target
  };
  Object.keys(source).forEach(key => {
    const srcVal = source[key];
    const tgtVal = target[key];
    if (isPlainObject$2(srcVal) && isPlainObject$2(tgtVal)) {
      out[key] = deepMerge$2(tgtVal, srcVal);
    } else {
      out[key] = srcVal;
    }
  });
  return out;
};
const BarsChart = ({
  labels,
  datasets,
  width = '100%',
  height = 300,
  options = {},
  stacked = false,
  maintainAspectRatio = false,
  roundedBars = true,
  barSpacing = 2,
  cleanGrid = true,
  valueFormatter = null,
  tooltipWidth = null
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: '',
    value: '',
    color: '',
    allDataPoints: [],
    monthLabel: ''
  });

  // Track mouse position over the canvas
  useEffect(() => {
    const canvas = chartRef.current;
    if (!canvas) return;
    const handleMouseMove = e => {
      if (!tooltip.visible) return;
      setTooltip(prev => ({
        ...prev,
        x: e.clientX,
        y: e.clientY
      }));
    };
    canvas.addEventListener('mousemove', handleMouseMove);
    return () => {
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [tooltip.visible]);
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    const ctx = chartRef.current.getContext('2d');
    const spacingPlugin = {
      id: 'spacingPlugin',
      afterDatasetsDraw: chart => {
        if (!stacked || barSpacing <= 0) {
          return;
        }
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          if (datasetIndex === 0) {
            return;
          }
          const meta = chart.getDatasetMeta(datasetIndex);
          const prevMeta = chart.getDatasetMeta(datasetIndex - 1);
          meta.data.forEach((bar, index) => {
            const prevBar = prevMeta.data[index];
            if (prevBar && bar) {
              const gap = barSpacing;
              if (bar.y < prevBar.y) {
                bar.y += gap;
                bar.height -= gap;
              } else {
                bar.y -= gap;
                bar.height -= gap;
              }
            }
          });
        });
      }
    };
    const defaultOptions = {
      maintainAspectRatio,
      responsive: true,
      plugins: {
        spacingPlugin,
        legend: {
          display: false
        },
        tooltip: {
          enabled: false,
          external: context => {
            const tooltipModel = context.tooltip;
            const chart = context.chart;
            const canvas = chart.canvas;
            const rect = canvas.getBoundingClientRect();
            if (tooltipModel.opacity === 0) {
              setTooltip(prev => ({
                ...prev,
                visible: false
              }));
              return;
            }
            if (tooltipModel.dataPoints && tooltipModel.dataPoints.length > 0) {
              const firstDp = tooltipModel.dataPoints[0];
              const dataIndex = firstDp.dataIndex;
              const tooltipX = rect.left + tooltipModel.caretX;
              const tooltipY = rect.top + tooltipModel.caretY;
              if (stacked) {
                const allDataPoints = [];
                let totalValue = 0;
                chart.data.datasets.forEach((dataset, datasetIndex) => {
                  const value = dataset.data[dataIndex];
                  if (value && value !== 0) {
                    let formattedValue = value;
                    if (valueFormatter && typeof value === 'number') {
                      formattedValue = valueFormatter(value);
                    }
                    allDataPoints.push({
                      label: dataset.label || '',
                      value: formattedValue,
                      rawValue: value,
                      color: Array.isArray(dataset.backgroundColor) ? dataset.backgroundColor[dataIndex] : dataset.backgroundColor
                    });
                    if (typeof value === 'number') {
                      totalValue += value;
                    }
                  }
                });
                allDataPoints.sort((a, b) => (b.rawValue || 0) - (a.rawValue || 0));
                if (allDataPoints.length > 1 && valueFormatter) {
                  allDataPoints.push({
                    label: 'Total',
                    value: valueFormatter(totalValue),
                    rawValue: totalValue,
                    color: 'transparent',
                    isTotal: true
                  });
                }
                setTooltip(prev => ({
                  ...prev,
                  visible: true,
                  x: tooltipX,
                  y: tooltipY,
                  monthLabel: chart.data.labels[dataIndex] || '',
                  allDataPoints,
                  label: firstDp.dataset.label || firstDp.label,
                  value: '',
                  color: firstDp.element.options.backgroundColor
                }));
              } else {
                // Non-stacked or single dataset - show single value
                const dp = firstDp;
                let formattedValue = dp.raw;
                if (valueFormatter && typeof dp.raw === 'number') {
                  formattedValue = valueFormatter(dp.raw);
                }
                setTooltip(prev => ({
                  ...prev,
                  visible: true,
                  x: tooltipX,
                  y: tooltipY,
                  label: dp.dataset.label || dp.label,
                  value: formattedValue,
                  color: dp.element.options.backgroundColor,
                  allDataPoints: [],
                  monthLabel: ''
                }));
              }
            }
          }
        }
      },
      scales: {
        x: {
          stacked: stacked,
          grid: {
            display: false
          },
          border: {
            display: false
          },
          ticks: {
            color: colors$1.bgDark,
            font: {
              size: 12
            }
          }
        },
        y: {
          stacked: stacked,
          grid: cleanGrid ? {
            display: true,
            drawBorder: false,
            color: getCSSVariable('--bg-dark'),
            lineWidth: 1
          } : {
            display: true
          },
          border: {
            display: false
          },
          ticks: {
            color: colors$1.bgDark,
            font: {
              size: 12
            }
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      elements: {
        bar: {
          borderSkipped: false,
          borderRadius: ctx => {
            const {
              datasetIndex,
              dataIndex,
              chart
            } = ctx;
            const datasetCount = chart.data.datasets.length;
            const value = ctx.raw;
            if (!stacked) return roundedBars ? BORDER_RADIUS : 0;
            const datasets = chart.data.datasets;
            datasetIndex > 0 ? datasets[datasetIndex - 1].data[dataIndex] : 0;
            datasetIndex < datasetCount - 1 ? datasets[datasetIndex + 1].data[dataIndex] : 0;
            if (value === 0) return 0;
            if (datasetCount === 1) {
              return BORDER_RADIUS;
            }
            if (datasetIndex === 0) {
              return {
                topLeft: 0,
                topRight: 0,
                bottomLeft: BORDER_RADIUS,
                bottomRight: BORDER_RADIUS
              };
            } else if (datasetIndex === datasetCount - 1) {
              return {
                topLeft: BORDER_RADIUS,
                topRight: BORDER_RADIUS,
                bottomLeft: 0,
                bottomRight: 0
              };
            } else {
              return 0;
            }
          }
        }
      },
      datasets: {
        bar: {
          barThickness: 20,
          maxBarThickness: 30
        }
      },
      layout: {
        padding: {
          top: 10,
          bottom: 10
        }
      }
    };
    const mergedOptions = deepMerge$2(defaultOptions, options || {});
    chartInstance.current = new Chart(ctx, {
      type: 'bar',
      data: {
        labels,
        datasets
      },
      options: mergedOptions
    });
    return () => {
      chartInstance.current && chartInstance.current.destroy();
    };
  }, [labels, datasets, options, stacked, maintainAspectRatio, roundedBars, barSpacing, cleanGrid]);
  return /*#__PURE__*/jsxs("div", {
    style: {
      position: 'relative',
      width,
      height
    },
    children: [/*#__PURE__*/jsx("canvas", {
      ref: chartRef
    }), /*#__PURE__*/jsx(ChartTooltip, {
      visible: tooltip.visible,
      x: tooltip.x,
      y: tooltip.y,
      content: /*#__PURE__*/jsx(BarsChartTooltipContent, {
        allDataPoints: tooltip.allDataPoints,
        monthLabel: tooltip.monthLabel,
        label: tooltip.label,
        value: tooltip.value,
        color: tooltip.color,
        tooltipWidth: tooltipWidth
      })
    })]
  });
};
BarsChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  datasets: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
    backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderWidth: PropTypes.number,
    yAxisID: PropTypes.string
  })).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.object,
  stacked: PropTypes.bool,
  maintainAspectRatio: PropTypes.bool,
  roundedBars: PropTypes.bool,
  barSpacing: PropTypes.number,
  cleanGrid: PropTypes.bool,
  valueFormatter: PropTypes.func,
  tooltipWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
BarsChart.defaultProps = {
  width: '100%',
  height: 300,
  options: {},
  stacked: false,
  maintainAspectRatio: false,
  roundedBars: true,
  barSpacing: 2,
  cleanGrid: true,
  valueFormatter: null,
  tooltipWidth: null
};

Chart.register(LineController, LineElement, PointElement, CategoryScale, LinearScale, plugin_tooltip, plugin_legend, index);
const isPlainObject$1 = val => val !== null && typeof val === 'object' && val.constructor === Object;
const deepMerge$1 = (target = {}, source = {}) => {
  const out = {
    ...target
  };
  Object.keys(source).forEach(key => {
    const srcVal = source[key];
    const tgtVal = target[key];
    if (isPlainObject$1(srcVal) && isPlainObject$1(tgtVal)) {
      out[key] = deepMerge$1(tgtVal, srcVal);
    } else {
      out[key] = srcVal;
    }
  });
  return out;
};
const LineChart = ({
  labels,
  datasets,
  width = '100%',
  height = 300,
  options = {},
  maintainAspectRatio = false,
  showLegend = false,
  cleanGrid = true,
  fillArea = false,
  pointRadius = 4,
  pointHoverRadius = 6,
  lineTension = 0
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: '',
    values: []
  });

  // Track mouse position over the canvas
  useEffect(() => {
    const canvas = chartRef.current;
    if (!canvas) return;
    const handleMouseMove = e => {
      if (!tooltip.visible) return;
      setTooltip(prev => ({
        ...prev,
        x: e.clientX,
        // Use viewport coordinates for fixed positioning
        y: e.clientY
      }));
    };
    canvas.addEventListener('mousemove', handleMouseMove);
    return () => {
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [tooltip.visible]);
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    const ctx = chartRef.current.getContext('2d');
    const defaultOptions = {
      maintainAspectRatio,
      responsive: true,
      plugins: {
        legend: {
          display: showLegend,
          position: 'top',
          labels: {
            usePointStyle: true,
            padding: 20,
            font: {
              size: 12
            }
          }
        },
        tooltip: {
          enabled: false,
          external: context => {
            const tooltipModel = context.tooltip;
            if (tooltipModel.opacity === 0) {
              setTooltip(prev => ({
                ...prev,
                visible: false
              }));
              return;
            }
            if (tooltipModel.dataPoints && tooltipModel.dataPoints.length > 0) {
              const dataIndex = tooltipModel.dataPoints[0].dataIndex;
              const label = tooltipModel.dataPoints[0].label;

              // Get all datasets and their values for this data index
              const chart = context.chart;
              const values = chart.data.datasets.map(dataset => ({
                label: dataset.label,
                value: dataset.data[dataIndex],
                color: dataset.borderColor || dataset.backgroundColor
              }));
              setTooltip(prev => ({
                ...prev,
                visible: true,
                label: label,
                values: values
              }));
            }
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false
          },
          border: {
            display: false
          },
          ticks: {
            color: getCSSVariable('--bg-dark'),
            font: {
              size: 12
            }
          }
        },
        y: {
          grid: cleanGrid ? {
            display: true,
            drawBorder: false,
            color: getCSSVariable('--bg-dark'),
            lineWidth: 1
          } : {
            display: true
          },
          border: {
            display: false
          },
          ticks: {
            color: getCSSVariable('--bg-dark'),
            font: {
              size: 12
            }
          }
        }
      },
      hover: {
        mode: 'nearest',
        intersect: true
      },
      elements: {
        line: {
          tension: lineTension
        },
        point: {
          radius: pointRadius,
          hoverRadius: pointHoverRadius
        }
      },
      layout: {
        padding: {
          top: 10,
          bottom: 10
        }
      }
    };

    // Add fill if requested
    const processedDatasets = datasets.map(dataset => ({
      ...dataset,
      fill: fillArea ? 'origin' : false
    }));

    // Deep merge options
    const mergedOptions = deepMerge$1(defaultOptions, options || {});
    chartInstance.current = new Chart(ctx, {
      type: 'line',
      data: {
        labels,
        datasets: processedDatasets
      },
      options: mergedOptions
    });
    return () => {
      chartInstance.current && chartInstance.current.destroy();
    };
  }, [labels, datasets, options, maintainAspectRatio, showLegend, cleanGrid, fillArea, pointRadius, pointHoverRadius, lineTension]);
  return /*#__PURE__*/jsxs("div", {
    style: {
      position: 'relative',
      width,
      height
    },
    children: [/*#__PURE__*/jsx("canvas", {
      ref: chartRef
    }), /*#__PURE__*/jsx(ChartTooltip, {
      visible: tooltip.visible,
      x: tooltip.x,
      y: tooltip.y,
      content: /*#__PURE__*/jsxs("div", {
        style: {
          minWidth: 120
        },
        children: [/*#__PURE__*/jsx("div", {
          style: {
            color: 'var(--grey-64)',
            marginBottom: 8,
            fontWeight: 500,
            fontSize: '12px'
          },
          children: tooltip.label
        }), tooltip.values.map((item, index) => /*#__PURE__*/jsxs("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            marginBottom: 4,
            fontSize: '12px'
          },
          children: [/*#__PURE__*/jsx("span", {
            style: {
              display: 'inline-block',
              width: 14,
              height: 14,
              background: item.color,
              borderRadius: 4,
              marginRight: 8
            }
          }), /*#__PURE__*/jsx("span", {
            style: {
              color: 'var(--grey-64)',
              marginRight: 12
            },
            children: item.label
          }), /*#__PURE__*/jsx("span", {
            style: {
              color: colors$1.primaryColor,
              fontWeight: 'bold'
            },
            children: item.value
          })]
        }, index))]
      })
    })]
  });
};
LineChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  datasets: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
    backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderWidth: PropTypes.number,
    pointBackgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    pointBorderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    yAxisID: PropTypes.string
  })).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.object,
  maintainAspectRatio: PropTypes.bool,
  showLegend: PropTypes.bool,
  cleanGrid: PropTypes.bool,
  fillArea: PropTypes.bool,
  pointRadius: PropTypes.number,
  pointHoverRadius: PropTypes.number,
  lineTension: PropTypes.number
};
LineChart.defaultProps = {
  width: '100%',
  height: 300,
  options: {},
  maintainAspectRatio: false,
  showLegend: false,
  cleanGrid: true,
  fillArea: false,
  pointRadius: 4,
  pointHoverRadius: 6,
  lineTension: 0
};

var css_248z$g = ".ChartLegendItem-module__chartLegendItem___I8sCl{align-items:center;color:var(--grey-64);display:flex;font-size:var(--body-small-size)}.ChartLegendItem-module__labelLegend___UQICc{border-radius:3px;box-sizing:content-box;flex-shrink:0;min-height:2px;min-width:2px;padding:6px}";
var css$f = {"chartLegendItem":"ChartLegendItem-module__chartLegendItem___I8sCl","labelLegend":"ChartLegendItem-module__labelLegend___UQICc"};
styleInject(css_248z$g);

const ChartLegendItem = ({
  label,
  color,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: `${css$f.chartLegendItem} ${className}`,
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 10,
    style: style,
    children: [/*#__PURE__*/jsx("div", {
      className: css$f.labelLegend,
      style: {
        backgroundColor: color
      }
    }), /*#__PURE__*/jsx("span", {
      children: label
    })]
  });
};
ChartLegendItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  style: PropTypes.object
};

var css_248z$f = ".LegendItem-module__legendItem___BOtX5{color:var(--grey-64);font-size:var(--body-small-size)}.LegendItem-module__legendColor___-1Cng{border-radius:3px;flex-shrink:0;height:14px;width:14px}";
var css$e = {"legendItem":"LegendItem-module__legendItem___BOtX5","legendColor":"LegendItem-module__legendColor___-1Cng"};
styleInject(css_248z$f);

const LegendItem = ({
  label,
  color
}) => {
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: css$e.legendItem,
    alignItems: "center",
    flexWrap: "nowrap",
    gap: 10,
    children: [/*#__PURE__*/jsx("div", {
      className: css$e.legendColor,
      style: {
        backgroundColor: color
      }
    }), /*#__PURE__*/jsx("span", {
      children: label
    })]
  });
};
LegendItem.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired
};

var css_248z$e = ".ChartLegend-module__chartLegend___XVmpE{margin-top:16px;width:100%}";
var css$d = {"chartLegend":"ChartLegend-module__chartLegend___XVmpE"};
styleInject(css_248z$e);

const ChartLegend = ({
  items = [],
  gap = 15,
  flexWrap = 'nowrap',
  align = 'flex-start'
}) => {
  return /*#__PURE__*/jsx(FlexContainer, {
    className: css$d.chartLegend,
    flexWrap: flexWrap,
    gap: gap,
    alignItems: "center",
    justifyContent: align,
    children: items.map((item, index) => /*#__PURE__*/jsx(LegendItem, {
      label: item.label,
      color: item.color
    }, index))
  });
};
ChartLegend.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
  })).isRequired,
  gap: PropTypes.number,
  flexWrap: PropTypes.string,
  align: PropTypes.string
};
ChartLegend.defaultProps = {
  gap: 15,
  flexWrap: 'nowrap',
  align: 'flex-start'
};

Chart.register(BarController, BarElement, CategoryScale, index, LinearScale, LineController, LineElement, plugin_tooltip, plugin_legend);
const isPlainObject = val => val !== null && typeof val === 'object' && val.constructor === Object;
const deepMerge = (target = {}, source = {}) => {
  const out = {
    ...target
  };
  Object.keys(source).forEach(key => {
    const srcVal = source[key];
    const tgtVal = target[key];
    if (isPlainObject(srcVal) && isPlainObject(tgtVal)) {
      out[key] = deepMerge(tgtVal, srcVal);
    } else {
      out[key] = srcVal;
    }
  });
  return out;
};
const BarsAndLineChart = ({
  labels,
  datasets,
  width = '100%',
  height = 300,
  options = {},
  stacked = false,
  maintainAspectRatio = false,
  roundedBars = true,
  barSpacing = 2,
  cleanGrid = true,
  pointRadius = 4,
  pointHoverRadius = 6,
  lineTension = 0,
  currency = null,
  labelsToDisplayCurrency = []
}) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    label: '',
    value: '',
    color: '',
    title: '',
    allDataPoints: []
  });

  // Track mouse position over the canvas
  useEffect(() => {
    const canvas = chartRef.current;
    if (!canvas) return;
    const handleMouseMove = e => {
      if (!tooltip.visible) return;
      setTooltip(prev => ({
        ...prev,
        x: e.clientX,
        // Use viewport coordinates for fixed positioning
        y: e.clientY
      }));
    };
    canvas.addEventListener('mousemove', handleMouseMove);
    return () => {
      canvas.removeEventListener('mousemove', handleMouseMove);
    };
  }, [tooltip.visible]);
  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }
    const ctx = chartRef.current.getContext('2d');
    const spacingPlugin = {
      id: 'spacingPlugin',
      afterDatasetsDraw: chart => {
        if (!stacked || barSpacing <= 0) return;
        chart.ctx;
        chart.data.datasets.forEach((dataset, datasetIndex) => {
          if (dataset.type !== 'bar') return;
          if (datasetIndex === 0) return; // skip bottom

          const meta = chart.getDatasetMeta(datasetIndex);
          const prevMeta = chart.getDatasetMeta(datasetIndex - 1);
          meta.data.forEach((bar, index) => {
            const prevBar = prevMeta.data[index];
            if (prevBar && bar) {
              const gap = barSpacing;
              // shift current bar down (for positive bars)
              if (bar.y < prevBar.y) {
                bar.y += gap;
                bar.height -= gap;
              } else {
                // shift for negative bars
                bar.y -= gap;
                bar.height -= gap;
              }
            }
          });
        });
      }
    };
    const defaultOptions = {
      maintainAspectRatio,
      responsive: true,
      plugins: {
        spacingPlugin,
        legend: {
          display: false
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          enabled: false,
          external: context => {
            const tooltipModel = context.tooltip;
            if (tooltipModel.opacity === 0) {
              setTooltip(prev => ({
                ...prev,
                visible: false
              }));
              return;
            }
            if (tooltipModel.dataPoints && tooltipModel.dataPoints.length > 0) {
              const dataPoints = tooltipModel.dataPoints.map(dp => ({
                label: dp.dataset.label,
                value: dp.raw,
                color: dp.element.options.backgroundColor
              }));
              const primaryDp = tooltipModel.dataPoints[0];
              const labelIndex = primaryDp.dataIndex;
              const chartLabel = context.chart.data.labels[labelIndex];
              setTooltip(prev => ({
                ...prev,
                visible: true,
                label: primaryDp.dataset.label || primaryDp.label,
                value: primaryDp.raw,
                color: primaryDp.element.options.backgroundColor,
                title: chartLabel,
                allDataPoints: dataPoints
              }));
            }
          }
        }
      },
      scales: {
        x: {
          stacked: stacked,
          grid: {
            display: false
          },
          border: {
            display: false
          },
          ticks: {
            color: colors$1.bgDark,
            font: {
              size: 12
            }
          }
        },
        y: {
          stacked: stacked,
          grid: cleanGrid ? {
            display: true,
            drawBorder: false,
            color: getCSSVariable('--bg-dark'),
            lineWidth: 1
          } : {
            display: true
          },
          border: {
            display: false
          },
          ticks: {
            color: colors$1.bgDark,
            font: {
              size: 12
            }
          },
          position: 'left',
          beginAtZero: true
        },
        y1: {
          display: true,
          position: 'right',
          beginAtZero: true,
          grid: {
            drawOnChartArea: false,
            display: false
          }
        }
      },
      hover: {
        mode: 'index',
        intersect: false
      },
      elements: {
        bar: {
          borderSkipped: false,
          borderRadius: ctx => {
            const {
              datasetIndex,
              dataIndex,
              chart
            } = ctx;
            const barDatasets = chart.data.datasets.filter(dataset => dataset.type === 'bar');
            const datasetCount = barDatasets.length;
            const value = ctx.raw;
            if (!stacked) return roundedBars ? 6 : 0;
            const datasets = barDatasets;
            datasetIndex > 0 ? datasets[datasetIndex - 1].data[dataIndex] : 0;
            datasetIndex < datasetCount - 1 ? datasets[datasetIndex + 1].data[dataIndex] : 0;
            if (value === 0) return 0;
            if (datasetIndex === 0) {
              return {
                topLeft: 0,
                topRight: 0,
                bottomLeft: 6,
                bottomRight: 6
              };
            } else if (datasetIndex === datasetCount - 1) {
              return {
                topLeft: 6,
                topRight: 6,
                bottomLeft: 0,
                bottomRight: 0
              };
            } else {
              return 0;
            }
          }
        },
        line: {
          tension: lineTension
        },
        point: {
          radius: pointRadius,
          hoverRadius: pointHoverRadius
        }
      },
      datasets: {
        bar: {
          maxBarThickness: 30
        }
      },
      layout: {
        padding: {
          top: 10,
          bottom: 10
        }
      }
    };
    const mergedOptions = deepMerge(defaultOptions, options || {});
    chartInstance.current = new Chart(ctx, {
      data: {
        labels: labels,
        datasets: datasets
      },
      options: mergedOptions
    });
    return () => {
      chartInstance.current && chartInstance.current.destroy();
    };
  }, [labels, datasets, options, stacked, maintainAspectRatio, roundedBars, barSpacing, cleanGrid, pointRadius, pointHoverRadius, lineTension]);
  const getFormattedValue = (value, label) => {
    if (currency && labelsToDisplayCurrency.includes(label)) {
      return formatCurrency(value, currency);
    }
    return value;
  };
  return /*#__PURE__*/jsxs("div", {
    style: {
      position: 'relative',
      width,
      height
    },
    children: [/*#__PURE__*/jsx("canvas", {
      ref: chartRef
    }), /*#__PURE__*/jsx(ChartTooltip, {
      visible: tooltip.visible,
      x: tooltip.x,
      y: tooltip.y,
      content: /*#__PURE__*/jsx(Fragment$1, {
        children: tooltip.allDataPoints.length > 1 ? /*#__PURE__*/jsxs(FlexContainer, {
          flexFlow: "column",
          gap: "8px",
          style: {
            minWidth: 150
          },
          children: [/*#__PURE__*/jsx("span", {
            children: tooltip.title
          }), tooltip.allDataPoints.map((dp, index) => /*#__PURE__*/jsxs(FlexContainer, {
            alignItems: "center",
            justifyContent: "space-between",
            style: {
              whiteSpace: 'nowrap'
            },
            children: [/*#__PURE__*/jsxs("div", {
              style: {
                display: 'flex',
                alignItems: 'center'
              },
              children: [/*#__PURE__*/jsx("span", {
                style: {
                  display: 'inline-block',
                  width: 14,
                  height: 14,
                  background: dp.color,
                  borderRadius: 4,
                  marginRight: 8
                }
              }), /*#__PURE__*/jsx("span", {
                style: {
                  color: 'var(--grey-64)'
                },
                children: dp.label
              })]
            }), /*#__PURE__*/jsx("span", {
              style: {
                color: 'var(--primary-color)',
                marginLeft: 12,
                fontWeight: 'bold'
              },
              children: getFormattedValue(dp.value, dp.label)
            })]
          }, index))]
        }) : /*#__PURE__*/jsxs(FlexContainer, {
          alignItems: "center",
          style: {
            minWidth: 90
          },
          children: [/*#__PURE__*/jsx("span", {
            style: {
              display: 'inline-block',
              width: 14,
              height: 14,
              background: tooltip.color,
              borderRadius: 4,
              marginRight: 12
            }
          }), /*#__PURE__*/jsx("span", {
            style: {
              color: 'var(--grey-64)',
              marginRight: 12
            },
            children: tooltip.label
          }), /*#__PURE__*/jsx("span", {
            style: {
              color: 'var(--primary-color)'
            },
            children: getFormattedValue(tooltip.value, tooltip.label)
          })]
        })
      })
    })]
  });
};
BarsAndLineChart.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  datasets: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.number).isRequired,
    backgroundColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderColor: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    borderWidth: PropTypes.number,
    yAxisID: PropTypes.string
  })).isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  options: PropTypes.object,
  stacked: PropTypes.bool,
  maintainAspectRatio: PropTypes.bool,
  roundedBars: PropTypes.bool,
  barSpacing: PropTypes.number,
  cleanGrid: PropTypes.bool,
  pointRadius: PropTypes.number,
  pointHoverRadius: PropTypes.number,
  lineTension: PropTypes.number
};
BarsAndLineChart.defaultProps = {
  width: '100%',
  height: 300,
  options: {},
  stacked: false,
  maintainAspectRatio: false,
  roundedBars: true,
  barSpacing: 2,
  cleanGrid: true,
  pointRadius: 4,
  pointHoverRadius: 6,
  lineTension: 0
};

const ReservationStatus = ({
  status
}) => {
  let variant = '';
  switch (status) {
    case reservationStatus.CONFIRMED:
    case reservationStatus.DUE_IN:
    case reservationStatus.INHOUSE:
      variant = 'success';
      break;
    case reservationStatus.TENTATIVE:
    case reservationStatus.TRANSFERRED:
    case reservationStatus.CHECKEDOUT:
      variant = '';
      break;
    case reservationStatus.CANCELLED:
      variant = 'danger';
      break;
    case reservationStatus.NOSHOW:
    case reservationStatus.DELETED:
      variant = 'disabled';
      break;
  }
  return /*#__PURE__*/jsx(Label, {
    variant: variant,
    children: status
  });
};

const RoomTypeName = ({
  id
}) => {
  const {
    roomTypesList
  } = useContext(RoomTypesListContext);
  const {
    crossPropertyRoomTypesList
  } = useContext(CrossPropertyRoomTypesListContext);
  if (!id) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "N/A"
    });
  }
  let roomType = roomTypesList[id];
  if (roomType) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: roomType.name
    });
  }
  if (crossPropertyRoomTypesList) {
    roomType = crossPropertyRoomTypesList[id] ?? null;
  }
  if (roomType) {
    return /*#__PURE__*/jsxs(Fragment$1, {
      children: [roomType.name, " (CP)"]
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: "Not Mapped"
  });
};

const ExtraTypeName = ({
  id
}) => {
  const {
    extraTypesList
  } = useContext(ExtraTypesListContext);
  if (!id) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "N/A"
    });
  }
  let extraType = extraTypesList[id];
  if (extraType) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: extraType.name
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: "Not Mapped"
  });
};

var css_248z$d = ".RoomTypeUpgrade-module__upsellItem___sKdh5{align-items:center;border-radius:var(--borderRadius);display:flex;gap:10px;text-transform:uppercase}.RoomTypeUpgrade-module__upsellItem___sKdh5 svg{height:12px!important;width:12px!important}.RoomTypeUpgrade-module__upsellItem___sKdh5 div{border-radius:var(--border-radius-small);font-size:var(--body-regular-size);padding:3px 10px}.RoomTypeUpgrade-module__upsellItem___sKdh5 div.RoomTypeUpgrade-module__from___1FedJ{background-color:var(--grey-8);color:var(--grey-64)}.RoomTypeUpgrade-module__upsellItem___sKdh5 div.RoomTypeUpgrade-module__to___eITeL{background-color:var(--primary-10);color:var(--primary-color)}";
var css$c = {"upsellItem":"RoomTypeUpgrade-module__upsellItem___sKdh5","from":"RoomTypeUpgrade-module__from___1FedJ","to":"RoomTypeUpgrade-module__to___eITeL"};
styleInject(css_248z$d);

const RoomTypeUpgrade = ({
  bookedRoomTypeId,
  upgradedRoomTypeId
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$c.upsellItem,
    children: [/*#__PURE__*/jsx("div", {
      className: css$c.from,
      children: /*#__PURE__*/jsx(RoomTypeCode, {
        id: bookedRoomTypeId
      })
    }), /*#__PURE__*/jsx(ChevronRight, {
      color: colors$1.primaryColor
    }), /*#__PURE__*/jsx("div", {
      className: css$c.to,
      children: /*#__PURE__*/jsx(RoomTypeCode, {
        id: upgradedRoomTypeId
      })
    })]
  });
};

const MarketSegmentCodeContent = ({
  id
}) => {
  const {
    getMarketSegment
  } = useContext(MarketSegmentsListContext);
  if (!id) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  const marketSegment = getMarketSegment(id);
  if (marketSegment) {
    const code = isNaN(marketSegment.code) ? marketSegment.code : marketSegment.name;
    return /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: purify.sanitize(code)
      }
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: "-"
  });
};
const MarketSegmentCode = ({
  id
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(MarketSegmentCodeContent, {
      id: id
    })
  });
};

const RatePlanCodeContent = ({
  id
}) => {
  const {
    getRatePlan
  } = useContext(RatePlansListContext);
  if (!id) {
    return /*#__PURE__*/jsx(Fragment$1, {
      children: "-"
    });
  }
  const ratePlan = getRatePlan(id);
  if (ratePlan) {
    const code = isNaN(ratePlan.code) ? ratePlan.code : ratePlan.name;
    return /*#__PURE__*/jsx("span", {
      dangerouslySetInnerHTML: {
        __html: purify.sanitize(code)
      }
    });
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: "-"
  });
};
const RatePlanCode = ({
  id
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(RatePlanCodeContent, {
      id: id
    })
  });
};

const ReservationSourceCodeContent = ({
  id,
  className
}) => {
  const {
    getReservationSource
  } = useContext(ReservationSourcesListContext);
  if (!id) {
    return null;
  }
  const reservationSource = getReservationSource(id);
  if (reservationSource) {
    const code = isNaN(reservationSource.code) ? reservationSource.code : reservationSource.name;
    return /*#__PURE__*/jsx("span", {
      className: className,
      dangerouslySetInnerHTML: {
        __html: purify.sanitize(code)
      }
    });
  }
  return /*#__PURE__*/jsx("span", {
    className: className,
    children: "Not Mapped"
  });
};
const ReservationSourceCode = ({
  id,
  className
}) => {
  return /*#__PURE__*/jsx(Suspense, {
    fallback: /*#__PURE__*/jsx(LazyLoadingIndicator, {}),
    children: /*#__PURE__*/jsx(ReservationSourceCodeContent, {
      id: id,
      className: className
    })
  });
};

const FrontDeskAgent = () => /*#__PURE__*/jsxs("svg", {
  width: "200",
  height: "96",
  viewBox: "0 0 217 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  children: [/*#__PURE__*/jsx("path", {
    d: "M157.857 29.5534C157.857 29.5534 161.468 35.9158 153.08 43.2143C144.692 50.5128 144.765 54.6635 146.95 57.96C149.136 61.2565 150.727 56.1388 150.727 56.1388C150.727 56.1388 150.594 50.881 154.156 48.0122C157.718 45.1434 160.456 36.5109 159.803 34.0103C159.376 32.4373 158.72 30.9356 157.857 29.5534Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M177.874 19.6565C174.415 16.1319 161.633 33.7315 161.633 33.7315C161.633 33.7315 161.364 38.7116 156.122 48.0656C150.88 57.4195 155.626 64.5854 160.27 65.2796C164.915 65.9739 190.044 64.5544 190.108 57.0439C190.171 49.5334 184.226 42.2213 183.355 35.0345C182.483 27.8476 181.331 23.1824 177.874 19.6565Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M174.359 24.7841L166.231 30.911L167.235 38.8864L163.785 40.5712C163.785 40.5712 164.261 49.8967 169.984 50.7372C175.707 51.5778 179.371 43.0086 180.055 38.5405L177.528 37.664L174.359 24.7841Z",
    fill: "#F9A293"
  }), /*#__PURE__*/jsx("path", {
    d: "M160.461 42.7209C160.461 42.7209 156.121 45.7236 152.949 55.209L144.65 74.1773C144.64 74.2313 144.619 74.2827 144.588 74.3279C144.557 74.3731 144.517 74.4111 144.47 74.4394C144.423 74.4677 144.37 74.4856 144.316 74.492C144.261 74.4983 144.206 74.4929 144.154 74.4761L122.23 67.9773C121.906 67.8822 121.61 67.7065 121.372 67.4665C119.901 65.9701 114.046 60.2673 109.27 59.1812C105.684 58.3655 103.986 57.8547 103.237 57.5968C102.837 57.4592 102.383 57.7134 102.369 58.1163C102.352 58.6692 102.771 59.5172 104.685 60.5735C104.783 60.627 104.886 60.6686 104.994 60.6975C105.662 60.8809 108.329 61.6893 108.232 63.0121C108.232 63.0121 105.715 65.1333 99.4421 62.8695C96.5969 61.8418 92.3197 62.448 92.0854 64.6597C91.8511 66.8714 103.977 73.2141 108.574 74.1786C111.628 74.8171 114.773 74.8431 116.542 74.7898C117.52 74.7611 118.491 74.9686 119.371 75.3948C124.578 77.9078 142.712 86.5737 146.963 87.3299C151.733 88.1767 156.576 72.7256 160.973 58.1101C161.679 55.762 162.821 52.7791 162.755 50.3343C162.692 47.8052 161.979 45.565 160.461 42.7209Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/jsx("path", {
    d: "M149.73 55.0354C148.269 57.8 147.115 62.0921 144.672 66.9792C143.421 69.4811 142.338 70.4877 142.338 70.4877C140.944 69.8033 139.488 69.2537 137.989 68.8463C130.949 66.9358 125.716 69.0137 125.716 69.0137L124.505 74.5194V74.543L123.844 77.5395C123.91 78.2104 124.119 78.8595 124.455 79.4438C126.768 83.7246 135.124 88.6787 141.732 90.6822C141.788 90.7008 141.844 90.7156 141.902 90.7318C143.938 91.3355 145.796 91.6554 147.252 91.5822C147.256 91.5811 147.26 91.5811 147.264 91.5822C147.44 91.5711 147.612 91.5574 147.775 91.5364C154.383 90.7033 161.544 65.0861 162.642 55.8487C163.74 46.6112 159.896 42.3651 159.896 42.3651C154.677 43.916 152.114 50.5264 149.73 55.0354Z",
    fill: "white"
  }), /*#__PURE__*/jsx("path", {
    d: "M120.689 76.037L123.837 77.5384L125.714 69.0138L123.225 68.2761L120.689 76.037Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/jsx("path", {
    d: "M154.494 79.8417C150.679 90.1131 132.248 84.2081 128.635 80.7702C125.122 77.4316 124.537 74.6756 124.508 74.5256L124.501 74.5429L123.84 77.5394C123.906 78.2103 124.115 78.8594 124.451 79.4437C126.764 83.7246 135.12 88.6786 141.728 90.6821C141.784 90.7007 141.84 90.7156 141.898 90.7317C143.972 91.3268 145.833 91.6454 147.248 91.5822C147.252 91.5811 147.256 91.5811 147.26 91.5822C147.436 91.571 147.608 91.5574 147.771 91.5363C154.379 90.7032 161.54 65.086 162.638 55.8486C163.737 46.6111 160.462 42.7233 160.462 42.7233C160.462 42.7233 165.114 51.2305 154.494 79.8417Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/jsx("path", {
    d: "M188.244 86.1187C188.177 86.0555 188.11 85.9947 188.044 85.9327L185.799 82.0523L189.085 63.9121L188.601 60.085L186.157 40.7348L179.853 38.5367C179.166 42.9999 175.548 49.1292 169.824 48.2936C164.101 47.458 164.198 40.255 164.198 40.255L159.115 42.6391C159.115 42.6391 158.488 50.3467 154.936 59.3498C151.384 68.3529 161.085 90.0227 161.085 90.0227L160.306 93.5238C157.574 105.774 156.209 118.289 156.233 130.841L156.28 150.089H202.831C202.831 150.089 209.109 105.685 188.244 86.1187Z",
    fill: "#002D6B"
  }), /*#__PURE__*/jsx("path", {
    d: "M179.853 38.5367C179.853 38.5367 175.382 48.4684 169.824 48.2936C169.824 48.2936 170.613 50.6393 176.578 50.7905C182.544 50.9418 181.94 39.2608 181.94 39.2608L179.853 38.5367Z",
    fill: "#091A31"
  }), /*#__PURE__*/jsx("path", {
    d: "M164.82 39.9649L163.784 40.2872C163.784 40.2872 161.396 48.001 163.784 49.7516C166.172 51.5021 169.824 48.2961 169.824 48.2961C164.566 47.0638 164.82 39.9649 164.82 39.9649Z",
    fill: "#091A31"
  }), /*#__PURE__*/jsx("path", {
    d: "M170.922 5.04218C160.267 1.57085 155.494 10.962 155.192 13.4068C154.856 15.8478 154.684 18.3084 154.676 20.7722C154.676 22.9939 154.816 25.4263 155.275 27.6393C155.992 31.0722 157.474 33.9707 160.34 34.6972C163.481 35.4944 166.207 34.7741 168.365 33.5975C171.556 31.8532 173.871 28.8121 174.863 25.3494C176.559 19.4234 178.825 7.62088 170.922 5.04218Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/jsx("path", {
    d: "M188.601 60.0788L186.178 57.0439C186.178 57.0439 185.126 76.8627 181.379 79.9596C177.631 83.0565 177.369 88.4854 177.369 88.4854L188.244 86.1187C188.177 86.0555 188.11 85.9947 188.045 85.9328L185.798 82.0523L189.085 63.9122L188.601 60.0788Z",
    fill: "#091A31"
  }), /*#__PURE__*/jsx("path", {
    d: "M155.076 7.86014C152.851 14.2015 149.18 14.6156 149.8 18.8568C149.846 19.1779 149.917 19.495 150.012 19.8052C151.077 23.3509 154.807 24.7841 154.807 24.7841L154.714 19.7457C157.076 9.65407 160.246 10.1091 161.291 10.5826C161.415 10.6364 161.531 10.7046 161.638 10.786L163.582 9.09741L165.831 7.14356L172.573 1.28817C172.35 1.1498 172.119 1.02558 171.88 0.916245C166.679 -1.50748 157.282 1.5696 155.076 7.86014Z",
    fill: "#47303B"
  }), /*#__PURE__*/jsx("path", {
    d: "M171.881 0.919994C170.034 0.94919 168.204 1.27614 166.462 1.88825C166.458 1.88903 166.455 1.88903 166.452 1.88825C164.05 3.66234 162.84 6.10343 162.236 7.97794C162.06 8.52343 161.916 9.07901 161.806 9.6417C161.729 10.0188 161.675 10.4 161.643 10.7835C162.264 10.5436 162.906 10.3594 163.56 10.2331C172.829 8.44533 173.781 22.3009 173.781 22.3009C173.781 22.3009 175.548 23.9659 177.21 27.2599C177.557 26.8647 177.952 26.5148 178.387 26.2185C180.701 24.6424 182.274 22.7245 183.107 20.4648C184.493 16.7207 183.85 12.058 181.265 6.55593C179.096 1.95147 175.153 0.882802 171.881 0.919994Z",
    fill: "#47303B"
  }), /*#__PURE__*/jsx("path", {
    d: "M174.002 10.9843C171.895 7.07411 168.156 6.84227 165.831 7.14105C165.135 7.22715 164.449 7.3829 163.784 7.60596C163.459 7.85603 163.147 8.12295 162.849 8.40561C162.458 8.78096 162.107 9.1965 161.802 9.64537C161.602 9.94103 161.431 10.2553 161.291 10.5839C161.414 10.6376 161.531 10.7058 161.638 10.7872C162.26 10.5472 162.902 10.363 163.556 10.2367C172.824 8.449 173.777 22.3045 173.777 22.3045C173.777 22.3045 175.543 23.9695 177.206 27.2636C177.553 26.8684 177.948 26.5185 178.382 26.2222C180.697 24.646 182.27 22.7281 183.102 20.4685C179.299 19.6428 176.402 15.4487 174.002 10.9843Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M176.793 19.9763C175.086 19.7284 173.347 21.3202 172.909 23.5319C172.472 25.7437 173.502 27.7397 175.209 27.9876C176.916 28.2356 178.654 26.6437 179.092 24.432C179.53 22.2203 178.499 20.2243 176.793 19.9763Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/jsx("path", {
    d: "M175.687 22.0007C175.669 22.0169 173.816 23.6645 174.811 26.33C174.834 26.3925 174.876 26.4464 174.93 26.4845C174.985 26.5226 175.05 26.5431 175.117 26.5432C175.156 26.543 175.195 26.5358 175.231 26.5221C175.271 26.5071 175.308 26.4843 175.34 26.455C175.371 26.4256 175.397 26.3904 175.414 26.3512C175.432 26.3121 175.442 26.2698 175.444 26.2268C175.445 26.1838 175.438 26.1409 175.423 26.1006C174.593 23.8691 176.054 22.55 176.117 22.4942C176.15 22.4659 176.177 22.4315 176.196 22.393C176.215 22.3544 176.227 22.3124 176.23 22.2694C176.233 22.2264 176.227 22.1833 176.214 22.1424C176.2 22.1015 176.179 22.0637 176.15 22.0311C176.122 21.9986 176.088 21.9719 176.049 21.9526C176.011 21.9333 175.969 21.9218 175.926 21.9188C175.883 21.9157 175.839 21.9212 175.799 21.9348C175.758 21.9485 175.72 21.97 175.687 21.9983V22.0007Z",
    fill: "#F29C8B"
  }), /*#__PURE__*/jsx("path", {
    d: "M173.211 4.81524C167.71 2.81427 164.098 7.51048 164.098 7.51048C164.098 7.51048 172.359 0.0967207 175.707 9.52633C179.054 18.9559 181.95 16.8136 181.95 16.8136C176.408 16.2433 178.713 6.81249 173.211 4.81524Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M157.332 7.02944C153.241 10.3706 154.958 19.2398 150.838 21.1627C150.838 21.1627 152.98 22.6045 155.475 12.3604C157.969 2.11628 164.101 7.51171 164.101 7.51171C164.101 7.51171 161.418 3.68829 157.332 7.02944Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M193.154 44.0996C191.236 42.4395 189.103 41.4552 185.981 40.6555C185.981 40.6555 181.532 50.4161 186.396 59.1527L198.546 73.5463C198.579 73.5899 198.603 73.6402 198.616 73.6937C198.628 73.7473 198.629 73.8028 198.618 73.8567C198.607 73.9106 198.585 73.9616 198.553 74.0062C198.521 74.0508 198.48 74.088 198.432 74.1154L178.844 85.9191C178.555 86.0954 178.226 86.1953 177.888 86.2092C175.791 86.2861 167.631 86.7622 163.608 89.5566C160.588 91.653 159.065 92.563 158.369 92.9424C157.997 93.1444 157.881 93.6515 158.17 93.9342C158.568 94.3197 159.475 94.5813 161.547 93.8809C161.652 93.8453 161.753 93.7974 161.847 93.7383C162.433 93.3664 164.832 91.9468 165.74 92.9076C165.74 92.9076 165.609 96.1967 159.707 99.3011C157.029 100.709 154.592 104.276 156.067 105.941C157.542 107.606 170.406 102.932 174.211 100.19C176.742 98.3663 178.885 96.0604 180.038 94.7202C180.676 93.9782 181.484 93.4015 182.393 93.0391C187.759 90.893 206.389 83.3454 209.814 80.7159C213.657 77.7665 205.515 63.7684 197.692 50.6616C196.437 48.554 195.004 45.7001 193.154 44.0996Z",
    fill: "#FFB69F"
  }), /*#__PURE__*/jsx("path", {
    d: "M185.981 40.6566C180.105 46.6868 182.095 54.1477 183.816 58.9493C184.872 61.8912 188.556 66.4176 191.254 69.481C192.955 71.415 194.259 72.7651 194.259 72.7651C192.814 73.3342 191.427 74.0399 190.116 74.8727C183.957 78.7829 181.961 84.0469 181.961 84.0469L185.209 88.6526L185.224 88.6725L186.991 91.1818C187.531 91.5849 188.15 91.8689 188.808 92.0149C193.529 93.1939 202.817 90.366 208.758 86.8376C208.81 86.8091 208.859 86.7781 208.91 86.7459C210.728 85.6499 212.219 84.4945 213.146 83.37C213.146 83.37 213.146 83.37 213.155 83.3614C213.266 83.225 213.371 83.0874 213.466 82.9535C217.309 77.5134 203.222 54.9486 197.143 47.9067C191.064 40.8649 185.981 40.6566 185.981 40.6566Z",
    fill: "white"
  }), /*#__PURE__*/jsx("path", {
    d: "M179.732 85.3847L183.753 92.491L186.984 91.1806L181.957 84.0446L179.732 85.3847Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/jsx("path", {
    d: "M185.983 40.6566C185.983 40.6566 195.405 42.9626 209.361 70.0997C214.373 79.8442 197.583 89.4709 192.608 89.8193C187.773 90.1614 185.344 88.7345 185.213 88.6551L185.222 88.6712L186.988 91.1805C187.528 91.5837 188.148 91.8676 188.806 92.0136C193.527 93.1926 202.815 90.3647 208.756 86.8364C208.808 86.8079 208.856 86.7769 208.907 86.7447C210.746 85.6152 212.236 84.4561 213.143 83.3688C213.143 83.3688 213.143 83.3688 213.152 83.3601C213.264 83.2237 213.369 83.0861 213.463 82.9522C217.307 77.5122 203.219 54.9473 197.141 47.9055C191.062 40.8637 185.983 40.6566 185.983 40.6566Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/jsx("path", {
    d: "M196.111 72.0102L191.249 69.4786C192.95 71.4127 194.255 72.7628 194.255 72.7628C192.81 73.3318 191.422 74.0375 190.111 74.8703C195.534 72.0338 202.997 73.4719 202.997 73.4719C198.679 71.4275 196.111 72.0102 196.111 72.0102Z",
    fill: "#EDF1F6"
  }), /*#__PURE__*/jsx("path", {
    d: "M162.848 8.41061C162.651 8.25517 162.444 8.11232 162.228 7.98289C161.184 7.34566 159.615 6.83116 157.805 7.69775C154.514 9.27224 157.025 12.115 154.043 14.1705C152.637 15.145 150.705 17.4311 150.008 19.8077C151.073 23.3534 154.803 24.7866 154.803 24.7866L154.71 19.7482C157.072 9.65657 160.242 10.1116 161.287 10.5851C161.411 10.6389 161.527 10.7071 161.634 10.7885C162.256 10.5485 162.898 10.3643 163.552 10.238C163.578 9.56111 163.578 9.14579 163.578 9.09992C163.356 8.84855 163.112 8.61783 162.848 8.41061Z",
    fill: "#35232C"
  }), /*#__PURE__*/jsx("path", {
    d: "M183.389 31.7416C179.433 31.8655 178.687 34.0401 178.575 34.4889L178.558 34.5707C178.558 34.5707 178.28 37.2635 182.812 37.2982C184.906 37.3155 186.589 35.7906 187.793 34.1442C188.676 32.9102 189.4 31.5693 189.946 30.1534C189.188 31.1899 187.802 31.6015 183.389 31.7416Z",
    fill: "#D33333"
  }), /*#__PURE__*/jsx("path", {
    d: "M178.575 34.4889L178.558 34.5708C178.558 34.5708 178.28 37.2635 182.812 37.2982C184.906 37.3156 186.589 35.7907 187.793 34.1443C186.553 34.1158 184.99 33.8083 182.814 33.6633C180.638 33.5182 179.343 33.9906 178.575 34.4889Z",
    fill: "#B02A1E"
  }), /*#__PURE__*/jsx("path", {
    d: "M184.318 36.1327C181.081 33.9929 179.421 35.7125 179.421 35.7125C179.421 35.7125 177.859 37.5014 181.085 39.826C184.311 42.1505 189.823 38.3184 189.823 38.3184C188.755 38.6767 187.554 38.2713 184.318 36.1327Z",
    fill: "#D13C2E"
  }), /*#__PURE__*/jsx("path", {
    d: "M177.582 33.729C176.683 33.429 176.498 34.3291 176.498 34.3291L177.029 37.0776C177.029 37.0776 178.407 37.6268 179.306 36.7553C180.205 35.8837 178.482 34.029 177.582 33.729Z",
    fill: "#D33333"
  }), /*#__PURE__*/jsx("path", {
    d: "M177.353 35.5203C173.237 37.463 169.209 35.5712 167.528 34.5633C167.426 34.5026 167.312 34.4666 167.195 34.4582C167.077 34.4498 166.959 34.4693 166.85 34.5151C166.742 34.5609 166.645 34.6316 166.569 34.7216C166.493 34.8116 166.439 34.9184 166.412 35.0331C166.001 36.744 165.621 40.1087 168.658 40.9914C172.78 42.1915 177.878 37.4693 177.878 36.3621C177.878 35.255 177.353 35.5203 177.353 35.5203Z",
    fill: "#D13C2E"
  }), /*#__PURE__*/jsx("path", {
    d: "M171.699 38.109C168.87 37.7867 170.555 40.0641 172.966 39.6066C175.377 39.1491 177.874 35.8154 177.874 35.8154C177.874 35.8154 174.528 38.4313 171.699 38.109Z",
    fill: "#B02A1E"
  }), /*#__PURE__*/jsx("path", {
    d: "M145.295 73.6478C145.231 73.1938 145.006 72.7781 144.659 72.4773C144.313 72.1766 143.87 72.0111 143.412 72.0114H89.6719L94.3433 105.295H147.545C147.817 105.295 148.086 105.237 148.334 105.124C148.582 105.011 148.802 104.846 148.981 104.641C149.159 104.435 149.291 104.194 149.369 103.933C149.446 103.672 149.466 103.398 149.428 103.128L145.295 73.6478Z",
    fill: "#171717",
    "fill-opacity": "0.64"
  }), /*#__PURE__*/jsx("path", {
    d: "M141.879 73.7854C141.81 73.2933 141.565 72.8427 141.19 72.5167C140.815 72.1907 140.335 72.0113 139.838 72.0114H89.1476C88.7861 72.0112 88.4288 72.0886 88.0998 72.2385C87.7709 72.3883 87.4779 72.607 87.2407 72.8798C87.0035 73.1525 86.8277 73.4731 86.725 73.8197C86.6224 74.1663 86.5954 74.5309 86.6458 74.8888L90.613 103.119C90.6976 103.723 90.9974 104.275 91.4571 104.675C91.9168 105.075 92.5056 105.295 93.1148 105.295H143.936C144.232 105.295 144.524 105.232 144.793 105.109C145.062 104.986 145.301 104.807 145.495 104.583C145.688 104.36 145.831 104.098 145.915 103.814C145.998 103.53 146.019 103.232 145.977 102.94L141.879 73.7854Z",
    fill: "#171717"
  }), /*#__PURE__*/jsx("path", {
    d: "M124.279 92.863H109.867C109.495 92.863 109.193 93.2201 109.193 93.6614V111.66C109.193 112.102 109.495 112.459 109.867 112.459H124.279C124.651 112.459 124.951 112.102 124.951 111.66V93.6614C124.951 93.2201 124.649 92.863 124.279 92.863Z",
    fill: "#171717",
    "fill-opacity": "0.64"
  }), /*#__PURE__*/jsx("path", {
    d: "M122.14 92.863H108.308C107.951 92.863 107.662 93.2201 107.662 93.6614V111.66C107.662 112.102 107.951 112.459 108.308 112.459H122.14C122.497 112.459 122.786 112.102 122.786 111.66V93.6614C122.786 93.2201 122.497 92.863 122.14 92.863Z",
    fill: "#171717"
  })]
});

const objectIsEmpty = object => {
  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      return false;
    }
  }
  return true;
};

var css_248z$c = ".Sidebar-module__sidebar___ViL-R{background-color:var(--white);border-right:1px solid var(--bg-dark);color:var(--text);display:flex;flex-direction:column;height:100vh;left:0;overflow:hidden;position:fixed;top:0;transition:width .3s ease,transform .3s ease;z-index:999}.Sidebar-module__sidebar___ViL-R.Sidebar-module__collapsed___1aZVQ .Sidebar-module__logoWrapper___86YMn{display:none}.Sidebar-module__sidebar___ViL-R.Sidebar-module__collapsed___1aZVQ .Sidebar-module__header___-vSdt{justify-content:center;padding:14px 8px}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt{align-items:center;display:flex;flex-shrink:0;justify-content:space-between;padding:14px 15px}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__logoWrapper___86YMn{flex:1;overflow:hidden}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__logoWrapper___86YMn .customLogoWrapper,.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__logoWrapper___86YMn .defaultLogoWrapper{margin:0}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__logoWrapper___86YMn .customLogoWrapper svg,.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__logoWrapper___86YMn .defaultLogoWrapper svg{height:40px}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__toggleButton___gYYFT{align-items:center;background:none;border:none;border-radius:var(--borderRadius,4px);color:var(--text);cursor:pointer;display:flex;flex-shrink:0;justify-content:center;padding:8px;transition:background-color .3s ease}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__toggleButton___gYYFT:hover{background-color:hsla(0,0%,100%,.1)}.Sidebar-module__sidebar___ViL-R .Sidebar-module__header___-vSdt .Sidebar-module__toggleButton___gYYFT svg{height:20px;width:20px}.Sidebar-module__sidebar___ViL-R .Sidebar-module__nav___QnVWk{display:flex;flex:1;flex-direction:column;overflow-x:hidden;overflow-y:auto}.Sidebar-module__sidebar___ViL-R .Sidebar-module__footer___1ghzs{flex-shrink:0;margin-top:auto;padding:8px 0}.Sidebar-module__mobile___eJsfm{box-shadow:none;transform:translateX(-100%);width:280px!important}.Sidebar-module__mobile___eJsfm.Sidebar-module__open___-ffsV{transform:translateX(0);z-index:9999}@media (max-width:1024px){.Sidebar-module__sidebar___ViL-R{width:280px}}";
var css$b = {"sidebar":"Sidebar-module__sidebar___ViL-R","collapsed":"Sidebar-module__collapsed___1aZVQ","logoWrapper":"Sidebar-module__logoWrapper___86YMn","header":"Sidebar-module__header___-vSdt","toggleButton":"Sidebar-module__toggleButton___gYYFT","nav":"Sidebar-module__nav___QnVWk","footer":"Sidebar-module__footer___1ghzs","mobile":"Sidebar-module__mobile___eJsfm","open":"Sidebar-module__open___-ffsV"};
styleInject(css_248z$c);

const LayoutSidebar = ({
  logo,
  children,
  footer,
  width = 210,
  collapsedWidth = 70,
  isCollapsed: isCollapsedProp,
  onToggleCollapse,
  isMobile = false,
  isMobileOpen = false,
  onMobileClose,
  mobileOffsetTop = 0
}) => {
  const [internalIsCollapsed, setInternalIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved === 'true';
  });
  const isCollapsed = isCollapsedProp !== undefined ? isCollapsedProp : internalIsCollapsed;
  useEffect(() => {
    if (isMobile) {
      onToggleCollapse?.(false);
      return;
    }
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
    }
    if (isCollapsedProp === undefined) {
      onToggleCollapse?.(isCollapsed);
    }
  }, [isCollapsed, isMobile, onToggleCollapse, isCollapsedProp]);
  useEffect(() => {
    if (isMobile && isCollapsedProp === undefined) {
      setInternalIsCollapsed(false);
    }
  }, [isMobile, isCollapsedProp]);
  const handleToggle = () => {
    if (isCollapsedProp !== undefined) {
      onToggleCollapse?.(!isCollapsed);
    } else {
      setInternalIsCollapsed(prev => !prev);
    }
  };
  const handleNavClickCapture = useCallback(e => {
    if (isMobile) {
      const target = e.target;
      const link = target.closest('a');
      if (link) {
        const href = link.getAttribute('href');
        if (href && href !== '#') {
          setTimeout(() => {
            onMobileClose?.();
          }, 100);
        }
      }
    }
  }, [isMobile, onMobileClose]);
  const sidebarClassName = useMemo(() => {
    let className = css$b.sidebar;
    if (isCollapsed) {
      className = `${className} ${css$b.collapsed}`;
    }
    if (isMobile) {
      className = `${className} ${css$b.mobile}`;
      if (isMobileOpen) {
        className = `${className} ${css$b.open}`;
      }
    }
    return className;
  }, [isCollapsed, isMobile, isMobileOpen]);
  const sidebarStyle = useMemo(() => {
    const resolvedWidth = isCollapsed ? collapsedWidth : width;
    const top = isMobile ? mobileOffsetTop : 0;
    const height = isMobile ? `calc(100vh - ${mobileOffsetTop}px)` : '100vh';
    return {
      width: isMobile ? undefined : `${resolvedWidth}px`,
      top: `${top}px`,
      height
    };
  }, [collapsedWidth, isCollapsed, isMobile, mobileOffsetTop, width]);
  return /*#__PURE__*/jsxs("aside", {
    className: sidebarClassName,
    style: sidebarStyle,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$b.header,
      children: [!isCollapsed && logo, !isMobile && /*#__PURE__*/jsx("button", {
        className: css$b.toggleButton,
        onClick: handleToggle,
        "aria-label": isCollapsed ? 'Expand sidebar' : 'Collapse sidebar',
        title: isCollapsed ? 'Expand sidebar' : 'Collapse sidebar',
        children: /*#__PURE__*/jsx(Menu05, {
          color: colors$1.primary20
        })
      })]
    }), /*#__PURE__*/jsx("nav", {
      className: css$b.nav,
      onClickCapture: handleNavClickCapture,
      children: children
    }), footer && /*#__PURE__*/jsx("div", {
      className: css$b.footer,
      children: footer
    })]
  });
};

var css_248z$b = ".Header-module__header___E6WxV{background-color:var(--white);border-bottom:1px solid var(--bg-dark);position:fixed;right:0;top:0;transition:left .3s ease;z-index:999999}.Header-module__header___E6WxV .Header-module__container___lZl4i{align-items:center;display:flex;gap:24px;height:100%;justify-content:space-between;max-width:100%;padding:0 24px}.Header-module__header___E6WxV .Header-module__leftSection___Y8JcY{align-items:center;display:flex;flex:1;gap:12px;min-width:0}.Header-module__header___E6WxV .Header-module__leftContent___MLJAy{align-items:center;display:flex;flex:1;gap:12px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.Header-module__header___E6WxV .Header-module__leftContent___MLJAy *{max-width:100%;min-width:0}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU{align-items:center;background-color:var(--white);border:1px solid var(--bg-dark);border-radius:var(--borderRadius,8px);cursor:pointer;display:inline-flex;height:36px;justify-content:center;padding:0;position:relative;transition:background-color .2s ease,border-color .2s ease;width:36px}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU svg{color:var(--text);height:20px;width:20px}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU:hover{background-color:var(--bg-light,rgba(0,0,0,.04));border-color:var(--primary-color)}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU .Header-module__menuToggleBadge___hwkuk{background-color:var(--danger);border:2px solid var(--white);border-radius:50%;box-sizing:content-box;height:8px;pointer-events:none;position:absolute;right:-3px;top:-3px;width:8px}.Header-module__header___E6WxV .Header-module__rightSection___rYonb{align-items:center;display:flex;flex-shrink:0;gap:16px;margin-left:auto}@media (max-width:1024px){.Header-module__header___E6WxV .Header-module__container___lZl4i{gap:16px;padding:0 16px}.Header-module__header___E6WxV .Header-module__rightSection___rYonb{gap:12px}}@media (max-width:768px){.Header-module__header___E6WxV .Header-module__container___lZl4i{gap:12px;padding:0 12px}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU{height:32px;width:32px}.Header-module__header___E6WxV .Header-module__menuToggleButton___2SwXU svg{height:18px;width:18px}.Header-module__header___E6WxV .Header-module__rightSection___rYonb{gap:0}}";
var css$a = {"header":"Header-module__header___E6WxV","container":"Header-module__container___lZl4i","leftSection":"Header-module__leftSection___Y8JcY","leftContent":"Header-module__leftContent___MLJAy","menuToggleButton":"Header-module__menuToggleButton___2SwXU","menuToggleBadge":"Header-module__menuToggleBadge___hwkuk","rightSection":"Header-module__rightSection___rYonb"};
styleInject(css_248z$b);

const MOBILE_BREAKPOINT$1 = 1024;
const LayoutHeader = ({
  leftSection,
  rightSection,
  height = 65,
  sidebarWidth = 250,
  showMenuToggle = false,
  onMenuToggle,
  isMenuOpen = false,
  hasPendingItems = false
}) => {
  const [isCompact, setIsCompact] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.innerWidth <= MOBILE_BREAKPOINT$1;
  });
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }
    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT$1}px)`);
    const handleChange = event => {
      setIsCompact(event.matches);
    };
    handleChange(mediaQuery);
    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }
    return () => {
      if (typeof mediaQuery.removeEventListener === 'function') {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, []);
  const resolvedSidebarWidth = useMemo(() => {
    if (isCompact) {
      return 0;
    }
    return Math.max(sidebarWidth, 0);
  }, [isCompact, sidebarWidth]);
  const headerStyle = useMemo(() => {
    if (isCompact) {
      return {
        height: `${height}px`,
        left: 0,
        width: '100%'
      };
    }
    if (resolvedSidebarWidth > 0) {
      return {
        height: `${height}px`,
        left: `${resolvedSidebarWidth - 1}px`,
        width: `calc(100% - ${resolvedSidebarWidth}px)`
      };
    }
    return {
      height: `${height}px`,
      left: 0,
      width: '100%'
    };
  }, [height, isCompact, resolvedSidebarWidth]);
  const handleMenuToggle = useCallback(() => {
    onMenuToggle?.();
  }, [onMenuToggle]);
  const hasLeftContent = showMenuToggle || !isCompact && leftSection;
  return /*#__PURE__*/jsx("header", {
    className: css$a.header,
    style: headerStyle,
    children: /*#__PURE__*/jsxs("div", {
      className: css$a.container,
      children: [hasLeftContent && /*#__PURE__*/jsxs("div", {
        className: css$a.leftSection,
        children: [showMenuToggle && /*#__PURE__*/jsxs("button", {
          type: "button",
          className: css$a.menuToggleButton,
          onClick: handleMenuToggle,
          "aria-label": `${isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}`,
          "aria-expanded": isMenuOpen,
          children: [/*#__PURE__*/jsx(Menu05, {}), hasPendingItems && !isMenuOpen && /*#__PURE__*/jsx("span", {
            className: css$a.menuToggleBadge,
            "aria-hidden": "true"
          })]
        }), !isCompact && leftSection && /*#__PURE__*/jsx("div", {
          className: css$a.leftContent,
          children: leftSection
        })]
      }), rightSection && /*#__PURE__*/jsx("div", {
        className: css$a.rightSection,
        children: rightSection
      })]
    })
  });
};

var css_248z$a = ".Layout-module__layout___Bjb4T{min-height:100vh;position:relative;width:100%}.Layout-module__content___EMp7e{box-sizing:border-box;min-height:calc(100vh - 65px);padding:24px;transition:margin-left .3s ease}.Layout-module__sidebarOverlay___zrBVx{background:rgba(0,0,0,.3);border:none;cursor:pointer;inset:0;margin:0;padding:0;position:fixed;z-index:998}.Layout-module__mobileSidebarOpen___bzStQ{overflow:hidden}@media (max-width:1024px){.Layout-module__content___EMp7e{padding:20px 16px}}@media (max-width:768px){.Layout-module__content___EMp7e{padding:16px 12px}}";
var css$9 = {"layout":"Layout-module__layout___Bjb4T","content":"Layout-module__content___EMp7e","sidebarOverlay":"Layout-module__sidebarOverlay___zrBVx","mobileSidebarOpen":"Layout-module__mobileSidebarOpen___bzStQ"};
styleInject(css_248z$a);

const MOBILE_BREAKPOINT = 1024;
const useIsMobileViewport = () => {
  const getIsMobile = () => typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;
  const [isMobile, setIsMobile] = useState(getIsMobile);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isMobile;
};
const Layout = ({
  sidebarContent,
  sidebarFooter,
  headerLeftSection,
  headerRightSection,
  children,
  sidebarWidth = 250,
  collapsedSidebarWidth = 70,
  headerHeight = 65,
  contentPaddingTop = 0,
  logo,
  hasPendingItems = false
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.localStorage.getItem('sidebarCollapsed') === 'true';
  });
  const isMobile = useIsMobileViewport();
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const currentSidebarWidth = sidebarCollapsed ? collapsedSidebarWidth : sidebarWidth;
  const effectiveSidebarWidth = isMobile ? 0 : currentSidebarWidth;
  useTrackedHotkeys('backspace', () => {
    console.log('toggle sidebar');
    setSidebarCollapsed(prevState => !prevState);
  }, 'toggleSidebar');
  useEffect(() => {
    if (typeof window !== 'undefined' && !isMobile) {
      window.localStorage.setItem('sidebarCollapsed', sidebarCollapsed.toString());
    }
  }, [sidebarCollapsed, isMobile]);
  useEffect(() => {
    if (isMobile && sidebarCollapsed) {
      setSidebarCollapsed(false);
    }
  }, [isMobile, sidebarCollapsed]);
  useEffect(() => {
    if (!isMobileSidebarOpen) {
      return;
    }
    const handleEscape = event => {
      if (event.key === 'Escape') {
        setIsMobileSidebarOpen(false);
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isMobileSidebarOpen]);
  useEffect(() => {
    if (!isMobile && isMobileSidebarOpen) {
      setIsMobileSidebarOpen(false);
    }
  }, [isMobile, isMobileSidebarOpen]);
  const handleMobileMenuToggle = () => {
    setIsMobileSidebarOpen(prev => !prev);
  };
  const handleMobileMenuClose = () => {
    setIsMobileSidebarOpen(false);
  };
  const layoutClassName = useMemo(() => `${css$9.layout}${isMobileSidebarOpen ? ` ${css$9.mobileSidebarOpen}` : ''}`, [isMobileSidebarOpen]);
  const mainStyle = useMemo(() => ({
    marginLeft: isMobile ? 0 : `${currentSidebarWidth}px`,
    paddingTop: `${headerHeight + contentPaddingTop}px`
  }), [currentSidebarWidth, headerHeight, isMobile]);
  const overlayStyle = useMemo(() => ({
    top: `${headerHeight}px`
  }), [headerHeight]);
  const shouldRenderOverlay = isMobile && isMobileSidebarOpen;
  return /*#__PURE__*/jsx(SidebarProvider, {
    isCollapsed: sidebarCollapsed,
    children: /*#__PURE__*/jsxs("div", {
      className: layoutClassName,
      children: [/*#__PURE__*/jsx(LayoutSidebar, {
        width: sidebarWidth,
        collapsedWidth: collapsedSidebarWidth,
        logo: logo,
        footer: sidebarFooter,
        isCollapsed: sidebarCollapsed,
        onToggleCollapse: setSidebarCollapsed,
        isMobile: isMobile,
        isMobileOpen: isMobileSidebarOpen,
        onMobileClose: handleMobileMenuClose,
        mobileOffsetTop: headerHeight,
        children: sidebarContent
      }), /*#__PURE__*/jsx(LayoutHeader, {
        height: headerHeight,
        leftSection: headerLeftSection,
        rightSection: headerRightSection,
        sidebarWidth: effectiveSidebarWidth,
        showMenuToggle: isMobile,
        onMenuToggle: handleMobileMenuToggle,
        isMenuOpen: isMobileSidebarOpen,
        hasPendingItems: hasPendingItems
      }), shouldRenderOverlay && /*#__PURE__*/jsx("button", {
        type: "button",
        className: css$9.sidebarOverlay,
        onClick: handleMobileMenuClose,
        "aria-label": "Close navigation menu",
        style: overlayStyle
      }), /*#__PURE__*/jsx("main", {
        className: css$9.content,
        style: mainStyle,
        children: children
      })]
    })
  });
};

var css_248z$9 = ".MenuItem-module__menuItemWrapper___raAX-{position:relative;width:100%}.MenuItem-module__menuItemWrapper___raAX-:hover .MenuItem-module__subMenu___8Hz-h{display:block}.MenuItem-module__link___5x4jY{color:inherit;cursor:pointer;display:block;text-decoration:none;width:100%}.MenuItem-module__menuItem___nMcye{align-items:center;color:var(--text);cursor:pointer;display:flex;font-size:var(--body-regular-size);gap:12px;margin:1px 0;padding:12px 16px;transition:background-color .2s ease,padding .3s ease;white-space:nowrap}.MenuItem-module__menuItem___nMcye:hover{background-color:var(--bg-light)}.MenuItem-module__menuItem___nMcye.MenuItem-module__collapsed___9Rd-y{justify-content:center;padding:12px 8px}.MenuItem-module__menuItem___nMcye.MenuItem-module__collapsed___9Rd-y .MenuItem-module__icon___MD-Uw{min-width:24px}.MenuItem-module__menuItem___nMcye .MenuItem-module__icon___MD-Uw{align-items:center;display:flex;flex-shrink:0;justify-content:center;min-width:20px}.MenuItem-module__menuItem___nMcye .MenuItem-module__iconWithBadge___mp8c1{position:relative}.MenuItem-module__menuItem___nMcye .MenuItem-module__iconBadgeOverlay___4W0XE{pointer-events:none;position:absolute;right:-10px;top:-8px;transform:scale(.8);transform-origin:top right}.MenuItem-module__menuItem___nMcye .MenuItem-module__title___Ac5p6{align-items:center;display:flex;flex:1;gap:6px;overflow:hidden;text-overflow:ellipsis}.MenuItem-module__menuItem___nMcye .MenuItem-module__caret___13FR9{align-items:center;display:flex;flex-shrink:0;margin-left:auto}.MenuItem-module__subMenu___8Hz-h{background-color:var(--bg-light-48);border-radius:var(--border-radius-small);list-style:none;padding:4px 0;position:relative;width:100%}.MenuItem-module__subMenu___8Hz-h li{margin:0;padding:0}.MenuItem-module__subMenu___8Hz-h li a,.MenuItem-module__subMenu___8Hz-h li button{background:none;border:none;color:var(--text);cursor:pointer;display:block;font-size:var(--body-regular-size);padding:10px 15px 10px 48px;text-align:left;text-decoration:none;transition:background-color .2s ease;width:100%}.MenuItem-module__subMenu___8Hz-h li a:hover,.MenuItem-module__subMenu___8Hz-h li button:hover{background-color:var(--bg-light)}.MenuItem-module__subMenu___8Hz-h.MenuItem-module__flyout___RC86W{background-color:#fff;border:1px solid var(--bg-dark);padding:4px 0;position:fixed;width:max-content;z-index:999}.MenuItem-module__subMenu___8Hz-h.MenuItem-module__flyout___RC86W li a,.MenuItem-module__subMenu___8Hz-h.MenuItem-module__flyout___RC86W li button{color:var(--primary-color);font-size:var(--body-small-size);opacity:1;padding:8px 12px}.MenuItem-module__subMenu___8Hz-h.MenuItem-module__flyout___RC86W li a:hover,.MenuItem-module__subMenu___8Hz-h.MenuItem-module__flyout___RC86W li button:hover{background-color:var(--bg-light)}.MenuItem-module__active___2YsfF,.MenuItem-module__active___2YsfF:hover{background-color:var(--primary-10)!important}.MenuItem-module__blocked___jnxB9{color:var(--grey-20)}";
var css$8 = {"menuItemWrapper":"MenuItem-module__menuItemWrapper___raAX-","subMenu":"MenuItem-module__subMenu___8Hz-h","link":"MenuItem-module__link___5x4jY","menuItem":"MenuItem-module__menuItem___nMcye","collapsed":"MenuItem-module__collapsed___9Rd-y","icon":"MenuItem-module__icon___MD-Uw","iconWithBadge":"MenuItem-module__iconWithBadge___mp8c1","iconBadgeOverlay":"MenuItem-module__iconBadgeOverlay___4W0XE","title":"MenuItem-module__title___Ac5p6","caret":"MenuItem-module__caret___13FR9","flyout":"MenuItem-module__flyout___RC86W","active":"MenuItem-module__active___2YsfF","blocked":"MenuItem-module__blocked___jnxB9"};
styleInject(css_248z$9);

const useOptionalLocation$1 = () => {
  try {
    return useLocation();
  } catch (error) {
    return null;
  }
};
const LayoutMenuItem = ({
  title,
  icon,
  linkTo,
  children,
  isBlocked = false,
  isSelected = false,
  isSpa = true,
  onClick,
  color,
  badge = null
}) => {
  const [showSubMenu, setShowSubMenu] = useState(false);
  const subMenuRef = useRef(null);
  const {
    isCollapsed
  } = useSidebar();
  const isOverlayBadge = !!badge && isCollapsed;
  const isInRouterContext = useInRouterContext();
  const location = useOptionalLocation$1();
  useClickOutside(subMenuRef, () => {
    if (!isCollapsed) {
      return;
    }
    setShowSubMenu(false);
  });
  const validChildren = React.Children.toArray(children).filter(child => child);
  const hasChildren = validChildren.length > 0;
  const canUseNavLink = isInRouterContext && isSpa && !hasChildren && linkTo && !onClick;
  const currentPath = useMemo(() => {
    const routerPath = location?.pathname ?? '';
    if (typeof window !== 'undefined') {
      const hashPath = window.location.hash && window.location.hash.startsWith('#/') ? window.location.hash.slice(1) : '';
      if (hashPath) {
        return hashPath;
      }
      if (!routerPath && window.location.pathname) {
        return window.location.pathname;
      }
    }
    return routerPath;
  }, [location]);
  const hasActiveChild = useMemo(() => {
    if (!hasChildren || !currentPath) {
      return false;
    }
    return validChildren.some(child => {
      if (! /*#__PURE__*/React.isValidElement(child)) {
        return false;
      }
      const childLinkTo = child.props?.linkTo;
      if (!childLinkTo) {
        return false;
      }
      const normalizedChildLink = childLinkTo.startsWith('/') ? childLinkTo : `/${childLinkTo}`;
      return currentPath.startsWith(normalizedChildLink);
    });
  }, [currentPath, hasChildren, validChildren]);
  useLayoutEffect(() => {
    if (isCollapsed) {
      setShowSubMenu(false);
    }
  }, [isCollapsed]);
  useEffect(() => {
    if (!isCollapsed && hasActiveChild) {
      setShowSubMenu(true);
    }
  }, [hasActiveChild, isCollapsed]);
  const finalLinkTo = useMemo(() => {
    if (!linkTo) {
      return linkTo;
    }
    if (canUseNavLink) {
      return linkTo;
    }
    const isExternalLink = /^([a-z][a-z0-9+\-.]*:|\/\/)/i.test(linkTo) || linkTo.startsWith('#');
    if (isExternalLink) {
      return linkTo;
    }
    const normalizedLink = linkTo.startsWith('/') ? linkTo : `/${linkTo}`;
    if (typeof window !== 'undefined') {
      const hasHashRouting = window.location.hash && window.location.hash.includes('#/');
      const inAppPath = window.location.pathname && window.location.pathname.startsWith('/app');
      if (hasHashRouting) {
        return linkTo.startsWith('#') ? linkTo : `#${normalizedLink}`;
      }
      if (isSpa && !linkTo.startsWith('/app') && inAppPath) {
        return `/app${normalizedLink}`;
      }
      if (!isSpa) {
        if (linkTo.startsWith('/')) {
          return linkTo;
        }
        if (inAppPath) {
          return `/app${normalizedLink}`;
        }
      }
    }
    return normalizedLink;
  }, [canUseNavLink, isSpa, linkTo]);
  const handleClick = e => {
    if (hasChildren) {
      e.preventDefault();
      e.stopPropagation();
      setShowSubMenu(!showSubMenu);
      return;
    }
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  const handleMouseEnter = () => {
    if (hasChildren && isCollapsed) {
      setShowSubMenu(true);
    }
  };
  const handleMouseLeave = () => {
    if (hasChildren && isCollapsed) {
      setShowSubMenu(false);
    }
  };
  const menuItemContent = /*#__PURE__*/jsxs("div", {
    className: `${css$8.menuItem} ${(isSelected || hasActiveChild) && css$8.active} ${isCollapsed && css$8.collapsed}`,
    title: isCollapsed ? typeof title === 'string' ? title : '' : '',
    style: {
      color: color
    },
    children: [icon && /*#__PURE__*/jsxs("span", {
      className: `${css$8.icon} ${badge ? css$8.iconWithBadge : ''}`,
      children: [icon, isOverlayBadge && /*#__PURE__*/jsx("span", {
        className: css$8.iconBadgeOverlay,
        children: badge
      })]
    }), !isCollapsed && title && /*#__PURE__*/jsxs("span", {
      className: css$8.title,
      children: [title, !isOverlayBadge && badge]
    }), !isCollapsed && hasChildren && /*#__PURE__*/jsx("span", {
      className: css$8.caret,
      children: /*#__PURE__*/jsx(ChevronDown, {
        width: 10,
        height: 10
      })
    })]
  });
  return /*#__PURE__*/jsxs("div", {
    className: css$8.menuItemWrapper,
    ref: subMenuRef,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    children: [hasChildren ? /*#__PURE__*/jsx("div", {
      className: css$8.link,
      onClick: handleClick,
      children: menuItemContent
    }) : canUseNavLink ? /*#__PURE__*/jsx(NavLink, {
      to: isBlocked ? '#' : finalLinkTo ?? '#',
      className: css$8.link,
      onClick: handleClick,
      children: menuItemContent
    }) : /*#__PURE__*/jsx("a", {
      href: isBlocked || !finalLinkTo ? '#' : finalLinkTo,
      className: css$8.link,
      onClick: handleClick,
      children: menuItemContent
    }), hasChildren && showSubMenu && /*#__PURE__*/jsx("ul", {
      className: `${css$8.subMenu} ${isCollapsed ? css$8.flyout : ''}`,
      onClick: e => {
        e.stopPropagation();
        if (isCollapsed) {
          setShowSubMenu(false);
        }
      },
      style: isCollapsed && subMenuRef.current ? {
        left: `${subMenuRef.current.getBoundingClientRect().right}px`,
        top: `${subMenuRef.current.getBoundingClientRect().top}px`
      } : {},
      children: validChildren
    })]
  });
};

const useOptionalLocation = () => {
  try {
    return useLocation();
  } catch (error) {
    return null;
  }
};
const LayoutSecondaryMenuItem = ({
  title,
  linkTo,
  onClick,
  isBlocked,
  blockedLink,
  isSpa = true,
  isSelected,
  badge = null
}) => {
  const isInRouterContext = useInRouterContext();
  const location = useOptionalLocation();
  const targetLink = isBlocked ? blockedLink || linkTo : linkTo;
  const canUseNavLink = isInRouterContext && isSpa && !onClick && !isBlocked && targetLink;
  const normalizedLink = useMemo(() => {
    if (!targetLink) {
      return targetLink;
    }
    return targetLink.startsWith('/') ? targetLink : `/${targetLink}`;
  }, [targetLink]);
  const finalLinkTo = useMemo(() => {
    if (!targetLink) {
      return targetLink;
    }
    if (canUseNavLink) {
      return targetLink;
    }
    const isExternalLink = /^([a-z][a-z0-9+\-.]*:|\/\/)/i.test(targetLink) || targetLink.startsWith('#');
    if (isExternalLink) {
      return targetLink;
    }
    if (!normalizedLink) {
      return targetLink;
    }
    if (typeof window !== 'undefined') {
      const hasHashRouting = window.location.hash && window.location.hash.includes('#/');
      const inAppPath = window.location.pathname && window.location.pathname.startsWith('/app');
      if (hasHashRouting) {
        return targetLink.startsWith('#') ? targetLink : `#${normalizedLink}`;
      }
      if (isSpa && !targetLink.startsWith('/app') && inAppPath) {
        return `/app${normalizedLink}`;
      }
      if (!isSpa) {
        if (targetLink.startsWith('/')) {
          return targetLink;
        }
        if (inAppPath) {
          return `/app${normalizedLink}`;
        }
      }
    }
    return normalizedLink;
  }, [canUseNavLink, isSpa, normalizedLink, targetLink]);
  const isActive = useMemo(() => {
    if (isBlocked) {
      return false;
    }
    if (isSelected !== undefined) {
      return isSelected;
    }
    if (!finalLinkTo) {
      return false;
    }
    const currentPath = (() => {
      const routerPath = location?.pathname ?? '';
      if (typeof window !== 'undefined') {
        const hashPath = window.location.hash && window.location.hash.startsWith('#/') ? window.location.hash.slice(1) : '';
        if (hashPath) {
          return hashPath;
        }
        if (!routerPath && window.location.pathname) {
          return window.location.pathname;
        }
      }
      return routerPath;
    })();
    if (!currentPath) {
      return false;
    }
    const normalizePath = path => {
      if (!path) {
        return '';
      }
      let normalized = path.startsWith('#') ? path.slice(1) : path;
      normalized = normalized.startsWith('/app') ? normalized.slice(4) : normalized;
      normalized = normalized.replace(/\/$/, '').toLowerCase();
      return normalized;
    };
    const normalizedCurrentPath = normalizePath(currentPath);
    const normalizedLinkPath = normalizePath(finalLinkTo);
    if (normalizedCurrentPath === normalizedLinkPath) {
      return true;
    }
    if (normalizedLinkPath && normalizedCurrentPath.startsWith(normalizedLinkPath + '/')) {
      return true;
    }
    return false;
  }, [finalLinkTo, isBlocked, isSelected, location]);
  const content = /*#__PURE__*/jsxs("span", {
    className: isBlocked ? css$8.blocked : undefined,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px'
    },
    children: [isBlocked && /*#__PURE__*/jsx(Lock02Icon, {
      width: 15,
      height: 15,
      color: colors$1.grey20
    }), /*#__PURE__*/jsx("span", {
      children: title ?? ''
    }), badge]
  });
  const liClassName = useMemo(() => {
    const classes = [];
    if (isBlocked) {
      classes.push(css$8.blocked);
    }
    if (isActive) {
      classes.push(css$8.active);
    }
    return classes.length > 0 ? classes.join(' ') : undefined;
  }, [isBlocked, isActive]);
  return /*#__PURE__*/jsx("li", {
    className: liClassName,
    children: canUseNavLink ? /*#__PURE__*/jsx(NavLink, {
      to: finalLinkTo,
      className: isBlocked ? css$8.blocked : undefined,
      children: content
    }) : /*#__PURE__*/jsx("a", {
      href: finalLinkTo,
      onClick: isBlocked ? undefined : onClick ? e => {
        e.preventDefault();
        onClick();
      } : undefined,
      "aria-disabled": isBlocked,
      style: isBlocked ? {
        color: colors$1.grey20
      } : undefined,
      children: content
    })
  });
};

var css_248z$8 = ".Breadcrumbs-module__breadcrumbs___5v7RJ{align-items:center;color:var(--grey-64);display:flex;flex-wrap:wrap;font-size:14px;gap:8px}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__homeIcon___8kOMI{align-items:center;color:var(--grey-64);display:flex;text-decoration:none;transition:color .2s ease}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__homeIcon___8kOMI:hover{color:var(--primary-color)}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__homeIcon___8kOMI svg{stroke:currentColor}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__separator___pNudJ{color:var(--grey-64);font-weight:300}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__hotelName___2NIkB{color:var(--grey-64);font-weight:400}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__link___T9oS2{color:var(--primary-color);text-decoration:none;transition:opacity .2s ease}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__link___T9oS2:hover{opacity:.8}.Breadcrumbs-module__breadcrumbs___5v7RJ .Breadcrumbs-module__current___T6IeY{color:var(--secondary-color);font-weight:500}";
var css$7 = {"breadcrumbs":"Breadcrumbs-module__breadcrumbs___5v7RJ","homeIcon":"Breadcrumbs-module__homeIcon___8kOMI","separator":"Breadcrumbs-module__separator___pNudJ","hotelName":"Breadcrumbs-module__hotelName___2NIkB","link":"Breadcrumbs-module__link___T9oS2","current":"Breadcrumbs-module__current___T6IeY"};
styleInject(css_248z$8);

const LayoutBreadcrumbs = ({
  currentHotel,
  linkTo,
  routeLabels = {},
  homePath = 'dashboard'
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  const breadcrumbItems = [];
  let startIndex = 0;
  if (pathParts[0] === 'app' || !isNaN(pathParts[0])) {
    startIndex = 1;
  }
  for (let i = startIndex; i < pathParts.length; i++) {
    const part = pathParts[i];
    if (!isNaN(part)) {
      continue;
    }
    const label = routeLabels[part] || part.charAt(0).toUpperCase() + part.slice(1);
    breadcrumbItems.push({
      label,
      isLast: i === pathParts.length - 1
    });
  }
  const hotelName = useMemo(() => {
    return hotelNamePlain(currentHotel?.name, currentHotel?.city, isDemoMode);
  }, [currentHotel, isDemoMode]);
  const homeLink = currentHotel && linkTo ? linkTo(homePath) : '/';
  return /*#__PURE__*/jsxs("nav", {
    className: css$7.breadcrumbs,
    children: [/*#__PURE__*/jsx(NavLink, {
      to: homeLink,
      className: css$7.homeIcon,
      children: /*#__PURE__*/jsx(Home02, {
        width: 15,
        height: 15
      })
    }), currentHotel && /*#__PURE__*/jsx("span", {
      className: css$7.hotelName,
      dangerouslySetInnerHTML: {
        __html: hotelName
      }
    }), breadcrumbItems.map((item, index) => /*#__PURE__*/jsxs(React.Fragment, {
      children: [/*#__PURE__*/jsx("span", {
        className: css$7.separator,
        children: "/"
      }), /*#__PURE__*/jsx("span", {
        className: item.isLast ? css$7.current : css$7.link,
        children: item.label
      })]
    }, index))]
  });
};

/**
 * Wire keyboard ArrowUp / ArrowDown to navigate between items in a list, typically when
 * a detail side-panel is open. Designed for list+panel patterns: while the panel is open
 * (driven by `isActive`), pressing ArrowDown / ArrowUp moves the "current id" to the next
 * or previous id in the caller-provided order.
 *
 * Behavior:
 *  - Skips when focus is in an `<input>`, `<textarea>`, or `contenteditable` element so
 *    the user can still type in forms inside the panel without the row swapping.
 *  - Boundary-safe: at the first/last id, the corresponding arrow does nothing (no wrap).
 *  - Listener attaches when `isActive` flips to `true` and detaches when it flips back.
 *  - `getOrderedIds`, `currentId`, and `onNavigate` are read from refs at keydown time, so
 *    callers may pass fresh closures each render without re-attaching the listener.
 *
 * The hook is intentionally agnostic about what an "id" or "item" is — pass any primitive
 * that supports strict equality (number or string). Deduplication / merging multiple
 * sources is the caller's job inside `getOrderedIds`.
 *
 * @param {Object}   params
 * @param {boolean}  params.isActive       Whether the listener should be attached.
 * @param {*}        params.currentId      The currently-selected id; null when nothing is selected.
 * @param {Function} params.getOrderedIds  Returns the list of ids in visible order.
 * @param {Function} params.onNavigate     Called with the next id when ArrowUp/Down moves focus.
 */
const useListKeyboardNavigation = ({
  isActive,
  currentId,
  getOrderedIds,
  onNavigate
}) => {
  const currentIdRef = useRef(currentId);
  const getOrderedIdsRef = useRef(getOrderedIds);
  const onNavigateRef = useRef(onNavigate);
  useEffect(() => {
    currentIdRef.current = currentId;
    getOrderedIdsRef.current = getOrderedIds;
    onNavigateRef.current = onNavigate;
  });
  useEffect(() => {
    if (!isActive) {
      return undefined;
    }
    const handleKeyDown = event => {
      const target = event.target;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return;
      }
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
        return;
      }
      const ids = getOrderedIdsRef.current();
      if (!Array.isArray(ids) || ids.length === 0) {
        return;
      }
      const currentIndex = ids.indexOf(currentIdRef.current);
      if (currentIndex === -1) {
        return;
      }
      let newIndex = -1;
      if (event.key === 'ArrowDown' && currentIndex < ids.length - 1) {
        newIndex = currentIndex + 1;
      } else if (event.key === 'ArrowUp' && currentIndex > 0) {
        newIndex = currentIndex - 1;
      }
      if (newIndex < 0) {
        return;
      }
      event.preventDefault();
      onNavigateRef.current(ids[newIndex]);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isActive]);
};

var css_248z$7 = ".HotelPickerButton-module__hotelPickerButton___rwyFm{border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);cursor:pointer;display:flex;gap:10px;padding:3px 10px}.HotelPickerButton-module__hotelPickerButton___rwyFm:hover{background-color:var(--bg-light-48)}.HotelPickerButton-module__wrapper___upDD1{align-items:center;background:none;border:none;display:inline-flex;gap:8px;padding:0}.HotelPickerButton-module__hotelInfo___XXoUt{align-items:flex-start;display:flex;flex-direction:column;gap:2px;min-width:0}.HotelPickerButton-module__hotelLabel___Nm0Dz{color:var(--text);font-size:11px;font-weight:600;text-transform:uppercase}.HotelPickerButton-module__hotelNameRow___qsgcy{align-items:center;display:flex;gap:6px;max-width:180px;min-width:0}.HotelPickerButton-module__hotelName___BCvIj{color:var(--grey-64);font-size:var(--body-regular-size);min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.HotelPickerButton-module__chevron___nXnnz{align-items:center;display:flex;justify-content:center}@media (max-width:768px){.HotelPickerButton-module__hotelPickerButton___rwyFm{gap:6px;max-width:60px;padding:2px 6px}.HotelPickerButton-module__wrapper___upDD1{gap:4px}.HotelPickerButton-module__hotelInfo___XXoUt{flex:1;gap:1px;min-width:0}.HotelPickerButton-module__hotelLabel___Nm0Dz{font-size:10px}.HotelPickerButton-module__hotelNameRow___qsgcy{gap:4px;max-width:100%;width:100%}.HotelPickerButton-module__hotelName___BCvIj{font-size:12px;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.HotelPickerButton-module__chevron___nXnnz{flex-shrink:0;transform:scale(.85)}}";
var css$6 = {"hotelPickerButton":"HotelPickerButton-module__hotelPickerButton___rwyFm","wrapper":"HotelPickerButton-module__wrapper___upDD1","hotelInfo":"HotelPickerButton-module__hotelInfo___XXoUt","hotelLabel":"HotelPickerButton-module__hotelLabel___Nm0Dz","hotelNameRow":"HotelPickerButton-module__hotelNameRow___qsgcy","hotelName":"HotelPickerButton-module__hotelName___BCvIj","chevron":"HotelPickerButton-module__chevron___nXnnz"};
styleInject(css_248z$7);

var css_248z$6 = ".HotelStatusDot-module__statusDot___5BV1h{border-radius:50%;display:inline-block;flex-shrink:0;height:8px;width:8px}.HotelStatusDot-module__statusDotWithLabel___pkkgB{align-items:center;display:inline-flex;gap:10px}.HotelStatusDot-module__online___CfUUw{background-color:var(--success);box-shadow:0 0 0 2px var(--success-10)}.HotelStatusDot-module__offline___dsY6C{background-color:var(--danger);box-shadow:0 0 0 2px var(--danger-10)}.HotelStatusDot-module__onboarding___1XDty{background-color:var(--warning);box-shadow:0 0 0 2px var(--warning-10)}.HotelStatusDot-module__terminated___ell2J{background-color:var(--grey-64);box-shadow:0 0 0 2px var(--grey-20)}";
var css$5 = {"statusDot":"HotelStatusDot-module__statusDot___5BV1h","statusDotWithLabel":"HotelStatusDot-module__statusDotWithLabel___pkkgB","online":"HotelStatusDot-module__online___CfUUw","offline":"HotelStatusDot-module__offline___dsY6C","onboarding":"HotelStatusDot-module__onboarding___1XDty","terminated":"HotelStatusDot-module__terminated___ell2J"};
styleInject(css_248z$6);

const STATUS_CLASS_MAP = {
  [HOTEL_STATUS.ONLINE]: css$5.online,
  [HOTEL_STATUS.OFFLINE]: css$5.offline,
  [HOTEL_STATUS.ONBOARDING]: css$5.onboarding,
  [HOTEL_STATUS.TERMINATED]: css$5.terminated
};
const STATUS_LABEL_MAP = {
  [HOTEL_STATUS.ONLINE]: 'Online',
  [HOTEL_STATUS.OFFLINE]: 'Offline',
  [HOTEL_STATUS.ONBOARDING]: 'Onboarding',
  [HOTEL_STATUS.TERMINATED]: 'Terminated'
};
const HotelStatusDot = ({
  status,
  title,
  showLabel = false
}) => {
  if (!status) {
    return null;
  }
  const statusClass = STATUS_CLASS_MAP[status];
  const label = STATUS_LABEL_MAP[status] ?? status;
  const tooltip = title ?? label;
  if (!showLabel) {
    if (!statusClass) {
      return null;
    }
    return /*#__PURE__*/jsx("span", {
      className: `${css$5.statusDot} ${statusClass}`,
      title: tooltip,
      "aria-label": tooltip,
      role: "img"
    });
  }
  return /*#__PURE__*/jsxs("span", {
    className: css$5.statusDotWithLabel,
    title: tooltip,
    children: [statusClass && /*#__PURE__*/jsx("span", {
      className: `${css$5.statusDot} ${statusClass}`,
      "aria-hidden": "true"
    }), /*#__PURE__*/jsx("span", {
      children: label
    })]
  });
};

const HotelPickerButton = ({
  currentHotel,
  label = 'Hotel',
  showLabel = true,
  onClick,
  showChevron = false
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const handleClick = event => {
    onClick?.(event);
  };
  const hotelName = useMemo(() => hotelNamePlain(currentHotel?.shortName, undefined, isDemoMode), [currentHotel?.shortName, isDemoMode]);
  return /*#__PURE__*/jsxs("div", {
    className: css$6.hotelPickerButton,
    onClick: onClick ? handleClick : undefined,
    children: [/*#__PURE__*/jsxs("div", {
      className: css$6.hotelInfo,
      children: [showLabel && /*#__PURE__*/jsx("div", {
        className: css$6.hotelLabel,
        children: label
      }), /*#__PURE__*/jsxs("div", {
        className: css$6.hotelNameRow,
        children: [/*#__PURE__*/jsx("span", {
          className: css$6.hotelName,
          children: hotelName
        }), /*#__PURE__*/jsx(HotelStatusDot, {
          status: currentHotel?.status
        })]
      })]
    }), showChevron && /*#__PURE__*/jsx("span", {
      className: css$6.chevron,
      children: /*#__PURE__*/jsx(ChevronDown, {})
    })]
  });
};

var css_248z$5 = ".AppsPickerButton-module__wrapper___AyCSH{position:relative}.AppsPickerButton-module__wrapper___AyCSH .AppsPickerButton-module__button___vRXjO{align-items:center;background-color:var(--bg-light-48);border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);color:var(--primary-color);cursor:pointer;display:flex;padding:8px;transition:background-color .2s ease}.AppsPickerButton-module__wrapper___AyCSH .AppsPickerButton-module__button___vRXjO:hover{background-color:var(--bg-light-80)}.AppsPickerButton-module__dropdown___luOaG{background-color:#fff;border:1px solid var(--bg-dark);border-radius:var(--border-radius-small);position:absolute;right:0;z-index:1000}.AppsPickerButton-module__dropdown___luOaG .AppsPickerButton-module__item___QOkfR{background:none;border:none;color:var(--text);cursor:pointer;display:block;font-size:var(--body-regular-size);padding:10px 15px;text-align:left;text-decoration:none;transition:background-color .2s ease}.AppsPickerButton-module__dropdown___luOaG .AppsPickerButton-module__item___QOkfR:hover{background-color:var(--bg-light-48)}";
var css$4 = {"wrapper":"AppsPickerButton-module__wrapper___AyCSH","button":"AppsPickerButton-module__button___vRXjO","dropdown":"AppsPickerButton-module__dropdown___luOaG","item":"AppsPickerButton-module__item___QOkfR"};
styleInject(css_248z$5);

const AppsPickerButton = ({
  extranet = false,
  onArrival = false,
  hq = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  useClickOutside(wrapperRef, () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });
  if (!extranet && !onArrival && !hq) {
    return null;
  }
  const handleToggle = () => {
    setIsOpen(prevState => {
      const nextState = !prevState;
      return nextState;
    });
  };
  const handleItemClick = () => {
    setIsOpen(false);
  };
  useTrackedHotkeys('g>p', () => {
    if (!extranet) {
      return false;
    }
    window.location = '/sso/redirect?audience=EXTRANET';
  }, 'extranet');
  useTrackedHotkeys('g>o', () => {
    if (!onArrival) {
      return false;
    }
    window.location = '/sso/redirect?audience=GUSTAVE';
  }, 'onarrival');
  useTrackedHotkeys('g>h', () => {
    if (!hq) {
      return false;
    }
    window.location = '/sso/redirect?audience=HQ';
  }, 'hq');
  return /*#__PURE__*/jsxs("div", {
    ref: wrapperRef,
    className: css$4.wrapper,
    children: [/*#__PURE__*/jsx("button", {
      type: "button",
      className: css$4.button,
      onClick: handleToggle,
      "aria-haspopup": "menu",
      "aria-expanded": isOpen,
      "aria-label": "Open apps picker",
      children: /*#__PURE__*/jsx(Grid01Icon, {
        width: 20
      })
    }), isOpen && /*#__PURE__*/jsxs("div", {
      className: css$4.dropdown,
      role: "menu",
      children: [extranet && /*#__PURE__*/jsx("a", {
        href: "/sso/redirect?audience=EXTRANET",
        className: css$4.item,
        onClick: handleItemClick,
        children: "Platform"
      }), onArrival && /*#__PURE__*/jsx("a", {
        href: "/sso/redirect?audience=GUSTAVE",
        className: css$4.item,
        onClick: handleItemClick,
        children: "OnArrival"
      }), hq && /*#__PURE__*/jsx("a", {
        href: "/sso/redirect?audience=HQ",
        className: css$4.item,
        onClick: handleItemClick,
        children: "HQ"
      })]
    })]
  });
};

var css_248z$4 = ".UserFullNameWithPicture-module__userContainer___Ax-1w{min-width:0}.UserFullNameWithPicture-module__username___eFllr{color:var(--primary-color);font-size:var(--body-regular-size)}.UserFullNameWithPicture-module__profilePicture___fEyl4{border-radius:50%;height:35px;object-fit:cover;width:35px}.UserFullNameWithPicture-module__avatarWrapper___rsPPX{display:inline-flex}@media (max-width:768px){.UserFullNameWithPicture-module__userContainer___Ax-1w{flex:1;min-width:0}.UserFullNameWithPicture-module__profilePicture___fEyl4{height:25px;width:25px}.UserFullNameWithPicture-module__avatarWrapper___rsPPX div{height:25px!important;width:25px!important}.UserFullNameWithPicture-module__username___eFllr{max-width:40px;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}}";
var css$3 = {"userContainer":"UserFullNameWithPicture-module__userContainer___Ax-1w","username":"UserFullNameWithPicture-module__username___eFllr","profilePicture":"UserFullNameWithPicture-module__profilePicture___fEyl4","avatarWrapper":"UserFullNameWithPicture-module__avatarWrapper___rsPPX"};
styleInject(css_248z$4);

const UserFullNameWithPicture = ({
  userFullName,
  userProfilePicSrc,
  userId
}) => {
  const {
    hotelEmployees
  } = useContext(CurrentHotelContext);
  const user = userId && hotelEmployees ? hotelEmployees[userId] : null;
  let userProfilePicUrl = userId ? null : userProfilePicSrc;
  let username = userId ? '-' : userFullName;
  if (user) {
    userProfilePicUrl = user.pictures?.['30s'];
    username = user.fullName;
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: css$3.userContainer,
    alignItems: "center",
    flexWrap: "nowrap",
    gap: "5px",
    children: [userProfilePicUrl ? /*#__PURE__*/jsx("img", {
      src: userProfilePicUrl,
      alt: username,
      className: css$3.profilePicture
    }) : /*#__PURE__*/jsx("div", {
      className: css$3.avatarWrapper,
      children: /*#__PURE__*/jsx(Avatar, {
        name: username
      })
    }), /*#__PURE__*/jsx("span", {
      className: css$3.username,
      children: /*#__PURE__*/jsx(AgentName, {
        agentName: username
      })
    })]
  });
};
UserFullNameWithPicture.propTypes = {
  userId: PropTypes.number
};

var css_248z$3 = ".HeaderContent-module__userLink___MPkG-{align-items:center;border-radius:var(--border-radius-small);display:flex;margin:0 -8px;padding:5px 8px;text-decoration:none;transition:background-color .2s ease}.HeaderContent-module__userLink___MPkG-:hover{background-color:var(--bg-light)}";
var css$2 = {"userLink":"HeaderContent-module__userLink___MPkG-"};
styleInject(css_248z$3);

const HeaderContent = ({
  currentUser,
  currentHotel,
  linkTo,
  appsPickerProps = {},
  gap = 10,
  additionalContent,
  hotelSwitcherComponent: HotelSwitcherComponent
}) => {
  const [openSwitchHotel, setOpenSwitchHotel] = useState(false);
  useTrackedHotkeys('ctrl+H', () => {
    if (!currentUser?.hasAccessToMultipleHotels) {
      return;
    }
    setOpenSwitchHotel(true);
  });
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      className: css$2.headerContentContainer,
      alignItems: "center",
      flexWrap: "nowrap",
      gap: gap,
      children: [additionalContent, /*#__PURE__*/jsx(AppsPickerButton, {
        ...appsPickerProps
      }), /*#__PURE__*/jsx(NavLink, {
        to: linkTo('account'),
        className: css$2.userLink,
        children: /*#__PURE__*/jsx(UserFullNameWithPicture, {
          userFullName: currentUser?.name,
          userProfilePicSrc: currentUser?.profilePictures && currentUser.profilePictures['30s']
        })
      }), /*#__PURE__*/jsx(HotelPickerButton, {
        currentHotel: currentHotel,
        onClick: () => setOpenSwitchHotel(true)
      })]
    }), openSwitchHotel && HotelSwitcherComponent && /*#__PURE__*/jsx(HotelSwitcherComponent, {
      onClose: () => setOpenSwitchHotel(false)
    })]
  });
};
HeaderContent.propTypes = {
  currentUser: PropTypes.object,
  currentHotel: PropTypes.object,
  linkTo: PropTypes.func.isRequired,
  appsPickerProps: PropTypes.object,
  gap: PropTypes.number,
  additionalContent: PropTypes.node,
  hotelSwitcherComponent: PropTypes.elementType
};

const TIMEZONE_LABELS = {
  [TIMEZONE_OPTIONS.UTC]: 'UTC',
  [TIMEZONE_OPTIONS.HOTEL]: 'Hotel',
  [TIMEZONE_OPTIONS.BROWSER]: 'Browser'
};
const TIMEZONE_BADGES = {
  [TIMEZONE_OPTIONS.UTC]: 'UTC',
  [TIMEZONE_OPTIONS.HOTEL]: 'H',
  [TIMEZONE_OPTIONS.BROWSER]: 'B'
};
const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const TimezoneMenuItem = ({
  option,
  isActive,
  onSelect
}) => {
  const handleClick = () => {
    onSelect(option.value);
  };
  return /*#__PURE__*/jsx(IconButtonMenu.Item, {
    onClick: handleClick,
    subtitle: isActive ? 'Currently active' : undefined,
    endContent: isActive ? /*#__PURE__*/jsx(CheckBroken, {
      color: colors$1.primaryColor,
      width: 16
    }) : undefined,
    children: option.label
  });
};
TimezoneMenuItem.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  isActive: PropTypes.bool,
  onSelect: PropTypes.func.isRequired
};
const TimezoneMenu = ({
  posthog
}) => {
  const {
    timezonePreference,
    setTimezonePreference,
    hotelTimezone
  } = useTimezone();
  const timezoneOptions = useMemo(() => [{
    value: TIMEZONE_OPTIONS.UTC,
    label: 'UTC'
  }, {
    value: TIMEZONE_OPTIONS.HOTEL,
    label: `Hotel (${hotelTimezone})`
  }, {
    value: TIMEZONE_OPTIONS.BROWSER,
    label: `Browser (${browserTimezone})`
  }], [hotelTimezone]);
  const handleTimezoneChange = timezone => {
    setTimezonePreference(timezone);
    posthog?.capture('timezone:preference_changed', {
      timezone: timezone
    });
  };
  return /*#__PURE__*/jsx(IconButtonMenu, {
    icon: /*#__PURE__*/jsx(Globe02Icon, {
      color: colors$1.primaryColor
    }),
    title: "Select timezone",
    label: `Timezone: ${TIMEZONE_LABELS[timezonePreference]}`,
    badge: TIMEZONE_BADGES[timezonePreference],
    anchorToHeaderOnMobile: true,
    children: timezoneOptions.map(option => /*#__PURE__*/jsx(TimezoneMenuItem, {
      option: option,
      isActive: timezonePreference === option.value,
      onSelect: handleTimezoneChange
    }, option.value))
  });
};
TimezoneMenu.propTypes = {
  posthog: PropTypes.object
};

var css_248z$2 = ".EditUserProfile-module__pageContainer___4ain- .EditUserProfile-module__formElems___Ryz-y{width:100%}.EditUserProfile-module__pageContainer___4ain- .EditUserProfile-module__formElems___Ryz-y .EditUserProfile-module__errorMessage___UDo4x{color:var(--danger);font-size:.75rem;margin-top:.2rem}.EditUserProfile-module__profilePicUploaderWrapper___IuYzv .EditUserProfile-module__profilePic___fv-FO{background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;height:150px}.EditUserProfile-module__profilePicUploaderWrapper___IuYzv label{display:block;width:fit-content}.EditUserProfile-module__profilePicUploaderWrapper___IuYzv .EditUserProfile-module__hover___2b2K8:hover{cursor:pointer;-webkit-filter:brightness(70%);-webkit-transition:all .5s ease;-moz-transition:all .5s ease;-o-transition:all .5s ease;-ms-transition:all .5s ease;transition:all .5s ease}.EditUserProfile-module__profilePicUploaderWrapper___IuYzv .EditUserProfile-module__iconWrapper___XyO22{background-color:var(--white);border-radius:100%;bottom:5px;height:25px;left:60px;position:absolute;width:25px}.EditUserProfile-module__card___WeiKg{background-color:var(--white);border-radius:var(--border-radius-medium);margin-bottom:20px;padding:15px}.EditUserProfile-module__card___WeiKg .EditUserProfile-module__title___fc7Hj{align-items:center;display:flex;gap:.5rem;margin-bottom:1rem}.EditUserProfile-module__card___WeiKg span{color:var(--grey-64)}.EditUserProfile-module__card___WeiKg .EditUserProfile-module__cardContent___G-Jjf{color:var(--text);font-size:var(--body-regular-size);font-weight:var(--body-regular-weight);line-height:var(--body-regular-line-height)}.EditUserProfile-module__userInfoContainer___gM5fP{display:flex;gap:25px}.EditUserProfile-module__changePasswordHeader___yOixP{align-items:start;display:flex;justify-content:space-between}@media (max-width:768px){.EditUserProfile-module__userInfoContainer___gM5fP{flex-direction:column!important;gap:20px!important}.EditUserProfile-module__changePasswordHeader___yOixP{align-items:flex-start!important;flex-direction:column!important;gap:10px!important}.EditUserProfile-module__changePasswordHeader___yOixP small{font-size:.875rem}.EditUserProfile-module__formElems___Ryz-y{width:100%!important}}";
var css$1 = {"pageContainer":"EditUserProfile-module__pageContainer___4ain-","formElems":"EditUserProfile-module__formElems___Ryz-y","errorMessage":"EditUserProfile-module__errorMessage___UDo4x","profilePicUploaderWrapper":"EditUserProfile-module__profilePicUploaderWrapper___IuYzv","profilePic":"EditUserProfile-module__profilePic___fv-FO","hover":"EditUserProfile-module__hover___2b2K8","iconWrapper":"EditUserProfile-module__iconWrapper___XyO22","card":"EditUserProfile-module__card___WeiKg","title":"EditUserProfile-module__title___fc7Hj","cardContent":"EditUserProfile-module__cardContent___G-Jjf","userInfoContainer":"EditUserProfile-module__userInfoContainer___gM5fP","changePasswordHeader":"EditUserProfile-module__changePasswordHeader___yOixP"};
styleInject(css_248z$2);

const EditUserProfile = ({
  posthog,
  toast
}) => {
  const [userProfile, setUserProfile] = useState({
    name: '',
    surname: '',
    email: '',
    password: '',
    currentPassword: '',
    passwordConfirmation: '',
    profilePicture: null
  });
  const [formErrors, setFormErrors] = useState({});
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const currentUserContext = useContext(CurrentUserContext);
  useEffect(() => {
    loadUserProfile();
    posthog.capture('account:page_open');
    // eslint-disable-next-line
  }, []);
  const fetchUserProfile = async () => {
    const response = await axios.get(restUrls.loadUserProfile);
    setUserProfile({
      name: response.data.name,
      surname: response.data.surname,
      email: response.data.email,
      profilePicture: response.data?.profilePictures?.['150s'] ?? null,
      password: '',
      currentPassword: '',
      passwordConfirmation: ''
    });
  };
  const loadUserProfile = async () => {
    showLoading();
    try {
      await fetchUserProfile();
    } catch (e) {
      toast.error('There was an error loading your profile');
    } finally {
      hideLoading();
    }
  };
  const saveUserProfile = async () => {
    if (!validateForm()) {
      return;
    }
    showLoading();
    try {
      const formData = new FormData();
      formData.append('profileData[name]', userProfile.name);
      formData.append('profileData[surname]', userProfile.surname);
      formData.append('profileData[email]', userProfile.email);
      formData.append('profileData[currentPassword]', userProfile.currentPassword);
      formData.append('profileData[password]', userProfile.password);
      formData.append('profileData[passwordConfirmation]', userProfile.passwordConfirmation);
      formData.append('profilePicture', userProfile.profilePicture);
      const response = await axios.post(restUrls.saveUserProfile, formData);
      if (response.data.error) {
        toast.error(response.data.error);
      } else {
        toast.success('Profile updated successfully');
        await fetchUserProfile();
        if (currentUserContext?.loadCurrentUser) {
          await currentUserContext.loadCurrentUser();
        }
      }
      posthog.capture('account:save_click');
    } catch (e) {
      toast.error('There was an error updating your profile');
    } finally {
      hideLoading();
    }
  };
  const validateForm = () => {
    const errors = {};
    if (userProfile.currentPassword || userProfile.password || userProfile.passwordConfirmation) {
      if (!userProfile.currentPassword) {
        errors.currentPassword = 'Current Password is required';
      }
      if (!userProfile.password) {
        errors.password = 'New password is required';
      }
      if (userProfile.passwordConfirmation !== userProfile.password) {
        errors.passwordConfirmation = 'Needs to match new password';
      }
      if (!userProfile.passwordConfirmation) {
        errors.passwordConfirmation = 'Confirm the new password';
      }
    }
    if (!validateEmail(userProfile.email)) {
      errors.email = 'Invalid email address';
    }
    if (userProfile.name.length < 3) {
      errors.name = 'Name must be at least 3 characters long';
    }
    if (userProfile.surname.length < 3) {
      errors.surname = 'Surname must be at least 3 characters long';
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return false;
    }
    setFormErrors(errors);
    return true;
  };
  const handleUpdate = (key, value) => {
    setUserProfile({
      ...userProfile,
      [key]: value
    });
  };
  return /*#__PURE__*/jsxs(PageContainer, {
    children: [/*#__PURE__*/jsx(PageTitle, {
      children: "Edit Profile"
    }), /*#__PURE__*/jsx(UserProfile, {
      userProfile: userProfile,
      onUpdate: handleUpdate,
      onSave: saveUserProfile,
      formErrors: formErrors,
      posthog: posthog
    })]
  });
};
const UserProfile = ({
  userProfile,
  onUpdate,
  onSave,
  formErrors,
  posthog
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css$1.pageContainer,
    children: [/*#__PURE__*/jsx(UserPicture, {
      onUpdate: onUpdate,
      userProfile: userProfile,
      posthog: posthog
    }), /*#__PURE__*/jsx(UserInfo, {
      onUpdate: onUpdate,
      userProfile: userProfile,
      formErrors: formErrors
    }), /*#__PURE__*/jsx(Button$1, {
      variant: "primary",
      onClick: onSave,
      children: "Save"
    })]
  });
};
const UserPicture = ({
  userProfile,
  onUpdate,
  posthog
}) => {
  const handlePhotoUpload = file => {
    onUpdate('profilePicture', file);
    posthog.capture('account:picture_upload');
  };
  return /*#__PURE__*/jsx(Card, {
    title: "Profile Picture",
    children: /*#__PURE__*/jsx(LogoUpload, {
      name: "profilePicture",
      onChange: handlePhotoUpload,
      initialImage: {
        preview: userProfile.profilePicture ?? ''
      },
      onImageChange: handlePhotoUpload,
      logoText: "Profile Picture"
    })
  });
};
const UserInfo = ({
  userProfile,
  onUpdate,
  formErrors
}) => {
  return /*#__PURE__*/jsxs(FlexContainer, {
    gap: "25px",
    className: css$1.userInfoContainer,
    children: [/*#__PURE__*/jsx(PersonalInfo, {
      onUpdate: onUpdate,
      userProfile: userProfile,
      formErrors: formErrors
    }), /*#__PURE__*/jsx(ChangePassword, {
      onUpdate: onUpdate,
      userProfile: userProfile,
      formErrors: formErrors
    })]
  });
};
const PersonalInfo = ({
  userProfile,
  onUpdate,
  formErrors
}) => {
  return /*#__PURE__*/jsxs(Card, {
    title: "Personal Info",
    className: css$1.formElems,
    children: [/*#__PURE__*/jsxs(FormGrid, {
      columns: 2,
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(InputText, {
          value: userProfile.name,
          onChange: evt => onUpdate('name', evt.target.value),
          name: "Name",
          label: "Name"
        }), formErrors.name && /*#__PURE__*/jsx("span", {
          className: css$1.errorMessage,
          children: formErrors.name
        })]
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx(InputText, {
          value: userProfile.surname,
          onChange: evt => onUpdate('surname', evt.target.value),
          name: "Surname",
          label: "Surname"
        }), formErrors.surname && /*#__PURE__*/jsx("span", {
          className: css$1.errorMessage,
          children: formErrors.surname
        })]
      })]
    }), /*#__PURE__*/jsxs(FormGrid, {
      children: [/*#__PURE__*/jsx(InputText, {
        value: userProfile.email,
        onChange: evt => onUpdate('email', evt.target.value),
        name: "Email Address",
        label: "Email Address"
      }), formErrors.email && /*#__PURE__*/jsx("span", {
        className: css$1.errorMessage,
        children: formErrors.email
      })]
    })]
  });
};
const ChangePassword = ({
  userProfile,
  onUpdate,
  formErrors
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: `${css$1.card} ${css$1.formElems}`,
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      justifyContent: "space-between",
      alignItems: "start",
      className: css$1.changePasswordHeader,
      children: [/*#__PURE__*/jsx("div", {
        className: css$1.title,
        children: /*#__PURE__*/jsx(CardTitle, {
          children: "Change Password"
        })
      }), /*#__PURE__*/jsx("small", {
        children: "If you don't want to change leave blank"
      })]
    }), /*#__PURE__*/jsxs("div", {
      className: css$1.cardContent,
      children: [/*#__PURE__*/jsx(FormGrid, {
        children: /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx(InputText, {
            type: "password",
            value: userProfile.currentPassword,
            onChange: evt => onUpdate('currentPassword', evt.target.value),
            name: "Current Password",
            label: "Current Password"
          }), formErrors.currentPassword && /*#__PURE__*/jsx("span", {
            className: css$1.errorMessage,
            children: formErrors.currentPassword
          })]
        })
      }), /*#__PURE__*/jsx(FormGrid, {
        children: /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx(InputText, {
            type: "password",
            value: userProfile.password,
            onChange: evt => onUpdate('password', evt.target.value),
            name: "New Password",
            label: "New Password"
          }), formErrors.password && /*#__PURE__*/jsx("span", {
            className: css$1.errorMessage,
            children: formErrors.password
          })]
        })
      }), /*#__PURE__*/jsx(FormGrid, {
        children: /*#__PURE__*/jsxs("div", {
          children: [/*#__PURE__*/jsx(InputText, {
            type: "password",
            value: userProfile.passwordConfirmation,
            onChange: evt => onUpdate('passwordConfirmation', evt.target.value),
            name: "New PasswordConfirmation",
            label: "New PasswordConfirmation"
          }), formErrors.passwordConfirmation && /*#__PURE__*/jsx("span", {
            className: css$1.errorMessage,
            children: formErrors.passwordConfirmation
          })]
        })
      })]
    })]
  });
};

const TasksSidePanelContext = /*#__PURE__*/createContext$1(null);
const TasksSidePanelProvider = ({
  children
}) => {
  const [showTasksSection, setShowTasksSection] = useState(false);
  const [taskStatusVersion, setTaskStatusVersion] = useState(0);
  const posthog = usePostHog();
  const handleShowSidePanel = useCallback(() => {
    posthog?.capture('tasks_annotations_open_side_panel');
    setShowTasksSection(true);
  }, [posthog]);
  const handleCloseSidePanel = useCallback(() => {
    posthog?.capture('tasks_annotations_close_side_panel');
    setShowTasksSection(false);
  }, [posthog]);
  const notifyTaskStatusUpdate = useCallback(() => {
    setTaskStatusVersion(version => version + 1);
  }, []);
  const value = useMemo(() => ({
    showTasksSection,
    handleShowSidePanel,
    handleCloseSidePanel,
    taskStatusVersion,
    notifyTaskStatusUpdate
  }), [showTasksSection, handleShowSidePanel, handleCloseSidePanel, taskStatusVersion, notifyTaskStatusUpdate]);
  return /*#__PURE__*/jsx(TasksSidePanelContext.Provider, {
    value: value,
    children: children
  });
};
const useTasksSidePanel = () => {
  const context = useContext(TasksSidePanelContext);
  if (!context) {
    throw new Error('useTasksSidePanel must be used within a TasksSidePanelProvider');
  }
  return context;
};

var css_248z$1 = ".TasksAndAnnotations-module__checkBox___AJ-X3{border-right:0!important;width:25px}.TasksAndAnnotations-module__titleCell___Dhx-b{padding-right:10px}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r{display:flex;gap:5px;position:relative}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P{background-color:#fff;border-radius:var(--borderRadius);box-shadow:var(--smoothShadow);font-size:12px;height:fit-content;left:50px;max-width:450px;min-width:350px;padding:10px;position:absolute;top:-75%;z-index:9}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P p{max-width:none;overflow:unset;white-space:normal}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P .TasksAndAnnotations-module__disableEvents___AbiMQ{pointer-events:none}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P input,.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P label{font-size:13px!important}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P:after{border:8px solid transparent;border-top-color:#fff;content:\"\";left:-16px;position:absolute;top:17px;transform:rotate(90deg)}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P .TasksAndAnnotations-module__viewTaskActions___eI3XB{border-bottom:1px solid var(--grey-20)}.TasksAndAnnotations-module__titleCell___Dhx-b .TasksAndAnnotations-module__viewTaskSection___EhA6r .TasksAndAnnotations-module__viewTask___2w01P .TasksAndAnnotations-module__linksSection___Kms2T>div:first-child{margin-bottom:5px!important}.TasksAndAnnotations-module__commentsSection___Ssa-K{background-color:var(--info-10);border-top:1px solid var(--grey-20)}.TasksAndAnnotations-module__commentsSection___Ssa-K button{padding:4px 20px}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9{margin-top:15px}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 .TasksAndAnnotations-module__taskCommentWrapper___wDCeA{border-bottom:1px solid var(--grey-20)}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 .TasksAndAnnotations-module__taskCommentWrapper___wDCeA .TasksAndAnnotations-module__taskComment___-KKen:not(:last-child){margin-bottom:5px;padding-bottom:5px;width:100%}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 .TasksAndAnnotations-module__taskCommentWrapper___wDCeA .TasksAndAnnotations-module__taskComment___-KKen small{font-style:italic;font-weight:700}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 .TasksAndAnnotations-module__taskCommentWrapper___wDCeA .TasksAndAnnotations-module__taskComment___-KKen p{line-height:1.2}.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 b,.TasksAndAnnotations-module__commentsSection___Ssa-K .TasksAndAnnotations-module__previousComments___xU3p9 svg{vertical-align:middle}.TasksAndAnnotations-module__multipleTasks___iI4j1{margin-top:35px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF{padding:0 10px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF button{padding:5px 25px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__createNewAnnotationSectionWrapper___PRIDJ .TasksAndAnnotations-module__createNewAnnotationSection___DAMeJ{background-color:var(--primary-20);border-radius:var(--borderRadius);color:var(--primary-color);margin-bottom:15px;padding:10px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__createNewAnnotationSectionWrapper___PRIDJ hr{border:1px solid var(--bg-light-80)}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i{background-color:var(--bg-light-80);border-radius:var(--borderRadius);margin-top:10px;padding:10px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i button{padding:3px 20px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i .TasksAndAnnotations-module__annotationsPreviousComments___-FTXo{margin-top:10px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i .TasksAndAnnotations-module__annotationsPreviousComments___-FTXo .TasksAndAnnotations-module__annotationCommentItem___YYVov:not(:last-child){border-bottom:1px solid var(--grey-20);margin-bottom:10px!important;padding-bottom:10px!important}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i .TasksAndAnnotations-module__annotationsPreviousComments___-FTXo b,.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationsCommentsSection___ifP1i .TasksAndAnnotations-module__annotationsPreviousComments___-FTXo svg{vertical-align:middle}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ{border:1px solid var(--grey-20);border-radius:var(--borderRadius);margin-bottom:10px!important;padding:10px!important}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d{border-left:1px solid var(--grey-20);padding-left:10px!important}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__delete___2A464{margin-top:4px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__delete___2A464 svg:hover,.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__delete___2A464 svg:hover path{fill:var(--danger)}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__edit___Vfh6o{margin-top:5px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__edit___Vfh6o svg:hover,.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__edit___Vfh6o svg:hover path{fill:var(--grey-64)}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__commentIcon___mhEkk{align-items:center;display:flex;gap:1px}.TasksAndAnnotations-module__annotationsListWrapper___k8JeF .TasksAndAnnotations-module__annotationItemWrapper___kGVhZ .TasksAndAnnotations-module__annotationItemActions___9sf4d .TasksAndAnnotations-module__commentIcon___mhEkk span{vertical-align:center}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E{bottom:0;height:100vh;overflow:auto;padding:0 10px 10px;position:fixed;right:0;top:0;z-index:99999}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E hr{margin:20px 0}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E label{margin:0!important}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E .TasksAndAnnotations-module__switch___HzAko{margin:15px 0!important}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E .TasksAndAnnotations-module__close___SyyIW{cursor:pointer;position:absolute;right:15px;top:15px}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E .TasksAndAnnotations-module__vl___yYwFM{border-left:1px solid var(--grey-64);height:13px}.TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E .Toastify__toast-container{right:10px;top:10px;z-index:999999}.TasksAndAnnotations-module__floatSectionWrapper___TMztm{background-color:#fff;border-radius:var(--borderRadius);bottom:17px;cursor:pointer;padding:3px;position:fixed;right:15px;z-index:1000}.TasksAndAnnotations-module__floatSectionWrapper___TMztm .TasksAndAnnotations-module__floatSectionBlue___zRsOD{align-items:center;background-color:var(--primary-color);border-radius:var(--borderRadius);display:inline-flex;font-size:35px;justify-content:center;position:relative;vertical-align:middle;width:53px}.TasksAndAnnotations-module__floatSectionWrapper___TMztm .TasksAndAnnotations-module__tasksTodoText___iyUfD{display:inline-block;font-size:15px;margin-left:10px;vertical-align:middle;width:297px}.TasksAndAnnotations-module__floatSectionWrapper___TMztm .TasksAndAnnotations-module__tasksTodoText___iyUfD b{color:var(--primary-color)}.TasksAndAnnotations-module__floatSectionWrapper___TMztm .TasksAndAnnotations-module__tasksTodoBadge___6QUdU{background-color:var(--danger);border-radius:100%;color:#fff;font-size:12px;font-weight:700;position:absolute;right:-5px;top:-5px}.TasksAndAnnotations-module__tasksListTab___2UqIC{max-width:1200px;overflow:auto;width:90%!important}.TasksAndAnnotations-module__tasksListTab___2UqIC ul{margin-top:5px}.TasksAndAnnotations-module__tasksListTab___2UqIC ul li{font-size:16px;padding:7px 10px!important}@media (max-width:768px){.TasksAndAnnotations-module__tasksListTab___2UqIC{max-width:100%;width:100%!important}}.TasksAndAnnotations-module__projectCard___f3OfC{border:1px solid var(--bg-dark)}.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 small{color:var(--grey-64)}.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 .TasksAndAnnotations-module__projectTitleContent___JiVfI{align-items:center;display:flex;flex:1;flex-direction:row;gap:10px}.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 .TasksAndAnnotations-module__projectTitleContent___JiVfI .TasksAndAnnotations-module__projectDates___tkFfq{align-items:center;display:flex;flex-direction:row;gap:10px}.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 .TasksAndAnnotations-module__projectTitleActions___aXHeT{align-items:center;display:flex;flex-direction:row;gap:5px}@media (max-width:768px){.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 .TasksAndAnnotations-module__projectTitleContent___JiVfI{align-items:flex-start;flex-direction:column;gap:5px}.TasksAndAnnotations-module__projectCard___f3OfC .TasksAndAnnotations-module__projectTitle___M-Ns6 .TasksAndAnnotations-module__projectTitleContent___JiVfI .TasksAndAnnotations-module__projectDates___tkFfq{align-items:flex-start;flex-direction:column;gap:3px}}";
var css = {"checkBox":"TasksAndAnnotations-module__checkBox___AJ-X3","titleCell":"TasksAndAnnotations-module__titleCell___Dhx-b","viewTaskSection":"TasksAndAnnotations-module__viewTaskSection___EhA6r","viewTask":"TasksAndAnnotations-module__viewTask___2w01P","disableEvents":"TasksAndAnnotations-module__disableEvents___AbiMQ","viewTaskActions":"TasksAndAnnotations-module__viewTaskActions___eI3XB","linksSection":"TasksAndAnnotations-module__linksSection___Kms2T","commentsSection":"TasksAndAnnotations-module__commentsSection___Ssa-K","previousComments":"TasksAndAnnotations-module__previousComments___xU3p9","taskCommentWrapper":"TasksAndAnnotations-module__taskCommentWrapper___wDCeA","taskComment":"TasksAndAnnotations-module__taskComment___-KKen","multipleTasks":"TasksAndAnnotations-module__multipleTasks___iI4j1","annotationsListWrapper":"TasksAndAnnotations-module__annotationsListWrapper___k8JeF","createNewAnnotationSectionWrapper":"TasksAndAnnotations-module__createNewAnnotationSectionWrapper___PRIDJ","createNewAnnotationSection":"TasksAndAnnotations-module__createNewAnnotationSection___DAMeJ","annotationsCommentsSection":"TasksAndAnnotations-module__annotationsCommentsSection___ifP1i","annotationsPreviousComments":"TasksAndAnnotations-module__annotationsPreviousComments___-FTXo","annotationCommentItem":"TasksAndAnnotations-module__annotationCommentItem___YYVov","annotationItemWrapper":"TasksAndAnnotations-module__annotationItemWrapper___kGVhZ","annotationItemActions":"TasksAndAnnotations-module__annotationItemActions___9sf4d","delete":"TasksAndAnnotations-module__delete___2A464","edit":"TasksAndAnnotations-module__edit___Vfh6o","commentIcon":"TasksAndAnnotations-module__commentIcon___mhEkk","tasksAndAnnotationsWrapper":"TasksAndAnnotations-module__tasksAndAnnotationsWrapper___YZs4E","switch":"TasksAndAnnotations-module__switch___HzAko","close":"TasksAndAnnotations-module__close___SyyIW","vl":"TasksAndAnnotations-module__vl___yYwFM","floatSectionWrapper":"TasksAndAnnotations-module__floatSectionWrapper___TMztm","floatSectionBlue":"TasksAndAnnotations-module__floatSectionBlue___zRsOD","tasksTodoText":"TasksAndAnnotations-module__tasksTodoText___iyUfD","tasksTodoBadge":"TasksAndAnnotations-module__tasksTodoBadge___6QUdU","tasksListTab":"TasksAndAnnotations-module__tasksListTab___2UqIC","projectCard":"TasksAndAnnotations-module__projectCard___f3OfC","projectTitle":"TasksAndAnnotations-module__projectTitle___M-Ns6","projectTitleContent":"TasksAndAnnotations-module__projectTitleContent___JiVfI","projectDates":"TasksAndAnnotations-module__projectDates___tkFfq","projectTitleActions":"TasksAndAnnotations-module__projectTitleActions___aXHeT"};
styleInject(css_248z$1);

// src/shorthands.ts
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var longhands = {
    margin: [
        "margin-top",
        "margin-right",
        "margin-bottom",
        "margin-left",
        "margin-inline-start",
        "margin-inline-end",
        "margin-block-start",
        "margin-block-end"
    ],
    padding: [
        "padding-top",
        "padding-right",
        "padding-bottom",
        "padding-left",
        "padding-inline-start",
        "padding-inline-end",
        "padding-block-start",
        "padding-block-end"
    ],
    inset: [
        "top",
        "right",
        "bottom",
        "left"
    ],
    gap: [
        "row-gap",
        "column-gap"
    ],
    overflow: [
        "overflow-x",
        "overflow-y"
    ],
    "border-width": [
        "border-top-width",
        "border-right-width",
        "border-bottom-width",
        "border-left-width"
    ],
    "border-style": [
        "border-top-style",
        "border-right-style",
        "border-bottom-style",
        "border-left-style"
    ],
    "border-color": [
        "border-top-color",
        "border-right-color",
        "border-bottom-color",
        "border-left-color"
    ],
    "border-top": [
        "border-top-width",
        "border-top-style",
        "border-top-color"
    ],
    "border-right": [
        "border-right-width",
        "border-right-style",
        "border-right-color"
    ],
    "border-bottom": [
        "border-bottom-width",
        "border-bottom-style",
        "border-bottom-color"
    ],
    "border-left": [
        "border-left-width",
        "border-left-style",
        "border-left-color"
    ],
    border: [
        "border-width",
        "border-style",
        "border-color",
        "border-top-width",
        "border-top-style",
        "border-top-color",
        "border-right-width",
        "border-right-style",
        "border-right-color",
        "border-bottom-width",
        "border-bottom-style",
        "border-bottom-color",
        "border-left-width",
        "border-left-style",
        "border-left-color",
        "border-image",
        "border-image-source",
        "border-image-slice",
        "border-image-width",
        "border-image-outset",
        "border-image-repeat"
    ],
    "border-radius": [
        "border-top-left-radius",
        "border-top-right-radius",
        "border-bottom-right-radius",
        "border-bottom-left-radius"
    ],
    outline: [
        "outline-width",
        "outline-style",
        "outline-color"
    ],
    background: [
        "background-color",
        "background-image",
        "background-position",
        "background-size",
        "background-repeat",
        "background-attachment",
        "background-origin",
        "background-clip"
    ],
    font: [
        "font-style",
        "font-variant",
        "font-weight",
        "font-size",
        "font-family",
        "line-height"
    ],
    flex: [
        "flex-grow",
        "flex-shrink",
        "flex-basis"
    ],
    "text-decoration": [
        "text-decoration-line",
        "text-decoration-style",
        "text-decoration-color",
        "text-decoration-thickness"
    ]
};
function coveredProperties(property) {
    var covered = longhands[property];
    if (covered) {
        return [
            property
        ].concat(covered);
    }
    return [
        property
    ];
}
var distributiveKinds = {
    margin: "box",
    padding: "box",
    inset: "box",
    "border-width": "box",
    "border-style": "box",
    "border-color": "box",
    gap: "pair",
    overflow: "pair",
    "border-radius": "corners"
};
function distributiveExpansion(property) {
    var kind = distributiveKinds[property];
    var covered = kind ? longhands[property] : void 0;
    if (!kind || !covered) {
        return void 0;
    }
    return {
        kind: kind,
        longhands: covered
    };
}
// src/utils/asArray.ts
function asArray(v) {
    return [].concat(v);
}
// src/utils/is.ts
function isPsuedoSelector(selector) {
    return selector.startsWith(":");
}
function isStyleCondition(selector) {
    return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
    return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
    return selector.startsWith("@media");
}
function isKeyframes(selector) {
    return selector.startsWith("@keyframes");
}
function isDirectClass(selector) {
    return selector === ".";
}
function isCssVariables(selector) {
    return selector === "--";
}
function isString(value) {
    return value + "" === value;
}
function isImmediatePostcondition(value) {
    return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}
// src/utils/joinTruthy.ts
function joinTruthy(arr) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return arr.filter(Boolean).join(delimiter);
}
// src/utils/stableHash.ts
function stableHash(prefix, seed) {
    var hash = 0;
    if (seed.length === 0) return hash.toString();
    for(var i = 0; i < seed.length; i++){
        var char = seed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return "".concat(prefix !== null && prefix !== void 0 ? prefix : "cl", "_").concat(hash.toString(36));
}
// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
    if (property === "content") {
        return '"'.concat(value, '"');
    }
    return value;
}
function camelCaseToDash(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
    return "".concat(property, ":").concat(value);
}
function toClass(str) {
    return str ? ".".concat(str) : "";
}
function appendString(base, line) {
    return appendStringInline(base, line, "\n");
}
function appendStringInline(base, line) {
    var separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : " ";
    return base ? "".concat(base).concat(separator).concat(line) : line;
}
// src/Rule.ts
function toCssIdent(value) {
    var cleaned = value.replace(/[^a-zA-Z0-9_-]/g, "_");
    if (/^[0-9]/.test(cleaned) || /^-[0-9]/.test(cleaned)) {
        return "_".concat(cleaned);
    }
    return cleaned;
}
function sheetIdent(name) {
    var encoded = name.replace(/[^A-Za-z0-9-]/g, function(char) {
        return "_".concat(char.charCodeAt(0).toString(16), "_");
    });
    if (/^[0-9]/.test(encoded) || /^-[0-9]/.test(encoded)) {
        return "_".concat(encoded);
    }
    return encoded;
}
var Rule = /*#__PURE__*/ function() {
    function _Rule(sheet, property, value, selector) {
        _class_call_check(this, _Rule);
        this.sheet = sheet;
        this.property = property;
        this.value = value;
        this.selector = selector;
        this.property = property;
        this.value = value;
        this.joined = joinedProperty(camelCaseToDash(property), value);
        var pre = this.selector.preconditions.join("\x00");
        var post = this.selector.postconditions.join("\x00");
        var atKey = this.selector.atRules.join("|");
        var scopePart = this.selector.hasConditions ? this.selector.scopeClassName : "";
        this.key = [
            this.joined,
            pre,
            post,
            atKey,
            scopePart
        ].join("\x00");
        this.hash = this.buildHash(atKey);
    }
    _create_class(_Rule, [
        {
            key: "getConflictKeys",
            value: function getConflictKeys() {
                var pre = this.selector.preconditions.join(",");
                var post = this.selector.postconditions.join(",");
                var at = this.selector.atRules.join("|");
                return coveredProperties(camelCaseToDash(this.property)).map(function(prop) {
                    return [
                        prop,
                        pre,
                        post,
                        at
                    ].join("\x00");
                });
            }
        },
        {
            key: "buildHash",
            value: function buildHash(atKey) {
                if (!this.selector.hasConditions && !atKey) {
                    return stableHash(sheetIdent(this.sheet.name), this.joined);
                }
                return stableHash(sheetIdent(this.sheet.name), this.key);
            }
        },
        {
            key: "toString",
            value: function toString() {
                var selectors = mergeSelectors(this.selector.preconditions, {
                    right: this.hash
                });
                selectors = mergeSelectors(this.selector.postconditions, {
                    left: selectors
                });
                return "".concat(selectors, " {").concat(_Rule.genRule(this.property, this.value), "}");
            }
        }
    ], [
        {
            key: "genRule",
            value: function genRule(property, value) {
                var transformedProperty = camelCaseToDash(property);
                return joinedProperty(transformedProperty, handlePropertyValue(property, value)) + ";";
            }
        }
    ]);
    return _Rule;
}();
function mergeSelectors(selectors) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_left = _ref.left, left = _ref_left === void 0 ? "" : _ref_left, _ref_right = _ref.right, right = _ref_right === void 0 ? "" : _ref_right;
    var output = selectors.reduce(function(selectors2, current) {
        if (isPsuedoSelector(current)) {
            return selectors2 + current;
        }
        if (isImmediatePostcondition(current)) {
            return selectors2 + current.slice(1);
        }
        return joinTruthy([
            selectors2,
            current
        ], " ");
    }, left);
    return joinTruthy([
        output,
        toClass(right)
    ], " ");
}
var Selector = /*#__PURE__*/ function() {
    function _Selector(sheet) {
        var scopeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, preconditions = _ref.preconditions, postconditions = _ref.postconditions, atRules = _ref.atRules;
        _class_call_check(this, _Selector);
        this.sheet = sheet;
        this.preconditions = [];
        this.scopeClassName = null;
        this.scopeName = null;
        this.postconditions = [];
        this.atRules = [];
        this.preconditions = preconditions ? asArray(preconditions) : [];
        this.postconditions = postconditions ? asArray(postconditions) : [];
        this.atRules = atRules ? atRules.slice() : [];
        this.setScope(scopeName);
    }
    _create_class(_Selector, [
        {
            key: "setScope",
            value: function setScope(scopeName) {
                if (!scopeName) {
                    return this;
                }
                if (!this.scopeClassName) {
                    this.scopeName = scopeName;
                    this.scopeClassName = stableHash(sheetIdent(this.sheet.name), // adding the count guarantees uniqueness across style.create calls
                    scopeName + "\x00" + this.sheet.count);
                }
                return this;
            }
        },
        {
            key: "hasConditions",
            get: function get() {
                return this.preconditions.length > 0 || this.postconditions.length > 0;
            }
        },
        {
            key: "addScope",
            value: function addScope(scopeName) {
                return new _Selector(this.sheet, scopeName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions,
                    atRules: this.atRules
                });
            }
        },
        {
            key: "addPrecondition",
            value: function addPrecondition(precondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    postconditions: this.postconditions,
                    preconditions: this.preconditions.concat(precondition),
                    atRules: this.atRules
                });
            }
        },
        {
            key: "addPostcondition",
            value: function addPostcondition(postcondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions.concat(postcondition),
                    atRules: this.atRules
                });
            }
        },
        {
            key: "addAtRule",
            value: function addAtRule(atRule) {
                var selector = new _Selector(this.sheet, null, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions,
                    atRules: this.atRules.concat(atRule)
                });
                selector.scopeClassName = this.scopeClassName;
                selector.scopeName = this.scopeName;
                return selector;
            }
        },
        {
            key: "createRule",
            value: function createRule(property, value) {
                return new Rule(this.sheet, property, value, this);
            }
        }
    ]);
    return _Selector;
}();
// src/utils/forIn.ts
function forIn(obj, fn) {
    for(var key in obj){
        fn(key.trim(), obj[key]);
    }
}
// src/keyframes.ts
function addKeyframes(sheet, input) {
    var keyframes = {};
    forIn(input, function(name, stages) {
        keyframes[name] = claimKeyframeName(sheet, name, stages);
    });
    return keyframes;
}
function claimKeyframeName(sheet, name, stages) {
    var seq = sheet.keyframeSeq();
    var hashed = formatKeyframeName(sheet.name, seq, name);
    var block = buildKeyframeBlock(hashed, stages);
    if (sheet.adoptedKeyframeBody(hashed) === stripWhitespace(block)) {
        return hashed;
    }
    return takeFreeKeyframeName(sheet, name, stages, seq);
}
function takeFreeKeyframeName(sheet, name, stages, start) {
    var counter = start;
    var hashed = formatKeyframeName(sheet.name, counter, name);
    while(sheet.isKeyframeNameTaken(hashed)){
        counter += 1;
        hashed = formatKeyframeName(sheet.name, counter, name);
    }
    sheet.append(buildKeyframeBlock(hashed, stages));
    sheet.markKeyframeNameUsed(hashed);
    return hashed;
}
function formatKeyframeName(sheetName, counter, name) {
    return "".concat(sheetIdent(sheetName), "_").concat(counter, "_").concat(toCssIdent(name));
}
function buildKeyframeBlock(hashed, stages) {
    var block = "@keyframes ".concat(hashed, " {");
    forIn(stages, function(stage, stylesObject) {
        block = appendKeyframeStage(block, stage, stylesObject);
    });
    return "".concat(block, "\n}");
}
function appendKeyframeStage(block, stage, stylesObject) {
    var output = "".concat(block, "\n").concat(stage, " {");
    forIn(stylesObject, function(key, value) {
        if (isValidProperty(key, value)) {
            output = "".concat(output, " ").concat(Rule.genRule(key, value));
        }
    });
    return "".concat(output, " }");
}
function stripWhitespace(value) {
    return value.replace(/\s+/g, "");
}
// src/classRegistry.ts
var classConflicts = /* @__PURE__ */ new Map();
function registerClassConflict(className, conflictKeys) {
    var existing = classConflicts.get(className);
    if (existing) {
        conflictKeys.forEach(function(key) {
            return existing.add(key);
        });
        return;
    }
    classConflicts.set(className, new Set(conflictKeys));
}
function getClassConflicts(className) {
    var found = classConflicts.get(className);
    return found ? Array.from(found) : void 0;
}
// src/Sheet.ts
var ruleLinePattern = /^\.([A-Za-z0-9_-]+)\s*\{\s*(.+?)\s*\}\s*$/;
var keyframesPattern = /^@keyframes\s+([A-Za-z0-9_-]+)\s*\{$/;
var Sheet = /*#__PURE__*/ function() {
    function Sheet(name, root) {
        _class_call_check(this, Sheet);
        this.name = name;
        // Hash->css
        this.storedStyles = {};
        // styles->hash
        this.storedClasses = {};
        this.adoptedTexts = /* @__PURE__ */ new Set();
        this.adoptedKeyframes = /* @__PURE__ */ new Map();
        this.usedKeyframeNames = /* @__PURE__ */ new Set();
        this.style = "";
        this.keyframesCount = 0;
        this.count = 0;
        this.id = "flairup-".concat(name);
        var resolved = resolveSheetRoot(root);
        this.rootNode = resolved.rootNode;
        this.nonce = resolved.nonce;
        this.styleTag = this.createStyleTag();
    }
    _create_class(Sheet, [
        {
            key: "getStyle",
            value: function getStyle() {
                return this.style;
            }
        },
        {
            key: "append",
            value: function append(css) {
                this.style = appendString(this.style, css);
            }
        },
        {
            key: "appendInline",
            value: function appendInline(css) {
                this.style = appendStringInline(this.style, css);
            }
        },
        {
            key: "seq",
            value: function seq() {
                return this.count++;
            }
        },
        {
            key: "keyframeSeq",
            value: function keyframeSeq() {
                return this.keyframesCount++;
            }
        },
        {
            key: "getLength",
            value: function getLength() {
                return this.style.length;
            }
        },
        {
            key: "truncate",
            value: function truncate(length) {
                this.style = this.style.slice(0, length);
            }
        },
        {
            key: "apply",
            value: function apply() {
                this.seq();
                if (!this.styleTag) {
                    return;
                }
                this.styleTag.innerHTML = this.style;
            }
        },
        {
            key: "isApplied",
            value: function isApplied() {
                return !!this.styleTag;
            }
        },
        {
            key: "isDetached",
            value: function isDetached() {
                return this.styleTag !== void 0 && !this.styleTag.isConnected;
            }
        },
        {
            key: "getNonce",
            value: function getNonce() {
                return this.nonce;
            }
        },
        {
            key: "setNonce",
            value: function setNonce(nonce) {
                this.nonce = nonce;
                if (this.styleTag && nonce) {
                    this.styleTag.setAttribute("nonce", nonce);
                }
            }
        },
        {
            key: "adoptedRuleText",
            value: function adoptedRuleText(text) {
                return this.adoptedTexts.has(text.trim());
            }
        },
        {
            key: "adoptedKeyframeBody",
            value: function adoptedKeyframeBody(name) {
                return this.adoptedKeyframes.get(name);
            }
        },
        {
            key: "isKeyframeNameTaken",
            value: function isKeyframeNameTaken(name) {
                return this.adoptedKeyframes.has(name) || this.usedKeyframeNames.has(name);
            }
        },
        {
            key: "markKeyframeNameUsed",
            value: function markKeyframeNameUsed(name) {
                this.usedKeyframeNames.add(name);
            }
        },
        {
            key: "createStyleTag",
            value: function createStyleTag() {
                if (typeof document === "undefined" || this.isApplied() || // Explicitly disallow mounting to the DOM
                this.rootNode === null) {
                    return this.styleTag;
                }
                var _this_adoptStyleTag;
                return (_this_adoptStyleTag = this.adoptStyleTag()) !== null && _this_adoptStyleTag !== void 0 ? _this_adoptStyleTag : this.mountStyleTag();
            }
        },
        {
            key: "addRule",
            value: function addRule(rule) {
                var storedClass = this.storedClasses[rule.key];
                if (isString(storedClass)) {
                    return storedClass;
                }
                var final = this.resolveHash(rule);
                this.commitRule(rule, final);
                return final;
            }
        },
        {
            key: "resolveHash",
            value: function resolveHash(rule) {
                var final = rule.hash;
                var counter = 0;
                while(this.isHashTaken(final, rule)){
                    counter += 1;
                    final = "".concat(rule.hash, "_").concat(counter);
                }
                return final;
            }
        },
        {
            key: "isHashTaken",
            value: function isHashTaken(hash, rule) {
                var stored = this.storedStyles[hash];
                return stored !== void 0 && (stored[0] !== rule.property || stored[1] !== rule.value);
            }
        },
        {
            key: "commitRule",
            value: function commitRule(rule, hash) {
                rule.hash = hash;
                this.storedClasses[rule.key] = hash;
                this.storedStyles[hash] = [
                    rule.property,
                    rule.value
                ];
                registerClassConflict(hash, rule.getConflictKeys());
                this.appendUnlessAdopted(rule);
            }
        },
        {
            key: "appendUnlessAdopted",
            value: function appendUnlessAdopted(rule) {
                var text = rule.toString();
                if (!this.adoptedTexts.has(text.trim())) {
                    this.append(text);
                }
            }
        },
        {
            key: "adoptStyleTag",
            value: function adoptStyleTag() {
                var existing = this.findExistingStyleTag();
                if (!existing) {
                    return void 0;
                }
                var css = existing.innerHTML;
                this.style = css;
                this.applyNonce(existing);
                this.hydrateFromStyle(css);
                return existing;
            }
        },
        {
            key: "hydrateFromStyle",
            value: function hydrateFromStyle(css) {
                var lines = css.split("\n");
                var stack = [];
                var index = 0;
                while(index < lines.length){
                    var line = lines[index];
                    if (line === void 0) {
                        break;
                    }
                    index = this.hydrateLine(lines, line.trim(), stack, index);
                }
            }
        },
        {
            key: "hydrateLine",
            value: function hydrateLine(lines, line, stack, index) {
                if (isKeyframes(line) && keyframesPattern.test(line)) {
                    return this.adoptKeyframesBlock(lines, index);
                }
                if (!this.trackStructure(line, stack)) {
                    this.adoptRuleLine(line, stack.join("|"));
                }
                return index + 1;
            }
        },
        {
            key: "trackStructure",
            value: function trackStructure(line, stack) {
                if (isMediaOpener(line)) {
                    stack.push(mediaOpenerText(line));
                    return true;
                }
                if (line === "}") {
                    stack.pop();
                    return true;
                }
                return false;
            }
        },
        {
            key: "adoptRuleLine",
            value: function adoptRuleLine(line, atKey) {
                if (!line) {
                    return;
                }
                this.adoptedTexts.add(line);
                var parsed = parseAdoptedRule(line, this.name);
                if (parsed) {
                    this.storeAdoptedRule(parsed, atKey);
                }
            }
        },
        {
            key: "storeAdoptedRule",
            value: function storeAdoptedRule(rule, atKey) {
                var joined = "".concat(rule.prop, ":").concat(rule.value);
                this.storedClasses[[
                    joined,
                    "",
                    atKey,
                    ""
                ].join("\x00")] = rule.hash;
                this.storedStyles[rule.hash] = [
                    rule.prop,
                    rule.value
                ];
                registerClassConflict(rule.hash, coveredProperties(rule.prop).map(function(prop) {
                    return conflictKey(prop, atKey);
                }));
            }
        },
        {
            key: "adoptKeyframesBlock",
            value: function adoptKeyframesBlock(lines, index) {
                var end = findBlockEnd(lines, index);
                if (end < 0) {
                    return index + 1;
                }
                var opener = lines[index];
                var name = opener === void 0 ? "" : parseKeyframeName(opener.trim());
                if (name) {
                    this.adoptedKeyframes.set(name, stripWhitespace2(lines.slice(index, end + 1).join("\n")));
                }
                return end + 1;
            }
        },
        {
            key: "mountStyleTag",
            value: function mountStyleTag() {
                var styleTag = document.createElement("style");
                styleTag.type = "text/css";
                styleTag.id = this.id;
                this.applyNonce(styleTag);
                this.getMountTarget().appendChild(styleTag);
                return styleTag;
            }
        },
        {
            key: "getMountTarget",
            value: function getMountTarget() {
                var _this_rootNode;
                return (_this_rootNode = this.rootNode) !== null && _this_rootNode !== void 0 ? _this_rootNode : document.head;
            }
        },
        {
            key: "findExistingStyleTag",
            value: function findExistingStyleTag() {
                var _this_rootNode;
                var scope = (_this_rootNode = this.rootNode) !== null && _this_rootNode !== void 0 ? _this_rootNode : document;
                var lookup = scope;
                if (typeof lookup.getElementsByTagName === "function") {
                    return this.findTagById(lookup.getElementsByTagName("style"));
                }
                return findStyleTagById(scope, this.id);
            }
        },
        {
            key: "findTagById",
            value: function findTagById(tags) {
                for(var i = 0; i < tags.length; i++){
                    var tag = tags[i];
                    if (tag && tag.id === this.id && tag.tagName === "STYLE") {
                        return tag;
                    }
                }
                return void 0;
            }
        },
        {
            key: "applyNonce",
            value: function applyNonce(styleTag) {
                if (!this.nonce) {
                    return;
                }
                styleTag.setAttribute("nonce", this.nonce);
            }
        }
    ]);
    return Sheet;
}();
function resolveSheetRoot(root) {
    if (!root || isRootNode(root)) {
        return {
            rootNode: root,
            nonce: void 0
        };
    }
    return {
        rootNode: root.rootNode,
        nonce: root.nonce
    };
}
function isRootNode(value) {
    return typeof value.nodeType === "number";
}
function isMediaOpener(line) {
    return line.endsWith("{") && isMediaQuery(mediaOpenerText(line));
}
function mediaOpenerText(line) {
    return line.slice(0, -1).trim();
}
function conflictKey(prop, atKey) {
    return [
        prop,
        "",
        "",
        atKey
    ].join("\x00");
}
function stripWhitespace2(value) {
    return value.replace(/\s+/g, "");
}
function findBlockEnd(lines, start) {
    for(var i = start + 1; i < lines.length; i++){
        var _lines_i;
        if (((_lines_i = lines[i]) === null || _lines_i === void 0 ? void 0 : _lines_i.trim()) === "}") {
            return i;
        }
    }
    return -1;
}
function parseKeyframeName(opener) {
    var match = keyframesPattern.exec(opener);
    var _match_;
    return (_match_ = match === null || match === void 0 ? void 0 : match[1]) !== null && _match_ !== void 0 ? _match_ : "";
}
function parseAdoptedRule(line, sheetName) {
    var match = ruleLinePattern.exec(line);
    var hash = match === null || match === void 0 ? void 0 : match[1];
    var body = match === null || match === void 0 ? void 0 : match[2];
    if (!hash || !body || !isSheetHash(hash, sheetName)) {
        return void 0;
    }
    var declaration = splitDeclaration(body);
    if (!declaration) {
        return void 0;
    }
    return {
        hash: hash,
        prop: declaration[0],
        value: declaration[1]
    };
}
function isSheetHash(hash, sheetName) {
    return hash.startsWith("".concat(sheetIdent(sheetName), "_"));
}
function splitDeclaration(body) {
    var parts = body.split(";").map(function(part) {
        return part.trim();
    }).filter(function(part) {
        return part !== "";
    });
    var only = parts[0];
    if (parts.length !== 1 || !only) {
        return void 0;
    }
    var separator = only.indexOf(":");
    if (separator < 0) {
        return void 0;
    }
    return [
        only.slice(0, separator).trim(),
        only.slice(separator + 1).trim()
    ];
}
function findStyleTagById(node, id) {
    var children = node.childNodes;
    for(var i = 0; i < children.length; i++){
        var found = findStyleTagInChild(children[i], id);
        if (found) {
            return found;
        }
    }
    return void 0;
}
function findStyleTagInChild(child, id) {
    if (!child) {
        return void 0;
    }
    var element = child;
    if (element.tagName === "STYLE" && element.id === id) {
        return element;
    }
    return findStyleTagById(child, id);
}
// src/cx.ts
function cx() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var tokens = [];
    flattenCxArgs(args, tokens);
    return resolveCxConflicts(tokens);
}
function flattenCxArgs(args, tokens) {
    args.forEach(function(arg) {
        return pushCxArg(arg, tokens);
    });
}
function pushCxArg(arg, tokens) {
    if (typeof arg === "string") {
        splitCxToken(arg, tokens);
        return;
    }
    if (arg && typeof arg === "object") {
        pushCxComposite(arg, tokens);
    }
}
function pushCxComposite(arg, tokens) {
    if (_instanceof(arg, Set)) {
        arg.forEach(function(value) {
            return pushCxArg(value, tokens);
        });
        return;
    }
    if (Array.isArray(arg)) {
        flattenCxArgs(arg, tokens);
        return;
    }
    pushCxObject(arg, tokens);
}
function pushCxObject(arg, tokens) {
    Object.entries(arg).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        if (value) {
            splitCxToken(key, tokens);
        }
    });
}
function splitCxToken(token, tokens) {
    token.split(/\s+/).forEach(function(part) {
        if (part) {
            tokens.push(part);
        }
    });
}
function resolveCxConflicts(tokens) {
    var claimed = /* @__PURE__ */ new Set();
    var keep = tokens.map(function() {
        return false;
    });
    claimCxTokens(tokens, keep, claimed);
    return tokens.filter(function(_, index) {
        return keep[index];
    }).join(" ");
}
function claimCxTokens(tokens, keep, claimed) {
    for(var index = tokens.length - 1; index >= 0; index--){
        claimCxToken(tokens, keep, claimed, index);
    }
}
function claimCxToken(tokens, keep, claimed, index) {
    var token = tokens[index];
    var _getClassConflicts;
    var keys = (_getClassConflicts = getClassConflicts(token)) !== null && _getClassConflicts !== void 0 ? _getClassConflicts : [
        token
    ];
    if (keys.some(function(key) {
        return claimed.has(key);
    })) {
        return;
    }
    keep[index] = true;
    keys.forEach(function(key) {
        return claimed.add(key);
    });
}
// src/treeParseUtils.ts
function iterateTopLevel(sheet, styles, selector) {
    var output = {
        preconditions: []
    };
    forIn(styles, function(key, value) {
        if (isStyleCondition(key)) {
            var res = iterateTopLevel(sheet, value, selector.addPrecondition(key));
            res.preconditions.forEach(function(item) {
                return output.preconditions.push(item);
            });
            return output;
        }
        output.preconditions.push([
            key,
            styles[key],
            selector.addScope(key)
        ]);
        return output;
    });
    return output;
}
function iterateStyles(sheet, styles, selector) {
    var output = /* @__PURE__ */ new Set();
    forIn(styles, function(property, value) {
        var res = [];
        if (isStyleCondition(property)) {
            res = iterateStyles(sheet, value, selector.addPostcondition(property));
        } else if (isDirectClass(property)) {
            res = asArray(value);
        } else if (isMediaQuery(property)) {
            res = handleMediaQuery(sheet, value, property, selector);
        } else if (isCssVariables(property)) {
            res = cssVariablesBlock(sheet, value, selector);
        } else if (isValidProperty(property, value)) {
            createDeclarationRules(selector, property, value).forEach(function(rule) {
                sheet.addRule(rule);
                output.add(rule.hash);
            });
        }
        return addEachClass(res, output);
    });
    return output;
}
function addEachClass(list, to) {
    list.forEach(function(className) {
        return to.add(className);
    });
    return to;
}
function createDeclarationRules(selector, property, value) {
    var expanded = expandShorthand(property, value);
    if (!expanded) {
        return [
            selector.createRule(property, value)
        ];
    }
    return expanded.map(function(param) {
        var _param = _sliced_to_array(param, 2), longhand = _param[0], token = _param[1];
        return selector.createRule(longhand, token);
    });
}
function expandShorthand(property, value) {
    var prepared = prepareShorthand(property, value);
    if (!prepared) {
        return void 0;
    }
    return expandPrepared(prepared);
}
function prepareShorthand(property, value) {
    var expansion = distributiveExpansion(camelCaseToDash(property));
    if (!expansion) {
        return void 0;
    }
    return expandTokens(expansion, String(value));
}
function expandTokens(expansion, value) {
    var _splitImportant = splitImportant(value), text = _splitImportant.text, important = _splitImportant.important;
    var _tokenizeValue = tokenizeValue(text), tokens = _tokenizeValue.tokens, slash = _tokenizeValue.slash;
    if (tokens.length === 0 || tokens.some(isOpaqueValue)) {
        return void 0;
    }
    return {
        kind: expansion.kind,
        longhands: expansion.longhands,
        tokens: tokens,
        slash: slash,
        important: important,
        text: text
    };
}
function expandPrepared(prepared) {
    var kind = prepared.kind, slash = prepared.slash, tokens = prepared.tokens;
    if (kind === "corners" && slash) {
        return expandElliptical(prepared);
    }
    if (tokens.length === 1) {
        return expandSingle(prepared);
    }
    return expandPositional(prepared);
}
function expansionTargets(prepared) {
    return prepared.kind === "box" ? prepared.longhands.slice(0, 4) : prepared.longhands;
}
function expandSingle(prepared) {
    var tokens = prepared.tokens, important = prepared.important;
    var only = tokens[0];
    if (!only) {
        return void 0;
    }
    return expansionTargets(prepared).map(function(longhand) {
        return [
            longhand,
            withImportant(only, important)
        ];
    });
}
var quadSides = {
    1: [
        0,
        0,
        0,
        0
    ],
    2: [
        0,
        1,
        0,
        1
    ],
    3: [
        0,
        1,
        2,
        1
    ],
    4: [
        0,
        1,
        2,
        3
    ]
};
var pairSides = {
    2: [
        0,
        1
    ]
};
function expandPositional(prepared) {
    var kind = prepared.kind, tokens = prepared.tokens, slash = prepared.slash, important = prepared.important;
    if (slash) {
        return void 0;
    }
    var sides = kind === "pair" ? pairSides[tokens.length] : quadSides[tokens.length];
    if (!sides) {
        return void 0;
    }
    return assignPositional(expansionTargets(prepared), sides, tokens, important);
}
function expandElliptical(prepared) {
    var halves = splitElliptical(prepared.text);
    if (!halves) {
        return void 0;
    }
    var horizontal = quadAssign(tokenizeValue(halves.horizontal).tokens);
    var vertical = quadAssign(tokenizeValue(halves.vertical).tokens);
    if (!horizontal || !vertical) {
        return void 0;
    }
    return assignCorners(prepared, horizontal, vertical);
}
function splitElliptical(text) {
    var slashAt = topLevelSlash(text);
    if (slashAt < 0) {
        return void 0;
    }
    var horizontal = text.slice(0, slashAt).trim();
    var vertical = text.slice(slashAt + 1).trim();
    if (!horizontal || !vertical || topLevelSlash(vertical) >= 0) {
        return void 0;
    }
    return {
        horizontal: horizontal,
        vertical: vertical
    };
}
function topLevelSlash(text) {
    var depth = 0;
    for(var index = 0; index < text.length; index++){
        var char = text[index];
        depth = Math.max(0, depth + parenDelta(char));
        if (depth === 0 && char === "/") {
            return index;
        }
    }
    return -1;
}
function quadAssign(tokens) {
    var sides = quadSides[tokens.length];
    if (!sides) {
        return void 0;
    }
    return assignTokens(tokens, sides);
}
function assignTokens(tokens, sides) {
    var output = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = sides[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var side = _step.value;
            var token = tokens[side];
            if (token === void 0) {
                return void 0;
            }
            output.push(token);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return output;
}
function assignCorners(prepared, horizontal, vertical) {
    var output = [];
    prepared.longhands.forEach(function(longhand, index) {
        var across = horizontal[index];
        var down = vertical[index];
        if (across === void 0 || down === void 0) {
            return;
        }
        output.push([
            longhand,
            withImportant("".concat(across, " ").concat(down), prepared.important)
        ]);
    });
    return output;
}
function assignPositional(positional, sides, tokens, important) {
    var output = [];
    sides.forEach(function(tokenIndex, index) {
        var longhand = positional[index];
        var token = tokens[tokenIndex];
        if (longhand !== void 0 && token !== void 0) {
            output.push([
                longhand,
                withImportant(token, important)
            ]);
        }
    });
    return output;
}
function withImportant(token, important) {
    return important ? "".concat(token, " !important") : token;
}
function splitImportant(text) {
    var match = /^(.*?)\s*!important\s*$/i.exec(text);
    if (!match) {
        return {
            text: text,
            important: false
        };
    }
    var _match_;
    return {
        text: ((_match_ = match[1]) !== null && _match_ !== void 0 ? _match_ : "").trim(),
        important: true
    };
}
function isOpaqueValue(text) {
    var trimmed = text.trim();
    var open = /^(var|env|attr)\(/i.exec(trimmed);
    if (!open) {
        return false;
    }
    return closesAtEnd(trimmed, open[0].length - 1);
}
function closesAtEnd(trimmed, start) {
    var depth = 0;
    for(var index = start; index < trimmed.length; index++){
        depth = Math.max(0, depth + parenDelta(trimmed[index]));
        if (depth === 0) {
            return index === trimmed.length - 1;
        }
    }
    return true;
}
function parenDelta(char) {
    if (char === "(") {
        return 1;
    }
    if (char === ")") {
        return -1;
    }
    return 0;
}
function tokenizeValue(text) {
    var tokens = [];
    var state = {
        current: "",
        depth: 0,
        slash: false
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var char = _step.value;
            stepTokenChar(state, char, tokens);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    pushToken(tokens, state);
    return {
        tokens: tokens,
        slash: state.slash
    };
}
function stepTokenChar(state, char, tokens) {
    state.depth = Math.max(0, state.depth + parenDelta(char));
    if (state.depth === 0 && isWhitespace(char)) {
        pushToken(tokens, state);
        return;
    }
    if (state.depth === 0 && char === "/") {
        state.slash = true;
    }
    state.current += char;
}
function pushToken(tokens, state) {
    if (state.current) {
        tokens.push(state.current);
        state.current = "";
    }
}
function isWhitespace(char) {
    return char === " " || char === "	" || char === "\n" || char === "\r";
}
function cssVariablesBlock(sheet, styles, selector) {
    var classes = /* @__PURE__ */ new Set();
    var chunkRows = [];
    var scope = selector.scopeClassName;
    forIn(styles, function(property, value) {
        if (isValidProperty(property, value)) {
            if (scope) {
                var rule = selector.createRule(property, value);
                classes.add(sheet.addRule(rule));
                return;
            }
            chunkRows.push(Rule.genRule(property, value));
            return;
        }
        var res = iterateStyles(sheet, value !== null && value !== void 0 ? value : {}, selector);
        addEachClass(res, classes);
    });
    if (!scope && chunkRows.length) {
        appendAmbientVariables(sheet, chunkRows.join(" "), selector);
    }
    return classes;
}
function appendAmbientVariables(sheet, css, selector) {
    var selectors = mergeSelectors(selector.preconditions, {});
    selectors = mergeSelectors(selector.postconditions, {
        left: selectors
    });
    if (selectors) {
        sheet.append("".concat(selectors, " {").concat(css, "}"));
    }
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
    var mark = sheet.getLength();
    sheet.append(mediaQuery + " {");
    var innerMark = sheet.getLength();
    var output = iterateStyles(sheet, styles, selector.addAtRule(mediaQuery));
    if (sheet.getLength() === innerMark) {
        sheet.truncate(mark);
        return output;
    }
    sheet.append("}");
    return output;
}
// src/index.ts
function createSheet(name, rootNode) {
    var sheet = resolveSheet(name, rootNode);
    return {
        create: genCreate(sheet),
        keyframes: genKeyframes(sheet),
        getStyle: sheet.getStyle.bind(sheet),
        isApplied: sheet.isApplied.bind(sheet)
    };
}
var defaultSheets = /* @__PURE__ */ new Map();
var rootedSheets = /* @__PURE__ */ new WeakMap();
function resolveSheet(name, root) {
    var resolved = resolveSheetRoot(root);
    if (!isCacheableContext(resolved.rootNode)) {
        return new Sheet(name, root);
    }
    return reuseOrCreateSheet(name, root, resolved.rootNode, resolved.nonce);
}
function reuseOrCreateSheet(name, root, rootNode, nonce) {
    var cacheKey = normalizeCacheRoot(rootNode);
    var cached = findCachedSheet(name, cacheKey);
    if (cached && !cached.isDetached()) {
        syncNonce(cached, nonce);
        return cached;
    }
    var sheet = new Sheet(name, root);
    storeCachedSheet(name, cacheKey, sheet);
    return sheet;
}
function normalizeCacheRoot(rootNode) {
    if (rootNode === void 0 && typeof document !== "undefined") {
        return document.head;
    }
    return rootNode;
}
function isCacheableContext(rootNode) {
    return typeof document !== "undefined" && rootNode !== null;
}
function findCachedSheet(name, rootNode) {
    if (rootNode === void 0) {
        return defaultSheets.get(name);
    }
    var scoped = rootedSheets.get(rootNode);
    return scoped === null || scoped === void 0 ? void 0 : scoped.get(name);
}
function storeCachedSheet(name, rootNode, sheet) {
    if (rootNode === void 0) {
        defaultSheets.set(name, sheet);
        return;
    }
    storeRootedSheet(rootNode, name, sheet);
}
function storeRootedSheet(rootNode, name, sheet) {
    var scoped = rootedSheets.get(rootNode);
    if (!scoped) {
        scoped = /* @__PURE__ */ new Map();
        rootedSheets.set(rootNode, scoped);
    }
    scoped.set(name, sheet);
}
function syncNonce(sheet, nonce) {
    if (nonce !== void 0 && nonce !== sheet.getNonce()) {
        sheet.setNonce(nonce);
    }
}
function genCreate(sheet) {
    return function create(styles) {
        var scopedStyles = {};
        var topLevel = iterateTopLevel(sheet, styles, new Selector(sheet));
        topLevel.preconditions.forEach(function(param) {
            var _param = _sliced_to_array(param, 3), scopeName = _param[0], styles2 = _param[1], selector = _param[2];
            iterateStyles(sheet, styles2, selector).forEach(function(className) {
                addScopedStyle(scopeName, className);
            });
        });
        sheet.apply();
        return scopedStyles;
        function addScopedStyle(name, className) {
            var _scopedStyles_name;
            scopedStyles[name] = (_scopedStyles_name = scopedStyles[name]) !== null && _scopedStyles_name !== void 0 ? _scopedStyles_name : /* @__PURE__ */ new Set();
            scopedStyles[name].add(className);
        }
    };
}
function genKeyframes(sheet) {
    return function keyframes(keyframesInput) {
        var output = addKeyframes(sheet, keyframesInput);
        sheet.apply();
        return output;
    };
}

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _createForOfIteratorHelperLoose(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (t) return (t = t.call(r)).next.bind(t);
  if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
    t && (r = t);
    var o = 0;
    return function () {
      return o >= r.length ? {
        done: !0
      } : {
        done: !1,
        value: r[o++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

var ClassNames;
(function (ClassNames) {
  ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
  ClassNames["searchActive"] = "epr-search-active";
  ClassNames["hidden"] = "epr-hidden";
  ClassNames["visible"] = "epr-visible";
  ClassNames["active"] = "epr-active";
  ClassNames["emoji"] = "epr-emoji";
  ClassNames["category"] = "epr-emoji-category";
  ClassNames["label"] = "epr-emoji-category-label";
  ClassNames["categoryContent"] = "epr-emoji-category-content";
  ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
  ClassNames["scrollBody"] = "epr-body";
  ClassNames["emojiList"] = "epr-emoji-list";
  ClassNames["external"] = "__EmojiPicker__";
  ClassNames["emojiPicker"] = "EmojiPickerReact";
  ClassNames["open"] = "epr-open";
  ClassNames["vertical"] = "epr-vertical";
  ClassNames["horizontal"] = "epr-horizontal";
  ClassNames["variationPicker"] = "epr-emoji-variation-picker";
  ClassNames["darkTheme"] = "epr-dark-theme";
  ClassNames["autoTheme"] = "epr-auto-theme";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
  for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
    classNames[_key] = arguments[_key];
  }
  return classNames.map(function (c) {
    return "." + c;
  }).join('');
}

var stylesheet = /*#__PURE__*/createSheet('epr', null);
var hidden = {
  display: 'none',
  opacity: '0',
  pointerEvents: 'none',
  visibility: 'hidden',
  overflow: 'hidden'
};
var commonStyles = /*#__PURE__*/stylesheet.create({
  hidden: /*#__PURE__*/_extends({
    '.': ClassNames.hidden
  }, hidden)
});
var PickerStyleTag = /*#__PURE__*/memo(function PickerStyleTag(_ref) {
  var nonce = _ref.nonce;
  return createElement("style", {
    nonce: nonce,
    suppressHydrationWarning: true,
    dangerouslySetInnerHTML: {
      __html: stylesheet.getStyle()
    }
  });
});
var commonInteractionStyles = /*#__PURE__*/stylesheet.create({
  '.epr-main': {
    ':has(input:not(:placeholder-shown))': {
      categoryBtn: {
        ':hover': {
          opacity: '1',
          backgroundPositionY: 'var(--epr-category-navigation-button-size)'
        }
      },
      hiddenOnSearch: /*#__PURE__*/_extends({
        '.': ClassNames.hiddenOnSearch
      }, hidden)
    },
    ':has(input:placeholder-shown)': {
      visibleOnSearchOnly: hidden
    }
  },
  hiddenOnReactions: {
    transition: 'all 0.5s ease-in-out'
  },
  '.epr-reactions': {
    hiddenOnReactions: {
      height: '0px',
      width: '0px',
      opacity: '0',
      pointerEvents: 'none',
      overflow: 'hidden'
    }
  },
  '.EmojiPickerReact:not(.epr-search-active)': {
    categoryBtn: {
      ':hover': {
        opacity: '1',
        backgroundPositionY: 'var(--epr-category-navigation-button-size)'
      },
      '&.epr-active': {
        opacity: '1',
        backgroundPositionY: 'var(--epr-category-navigation-button-size)'
      }
    },
    visibleOnSearchOnly: /*#__PURE__*/_extends({
      '.': 'epr-visible-on-search-only'
    }, hidden)
  }
});
function darkMode(key, value) {
  var _eprDarkTheme, _eprAutoTheme;
  return {
    '.epr-dark-theme': (_eprDarkTheme = {}, _eprDarkTheme[key] = value, _eprDarkTheme),
    '.epr-auto-theme': (_eprAutoTheme = {}, _eprAutoTheme[key] = {
      '@media (prefers-color-scheme: dark)': value
    }, _eprAutoTheme)
  };
}

// eslint-disable-next-line complexity
function compareConfig(prev, next) {
  var _prev$customEmojis, _next$customEmojis;
  var prevCustomEmojis = (_prev$customEmojis = prev.customEmojis) != null ? _prev$customEmojis : [];
  var nextCustomEmojis = (_next$customEmojis = next.customEmojis) != null ? _next$customEmojis : [];
  return prev.open === next.open && prev.emojiVersion === next.emojiVersion && prev.reactionsDefaultOpen === next.reactionsDefaultOpen && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.searchClearButtonLabel === next.searchClearButtonLabel && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.className === next.className && prev.height === next.height && prev.width === next.width && prev.style === next.style && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation && prevCustomEmojis.length === nextCustomEmojis.length && prev.emojiData === next.emojiData;
}

var DEFAULT_REACTIONS = ['1f44d', '2764-fe0f', '1f603', '1f622', '1f64f', '1f44e', '1f621'];

var SuggestionMode;
(function (SuggestionMode) {
  SuggestionMode["RECENT"] = "recent";
  SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function (EmojiStyle) {
  EmojiStyle["NATIVE"] = "native";
  EmojiStyle["APPLE"] = "apple";
  EmojiStyle["TWITTER"] = "twitter";
  EmojiStyle["GOOGLE"] = "google";
  EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
  Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function (SkinTones) {
  SkinTones["NEUTRAL"] = "neutral";
  SkinTones["LIGHT"] = "1f3fb";
  SkinTones["MEDIUM_LIGHT"] = "1f3fc";
  SkinTones["MEDIUM"] = "1f3fd";
  SkinTones["MEDIUM_DARK"] = "1f3fe";
  SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function (Categories) {
  Categories["SUGGESTED"] = "suggested";
  Categories["CUSTOM"] = "custom";
  Categories["SMILEYS_PEOPLE"] = "smileys_people";
  Categories["ANIMALS_NATURE"] = "animals_nature";
  Categories["FOOD_DRINK"] = "food_drink";
  Categories["TRAVEL_PLACES"] = "travel_places";
  Categories["ACTIVITIES"] = "activities";
  Categories["OBJECTS"] = "objects";
  Categories["SYMBOLS"] = "symbols";
  Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function (SkinTonePickerLocation) {
  SkinTonePickerLocation["SEARCH"] = "SEARCH";
  SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));

var CDN_URL_APPLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/';
var CDN_URL_FACEBOOK = 'https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/';
var CDN_URL_TWITTER = 'https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/';
var CDN_URL_GOOGLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/';
function cdnUrl(emojiStyle) {
  switch (emojiStyle) {
    case EmojiStyle.TWITTER:
      return CDN_URL_TWITTER;
    case EmojiStyle.GOOGLE:
      return CDN_URL_GOOGLE;
    case EmojiStyle.FACEBOOK:
      return CDN_URL_FACEBOOK;
    case EmojiStyle.APPLE:
    default:
      return CDN_URL_APPLE;
  }
}

var skinToneVariations = [SkinTones.NEUTRAL, SkinTones.LIGHT, SkinTones.MEDIUM_LIGHT, SkinTones.MEDIUM, SkinTones.MEDIUM_DARK, SkinTones.DARK];
var skinTonesNamed = /*#__PURE__*/Object.entries(SkinTones).reduce(function (acc, _ref) {
  var key = _ref[0],
    value = _ref[1];
  acc[value] = key;
  return acc;
}, {});
var skinTonesMapped = /*#__PURE__*/skinToneVariations.reduce(function (mapped, skinTone) {
  var _Object$assign;
  return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});

var EmojiProperties;
(function (EmojiProperties) {
  EmojiProperties["name"] = "n";
  EmojiProperties["unified"] = "u";
  EmojiProperties["variations"] = "v";
  EmojiProperties["added_in"] = "a";
  EmojiProperties["imgUrl"] = "imgUrl";
})(EmojiProperties || (EmojiProperties = {}));

function emojiNames(emoji) {
  var _emoji$EmojiPropertie;
  return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function addedIn(emoji) {
  return parseFloat(emoji[EmojiProperties.added_in] || '0');
}
function emojiName(emoji) {
  if (!emoji) {
    return '';
  }
  var names = emojiNames(emoji);
  return names[names.length - 1];
}
function unifiedWithoutSkinTone(unified) {
  var splat = unified.split('-');
  var _splat$splice = splat.splice(1, 1),
    skinTone = _splat$splice[0];
  if (skinTonesMapped[skinTone]) {
    return splat.join('-');
  }
  return unified;
}
function emojiUnified(emoji, skinTone) {
  var _emojiVariationUnifie;
  var unified = emoji[EmojiProperties.unified];
  if (!skinTone || !emojiHasVariations(emoji)) {
    return unified;
  }
  return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojiUrlByUnified(unified, emojiStyle) {
  return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
  var _emoji$EmojiPropertie2;
  return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
  return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
  return skinTone ? emojiVariations(emoji).find(function (variation) {
    return variation.includes(skinTone);
  }) : emojiUnified(emoji);
}
function activeVariationFromUnified(unified) {
  var _unified$split = unified.split('-'),
    suspectedSkinTone = _unified$split[1];
  return Object.keys(skinTonesMapped).includes(suspectedSkinTone) ? suspectedSkinTone : null;
}

var _configByCategory;
var categoriesOrdered = [Categories.SUGGESTED, Categories.CUSTOM, Categories.SMILEYS_PEOPLE, Categories.ANIMALS_NATURE, Categories.FOOD_DRINK, Categories.TRAVEL_PLACES, Categories.ACTIVITIES, Categories.OBJECTS, Categories.SYMBOLS, Categories.FLAGS];
var SuggestedRecent = {
  name: 'Recently Used',
  category: Categories.SUGGESTED
};
var configByCategory = (_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
  category: Categories.SUGGESTED,
  name: 'Frequently Used'
}, _configByCategory[Categories.CUSTOM] = {
  category: Categories.CUSTOM,
  name: 'Custom Emojis'
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
  category: Categories.SMILEYS_PEOPLE,
  name: 'Smileys & People'
}, _configByCategory[Categories.ANIMALS_NATURE] = {
  category: Categories.ANIMALS_NATURE,
  name: 'Animals & Nature'
}, _configByCategory[Categories.FOOD_DRINK] = {
  category: Categories.FOOD_DRINK,
  name: 'Food & Drink'
}, _configByCategory[Categories.TRAVEL_PLACES] = {
  category: Categories.TRAVEL_PLACES,
  name: 'Travel & Places'
}, _configByCategory[Categories.ACTIVITIES] = {
  category: Categories.ACTIVITIES,
  name: 'Activities'
}, _configByCategory[Categories.OBJECTS] = {
  category: Categories.OBJECTS,
  name: 'Objects'
}, _configByCategory[Categories.SYMBOLS] = {
  category: Categories.SYMBOLS,
  name: 'Symbols'
}, _configByCategory[Categories.FLAGS] = {
  category: Categories.FLAGS,
  name: 'Flags'
}, _configByCategory);
function baseCategoriesConfig(modifiers) {
  return categoriesOrdered.map(function (category) {
    return _extends({}, configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
  });
}
function categoryFromCategoryConfig(category) {
  return category.category;
}
function categoryNameFromCategoryConfig(category) {
  return category.name;
}
function mergeCategoriesConfig(userCategoriesConfig, modifiers, emojiData) {
  var _userCategoriesConfig;
  if (userCategoriesConfig === void 0) {
    userCategoriesConfig = [];
  }
  if (modifiers === void 0) {
    modifiers = {};
  }
  var extra = function () {
    // 1. Start with localized categories from emojiData
    var fromData = emojiData != null && emojiData.categories ? Object.fromEntries(Object.entries(emojiData.categories).filter(function (_ref) {
      var config = _ref[1];
      return !!config;
    })) : {};
    // 2. Handle "Recently Used" override for explicit 'recent' mode
    if (modifiers.suggestionMode === SuggestionMode.RECENT) {
      var _emojiData$categories;
      var recentConfig = emojiData == null ? void 0 : (_emojiData$categories = emojiData.categories) == null ? void 0 : _emojiData$categories['suggested_recent'];
      fromData[Categories.SUGGESTED] = recentConfig ? {
        category: Categories.SUGGESTED,
        name: recentConfig.name
      } : SuggestedRecent;
    }
    return fromData;
  }();
  var base = baseCategoriesConfig(extra);
  if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) {
    return base;
  }
  return userCategoriesConfig.map(function (category) {
    if (typeof category === 'string') {
      return getBaseConfigByCategory(category, extra[category]);
    }
    return _extends({}, getBaseConfigByCategory(category.category, extra[category.category]), category);
  });
}
function getBaseConfigByCategory(category, modifier) {
  if (modifier === void 0) {
    modifier = {};
  }
  return Object.assign(configByCategory[category], modifier);
}

var KNOWN_FAILING_EMOJIS = ['2640-fe0f', '2642-fe0f', '2695-fe0f'];
var DEFAULT_SEARCH_PLACEHOLDER = 'Search';
var DEFAULT_SEARCH_CLEAR_BUTTON_LABEL = 'Clear';
var SEARCH_RESULTS_NO_RESULTS_FOUND = 'No results found';
var SEARCH_RESULTS_SUFFIX = ' found. Use up and down arrow keys to navigate.';
var SEARCH_RESULTS_ONE_RESULT_FOUND = '1 result' + SEARCH_RESULTS_SUFFIX;
var SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND = '%n results' + SEARCH_RESULTS_SUFFIX;
function mergeConfig(userConfig) {
  var _userConfig$emojiData, _userConfig$emojiData2, _userConfig$emojiData3, _userConfig$previewCo, _userConfig$previewCo2;
  if (userConfig === void 0) {
    userConfig = {};
  }
  var base = basePickerConfig();
  // Get localized mood from emojiData, fallback to base default
  // Get localized mood from emojiData, fallback to base default
  var localizedMood = (_userConfig$emojiData = userConfig.emojiData) == null ? void 0 : (_userConfig$emojiData2 = _userConfig$emojiData.categories) == null ? void 0 : (_userConfig$emojiData3 = _userConfig$emojiData2.preview_mood) == null ? void 0 : _userConfig$emojiData3.name;
  var previewConfig = _extends({}, base.previewConfig, localizedMood && !((_userConfig$previewCo = userConfig.previewConfig) != null && _userConfig$previewCo.defaultCaption) ? {
    defaultCaption: localizedMood
  } : {}, (_userConfig$previewCo2 = userConfig.previewConfig) != null ? _userConfig$previewCo2 : {});
  var config = Object.assign(base, userConfig);
  var categories = mergeCategoriesConfig(userConfig.categories, {
    suggestionMode: config.suggestedEmojisMode
  }, userConfig.emojiData);
  config.hiddenEmojis.forEach(function (emoji) {
    config.unicodeToHide.add(emoji);
  });
  var skinTonePickerLocation = config.searchDisabled ? SkinTonePickerLocation.PREVIEW : config.skinTonePickerLocation;
  return _extends({}, config, {
    categories: categories,
    previewConfig: previewConfig,
    skinTonePickerLocation: skinTonePickerLocation
  });
}
function basePickerConfig() {
  return {
    autoFocusSearch: true,
    categories: baseCategoriesConfig(),
    className: '',
    customEmojis: [],
    defaultSkinTone: SkinTones.NEUTRAL,
    emojiStyle: EmojiStyle.APPLE,
    emojiVersion: null,
    getEmojiUrl: emojiUrlByUnified,
    height: 450,
    lazyLoadEmojis: false,
    previewConfig: _extends({}, basePreviewConfig),
    searchDisabled: false,
    searchPlaceHolder: DEFAULT_SEARCH_PLACEHOLDER,
    searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
    searchClearButtonLabel: DEFAULT_SEARCH_CLEAR_BUTTON_LABEL,
    skinTonePickerLocation: SkinTonePickerLocation.SEARCH,
    skinTonesDisabled: false,
    style: {},
    suggestedEmojisMode: SuggestionMode.FREQUENT,
    theme: Theme.LIGHT,
    unicodeToHide: new Set(KNOWN_FAILING_EMOJIS),
    width: 350,
    reactionsDefaultOpen: false,
    reactions: DEFAULT_REACTIONS,
    open: true,
    allowExpandReactions: true,
    hiddenEmojis: [],
    emojiData: undefined,
    categoryIcons: {},
    nonce: undefined
  };
}
var basePreviewConfig = {
  defaultEmoji: '1f60a',
  defaultCaption: "What's your mood?",
  showPreview: true
};

var _excluded = ["children"];
var ConfigContext = /*#__PURE__*/createContext$1(/*#__PURE__*/basePickerConfig());
function PickerConfigProvider(_ref) {
  var children = _ref.children,
    config = _objectWithoutPropertiesLoose(_ref, _excluded);
  var mergedConfig = useSetConfig(config);
  return createElement(ConfigContext.Provider, {
    value: mergedConfig
  }, children);
}
function useSetConfig(config) {
  var _config$customEmojis;
  var _React$useState = useState(function () {
      return mergeConfig(config);
    }),
    mergedConfig = _React$useState[0],
    setMergedConfig = _React$useState[1];
  useEffect(function () {
    if (compareConfig(mergedConfig, config)) {
      return;
    }
    setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [(_config$customEmojis = config.customEmojis) == null ? void 0 : _config$customEmojis.length, config.open, config.emojiVersion, config.reactionsDefaultOpen, config.searchPlaceHolder, config.searchPlaceholder, config.searchClearButtonLabel, config.defaultSkinTone, config.skinTonesDisabled, config.autoFocusSearch, config.emojiStyle, config.theme, config.suggestedEmojisMode, config.lazyLoadEmojis, config.className, config.height, config.width, config.searchDisabled, config.skinTonePickerLocation, config.allowExpandReactions, config.emojiData]);
  return mergedConfig;
}
function usePickerConfig() {
  return useContext(ConfigContext);
}

function useDebouncedState(initialValue, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  var _useState = useState(initialValue),
    state = _useState[0],
    setState = _useState[1];
  var timer = useRef(null);
  function debouncedSetState(value) {
    return new Promise(function (resolve) {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(function () {
        setState(value);
        resolve(value);
      }, delay);
    });
  }
  return [state, debouncedSetState];
}

var categories = {
	smileys_people: {
		category: "smileys_people",
		name: "people & body"
	},
	animals_nature: {
		category: "animals_nature",
		name: "animals & nature"
	},
	food_drink: {
		category: "food_drink",
		name: "food & drink"
	},
	travel_places: {
		category: "travel_places",
		name: "travel & places"
	},
	activities: {
		category: "activities",
		name: "activities"
	},
	objects: {
		category: "objects",
		name: "objects"
	},
	symbols: {
		category: "symbols",
		name: "symbols"
	},
	flags: {
		category: "flags",
		name: "flags"
	},
	suggested: {
		category: "suggested",
		name: "Frequently Used"
	},
	custom: {
		category: "custom",
		name: "Custom Emojis"
	},
	suggested_recent: {
		category: "suggested",
		name: "Recently Used"
	},
	preview_mood: {
		category: "preview_mood",
		name: "What's your mood?"
	}
};
var emojis = {
	custom: [
	],
	smileys_people: [
		{
			n: [
				"face",
				"grin",
				"nice",
				"happy",
				"laugh",
				"smile",
				"teeth",
				"cheery",
				"smiling",
				"cheerful",
				"grinning",
				"grinning face"
			],
			u: "1f600",
			a: "1"
		},
		{
			n: [
				"big",
				"yay",
				"eyes",
				"face",
				"grin",
				"open",
				"happy",
				"mouth",
				"smile",
				"teeth",
				"awesome",
				"smiling",
				"grinning",
				"grinning face with big eyes"
			],
			u: "1f603",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"lol",
				"eyes",
				"face",
				"grin",
				"open",
				"happy",
				"laugh",
				"mouth",
				"smile",
				"smiling",
				"grinning",
				"grinning face with smiling eyes"
			],
			u: "1f604",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"eyes",
				"face",
				"grin",
				"nice",
				"happy",
				"smile",
				"teeth",
				"beaming",
				"smiling",
				"grinning",
				"beaming face with smiling eyes"
			],
			u: "1f601",
			a: "0.6"
		},
		{
			n: [
				"lol",
				"eyes",
				"face",
				"haha",
				"open",
				"rofl",
				"happy",
				"laugh",
				"mouth",
				"smile",
				"closed",
				"hahaha",
				"smiling",
				"grinning",
				"squinting",
				"grinning squinting face"
			],
			u: "1f606",
			a: "0.6"
		},
		{
			n: [
				"cold",
				"face",
				"open",
				"mouth",
				"smile",
				"sweat",
				"stress",
				"excited",
				"nervous",
				"smiling",
				"dejected",
				"grinning",
				"stressed",
				"grinning face with sweat"
			],
			u: "1f605",
			a: "0.6"
		},
		{
			n: [
				"joy",
				"lol",
				"face",
				"haha",
				"hehe",
				"lmao",
				"rofl",
				"tear",
				"floor",
				"funny",
				"happy",
				"laugh",
				"crying",
				"roflmao",
				"rolling",
				"hilarious",
				"rolling on the floor laughing"
			],
			u: "1f923",
			a: "3"
		},
		{
			n: [
				"joy",
				"lol",
				"face",
				"haha",
				"hehe",
				"lmao",
				"rofl",
				"tear",
				"feels",
				"funny",
				"happy",
				"laugh",
				"crying",
				"roflmao",
				"hilarious",
				"face with tears of joy"
			],
			u: "1f602",
			a: "0.6"
		},
		{
			n: [
				"face",
				"happy",
				"smile",
				"smiling",
				"slightly",
				"slightly smiling face"
			],
			u: "1f642",
			a: "1"
		},
		{
			n: [
				"face",
				"hehe",
				"smile",
				"upside down",
				"upside down face"
			],
			u: "1f643",
			a: "1"
		},
		{
			n: [
				"hot",
				"lol",
				"face",
				"haha",
				"heat",
				"melt",
				"liquid",
				"melting",
				"sarcasm",
				"dissolve",
				"disappear",
				"sarcastic",
				"embarrassed",
				"melting face"
			],
			u: "1fae0",
			a: "14"
		},
		{
			n: [
				"face",
				"sexy",
				"wink",
				"flirt",
				"slide",
				"tease",
				"winks",
				"winking",
				"winking face",
				"heartbreaker"
			],
			u: "1f609",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"eyes",
				"face",
				"glad",
				"blush",
				"smile",
				"smiling",
				"satisfied",
				"smiling face with smiling eyes"
			],
			u: "1f60a",
			a: "0.6"
		},
		{
			n: [
				"face",
				"halo",
				"tale",
				"angel",
				"fairy",
				"happy",
				"smile",
				"angels",
				"spirit",
				"angelic",
				"blessed",
				"fantasy",
				"smiling",
				"innocent",
				"peaceful",
				"fairytale",
				"smiling face with halo"
			],
			u: "1f607",
			a: "1"
		},
		{
			n: [
				"3",
				"ily",
				"you",
				"face",
				"love",
				"adore",
				"crush",
				"heart",
				"smile",
				"hearts",
				"romance",
				"smiling",
				"smiling face with hearts"
			],
			u: "1f970",
			a: "11"
		},
		{
			n: [
				"143",
				"bae",
				"eye",
				"ily",
				"face",
				"love",
				"xoxo",
				"feels",
				"smile",
				"hearts",
				"kisses",
				"romance",
				"romantic",
				"heart eyes",
				"smiling face with heart eyes"
			],
			u: "1f60d",
			a: "0.6"
		},
		{
			n: [
				"wow",
				"eyes",
				"face",
				"star",
				"smile",
				"excited",
				"grinning",
				"star struck",
				"starry eyed"
			],
			u: "1f929",
			a: "5"
		},
		{
			n: [
				"bae",
				"ily",
				"you",
				"face",
				"kiss",
				"love",
				"miss",
				"muah",
				"xoxo",
				"flirt",
				"heart",
				"lover",
				"adorbs",
				"smooch",
				"blowing",
				"romantic",
				"face blowing a kiss"
			],
			u: "1f618",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"you",
				"date",
				"face",
				"kiss",
				"love",
				"xoxo",
				"flirt",
				"dating",
				"smooch",
				"smooches",
				"kissing face"
			],
			u: "1f617",
			a: "1"
		},
		{
			n: [
				"face",
				"happy",
				"smile",
				"relaxed",
				"smiling",
				"outlined",
				"smiling face"
			],
			u: "263a-fe0f",
			a: "0.6"
		},
		{
			n: [
				"143",
				"bae",
				"eye",
				"ily",
				"date",
				"eyes",
				"face",
				"xoxo",
				"blush",
				"flirt",
				"closed",
				"dating",
				"kisses",
				"kissing",
				"smooches",
				"kissing face with closed eyes"
			],
			u: "1f61a",
			a: "0.6"
		},
		{
			n: [
				"143",
				"eye",
				"ily",
				"date",
				"eyes",
				"face",
				"kiss",
				"love",
				"flirt",
				"night",
				"smile",
				"closed",
				"dating",
				"kisses",
				"kissing",
				"smiling",
				"kissing face with smiling eyes"
			],
			u: "1f619",
			a: "1"
		},
		{
			n: [
				"joy",
				"face",
				"glad",
				"pain",
				"tear",
				"happy",
				"proud",
				"smile",
				"smiley",
				"smiling",
				"touched",
				"grateful",
				"relieved",
				"smiling face with tear"
			],
			u: "1f972",
			a: "13"
		},
		{
			n: [
				"um",
				"eat",
				"yum",
				"face",
				"food",
				"full",
				"savor",
				"smile",
				"tasty",
				"yummy",
				"hungry",
				"smiling",
				"delicious",
				"face savoring food"
			],
			u: "1f60b",
			a: "0.6"
		},
		{
			n: [
				"cool",
				"face",
				"nice",
				"party",
				"sweet",
				"tongue",
				"awesome",
				"stuck out",
				"face with tongue"
			],
			u: "1f61b",
			a: "1"
		},
		{
			n: [
				"eye",
				"epic",
				"face",
				"joke",
				"wink",
				"yolo",
				"crazy",
				"funny",
				"loopy",
				"nutty",
				"party",
				"wacky",
				"tongue",
				"weirdo",
				"winking",
				"stuck out",
				"winking face with tongue"
			],
			u: "1f61c",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"eyes",
				"face",
				"zany",
				"crazy",
				"goofy",
				"large",
				"small",
				"zany face"
			],
			u: "1f92a",
			a: "5"
		},
		{
			n: [
				"eye",
				"omg",
				"eyes",
				"face",
				"yolo",
				"gross",
				"taste",
				"closed",
				"tongue",
				"horrible",
				"whatever",
				"squinting",
				"stuck out",
				"squinting face with tongue"
			],
			u: "1f61d",
			a: "0.6"
		},
		{
			n: [
				"face",
				"paid",
				"money",
				"mouth",
				"money mouth",
				"money mouth face"
			],
			u: "1f911",
			a: "1"
		},
		{
			n: [
				"hug",
				"face",
				"open",
				"hands",
				"hugging",
				"smiling",
				"smiling face with open hands"
			],
			u: "1f917",
			a: "1"
		},
		{
			n: [
				"face",
				"hand",
				"oops",
				"mouth",
				"shock",
				"giggle",
				"secret",
				"sudden",
				"whoops",
				"giggling",
				"surprise",
				"realization",
				"face with hand over mouth"
			],
			u: "1f92d",
			a: "5"
		},
		{
			n: [
				"awe",
				"omg",
				"eyes",
				"face",
				"gasp",
				"hand",
				"open",
				"over",
				"mouth",
				"quiet",
				"shock",
				"scared",
				"surprise",
				"amazement",
				"disbelief",
				"embarrass",
				"face with open eyes and hand over mouth"
			],
			u: "1fae2",
			a: "14"
		},
		{
			n: [
				"eye",
				"shy",
				"face",
				"hide",
				"peek",
				"peep",
				"stare",
				"hiding",
				"scared",
				"peeking",
				"embarrass",
				"captivated",
				"face with peeking eye"
			],
			u: "1fae3",
			a: "14"
		},
		{
			n: [
				"shh",
				"face",
				"quiet",
				"shush",
				"shushing",
				"shushing face"
			],
			u: "1f92b",
			a: "5"
		},
		{
			n: [
				"hmm",
				"chin",
				"face",
				"ponder",
				"consider",
				"thinking",
				"pondering",
				"wondering",
				"thinking face"
			],
			u: "1f914",
			a: "1"
		},
		{
			n: [
				"ok",
				"sir",
				"yes",
				"face",
				"good",
				"luck",
				"ma’am",
				"salute",
				"troops",
				"respect",
				"saluting",
				"saluting face"
			],
			u: "1fae1",
			a: "14"
		},
		{
			n: [
				"zip",
				"face",
				"keep",
				"shut",
				"mouth",
				"quiet",
				"secret",
				"zipper",
				"zipper mouth",
				"zipper mouth face"
			],
			u: "1f910",
			a: "1"
		},
		{
			n: [
				"hmm",
				"face",
				"mild",
				"what",
				"emoji",
				"raised",
				"eyebrow",
				"skeptic",
				"distrust",
				"surprise",
				"disbelief",
				"skeptical",
				"skepticism",
				"disapproval",
				"face with raised eyebrow"
			],
			u: "1f928",
			a: "5"
		},
		{
			n: [
				"oh",
				"meh",
				"face",
				"fine",
				"blank",
				"shade",
				"awkward",
				"deadpan",
				"jealous",
				"neutral",
				"unhappy",
				"straight",
				"unamused",
				"whatever",
				"unimpressed",
				"neutral face",
				"expressionless"
			],
			u: "1f610",
			a: "0.7"
		},
		{
			n: [
				"oh",
				"uh",
				"meh",
				"not",
				"omg",
				"dead",
				"face",
				"fine",
				"awkward",
				"jealous",
				"unhappy",
				"straight",
				"whatever",
				"unimpressed",
				"inexpressive",
				"expressionless",
				"expressionless face"
			],
			u: "1f611",
			a: "1"
		},
		{
			n: [
				"face",
				"mute",
				"blank",
				"mouth",
				"quiet",
				"secret",
				"silent",
				"awkward",
				"silence",
				"mouthless",
				"speechless",
				"expressionless",
				"face without mouth"
			],
			u: "1f636",
			a: "1"
		},
		{
			n: [
				"meh",
				"wtv",
				"face",
				"hide",
				"line",
				"dotted",
				"hidden",
				"whatever",
				"depressed",
				"disappear",
				"introvert",
				"invisible",
				"dotted line face"
			],
			u: "1fae5",
			a: "14"
		},
		{
			n: [
				"fog",
				"face",
				"head",
				"clouds",
				"absentminded",
				"face in clouds"
			],
			u: "1f636-200d-1f32b-fe0f",
			a: "13.1"
		},
		{
			n: [
				"sly",
				"boss",
				"face",
				"leer",
				"smug",
				"swag",
				"flirt",
				"homie",
				"shade",
				"slick",
				"smirk",
				"suave",
				"dapper",
				"kidding",
				"snicker",
				"suspicious",
				"smirking face"
			],
			u: "1f60f",
			a: "0.6"
		},
		{
			n: [
				"...",
				"jel",
				"smh",
				"ugh",
				"uhh",
				"face",
				"fine",
				"bored",
				"jelly",
				"weird",
				"pissed",
				"jealous",
				"unhappy",
				"unamused",
				"whatever",
				"unamused face"
			],
			u: "1f612",
			a: "0.6"
		},
		{
			n: [
				"ugh",
				"eyes",
				"face",
				"shade",
				"eyeroll",
				"rolling",
				"whatever",
				"face with rolling eyes"
			],
			u: "1f644",
			a: "1"
		},
		{
			n: [
				"awk",
				"face",
				"smile",
				"awkward",
				"dentist",
				"grimace",
				"smiling",
				"grinning",
				"grimacing",
				"grimacing face"
			],
			u: "1f62c",
			a: "1"
		},
		{
			n: [
				"blow",
				"face",
				"gasp",
				"sigh",
				"groan",
				"smoke",
				"exhale",
				"relief",
				"smiley",
				"blowing",
				"whisper",
				"whistle",
				"exhaling",
				"exhausted",
				"face exhaling"
			],
			u: "1f62e-200d-1f4a8",
			a: "13.1"
		},
		{
			n: [
				"lie",
				"face",
				"liar",
				"lying",
				"pinocchio",
				"lying face"
			],
			u: "1f925",
			a: "3"
		},
		{
			n: [
				"omg",
				"wow",
				"daze",
				"face",
				"whoa",
				"crazy",
				"panic",
				"shock",
				"shaking",
				"vibrate",
				"surprise",
				"earthquake",
				"shaking face"
			],
			u: "1fae8",
			a: "15"
		},
		{
			n: [
				"no",
				"head",
				"shake",
				"shaking",
				"horizontally",
				"head shaking horizontally"
			],
			u: "1f642-200d-2194-fe0f",
			a: "15.1"
		},
		{
			n: [
				"nod",
				"yes",
				"head",
				"shaking",
				"vertically",
				"head shaking vertically"
			],
			u: "1f642-200d-2195-fe0f",
			a: "15.1"
		},
		{
			n: [
				"zen",
				"calm",
				"face",
				"peace",
				"relief",
				"relieved",
				"relieved face"
			],
			u: "1f60c",
			a: "0.6"
		},
		{
			n: [
				"sad",
				"died",
				"face",
				"lost",
				"awful",
				"bored",
				"sucks",
				"losing",
				"pensive",
				"dejected",
				"pensive face",
				"disappointed"
			],
			u: "1f614",
			a: "0.6"
		},
		{
			n: [
				"sad",
				"face",
				"good",
				"night",
				"sleep",
				"tired",
				"crying",
				"sleepy",
				"sleeping",
				"sleepy face"
			],
			u: "1f62a",
			a: "0.6"
		},
		{
			n: [
				"face",
				"drooling",
				"drooling face"
			],
			u: "1f924",
			a: "3"
		},
		{
			n: [
				"bed",
				"nap",
				"zzz",
				"face",
				"good",
				"yawn",
				"night",
				"sleep",
				"tired",
				"bedtime",
				"sleeping",
				"whatever",
				"goodnight",
				"sleeping face"
			],
			u: "1f634",
			a: "1"
		},
		{
			n: [
				"bags",
				"eyes",
				"face",
				"late",
				"bored",
				"tired",
				"weary",
				"sleepy",
				"fatigued",
				"exhausted",
				"face with bags under eyes"
			],
			u: "1fae9",
			a: "16"
		},
		{
			n: [
				"dr",
				"cold",
				"face",
				"mask",
				"sick",
				"germs",
				"doctor",
				"dentist",
				"medical",
				"medicine",
				"dermatologist",
				"face with medical mask"
			],
			u: "1f637",
			a: "0.6"
		},
		{
			n: [
				"ill",
				"face",
				"sick",
				"thermometer",
				"face with thermometer"
			],
			u: "1f912",
			a: "1"
		},
		{
			n: [
				"face",
				"hurt",
				"ouch",
				"injury",
				"bandage",
				"head bandage",
				"face with head bandage"
			],
			u: "1f915",
			a: "1"
		},
		{
			n: [
				"face",
				"sick",
				"gross",
				"nasty",
				"vomit",
				"nauseated",
				"nauseated face"
			],
			u: "1f922",
			a: "3"
		},
		{
			n: [
				"ew",
				"up",
				"barf",
				"face",
				"puke",
				"sick",
				"spew",
				"gross",
				"throw",
				"vomit",
				"vomiting",
				"face vomiting"
			],
			u: "1f92e",
			a: "5"
		},
		{
			n: [
				"flu",
				"face",
				"sick",
				"fever",
				"sneeze",
				"sneezing",
				"gesundheit",
				"sneezing face"
			],
			u: "1f927",
			a: "3"
		},
		{
			n: [
				"hot",
				"face",
				"heat",
				"dying",
				"stroke",
				"tongue",
				"panting",
				"hot face",
				"feverish",
				"sweating",
				"red faced"
			],
			u: "1f975",
			a: "11"
		},
		{
			n: [
				"blue",
				"cold",
				"face",
				"teeth",
				"icicles",
				"subzero",
				"freezing",
				"cold face",
				"frostbite",
				"blue faced"
			],
			u: "1f976",
			a: "11"
		},
		{
			n: [
				"eyes",
				"face",
				"wavy",
				"dizzy",
				"drunk",
				"mouth",
				"tipsy",
				"woozy",
				"uneven",
				"woozy face",
				"intoxicated"
			],
			u: "1f974",
			a: "11"
		},
		{
			n: [
				"out",
				"dead",
				"eyes",
				"face",
				"sick",
				"dizzy",
				"feels",
				"tired",
				"knocked",
				"crossed out",
				"face with crossed out eyes"
			],
			u: "1f635",
			a: "0.6"
		},
		{
			n: [
				"omg",
				"eyes",
				"face",
				"whoa",
				"woah",
				"dizzy",
				"woozy",
				"smiley",
				"spiral",
				"trouble",
				"confused",
				"hypnotized",
				"face with spiral eyes"
			],
			u: "1f635-200d-1f4ab",
			a: "13.1"
		},
		{
			n: [
				"no",
				"way",
				"head",
				"mind",
				"blown",
				"explode",
				"shocked",
				"exploding",
				"mindblown",
				"exploding head"
			],
			u: "1f92f",
			a: "5"
		},
		{
			n: [
				"hat",
				"face",
				"cowboy",
				"cowgirl",
				"cowboy hat face"
			],
			u: "1f920",
			a: "3"
		},
		{
			n: [
				"hat",
				"bday",
				"face",
				"horn",
				"happy",
				"party",
				"hooray",
				"excited",
				"birthday",
				"partying",
				"celebrate",
				"celebration",
				"partying face"
			],
			u: "1f973",
			a: "11"
		},
		{
			n: [
				"spy",
				"face",
				"nose",
				"tash",
				"tache",
				"person",
				"eyebrow",
				"glasses",
				"disguise",
				"mustache",
				"incognito",
				"moustache",
				"disguised face"
			],
			u: "1f978",
			a: "13"
		},
		{
			n: [
				"bro",
				"rad",
				"win",
				"cool",
				"face",
				"slay",
				"swag",
				"beach",
				"smile",
				"style",
				"bright",
				"shades",
				"awesome",
				"relaxed",
				"chilling",
				"sunglasses",
				"smiling face with sunglasses"
			],
			u: "1f60e",
			a: "1"
		},
		{
			n: [
				"face",
				"geek",
				"nerd",
				"smart",
				"brainy",
				"clever",
				"expert",
				"gifted",
				"glasses",
				"nerd face",
				"intelligent"
			],
			u: "1f913",
			a: "1"
		},
		{
			n: [
				"face",
				"rich",
				"fancy",
				"classy",
				"stuffy",
				"monocle",
				"wealthy",
				"face with monocle"
			],
			u: "1f9d0",
			a: "5"
		},
		{
			n: [
				"hm",
				"meh",
				"not",
				"sad",
				"face",
				"sure",
				"dunno",
				"frown",
				"sorry",
				"confused",
				"befuddled",
				"confusing",
				"confused face"
			],
			u: "1f615",
			a: "1"
		},
		{
			n: [
				"meh",
				"wtv",
				"face",
				"doubt",
				"mouth",
				"unsure",
				"confused",
				"diagonal",
				"doubtful",
				"whatever",
				"confusion",
				"skeptical",
				"frustrated",
				"frustration",
				"disappointed",
				"face with diagonal mouth"
			],
			u: "1fae4",
			a: "14"
		},
		{
			n: [
				"sad",
				"face",
				"worry",
				"nerves",
				"stress",
				"anxious",
				"nervous",
				"worried",
				"stressed",
				"surprised",
				"butterflies",
				"worried face"
			],
			u: "1f61f",
			a: "1"
		},
		{
			n: [
				"sad",
				"face",
				"frown",
				"frowning",
				"slightly",
				"slightly frowning face"
			],
			u: "1f641",
			a: "1"
		},
		{
			n: [
				"sad",
				"face",
				"frown",
				"frowning",
				"frowning face"
			],
			u: "2639-fe0f",
			a: "0.7"
		},
		{
			n: [
				"omg",
				"wow",
				"you",
				"face",
				"open",
				"whoa",
				"mouth",
				"forgot",
				"unreal",
				"believe",
				"shocked",
				"sympathy",
				"surprised",
				"unbelievable",
				"face with open mouth"
			],
			u: "1f62e",
			a: "1"
		},
		{
			n: [
				"omg",
				"epic",
				"face",
				"whoa",
				"woah",
				"hushed",
				"stunned",
				"surprised",
				"hushed face"
			],
			u: "1f62f",
			a: "1"
		},
		{
			n: [
				"no",
				"omg",
				"way",
				"cost",
				"face",
				"shocked",
				"totally",
				"astonished",
				"astonished face"
			],
			u: "1f632",
			a: "0.6"
		},
		{
			n: [
				"hot",
				"wow",
				"dead",
				"face",
				"geez",
				"heat",
				"jeez",
				"what",
				"crazy",
				"dazed",
				"amazed",
				"awkward",
				"flushed",
				"disbelief",
				"impressed",
				"embarrassed",
				"flushed face"
			],
			u: "1f633",
			a: "0.6"
		},
		{
			n: [
				"big",
				"not",
				"sad",
				"why",
				"eyes",
				"face",
				"mercy",
				"puppy",
				"please",
				"pretty",
				"begging",
				"pleading",
				"pleading face"
			],
			u: "1f97a",
			a: "11"
		},
		{
			n: [
				"aww",
				"cry",
				"joy",
				"sad",
				"back",
				"face",
				"proud",
				"tears",
				"please",
				"resist",
				"holding",
				"feelings",
				"grateful",
				"gratitude",
				"admiration",
				"embarrassed",
				"face holding back tears"
			],
			u: "1f979",
			a: "14"
		},
		{
			n: [
				"wow",
				"face",
				"open",
				"what",
				"frown",
				"guard",
				"mouth",
				"scary",
				"caught",
				"scared",
				"frowning",
				"surprise",
				"frowning face with open mouth"
			],
			u: "1f626",
			a: "1"
		},
		{
			n: [
				"wow",
				"face",
				"what",
				"scary",
				"forgot",
				"scared",
				"unhappy",
				"stressed",
				"surprise",
				"anguished",
				"anguished face"
			],
			u: "1f627",
			a: "1"
		},
		{
			n: [
				"face",
				"fear",
				"blame",
				"afraid",
				"scared",
				"anxious",
				"fearful",
				"worried",
				"fearful face"
			],
			u: "1f628",
			a: "0.6"
		},
		{
			n: [
				"eek",
				"blue",
				"cold",
				"face",
				"open",
				"mouth",
				"sweat",
				"yikes",
				"rushed",
				"scared",
				"anxious",
				"nervous",
				"anxious face with sweat"
			],
			u: "1f630",
			a: "0.6"
		},
		{
			n: [
				"not",
				"sad",
				"call",
				"face",
				"time",
				"whew",
				"close",
				"sweat",
				"anxious",
				"relieved",
				"complicated",
				"disappointed",
				"sad but relieved face"
			],
			u: "1f625",
			a: "0.6"
		},
		{
			n: [
				"cry",
				"sad",
				"face",
				"miss",
				"tear",
				"awful",
				"feels",
				"crying",
				"triste",
				"unhappy",
				"crying face"
			],
			u: "1f622",
			a: "0.6"
		},
		{
			n: [
				"cry",
				"sad",
				"sob",
				"face",
				"tear",
				"tears",
				"crying",
				"loudly",
				"bawling",
				"unhappy",
				"loudly crying face"
			],
			u: "1f62d",
			a: "0.6"
		},
		{
			n: [
				"epic",
				"face",
				"fear",
				"woah",
				"munch",
				"scared",
				"scream",
				"fearful",
				"shocked",
				"screamer",
				"screaming",
				"surprised",
				"face screaming in fear"
			],
			u: "1f631",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"sad",
				"face",
				"feels",
				"cringe",
				"annoyed",
				"confused",
				"confounded",
				"distraught",
				"frustrated",
				"confounded face"
			],
			u: "1f616",
			a: "0.6"
		},
		{
			n: [
				"face",
				"focus",
				"headache",
				"persevere",
				"concentrate",
				"persevering",
				"concentration",
				"persevering face"
			],
			u: "1f623",
			a: "0.6"
		},
		{
			n: [
				"sad",
				"face",
				"fail",
				"awful",
				"blame",
				"losing",
				"unhappy",
				"dejected",
				"disappointed",
				"disappointed face"
			],
			u: "1f61e",
			a: "0.6"
		},
		{
			n: [
				"sad",
				"cold",
				"face",
				"close",
				"feels",
				"sweat",
				"yikes",
				"scared",
				"nervous",
				"downcast",
				"headache",
				"downcast face with sweat"
			],
			u: "1f613",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"sad",
				"face",
				"fail",
				"nooo",
				"feels",
				"tired",
				"weary",
				"crying",
				"hungry",
				"sleepy",
				"unhappy",
				"weary face"
			],
			u: "1f629",
			a: "0.6"
		},
		{
			n: [
				"nap",
				"sad",
				"cost",
				"face",
				"feels",
				"tired",
				"sneeze",
				"tired face"
			],
			u: "1f62b",
			a: "0.6"
		},
		{
			n: [
				"nap",
				"zzz",
				"face",
				"yawn",
				"bored",
				"night",
				"sleep",
				"tired",
				"sleepy",
				"bedtime",
				"yawning",
				"whatever",
				"goodnight",
				"yawning face"
			],
			u: "1f971",
			a: "12"
		},
		{
			n: [
				"mad",
				"won",
				"face",
				"fume",
				"fury",
				"nose",
				"anger",
				"angry",
				"feels",
				"steam",
				"fuming",
				"furious",
				"triumph",
				"unhappy",
				"face with steam from nose"
			],
			u: "1f624",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"red",
				"face",
				"rage",
				"anger",
				"angry",
				"feels",
				"shade",
				"upset",
				"enraged",
				"pouting",
				"unhappy",
				"maddening",
				"enraged face"
			],
			u: "1f621",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"face",
				"rage",
				"anger",
				"angry",
				"blame",
				"feels",
				"shade",
				"upset",
				"unhappy",
				"maddening",
				"angry face",
				"frustrated"
			],
			u: "1f620",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"face",
				"mouth",
				"censor",
				"pissed",
				"cursing",
				"cussing",
				"symbols",
				"swearing",
				"face with symbols on mouth"
			],
			u: "1f92c",
			a: "5"
		},
		{
			n: [
				"evil",
				"face",
				"tale",
				"demon",
				"devil",
				"fairy",
				"horns",
				"shade",
				"smile",
				"purple",
				"fantasy",
				"smiling",
				"fairytale",
				"smiling face with horns"
			],
			u: "1f608",
			a: "1"
		},
		{
			n: [
				"imp",
				"evil",
				"face",
				"tale",
				"angry",
				"demon",
				"devil",
				"fairy",
				"horns",
				"shade",
				"purple",
				"fantasy",
				"fairytale",
				"mischievous",
				"angry face with horns"
			],
			u: "1f47f",
			a: "0.6"
		},
		{
			n: [
				"i’m",
				"body",
				"dead",
				"face",
				"lmao",
				"tale",
				"yolo",
				"skull",
				"death",
				"fairy",
				"monster",
				"fairytale"
			],
			u: "1f480",
			a: "0.6"
		},
		{
			n: [
				"bone",
				"dead",
				"face",
				"death",
				"skull",
				"monster",
				"crossbones",
				"skull and crossbones"
			],
			u: "2620-fe0f",
			a: "1"
		},
		{
			n: [
				"bs",
				"doo",
				"fml",
				"poo",
				"smh",
				"dung",
				"face",
				"pile",
				"poop",
				"turd",
				"comic",
				"stink",
				"smelly",
				"stinks",
				"stinky",
				"monster",
				"pile of poo"
			],
			u: "1f4a9",
			a: "0.6"
		},
		{
			n: [
				"face",
				"clown",
				"clown face"
			],
			u: "1f921",
			a: "3"
		},
		{
			n: [
				"ogre",
				"face",
				"mask",
				"tale",
				"devil",
				"fairy",
				"scary",
				"fantasy",
				"monster",
				"creature",
				"fairytale"
			],
			u: "1f479",
			a: "0.6"
		},
		{
			n: [
				"face",
				"mask",
				"mean",
				"tale",
				"angry",
				"fairy",
				"goblin",
				"fantasy",
				"monster",
				"creature",
				"fairytale"
			],
			u: "1f47a",
			a: "0.6"
		},
		{
			n: [
				"boo",
				"face",
				"tale",
				"ghost",
				"fairy",
				"scary",
				"silly",
				"excited",
				"fantasy",
				"monster",
				"creature",
				"haunting",
				"fairytale",
				"halloween"
			],
			u: "1f47b",
			a: "0.6"
		},
		{
			n: [
				"ufo",
				"face",
				"tale",
				"alien",
				"fairy",
				"space",
				"fantasy",
				"monster",
				"creature",
				"fairytale",
				"extraterrestrial"
			],
			u: "1f47d",
			a: "0.6"
		},
		{
			n: [
				"ufo",
				"face",
				"game",
				"tale",
				"alien",
				"fairy",
				"gamer",
				"games",
				"space",
				"fantasy",
				"monster",
				"creature",
				"fairytale",
				"pixelated",
				"alien monster",
				"extraterrestrial"
			],
			u: "1f47e",
			a: "0.6"
		},
		{
			n: [
				"face",
				"robot",
				"monster"
			],
			u: "1f916",
			a: "1"
		},
		{
			n: [
				"cat",
				"face",
				"open",
				"mouth",
				"smile",
				"animal",
				"smiling",
				"grinning",
				"grinning cat"
			],
			u: "1f63a",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"eye",
				"eyes",
				"face",
				"grin",
				"smile",
				"animal",
				"smiling",
				"grinning",
				"grinning cat with smiling eyes"
			],
			u: "1f638",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"joy",
				"lol",
				"face",
				"tear",
				"laugh",
				"tears",
				"animal",
				"laughing",
				"cat with tears of joy"
			],
			u: "1f639",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"eye",
				"face",
				"love",
				"heart",
				"smile",
				"animal",
				"smiling",
				"heart eyes",
				"smiling cat with heart eyes"
			],
			u: "1f63b",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"wry",
				"face",
				"smile",
				"animal",
				"ironic",
				"cat with wry smile"
			],
			u: "1f63c",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"eye",
				"eyes",
				"face",
				"kiss",
				"animal",
				"closed",
				"kissing",
				"kissing cat"
			],
			u: "1f63d",
			a: "0.6"
		},
		{
			n: [
				"oh",
				"cat",
				"face",
				"weary",
				"animal",
				"weary cat",
				"surprised"
			],
			u: "1f640",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"cry",
				"sad",
				"face",
				"tear",
				"animal",
				"crying",
				"crying cat"
			],
			u: "1f63f",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"face",
				"animal",
				"pouting",
				"pouting cat"
			],
			u: "1f63e",
			a: "0.6"
		},
		{
			n: [
				"no",
				"omg",
				"smh",
				"evil",
				"face",
				"hide",
				"watch",
				"forgot",
				"monkey",
				"scared",
				"secret",
				"gesture",
				"forbidden",
				"prohibited",
				"embarrassed",
				"see no evil monkey"
			],
			u: "1f648",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"shh",
				"tmi",
				"ears",
				"evil",
				"face",
				"hear",
				"animal",
				"listen",
				"monkey",
				"secret",
				"gesture",
				"forbidden",
				"prohibited",
				"hear no evil monkey"
			],
			u: "1f649",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"evil",
				"face",
				"oops",
				"quiet",
				"speak",
				"animal",
				"monkey",
				"secret",
				"gesture",
				"stealth",
				"forbidden",
				"prohibited",
				"speak no evil monkey"
			],
			u: "1f64a",
			a: "0.6"
		},
		{
			n: [
				"love",
				"mail",
				"heart",
				"letter",
				"romance",
				"valentine",
				"love letter"
			],
			u: "1f48c",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"date",
				"love",
				"arrow",
				"cupid",
				"heart",
				"adorbs",
				"emotion",
				"romance",
				"valentine",
				"heart with arrow"
			],
			u: "1f498",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"xoxo",
				"heart",
				"kisses",
				"ribbon",
				"emotion",
				"valentine",
				"anniversary",
				"heart with ribbon"
			],
			u: "1f49d",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"good",
				"xoxo",
				"heart",
				"night",
				"kisses",
				"emotion",
				"excited",
				"morning",
				"sparkle",
				"sparkling",
				"sparkling heart"
			],
			u: "1f496",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"muah",
				"xoxo",
				"heart",
				"pulse",
				"kisses",
				"emotion",
				"excited",
				"growing",
				"nervous",
				"heartpulse",
				"growing heart"
			],
			u: "1f497",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"love",
				"heart",
				"pulse",
				"cardio",
				"beating",
				"emotion",
				"heartbeat",
				"pulsating",
				"beating heart"
			],
			u: "1f493",
			a: "0.6"
		},
		{
			n: [
				"143",
				"heart",
				"adorbs",
				"hearts",
				"emotion",
				"revolving",
				"anniversary",
				"revolving hearts"
			],
			u: "1f49e",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"two",
				"date",
				"love",
				"xoxo",
				"heart",
				"dating",
				"hearts",
				"kisses",
				"loving",
				"emotion",
				"two hearts",
				"anniversary"
			],
			u: "1f495",
			a: "0.6"
		},
		{
			n: [
				"143",
				"heart",
				"white",
				"hearth",
				"purple",
				"emotion",
				"decoration",
				"heart decoration"
			],
			u: "1f49f",
			a: "0.6"
		},
		{
			n: [
				"mark",
				"heart",
				"heavy",
				"exclamation",
				"punctuation",
				"heart exclamation"
			],
			u: "2763-fe0f",
			a: "1"
		},
		{
			n: [
				"sad",
				"break",
				"heart",
				"broken",
				"lonely",
				"crushed",
				"emotion",
				"heartbroken",
				"broken heart"
			],
			u: "1f494",
			a: "0.6"
		},
		{
			n: [
				"burn",
				"fire",
				"love",
				"lust",
				"heart",
				"sacred",
				"heart on fire"
			],
			u: "2764-fe0f-200d-1f525",
			a: "13.1"
		},
		{
			n: [
				"well",
				"heart",
				"mending",
				"healthier",
				"improving",
				"recovering",
				"recuperating",
				"mending heart"
			],
			u: "2764-fe0f-200d-1fa79",
			a: "13.1"
		},
		{
			n: [
				"red",
				"love",
				"heart",
				"emotion",
				"red heart"
			],
			u: "2764-fe0f",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"cute",
				"like",
				"love",
				"pink",
				"heart",
				"sweet",
				"emotion",
				"special",
				"adorable",
				"pink heart"
			],
			u: "1fa77",
			a: "15"
		},
		{
			n: [
				"143",
				"heart",
				"orange",
				"orange heart"
			],
			u: "1f9e1",
			a: "5"
		},
		{
			n: [
				"143",
				"ily",
				"love",
				"heart",
				"yellow",
				"cardiac",
				"emotion",
				"yellow heart"
			],
			u: "1f49b",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"love",
				"green",
				"heart",
				"emotion",
				"romantic",
				"green heart"
			],
			u: "1f49a",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"blue",
				"love",
				"heart",
				"emotion",
				"romance",
				"blue heart"
			],
			u: "1f499",
			a: "0.6"
		},
		{
			n: [
				"143",
				"ily",
				"sky",
				"blue",
				"cute",
				"cyan",
				"like",
				"love",
				"teal",
				"heart",
				"light",
				"emotion",
				"special",
				"light blue heart"
			],
			u: "1fa75",
			a: "15"
		},
		{
			n: [
				"143",
				"ily",
				"love",
				"heart",
				"purple",
				"bestest",
				"emotion",
				"purple heart"
			],
			u: "1f49c",
			a: "0.6"
		},
		{
			n: [
				"143",
				"brown",
				"heart",
				"brown heart"
			],
			u: "1f90e",
			a: "12"
		},
		{
			n: [
				"evil",
				"black",
				"heart",
				"wicked",
				"black heart"
			],
			u: "1f5a4",
			a: "3"
		},
		{
			n: [
				"143",
				"ily",
				"gray",
				"grey",
				"love",
				"heart",
				"slate",
				"silver",
				"emotion",
				"special",
				"grey heart"
			],
			u: "1fa76",
			a: "15"
		},
		{
			n: [
				"143",
				"heart",
				"white",
				"white heart"
			],
			u: "1f90d",
			a: "12"
		},
		{
			n: [
				"kiss",
				"lips",
				"mark",
				"sexy",
				"heart",
				"dating",
				"emotion",
				"kissing",
				"romance",
				"kiss mark"
			],
			u: "1f48b",
			a: "0.6"
		},
		{
			n: [
				"a+",
				"100",
				"yup",
				"full",
				"keep",
				"true",
				"agree",
				"fleek",
				"point",
				"score",
				"truth",
				"clearly",
				"hundred",
				"perfect",
				"faithful",
				"definitely",
				"hundred points"
			],
			u: "1f4af",
			a: "0.6"
		},
		{
			n: [
				"mad",
				"anger",
				"angry",
				"comic",
				"upset",
				"symbol",
				"anger symbol"
			],
			u: "1f4a2",
			a: "0.6"
		},
		{
			n: [
				"bomb",
				"boom",
				"comic",
				"collide",
				"explode",
				"collision"
			],
			u: "1f4a5",
			a: "0.6"
		},
		{
			n: [
				"star",
				"dizzy",
				"comic",
				"stars",
				"shining",
				"shooting"
			],
			u: "1f4ab",
			a: "0.6"
		},
		{
			n: [
				"wet",
				"drip",
				"work",
				"comic",
				"drops",
				"sweat",
				"water",
				"squirt",
				"droplet",
				"workout",
				"droplets",
				"splashing",
				"sweat droplets"
			],
			u: "1f4a6",
			a: "0.6"
		},
		{
			n: [
				"go",
				"away",
				"dash",
				"fart",
				"fast",
				"gone",
				"cloud",
				"comic",
				"gotta",
				"smoke",
				"dashing",
				"running",
				"dashing away"
			],
			u: "1f4a8",
			a: "0.6"
		},
		{
			n: [
				"hole"
			],
			u: "1f573-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sms",
				"talk",
				"text",
				"comic",
				"bubble",
				"dialog",
				"speech",
				"typing",
				"balloon",
				"message",
				"speech balloon"
			],
			u: "1f4ac",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"bubble",
				"speech",
				"balloon",
				"witness",
				"eye in speech bubble"
			],
			u: "1f441-fe0f-200d-1f5e8-fe0f",
			a: "2"
		},
		{
			n: [
				"left",
				"bubble",
				"dialog",
				"speech",
				"balloon",
				"left speech bubble"
			],
			u: "1f5e8-fe0f",
			a: "2"
		},
		{
			n: [
				"mad",
				"anger",
				"angry",
				"right",
				"bubble",
				"balloon",
				"right anger bubble"
			],
			u: "1f5ef-fe0f",
			a: "0.7"
		},
		{
			n: [
				"idea",
				"cloud",
				"comic",
				"dream",
				"think",
				"bubble",
				"invent",
				"wonder",
				"balloon",
				"cartoon",
				"realize",
				"daydream",
				"thoughts",
				"decisions",
				"invention",
				"thought balloon"
			],
			u: "1f4ad",
			a: "1"
		},
		{
			n: [
				"ZZZ",
				"zzz",
				"good",
				"comic",
				"night",
				"sleep",
				"tired",
				"sleepy",
				"sleeping",
				"goodnight"
			],
			u: "1f4a4",
			a: "0.6"
		},
		{
			n: [
				"hi",
				"yo",
				"bye",
				"cya",
				"g2g",
				"gtg",
				"hey",
				"you",
				"hand",
				"ttfn",
				"ttyl",
				"wave",
				"hello",
				"later",
				"outtie",
				"greetings",
				"waving hand"
			],
			u: "1f44b",
			v: [
				"1f44b-1f3fb",
				"1f44b-1f3fc",
				"1f44b-1f3fd",
				"1f44b-1f3fe",
				"1f44b-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"back",
				"hand",
				"raised",
				"backhand",
				"raised back of hand"
			],
			u: "1f91a",
			v: [
				"1f91a-1f3fb",
				"1f91a-1f3fc",
				"1f91a-1f3fd",
				"1f91a-1f3fe",
				"1f91a-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"hand",
				"stop",
				"finger",
				"raised",
				"fingers",
				"splayed",
				"hand with fingers splayed"
			],
			u: "1f590-fe0f",
			v: [
				"1f590-1f3fb",
				"1f590-1f3fc",
				"1f590-1f3fd",
				"1f590-1f3fe",
				"1f590-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"5",
				"five",
				"hand",
				"high",
				"stop",
				"raised",
				"raised hand"
			],
			u: "270b",
			v: [
				"270b-1f3fb",
				"270b-1f3fc",
				"270b-1f3fd",
				"270b-1f3fe",
				"270b-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"hands",
				"finger",
				"salute",
				"vulcan",
				"vulcan salute"
			],
			u: "1f596",
			v: [
				"1f596-1f3fb",
				"1f596-1f3fc",
				"1f596-1f3fd",
				"1f596-1f3fe",
				"1f596-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"hand",
				"hold",
				"reach",
				"right",
				"shake",
				"handshake",
				"rightward",
				"rightwards",
				"rightwards hand"
			],
			u: "1faf1",
			v: [
				"1faf1-1f3fb",
				"1faf1-1f3fc",
				"1faf1-1f3fd",
				"1faf1-1f3fe",
				"1faf1-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"hand",
				"hold",
				"left",
				"reach",
				"shake",
				"leftward",
				"handshake",
				"leftwards",
				"leftwards hand"
			],
			u: "1faf2",
			v: [
				"1faf2-1f3fb",
				"1faf2-1f3fc",
				"1faf2-1f3fd",
				"1faf2-1f3fe",
				"1faf2-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"up",
				"down",
				"drop",
				"hand",
				"palm",
				"pick",
				"shoo",
				"dismiss",
				"dropped",
				"palm down hand"
			],
			u: "1faf3",
			v: [
				"1faf3-1f3fb",
				"1faf3-1f3fc",
				"1faf3-1f3fd",
				"1faf3-1f3fe",
				"1faf3-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"me",
				"come",
				"hand",
				"hold",
				"know",
				"lift",
				"palm",
				"tell",
				"catch",
				"offer",
				"beckon",
				"palm up hand"
			],
			u: "1faf4",
			v: [
				"1faf4-1f3fb",
				"1faf4-1f3fc",
				"1faf4-1f3fd",
				"1faf4-1f3fe",
				"1faf4-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"five",
				"halt",
				"hand",
				"high",
				"hold",
				"push",
				"slap",
				"stop",
				"wait",
				"block",
				"pause",
				"refuse",
				"pushing",
				"leftward",
				"leftwards",
				"leftwards pushing hand"
			],
			u: "1faf7",
			v: [
				"1faf7-1f3fb",
				"1faf7-1f3fc",
				"1faf7-1f3fd",
				"1faf7-1f3fe",
				"1faf7-1f3ff"
			],
			a: "15"
		},
		{
			n: [
				"five",
				"halt",
				"hand",
				"high",
				"hold",
				"push",
				"slap",
				"stop",
				"wait",
				"block",
				"pause",
				"refuse",
				"pushing",
				"rightward",
				"rightwards",
				"rightwards pushing hand"
			],
			u: "1faf8",
			v: [
				"1faf8-1f3fb",
				"1faf8-1f3fc",
				"1faf8-1f3fd",
				"1faf8-1f3fe",
				"1faf8-1f3ff"
			],
			a: "15"
		},
		{
			n: [
				"ok",
				"bet",
				"got",
				"rad",
				"dope",
				"hand",
				"okay",
				"sure",
				"fleek",
				"fosho",
				"legit",
				"pinch",
				"sweet",
				"three",
				"gotcha",
				"OK hand",
				"awesome"
			],
			u: "1f44c",
			v: [
				"1f44c-1f3fb",
				"1f44c-1f3fc",
				"1f44c-1f3fd",
				"1f44c-1f3fe",
				"1f44c-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"huh",
				"ugh",
				"zip",
				"hand",
				"hold",
				"what",
				"relax",
				"fingers",
				"gesture",
				"pinched",
				"patience",
				"sarcastic",
				"interrogation",
				"pinched fingers"
			],
			u: "1f90c",
			v: [
				"1f90c-1f3fb",
				"1f90c-1f3fc",
				"1f90c-1f3fd",
				"1f90c-1f3fe",
				"1f90c-1f3ff"
			],
			a: "13"
		},
		{
			n: [
				"bit",
				"hand",
				"sort",
				"small",
				"amount",
				"little",
				"fingers",
				"pinching",
				"pinching hand"
			],
			u: "1f90f",
			v: [
				"1f90f-1f3fb",
				"1f90f-1f3fc",
				"1f90f-1f3fd",
				"1f90f-1f3fe",
				"1f90f-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"v",
				"hand",
				"peace",
				"victory",
				"victory hand"
			],
			u: "270c-fe0f",
			v: [
				"270c-1f3fb",
				"270c-1f3fc",
				"270c-1f3fd",
				"270c-1f3fe",
				"270c-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"luck",
				"cross",
				"finger",
				"crossed",
				"fingers",
				"crossed fingers"
			],
			u: "1f91e",
			v: [
				"1f91e-1f3fb",
				"1f91e-1f3fc",
				"1f91e-1f3fd",
				"1f91e-1f3fe",
				"1f91e-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"<3",
				"hand",
				"love",
				"snap",
				"heart",
				"index",
				"money",
				"thumb",
				"finger",
				"crossed",
				"expensive",
				"hand with index finger and thumb crossed"
			],
			u: "1faf0",
			v: [
				"1faf0-1f3fb",
				"1faf0-1f3fc",
				"1faf0-1f3fd",
				"1faf0-1f3fe",
				"1faf0-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"ily",
				"you",
				"hand",
				"love",
				"three",
				"fingers",
				"gesture",
				"love you",
				"love you gesture"
			],
			u: "1f91f",
			v: [
				"1f91f-1f3fb",
				"1f91f-1f3fc",
				"1f91f-1f3fd",
				"1f91f-1f3fe",
				"1f91f-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"hand",
				"sign",
				"horns",
				"finger",
				"rock on",
				"sign of the horns"
			],
			u: "1f918",
			v: [
				"1f918-1f3fb",
				"1f918-1f3fc",
				"1f918-1f3fd",
				"1f918-1f3fe",
				"1f918-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"me",
				"call",
				"hand",
				"hang",
				"loose",
				"shaka",
				"call me hand"
			],
			u: "1f919",
			v: [
				"1f919-1f3fb",
				"1f919-1f3fc",
				"1f919-1f3fd",
				"1f919-1f3fe",
				"1f919-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"hand",
				"left",
				"index",
				"point",
				"finger",
				"backhand",
				"pointing",
				"backhand index pointing left"
			],
			u: "1f448",
			v: [
				"1f448-1f3fb",
				"1f448-1f3fc",
				"1f448-1f3fd",
				"1f448-1f3fe",
				"1f448-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"index",
				"point",
				"right",
				"finger",
				"backhand",
				"pointing",
				"backhand index pointing right"
			],
			u: "1f449",
			v: [
				"1f449-1f3fb",
				"1f449-1f3fc",
				"1f449-1f3fd",
				"1f449-1f3fe",
				"1f449-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"up",
				"hand",
				"index",
				"point",
				"finger",
				"backhand",
				"pointing",
				"backhand index pointing up"
			],
			u: "1f446",
			v: [
				"1f446-1f3fb",
				"1f446-1f3fc",
				"1f446-1f3fd",
				"1f446-1f3fe",
				"1f446-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"finger",
				"middle",
				"middle finger"
			],
			u: "1f595",
			v: [
				"1f595-1f3fb",
				"1f595-1f3fc",
				"1f595-1f3fd",
				"1f595-1f3fe",
				"1f595-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"down",
				"hand",
				"index",
				"point",
				"finger",
				"backhand",
				"pointing",
				"backhand index pointing down"
			],
			u: "1f447",
			v: [
				"1f447-1f3fb",
				"1f447-1f3fc",
				"1f447-1f3fd",
				"1f447-1f3fe",
				"1f447-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"up",
				"hand",
				"this",
				"index",
				"point",
				"finger",
				"pointing",
				"index pointing up"
			],
			u: "261d-fe0f",
			v: [
				"261d-1f3fb",
				"261d-1f3fc",
				"261d-1f3fd",
				"261d-1f3fe",
				"261d-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"at",
				"you",
				"hand",
				"poke",
				"index",
				"finger",
				"viewer",
				"pointing",
				"index pointing at the viewer"
			],
			u: "1faf5",
			v: [
				"1faf5-1f3fb",
				"1faf5-1f3fc",
				"1faf5-1f3fd",
				"1faf5-1f3fe",
				"1faf5-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"+1",
				"up",
				"yes",
				"good",
				"hand",
				"like",
				"thumb",
				"thumbs up"
			],
			u: "1f44d",
			v: [
				"1f44d-1f3fb",
				"1f44d-1f3fc",
				"1f44d-1f3fd",
				"1f44d-1f3fe",
				"1f44d-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				" 1",
				"no",
				"bad",
				"down",
				"good",
				"hand",
				"nope",
				"thumb",
				"thumbs",
				"dislike",
				"thumbs down"
			],
			u: "1f44e",
			v: [
				"1f44e-1f3fb",
				"1f44e-1f3fc",
				"1f44e-1f3fd",
				"1f44e-1f3fe",
				"1f44e-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"fist",
				"hand",
				"punch",
				"raised",
				"clenched",
				"solidarity",
				"raised fist"
			],
			u: "270a",
			v: [
				"270a-1f3fb",
				"270a-1f3fc",
				"270a-1f3fd",
				"270a-1f3fe",
				"270a-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"bro",
				"boom",
				"bruh",
				"bump",
				"fist",
				"hand",
				"rock",
				"ttyl",
				"agree",
				"pound",
				"punch",
				"correct",
				"knuckle",
				"clenched",
				"oncoming",
				"absolutely",
				"oncoming fist"
			],
			u: "1f44a",
			v: [
				"1f44a-1f3fb",
				"1f44a-1f3fc",
				"1f44a-1f3fd",
				"1f44a-1f3fe",
				"1f44a-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"fist",
				"leftwards",
				"left facing",
				"left facing fist"
			],
			u: "1f91b",
			v: [
				"1f91b-1f3fb",
				"1f91b-1f3fc",
				"1f91b-1f3fd",
				"1f91b-1f3fe",
				"1f91b-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"fist",
				"rightwards",
				"right facing",
				"right facing fist"
			],
			u: "1f91c",
			v: [
				"1f91c-1f3fb",
				"1f91c-1f3fc",
				"1f91c-1f3fd",
				"1f91c-1f3fe",
				"1f91c-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"job",
				"yay",
				"clap",
				"good",
				"hand",
				"nice",
				"well",
				"great",
				"homie",
				"prayed",
				"awesome",
				"excited",
				"applause",
				"approval",
				"congrats",
				"clapping hands",
				"congratulations"
			],
			u: "1f44f",
			v: [
				"1f44f-1f3fb",
				"1f44f-1f3fc",
				"1f44f-1f3fd",
				"1f44f-1f3fe",
				"1f44f-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"hands",
				"hooray",
				"praise",
				"raised",
				"gesture",
				"raising",
				"celebration",
				"raising hands"
			],
			u: "1f64c",
			v: [
				"1f64c-1f3fb",
				"1f64c-1f3fc",
				"1f64c-1f3fd",
				"1f64c-1f3fe",
				"1f64c-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"<3",
				"you",
				"love",
				"hands",
				"heart",
				"heart hands"
			],
			u: "1faf6",
			v: [
				"1faf6-1f3fb",
				"1faf6-1f3fc",
				"1faf6-1f3fd",
				"1faf6-1f3fe",
				"1faf6-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"hug",
				"hand",
				"jazz",
				"open",
				"hands",
				"swerve",
				"open hands"
			],
			u: "1f450",
			v: [
				"1f450-1f3fb",
				"1f450-1f3fc",
				"1f450-1f3fd",
				"1f450-1f3fe",
				"1f450-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"up",
				"dua",
				"pray",
				"wish",
				"hands",
				"palms",
				"cupped",
				"prayer",
				"together",
				"palms up together"
			],
			u: "1f932",
			v: [
				"1f932-1f3fb",
				"1f932-1f3fc",
				"1f932-1f3fd",
				"1f932-1f3fe",
				"1f932-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"deal",
				"hand",
				"shake",
				"meeting",
				"handshake",
				"agreement"
			],
			u: "1f91d",
			v: [
				"1f91d-1f3fb",
				"1f91d-1f3fc",
				"1f91d-1f3fd",
				"1f91d-1f3fe",
				"1f91d-1f3ff",
				"1faf1-1f3fb-200d-1faf2-1f3fc",
				"1faf1-1f3fb-200d-1faf2-1f3fd",
				"1faf1-1f3fb-200d-1faf2-1f3fe",
				"1faf1-1f3fb-200d-1faf2-1f3ff",
				"1faf1-1f3fc-200d-1faf2-1f3fb",
				"1faf1-1f3fc-200d-1faf2-1f3fd",
				"1faf1-1f3fc-200d-1faf2-1f3fe",
				"1faf1-1f3fc-200d-1faf2-1f3ff",
				"1faf1-1f3fd-200d-1faf2-1f3fb",
				"1faf1-1f3fd-200d-1faf2-1f3fc",
				"1faf1-1f3fd-200d-1faf2-1f3fe",
				"1faf1-1f3fd-200d-1faf2-1f3ff",
				"1faf1-1f3fe-200d-1faf2-1f3fb",
				"1faf1-1f3fe-200d-1faf2-1f3fc",
				"1faf1-1f3fe-200d-1faf2-1f3fd",
				"1faf1-1f3fe-200d-1faf2-1f3ff",
				"1faf1-1f3ff-200d-1faf2-1f3fb",
				"1faf1-1f3ff-200d-1faf2-1f3fc",
				"1faf1-1f3ff-200d-1faf2-1f3fd",
				"1faf1-1f3ff-200d-1faf2-1f3fe"
			],
			a: "3"
		},
		{
			n: [
				"ask",
				"beg",
				"bow",
				"thx",
				"cmon",
				"five",
				"hand",
				"high",
				"pray",
				"folded",
				"please",
				"thanks",
				"blessed",
				"gesture",
				"appreciate",
				"folded hands"
			],
			u: "1f64f",
			v: [
				"1f64f-1f3fb",
				"1f64f-1f3fc",
				"1f64f-1f3fd",
				"1f64f-1f3fe",
				"1f64f-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"hand",
				"write",
				"writing",
				"writing hand"
			],
			u: "270d-fe0f",
			v: [
				"270d-1f3fb",
				"270d-1f3fc",
				"270d-1f3fd",
				"270d-1f3fe",
				"270d-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"care",
				"done",
				"nail",
				"bored",
				"makeup",
				"polish",
				"manicure",
				"whatever",
				"cosmetics",
				"nail polish"
			],
			u: "1f485",
			v: [
				"1f485-1f3fb",
				"1f485-1f3fc",
				"1f485-1f3fd",
				"1f485-1f3fe",
				"1f485-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"phone",
				"selfie",
				"camera"
			],
			u: "1f933",
			v: [
				"1f933-1f3fb",
				"1f933-1f3fc",
				"1f933-1f3fd",
				"1f933-1f3fe",
				"1f933-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"arm",
				"bro",
				"gym",
				"flex",
				"beast",
				"bench",
				"curls",
				"gains",
				"press",
				"biceps",
				"jacked",
				"muscle",
				"ripped",
				"strong",
				"weightlift",
				"bodybuilder",
				"flexed biceps"
			],
			u: "1f4aa",
			v: [
				"1f4aa-1f3fb",
				"1f4aa-1f3fc",
				"1f4aa-1f3fd",
				"1f4aa-1f3fe",
				"1f4aa-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"arm",
				"mechanical",
				"prosthetic",
				"accessibility",
				"mechanical arm"
			],
			u: "1f9be",
			a: "12"
		},
		{
			n: [
				"leg",
				"mechanical",
				"prosthetic",
				"accessibility",
				"mechanical leg"
			],
			u: "1f9bf",
			a: "12"
		},
		{
			n: [
				"leg",
				"bent",
				"foot",
				"kick",
				"knee",
				"limb"
			],
			u: "1f9b5",
			v: [
				"1f9b5-1f3fb",
				"1f9b5-1f3fc",
				"1f9b5-1f3fd",
				"1f9b5-1f3fe",
				"1f9b5-1f3ff"
			],
			a: "11"
		},
		{
			n: [
				"foot",
				"feet",
				"kick",
				"ankle",
				"stomp"
			],
			u: "1f9b6",
			v: [
				"1f9b6-1f3fb",
				"1f9b6-1f3fc",
				"1f9b6-1f3fd",
				"1f9b6-1f3fe",
				"1f9b6-1f3ff"
			],
			a: "11"
		},
		{
			n: [
				"ear",
				"body",
				"ears",
				"hear",
				"sound",
				"listen",
				"hearing",
				"listening"
			],
			u: "1f442",
			v: [
				"1f442-1f3fb",
				"1f442-1f3fc",
				"1f442-1f3fd",
				"1f442-1f3fe",
				"1f442-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"aid",
				"ear",
				"hard",
				"hearing",
				"accessibility",
				"ear with hearing aid"
			],
			u: "1f9bb",
			v: [
				"1f9bb-1f3fb",
				"1f9bb-1f3fc",
				"1f9bb-1f3fd",
				"1f9bb-1f3fe",
				"1f9bb-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"nose",
				"body",
				"odor",
				"noses",
				"nosey",
				"smell",
				"smells"
			],
			u: "1f443",
			v: [
				"1f443-1f3fb",
				"1f443-1f3fc",
				"1f443-1f3fd",
				"1f443-1f3fe",
				"1f443-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"brain",
				"smart",
				"intelligent"
			],
			u: "1f9e0",
			a: "5"
		},
		{
			n: [
				"red",
				"beat",
				"real",
				"heart",
				"organ",
				"pulse",
				"heartbeat",
				"anatomical",
				"cardiology",
				"anatomical heart"
			],
			u: "1fac0",
			a: "13"
		},
		{
			n: [
				"lung",
				"lungs",
				"organ",
				"breath",
				"breathe",
				"exhalation",
				"inhalation",
				"respiration"
			],
			u: "1fac1",
			a: "13"
		},
		{
			n: [
				"tooth",
				"teeth",
				"white",
				"pearly",
				"dentist"
			],
			u: "1f9b7",
			a: "11"
		},
		{
			n: [
				"dog",
				"bone",
				"bones",
				"skeleton",
				"wishbone"
			],
			u: "1f9b4",
			a: "11"
		},
		{
			n: [
				"eye",
				"omg",
				"see",
				"eyes",
				"body",
				"face",
				"look",
				"peep",
				"googly",
				"seeing",
				"looking"
			],
			u: "1f440",
			a: "0.6"
		},
		{
			n: [
				"1",
				"eye",
				"one",
				"body"
			],
			u: "1f441-fe0f",
			a: "0.7"
		},
		{
			n: [
				"body",
				"lick",
				"slurp",
				"tongue"
			],
			u: "1f445",
			a: "0.6"
		},
		{
			n: [
				"body",
				"kiss",
				"lips",
				"mouth",
				"beauty",
				"kissing",
				"lipstick"
			],
			u: "1f444",
			a: "0.6"
		},
		{
			n: [
				"lip",
				"bite",
				"fear",
				"kiss",
				"sexy",
				"flirt",
				"worry",
				"biting",
				"anxious",
				"nervous",
				"worried",
				"flirting",
				"lipstick",
				"biting lip",
				"uncomfortable"
			],
			u: "1fae6",
			a: "14"
		},
		{
			n: [
				"goo",
				"baby",
				"young",
				"babies",
				"infant",
				"newborn",
				"children",
				"pregnant"
			],
			u: "1f476",
			v: [
				"1f476-1f3fb",
				"1f476-1f3fc",
				"1f476-1f3fd",
				"1f476-1f3fe",
				"1f476-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"kid",
				"child",
				"young",
				"younger",
				"grandchild",
				"bright eyed"
			],
			u: "1f9d2",
			v: [
				"1f9d2-1f3fb",
				"1f9d2-1f3fc",
				"1f9d2-1f3fd",
				"1f9d2-1f3fe",
				"1f9d2-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"boy",
				"kid",
				"son",
				"child",
				"young",
				"younger",
				"grandson",
				"bright eyed"
			],
			u: "1f466",
			v: [
				"1f466-1f3fb",
				"1f466-1f3fc",
				"1f466-1f3fd",
				"1f466-1f3fe",
				"1f466-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"kid",
				"girl",
				"child",
				"virgo",
				"young",
				"zodiac",
				"younger",
				"daughter",
				"bright eyed",
				"granddaughter"
			],
			u: "1f467",
			v: [
				"1f467-1f3fb",
				"1f467-1f3fc",
				"1f467-1f3fd",
				"1f467-1f3fe",
				"1f467-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"adult",
				"person"
			],
			u: "1f9d1",
			v: [
				"1f9d1-1f3fb",
				"1f9d1-1f3fc",
				"1f9d1-1f3fd",
				"1f9d1-1f3fe",
				"1f9d1-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"blond",
				"human",
				"person",
				"blond haired",
				"person: blond hair"
			],
			u: "1f471",
			v: [
				"1f471-1f3fb",
				"1f471-1f3fc",
				"1f471-1f3fd",
				"1f471-1f3fe",
				"1f471-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"bro",
				"adult"
			],
			u: "1f468",
			v: [
				"1f468-1f3fb",
				"1f468-1f3fc",
				"1f468-1f3fd",
				"1f468-1f3fe",
				"1f468-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"beard",
				"person",
				"bearded",
				"whiskers",
				"person: beard"
			],
			u: "1f9d4",
			v: [
				"1f9d4-1f3fb",
				"1f9d4-1f3fc",
				"1f9d4-1f3fd",
				"1f9d4-1f3fe",
				"1f9d4-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"beard",
				"bearded",
				"whiskers",
				"man: beard"
			],
			u: "1f9d4-200d-2642-fe0f",
			v: [
				"1f9d4-1f3fb-200d-2642-fe0f",
				"1f9d4-1f3fc-200d-2642-fe0f",
				"1f9d4-1f3fd-200d-2642-fe0f",
				"1f9d4-1f3fe-200d-2642-fe0f",
				"1f9d4-1f3ff-200d-2642-fe0f"
			],
			a: "13.1"
		},
		{
			n: [
				"beard",
				"woman",
				"bearded",
				"whiskers",
				"woman: beard"
			],
			u: "1f9d4-200d-2640-fe0f",
			v: [
				"1f9d4-1f3fb-200d-2640-fe0f",
				"1f9d4-1f3fc-200d-2640-fe0f",
				"1f9d4-1f3fd-200d-2640-fe0f",
				"1f9d4-1f3fe-200d-2640-fe0f",
				"1f9d4-1f3ff-200d-2640-fe0f"
			],
			a: "13.1"
		},
		{
			n: [
				"bro",
				"man",
				"adult",
				"red hair",
				"man: red hair"
			],
			u: "1f468-200d-1f9b0",
			v: [
				"1f468-1f3fb-200d-1f9b0",
				"1f468-1f3fc-200d-1f9b0",
				"1f468-1f3fd-200d-1f9b0",
				"1f468-1f3fe-200d-1f9b0",
				"1f468-1f3ff-200d-1f9b0"
			],
			a: "11"
		},
		{
			n: [
				"bro",
				"man",
				"adult",
				"curly hair",
				"man: curly hair"
			],
			u: "1f468-200d-1f9b1",
			v: [
				"1f468-1f3fb-200d-1f9b1",
				"1f468-1f3fc-200d-1f9b1",
				"1f468-1f3fd-200d-1f9b1",
				"1f468-1f3fe-200d-1f9b1",
				"1f468-1f3ff-200d-1f9b1"
			],
			a: "11"
		},
		{
			n: [
				"bro",
				"man",
				"adult",
				"white hair",
				"man: white hair"
			],
			u: "1f468-200d-1f9b3",
			v: [
				"1f468-1f3fb-200d-1f9b3",
				"1f468-1f3fc-200d-1f9b3",
				"1f468-1f3fd-200d-1f9b3",
				"1f468-1f3fe-200d-1f9b3",
				"1f468-1f3ff-200d-1f9b3"
			],
			a: "11"
		},
		{
			n: [
				"bro",
				"man",
				"bald",
				"adult",
				"man: bald"
			],
			u: "1f468-200d-1f9b2",
			v: [
				"1f468-1f3fb-200d-1f9b2",
				"1f468-1f3fc-200d-1f9b2",
				"1f468-1f3fd-200d-1f9b2",
				"1f468-1f3fe-200d-1f9b2",
				"1f468-1f3ff-200d-1f9b2"
			],
			a: "11"
		},
		{
			n: [
				"lady",
				"woman",
				"adult"
			],
			u: "1f469",
			v: [
				"1f469-1f3fb",
				"1f469-1f3fc",
				"1f469-1f3fd",
				"1f469-1f3fe",
				"1f469-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"lady",
				"adult",
				"woman",
				"red hair",
				"woman: red hair"
			],
			u: "1f469-200d-1f9b0",
			v: [
				"1f469-1f3fb-200d-1f9b0",
				"1f469-1f3fc-200d-1f9b0",
				"1f469-1f3fd-200d-1f9b0",
				"1f469-1f3fe-200d-1f9b0",
				"1f469-1f3ff-200d-1f9b0"
			],
			a: "11"
		},
		{
			n: [
				"adult",
				"person",
				"red hair",
				"person: red hair"
			],
			u: "1f9d1-200d-1f9b0",
			v: [
				"1f9d1-1f3fb-200d-1f9b0",
				"1f9d1-1f3fc-200d-1f9b0",
				"1f9d1-1f3fd-200d-1f9b0",
				"1f9d1-1f3fe-200d-1f9b0",
				"1f9d1-1f3ff-200d-1f9b0"
			],
			a: "12.1"
		},
		{
			n: [
				"lady",
				"adult",
				"woman",
				"curly hair",
				"woman: curly hair"
			],
			u: "1f469-200d-1f9b1",
			v: [
				"1f469-1f3fb-200d-1f9b1",
				"1f469-1f3fc-200d-1f9b1",
				"1f469-1f3fd-200d-1f9b1",
				"1f469-1f3fe-200d-1f9b1",
				"1f469-1f3ff-200d-1f9b1"
			],
			a: "11"
		},
		{
			n: [
				"adult",
				"person",
				"curly hair",
				"person: curly hair"
			],
			u: "1f9d1-200d-1f9b1",
			v: [
				"1f9d1-1f3fb-200d-1f9b1",
				"1f9d1-1f3fc-200d-1f9b1",
				"1f9d1-1f3fd-200d-1f9b1",
				"1f9d1-1f3fe-200d-1f9b1",
				"1f9d1-1f3ff-200d-1f9b1"
			],
			a: "12.1"
		},
		{
			n: [
				"lady",
				"adult",
				"woman",
				"white hair",
				"woman: white hair"
			],
			u: "1f469-200d-1f9b3",
			v: [
				"1f469-1f3fb-200d-1f9b3",
				"1f469-1f3fc-200d-1f9b3",
				"1f469-1f3fd-200d-1f9b3",
				"1f469-1f3fe-200d-1f9b3",
				"1f469-1f3ff-200d-1f9b3"
			],
			a: "11"
		},
		{
			n: [
				"adult",
				"person",
				"white hair",
				"person: white hair"
			],
			u: "1f9d1-200d-1f9b3",
			v: [
				"1f9d1-1f3fb-200d-1f9b3",
				"1f9d1-1f3fc-200d-1f9b3",
				"1f9d1-1f3fd-200d-1f9b3",
				"1f9d1-1f3fe-200d-1f9b3",
				"1f9d1-1f3ff-200d-1f9b3"
			],
			a: "12.1"
		},
		{
			n: [
				"bald",
				"lady",
				"adult",
				"woman",
				"woman: bald"
			],
			u: "1f469-200d-1f9b2",
			v: [
				"1f469-1f3fb-200d-1f9b2",
				"1f469-1f3fc-200d-1f9b2",
				"1f469-1f3fd-200d-1f9b2",
				"1f469-1f3fe-200d-1f9b2",
				"1f469-1f3ff-200d-1f9b2"
			],
			a: "11"
		},
		{
			n: [
				"bald",
				"adult",
				"person",
				"person: bald"
			],
			u: "1f9d1-200d-1f9b2",
			v: [
				"1f9d1-1f3fb-200d-1f9b2",
				"1f9d1-1f3fc-200d-1f9b2",
				"1f9d1-1f3fd-200d-1f9b2",
				"1f9d1-1f3fe-200d-1f9b2",
				"1f9d1-1f3ff-200d-1f9b2"
			],
			a: "12.1"
		},
		{
			n: [
				"hair",
				"blond",
				"woman",
				"blonde",
				"blond haired",
				"woman: blond hair"
			],
			u: "1f471-200d-2640-fe0f",
			v: [
				"1f471-1f3fb-200d-2640-fe0f",
				"1f471-1f3fc-200d-2640-fe0f",
				"1f471-1f3fd-200d-2640-fe0f",
				"1f471-1f3fe-200d-2640-fe0f",
				"1f471-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"man",
				"hair",
				"blond",
				"blond haired",
				"man: blond hair"
			],
			u: "1f471-200d-2642-fe0f",
			v: [
				"1f471-1f3fb-200d-2642-fe0f",
				"1f471-1f3fc-200d-2642-fe0f",
				"1f471-1f3fd-200d-2642-fe0f",
				"1f471-1f3fe-200d-2642-fe0f",
				"1f471-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"old",
				"wise",
				"adult",
				"person",
				"elderly",
				"grandparent",
				"older person"
			],
			u: "1f9d3",
			v: [
				"1f9d3-1f3fb",
				"1f9d3-1f3fc",
				"1f9d3-1f3fd",
				"1f9d3-1f3fe",
				"1f9d3-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"old",
				"bald",
				"wise",
				"adult",
				"gramps",
				"old man",
				"elderly",
				"grandpa",
				"grandfather"
			],
			u: "1f474",
			v: [
				"1f474-1f3fb",
				"1f474-1f3fc",
				"1f474-1f3fd",
				"1f474-1f3fe",
				"1f474-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"old",
				"lady",
				"wise",
				"adult",
				"woman",
				"granny",
				"elderly",
				"grandma",
				"old woman",
				"grandmother"
			],
			u: "1f475",
			v: [
				"1f475-1f3fb",
				"1f475-1f3fc",
				"1f475-1f3fd",
				"1f475-1f3fe",
				"1f475-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"frown",
				"upset",
				"person",
				"annoyed",
				"gesture",
				"frowning",
				"disturbed",
				"irritated",
				"frustrated",
				"disgruntled",
				"disappointed",
				"person frowning"
			],
			u: "1f64d",
			v: [
				"1f64d-1f3fb",
				"1f64d-1f3fc",
				"1f64d-1f3fd",
				"1f64d-1f3fe",
				"1f64d-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"frown",
				"upset",
				"annoyed",
				"gesture",
				"frowning",
				"disturbed",
				"irritated",
				"frustrated",
				"disgruntled",
				"man frowning",
				"disappointed"
			],
			u: "1f64d-200d-2642-fe0f",
			v: [
				"1f64d-1f3fb-200d-2642-fe0f",
				"1f64d-1f3fc-200d-2642-fe0f",
				"1f64d-1f3fd-200d-2642-fe0f",
				"1f64d-1f3fe-200d-2642-fe0f",
				"1f64d-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"frown",
				"upset",
				"woman",
				"annoyed",
				"gesture",
				"frowning",
				"disturbed",
				"irritated",
				"frustrated",
				"disgruntled",
				"disappointed",
				"woman frowning"
			],
			u: "1f64d-200d-2640-fe0f",
			v: [
				"1f64d-1f3fb-200d-2640-fe0f",
				"1f64d-1f3fc-200d-2640-fe0f",
				"1f64d-1f3fd-200d-2640-fe0f",
				"1f64d-1f3fe-200d-2640-fe0f",
				"1f64d-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"sulk",
				"frown",
				"scowl",
				"upset",
				"whine",
				"person",
				"grimace",
				"pouting",
				"downtrodden",
				"disappointed",
				"person pouting"
			],
			u: "1f64e",
			v: [
				"1f64e-1f3fb",
				"1f64e-1f3fc",
				"1f64e-1f3fd",
				"1f64e-1f3fe",
				"1f64e-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"sulk",
				"frown",
				"scowl",
				"upset",
				"whine",
				"grimace",
				"pouting",
				"man pouting",
				"downtrodden",
				"disappointed"
			],
			u: "1f64e-200d-2642-fe0f",
			v: [
				"1f64e-1f3fb-200d-2642-fe0f",
				"1f64e-1f3fc-200d-2642-fe0f",
				"1f64e-1f3fd-200d-2642-fe0f",
				"1f64e-1f3fe-200d-2642-fe0f",
				"1f64e-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"sulk",
				"frown",
				"scowl",
				"upset",
				"whine",
				"woman",
				"grimace",
				"pouting",
				"downtrodden",
				"disappointed",
				"woman pouting"
			],
			u: "1f64e-200d-2640-fe0f",
			v: [
				"1f64e-1f3fb-200d-2640-fe0f",
				"1f64e-1f3fc-200d-2640-fe0f",
				"1f64e-1f3fd-200d-2640-fe0f",
				"1f64e-1f3fe-200d-2640-fe0f",
				"1f64e-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"no",
				"not",
				"hand",
				"person",
				"gesture",
				"prohibit",
				"forbidden",
				"person gesturing NO"
			],
			u: "1f645",
			v: [
				"1f645-1f3fb",
				"1f645-1f3fc",
				"1f645-1f3fd",
				"1f645-1f3fe",
				"1f645-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"no",
				"man",
				"not",
				"hand",
				"gesture",
				"prohibit",
				"forbidden",
				"man gesturing NO"
			],
			u: "1f645-200d-2642-fe0f",
			v: [
				"1f645-1f3fb-200d-2642-fe0f",
				"1f645-1f3fc-200d-2642-fe0f",
				"1f645-1f3fd-200d-2642-fe0f",
				"1f645-1f3fe-200d-2642-fe0f",
				"1f645-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"no",
				"not",
				"hand",
				"woman",
				"gesture",
				"prohibit",
				"forbidden",
				"woman gesturing NO"
			],
			u: "1f645-200d-2640-fe0f",
			v: [
				"1f645-1f3fb-200d-2640-fe0f",
				"1f645-1f3fc-200d-2640-fe0f",
				"1f645-1f3fd-200d-2640-fe0f",
				"1f645-1f3fe-200d-2640-fe0f",
				"1f645-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"ok",
				"omg",
				"hand",
				"person",
				"gesture",
				"exercise",
				"gesturing",
				"person gesturing OK"
			],
			u: "1f646",
			v: [
				"1f646-1f3fb",
				"1f646-1f3fc",
				"1f646-1f3fd",
				"1f646-1f3fe",
				"1f646-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"ok",
				"man",
				"omg",
				"hand",
				"gesture",
				"exercise",
				"gesturing",
				"man gesturing OK"
			],
			u: "1f646-200d-2642-fe0f",
			v: [
				"1f646-1f3fb-200d-2642-fe0f",
				"1f646-1f3fc-200d-2642-fe0f",
				"1f646-1f3fd-200d-2642-fe0f",
				"1f646-1f3fe-200d-2642-fe0f",
				"1f646-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"ok",
				"omg",
				"hand",
				"woman",
				"gesture",
				"exercise",
				"gesturing",
				"woman gesturing OK"
			],
			u: "1f646-200d-2640-fe0f",
			v: [
				"1f646-1f3fb-200d-2640-fe0f",
				"1f646-1f3fc-200d-2640-fe0f",
				"1f646-1f3fd-200d-2640-fe0f",
				"1f646-1f3fe-200d-2640-fe0f",
				"1f646-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"flip",
				"hand",
				"fetch",
				"flick",
				"sassy",
				"gossip",
				"person",
				"sarcasm",
				"tipping",
				"whatever",
				"sarcastic",
				"seriously",
				"person tipping hand"
			],
			u: "1f481",
			v: [
				"1f481-1f3fb",
				"1f481-1f3fc",
				"1f481-1f3fd",
				"1f481-1f3fe",
				"1f481-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"flip",
				"hand",
				"fetch",
				"flick",
				"sassy",
				"gossip",
				"sarcasm",
				"tipping",
				"whatever",
				"sarcastic",
				"seriously",
				"man tipping hand"
			],
			u: "1f481-200d-2642-fe0f",
			v: [
				"1f481-1f3fb-200d-2642-fe0f",
				"1f481-1f3fc-200d-2642-fe0f",
				"1f481-1f3fd-200d-2642-fe0f",
				"1f481-1f3fe-200d-2642-fe0f",
				"1f481-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"flip",
				"hand",
				"fetch",
				"flick",
				"sassy",
				"woman",
				"gossip",
				"sarcasm",
				"tipping",
				"whatever",
				"sarcastic",
				"seriously",
				"woman tipping hand"
			],
			u: "1f481-200d-2640-fe0f",
			v: [
				"1f481-1f3fb-200d-2640-fe0f",
				"1f481-1f3fc-200d-2640-fe0f",
				"1f481-1f3fd-200d-2640-fe0f",
				"1f481-1f3fe-200d-2640-fe0f",
				"1f481-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"me",
				"hand",
				"here",
				"know",
				"pick",
				"raise",
				"person",
				"gesture",
				"raising",
				"question",
				"person raising hand"
			],
			u: "1f64b",
			v: [
				"1f64b-1f3fb",
				"1f64b-1f3fc",
				"1f64b-1f3fd",
				"1f64b-1f3fe",
				"1f64b-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"me",
				"man",
				"hand",
				"here",
				"know",
				"pick",
				"raise",
				"gesture",
				"raising",
				"question",
				"man raising hand"
			],
			u: "1f64b-200d-2642-fe0f",
			v: [
				"1f64b-1f3fb-200d-2642-fe0f",
				"1f64b-1f3fc-200d-2642-fe0f",
				"1f64b-1f3fd-200d-2642-fe0f",
				"1f64b-1f3fe-200d-2642-fe0f",
				"1f64b-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"me",
				"hand",
				"here",
				"know",
				"pick",
				"raise",
				"woman",
				"gesture",
				"raising",
				"question",
				"woman raising hand"
			],
			u: "1f64b-200d-2640-fe0f",
			v: [
				"1f64b-1f3fb-200d-2640-fe0f",
				"1f64b-1f3fc-200d-2640-fe0f",
				"1f64b-1f3fd-200d-2640-fe0f",
				"1f64b-1f3fe-200d-2640-fe0f",
				"1f64b-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"ear",
				"deaf",
				"hear",
				"person",
				"gesture",
				"deaf person",
				"accessibility"
			],
			u: "1f9cf",
			v: [
				"1f9cf-1f3fb",
				"1f9cf-1f3fc",
				"1f9cf-1f3fd",
				"1f9cf-1f3fe",
				"1f9cf-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"ear",
				"man",
				"deaf",
				"hear",
				"gesture",
				"deaf man",
				"accessibility"
			],
			u: "1f9cf-200d-2642-fe0f",
			v: [
				"1f9cf-1f3fb-200d-2642-fe0f",
				"1f9cf-1f3fc-200d-2642-fe0f",
				"1f9cf-1f3fd-200d-2642-fe0f",
				"1f9cf-1f3fe-200d-2642-fe0f",
				"1f9cf-1f3ff-200d-2642-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"ear",
				"deaf",
				"hear",
				"woman",
				"gesture",
				"deaf woman",
				"accessibility"
			],
			u: "1f9cf-200d-2640-fe0f",
			v: [
				"1f9cf-1f3fb-200d-2640-fe0f",
				"1f9cf-1f3fc-200d-2640-fe0f",
				"1f9cf-1f3fd-200d-2640-fe0f",
				"1f9cf-1f3fe-200d-2640-fe0f",
				"1f9cf-1f3ff-200d-2640-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"ask",
				"beg",
				"bow",
				"pity",
				"favor",
				"sorry",
				"bowing",
				"person",
				"regret",
				"apology",
				"forgive",
				"gesture",
				"meditate",
				"meditation",
				"person bowing"
			],
			u: "1f647",
			v: [
				"1f647-1f3fb",
				"1f647-1f3fc",
				"1f647-1f3fd",
				"1f647-1f3fe",
				"1f647-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"ask",
				"beg",
				"bow",
				"man",
				"pity",
				"favor",
				"sorry",
				"bowing",
				"regret",
				"apology",
				"forgive",
				"gesture",
				"meditate",
				"man bowing",
				"meditation"
			],
			u: "1f647-200d-2642-fe0f",
			v: [
				"1f647-1f3fb-200d-2642-fe0f",
				"1f647-1f3fc-200d-2642-fe0f",
				"1f647-1f3fd-200d-2642-fe0f",
				"1f647-1f3fe-200d-2642-fe0f",
				"1f647-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"ask",
				"beg",
				"bow",
				"pity",
				"favor",
				"sorry",
				"woman",
				"bowing",
				"regret",
				"apology",
				"forgive",
				"gesture",
				"meditate",
				"meditation",
				"woman bowing"
			],
			u: "1f647-200d-2640-fe0f",
			v: [
				"1f647-1f3fb-200d-2640-fe0f",
				"1f647-1f3fc-200d-2640-fe0f",
				"1f647-1f3fd-200d-2640-fe0f",
				"1f647-1f3fe-200d-2640-fe0f",
				"1f647-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"no",
				"oh",
				"not",
				"omg",
				"smh",
				"again",
				"shock",
				"person",
				"bewilder",
				"facepalm",
				"disbelief",
				"exasperation",
				"person facepalming"
			],
			u: "1f926",
			v: [
				"1f926-1f3fb",
				"1f926-1f3fc",
				"1f926-1f3fd",
				"1f926-1f3fe",
				"1f926-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"no",
				"oh",
				"man",
				"not",
				"omg",
				"smh",
				"again",
				"shock",
				"bewilder",
				"facepalm",
				"disbelief",
				"exasperation",
				"man facepalming"
			],
			u: "1f926-200d-2642-fe0f",
			v: [
				"1f926-1f3fb-200d-2642-fe0f",
				"1f926-1f3fc-200d-2642-fe0f",
				"1f926-1f3fd-200d-2642-fe0f",
				"1f926-1f3fe-200d-2642-fe0f",
				"1f926-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"no",
				"oh",
				"not",
				"omg",
				"smh",
				"again",
				"shock",
				"woman",
				"bewilder",
				"facepalm",
				"disbelief",
				"exasperation",
				"woman facepalming"
			],
			u: "1f926-200d-2640-fe0f",
			v: [
				"1f926-1f3fb-200d-2640-fe0f",
				"1f926-1f3fc-200d-2640-fe0f",
				"1f926-1f3fd-200d-2640-fe0f",
				"1f926-1f3fe-200d-2640-fe0f",
				"1f926-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"idk",
				"who",
				"doubt",
				"dunno",
				"guess",
				"knows",
				"maybe",
				"shrug",
				"person",
				"whatever",
				"ignorance",
				"shrugging",
				"indifference",
				"person shrugging"
			],
			u: "1f937",
			v: [
				"1f937-1f3fb",
				"1f937-1f3fc",
				"1f937-1f3fd",
				"1f937-1f3fe",
				"1f937-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"idk",
				"man",
				"who",
				"doubt",
				"dunno",
				"guess",
				"knows",
				"maybe",
				"shrug",
				"whatever",
				"ignorance",
				"shrugging",
				"indifference",
				"man shrugging"
			],
			u: "1f937-200d-2642-fe0f",
			v: [
				"1f937-1f3fb-200d-2642-fe0f",
				"1f937-1f3fc-200d-2642-fe0f",
				"1f937-1f3fd-200d-2642-fe0f",
				"1f937-1f3fe-200d-2642-fe0f",
				"1f937-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"idk",
				"who",
				"doubt",
				"dunno",
				"guess",
				"knows",
				"maybe",
				"shrug",
				"woman",
				"whatever",
				"ignorance",
				"shrugging",
				"indifference",
				"woman shrugging"
			],
			u: "1f937-200d-2640-fe0f",
			v: [
				"1f937-1f3fb-200d-2640-fe0f",
				"1f937-1f3fc-200d-2640-fe0f",
				"1f937-1f3fd-200d-2640-fe0f",
				"1f937-1f3fe-200d-2640-fe0f",
				"1f937-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"nurse",
				"doctor",
				"health",
				"worker",
				"therapist",
				"healthcare",
				"health worker"
			],
			u: "1f9d1-200d-2695-fe0f",
			v: [
				"1f9d1-1f3fb-200d-2695-fe0f",
				"1f9d1-1f3fc-200d-2695-fe0f",
				"1f9d1-1f3fd-200d-2695-fe0f",
				"1f9d1-1f3fe-200d-2695-fe0f",
				"1f9d1-1f3ff-200d-2695-fe0f"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"nurse",
				"doctor",
				"health",
				"worker",
				"therapist",
				"healthcare",
				"man health worker"
			],
			u: "1f468-200d-2695-fe0f",
			v: [
				"1f468-1f3fb-200d-2695-fe0f",
				"1f468-1f3fc-200d-2695-fe0f",
				"1f468-1f3fd-200d-2695-fe0f",
				"1f468-1f3fe-200d-2695-fe0f",
				"1f468-1f3ff-200d-2695-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"nurse",
				"woman",
				"doctor",
				"health",
				"worker",
				"therapist",
				"healthcare",
				"woman health worker"
			],
			u: "1f469-200d-2695-fe0f",
			v: [
				"1f469-1f3fb-200d-2695-fe0f",
				"1f469-1f3fc-200d-2695-fe0f",
				"1f469-1f3fd-200d-2695-fe0f",
				"1f469-1f3fe-200d-2695-fe0f",
				"1f469-1f3ff-200d-2695-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"student",
				"graduate"
			],
			u: "1f9d1-200d-1f393",
			v: [
				"1f9d1-1f3fb-200d-1f393",
				"1f9d1-1f3fc-200d-1f393",
				"1f9d1-1f3fd-200d-1f393",
				"1f9d1-1f3fe-200d-1f393",
				"1f9d1-1f3ff-200d-1f393"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"student",
				"graduate",
				"man student"
			],
			u: "1f468-200d-1f393",
			v: [
				"1f468-1f3fb-200d-1f393",
				"1f468-1f3fc-200d-1f393",
				"1f468-1f3fd-200d-1f393",
				"1f468-1f3fe-200d-1f393",
				"1f468-1f3ff-200d-1f393"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"student",
				"graduate",
				"woman student"
			],
			u: "1f469-200d-1f393",
			v: [
				"1f469-1f3fb-200d-1f393",
				"1f469-1f3fc-200d-1f393",
				"1f469-1f3fd-200d-1f393",
				"1f469-1f3fe-200d-1f393",
				"1f469-1f3ff-200d-1f393"
			],
			a: "4"
		},
		{
			n: [
				"teacher",
				"lecturer",
				"professor",
				"instructor"
			],
			u: "1f9d1-200d-1f3eb",
			v: [
				"1f9d1-1f3fb-200d-1f3eb",
				"1f9d1-1f3fc-200d-1f3eb",
				"1f9d1-1f3fd-200d-1f3eb",
				"1f9d1-1f3fe-200d-1f3eb",
				"1f9d1-1f3ff-200d-1f3eb"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"teacher",
				"lecturer",
				"professor",
				"instructor",
				"man teacher"
			],
			u: "1f468-200d-1f3eb",
			v: [
				"1f468-1f3fb-200d-1f3eb",
				"1f468-1f3fc-200d-1f3eb",
				"1f468-1f3fd-200d-1f3eb",
				"1f468-1f3fe-200d-1f3eb",
				"1f468-1f3ff-200d-1f3eb"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"teacher",
				"lecturer",
				"professor",
				"instructor",
				"woman teacher"
			],
			u: "1f469-200d-1f3eb",
			v: [
				"1f469-1f3fb-200d-1f3eb",
				"1f469-1f3fc-200d-1f3eb",
				"1f469-1f3fd-200d-1f3eb",
				"1f469-1f3fe-200d-1f3eb",
				"1f469-1f3ff-200d-1f3eb"
			],
			a: "4"
		},
		{
			n: [
				"law",
				"judge",
				"scales",
				"justice"
			],
			u: "1f9d1-200d-2696-fe0f",
			v: [
				"1f9d1-1f3fb-200d-2696-fe0f",
				"1f9d1-1f3fc-200d-2696-fe0f",
				"1f9d1-1f3fd-200d-2696-fe0f",
				"1f9d1-1f3fe-200d-2696-fe0f",
				"1f9d1-1f3ff-200d-2696-fe0f"
			],
			a: "12.1"
		},
		{
			n: [
				"law",
				"man",
				"judge",
				"scales",
				"justice",
				"man judge"
			],
			u: "1f468-200d-2696-fe0f",
			v: [
				"1f468-1f3fb-200d-2696-fe0f",
				"1f468-1f3fc-200d-2696-fe0f",
				"1f468-1f3fd-200d-2696-fe0f",
				"1f468-1f3fe-200d-2696-fe0f",
				"1f468-1f3ff-200d-2696-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"law",
				"judge",
				"woman",
				"scales",
				"justice",
				"woman judge"
			],
			u: "1f469-200d-2696-fe0f",
			v: [
				"1f469-1f3fb-200d-2696-fe0f",
				"1f469-1f3fc-200d-2696-fe0f",
				"1f469-1f3fd-200d-2696-fe0f",
				"1f469-1f3fe-200d-2696-fe0f",
				"1f469-1f3ff-200d-2696-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"farmer",
				"rancher",
				"gardener"
			],
			u: "1f9d1-200d-1f33e",
			v: [
				"1f9d1-1f3fb-200d-1f33e",
				"1f9d1-1f3fc-200d-1f33e",
				"1f9d1-1f3fd-200d-1f33e",
				"1f9d1-1f3fe-200d-1f33e",
				"1f9d1-1f3ff-200d-1f33e"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"farmer",
				"rancher",
				"gardener",
				"man farmer"
			],
			u: "1f468-200d-1f33e",
			v: [
				"1f468-1f3fb-200d-1f33e",
				"1f468-1f3fc-200d-1f33e",
				"1f468-1f3fd-200d-1f33e",
				"1f468-1f3fe-200d-1f33e",
				"1f468-1f3ff-200d-1f33e"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"farmer",
				"rancher",
				"gardener",
				"woman farmer"
			],
			u: "1f469-200d-1f33e",
			v: [
				"1f469-1f3fb-200d-1f33e",
				"1f469-1f3fc-200d-1f33e",
				"1f469-1f3fd-200d-1f33e",
				"1f469-1f3fe-200d-1f33e",
				"1f469-1f3ff-200d-1f33e"
			],
			a: "4"
		},
		{
			n: [
				"cook",
				"chef"
			],
			u: "1f9d1-200d-1f373",
			v: [
				"1f9d1-1f3fb-200d-1f373",
				"1f9d1-1f3fc-200d-1f373",
				"1f9d1-1f3fd-200d-1f373",
				"1f9d1-1f3fe-200d-1f373",
				"1f9d1-1f3ff-200d-1f373"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"chef",
				"cook",
				"man cook"
			],
			u: "1f468-200d-1f373",
			v: [
				"1f468-1f3fb-200d-1f373",
				"1f468-1f3fc-200d-1f373",
				"1f468-1f3fd-200d-1f373",
				"1f468-1f3fe-200d-1f373",
				"1f468-1f3ff-200d-1f373"
			],
			a: "4"
		},
		{
			n: [
				"chef",
				"cook",
				"woman",
				"woman cook"
			],
			u: "1f469-200d-1f373",
			v: [
				"1f469-1f3fb-200d-1f373",
				"1f469-1f3fc-200d-1f373",
				"1f469-1f3fd-200d-1f373",
				"1f469-1f3fe-200d-1f373",
				"1f469-1f3ff-200d-1f373"
			],
			a: "4"
		},
		{
			n: [
				"plumber",
				"mechanic",
				"electrician",
				"tradesperson"
			],
			u: "1f9d1-200d-1f527",
			v: [
				"1f9d1-1f3fb-200d-1f527",
				"1f9d1-1f3fc-200d-1f527",
				"1f9d1-1f3fd-200d-1f527",
				"1f9d1-1f3fe-200d-1f527",
				"1f9d1-1f3ff-200d-1f527"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"plumber",
				"mechanic",
				"electrician",
				"man mechanic",
				"tradesperson"
			],
			u: "1f468-200d-1f527",
			v: [
				"1f468-1f3fb-200d-1f527",
				"1f468-1f3fc-200d-1f527",
				"1f468-1f3fd-200d-1f527",
				"1f468-1f3fe-200d-1f527",
				"1f468-1f3ff-200d-1f527"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"plumber",
				"mechanic",
				"electrician",
				"tradesperson",
				"woman mechanic"
			],
			u: "1f469-200d-1f527",
			v: [
				"1f469-1f3fb-200d-1f527",
				"1f469-1f3fc-200d-1f527",
				"1f469-1f3fd-200d-1f527",
				"1f469-1f3fe-200d-1f527",
				"1f469-1f3ff-200d-1f527"
			],
			a: "4"
		},
		{
			n: [
				"worker",
				"factory",
				"assembly",
				"industrial",
				"factory worker"
			],
			u: "1f9d1-200d-1f3ed",
			v: [
				"1f9d1-1f3fb-200d-1f3ed",
				"1f9d1-1f3fc-200d-1f3ed",
				"1f9d1-1f3fd-200d-1f3ed",
				"1f9d1-1f3fe-200d-1f3ed",
				"1f9d1-1f3ff-200d-1f3ed"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"worker",
				"factory",
				"assembly",
				"industrial",
				"man factory worker"
			],
			u: "1f468-200d-1f3ed",
			v: [
				"1f468-1f3fb-200d-1f3ed",
				"1f468-1f3fc-200d-1f3ed",
				"1f468-1f3fd-200d-1f3ed",
				"1f468-1f3fe-200d-1f3ed",
				"1f468-1f3ff-200d-1f3ed"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"worker",
				"factory",
				"assembly",
				"industrial",
				"woman factory worker"
			],
			u: "1f469-200d-1f3ed",
			v: [
				"1f469-1f3fb-200d-1f3ed",
				"1f469-1f3fc-200d-1f3ed",
				"1f469-1f3fd-200d-1f3ed",
				"1f469-1f3fe-200d-1f3ed",
				"1f469-1f3ff-200d-1f3ed"
			],
			a: "4"
		},
		{
			n: [
				"office",
				"worker",
				"manager",
				"business",
				"architect",
				"white collar",
				"office worker"
			],
			u: "1f9d1-200d-1f4bc",
			v: [
				"1f9d1-1f3fb-200d-1f4bc",
				"1f9d1-1f3fc-200d-1f4bc",
				"1f9d1-1f3fd-200d-1f4bc",
				"1f9d1-1f3fe-200d-1f4bc",
				"1f9d1-1f3ff-200d-1f4bc"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"office",
				"worker",
				"manager",
				"business",
				"architect",
				"white collar",
				"man office worker"
			],
			u: "1f468-200d-1f4bc",
			v: [
				"1f468-1f3fb-200d-1f4bc",
				"1f468-1f3fc-200d-1f4bc",
				"1f468-1f3fd-200d-1f4bc",
				"1f468-1f3fe-200d-1f4bc",
				"1f468-1f3ff-200d-1f4bc"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"office",
				"worker",
				"manager",
				"business",
				"architect",
				"white collar",
				"woman office worker"
			],
			u: "1f469-200d-1f4bc",
			v: [
				"1f469-1f3fb-200d-1f4bc",
				"1f469-1f3fc-200d-1f4bc",
				"1f469-1f3fd-200d-1f4bc",
				"1f469-1f3fe-200d-1f4bc",
				"1f469-1f3ff-200d-1f4bc"
			],
			a: "4"
		},
		{
			n: [
				"chemist",
				"engineer",
				"scientist",
				"biologist",
				"physicist",
				"mathematician"
			],
			u: "1f9d1-200d-1f52c",
			v: [
				"1f9d1-1f3fb-200d-1f52c",
				"1f9d1-1f3fc-200d-1f52c",
				"1f9d1-1f3fd-200d-1f52c",
				"1f9d1-1f3fe-200d-1f52c",
				"1f9d1-1f3ff-200d-1f52c"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"chemist",
				"engineer",
				"biologist",
				"physicist",
				"scientist",
				"man scientist",
				"mathematician"
			],
			u: "1f468-200d-1f52c",
			v: [
				"1f468-1f3fb-200d-1f52c",
				"1f468-1f3fc-200d-1f52c",
				"1f468-1f3fd-200d-1f52c",
				"1f468-1f3fe-200d-1f52c",
				"1f468-1f3ff-200d-1f52c"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"chemist",
				"engineer",
				"biologist",
				"physicist",
				"scientist",
				"mathematician",
				"woman scientist"
			],
			u: "1f469-200d-1f52c",
			v: [
				"1f469-1f3fb-200d-1f52c",
				"1f469-1f3fc-200d-1f52c",
				"1f469-1f3fd-200d-1f52c",
				"1f469-1f3fe-200d-1f52c",
				"1f469-1f3ff-200d-1f52c"
			],
			a: "4"
		},
		{
			n: [
				"coder",
				"computer",
				"inventor",
				"software",
				"developer",
				"technologist"
			],
			u: "1f9d1-200d-1f4bb",
			v: [
				"1f9d1-1f3fb-200d-1f4bb",
				"1f9d1-1f3fc-200d-1f4bb",
				"1f9d1-1f3fd-200d-1f4bb",
				"1f9d1-1f3fe-200d-1f4bb",
				"1f9d1-1f3ff-200d-1f4bb"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"coder",
				"computer",
				"inventor",
				"software",
				"developer",
				"technologist",
				"man technologist"
			],
			u: "1f468-200d-1f4bb",
			v: [
				"1f468-1f3fb-200d-1f4bb",
				"1f468-1f3fc-200d-1f4bb",
				"1f468-1f3fd-200d-1f4bb",
				"1f468-1f3fe-200d-1f4bb",
				"1f468-1f3ff-200d-1f4bb"
			],
			a: "4"
		},
		{
			n: [
				"coder",
				"woman",
				"computer",
				"inventor",
				"software",
				"developer",
				"technologist",
				"woman technologist"
			],
			u: "1f469-200d-1f4bb",
			v: [
				"1f469-1f3fb-200d-1f4bb",
				"1f469-1f3fc-200d-1f4bb",
				"1f469-1f3fd-200d-1f4bb",
				"1f469-1f3fe-200d-1f4bb",
				"1f469-1f3ff-200d-1f4bb"
			],
			a: "4"
		},
		{
			n: [
				"rock",
				"star",
				"actor",
				"singer",
				"rockstar",
				"entertainer"
			],
			u: "1f9d1-200d-1f3a4",
			v: [
				"1f9d1-1f3fb-200d-1f3a4",
				"1f9d1-1f3fc-200d-1f3a4",
				"1f9d1-1f3fd-200d-1f3a4",
				"1f9d1-1f3fe-200d-1f3a4",
				"1f9d1-1f3ff-200d-1f3a4"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"rock",
				"star",
				"actor",
				"singer",
				"rockstar",
				"man singer",
				"entertainer"
			],
			u: "1f468-200d-1f3a4",
			v: [
				"1f468-1f3fb-200d-1f3a4",
				"1f468-1f3fc-200d-1f3a4",
				"1f468-1f3fd-200d-1f3a4",
				"1f468-1f3fe-200d-1f3a4",
				"1f468-1f3ff-200d-1f3a4"
			],
			a: "4"
		},
		{
			n: [
				"rock",
				"star",
				"actor",
				"woman",
				"singer",
				"rockstar",
				"entertainer",
				"woman singer"
			],
			u: "1f469-200d-1f3a4",
			v: [
				"1f469-1f3fb-200d-1f3a4",
				"1f469-1f3fc-200d-1f3a4",
				"1f469-1f3fd-200d-1f3a4",
				"1f469-1f3fe-200d-1f3a4",
				"1f469-1f3ff-200d-1f3a4"
			],
			a: "4"
		},
		{
			n: [
				"artist",
				"palette"
			],
			u: "1f9d1-200d-1f3a8",
			v: [
				"1f9d1-1f3fb-200d-1f3a8",
				"1f9d1-1f3fc-200d-1f3a8",
				"1f9d1-1f3fd-200d-1f3a8",
				"1f9d1-1f3fe-200d-1f3a8",
				"1f9d1-1f3ff-200d-1f3a8"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"artist",
				"palette",
				"man artist"
			],
			u: "1f468-200d-1f3a8",
			v: [
				"1f468-1f3fb-200d-1f3a8",
				"1f468-1f3fc-200d-1f3a8",
				"1f468-1f3fd-200d-1f3a8",
				"1f468-1f3fe-200d-1f3a8",
				"1f468-1f3ff-200d-1f3a8"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"artist",
				"palette",
				"woman artist"
			],
			u: "1f469-200d-1f3a8",
			v: [
				"1f469-1f3fb-200d-1f3a8",
				"1f469-1f3fc-200d-1f3a8",
				"1f469-1f3fd-200d-1f3a8",
				"1f469-1f3fe-200d-1f3a8",
				"1f469-1f3ff-200d-1f3a8"
			],
			a: "4"
		},
		{
			n: [
				"pilot",
				"plane"
			],
			u: "1f9d1-200d-2708-fe0f",
			v: [
				"1f9d1-1f3fb-200d-2708-fe0f",
				"1f9d1-1f3fc-200d-2708-fe0f",
				"1f9d1-1f3fd-200d-2708-fe0f",
				"1f9d1-1f3fe-200d-2708-fe0f",
				"1f9d1-1f3ff-200d-2708-fe0f"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"pilot",
				"plane",
				"man pilot"
			],
			u: "1f468-200d-2708-fe0f",
			v: [
				"1f468-1f3fb-200d-2708-fe0f",
				"1f468-1f3fc-200d-2708-fe0f",
				"1f468-1f3fd-200d-2708-fe0f",
				"1f468-1f3fe-200d-2708-fe0f",
				"1f468-1f3ff-200d-2708-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"pilot",
				"plane",
				"woman",
				"woman pilot"
			],
			u: "1f469-200d-2708-fe0f",
			v: [
				"1f469-1f3fb-200d-2708-fe0f",
				"1f469-1f3fc-200d-2708-fe0f",
				"1f469-1f3fd-200d-2708-fe0f",
				"1f469-1f3fe-200d-2708-fe0f",
				"1f469-1f3ff-200d-2708-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"space",
				"rocket",
				"astronaut"
			],
			u: "1f9d1-200d-1f680",
			v: [
				"1f9d1-1f3fb-200d-1f680",
				"1f9d1-1f3fc-200d-1f680",
				"1f9d1-1f3fd-200d-1f680",
				"1f9d1-1f3fe-200d-1f680",
				"1f9d1-1f3ff-200d-1f680"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"space",
				"rocket",
				"astronaut",
				"man astronaut"
			],
			u: "1f468-200d-1f680",
			v: [
				"1f468-1f3fb-200d-1f680",
				"1f468-1f3fc-200d-1f680",
				"1f468-1f3fd-200d-1f680",
				"1f468-1f3fe-200d-1f680",
				"1f468-1f3ff-200d-1f680"
			],
			a: "4"
		},
		{
			n: [
				"space",
				"woman",
				"rocket",
				"astronaut",
				"woman astronaut"
			],
			u: "1f469-200d-1f680",
			v: [
				"1f469-1f3fb-200d-1f680",
				"1f469-1f3fc-200d-1f680",
				"1f469-1f3fd-200d-1f680",
				"1f469-1f3fe-200d-1f680",
				"1f469-1f3ff-200d-1f680"
			],
			a: "4"
		},
		{
			n: [
				"fire",
				"firetruck",
				"firefighter"
			],
			u: "1f9d1-200d-1f692",
			v: [
				"1f9d1-1f3fb-200d-1f692",
				"1f9d1-1f3fc-200d-1f692",
				"1f9d1-1f3fd-200d-1f692",
				"1f9d1-1f3fe-200d-1f692",
				"1f9d1-1f3ff-200d-1f692"
			],
			a: "12.1"
		},
		{
			n: [
				"man",
				"fire",
				"firetruck",
				"firefighter",
				"man firefighter"
			],
			u: "1f468-200d-1f692",
			v: [
				"1f468-1f3fb-200d-1f692",
				"1f468-1f3fc-200d-1f692",
				"1f468-1f3fd-200d-1f692",
				"1f468-1f3fe-200d-1f692",
				"1f468-1f3ff-200d-1f692"
			],
			a: "4"
		},
		{
			n: [
				"fire",
				"woman",
				"firetruck",
				"firefighter",
				"woman firefighter"
			],
			u: "1f469-200d-1f692",
			v: [
				"1f469-1f3fb-200d-1f692",
				"1f469-1f3fc-200d-1f692",
				"1f469-1f3fd-200d-1f692",
				"1f469-1f3fe-200d-1f692",
				"1f469-1f3ff-200d-1f692"
			],
			a: "4"
		},
		{
			n: [
				"cop",
				"law",
				"over",
				"arrest",
				"police",
				"pulled",
				"officer",
				"citation",
				"apprehend",
				"undercover",
				"police officer"
			],
			u: "1f46e",
			v: [
				"1f46e-1f3fb",
				"1f46e-1f3fc",
				"1f46e-1f3fd",
				"1f46e-1f3fe",
				"1f46e-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"cop",
				"law",
				"man",
				"over",
				"arrest",
				"police",
				"pulled",
				"officer",
				"citation",
				"apprehend",
				"undercover",
				"man police officer"
			],
			u: "1f46e-200d-2642-fe0f",
			v: [
				"1f46e-1f3fb-200d-2642-fe0f",
				"1f46e-1f3fc-200d-2642-fe0f",
				"1f46e-1f3fd-200d-2642-fe0f",
				"1f46e-1f3fe-200d-2642-fe0f",
				"1f46e-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"cop",
				"law",
				"over",
				"woman",
				"arrest",
				"police",
				"pulled",
				"officer",
				"citation",
				"apprehend",
				"undercover",
				"woman police officer"
			],
			u: "1f46e-200d-2640-fe0f",
			v: [
				"1f46e-1f3fb-200d-2640-fe0f",
				"1f46e-1f3fc-200d-2640-fe0f",
				"1f46e-1f3fd-200d-2640-fe0f",
				"1f46e-1f3fe-200d-2640-fe0f",
				"1f46e-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"spy",
				"sleuth",
				"detective"
			],
			u: "1f575-fe0f",
			v: [
				"1f575-1f3fb",
				"1f575-1f3fc",
				"1f575-1f3fd",
				"1f575-1f3fe",
				"1f575-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"man",
				"spy",
				"sleuth",
				"detective",
				"man detective"
			],
			u: "1f575-fe0f-200d-2642-fe0f",
			v: [
				"1f575-1f3fb-200d-2642-fe0f",
				"1f575-1f3fc-200d-2642-fe0f",
				"1f575-1f3fd-200d-2642-fe0f",
				"1f575-1f3fe-200d-2642-fe0f",
				"1f575-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"spy",
				"woman",
				"sleuth",
				"detective",
				"woman detective"
			],
			u: "1f575-fe0f-200d-2640-fe0f",
			v: [
				"1f575-1f3fb-200d-2640-fe0f",
				"1f575-1f3fc-200d-2640-fe0f",
				"1f575-1f3fd-200d-2640-fe0f",
				"1f575-1f3fe-200d-2640-fe0f",
				"1f575-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"guard",
				"helmet",
				"london",
				"palace",
				"buckingham"
			],
			u: "1f482",
			v: [
				"1f482-1f3fb",
				"1f482-1f3fc",
				"1f482-1f3fd",
				"1f482-1f3fe",
				"1f482-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"guard",
				"helmet",
				"london",
				"palace",
				"man guard",
				"buckingham"
			],
			u: "1f482-200d-2642-fe0f",
			v: [
				"1f482-1f3fb-200d-2642-fe0f",
				"1f482-1f3fc-200d-2642-fe0f",
				"1f482-1f3fd-200d-2642-fe0f",
				"1f482-1f3fe-200d-2642-fe0f",
				"1f482-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"guard",
				"woman",
				"helmet",
				"london",
				"palace",
				"buckingham",
				"woman guard"
			],
			u: "1f482-200d-2640-fe0f",
			v: [
				"1f482-1f3fb-200d-2640-fe0f",
				"1f482-1f3fc-200d-2640-fe0f",
				"1f482-1f3fd-200d-2640-fe0f",
				"1f482-1f3fe-200d-2640-fe0f",
				"1f482-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"sly",
				"war",
				"ninja",
				"fight",
				"hidden",
				"person",
				"secret",
				"skills",
				"fighter",
				"soldier",
				"stealth",
				"assassin"
			],
			u: "1f977",
			v: [
				"1f977-1f3fb",
				"1f977-1f3fc",
				"1f977-1f3fd",
				"1f977-1f3fe",
				"1f977-1f3ff"
			],
			a: "13"
		},
		{
			n: [
				"fix",
				"hat",
				"man",
				"work",
				"build",
				"person",
				"repair",
				"worker",
				"hardhat",
				"rebuild",
				"remodel",
				"construction",
				"construction worker"
			],
			u: "1f477",
			v: [
				"1f477-1f3fb",
				"1f477-1f3fc",
				"1f477-1f3fd",
				"1f477-1f3fe",
				"1f477-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"fix",
				"hat",
				"man",
				"work",
				"build",
				"repair",
				"worker",
				"hardhat",
				"rebuild",
				"remodel",
				"construction",
				"man construction worker"
			],
			u: "1f477-200d-2642-fe0f",
			v: [
				"1f477-1f3fb-200d-2642-fe0f",
				"1f477-1f3fc-200d-2642-fe0f",
				"1f477-1f3fd-200d-2642-fe0f",
				"1f477-1f3fe-200d-2642-fe0f",
				"1f477-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"fix",
				"hat",
				"man",
				"work",
				"build",
				"woman",
				"repair",
				"worker",
				"hardhat",
				"rebuild",
				"remodel",
				"construction",
				"woman construction worker"
			],
			u: "1f477-200d-2640-fe0f",
			v: [
				"1f477-1f3fb-200d-2640-fe0f",
				"1f477-1f3fc-200d-2640-fe0f",
				"1f477-1f3fd-200d-2640-fe0f",
				"1f477-1f3fe-200d-2640-fe0f",
				"1f477-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"crown",
				"noble",
				"regal",
				"royal",
				"person",
				"monarch",
				"royalty",
				"person with crown"
			],
			u: "1fac5",
			v: [
				"1fac5-1f3fb",
				"1fac5-1f3fc",
				"1fac5-1f3fd",
				"1fac5-1f3fe",
				"1fac5-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"king",
				"tale",
				"crown",
				"fairy",
				"royal",
				"prince",
				"fantasy",
				"royalty",
				"fairytale"
			],
			u: "1f934",
			v: [
				"1f934-1f3fb",
				"1f934-1f3fc",
				"1f934-1f3fd",
				"1f934-1f3fe",
				"1f934-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"tale",
				"crown",
				"fairy",
				"queen",
				"royal",
				"fantasy",
				"royalty",
				"princess",
				"fairytale"
			],
			u: "1f478",
			v: [
				"1f478-1f3fb",
				"1f478-1f3fc",
				"1f478-1f3fd",
				"1f478-1f3fe",
				"1f478-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"person",
				"turban",
				"wearing",
				"person wearing turban"
			],
			u: "1f473",
			v: [
				"1f473-1f3fb",
				"1f473-1f3fc",
				"1f473-1f3fd",
				"1f473-1f3fe",
				"1f473-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"turban",
				"wearing",
				"man wearing turban"
			],
			u: "1f473-200d-2642-fe0f",
			v: [
				"1f473-1f3fb-200d-2642-fe0f",
				"1f473-1f3fc-200d-2642-fe0f",
				"1f473-1f3fd-200d-2642-fe0f",
				"1f473-1f3fe-200d-2642-fe0f",
				"1f473-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"turban",
				"wearing",
				"woman wearing turban"
			],
			u: "1f473-200d-2640-fe0f",
			v: [
				"1f473-1f3fb-200d-2640-fe0f",
				"1f473-1f3fc-200d-2640-fe0f",
				"1f473-1f3fd-200d-2640-fe0f",
				"1f473-1f3fe-200d-2640-fe0f",
				"1f473-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"pi",
				"cap",
				"gua",
				"hat",
				"mao",
				"guapi",
				"person",
				"chinese",
				"skullcap",
				"person with skullcap"
			],
			u: "1f472",
			v: [
				"1f472-1f3fb",
				"1f472-1f3fc",
				"1f472-1f3fd",
				"1f472-1f3fe",
				"1f472-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"head",
				"hijab",
				"woman",
				"tichel",
				"bandana",
				"kerchief",
				"mantilla",
				"headscarf",
				"woman with headscarf"
			],
			u: "1f9d5",
			v: [
				"1f9d5-1f3fb",
				"1f9d5-1f3fc",
				"1f9d5-1f3fd",
				"1f9d5-1f3fe",
				"1f9d5-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"formal",
				"person",
				"tuxedo",
				"wedding",
				"person in tuxedo"
			],
			u: "1f935",
			v: [
				"1f935-1f3fb",
				"1f935-1f3fc",
				"1f935-1f3fd",
				"1f935-1f3fe",
				"1f935-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"man",
				"groom",
				"formal",
				"tuxedo",
				"wedding",
				"man in tuxedo"
			],
			u: "1f935-200d-2642-fe0f",
			v: [
				"1f935-1f3fb-200d-2642-fe0f",
				"1f935-1f3fc-200d-2642-fe0f",
				"1f935-1f3fd-200d-2642-fe0f",
				"1f935-1f3fe-200d-2642-fe0f",
				"1f935-1f3ff-200d-2642-fe0f"
			],
			a: "13"
		},
		{
			n: [
				"woman",
				"formal",
				"tuxedo",
				"wedding",
				"woman in tuxedo"
			],
			u: "1f935-200d-2640-fe0f",
			v: [
				"1f935-1f3fb-200d-2640-fe0f",
				"1f935-1f3fc-200d-2640-fe0f",
				"1f935-1f3fd-200d-2640-fe0f",
				"1f935-1f3fe-200d-2640-fe0f",
				"1f935-1f3ff-200d-2640-fe0f"
			],
			a: "13"
		},
		{
			n: [
				"veil",
				"person",
				"wedding",
				"person with veil"
			],
			u: "1f470",
			v: [
				"1f470-1f3fb",
				"1f470-1f3fc",
				"1f470-1f3fd",
				"1f470-1f3fe",
				"1f470-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"veil",
				"wedding",
				"man with veil"
			],
			u: "1f470-200d-2642-fe0f",
			v: [
				"1f470-1f3fb-200d-2642-fe0f",
				"1f470-1f3fc-200d-2642-fe0f",
				"1f470-1f3fd-200d-2642-fe0f",
				"1f470-1f3fe-200d-2642-fe0f",
				"1f470-1f3ff-200d-2642-fe0f"
			],
			a: "13"
		},
		{
			n: [
				"veil",
				"bride",
				"woman",
				"wedding",
				"woman with veil"
			],
			u: "1f470-200d-2640-fe0f",
			v: [
				"1f470-1f3fb-200d-2640-fe0f",
				"1f470-1f3fc-200d-2640-fe0f",
				"1f470-1f3fd-200d-2640-fe0f",
				"1f470-1f3fe-200d-2640-fe0f",
				"1f470-1f3ff-200d-2640-fe0f"
			],
			a: "13"
		},
		{
			n: [
				"woman",
				"pregnant",
				"pregnant woman"
			],
			u: "1f930",
			v: [
				"1f930-1f3fb",
				"1f930-1f3fc",
				"1f930-1f3fd",
				"1f930-1f3fe",
				"1f930-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"man",
				"full",
				"belly",
				"bloated",
				"overeat",
				"pregnant",
				"pregnant man"
			],
			u: "1fac3",
			v: [
				"1fac3-1f3fb",
				"1fac3-1f3fc",
				"1fac3-1f3fd",
				"1fac3-1f3fe",
				"1fac3-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"full",
				"belly",
				"person",
				"bloated",
				"overeat",
				"stuffed",
				"pregnant",
				"pregnant person"
			],
			u: "1fac4",
			v: [
				"1fac4-1f3fb",
				"1fac4-1f3fc",
				"1fac4-1f3fd",
				"1fac4-1f3fe",
				"1fac4-1f3ff"
			],
			a: "14"
		},
		{
			n: [
				"mom",
				"baby",
				"woman",
				"breast",
				"mother",
				"feeding",
				"nursing",
				"breast feeding"
			],
			u: "1f931",
			v: [
				"1f931-1f3fb",
				"1f931-1f3fc",
				"1f931-1f3fd",
				"1f931-1f3fe",
				"1f931-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"mom",
				"baby",
				"feed",
				"nanny",
				"woman",
				"mother",
				"feeding",
				"newborn",
				"nursing",
				"woman feeding baby"
			],
			u: "1f469-200d-1f37c",
			v: [
				"1f469-1f3fb-200d-1f37c",
				"1f469-1f3fc-200d-1f37c",
				"1f469-1f3fd-200d-1f37c",
				"1f469-1f3fe-200d-1f37c",
				"1f469-1f3ff-200d-1f37c"
			],
			a: "13"
		},
		{
			n: [
				"dad",
				"man",
				"baby",
				"feed",
				"nanny",
				"father",
				"feeding",
				"newborn",
				"nursing",
				"man feeding baby"
			],
			u: "1f468-200d-1f37c",
			v: [
				"1f468-1f3fb-200d-1f37c",
				"1f468-1f3fc-200d-1f37c",
				"1f468-1f3fd-200d-1f37c",
				"1f468-1f3fe-200d-1f37c",
				"1f468-1f3ff-200d-1f37c"
			],
			a: "13"
		},
		{
			n: [
				"baby",
				"feed",
				"nanny",
				"parent",
				"feeding",
				"newborn",
				"nursing",
				"person feeding baby"
			],
			u: "1f9d1-200d-1f37c",
			v: [
				"1f9d1-1f3fb-200d-1f37c",
				"1f9d1-1f3fc-200d-1f37c",
				"1f9d1-1f3fd-200d-1f37c",
				"1f9d1-1f3fe-200d-1f37c",
				"1f9d1-1f3ff-200d-1f37c"
			],
			a: "13"
		},
		{
			n: [
				"baby",
				"face",
				"tale",
				"angel",
				"fairy",
				"church",
				"fantasy",
				"fairytale",
				"baby angel"
			],
			u: "1f47c",
			v: [
				"1f47c-1f3fb",
				"1f47c-1f3fc",
				"1f47c-1f3fd",
				"1f47c-1f3fe",
				"1f47c-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"tale",
				"xmas",
				"claus",
				"fairy",
				"merry",
				"santa",
				"father",
				"fantasy",
				"holiday",
				"christmas",
				"Santa Claus",
				"celebration"
			],
			u: "1f385",
			v: [
				"1f385-1f3fb",
				"1f385-1f3fc",
				"1f385-1f3fd",
				"1f385-1f3fe",
				"1f385-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"mrs",
				"tale",
				"xmas",
				"claus",
				"fairy",
				"merry",
				"santa",
				"mother",
				"fantasy",
				"holiday",
				"christmas",
				"Mrs. Claus",
				"celebration"
			],
			u: "1f936",
			v: [
				"1f936-1f3fb",
				"1f936-1f3fc",
				"1f936-1f3fd",
				"1f936-1f3fe",
				"1f936-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"mx",
				"tale",
				"xmas",
				"claus",
				"fairy",
				"merry",
				"santa",
				"fantasy",
				"holiday",
				"Mx Claus",
				"christmas",
				"celebration"
			],
			u: "1f9d1-200d-1f384",
			v: [
				"1f9d1-1f3fb-200d-1f384",
				"1f9d1-1f3fc-200d-1f384",
				"1f9d1-1f3fd-200d-1f384",
				"1f9d1-1f3fe-200d-1f384",
				"1f9d1-1f3ff-200d-1f384"
			],
			a: "13"
		},
		{
			n: [
				"good",
				"hero",
				"superhero",
				"superpower"
			],
			u: "1f9b8",
			v: [
				"1f9b8-1f3fb",
				"1f9b8-1f3fc",
				"1f9b8-1f3fd",
				"1f9b8-1f3fe",
				"1f9b8-1f3ff"
			],
			a: "11"
		},
		{
			n: [
				"man",
				"good",
				"hero",
				"superhero",
				"superpower",
				"man superhero"
			],
			u: "1f9b8-200d-2642-fe0f",
			v: [
				"1f9b8-1f3fb-200d-2642-fe0f",
				"1f9b8-1f3fc-200d-2642-fe0f",
				"1f9b8-1f3fd-200d-2642-fe0f",
				"1f9b8-1f3fe-200d-2642-fe0f",
				"1f9b8-1f3ff-200d-2642-fe0f"
			],
			a: "11"
		},
		{
			n: [
				"good",
				"hero",
				"woman",
				"heroine",
				"superhero",
				"superpower",
				"woman superhero"
			],
			u: "1f9b8-200d-2640-fe0f",
			v: [
				"1f9b8-1f3fb-200d-2640-fe0f",
				"1f9b8-1f3fc-200d-2640-fe0f",
				"1f9b8-1f3fd-200d-2640-fe0f",
				"1f9b8-1f3fe-200d-2640-fe0f",
				"1f9b8-1f3ff-200d-2640-fe0f"
			],
			a: "11"
		},
		{
			n: [
				"bad",
				"evil",
				"villain",
				"criminal",
				"superpower",
				"supervillain"
			],
			u: "1f9b9",
			v: [
				"1f9b9-1f3fb",
				"1f9b9-1f3fc",
				"1f9b9-1f3fd",
				"1f9b9-1f3fe",
				"1f9b9-1f3ff"
			],
			a: "11"
		},
		{
			n: [
				"bad",
				"man",
				"evil",
				"villain",
				"criminal",
				"superpower",
				"supervillain",
				"man supervillain"
			],
			u: "1f9b9-200d-2642-fe0f",
			v: [
				"1f9b9-1f3fb-200d-2642-fe0f",
				"1f9b9-1f3fc-200d-2642-fe0f",
				"1f9b9-1f3fd-200d-2642-fe0f",
				"1f9b9-1f3fe-200d-2642-fe0f",
				"1f9b9-1f3ff-200d-2642-fe0f"
			],
			a: "11"
		},
		{
			n: [
				"bad",
				"evil",
				"woman",
				"villain",
				"criminal",
				"superpower",
				"supervillain",
				"woman supervillain"
			],
			u: "1f9b9-200d-2640-fe0f",
			v: [
				"1f9b9-1f3fb-200d-2640-fe0f",
				"1f9b9-1f3fc-200d-2640-fe0f",
				"1f9b9-1f3fd-200d-2640-fe0f",
				"1f9b9-1f3fe-200d-2640-fe0f",
				"1f9b9-1f3ff-200d-2640-fe0f"
			],
			a: "11"
		},
		{
			n: [
				"mage",
				"play",
				"magic",
				"spell",
				"witch",
				"summon",
				"wizard",
				"fantasy",
				"sorcery",
				"sorcerer",
				"sorceress"
			],
			u: "1f9d9",
			v: [
				"1f9d9-1f3fb",
				"1f9d9-1f3fc",
				"1f9d9-1f3fd",
				"1f9d9-1f3fe",
				"1f9d9-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"mage",
				"play",
				"magic",
				"spell",
				"witch",
				"summon",
				"wizard",
				"fantasy",
				"sorcery",
				"man mage",
				"sorcerer",
				"sorceress"
			],
			u: "1f9d9-200d-2642-fe0f",
			v: [
				"1f9d9-1f3fb-200d-2642-fe0f",
				"1f9d9-1f3fc-200d-2642-fe0f",
				"1f9d9-1f3fd-200d-2642-fe0f",
				"1f9d9-1f3fe-200d-2642-fe0f",
				"1f9d9-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"mage",
				"play",
				"magic",
				"spell",
				"witch",
				"woman",
				"summon",
				"wizard",
				"fantasy",
				"sorcery",
				"sorcerer",
				"sorceress",
				"woman mage"
			],
			u: "1f9d9-200d-2640-fe0f",
			v: [
				"1f9d9-1f3fb-200d-2640-fe0f",
				"1f9d9-1f3fc-200d-2640-fe0f",
				"1f9d9-1f3fd-200d-2640-fe0f",
				"1f9d9-1f3fe-200d-2640-fe0f",
				"1f9d9-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"myth",
				"tale",
				"fairy",
				"pixie",
				"wings",
				"person",
				"fantasy",
				"fairytale"
			],
			u: "1f9da",
			v: [
				"1f9da-1f3fb",
				"1f9da-1f3fc",
				"1f9da-1f3fd",
				"1f9da-1f3fe",
				"1f9da-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"myth",
				"puck",
				"tale",
				"fairy",
				"pixie",
				"wings",
				"oberon",
				"person",
				"fantasy",
				"man fairy",
				"fairytale"
			],
			u: "1f9da-200d-2642-fe0f",
			v: [
				"1f9da-1f3fb-200d-2642-fe0f",
				"1f9da-1f3fc-200d-2642-fe0f",
				"1f9da-1f3fd-200d-2642-fe0f",
				"1f9da-1f3fe-200d-2642-fe0f",
				"1f9da-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"myth",
				"tale",
				"fairy",
				"pixie",
				"wings",
				"woman",
				"person",
				"fantasy",
				"titania",
				"fairytale",
				"woman fairy"
			],
			u: "1f9da-200d-2640-fe0f",
			v: [
				"1f9da-1f3fb-200d-2640-fe0f",
				"1f9da-1f3fc-200d-2640-fe0f",
				"1f9da-1f3fd-200d-2640-fe0f",
				"1f9da-1f3fe-200d-2640-fe0f",
				"1f9da-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"blood",
				"fangs",
				"scary",
				"teeth",
				"undead",
				"vampire",
				"dracula",
				"halloween",
				"supernatural"
			],
			u: "1f9db",
			v: [
				"1f9db-1f3fb",
				"1f9db-1f3fc",
				"1f9db-1f3fd",
				"1f9db-1f3fe",
				"1f9db-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"blood",
				"fangs",
				"scary",
				"teeth",
				"undead",
				"vampire",
				"halloween",
				"man vampire",
				"supernatural"
			],
			u: "1f9db-200d-2642-fe0f",
			v: [
				"1f9db-1f3fb-200d-2642-fe0f",
				"1f9db-1f3fc-200d-2642-fe0f",
				"1f9db-1f3fd-200d-2642-fe0f",
				"1f9db-1f3fe-200d-2642-fe0f",
				"1f9db-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"blood",
				"fangs",
				"scary",
				"teeth",
				"woman",
				"undead",
				"vampire",
				"halloween",
				"supernatural",
				"woman vampire"
			],
			u: "1f9db-200d-2640-fe0f",
			v: [
				"1f9db-1f3fb-200d-2640-fe0f",
				"1f9db-1f3fc-200d-2640-fe0f",
				"1f9db-1f3fd-200d-2640-fe0f",
				"1f9db-1f3fe-200d-2640-fe0f",
				"1f9db-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"sea",
				"ocean",
				"siren",
				"trident",
				"creature",
				"folklore",
				"merperson",
				"fairytale"
			],
			u: "1f9dc",
			v: [
				"1f9dc-1f3fb",
				"1f9dc-1f3fc",
				"1f9dc-1f3fd",
				"1f9dc-1f3fe",
				"1f9dc-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"sea",
				"ocean",
				"siren",
				"merman",
				"triton",
				"neptune",
				"trident",
				"creature",
				"folklore",
				"poseidon",
				"fairytale"
			],
			u: "1f9dc-200d-2642-fe0f",
			v: [
				"1f9dc-1f3fb-200d-2642-fe0f",
				"1f9dc-1f3fc-200d-2642-fe0f",
				"1f9dc-1f3fd-200d-2642-fe0f",
				"1f9dc-1f3fe-200d-2642-fe0f",
				"1f9dc-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"sea",
				"ocean",
				"siren",
				"mermaid",
				"trident",
				"creature",
				"folklore",
				"merwoman",
				"fairytale"
			],
			u: "1f9dc-200d-2640-fe0f",
			v: [
				"1f9dc-1f3fb-200d-2640-fe0f",
				"1f9dc-1f3fc-200d-2640-fe0f",
				"1f9dc-1f3fd-200d-2640-fe0f",
				"1f9dc-1f3fe-200d-2640-fe0f",
				"1f9dc-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"elf",
				"myth",
				"elves",
				"magic",
				"fantasy",
				"magical",
				"folklore",
				"enchantment"
			],
			u: "1f9dd",
			v: [
				"1f9dd-1f3fb",
				"1f9dd-1f3fc",
				"1f9dd-1f3fd",
				"1f9dd-1f3fe",
				"1f9dd-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"elf",
				"man",
				"myth",
				"elves",
				"magic",
				"man elf",
				"fantasy",
				"magical",
				"folklore",
				"enchantment"
			],
			u: "1f9dd-200d-2642-fe0f",
			v: [
				"1f9dd-1f3fb-200d-2642-fe0f",
				"1f9dd-1f3fc-200d-2642-fe0f",
				"1f9dd-1f3fd-200d-2642-fe0f",
				"1f9dd-1f3fe-200d-2642-fe0f",
				"1f9dd-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"elf",
				"myth",
				"elves",
				"magic",
				"woman",
				"fantasy",
				"magical",
				"folklore",
				"woman elf",
				"enchantment"
			],
			u: "1f9dd-200d-2640-fe0f",
			v: [
				"1f9dd-1f3fb-200d-2640-fe0f",
				"1f9dd-1f3fc-200d-2640-fe0f",
				"1f9dd-1f3fd-200d-2640-fe0f",
				"1f9dd-1f3fe-200d-2640-fe0f",
				"1f9dd-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"rub",
				"jinn",
				"lamp",
				"myth",
				"genie",
				"djinn",
				"wishes",
				"fantasy"
			],
			u: "1f9de",
			a: "5"
		},
		{
			n: [
				"man",
				"rub",
				"jinn",
				"lamp",
				"myth",
				"djinn",
				"genie",
				"wishes",
				"fantasy",
				"man genie"
			],
			u: "1f9de-200d-2642-fe0f",
			a: "5"
		},
		{
			n: [
				"rub",
				"jinn",
				"lamp",
				"myth",
				"djinn",
				"genie",
				"woman",
				"wishes",
				"fantasy",
				"woman genie"
			],
			u: "1f9de-200d-2640-fe0f",
			a: "5"
		},
		{
			n: [
				"dead",
				"scary",
				"zombie",
				"horror",
				"undead",
				"walking",
				"halloween",
				"apocalypse"
			],
			u: "1f9df",
			a: "5"
		},
		{
			n: [
				"man",
				"dead",
				"scary",
				"horror",
				"undead",
				"zombie",
				"walking",
				"halloween",
				"man zombie",
				"apocalypse"
			],
			u: "1f9df-200d-2642-fe0f",
			a: "5"
		},
		{
			n: [
				"dead",
				"scary",
				"woman",
				"horror",
				"undead",
				"zombie",
				"walking",
				"halloween",
				"apocalypse",
				"woman zombie"
			],
			u: "1f9df-200d-2640-fe0f",
			a: "5"
		},
		{
			n: [
				"tale",
				"troll",
				"fairy",
				"fantasy",
				"monster",
				"trolling"
			],
			u: "1f9cc",
			a: "14"
		},
		{
			n: [
				"spa",
				"face",
				"relax",
				"salon",
				"person",
				"soothe",
				"getting",
				"massage",
				"tension",
				"therapy",
				"headache",
				"relaxing",
				"treatment",
				"person getting massage"
			],
			u: "1f486",
			v: [
				"1f486-1f3fb",
				"1f486-1f3fc",
				"1f486-1f3fd",
				"1f486-1f3fe",
				"1f486-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"spa",
				"face",
				"relax",
				"salon",
				"soothe",
				"getting",
				"massage",
				"tension",
				"therapy",
				"headache",
				"relaxing",
				"treatment",
				"man getting massage"
			],
			u: "1f486-200d-2642-fe0f",
			v: [
				"1f486-1f3fb-200d-2642-fe0f",
				"1f486-1f3fc-200d-2642-fe0f",
				"1f486-1f3fd-200d-2642-fe0f",
				"1f486-1f3fe-200d-2642-fe0f",
				"1f486-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"spa",
				"face",
				"relax",
				"salon",
				"woman",
				"soothe",
				"getting",
				"massage",
				"tension",
				"therapy",
				"headache",
				"relaxing",
				"treatment",
				"woman getting massage"
			],
			u: "1f486-200d-2640-fe0f",
			v: [
				"1f486-1f3fb-200d-2640-fe0f",
				"1f486-1f3fc-200d-2640-fe0f",
				"1f486-1f3fd-200d-2640-fe0f",
				"1f486-1f3fe-200d-2640-fe0f",
				"1f486-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"cut",
				"chop",
				"hair",
				"groom",
				"style",
				"barber",
				"beauty",
				"parlor",
				"person",
				"shears",
				"haircut",
				"cosmetology",
				"person getting haircut"
			],
			u: "1f487",
			v: [
				"1f487-1f3fb",
				"1f487-1f3fc",
				"1f487-1f3fd",
				"1f487-1f3fe",
				"1f487-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"cut",
				"man",
				"chop",
				"hair",
				"groom",
				"style",
				"barber",
				"beauty",
				"parlor",
				"person",
				"shears",
				"haircut",
				"cosmetology",
				"man getting haircut"
			],
			u: "1f487-200d-2642-fe0f",
			v: [
				"1f487-1f3fb-200d-2642-fe0f",
				"1f487-1f3fc-200d-2642-fe0f",
				"1f487-1f3fd-200d-2642-fe0f",
				"1f487-1f3fe-200d-2642-fe0f",
				"1f487-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"cut",
				"chop",
				"hair",
				"groom",
				"style",
				"woman",
				"barber",
				"beauty",
				"parlor",
				"person",
				"shears",
				"haircut",
				"cosmetology",
				"woman getting haircut"
			],
			u: "1f487-200d-2640-fe0f",
			v: [
				"1f487-1f3fb-200d-2640-fe0f",
				"1f487-1f3fc-200d-2640-fe0f",
				"1f487-1f3fd-200d-2640-fe0f",
				"1f487-1f3fe-200d-2640-fe0f",
				"1f487-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"person",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"person walking"
			],
			u: "1f6b6",
			v: [
				"1f6b6-1f3fb",
				"1f6b6-1f3fc",
				"1f6b6-1f3fd",
				"1f6b6-1f3fe",
				"1f6b6-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"man walking"
			],
			u: "1f6b6-200d-2642-fe0f",
			v: [
				"1f6b6-1f3fb-200d-2642-fe0f",
				"1f6b6-1f3fc-200d-2642-fe0f",
				"1f6b6-1f3fd-200d-2642-fe0f",
				"1f6b6-1f3fe-200d-2642-fe0f",
				"1f6b6-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"woman",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"woman walking"
			],
			u: "1f6b6-200d-2640-fe0f",
			v: [
				"1f6b6-1f3fb-200d-2640-fe0f",
				"1f6b6-1f3fc-200d-2640-fe0f",
				"1f6b6-1f3fd-200d-2640-fe0f",
				"1f6b6-1f3fe-200d-2640-fe0f",
				"1f6b6-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"right",
				"facing",
				"person",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"person walking: facing right"
			],
			u: "1f6b6-200d-27a1-fe0f",
			v: [
				"1f6b6-1f3fb-200d-27a1-fe0f",
				"1f6b6-1f3fc-200d-27a1-fe0f",
				"1f6b6-1f3fd-200d-27a1-fe0f",
				"1f6b6-1f3fe-200d-27a1-fe0f",
				"1f6b6-1f3ff-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"right",
				"woman",
				"facing",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"woman walking: facing right"
			],
			u: "1f6b6-200d-2640-fe0f-200d-27a1-fe0f",
			v: [
				"1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"gait",
				"hike",
				"pace",
				"walk",
				"amble",
				"right",
				"facing",
				"stride",
				"stroll",
				"walking",
				"pedestrian",
				"man walking: facing right"
			],
			u: "1f6b6-200d-2642-fe0f-200d-27a1-fe0f",
			v: [
				"1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
				"1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"stand",
				"person",
				"standing",
				"person standing"
			],
			u: "1f9cd",
			v: [
				"1f9cd-1f3fb",
				"1f9cd-1f3fc",
				"1f9cd-1f3fd",
				"1f9cd-1f3fe",
				"1f9cd-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"man",
				"stand",
				"standing",
				"man standing"
			],
			u: "1f9cd-200d-2642-fe0f",
			v: [
				"1f9cd-1f3fb-200d-2642-fe0f",
				"1f9cd-1f3fc-200d-2642-fe0f",
				"1f9cd-1f3fd-200d-2642-fe0f",
				"1f9cd-1f3fe-200d-2642-fe0f",
				"1f9cd-1f3ff-200d-2642-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"stand",
				"woman",
				"standing",
				"woman standing"
			],
			u: "1f9cd-200d-2640-fe0f",
			v: [
				"1f9cd-1f3fb-200d-2640-fe0f",
				"1f9cd-1f3fc-200d-2640-fe0f",
				"1f9cd-1f3fd-200d-2640-fe0f",
				"1f9cd-1f3fe-200d-2640-fe0f",
				"1f9cd-1f3ff-200d-2640-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"kneel",
				"knees",
				"person",
				"kneeling",
				"person kneeling"
			],
			u: "1f9ce",
			v: [
				"1f9ce-1f3fb",
				"1f9ce-1f3fc",
				"1f9ce-1f3fd",
				"1f9ce-1f3fe",
				"1f9ce-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"man",
				"kneel",
				"knees",
				"kneeling",
				"man kneeling"
			],
			u: "1f9ce-200d-2642-fe0f",
			v: [
				"1f9ce-1f3fb-200d-2642-fe0f",
				"1f9ce-1f3fc-200d-2642-fe0f",
				"1f9ce-1f3fd-200d-2642-fe0f",
				"1f9ce-1f3fe-200d-2642-fe0f",
				"1f9ce-1f3ff-200d-2642-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"kneel",
				"knees",
				"woman",
				"kneeling",
				"woman kneeling"
			],
			u: "1f9ce-200d-2640-fe0f",
			v: [
				"1f9ce-1f3fb-200d-2640-fe0f",
				"1f9ce-1f3fc-200d-2640-fe0f",
				"1f9ce-1f3fd-200d-2640-fe0f",
				"1f9ce-1f3fe-200d-2640-fe0f",
				"1f9ce-1f3ff-200d-2640-fe0f"
			],
			a: "12"
		},
		{
			n: [
				"kneel",
				"knees",
				"right",
				"facing",
				"person",
				"kneeling",
				"person kneeling: facing right"
			],
			u: "1f9ce-200d-27a1-fe0f",
			v: [
				"1f9ce-1f3fb-200d-27a1-fe0f",
				"1f9ce-1f3fc-200d-27a1-fe0f",
				"1f9ce-1f3fd-200d-27a1-fe0f",
				"1f9ce-1f3fe-200d-27a1-fe0f",
				"1f9ce-1f3ff-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"kneel",
				"knees",
				"right",
				"woman",
				"facing",
				"kneeling",
				"woman kneeling: facing right"
			],
			u: "1f9ce-200d-2640-fe0f-200d-27a1-fe0f",
			v: [
				"1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"kneel",
				"knees",
				"right",
				"facing",
				"kneeling",
				"man kneeling: facing right"
			],
			u: "1f9ce-200d-2642-fe0f-200d-27a1-fe0f",
			v: [
				"1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
				"1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"cane",
				"blind",
				"white",
				"person",
				"probing",
				"accessibility",
				"person with white cane"
			],
			u: "1f9d1-200d-1f9af",
			v: [
				"1f9d1-1f3fb-200d-1f9af",
				"1f9d1-1f3fc-200d-1f9af",
				"1f9d1-1f3fd-200d-1f9af",
				"1f9d1-1f3fe-200d-1f9af",
				"1f9d1-1f3ff-200d-1f9af"
			],
			a: "12.1"
		},
		{
			n: [
				"cane",
				"blind",
				"right",
				"white",
				"facing",
				"person",
				"probing",
				"accessibility",
				"person with white cane: facing right"
			],
			u: "1f9d1-200d-1f9af-200d-27a1-fe0f",
			v: [
				"1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f",
				"1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f",
				"1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f",
				"1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f",
				"1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"cane",
				"blind",
				"white",
				"probing",
				"accessibility",
				"man with white cane"
			],
			u: "1f468-200d-1f9af",
			v: [
				"1f468-1f3fb-200d-1f9af",
				"1f468-1f3fc-200d-1f9af",
				"1f468-1f3fd-200d-1f9af",
				"1f468-1f3fe-200d-1f9af",
				"1f468-1f3ff-200d-1f9af"
			],
			a: "12"
		},
		{
			n: [
				"man",
				"cane",
				"blind",
				"right",
				"white",
				"facing",
				"probing",
				"accessibility",
				"man with white cane: facing right"
			],
			u: "1f468-200d-1f9af-200d-27a1-fe0f",
			v: [
				"1f468-1f3fb-200d-1f9af-200d-27a1-fe0f",
				"1f468-1f3fc-200d-1f9af-200d-27a1-fe0f",
				"1f468-1f3fd-200d-1f9af-200d-27a1-fe0f",
				"1f468-1f3fe-200d-1f9af-200d-27a1-fe0f",
				"1f468-1f3ff-200d-1f9af-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"cane",
				"blind",
				"white",
				"woman",
				"probing",
				"accessibility",
				"woman with white cane"
			],
			u: "1f469-200d-1f9af",
			v: [
				"1f469-1f3fb-200d-1f9af",
				"1f469-1f3fc-200d-1f9af",
				"1f469-1f3fd-200d-1f9af",
				"1f469-1f3fe-200d-1f9af",
				"1f469-1f3ff-200d-1f9af"
			],
			a: "12"
		},
		{
			n: [
				"cane",
				"blind",
				"right",
				"white",
				"woman",
				"facing",
				"probing",
				"accessibility",
				"woman with white cane: facing right"
			],
			u: "1f469-200d-1f9af-200d-27a1-fe0f",
			v: [
				"1f469-1f3fb-200d-1f9af-200d-27a1-fe0f",
				"1f469-1f3fc-200d-1f9af-200d-27a1-fe0f",
				"1f469-1f3fd-200d-1f9af-200d-27a1-fe0f",
				"1f469-1f3fe-200d-1f9af-200d-27a1-fe0f",
				"1f469-1f3ff-200d-1f9af-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"person",
				"motorized",
				"wheelchair",
				"accessibility",
				"person in motorized wheelchair"
			],
			u: "1f9d1-200d-1f9bc",
			v: [
				"1f9d1-1f3fb-200d-1f9bc",
				"1f9d1-1f3fc-200d-1f9bc",
				"1f9d1-1f3fd-200d-1f9bc",
				"1f9d1-1f3fe-200d-1f9bc",
				"1f9d1-1f3ff-200d-1f9bc"
			],
			a: "12.1"
		},
		{
			n: [
				"right",
				"facing",
				"person",
				"motorized",
				"wheelchair",
				"accessibility",
				"person in motorized wheelchair: facing right"
			],
			u: "1f9d1-200d-1f9bc-200d-27a1-fe0f",
			v: [
				"1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f",
				"1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f",
				"1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f",
				"1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f",
				"1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"motorized",
				"wheelchair",
				"accessibility",
				"man in motorized wheelchair"
			],
			u: "1f468-200d-1f9bc",
			v: [
				"1f468-1f3fb-200d-1f9bc",
				"1f468-1f3fc-200d-1f9bc",
				"1f468-1f3fd-200d-1f9bc",
				"1f468-1f3fe-200d-1f9bc",
				"1f468-1f3ff-200d-1f9bc"
			],
			a: "12"
		},
		{
			n: [
				"man",
				"right",
				"facing",
				"motorized",
				"wheelchair",
				"accessibility",
				"man in motorized wheelchair: facing right"
			],
			u: "1f468-200d-1f9bc-200d-27a1-fe0f",
			v: [
				"1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f",
				"1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f",
				"1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f",
				"1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f",
				"1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"woman",
				"motorized",
				"wheelchair",
				"accessibility",
				"woman in motorized wheelchair"
			],
			u: "1f469-200d-1f9bc",
			v: [
				"1f469-1f3fb-200d-1f9bc",
				"1f469-1f3fc-200d-1f9bc",
				"1f469-1f3fd-200d-1f9bc",
				"1f469-1f3fe-200d-1f9bc",
				"1f469-1f3ff-200d-1f9bc"
			],
			a: "12"
		},
		{
			n: [
				"right",
				"woman",
				"facing",
				"motorized",
				"wheelchair",
				"accessibility",
				"woman in motorized wheelchair: facing right"
			],
			u: "1f469-200d-1f9bc-200d-27a1-fe0f",
			v: [
				"1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f",
				"1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f",
				"1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f",
				"1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f",
				"1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"manual",
				"person",
				"wheelchair",
				"accessibility",
				"person in manual wheelchair"
			],
			u: "1f9d1-200d-1f9bd",
			v: [
				"1f9d1-1f3fb-200d-1f9bd",
				"1f9d1-1f3fc-200d-1f9bd",
				"1f9d1-1f3fd-200d-1f9bd",
				"1f9d1-1f3fe-200d-1f9bd",
				"1f9d1-1f3ff-200d-1f9bd"
			],
			a: "12.1"
		},
		{
			n: [
				"right",
				"facing",
				"manual",
				"person",
				"wheelchair",
				"accessibility",
				"person in manual wheelchair: facing right"
			],
			u: "1f9d1-200d-1f9bd-200d-27a1-fe0f",
			v: [
				"1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f",
				"1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f",
				"1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f",
				"1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f",
				"1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"manual",
				"wheelchair",
				"accessibility",
				"man in manual wheelchair"
			],
			u: "1f468-200d-1f9bd",
			v: [
				"1f468-1f3fb-200d-1f9bd",
				"1f468-1f3fc-200d-1f9bd",
				"1f468-1f3fd-200d-1f9bd",
				"1f468-1f3fe-200d-1f9bd",
				"1f468-1f3ff-200d-1f9bd"
			],
			a: "12"
		},
		{
			n: [
				"man",
				"right",
				"facing",
				"manual",
				"wheelchair",
				"accessibility",
				"man in manual wheelchair: facing right"
			],
			u: "1f468-200d-1f9bd-200d-27a1-fe0f",
			v: [
				"1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f",
				"1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f",
				"1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f",
				"1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f",
				"1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"woman",
				"manual",
				"wheelchair",
				"accessibility",
				"woman in manual wheelchair"
			],
			u: "1f469-200d-1f9bd",
			v: [
				"1f469-1f3fb-200d-1f9bd",
				"1f469-1f3fc-200d-1f9bd",
				"1f469-1f3fd-200d-1f9bd",
				"1f469-1f3fe-200d-1f9bd",
				"1f469-1f3ff-200d-1f9bd"
			],
			a: "12"
		},
		{
			n: [
				"right",
				"woman",
				"facing",
				"manual",
				"wheelchair",
				"accessibility",
				"woman in manual wheelchair: facing right"
			],
			u: "1f469-200d-1f9bd-200d-27a1-fe0f",
			v: [
				"1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f",
				"1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f",
				"1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f",
				"1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f",
				"1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"speed",
				"person",
				"racing",
				"marathon",
				"person running"
			],
			u: "1f3c3",
			v: [
				"1f3c3-1f3fb",
				"1f3c3-1f3fc",
				"1f3c3-1f3fd",
				"1f3c3-1f3fe",
				"1f3c3-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"speed",
				"racing",
				"marathon",
				"man running"
			],
			u: "1f3c3-200d-2642-fe0f",
			v: [
				"1f3c3-1f3fb-200d-2642-fe0f",
				"1f3c3-1f3fc-200d-2642-fe0f",
				"1f3c3-1f3fd-200d-2642-fe0f",
				"1f3c3-1f3fe-200d-2642-fe0f",
				"1f3c3-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"speed",
				"woman",
				"racing",
				"marathon",
				"woman running"
			],
			u: "1f3c3-200d-2640-fe0f",
			v: [
				"1f3c3-1f3fb-200d-2640-fe0f",
				"1f3c3-1f3fc-200d-2640-fe0f",
				"1f3c3-1f3fd-200d-2640-fe0f",
				"1f3c3-1f3fe-200d-2640-fe0f",
				"1f3c3-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"right",
				"speed",
				"facing",
				"person",
				"racing",
				"marathon",
				"person running: facing right"
			],
			u: "1f3c3-200d-27a1-fe0f",
			v: [
				"1f3c3-1f3fb-200d-27a1-fe0f",
				"1f3c3-1f3fc-200d-27a1-fe0f",
				"1f3c3-1f3fd-200d-27a1-fe0f",
				"1f3c3-1f3fe-200d-27a1-fe0f",
				"1f3c3-1f3ff-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"right",
				"speed",
				"woman",
				"facing",
				"racing",
				"marathon",
				"woman running: facing right"
			],
			u: "1f3c3-200d-2640-fe0f-200d-27a1-fe0f",
			v: [
				"1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"man",
				"run",
				"fast",
				"move",
				"race",
				"rush",
				"hurry",
				"quick",
				"right",
				"speed",
				"facing",
				"racing",
				"marathon",
				"man running: facing right"
			],
			u: "1f3c3-200d-2642-fe0f-200d-27a1-fe0f",
			v: [
				"1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
				"1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
			],
			a: "15.1"
		},
		{
			n: [
				"dance",
				"flair",
				"let’s",
				"salsa",
				"tango",
				"woman",
				"dancer",
				"groove",
				"dancing",
				"elegant",
				"festive",
				"flamenco",
				"woman dancing"
			],
			u: "1f483",
			v: [
				"1f483-1f3fb",
				"1f483-1f3fc",
				"1f483-1f3fd",
				"1f483-1f3fe",
				"1f483-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"dance",
				"flair",
				"let’s",
				"salsa",
				"tango",
				"dancer",
				"groove",
				"dancing",
				"elegant",
				"festive",
				"flamenco",
				"man dancing"
			],
			u: "1f57a",
			v: [
				"1f57a-1f3fb",
				"1f57a-1f3fc",
				"1f57a-1f3fd",
				"1f57a-1f3fe",
				"1f57a-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"suit",
				"person",
				"business",
				"levitating",
				"person in suit levitating"
			],
			u: "1f574-fe0f",
			v: [
				"1f574-1f3fb",
				"1f574-1f3fc",
				"1f574-1f3fd",
				"1f574-1f3fe",
				"1f574-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"bff",
				"ear",
				"pair",
				"twin",
				"bunny",
				"party",
				"bestie",
				"dancer",
				"double",
				"people",
				"partying",
				"soulmate",
				"twinsies",
				"identical",
				"counterpart",
				"people with bunny ears"
			],
			u: "1f46f",
			v: [
				"1f46f-1f3fb",
				"1f46f-1f3fc",
				"1f46f-1f3fd",
				"1f46f-1f3fe",
				"1f46f-1f3ff",
				"1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fc",
				"1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fd",
				"1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3fe",
				"1f9d1-1f3fb-200d-1f430-200d-1f9d1-1f3ff",
				"1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fb",
				"1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fd",
				"1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3fe",
				"1f9d1-1f3fc-200d-1f430-200d-1f9d1-1f3ff",
				"1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fb",
				"1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fc",
				"1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3fe",
				"1f9d1-1f3fd-200d-1f430-200d-1f9d1-1f3ff",
				"1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fb",
				"1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fc",
				"1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3fd",
				"1f9d1-1f3fe-200d-1f430-200d-1f9d1-1f3ff",
				"1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fb",
				"1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fc",
				"1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fd",
				"1f9d1-1f3ff-200d-1f430-200d-1f9d1-1f3fe"
			],
			a: "0.6"
		},
		{
			n: [
				"bff",
				"ear",
				"men",
				"pair",
				"twin",
				"bunny",
				"party",
				"bestie",
				"dancer",
				"double",
				"people",
				"partying",
				"soulmate",
				"twinsies",
				"identical",
				"counterpart",
				"men with bunny ears"
			],
			u: "1f46f-200d-2642-fe0f",
			v: [
				"1f468-1f3fb-200d-1f430-200d-1f468-1f3fc",
				"1f468-1f3fb-200d-1f430-200d-1f468-1f3fd",
				"1f468-1f3fb-200d-1f430-200d-1f468-1f3fe",
				"1f468-1f3fb-200d-1f430-200d-1f468-1f3ff",
				"1f468-1f3fc-200d-1f430-200d-1f468-1f3fb",
				"1f468-1f3fc-200d-1f430-200d-1f468-1f3fd",
				"1f468-1f3fc-200d-1f430-200d-1f468-1f3fe",
				"1f468-1f3fc-200d-1f430-200d-1f468-1f3ff",
				"1f468-1f3fd-200d-1f430-200d-1f468-1f3fb",
				"1f468-1f3fd-200d-1f430-200d-1f468-1f3fc",
				"1f468-1f3fd-200d-1f430-200d-1f468-1f3fe",
				"1f468-1f3fd-200d-1f430-200d-1f468-1f3ff",
				"1f468-1f3fe-200d-1f430-200d-1f468-1f3fb",
				"1f468-1f3fe-200d-1f430-200d-1f468-1f3fc",
				"1f468-1f3fe-200d-1f430-200d-1f468-1f3fd",
				"1f468-1f3fe-200d-1f430-200d-1f468-1f3ff",
				"1f468-1f3ff-200d-1f430-200d-1f468-1f3fb",
				"1f468-1f3ff-200d-1f430-200d-1f468-1f3fc",
				"1f468-1f3ff-200d-1f430-200d-1f468-1f3fd",
				"1f468-1f3ff-200d-1f430-200d-1f468-1f3fe",
				"1f46f-1f3fb-200d-2642-fe0f",
				"1f46f-1f3fc-200d-2642-fe0f",
				"1f46f-1f3fd-200d-2642-fe0f",
				"1f46f-1f3fe-200d-2642-fe0f",
				"1f46f-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"bff",
				"ear",
				"pair",
				"twin",
				"bunny",
				"party",
				"women",
				"bestie",
				"dancer",
				"double",
				"people",
				"partying",
				"soulmate",
				"twinsies",
				"identical",
				"counterpart",
				"women with bunny ears"
			],
			u: "1f46f-200d-2640-fe0f",
			v: [
				"1f469-1f3fb-200d-1f430-200d-1f469-1f3fc",
				"1f469-1f3fb-200d-1f430-200d-1f469-1f3fd",
				"1f469-1f3fb-200d-1f430-200d-1f469-1f3fe",
				"1f469-1f3fb-200d-1f430-200d-1f469-1f3ff",
				"1f469-1f3fc-200d-1f430-200d-1f469-1f3fb",
				"1f469-1f3fc-200d-1f430-200d-1f469-1f3fd",
				"1f469-1f3fc-200d-1f430-200d-1f469-1f3fe",
				"1f469-1f3fc-200d-1f430-200d-1f469-1f3ff",
				"1f469-1f3fd-200d-1f430-200d-1f469-1f3fb",
				"1f469-1f3fd-200d-1f430-200d-1f469-1f3fc",
				"1f469-1f3fd-200d-1f430-200d-1f469-1f3fe",
				"1f469-1f3fd-200d-1f430-200d-1f469-1f3ff",
				"1f469-1f3fe-200d-1f430-200d-1f469-1f3fb",
				"1f469-1f3fe-200d-1f430-200d-1f469-1f3fc",
				"1f469-1f3fe-200d-1f430-200d-1f469-1f3fd",
				"1f469-1f3fe-200d-1f430-200d-1f469-1f3ff",
				"1f469-1f3ff-200d-1f430-200d-1f469-1f3fb",
				"1f469-1f3ff-200d-1f430-200d-1f469-1f3fc",
				"1f469-1f3ff-200d-1f430-200d-1f469-1f3fd",
				"1f469-1f3ff-200d-1f430-200d-1f469-1f3fe",
				"1f46f-1f3fb-200d-2640-fe0f",
				"1f46f-1f3fc-200d-2640-fe0f",
				"1f46f-1f3fd-200d-2640-fe0f",
				"1f46f-1f3fe-200d-2640-fe0f",
				"1f46f-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"day",
				"spa",
				"room",
				"relax",
				"sauna",
				"steam",
				"pamper",
				"person",
				"unwind",
				"luxurious",
				"steambath",
				"person in steamy room"
			],
			u: "1f9d6",
			v: [
				"1f9d6-1f3fb",
				"1f9d6-1f3fc",
				"1f9d6-1f3fd",
				"1f9d6-1f3fe",
				"1f9d6-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"day",
				"man",
				"spa",
				"room",
				"relax",
				"sauna",
				"steam",
				"pamper",
				"unwind",
				"luxurious",
				"steambath",
				"man in steamy room"
			],
			u: "1f9d6-200d-2642-fe0f",
			v: [
				"1f9d6-1f3fb-200d-2642-fe0f",
				"1f9d6-1f3fc-200d-2642-fe0f",
				"1f9d6-1f3fd-200d-2642-fe0f",
				"1f9d6-1f3fe-200d-2642-fe0f",
				"1f9d6-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"day",
				"spa",
				"room",
				"relax",
				"sauna",
				"steam",
				"woman",
				"pamper",
				"unwind",
				"luxurious",
				"steambath",
				"woman in steamy room"
			],
			u: "1f9d6-200d-2640-fe0f",
			v: [
				"1f9d6-1f3fb-200d-2640-fe0f",
				"1f9d6-1f3fc-200d-2640-fe0f",
				"1f9d6-1f3fd-200d-2640-fe0f",
				"1f9d6-1f3fe-200d-2640-fe0f",
				"1f9d6-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"up",
				"rock",
				"climb",
				"scale",
				"person",
				"climber",
				"climbing",
				"mountain",
				"person climbing"
			],
			u: "1f9d7",
			v: [
				"1f9d7-1f3fb",
				"1f9d7-1f3fc",
				"1f9d7-1f3fd",
				"1f9d7-1f3fe",
				"1f9d7-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"up",
				"man",
				"rock",
				"climb",
				"scale",
				"climber",
				"climbing",
				"mountain",
				"man climbing"
			],
			u: "1f9d7-200d-2642-fe0f",
			v: [
				"1f9d7-1f3fb-200d-2642-fe0f",
				"1f9d7-1f3fc-200d-2642-fe0f",
				"1f9d7-1f3fd-200d-2642-fe0f",
				"1f9d7-1f3fe-200d-2642-fe0f",
				"1f9d7-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"up",
				"rock",
				"climb",
				"scale",
				"woman",
				"climber",
				"climbing",
				"mountain",
				"woman climbing"
			],
			u: "1f9d7-200d-2640-fe0f",
			v: [
				"1f9d7-1f3fb-200d-2640-fe0f",
				"1f9d7-1f3fc-200d-2640-fe0f",
				"1f9d7-1f3fd-200d-2640-fe0f",
				"1f9d7-1f3fe-200d-2640-fe0f",
				"1f9d7-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"sword",
				"fencer",
				"person",
				"fencing",
				"person fencing"
			],
			u: "1f93a",
			a: "3"
		},
		{
			n: [
				"horse",
				"sport",
				"jockey",
				"racing",
				"riding",
				"racehorse",
				"horse racing"
			],
			u: "1f3c7",
			v: [
				"1f3c7-1f3fb",
				"1f3c7-1f3fc",
				"1f3c7-1f3fd",
				"1f3c7-1f3fe",
				"1f3c7-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"ski",
				"snow",
				"skier"
			],
			u: "26f7-fe0f",
			a: "0.7"
		},
		{
			n: [
				"ski",
				"snow",
				"sport",
				"snowboard",
				"snowboarder"
			],
			u: "1f3c2",
			v: [
				"1f3c2-1f3fb",
				"1f3c2-1f3fc",
				"1f3c2-1f3fd",
				"1f3c2-1f3fe",
				"1f3c2-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"pga",
				"tee",
				"ball",
				"golf",
				"putt",
				"caddy",
				"green",
				"range",
				"birdie",
				"person",
				"driving",
				"golfing",
				"person golfing"
			],
			u: "1f3cc-fe0f",
			v: [
				"1f3cc-1f3fb",
				"1f3cc-1f3fc",
				"1f3cc-1f3fd",
				"1f3cc-1f3fe",
				"1f3cc-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"man",
				"pga",
				"tee",
				"ball",
				"golf",
				"putt",
				"caddy",
				"green",
				"range",
				"birdie",
				"driving",
				"golfing",
				"man golfing"
			],
			u: "1f3cc-fe0f-200d-2642-fe0f",
			v: [
				"1f3cc-1f3fb-200d-2642-fe0f",
				"1f3cc-1f3fc-200d-2642-fe0f",
				"1f3cc-1f3fd-200d-2642-fe0f",
				"1f3cc-1f3fe-200d-2642-fe0f",
				"1f3cc-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"pga",
				"tee",
				"ball",
				"golf",
				"putt",
				"caddy",
				"green",
				"range",
				"woman",
				"birdie",
				"driving",
				"golfing",
				"woman golfing"
			],
			u: "1f3cc-fe0f-200d-2640-fe0f",
			v: [
				"1f3cc-1f3fb-200d-2640-fe0f",
				"1f3cc-1f3fc-200d-2640-fe0f",
				"1f3cc-1f3fd-200d-2640-fe0f",
				"1f3cc-1f3fe-200d-2640-fe0f",
				"1f3cc-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"surf",
				"beach",
				"ocean",
				"sport",
				"swell",
				"waves",
				"person",
				"surfer",
				"surfing",
				"person surfing"
			],
			u: "1f3c4",
			v: [
				"1f3c4-1f3fb",
				"1f3c4-1f3fc",
				"1f3c4-1f3fd",
				"1f3c4-1f3fe",
				"1f3c4-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"surf",
				"beach",
				"ocean",
				"sport",
				"swell",
				"waves",
				"surfer",
				"surfing",
				"man surfing"
			],
			u: "1f3c4-200d-2642-fe0f",
			v: [
				"1f3c4-1f3fb-200d-2642-fe0f",
				"1f3c4-1f3fc-200d-2642-fe0f",
				"1f3c4-1f3fd-200d-2642-fe0f",
				"1f3c4-1f3fe-200d-2642-fe0f",
				"1f3c4-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"surf",
				"beach",
				"ocean",
				"sport",
				"swell",
				"waves",
				"person",
				"surfer",
				"surfing",
				"woman surfing"
			],
			u: "1f3c4-200d-2640-fe0f",
			v: [
				"1f3c4-1f3fb-200d-2640-fe0f",
				"1f3c4-1f3fc-200d-2640-fe0f",
				"1f3c4-1f3fd-200d-2640-fe0f",
				"1f3c4-1f3fe-200d-2640-fe0f",
				"1f3c4-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"oar",
				"row",
				"boat",
				"lake",
				"raft",
				"canoe",
				"river",
				"cruise",
				"paddle",
				"person",
				"rowing",
				"fishing",
				"rowboat",
				"person rowing boat"
			],
			u: "1f6a3",
			v: [
				"1f6a3-1f3fb",
				"1f6a3-1f3fc",
				"1f6a3-1f3fd",
				"1f6a3-1f3fe",
				"1f6a3-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"man",
				"oar",
				"row",
				"boat",
				"lake",
				"raft",
				"canoe",
				"river",
				"cruise",
				"paddle",
				"rowing",
				"fishing",
				"rowboat",
				"man rowing boat"
			],
			u: "1f6a3-200d-2642-fe0f",
			v: [
				"1f6a3-1f3fb-200d-2642-fe0f",
				"1f6a3-1f3fc-200d-2642-fe0f",
				"1f6a3-1f3fd-200d-2642-fe0f",
				"1f6a3-1f3fe-200d-2642-fe0f",
				"1f6a3-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"oar",
				"row",
				"boat",
				"lake",
				"raft",
				"canoe",
				"river",
				"woman",
				"cruise",
				"paddle",
				"rowing",
				"fishing",
				"rowboat",
				"woman rowing boat"
			],
			u: "1f6a3-200d-2640-fe0f",
			v: [
				"1f6a3-1f3fb-200d-2640-fe0f",
				"1f6a3-1f3fc-200d-2640-fe0f",
				"1f6a3-1f3fd-200d-2640-fe0f",
				"1f6a3-1f3fe-200d-2640-fe0f",
				"1f6a3-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"swim",
				"sport",
				"person",
				"swimmer",
				"swimming",
				"freestyle",
				"triathlon",
				"person swimming"
			],
			u: "1f3ca",
			v: [
				"1f3ca-1f3fb",
				"1f3ca-1f3fc",
				"1f3ca-1f3fd",
				"1f3ca-1f3fe",
				"1f3ca-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"man",
				"swim",
				"sport",
				"swimmer",
				"swimming",
				"freestyle",
				"triathlon",
				"man swimming"
			],
			u: "1f3ca-200d-2642-fe0f",
			v: [
				"1f3ca-1f3fb-200d-2642-fe0f",
				"1f3ca-1f3fc-200d-2642-fe0f",
				"1f3ca-1f3fd-200d-2642-fe0f",
				"1f3ca-1f3fe-200d-2642-fe0f",
				"1f3ca-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"man",
				"swim",
				"sport",
				"swimmer",
				"swimming",
				"freestyle",
				"triathlon",
				"woman swimming"
			],
			u: "1f3ca-200d-2640-fe0f",
			v: [
				"1f3ca-1f3fb-200d-2640-fe0f",
				"1f3ca-1f3fc-200d-2640-fe0f",
				"1f3ca-1f3fd-200d-2640-fe0f",
				"1f3ca-1f3fe-200d-2640-fe0f",
				"1f3ca-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"net",
				"ball",
				"throw",
				"person",
				"player",
				"dribble",
				"athletic",
				"bouncing",
				"basketball",
				"championship",
				"person bouncing ball"
			],
			u: "26f9-fe0f",
			v: [
				"26f9-1f3fb",
				"26f9-1f3fc",
				"26f9-1f3fd",
				"26f9-1f3fe",
				"26f9-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"man",
				"net",
				"ball",
				"throw",
				"player",
				"dribble",
				"athletic",
				"bouncing",
				"basketball",
				"championship",
				"man bouncing ball"
			],
			u: "26f9-fe0f-200d-2642-fe0f",
			v: [
				"26f9-1f3fb-200d-2642-fe0f",
				"26f9-1f3fc-200d-2642-fe0f",
				"26f9-1f3fd-200d-2642-fe0f",
				"26f9-1f3fe-200d-2642-fe0f",
				"26f9-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"net",
				"ball",
				"throw",
				"woman",
				"player",
				"dribble",
				"athletic",
				"bouncing",
				"basketball",
				"championship",
				"woman bouncing ball"
			],
			u: "26f9-fe0f-200d-2640-fe0f",
			v: [
				"26f9-1f3fb-200d-2640-fe0f",
				"26f9-1f3fc-200d-2640-fe0f",
				"26f9-1f3fd-200d-2640-fe0f",
				"26f9-1f3fe-200d-2640-fe0f",
				"26f9-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"lifter",
				"person",
				"weight",
				"barbell",
				"lifting",
				"weights",
				"workout",
				"deadlift",
				"bodybuilder",
				"powerlifting",
				"weightlifter",
				"person lifting weights"
			],
			u: "1f3cb-fe0f",
			v: [
				"1f3cb-1f3fb",
				"1f3cb-1f3fc",
				"1f3cb-1f3fd",
				"1f3cb-1f3fe",
				"1f3cb-1f3ff"
			],
			a: "0.7"
		},
		{
			n: [
				"man",
				"lifter",
				"weight",
				"barbell",
				"lifting",
				"weights",
				"workout",
				"deadlift",
				"bodybuilder",
				"powerlifting",
				"weightlifter",
				"man lifting weights"
			],
			u: "1f3cb-fe0f-200d-2642-fe0f",
			v: [
				"1f3cb-1f3fb-200d-2642-fe0f",
				"1f3cb-1f3fc-200d-2642-fe0f",
				"1f3cb-1f3fd-200d-2642-fe0f",
				"1f3cb-1f3fe-200d-2642-fe0f",
				"1f3cb-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"woman",
				"lifter",
				"weight",
				"barbell",
				"lifting",
				"weights",
				"workout",
				"deadlift",
				"bodybuilder",
				"powerlifting",
				"weightlifter",
				"woman lifting weights"
			],
			u: "1f3cb-fe0f-200d-2640-fe0f",
			v: [
				"1f3cb-1f3fb-200d-2640-fe0f",
				"1f3cb-1f3fc-200d-2640-fe0f",
				"1f3cb-1f3fd-200d-2640-fe0f",
				"1f3cb-1f3fe-200d-2640-fe0f",
				"1f3cb-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"bike",
				"cycle",
				"sport",
				"biking",
				"person",
				"riding",
				"bicycle",
				"cyclist",
				"bicyclist",
				"person biking"
			],
			u: "1f6b4",
			v: [
				"1f6b4-1f3fb",
				"1f6b4-1f3fc",
				"1f6b4-1f3fd",
				"1f6b4-1f3fe",
				"1f6b4-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"man",
				"bike",
				"cycle",
				"sport",
				"biking",
				"riding",
				"bicycle",
				"cyclist",
				"bicyclist",
				"man biking"
			],
			u: "1f6b4-200d-2642-fe0f",
			v: [
				"1f6b4-1f3fb-200d-2642-fe0f",
				"1f6b4-1f3fc-200d-2642-fe0f",
				"1f6b4-1f3fd-200d-2642-fe0f",
				"1f6b4-1f3fe-200d-2642-fe0f",
				"1f6b4-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"bike",
				"cycle",
				"sport",
				"woman",
				"biking",
				"riding",
				"bicycle",
				"cyclist",
				"bicyclist",
				"woman biking"
			],
			u: "1f6b4-200d-2640-fe0f",
			v: [
				"1f6b4-1f3fb-200d-2640-fe0f",
				"1f6b4-1f3fc-200d-2640-fe0f",
				"1f6b4-1f3fd-200d-2640-fe0f",
				"1f6b4-1f3fe-200d-2640-fe0f",
				"1f6b4-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"bike",
				"cycle",
				"sport",
				"biking",
				"person",
				"riding",
				"bicycle",
				"cyclist",
				"mountain",
				"bicyclist",
				"person mountain biking"
			],
			u: "1f6b5",
			v: [
				"1f6b5-1f3fb",
				"1f6b5-1f3fc",
				"1f6b5-1f3fd",
				"1f6b5-1f3fe",
				"1f6b5-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"man",
				"bike",
				"cycle",
				"sport",
				"biking",
				"riding",
				"bicycle",
				"cyclist",
				"mountain",
				"bicyclist",
				"man mountain biking"
			],
			u: "1f6b5-200d-2642-fe0f",
			v: [
				"1f6b5-1f3fb-200d-2642-fe0f",
				"1f6b5-1f3fc-200d-2642-fe0f",
				"1f6b5-1f3fd-200d-2642-fe0f",
				"1f6b5-1f3fe-200d-2642-fe0f",
				"1f6b5-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"bike",
				"cycle",
				"sport",
				"woman",
				"biking",
				"riding",
				"bicycle",
				"cyclist",
				"mountain",
				"bicyclist",
				"woman mountain biking"
			],
			u: "1f6b5-200d-2640-fe0f",
			v: [
				"1f6b5-1f3fb-200d-2640-fe0f",
				"1f6b5-1f3fc-200d-2640-fe0f",
				"1f6b5-1f3fd-200d-2640-fe0f",
				"1f6b5-1f3fe-200d-2640-fe0f",
				"1f6b5-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"flip",
				"happy",
				"active",
				"person",
				"excited",
				"cartwheel",
				"gymnastics",
				"somersault",
				"cartwheeling",
				"person cartwheeling"
			],
			u: "1f938",
			v: [
				"1f938-1f3fb",
				"1f938-1f3fc",
				"1f938-1f3fd",
				"1f938-1f3fe",
				"1f938-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"man",
				"flip",
				"happy",
				"active",
				"excited",
				"cartwheel",
				"gymnastics",
				"somersault",
				"cartwheeling",
				"man cartwheeling"
			],
			u: "1f938-200d-2642-fe0f",
			v: [
				"1f938-1f3fb-200d-2642-fe0f",
				"1f938-1f3fc-200d-2642-fe0f",
				"1f938-1f3fd-200d-2642-fe0f",
				"1f938-1f3fe-200d-2642-fe0f",
				"1f938-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"flip",
				"happy",
				"woman",
				"active",
				"excited",
				"cartwheel",
				"gymnastics",
				"somersault",
				"cartwheeling",
				"woman cartwheeling"
			],
			u: "1f938-200d-2640-fe0f",
			v: [
				"1f938-1f3fb-200d-2640-fe0f",
				"1f938-1f3fc-200d-2640-fe0f",
				"1f938-1f3fd-200d-2640-fe0f",
				"1f938-1f3fe-200d-2640-fe0f",
				"1f938-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"duel",
				"ring",
				"combat",
				"people",
				"grapple",
				"wrestle",
				"wrestling",
				"tournament",
				"people wrestling"
			],
			u: "1f93c",
			v: [
				"1f93c-1f3fb",
				"1f93c-1f3fc",
				"1f93c-1f3fd",
				"1f93c-1f3fe",
				"1f93c-1f3ff",
				"1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fc",
				"1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fd",
				"1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3fe",
				"1f9d1-1f3fb-200d-1faef-200d-1f9d1-1f3ff",
				"1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fb",
				"1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fd",
				"1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3fe",
				"1f9d1-1f3fc-200d-1faef-200d-1f9d1-1f3ff",
				"1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fb",
				"1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fc",
				"1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3fe",
				"1f9d1-1f3fd-200d-1faef-200d-1f9d1-1f3ff",
				"1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fb",
				"1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fc",
				"1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3fd",
				"1f9d1-1f3fe-200d-1faef-200d-1f9d1-1f3ff",
				"1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fb",
				"1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fc",
				"1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fd",
				"1f9d1-1f3ff-200d-1faef-200d-1f9d1-1f3fe"
			],
			a: "3"
		},
		{
			n: [
				"men",
				"duel",
				"ring",
				"combat",
				"grapple",
				"wrestle",
				"wrestling",
				"tournament",
				"men wrestling"
			],
			u: "1f93c-200d-2642-fe0f",
			v: [
				"1f468-1f3fb-200d-1faef-200d-1f468-1f3fc",
				"1f468-1f3fb-200d-1faef-200d-1f468-1f3fd",
				"1f468-1f3fb-200d-1faef-200d-1f468-1f3fe",
				"1f468-1f3fb-200d-1faef-200d-1f468-1f3ff",
				"1f468-1f3fc-200d-1faef-200d-1f468-1f3fb",
				"1f468-1f3fc-200d-1faef-200d-1f468-1f3fd",
				"1f468-1f3fc-200d-1faef-200d-1f468-1f3fe",
				"1f468-1f3fc-200d-1faef-200d-1f468-1f3ff",
				"1f468-1f3fd-200d-1faef-200d-1f468-1f3fb",
				"1f468-1f3fd-200d-1faef-200d-1f468-1f3fc",
				"1f468-1f3fd-200d-1faef-200d-1f468-1f3fe",
				"1f468-1f3fd-200d-1faef-200d-1f468-1f3ff",
				"1f468-1f3fe-200d-1faef-200d-1f468-1f3fb",
				"1f468-1f3fe-200d-1faef-200d-1f468-1f3fc",
				"1f468-1f3fe-200d-1faef-200d-1f468-1f3fd",
				"1f468-1f3fe-200d-1faef-200d-1f468-1f3ff",
				"1f468-1f3ff-200d-1faef-200d-1f468-1f3fb",
				"1f468-1f3ff-200d-1faef-200d-1f468-1f3fc",
				"1f468-1f3ff-200d-1faef-200d-1f468-1f3fd",
				"1f468-1f3ff-200d-1faef-200d-1f468-1f3fe",
				"1f93c-1f3fb-200d-2642-fe0f",
				"1f93c-1f3fc-200d-2642-fe0f",
				"1f93c-1f3fd-200d-2642-fe0f",
				"1f93c-1f3fe-200d-2642-fe0f",
				"1f93c-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"duel",
				"ring",
				"women",
				"combat",
				"grapple",
				"wrestle",
				"wrestling",
				"tournament",
				"women wrestling"
			],
			u: "1f93c-200d-2640-fe0f",
			v: [
				"1f469-1f3fb-200d-1faef-200d-1f469-1f3fc",
				"1f469-1f3fb-200d-1faef-200d-1f469-1f3fd",
				"1f469-1f3fb-200d-1faef-200d-1f469-1f3fe",
				"1f469-1f3fb-200d-1faef-200d-1f469-1f3ff",
				"1f469-1f3fc-200d-1faef-200d-1f469-1f3fb",
				"1f469-1f3fc-200d-1faef-200d-1f469-1f3fd",
				"1f469-1f3fc-200d-1faef-200d-1f469-1f3fe",
				"1f469-1f3fc-200d-1faef-200d-1f469-1f3ff",
				"1f469-1f3fd-200d-1faef-200d-1f469-1f3fb",
				"1f469-1f3fd-200d-1faef-200d-1f469-1f3fc",
				"1f469-1f3fd-200d-1faef-200d-1f469-1f3fe",
				"1f469-1f3fd-200d-1faef-200d-1f469-1f3ff",
				"1f469-1f3fe-200d-1faef-200d-1f469-1f3fb",
				"1f469-1f3fe-200d-1faef-200d-1f469-1f3fc",
				"1f469-1f3fe-200d-1faef-200d-1f469-1f3fd",
				"1f469-1f3fe-200d-1faef-200d-1f469-1f3ff",
				"1f469-1f3ff-200d-1faef-200d-1f469-1f3fb",
				"1f469-1f3ff-200d-1faef-200d-1f469-1f3fc",
				"1f469-1f3ff-200d-1faef-200d-1f469-1f3fd",
				"1f469-1f3ff-200d-1faef-200d-1f469-1f3fe",
				"1f93c-1f3fb-200d-2640-fe0f",
				"1f93c-1f3fc-200d-2640-fe0f",
				"1f93c-1f3fd-200d-2640-fe0f",
				"1f93c-1f3fe-200d-2640-fe0f",
				"1f93c-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"polo",
				"sport",
				"water",
				"person",
				"playing",
				"swimming",
				"waterpolo",
				"person playing water polo"
			],
			u: "1f93d",
			v: [
				"1f93d-1f3fb",
				"1f93d-1f3fc",
				"1f93d-1f3fd",
				"1f93d-1f3fe",
				"1f93d-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"man",
				"polo",
				"sport",
				"water",
				"playing",
				"swimming",
				"waterpolo",
				"man playing water polo"
			],
			u: "1f93d-200d-2642-fe0f",
			v: [
				"1f93d-1f3fb-200d-2642-fe0f",
				"1f93d-1f3fc-200d-2642-fe0f",
				"1f93d-1f3fd-200d-2642-fe0f",
				"1f93d-1f3fe-200d-2642-fe0f",
				"1f93d-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"polo",
				"sport",
				"water",
				"woman",
				"playing",
				"swimming",
				"waterpolo",
				"woman playing water polo"
			],
			u: "1f93d-200d-2640-fe0f",
			v: [
				"1f93d-1f3fb-200d-2640-fe0f",
				"1f93d-1f3fc-200d-2640-fe0f",
				"1f93d-1f3fd-200d-2640-fe0f",
				"1f93d-1f3fe-200d-2640-fe0f",
				"1f93d-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"lob",
				"ball",
				"hurl",
				"toss",
				"catch",
				"chuck",
				"pitch",
				"sport",
				"throw",
				"person",
				"playing",
				"handball",
				"athletics",
				"person playing handball"
			],
			u: "1f93e",
			v: [
				"1f93e-1f3fb",
				"1f93e-1f3fc",
				"1f93e-1f3fd",
				"1f93e-1f3fe",
				"1f93e-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"lob",
				"man",
				"ball",
				"hurl",
				"toss",
				"catch",
				"chuck",
				"pitch",
				"sport",
				"throw",
				"playing",
				"handball",
				"athletics",
				"man playing handball"
			],
			u: "1f93e-200d-2642-fe0f",
			v: [
				"1f93e-1f3fb-200d-2642-fe0f",
				"1f93e-1f3fc-200d-2642-fe0f",
				"1f93e-1f3fd-200d-2642-fe0f",
				"1f93e-1f3fe-200d-2642-fe0f",
				"1f93e-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"lob",
				"ball",
				"hurl",
				"toss",
				"catch",
				"chuck",
				"pitch",
				"sport",
				"throw",
				"woman",
				"playing",
				"handball",
				"athletics",
				"woman playing handball"
			],
			u: "1f93e-200d-2640-fe0f",
			v: [
				"1f93e-1f3fb-200d-2640-fe0f",
				"1f93e-1f3fc-200d-2640-fe0f",
				"1f93e-1f3fd-200d-2640-fe0f",
				"1f93e-1f3fe-200d-2640-fe0f",
				"1f93e-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"act",
				"skill",
				"handle",
				"juggle",
				"manage",
				"person",
				"balance",
				"juggling",
				"balancing",
				"multitask",
				"person juggling"
			],
			u: "1f939",
			v: [
				"1f939-1f3fb",
				"1f939-1f3fc",
				"1f939-1f3fd",
				"1f939-1f3fe",
				"1f939-1f3ff"
			],
			a: "3"
		},
		{
			n: [
				"act",
				"man",
				"skill",
				"handle",
				"juggle",
				"manage",
				"balance",
				"juggling",
				"balancing",
				"multitask",
				"man juggling"
			],
			u: "1f939-200d-2642-fe0f",
			v: [
				"1f939-1f3fb-200d-2642-fe0f",
				"1f939-1f3fc-200d-2642-fe0f",
				"1f939-1f3fd-200d-2642-fe0f",
				"1f939-1f3fe-200d-2642-fe0f",
				"1f939-1f3ff-200d-2642-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"act",
				"skill",
				"woman",
				"handle",
				"juggle",
				"manage",
				"balance",
				"juggling",
				"balancing",
				"multitask",
				"woman juggling"
			],
			u: "1f939-200d-2640-fe0f",
			v: [
				"1f939-1f3fb-200d-2640-fe0f",
				"1f939-1f3fc-200d-2640-fe0f",
				"1f939-1f3fd-200d-2640-fe0f",
				"1f939-1f3fe-200d-2640-fe0f",
				"1f939-1f3ff-200d-2640-fe0f"
			],
			a: "4"
		},
		{
			n: [
				"zen",
				"legs",
				"yoga",
				"yogi",
				"cross",
				"lotus",
				"peace",
				"relax",
				"legged",
				"person",
				"position",
				"serenity",
				"meditation",
				"person in lotus position"
			],
			u: "1f9d8",
			v: [
				"1f9d8-1f3fb",
				"1f9d8-1f3fc",
				"1f9d8-1f3fd",
				"1f9d8-1f3fe",
				"1f9d8-1f3ff"
			],
			a: "5"
		},
		{
			n: [
				"man",
				"zen",
				"legs",
				"yoga",
				"yogi",
				"cross",
				"lotus",
				"peace",
				"relax",
				"legged",
				"position",
				"serenity",
				"meditation",
				"man in lotus position"
			],
			u: "1f9d8-200d-2642-fe0f",
			v: [
				"1f9d8-1f3fb-200d-2642-fe0f",
				"1f9d8-1f3fc-200d-2642-fe0f",
				"1f9d8-1f3fd-200d-2642-fe0f",
				"1f9d8-1f3fe-200d-2642-fe0f",
				"1f9d8-1f3ff-200d-2642-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"zen",
				"legs",
				"yoga",
				"yogi",
				"cross",
				"lotus",
				"peace",
				"relax",
				"woman",
				"legged",
				"position",
				"serenity",
				"meditation",
				"woman in lotus position"
			],
			u: "1f9d8-200d-2640-fe0f",
			v: [
				"1f9d8-1f3fb-200d-2640-fe0f",
				"1f9d8-1f3fc-200d-2640-fe0f",
				"1f9d8-1f3fd-200d-2640-fe0f",
				"1f9d8-1f3fe-200d-2640-fe0f",
				"1f9d8-1f3ff-200d-2640-fe0f"
			],
			a: "5"
		},
		{
			n: [
				"tub",
				"bath",
				"person",
				"taking",
				"bathtub",
				"person taking bath"
			],
			u: "1f6c0",
			v: [
				"1f6c0-1f3fb",
				"1f6c0-1f3fc",
				"1f6c0-1f3fd",
				"1f6c0-1f3fe",
				"1f6c0-1f3ff"
			],
			a: "0.6"
		},
		{
			n: [
				"bed",
				"nap",
				"zzz",
				"good",
				"hotel",
				"night",
				"sleep",
				"tired",
				"person",
				"bedtime",
				"goodnight",
				"person in bed"
			],
			u: "1f6cc",
			v: [
				"1f6cc-1f3fb",
				"1f6cc-1f3fc",
				"1f6cc-1f3fd",
				"1f6cc-1f3fe",
				"1f6cc-1f3ff"
			],
			a: "1"
		},
		{
			n: [
				"bae",
				"bff",
				"hand",
				"hold",
				"flirt",
				"twins",
				"bestie",
				"couple",
				"dating",
				"people",
				"friends",
				"people holding hands"
			],
			u: "1f9d1-200d-1f91d-200d-1f9d1",
			v: [
				"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
				"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
				"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
				"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
				"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
				"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
				"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
				"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
				"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
				"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
				"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
				"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
				"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
				"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
				"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
				"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
				"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
				"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
				"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
				"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
				"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
				"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
				"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
				"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
				"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
			],
			a: "12"
		},
		{
			n: [
				"bae",
				"bff",
				"hand",
				"hold",
				"flirt",
				"girls",
				"twins",
				"women",
				"bestie",
				"couple",
				"dating",
				"friends",
				"sisters",
				"women holding hands"
			],
			u: "1f46d",
			v: [
				"1f46d-1f3fb",
				"1f46d-1f3fc",
				"1f46d-1f3fd",
				"1f46d-1f3fe",
				"1f46d-1f3ff",
				"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
				"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
				"1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
				"1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
				"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
				"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
				"1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
				"1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
				"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
				"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
				"1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
				"1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
				"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
				"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
				"1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
				"1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
				"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
				"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
				"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
				"1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
			],
			a: "1"
		},
		{
			n: [
				"bae",
				"bff",
				"man",
				"hand",
				"hold",
				"flirt",
				"twins",
				"woman",
				"bestie",
				"couple",
				"dating",
				"friends",
				"woman and man holding hands"
			],
			u: "1f46b",
			v: [
				"1f46b-1f3fb",
				"1f46b-1f3fc",
				"1f46b-1f3fd",
				"1f46b-1f3fe",
				"1f46b-1f3ff",
				"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
				"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
				"1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
				"1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
				"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
				"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
				"1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
				"1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
				"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
				"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
				"1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
				"1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
				"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
				"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
				"1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
				"1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
				"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
				"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
				"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
				"1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
			],
			a: "0.6"
		},
		{
			n: [
				"bae",
				"bff",
				"men",
				"boys",
				"hand",
				"hold",
				"flirt",
				"twins",
				"bestie",
				"couple",
				"dating",
				"friends",
				"brothers",
				"men holding hands"
			],
			u: "1f46c",
			v: [
				"1f46c-1f3fb",
				"1f46c-1f3fc",
				"1f46c-1f3fd",
				"1f46c-1f3fe",
				"1f46c-1f3ff",
				"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
				"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
				"1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
				"1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
				"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
				"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
				"1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
				"1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
				"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
				"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
				"1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
				"1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
				"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
				"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
				"1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
				"1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
				"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
				"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
				"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
				"1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
			],
			a: "1"
		},
		{
			n: [
				"bae",
				"kiss",
				"babe",
				"date",
				"love",
				"mwah",
				"xoxo",
				"heart",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary"
			],
			u: "1f48f",
			v: [
				"1f48f-1f3fb",
				"1f48f-1f3fc",
				"1f48f-1f3fd",
				"1f48f-1f3fe",
				"1f48f-1f3ff",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
			],
			a: "0.6"
		},
		{
			n: [
				"bae",
				"man",
				"babe",
				"date",
				"kiss",
				"love",
				"mwah",
				"xoxo",
				"heart",
				"woman",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"kiss: woman, man"
			],
			u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
			v: [
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"bae",
				"man",
				"babe",
				"date",
				"kiss",
				"love",
				"mwah",
				"xoxo",
				"heart",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"kiss: man, man"
			],
			u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
			v: [
				"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"bae",
				"babe",
				"date",
				"kiss",
				"love",
				"mwah",
				"xoxo",
				"heart",
				"woman",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"kiss: woman, woman"
			],
			u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
			v: [
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"bae",
				"you",
				"babe",
				"kiss",
				"love",
				"heart",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"relationship",
				"couple with heart"
			],
			u: "1f491",
			v: [
				"1f491-1f3fb",
				"1f491-1f3fc",
				"1f491-1f3fd",
				"1f491-1f3fe",
				"1f491-1f3ff",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
				"1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
				"1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
				"1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
				"1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
				"1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
			],
			a: "0.6"
		},
		{
			n: [
				"bae",
				"man",
				"you",
				"babe",
				"kiss",
				"love",
				"heart",
				"woman",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"relationship",
				"couple with heart: woman, man"
			],
			u: "1f469-200d-2764-fe0f-200d-1f468",
			v: [
				"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"bae",
				"man",
				"you",
				"babe",
				"kiss",
				"love",
				"heart",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"relationship",
				"couple with heart: man, man"
			],
			u: "1f468-200d-2764-fe0f-200d-1f468",
			v: [
				"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
				"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"bae",
				"you",
				"babe",
				"kiss",
				"love",
				"heart",
				"woman",
				"couple",
				"dating",
				"person",
				"romance",
				"together",
				"anniversary",
				"relationship",
				"couple with heart: woman, woman"
			],
			u: "1f469-200d-2764-fe0f-200d-1f469",
			v: [
				"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
				"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
				"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
				"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
				"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
				"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
			],
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"woman",
				"family",
				"family: man, woman, boy"
			],
			u: "1f468-200d-1f469-200d-1f466",
			a: "2"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"woman",
				"family",
				"family: man, woman, girl"
			],
			u: "1f468-200d-1f469-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"girl",
				"child",
				"woman",
				"family",
				"family: man, woman, girl, boy"
			],
			u: "1f468-200d-1f469-200d-1f467-200d-1f466",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"woman",
				"family",
				"family: man, woman, boy, boy"
			],
			u: "1f468-200d-1f469-200d-1f466-200d-1f466",
			a: "2"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"woman",
				"family",
				"family: man, woman, girl, girl"
			],
			u: "1f468-200d-1f469-200d-1f467-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"family",
				"family: man, man, boy"
			],
			u: "1f468-200d-1f468-200d-1f466",
			a: "2"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"family",
				"family: man, man, girl"
			],
			u: "1f468-200d-1f468-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"girl",
				"child",
				"family",
				"family: man, man, girl, boy"
			],
			u: "1f468-200d-1f468-200d-1f467-200d-1f466",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"family",
				"family: man, man, boy, boy"
			],
			u: "1f468-200d-1f468-200d-1f466-200d-1f466",
			a: "2"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"family",
				"family: man, man, girl, girl"
			],
			u: "1f468-200d-1f468-200d-1f467-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"child",
				"woman",
				"family",
				"family: woman, woman, boy"
			],
			u: "1f469-200d-1f469-200d-1f466",
			a: "2"
		},
		{
			n: [
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, woman, girl"
			],
			u: "1f469-200d-1f469-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, woman, girl, boy"
			],
			u: "1f469-200d-1f469-200d-1f467-200d-1f466",
			a: "2"
		},
		{
			n: [
				"boy",
				"child",
				"woman",
				"family",
				"family: woman, woman, boy, boy"
			],
			u: "1f469-200d-1f469-200d-1f466-200d-1f466",
			a: "2"
		},
		{
			n: [
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, woman, girl, girl"
			],
			u: "1f469-200d-1f469-200d-1f467-200d-1f467",
			a: "2"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"family",
				"family: man, boy"
			],
			u: "1f468-200d-1f466",
			a: "4"
		},
		{
			n: [
				"boy",
				"man",
				"child",
				"family",
				"family: man, boy, boy"
			],
			u: "1f468-200d-1f466-200d-1f466",
			a: "4"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"family",
				"family: man, girl"
			],
			u: "1f468-200d-1f467",
			a: "4"
		},
		{
			n: [
				"boy",
				"man",
				"girl",
				"child",
				"family",
				"family: man, girl, boy"
			],
			u: "1f468-200d-1f467-200d-1f466",
			a: "4"
		},
		{
			n: [
				"man",
				"girl",
				"child",
				"family",
				"family: man, girl, girl"
			],
			u: "1f468-200d-1f467-200d-1f467",
			a: "4"
		},
		{
			n: [
				"boy",
				"child",
				"woman",
				"family",
				"family: woman, boy"
			],
			u: "1f469-200d-1f466",
			a: "4"
		},
		{
			n: [
				"boy",
				"child",
				"woman",
				"family",
				"family: woman, boy, boy"
			],
			u: "1f469-200d-1f466-200d-1f466",
			a: "4"
		},
		{
			n: [
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, girl"
			],
			u: "1f469-200d-1f467",
			a: "4"
		},
		{
			n: [
				"boy",
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, girl, boy"
			],
			u: "1f469-200d-1f467-200d-1f466",
			a: "4"
		},
		{
			n: [
				"girl",
				"child",
				"woman",
				"family",
				"family: woman, girl, girl"
			],
			u: "1f469-200d-1f467-200d-1f467",
			a: "4"
		},
		{
			n: [
				"face",
				"head",
				"speak",
				"speaking",
				"silhouette",
				"speaking head"
			],
			u: "1f5e3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bust",
				"shadow",
				"mysterious",
				"silhouette",
				"bust in silhouette"
			],
			u: "1f464",
			a: "0.6"
		},
		{
			n: [
				"bff",
				"bust",
				"busts",
				"friend",
				"people",
				"friends",
				"everyone",
				"silhouette",
				"busts in silhouette"
			],
			u: "1f465",
			a: "1"
		},
		{
			n: [
				"hug",
				"love",
				"hello",
				"people",
				"thanks",
				"comfort",
				"embrace",
				"goodbye",
				"hugging",
				"farewell",
				"friendship",
				"people hugging"
			],
			u: "1fac2",
			a: "13"
		},
		{
			n: [
				"child",
				"family"
			],
			u: "1f46a",
			a: "0.6"
		},
		{
			n: [
				"adult",
				"child",
				"family",
				"family: adult, adult, child"
			],
			u: "1f9d1-200d-1f9d1-200d-1f9d2",
			a: "15.1"
		},
		{
			n: [
				"adult",
				"child",
				"family",
				"family: adult, adult, child, child"
			],
			u: "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2",
			a: "15.1"
		},
		{
			n: [
				"adult",
				"child",
				"family",
				"family: adult, child"
			],
			u: "1f9d1-200d-1f9d2",
			a: "15.1"
		},
		{
			n: [
				"adult",
				"child",
				"family",
				"family: adult, child, child"
			],
			u: "1f9d1-200d-1f9d2-200d-1f9d2",
			a: "15.1"
		},
		{
			n: [
				"omw",
				"walk",
				"print",
				"barefoot",
				"clothing",
				"footprint",
				"footprints"
			],
			u: "1f463",
			a: "0.6"
		},
		{
			n: [
				"clue",
				"crime",
				"print",
				"trace",
				"safety",
				"mystery",
				"identity",
				"detective",
				"forensics",
				"fingerprint"
			],
			u: "1fac6",
			a: "16"
		}
	],
	animals_nature: [
		{
			n: [
				"face",
				"animal",
				"banana",
				"monkey",
				"monkey face"
			],
			u: "1f435",
			a: "0.6"
		},
		{
			n: [
				"monkey",
				"animal",
				"banana"
			],
			u: "1f412",
			a: "0.6"
		},
		{
			n: [
				"animal",
				"gorilla"
			],
			u: "1f98d",
			a: "3"
		},
		{
			n: [
				"ape",
				"animal",
				"monkey",
				"orangutan"
			],
			u: "1f9a7",
			a: "12"
		},
		{
			n: [
				"dog",
				"pet",
				"face",
				"puppy",
				"adorbs",
				"animal",
				"puppies",
				"dog face"
			],
			u: "1f436",
			a: "0.6"
		},
		{
			n: [
				"dog",
				"pet",
				"dogs",
				"animal",
				"animals"
			],
			u: "1f415",
			a: "0.7"
		},
		{
			n: [
				"dog",
				"blind",
				"guide",
				"animal",
				"guide dog",
				"accessibility"
			],
			u: "1f9ae",
			a: "12"
		},
		{
			n: [
				"dog",
				"animal",
				"service",
				"assistance",
				"service dog",
				"accessibility"
			],
			u: "1f415-200d-1f9ba",
			a: "12"
		},
		{
			n: [
				"dog",
				"poodle",
				"animal",
				"fluffy"
			],
			u: "1f429",
			a: "0.6"
		},
		{
			n: [
				"wolf",
				"face",
				"animal"
			],
			u: "1f43a",
			a: "0.6"
		},
		{
			n: [
				"fox",
				"face",
				"animal"
			],
			u: "1f98a",
			a: "3"
		},
		{
			n: [
				"sly",
				"animal",
				"raccoon",
				"curious"
			],
			u: "1f99d",
			a: "11"
		},
		{
			n: [
				"cat",
				"pet",
				"face",
				"kitty",
				"animal",
				"kitten",
				"cat face"
			],
			u: "1f431",
			a: "0.6"
		},
		{
			n: [
				"cat",
				"pet",
				"cats",
				"animal",
				"kitten",
				"animals"
			],
			u: "1f408",
			a: "0.7"
		},
		{
			n: [
				"cat",
				"meow",
				"black",
				"animal",
				"feline",
				"unlucky",
				"black cat",
				"halloween"
			],
			u: "1f408-200d-2b1b",
			a: "13"
		},
		{
			n: [
				"leo",
				"lion",
				"face",
				"mane",
				"rawr",
				"roar",
				"alpha",
				"order",
				"animal",
				"safari",
				"strong",
				"zodiac"
			],
			u: "1f981",
			a: "1"
		},
		{
			n: [
				"big",
				"cat",
				"face",
				"tiger",
				"animal",
				"predator",
				"tiger face"
			],
			u: "1f42f",
			a: "0.6"
		},
		{
			n: [
				"big",
				"cat",
				"zoo",
				"tiger",
				"animal",
				"predator"
			],
			u: "1f405",
			a: "1"
		},
		{
			n: [
				"big",
				"cat",
				"zoo",
				"animal",
				"leopard",
				"predator"
			],
			u: "1f406",
			a: "1"
		},
		{
			n: [
				"face",
				"farm",
				"horse",
				"animal",
				"equine",
				"horses",
				"dressage",
				"horse face"
			],
			u: "1f434",
			a: "0.6"
		},
		{
			n: [
				"elk",
				"moose",
				"alces",
				"animal",
				"mammal",
				"antlers"
			],
			u: "1face",
			a: "15"
		},
		{
			n: [
				"ass",
				"mule",
				"burro",
				"hinny",
				"donkey",
				"animal",
				"mammal",
				"stubborn"
			],
			u: "1facf",
			a: "15"
		},
		{
			n: [
				"farm",
				"horse",
				"animal",
				"racing",
				"racehorse",
				"equestrian"
			],
			u: "1f40e",
			a: "0.6"
		},
		{
			n: [
				"face",
				"unicorn"
			],
			u: "1f984",
			a: "1"
		},
		{
			n: [
				"zebra",
				"animal",
				"stripe"
			],
			u: "1f993",
			a: "5"
		},
		{
			n: [
				"deer",
				"animal"
			],
			u: "1f98c",
			a: "3"
		},
		{
			n: [
				"herd",
				"bison",
				"animal",
				"wisent",
				"buffalo"
			],
			u: "1f9ac",
			a: "13"
		},
		{
			n: [
				"cow",
				"moo",
				"face",
				"farm",
				"milk",
				"animal",
				"cow face"
			],
			u: "1f42e",
			a: "0.6"
		},
		{
			n: [
				"ox",
				"bull",
				"farm",
				"animal",
				"taurus",
				"zodiac",
				"animals"
			],
			u: "1f402",
			a: "1"
		},
		{
			n: [
				"zoo",
				"water",
				"animal",
				"buffalo",
				"water buffalo"
			],
			u: "1f403",
			a: "1"
		},
		{
			n: [
				"cow",
				"moo",
				"farm",
				"milk",
				"animal",
				"animals"
			],
			u: "1f404",
			a: "1"
		},
		{
			n: [
				"pig",
				"face",
				"farm",
				"pork",
				"bacon",
				"animal",
				"pig face"
			],
			u: "1f437",
			a: "0.6"
		},
		{
			n: [
				"pig",
				"sow",
				"farm",
				"pork",
				"bacon",
				"animal"
			],
			u: "1f416",
			a: "1"
		},
		{
			n: [
				"pig",
				"boar",
				"animal"
			],
			u: "1f417",
			a: "0.6"
		},
		{
			n: [
				"pig",
				"face",
				"farm",
				"nose",
				"smell",
				"snout",
				"animal",
				"pig nose"
			],
			u: "1f43d",
			a: "0.6"
		},
		{
			n: [
				"ram",
				"zoo",
				"male",
				"aries",
				"horns",
				"sheep",
				"animal",
				"zodiac"
			],
			u: "1f40f",
			a: "1"
		},
		{
			n: [
				"ewe",
				"baa",
				"farm",
				"lamb",
				"wool",
				"sheep",
				"animal",
				"female",
				"fluffy"
			],
			u: "1f411",
			a: "0.6"
		},
		{
			n: [
				"goat",
				"farm",
				"milk",
				"animal",
				"zodiac",
				"capricorn"
			],
			u: "1f410",
			a: "1"
		},
		{
			n: [
				"one",
				"hump",
				"camel",
				"animal",
				"desert",
				"dromedary"
			],
			u: "1f42a",
			a: "1"
		},
		{
			n: [
				"two",
				"hump",
				"camel",
				"animal",
				"desert",
				"bactrian",
				"two hump",
				"two hump camel"
			],
			u: "1f42b",
			a: "0.6"
		},
		{
			n: [
				"wool",
				"llama",
				"alpaca",
				"animal",
				"vicuña",
				"guanaco"
			],
			u: "1f999",
			a: "11"
		},
		{
			n: [
				"spots",
				"animal",
				"giraffe"
			],
			u: "1f992",
			a: "5"
		},
		{
			n: [
				"animal",
				"elephant"
			],
			u: "1f418",
			a: "0.6"
		},
		{
			n: [
				"tusk",
				"large",
				"wooly",
				"animal",
				"mammoth",
				"extinction"
			],
			u: "1f9a3",
			a: "13"
		},
		{
			n: [
				"animal",
				"rhinoceros"
			],
			u: "1f98f",
			a: "3"
		},
		{
			n: [
				"hippo",
				"animal",
				"hippopotamus"
			],
			u: "1f99b",
			a: "11"
		},
		{
			n: [
				"face",
				"mouse",
				"animal",
				"mouse face"
			],
			u: "1f42d",
			a: "0.6"
		},
		{
			n: [
				"mouse",
				"animal",
				"animals"
			],
			u: "1f401",
			a: "1"
		},
		{
			n: [
				"rat",
				"animal"
			],
			u: "1f400",
			a: "1"
		},
		{
			n: [
				"pet",
				"face",
				"animal",
				"hamster"
			],
			u: "1f439",
			a: "0.6"
		},
		{
			n: [
				"pet",
				"face",
				"bunny",
				"animal",
				"rabbit",
				"rabbit face"
			],
			u: "1f430",
			a: "0.6"
		},
		{
			n: [
				"pet",
				"bunny",
				"rabbit",
				"animal"
			],
			u: "1f407",
			a: "1"
		},
		{
			n: [
				"animal",
				"chipmunk",
				"squirrel"
			],
			u: "1f43f-fe0f",
			a: "0.7"
		},
		{
			n: [
				"dam",
				"teeth",
				"beaver",
				"animal"
			],
			u: "1f9ab",
			a: "13"
		},
		{
			n: [
				"spiny",
				"animal",
				"hedgehog"
			],
			u: "1f994",
			a: "5"
		},
		{
			n: [
				"bat",
				"animal",
				"vampire"
			],
			u: "1f987",
			a: "3"
		},
		{
			n: [
				"bear",
				"face",
				"growl",
				"honey",
				"animal",
				"grizzly"
			],
			u: "1f43b",
			a: "0.6"
		},
		{
			n: [
				"bear",
				"polar",
				"white",
				"animal",
				"arctic",
				"polar bear"
			],
			u: "1f43b-200d-2744-fe0f",
			a: "13"
		},
		{
			n: [
				"bear",
				"down",
				"face",
				"koala",
				"under",
				"animal",
				"australia",
				"marsupial"
			],
			u: "1f428",
			a: "0.6"
		},
		{
			n: [
				"face",
				"panda",
				"animal",
				"bamboo"
			],
			u: "1f43c",
			a: "0.6"
		},
		{
			n: [
				"lazy",
				"slow",
				"sloth"
			],
			u: "1f9a5",
			a: "12"
		},
		{
			n: [
				"otter",
				"animal",
				"fishing",
				"playful"
			],
			u: "1f9a6",
			a: "12"
		},
		{
			n: [
				"skunk",
				"stink",
				"animal"
			],
			u: "1f9a8",
			a: "12"
		},
		{
			n: [
				"joey",
				"jump",
				"animal",
				"kangaroo",
				"marsupial"
			],
			u: "1f998",
			a: "11"
		},
		{
			n: [
				"honey",
				"badger",
				"animal",
				"pester"
			],
			u: "1f9a1",
			a: "11"
		},
		{
			n: [
				"paw",
				"feet",
				"paws",
				"print",
				"prints",
				"paw prints"
			],
			u: "1f43e",
			a: "0.6"
		},
		{
			n: [
				"bird",
				"turkey",
				"gobble",
				"thanksgiving"
			],
			u: "1f983",
			a: "1"
		},
		{
			n: [
				"bird",
				"animal",
				"chicken",
				"ornithology"
			],
			u: "1f414",
			a: "0.6"
		},
		{
			n: [
				"bird",
				"animal",
				"rooster",
				"ornithology"
			],
			u: "1f413",
			a: "1"
		},
		{
			n: [
				"egg",
				"baby",
				"bird",
				"chick",
				"animal",
				"hatching",
				"hatching chick"
			],
			u: "1f423",
			a: "0.6"
		},
		{
			n: [
				"baby",
				"bird",
				"chick",
				"animal",
				"baby chick",
				"ornithology"
			],
			u: "1f424",
			a: "0.6"
		},
		{
			n: [
				"baby",
				"bird",
				"chick",
				"animal",
				"newborn",
				"ornithology",
				"front facing",
				"front facing baby chick"
			],
			u: "1f425",
			a: "0.6"
		},
		{
			n: [
				"bird",
				"animal",
				"ornithology"
			],
			u: "1f426",
			a: "0.6"
		},
		{
			n: [
				"bird",
				"animal",
				"penguin",
				"antarctica",
				"ornithology"
			],
			u: "1f427",
			a: "0.6"
		},
		{
			n: [
				"fly",
				"dove",
				"bird",
				"peace",
				"ornithology"
			],
			u: "1f54a-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bird",
				"eagle",
				"animal",
				"ornithology"
			],
			u: "1f985",
			a: "3"
		},
		{
			n: [
				"duck",
				"bird",
				"animal",
				"ornithology"
			],
			u: "1f986",
			a: "3"
		},
		{
			n: [
				"swan",
				"bird",
				"ugly",
				"animal",
				"cygnet",
				"duckling",
				"ornithology"
			],
			u: "1f9a2",
			a: "11"
		},
		{
			n: [
				"owl",
				"bird",
				"wise",
				"animal",
				"ornithology"
			],
			u: "1f989",
			a: "3"
		},
		{
			n: [
				"dodo",
				"bird",
				"large",
				"animal",
				"extinction",
				"ornithology"
			],
			u: "1f9a4",
			a: "13"
		},
		{
			n: [
				"bird",
				"light",
				"flight",
				"feather",
				"plumage"
			],
			u: "1fab6",
			a: "13"
		},
		{
			n: [
				"bird",
				"animal",
				"flamingo",
				"tropical",
				"flamboyant",
				"ornithology"
			],
			u: "1f9a9",
			a: "12"
		},
		{
			n: [
				"bird",
				"proud",
				"animal",
				"peahen",
				"pretty",
				"peacock",
				"colorful",
				"ornithology",
				"ostentatious"
			],
			u: "1f99a",
			a: "11"
		},
		{
			n: [
				"bird",
				"talk",
				"parrot",
				"animal",
				"pirate",
				"ornithology"
			],
			u: "1f99c",
			a: "11"
		},
		{
			n: [
				"fly",
				"wing",
				"bird",
				"soar",
				"ascend",
				"flying",
				"angelic",
				"aviation",
				"heavenly",
				"mythology"
			],
			u: "1fabd",
			a: "15"
		},
		{
			n: [
				"caw",
				"beak",
				"bird",
				"crow",
				"rook",
				"black",
				"raven",
				"animal",
				"corvid",
				"black bird",
				"ornithology"
			],
			u: "1f426-200d-2b1b",
			a: "15"
		},
		{
			n: [
				"bird",
				"duck",
				"fowl",
				"honk",
				"goose",
				"flock",
				"geese",
				"silly",
				"animal",
				"gaggle",
				"gander",
				"ornithology"
			],
			u: "1fabf",
			a: "15"
		},
		{
			n: [
				"rise",
				"glory",
				"ascend",
				"emerge",
				"revive",
				"phoenix",
				"fantasy",
				"rebirth",
				"renewal",
				"revival",
				"firebird",
				"immortal",
				"reinvent",
				"ascension",
				"transform",
				"reincarnation"
			],
			u: "1f426-200d-1f525",
			a: "15.1"
		},
		{
			n: [
				"frog",
				"face",
				"animal"
			],
			u: "1f438",
			a: "0.6"
		},
		{
			n: [
				"zoo",
				"animal",
				"crocodile"
			],
			u: "1f40a",
			a: "1"
		},
		{
			n: [
				"turtle",
				"animal",
				"terrapin",
				"tortoise"
			],
			u: "1f422",
			a: "0.6"
		},
		{
			n: [
				"lizard",
				"animal",
				"reptile"
			],
			u: "1f98e",
			a: "3"
		},
		{
			n: [
				"snake",
				"animal",
				"bearer",
				"zodiac",
				"serpent",
				"ophiuchus"
			],
			u: "1f40d",
			a: "0.6"
		},
		{
			n: [
				"face",
				"tale",
				"fairy",
				"animal",
				"dragon",
				"fairytale",
				"dragon face"
			],
			u: "1f432",
			a: "0.6"
		},
		{
			n: [
				"tale",
				"fairy",
				"dragon",
				"animal",
				"knights",
				"fairytale"
			],
			u: "1f409",
			a: "1"
		},
		{
			n: [
				"sauropod",
				"dinosaur",
				"diplodocus",
				"brontosaurus",
				"brachiosaurus"
			],
			u: "1f995",
			a: "5"
		},
		{
			n: [
				"t",
				"rex",
				"T Rex",
				"t rex",
				"dinosaur",
				"tyrannosaurus"
			],
			u: "1f996",
			a: "5"
		},
		{
			n: [
				"face",
				"beach",
				"ocean",
				"whale",
				"animal",
				"spouting",
				"spouting whale"
			],
			u: "1f433",
			a: "0.6"
		},
		{
			n: [
				"whale",
				"beach",
				"ocean",
				"animal"
			],
			u: "1f40b",
			a: "1"
		},
		{
			n: [
				"beach",
				"ocean",
				"animal",
				"dolphin",
				"flipper"
			],
			u: "1f42c",
			a: "0.6"
		},
		{
			n: [
				"sea",
				"seal",
				"lion",
				"ocean",
				"animal"
			],
			u: "1f9ad",
			a: "13"
		},
		{
			n: [
				"fish",
				"animal",
				"dinner",
				"fishes",
				"pisces",
				"zodiac",
				"fishing"
			],
			u: "1f41f",
			a: "0.6"
		},
		{
			n: [
				"fish",
				"animal",
				"fishes",
				"tropical",
				"tropical fish"
			],
			u: "1f420",
			a: "0.6"
		},
		{
			n: [
				"fish",
				"animal",
				"blowfish"
			],
			u: "1f421",
			a: "0.6"
		},
		{
			n: [
				"fish",
				"shark",
				"animal"
			],
			u: "1f988",
			a: "3"
		},
		{
			n: [
				"ocean",
				"animal",
				"octopus",
				"creature"
			],
			u: "1f419",
			a: "0.6"
		},
		{
			n: [
				"sea",
				"beach",
				"conch",
				"shell",
				"animal",
				"spiral",
				"spiral shell"
			],
			u: "1f41a",
			a: "0.6"
		},
		{
			n: [
				"sea",
				"reef",
				"coral",
				"ocean",
				"change",
				"climate"
			],
			u: "1fab8",
			a: "14"
		},
		{
			n: [
				"sea",
				"burn",
				"life",
				"ouch",
				"jelly",
				"ocean",
				"sting",
				"animal",
				"marine",
				"stinger",
				"aquarium",
				"plankton",
				"jellyfish",
				"tentacles",
				"invertebrate"
			],
			u: "1fabc",
			a: "15"
		},
		{
			n: [
				"crab",
				"cancer",
				"zodiac"
			],
			u: "1f980",
			a: "1"
		},
		{
			n: [
				"claws",
				"animal",
				"bisque",
				"lobster",
				"seafood"
			],
			u: "1f99e",
			a: "11"
		},
		{
			n: [
				"food",
				"small",
				"shrimp",
				"shellfish"
			],
			u: "1f990",
			a: "3"
		},
		{
			n: [
				"food",
				"squid",
				"animal",
				"mollusk"
			],
			u: "1f991",
			a: "3"
		},
		{
			n: [
				"pearl",
				"oyster",
				"diving"
			],
			u: "1f9aa",
			a: "12"
		},
		{
			n: [
				"slug",
				"snail",
				"animal",
				"garden",
				"nature",
				"escargot"
			],
			u: "1f40c",
			a: "0.6"
		},
		{
			n: [
				"insect",
				"pretty",
				"butterfly"
			],
			u: "1f98b",
			a: "3"
		},
		{
			n: [
				"bug",
				"animal",
				"garden",
				"insect"
			],
			u: "1f41b",
			a: "0.6"
		},
		{
			n: [
				"ant",
				"animal",
				"garden",
				"insect"
			],
			u: "1f41c",
			a: "0.6"
		},
		{
			n: [
				"bee",
				"honey",
				"animal",
				"insect",
				"nature",
				"spring",
				"honeybee",
				"bumblebee"
			],
			u: "1f41d",
			a: "0.6"
		},
		{
			n: [
				"bug",
				"beetle",
				"animal",
				"insect"
			],
			u: "1fab2",
			a: "13"
		},
		{
			n: [
				"lady",
				"animal",
				"beetle",
				"garden",
				"insect",
				"nature",
				"ladybug",
				"ladybird",
				"lady beetle"
			],
			u: "1f41e",
			a: "0.6"
		},
		{
			n: [
				"bug",
				"animal",
				"insect",
				"cricket",
				"orthoptera",
				"grasshopper"
			],
			u: "1f997",
			a: "5"
		},
		{
			n: [
				"pest",
				"roach",
				"animal",
				"insect",
				"cockroach"
			],
			u: "1fab3",
			a: "13"
		},
		{
			n: [
				"spider",
				"animal",
				"insect"
			],
			u: "1f577-fe0f",
			a: "0.7"
		},
		{
			n: [
				"web",
				"spider",
				"spider web"
			],
			u: "1f578-fe0f",
			a: "0.7"
		},
		{
			n: [
				"zodiac",
				"scorpio",
				"scorpion",
				"scorpius"
			],
			u: "1f982",
			a: "1"
		},
		{
			n: [
				"bite",
				"pest",
				"fever",
				"virus",
				"insect",
				"disease",
				"malaria",
				"mosquito"
			],
			u: "1f99f",
			a: "11"
		},
		{
			n: [
				"fly",
				"pest",
				"animal",
				"insect",
				"maggot",
				"disease",
				"rotting"
			],
			u: "1fab0",
			a: "13"
		},
		{
			n: [
				"worm",
				"animal",
				"annelid",
				"parasite",
				"earthworm"
			],
			u: "1fab1",
			a: "13"
		},
		{
			n: [
				"virus",
				"amoeba",
				"microbe",
				"science",
				"bacteria"
			],
			u: "1f9a0",
			a: "11"
		},
		{
			n: [
				"date",
				"love",
				"plant",
				"flower",
				"bouquet",
				"romance",
				"birthday",
				"anniversary"
			],
			u: "1f490",
			a: "0.6"
		},
		{
			n: [
				"plant",
				"cherry",
				"flower",
				"spring",
				"blossom",
				"springtime",
				"cherry blossom"
			],
			u: "1f338",
			a: "0.6"
		},
		{
			n: [
				"white",
				"flower",
				"white flower"
			],
			u: "1f4ae",
			a: "0.6"
		},
		{
			n: [
				"calm",
				"lotus",
				"peace",
				"beauty",
				"flower",
				"purity",
				"buddhism",
				"hinduism",
				"serenity"
			],
			u: "1fab7",
			a: "14"
		},
		{
			n: [
				"plant",
				"rosette"
			],
			u: "1f3f5-fe0f",
			a: "0.7"
		},
		{
			n: [
				"red",
				"rose",
				"love",
				"plant",
				"beauty",
				"flower",
				"elegant",
				"valentine"
			],
			u: "1f339",
			a: "0.6"
		},
		{
			n: [
				"dying",
				"flower",
				"wilted",
				"wilted flower"
			],
			u: "1f940",
			a: "3"
		},
		{
			n: [
				"plant",
				"flower",
				"hibiscus"
			],
			u: "1f33a",
			a: "0.6"
		},
		{
			n: [
				"sun",
				"plant",
				"flower",
				"outdoors",
				"sunflower"
			],
			u: "1f33b",
			a: "0.6"
		},
		{
			n: [
				"plant",
				"flower",
				"blossom",
				"buttercup",
				"dandelion"
			],
			u: "1f33c",
			a: "0.6"
		},
		{
			n: [
				"tulip",
				"plant",
				"flower",
				"growth",
				"blossom"
			],
			u: "1f337",
			a: "0.6"
		},
		{
			n: [
				"bloom",
				"lilac",
				"plant",
				"shrub",
				"flower",
				"indigo",
				"lupine",
				"purple",
				"spring",
				"violet",
				"hyacinth",
				"lavender",
				"bluebonnet",
				"snapdragon"
			],
			u: "1fabb",
			a: "15"
		},
		{
			n: [
				"plant",
				"young",
				"sprout",
				"sapling",
				"seedling"
			],
			u: "1f331",
			a: "0.6"
		},
		{
			n: [
				"pot",
				"grow",
				"decor",
				"house",
				"plant",
				"potted",
				"nurturing",
				"potted plant"
			],
			u: "1fab4",
			a: "13"
		},
		{
			n: [
				"pine",
				"tree",
				"forest",
				"christmas",
				"evergreen",
				"evergreen tree"
			],
			u: "1f332",
			a: "1"
		},
		{
			n: [
				"tree",
				"green",
				"forest",
				"habitat",
				"shedding",
				"deciduous",
				"deciduous tree"
			],
			u: "1f333",
			a: "1"
		},
		{
			n: [
				"palm",
				"tree",
				"beach",
				"plant",
				"tropical",
				"palm tree"
			],
			u: "1f334",
			a: "0.6"
		},
		{
			n: [
				"plant",
				"cactus",
				"desert",
				"nature",
				"drought"
			],
			u: "1f335",
			a: "0.6"
		},
		{
			n: [
				"ear",
				"rice",
				"grain",
				"plant",
				"sheaf",
				"grains",
				"sheaf of rice"
			],
			u: "1f33e",
			a: "0.6"
		},
		{
			n: [
				"herb",
				"leaf",
				"plant"
			],
			u: "1f33f",
			a: "0.6"
		},
		{
			n: [
				"irish",
				"plant",
				"shamrock"
			],
			u: "2618-fe0f",
			a: "1"
		},
		{
			n: [
				"4",
				"four",
				"leaf",
				"irish",
				"lucky",
				"plant",
				"clover",
				"four leaf",
				"four leaf clover"
			],
			u: "1f340",
			a: "0.6"
		},
		{
			n: [
				"leaf",
				"maple",
				"falling",
				"maple leaf"
			],
			u: "1f341",
			a: "0.6"
		},
		{
			n: [
				"fall",
				"leaf",
				"autumn",
				"fallen",
				"falling",
				"fallen leaf"
			],
			u: "1f342",
			a: "0.6"
		},
		{
			n: [
				"blow",
				"leaf",
				"wind",
				"flutter",
				"fluttering",
				"leaf fluttering in wind"
			],
			u: "1f343",
			a: "0.6"
		},
		{
			n: [
				"home",
				"nest",
				"empty",
				"branch",
				"nesting",
				"empty nest"
			],
			u: "1fab9",
			a: "14"
		},
		{
			n: [
				"egg",
				"bird",
				"eggs",
				"nest",
				"branch",
				"nesting",
				"nest with eggs"
			],
			u: "1faba",
			a: "14"
		},
		{
			n: [
				"fungus",
				"mushroom",
				"toadstool"
			],
			u: "1f344",
			a: "0.6"
		},
		{
			n: [
				"bare",
				"dead",
				"tree",
				"wood",
				"trunk",
				"barren",
				"winter",
				"drought",
				"branches",
				"leafless",
				"leafless tree"
			],
			u: "1fabe",
			a: "16"
		}
	],
	food_drink: [
		{
			n: [
				"fruit",
				"grape",
				"grapes",
				"dionysus"
			],
			u: "1f347",
			a: "0.6"
		},
		{
			n: [
				"melon",
				"fruit",
				"cantaloupe"
			],
			u: "1f348",
			a: "0.6"
		},
		{
			n: [
				"fruit",
				"watermelon"
			],
			u: "1f349",
			a: "0.6"
		},
		{
			n: [
				"c",
				"fruit",
				"citrus",
				"orange",
				"vitamin",
				"tangerine",
				"nectarine"
			],
			u: "1f34a",
			a: "0.6"
		},
		{
			n: [
				"sour",
				"lemon",
				"fruit",
				"citrus"
			],
			u: "1f34b",
			a: "1"
		},
		{
			n: [
				"key",
				"lime",
				"sour",
				"zest",
				"fruit",
				"salsa",
				"tangy",
				"citrus",
				"mojito",
				"acidity",
				"garnish",
				"tequila",
				"cocktail",
				"tropical",
				"margarita",
				"refreshing"
			],
			u: "1f34b-200d-1f7e9",
			a: "15.1"
		},
		{
			n: [
				"fruit",
				"banana",
				"potassium"
			],
			u: "1f34c",
			a: "0.6"
		},
		{
			n: [
				"pina",
				"fruit",
				"colada",
				"tropical",
				"pineapple"
			],
			u: "1f34d",
			a: "0.6"
		},
		{
			n: [
				"food",
				"mango",
				"fruit",
				"tropical"
			],
			u: "1f96d",
			a: "11"
		},
		{
			n: [
				"red",
				"diet",
				"food",
				"ripe",
				"apple",
				"fruit",
				"health",
				"red apple"
			],
			u: "1f34e",
			a: "0.6"
		},
		{
			n: [
				"apple",
				"fruit",
				"green",
				"green apple"
			],
			u: "1f34f",
			a: "0.6"
		},
		{
			n: [
				"pear",
				"fruit"
			],
			u: "1f350",
			a: "1"
		},
		{
			n: [
				"peach",
				"fruit"
			],
			u: "1f351",
			a: "0.6"
		},
		{
			n: [
				"red",
				"fruit",
				"cherry",
				"berries",
				"cherries"
			],
			u: "1f352",
			a: "0.6"
		},
		{
			n: [
				"berry",
				"fruit",
				"strawberry"
			],
			u: "1f353",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"food",
				"berry",
				"fruit",
				"berries",
				"bilberry",
				"blueberry",
				"blueberries"
			],
			u: "1fad0",
			a: "13"
		},
		{
			n: [
				"food",
				"kiwi",
				"fruit",
				"kiwi fruit"
			],
			u: "1f95d",
			a: "3"
		},
		{
			n: [
				"food",
				"fruit",
				"tomato",
				"vegetable"
			],
			u: "1f345",
			a: "0.6"
		},
		{
			n: [
				"food",
				"olive"
			],
			u: "1fad2",
			a: "13"
		},
		{
			n: [
				"palm",
				"piña",
				"colada",
				"coconut"
			],
			u: "1f965",
			a: "5"
		},
		{
			n: [
				"food",
				"fruit",
				"avocado"
			],
			u: "1f951",
			a: "3"
		},
		{
			n: [
				"eggplant",
				"aubergine",
				"vegetable"
			],
			u: "1f346",
			a: "0.6"
		},
		{
			n: [
				"food",
				"potato",
				"vegetable"
			],
			u: "1f954",
			a: "3"
		},
		{
			n: [
				"food",
				"carrot",
				"vegetable"
			],
			u: "1f955",
			a: "3"
		},
		{
			n: [
				"ear",
				"corn",
				"farm",
				"maze",
				"crops",
				"maize",
				"ear of corn"
			],
			u: "1f33d",
			a: "0.6"
		},
		{
			n: [
				"hot",
				"pepper",
				"hot pepper"
			],
			u: "1f336-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bell",
				"food",
				"pepper",
				"capsicum",
				"vegetable",
				"bell pepper"
			],
			u: "1fad1",
			a: "13"
		},
		{
			n: [
				"food",
				"pickle",
				"cucumber",
				"vegetable"
			],
			u: "1f952",
			a: "3"
		},
		{
			n: [
				"bok",
				"choy",
				"kale",
				"green",
				"leafy",
				"salad",
				"burgers",
				"cabbage",
				"lettuce",
				"leafy green"
			],
			u: "1f96c",
			a: "11"
		},
		{
			n: [
				"wild",
				"cabbage",
				"broccoli"
			],
			u: "1f966",
			a: "5"
		},
		{
			n: [
				"garlic",
				"flavoring"
			],
			u: "1f9c4",
			a: "12"
		},
		{
			n: [
				"onion",
				"flavoring"
			],
			u: "1f9c5",
			a: "12"
		},
		{
			n: [
				"nut",
				"food",
				"peanut",
				"peanuts",
				"vegetable"
			],
			u: "1f95c",
			a: "3"
		},
		{
			n: [
				"food",
				"beans",
				"small",
				"kidney",
				"legume"
			],
			u: "1fad8",
			a: "14"
		},
		{
			n: [
				"plant",
				"almond",
				"chestnut"
			],
			u: "1f330",
			a: "0.6"
		},
		{
			n: [
				"beer",
				"herb",
				"root",
				"spice",
				"ginger",
				"health",
				"natural",
				"ginger root"
			],
			u: "1fada",
			a: "15"
		},
		{
			n: [
				"pea",
				"pod",
				"beans",
				"legume",
				"veggie",
				"pea pod",
				"edamame",
				"soybean",
				"beanstalk",
				"vegetable"
			],
			u: "1fadb",
			a: "15"
		},
		{
			n: [
				"food",
				"fungi",
				"pizza",
				"spore",
				"fungus",
				"nature",
				"shroom",
				"sprout",
				"veggie",
				"truffle",
				"mushroom",
				"shiitake",
				"toppings",
				"vegetable",
				"portobello",
				"vegetarian",
				"brown mushroom"
			],
			u: "1f344-200d-1f7eb",
			a: "15.1"
		},
		{
			n: [
				"beet",
				"food",
				"root",
				"salad",
				"garden",
				"radish",
				"turnip",
				"vegetable",
				"vegetarian",
				"root vegetable"
			],
			u: "1fadc",
			a: "16"
		},
		{
			n: [
				"food",
				"loaf",
				"bread",
				"carbs",
				"grain",
				"toast",
				"wheat",
				"restaurant"
			],
			u: "1f35e",
			a: "0.6"
		},
		{
			n: [
				"food",
				"roll",
				"bread",
				"french",
				"crescent",
				"croissant",
				"breakfast"
			],
			u: "1f950",
			a: "3"
		},
		{
			n: [
				"food",
				"bread",
				"french",
				"baguette",
				"baguette bread"
			],
			u: "1f956",
			a: "3"
		},
		{
			n: [
				"food",
				"naan",
				"pita",
				"arepa",
				"bread",
				"lavash",
				"gordita",
				"flatbread"
			],
			u: "1fad3",
			a: "13"
		},
		{
			n: [
				"pretzel",
				"twisted",
				"convoluted"
			],
			u: "1f968",
			a: "5"
		},
		{
			n: [
				"bagel",
				"bread",
				"bakery",
				"schmear",
				"breakfast"
			],
			u: "1f96f",
			a: "11"
		},
		{
			n: [
				"food",
				"crêpe",
				"hotcake",
				"pancake",
				"pancakes",
				"breakfast"
			],
			u: "1f95e",
			a: "3"
		},
		{
			n: [
				"iron",
				"waffle",
				"breakfast",
				"indecisive"
			],
			u: "1f9c7",
			a: "12"
		},
		{
			n: [
				"wedge",
				"cheese",
				"cheese wedge"
			],
			u: "1f9c0",
			a: "1"
		},
		{
			n: [
				"bone",
				"meat",
				"meat on bone"
			],
			u: "1f356",
			a: "0.6"
		},
		{
			n: [
				"leg",
				"bone",
				"hungry",
				"turkey",
				"chicken",
				"poultry",
				"drumstick",
				"poultry leg"
			],
			u: "1f357",
			a: "0.6"
		},
		{
			n: [
				"cut",
				"red",
				"chop",
				"meat",
				"steak",
				"lambchop",
				"porkchop",
				"cut of meat"
			],
			u: "1f969",
			a: "5"
		},
		{
			n: [
				"food",
				"meat",
				"bacon",
				"breakfast"
			],
			u: "1f953",
			a: "3"
		},
		{
			n: [
				"eat",
				"fast",
				"food",
				"burger",
				"hungry",
				"hamburger"
			],
			u: "1f354",
			a: "0.6"
		},
		{
			n: [
				"fast",
				"food",
				"fries",
				"french",
				"french fries"
			],
			u: "1f35f",
			a: "0.6"
		},
		{
			n: [
				"food",
				"pizza",
				"slice",
				"cheese",
				"hungry",
				"pepperoni"
			],
			u: "1f355",
			a: "0.6"
		},
		{
			n: [
				"dog",
				"hot",
				"hotdog",
				"hot dog",
				"sausage",
				"frankfurter"
			],
			u: "1f32d",
			a: "1"
		},
		{
			n: [
				"bread",
				"sandwich"
			],
			u: "1f96a",
			a: "5"
		},
		{
			n: [
				"taco",
				"mexican"
			],
			u: "1f32e",
			a: "1"
		},
		{
			n: [
				"wrap",
				"burrito",
				"mexican"
			],
			u: "1f32f",
			a: "1"
		},
		{
			n: [
				"food",
				"tamale",
				"mexican",
				"pamonha",
				"wrapped"
			],
			u: "1fad4",
			a: "13"
		},
		{
			n: [
				"food",
				"gyro",
				"kebab",
				"falafel",
				"stuffed",
				"flatbread",
				"stuffed flatbread"
			],
			u: "1f959",
			a: "3"
		},
		{
			n: [
				"falafel",
				"chickpea",
				"meatball"
			],
			u: "1f9c6",
			a: "12"
		},
		{
			n: [
				"egg",
				"food",
				"breakfast"
			],
			u: "1f95a",
			a: "3"
		},
		{
			n: [
				"up",
				"egg",
				"fry",
				"pan",
				"easy",
				"over",
				"side",
				"sunny",
				"frying",
				"cooking",
				"breakfast",
				"restaurant"
			],
			u: "1f373",
			a: "0.6"
		},
		{
			n: [
				"pan",
				"food",
				"paella",
				"shallow",
				"casserole",
				"shallow pan of food"
			],
			u: "1f958",
			a: "3"
		},
		{
			n: [
				"pot",
				"food",
				"soup",
				"stew",
				"pot of food"
			],
			u: "1f372",
			a: "0.6"
		},
		{
			n: [
				"pot",
				"ski",
				"food",
				"fondue",
				"cheese",
				"melted",
				"chocolate"
			],
			u: "1fad5",
			a: "13"
		},
		{
			n: [
				"bowl",
				"spoon",
				"cereal",
				"congee",
				"oatmeal",
				"porridge",
				"breakfast",
				"bowl with spoon"
			],
			u: "1f963",
			a: "5"
		},
		{
			n: [
				"food",
				"green",
				"salad",
				"green salad"
			],
			u: "1f957",
			a: "3"
		},
		{
			n: [
				"pop",
				"corn",
				"movie",
				"popcorn"
			],
			u: "1f37f",
			a: "1"
		},
		{
			n: [
				"dairy",
				"butter"
			],
			u: "1f9c8",
			a: "12"
		},
		{
			n: [
				"mad",
				"salt",
				"salty",
				"taste",
				"upset",
				"flavor",
				"shaker",
				"condiment"
			],
			u: "1f9c2",
			a: "11"
		},
		{
			n: [
				"can",
				"food",
				"canned",
				"canned food"
			],
			u: "1f96b",
			a: "5"
		},
		{
			n: [
				"box",
				"food",
				"bento",
				"bento box"
			],
			u: "1f371",
			a: "0.6"
		},
		{
			n: [
				"food",
				"rice",
				"cracker",
				"rice cracker"
			],
			u: "1f358",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"food",
				"rice",
				"japanese",
				"rice ball"
			],
			u: "1f359",
			a: "0.6"
		},
		{
			n: [
				"food",
				"rice",
				"cooked",
				"cooked rice"
			],
			u: "1f35a",
			a: "0.6"
		},
		{
			n: [
				"food",
				"rice",
				"curry",
				"curry rice"
			],
			u: "1f35b",
			a: "0.6"
		},
		{
			n: [
				"pho",
				"bowl",
				"food",
				"soup",
				"ramen",
				"noodle",
				"steaming",
				"chopsticks",
				"steaming bowl"
			],
			u: "1f35c",
			a: "0.6"
		},
		{
			n: [
				"food",
				"pasta",
				"spaghetti",
				"meatballs",
				"restaurant"
			],
			u: "1f35d",
			a: "0.6"
		},
		{
			n: [
				"food",
				"sweet",
				"potato",
				"roasted",
				"roasted sweet potato"
			],
			u: "1f360",
			a: "0.6"
		},
		{
			n: [
				"oden",
				"food",
				"kebab",
				"stick",
				"skewer",
				"seafood",
				"restaurant"
			],
			u: "1f362",
			a: "0.6"
		},
		{
			n: [
				"food",
				"sushi"
			],
			u: "1f363",
			a: "0.6"
		},
		{
			n: [
				"fried",
				"prawn",
				"shrimp",
				"tempura",
				"fried shrimp"
			],
			u: "1f364",
			a: "0.6"
		},
		{
			n: [
				"cake",
				"fish",
				"food",
				"swirl",
				"pastry",
				"restaurant",
				"fish cake with swirl"
			],
			u: "1f365",
			a: "0.6"
		},
		{
			n: [
				"cake",
				"moon",
				"autumn",
				"yuèbǐng",
				"festival",
				"moon cake"
			],
			u: "1f96e",
			a: "11"
		},
		{
			n: [
				"dango",
				"stick",
				"sweet",
				"skewer",
				"dessert",
				"japanese"
			],
			u: "1f361",
			a: "0.6"
		},
		{
			n: [
				"gyōza",
				"jiaozi",
				"pierogi",
				"dumpling",
				"empanada",
				"potsticker"
			],
			u: "1f95f",
			a: "5"
		},
		{
			n: [
				"cookie",
				"fortune",
				"prophecy",
				"fortune cookie"
			],
			u: "1f960",
			a: "5"
		},
		{
			n: [
				"box",
				"food",
				"pail",
				"oyster",
				"takeout",
				"delivery",
				"chopsticks",
				"takeout box"
			],
			u: "1f961",
			a: "5"
		},
		{
			n: [
				"ice",
				"food",
				"soft",
				"cream",
				"serve",
				"sweet",
				"dessert",
				"icecream",
				"restaurant",
				"soft ice cream"
			],
			u: "1f366",
			a: "0.6"
		},
		{
			n: [
				"ice",
				"sweet",
				"shaved",
				"dessert",
				"shaved ice",
				"restaurant"
			],
			u: "1f367",
			a: "0.6"
		},
		{
			n: [
				"ice",
				"food",
				"cream",
				"sweet",
				"dessert",
				"ice cream",
				"restaurant"
			],
			u: "1f368",
			a: "0.6"
		},
		{
			n: [
				"food",
				"donut",
				"sweet",
				"dessert",
				"doughnut",
				"breakfast"
			],
			u: "1f369",
			a: "0.6"
		},
		{
			n: [
				"chip",
				"sweet",
				"cookie",
				"dessert",
				"chocolate"
			],
			u: "1f36a",
			a: "0.6"
		},
		{
			n: [
				"bday",
				"cake",
				"happy",
				"sweet",
				"pastry",
				"dessert",
				"birthday",
				"celebration",
				"birthday cake"
			],
			u: "1f382",
			a: "0.6"
		},
		{
			n: [
				"cake",
				"slice",
				"sweet",
				"pastry",
				"dessert",
				"shortcake"
			],
			u: "1f370",
			a: "0.6"
		},
		{
			n: [
				"sugar",
				"sweet",
				"treat",
				"bakery",
				"cupcake",
				"dessert",
				"sprinkles"
			],
			u: "1f9c1",
			a: "11"
		},
		{
			n: [
				"pie",
				"meat",
				"apple",
				"fruit",
				"slice",
				"pastry",
				"filling",
				"pumpkin"
			],
			u: "1f967",
			a: "5"
		},
		{
			n: [
				"bar",
				"candy",
				"sweet",
				"tooth",
				"dessert",
				"chocolate",
				"halloween",
				"chocolate bar"
			],
			u: "1f36b",
			a: "0.6"
		},
		{
			n: [
				"candy",
				"sweet",
				"tooth",
				"dessert",
				"wrapper",
				"cavities",
				"halloween",
				"restaurant"
			],
			u: "1f36c",
			a: "0.6"
		},
		{
			n: [
				"food",
				"candy",
				"sweet",
				"dessert",
				"lollipop",
				"restaurant"
			],
			u: "1f36d",
			a: "0.6"
		},
		{
			n: [
				"sweet",
				"custard",
				"dessert",
				"pudding"
			],
			u: "1f36e",
			a: "0.6"
		},
		{
			n: [
				"jar",
				"pot",
				"bear",
				"food",
				"honey",
				"sweet",
				"barrel",
				"honeypot",
				"honey pot"
			],
			u: "1f36f",
			a: "0.6"
		},
		{
			n: [
				"baby",
				"born",
				"milk",
				"birth",
				"drink",
				"babies",
				"bottle",
				"infant",
				"newborn",
				"baby bottle"
			],
			u: "1f37c",
			a: "1"
		},
		{
			n: [
				"milk",
				"drink",
				"glass",
				"glass of milk"
			],
			u: "1f95b",
			a: "3"
		},
		{
			n: [
				"hot",
				"tea",
				"cafe",
				"chai",
				"drink",
				"coffee",
				"morning",
				"beverage",
				"caffeine",
				"steaming",
				"hot beverage"
			],
			u: "2615",
			a: "0.6"
		},
		{
			n: [
				"pot",
				"tea",
				"brew",
				"food",
				"drink",
				"teapot"
			],
			u: "1fad6",
			a: "13"
		},
		{
			n: [
				"cup",
				"tea",
				"drink",
				"handle",
				"oolong",
				"teacup",
				"beverage",
				"teacup without handle"
			],
			u: "1f375",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"cup",
				"sake",
				"drink",
				"bottle",
				"beverage",
				"restaurant"
			],
			u: "1f376",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"cork",
				"drink",
				"bottle",
				"popping",
				"bottle with popping cork"
			],
			u: "1f37e",
			a: "1"
		},
		{
			n: [
				"bar",
				"club",
				"wine",
				"booze",
				"drink",
				"glass",
				"drinks",
				"alcohol",
				"beverage",
				"drinking",
				"wine glass",
				"restaurant"
			],
			u: "1f377",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"mad",
				"men",
				"club",
				"booze",
				"drink",
				"glass",
				"drinks",
				"alcohol",
				"martini",
				"cocktail",
				"drinking",
				"cocktail glass"
			],
			u: "1f378",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"mai",
				"tai",
				"club",
				"booze",
				"drink",
				"drunk",
				"party",
				"drinks",
				"alcohol",
				"tropics",
				"cocktail",
				"drinking",
				"tropical",
				"tropical drink"
			],
			u: "1f379",
			a: "0.6"
		},
		{
			n: [
				"ale",
				"bar",
				"mug",
				"beer",
				"pint",
				"booze",
				"drink",
				"stein",
				"drinks",
				"summer",
				"alcohol",
				"beer mug",
				"drinking",
				"octoberfest",
				"oktoberfest"
			],
			u: "1f37a",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"beer",
				"mugs",
				"booze",
				"clink",
				"cheers",
				"drinks",
				"alcohol",
				"bottoms",
				"clinking",
				"drinking",
				"clinking beer mugs"
			],
			u: "1f37b",
			a: "0.6"
		},
		{
			n: [
				"clink",
				"drink",
				"glass",
				"glasses",
				"clinking",
				"celebrate",
				"clinking glasses"
			],
			u: "1f942",
			a: "3"
		},
		{
			n: [
				"shot",
				"glass",
				"liquor",
				"scotch",
				"whisky",
				"tumbler",
				"whiskey",
				"tumbler glass"
			],
			u: "1f943",
			a: "3"
		},
		{
			n: [
				"oops",
				"pour",
				"drink",
				"empty",
				"glass",
				"spill",
				"water",
				"liquid",
				"pouring",
				"accident",
				"pouring liquid"
			],
			u: "1fad7",
			a: "14"
		},
		{
			n: [
				"cup",
				"malt",
				"soda",
				"soft",
				"drink",
				"juice",
				"straw",
				"water",
				"cup with straw"
			],
			u: "1f964",
			a: "5"
		},
		{
			n: [
				"tea",
				"boba",
				"food",
				"milk",
				"pearl",
				"bubble",
				"bubble tea"
			],
			u: "1f9cb",
			a: "13"
		},
		{
			n: [
				"box",
				"juice",
				"straw",
				"sweet",
				"beverage",
				"beverage box"
			],
			u: "1f9c3",
			a: "12"
		},
		{
			n: [
				"mate",
				"drink"
			],
			u: "1f9c9",
			a: "12"
		},
		{
			n: [
				"ice",
				"cold",
				"cube",
				"iceberg"
			],
			u: "1f9ca",
			a: "12"
		},
		{
			n: [
				"hashi",
				"kuaizi",
				"jeotgarak",
				"chopsticks"
			],
			u: "1f962",
			a: "5"
		},
		{
			n: [
				"eat",
				"fork",
				"knife",
				"plate",
				"dinner",
				"cooking",
				"fork and knife with plate"
			],
			u: "1f37d-fe0f",
			a: "0.7"
		},
		{
			n: [
				"eat",
				"yum",
				"feed",
				"food",
				"fork",
				"knife",
				"lunch",
				"yummy",
				"breaky",
				"dinner",
				"hungry",
				"cooking",
				"cutlery",
				"breakfast",
				"delicious",
				"restaurant",
				"fork and knife"
			],
			u: "1f374",
			a: "0.6"
		},
		{
			n: [
				"eat",
				"spoon",
				"tableware"
			],
			u: "1f944",
			a: "3"
		},
		{
			n: [
				"chef",
				"tool",
				"hocho",
				"knife",
				"weapon",
				"cooking",
				"kitchen",
				"kitchen knife"
			],
			u: "1f52a",
			a: "0.6"
		},
		{
			n: [
				"jar",
				"empty",
				"sauce",
				"store",
				"nothing",
				"condiment",
				"container"
			],
			u: "1fad9",
			a: "14"
		},
		{
			n: [
				"jug",
				"tool",
				"drink",
				"weapon",
				"zodiac",
				"amphora",
				"cooking",
				"aquarius"
			],
			u: "1f3fa",
			a: "1"
		}
	],
	travel_places: [
		{
			n: [
				"earth",
				"globe",
				"world",
				"africa",
				"europe",
				"showing",
				"europe africa",
				"globe showing Europe Africa"
			],
			u: "1f30d",
			a: "0.7"
		},
		{
			n: [
				"earth",
				"globe",
				"world",
				"showing",
				"americas",
				"globe showing Americas"
			],
			u: "1f30e",
			a: "0.7"
		},
		{
			n: [
				"asia",
				"earth",
				"globe",
				"world",
				"showing",
				"australia",
				"asia australia",
				"globe showing Asia Australia"
			],
			u: "1f30f",
			a: "0.6"
		},
		{
			n: [
				"web",
				"earth",
				"globe",
				"world",
				"internet",
				"meridians",
				"worldwide",
				"globe with meridians"
			],
			u: "1f310",
			a: "1"
		},
		{
			n: [
				"map",
				"world",
				"world map"
			],
			u: "1f5fa-fe0f",
			a: "0.7"
		},
		{
			n: [
				"map",
				"japan",
				"map of Japan"
			],
			u: "1f5fe",
			a: "0.6"
		},
		{
			n: [
				"compass",
				"magnetic",
				"direction",
				"navigation",
				"orienteering"
			],
			u: "1f9ed",
			a: "11"
		},
		{
			n: [
				"cold",
				"snow",
				"mountain",
				"snow capped",
				"snow capped mountain"
			],
			u: "1f3d4-fe0f",
			a: "0.7"
		},
		{
			n: [
				"mountain"
			],
			u: "26f0-fe0f",
			a: "0.7"
		},
		{
			n: [
				"nature",
				"volcano",
				"eruption",
				"mountain"
			],
			u: "1f30b",
			a: "0.6"
		},
		{
			n: [
				"fuji",
				"mount",
				"nature",
				"mountain",
				"mount fuji"
			],
			u: "1f5fb",
			a: "0.6"
		},
		{
			n: [
				"camping"
			],
			u: "1f3d5-fe0f",
			a: "0.7"
		},
		{
			n: [
				"beach",
				"umbrella",
				"beach with umbrella"
			],
			u: "1f3d6-fe0f",
			a: "0.7"
		},
		{
			n: [
				"desert"
			],
			u: "1f3dc-fe0f",
			a: "0.7"
		},
		{
			n: [
				"desert",
				"island",
				"desert island"
			],
			u: "1f3dd-fe0f",
			a: "0.7"
		},
		{
			n: [
				"park",
				"national",
				"national park"
			],
			u: "1f3de-fe0f",
			a: "0.7"
		},
		{
			n: [
				"stadium"
			],
			u: "1f3df-fe0f",
			a: "0.7"
		},
		{
			n: [
				"building",
				"classical",
				"classical building"
			],
			u: "1f3db-fe0f",
			a: "0.7"
		},
		{
			n: [
				"crane",
				"building",
				"construction",
				"building construction"
			],
			u: "1f3d7-fe0f",
			a: "0.7"
		},
		{
			n: [
				"clay",
				"wall",
				"brick",
				"bricks",
				"mortar"
			],
			u: "1f9f1",
			a: "11"
		},
		{
			n: [
				"rock",
				"heavy",
				"solid",
				"stone",
				"tough",
				"boulder"
			],
			u: "1faa8",
			a: "13"
		},
		{
			n: [
				"log",
				"wood",
				"lumber",
				"timber"
			],
			u: "1fab5",
			a: "13"
		},
		{
			n: [
				"hut",
				"home",
				"yurt",
				"house",
				"shelter",
				"roundhouse"
			],
			u: "1f6d6",
			a: "13"
		},
		{
			n: [
				"house",
				"houses"
			],
			u: "1f3d8-fe0f",
			a: "0.7"
		},
		{
			n: [
				"home",
				"house",
				"derelict",
				"derelict house"
			],
			u: "1f3da-fe0f",
			a: "0.7"
		},
		{
			n: [
				"home",
				"house",
				"heart",
				"ranch",
				"where",
				"settle",
				"simple",
				"country",
				"building",
				"suburban",
				"suburbia"
			],
			u: "1f3e0",
			a: "0.6"
		},
		{
			n: [
				"home",
				"heart",
				"house",
				"ranch",
				"where",
				"garden",
				"settle",
				"simple",
				"country",
				"building",
				"suburban",
				"suburbia",
				"house with garden"
			],
			u: "1f3e1",
			a: "0.6"
		},
		{
			n: [
				"job",
				"city",
				"office",
				"cubical",
				"building",
				"office building"
			],
			u: "1f3e2",
			a: "0.6"
		},
		{
			n: [
				"post",
				"office",
				"building",
				"japanese",
				"Japanese post office"
			],
			u: "1f3e3",
			a: "0.6"
		},
		{
			n: [
				"post",
				"office",
				"building",
				"european",
				"post office"
			],
			u: "1f3e4",
			a: "1"
		},
		{
			n: [
				"doctor",
				"hospital",
				"building",
				"medicine"
			],
			u: "1f3e5",
			a: "0.6"
		},
		{
			n: [
				"bank",
				"building"
			],
			u: "1f3e6",
			a: "0.6"
		},
		{
			n: [
				"hotel",
				"building"
			],
			u: "1f3e8",
			a: "0.6"
		},
		{
			n: [
				"love",
				"hotel",
				"building",
				"love hotel"
			],
			u: "1f3e9",
			a: "0.6"
		},
		{
			n: [
				"24",
				"hours",
				"store",
				"building",
				"convenience",
				"convenience store"
			],
			u: "1f3ea",
			a: "0.6"
		},
		{
			n: [
				"school",
				"building"
			],
			u: "1f3eb",
			a: "0.6"
		},
		{
			n: [
				"store",
				"building",
				"department",
				"department store"
			],
			u: "1f3ec",
			a: "0.6"
		},
		{
			n: [
				"factory",
				"building"
			],
			u: "1f3ed",
			a: "0.6"
		},
		{
			n: [
				"castle",
				"building",
				"japanese",
				"Japanese castle"
			],
			u: "1f3ef",
			a: "0.6"
		},
		{
			n: [
				"castle",
				"building",
				"european"
			],
			u: "1f3f0",
			a: "0.6"
		},
		{
			n: [
				"chapel",
				"wedding",
				"hitched",
				"romance",
				"nuptials"
			],
			u: "1f492",
			a: "0.6"
		},
		{
			n: [
				"tokyo",
				"tower",
				"Tokyo tower"
			],
			u: "1f5fc",
			a: "0.6"
		},
		{
			n: [
				"ny",
				"new",
				"nyc",
				"york",
				"statue",
				"liberty",
				"Statue of Liberty"
			],
			u: "1f5fd",
			a: "0.6"
		},
		{
			n: [
				"bless",
				"cross",
				"church",
				"chapel",
				"religion",
				"christian"
			],
			u: "26ea",
			a: "0.6"
		},
		{
			n: [
				"islam",
				"mosque",
				"masjid",
				"muslim",
				"religion"
			],
			u: "1f54c",
			a: "1"
		},
		{
			n: [
				"hindu",
				"temple",
				"hindu temple"
			],
			u: "1f6d5",
			a: "12"
		},
		{
			n: [
				"jew",
				"jewish",
				"temple",
				"judaism",
				"religion",
				"synagogue"
			],
			u: "1f54d",
			a: "1"
		},
		{
			n: [
				"shinto",
				"shrine",
				"religion",
				"shinto shrine"
			],
			u: "26e9-fe0f",
			a: "0.7"
		},
		{
			n: [
				"hajj",
				"kaaba",
				"islam",
				"umrah",
				"muslim",
				"religion"
			],
			u: "1f54b",
			a: "1"
		},
		{
			n: [
				"fountain"
			],
			u: "26f2",
			a: "0.6"
		},
		{
			n: [
				"tent",
				"camping"
			],
			u: "26fa",
			a: "0.6"
		},
		{
			n: [
				"fog",
				"foggy"
			],
			u: "1f301",
			a: "0.6"
		},
		{
			n: [
				"star",
				"night",
				"stars",
				"night with stars"
			],
			u: "1f303",
			a: "0.6"
		},
		{
			n: [
				"city",
				"cityscape"
			],
			u: "1f3d9-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sun",
				"over",
				"morning",
				"sunrise",
				"mountains",
				"sunrise over mountains"
			],
			u: "1f304",
			a: "0.6"
		},
		{
			n: [
				"sun",
				"nature",
				"sunrise",
				"morning"
			],
			u: "1f305",
			a: "0.6"
		},
		{
			n: [
				"at",
				"sun",
				"city",
				"dusk",
				"sunset",
				"evening",
				"building",
				"cityscape",
				"landscape",
				"cityscape at dusk"
			],
			u: "1f306",
			a: "0.6"
		},
		{
			n: [
				"sun",
				"dusk",
				"sunset",
				"building"
			],
			u: "1f307",
			a: "0.6"
		},
		{
			n: [
				"at",
				"night",
				"bridge",
				"bridge at night"
			],
			u: "1f309",
			a: "0.6"
		},
		{
			n: [
				"hot",
				"springs",
				"steaming",
				"hotsprings",
				"hot springs"
			],
			u: "2668-fe0f",
			a: "0.6"
		},
		{
			n: [
				"horse",
				"carousel",
				"entertainment",
				"carousel horse"
			],
			u: "1f3a0",
			a: "0.6"
		},
		{
			n: [
				"park",
				"play",
				"slide",
				"theme",
				"playing",
				"sliding",
				"amusement",
				"playground",
				"playground slide"
			],
			u: "1f6dd",
			a: "14"
		},
		{
			n: [
				"park",
				"theme",
				"wheel",
				"ferris",
				"amusement",
				"ferris wheel"
			],
			u: "1f3a1",
			a: "0.6"
		},
		{
			n: [
				"park",
				"theme",
				"roller",
				"coaster",
				"amusement",
				"roller coaster"
			],
			u: "1f3a2",
			a: "0.6"
		},
		{
			n: [
				"cut",
				"pole",
				"fresh",
				"shave",
				"barber",
				"haircut",
				"barber pole"
			],
			u: "1f488",
			a: "0.6"
		},
		{
			n: [
				"tent",
				"circus",
				"circus tent"
			],
			u: "1f3aa",
			a: "0.6"
		},
		{
			n: [
				"steam",
				"train",
				"engine",
				"trains",
				"travel",
				"caboose",
				"railway",
				"locomotive"
			],
			u: "1f682",
			a: "1"
		},
		{
			n: [
				"car",
				"tram",
				"train",
				"travel",
				"railway",
				"electric",
				"trolleybus",
				"railway car"
			],
			u: "1f683",
			a: "0.6"
		},
		{
			n: [
				"speed",
				"train",
				"railway",
				"high speed",
				"shinkansen",
				"high speed train"
			],
			u: "1f684",
			a: "0.6"
		},
		{
			n: [
				"nose",
				"speed",
				"train",
				"bullet",
				"travel",
				"railway",
				"high speed",
				"shinkansen",
				"bullet train"
			],
			u: "1f685",
			a: "0.6"
		},
		{
			n: [
				"choo",
				"train",
				"arrived",
				"railway"
			],
			u: "1f686",
			a: "1"
		},
		{
			n: [
				"metro",
				"subway",
				"travel"
			],
			u: "1f687",
			a: "0.6"
		},
		{
			n: [
				"rail",
				"light",
				"arrived",
				"railway",
				"monorail",
				"light rail"
			],
			u: "1f688",
			a: "1"
		},
		{
			n: [
				"train",
				"station",
				"railway"
			],
			u: "1f689",
			a: "0.6"
		},
		{
			n: [
				"tram",
				"trolleybus"
			],
			u: "1f68a",
			a: "1"
		},
		{
			n: [
				"vehicle",
				"monorail"
			],
			u: "1f69d",
			a: "1"
		},
		{
			n: [
				"car",
				"trip",
				"railway",
				"mountain",
				"mountain railway"
			],
			u: "1f69e",
			a: "1"
		},
		{
			n: [
				"bus",
				"car",
				"tram",
				"trolley",
				"tram car",
				"trolleybus"
			],
			u: "1f68b",
			a: "1"
		},
		{
			n: [
				"bus",
				"school",
				"vehicle"
			],
			u: "1f68c",
			a: "0.6"
		},
		{
			n: [
				"bus",
				"cars",
				"oncoming",
				"oncoming bus"
			],
			u: "1f68d",
			a: "0.7"
		},
		{
			n: [
				"bus",
				"tram",
				"trolley",
				"trolleybus"
			],
			u: "1f68e",
			a: "1"
		},
		{
			n: [
				"bus",
				"van",
				"drive",
				"minibus",
				"vehicle"
			],
			u: "1f690",
			a: "1"
		},
		{
			n: [
				"vehicle",
				"ambulance",
				"emergency"
			],
			u: "1f691",
			a: "0.6"
		},
		{
			n: [
				"fire",
				"truck",
				"engine",
				"fire engine"
			],
			u: "1f692",
			a: "0.6"
		},
		{
			n: [
				"5–0",
				"car",
				"cops",
				"patrol",
				"police",
				"police car"
			],
			u: "1f693",
			a: "0.6"
		},
		{
			n: [
				"car",
				"police",
				"oncoming",
				"oncoming police car"
			],
			u: "1f694",
			a: "0.7"
		},
		{
			n: [
				"cab",
				"car",
				"taxi",
				"drive",
				"cabbie",
				"yellow",
				"vehicle"
			],
			u: "1f695",
			a: "0.6"
		},
		{
			n: [
				"cab",
				"cars",
				"hail",
				"taxi",
				"drove",
				"cabbie",
				"yellow",
				"oncoming",
				"oncoming taxi"
			],
			u: "1f696",
			a: "1"
		},
		{
			n: [
				"car",
				"driving",
				"vehicle",
				"automobile"
			],
			u: "1f697",
			a: "0.6"
		},
		{
			n: [
				"car",
				"cars",
				"drove",
				"vehicle",
				"oncoming",
				"automobile",
				"oncoming automobile"
			],
			u: "1f698",
			a: "0.7"
		},
		{
			n: [
				"car",
				"drive",
				"sport",
				"utility",
				"vehicle",
				"recreational",
				"sportutility",
				"sport utility vehicle"
			],
			u: "1f699",
			a: "0.6"
		},
		{
			n: [
				"car",
				"truck",
				"pickup",
				"flatbed",
				"pick up",
				"automobile",
				"pickup truck",
				"transportation"
			],
			u: "1f6fb",
			a: "13"
		},
		{
			n: [
				"car",
				"drive",
				"truck",
				"vehicle",
				"delivery",
				"delivery truck"
			],
			u: "1f69a",
			a: "0.6"
		},
		{
			n: [
				"car",
				"move",
				"semi",
				"drive",
				"lorry",
				"truck",
				"vehicle",
				"articulated",
				"articulated lorry"
			],
			u: "1f69b",
			a: "1"
		},
		{
			n: [
				"tractor",
				"vehicle"
			],
			u: "1f69c",
			a: "1"
		},
		{
			n: [
				"car",
				"zoom",
				"racing",
				"racing car"
			],
			u: "1f3ce-fe0f",
			a: "0.7"
		},
		{
			n: [
				"racing",
				"motorcycle"
			],
			u: "1f3cd-fe0f",
			a: "0.7"
		},
		{
			n: [
				"motor",
				"scooter",
				"motor scooter"
			],
			u: "1f6f5",
			a: "3"
		},
		{
			n: [
				"manual",
				"wheelchair",
				"accessibility",
				"manual wheelchair"
			],
			u: "1f9bd",
			a: "12"
		},
		{
			n: [
				"motorized",
				"wheelchair",
				"accessibility",
				"motorized wheelchair"
			],
			u: "1f9bc",
			a: "12"
		},
		{
			n: [
				"tuk",
				"auto",
				"rickshaw",
				"auto rickshaw"
			],
			u: "1f6fa",
			a: "12"
		},
		{
			n: [
				"bike",
				"gang",
				"ride",
				"spin",
				"class",
				"cycle",
				"bicycle",
				"cycling",
				"cyclist",
				"spinning"
			],
			u: "1f6b2",
			a: "0.6"
		},
		{
			n: [
				"kick",
				"scooter",
				"kick scooter"
			],
			u: "1f6f4",
			a: "3"
		},
		{
			n: [
				"board",
				"skate",
				"skater",
				"wheels",
				"skateboard"
			],
			u: "1f6f9",
			a: "11"
		},
		{
			n: [
				"skate",
				"sport",
				"blades",
				"roller",
				"skates",
				"roller skate"
			],
			u: "1f6fc",
			a: "13"
		},
		{
			n: [
				"bus",
				"stop",
				"busstop",
				"bus stop"
			],
			u: "1f68f",
			a: "0.6"
		},
		{
			n: [
				"road",
				"highway",
				"motorway"
			],
			u: "1f6e3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"track",
				"train",
				"railway",
				"railway track"
			],
			u: "1f6e4-fe0f",
			a: "0.7"
		},
		{
			n: [
				"oil",
				"drum",
				"oil drum"
			],
			u: "1f6e2-fe0f",
			a: "0.7"
		},
		{
			n: [
				"gas",
				"fuel",
				"pump",
				"diesel",
				"station",
				"fuelpump",
				"gasoline",
				"fuel pump"
			],
			u: "26fd",
			a: "0.6"
		},
		{
			n: [
				"car",
				"tire",
				"turn",
				"wheel",
				"circle",
				"vehicle"
			],
			u: "1f6de",
			a: "14"
		},
		{
			n: [
				"car",
				"alarm",
				"alert",
				"light",
				"siren",
				"beacon",
				"police",
				"emergency",
				"revolving",
				"police car light"
			],
			u: "1f6a8",
			a: "0.6"
		},
		{
			n: [
				"stop",
				"light",
				"signal",
				"traffic",
				"stoplight",
				"horizontal",
				"intersection",
				"horizontal traffic light"
			],
			u: "1f6a5",
			a: "0.6"
		},
		{
			n: [
				"stop",
				"drove",
				"light",
				"signal",
				"traffic",
				"vertical",
				"stoplight",
				"intersection",
				"vertical traffic light"
			],
			u: "1f6a6",
			a: "1"
		},
		{
			n: [
				"sign",
				"stop",
				"stop sign",
				"octagonal"
			],
			u: "1f6d1",
			a: "3"
		},
		{
			n: [
				"barrier",
				"construction"
			],
			u: "1f6a7",
			a: "0.6"
		},
		{
			n: [
				"ship",
				"tool",
				"anchor"
			],
			u: "2693",
			a: "0.6"
		},
		{
			n: [
				"buoy",
				"life",
				"ring",
				"save",
				"swim",
				"float",
				"saver",
				"rescue",
				"safety",
				"ring buoy",
				"lifesaver",
				"preserver"
			],
			u: "1f6df",
			a: "14"
		},
		{
			n: [
				"sea",
				"boat",
				"yacht",
				"resort",
				"sailing",
				"sailboat"
			],
			u: "26f5",
			a: "0.6"
		},
		{
			n: [
				"boat",
				"canoe"
			],
			u: "1f6f6",
			a: "3"
		},
		{
			n: [
				"boat",
				"lake",
				"luxury",
				"summer",
				"travel",
				"speedboat",
				"billionaire",
				"millionaire"
			],
			u: "1f6a4",
			a: "0.6"
		},
		{
			n: [
				"ship",
				"passenger",
				"passenger ship"
			],
			u: "1f6f3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"boat",
				"ferry",
				"passenger"
			],
			u: "26f4-fe0f",
			a: "0.7"
		},
		{
			n: [
				"boat",
				"motor",
				"motorboat",
				"motor boat"
			],
			u: "1f6e5-fe0f",
			a: "0.7"
		},
		{
			n: [
				"ship",
				"boat",
				"travel",
				"passenger"
			],
			u: "1f6a2",
			a: "0.6"
		},
		{
			n: [
				"fly",
				"jet",
				"plane",
				"flying",
				"travel",
				"airplane",
				"aeroplane"
			],
			u: "2708-fe0f",
			a: "0.6"
		},
		{
			n: [
				"plane",
				"small",
				"airplane",
				"aeroplane",
				"small airplane"
			],
			u: "1f6e9-fe0f",
			a: "0.7"
		},
		{
			n: [
				"plane",
				"airplane",
				"check in",
				"aeroplane",
				"departure",
				"departures",
				"airplane departure"
			],
			u: "1f6eb",
			a: "1"
		},
		{
			n: [
				"plane",
				"arrival",
				"landing",
				"airplane",
				"arrivals",
				"arriving",
				"aeroplane",
				"airplane arrival"
			],
			u: "1f6ec",
			a: "1"
		},
		{
			n: [
				"skydive",
				"parasail",
				"parachute",
				"hang glide"
			],
			u: "1fa82",
			a: "12"
		},
		{
			n: [
				"seat",
				"chair"
			],
			u: "1f4ba",
			a: "0.6"
		},
		{
			n: [
				"copter",
				"travel",
				"vehicle",
				"helicopter",
				"roflcopter"
			],
			u: "1f681",
			a: "1"
		},
		{
			n: [
				"railway",
				"suspension",
				"suspension railway"
			],
			u: "1f69f",
			a: "1"
		},
		{
			n: [
				"ski",
				"lift",
				"cable",
				"gondola",
				"cableway",
				"mountain",
				"mountain cableway"
			],
			u: "1f6a0",
			a: "1"
		},
		{
			n: [
				"car",
				"cable",
				"aerial",
				"gondola",
				"ropeway",
				"tramway",
				"aerial tramway"
			],
			u: "1f6a1",
			a: "1"
		},
		{
			n: [
				"space",
				"satellite"
			],
			u: "1f6f0-fe0f",
			a: "0.7"
		},
		{
			n: [
				"space",
				"rocket",
				"launch",
				"travel",
				"rockets"
			],
			u: "1f680",
			a: "0.6"
		},
		{
			n: [
				"ufo",
				"extra",
				"aliens",
				"flying",
				"saucer",
				"terrestrial",
				"flying saucer"
			],
			u: "1f6f8",
			a: "5"
		},
		{
			n: [
				"bell",
				"hotel",
				"bellhop",
				"bellhop bell"
			],
			u: "1f6ce-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bag",
				"roller",
				"travel",
				"luggage",
				"packing",
				"suitcase"
			],
			u: "1f9f3",
			a: "11"
		},
		{
			n: [
				"done",
				"sand",
				"time",
				"timer",
				"hourglass",
				"hourglass done"
			],
			u: "231b",
			a: "0.6"
		},
		{
			n: [
				"not",
				"done",
				"sand",
				"yolo",
				"hours",
				"timer",
				"flowing",
				"waiting",
				"hourglass",
				"hourglass not done"
			],
			u: "23f3",
			a: "0.6"
		},
		{
			n: [
				"time",
				"watch",
				"clock"
			],
			u: "231a",
			a: "0.6"
		},
		{
			n: [
				"hrs",
				"late",
				"time",
				"alarm",
				"clock",
				"hours",
				"waiting",
				"alarm clock"
			],
			u: "23f0",
			a: "0.6"
		},
		{
			n: [
				"time",
				"clock",
				"stopwatch"
			],
			u: "23f1-fe0f",
			a: "1"
		},
		{
			n: [
				"clock",
				"timer",
				"timer clock"
			],
			u: "23f2-fe0f",
			a: "1"
		},
		{
			n: [
				"time",
				"clock",
				"mantelpiece",
				"mantelpiece clock"
			],
			u: "1f570-fe0f",
			a: "0.7"
		},
		{
			n: [
				"12",
				"time",
				"12:00",
				"clock",
				"twelve",
				"o’clock",
				"twelve o’clock"
			],
			u: "1f55b",
			a: "0.6"
		},
		{
			n: [
				"12",
				"30",
				"time",
				"12:30",
				"clock",
				"thirty",
				"twelve",
				"twelve thirty"
			],
			u: "1f567",
			a: "0.7"
		},
		{
			n: [
				"1",
				"one",
				"1:00",
				"time",
				"clock",
				"o’clock",
				"one o’clock"
			],
			u: "1f550",
			a: "0.6"
		},
		{
			n: [
				"1",
				"30",
				"one",
				"1:30",
				"time",
				"clock",
				"thirty",
				"one thirty"
			],
			u: "1f55c",
			a: "0.7"
		},
		{
			n: [
				"2",
				"two",
				"2:00",
				"time",
				"clock",
				"o’clock",
				"two o’clock"
			],
			u: "1f551",
			a: "0.6"
		},
		{
			n: [
				"2",
				"30",
				"two",
				"2:30",
				"time",
				"clock",
				"thirty",
				"two thirty"
			],
			u: "1f55d",
			a: "0.7"
		},
		{
			n: [
				"3",
				"3:00",
				"time",
				"clock",
				"three",
				"o’clock",
				"three o’clock"
			],
			u: "1f552",
			a: "0.6"
		},
		{
			n: [
				"3",
				"30",
				"3:30",
				"time",
				"clock",
				"three",
				"thirty",
				"three thirty"
			],
			u: "1f55e",
			a: "0.7"
		},
		{
			n: [
				"4",
				"4:00",
				"four",
				"time",
				"clock",
				"o’clock",
				"four o’clock"
			],
			u: "1f553",
			a: "0.6"
		},
		{
			n: [
				"4",
				"30",
				"4:30",
				"four",
				"time",
				"clock",
				"thirty",
				"four thirty"
			],
			u: "1f55f",
			a: "0.7"
		},
		{
			n: [
				"5",
				"5:00",
				"five",
				"time",
				"clock",
				"o’clock",
				"five o’clock"
			],
			u: "1f554",
			a: "0.6"
		},
		{
			n: [
				"5",
				"30",
				"5:30",
				"five",
				"time",
				"clock",
				"thirty",
				"five thirty"
			],
			u: "1f560",
			a: "0.7"
		},
		{
			n: [
				"6",
				"six",
				"6:00",
				"time",
				"clock",
				"o’clock",
				"six o’clock"
			],
			u: "1f555",
			a: "0.6"
		},
		{
			n: [
				"6",
				"30",
				"six",
				"6:30",
				"clock",
				"thirty",
				"six thirty"
			],
			u: "1f561",
			a: "0.7"
		},
		{
			n: [
				"0",
				"7",
				"7:00",
				"clock",
				"seven",
				"o’clock",
				"seven o’clock"
			],
			u: "1f556",
			a: "0.6"
		},
		{
			n: [
				"7",
				"30",
				"7:30",
				"clock",
				"seven",
				"thirty",
				"seven thirty"
			],
			u: "1f562",
			a: "0.7"
		},
		{
			n: [
				"8",
				"8:00",
				"time",
				"clock",
				"eight",
				"o’clock",
				"eight o’clock"
			],
			u: "1f557",
			a: "0.6"
		},
		{
			n: [
				"8",
				"30",
				"8:30",
				"time",
				"clock",
				"eight",
				"thirty",
				"eight thirty"
			],
			u: "1f563",
			a: "0.7"
		},
		{
			n: [
				"9",
				"9:00",
				"nine",
				"time",
				"clock",
				"o’clock",
				"nine o’clock"
			],
			u: "1f558",
			a: "0.6"
		},
		{
			n: [
				"9",
				"30",
				"9:30",
				"nine",
				"time",
				"clock",
				"thirty",
				"nine thirty"
			],
			u: "1f564",
			a: "0.7"
		},
		{
			n: [
				"0",
				"10",
				"ten",
				"10:00",
				"clock",
				"o’clock",
				"ten o’clock"
			],
			u: "1f559",
			a: "0.6"
		},
		{
			n: [
				"10",
				"30",
				"ten",
				"time",
				"10:30",
				"clock",
				"thirty",
				"ten thirty"
			],
			u: "1f565",
			a: "0.7"
		},
		{
			n: [
				"11",
				"time",
				"11:00",
				"clock",
				"eleven",
				"o’clock",
				"eleven o’clock"
			],
			u: "1f55a",
			a: "0.6"
		},
		{
			n: [
				"11",
				"30",
				"time",
				"11:30",
				"clock",
				"eleven",
				"thirty",
				"eleven thirty"
			],
			u: "1f566",
			a: "0.7"
		},
		{
			n: [
				"new",
				"dark",
				"moon",
				"space",
				"new moon"
			],
			u: "1f311",
			a: "0.6"
		},
		{
			n: [
				"moon",
				"space",
				"dreams",
				"waxing",
				"crescent",
				"waxing crescent moon"
			],
			u: "1f312",
			a: "1"
		},
		{
			n: [
				"moon",
				"first",
				"space",
				"quarter",
				"first quarter moon"
			],
			u: "1f313",
			a: "0.6"
		},
		{
			n: [
				"moon",
				"space",
				"waxing",
				"gibbous",
				"waxing gibbous moon"
			],
			u: "1f314",
			a: "0.6"
		},
		{
			n: [
				"full",
				"moon",
				"space",
				"full moon"
			],
			u: "1f315",
			a: "0.6"
		},
		{
			n: [
				"moon",
				"space",
				"waning",
				"gibbous",
				"waning gibbous moon"
			],
			u: "1f316",
			a: "1"
		},
		{
			n: [
				"last",
				"moon",
				"space",
				"quarter",
				"last quarter moon"
			],
			u: "1f317",
			a: "1"
		},
		{
			n: [
				"moon",
				"space",
				"waning",
				"crescent",
				"waning crescent moon"
			],
			u: "1f318",
			a: "1"
		},
		{
			n: [
				"moon",
				"space",
				"ramadan",
				"crescent",
				"crescent moon"
			],
			u: "1f319",
			a: "0.6"
		},
		{
			n: [
				"new",
				"face",
				"moon",
				"space",
				"new moon face"
			],
			u: "1f31a",
			a: "1"
		},
		{
			n: [
				"face",
				"moon",
				"first",
				"space",
				"quarter",
				"first quarter moon face"
			],
			u: "1f31b",
			a: "0.6"
		},
		{
			n: [
				"face",
				"last",
				"moon",
				"dreams",
				"quarter",
				"last quarter moon face"
			],
			u: "1f31c",
			a: "0.7"
		},
		{
			n: [
				"weather",
				"thermometer"
			],
			u: "1f321-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sun",
				"rays",
				"space",
				"sunny",
				"bright",
				"weather"
			],
			u: "2600-fe0f",
			a: "0.6"
		},
		{
			n: [
				"face",
				"full",
				"moon",
				"bright",
				"full moon face"
			],
			u: "1f31d",
			a: "1"
		},
		{
			n: [
				"day",
				"sun",
				"face",
				"heat",
				"beach",
				"shine",
				"sunny",
				"bright",
				"weather",
				"sunshine",
				"sun with face"
			],
			u: "1f31e",
			a: "1"
		},
		{
			n: [
				"planet",
				"ringed",
				"saturn",
				"saturnine",
				"ringed planet"
			],
			u: "1fa90",
			a: "12"
		},
		{
			n: [
				"star",
				"stars",
				"white",
				"medium",
				"astronomy"
			],
			u: "2b50",
			a: "0.6"
		},
		{
			n: [
				"win",
				"glow",
				"star",
				"night",
				"glowing",
				"shining",
				"sparkle",
				"glittery",
				"glowing star"
			],
			u: "1f31f",
			a: "0.6"
		},
		{
			n: [
				"star",
				"night",
				"space",
				"falling",
				"shooting",
				"shooting star"
			],
			u: "1f320",
			a: "0.6"
		},
		{
			n: [
				"way",
				"milky",
				"space",
				"milky way"
			],
			u: "1f30c",
			a: "0.6"
		},
		{
			n: [
				"cloud",
				"weather"
			],
			u: "2601-fe0f",
			a: "0.6"
		},
		{
			n: [
				"sun",
				"cloud",
				"behind",
				"cloudy",
				"weather",
				"sun behind cloud"
			],
			u: "26c5",
			a: "0.6"
		},
		{
			n: [
				"rain",
				"cloud",
				"thunder",
				"lightning",
				"thunderstorm",
				"cloud with lightning and rain"
			],
			u: "26c8-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sun",
				"cloud",
				"behind",
				"weather",
				"sun behind small cloud"
			],
			u: "1f324-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sun",
				"cloud",
				"behind",
				"weather",
				"sun behind large cloud"
			],
			u: "1f325-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sun",
				"rain",
				"cloud",
				"behind",
				"weather",
				"sun behind rain cloud"
			],
			u: "1f326-fe0f",
			a: "0.7"
		},
		{
			n: [
				"rain",
				"cloud",
				"weather",
				"cloud with rain"
			],
			u: "1f327-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cold",
				"snow",
				"cloud",
				"weather",
				"cloud with snow"
			],
			u: "1f328-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cloud",
				"weather",
				"lightning",
				"cloud with lightning"
			],
			u: "1f329-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cloud",
				"tornado",
				"weather",
				"whirlwind"
			],
			u: "1f32a-fe0f",
			a: "0.7"
		},
		{
			n: [
				"fog",
				"cloud",
				"weather"
			],
			u: "1f32b-fe0f",
			a: "0.7"
		},
		{
			n: [
				"blow",
				"face",
				"wind",
				"cloud",
				"wind face"
			],
			u: "1f32c-fe0f",
			a: "0.7"
		},
		{
			n: [
				"dizzy",
				"cyclone",
				"twister",
				"typhoon",
				"weather",
				"hurricane"
			],
			u: "1f300",
			a: "0.6"
		},
		{
			n: [
				"gay",
				"glbt",
				"lgbt",
				"rain",
				"glbtq",
				"lgbtq",
				"pride",
				"queer",
				"trans",
				"nature",
				"rainbow",
				"lesbian",
				"lgbtqia",
				"weather",
				"genderqueer",
				"transgender"
			],
			u: "1f308",
			a: "0.6"
		},
		{
			n: [
				"rain",
				"closed",
				"clothing",
				"umbrella",
				"closed umbrella"
			],
			u: "1f302",
			a: "0.6"
		},
		{
			n: [
				"rain",
				"umbrella",
				"clothing"
			],
			u: "2602-fe0f",
			a: "0.7"
		},
		{
			n: [
				"drop",
				"rain",
				"drops",
				"weather",
				"clothing",
				"umbrella",
				"umbrella with rain drops"
			],
			u: "2614",
			a: "0.6"
		},
		{
			n: [
				"sun",
				"rain",
				"ground",
				"umbrella",
				"umbrella on ground"
			],
			u: "26f1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"zap",
				"high",
				"danger",
				"nature",
				"thunder",
				"voltage",
				"electric",
				"lightning",
				"electricity",
				"thunderbolt",
				"high voltage"
			],
			u: "26a1",
			a: "0.6"
		},
		{
			n: [
				"cold",
				"snow",
				"weather",
				"snowflake"
			],
			u: "2744-fe0f",
			a: "0.6"
		},
		{
			n: [
				"man",
				"cold",
				"snow",
				"snowman"
			],
			u: "2603-fe0f",
			a: "0.7"
		},
		{
			n: [
				"man",
				"cold",
				"snow",
				"snowman",
				"snowman without snow"
			],
			u: "26c4",
			a: "0.6"
		},
		{
			n: [
				"comet",
				"space"
			],
			u: "2604-fe0f",
			a: "1"
		},
		{
			n: [
				"af",
				"hot",
				"lit",
				"fire",
				"burn",
				"tool",
				"flame",
				"litaf"
			],
			u: "1f525",
			a: "0.6"
		},
		{
			n: [
				"sad",
				"cold",
				"drop",
				"tear",
				"comic",
				"sweat",
				"water",
				"nature",
				"droplet",
				"weather"
			],
			u: "1f4a7",
			a: "0.6"
		},
		{
			n: [
				"surf",
				"wave",
				"ocean",
				"water",
				"nature",
				"surfer",
				"surfing",
				"water wave"
			],
			u: "1f30a",
			a: "0.6"
		}
	],
	activities: [
		{
			n: [
				"jack",
				"lantern",
				"pumpkin",
				"halloween",
				"celebration",
				"jack o lantern"
			],
			u: "1f383",
			a: "0.6"
		},
		{
			n: [
				"tree",
				"christmas",
				"celebration",
				"Christmas tree"
			],
			u: "1f384",
			a: "0.6"
		},
		{
			n: [
				"boom",
				"yolo",
				"fireworks",
				"celebration",
				"entertainment"
			],
			u: "1f386",
			a: "0.6"
		},
		{
			n: [
				"boom",
				"sparkle",
				"sparkler",
				"fireworks",
				"celebration"
			],
			u: "1f387",
			a: "0.6"
		},
		{
			n: [
				"pop",
				"fire",
				"light",
				"spark",
				"popping",
				"dynamite",
				"explosive",
				"fireworks",
				"firecracker"
			],
			u: "1f9e8",
			a: "11"
		},
		{
			n: [
				"*",
				"star",
				"magic",
				"sparkle",
				"sparkles"
			],
			u: "2728",
			a: "0.6"
		},
		{
			n: [
				"balloon",
				"birthday",
				"celebrate",
				"celebration"
			],
			u: "1f388",
			a: "0.6"
		},
		{
			n: [
				"tada",
				"party",
				"hooray",
				"popper",
				"woohoo",
				"awesome",
				"excited",
				"birthday",
				"celebrate",
				"celebration",
				"party popper"
			],
			u: "1f389",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"party",
				"woohoo",
				"confetti",
				"celebrate",
				"celebration",
				"confetti ball"
			],
			u: "1f38a",
			a: "0.6"
		},
		{
			n: [
				"tree",
				"banner",
				"japanese",
				"tanabata",
				"celebration",
				"tanabata tree"
			],
			u: "1f38b",
			a: "0.6"
		},
		{
			n: [
				"pine",
				"plant",
				"bamboo",
				"japanese",
				"decoration",
				"celebration",
				"pine decoration"
			],
			u: "1f38d",
			a: "0.6"
		},
		{
			n: [
				"doll",
				"dolls",
				"festival",
				"japanese",
				"celebration",
				"Japanese dolls"
			],
			u: "1f38e",
			a: "0.6"
		},
		{
			n: [
				"carp",
				"streamer",
				"celebration",
				"carp streamer"
			],
			u: "1f38f",
			a: "0.6"
		},
		{
			n: [
				"bell",
				"wind",
				"chime",
				"wind chime",
				"celebration"
			],
			u: "1f390",
			a: "0.6"
		},
		{
			n: [
				"moon",
				"viewing",
				"ceremony",
				"celebration",
				"moon viewing ceremony"
			],
			u: "1f391",
			a: "0.6"
		},
		{
			n: [
				"lai",
				"red",
				"see",
				"gift",
				"good",
				"luck",
				"money",
				"hóngbāo",
				"envelope",
				"red envelope"
			],
			u: "1f9e7",
			a: "11"
		},
		{
			n: [
				"ribbon",
				"celebration"
			],
			u: "1f380",
			a: "0.6"
		},
		{
			n: [
				"bow",
				"box",
				"gift",
				"present",
				"wrapped",
				"birthday",
				"surprise",
				"christmas",
				"celebration",
				"wrapped gift"
			],
			u: "1f381",
			a: "0.6"
		},
		{
			n: [
				"ribbon",
				"reminder",
				"celebration",
				"reminder ribbon"
			],
			u: "1f397-fe0f",
			a: "0.7"
		},
		{
			n: [
				"ticket",
				"tickets",
				"admission",
				"admission tickets"
			],
			u: "1f39f-fe0f",
			a: "0.7"
		},
		{
			n: [
				"stub",
				"ticket",
				"admission"
			],
			u: "1f3ab",
			a: "0.6"
		},
		{
			n: [
				"award",
				"medal",
				"military",
				"celebration",
				"military medal"
			],
			u: "1f396-fe0f",
			a: "0.7"
		},
		{
			n: [
				"win",
				"slay",
				"prize",
				"sport",
				"trophy",
				"champs",
				"victory",
				"winning",
				"champion"
			],
			u: "1f3c6",
			a: "0.6"
		},
		{
			n: [
				"gold",
				"award",
				"medal",
				"sports",
				"winner",
				"sports medal"
			],
			u: "1f3c5",
			a: "1"
		},
		{
			n: [
				"1st",
				"gold",
				"first",
				"medal",
				"place",
				"1st place medal"
			],
			u: "1f947",
			a: "3"
		},
		{
			n: [
				"2nd",
				"medal",
				"place",
				"second",
				"silver",
				"2nd place medal"
			],
			u: "1f948",
			a: "3"
		},
		{
			n: [
				"3rd",
				"medal",
				"place",
				"third",
				"bronze",
				"3rd place medal"
			],
			u: "1f949",
			a: "3"
		},
		{
			n: [
				"ball",
				"sport",
				"futbol",
				"soccer",
				"football",
				"soccer ball"
			],
			u: "26bd",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"sport",
				"baseball"
			],
			u: "26be",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"glove",
				"sports",
				"softball",
				"underarm"
			],
			u: "1f94e",
			a: "11"
		},
		{
			n: [
				"ball",
				"hoop",
				"sport",
				"basketball"
			],
			u: "1f3c0",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"game",
				"volleyball"
			],
			u: "1f3d0",
			a: "1"
		},
		{
			n: [
				"ball",
				"bowl",
				"sport",
				"super",
				"american",
				"football",
				"american football"
			],
			u: "1f3c8",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"rugby",
				"sport",
				"football",
				"rugby football"
			],
			u: "1f3c9",
			a: "1"
		},
		{
			n: [
				"ball",
				"sport",
				"tennis",
				"racquet"
			],
			u: "1f3be",
			a: "0.6"
		},
		{
			n: [
				"disc",
				"flying",
				"ultimate",
				"flying disc"
			],
			u: "1f94f",
			a: "11"
		},
		{
			n: [
				"ball",
				"game",
				"sport",
				"strike",
				"bowling"
			],
			u: "1f3b3",
			a: "0.6"
		},
		{
			n: [
				"bat",
				"ball",
				"game",
				"cricket",
				"cricket game"
			],
			u: "1f3cf",
			a: "1"
		},
		{
			n: [
				"ball",
				"game",
				"field",
				"stick",
				"hockey",
				"field hockey"
			],
			u: "1f3d1",
			a: "1"
		},
		{
			n: [
				"ice",
				"game",
				"puck",
				"stick",
				"hockey",
				"ice hockey"
			],
			u: "1f3d2",
			a: "1"
		},
		{
			n: [
				"ball",
				"goal",
				"stick",
				"sports",
				"lacrosse"
			],
			u: "1f94d",
			a: "11"
		},
		{
			n: [
				"bat",
				"ball",
				"game",
				"ping",
				"pong",
				"table",
				"paddle",
				"tennis",
				"pingpong",
				"ping pong"
			],
			u: "1f3d3",
			a: "1"
		},
		{
			n: [
				"game",
				"birdie",
				"racquet",
				"badminton",
				"shuttlecock"
			],
			u: "1f3f8",
			a: "1"
		},
		{
			n: [
				"glove",
				"boxing",
				"boxing glove"
			],
			u: "1f94a",
			a: "3"
		},
		{
			n: [
				"arts",
				"judo",
				"karate",
				"martial",
				"uniform",
				"taekwondo",
				"martial arts uniform"
			],
			u: "1f94b",
			a: "3"
		},
		{
			n: [
				"net",
				"goal",
				"goal net"
			],
			u: "1f945",
			a: "3"
		},
		{
			n: [
				"flag",
				"golf",
				"hole",
				"sport",
				"flag in hole"
			],
			u: "26f3",
			a: "0.6"
		},
		{
			n: [
				"ice",
				"skate",
				"skating",
				"ice skate"
			],
			u: "26f8-fe0f",
			a: "0.7"
		},
		{
			n: [
				"fish",
				"pole",
				"sport",
				"fishing",
				"fishing pole",
				"entertainment"
			],
			u: "1f3a3",
			a: "0.6"
		},
		{
			n: [
				"mask",
				"scuba",
				"diving",
				"snorkeling",
				"diving mask"
			],
			u: "1f93f",
			a: "12"
		},
		{
			n: [
				"sash",
				"shirt",
				"running",
				"athletics",
				"running shirt"
			],
			u: "1f3bd",
			a: "0.6"
		},
		{
			n: [
				"ski",
				"skis",
				"snow",
				"sport"
			],
			u: "1f3bf",
			a: "0.6"
		},
		{
			n: [
				"sled",
				"luge",
				"snow",
				"sledge",
				"sleigh",
				"toboggan"
			],
			u: "1f6f7",
			a: "5"
		},
		{
			n: [
				"game",
				"rock",
				"stone",
				"curling",
				"curling stone"
			],
			u: "1f94c",
			a: "5"
		},
		{
			n: [
				"hit",
				"bull",
				"dart",
				"game",
				"direct",
				"target",
				"bullseye",
				"entertainment"
			],
			u: "1f3af",
			a: "0.6"
		},
		{
			n: [
				"toy",
				"yo yo",
				"fluctuate"
			],
			u: "1fa80",
			a: "12"
		},
		{
			n: [
				"fly",
				"kite",
				"soar"
			],
			u: "1fa81",
			a: "12"
		},
		{
			n: [
				"gun",
				"tool",
				"water",
				"pistol",
				"weapon",
				"handgun",
				"revolver",
				"water pistol"
			],
			u: "1f52b",
			a: "0.6"
		},
		{
			n: [
				"8",
				"ball",
				"game",
				"pool",
				"8ball",
				"eight",
				"billiard",
				"pool 8 ball"
			],
			u: "1f3b1",
			a: "0.6"
		},
		{
			n: [
				"ball",
				"tale",
				"tool",
				"fairy",
				"magic",
				"future",
				"crystal",
				"fantasy",
				"fortune",
				"fairytale",
				"crystal ball"
			],
			u: "1f52e",
			a: "0.6"
		},
		{
			n: [
				"wand",
				"magic",
				"witch",
				"wizard",
				"magician",
				"magic wand"
			],
			u: "1fa84",
			a: "13"
		},
		{
			n: [
				"game",
				"video",
				"video game",
				"controller",
				"entertainment"
			],
			u: "1f3ae",
			a: "0.6"
		},
		{
			n: [
				"game",
				"video",
				"joystick",
				"videogame"
			],
			u: "1f579-fe0f",
			a: "0.7"
		},
		{
			n: [
				"game",
				"slot",
				"slots",
				"casino",
				"gamble",
				"machine",
				"gambling",
				"slot machine"
			],
			u: "1f3b0",
			a: "0.6"
		},
		{
			n: [
				"die",
				"dice",
				"game",
				"game die",
				"entertainment"
			],
			u: "1f3b2",
			a: "0.6"
		},
		{
			n: [
				"clue",
				"piece",
				"jigsaw",
				"puzzle",
				"puzzle piece",
				"interlocking"
			],
			u: "1f9e9",
			a: "11"
		},
		{
			n: [
				"toy",
				"bear",
				"plush",
				"teddy",
				"stuffed",
				"plaything",
				"teddy bear"
			],
			u: "1f9f8",
			a: "11"
		},
		{
			n: [
				"de",
				"mayo",
				"candy",
				"cinco",
				"party",
				"piñata",
				"pinada",
				"pinata",
				"festive",
				"celebrate",
				"celebration"
			],
			u: "1fa85",
			a: "13"
		},
		{
			n: [
				"ball",
				"dance",
				"disco",
				"party",
				"mirror",
				"glitter",
				"mirror ball"
			],
			u: "1faa9",
			a: "14"
		},
		{
			n: [
				"doll",
				"dolls",
				"russia",
				"nesting",
				"babushka",
				"babooshka",
				"baboushka",
				"matryoshka",
				"nesting dolls"
			],
			u: "1fa86",
			a: "13"
		},
		{
			n: [
				"card",
				"game",
				"suit",
				"spade",
				"spade suit"
			],
			u: "2660-fe0f",
			a: "0.6"
		},
		{
			n: [
				"card",
				"game",
				"suit",
				"heart",
				"hearts",
				"emotion",
				"heart suit"
			],
			u: "2665-fe0f",
			a: "0.6"
		},
		{
			n: [
				"card",
				"game",
				"suit",
				"diamond",
				"diamond suit"
			],
			u: "2666-fe0f",
			a: "0.6"
		},
		{
			n: [
				"card",
				"club",
				"game",
				"suit",
				"clubs",
				"club suit"
			],
			u: "2663-fe0f",
			a: "0.6"
		},
		{
			n: [
				"dupe",
				"pawn",
				"chess",
				"chess pawn",
				"expendable"
			],
			u: "265f-fe0f",
			a: "11"
		},
		{
			n: [
				"card",
				"game",
				"joker",
				"wildcard"
			],
			u: "1f0cf",
			a: "0.6"
		},
		{
			n: [
				"red",
				"game",
				"dragon",
				"mahjong",
				"mahjong red dragon"
			],
			u: "1f004",
			a: "0.6"
		},
		{
			n: [
				"card",
				"game",
				"cards",
				"flower",
				"playing",
				"japanese",
				"flower playing cards"
			],
			u: "1f3b4",
			a: "0.6"
		},
		{
			n: [
				"art",
				"arts",
				"mask",
				"actor",
				"actress",
				"theater",
				"theatre",
				"thespian",
				"performing",
				"entertainment",
				"performing arts"
			],
			u: "1f3ad",
			a: "0.6"
		},
		{
			n: [
				"art",
				"frame",
				"framed",
				"museum",
				"picture",
				"painting",
				"framed picture"
			],
			u: "1f5bc-fe0f",
			a: "0.7"
		},
		{
			n: [
				"art",
				"arty",
				"artsy",
				"artist",
				"museum",
				"painter",
				"palette",
				"colorful",
				"creative",
				"painting",
				"entertainment",
				"artist palette"
			],
			u: "1f3a8",
			a: "0.6"
		},
		{
			n: [
				"spool",
				"thread",
				"needle",
				"sewing",
				"string"
			],
			u: "1f9f5",
			a: "11"
		},
		{
			n: [
				"sew",
				"needle",
				"sewing",
				"thread",
				"sutures",
				"stitches",
				"tailoring",
				"embroidery",
				"sewing needle"
			],
			u: "1faa1",
			a: "13"
		},
		{
			n: [
				"yarn",
				"ball",
				"knit",
				"crochet"
			],
			u: "1f9f6",
			a: "11"
		},
		{
			n: [
				"tie",
				"knot",
				"cord",
				"rope",
				"twine",
				"twist",
				"tangled"
			],
			u: "1faa2",
			a: "13"
		}
	],
	objects: [
		{
			n: [
				"eye",
				"glasses",
				"eyewear",
				"clothing",
				"eyeglasses"
			],
			u: "1f453",
			a: "0.6"
		},
		{
			n: [
				"eye",
				"dark",
				"eyewear",
				"glasses",
				"sunglasses"
			],
			u: "1f576-fe0f",
			a: "0.7"
		},
		{
			n: [
				"eye",
				"dive",
				"scuba",
				"goggles",
				"welding",
				"swimming",
				"protection"
			],
			u: "1f97d",
			a: "11"
		},
		{
			n: [
				"dr",
				"lab",
				"coat",
				"white",
				"doctor",
				"jacket",
				"clothes",
				"lab coat",
				"scientist",
				"experiment"
			],
			u: "1f97c",
			a: "11"
		},
		{
			n: [
				"vest",
				"safety",
				"emergency",
				"safety vest"
			],
			u: "1f9ba",
			a: "12"
		},
		{
			n: [
				"tie",
				"shirt",
				"necktie",
				"serious",
				"clothing",
				"employed"
			],
			u: "1f454",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"shirt",
				"casual",
				"collar",
				"tshirt",
				"t shirt",
				"clothes",
				"dressed",
				"weekend",
				"clothing",
				"shopping"
			],
			u: "1f455",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"jeans",
				"denim",
				"pants",
				"casual",
				"clothes",
				"dressed",
				"weekend",
				"clothing",
				"shopping",
				"trousers"
			],
			u: "1f456",
			a: "0.6"
		},
		{
			n: [
				"up",
				"cold",
				"neck",
				"scarf",
				"bundle"
			],
			u: "1f9e3",
			a: "5"
		},
		{
			n: [
				"hand",
				"gloves"
			],
			u: "1f9e4",
			a: "5"
		},
		{
			n: [
				"up",
				"brr",
				"coat",
				"cold",
				"bundle",
				"jacket"
			],
			u: "1f9e5",
			a: "5"
		},
		{
			n: [
				"socks",
				"stocking"
			],
			u: "1f9e6",
			a: "5"
		},
		{
			n: [
				"dress",
				"fancy",
				"clothes",
				"dressed",
				"clothing",
				"shopping"
			],
			u: "1f457",
			a: "0.6"
		},
		{
			n: [
				"kimono",
				"clothing",
				"comfortable"
			],
			u: "1f458",
			a: "0.6"
		},
		{
			n: [
				"sari",
				"dress",
				"clothing"
			],
			u: "1f97b",
			a: "12"
		},
		{
			n: [
				"suit",
				"bathing",
				"swimsuit",
				"one piece",
				"one piece swimsuit"
			],
			u: "1fa71",
			a: "12"
		},
		{
			n: [
				"suit",
				"briefs",
				"bathing",
				"swimsuit",
				"one piece",
				"underwear"
			],
			u: "1fa72",
			a: "12"
		},
		{
			n: [
				"suit",
				"pants",
				"shorts",
				"bathing",
				"swimsuit",
				"underwear"
			],
			u: "1fa73",
			a: "12"
		},
		{
			n: [
				"pool",
				"suit",
				"swim",
				"beach",
				"bikini",
				"bathing",
				"clothing"
			],
			u: "1f459",
			a: "0.6"
		},
		{
			n: [
				"lady",
				"dress",
				"shirt",
				"woman",
				"blouse",
				"collar",
				"clothes",
				"dressed",
				"woman’s",
				"clothing",
				"shopping",
				"woman’s clothes"
			],
			u: "1f45a",
			a: "0.6"
		},
		{
			n: [
				"fan",
				"hot",
				"shy",
				"clap",
				"cool",
				"hand",
				"clack",
				"dance",
				"flirt",
				"cooling",
				"flutter",
				"folding",
				"folding hand fan"
			],
			u: "1faad",
			a: "15"
		},
		{
			n: [
				"coin",
				"purse",
				"dress",
				"fancy",
				"clothes",
				"handbag",
				"clothing",
				"shopping"
			],
			u: "1f45b",
			a: "0.6"
		},
		{
			n: [
				"bag",
				"lady",
				"dress",
				"purse",
				"handbag",
				"clothes",
				"clothing",
				"shopping"
			],
			u: "1f45c",
			a: "0.6"
		},
		{
			n: [
				"bag",
				"dress",
				"pouch",
				"purse",
				"clutch",
				"clothes",
				"handbag",
				"clothing",
				"clutch bag"
			],
			u: "1f45d",
			a: "0.6"
		},
		{
			n: [
				"bag",
				"bags",
				"hotel",
				"shopping",
				"shopping bags"
			],
			u: "1f6cd-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bag",
				"school",
				"bookbag",
				"satchel",
				"backpack",
				"rucksack",
				"education",
				"backpacking"
			],
			u: "1f392",
			a: "0.6"
		},
		{
			n: [
				"flip",
				"flop",
				"shoe",
				"zōri",
				"beach",
				"thong",
				"sandal",
				"thongs",
				"sandals",
				"thong sandal"
			],
			u: "1fa74",
			a: "13"
		},
		{
			n: [
				"man",
				"feet",
				"foot",
				"kick",
				"shoe",
				"brown",
				"man’s",
				"shoes",
				"clothes",
				"clothing",
				"shopping",
				"man’s shoe"
			],
			u: "1f45e",
			a: "0.6"
		},
		{
			n: [
				"fast",
				"kick",
				"shoe",
				"shoes",
				"tennis",
				"clothes",
				"running",
				"sneaker",
				"athletic",
				"clothing",
				"shopping",
				"running shoe"
			],
			u: "1f45f",
			a: "0.6"
		},
		{
			n: [
				"boot",
				"shoe",
				"brown",
				"hiking",
				"camping",
				"outdoors",
				"hiking boot",
				"backpacking"
			],
			u: "1f97e",
			a: "11"
		},
		{
			n: [
				"flat",
				"shoe",
				"comfy",
				"flats",
				"ballet",
				"slip on",
				"slipper",
				"flat shoe"
			],
			u: "1f97f",
			a: "11"
		},
		{
			n: [
				"heel",
				"shoe",
				"dress",
				"heels",
				"shoes",
				"woman",
				"clothes",
				"fashion",
				"clothing",
				"shopping",
				"stiletto",
				"high heeled",
				"high heeled shoe"
			],
			u: "1f460",
			a: "0.6"
		},
		{
			n: [
				"shoe",
				"woman",
				"sandal",
				"woman’s",
				"clothing",
				"woman’s sandal"
			],
			u: "1f461",
			a: "0.6"
		},
		{
			n: [
				"dance",
				"shoes",
				"ballet",
				"ballet shoes"
			],
			u: "1fa70",
			a: "12"
		},
		{
			n: [
				"boot",
				"shoe",
				"dress",
				"shoes",
				"woman",
				"clothes",
				"woman’s",
				"clothing",
				"shopping",
				"woman’s boot"
			],
			u: "1f462",
			a: "0.6"
		},
		{
			n: [
				"afro",
				"comb",
				"hair",
				"pick",
				"groom",
				"hair pick"
			],
			u: "1faae",
			a: "15"
		},
		{
			n: [
				"win",
				"king",
				"crown",
				"queen",
				"royal",
				"family",
				"royalty",
				"clothing",
				"medieval"
			],
			u: "1f451",
			a: "0.6"
		},
		{
			n: [
				"hat",
				"hats",
				"party",
				"woman",
				"garden",
				"clothes",
				"woman’s",
				"clothing",
				"woman’s hat"
			],
			u: "1f452",
			a: "0.6"
		},
		{
			n: [
				"hat",
				"top",
				"fancy",
				"magic",
				"formal",
				"tophat",
				"top hat",
				"clothes",
				"clothing"
			],
			u: "1f3a9",
			a: "0.6"
		},
		{
			n: [
				"cap",
				"hat",
				"scholar",
				"clothing",
				"education",
				"graduation",
				"celebration",
				"graduation cap"
			],
			u: "1f393",
			a: "0.6"
		},
		{
			n: [
				"cap",
				"dad",
				"hat",
				"bent",
				"billed",
				"baseball",
				"billed cap"
			],
			u: "1f9e2",
			a: "5"
		},
		{
			n: [
				"war",
				"army",
				"helmet",
				"soldier",
				"warrior",
				"military",
				"military helmet"
			],
			u: "1fa96",
			a: "13"
		},
		{
			n: [
				"aid",
				"hat",
				"face",
				"cross",
				"helmet",
				"rescue",
				"worker’s",
				"rescue worker’s helmet"
			],
			u: "26d1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"beads",
				"prayer",
				"clothing",
				"necklace",
				"religion",
				"prayer beads"
			],
			u: "1f4ff",
			a: "1"
		},
		{
			n: [
				"date",
				"makeup",
				"lipstick",
				"cosmetics"
			],
			u: "1f484",
			a: "0.6"
		},
		{
			n: [
				"ring",
				"shiny",
				"diamond",
				"engaged",
				"married",
				"romance",
				"wedding",
				"sparkling",
				"engagement"
			],
			u: "1f48d",
			a: "0.6"
		},
		{
			n: [
				"gem",
				"jewel",
				"money",
				"stone",
				"diamond",
				"romance",
				"wedding",
				"gem stone",
				"engagement"
			],
			u: "1f48e",
			a: "0.6"
		},
		{
			n: [
				"mute",
				"muted",
				"quiet",
				"sound",
				"silent",
				"speaker",
				"muted speaker"
			],
			u: "1f507",
			a: "1"
		},
		{
			n: [
				"low",
				"soft",
				"sound",
				"volume",
				"speaker",
				"speaker low volume"
			],
			u: "1f508",
			a: "0.7"
		},
		{
			n: [
				"sound",
				"medium",
				"volume",
				"speaker",
				"speaker medium volume"
			],
			u: "1f509",
			a: "1"
		},
		{
			n: [
				"high",
				"loud",
				"music",
				"sound",
				"volume",
				"speaker",
				"speaker high volume"
			],
			u: "1f50a",
			a: "0.6"
		},
		{
			n: [
				"loud",
				"sound",
				"public",
				"address",
				"loudspeaker",
				"communication"
			],
			u: "1f4e2",
			a: "0.6"
		},
		{
			n: [
				"sound",
				"cheering",
				"megaphone"
			],
			u: "1f4e3",
			a: "0.6"
		},
		{
			n: [
				"horn",
				"post",
				"postal",
				"postal horn"
			],
			u: "1f4ef",
			a: "1"
		},
		{
			n: [
				"bell",
				"break",
				"sound",
				"church"
			],
			u: "1f514",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"bell",
				"mute",
				"quiet",
				"slash",
				"sound",
				"silent",
				"forbidden",
				"prohibited",
				"bell with slash"
			],
			u: "1f515",
			a: "1"
		},
		{
			n: [
				"note",
				"music",
				"score",
				"musical",
				"musical score"
			],
			u: "1f3bc",
			a: "0.6"
		},
		{
			n: [
				"note",
				"music",
				"sound",
				"musical",
				"musical note"
			],
			u: "1f3b5",
			a: "0.6"
		},
		{
			n: [
				"note",
				"music",
				"notes",
				"sound",
				"musical",
				"musical notes"
			],
			u: "1f3b6",
			a: "0.6"
		},
		{
			n: [
				"mic",
				"music",
				"studio",
				"microphone",
				"studio microphone"
			],
			u: "1f399-fe0f",
			a: "0.7"
		},
		{
			n: [
				"level",
				"music",
				"slider",
				"level slider"
			],
			u: "1f39a-fe0f",
			a: "0.7"
		},
		{
			n: [
				"knobs",
				"music",
				"control",
				"control knobs"
			],
			u: "1f39b-fe0f",
			a: "0.7"
		},
		{
			n: [
				"mic",
				"sing",
				"music",
				"sound",
				"karaoke",
				"microphone"
			],
			u: "1f3a4",
			a: "0.6"
		},
		{
			n: [
				"sound",
				"earbud",
				"headphone"
			],
			u: "1f3a7",
			a: "0.6"
		},
		{
			n: [
				"tbt",
				"radio",
				"video",
				"entertainment"
			],
			u: "1f4fb",
			a: "0.6"
		},
		{
			n: [
				"sax",
				"music",
				"saxophone",
				"instrument"
			],
			u: "1f3b7",
			a: "0.6"
		},
		{
			n: [
				"music",
				"trumpet",
				"instrument"
			],
			u: "1f3ba",
			a: "0.6"
		},
		{
			n: [
				"box",
				"music",
				"squeeze",
				"accordion",
				"concertina",
				"instrument",
				"squeezebox"
			],
			u: "1fa97",
			a: "13"
		},
		{
			n: [
				"music",
				"strat",
				"guitar",
				"instrument"
			],
			u: "1f3b8",
			a: "0.6"
		},
		{
			n: [
				"music",
				"piano",
				"musical",
				"keyboard",
				"instrument",
				"musical keyboard"
			],
			u: "1f3b9",
			a: "0.6"
		},
		{
			n: [
				"music",
				"violin",
				"instrument"
			],
			u: "1f3bb",
			a: "0.6"
		},
		{
			n: [
				"banjo",
				"music",
				"stringed"
			],
			u: "1fa95",
			a: "12"
		},
		{
			n: [
				"drum",
				"music",
				"drumsticks"
			],
			u: "1f941",
			a: "3"
		},
		{
			n: [
				"beat",
				"drum",
				"long",
				"conga",
				"rhythm",
				"long drum",
				"instrument"
			],
			u: "1fa98",
			a: "13"
		},
		{
			n: [
				"cha",
				"dance",
				"music",
				"party",
				"shake",
				"rattle",
				"shaker",
				"maracas",
				"instrument",
				"percussion"
			],
			u: "1fa87",
			a: "15"
		},
		{
			n: [
				"band",
				"fife",
				"pipe",
				"flute",
				"music",
				"piccolo",
				"flautist",
				"marching",
				"recorder",
				"woodwind",
				"orchestra",
				"instrument"
			],
			u: "1fa88",
			a: "15"
		},
		{
			n: [
				"harp",
				"love",
				"cupid",
				"music",
				"orchestra",
				"instrument"
			],
			u: "1fa89",
			a: "16"
		},
		{
			n: [
				"cell",
				"phone",
				"mobile",
				"telephone",
				"mobile phone",
				"communication"
			],
			u: "1f4f1",
			a: "0.6"
		},
		{
			n: [
				"call",
				"cell",
				"arrow",
				"build",
				"phone",
				"mobile",
				"receive",
				"telephone",
				"communication",
				"mobile phone with arrow"
			],
			u: "1f4f2",
			a: "0.6"
		},
		{
			n: [
				"phone",
				"telephone"
			],
			u: "260e-fe0f",
			a: "0.6"
		},
		{
			n: [
				"voip",
				"phone",
				"receiver",
				"telephone",
				"communication",
				"telephone receiver"
			],
			u: "1f4de",
			a: "0.6"
		},
		{
			n: [
				"pager",
				"communication"
			],
			u: "1f4df",
			a: "0.6"
		},
		{
			n: [
				"fax",
				"machine",
				"fax machine",
				"communication"
			],
			u: "1f4e0",
			a: "0.6"
		},
		{
			n: [
				"battery"
			],
			u: "1f50b",
			a: "0.6"
		},
		{
			n: [
				"low",
				"power",
				"energy",
				"battery",
				"drained",
				"electronic",
				"low battery"
			],
			u: "1faab",
			a: "14"
		},
		{
			n: [
				"plug",
				"electric",
				"electricity",
				"electric plug"
			],
			u: "1f50c",
			a: "0.6"
		},
		{
			n: [
				"pc",
				"laptop",
				"office",
				"computer",
				"personal"
			],
			u: "1f4bb",
			a: "0.6"
		},
		{
			n: [
				"desktop",
				"monitor",
				"computer",
				"desktop computer"
			],
			u: "1f5a5-fe0f",
			a: "0.7"
		},
		{
			n: [
				"printer",
				"computer"
			],
			u: "1f5a8-fe0f",
			a: "0.7"
		},
		{
			n: [
				"keyboard",
				"computer"
			],
			u: "2328-fe0f",
			a: "1"
		},
		{
			n: [
				"mouse",
				"computer",
				"computer mouse"
			],
			u: "1f5b1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"computer",
				"trackball"
			],
			u: "1f5b2-fe0f",
			a: "0.7"
		},
		{
			n: [
				"disk",
				"optical",
				"computer",
				"minidisk",
				"computer disk"
			],
			u: "1f4bd",
			a: "0.6"
		},
		{
			n: [
				"disk",
				"floppy",
				"computer",
				"floppy disk"
			],
			u: "1f4be",
			a: "0.6"
		},
		{
			n: [
				"cd",
				"dvd",
				"disk",
				"blu ray",
				"optical",
				"computer",
				"optical disk"
			],
			u: "1f4bf",
			a: "0.6"
		},
		{
			n: [
				"cd",
				"dvd",
				"disk",
				"blu ray",
				"optical",
				"computer"
			],
			u: "1f4c0",
			a: "0.6"
		},
		{
			n: [
				"abacus",
				"calculator",
				"calculation"
			],
			u: "1f9ee",
			a: "11"
		},
		{
			n: [
				"film",
				"movie",
				"camera",
				"cinema",
				"record",
				"bollywood",
				"hollywood",
				"movie camera"
			],
			u: "1f3a5",
			a: "0.6"
		},
		{
			n: [
				"film",
				"movie",
				"cinema",
				"frames",
				"film frames"
			],
			u: "1f39e-fe0f",
			a: "0.7"
		},
		{
			n: [
				"film",
				"movie",
				"video",
				"cinema",
				"projector",
				"film projector"
			],
			u: "1f4fd-fe0f",
			a: "0.7"
		},
		{
			n: [
				"board",
				"movie",
				"action",
				"clapper",
				"clapper board"
			],
			u: "1f3ac",
			a: "0.6"
		},
		{
			n: [
				"tv",
				"video",
				"television"
			],
			u: "1f4fa",
			a: "0.6"
		},
		{
			n: [
				"tbt",
				"snap",
				"trip",
				"photo",
				"video",
				"camera",
				"selfie"
			],
			u: "1f4f7",
			a: "0.6"
		},
		{
			n: [
				"flash",
				"video",
				"camera",
				"camera with flash"
			],
			u: "1f4f8",
			a: "1"
		},
		{
			n: [
				"tbt",
				"video",
				"camera",
				"camcorder",
				"video camera"
			],
			u: "1f4f9",
			a: "0.6"
		},
		{
			n: [
				"old",
				"vcr",
				"vhs",
				"tape",
				"video",
				"school",
				"videocassette"
			],
			u: "1f4fc",
			a: "0.6"
		},
		{
			n: [
				"lab",
				"left",
				"tool",
				"glass",
				"search",
				"tilted",
				"science",
				"magnifying",
				"left pointing",
				"magnifying glass tilted left"
			],
			u: "1f50d",
			a: "0.6"
		},
		{
			n: [
				"lab",
				"tool",
				"glass",
				"right",
				"search",
				"tilted",
				"contact",
				"science",
				"magnifying",
				"right pointing",
				"magnifying glass tilted right"
			],
			u: "1f50e",
			a: "0.6"
		},
		{
			n: [
				"light",
				"candle"
			],
			u: "1f56f-fe0f",
			a: "0.7"
		},
		{
			n: [
				"bulb",
				"idea",
				"comic",
				"light",
				"electric",
				"light bulb"
			],
			u: "1f4a1",
			a: "0.6"
		},
		{
			n: [
				"tool",
				"light",
				"torch",
				"electric",
				"flashlight"
			],
			u: "1f526",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"red",
				"light",
				"paper",
				"lantern",
				"restaurant",
				"red paper lantern"
			],
			u: "1f3ee",
			a: "0.6"
		},
		{
			n: [
				"oil",
				"diya",
				"lamp",
				"light",
				"diya lamp"
			],
			u: "1fa94",
			a: "12"
		},
		{
			n: [
				"book",
				"cover",
				"school",
				"writing",
				"notebook",
				"decorated",
				"education",
				"decorative",
				"notebook with decorative cover"
			],
			u: "1f4d4",
			a: "0.6"
		},
		{
			n: [
				"book",
				"closed",
				"education",
				"closed book"
			],
			u: "1f4d5",
			a: "0.6"
		},
		{
			n: [
				"book",
				"open",
				"novels",
				"fantasy",
				"library",
				"reading",
				"open book",
				"education",
				"knowledge"
			],
			u: "1f4d6",
			a: "0.6"
		},
		{
			n: [
				"book",
				"green",
				"fantasy",
				"library",
				"reading",
				"education",
				"green book"
			],
			u: "1f4d7",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"book",
				"fantasy",
				"library",
				"reading",
				"blue book",
				"education"
			],
			u: "1f4d8",
			a: "0.6"
		},
		{
			n: [
				"book",
				"orange",
				"fantasy",
				"library",
				"reading",
				"education",
				"orange book"
			],
			u: "1f4d9",
			a: "0.6"
		},
		{
			n: [
				"book",
				"books",
				"study",
				"novels",
				"school",
				"fantasy",
				"library",
				"reading",
				"education",
				"knowledge"
			],
			u: "1f4da",
			a: "0.6"
		},
		{
			n: [
				"notebook"
			],
			u: "1f4d3",
			a: "0.6"
		},
		{
			n: [
				"ledger",
				"notebook"
			],
			u: "1f4d2",
			a: "0.6"
		},
		{
			n: [
				"curl",
				"page",
				"paper",
				"document",
				"page with curl"
			],
			u: "1f4c3",
			a: "0.6"
		},
		{
			n: [
				"paper",
				"scroll"
			],
			u: "1f4dc",
			a: "0.6"
		},
		{
			n: [
				"up",
				"page",
				"paper",
				"facing",
				"document",
				"page facing up"
			],
			u: "1f4c4",
			a: "0.6"
		},
		{
			n: [
				"news",
				"paper",
				"newspaper",
				"communication"
			],
			u: "1f4f0",
			a: "0.6"
		},
		{
			n: [
				"news",
				"paper",
				"rolled",
				"newspaper",
				"rolled up",
				"rolled up newspaper"
			],
			u: "1f5de-fe0f",
			a: "0.7"
		},
		{
			n: [
				"mark",
				"tabs",
				"marker",
				"bookmark",
				"bookmark tabs"
			],
			u: "1f4d1",
			a: "0.6"
		},
		{
			n: [
				"mark",
				"bookmark"
			],
			u: "1f516",
			a: "0.6"
		},
		{
			n: [
				"tag",
				"label"
			],
			u: "1f3f7-fe0f",
			a: "0.7"
		},
		{
			n: [
				"coin",
				"euro",
				"gold",
				"rich",
				"metal",
				"money",
				"dollar",
				"silver",
				"treasure"
			],
			u: "1fa99",
			a: "13"
		},
		{
			n: [
				"bag",
				"bet",
				"pot",
				"win",
				"bank",
				"cash",
				"cost",
				"gold",
				"paid",
				"rich",
				"money",
				"dollar",
				"paying",
				"billion",
				"million",
				"moneybag",
				"money bag"
			],
			u: "1f4b0",
			a: "0.6"
		},
		{
			n: [
				"yen",
				"bank",
				"bill",
				"note",
				"money",
				"banknote",
				"currency",
				"yen banknote"
			],
			u: "1f4b4",
			a: "0.6"
		},
		{
			n: [
				"bank",
				"bill",
				"note",
				"money",
				"dollar",
				"banknote",
				"currency",
				"dollar banknote"
			],
			u: "1f4b5",
			a: "0.6"
		},
		{
			n: [
				"100",
				"bank",
				"bill",
				"euro",
				"note",
				"rich",
				"money",
				"banknote",
				"currency",
				"euro banknote"
			],
			u: "1f4b6",
			a: "1"
		},
		{
			n: [
				"bank",
				"bill",
				"cash",
				"note",
				"money",
				"pound",
				"pounds",
				"billion",
				"banknote",
				"currency",
				"pound banknote"
			],
			u: "1f4b7",
			a: "1"
		},
		{
			n: [
				"fly",
				"pay",
				"bank",
				"bill",
				"cash",
				"note",
				"money",
				"wings",
				"dollar",
				"billion",
				"million",
				"banknote",
				"money with wings"
			],
			u: "1f4b8",
			a: "0.6"
		},
		{
			n: [
				"pay",
				"bank",
				"card",
				"cash",
				"money",
				"charge",
				"credit",
				"credit card"
			],
			u: "1f4b3",
			a: "0.6"
		},
		{
			n: [
				"proof",
				"receipt",
				"invoice",
				"evidence",
				"accounting",
				"bookkeeping"
			],
			u: "1f9fe",
			a: "11"
		},
		{
			n: [
				"yen",
				"bank",
				"rise",
				"chart",
				"graph",
				"money",
				"trend",
				"growth",
				"market",
				"upward",
				"currency",
				"increasing",
				"chart increasing with yen"
			],
			u: "1f4b9",
			a: "0.6"
		},
		{
			n: [
				"email",
				"e mail",
				"letter",
				"envelope"
			],
			u: "2709-fe0f",
			a: "0.6"
		},
		{
			n: [
				"mail",
				"email",
				"e mail",
				"letter"
			],
			u: "1f4e7",
			a: "0.6"
		},
		{
			n: [
				"mail",
				"sent",
				"email",
				"e mail",
				"letter",
				"receive",
				"envelope",
				"incoming",
				"delivering",
				"incoming envelope"
			],
			u: "1f4e8",
			a: "0.6"
		},
		{
			n: [
				"down",
				"mail",
				"send",
				"sent",
				"arrow",
				"email",
				"e mail",
				"letter",
				"envelope",
				"outgoing",
				"communication",
				"envelope with arrow"
			],
			u: "1f4e9",
			a: "0.6"
		},
		{
			n: [
				"box",
				"mail",
				"sent",
				"tray",
				"email",
				"letter",
				"outbox",
				"outbox tray"
			],
			u: "1f4e4",
			a: "0.6"
		},
		{
			n: [
				"box",
				"mail",
				"tray",
				"zero",
				"email",
				"inbox",
				"letter",
				"receive",
				"inbox tray"
			],
			u: "1f4e5",
			a: "0.6"
		},
		{
			n: [
				"box",
				"parcel",
				"package",
				"delivery",
				"shipping",
				"communication"
			],
			u: "1f4e6",
			a: "0.6"
		},
		{
			n: [
				"flag",
				"mail",
				"closed",
				"raised",
				"mailbox",
				"postbox",
				"communication",
				"closed mailbox with raised flag"
			],
			u: "1f4eb",
			a: "0.6"
		},
		{
			n: [
				"flag",
				"mail",
				"closed",
				"lowered",
				"mailbox",
				"postbox",
				"closed mailbox with lowered flag"
			],
			u: "1f4ea",
			a: "0.6"
		},
		{
			n: [
				"flag",
				"mail",
				"open",
				"raised",
				"mailbox",
				"postbox",
				"open mailbox with raised flag"
			],
			u: "1f4ec",
			a: "0.7"
		},
		{
			n: [
				"flag",
				"mail",
				"open",
				"lowered",
				"mailbox",
				"postbox",
				"open mailbox with lowered flag"
			],
			u: "1f4ed",
			a: "0.7"
		},
		{
			n: [
				"mail",
				"postbox",
				"mailbox"
			],
			u: "1f4ee",
			a: "0.6"
		},
		{
			n: [
				"box",
				"ballot",
				"ballot box with ballot"
			],
			u: "1f5f3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"pencil"
			],
			u: "270f-fe0f",
			a: "0.6"
		},
		{
			n: [
				"nib",
				"pen",
				"black",
				"black nib"
			],
			u: "2712-fe0f",
			a: "0.6"
		},
		{
			n: [
				"pen",
				"fountain",
				"fountain pen"
			],
			u: "1f58b-fe0f",
			a: "0.7"
		},
		{
			n: [
				"pen",
				"ballpoint"
			],
			u: "1f58a-fe0f",
			a: "0.7"
		},
		{
			n: [
				"painting",
				"paintbrush"
			],
			u: "1f58c-fe0f",
			a: "0.7"
		},
		{
			n: [
				"crayon"
			],
			u: "1f58d-fe0f",
			a: "0.7"
		},
		{
			n: [
				"memo",
				"media",
				"notes",
				"pencil",
				"communication"
			],
			u: "1f4dd",
			a: "0.6"
		},
		{
			n: [
				"office",
				"briefcase"
			],
			u: "1f4bc",
			a: "0.6"
		},
		{
			n: [
				"file",
				"folder",
				"file folder"
			],
			u: "1f4c1",
			a: "0.6"
		},
		{
			n: [
				"file",
				"open",
				"folder",
				"open file folder"
			],
			u: "1f4c2",
			a: "0.6"
		},
		{
			n: [
				"card",
				"index",
				"dividers",
				"card index dividers"
			],
			u: "1f5c2-fe0f",
			a: "0.7"
		},
		{
			n: [
				"date",
				"calendar"
			],
			u: "1f4c5",
			a: "0.6"
		},
		{
			n: [
				"calendar",
				"tear off",
				"tear off calendar"
			],
			u: "1f4c6",
			a: "0.6"
		},
		{
			n: [
				"pad",
				"note",
				"spiral",
				"notepad",
				"spiral notepad"
			],
			u: "1f5d2-fe0f",
			a: "0.7"
		},
		{
			n: [
				"pad",
				"spiral",
				"calendar",
				"spiral calendar"
			],
			u: "1f5d3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"old",
				"card",
				"index",
				"school",
				"rolodex",
				"card index"
			],
			u: "1f4c7",
			a: "0.6"
		},
		{
			n: [
				"up",
				"data",
				"chart",
				"graph",
				"right",
				"trend",
				"growth",
				"upward",
				"increasing",
				"chart increasing"
			],
			u: "1f4c8",
			a: "0.6"
		},
		{
			n: [
				"data",
				"down",
				"chart",
				"graph",
				"trend",
				"downward",
				"negative",
				"decreasing",
				"chart decreasing"
			],
			u: "1f4c9",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"data",
				"chart",
				"graph",
				"bar chart"
			],
			u: "1f4ca",
			a: "0.6"
		},
		{
			n: [
				"do",
				"list",
				"notes",
				"clipboard"
			],
			u: "1f4cb",
			a: "0.6"
		},
		{
			n: [
				"pin",
				"pushpin",
				"collage"
			],
			u: "1f4cc",
			a: "0.6"
		},
		{
			n: [
				"map",
				"pin",
				"round",
				"pushpin",
				"location",
				"round pushpin"
			],
			u: "1f4cd",
			a: "0.6"
		},
		{
			n: [
				"paperclip"
			],
			u: "1f4ce",
			a: "0.6"
		},
		{
			n: [
				"link",
				"linked",
				"paperclip",
				"paperclips",
				"linked paperclips"
			],
			u: "1f587-fe0f",
			a: "0.7"
		},
		{
			n: [
				"edge",
				"math",
				"angle",
				"ruler",
				"straight",
				"straightedge",
				"straight ruler"
			],
			u: "1f4cf",
			a: "0.6"
		},
		{
			n: [
				"set",
				"math",
				"rule",
				"angle",
				"ruler",
				"slide",
				"triangle",
				"triangular",
				"triangular ruler"
			],
			u: "1f4d0",
			a: "0.6"
		},
		{
			n: [
				"cut",
				"tool",
				"paper",
				"cutting",
				"scissors"
			],
			u: "2702-fe0f",
			a: "0.6"
		},
		{
			n: [
				"box",
				"card",
				"file",
				"card file box"
			],
			u: "1f5c3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"file",
				"paper",
				"filing",
				"cabinet",
				"file cabinet"
			],
			u: "1f5c4-fe0f",
			a: "0.7"
		},
		{
			n: [
				"can",
				"trash",
				"waste",
				"garbage",
				"wastebasket"
			],
			u: "1f5d1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"lock",
				"locked",
				"closed",
				"private"
			],
			u: "1f512",
			a: "0.6"
		},
		{
			n: [
				"lock",
				"open",
				"unlock",
				"cracked",
				"unlocked"
			],
			u: "1f513",
			a: "0.6"
		},
		{
			n: [
				"ink",
				"nib",
				"pen",
				"lock",
				"locked",
				"privacy",
				"locked with pen"
			],
			u: "1f50f",
			a: "0.6"
		},
		{
			n: [
				"key",
				"bike",
				"lock",
				"closed",
				"locked",
				"secure",
				"locked with key"
			],
			u: "1f510",
			a: "0.6"
		},
		{
			n: [
				"key",
				"keys",
				"lock",
				"major",
				"unlock",
				"password"
			],
			u: "1f511",
			a: "0.6"
		},
		{
			n: [
				"key",
				"old",
				"clue",
				"lock",
				"old key"
			],
			u: "1f5dd-fe0f",
			a: "0.7"
		},
		{
			n: [
				"home",
				"tool",
				"hammer",
				"repairs",
				"improvement"
			],
			u: "1f528",
			a: "0.6"
		},
		{
			n: [
				"ax",
				"axe",
				"chop",
				"wood",
				"split",
				"hatchet"
			],
			u: "1fa93",
			a: "12"
		},
		{
			n: [
				"pick",
				"tool",
				"hammer",
				"mining"
			],
			u: "26cf-fe0f",
			a: "0.7"
		},
		{
			n: [
				"pick",
				"tool",
				"hammer",
				"hammer and pick"
			],
			u: "2692-fe0f",
			a: "1"
		},
		{
			n: [
				"tool",
				"hammer",
				"wrench",
				"spanner",
				"hammer and wrench"
			],
			u: "1f6e0-fe0f",
			a: "0.7"
		},
		{
			n: [
				"knife",
				"dagger",
				"weapon"
			],
			u: "1f5e1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"swords",
				"weapon",
				"crossed",
				"crossed swords"
			],
			u: "2694-fe0f",
			a: "1"
		},
		{
			n: [
				"hot",
				"bomb",
				"boom",
				"comic",
				"dangerous",
				"explosion"
			],
			u: "1f4a3",
			a: "0.6"
		},
		{
			n: [
				"weapon",
				"rebound",
				"boomerang",
				"repercussion"
			],
			u: "1fa83",
			a: "13"
		},
		{
			n: [
				"bow",
				"tool",
				"arrow",
				"archer",
				"weapon",
				"zodiac",
				"archery",
				"sagittarius",
				"bow and arrow"
			],
			u: "1f3f9",
			a: "1"
		},
		{
			n: [
				"shield",
				"weapon"
			],
			u: "1f6e1-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cut",
				"saw",
				"tool",
				"trim",
				"lumber",
				"carpenter",
				"carpentry",
				"carpentry saw"
			],
			u: "1fa9a",
			a: "13"
		},
		{
			n: [
				"home",
				"tool",
				"wrench",
				"spanner",
				"improvement"
			],
			u: "1f527",
			a: "0.6"
		},
		{
			n: [
				"tool",
				"handy",
				"screw",
				"flathead",
				"screwdriver"
			],
			u: "1fa9b",
			a: "13"
		},
		{
			n: [
				"nut",
				"bolt",
				"home",
				"tool",
				"improvement",
				"nut and bolt"
			],
			u: "1f529",
			a: "0.6"
		},
		{
			n: [
				"cog",
				"gear",
				"tool",
				"cogwheel"
			],
			u: "2699-fe0f",
			a: "1"
		},
		{
			n: [
				"tool",
				"vice",
				"clamp",
				"compress"
			],
			u: "1f5dc-fe0f",
			a: "0.7"
		},
		{
			n: [
				"tool",
				"libra",
				"scale",
				"scales",
				"weight",
				"zodiac",
				"balance",
				"justice",
				"balance scale"
			],
			u: "2696-fe0f",
			a: "1"
		},
		{
			n: [
				"cane",
				"blind",
				"white",
				"probing",
				"white cane",
				"accessibility"
			],
			u: "1f9af",
			a: "12"
		},
		{
			n: [
				"link",
				"links"
			],
			u: "1f517",
			a: "0.6"
		},
		{
			n: [
				"break",
				"chain",
				"cuffs",
				"broken",
				"freedom",
				"breaking",
				"broken chain"
			],
			u: "26d3-fe0f-200d-1f4a5",
			a: "15.1"
		},
		{
			n: [
				"chain",
				"chains"
			],
			u: "26d3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"hook",
				"catch",
				"crook",
				"curve",
				"point",
				"ensnare",
				"selling"
			],
			u: "1fa9d",
			a: "13"
		},
		{
			n: [
				"box",
				"red",
				"tool",
				"chest",
				"toolbox",
				"mechanic"
			],
			u: "1f9f0",
			a: "11"
		},
		{
			n: [
				"u",
				"shape",
				"magnet",
				"magnetic",
				"negative",
				"positive",
				"horseshoe",
				"attraction"
			],
			u: "1f9f2",
			a: "11"
		},
		{
			n: [
				"rung",
				"step",
				"climb",
				"ladder"
			],
			u: "1fa9c",
			a: "13"
		},
		{
			n: [
				"dig",
				"bury",
				"hole",
				"snow",
				"plant",
				"scoop",
				"spade",
				"shovel",
				"garden"
			],
			u: "1fa8f",
			a: "16"
		},
		{
			n: [
				"tool",
				"alembic",
				"chemistry"
			],
			u: "2697-fe0f",
			a: "1"
		},
		{
			n: [
				"lab",
				"test",
				"tube",
				"chemist",
				"science",
				"test tube",
				"chemistry",
				"experiment"
			],
			u: "1f9ea",
			a: "11"
		},
		{
			n: [
				"lab",
				"dish",
				"petri",
				"biology",
				"culture",
				"bacteria",
				"biologist",
				"petri dish"
			],
			u: "1f9eb",
			a: "11"
		},
		{
			n: [
				"dna",
				"gene",
				"life",
				"genetics",
				"biologist",
				"evolution"
			],
			u: "1f9ec",
			a: "11"
		},
		{
			n: [
				"lab",
				"tool",
				"science",
				"microscope",
				"experiment"
			],
			u: "1f52c",
			a: "1"
		},
		{
			n: [
				"tool",
				"contact",
				"science",
				"telescope",
				"extraterrestrial"
			],
			u: "1f52d",
			a: "1"
		},
		{
			n: [
				"dish",
				"aliens",
				"antenna",
				"contact",
				"science",
				"satellite",
				"satellite antenna"
			],
			u: "1f4e1",
			a: "0.6"
		},
		{
			n: [
				"flu",
				"shot",
				"sick",
				"tool",
				"doctor",
				"needle",
				"syringe",
				"medicine",
				"vaccination"
			],
			u: "1f489",
			a: "0.6"
		},
		{
			n: [
				"drop",
				"bleed",
				"blood",
				"injury",
				"donation",
				"medicine",
				"menstruation",
				"drop of blood"
			],
			u: "1fa78",
			a: "12"
		},
		{
			n: [
				"pill",
				"sick",
				"drugs",
				"pills",
				"doctor",
				"vitamin",
				"medicine",
				"medicated"
			],
			u: "1f48a",
			a: "0.6"
		},
		{
			n: [
				"bandage",
				"adhesive",
				"adhesive bandage"
			],
			u: "1fa79",
			a: "12"
		},
		{
			n: [
				"aid",
				"cane",
				"help",
				"hurt",
				"stick",
				"crutch",
				"injured",
				"mobility",
				"disability"
			],
			u: "1fa7c",
			a: "14"
		},
		{
			n: [
				"heart",
				"doctor",
				"medicine",
				"stethoscope"
			],
			u: "1fa7a",
			a: "12"
		},
		{
			n: [
				"xray",
				"x ray",
				"bones",
				"skull",
				"doctor",
				"medical",
				"skeleton"
			],
			u: "1fa7b",
			a: "14"
		},
		{
			n: [
				"door",
				"back",
				"front",
				"closet"
			],
			u: "1f6aa",
			a: "0.6"
		},
		{
			n: [
				"lift",
				"hoist",
				"elevator",
				"accessibility"
			],
			u: "1f6d7",
			a: "13"
		},
		{
			n: [
				"mirror",
				"makeup",
				"speculum",
				"reflector",
				"reflection"
			],
			u: "1fa9e",
			a: "13"
		},
		{
			n: [
				"air",
				"view",
				"frame",
				"fresh",
				"window",
				"opening",
				"transparent"
			],
			u: "1fa9f",
			a: "13"
		},
		{
			n: [
				"bed",
				"hotel",
				"sleep"
			],
			u: "1f6cf-fe0f",
			a: "0.7"
		},
		{
			n: [
				"lamp",
				"couch",
				"hotel",
				"couch and lamp"
			],
			u: "1f6cb-fe0f",
			a: "0.7"
		},
		{
			n: [
				"sit",
				"seat",
				"chair"
			],
			u: "1fa91",
			a: "12"
		},
		{
			n: [
				"toilet",
				"bathroom"
			],
			u: "1f6bd",
			a: "0.6"
		},
		{
			n: [
				"cup",
				"poop",
				"force",
				"toilet",
				"plunger",
				"plumber",
				"suction"
			],
			u: "1faa0",
			a: "13"
		},
		{
			n: [
				"water",
				"shower"
			],
			u: "1f6bf",
			a: "1"
		},
		{
			n: [
				"bath",
				"bathtub"
			],
			u: "1f6c1",
			a: "1"
		},
		{
			n: [
				"bait",
				"lure",
				"trap",
				"mouse",
				"snare",
				"cheese",
				"mousetrap",
				"mouse trap"
			],
			u: "1faa4",
			a: "13"
		},
		{
			n: [
				"razor",
				"sharp",
				"shave"
			],
			u: "1fa92",
			a: "12"
		},
		{
			n: [
				"bottle",
				"lotion",
				"shampoo",
				"sunscreen",
				"moisturizer",
				"lotion bottle"
			],
			u: "1f9f4",
			a: "11"
		},
		{
			n: [
				"pin",
				"punk",
				"rock",
				"diaper",
				"safety",
				"safety pin"
			],
			u: "1f9f7",
			a: "11"
		},
		{
			n: [
				"broom",
				"witch",
				"cleaning",
				"sweeping"
			],
			u: "1f9f9",
			a: "11"
		},
		{
			n: [
				"basket",
				"picnic",
				"farming",
				"laundry"
			],
			u: "1f9fa",
			a: "11"
		},
		{
			n: [
				"roll",
				"paper",
				"toilet",
				"towels",
				"roll of paper"
			],
			u: "1f9fb",
			a: "11"
		},
		{
			n: [
				"vat",
				"cask",
				"pail",
				"bucket"
			],
			u: "1faa3",
			a: "13"
		},
		{
			n: [
				"bar",
				"soap",
				"clean",
				"lather",
				"bathing",
				"cleaning",
				"soapdish"
			],
			u: "1f9fc",
			a: "11"
		},
		{
			n: [
				"burp",
				"soap",
				"clean",
				"pearl",
				"bubble",
				"bubbles",
				"floating",
				"underwater"
			],
			u: "1fae7",
			a: "14"
		},
		{
			n: [
				"brush",
				"clean",
				"teeth",
				"dental",
				"hygiene",
				"bathroom",
				"toiletry",
				"toothbrush"
			],
			u: "1faa5",
			a: "13"
		},
		{
			n: [
				"soak",
				"sponge",
				"porous",
				"cleaning",
				"absorbing"
			],
			u: "1f9fd",
			a: "11"
		},
		{
			n: [
				"fire",
				"quench",
				"extinguish",
				"extinguisher",
				"fire extinguisher"
			],
			u: "1f9ef",
			a: "11"
		},
		{
			n: [
				"cart",
				"trolley",
				"shopping",
				"shopping cart"
			],
			u: "1f6d2",
			a: "3"
		},
		{
			n: [
				"smoking",
				"cigarette"
			],
			u: "1f6ac",
			a: "0.6"
		},
		{
			n: [
				"dead",
				"death",
				"coffin",
				"vampire"
			],
			u: "26b0-fe0f",
			a: "1"
		},
		{
			n: [
				"rip",
				"dead",
				"tomb",
				"grave",
				"cemetery",
				"memorial",
				"headstone",
				"graveyard",
				"tombstone"
			],
			u: "1faa6",
			a: "13"
		},
		{
			n: [
				"urn",
				"ashes",
				"death",
				"funeral",
				"funeral urn"
			],
			u: "26b1-fe0f",
			a: "1"
		},
		{
			n: [
				"bead",
				"blue",
				"charm",
				"nazar",
				"amulet",
				"evil eye",
				"talisman",
				"nazar amulet"
			],
			u: "1f9ff",
			a: "11"
		},
		{
			n: [
				"hand",
				"mary",
				"palm",
				"hamsa",
				"guide",
				"amulet",
				"fatima",
				"miriam",
				"fortune",
				"protect",
				"protection"
			],
			u: "1faac",
			a: "14"
		},
		{
			n: [
				"moai",
				"face",
				"moyai",
				"statue",
				"travel",
				"stoneface"
			],
			u: "1f5ff",
			a: "0.6"
		},
		{
			n: [
				"card",
				"sign",
				"notice",
				"picket",
				"plaque",
				"placard",
				"protest",
				"demonstration"
			],
			u: "1faa7",
			a: "13"
		},
		{
			n: [
				"id",
				"card",
				"license",
				"document",
				"security",
				"credentials",
				"identification",
				"identification card"
			],
			u: "1faaa",
			a: "14"
		}
	],
	symbols: [
		{
			n: [
				"atm",
				"bank",
				"cash",
				"sign",
				"money",
				"teller",
				"ATM sign",
				"automated"
			],
			u: "1f3e7",
			a: "0.6"
		},
		{
			n: [
				"bin",
				"sign",
				"litter",
				"litterbin",
				"litter in bin sign"
			],
			u: "1f6ae",
			a: "1"
		},
		{
			n: [
				"water",
				"potable",
				"drinking",
				"potable water"
			],
			u: "1f6b0",
			a: "1"
		},
		{
			n: [
				"access",
				"symbol",
				"handicap",
				"wheelchair",
				"wheelchair symbol"
			],
			u: "267f",
			a: "0.6"
		},
		{
			n: [
				"wc",
				"man",
				"room",
				"men’s",
				"toilet",
				"bathroom",
				"lavatory",
				"restroom",
				"men’s room"
			],
			u: "1f6b9",
			a: "0.6"
		},
		{
			n: [
				"wc",
				"room",
				"woman",
				"toilet",
				"women’s",
				"bathroom",
				"lavatory",
				"restroom",
				"women’s room"
			],
			u: "1f6ba",
			a: "0.6"
		},
		{
			n: [
				"wc",
				"toilet",
				"restroom",
				"bathroom",
				"lavatory"
			],
			u: "1f6bb",
			a: "0.6"
		},
		{
			n: [
				"baby",
				"symbol",
				"changing",
				"baby symbol"
			],
			u: "1f6bc",
			a: "0.6"
		},
		{
			n: [
				"wc",
				"water",
				"closet",
				"toilet",
				"bathroom",
				"lavatory",
				"restroom",
				"water closet"
			],
			u: "1f6be",
			a: "0.6"
		},
		{
			n: [
				"control",
				"passport",
				"passport control"
			],
			u: "1f6c2",
			a: "1"
		},
		{
			n: [
				"customs",
				"packing"
			],
			u: "1f6c3",
			a: "1"
		},
		{
			n: [
				"bags",
				"case",
				"trip",
				"claim",
				"plane",
				"ready",
				"travel",
				"arrived",
				"baggage",
				"checked",
				"journey",
				"packing",
				"baggage claim"
			],
			u: "1f6c4",
			a: "1"
		},
		{
			n: [
				"case",
				"left",
				"locker",
				"baggage",
				"luggage",
				"left luggage"
			],
			u: "1f6c5",
			a: "1"
		},
		{
			n: [
				"warning",
				"caution"
			],
			u: "26a0-fe0f",
			a: "0.6"
		},
		{
			n: [
				"child",
				"traffic",
				"children",
				"crossing",
				"pedestrian",
				"children crossing"
			],
			u: "1f6b8",
			a: "1"
		},
		{
			n: [
				"do",
				"no",
				"not",
				"fail",
				"pass",
				"entry",
				"traffic",
				"no entry",
				"forbidden",
				"prohibited"
			],
			u: "26d4",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"entry",
				"smoke",
				"forbidden",
				"prohibited"
			],
			u: "1f6ab",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"bike",
				"bicycle",
				"bicycles",
				"forbidden",
				"prohibited",
				"no bicycles"
			],
			u: "1f6b3",
			a: "1"
		},
		{
			n: [
				"no",
				"not",
				"smoke",
				"smoking",
				"forbidden",
				"no smoking",
				"prohibited"
			],
			u: "1f6ad",
			a: "0.6"
		},
		{
			n: [
				"no",
				"not",
				"litter",
				"forbidden",
				"littering",
				"prohibited",
				"no littering"
			],
			u: "1f6af",
			a: "1"
		},
		{
			n: [
				"dry",
				"water",
				"prohibited",
				"non potable",
				"non drinking",
				"non potable water"
			],
			u: "1f6b1",
			a: "1"
		},
		{
			n: [
				"no",
				"not",
				"forbidden",
				"pedestrian",
				"prohibited",
				"pedestrians",
				"no pedestrians"
			],
			u: "1f6b7",
			a: "1"
		},
		{
			n: [
				"no",
				"not",
				"cell",
				"phone",
				"mobile",
				"phones",
				"forbidden",
				"telephone",
				"prohibited",
				"no mobile phones"
			],
			u: "1f4f5",
			a: "1"
		},
		{
			n: [
				"18",
				"no",
				"age",
				"not",
				"one",
				"eighteen",
				"underage",
				"forbidden",
				"prohibited",
				"restriction",
				"no one under eighteen"
			],
			u: "1f51e",
			a: "0.6"
		},
		{
			n: [
				"sign",
				"radioactive"
			],
			u: "2622-fe0f",
			a: "1"
		},
		{
			n: [
				"sign",
				"biohazard"
			],
			u: "2623-fe0f",
			a: "1"
		},
		{
			n: [
				"up",
				"arrow",
				"north",
				"up arrow",
				"cardinal",
				"direction"
			],
			u: "2b06-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"up right",
				"direction",
				"northeast",
				"intercardinal",
				"up right arrow"
			],
			u: "2197-fe0f",
			a: "0.6"
		},
		{
			n: [
				"east",
				"arrow",
				"right",
				"cardinal",
				"direction",
				"right arrow"
			],
			u: "27a1-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"direction",
				"southeast",
				"down right",
				"intercardinal",
				"down right arrow"
			],
			u: "2198-fe0f",
			a: "0.6"
		},
		{
			n: [
				"down",
				"arrow",
				"south",
				"cardinal",
				"direction",
				"down arrow"
			],
			u: "2b07-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"direction",
				"down left",
				"southwest",
				"intercardinal",
				"down left arrow"
			],
			u: "2199-fe0f",
			a: "0.6"
		},
		{
			n: [
				"left",
				"west",
				"arrow",
				"cardinal",
				"direction",
				"left arrow"
			],
			u: "2b05-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"up left",
				"direction",
				"northwest",
				"up left arrow",
				"intercardinal"
			],
			u: "2196-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"up down",
				"up down arrow"
			],
			u: "2195-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"left right",
				"left right arrow"
			],
			u: "2194-fe0f",
			a: "0.6"
		},
		{
			n: [
				"left",
				"arrow",
				"right",
				"curving",
				"right arrow curving left"
			],
			u: "21a9-fe0f",
			a: "0.6"
		},
		{
			n: [
				"left",
				"arrow",
				"right",
				"curving",
				"left arrow curving right"
			],
			u: "21aa-fe0f",
			a: "0.6"
		},
		{
			n: [
				"up",
				"arrow",
				"right",
				"curving",
				"right arrow curving up"
			],
			u: "2934-fe0f",
			a: "0.6"
		},
		{
			n: [
				"down",
				"arrow",
				"right",
				"curving",
				"right arrow curving down"
			],
			u: "2935-fe0f",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"arrows",
				"reload",
				"refresh",
				"vertical",
				"clockwise",
				"clockwise vertical arrows"
			],
			u: "1f503",
			a: "0.6"
		},
		{
			n: [
				"vu",
				"deja",
				"again",
				"arrow",
				"arrows",
				"button",
				"refresh",
				"anticlockwise",
				"rewindershins",
				"counterclockwise",
				"counterclockwise arrows button"
			],
			u: "1f504",
			a: "1"
		},
		{
			n: [
				"back",
				"arrow",
				"BACK arrow"
			],
			u: "1f519",
			a: "0.6"
		},
		{
			n: [
				"end",
				"arrow",
				"END arrow"
			],
			u: "1f51a",
			a: "0.6"
		},
		{
			n: [
				"on!",
				"mark",
				"arrow",
				"ON! arrow"
			],
			u: "1f51b",
			a: "0.6"
		},
		{
			n: [
				"brb",
				"omw",
				"soon",
				"arrow",
				"SOON arrow"
			],
			u: "1f51c",
			a: "0.6"
		},
		{
			n: [
				"up",
				"top",
				"arrow",
				"homie",
				"TOP arrow"
			],
			u: "1f51d",
			a: "0.6"
		},
		{
			n: [
				"pray",
				"place",
				"worship",
				"religion",
				"place of worship"
			],
			u: "1f6d0",
			a: "1"
		},
		{
			n: [
				"atom",
				"symbol",
				"atheist",
				"atom symbol"
			],
			u: "269b-fe0f",
			a: "1"
		},
		{
			n: [
				"om",
				"hindu",
				"religion"
			],
			u: "1f549-fe0f",
			a: "0.7"
		},
		{
			n: [
				"jew",
				"star",
				"david",
				"jewish",
				"judaism",
				"religion",
				"star of David"
			],
			u: "2721-fe0f",
			a: "0.7"
		},
		{
			n: [
				"wheel",
				"dharma",
				"buddhist",
				"religion",
				"wheel of dharma"
			],
			u: "2638-fe0f",
			a: "0.7"
		},
		{
			n: [
				"tao",
				"yin",
				"yang",
				"lives",
				"total",
				"taoist",
				"yinyang",
				"yin yang",
				"religion",
				"difficult"
			],
			u: "262f-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cross",
				"latin",
				"christ",
				"religion",
				"christian",
				"latin cross"
			],
			u: "271d-fe0f",
			a: "0.7"
		},
		{
			n: [
				"cross",
				"orthodox",
				"religion",
				"christian",
				"orthodox cross"
			],
			u: "2626-fe0f",
			a: "1"
		},
		{
			n: [
				"star",
				"islam",
				"muslim",
				"ramadan",
				"crescent",
				"religion",
				"star and crescent"
			],
			u: "262a-fe0f",
			a: "0.7"
		},
		{
			n: [
				"peace",
				"symbol",
				"healing",
				"peaceful",
				"peace symbol"
			],
			u: "262e-fe0f",
			a: "1"
		},
		{
			n: [
				"jewish",
				"menorah",
				"judaism",
				"hanukkah",
				"religion",
				"candelabrum",
				"candlestick"
			],
			u: "1f54e",
			a: "1"
		},
		{
			n: [
				"star",
				"dotted",
				"jewish",
				"fortune",
				"judaism",
				"six pointed",
				"dotted six pointed star"
			],
			u: "1f52f",
			a: "0.6"
		},
		{
			n: [
				"deg",
				"sikh",
				"tegh",
				"fateh",
				"khanda",
				"khalsa",
				"sikhism",
				"religion"
			],
			u: "1faaf",
			a: "15"
		},
		{
			n: [
				"ram",
				"Aries",
				"aries",
				"zodiac",
				"horoscope"
			],
			u: "2648",
			a: "0.6"
		},
		{
			n: [
				"ox",
				"bull",
				"Taurus",
				"taurus",
				"zodiac",
				"horoscope"
			],
			u: "2649",
			a: "0.6"
		},
		{
			n: [
				"twins",
				"Gemini",
				"gemini",
				"zodiac",
				"horoscope"
			],
			u: "264a",
			a: "0.6"
		},
		{
			n: [
				"crab",
				"Cancer",
				"cancer",
				"zodiac",
				"horoscope"
			],
			u: "264b",
			a: "0.6"
		},
		{
			n: [
				"Leo",
				"leo",
				"lion",
				"zodiac",
				"horoscope"
			],
			u: "264c",
			a: "0.6"
		},
		{
			n: [
				"Virgo",
				"virgo",
				"zodiac",
				"horoscope"
			],
			u: "264d",
			a: "0.6"
		},
		{
			n: [
				"Libra",
				"libra",
				"scales",
				"zodiac",
				"balance",
				"justice",
				"horoscope"
			],
			u: "264e",
			a: "0.6"
		},
		{
			n: [
				"zodiac",
				"Scorpio",
				"scorpio",
				"scorpion",
				"scorpius",
				"horoscope"
			],
			u: "264f",
			a: "0.6"
		},
		{
			n: [
				"archer",
				"zodiac",
				"horoscope",
				"Sagittarius",
				"sagittarius"
			],
			u: "2650",
			a: "0.6"
		},
		{
			n: [
				"goat",
				"zodiac",
				"Capricorn",
				"capricorn",
				"horoscope"
			],
			u: "2651",
			a: "0.6"
		},
		{
			n: [
				"water",
				"bearer",
				"zodiac",
				"Aquarius",
				"aquarius",
				"horoscope"
			],
			u: "2652",
			a: "0.6"
		},
		{
			n: [
				"fish",
				"Pisces",
				"pisces",
				"zodiac",
				"horoscope"
			],
			u: "2653",
			a: "0.6"
		},
		{
			n: [
				"snake",
				"bearer",
				"zodiac",
				"serpent",
				"Ophiuchus",
				"ophiuchus"
			],
			u: "26ce",
			a: "0.6"
		},
		{
			n: [
				"arrow",
				"button",
				"tracks",
				"crossed",
				"shuffle",
				"shuffle tracks button"
			],
			u: "1f500",
			a: "1"
		},
		{
			n: [
				"arrow",
				"button",
				"repeat",
				"clockwise",
				"repeat button"
			],
			u: "1f501",
			a: "1"
		},
		{
			n: [
				"once",
				"arrow",
				"button",
				"repeat",
				"single",
				"clockwise",
				"repeat single button"
			],
			u: "1f502",
			a: "1"
		},
		{
			n: [
				"play",
				"arrow",
				"right",
				"button",
				"triangle",
				"play button"
			],
			u: "25b6-fe0f",
			a: "0.6"
		},
		{
			n: [
				"fast",
				"arrow",
				"button",
				"double",
				"forward",
				"fast forward",
				"fast forward button"
			],
			u: "23e9",
			a: "0.6"
		},
		{
			n: [
				"next",
				"arrow",
				"scene",
				"track",
				"button",
				"triangle",
				"next track button"
			],
			u: "23ed-fe0f",
			a: "0.7"
		},
		{
			n: [
				"play",
				"arrow",
				"pause",
				"right",
				"button",
				"triangle",
				"play or pause button"
			],
			u: "23ef-fe0f",
			a: "1"
		},
		{
			n: [
				"left",
				"arrow",
				"button",
				"reverse",
				"triangle",
				"reverse button"
			],
			u: "25c0-fe0f",
			a: "0.6"
		},
		{
			n: [
				"fast",
				"arrow",
				"button",
				"double",
				"rewind",
				"reverse",
				"fast reverse button"
			],
			u: "23ea",
			a: "0.6"
		},
		{
			n: [
				"last",
				"arrow",
				"scene",
				"track",
				"button",
				"previous",
				"triangle",
				"last track button"
			],
			u: "23ee-fe0f",
			a: "0.7"
		},
		{
			n: [
				"up",
				"red",
				"arrow",
				"button",
				"upwards",
				"upwards button"
			],
			u: "1f53c",
			a: "0.6"
		},
		{
			n: [
				"up",
				"fast",
				"arrow",
				"button",
				"double",
				"fast up button"
			],
			u: "23eb",
			a: "0.6"
		},
		{
			n: [
				"red",
				"down",
				"arrow",
				"button",
				"downwards",
				"downwards button"
			],
			u: "1f53d",
			a: "0.6"
		},
		{
			n: [
				"down",
				"fast",
				"arrow",
				"button",
				"double",
				"fast down button"
			],
			u: "23ec",
			a: "0.6"
		},
		{
			n: [
				"bar",
				"pause",
				"button",
				"double",
				"vertical",
				"pause button"
			],
			u: "23f8-fe0f",
			a: "0.7"
		},
		{
			n: [
				"stop",
				"button",
				"square",
				"stop button"
			],
			u: "23f9-fe0f",
			a: "0.7"
		},
		{
			n: [
				"button",
				"circle",
				"record",
				"record button"
			],
			u: "23fa-fe0f",
			a: "0.7"
		},
		{
			n: [
				"eject",
				"button",
				"eject button"
			],
			u: "23cf-fe0f",
			a: "1"
		},
		{
			n: [
				"film",
				"movie",
				"cinema",
				"camera"
			],
			u: "1f3a6",
			a: "0.6"
		},
		{
			n: [
				"dim",
				"low",
				"button",
				"dim button",
				"brightness"
			],
			u: "1f505",
			a: "1"
		},
		{
			n: [
				"light",
				"bright",
				"button",
				"brightness",
				"bright button"
			],
			u: "1f506",
			a: "1"
		},
		{
			n: [
				"bar",
				"bars",
				"cell",
				"phone",
				"mobile",
				"signal",
				"antenna",
				"telephone",
				"antenna bars",
				"communication"
			],
			u: "1f4f6",
			a: "0.6"
		},
		{
			n: [
				"wifi",
				"wlan",
				"wi fi",
				"router",
				"hotspot",
				"network",
				"wireless",
				"computer",
				"internet",
				"broadband",
				"smartphone",
				"connectivity"
			],
			u: "1f6dc",
			a: "15"
		},
		{
			n: [
				"cell",
				"mode",
				"phone",
				"mobile",
				"telephone",
				"vibration",
				"communication",
				"vibration mode"
			],
			u: "1f4f3",
			a: "0.6"
		},
		{
			n: [
				"off",
				"cell",
				"phone",
				"mobile",
				"telephone",
				"mobile phone off"
			],
			u: "1f4f4",
			a: "0.6"
		},
		{
			n: [
				"sign",
				"woman",
				"female",
				"female sign"
			],
			u: "2640-fe0f",
			a: "4"
		},
		{
			n: [
				"man",
				"male",
				"sign",
				"male sign"
			],
			u: "2642-fe0f",
			a: "4"
		},
		{
			n: [
				"symbol",
				"transgender",
				"transgender symbol"
			],
			u: "26a7-fe0f",
			a: "13"
		},
		{
			n: [
				"x",
				"×",
				"sign",
				"cancel",
				"multiply",
				"multiplication"
			],
			u: "2716-fe0f",
			a: "0.6"
		},
		{
			n: [
				"+",
				"plus"
			],
			u: "2795",
			a: "0.6"
		},
		{
			n: [
				" ",
				"−",
				"math",
				"sign",
				"minus",
				"heavy"
			],
			u: "2796",
			a: "0.6"
		},
		{
			n: [
				"÷",
				"math",
				"sign",
				"heavy",
				"divide",
				"division"
			],
			u: "2797",
			a: "0.6"
		},
		{
			n: [
				"math",
				"sign",
				"equal",
				"heavy",
				"answer",
				"equals",
				"equality",
				"heavy equals sign"
			],
			u: "1f7f0",
			a: "14"
		},
		{
			n: [
				"forever",
				"infinity",
				"unbounded",
				"universal"
			],
			u: "267e-fe0f",
			a: "11"
		},
		{
			n: [
				"!",
				"!!",
				"mark",
				"double",
				"bangbang",
				"exclamation",
				"punctuation",
				"double exclamation mark"
			],
			u: "203c-fe0f",
			a: "0.6"
		},
		{
			n: [
				"!",
				"?",
				"!?",
				"mark",
				"question",
				"exclamation",
				"interrobang",
				"punctuation",
				"exclamation question mark"
			],
			u: "2049-fe0f",
			a: "0.6"
		},
		{
			n: [
				"?",
				"red",
				"mark",
				"question",
				"punctuation",
				"red question mark"
			],
			u: "2753",
			a: "0.6"
		},
		{
			n: [
				"?",
				"mark",
				"white",
				"outlined",
				"question",
				"punctuation",
				"white question mark"
			],
			u: "2754",
			a: "0.6"
		},
		{
			n: [
				"!",
				"mark",
				"white",
				"outlined",
				"exclamation",
				"punctuation",
				"white exclamation mark"
			],
			u: "2755",
			a: "0.6"
		},
		{
			n: [
				"!",
				"red",
				"mark",
				"exclamation",
				"punctuation",
				"red exclamation mark"
			],
			u: "2757",
			a: "0.6"
		},
		{
			n: [
				"dash",
				"wavy",
				"wavy dash",
				"punctuation"
			],
			u: "3030-fe0f",
			a: "0.6"
		},
		{
			n: [
				"bank",
				"money",
				"currency",
				"exchange",
				"currency exchange"
			],
			u: "1f4b1",
			a: "0.6"
		},
		{
			n: [
				"pay",
				"cash",
				"sign",
				"heavy",
				"money",
				"charge",
				"dollar",
				"billion",
				"million",
				"currency",
				"heavy dollar sign"
			],
			u: "1f4b2",
			a: "0.6"
		},
		{
			n: [
				"staff",
				"symbol",
				"medical",
				"medicine",
				"aesculapius",
				"medical symbol"
			],
			u: "2695-fe0f",
			a: "4"
		},
		{
			n: [
				"symbol",
				"recycle",
				"recycling",
				"recycling symbol"
			],
			u: "267b-fe0f",
			a: "0.6"
		},
		{
			n: [
				"knights",
				"fleur de lis"
			],
			u: "269c-fe0f",
			a: "1"
		},
		{
			n: [
				"ship",
				"tool",
				"anchor",
				"emblem",
				"trident",
				"poseidon",
				"trident emblem"
			],
			u: "1f531",
			a: "0.6"
		},
		{
			n: [
				"name",
				"badge",
				"name badge"
			],
			u: "1f4db",
			a: "0.6"
		},
		{
			n: [
				"leaf",
				"tool",
				"green",
				"symbol",
				"yellow",
				"chevron",
				"beginner",
				"japanese",
				"Japanese symbol for beginner"
			],
			u: "1f530",
			a: "0.6"
		},
		{
			n: [
				"o",
				"red",
				"heavy",
				"large",
				"circle",
				"hollow",
				"hollow red circle"
			],
			u: "2b55",
			a: "0.6"
		},
		{
			n: [
				"✓",
				"done",
				"mark",
				"tick",
				"check",
				"fixed",
				"button",
				"checked",
				"complete",
				"checkmark",
				"completed",
				"check mark button"
			],
			u: "2705",
			a: "0.6"
		},
		{
			n: [
				"✓",
				"box",
				"off",
				"done",
				"tick",
				"check",
				"ballot",
				"checked",
				"check box with check"
			],
			u: "2611-fe0f",
			a: "0.6"
		},
		{
			n: [
				"✓",
				"done",
				"mark",
				"tick",
				"check",
				"heavy",
				"checked",
				"checkmark",
				"check mark"
			],
			u: "2714-fe0f",
			a: "0.6"
		},
		{
			n: [
				"x",
				"×",
				"mark",
				"cross",
				"cancel",
				"multiply",
				"cross mark",
				"multiplication"
			],
			u: "274c",
			a: "0.6"
		},
		{
			n: [
				"x",
				"×",
				"mark",
				"cross",
				"button",
				"square",
				"multiply",
				"multiplication",
				"cross mark button"
			],
			u: "274e",
			a: "0.6"
		},
		{
			n: [
				"curl",
				"loop",
				"curly",
				"curly loop"
			],
			u: "27b0",
			a: "0.6"
		},
		{
			n: [
				"curl",
				"loop",
				"curly",
				"double",
				"double curly loop"
			],
			u: "27bf",
			a: "1"
		},
		{
			n: [
				"mark",
				"part",
				"alternation",
				"part alternation mark"
			],
			u: "303d-fe0f",
			a: "0.6"
		},
		{
			n: [
				"*",
				"asterisk",
				"eight spoked",
				"eight spoked asterisk"
			],
			u: "2733-fe0f",
			a: "0.6"
		},
		{
			n: [
				"*",
				"star",
				"eight pointed",
				"eight pointed star"
			],
			u: "2734-fe0f",
			a: "0.6"
		},
		{
			n: [
				"*",
				"sparkle"
			],
			u: "2747-fe0f",
			a: "0.6"
		},
		{
			n: [
				"c",
				"copyright"
			],
			u: "00a9-fe0f",
			a: "0.6"
		},
		{
			n: [
				"r",
				"registered"
			],
			u: "00ae-fe0f",
			a: "0.6"
		},
		{
			n: [
				"tm",
				"mark",
				"trade",
				"trademark",
				"trade mark"
			],
			u: "2122-fe0f",
			a: "0.6"
		},
		{
			n: [
				"ink",
				"drip",
				"holi",
				"mess",
				"paint",
				"spill",
				"stain",
				"liquid",
				"splatter"
			],
			u: "1fadf",
			a: "16"
		},
		{
			n: [
				"keycap",
				"keycap: #"
			],
			u: "0023-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"keycap",
				"keycap: *"
			],
			u: "002a-fe0f-20e3",
			a: "2"
		},
		{
			n: [
				"0",
				"zero",
				"keycap",
				"keycap: 0"
			],
			u: "0030-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"1",
				"one",
				"keycap",
				"keycap: 1"
			],
			u: "0031-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"2",
				"two",
				"keycap",
				"keycap: 2"
			],
			u: "0032-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"3",
				"three",
				"keycap",
				"keycap: 3"
			],
			u: "0033-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"4",
				"four",
				"keycap",
				"keycap: 4"
			],
			u: "0034-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"5",
				"five",
				"keycap",
				"keycap: 5"
			],
			u: "0035-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"6",
				"six",
				"keycap",
				"keycap: 6"
			],
			u: "0036-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"7",
				"seven",
				"keycap",
				"keycap: 7"
			],
			u: "0037-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"8",
				"eight",
				"keycap",
				"keycap: 8"
			],
			u: "0038-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"9",
				"nine",
				"keycap",
				"keycap: 9"
			],
			u: "0039-fe0f-20e3",
			a: "0.6"
		},
		{
			n: [
				"keycap",
				"keycap: 10"
			],
			u: "1f51f",
			a: "0.6"
		},
		{
			n: [
				"abcd",
				"input",
				"latin",
				"letters",
				"uppercase",
				"input latin uppercase"
			],
			u: "1f520",
			a: "0.6"
		},
		{
			n: [
				"abcd",
				"input",
				"latin",
				"letters",
				"lowercase",
				"input latin lowercase"
			],
			u: "1f521",
			a: "0.6"
		},
		{
			n: [
				"1234",
				"input",
				"numbers",
				"input numbers"
			],
			u: "1f522",
			a: "0.6"
		},
		{
			n: [
				"%",
				"&",
				"♪",
				"〒",
				"input",
				"symbols",
				"input symbols"
			],
			u: "1f523",
			a: "0.6"
		},
		{
			n: [
				"abc",
				"input",
				"latin",
				"letters",
				"alphabet",
				"input latin letters"
			],
			u: "1f524",
			a: "0.6"
		},
		{
			n: [
				"type",
				"blood",
				"button",
				"A button (blood type)"
			],
			u: "1f170-fe0f",
			a: "0.6"
		},
		{
			n: [
				"ab",
				"type",
				"blood",
				"button",
				"AB button (blood type)"
			],
			u: "1f18e",
			a: "0.6"
		},
		{
			n: [
				"b",
				"type",
				"blood",
				"button",
				"B button (blood type)"
			],
			u: "1f171-fe0f",
			a: "0.6"
		},
		{
			n: [
				"cl",
				"button",
				"CL button"
			],
			u: "1f191",
			a: "0.6"
		},
		{
			n: [
				"cool",
				"button",
				"COOL button"
			],
			u: "1f192",
			a: "0.6"
		},
		{
			n: [
				"free",
				"button",
				"FREE button"
			],
			u: "1f193",
			a: "0.6"
		},
		{
			n: [
				"i",
				"information"
			],
			u: "2139-fe0f",
			a: "0.6"
		},
		{
			n: [
				"id",
				"button",
				"identity",
				"ID button"
			],
			u: "1f194",
			a: "0.6"
		},
		{
			n: [
				"m",
				"circle",
				"circled",
				"circled M"
			],
			u: "24c2-fe0f",
			a: "0.6"
		},
		{
			n: [
				"new",
				"button",
				"NEW button"
			],
			u: "1f195",
			a: "0.6"
		},
		{
			n: [
				"ng",
				"button",
				"NG button"
			],
			u: "1f196",
			a: "0.6"
		},
		{
			n: [
				"o",
				"type",
				"blood",
				"button",
				"O button (blood type)"
			],
			u: "1f17e-fe0f",
			a: "0.6"
		},
		{
			n: [
				"ok",
				"okay",
				"button",
				"OK button"
			],
			u: "1f197",
			a: "0.6"
		},
		{
			n: [
				"p",
				"button",
				"parking",
				"P button"
			],
			u: "1f17f-fe0f",
			a: "0.6"
		},
		{
			n: [
				"sos",
				"help",
				"button",
				"SOS button"
			],
			u: "1f198",
			a: "0.6"
		},
		{
			n: [
				"up",
				"up!",
				"mark",
				"button",
				"UP! button"
			],
			u: "1f199",
			a: "0.6"
		},
		{
			n: [
				"vs",
				"button",
				"versus",
				"VS button"
			],
			u: "1f19a",
			a: "0.6"
		},
		{
			n: [
				"here",
				"button",
				"japanese",
				"katakana",
				"Japanese “here” button"
			],
			u: "1f201",
			a: "0.6"
		},
		{
			n: [
				"button",
				"charge",
				"service",
				"japanese",
				"katakana",
				"Japanese “service charge” button"
			],
			u: "1f202-fe0f",
			a: "0.6"
		},
		{
			n: [
				"amount",
				"button",
				"monthly",
				"japanese",
				"ideograph",
				"Japanese “monthly amount” button"
			],
			u: "1f237-fe0f",
			a: "0.6"
		},
		{
			n: [
				"not",
				"free",
				"button",
				"charge",
				"japanese",
				"ideograph",
				"Japanese “not free of charge” button"
			],
			u: "1f236",
			a: "0.6"
		},
		{
			n: [
				"button",
				"japanese",
				"reserved",
				"ideograph",
				"Japanese “reserved” button"
			],
			u: "1f22f",
			a: "0.6"
		},
		{
			n: [
				"button",
				"bargain",
				"japanese",
				"ideograph",
				"Japanese “bargain” button"
			],
			u: "1f250",
			a: "0.6"
		},
		{
			n: [
				"button",
				"discount",
				"japanese",
				"ideograph",
				"Japanese “discount” button"
			],
			u: "1f239",
			a: "0.6"
		},
		{
			n: [
				"free",
				"button",
				"charge",
				"japanese",
				"ideograph",
				"Japanese “free of charge” button"
			],
			u: "1f21a",
			a: "0.6"
		},
		{
			n: [
				"button",
				"japanese",
				"ideograph",
				"prohibited",
				"Japanese “prohibited” button"
			],
			u: "1f232",
			a: "0.6"
		},
		{
			n: [
				"button",
				"japanese",
				"ideograph",
				"acceptable",
				"Japanese “acceptable” button"
			],
			u: "1f251",
			a: "0.6"
		},
		{
			n: [
				"button",
				"japanese",
				"ideograph",
				"application",
				"Japanese “application” button"
			],
			u: "1f238",
			a: "0.6"
		},
		{
			n: [
				"grade",
				"button",
				"passing",
				"japanese",
				"ideograph",
				"Japanese “passing grade” button"
			],
			u: "1f234",
			a: "0.6"
		},
		{
			n: [
				"button",
				"vacancy",
				"japanese",
				"ideograph",
				"Japanese “vacancy” button"
			],
			u: "1f233",
			a: "0.6"
		},
		{
			n: [
				"button",
				"japanese",
				"ideograph",
				"congratulations",
				"Japanese “congratulations” button"
			],
			u: "3297-fe0f",
			a: "0.6"
		},
		{
			n: [
				"button",
				"secret",
				"japanese",
				"ideograph",
				"Japanese “secret” button"
			],
			u: "3299-fe0f",
			a: "0.6"
		},
		{
			n: [
				"open",
				"button",
				"business",
				"japanese",
				"ideograph",
				"Japanese “open for business” button"
			],
			u: "1f23a",
			a: "0.6"
		},
		{
			n: [
				"no",
				"button",
				"vacancy",
				"japanese",
				"ideograph",
				"Japanese “no vacancy” button"
			],
			u: "1f235",
			a: "0.6"
		},
		{
			n: [
				"red",
				"circle",
				"geometric",
				"red circle"
			],
			u: "1f534",
			a: "0.6"
		},
		{
			n: [
				"circle",
				"orange",
				"orange circle"
			],
			u: "1f7e0",
			a: "12"
		},
		{
			n: [
				"circle",
				"yellow",
				"yellow circle"
			],
			u: "1f7e1",
			a: "12"
		},
		{
			n: [
				"green",
				"circle",
				"green circle"
			],
			u: "1f7e2",
			a: "12"
		},
		{
			n: [
				"blue",
				"circle",
				"geometric",
				"blue circle"
			],
			u: "1f535",
			a: "0.6"
		},
		{
			n: [
				"circle",
				"purple",
				"purple circle"
			],
			u: "1f7e3",
			a: "12"
		},
		{
			n: [
				"brown",
				"circle",
				"brown circle"
			],
			u: "1f7e4",
			a: "12"
		},
		{
			n: [
				"black",
				"circle",
				"geometric",
				"black circle"
			],
			u: "26ab",
			a: "0.6"
		},
		{
			n: [
				"white",
				"circle",
				"geometric",
				"white circle"
			],
			u: "26aa",
			a: "0.6"
		},
		{
			n: [
				"red",
				"card",
				"square",
				"penalty",
				"red square"
			],
			u: "1f7e5",
			a: "12"
		},
		{
			n: [
				"orange",
				"square",
				"orange square"
			],
			u: "1f7e7",
			a: "12"
		},
		{
			n: [
				"card",
				"square",
				"yellow",
				"penalty",
				"yellow square"
			],
			u: "1f7e8",
			a: "12"
		},
		{
			n: [
				"green",
				"square",
				"green square"
			],
			u: "1f7e9",
			a: "12"
		},
		{
			n: [
				"blue",
				"square",
				"blue square"
			],
			u: "1f7e6",
			a: "12"
		},
		{
			n: [
				"purple",
				"square",
				"purple square"
			],
			u: "1f7ea",
			a: "12"
		},
		{
			n: [
				"brown",
				"square",
				"brown square"
			],
			u: "1f7eb",
			a: "12"
		},
		{
			n: [
				"black",
				"large",
				"square",
				"geometric",
				"black large square"
			],
			u: "2b1b",
			a: "0.6"
		},
		{
			n: [
				"large",
				"white",
				"square",
				"geometric",
				"white large square"
			],
			u: "2b1c",
			a: "0.6"
		},
		{
			n: [
				"black",
				"medium",
				"square",
				"geometric",
				"black medium square"
			],
			u: "25fc-fe0f",
			a: "0.6"
		},
		{
			n: [
				"white",
				"medium",
				"square",
				"geometric",
				"white medium square"
			],
			u: "25fb-fe0f",
			a: "0.6"
		},
		{
			n: [
				"black",
				"square",
				"geometric",
				"medium small",
				"black medium small square"
			],
			u: "25fe",
			a: "0.6"
		},
		{
			n: [
				"white",
				"square",
				"geometric",
				"medium small",
				"white medium small square"
			],
			u: "25fd",
			a: "0.6"
		},
		{
			n: [
				"black",
				"small",
				"square",
				"geometric",
				"black small square"
			],
			u: "25aa-fe0f",
			a: "0.6"
		},
		{
			n: [
				"small",
				"white",
				"square",
				"geometric",
				"white small square"
			],
			u: "25ab-fe0f",
			a: "0.6"
		},
		{
			n: [
				"large",
				"orange",
				"diamond",
				"geometric",
				"large orange diamond"
			],
			u: "1f536",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"large",
				"diamond",
				"geometric",
				"large blue diamond"
			],
			u: "1f537",
			a: "0.6"
		},
		{
			n: [
				"small",
				"orange",
				"diamond",
				"geometric",
				"small orange diamond"
			],
			u: "1f538",
			a: "0.6"
		},
		{
			n: [
				"blue",
				"small",
				"diamond",
				"geometric",
				"small blue diamond"
			],
			u: "1f539",
			a: "0.6"
		},
		{
			n: [
				"up",
				"red",
				"pointed",
				"triangle",
				"geometric",
				"red triangle pointed up"
			],
			u: "1f53a",
			a: "0.6"
		},
		{
			n: [
				"red",
				"down",
				"pointed",
				"triangle",
				"geometric",
				"red triangle pointed down"
			],
			u: "1f53b",
			a: "0.6"
		},
		{
			n: [
				"dot",
				"comic",
				"diamond",
				"geometric",
				"diamond with a dot"
			],
			u: "1f4a0",
			a: "0.6"
		},
		{
			n: [
				"radio",
				"button",
				"geometric",
				"radio button"
			],
			u: "1f518",
			a: "0.6"
		},
		{
			n: [
				"white",
				"button",
				"square",
				"outlined",
				"geometric",
				"white square button"
			],
			u: "1f533",
			a: "0.6"
		},
		{
			n: [
				"black",
				"button",
				"square",
				"geometric",
				"black square button"
			],
			u: "1f532",
			a: "0.6"
		}
	],
	flags: [
		{
			n: [
				"win",
				"flag",
				"game",
				"race",
				"flags",
				"sport",
				"finish",
				"racing",
				"checkered",
				"chequered",
				"chequered flag"
			],
			u: "1f3c1",
			a: "0.6"
		},
		{
			n: [
				"flag",
				"golf",
				"post",
				"triangular",
				"construction",
				"triangular flag"
			],
			u: "1f6a9",
			a: "0.6"
		},
		{
			n: [
				"cross",
				"flags",
				"crossed",
				"japanese",
				"celebration",
				"crossed flags"
			],
			u: "1f38c",
			a: "0.6"
		},
		{
			n: [
				"flag",
				"black",
				"waving",
				"black flag"
			],
			u: "1f3f4",
			a: "1"
		},
		{
			n: [
				"flag",
				"white",
				"waving",
				"white flag"
			],
			u: "1f3f3-fe0f",
			a: "0.7"
		},
		{
			n: [
				"gay",
				"flag",
				"glbt",
				"lgbt",
				"glbtq",
				"lgbtq",
				"pride",
				"queer",
				"trans",
				"lesbian",
				"lgbtqia",
				"rainbow",
				"bisexual",
				"genderqueer",
				"transgender",
				"rainbow flag"
			],
			u: "1f3f3-fe0f-200d-1f308",
			a: "4"
		},
		{
			n: [
				"blue",
				"flag",
				"pink",
				"light",
				"white",
				"transgender",
				"transgender flag"
			],
			u: "1f3f3-fe0f-200d-26a7-fe0f",
			a: "13"
		},
		{
			n: [
				"flag",
				"jolly",
				"roger",
				"pirate",
				"plunder",
				"treasure",
				"pirate flag"
			],
			u: "1f3f4-200d-2620-fe0f",
			a: "11"
		},
		{
			n: [
				"AC",
				"flag",
				"flag: Ascension Island"
			],
			u: "1f1e6-1f1e8",
			a: "2"
		},
		{
			n: [
				"AD",
				"flag",
				"flag: Andorra"
			],
			u: "1f1e6-1f1e9",
			a: "2"
		},
		{
			n: [
				"AE",
				"flag",
				"flag: United Arab Emirates"
			],
			u: "1f1e6-1f1ea",
			a: "2"
		},
		{
			n: [
				"AF",
				"flag",
				"flag: Afghanistan"
			],
			u: "1f1e6-1f1eb",
			a: "2"
		},
		{
			n: [
				"AG",
				"flag",
				"flag: Antigua & Barbuda"
			],
			u: "1f1e6-1f1ec",
			a: "2"
		},
		{
			n: [
				"AI",
				"flag",
				"flag: Anguilla"
			],
			u: "1f1e6-1f1ee",
			a: "2"
		},
		{
			n: [
				"AL",
				"flag",
				"flag: Albania"
			],
			u: "1f1e6-1f1f1",
			a: "2"
		},
		{
			n: [
				"AM",
				"flag",
				"flag: Armenia"
			],
			u: "1f1e6-1f1f2",
			a: "2"
		},
		{
			n: [
				"AO",
				"flag",
				"flag: Angola"
			],
			u: "1f1e6-1f1f4",
			a: "2"
		},
		{
			n: [
				"AQ",
				"flag",
				"flag: Antarctica"
			],
			u: "1f1e6-1f1f6",
			a: "2"
		},
		{
			n: [
				"AR",
				"flag",
				"flag: Argentina"
			],
			u: "1f1e6-1f1f7",
			a: "2"
		},
		{
			n: [
				"AS",
				"flag",
				"flag: American Samoa"
			],
			u: "1f1e6-1f1f8",
			a: "2"
		},
		{
			n: [
				"AT",
				"flag",
				"flag: Austria"
			],
			u: "1f1e6-1f1f9",
			a: "2"
		},
		{
			n: [
				"AU",
				"flag",
				"flag: Australia"
			],
			u: "1f1e6-1f1fa",
			a: "2"
		},
		{
			n: [
				"AW",
				"flag",
				"flag: Aruba"
			],
			u: "1f1e6-1f1fc",
			a: "2"
		},
		{
			n: [
				"AX",
				"flag",
				"flag: Åland Islands"
			],
			u: "1f1e6-1f1fd",
			a: "2"
		},
		{
			n: [
				"AZ",
				"flag",
				"flag: Azerbaijan"
			],
			u: "1f1e6-1f1ff",
			a: "2"
		},
		{
			n: [
				"BA",
				"flag",
				"flag: Bosnia & Herzegovina"
			],
			u: "1f1e7-1f1e6",
			a: "2"
		},
		{
			n: [
				"BB",
				"flag",
				"flag: Barbados"
			],
			u: "1f1e7-1f1e7",
			a: "2"
		},
		{
			n: [
				"BD",
				"flag",
				"flag: Bangladesh"
			],
			u: "1f1e7-1f1e9",
			a: "2"
		},
		{
			n: [
				"BE",
				"flag",
				"flag: Belgium"
			],
			u: "1f1e7-1f1ea",
			a: "2"
		},
		{
			n: [
				"BF",
				"flag",
				"flag: Burkina Faso"
			],
			u: "1f1e7-1f1eb",
			a: "2"
		},
		{
			n: [
				"BG",
				"flag",
				"flag: Bulgaria"
			],
			u: "1f1e7-1f1ec",
			a: "2"
		},
		{
			n: [
				"BH",
				"flag",
				"flag: Bahrain"
			],
			u: "1f1e7-1f1ed",
			a: "2"
		},
		{
			n: [
				"BI",
				"flag",
				"flag: Burundi"
			],
			u: "1f1e7-1f1ee",
			a: "2"
		},
		{
			n: [
				"BJ",
				"flag",
				"flag: Benin"
			],
			u: "1f1e7-1f1ef",
			a: "2"
		},
		{
			n: [
				"BL",
				"flag",
				"flag: St. Barthélemy"
			],
			u: "1f1e7-1f1f1",
			a: "2"
		},
		{
			n: [
				"BM",
				"flag",
				"flag: Bermuda"
			],
			u: "1f1e7-1f1f2",
			a: "2"
		},
		{
			n: [
				"BN",
				"flag",
				"flag: Brunei"
			],
			u: "1f1e7-1f1f3",
			a: "2"
		},
		{
			n: [
				"BO",
				"flag",
				"flag: Bolivia"
			],
			u: "1f1e7-1f1f4",
			a: "2"
		},
		{
			n: [
				"BQ",
				"flag",
				"flag: Caribbean Netherlands"
			],
			u: "1f1e7-1f1f6",
			a: "2"
		},
		{
			n: [
				"BR",
				"flag",
				"flag: Brazil"
			],
			u: "1f1e7-1f1f7",
			a: "2"
		},
		{
			n: [
				"BS",
				"flag",
				"flag: Bahamas"
			],
			u: "1f1e7-1f1f8",
			a: "2"
		},
		{
			n: [
				"BT",
				"flag",
				"flag: Bhutan"
			],
			u: "1f1e7-1f1f9",
			a: "2"
		},
		{
			n: [
				"BV",
				"flag",
				"flag: Bouvet Island"
			],
			u: "1f1e7-1f1fb",
			a: "2"
		},
		{
			n: [
				"BW",
				"flag",
				"flag: Botswana"
			],
			u: "1f1e7-1f1fc",
			a: "2"
		},
		{
			n: [
				"BY",
				"flag",
				"flag: Belarus"
			],
			u: "1f1e7-1f1fe",
			a: "2"
		},
		{
			n: [
				"BZ",
				"flag",
				"flag: Belize"
			],
			u: "1f1e7-1f1ff",
			a: "2"
		},
		{
			n: [
				"CA",
				"flag",
				"flag: Canada"
			],
			u: "1f1e8-1f1e6",
			a: "2"
		},
		{
			n: [
				"CC",
				"flag",
				"flag: Cocos (Keeling) Islands"
			],
			u: "1f1e8-1f1e8",
			a: "2"
		},
		{
			n: [
				"CD",
				"flag",
				"flag: Congo   Kinshasa"
			],
			u: "1f1e8-1f1e9",
			a: "2"
		},
		{
			n: [
				"CF",
				"flag",
				"flag: Central African Republic"
			],
			u: "1f1e8-1f1eb",
			a: "2"
		},
		{
			n: [
				"CG",
				"flag",
				"flag: Congo   Brazzaville"
			],
			u: "1f1e8-1f1ec",
			a: "2"
		},
		{
			n: [
				"CH",
				"flag",
				"flag: Switzerland"
			],
			u: "1f1e8-1f1ed",
			a: "2"
		},
		{
			n: [
				"CI",
				"flag",
				"flag: Côte d’Ivoire"
			],
			u: "1f1e8-1f1ee",
			a: "2"
		},
		{
			n: [
				"CK",
				"flag",
				"flag: Cook Islands"
			],
			u: "1f1e8-1f1f0",
			a: "2"
		},
		{
			n: [
				"CL",
				"flag",
				"flag: Chile"
			],
			u: "1f1e8-1f1f1",
			a: "2"
		},
		{
			n: [
				"CM",
				"flag",
				"flag: Cameroon"
			],
			u: "1f1e8-1f1f2",
			a: "2"
		},
		{
			n: [
				"CN",
				"flag",
				"flag: China"
			],
			u: "1f1e8-1f1f3",
			a: "0.6"
		},
		{
			n: [
				"CO",
				"flag",
				"flag: Colombia"
			],
			u: "1f1e8-1f1f4",
			a: "2"
		},
		{
			n: [
				"CP",
				"flag",
				"flag: Clipperton Island"
			],
			u: "1f1e8-1f1f5",
			a: "2"
		},
		{
			n: [
				"CQ",
				"flag",
				"flag: Sark"
			],
			u: "1f1e8-1f1f6",
			a: "16"
		},
		{
			n: [
				"CR",
				"flag",
				"flag: Costa Rica"
			],
			u: "1f1e8-1f1f7",
			a: "2"
		},
		{
			n: [
				"CU",
				"flag",
				"flag: Cuba"
			],
			u: "1f1e8-1f1fa",
			a: "2"
		},
		{
			n: [
				"CV",
				"flag",
				"flag: Cape Verde"
			],
			u: "1f1e8-1f1fb",
			a: "2"
		},
		{
			n: [
				"CW",
				"flag",
				"flag: Curaçao"
			],
			u: "1f1e8-1f1fc",
			a: "2"
		},
		{
			n: [
				"CX",
				"flag",
				"flag: Christmas Island"
			],
			u: "1f1e8-1f1fd",
			a: "2"
		},
		{
			n: [
				"CY",
				"flag",
				"flag: Cyprus"
			],
			u: "1f1e8-1f1fe",
			a: "2"
		},
		{
			n: [
				"CZ",
				"flag",
				"flag: Czechia"
			],
			u: "1f1e8-1f1ff",
			a: "2"
		},
		{
			n: [
				"DE",
				"flag",
				"flag: Germany"
			],
			u: "1f1e9-1f1ea",
			a: "0.6"
		},
		{
			n: [
				"DG",
				"flag",
				"flag: Diego Garcia"
			],
			u: "1f1e9-1f1ec",
			a: "2"
		},
		{
			n: [
				"DJ",
				"flag",
				"flag: Djibouti"
			],
			u: "1f1e9-1f1ef",
			a: "2"
		},
		{
			n: [
				"DK",
				"flag",
				"flag: Denmark"
			],
			u: "1f1e9-1f1f0",
			a: "2"
		},
		{
			n: [
				"DM",
				"flag",
				"flag: Dominica"
			],
			u: "1f1e9-1f1f2",
			a: "2"
		},
		{
			n: [
				"DO",
				"flag",
				"flag: Dominican Republic"
			],
			u: "1f1e9-1f1f4",
			a: "2"
		},
		{
			n: [
				"DZ",
				"flag",
				"flag: Algeria"
			],
			u: "1f1e9-1f1ff",
			a: "2"
		},
		{
			n: [
				"EA",
				"flag",
				"flag: Ceuta & Melilla"
			],
			u: "1f1ea-1f1e6",
			a: "2"
		},
		{
			n: [
				"EC",
				"flag",
				"flag: Ecuador"
			],
			u: "1f1ea-1f1e8",
			a: "2"
		},
		{
			n: [
				"EE",
				"flag",
				"flag: Estonia"
			],
			u: "1f1ea-1f1ea",
			a: "2"
		},
		{
			n: [
				"EG",
				"flag",
				"flag: Egypt"
			],
			u: "1f1ea-1f1ec",
			a: "2"
		},
		{
			n: [
				"EH",
				"flag",
				"flag: Western Sahara"
			],
			u: "1f1ea-1f1ed",
			a: "2"
		},
		{
			n: [
				"ER",
				"flag",
				"flag: Eritrea"
			],
			u: "1f1ea-1f1f7",
			a: "2"
		},
		{
			n: [
				"ES",
				"flag",
				"flag: Spain"
			],
			u: "1f1ea-1f1f8",
			a: "0.6"
		},
		{
			n: [
				"ET",
				"flag",
				"flag: Ethiopia"
			],
			u: "1f1ea-1f1f9",
			a: "2"
		},
		{
			n: [
				"EU",
				"flag",
				"flag: European Union"
			],
			u: "1f1ea-1f1fa",
			a: "2"
		},
		{
			n: [
				"FI",
				"flag",
				"flag: Finland"
			],
			u: "1f1eb-1f1ee",
			a: "2"
		},
		{
			n: [
				"FJ",
				"flag",
				"flag: Fiji"
			],
			u: "1f1eb-1f1ef",
			a: "2"
		},
		{
			n: [
				"FK",
				"flag",
				"flag: Falkland Islands"
			],
			u: "1f1eb-1f1f0",
			a: "2"
		},
		{
			n: [
				"FM",
				"flag",
				"flag: Micronesia"
			],
			u: "1f1eb-1f1f2",
			a: "2"
		},
		{
			n: [
				"FO",
				"flag",
				"flag: Faroe Islands"
			],
			u: "1f1eb-1f1f4",
			a: "2"
		},
		{
			n: [
				"FR",
				"flag",
				"flag: France"
			],
			u: "1f1eb-1f1f7",
			a: "0.6"
		},
		{
			n: [
				"GA",
				"flag",
				"flag: Gabon"
			],
			u: "1f1ec-1f1e6",
			a: "2"
		},
		{
			n: [
				"GB",
				"flag",
				"flag: United Kingdom"
			],
			u: "1f1ec-1f1e7",
			a: "0.6"
		},
		{
			n: [
				"GD",
				"flag",
				"flag: Grenada"
			],
			u: "1f1ec-1f1e9",
			a: "2"
		},
		{
			n: [
				"GE",
				"flag",
				"flag: Georgia"
			],
			u: "1f1ec-1f1ea",
			a: "2"
		},
		{
			n: [
				"GF",
				"flag",
				"flag: French Guiana"
			],
			u: "1f1ec-1f1eb",
			a: "2"
		},
		{
			n: [
				"GG",
				"flag",
				"flag: Guernsey"
			],
			u: "1f1ec-1f1ec",
			a: "2"
		},
		{
			n: [
				"GH",
				"flag",
				"flag: Ghana"
			],
			u: "1f1ec-1f1ed",
			a: "2"
		},
		{
			n: [
				"GI",
				"flag",
				"flag: Gibraltar"
			],
			u: "1f1ec-1f1ee",
			a: "2"
		},
		{
			n: [
				"GL",
				"flag",
				"flag: Greenland"
			],
			u: "1f1ec-1f1f1",
			a: "2"
		},
		{
			n: [
				"GM",
				"flag",
				"flag: Gambia"
			],
			u: "1f1ec-1f1f2",
			a: "2"
		},
		{
			n: [
				"GN",
				"flag",
				"flag: Guinea"
			],
			u: "1f1ec-1f1f3",
			a: "2"
		},
		{
			n: [
				"GP",
				"flag",
				"flag: Guadeloupe"
			],
			u: "1f1ec-1f1f5",
			a: "2"
		},
		{
			n: [
				"GQ",
				"flag",
				"flag: Equatorial Guinea"
			],
			u: "1f1ec-1f1f6",
			a: "2"
		},
		{
			n: [
				"GR",
				"flag",
				"flag: Greece"
			],
			u: "1f1ec-1f1f7",
			a: "2"
		},
		{
			n: [
				"GS",
				"flag",
				"flag: South Georgia & South Sandwich Islands"
			],
			u: "1f1ec-1f1f8",
			a: "2"
		},
		{
			n: [
				"GT",
				"flag",
				"flag: Guatemala"
			],
			u: "1f1ec-1f1f9",
			a: "2"
		},
		{
			n: [
				"GU",
				"flag",
				"flag: Guam"
			],
			u: "1f1ec-1f1fa",
			a: "2"
		},
		{
			n: [
				"GW",
				"flag",
				"flag: Guinea Bissau"
			],
			u: "1f1ec-1f1fc",
			a: "2"
		},
		{
			n: [
				"GY",
				"flag",
				"flag: Guyana"
			],
			u: "1f1ec-1f1fe",
			a: "2"
		},
		{
			n: [
				"HK",
				"flag",
				"flag: Hong Kong SAR China"
			],
			u: "1f1ed-1f1f0",
			a: "2"
		},
		{
			n: [
				"HM",
				"flag",
				"flag: Heard & McDonald Islands"
			],
			u: "1f1ed-1f1f2",
			a: "2"
		},
		{
			n: [
				"HN",
				"flag",
				"flag: Honduras"
			],
			u: "1f1ed-1f1f3",
			a: "2"
		},
		{
			n: [
				"HR",
				"flag",
				"flag: Croatia"
			],
			u: "1f1ed-1f1f7",
			a: "2"
		},
		{
			n: [
				"HT",
				"flag",
				"flag: Haiti"
			],
			u: "1f1ed-1f1f9",
			a: "2"
		},
		{
			n: [
				"HU",
				"flag",
				"flag: Hungary"
			],
			u: "1f1ed-1f1fa",
			a: "2"
		},
		{
			n: [
				"IC",
				"flag",
				"flag: Canary Islands"
			],
			u: "1f1ee-1f1e8",
			a: "2"
		},
		{
			n: [
				"ID",
				"flag",
				"flag: Indonesia"
			],
			u: "1f1ee-1f1e9",
			a: "2"
		},
		{
			n: [
				"IE",
				"flag",
				"flag: Ireland"
			],
			u: "1f1ee-1f1ea",
			a: "2"
		},
		{
			n: [
				"IL",
				"flag",
				"flag: Israel"
			],
			u: "1f1ee-1f1f1",
			a: "2"
		},
		{
			n: [
				"IM",
				"flag",
				"flag: Isle of Man"
			],
			u: "1f1ee-1f1f2",
			a: "2"
		},
		{
			n: [
				"IN",
				"flag",
				"flag: India"
			],
			u: "1f1ee-1f1f3",
			a: "2"
		},
		{
			n: [
				"IO",
				"flag",
				"flag: British Indian Ocean Territory"
			],
			u: "1f1ee-1f1f4",
			a: "2"
		},
		{
			n: [
				"IQ",
				"flag",
				"flag: Iraq"
			],
			u: "1f1ee-1f1f6",
			a: "2"
		},
		{
			n: [
				"IR",
				"flag",
				"flag: Iran"
			],
			u: "1f1ee-1f1f7",
			a: "2"
		},
		{
			n: [
				"IS",
				"flag",
				"flag: Iceland"
			],
			u: "1f1ee-1f1f8",
			a: "2"
		},
		{
			n: [
				"IT",
				"flag",
				"flag: Italy"
			],
			u: "1f1ee-1f1f9",
			a: "0.6"
		},
		{
			n: [
				"JE",
				"flag",
				"flag: Jersey"
			],
			u: "1f1ef-1f1ea",
			a: "2"
		},
		{
			n: [
				"JM",
				"flag",
				"flag: Jamaica"
			],
			u: "1f1ef-1f1f2",
			a: "2"
		},
		{
			n: [
				"JO",
				"flag",
				"flag: Jordan"
			],
			u: "1f1ef-1f1f4",
			a: "2"
		},
		{
			n: [
				"JP",
				"flag",
				"flag: Japan"
			],
			u: "1f1ef-1f1f5",
			a: "0.6"
		},
		{
			n: [
				"KE",
				"flag",
				"flag: Kenya"
			],
			u: "1f1f0-1f1ea",
			a: "2"
		},
		{
			n: [
				"KG",
				"flag",
				"flag: Kyrgyzstan"
			],
			u: "1f1f0-1f1ec",
			a: "2"
		},
		{
			n: [
				"KH",
				"flag",
				"flag: Cambodia"
			],
			u: "1f1f0-1f1ed",
			a: "2"
		},
		{
			n: [
				"KI",
				"flag",
				"flag: Kiribati"
			],
			u: "1f1f0-1f1ee",
			a: "2"
		},
		{
			n: [
				"KM",
				"flag",
				"flag: Comoros"
			],
			u: "1f1f0-1f1f2",
			a: "2"
		},
		{
			n: [
				"KN",
				"flag",
				"flag: St. Kitts & Nevis"
			],
			u: "1f1f0-1f1f3",
			a: "2"
		},
		{
			n: [
				"KP",
				"flag",
				"flag: North Korea"
			],
			u: "1f1f0-1f1f5",
			a: "2"
		},
		{
			n: [
				"KR",
				"flag",
				"flag: South Korea"
			],
			u: "1f1f0-1f1f7",
			a: "0.6"
		},
		{
			n: [
				"KW",
				"flag",
				"flag: Kuwait"
			],
			u: "1f1f0-1f1fc",
			a: "2"
		},
		{
			n: [
				"KY",
				"flag",
				"flag: Cayman Islands"
			],
			u: "1f1f0-1f1fe",
			a: "2"
		},
		{
			n: [
				"KZ",
				"flag",
				"flag: Kazakhstan"
			],
			u: "1f1f0-1f1ff",
			a: "2"
		},
		{
			n: [
				"LA",
				"flag",
				"flag: Laos"
			],
			u: "1f1f1-1f1e6",
			a: "2"
		},
		{
			n: [
				"LB",
				"flag",
				"flag: Lebanon"
			],
			u: "1f1f1-1f1e7",
			a: "2"
		},
		{
			n: [
				"LC",
				"flag",
				"flag: St. Lucia"
			],
			u: "1f1f1-1f1e8",
			a: "2"
		},
		{
			n: [
				"LI",
				"flag",
				"flag: Liechtenstein"
			],
			u: "1f1f1-1f1ee",
			a: "2"
		},
		{
			n: [
				"LK",
				"flag",
				"flag: Sri Lanka"
			],
			u: "1f1f1-1f1f0",
			a: "2"
		},
		{
			n: [
				"LR",
				"flag",
				"flag: Liberia"
			],
			u: "1f1f1-1f1f7",
			a: "2"
		},
		{
			n: [
				"LS",
				"flag",
				"flag: Lesotho"
			],
			u: "1f1f1-1f1f8",
			a: "2"
		},
		{
			n: [
				"LT",
				"flag",
				"flag: Lithuania"
			],
			u: "1f1f1-1f1f9",
			a: "2"
		},
		{
			n: [
				"LU",
				"flag",
				"flag: Luxembourg"
			],
			u: "1f1f1-1f1fa",
			a: "2"
		},
		{
			n: [
				"LV",
				"flag",
				"flag: Latvia"
			],
			u: "1f1f1-1f1fb",
			a: "2"
		},
		{
			n: [
				"LY",
				"flag",
				"flag: Libya"
			],
			u: "1f1f1-1f1fe",
			a: "2"
		},
		{
			n: [
				"MA",
				"flag",
				"flag: Morocco"
			],
			u: "1f1f2-1f1e6",
			a: "2"
		},
		{
			n: [
				"MC",
				"flag",
				"flag: Monaco"
			],
			u: "1f1f2-1f1e8",
			a: "2"
		},
		{
			n: [
				"MD",
				"flag",
				"flag: Moldova"
			],
			u: "1f1f2-1f1e9",
			a: "2"
		},
		{
			n: [
				"ME",
				"flag",
				"flag: Montenegro"
			],
			u: "1f1f2-1f1ea",
			a: "2"
		},
		{
			n: [
				"MF",
				"flag",
				"flag: St. Martin"
			],
			u: "1f1f2-1f1eb",
			a: "2"
		},
		{
			n: [
				"MG",
				"flag",
				"flag: Madagascar"
			],
			u: "1f1f2-1f1ec",
			a: "2"
		},
		{
			n: [
				"MH",
				"flag",
				"flag: Marshall Islands"
			],
			u: "1f1f2-1f1ed",
			a: "2"
		},
		{
			n: [
				"MK",
				"flag",
				"flag: North Macedonia"
			],
			u: "1f1f2-1f1f0",
			a: "2"
		},
		{
			n: [
				"ML",
				"flag",
				"flag: Mali"
			],
			u: "1f1f2-1f1f1",
			a: "2"
		},
		{
			n: [
				"MM",
				"flag",
				"flag: Myanmar (Burma)"
			],
			u: "1f1f2-1f1f2",
			a: "2"
		},
		{
			n: [
				"MN",
				"flag",
				"flag: Mongolia"
			],
			u: "1f1f2-1f1f3",
			a: "2"
		},
		{
			n: [
				"MO",
				"flag",
				"flag: Macao SAR China"
			],
			u: "1f1f2-1f1f4",
			a: "2"
		},
		{
			n: [
				"MP",
				"flag",
				"flag: Northern Mariana Islands"
			],
			u: "1f1f2-1f1f5",
			a: "2"
		},
		{
			n: [
				"MQ",
				"flag",
				"flag: Martinique"
			],
			u: "1f1f2-1f1f6",
			a: "2"
		},
		{
			n: [
				"MR",
				"flag",
				"flag: Mauritania"
			],
			u: "1f1f2-1f1f7",
			a: "2"
		},
		{
			n: [
				"MS",
				"flag",
				"flag: Montserrat"
			],
			u: "1f1f2-1f1f8",
			a: "2"
		},
		{
			n: [
				"MT",
				"flag",
				"flag: Malta"
			],
			u: "1f1f2-1f1f9",
			a: "2"
		},
		{
			n: [
				"MU",
				"flag",
				"flag: Mauritius"
			],
			u: "1f1f2-1f1fa",
			a: "2"
		},
		{
			n: [
				"MV",
				"flag",
				"flag: Maldives"
			],
			u: "1f1f2-1f1fb",
			a: "2"
		},
		{
			n: [
				"MW",
				"flag",
				"flag: Malawi"
			],
			u: "1f1f2-1f1fc",
			a: "2"
		},
		{
			n: [
				"MX",
				"flag",
				"flag: Mexico"
			],
			u: "1f1f2-1f1fd",
			a: "2"
		},
		{
			n: [
				"MY",
				"flag",
				"flag: Malaysia"
			],
			u: "1f1f2-1f1fe",
			a: "2"
		},
		{
			n: [
				"MZ",
				"flag",
				"flag: Mozambique"
			],
			u: "1f1f2-1f1ff",
			a: "2"
		},
		{
			n: [
				"NA",
				"flag",
				"flag: Namibia"
			],
			u: "1f1f3-1f1e6",
			a: "2"
		},
		{
			n: [
				"NC",
				"flag",
				"flag: New Caledonia"
			],
			u: "1f1f3-1f1e8",
			a: "2"
		},
		{
			n: [
				"NE",
				"flag",
				"flag: Niger"
			],
			u: "1f1f3-1f1ea",
			a: "2"
		},
		{
			n: [
				"NF",
				"flag",
				"flag: Norfolk Island"
			],
			u: "1f1f3-1f1eb",
			a: "2"
		},
		{
			n: [
				"NG",
				"flag",
				"flag: Nigeria"
			],
			u: "1f1f3-1f1ec",
			a: "2"
		},
		{
			n: [
				"NI",
				"flag",
				"flag: Nicaragua"
			],
			u: "1f1f3-1f1ee",
			a: "2"
		},
		{
			n: [
				"NL",
				"flag",
				"flag: Netherlands"
			],
			u: "1f1f3-1f1f1",
			a: "2"
		},
		{
			n: [
				"NO",
				"flag",
				"flag: Norway"
			],
			u: "1f1f3-1f1f4",
			a: "2"
		},
		{
			n: [
				"NP",
				"flag",
				"flag: Nepal"
			],
			u: "1f1f3-1f1f5",
			a: "2"
		},
		{
			n: [
				"NR",
				"flag",
				"flag: Nauru"
			],
			u: "1f1f3-1f1f7",
			a: "2"
		},
		{
			n: [
				"NU",
				"flag",
				"flag: Niue"
			],
			u: "1f1f3-1f1fa",
			a: "2"
		},
		{
			n: [
				"NZ",
				"flag",
				"flag: New Zealand"
			],
			u: "1f1f3-1f1ff",
			a: "2"
		},
		{
			n: [
				"OM",
				"flag",
				"flag: Oman"
			],
			u: "1f1f4-1f1f2",
			a: "2"
		},
		{
			n: [
				"PA",
				"flag",
				"flag: Panama"
			],
			u: "1f1f5-1f1e6",
			a: "2"
		},
		{
			n: [
				"PE",
				"flag",
				"flag: Peru"
			],
			u: "1f1f5-1f1ea",
			a: "2"
		},
		{
			n: [
				"PF",
				"flag",
				"flag: French Polynesia"
			],
			u: "1f1f5-1f1eb",
			a: "2"
		},
		{
			n: [
				"PG",
				"flag",
				"flag: Papua New Guinea"
			],
			u: "1f1f5-1f1ec",
			a: "2"
		},
		{
			n: [
				"PH",
				"flag",
				"flag: Philippines"
			],
			u: "1f1f5-1f1ed",
			a: "2"
		},
		{
			n: [
				"PK",
				"flag",
				"flag: Pakistan"
			],
			u: "1f1f5-1f1f0",
			a: "2"
		},
		{
			n: [
				"PL",
				"flag",
				"flag: Poland"
			],
			u: "1f1f5-1f1f1",
			a: "2"
		},
		{
			n: [
				"PM",
				"flag",
				"flag: St. Pierre & Miquelon"
			],
			u: "1f1f5-1f1f2",
			a: "2"
		},
		{
			n: [
				"PN",
				"flag",
				"flag: Pitcairn Islands"
			],
			u: "1f1f5-1f1f3",
			a: "2"
		},
		{
			n: [
				"PR",
				"flag",
				"flag: Puerto Rico"
			],
			u: "1f1f5-1f1f7",
			a: "2"
		},
		{
			n: [
				"PS",
				"flag",
				"flag: Palestinian Territories"
			],
			u: "1f1f5-1f1f8",
			a: "2"
		},
		{
			n: [
				"PT",
				"flag",
				"flag: Portugal"
			],
			u: "1f1f5-1f1f9",
			a: "2"
		},
		{
			n: [
				"PW",
				"flag",
				"flag: Palau"
			],
			u: "1f1f5-1f1fc",
			a: "2"
		},
		{
			n: [
				"PY",
				"flag",
				"flag: Paraguay"
			],
			u: "1f1f5-1f1fe",
			a: "2"
		},
		{
			n: [
				"QA",
				"flag",
				"flag: Qatar"
			],
			u: "1f1f6-1f1e6",
			a: "2"
		},
		{
			n: [
				"RE",
				"flag",
				"flag: Réunion"
			],
			u: "1f1f7-1f1ea",
			a: "2"
		},
		{
			n: [
				"RO",
				"flag",
				"flag: Romania"
			],
			u: "1f1f7-1f1f4",
			a: "2"
		},
		{
			n: [
				"RS",
				"flag",
				"flag: Serbia"
			],
			u: "1f1f7-1f1f8",
			a: "2"
		},
		{
			n: [
				"RU",
				"flag",
				"flag: Russia"
			],
			u: "1f1f7-1f1fa",
			a: "0.6"
		},
		{
			n: [
				"RW",
				"flag",
				"flag: Rwanda"
			],
			u: "1f1f7-1f1fc",
			a: "2"
		},
		{
			n: [
				"SA",
				"flag",
				"flag: Saudi Arabia"
			],
			u: "1f1f8-1f1e6",
			a: "2"
		},
		{
			n: [
				"SB",
				"flag",
				"flag: Solomon Islands"
			],
			u: "1f1f8-1f1e7",
			a: "2"
		},
		{
			n: [
				"SC",
				"flag",
				"flag: Seychelles"
			],
			u: "1f1f8-1f1e8",
			a: "2"
		},
		{
			n: [
				"SD",
				"flag",
				"flag: Sudan"
			],
			u: "1f1f8-1f1e9",
			a: "2"
		},
		{
			n: [
				"SE",
				"flag",
				"flag: Sweden"
			],
			u: "1f1f8-1f1ea",
			a: "2"
		},
		{
			n: [
				"SG",
				"flag",
				"flag: Singapore"
			],
			u: "1f1f8-1f1ec",
			a: "2"
		},
		{
			n: [
				"SH",
				"flag",
				"flag: St. Helena"
			],
			u: "1f1f8-1f1ed",
			a: "2"
		},
		{
			n: [
				"SI",
				"flag",
				"flag: Slovenia"
			],
			u: "1f1f8-1f1ee",
			a: "2"
		},
		{
			n: [
				"SJ",
				"flag",
				"flag: Svalbard & Jan Mayen"
			],
			u: "1f1f8-1f1ef",
			a: "2"
		},
		{
			n: [
				"SK",
				"flag",
				"flag: Slovakia"
			],
			u: "1f1f8-1f1f0",
			a: "2"
		},
		{
			n: [
				"SL",
				"flag",
				"flag: Sierra Leone"
			],
			u: "1f1f8-1f1f1",
			a: "2"
		},
		{
			n: [
				"SM",
				"flag",
				"flag: San Marino"
			],
			u: "1f1f8-1f1f2",
			a: "2"
		},
		{
			n: [
				"SN",
				"flag",
				"flag: Senegal"
			],
			u: "1f1f8-1f1f3",
			a: "2"
		},
		{
			n: [
				"SO",
				"flag",
				"flag: Somalia"
			],
			u: "1f1f8-1f1f4",
			a: "2"
		},
		{
			n: [
				"SR",
				"flag",
				"flag: Suriname"
			],
			u: "1f1f8-1f1f7",
			a: "2"
		},
		{
			n: [
				"SS",
				"flag",
				"flag: South Sudan"
			],
			u: "1f1f8-1f1f8",
			a: "2"
		},
		{
			n: [
				"ST",
				"flag",
				"flag: São Tomé & Príncipe"
			],
			u: "1f1f8-1f1f9",
			a: "2"
		},
		{
			n: [
				"SV",
				"flag",
				"flag: El Salvador"
			],
			u: "1f1f8-1f1fb",
			a: "2"
		},
		{
			n: [
				"SX",
				"flag",
				"flag: Sint Maarten"
			],
			u: "1f1f8-1f1fd",
			a: "2"
		},
		{
			n: [
				"SY",
				"flag",
				"flag: Syria"
			],
			u: "1f1f8-1f1fe",
			a: "2"
		},
		{
			n: [
				"SZ",
				"flag",
				"flag: Eswatini"
			],
			u: "1f1f8-1f1ff",
			a: "2"
		},
		{
			n: [
				"TA",
				"flag",
				"flag: Tristan da Cunha"
			],
			u: "1f1f9-1f1e6",
			a: "2"
		},
		{
			n: [
				"TC",
				"flag",
				"flag: Turks & Caicos Islands"
			],
			u: "1f1f9-1f1e8",
			a: "2"
		},
		{
			n: [
				"TD",
				"flag",
				"flag: Chad"
			],
			u: "1f1f9-1f1e9",
			a: "2"
		},
		{
			n: [
				"TF",
				"flag",
				"flag: French Southern Territories"
			],
			u: "1f1f9-1f1eb",
			a: "2"
		},
		{
			n: [
				"TG",
				"flag",
				"flag: Togo"
			],
			u: "1f1f9-1f1ec",
			a: "2"
		},
		{
			n: [
				"TH",
				"flag",
				"flag: Thailand"
			],
			u: "1f1f9-1f1ed",
			a: "2"
		},
		{
			n: [
				"TJ",
				"flag",
				"flag: Tajikistan"
			],
			u: "1f1f9-1f1ef",
			a: "2"
		},
		{
			n: [
				"TK",
				"flag",
				"flag: Tokelau"
			],
			u: "1f1f9-1f1f0",
			a: "2"
		},
		{
			n: [
				"TL",
				"flag",
				"flag: Timor Leste"
			],
			u: "1f1f9-1f1f1",
			a: "2"
		},
		{
			n: [
				"TM",
				"flag",
				"flag: Turkmenistan"
			],
			u: "1f1f9-1f1f2",
			a: "2"
		},
		{
			n: [
				"TN",
				"flag",
				"flag: Tunisia"
			],
			u: "1f1f9-1f1f3",
			a: "2"
		},
		{
			n: [
				"TO",
				"flag",
				"flag: Tonga"
			],
			u: "1f1f9-1f1f4",
			a: "2"
		},
		{
			n: [
				"TR",
				"flag",
				"flag: Türkiye"
			],
			u: "1f1f9-1f1f7",
			a: "2"
		},
		{
			n: [
				"TT",
				"flag",
				"flag: Trinidad & Tobago"
			],
			u: "1f1f9-1f1f9",
			a: "2"
		},
		{
			n: [
				"TV",
				"flag",
				"flag: Tuvalu"
			],
			u: "1f1f9-1f1fb",
			a: "2"
		},
		{
			n: [
				"TW",
				"flag",
				"flag: Taiwan"
			],
			u: "1f1f9-1f1fc",
			a: "2"
		},
		{
			n: [
				"TZ",
				"flag",
				"flag: Tanzania"
			],
			u: "1f1f9-1f1ff",
			a: "2"
		},
		{
			n: [
				"UA",
				"flag",
				"flag: Ukraine"
			],
			u: "1f1fa-1f1e6",
			a: "2"
		},
		{
			n: [
				"UG",
				"flag",
				"flag: Uganda"
			],
			u: "1f1fa-1f1ec",
			a: "2"
		},
		{
			n: [
				"UM",
				"flag",
				"flag: U.S. Outlying Islands"
			],
			u: "1f1fa-1f1f2",
			a: "2"
		},
		{
			n: [
				"UN",
				"flag",
				"flag: United Nations"
			],
			u: "1f1fa-1f1f3",
			a: "4"
		},
		{
			n: [
				"US",
				"flag",
				"flag: United States"
			],
			u: "1f1fa-1f1f8",
			a: "0.6"
		},
		{
			n: [
				"UY",
				"flag",
				"flag: Uruguay"
			],
			u: "1f1fa-1f1fe",
			a: "2"
		},
		{
			n: [
				"UZ",
				"flag",
				"flag: Uzbekistan"
			],
			u: "1f1fa-1f1ff",
			a: "2"
		},
		{
			n: [
				"VA",
				"flag",
				"flag: Vatican City"
			],
			u: "1f1fb-1f1e6",
			a: "2"
		},
		{
			n: [
				"VC",
				"flag",
				"flag: St. Vincent & Grenadines"
			],
			u: "1f1fb-1f1e8",
			a: "2"
		},
		{
			n: [
				"VE",
				"flag",
				"flag: Venezuela"
			],
			u: "1f1fb-1f1ea",
			a: "2"
		},
		{
			n: [
				"VG",
				"flag",
				"flag: British Virgin Islands"
			],
			u: "1f1fb-1f1ec",
			a: "2"
		},
		{
			n: [
				"VI",
				"flag",
				"flag: U.S. Virgin Islands"
			],
			u: "1f1fb-1f1ee",
			a: "2"
		},
		{
			n: [
				"VN",
				"flag",
				"flag: Vietnam"
			],
			u: "1f1fb-1f1f3",
			a: "2"
		},
		{
			n: [
				"VU",
				"flag",
				"flag: Vanuatu"
			],
			u: "1f1fb-1f1fa",
			a: "2"
		},
		{
			n: [
				"WF",
				"flag",
				"flag: Wallis & Futuna"
			],
			u: "1f1fc-1f1eb",
			a: "2"
		},
		{
			n: [
				"WS",
				"flag",
				"flag: Samoa"
			],
			u: "1f1fc-1f1f8",
			a: "2"
		},
		{
			n: [
				"XK",
				"flag",
				"flag: Kosovo"
			],
			u: "1f1fd-1f1f0",
			a: "2"
		},
		{
			n: [
				"YE",
				"flag",
				"flag: Yemen"
			],
			u: "1f1fe-1f1ea",
			a: "2"
		},
		{
			n: [
				"YT",
				"flag",
				"flag: Mayotte"
			],
			u: "1f1fe-1f1f9",
			a: "2"
		},
		{
			n: [
				"ZA",
				"flag",
				"flag: South Africa"
			],
			u: "1f1ff-1f1e6",
			a: "2"
		},
		{
			n: [
				"ZM",
				"flag",
				"flag: Zambia"
			],
			u: "1f1ff-1f1f2",
			a: "2"
		},
		{
			n: [
				"ZW",
				"flag",
				"flag: Zimbabwe"
			],
			u: "1f1ff-1f1fc",
			a: "2"
		},
		{
			n: [
				"flag",
				"gbeng",
				"flag: England"
			],
			u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
			a: "5"
		},
		{
			n: [
				"flag",
				"gbsct",
				"flag: Scotland"
			],
			u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
			a: "5"
		},
		{
			n: [
				"flag",
				"gbwls",
				"flag: Wales"
			],
			u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
			a: "5"
		}
	]
};
var defaultEmojiData = {
	categories: categories,
	emojis: emojis
};

// Pure data helpers plus the legacy global registry. This module intentionally
function unifiedWithoutSkinTone$1(unified) {
  var splat = unified.split('-');
  var _splat$splice = splat.splice(1, 1),
    skinTone = _splat$splice[0];
  if (skinTonesMapped[skinTone]) {
    return splat.join('-');
  }
  return unified;
}
function emojiUnified$1(emoji, skinTone) {
  var _emojiVariationUnifie;
  var unified = emoji[EmojiProperties.unified];
  if (!skinTone || !emojiHasVariations$1(emoji)) {
    return unified;
  }
  return (_emojiVariationUnifie = emojiVariationUnified$1(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojiVariations$1(emoji) {
  var _emoji$EmojiPropertie2;
  return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations$1(emoji) {
  return emojiVariations$1(emoji).length > 0;
}
function emojiVariationUnified$1(emoji, skinTone) {
  return skinTone ? emojiVariations$1(emoji).find(function (variation) {
    return variation.includes(skinTone);
  }) : emojiUnified$1(emoji);
}
function emojiByUnified(unified) {
  if (!unified) {
    return;
  }
  if (allEmojisByUnified[unified]) {
    return allEmojisByUnified[unified];
  }
  var withoutSkinTone = unifiedWithoutSkinTone$1(unified);
  return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/Object.values(defaultEmojiData.emojis).flat();
var allEmojisByUnified = {};
allEmojis.reduce(function (allEmojis, Emoji) {
  allEmojis[emojiUnified$1(Emoji)] = Emoji;
  if (emojiHasVariations$1(Emoji)) {
    emojiVariations$1(Emoji).forEach(function (variation) {
      allEmojis[variation] = Emoji;
    });
  }
  return allEmojis;
}, allEmojisByUnified);

var SUGGESTED_LS_KEY = 'epr_suggested';
function getSuggested(mode) {
  try {
    var _window$localStorage$;
    if (typeof window === 'undefined' || !window.localStorage) {
      return [];
    }
    var recent = JSON.parse((_window$localStorage$ = window.localStorage.getItem(SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : '[]');
    if (mode === SuggestionMode.FREQUENT) {
      return recent.sort(function (a, b) {
        return b.count - a.count;
      });
    }
    return recent;
  } catch (_unused) {
    return [];
  }
}
function setSuggested(emoji, skinTone) {
  var recent = getSuggested();
  var unified = emojiUnified(emoji, skinTone);
  var originalUnified = emojiUnified(emoji);
  var existing = recent.find(function (_ref) {
    var u = _ref.unified;
    return u === unified;
  });
  var nextList;
  if (existing) {
    nextList = [existing].concat(recent.filter(function (i) {
      return i !== existing;
    }));
  } else {
    existing = {
      unified: unified,
      original: originalUnified,
      count: 0
    };
    nextList = [existing].concat(recent);
  }
  existing.count++;
  nextList.length = Math.min(nextList.length, 14);
  try {
    if (typeof window === 'undefined') {
      return;
    }
    window.localStorage.setItem(SUGGESTED_LS_KEY, JSON.stringify(nextList));
    // Prevents the change from being seen immediately.
  } catch (_unused2) {
    // ignore
  }
}

function useIsMounted() {
  var _React$useState = useState(false),
    isMounted = _React$useState[0],
    setIsMounted = _React$useState[1];
  useEffect(function () {
    setIsMounted(true);
  }, []);
  return isMounted;
}

var PickerDataContext = /*#__PURE__*/React.createContext({
  emojiData: {},
  allEmojis: [],
  allEmojisByUnified: {},
  searchIndex: {},
  emojiByUnified: emojiByUnified,
  activeVariationFromUnified: function activeVariationFromUnified() {
    return null;
  }
});
function PickerDataProvider(_ref) {
  var children = _ref.children;
  var _usePickerConfig = usePickerConfig(),
    customEmojis = _usePickerConfig.customEmojis,
    genericEmojiData = _usePickerConfig.emojiData;
  var data = React.useMemo(function () {
    var emojiData = genericEmojiData || defaultEmojiData;
    // Clone to avoid mutation of shared source
    var newData = JSON.parse(JSON.stringify(emojiData));
    if (customEmojis && customEmojis.length > 0) {
      newData.emojis[Categories.CUSTOM] = customEmojis.map(customToRegularEmoji);
    }
    var emojis = newData.emojis || {};
    var allEmojis = Object.values(emojis).flat();
    var allEmojisByUnified = {};
    var searchIndex = {};
    allEmojis.forEach(function (emoji) {
      var unified = emoji[EmojiProperties.unified];
      allEmojisByUnified[unified] = emoji;
      if (emoji[EmojiProperties.variations]) {
        var _emoji$Keys$variation;
        (_emoji$Keys$variation = emoji[EmojiProperties.variations]) == null ? void 0 : _emoji$Keys$variation.forEach(function (variation) {
          allEmojisByUnified[variation] = emoji;
        });
      }
      // Index for search
      // Re-implement indexEmoji logic here to be local
      var joinedNameString = (emoji[EmojiProperties.name] || []).join('').toLowerCase().split('');
      joinedNameString.forEach(function (_char) {
        var _searchIndex$_char;
        searchIndex[_char] = (_searchIndex$_char = searchIndex[_char]) != null ? _searchIndex$_char : {};
        searchIndex[_char][unified] = emoji;
      });
    });
    return {
      emojiData: newData,
      allEmojis: allEmojis,
      allEmojisByUnified: allEmojisByUnified,
      searchIndex: searchIndex
    };
  }, [genericEmojiData, customEmojis]);
  var emojiByUnified = React.useCallback(function (unified) {
    var _data$allEmojisByUnif;
    if (!unified) return undefined;
    var result = (_data$allEmojisByUnif = data.allEmojisByUnified[unified]) != null ? _data$allEmojisByUnif : data.allEmojisByUnified[unifiedWithoutSkinTone(unified)];
    return result;
  }, [data.allEmojisByUnified]);
  return React.createElement(PickerDataContext.Provider, {
    value: _extends({}, data, {
      emojiByUnified: emojiByUnified,
      activeVariationFromUnified: activeVariationFromUnified
    })
  }, children);
}
function usePickerDataContext() {
  return React.useContext(PickerDataContext);
}
function useGetEmojisByCategory() {
  var _usePickerDataContext = usePickerDataContext(),
    emojiData = _usePickerDataContext.emojiData,
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
  var _useUpdateSuggested = useUpdateSuggested(),
    suggestedUpdated = _useUpdateSuggested[0];
  // Suggestions come from localStorage, which doesn't exist during SSR.
  // Read them only after mount so the first client render matches the server.
  var isMounted = useIsMounted();
  var suggested = React.useMemo(function () {
    var _getSuggested;
    if (!isMounted) {
      return [];
    }
    var suggested = (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    return suggested.map(function (s) {
      var _extends2;
      var emoji = emojiByUnified(s.unified);
      if (!emoji) return undefined;
      return _extends({}, emoji, (_extends2 = {}, _extends2[EmojiProperties.unified] = s.unified, _extends2));
    }).filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted, suggestedUpdated, suggestedEmojisModeConfig, emojiByUnified]);
  return function getEmojisByCategory(category) {
    var _emojiData$emojis$cat, _emojiData$emojis;
    if (category === Categories.SUGGESTED) {
      return suggested;
    }
    return (_emojiData$emojis$cat = (_emojiData$emojis = emojiData.emojis) == null ? void 0 : _emojiData$emojis[category]) != null ? _emojiData$emojis$cat : [];
  };
}
function customToRegularEmoji(emoji) {
  var _ref2;
  return _ref2 = {}, _ref2[EmojiProperties.name] = emoji.names.map(function (name) {
    return name.toLowerCase();
  }), _ref2[EmojiProperties.unified] = emoji.id.toLowerCase(), _ref2[EmojiProperties.added_in] = '0', _ref2[EmojiProperties.imgUrl] = emoji.imgUrl, _ref2;
}

function useIsUnicodeHidden() {
  var unicodeToHide = useUnicodeToHide();
  return function (emojiUnified) {
    return unicodeToHide.has(emojiUnified);
  };
}

function useDisallowedEmojis() {
  var DisallowedEmojisRef = useRef({});
  var emojiVersionConfig = useEmojiVersionConfig();
  var _usePickerDataContext = usePickerDataContext(),
    allEmojis = _usePickerDataContext.allEmojis;
  return useMemo(function () {
    var emojiVersion = parseFloat("" + emojiVersionConfig);
    if (!emojiVersionConfig || Number.isNaN(emojiVersion)) {
      return DisallowedEmojisRef.current;
    }
    return allEmojis.reduce(function (disallowedEmojis, emoji) {
      if (addedInNewerVersion(emoji, emojiVersion)) {
        disallowedEmojis[emojiUnified(emoji)] = true;
      }
      return disallowedEmojis;
    }, DisallowedEmojisRef.current);
  }, [emojiVersionConfig, allEmojis]);
}
function useIsEmojiDisallowed() {
  var disallowedEmojis = useDisallowedEmojis();
  var isUnicodeHidden = useIsUnicodeHidden();
  return function isEmojiDisallowed(emoji) {
    var unified = unifiedWithoutSkinTone(emojiUnified(emoji));
    return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
  };
}
function addedInNewerVersion(emoji, supportedLevel) {
  return addedIn(emoji) > supportedLevel;
}

function useMarkInitialLoad(dispatch) {
  useEffect(function () {
    dispatch(true);
  }, [dispatch]);
}

function PickerContextProvider(_ref) {
  var children = _ref.children;
  var disallowedEmojis = useDisallowedEmojis();
  var defaultSkinTone = useDefaultSkinToneConfig();
  var reactionsDefaultOpen = useReactionsOpenConfig();
  var _usePickerDataContext = usePickerDataContext(),
    searchIndex = _usePickerDataContext.searchIndex;
  // Initialize the filter with the inititial dictionary
  var filterRef = useRef(searchIndex);
  useEffect(function () {
    filterRef.current = searchIndex;
  }, [searchIndex]);
  var disallowClickRef = useRef(false);
  var disallowMouseRef = useRef(false);
  var disallowedEmojisRef = useRef(disallowedEmojis);
  var suggestedUpdateState = useDebouncedState(Date.now(), 200);
  var searchTerm = useDebouncedState('', 100);
  var skinToneFanOpenState = useState(false);
  var activeSkinTone = useState(defaultSkinTone);
  var activeCategoryState = useState(null);
  var emojisThatFailedToLoadState = useState(new Set());
  var emojiVariationPickerState = useState(null);
  var reactionsModeState = useState(reactionsDefaultOpen);
  var _useState = useState(false),
    isPastInitialLoad = _useState[0],
    setIsPastInitialLoad = _useState[1];
  var visibleCategoriesState = useState([]);
  var emojiSizeState = useState(null);
  useMarkInitialLoad(setIsPastInitialLoad);
  return createElement(PickerContext.Provider, {
    value: {
      activeCategoryState: activeCategoryState,
      activeSkinTone: activeSkinTone,
      disallowClickRef: disallowClickRef,
      disallowMouseRef: disallowMouseRef,
      disallowedEmojisRef: disallowedEmojisRef,
      emojiVariationPickerState: emojiVariationPickerState,
      emojisThatFailedToLoadState: emojisThatFailedToLoadState,
      filterRef: filterRef,
      isPastInitialLoad: isPastInitialLoad,
      searchTerm: searchTerm,
      skinToneFanOpenState: skinToneFanOpenState,
      suggestedUpdateState: suggestedUpdateState,
      reactionsModeState: reactionsModeState,
      visibleCategoriesState: visibleCategoriesState,
      emojiSizeState: emojiSizeState
    }
  }, children);
}
var PickerContext = /*#__PURE__*/createContext$1({
  activeCategoryState: [null, function () {}],
  activeSkinTone: [SkinTones.NEUTRAL, function () {}],
  disallowClickRef: {
    current: false
  },
  disallowMouseRef: {
    current: false
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function () {}],
  emojisThatFailedToLoadState: [/*#__PURE__*/new Set(), function () {}],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: true,
  searchTerm: ['', function () {
    return new Promise(function () {
      return undefined;
    });
  }],
  skinToneFanOpenState: [false, function () {}],
  suggestedUpdateState: [/*#__PURE__*/Date.now(), function () {}],
  reactionsModeState: [false, function () {}],
  visibleCategoriesState: [[], function () {
    return [];
  }],
  emojiSizeState: [null, function () {}]
});
function useFilterRef() {
  var _React$useContext = useContext(PickerContext),
    filterRef = _React$useContext.filterRef;
  return filterRef;
}
function useDisallowClickRef() {
  var _React$useContext2 = useContext(PickerContext),
    disallowClickRef = _React$useContext2.disallowClickRef;
  return disallowClickRef;
}
function useDisallowMouseRef() {
  var _React$useContext3 = useContext(PickerContext),
    disallowMouseRef = _React$useContext3.disallowMouseRef;
  return disallowMouseRef;
}
function useReactionsModeState() {
  var _React$useContext4 = useContext(PickerContext),
    reactionsModeState = _React$useContext4.reactionsModeState;
  return reactionsModeState;
}
function useSearchTermState() {
  var _React$useContext5 = useContext(PickerContext),
    searchTerm = _React$useContext5.searchTerm;
  return searchTerm;
}
function useActiveSkinToneState() {
  var _React$useContext6 = useContext(PickerContext),
    activeSkinTone = _React$useContext6.activeSkinTone;
  return activeSkinTone;
}
function useEmojisThatFailedToLoadState() {
  var _React$useContext7 = useContext(PickerContext),
    emojisThatFailedToLoadState = _React$useContext7.emojisThatFailedToLoadState;
  return emojisThatFailedToLoadState;
}
function useEmojiVariationPickerState() {
  var _React$useContext9 = useContext(PickerContext),
    emojiVariationPickerState = _React$useContext9.emojiVariationPickerState;
  return emojiVariationPickerState;
}
function useSkinToneFanOpenState() {
  var _React$useContext0 = useContext(PickerContext),
    skinToneFanOpenState = _React$useContext0.skinToneFanOpenState;
  return skinToneFanOpenState;
}
function useVisibleCategoriesState() {
  var _React$useContext10 = useContext(PickerContext),
    visibleCategoriesState = _React$useContext10.visibleCategoriesState;
  return visibleCategoriesState;
}
function useEmojiSizeState() {
  var _React$useContext11 = useContext(PickerContext),
    emojiSizeState = _React$useContext11.emojiSizeState;
  return emojiSizeState;
}
function useUpdateSuggested() {
  var _React$useContext12 = useContext(PickerContext),
    suggestedUpdateState = _React$useContext12.suggestedUpdateState;
  var suggestedUpdated = suggestedUpdateState[0],
    setsuggestedUpdate = suggestedUpdateState[1];
  return [suggestedUpdated, function updateSuggested() {
    setsuggestedUpdate(Date.now());
  }];
}

var MutableConfigContext = /*#__PURE__*/React.createContext({});
function useMutableConfig() {
  var mutableConfig = React.useContext(MutableConfigContext);
  return mutableConfig;
}
function useDefineMutableConfig(config) {
  var MutableConfigRef = React.useRef({
    onEmojiClick: config.onEmojiClick || emptyFunc,
    onReactionClick: config.onReactionClick || config.onEmojiClick,
    onSkinToneChange: config.onSkinToneChange || emptyFunc
  });
  React.useEffect(function () {
    MutableConfigRef.current.onEmojiClick = config.onEmojiClick || emptyFunc;
    MutableConfigRef.current.onReactionClick = config.onReactionClick || config.onEmojiClick;
  }, [config.onEmojiClick, config.onReactionClick]);
  React.useEffect(function () {
    MutableConfigRef.current.onSkinToneChange = config.onSkinToneChange || emptyFunc;
  }, [config.onSkinToneChange]);
  return MutableConfigRef;
}
function emptyFunc() {}

var MOUSE_EVENT_SOURCE;
(function (MOUSE_EVENT_SOURCE) {
  MOUSE_EVENT_SOURCE["REACTIONS"] = "reactions";
  MOUSE_EVENT_SOURCE["PICKER"] = "picker";
})(MOUSE_EVENT_SOURCE || (MOUSE_EVENT_SOURCE = {}));
function useSearchPlaceHolderConfig() {
  var _find;
  var _usePickerConfig = usePickerConfig(),
    searchPlaceHolder = _usePickerConfig.searchPlaceHolder,
    searchPlaceholder = _usePickerConfig.searchPlaceholder;
  return (_find = [searchPlaceHolder, searchPlaceholder].find(function (p) {
    return p !== DEFAULT_SEARCH_PLACEHOLDER;
  })) != null ? _find : DEFAULT_SEARCH_PLACEHOLDER;
}
function useSearchClearButtonLabelConfig() {
  var _usePickerConfig2 = usePickerConfig(),
    searchClearButtonLabel = _usePickerConfig2.searchClearButtonLabel;
  return searchClearButtonLabel != null ? searchClearButtonLabel : DEFAULT_SEARCH_CLEAR_BUTTON_LABEL;
}
function useDefaultSkinToneConfig() {
  var _usePickerConfig3 = usePickerConfig(),
    defaultSkinTone = _usePickerConfig3.defaultSkinTone;
  return defaultSkinTone;
}
function useAllowExpandReactions() {
  var _usePickerConfig4 = usePickerConfig(),
    allowExpandReactions = _usePickerConfig4.allowExpandReactions;
  return allowExpandReactions;
}
function useSkinTonesDisabledConfig() {
  var _usePickerConfig5 = usePickerConfig(),
    skinTonesDisabled = _usePickerConfig5.skinTonesDisabled;
  return skinTonesDisabled;
}
function useEmojiStyleConfig() {
  var _usePickerConfig6 = usePickerConfig(),
    emojiStyle = _usePickerConfig6.emojiStyle;
  return emojiStyle;
}
function useAutoFocusSearchConfig() {
  var _usePickerConfig7 = usePickerConfig(),
    autoFocusSearch = _usePickerConfig7.autoFocusSearch;
  return autoFocusSearch;
}
function useCategoriesConfig() {
  var _usePickerConfig8 = usePickerConfig(),
    categories = _usePickerConfig8.categories;
  return categories;
}
function useCategoryIconsConfig() {
  var _usePickerConfig9 = usePickerConfig(),
    categoryIcons = _usePickerConfig9.categoryIcons;
  return categoryIcons;
}
function useCustomEmojisConfig() {
  var _usePickerConfig0 = usePickerConfig(),
    customEmojis = _usePickerConfig0.customEmojis;
  return customEmojis;
}
function useOpenConfig() {
  var _usePickerConfig1 = usePickerConfig(),
    open = _usePickerConfig1.open;
  return open;
}
function useOnEmojiClickConfig(mouseEventSource) {
  var _useMutableConfig = useMutableConfig(),
    current = _useMutableConfig.current;
  var _useReactionsModeStat = useReactionsModeState(),
    setReactionsOpen = _useReactionsModeStat[1];
  var handler = current.onEmojiClick || function () {};
  var onReactionClick = current.onReactionClick;
  if (mouseEventSource === MOUSE_EVENT_SOURCE.REACTIONS && onReactionClick) {
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return onReactionClick.apply(void 0, args.concat([{
        collapseToReactions: function collapseToReactions() {
          setReactionsOpen(function (o) {
            return o;
          });
        }
      }]));
    };
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    handler.apply(void 0, args.concat([{
      collapseToReactions: function collapseToReactions() {
        setReactionsOpen(true);
      }
    }]));
  };
}
function useOnSkinToneChangeConfig() {
  var _useMutableConfig2 = useMutableConfig(),
    current = _useMutableConfig2.current;
  return current.onSkinToneChange || function () {};
}
function usePreviewConfig() {
  var _usePickerConfig10 = usePickerConfig(),
    previewConfig = _usePickerConfig10.previewConfig;
  return previewConfig;
}
function useThemeConfig() {
  var _usePickerConfig11 = usePickerConfig(),
    theme = _usePickerConfig11.theme;
  return theme;
}
function useSuggestedEmojisModeConfig() {
  var _usePickerConfig12 = usePickerConfig(),
    suggestedEmojisMode = _usePickerConfig12.suggestedEmojisMode;
  return suggestedEmojisMode;
}
function useLazyLoadEmojisConfig() {
  var _usePickerConfig13 = usePickerConfig(),
    lazyLoadEmojis = _usePickerConfig13.lazyLoadEmojis;
  return lazyLoadEmojis;
}
function useClassNameConfig() {
  var _usePickerConfig14 = usePickerConfig(),
    className = _usePickerConfig14.className;
  return className;
}
function useStyleConfig() {
  var _usePickerConfig15 = usePickerConfig(),
    height = _usePickerConfig15.height,
    width = _usePickerConfig15.width,
    style = _usePickerConfig15.style;
  return _extends({
    height: getDimension(height),
    width: getDimension(width)
  }, style);
}
function useReactionsOpenConfig() {
  var _usePickerConfig16 = usePickerConfig(),
    reactionsDefaultOpen = _usePickerConfig16.reactionsDefaultOpen;
  return reactionsDefaultOpen;
}
function useEmojiVersionConfig() {
  var _usePickerConfig17 = usePickerConfig(),
    emojiVersion = _usePickerConfig17.emojiVersion;
  return emojiVersion;
}
function useSearchDisabledConfig() {
  var _usePickerConfig18 = usePickerConfig(),
    searchDisabled = _usePickerConfig18.searchDisabled;
  return searchDisabled;
}
function useSkinTonePickerLocationConfig() {
  var _usePickerConfig19 = usePickerConfig(),
    skinTonePickerLocation = _usePickerConfig19.skinTonePickerLocation;
  return skinTonePickerLocation;
}
function useUnicodeToHide() {
  var _usePickerConfig20 = usePickerConfig(),
    unicodeToHide = _usePickerConfig20.unicodeToHide;
  return unicodeToHide;
}
function useReactionsConfig() {
  var _usePickerConfig21 = usePickerConfig(),
    reactions = _usePickerConfig21.reactions;
  return reactions;
}
function useGetEmojiUrlConfig() {
  var _usePickerConfig22 = usePickerConfig(),
    getEmojiUrl = _usePickerConfig22.getEmojiUrl;
  return getEmojiUrl;
}
function getDimension(dimensionConfig) {
  return typeof dimensionConfig === 'number' ? dimensionConfig + "px" : dimensionConfig;
}
function useSearchResultsConfig(searchResultsCount) {
  var hasResults = searchResultsCount > 0;
  var isPlural = searchResultsCount > 1;
  if (hasResults) {
    return isPlural ? SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND.replace('%n', searchResultsCount.toString()) : SEARCH_RESULTS_ONE_RESULT_FOUND;
  }
  return SEARCH_RESULTS_NO_RESULTS_FOUND;
}

function useIsSearchMode() {
  var _useSearchTermState = useSearchTermState(),
    searchTerm = _useSearchTermState[0];
  return !!searchTerm;
}

function focusElement(element) {
  if (!element) {
    return;
  }
  requestAnimationFrame(function () {
    element.focus();
  });
}
function focusPrevElementSibling(element) {
  if (!element) return;
  var prev = element.previousElementSibling;
  focusElement(prev);
}
function focusNextElementSibling(element) {
  if (!element) return;
  var next = element.nextElementSibling;
  focusElement(next);
}
function focusFirstElementChild(element) {
  if (!element) return;
  var first = element.firstElementChild;
  focusElement(first);
}

function getActiveElement() {
  return document.activeElement;
}

function ElementRefContextProvider(_ref) {
  var children = _ref.children;
  var PickerMainRef = useRef(null);
  var AnchoredEmojiRef = useRef(null);
  var BodyRef = useRef(null);
  var EmojiListRef = useRef(null);
  var SearchInputRef = useRef(null);
  var SkinTonePickerRef = useRef(null);
  var CategoryNavigationRef = useRef(null);
  var VariationPickerRef = useRef(null);
  var ReactionsRef = useRef(null);
  return createElement(ElementRefContext.Provider, {
    value: {
      AnchoredEmojiRef: AnchoredEmojiRef,
      BodyRef: BodyRef,
      EmojiListRef: EmojiListRef,
      CategoryNavigationRef: CategoryNavigationRef,
      PickerMainRef: PickerMainRef,
      SearchInputRef: SearchInputRef,
      SkinTonePickerRef: SkinTonePickerRef,
      VariationPickerRef: VariationPickerRef,
      ReactionsRef: ReactionsRef
    }
  }, children);
}
var ElementRefContext = /*#__PURE__*/createContext$1({
  AnchoredEmojiRef: /*#__PURE__*/createRef(),
  BodyRef: /*#__PURE__*/createRef(),
  CategoryNavigationRef: /*#__PURE__*/createRef(),
  EmojiListRef: /*#__PURE__*/createRef(),
  PickerMainRef: /*#__PURE__*/createRef(),
  SearchInputRef: /*#__PURE__*/createRef(),
  SkinTonePickerRef: /*#__PURE__*/createRef(),
  VariationPickerRef: /*#__PURE__*/createRef(),
  ReactionsRef: /*#__PURE__*/createRef()
});
function useElementRef() {
  return useContext(ElementRefContext);
}
function useEmojiListRef() {
  return useElementRef()['EmojiListRef'];
}
function usePickerMainRef() {
  return useElementRef()['PickerMainRef'];
}
function useAnchoredEmojiRef() {
  return useElementRef()['AnchoredEmojiRef'];
}
function useSetAnchoredEmojiRef() {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  return function (target) {
    if (target === null && AnchoredEmojiRef.current !== null) {
      focusElement(AnchoredEmojiRef.current);
    }
    AnchoredEmojiRef.current = target;
  };
}
function useBodyRef() {
  return useElementRef()['BodyRef'];
}
function useReactionsRef() {
  return useElementRef()['ReactionsRef'];
}
function useSearchInputRef() {
  return useElementRef()['SearchInputRef'];
}
function useSkinTonePickerRef() {
  return useElementRef()['SkinTonePickerRef'];
}
function useCategoryNavigationRef() {
  return useElementRef()['CategoryNavigationRef'];
}
function useVariationPickerRef() {
  return useElementRef()['VariationPickerRef'];
}

function scrollTo(root, top) {
  if (top === void 0) {
    top = 0;
  }
  var $eprBody = queryScrollBody(root);
  if (!$eprBody) {
    return;
  }
  requestAnimationFrame(function () {
    $eprBody.scrollTop = top;
  });
}
function scrollBy(root, by) {
  var $eprBody = queryScrollBody(root);
  if (!$eprBody) {
    return;
  }
  requestAnimationFrame(function () {
    $eprBody.scrollTop = $eprBody.scrollTop + by;
  });
}
function useScrollTo() {
  var BodyRef = useBodyRef();
  return useCallback(function (top) {
    requestAnimationFrame(function () {
      if (BodyRef.current) {
        BodyRef.current.scrollTop = top;
      }
    });
  }, [BodyRef]);
}
function scrollEmojiAboveLabel(emoji) {
  if (!emoji || !isEmojiBehindLabel(emoji)) {
    return;
  }
  if (emoji.closest(asSelectors(ClassNames.variationPicker))) {
    return;
  }
  var scrollBody = closestScrollBody(emoji);
  var by = emojiDistanceFromScrollTop(emoji);
  scrollBy(scrollBody, -(categoryLabelHeight(closestCategory(emoji)) - by));
}

function focusFirstVisibleEmoji(parent) {
  var emoji = firstVisibleEmoji(parent);
  focusElement(emoji);
  scrollEmojiAboveLabel(emoji);
}
function focusAndClickFirstVisibleEmoji(parent) {
  var firstEmoji = firstVisibleEmoji(parent);
  focusElement(firstEmoji);
  firstEmoji == null ? void 0 : firstEmoji.click();
}
function focusLastVisibleEmoji(parent) {
  focusElement(lastVisibleEmoji(parent));
}
function focusNextVisibleEmoji(element) {
  if (!element) {
    return;
  }
  var next = nextVisibleEmoji(element);
  if (!next) {
    return focusFirstVisibleEmoji(nextCategory(element));
  }
  focusElement(next);
  scrollEmojiAboveLabel(next);
}
function focusPrevVisibleEmoji(element) {
  if (!element) {
    return;
  }
  var prev = prevVisibleEmoji(element);
  if (!prev) {
    return focusLastVisibleEmoji(prevCategory(element));
  }
  focusElement(prev);
  scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowUp(element, exitUp) {
  if (!element) {
    return;
  }
  var prev = visibleEmojiOneRowUp(element);
  if (!prev) {
    return exitUp();
  }
  focusElement(prev);
  scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowDown(element) {
  if (!element) {
    return;
  }
  var next = visibleEmojiOneRowDown(element);
  return focusElement(next);
}
function visibleEmojiOneRowUp(element) {
  if (!element) {
    return null;
  }
  var categoryContent = closestCategoryContent(element);
  var category = closestCategory(categoryContent);
  var countInRow = elementCountInRow(categoryContent, element);
  var emojisInCurrentCategory = allVisibleEmojis(category);
  var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
  var indexInRow = currentEmojiIndex % countInRow;
  if (currentEmojiIndex === -1) {
    return null;
  }
  if (emojisInCurrentCategory[currentEmojiIndex - countInRow]) {
    return emojisInCurrentCategory[currentEmojiIndex - countInRow];
  }
  var prevVisibleCategory = prevCategory(category);
  if (!prevVisibleCategory) {
    return null;
  }
  var allPrevEmojis = allVisibleEmojis(prevVisibleCategory);
  // if there is an emoji in the same index of `indexInRow` in the previous category, return it
  // for this we need to find the last emoji in the previous category that shares the same indexInRow
  // this is by using the % operator to find the last emoji that matches
  var lastIndexInRow = allPrevEmojis.length % countInRow - 1;
  if (indexInRow > lastIndexInRow) {
    return allPrevEmojis.at(-1);
  }
  // otherwise, return the last emoji that shares the same indexInRow
  for (var i = allPrevEmojis.length - 1; i >= 0; i--) {
    if (i % countInRow === indexInRow) {
      return allPrevEmojis[i];
    }
  }
  return allPrevEmojis.at(-1);
}
function visibleEmojiOneRowDown(element) {
  var _emojisInNextCategory;
  if (!element) {
    return null;
  }
  var categoryContent = closestCategoryContent(element);
  var category = closestCategory(categoryContent);
  var countInRow = elementCountInRow(categoryContent, element);
  var emojisInCurrentCategory = allVisibleEmojis(category);
  var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
  if (currentEmojiIndex === -1) {
    return null;
  }
  // the remainder until the end of the row
  var remainder = countInRow - currentEmojiIndex % countInRow - 1;
  var firstInNextRow = currentEmojiIndex + remainder + 1;
  if (emojisInCurrentCategory[firstInNextRow]) {
    // if we have a next row, search in the next row for the last available emoji
    for (var p = currentEmojiIndex + countInRow; p % countInRow >= 0; p--) {
      if (emojisInCurrentCategory[p]) {
        return emojisInCurrentCategory[p];
      }
    }
  }
  var indexInRow = currentEmojiIndex % countInRow;
  var nextVisibleCategory = nextCategory(category);
  var emojisInNextCategory = allVisibleEmojis(nextVisibleCategory);
  if (emojisInNextCategory[indexInRow]) {
    return emojisInNextCategory[indexInRow];
  }
  return (_emojisInNextCategory = emojisInNextCategory.at(0)) != null ? _emojisInNextCategory : null;
}

function useCloseAllOpenToggles() {
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    variationPicker = _useEmojiVariationPic[0],
    setVariationPicker = _useEmojiVariationPic[1];
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    skinToneFanOpen = _useSkinToneFanOpenSt[0],
    setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
  var closeAllOpenToggles = useCallback(function () {
    if (variationPicker) {
      setVariationPicker(null);
    }
    if (skinToneFanOpen) {
      setSkinToneFanOpen(false);
    }
  }, [variationPicker, skinToneFanOpen, setVariationPicker, setSkinToneFanOpen]);
  return closeAllOpenToggles;
}
function useHasOpenToggles() {
  var _useEmojiVariationPic2 = useEmojiVariationPickerState(),
    variationPicker = _useEmojiVariationPic2[0];
  var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(),
    skinToneFanOpen = _useSkinToneFanOpenSt2[0];
  return function hasOpenToggles() {
    return !!variationPicker || skinToneFanOpen;
  };
}

function useDisallowMouseMove() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function disallowMouseMove() {
    DisallowMouseRef.current = true;
  };
}
function useAllowMouseMove() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function allowMouseMove() {
    DisallowMouseRef.current = false;
  };
}
function useIsMouseDisallowed() {
  var DisallowMouseRef = useDisallowMouseRef();
  return function isMouseDisallowed() {
    return DisallowMouseRef.current;
  };
}
function useOnMouseMove() {
  var BodyRef = useBodyRef();
  var allowMouseMove = useAllowMouseMove();
  var isMouseDisallowed = useIsMouseDisallowed();
  useEffect(function () {
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('mousemove', onMouseMove, {
      passive: true
    });
    function onMouseMove() {
      if (isMouseDisallowed()) {
        allowMouseMove();
      }
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mousemove', onMouseMove);
    };
  }, [BodyRef, allowMouseMove, isMouseDisallowed]);
}

function useFocusSearchInput() {
  var SearchInputRef = useSearchInputRef();
  return useCallback(function () {
    focusElement(SearchInputRef.current);
  }, [SearchInputRef]);
}
function useFocusSkinTonePicker() {
  var SkinTonePickerRef = useSkinTonePickerRef();
  return useCallback(function () {
    if (!SkinTonePickerRef.current) {
      return;
    }
    focusFirstElementChild(SkinTonePickerRef.current);
  }, [SkinTonePickerRef]);
}
function useFocusCategoryNavigation() {
  var CategoryNavigationRef = useCategoryNavigationRef();
  return useCallback(function () {
    if (!CategoryNavigationRef.current) {
      return;
    }
    focusFirstElementChild(CategoryNavigationRef.current);
  }, [CategoryNavigationRef]);
}

function useSetFilterRef() {
  var filterRef = useFilterRef();
  return function setFilter(setter) {
    if (typeof setter === 'function') {
      return setFilter(setter(filterRef.current));
    }
    filterRef.current = setter;
  };
}
function useClearSearch() {
  var applySearch = useApplySearch();
  var SearchInputRef = useSearchInputRef();
  var focusSearchInput = useFocusSearchInput();
  return function clearSearch() {
    if (SearchInputRef.current) {
      SearchInputRef.current.value = '';
    }
    applySearch('');
    focusSearchInput();
  };
}
function useAppendSearch() {
  var SearchInputRef = useSearchInputRef();
  var applySearch = useApplySearch();
  return function appendSearch(str) {
    if (SearchInputRef.current) {
      SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
      applySearch(getNormalizedSearchTerm(SearchInputRef.current.value));
    } else {
      applySearch(getNormalizedSearchTerm(str));
    }
  };
}
function useFilter() {
  var SearchInputRef = useSearchInputRef();
  var filterRef = useFilterRef();
  var setFilterRef = useSetFilterRef();
  var applySearch = useApplySearch();
  var _useSearchTermState = useSearchTermState(),
    searchTerm = _useSearchTermState[0];
  var statusSearchResults = getStatusSearchResults(filterRef.current, searchTerm);
  return {
    onChange: onChange,
    searchTerm: searchTerm,
    SearchInputRef: SearchInputRef,
    statusSearchResults: statusSearchResults
  };
  function onChange(inputValue) {
    var filter = filterRef.current;
    var nextValue = inputValue.toLowerCase();
    if (filter != null && filter[nextValue] || nextValue.length <= 1) {
      return applySearch(nextValue);
    }
    var longestMatch = findLongestMatch(nextValue, filter);
    if (!longestMatch) {
      // Can we even get here?
      // If so, we need to search among all emojis
      return applySearch(nextValue);
    }
    setFilterRef(function (current) {
      var _Object$assign;
      return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
    });
    applySearch(nextValue);
  }
}
function useApplySearch() {
  var _useSearchTermState2 = useSearchTermState(),
    setSearchTerm = _useSearchTermState2[1];
  var PickerMainRef = usePickerMainRef();
  return function applySearch(searchTerm) {
    requestAnimationFrame(function () {
      setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function () {
        scrollTo(PickerMainRef.current, 0);
      });
    });
  };
}
function filterEmojiObjectByKeyword(emojis, keyword) {
  var filtered = {};
  for (var unified in emojis) {
    var emoji = emojis[unified];
    if (hasMatch(emoji, keyword)) {
      filtered[unified] = emoji;
    }
  }
  return filtered;
}
function hasMatch(emoji, keyword) {
  return emojiNames(emoji).some(function (name) {
    return name.includes(keyword);
  });
}
function useIsEmojiFiltered() {
  var _useFilterRef = useFilterRef(),
    filter = _useFilterRef.current;
  var _useSearchTermState3 = useSearchTermState(),
    searchTerm = _useSearchTermState3[0];
  return function (unified) {
    return isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
  };
}
function isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
  var _filter$searchTerm;
  if (!filter || !searchTerm) {
    return false;
  }
  return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function findLongestMatch(keyword, dict) {
  if (!dict) {
    return null;
  }
  if (dict[keyword]) {
    return dict[keyword];
  }
  var longestMatchingKey = Object.keys(dict).sort(function (a, b) {
    return b.length - a.length;
  }).find(function (key) {
    return keyword.includes(key);
  });
  if (longestMatchingKey) {
    return dict[longestMatchingKey];
  }
  return null;
}
function getNormalizedSearchTerm(str) {
  if (!str || typeof str !== 'string') {
    return '';
  }
  return str.trim().toLowerCase();
}
function getStatusSearchResults(filterState, searchTerm) {
  var _Object$entries;
  if (!(filterState != null && filterState[searchTerm])) return '';
  var searchResultsCount = ((_Object$entries = Object.entries(filterState == null ? void 0 : filterState[searchTerm])) == null ? void 0 : _Object$entries.length) || 0;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useSearchResultsConfig(searchResultsCount);
}

function useSetVariationPicker() {
  var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    setEmojiVariationPicker = _useEmojiVariationPic[1];
  return function setVariationPicker(element) {
    var _emojiFromElement = emojiFromElement(element),
      emoji = _emojiFromElement[0];
    if (emoji) {
      setAnchoredEmojiRef(element);
      setEmojiVariationPicker(emoji);
    }
  };
}

function useIsSkinToneInSearch() {
  var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
  return skinTonePickerLocationConfig === SkinTonePickerLocation.SEARCH;
}
function useIsSkinToneInPreview() {
  var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
  return skinTonePickerLocationConfig === SkinTonePickerLocation.PREVIEW;
}

var KeyboardEvents;
(function (KeyboardEvents) {
  KeyboardEvents["ArrowDown"] = "ArrowDown";
  KeyboardEvents["ArrowUp"] = "ArrowUp";
  KeyboardEvents["ArrowLeft"] = "ArrowLeft";
  KeyboardEvents["ArrowRight"] = "ArrowRight";
  KeyboardEvents["Escape"] = "Escape";
  KeyboardEvents["Enter"] = "Enter";
  KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
function useKeyboardNavigation() {
  usePickerMainKeyboardEvents();
  useSearchInputKeyboardEvents();
  useSkinTonePickerKeyboardEvents();
  useCategoryNavigationKeyboardEvents();
  useBodyKeyboardEvents();
}
function usePickerMainKeyboardEvents() {
  var PickerMainRef = usePickerMainRef();
  var clearSearch = useClearSearch();
  var scrollTo = useScrollTo();
  var SearchInputRef = useSearchInputRef();
  var focusSearchInput = useFocusSearchInput();
  var hasOpenToggles = useHasOpenToggles();
  var disallowMouseMove = useDisallowMouseMove();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      disallowMouseMove();
      switch (key) {
        // eslint-disable-next-line no-fallthrough
        case KeyboardEvents.Escape:
          event.preventDefault();
          if (hasOpenToggles()) {
            closeAllOpenToggles();
            return;
          }
          clearSearch();
          scrollTo(0);
          focusSearchInput();
          break;
      }
    };
  }, [scrollTo, clearSearch, closeAllOpenToggles, focusSearchInput, hasOpenToggles, disallowMouseMove]);
  useEffect(function () {
    var current = PickerMainRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [PickerMainRef, SearchInputRef, scrollTo, onKeyDown]);
}
function useSearchInputKeyboardEvents() {
  var focusSkinTonePicker = useFocusSkinTonePicker();
  var PickerMainRef = usePickerMainRef();
  var BodyRef = useBodyRef();
  var SearchInputRef = useSearchInputRef();
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
  var goDownFromSearchInput = useGoDownFromSearchInput();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      switch (key) {
        case KeyboardEvents.ArrowRight:
          if (!isSkinToneInSearch) {
            return;
          }
          event.preventDefault();
          setSkinToneFanOpenState(true);
          focusSkinTonePicker();
          break;
        case KeyboardEvents.ArrowDown:
          event.preventDefault();
          goDownFromSearchInput();
          break;
        case KeyboardEvents.Enter:
          event.preventDefault();
          focusAndClickFirstVisibleEmoji(BodyRef.current);
          break;
      }
    };
  }, [focusSkinTonePicker, goDownFromSearchInput, setSkinToneFanOpenState, BodyRef, isSkinToneInSearch]);
  useEffect(function () {
    var current = SearchInputRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [PickerMainRef, SearchInputRef, onKeyDown]);
}
function useSkinTonePickerKeyboardEvents() {
  var SkinTonePickerRef = useSkinTonePickerRef();
  var focusSearchInput = useFocusSearchInput();
  var SearchInputRef = useSearchInputRef();
  var goDownFromSearchInput = useGoDownFromSearchInput();
  var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(),
    isOpen = _useSkinToneFanOpenSt2[0],
    setIsOpen = _useSkinToneFanOpenSt2[1];
  var isSkinToneInPreview = useIsSkinToneInPreview();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return (
      // eslint-disable-next-line complexity
      function onKeyDown(event) {
        var key = event.key;
        if (isSkinToneInSearch) {
          switch (key) {
            case KeyboardEvents.ArrowLeft:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusNextSkinTone(focusSearchInput);
              break;
            case KeyboardEvents.ArrowRight:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusPrevSkinTone();
              break;
            case KeyboardEvents.ArrowDown:
              event.preventDefault();
              if (isOpen) {
                setIsOpen(false);
              }
              goDownFromSearchInput();
              break;
            default:
              onType(event);
              break;
          }
        }
        if (isSkinToneInPreview) {
          switch (key) {
            case KeyboardEvents.ArrowUp:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusNextSkinTone(focusSearchInput);
              break;
            case KeyboardEvents.ArrowDown:
              event.preventDefault();
              if (!isOpen) {
                return focusSearchInput();
              }
              focusPrevSkinTone();
              break;
            default:
              onType(event);
              break;
          }
        }
      }
    );
  }, [isOpen, focusSearchInput, setIsOpen, goDownFromSearchInput, onType, isSkinToneInPreview, isSkinToneInSearch]);
  useEffect(function () {
    var current = SkinTonePickerRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [SkinTonePickerRef, SearchInputRef, isOpen, onKeyDown]);
}
function useCategoryNavigationKeyboardEvents() {
  var focusSearchInput = useFocusSearchInput();
  var CategoryNavigationRef = useCategoryNavigationRef();
  var BodyRef = useBodyRef();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return function onKeyDown(event) {
      var key = event.key;
      switch (key) {
        case KeyboardEvents.ArrowUp:
          event.preventDefault();
          focusSearchInput();
          break;
        case KeyboardEvents.ArrowRight:
          event.preventDefault();
          focusNextElementSibling(getActiveElement());
          break;
        case KeyboardEvents.ArrowLeft:
          event.preventDefault();
          focusPrevElementSibling(getActiveElement());
          break;
        case KeyboardEvents.ArrowDown:
          event.preventDefault();
          focusFirstVisibleEmoji(BodyRef.current);
          break;
        default:
          onType(event);
          break;
      }
    };
  }, [BodyRef, focusSearchInput, onType]);
  useEffect(function () {
    var current = CategoryNavigationRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [CategoryNavigationRef, BodyRef, onKeyDown]);
}
function useBodyKeyboardEvents() {
  var BodyRef = useBodyRef();
  var goUpFromBody = useGoUpFromBody();
  var setVariationPicker = useSetVariationPicker();
  var hasOpenToggles = useHasOpenToggles();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var onType = useOnType();
  var onKeyDown = useMemo(function () {
    return (
      // eslint-disable-next-line complexity
      function onKeyDown(event) {
        var key = event.key;
        var activeElement = buttonFromTarget(getActiveElement());
        switch (key) {
          case KeyboardEvents.ArrowRight:
            event.preventDefault();
            focusNextVisibleEmoji(activeElement);
            break;
          case KeyboardEvents.ArrowLeft:
            event.preventDefault();
            focusPrevVisibleEmoji(activeElement);
            break;
          case KeyboardEvents.ArrowDown:
            event.preventDefault();
            if (hasOpenToggles()) {
              closeAllOpenToggles();
              break;
            }
            focusVisibleEmojiOneRowDown(activeElement);
            break;
          case KeyboardEvents.ArrowUp:
            event.preventDefault();
            if (hasOpenToggles()) {
              closeAllOpenToggles();
              break;
            }
            focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
            break;
          case KeyboardEvents.Space:
            event.preventDefault();
            setVariationPicker(event.target);
            break;
          default:
            onType(event);
            break;
        }
      }
    );
  }, [goUpFromBody, onType, setVariationPicker, hasOpenToggles, closeAllOpenToggles]);
  useEffect(function () {
    var current = BodyRef.current;
    if (!current) {
      return;
    }
    current.addEventListener('keydown', onKeyDown);
    return function () {
      current.removeEventListener('keydown', onKeyDown);
    };
  }, [BodyRef, onKeyDown]);
}
function useGoDownFromSearchInput() {
  var focusCategoryNavigation = useFocusCategoryNavigation();
  var isSearchMode = useIsSearchMode();
  var BodyRef = useBodyRef();
  return useCallback(function goDownFromSearchInput() {
    if (isSearchMode) {
      return focusFirstVisibleEmoji(BodyRef.current);
    }
    return focusCategoryNavigation();
  }, [BodyRef, focusCategoryNavigation, isSearchMode]);
}
function useGoUpFromBody() {
  var focusSearchInput = useFocusSearchInput();
  var focusCategoryNavigation = useFocusCategoryNavigation();
  var isSearchMode = useIsSearchMode();
  return useCallback(function goUpFromEmoji() {
    if (isSearchMode) {
      return focusSearchInput();
    }
    return focusCategoryNavigation();
  }, [focusSearchInput, isSearchMode, focusCategoryNavigation]);
}
function focusNextSkinTone(exitLeft) {
  var currentSkinTone = getActiveElement();
  if (!currentSkinTone) {
    return;
  }
  if (!hasNextElementSibling(currentSkinTone)) {
    exitLeft();
  }
  focusNextElementSibling(currentSkinTone);
}
function focusPrevSkinTone() {
  var currentSkinTone = getActiveElement();
  if (!currentSkinTone) {
    return;
  }
  focusPrevElementSibling(currentSkinTone);
}
function useOnType() {
  var appendSearch = useAppendSearch();
  var focusSearchInput = useFocusSearchInput();
  var searchDisabled = useSearchDisabledConfig();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  return function onType(event) {
    var key = event.key;
    if (hasModifier(event) || searchDisabled) {
      return;
    }
    if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
      event.preventDefault();
      closeAllOpenToggles();
      focusSearchInput();
      appendSearch(key);
    }
  };
}
function hasModifier(event) {
  var metaKey = event.metaKey,
    ctrlKey = event.ctrlKey,
    altKey = event.altKey;
  return metaKey || ctrlKey || altKey;
}

// eslint-disable-next-line max-params
function preloadEmojiIfNeeded(emoji, emojiStyles, scrollTop, clientHeight, topOffset, style, dimensions, getEmojiUrl) {
  if (!emoji) {
    return;
  }
  if (emojiStyles === EmojiStyle.NATIVE) {
    return;
  }
  var unified = emojiUnified(emoji);
  if (preloadedEmojs.has(unified)) {
    return;
  }
  // preload only if the emoji is a few rows below the viewport
  if (!style || !dimensions) {
    return;
  }
  setTimeout(function () {
    var emojiTop = topOffset + style.top;
    var viewportBottom = scrollTop + clientHeight;
    var isJustBelowViewport = emojiTop >= viewportBottom && emojiTop < viewportBottom + dimensions.emojiSize * 2;
    if (isJustBelowViewport) {
      preloadEmoji(getEmojiUrl, emoji, emojiStyles);
    }
  });
}
function preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
  if (!emoji) {
    return;
  }
  var unified = emojiUnified(emoji);
  if (preloadedEmojs.has(unified)) {
    return;
  }
  preloadedEmojs.add(unified);
  emojiVariations(emoji).concat(unified).forEach(function (variation) {
    var emojiUrl = getEmojiUrl(variation, emojiStyle);
    preloadImage(emojiUrl);
  });
}
var preloadedEmojs = /*#__PURE__*/new Set();
function preloadImage(url) {
  var image = new Image();
  image.src = url;
}

function useOnFocus() {
  var BodyRef = useBodyRef();
  var emojiStyle = useEmojiStyleConfig();
  var getEmojiUrl = useGetEmojiUrlConfig();
  useEffect(function () {
    if (emojiStyle === EmojiStyle.NATIVE) {
      return;
    }
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('focusin', onFocus);
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('focusin', onFocus);
    };
    function onFocus(event) {
      var button = buttonFromTarget(event.target);
      if (!button) {
        return;
      }
      var _emojiFromElement = emojiFromElement(button),
        emoji = _emojiFromElement[0];
      if (!emoji) {
        return;
      }
      if (emojiHasVariations(emoji)) {
        preloadEmoji(getEmojiUrl, emoji, emojiStyle);
      }
    }
  }, [BodyRef, emojiStyle, getEmojiUrl]);
}

var _excluded$1 = ["width", "height"];
var DEFAULT_LABEL_HEIGHT = 40;
function PickerMain(_ref) {
  var children = _ref.children;
  return createElement(PickerContextProvider, null, createElement(PickerRootElement, null, children));
}
function PickerRootElement(_ref2) {
  var _cx;
  var children = _ref2.children;
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsMode = _useReactionsModeStat[0];
  var theme = useThemeConfig();
  var searchModeActive = useIsSearchMode();
  var PickerMainRef = usePickerMainRef();
  var className = useClassNameConfig();
  var style = useStyleConfig();
  useKeyboardNavigation();
  useOnFocus();
  var _ref3 = style || {},
    width = _ref3.width,
    height = _ref3.height,
    styleProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1);
  return createElement("aside", {
    className: cx(styles$1.main, styles$1.baseVariables, theme === Theme.DARK && styles$1.darkTheme, theme === Theme.AUTO && styles$1.autoThemeDark, (_cx = {}, _cx[ClassNames.searchActive] = searchModeActive, _cx), reactionsMode && styles$1.reactionsMenu, className),
    ref: PickerMainRef,
    style: _extends({}, styleProps, !reactionsMode && {
      height: height,
      width: width
    })
  }, children);
}
var DarkTheme = {
  '--epr-emoji-variation-picker-bg-color': 'var(--epr-dark-emoji-variation-picker-bg-color)',
  '--epr-hover-bg-color-reduced-opacity': 'var(--epr-dark-hover-bg-color-reduced-opacity)',
  '--epr-highlight-color': 'var(--epr-dark-highlight-color)',
  '--epr-text-color': 'var(--epr-dark-text-color)',
  '--epr-hover-bg-color': 'var(--epr-dark-hover-bg-color)',
  '--epr-focus-bg-color': 'var(--epr-dark-focus-bg-color)',
  '--epr-search-input-bg-color': 'var(--epr-dark-search-input-bg-color)',
  '--epr-category-label-bg-color': 'var(--epr-dark-category-label-bg-color)',
  '--epr-picker-border-color': 'var(--epr-dark-picker-border-color)',
  '--epr-bg-color': 'var(--epr-dark-bg-color)',
  '--epr-reactions-bg-color': 'var(--epr-dark-reactions-bg-color)',
  '--epr-search-input-bg-color-active': 'var(--epr-dark-search-input-bg-color-active)',
  '--epr-emoji-variation-indicator-color': 'var(--epr-dark-emoji-variation-indicator-color)',
  '--epr-category-icon-active-color': 'var(--epr-dark-category-icon-active-color)',
  '--epr-skin-tone-picker-menu-color': 'var(--epr-dark-skin-tone-picker-menu-color)',
  '--epr-skin-tone-outer-border-color': 'var(--epr-dark-skin-tone-outer-border-color)',
  '--epr-skin-tone-inner-border-color': 'var(--epr-dark-skin-tone-inner-border-color)'
};
var styles$1 = /*#__PURE__*/stylesheet.create({
  main: {
    '.': ['epr-main', ClassNames.emojiPicker],
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderRadius: 'var(--epr-picker-border-radius)',
    borderColor: 'var(--epr-picker-border-color)',
    backgroundColor: 'var(--epr-bg-color)',
    overflow: 'hidden',
    transition: 'height 0.3s ease-in-out, background-color 0.1s ease-in-out',
    '*': {
      boxSizing: 'border-box',
      fontFamily: 'sans-serif'
    }
  },
  baseVariables: {
    '--': {
      '--epr-highlight-color': '#007aeb',
      '--epr-hover-bg-color': '#e5f0fa',
      '--epr-hover-bg-color-reduced-opacity': '#e5f0fa80',
      '--epr-focus-bg-color': '#e0f0ff',
      '--epr-text-color': '#858585',
      '--epr-search-input-bg-color': '#f6f6f6',
      '--epr-picker-border-color': '#e7e7e7',
      '--epr-bg-color': '#fff',
      '--epr-reactions-bg-color': '#ffffff90',
      '--epr-category-icon-active-color': '#6aa8de',
      '--epr-skin-tone-picker-menu-color': '#ffffff95',
      '--epr-skin-tone-outer-border-color': '#555555',
      '--epr-skin-tone-inner-border-color': 'var(--epr-bg-color)',
      '--epr-horizontal-padding': '10px',
      '--epr-picker-border-radius': '8px',
      /* Header */
      '--epr-header-padding': '15px var(--epr-horizontal-padding)',
      /* Skin Tone Picker */
      '--epr-active-skin-tone-indicator-border-color': 'var(--epr-highlight-color)',
      '--epr-active-skin-hover-color': 'var(--epr-hover-bg-color)',
      /* Search */
      '--epr-search-input-bg-color-active': 'var(--epr-search-input-bg-color)',
      '--epr-search-input-padding': '0 30px',
      '--epr-search-input-border-radius': '8px',
      '--epr-search-input-height': '40px',
      '--epr-search-input-text-color': 'var(--epr-text-color)',
      '--epr-search-input-placeholder-color': 'var(--epr-text-color)',
      '--epr-search-bar-inner-padding': 'var(--epr-horizontal-padding)',
      '--epr-search-border-color': 'var(--epr-search-input-bg-color)',
      '--epr-search-border-color-active': 'var(--epr-highlight-color)',
      /*  Category Navigation */
      '--epr-category-navigation-button-size': '30px',
      /* Variation Picker */
      '--epr-emoji-variation-picker-height': '45px',
      '--epr-emoji-variation-picker-bg-color': 'var(--epr-bg-color)',
      /*  Preview */
      '--epr-preview-height': '70px',
      '--epr-preview-text-size': '14px',
      '--epr-preview-text-padding': '0 var(--epr-horizontal-padding)',
      '--epr-preview-border-color': 'var(--epr-picker-border-color)',
      '--epr-preview-text-color': 'var(--epr-text-color)',
      /* Category */
      '--epr-category-padding': '0 var(--epr-horizontal-padding)',
      /*  Category Label */
      '--epr-category-label-bg-color': '#ffffffe6',
      '--epr-category-label-text-color': 'var(--epr-text-color)',
      '--epr-category-label-padding': '0 var(--epr-horizontal-padding)',
      '--epr-category-label-height': DEFAULT_LABEL_HEIGHT + "px",
      /*  Emoji */
      '--epr-emoji-size': '30px',
      '--epr-emoji-padding': '5px',
      '--epr-emoji-fullsize': 'calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)',
      '--epr-emoji-hover-color': 'var(--epr-hover-bg-color)',
      '--epr-emoji-variation-indicator-color': 'var(--epr-picker-border-color)',
      '--epr-emoji-variation-indicator-color-hover': 'var(--epr-text-color)',
      /* Z-Index */
      '--epr-header-overlay-z-index': '3',
      '--epr-emoji-variations-indictator-z-index': '1',
      '--epr-category-label-z-index': '2',
      '--epr-skin-variation-picker-z-index': '5',
      '--epr-preview-z-index': '6',
      /* Dark Theme Variables */
      '--epr-dark': '#000',
      '--epr-dark-emoji-variation-picker-bg-color': 'var(--epr-dark)',
      '--epr-dark-highlight-color': '#c0c0c0',
      '--epr-dark-text-color': 'var(--epr-highlight-color)',
      '--epr-dark-hover-bg-color': '#363636f6',
      '--epr-dark-hover-bg-color-reduced-opacity': '#36363680',
      '--epr-dark-focus-bg-color': '#474747',
      '--epr-dark-search-input-bg-color': '#333333',
      '--epr-dark-category-label-bg-color': '#222222e6',
      '--epr-dark-picker-border-color': '#151617',
      '--epr-dark-bg-color': '#222222',
      '--epr-dark-reactions-bg-color': '#22222290',
      '--epr-dark-search-input-bg-color-active': 'var(--epr-dark)',
      '--epr-dark-emoji-variation-indicator-color': '#444',
      '--epr-dark-category-icon-active-color': '#3271b7',
      '--epr-dark-skin-tone-picker-menu-color': '#22222295',
      '--epr-dark-skin-tone-outer-border-color': 'var(--epr-dark-picker-border-color)',
      '--epr-dark-skin-tone-inner-border-color': '#00000000'
    }
  },
  autoThemeDark: {
    '.': ClassNames.autoTheme,
    '@media (prefers-color-scheme: dark)': {
      '--': DarkTheme
    }
  },
  darkTheme: {
    '.': ClassNames.darkTheme,
    '--': DarkTheme
  },
  reactionsMenu: {
    '.': 'epr-reactions',
    height: '50px',
    display: 'inline-flex',
    backgroundColor: 'var(--epr-reactions-bg-color)',
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(8px)',
    '--': {
      '--epr-picker-border-radius': '50px'
    }
  }
});

function elementCountInRow(parent, element) {
  if (!parent || !element) {
    return 0;
  }
  var parentWidth = parent.getBoundingClientRect().width;
  var elementWidth = element.getBoundingClientRect().width;
  return Math.floor(parentWidth / elementWidth);
}
function firstVisibleElementInContainer(parent, elements, maxVisibilityDiffThreshold) {
  if (maxVisibilityDiffThreshold === void 0) {
    maxVisibilityDiffThreshold = 0;
  }
  if (!parent || !elements.length) {
    return null;
  }
  var parentTop = parent.getBoundingClientRect().top;
  var parentBottom = parent.getBoundingClientRect().bottom;
  var parentTopWithLabel = parentTop + getLabelHeight(parent);
  var visibleElements = elements.find(function (element) {
    var elementTop = element.getBoundingClientRect().top;
    var elementBottom = element.getBoundingClientRect().bottom;
    var maxVisibilityDiffPixels = element.clientHeight * maxVisibilityDiffThreshold;
    var elementTopWithAllowedDiff = elementTop + maxVisibilityDiffPixels;
    var elementBottomWithAllowedDiff = elementBottom - maxVisibilityDiffPixels;
    if (elementTopWithAllowedDiff < parentTopWithLabel) {
      return false;
    }
    return elementTopWithAllowedDiff >= parentTop && elementTopWithAllowedDiff <= parentBottom || elementBottomWithAllowedDiff >= parentTop && elementBottomWithAllowedDiff <= parentBottom;
  });
  return visibleElements || null;
}
function hasNextElementSibling(element) {
  return !!element.nextElementSibling;
}
function getLabelHeight(parentNode) {
  if (!parentNode) {
    return DEFAULT_LABEL_HEIGHT;
  }
  var label = parentNode.querySelector(asSelectors(ClassNames.label));
  if (label) {
    var height = label.getBoundingClientRect().height;
    if (height > 0) {
      return height;
    }
  }
  // fallback to default
  return DEFAULT_LABEL_HEIGHT;
}

var EmojiButtonSelector = "button" + /*#__PURE__*/asSelectors(ClassNames.emoji);
var VisibleEmojiSelector = /*#__PURE__*/[EmojiButtonSelector, asSelectors(ClassNames.visible), ":not(" + asSelectors(ClassNames.hidden) + ")"].join('');
function buttonFromTarget(emojiElement) {
  var _emojiElement$closest;
  return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest(EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function emojiFromElement(element) {
  var originalUnified = originalUnifiedFromEmojiElement(element);
  var unified = unifiedFromEmojiElement(element);
  if (!originalUnified) {
    return [];
  }
  var emoji = emojiByUnified(unified != null ? unified : originalUnified);
  if (!emoji) {
    return [];
  }
  return [emoji, unified];
}
function isEmojiElement(element) {
  var _element$parentElemen;
  return Boolean((element == null ? void 0 : element.matches(EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches(EmojiButtonSelector)));
}
function elementHeight(element) {
  var _element$clientHeight;
  return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function emojiTrueOffsetTop(element) {
  if (!element) {
    return 0;
  }
  var button = buttonFromTarget(element);
  var category = closestCategory(button);
  // compensate for the label height
  var labelHeight = categoryLabelHeight(category);
  return elementOffsetTop(button) + elementOffsetTop(category) + labelHeight;
}
function categoryLabelHeight(category) {
  var _category$clientHeigh, _categoryWithoutLabel;
  if (!category) {
    return 0;
  }
  var categoryWithoutLabel = category.querySelector(asSelectors(ClassNames.categoryContent));
  return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function isEmojiBehindLabel(emoji) {
  if (!emoji) {
    return false;
  }
  return emojiDistanceFromScrollTop(emoji) < categoryLabelHeight(closestCategory(emoji));
}
function queryScrollBody(root) {
  if (!root) return null;
  return root.matches(asSelectors(ClassNames.scrollBody)) ? root : root.querySelector(asSelectors(ClassNames.scrollBody));
}
function emojiDistanceFromScrollTop(emoji) {
  var _closestScrollBody$sc, _closestScrollBody;
  if (!emoji) {
    return 0;
  }
  return emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function closestScrollBody(element) {
  var _element$closest;
  if (!element) {
    return null;
  }
  return (_element$closest = element.closest(asSelectors(ClassNames.scrollBody))) != null ? _element$closest : null;
}
function emojiTruOffsetLeft(element) {
  var button = buttonFromTarget(element);
  var category = closestCategory(button);
  return elementOffsetLeft(button) + elementOffsetLeft(category);
}
function elementOffsetTop(element) {
  var _element$offsetTop;
  return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function elementOffsetLeft(element) {
  var _element$offsetLeft;
  return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function unifiedFromEmojiElement(emoji) {
  var _elementDataSetKey;
  return (_elementDataSetKey = elementDataSetKey(buttonFromTarget(emoji), 'unified')) != null ? _elementDataSetKey : null;
}
function originalUnifiedFromEmojiElement(emoji) {
  var unified = unifiedFromEmojiElement(emoji);
  if (unified) {
    return unifiedWithoutSkinTone$1(unified);
  }
  return null;
}
function allUnifiedFromEmojiElement(emoji) {
  if (!emoji) {
    return {
      unified: null,
      originalUnified: null
    };
  }
  return {
    unified: unifiedFromEmojiElement(emoji),
    originalUnified: originalUnifiedFromEmojiElement(emoji)
  };
}
function elementDataSetKey(element, key) {
  var _elementDataSet$key;
  return (_elementDataSet$key = elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function elementDataSet(element) {
  var _element$dataset;
  return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function isVisibleEmoji(element) {
  return element.classList.contains(ClassNames.visible);
}
function isHidden(element) {
  if (!element) return true;
  return element.classList.contains(ClassNames.hidden);
}
function allVisibleEmojis(parent) {
  if (!parent) {
    return [];
  }
  return Array.from(parent.querySelectorAll(VisibleEmojiSelector));
}
function lastVisibleEmoji(element) {
  if (!element) return null;
  var allEmojis = allVisibleEmojis(element);
  var _allEmojis$slice = allEmojis.slice(-1),
    last = _allEmojis$slice[0];
  if (!last) {
    return null;
  }
  if (!isVisibleEmoji(last)) {
    return prevVisibleEmoji(last);
  }
  return last;
}
function nextVisibleEmoji(element) {
  var next = element.nextElementSibling;
  if (!next) {
    return firstVisibleEmoji(nextCategory(element));
  }
  if (!isVisibleEmoji(next)) {
    return nextVisibleEmoji(next);
  }
  return next;
}
function prevVisibleEmoji(element) {
  var prev = element.previousElementSibling;
  if (!prev) {
    return lastVisibleEmoji(prevCategory(element));
  }
  if (!isVisibleEmoji(prev)) {
    return prevVisibleEmoji(prev);
  }
  return prev;
}
function firstVisibleEmoji(parent) {
  if (!parent) {
    return null;
  }
  var allEmojis = allVisibleEmojis(parent);
  return firstVisibleElementInContainer(parent, allEmojis, 0.1);
}
function prevCategory(element) {
  var category = closestCategory(element);
  if (!category) {
    return null;
  }
  var prev = category.previousElementSibling;
  if (!prev) {
    return null;
  }
  if (isHidden(prev)) {
    return prevCategory(prev);
  }
  return prev;
}
function nextCategory(element) {
  var category = closestCategory(element);
  if (!category) {
    return null;
  }
  var next = category.nextElementSibling;
  if (!next) {
    return null;
  }
  if (isHidden(next)) {
    return nextCategory(next);
  }
  return next;
}
function closestCategory(element) {
  if (!element) {
    return null;
  }
  return element.closest(asSelectors(ClassNames.category));
}
function closestCategoryContent(element) {
  if (!element) {
    return null;
  }
  return element.closest(asSelectors(ClassNames.categoryContent));
}

function parseNativeEmoji(unified) {
  return unified.split('-').map(function (hex) {
    return String.fromCodePoint(parseInt(hex, 16));
  }).join('');
}

function isCustomCategory(category) {
  return category.category === Categories.CUSTOM;
}
function isCustomEmoji(emoji) {
  return emoji.imgUrl !== undefined;
}

function useMouseDownHandlers(ContainerRef, mouseEventSource) {
  var mouseDownTimerRef = useRef();
  var setVariationPicker = useSetVariationPicker();
  var disallowClickRef = useDisallowClickRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    setEmojiVariationPicker = _useEmojiVariationPic[1];
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var onEmojiClick = useOnEmojiClickConfig(mouseEventSource);
  var _useUpdateSuggested = useUpdateSuggested(),
    updateSuggested = _useUpdateSuggested[1];
  var getEmojiUrl = useGetEmojiUrlConfig();
  var activeEmojiStyle = useEmojiStyleConfig();
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var onClick = useCallback(function onClick(event) {
    if (disallowClickRef.current) {
      return;
    }
    closeAllOpenToggles();
    var _emojiFromEvent = emojiFromEvent(event, emojiByUnified),
      emoji = _emojiFromEvent[0],
      unified = _emojiFromEvent[1];
    if (!emoji || !unified) {
      return;
    }
    var skinToneToUse = activeVariationFromUnified(unified) || activeSkinTone;
    updateSuggested();
    setSuggested(emoji, skinToneToUse);
    onEmojiClick(emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
  }, [activeSkinTone, closeAllOpenToggles, disallowClickRef, emojiByUnified, onEmojiClick, updateSuggested, getEmojiUrl, activeEmojiStyle]);
  var onMouseDown = useCallback(function onMouseDown(event) {
    if (mouseDownTimerRef.current) {
      clearTimeout(mouseDownTimerRef.current);
    }
    var _emojiFromEvent2 = emojiFromEvent(event, emojiByUnified),
      emoji = _emojiFromEvent2[0];
    if (!emoji || !emojiHasVariations(emoji)) {
      return;
    }
    mouseDownTimerRef.current = setTimeout(function () {
      disallowClickRef.current = true;
      mouseDownTimerRef.current = undefined;
      closeAllOpenToggles();
      setVariationPicker(event.target);
      setEmojiVariationPicker(emoji);
    }, 500);
  }, [disallowClickRef, emojiByUnified, closeAllOpenToggles, setVariationPicker, setEmojiVariationPicker]);
  var onMouseUp = useCallback(function onMouseUp() {
    if (mouseDownTimerRef.current) {
      clearTimeout(mouseDownTimerRef.current);
      mouseDownTimerRef.current = undefined;
    } else if (disallowClickRef.current) {
      // The problem we're trying to overcome here
      // is that the emoji has both mouseup and click events
      // and when releasing a mouseup event
      // the click gets triggered too
      // So we're disallowing the click event for a short time
      requestAnimationFrame(function () {
        disallowClickRef.current = false;
      });
    }
  }, [disallowClickRef]);
  useEffect(function () {
    if (!ContainerRef.current) {
      return;
    }
    var confainerRef = ContainerRef.current;
    confainerRef.addEventListener('click', onClick, {
      passive: true
    });
    confainerRef.addEventListener('mousedown', onMouseDown, {
      passive: true
    });
    confainerRef.addEventListener('mouseup', onMouseUp, {
      passive: true
    });
    return function () {
      confainerRef == null ? void 0 : confainerRef.removeEventListener('click', onClick);
      confainerRef == null ? void 0 : confainerRef.removeEventListener('mousedown', onMouseDown);
      confainerRef == null ? void 0 : confainerRef.removeEventListener('mouseup', onMouseUp);
    };
  }, [ContainerRef, onClick, onMouseDown, onMouseUp]);
}
function emojiFromEvent(event, lookupEmojiByUnified) {
  var target = event == null ? void 0 : event.target;
  if (!isEmojiElement(target)) {
    return [];
  }
  var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(target),
    unified = _allUnifiedFromEmojiE.unified,
    originalUnified = _allUnifiedFromEmojiE.originalUnified;
  var resolvedUnified = unified != null ? unified : originalUnified;
  if (!resolvedUnified) {
    return [];
  }
  var emoji = lookupEmojiByUnified(resolvedUnified);
  if (!emoji) {
    return [];
  }
  return [emoji, unified != null ? unified : resolvedUnified];
}
function emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
  var names = emojiNames(emoji);
  if (isCustomEmoji(emoji)) {
    var _unified = emojiUnified(emoji);
    return {
      activeSkinTone: activeSkinTone,
      emoji: _unified,
      getImageUrl: function getImageUrl() {
        return emoji.imgUrl;
      },
      imageUrl: emoji.imgUrl,
      isCustom: true,
      names: names,
      unified: _unified,
      unifiedWithoutSkinTone: _unified
    };
  }
  var unified = emojiUnified(emoji, activeSkinTone);
  return {
    activeSkinTone: activeSkinTone,
    emoji: parseNativeEmoji(unified),
    getImageUrl: function getImageUrl(emojiStyle) {
      if (emojiStyle === void 0) {
        emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE;
      }
      return getEmojiUrl(unified, emojiStyle);
    },
    imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE),
    isCustom: false,
    names: names,
    unified: unified,
    unifiedWithoutSkinTone: emojiUnified(emoji)
  };
}

function Button(props) {
  return createElement("button", Object.assign({
    type: "button"
  }, props, {
    className: cx(styles$1$1.button, props.className)
  }), props.children);
}
var styles$1$1 = /*#__PURE__*/stylesheet.create({
  button: {
    '.': 'epr-btn',
    cursor: 'pointer',
    border: '0',
    // Longhand, not `background: 'none'`: a shorthand reset shares its
    // conflict keys with every background longhand, so cx() would drop
    // this whole class wherever a later class sets background-image
    // (e.g. the category nav sprite) and the native button face would
    // show through.
    backgroundColor: 'transparent',
    outline: 'none'
  }
});

function ClickableEmojiButton(_ref) {
  var _cx;
  var emojiNames = _ref.emojiNames,
    unified = _ref.unified,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    _ref$showVariations = _ref.showVariations,
    showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations,
    hasVariations = _ref.hasVariations,
    children = _ref.children,
    className = _ref.className,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    style = _ref.style;
  return createElement(Button, {
    className: cx(styles$2.emoji, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch, (_cx = {}, _cx[ClassNames.visible] = !hidden && !hiddenOnSearch, _cx), !!(hasVariations && showVariations) && styles$2.hasVariations, noBackground && styles$2.noBackground, className),
    "data-unified": unified,
    "aria-label": getAriaLabel(emojiNames),
    "data-full-name": emojiNames,
    style: style
  }, children);
}
function getAriaLabel(emojiNames) {
  return emojiNames[emojiNames.length - 1];
}
var styles$2 = /*#__PURE__*/stylesheet.create({
  emoji: {
    '.': ClassNames.emoji,
    position: 'relative',
    width: 'var(--epr-emoji-fullsize)',
    height: 'var(--epr-emoji-fullsize)',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: 'var(--epr-emoji-fullsize)',
    maxHeight: 'var(--epr-emoji-fullsize)',
    borderRadius: '8px',
    overflow: 'hidden',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: 'var(--epr-emoji-hover-color)'
    },
    ':focus': {
      backgroundColor: 'var(--epr-focus-bg-color)'
    }
  },
  noBackground: {
    background: 'none',
    ':hover': {
      backgroundColor: 'transparent',
      background: 'none'
    },
    ':focus': {
      backgroundColor: 'transparent',
      background: 'none'
    }
  },
  hasVariations: {
    '.': ClassNames.emojiHasVariations,
    ':after': {
      content: '',
      display: 'block',
      width: '0',
      height: '0',
      right: '0px',
      bottom: '1px',
      position: 'absolute',
      borderLeft: '4px solid transparent',
      borderRight: '4px solid transparent',
      transform: 'rotate(135deg)',
      borderBottom: '4px solid var(--epr-emoji-variation-indicator-color)',
      zIndex: 'var(--epr-emoji-variations-indictator-z-index)'
    },
    ':hover:after': {
      borderBottom: '4px solid var(--epr-emoji-variation-indicator-color-hover)'
    }
  }
});

var emojiStyles = /*#__PURE__*/stylesheet.create({
  external: {
    '.': ClassNames.external,
    fontSize: '0'
  },
  common: {
    alignSelf: 'center',
    justifySelf: 'center',
    display: 'block'
  }
});

function EmojiImg(_ref) {
  var emojiName = _ref.emojiName,
    style = _ref.style,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    imgUrl = _ref.imgUrl,
    onError = _ref.onError,
    className = _ref.className;
  return createElement("img", {
    src: imgUrl,
    alt: emojiName,
    className: cx(styles$3.emojiImag, emojiStyles.external, emojiStyles.common, className),
    loading: lazyLoad ? 'lazy' : 'eager',
    onError: onError,
    style: style
  });
}
var styles$3 = /*#__PURE__*/stylesheet.create({
  emojiImag: {
    '.': 'epr-emoji-img',
    maxWidth: 'var(--epr-emoji-fullsize)',
    maxHeight: 'var(--epr-emoji-fullsize)',
    minWidth: 'var(--epr-emoji-fullsize)',
    minHeight: 'var(--epr-emoji-fullsize)',
    padding: 'var(--epr-emoji-padding)'
  }
});

function NativeEmoji(_ref) {
  var unified = _ref.unified,
    style = _ref.style,
    className = _ref.className;
  return createElement("span", {
    className: cx(
    // Order matters: cx() lets the later class win same-property
    // conflicts, so the zeroing reset must come first and the real
    // font-size last — otherwise the emoji renders at 0px.
    emojiStyles.external, emojiStyles.common, styles$4.nativeEmoji, className),
    "data-unified": unified,
    style: style
  }, parseNativeEmoji(unified));
}
var styles$4 = /*#__PURE__*/stylesheet.create({
  nativeEmoji: {
    '.': 'epr-emoji-native',
    fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
    position: 'relative',
    lineHeight: '100%',
    fontSize: 'var(--epr-emoji-size)',
    textAlign: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    letterSpacing: '0',
    padding: 'var(--epr-emoji-padding)'
  }
});

function ViewOnlyEmoji(_ref) {
  var emoji = _ref.emoji,
    unified = _ref.unified,
    emojiStyle = _ref.emojiStyle,
    size = _ref.size,
    lazyLoad = _ref.lazyLoad,
    _ref$getEmojiUrl = _ref.getEmojiUrl,
    getEmojiUrl = _ref$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref$getEmojiUrl,
    className = _ref.className;
  var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(),
    setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  var style = {};
  if (size) {
    style.width = style.height = style.fontSize = size + "px";
  }
  var emojiToRender = emoji ? emoji : emojiByUnified(unified);
  if (!emojiToRender) {
    return null;
  }
  if (isCustomEmoji(emojiToRender)) {
    return createElement(EmojiImg, {
      style: style,
      emojiName: unified,
      emojiStyle: EmojiStyle.NATIVE,
      lazyLoad: lazyLoad,
      imgUrl: emojiToRender.imgUrl,
      onError: onError,
      className: className
    });
  }
  return createElement(Fragment$2, null, emojiStyle === EmojiStyle.NATIVE ? createElement(NativeEmoji, {
    unified: unified,
    style: style,
    className: className
  }) : createElement(EmojiImg, {
    style: style,
    emojiName: emojiName(emojiToRender),
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    imgUrl: getEmojiUrl(unified, emojiStyle),
    onError: onError,
    className: className
  }));
  function onError() {
    setEmojisThatFailedToLoad(function (prev) {
      return new Set(prev).add(unified);
    });
  }
}

function ClickableEmoji(_ref) {
  var emoji = _ref.emoji,
    unified = _ref.unified,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    emojiStyle = _ref.emojiStyle,
    _ref$showVariations = _ref.showVariations,
    showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations,
    size = _ref.size,
    lazyLoad = _ref.lazyLoad,
    getEmojiUrl = _ref.getEmojiUrl,
    className = _ref.className,
    _ref$noBackground = _ref.noBackground,
    noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground,
    style = _ref.style;
  var hasVariations = emojiHasVariations(emoji);
  return createElement(ClickableEmojiButton, {
    hasVariations: hasVariations,
    showVariations: showVariations,
    hidden: hidden,
    hiddenOnSearch: hiddenOnSearch,
    emojiNames: emojiNames(emoji),
    unified: unified,
    noBackground: noBackground,
    style: style
  }, createElement(ViewOnlyEmoji, {
    unified: unified,
    emoji: emoji,
    size: size,
    emojiStyle: emojiStyle,
    lazyLoad: lazyLoad,
    getEmojiUrl: getEmojiUrl,
    className: className
  }));
}

var Plus = 'data:image/svg+xml;base64,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';

function BtnPlus() {
  var _useReactionsModeStat = useReactionsModeState(),
    setReactionsMode = _useReactionsModeStat[1];
  return createElement(Button, {
    "aria-label": "Show all Emojis",
    title: "Show all Emojis",
    tabIndex: 0,
    className: cx(styles$5.plusSign),
    onClick: function onClick() {
      return setReactionsMode(false);
    }
  });
}
var styles$5 = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  plusSign: {
    fontSize: '20px',
    padding: '17px',
    color: 'var(--epr-text-color)',
    borderRadius: '50%',
    textAlign: 'center',
    lineHeight: '100%',
    width: '20px',
    height: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transition: 'background-color 0.2s ease-in-out',
    ':after': {
      content: '',
      minWidth: '20px',
      minHeight: '20px',
      backgroundImage: "url(" + Plus + ")",
      backgroundColor: 'transparent',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '20px',
      backgroundPositionY: '0'
    },
    ':hover': {
      color: 'var(--epr-highlight-color)',
      backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
      ':after': {
        backgroundPositionY: '-20px'
      }
    },
    ':focus': {
      color: 'var(--epr-highlight-color)',
      backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
      ':after': {
        backgroundPositionY: '-40px'
      }
    }
  }
}, /*#__PURE__*/darkMode('plusSign', {
  ':after': {
    backgroundPositionY: '-40px'
  },
  ':hover:after': {
    backgroundPositionY: '-60px'
  }
})));

function Reactions() {
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsOpen = _useReactionsModeStat[0];
  var ReactionsRef = useReactionsRef();
  var reactions = useReactionsConfig();
  useMouseDownHandlers(ReactionsRef, MOUSE_EVENT_SOURCE.REACTIONS);
  var emojiStyle = useEmojiStyleConfig();
  var allowExpandReactions = useAllowExpandReactions();
  var getEmojiUrl = useGetEmojiUrlConfig();
  if (!reactionsOpen) {
    return null;
  }
  return createElement("ul", {
    className: cx(styles$6.list, !reactionsOpen && commonStyles.hidden),
    ref: ReactionsRef,
    "aria-label": "Reactions"
  }, reactions.map(function (reaction) {
    var emoji = emojiByUnified(reaction);
    if (!emoji) {
      return null;
    }
    return createElement("li", {
      key: reaction
    }, createElement(ClickableEmoji, {
      emoji: emoji,
      emojiStyle: emojiStyle,
      unified: reaction,
      showVariations: false,
      className: cx(styles$6.emojiButton),
      noBackground: true,
      getEmojiUrl: getEmojiUrl
    }));
  }), allowExpandReactions ? createElement("li", null, createElement(BtnPlus, null)) : null);
}
var styles$6 = /*#__PURE__*/stylesheet.create({
  list: {
    listStyle: 'none',
    margin: '0',
    padding: '0 5px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '100%'
  },
  emojiButton: {
    ':hover': {
      transform: 'scale(1.2)'
    },
    ':focus': {
      transform: 'scale(1.2)'
    },
    ':active': {
      transform: 'scale(1.1)'
    },
    transition: 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)'
  }
});

function useOnScroll(BodyRef) {
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var _useState = useState(0),
    scrollTop = _useState[0],
    setScrollTop = _useState[1];
  useEffect(function () {
    var bodyRef = BodyRef.current;
    if (!bodyRef) {
      return;
    }
    bodyRef.addEventListener('scroll', onScroll, {
      passive: true
    });
    function onScroll() {
      var _bodyRef$scrollTop;
      setScrollTop((_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0);
      closeAllOpenToggles();
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('scroll', onScroll);
    };
  }, [BodyRef, closeAllOpenToggles]);
  return scrollTop;
}

function shouldVirtualize(_ref) {
  var scrollTop = _ref.scrollTop,
    clientHeight = _ref.clientHeight,
    topOffset = _ref.topOffset,
    style = _ref.style,
    dimensions = _ref.dimensions;
  if (!style || !dimensions) {
    return false;
  }
  var emojiTop = topOffset + style.top;
  var emojiBottom = emojiTop + dimensions.emojiSize;
  var isVisible = emojiBottom + dimensions.emojiSize * 2 >= scrollTop && emojiTop <= scrollTop + clientHeight + dimensions.emojiSize;
  return !isVisible;
}
function getEmojiPositionStyle(dimensions, index) {
  return dimensions ? {
    top: Math.floor(index / dimensions.emojisPerRow) * dimensions.emojiSize,
    left: index % dimensions.emojisPerRow * dimensions.emojiSize
  } : undefined;
}

var EMOJI_SIZE_DEFAULT = 40;
function useCategoryHeight(emojiCount) {
  var EmojiListRef = useEmojiListRef();
  var _useReactionsModeStat = useReactionsModeState(),
    isReactionsMode = _useReactionsModeStat[0];
  var PickerMainRef = usePickerMainRef();
  var emojiSizeRef = useRef();
  var _useVisibleCategories = useVisibleCategoriesState(),
    visibleCategories = _useVisibleCategories[0];
  var _useEmojiSizeState = useEmojiSizeState(),
    emojiSizeFromContext = _useEmojiSizeState[0];
  var _React$useState = useState(),
    dimensions = _React$useState[0],
    setDimensions = _React$useState[1];
  // Helper to compute and store dimensions based on current DOM
  var computeAndSetDimensions = useCallback(function () {
    var listEl = EmojiListRef.current;
    if (!listEl) return;
    var emojiElement = listEl.querySelector(EmojiButtonSelector);
    var measured = emojiElement == null ? void 0 : emojiElement.clientHeight;
    if (measured) {
      emojiSizeRef.current = measured;
    }
    var emojiSize = emojiSizeFromContext || measured || emojiSizeRef.current || EMOJI_SIZE_DEFAULT;
    var pickerWidth = listEl.clientWidth;
    if (pickerWidth === 0 || emojiSize === 0) return;
    var emojisPerRow = Math.max(1, Math.floor(pickerWidth / emojiSize));
    var rowCount = Math.ceil(emojiCount / emojisPerRow);
    var categoryHeight = rowCount * emojiSize;
    setDimensions({
      categoryHeight: categoryHeight,
      emojisPerRow: emojisPerRow,
      emojiSize: emojiSize
    });
  }, [EmojiListRef, emojiCount, emojiSizeFromContext]);
  // Recompute on data-count changes and when reactions mode toggles
  useEffect(function () {
    computeAndSetDimensions();
  }, [emojiCount, isReactionsMode, computeAndSetDimensions, visibleCategories.length]);
  // Listen to transitionend on the picker root (where height transition occurs)
  useEffect(function () {
    var rootEl = PickerMainRef.current;
    if (!rootEl) return;
    var handler = function handler(e) {
      var te = e;
      var prop = te.propertyName;
      if (prop === 'width' || prop === 'max-width' || prop === 'min-width' || prop === 'height' || prop === 'max-height' || prop === 'min-height') {
        if (typeof queueMicrotask === 'function') {
          queueMicrotask(function () {
            return computeAndSetDimensions();
          });
        } else {
          requestAnimationFrame(function () {
            return computeAndSetDimensions();
          });
        }
      }
    };
    rootEl.addEventListener('transitionend', handler, {
      passive: true
    });
    return function () {
      rootEl.removeEventListener('transitionend', handler);
    };
  }, [PickerMainRef, computeAndSetDimensions]);
  return dimensions;
}

function useIsEmojiHidden() {
  var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(),
    emojisThatFailedToLoad = _useEmojisThatFailedT[0];
  var isEmojiFiltered = useIsEmojiFiltered();
  return function (emoji) {
    var unified = emojiUnified(emoji);
    var failedToLoad = emojisThatFailedToLoad.has(unified);
    var filteredOut = isEmojiFiltered(unified);
    return {
      failedToLoad: failedToLoad,
      filteredOut: filteredOut,
      hidden: failedToLoad || filteredOut
    };
  };
}

function useEmojiVirtualization(_ref) {
  var categoryEmojis = _ref.categoryEmojis,
    topOffset = _ref.topOffset,
    onHeightReady = _ref.onHeightReady,
    scrollTop = _ref.scrollTop,
    isCategoryVisible = _ref.isCategoryVisible;
  var isEmojiHidden = useIsEmojiHidden();
  var lazyLoadEmojis = useLazyLoadEmojisConfig();
  var emojiStyle = useEmojiStyleConfig();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var isEmojiDisallowed = useIsEmojiDisallowed();
  var getEmojiUrl = useGetEmojiUrlConfig();
  var showVariations = !useSkinTonesDisabledConfig();
  var BodyRef = useBodyRef();
  var virtualizedCounter = 0;
  var emojisToPush = categoryEmojis.filter(function (emoji) {
    var isDisallowed = isEmojiDisallowed(emoji);
    var _isEmojiHidden = isEmojiHidden(emoji),
      failedToLoad = _isEmojiHidden.failedToLoad,
      filteredOut = _isEmojiHidden.filteredOut,
      hidden = _isEmojiHidden.hidden;
    return !failedToLoad && !filteredOut && !hidden && !isDisallowed;
  });
  var dimensions = useCategoryHeight(emojisToPush.length);
  useEffect(function () {
    if (dimensions) {
      onHeightReady(dimensions.categoryHeight);
    }
  }, [dimensions, onHeightReady, emojisToPush.length]);
  var isVirtualized = function isVirtualized(style) {
    var _BodyRef$current$clie, _BodyRef$current;
    return dimensions && BodyRef.current && shouldVirtualize({
      scrollTop: scrollTop,
      clientHeight: (_BodyRef$current$clie = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.clientHeight) != null ? _BodyRef$current$clie : 0,
      topOffset: topOffset,
      style: style,
      dimensions: dimensions
    });
  };
  var emojis = emojisToPush.reduce(function (accumulator, emoji, index) {
    var unified = emojiUnified(emoji, activeSkinTone);
    var style = getEmojiPositionStyle(dimensions, index);
    if (isVirtualized(style)) {
      var _BodyRef$current$clie2, _BodyRef$current2;
      virtualizedCounter++;
      preloadEmojiIfNeeded(emoji, emojiStyle, scrollTop, (_BodyRef$current$clie2 = (_BodyRef$current2 = BodyRef.current) == null ? void 0 : _BodyRef$current2.clientHeight) != null ? _BodyRef$current$clie2 : 0, topOffset, style, dimensions, getEmojiUrl);
      return accumulator;
    }
    if (!isCategoryVisible) {
      virtualizedCounter++;
      return accumulator;
    }
    accumulator.push(createElement(ClickableEmoji, {
      showVariations: showVariations,
      key: unified,
      emoji: emoji,
      unified: unified,
      emojiStyle: emojiStyle,
      lazyLoad: lazyLoadEmojis,
      getEmojiUrl: getEmojiUrl,
      style: _extends({}, style, {
        position: 'absolute'
      })
    }));
    return accumulator;
  }, []);
  return {
    virtualizedCounter: virtualizedCounter,
    emojis: emojis,
    dimensions: dimensions
  };
}

function EmojiCategory(_ref) {
  var categoryConfig = _ref.categoryConfig,
    children = _ref.children,
    hidden = _ref.hidden,
    hiddenOnSearch = _ref.hiddenOnSearch,
    height = _ref.height;
  var category = categoryFromCategoryConfig(categoryConfig);
  var categoryName = categoryNameFromCategoryConfig(categoryConfig);
  return createElement("li", {
    className: cx(styles$7.category, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch),
    "data-name": category,
    "aria-label": categoryName
  }, createElement("h2", {
    className: cx(styles$7.label)
  }, categoryName), createElement("div", {
    className: cx(styles$7.categoryContent),
    style: {
      height: height
    }
  }, children));
}
var styles$7 = /*#__PURE__*/stylesheet.create({
  category: {
    '.': ClassNames.category,
    minHeight: 'calc(var(--epr-emoji-fullsize) + var(--epr-category-label-height))',
    position: 'relative'
  },
  categoryContent: {
    '.': ClassNames.categoryContent,
    display: 'grid',
    gridGap: '0',
    gridTemplateColumns: 'repeat(auto-fill, var(--epr-emoji-fullsize))',
    justifyContent: 'space-between',
    margin: 'var(--epr-category-padding)',
    position: 'relative'
  },
  label: {
    '.': ClassNames.label,
    alignItems: 'center',
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(3px)',
    backgroundColor: 'var(--epr-category-label-bg-color)',
    color: 'var(--epr-category-label-text-color)',
    display: 'flex',
    fontSize: '16px',
    fontWeight: 'bold',
    height: 'var(--epr-category-label-height)',
    margin: '0',
    padding: 'var(--epr-category-label-padding)',
    position: 'sticky',
    textTransform: 'capitalize',
    top: '0',
    width: '100%',
    zIndex: 'var(--epr-category-label-z-index)'
  }
});

// `useLayoutEffect` warns during SSR since it never runs on the server.
// Fall back to `useEffect` there: measurement only matters on the client.
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

function MeasureEmoji() {
  var categories = useCategoriesConfig();
  var getEmojisByCategory = useGetEmojisByCategory();
  var emojiStyle = useEmojiStyleConfig();
  var getEmojiUrl = useGetEmojiUrlConfig();
  var lazyLoadEmojis = useLazyLoadEmojisConfig();
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0];
  var _useEmojiSizeState = useEmojiSizeState(),
    emojiSize = _useEmojiSizeState[0],
    setEmojiSize = _useEmojiSizeState[1];
  var ref = useRef(null);
  useIsomorphicLayoutEffect(function () {
    if (ref.current) {
      setEmojiSize(ref.current.clientHeight);
    }
  });
  if (emojiSize) {
    return null;
  }
  var firstCategory = categories[0];
  var dummyEmoji = getEmojisByCategory(categoryFromCategoryConfig(firstCategory))[0];
  var unified = dummyEmoji ? emojiUnified(dummyEmoji, activeSkinTone) : '';
  if (!dummyEmoji) {
    return null;
  }
  return createElement("div", {
    ref: ref
  }, createElement(ClickableEmoji, {
    emoji: dummyEmoji,
    unified: unified,
    emojiStyle: emojiStyle,
    getEmojiUrl: getEmojiUrl,
    lazyLoad: lazyLoadEmojis,
    showVariations: false,
    hidden: false,
    style: {
      opacity: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: -1,
      height: 'var(--epr-emoji-fullsize)',
      width: 'var(--epr-emoji-fullsize)'
    }
  }));
}

function EmojiList(_ref) {
  var scrollTop = _ref.scrollTop;
  var categories = useCategoriesConfig();
  var _React$useState = useState({}),
    categoryHeights = _React$useState[0],
    setCategoryHeights = _React$useState[1];
  var EmojiListRef = useEmojiListRef();
  var getEmojisByCategory = useGetEmojisByCategory();
  var labelHeight = getLabelHeight(EmojiListRef.current);
  var topOffset = 0;
  return createElement("ul", {
    className: cx(styles$8.emojiList),
    ref: EmojiListRef
  }, createElement(MeasureEmoji, null), categories.map(function (categoryConfig) {
    var category = categoryFromCategoryConfig(categoryConfig);
    var currentOffset = topOffset;
    var categoryHeight = categoryHeights[category];
    if (categoryHeight) {
      topOffset += categoryHeight + labelHeight;
    }
    return createElement(RenderCategory, {
      key: category,
      categoryEmojis: getEmojisByCategory(category),
      categoryConfig: categoryConfig,
      topOffset: currentOffset,
      onHeightReady: function onHeightReady(height) {
        if (categoryHeights[category] !== height) {
          setCategoryHeights(function (prev) {
            var _extends2;
            return _extends({}, prev, (_extends2 = {}, _extends2[category] = height, _extends2));
          });
        }
      },
      scrollTop: scrollTop
    });
  }));
}
function RenderCategory(_ref2) {
  var categoryEmojis = _ref2.categoryEmojis,
    categoryConfig = _ref2.categoryConfig,
    topOffset = _ref2.topOffset,
    onHeightReady = _ref2.onHeightReady,
    scrollTop = _ref2.scrollTop;
  var _useVisibleCategories = useVisibleCategoriesState(),
    visibleCategories = _useVisibleCategories[0];
  var _useEmojiVirtualizati = useEmojiVirtualization({
      categoryEmojis: categoryEmojis,
      topOffset: topOffset,
      onHeightReady: onHeightReady,
      scrollTop: scrollTop,
      isCategoryVisible: visibleCategories.includes(categoryConfig.category)
    }),
    virtualizedCounter = _useEmojiVirtualizati.virtualizedCounter,
    emojis = _useEmojiVirtualizati.emojis,
    dimensions = _useEmojiVirtualizati.dimensions;
  return createElement(EmojiCategory, {
    categoryConfig: categoryConfig,
    height: dimensions == null ? void 0 : dimensions.categoryHeight,
    // Indicates that there are no visible emojis
    // Hence, the category should be hidden
    hidden: !emojis.length && virtualizedCounter === 0
  }, emojis);
}
var styles$8 = /*#__PURE__*/stylesheet.create({
  emojiList: {
    '.': ClassNames.emojiList,
    listStyle: 'none',
    margin: '0',
    padding: '0'
  }
});

var SVGTriangle = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=';

var Direction;
(function (Direction) {
  Direction[Direction["Up"] = 0] = "Up";
  Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
// eslint-disable-next-line complexity
function EmojiVariationPicker() {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  var VariationPickerRef = useVariationPickerRef();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    emoji = _useEmojiVariationPic[0];
  var emojiStyle = useEmojiStyleConfig();
  var _useVariationPickerTo = useVariationPickerTop(VariationPickerRef),
    getTop = _useVariationPickerTo.getTop,
    getMenuDirection = _useVariationPickerTo.getMenuDirection;
  var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
  var getPointerStyle = usePointerStyle(VariationPickerRef);
  var getEmojiUrl = useGetEmojiUrlConfig();
  var button = buttonFromTarget(AnchoredEmojiRef.current);
  var visible = Boolean(emoji && button && emojiHasVariations(emoji) && button.classList.contains(ClassNames.emojiHasVariations));
  useEffect(function () {
    if (!visible) {
      return;
    }
    focusFirstVisibleEmoji(VariationPickerRef.current);
  }, [VariationPickerRef, visible, AnchoredEmojiRef]);
  var top, pointerStyle;
  if (!visible && AnchoredEmojiRef.current) {
    setAnchoredEmojiRef(null);
  } else {
    top = getTop();
    pointerStyle = getPointerStyle();
  }
  return createElement("div", {
    ref: VariationPickerRef,
    className: cx(styles$9.variationPicker, getMenuDirection() === Direction.Down && styles$9.pointingUp, visible && styles$9.visible),
    style: {
      top: top
    }
  }, visible && emoji ? [emojiUnified(emoji)].concat(emojiVariations(emoji)).slice(0, 6).map(function (unified) {
    return createElement(ClickableEmoji, {
      key: unified,
      emoji: emoji,
      unified: unified,
      emojiStyle: emojiStyle,
      showVariations: false,
      getEmojiUrl: getEmojiUrl
    });
  }) : null, createElement("div", {
    className: cx(styles$9.pointer),
    style: pointerStyle
  }));
}
function usePointerStyle(VariationPickerRef) {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  return function getPointerStyle() {
    var style = {};
    if (!VariationPickerRef.current) {
      return style;
    }
    if (AnchoredEmojiRef.current) {
      var button = buttonFromTarget(AnchoredEmojiRef.current);
      var offsetLeft = emojiTruOffsetLeft(button);
      if (!button) {
        return style;
      }
      // half of the button
      style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
    }
    return style;
  };
}
function useVariationPickerTop(VariationPickerRef) {
  var AnchoredEmojiRef = useAnchoredEmojiRef();
  var BodyRef = useBodyRef();
  var direction = Direction.Up;
  return {
    getMenuDirection: getMenuDirection,
    getTop: getTop
  };
  function getMenuDirection() {
    return direction;
  }
  function getTop() {
    direction = Direction.Up;
    var emojiOffsetTop = 0;
    if (!VariationPickerRef.current) {
      return 0;
    }
    var height = elementHeight(VariationPickerRef.current);
    if (AnchoredEmojiRef.current) {
      var _bodyRef$scrollTop;
      var bodyRef = BodyRef.current;
      var button = buttonFromTarget(AnchoredEmojiRef.current);
      var buttonHeight = elementHeight(button);
      emojiOffsetTop = emojiTrueOffsetTop(button);
      var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
      if (scrollTop > emojiOffsetTop - height) {
        direction = Direction.Down;
        emojiOffsetTop += buttonHeight + height;
      }
    }
    return emojiOffsetTop - height;
  }
}
var styles$9 = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  variationPicker: {
    '.': ClassNames.variationPicker,
    position: 'absolute',
    right: '15px',
    left: '15px',
    padding: '5px',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    opacity: '0',
    visibility: 'hidden',
    pointerEvents: 'none',
    top: '-100%',
    border: '1px solid var(--epr-picker-border-color)',
    height: 'var(--epr-emoji-variation-picker-height)',
    zIndex: 'var(--epr-skin-variation-picker-z-index)',
    background: 'var(--epr-emoji-variation-picker-bg-color)',
    transform: 'scale(0.9)',
    transition: 'transform 0.1s ease-out, opacity 0.2s ease-out'
  },
  visible: {
    opacity: '1',
    visibility: 'visible',
    pointerEvents: 'all',
    transform: 'scale(1)'
  },
  pointingUp: {
    '.': 'pointing-up',
    transformOrigin: 'center 0%',
    transform: 'scale(0.9)'
  },
  '.pointing-up': {
    pointer: {
      top: '0',
      transform: 'rotate(180deg) translateY(100%) translateX(18px)'
    }
  },
  pointer: {
    '.': 'epr-emoji-pointer',
    content: '',
    position: 'absolute',
    width: '25px',
    height: '15px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    backgroundSize: '50px 15px',
    top: '100%',
    transform: 'translateX(-18px)',
    backgroundImage: "url(" + SVGTriangle + ")"
  }
}, /*#__PURE__*/darkMode('pointer', {
  backgroundPosition: '-25px 0'
})));

function Body() {
  var BodyRef = useBodyRef();
  var scrollTop = useOnScroll(BodyRef);
  useMouseDownHandlers(BodyRef, MOUSE_EVENT_SOURCE.PICKER);
  useOnMouseMove();
  return createElement("div", {
    className: cx(styles$a.body, commonInteractionStyles.hiddenOnReactions),
    ref: BodyRef
  }, createElement(EmojiVariationPicker, null), createElement(EmojiList, {
    scrollTop: scrollTop
  }));
}
var styles$a = /*#__PURE__*/stylesheet.create({
  body: {
    '.': ClassNames.scrollBody,
    flex: '1',
    overflowY: 'scroll',
    overflowX: 'hidden',
    position: 'relative'
  }
});

function detectEmojyPartiallyBelowFold(button, bodyRef) {
  if (!button || !bodyRef) {
    return 0;
  }
  var buttonRect = button.getBoundingClientRect();
  var bodyRect = bodyRef.getBoundingClientRect();
  // If the element is obscured by at least half of its size
  return bodyRect.height - (buttonRect.y - bodyRect.y);
}

function useEmojiPreviewEvents(allow, setPreviewEmoji) {
  var BodyRef = useBodyRef();
  var isMouseDisallowed = useIsMouseDisallowed();
  var allowMouseMove = useAllowMouseMove();
  useEffect(function () {
    if (!allow) {
      return;
    }
    var bodyRef = BodyRef.current;
    bodyRef == null ? void 0 : bodyRef.addEventListener('keydown', onEscape, {
      passive: true
    });
    bodyRef == null ? void 0 : bodyRef.addEventListener('mouseover', onMouseOver, true);
    bodyRef == null ? void 0 : bodyRef.addEventListener('focus', onEnter, true);
    bodyRef == null ? void 0 : bodyRef.addEventListener('mouseout', onLeave, {
      passive: true
    });
    bodyRef == null ? void 0 : bodyRef.addEventListener('blur', onLeave, true);
    function onEnter(e) {
      var button = buttonFromTarget(e.target);
      if (!button) {
        return onLeave();
      }
      var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(button),
        unified = _allUnifiedFromEmojiE.unified,
        originalUnified = _allUnifiedFromEmojiE.originalUnified;
      if (!unified || !originalUnified) {
        return onLeave();
      }
      setPreviewEmoji({
        unified: unified,
        originalUnified: originalUnified
      });
    }
    function onLeave(e) {
      if (e) {
        var relatedTarget = e.relatedTarget;
        if (!buttonFromTarget(relatedTarget)) {
          return setPreviewEmoji(null);
        }
      }
      setPreviewEmoji(null);
    }
    function onEscape(e) {
      if (e.key === 'Escape') {
        setPreviewEmoji(null);
      }
    }
    function onMouseOver(e) {
      if (isMouseDisallowed()) {
        return;
      }
      var button = buttonFromTarget(e.target);
      if (button) {
        var belowFoldByPx = detectEmojyPartiallyBelowFold(button, bodyRef);
        var buttonHeight = button.getBoundingClientRect().height;
        if (belowFoldByPx < buttonHeight) {
          return handlePartiallyVisibleElementFocus(button, setPreviewEmoji);
        }
        focusElement(button);
      }
    }
    return function () {
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mouseover', onMouseOver);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('mouseout', onLeave);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('focus', onEnter, true);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('blur', onLeave, true);
      bodyRef == null ? void 0 : bodyRef.removeEventListener('keydown', onEscape);
    };
  }, [BodyRef, allow, setPreviewEmoji, isMouseDisallowed, allowMouseMove]);
}
function handlePartiallyVisibleElementFocus(button, setPreviewEmoji) {
  var _document$activeEleme;
  var _allUnifiedFromEmojiE2 = allUnifiedFromEmojiElement(button),
    unified = _allUnifiedFromEmojiE2.unified,
    originalUnified = _allUnifiedFromEmojiE2.originalUnified;
  if (!unified || !originalUnified) {
    return;
  }
  (_document$activeEleme = document.activeElement) == null ? void 0 : _document$activeEleme.blur == null ? void 0 : _document$activeEleme.blur();
  setPreviewEmoji({
    unified: unified,
    originalUnified: originalUnified
  });
}

var _stylesheet$create;
var FlexDirection;
(function (FlexDirection) {
  FlexDirection["ROW"] = "FlexRow";
  FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
function Flex(_ref) {
  var children = _ref.children,
    className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? FlexDirection.ROW : _ref$direction;
  return createElement("div", {
    style: _extends({}, style),
    className: cx(styles$b.flex, className, styles$b[direction])
  }, children);
}
var styles$b = /*#__PURE__*/stylesheet.create((_stylesheet$create = {
  flex: {
    display: 'flex'
  }
}, _stylesheet$create[FlexDirection.ROW] = {
  flexDirection: 'row'
}, _stylesheet$create[FlexDirection.COLUMN] = {
  flexDirection: 'column'
}, _stylesheet$create));

function Space(_ref) {
  var className = _ref.className,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style;
  return createElement("div", {
    style: _extends({
      flex: 1
    }, style),
    className: cx(className)
  });
}

function Absolute(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return createElement("div", {
    style: _extends({}, style, {
      position: 'absolute'
    }),
    className: className
  }, children);
}

function Relative(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style;
  return createElement("div", {
    style: _extends({}, style, {
      position: 'relative'
    }),
    className: className
  }, children);
}

// eslint-disable-next-line complexity
function BtnSkinToneVariation(_ref) {
  var isOpen = _ref.isOpen,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    skinToneVariation = _ref.skinToneVariation,
    style = _ref.style;
  return createElement(Button, {
    style: style,
    onClick: onClick,
    className: cx("epr-tone-" + skinToneVariation, styles$c.tone, !isOpen && styles$c.closedTone, isActive && styles$c.active),
    "aria-pressed": isActive,
    "aria-label": "Skin tone " + skinTonesNamed[skinToneVariation]
  });
}
var styles$c = /*#__PURE__*/stylesheet.create({
  closedTone: {
    opacity: '0',
    zIndex: '0'
  },
  active: {
    '.': 'epr-active',
    zIndex: '1',
    opacity: '1'
  },
  tone: {
    '.': 'epr-tone',
    width: 'var(--epr-skin-tone-size)',
    display: 'block',
    cursor: 'pointer',
    borderRadius: '4px',
    height: 'var(--epr-skin-tone-size)',
    position: 'absolute',
    right: '0',
    transition: 'transform 0.3s ease-in-out, opacity 0.35s ease-in-out',
    zIndex: '0',
    border: '1px solid var(--epr-skin-tone-outer-border-color)',
    boxShadow: 'inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)',
    ':hover': {
      boxShadow: '0 0 0 3px var(--epr-active-skin-hover-color), inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)'
    },
    ':focus': {
      boxShadow: '0 0 0 3px var(--epr-focus-bg-color)'
    },
    '&.epr-tone-neutral': {
      backgroundColor: '#ffd225'
    },
    '&.epr-tone-1f3fb': {
      backgroundColor: '#ffdfbd'
    },
    '&.epr-tone-1f3fc': {
      backgroundColor: '#e9c197'
    },
    '&.epr-tone-1f3fd': {
      backgroundColor: '#c88e62'
    },
    '&.epr-tone-1f3fe': {
      backgroundColor: '#a86637'
    },
    '&.epr-tone-1f3ff': {
      backgroundColor: '#60463a'
    }
  }
});

/* eslint-disable complexity */
var ITEM_SIZE = 28;
function SkinTonePickerMenu() {
  return createElement(Relative, {
    style: {
      height: ITEM_SIZE
    }
  }, createElement(Absolute, {
    style: {
      bottom: 0,
      right: 0
    }
  }, createElement(SkinTonePicker, {
    direction: SkinTonePickerDirection.VERTICAL
  })));
}
function SkinTonePicker(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? SkinTonePickerDirection.HORIZONTAL : _ref$direction;
  var SkinTonePickerRef = useSkinTonePickerRef();
  var isDisabled = useSkinTonesDisabledConfig();
  var _useSkinToneFanOpenSt = useSkinToneFanOpenState(),
    isOpen = _useSkinToneFanOpenSt[0],
    setIsOpen = _useSkinToneFanOpenSt[1];
  var _useActiveSkinToneSta = useActiveSkinToneState(),
    activeSkinTone = _useActiveSkinToneSta[0],
    setActiveSkinTone = _useActiveSkinToneSta[1];
  var onSkinToneChange = useOnSkinToneChangeConfig();
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var focusSearchInput = useFocusSearchInput();
  if (isDisabled) {
    return null;
  }
  var fullWidth = ITEM_SIZE * skinToneVariations.length + "px";
  var expandedSize = isOpen ? fullWidth : ITEM_SIZE + 'px';
  var vertical = direction === SkinTonePickerDirection.VERTICAL;
  return createElement(Relative, {
    className: cx(styles$d.skinTones, vertical && styles$d.vertical, isOpen && styles$d.open, vertical && isOpen && styles$d.verticalShadow),
    style: vertical ? {
      flexBasis: expandedSize,
      height: expandedSize
    } : {
      flexBasis: expandedSize
    }
  }, createElement("div", {
    className: cx(styles$d.select),
    ref: SkinTonePickerRef
  }, skinToneVariations.map(function (skinToneVariation, i) {
    var active = skinToneVariation === activeSkinTone;
    return createElement(BtnSkinToneVariation, {
      key: skinToneVariation,
      skinToneVariation: skinToneVariation,
      isOpen: isOpen,
      style: {
        transform: cx(vertical ? "translateY(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)", isOpen && active && 'scale(1.3)')
      },
      isActive: active,
      onClick: function onClick() {
        if (isOpen) {
          setActiveSkinTone(skinToneVariation);
          onSkinToneChange(skinToneVariation);
          focusSearchInput();
        } else {
          setIsOpen(true);
        }
        closeAllOpenToggles();
      }
    });
  })));
}
var SkinTonePickerDirection;
(function (SkinTonePickerDirection) {
  SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
  SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var styles$d = /*#__PURE__*/stylesheet.create({
  skinTones: {
    '.': 'epr-skin-tones',
    '--': {
      '--epr-skin-tone-size': '15px'
    },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    transition: 'all 0.3s ease-in-out',
    padding: '10px 0'
  },
  vertical: {
    padding: '9px',
    alignItems: 'flex-end',
    flexDirection: 'column',
    borderRadius: '6px',
    border: '1px solid var(--epr-bg-color)'
  },
  verticalShadow: {
    boxShadow: '0px 0 7px var(--epr-picker-border-color)'
  },
  open: {
    // @ts-ignore - backdropFilter is not recognized.
    backdropFilter: 'blur(5px)',
    background: 'var(--epr-skin-tone-picker-menu-color)',
    '.epr-active': {
      border: '1px solid var(--epr-active-skin-tone-indicator-border-color)'
    }
  },
  select: {
    '.': 'epr-skin-tone-select',
    position: 'relative',
    width: 'var(--epr-skin-tone-size)',
    height: 'var(--epr-skin-tone-size)'
  }
});

function Preview() {
  var previewConfig = usePreviewConfig();
  var isSkinToneInPreview = useIsSkinToneInPreview();
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsOpen = _useReactionsModeStat[0];
  if (!previewConfig.showPreview) {
    return null;
  }
  return createElement(Flex, {
    className: cx(styles$e.preview, commonInteractionStyles.hiddenOnReactions, reactionsOpen && styles$e.hideOnReactions)
  }, createElement(PreviewBody, null), createElement(Space, null), isSkinToneInPreview ? createElement(SkinTonePickerMenu, null) : null);
}
function PreviewBody() {
  var _previewEmoji$unified;
  var previewConfig = usePreviewConfig();
  var _useState = useState(null),
    previewEmoji = _useState[0],
    setPreviewEmoji = _useState[1];
  var emojiStyle = useEmojiStyleConfig();
  var _useEmojiVariationPic = useEmojiVariationPickerState(),
    variationPickerEmoji = _useEmojiVariationPic[0];
  var getEmojiUrl = useGetEmojiUrlConfig();
  var _usePickerDataContext = usePickerDataContext(),
    emojiByUnified = _usePickerDataContext.emojiByUnified;
  useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
  var emoji = emojiByUnified((_previewEmoji$unified = previewEmoji == null ? void 0 : previewEmoji.unified) != null ? _previewEmoji$unified : previewEmoji == null ? void 0 : previewEmoji.originalUnified);
  var show = emoji != null && previewEmoji != null;
  return createElement(PreviewContent, null);
  function PreviewContent() {
    var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : emojiByUnified(previewConfig.defaultEmoji);
    if (!defaultEmoji) {
      return null;
    }
    var defaultText = variationPickerEmoji ? emojiName(variationPickerEmoji) : previewConfig.defaultCaption;
    return createElement(Fragment$2, null, createElement("div", null, show ? createElement(ViewOnlyEmoji, {
      unified: previewEmoji == null ? void 0 : previewEmoji.unified,
      emoji: emoji,
      emojiStyle: emojiStyle,
      size: 45,
      getEmojiUrl: getEmojiUrl,
      className: cx(styles$e.emoji)
    }) : defaultEmoji ? createElement(ViewOnlyEmoji, {
      unified: emojiUnified(defaultEmoji),
      emoji: defaultEmoji,
      emojiStyle: emojiStyle,
      size: 45,
      getEmojiUrl: getEmojiUrl,
      className: cx(styles$e.emoji)
    }) : null), createElement("div", {
      className: cx(styles$e.label)
    }, show ? emojiName(emoji) : defaultText));
  }
}
var styles$e = /*#__PURE__*/stylesheet.create({
  preview: {
    alignItems: 'center',
    borderTop: '1px solid var(--epr-preview-border-color)',
    height: 'var(--epr-preview-height)',
    padding: '0 var(--epr-horizontal-padding)',
    position: 'relative',
    zIndex: 'var(--epr-preview-z-index)'
  },
  label: {
    color: 'var(--epr-preview-text-color)',
    fontSize: 'var(--epr-preview-text-size)',
    padding: 'var(--epr-preview-text-padding)',
    textTransform: 'capitalize'
  },
  emoji: {
    padding: '0'
  },
  hideOnReactions: {
    opacity: '0',
    transition: 'opacity 0.5s ease-in-out'
  }
});

function categoryNameFromDom($category) {
  var _$category$getAttribu;
  return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute('data-name')) != null ? _$category$getAttribu : null;
}

function useActiveCategoryScrollDetection(_ref) {
  var setActiveCategory = _ref.setActiveCategory,
    setVisibleCategories = _ref.setVisibleCategories;
  var BodyRef = useBodyRef();
  useEffect(function () {
    var visibleCategories = new Map();
    var intersectingCategories = new Map();
    var bodyRef = BodyRef.current;
    var observer = new IntersectionObserver(function (entries) {
      if (!bodyRef) {
        return;
      }
      for (var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;) {
        var entry = _step.value;
        var _id = categoryNameFromDom(entry.target);
        if (!_id) {
          continue;
        }
        visibleCategories.set(_id, entry.intersectionRatio);
        intersectingCategories.set(_id, entry.isIntersecting);
      }
      var ratios = Array.from(visibleCategories);
      var visibleCats = ratios.filter(function (_ref2) {
        var id = _ref2[0],
          ratio = _ref2[1];
        return ratio > 0 || intersectingCategories.get(id);
      }).map(function (_ref3) {
        var id = _ref3[0];
        return id;
      });
      setVisibleCategories(visibleCats);
      var lastCategory = ratios[ratios.length - 1];
      if ((lastCategory == null ? void 0 : lastCategory[1]) == 1) {
        return setActiveCategory(lastCategory[0]);
      }
      for (var _i = 0, _ratios = ratios; _i < _ratios.length; _i++) {
        var _ratios$_i = _ratios[_i],
          id = _ratios$_i[0],
          ratio = _ratios$_i[1];
        if (ratio) {
          setActiveCategory(id);
          break;
        }
      }
    }, {
      root: bodyRef,
      threshold: [0, 1]
    });
    bodyRef == null ? void 0 : bodyRef.querySelectorAll(asSelectors(ClassNames.category)).forEach(function (el) {
      observer.observe(el);
    });
    return function () {
      observer.disconnect();
    };
  }, [BodyRef, setActiveCategory, setVisibleCategories]);
}

function useScrollCategoryIntoView() {
  var BodyRef = useBodyRef();
  var PickerMainRef = usePickerMainRef();
  return function scrollCategoryIntoView(category) {
    var _BodyRef$current;
    if (!BodyRef.current) {
      return;
    }
    var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector("[data-name=\"" + category + "\"]");
    if (!$category) {
      return;
    }
    var offsetTop = $category.offsetTop || 0;
    scrollTo(PickerMainRef.current, offsetTop);
  };
}

function useShouldHideCustomEmojis() {
  var customCategoryConfig = useCustomEmojisConfig();
  if (!customCategoryConfig) {
    return false;
  }
  return customCategoryConfig.length === 0;
}

var SVGNavigation = 'data:image/svg+xml;base64,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';

function CategoryButton(_ref) {
  var _categoryConfig$icon, _cx;
  var isActiveCategory = _ref.isActiveCategory,
    category = _ref.category,
    allowNavigation = _ref.allowNavigation,
    categoryConfig = _ref.categoryConfig,
    onClick = _ref.onClick,
    customIcon = _ref.customIcon;
  // Priority: categoryConfig.icon > customIcon prop (from categoryIcons)
  var icon = (_categoryConfig$icon = categoryConfig.icon) != null ? _categoryConfig$icon : customIcon;
  var hasCustomIcon = icon != null;
  return createElement(Button, {
    tabIndex: allowNavigation ? 0 : -1,
    className: cx(styles$f.catBtn, commonInteractionStyles.categoryBtn, hasCustomIcon ? styles$f.customIcon : "epr-icn-" + category, (_cx = {}, _cx[ClassNames.active] = isActiveCategory, _cx)),
    onClick: onClick,
    "aria-label": categoryNameFromCategoryConfig(categoryConfig),
    "aria-selected": isActiveCategory,
    role: "tab",
    "aria-controls": "epr-category-nav-id"
  }, hasCustomIcon ? icon : null);
}
var DarkActivePositionY = {
  backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 3)'
};
var DarkPositionY = {
  backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 2)'
};
var DarkInactivePosition = {
  ':not(.epr-search-active)': {
    catBtn: {
      ':hover': DarkActivePositionY,
      '&.epr-active': DarkActivePositionY
    }
  }
};
var styles$f = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  catBtn: {
    '.': 'epr-cat-btn',
    display: 'inline-block',
    transition: 'opacity 0.2s ease-in-out',
    position: 'relative',
    height: 'var(--epr-category-navigation-button-size)',
    width: 'var(--epr-category-navigation-button-size)',
    backgroundSize: 'calc(var(--epr-category-navigation-button-size) * 10)',
    outline: 'none',
    backgroundPosition: '0 0',
    backgroundImage: "url(" + SVGNavigation + ")",
    ':focus:before': {
      content: '',
      position: 'absolute',
      top: '-2px',
      left: '-2px',
      right: '-2px',
      bottom: '-2px',
      border: '2px solid var(--epr-category-icon-active-color)',
      borderRadius: '50%'
    },
    '&.epr-icn-suggested': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -8)'
    },
    '&.epr-icn-custom': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -9)'
    },
    '&.epr-icn-activities': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -4)'
    },
    '&.epr-icn-animals_nature': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -1)'
    },
    '&.epr-icn-flags': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -7)'
    },
    '&.epr-icn-food_drink': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -2)'
    },
    '&.epr-icn-objects': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -5)'
    },
    '&.epr-icn-smileys_people': {
      backgroundPositionX: '0px'
    },
    '&.epr-icn-symbols': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -6)'
    },
    '&.epr-icn-travel_places': {
      backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -3)'
    }
  },
  customIcon: {
    '.': 'epr-cat-btn-custom-icon',
    backgroundImage: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
}, /*#__PURE__*/darkMode('catBtn', DarkPositionY), {
  '.epr-dark-theme': /*#__PURE__*/_extends({}, DarkInactivePosition),
  '.epr-auto-theme': /*#__PURE__*/_extends({}, DarkInactivePosition)
}));

function CategoryNavigation() {
  var _useState = useState(null),
    activeCategory = _useState[0],
    setActiveCategory = _useState[1];
  var _useVisibleCategories = useVisibleCategoriesState(),
    setVisibleCategories = _useVisibleCategories[1];
  var scrollCategoryIntoView = useScrollCategoryIntoView();
  useActiveCategoryScrollDetection({
    setActiveCategory: setActiveCategory,
    setVisibleCategories: setVisibleCategories
  });
  var isSearchMode = useIsSearchMode();
  var categoriesConfig = useCategoriesConfig();
  var categoryIcons = useCategoryIconsConfig();
  var CategoryNavigationRef = useCategoryNavigationRef();
  var hideCustomCategory = useShouldHideCustomEmojis();
  return createElement("div", {
    className: cx(styles$g.nav),
    role: "tablist",
    "aria-label": "Category navigation",
    id: "epr-category-nav-id",
    ref: CategoryNavigationRef
  }, categoriesConfig.map(function (categoryConfig) {
    var category = categoryFromCategoryConfig(categoryConfig);
    var isActiveCategory = category === activeCategory;
    if (isCustomCategory(categoryConfig) && hideCustomCategory) {
      return null;
    }
    var allowNavigation = !isSearchMode && !isActiveCategory;
    return createElement(CategoryButton, {
      key: category,
      category: category,
      isActiveCategory: isActiveCategory,
      allowNavigation: allowNavigation,
      categoryConfig: categoryConfig,
      customIcon: categoryIcons[category],
      onClick: function onClick() {
        scrollCategoryIntoView(category);
        setTimeout(function () {
          setActiveCategory(category);
        }, 10);
      }
    });
  }));
}
var styles$g = /*#__PURE__*/stylesheet.create({
  nav: {
    '.': 'epr-category-nav',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    padding: 'var(--epr-header-padding)'
  },
  '.epr-search-active': {
    nav: {
      opacity: '0.3',
      cursor: 'default',
      pointerEvents: 'none'
    }
  },
  '.epr-main:has(input:not(:placeholder-shown))': {
    nav: {
      opacity: '0.3',
      cursor: 'default',
      pointerEvents: 'none'
    }
  }
});

var SVGTimes = 'data:image/svg+xml;base64,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';

function BtnClearSearch() {
  var clearSearch = useClearSearch();
  var searchClearButtonLabel = useSearchClearButtonLabelConfig();
  return createElement(Button, {
    className: cx(styles$h.btnClearSearch, commonInteractionStyles.visibleOnSearchOnly),
    onClick: clearSearch,
    "aria-label": searchClearButtonLabel,
    title: searchClearButtonLabel
  }, createElement("div", {
    className: cx(styles$h.icnClearnSearch)
  }));
}
var HoverDark = {
  ':hover': {
    '> .epr-icn-clear-search': {
      backgroundPositionY: '-60px'
    }
  }
};
var styles$h = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  btnClearSearch: {
    '.': 'epr-btn-clear-search',
    position: 'absolute',
    right: 'var(--epr-search-bar-inner-padding)',
    height: '30px',
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '0',
    borderRadius: '50%',
    ':hover': {
      background: 'var(--epr-hover-bg-color)'
    },
    ':focus': {
      background: 'var(--epr-hover-bg-color)'
    }
  },
  icnClearnSearch: {
    '.': 'epr-icn-clear-search',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px',
    height: '20px',
    width: '20px',
    backgroundImage: "url(" + SVGTimes + ")",
    ':hover': {
      backgroundPositionY: '-20px'
    },
    ':focus': {
      backgroundPositionY: '-20px'
    }
  }
}, /*#__PURE__*/darkMode('icnClearnSearch', {
  backgroundPositionY: '-40px'
}), /*#__PURE__*/darkMode('btnClearSearch', HoverDark)));

var SVGMagnifier = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+';

function IcnSearch() {
  return createElement("div", {
    className: cx(styles$i.icnSearch)
  });
}
var styles$i = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  icnSearch: {
    '.': 'epr-icn-search',
    content: '',
    position: 'absolute',
    top: '50%',
    left: 'var(--epr-search-bar-inner-padding)',
    transform: 'translateY(-50%)',
    width: '20px',
    height: '20px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: '0 0',
    backgroundSize: '20px',
    backgroundImage: "url(" + SVGMagnifier + ")"
  }
}, /*#__PURE__*/darkMode('icnSearch', {
  backgroundPositionY: '-20px'
})));

function SearchContainer() {
  var searchDisabled = useSearchDisabledConfig();
  var isSkinToneInSearch = useIsSkinToneInSearch();
  if (searchDisabled) {
    return null;
  }
  return createElement(Flex, {
    className: cx(styles$j.overlay)
  }, createElement(Search, null), isSkinToneInSearch ? createElement(SkinTonePicker, null) : null);
}
function Search() {
  var closeAllOpenToggles = useCloseAllOpenToggles();
  var SearchInputRef = useSearchInputRef();
  var placeholder = useSearchPlaceHolderConfig();
  var autoFocus = useAutoFocusSearchConfig();
  var _useFilter = useFilter(),
    statusSearchResults = _useFilter.statusSearchResults,
    searchTerm = _useFilter.searchTerm,
    _onChange = _useFilter.onChange;
  var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
  var value = input == null ? void 0 : input.value;
  return createElement(Relative, {
    className: cx(styles$j.searchContainer)
  }, createElement("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: autoFocus,
    "aria-label": 'Type to search for an emoji',
    onFocus: closeAllOpenToggles,
    className: cx(styles$j.search),
    type: "text",
    "aria-controls": "epr-search-id",
    placeholder: placeholder,
    onChange: function onChange(event) {
      var _event$target$value, _event$target;
      _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
    },
    ref: SearchInputRef
  }), searchTerm ? createElement("div", {
    role: "status",
    className: cx('epr-status-search-results', styles$j.visuallyHidden),
    "aria-live": "polite",
    id: "epr-search-id",
    "aria-atomic": "true"
  }, statusSearchResults) : null, createElement(IcnSearch, null), createElement(BtnClearSearch, null));
}
var styles$j = /*#__PURE__*/stylesheet.create(/*#__PURE__*/_extends({
  overlay: {
    padding: 'var(--epr-header-padding)',
    zIndex: 'var(--epr-header-overlay-z-index)'
  },
  searchContainer: {
    '.': 'epr-search-container',
    flex: '1',
    display: 'block',
    minWidth: '0'
  },
  visuallyHidden: {
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    overflow: 'hidden',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  },
  search: {
    outline: 'none',
    transition: 'all 0.2s ease-in-out',
    color: 'var(--epr-search-input-text-color)',
    borderRadius: 'var(--epr-search-input-border-radius)',
    padding: 'var(--epr-search-input-padding)',
    height: 'var(--epr-search-input-height)',
    backgroundColor: 'var(--epr-search-input-bg-color)',
    border: '1px solid var(--epr-search-border-color)',
    width: '100%',
    ':focus': {
      backgroundColor: 'var(--epr-search-input-bg-color-active)',
      border: '1px solid var(--epr-search-border-color-active)'
    },
    '::placeholder': {
      color: 'var(--epr-search-input-placeholder-color)'
    }
  },
  btnClearSearch: {
    '.': 'epr-btn-clear-search',
    position: 'absolute',
    right: 'var(--epr-search-bar-inner-padding)',
    height: '30px',
    width: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '0',
    borderRadius: '50%',
    ':hover': {
      background: 'var(--epr-hover-bg-color)'
    },
    ':focus': {
      background: 'var(--epr-hover-bg-color)'
    }
  },
  icnClearnSearch: {
    '.': 'epr-icn-clear-search',
    backgroundColor: 'transparent',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '20px',
    height: '20px',
    width: '20px',
    backgroundImage: "url(" + SVGTimes + ")",
    ':hover': {
      backgroundPositionY: '-20px'
    },
    ':focus': {
      backgroundPositionY: '-20px'
    }
  }
}, /*#__PURE__*/darkMode('icnClearnSearch', {
  backgroundPositionY: '-40px'
}), /*#__PURE__*/darkMode('btnClearSearch', {
  ':hover > .epr-icn-clear-search': {
    backgroundPositionY: '-60px'
  }
})));

function Header() {
  return createElement(Relative, {
    className: cx('epr-header', commonInteractionStyles.hiddenOnReactions)
  }, createElement(SearchContainer, null), createElement(CategoryNavigation, null));
}

function EmojiPicker$1(props) {
  return createElement(ElementRefContextProvider, null, createElement(PickerStyleTag, {
    nonce: props.nonce
  }), createElement(PickerConfigProvider, Object.assign({}, props), createElement(PickerDataProvider, null, createElement(ContentControl, null))));
}
function ContentControl() {
  var _useReactionsModeStat = useReactionsModeState(),
    reactionsDefaultOpen = _useReactionsModeStat[0];
  var allowExpandReactions = useAllowExpandReactions();
  var _React$useState = useState(!reactionsDefaultOpen),
    renderAll = _React$useState[0],
    setRenderAll = _React$useState[1];
  var isOpen = useOpenConfig();
  useEffect(function () {
    if (reactionsDefaultOpen && !allowExpandReactions) {
      return;
    }
    if (!renderAll) {
      setRenderAll(true);
    }
  }, [renderAll, allowExpandReactions, reactionsDefaultOpen]);
  if (!isOpen) {
    return null;
  }
  return createElement(PickerMain, null, createElement(Reactions, null), createElement(ExpandedPickerContent, {
    renderAll: renderAll
  }));
}
function ExpandedPickerContent(_ref) {
  var renderAll = _ref.renderAll;
  if (!renderAll) {
    return null;
  }
  return createElement(Fragment$2, null, createElement(Header, null), createElement(Body, null), createElement(Preview, null));
}
// eslint-disable-next-line complexity
var EmojiPickerReact = /*#__PURE__*/memo(EmojiPicker$1, compareConfig);

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
    return {
      hasError: true
    };
  };
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error('Emoji Picker React failed to render:', error, errorInfo);
  };
  _proto.render = function render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  };
  return ErrorBoundary;
}(Component$1);

function EmojiPicker$1$1(props) {
  var MutableConfigRef = useDefineMutableConfig({
    onEmojiClick: props.onEmojiClick,
    onReactionClick: props.onReactionClick,
    onSkinToneChange: props.onSkinToneChange
  });
  return createElement(ErrorBoundary, null, createElement(MutableConfigContext.Provider, {
    value: MutableConfigRef
  }, createElement(EmojiPickerReact, Object.assign({}, props))));
}

var css_248z = ".EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPickerReact{position:absolute!important;right:0;z-index:20}.EmojiPicker-module__emojiPickerWrapper___YoUcX .epr-preview{display:none}.EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPicker-module__emojiPickerIcon___Md2x7{cursor:pointer;margin-bottom:5px;margin-right:5px;padding:5px 5px 0}.EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPicker-module__emojiPickerIcon___Md2x7:hover{background-color:var(--bg-light-80);border-radius:var(--borderRadius)}.EmojiPicker-module__emojiPickerWrapper___YoUcX aside.EmojiPickerReact.epr-main{border-radius:var(--borderRadius);box-shadow:var(--smoothShadow)}.EmojiPicker-module__emojiPickerWrapper___YoUcX .epr-header-overlay{background-color:var(--primary-color)}.EmojiPicker-module__emojiPickerWrapper___YoUcX .epr-search{border-radius:var(--borderRadius)!important}.EmojiPicker-module__emojiPickerWrapper___YoUcX .epr-emoji-category-label{color:var(--primary-color)!important}.EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPickerReact button.epr-emoji:hover>*{background-color:var(--primary-20)!important;color:var(--primary-color)}.EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPickerReact .epr-emoji-variation-picker,.EmojiPicker-module__emojiPickerWrapper___YoUcX .EmojiPickerReact button.epr-emoji{border-radius:var(--borderRadius)!important}";
var styles = {"emojiPickerWrapper":"EmojiPicker-module__emojiPickerWrapper___YoUcX","emojiPickerIcon":"EmojiPicker-module__emojiPickerIcon___Md2x7"};
styleInject(css_248z);

const EmojiPicker = ({
  inputTargetId,
  setInput
}) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const onEmojiClick = event => {
    if (inputTargetId) {
      const input = document.getElementById(inputTargetId);
      input.value += event.emoji;
      if (setInput) {
        setInput(input.value);
      }
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: styles.emojiPickerWrapper,
    children: [/*#__PURE__*/jsx("div", {
      className: styles.emojiPickerIcon,
      onClick: () => setShowEmojiPicker(!showEmojiPicker),
      children: /*#__PURE__*/jsx(SmileEmojiIcon, {
        width: 20,
        color: getRootStyle('--grey-64')
      })
    }), showEmojiPicker && /*#__PURE__*/jsx(EmojiPicker$1$1, {
      onEmojiClick: onEmojiClick,
      disableAutoFocus: true,
      native: true,
      categories: [{
        name: 'Smiles',
        category: Categories.SMILEYS_PEOPLE
      }, {
        name: 'Flags',
        category: Categories.FLAGS
      }, {
        name: 'Food',
        category: Categories.FOOD_DRINK
      }, {
        name: 'Symbols',
        category: Categories.SYMBOLS
      }, {
        name: 'Travel',
        category: Categories.TRAVEL_PLACES
      }]
    })]
  });
};

const ProjectForm = ({
  onClose,
  onProjectSaved,
  project
}) => {
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [startDate, setStartDate] = useState(project?.startDate ? project.startDate : '');
  const [dueDate, setDueDate] = useState(project?.dueDate ? project.dueDate : '');
  const [completionDate, setCompletionDate] = useState(project?.completionDate ? project.completionDate : '');
  const [projectName, setProjectName] = useState(project ? project.name : '');
  const saveProject = async () => {
    let projectFormData = new FormData();
    if (dueDate && projectName) {
      projectFormData.append('name', projectName);
      projectFormData.append('startDate', startDate);
      projectFormData.append('dueDate', dueDate);
      projectFormData.append('completionDate', completionDate);
      showLoading();
      try {
        await axios.post(`${restUrls.tasksSaveProject}/${project?.id}`, projectFormData);
        toast.success(`Project ${project ? 'Edited' : 'Created'}!`);
        onProjectSaved();
      } catch (error) {
        console.log(error);
        toast.error(`There was an error while ${project ? 'editing' : 'creating'} the project.`);
      }
      hideLoading();
    } else {
      alert('Please fill all the mandatory fields.');
    }
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(FormGrid, {
      columns: 3,
      children: [/*#__PURE__*/jsx(InputCalendar, {
        label: "Start Date",
        value: startDate,
        onChange: e => setStartDate(e.target.value)
      }), /*#__PURE__*/jsx(InputCalendar, {
        label: "Due Date*",
        value: dueDate,
        onChange: e => setDueDate(e.target.value),
        min: formatDate$1(new Date(), 'yyyy-MM-dd')
      }), /*#__PURE__*/jsx(InputCalendar, {
        label: "Completion Date",
        value: completionDate,
        onChange: e => setCompletionDate(e.target.value),
        max: formatDate$1(new Date(), 'yyyy-MM-dd')
      })]
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsxs(FlexContainer, {
        gap: "5px",
        alignItems: "flex-end",
        children: [/*#__PURE__*/jsx(InputText, {
          placeholder: "Project Name",
          label: "Project Name*",
          value: projectName,
          id: "project-name",
          onChange: e => setProjectName(e.target.value)
        }), /*#__PURE__*/jsx(EmojiPicker, {
          inputTargetId: "project-name",
          setInput: setProjectName
        })]
      })
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        onClick: saveProject,
        children: project ? 'Edit Project' : 'Create Project'
      })
    })]
  });
};

const TaskStatusLabel = ({
  status
}) => {
  switch (status) {
    case taskStatus.TODO:
      return /*#__PURE__*/jsx("span", {
        children: "Todo"
      });
    case taskStatus.DONE:
      return /*#__PURE__*/jsx("span", {
        style: {
          color: 'var(--success)'
        },
        children: "Done"
      });
    default:
      return '-';
  }
};

const TaskPriorityStatusLabel = ({
  priority
}) => {
  switch (priority) {
    case taskPriority.LOW:
      return /*#__PURE__*/jsx(Label, {
        color: taskPriorityColours.LOW_TEXT,
        backgroundColor: taskPriorityColours.LOW_BG,
        children: taskPriority.LOW
      });
    case taskPriority.MEDIUM:
      return /*#__PURE__*/jsx(Label, {
        color: taskPriorityColours.MEDIUM_TEXT,
        backgroundColor: taskPriorityColours.MEDIUM_BG,
        children: taskPriority.MEDIUM
      });
    case taskPriority.HIGH:
      return /*#__PURE__*/jsx(Label, {
        color: taskPriorityColours.HIGH_TEXT,
        backgroundColor: taskPriorityColours.HIGH_BG,
        children: taskPriority.HIGH
      });
    case taskPriority.URGENT:
      return /*#__PURE__*/jsx(Label, {
        color: taskPriorityColours.URGENT_TEXT,
        backgroundColor: taskPriorityColours.URGENT_BG,
        children: taskPriority.URGENT
      });
    default:
      return /*#__PURE__*/jsx(Label, {
        variant: "disabled",
        children: priority || '-'
      });
  }
};

const TaskCommentForm = ({
  onSubmit,
  onClose
}) => {
  const [commentText, setCommentText] = useState('');
  const handleSubmitComment = () => {
    onSubmit(commentText);
    setCommentText('');
  };
  return /*#__PURE__*/jsxs("div", {
    style: {
      padding: '10px'
    },
    children: [/*#__PURE__*/jsx(TextArea, {
      placeholder: "Leave a comment...",
      value: commentText,
      resize: "none",
      onChange: event => setCommentText(event.target.value)
    }), /*#__PURE__*/jsxs(FlexContainer, {
      flexWrap: "nowwrap",
      gap: "5px",
      alignItems: "center",
      margin: "10px 0px 0px 0px",
      children: [/*#__PURE__*/jsx(Button$1, {
        variant: "tertiary",
        onClick: onClose,
        children: "Close"
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        onClick: handleSubmitComment,
        children: "Add comment"
      })]
    })]
  });
};

const TaskCommentsList = ({
  task,
  usersList,
  onClose,
  onCommentAdded,
  onCommentRemoved
}) => {
  const [commentsList, setCommentsList] = useState([]);
  const posthog = usePostHog();
  useEffect(() => {
    loadComments();
    posthog.capture('tasks_open_comments');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadComments = async () => {
    try {
      let response = await axios.get(`${restUrls.tasksCommentsList}/${task.id}`);
      setCommentsList(response.data.comments);
    } catch (error) {
      console.log(error);
    }
  };
  const removeComment = async comment => {
    if (window.confirm('Do you really want to delete this comment?')) {
      try {
        await axios.post(`${restUrls.taskRemoveComment}/${comment.id}`);
        loadComments();
        posthog.capture('tasks_remove_comment');
        onCommentRemoved(task);
      } catch (error) {
        console.log(error);
        toast.error('There was an error while removing the comment.');
      }
    }
  };
  const createComment = async commentText => {
    let newTaskCommentFormData = new FormData();
    newTaskCommentFormData.append('taskId', task.id);
    newTaskCommentFormData.append('comment', commentText);
    try {
      await axios.post(restUrls.taskSaveComment, newTaskCommentFormData);
      onCommentAdded(task);
      posthog.capture('tasks_add_comment');
      loadComments();
    } catch (error) {
      console.log(error);
      toast.error('There was an error while creating the comment.');
    }
  };
  return /*#__PURE__*/jsx("tr", {
    children: /*#__PURE__*/jsxs("td", {
      colSpan: 10,
      className: css.commentsSection,
      children: [/*#__PURE__*/jsx(TaskCommentForm, {
        onSubmit: createComment,
        onClose: onClose
      }), commentsList.length !== 0 && /*#__PURE__*/jsxs("div", {
        className: css.previousComments,
        children: [/*#__PURE__*/jsxs(FlexContainer, {
          gap: 5,
          margin: "0px 15px",
          children: [/*#__PURE__*/jsx(MessageText02, {
            width: 15
          }), /*#__PURE__*/jsx("b", {
            children: " Previous Comments"
          })]
        }), commentsList.map(comment => /*#__PURE__*/jsx(TaskCommentItem, {
          comment: comment,
          usersList: usersList,
          onCommentDelete: removeComment
        }, comment.id))]
      })]
    })
  });
};
const TaskCommentItem = ({
  comment,
  usersList,
  onCommentDelete
}) => {
  if (comment.status === taskStatus.DELETED) {
    return null;
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    flexWrap: "nowwrap",
    gap: "5px",
    alignItems: "center",
    className: css.taskCommentWrapper,
    padding: "0px 15px",
    children: [/*#__PURE__*/jsxs("div", {
      className: css.taskComment,
      children: [/*#__PURE__*/jsxs("small", {
        children: [comment.createdAt, " by ", usersList[comment.userId]?.fullName ?? '-']
      }), /*#__PURE__*/jsx("p", {
        dangerouslySetInnerHTML: {
          __html: comment.text
        }
      })]
    }, comment.id), /*#__PURE__*/jsx(DeleteButton, {
      si: true,
      onClick: () => onCommentDelete(comment)
    })]
  });
};

const TasksProgress = ({
  subtasks
}) => {
  if (!subtasks || subtasks.length === 0) {
    return null;
  }
  let tasksDone = 0;
  subtasks.forEach(subTask => {
    if (subTask.status === 'DONE') {
      tasksDone++;
    }
  });
  return /*#__PURE__*/jsx(FlexContainer, {
    alignItems: "center",
    gap: "5px",
    justifyContent: "center",
    children: /*#__PURE__*/jsxs("small", {
      children: [tasksDone, "/", subtasks.length, " Tasks"]
    })
  });
};

const convertUsersListToOptions = usersList => {
  let usersOptions = [{
    label: 'Not Assigned',
    value: ''
  }];
  Object.values(usersList).forEach(user => {
    usersOptions.push({
      label: user.fullName,
      value: user.id
    });
  });
  return usersOptions;
};

const TaskView = ({
  task,
  onEditTaskClick,
  onCloseTaskClick,
  usersList,
  project
}) => {
  const {
    currentUser
  } = useCurrentUser();
  const taskViewRef = useRef(null);
  useClickOutside(taskViewRef, () => onCloseTaskClick(task));
  return /*#__PURE__*/jsxs("div", {
    ref: taskViewRef,
    className: `${css.viewTask}`,
    children: [/*#__PURE__*/jsx(TaskViewActions, {
      task: task,
      onCloseTaskClick: onCloseTaskClick,
      onEditTaskClick: onEditTaskClick
    }), /*#__PURE__*/jsx(TaskViewInfo, {
      title: task.title,
      text: task.text,
      dueDate: task.dueDate,
      timeStatus: task.timeStatus,
      projectName: project ? project.name : '-',
      userName: task.userId ? usersList[task.userId]?.fullName : '-',
      visibility: task.visibility,
      priority: task.priority,
      status: task.status,
      currentUser: currentUser
    }), /*#__PURE__*/jsx(TaskViewLinks, {
      knowledgeBaseLink: task.knowledgeBaseLink,
      platformLink: task.platformLink
    })]
  });
};
const TaskViewActions = ({
  task,
  onCloseTaskClick,
  onEditTaskClick
}) => {
  return /*#__PURE__*/jsxs(FlexContainer, {
    gap: "5px",
    alignItems: "center",
    className: css.viewTaskActions,
    children: [/*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      icon: /*#__PURE__*/jsx(Edit04, {}),
      size: "small",
      onClick: () => {
        onCloseTaskClick(task);
        onEditTaskClick(task);
      }
    }), /*#__PURE__*/jsx(Button$1, {
      variant: "ghost",
      icon: /*#__PURE__*/jsx(CloseIcon, {
        color: ""
      }),
      size: "small",
      onClick: () => onCloseTaskClick(task)
    })]
  });
};
const TaskViewInfo = ({
  title,
  text,
  dueDate,
  timeStatus,
  projectName,
  userName,
  visibility,
  priority,
  status,
  currentUser
}) => {
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("label", {
        children: "Title"
      }), /*#__PURE__*/jsx("p", {
        dangerouslySetInnerHTML: {
          __html: title
        }
      })]
    }), /*#__PURE__*/jsxs("div", {
      children: [/*#__PURE__*/jsx("label", {
        children: "Description"
      }), text ? /*#__PURE__*/jsx("p", {
        dangerouslySetInnerHTML: {
          __html: text
        }
      }) : /*#__PURE__*/jsx("p", {
        children: "-"
      })]
    }), /*#__PURE__*/jsxs(FlexContainer, {
      flexWrap: "wrap",
      gap: "15px",
      justifyContent: "space-between",
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "Status"
        }), /*#__PURE__*/jsx("p", {
          children: /*#__PURE__*/jsx(TaskStatusLabel, {
            status: status
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "Due Date"
        }), /*#__PURE__*/jsx("p", {
          children: /*#__PURE__*/jsx(TaskDueDateStatus, {
            dueDate: dueDate,
            timesStatus: timeStatus
          })
        })]
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "Project"
        }), /*#__PURE__*/jsx("p", {
          children: projectName ?? '-'
        })]
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "User Assigned"
        }), /*#__PURE__*/jsx("p", {
          children: userName ?? '-'
        })]
      })]
    }), /*#__PURE__*/jsxs(FlexContainer, {
      flexWrap: "wrap",
      gap: "15px",
      children: [(currentUser.role === 'USG_EMPLOYEE_SALES' || currentUser.role === 'ADMIN') && /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "Visibility"
        }), /*#__PURE__*/jsx("p", {
          children: visibility ?? '-'
        })]
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("label", {
          children: "Priority"
        }), /*#__PURE__*/jsx("p", {
          children: /*#__PURE__*/jsx(TaskPriorityStatusLabel, {
            priority: priority
          })
        })]
      })]
    })]
  });
};
const TaskViewLinks = ({
  knowledgeBaseLink,
  platformLink
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: css.linksSection,
    children: [/*#__PURE__*/jsxs("div", {
      id: "knowledgeBaseLink",
      children: [/*#__PURE__*/jsx("label", {
        children: "Link To Knowledge Base"
      }), /*#__PURE__*/jsx("p", {
        children: knowledgeBaseLink ? /*#__PURE__*/jsx("a", {
          href: knowledgeBaseLink,
          children: knowledgeBaseLink
        }) : '-'
      })]
    }), /*#__PURE__*/jsxs("div", {
      id: "platformLink",
      children: [/*#__PURE__*/jsx("label", {
        children: "Link to Platform Page Where Task Applies"
      }), /*#__PURE__*/jsx("p", {
        children: platformLink ? /*#__PURE__*/jsx("a", {
          href: platformLink,
          children: platformLink
        }) : '-'
      })]
    })]
  });
};
const TaskDueDateStatus = ({
  dueDate,
  timesStatus
}) => {
  if (timesStatus === taskDueDateStatus.OVERDUE) {
    return /*#__PURE__*/jsx("b", {
      children: /*#__PURE__*/jsxs("span", {
        style: {
          color: taskPriorityColours.URGENT_TEXT
        },
        children: [formatDate$1(dueDate, 'dd MMM yy'), " Overdue"]
      })
    });
  }
  if (timesStatus === taskDueDateStatus.DUE_TODAY) {
    return /*#__PURE__*/jsxs(FlexContainer, {
      justifyContent: "center",
      alignItems: "center",
      gap: 5,
      style: {
        color: taskPriorityColours.HIGH_TEXT
      },
      children: [/*#__PURE__*/jsx("b", {
        children: "Today"
      }), /*#__PURE__*/jsx(AlertTriangle, {
        width: 14
      })]
    });
  }
  if (timesStatus === taskDueDateStatus.DUE_TOMORROW) {
    return /*#__PURE__*/jsxs(FlexContainer, {
      justifyContent: "center",
      alignItems: "center",
      gap: 5,
      style: {
        color: taskPriorityColours.MEDIUM_TEXT
      },
      children: [/*#__PURE__*/jsx("b", {
        children: "Tomorrow"
      }), /*#__PURE__*/jsx(AlertTriangle, {
        width: 14
      })]
    });
  }
  return /*#__PURE__*/jsx("span", {
    children: dueDate ? formatDate$1(dueDate, 'dd MMM yy') : '-'
  });
};

const TaskItem = ({
  task,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onMarkTaskAsDone,
  onUserAssigned,
  onDueDateChange,
  usersList,
  onCommentAdded,
  onCommentRemoved,
  onViewTaskClick,
  viewTaskId,
  project,
  areFiltersApplied,
  onSortingChange,
  cscMode
}) => {
  const isParentTask = task.subtasks.length !== 0;
  return /*#__PURE__*/jsxs(Table, {
    compact: true,
    scrollable: true,
    children: [/*#__PURE__*/jsx(TaskTableHeader, {
      task: task,
      onSortingChange: onSortingChange
    }), /*#__PURE__*/jsx(TaskTableBody, {
      task: task,
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onMarkTaskAsDone: onMarkTaskAsDone,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      isParentTask: isParentTask,
      usersList: usersList,
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved,
      onViewTaskClick: onViewTaskClick,
      viewTaskId: viewTaskId,
      project: project,
      areFiltersApplied: areFiltersApplied,
      onSortingChange: onSortingChange,
      cscMode: cscMode
    }, task.id)]
  });
};
const TaskTableHeader = ({
  task,
  onSortingChange
}) => {
  return /*#__PURE__*/jsx(TableHead, {
    children: /*#__PURE__*/jsxs(TableRow, {
      children: [task?.subtasks?.length > 0 && /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '25px'
        }
      }), task?.subtasks?.length === 0 && /*#__PURE__*/jsx(TableHeader, {
        className: css.checkBox
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '105px',
          textAlign: 'center'
        },
        children: "Status"
      }), /*#__PURE__*/jsx(TableHeader, {
        children: "Task"
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '50px',
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(MessageSquareIcon, {})
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '50px',
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(Book02, {})
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '50px',
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(LinkAngled, {})
      }), /*#__PURE__*/jsx(TableSortableHeader, {
        sortable: true,
        onSortColumn: () => onSortingChange('dueDate'),
        style: {
          width: '175px',
          textAlign: 'center'
        },
        children: "Due Date"
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '115px',
          textAlign: 'center'
        },
        children: "Priority"
      }), /*#__PURE__*/jsx(TableSortableHeader, {
        sortable: true,
        onSortColumn: () => onSortingChange('user'),
        style: {
          width: '145px',
          textAlign: 'center'
        },
        children: "User"
      }), /*#__PURE__*/jsx(TableHeader, {
        style: {
          width: '75px',
          textAlign: 'center'
        },
        children: "\xA0"
      })]
    })
  });
};
const TaskTableBody = ({
  key,
  task,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onMarkTaskAsDone,
  onUserAssigned,
  onDueDateChange,
  isParentTask,
  usersList,
  onCommentAdded,
  onCommentRemoved,
  onViewTaskClick,
  viewTaskId,
  project,
  areFiltersApplied,
  onSortingChange,
  cscMode
}) => {
  const [showSubTasksToggle, setShowSubTasksToggle] = useState(true);
  if (task.status === 'DELETED') {
    return null;
  }
  return /*#__PURE__*/jsxs("tbody", {
    children: [/*#__PURE__*/jsx(TaskTableRow, {
      task: task,
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onMarkTaskAsDone: onMarkTaskAsDone,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      isParentTask: isParentTask,
      showSubTasksToggle: showSubTasksToggle,
      onShowSubTasks: () => setShowSubTasksToggle(!showSubTasksToggle),
      usersList: usersList,
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved,
      onViewTaskClick: onViewTaskClick,
      viewTaskId: viewTaskId,
      project: project,
      areFiltersApplied: areFiltersApplied,
      onSortingChange: onSortingChange,
      cscMode: cscMode,
      handleShowTaskCommentsSection: true
    }, task.id), showSubTasksToggle && task.subtasks.map(subTask => /*#__PURE__*/jsx(TaskTableRow, {
      task: subTask,
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onMarkTaskAsDone: onMarkTaskAsDone,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      usersList: usersList,
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved
    }, subTask.id))]
  });
};
const TaskTableRow = ({
  key,
  task,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onMarkTaskAsDone,
  onUserAssigned,
  onDueDateChange,
  isParentTask,
  showSubTasksToggle,
  onShowSubTasks,
  usersList,
  onCommentAdded,
  onCommentRemoved,
  onViewTaskClick,
  viewTaskId,
  project,
  areFiltersApplied,
  onSortingChange,
  cscMode
}) => {
  const [showCommentsToggle, setShowCommentsToggle] = useState(false);
  const handleShowTaskCommentsSection = () => {
    setShowCommentsToggle(!showCommentsToggle);
  };
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(TableRow, {
      children: [isParentTask && task?.subtasks?.length > 0 && /*#__PURE__*/jsx(TableCell, {
        children: /*#__PURE__*/jsx(ExpandableButton, {
          isExpanded: showSubTasksToggle,
          onChange: onShowSubTasks
        })
      }), (!isParentTask || isParentTask && task?.subtasks?.length === 0) && /*#__PURE__*/jsx(TableCell, {
        className: css.checkBox,
        children: /*#__PURE__*/jsx(Checkbox, {
          id: `task-checkbox-${task.id}`,
          checked: task.status === 'DONE',
          onChange: () => onMarkTaskAsDone(task)
        })
      }), /*#__PURE__*/jsx(TableCell, {
        style: {
          width: '105px',
          textAlign: 'center'
        },
        children: !areFiltersApplied ? task.subtasks?.length > 0 ? /*#__PURE__*/jsx(TasksProgress, {
          subtasks: task.subtasks
        }) : /*#__PURE__*/jsx(TaskStatusLabel, {
          status: task.status
        }) : null
      }), /*#__PURE__*/jsx(TableCell, {
        children: /*#__PURE__*/jsx(TaskTitle, {
          task: task,
          onViewTaskClick: onViewTaskClick,
          onEditTaskClick: onEditTask,
          usersList: usersList,
          project: project,
          isParentTask: isParentTask,
          viewTaskId: viewTaskId
        })
      }), /*#__PURE__*/jsx(TableCell, {
        children: /*#__PURE__*/jsx(Button$1, {
          variant: "ghost",
          onClick: handleShowTaskCommentsSection,
          icon: /*#__PURE__*/jsx(MessageSquareTypingIcon, {
            width: 13,
            color: getRootStyle('--grey-64')
          }),
          count: task.commentsCount
        })
      }), /*#__PURE__*/jsx(TableCell, {
        style: {
          textAlign: 'center'
        },
        children: task.knowledgeBaseLink && /*#__PURE__*/jsx("a", {
          href: task.knowledgeBaseLink,
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/jsx(Book02, {
            color: getRootStyle('--grey-64'),
            width: 18
          })
        })
      }), /*#__PURE__*/jsx(TableCell, {
        style: {
          textAlign: 'center'
        },
        children: task.platformLink && /*#__PURE__*/jsx("a", {
          href: task.platformLink,
          target: "_blank",
          rel: "noreferrer",
          children: /*#__PURE__*/jsx(LinkAngled, {
            color: getRootStyle('--grey-64'),
            width: 18
          })
        })
      }), /*#__PURE__*/jsx(DueDateStatusCell, {
        task: task,
        onDueDateChange: onDueDateChange
      }), /*#__PURE__*/jsx(TableCell, {
        style: {
          width: '70px',
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(TaskPriorityStatusLabel, {
          priority: task.priority
        })
      }), cscMode && /*#__PURE__*/jsx(TableCell, {
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(FlexContainer, {
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/jsx(Avatar, {
            name: task.hotelName
          })
        })
      }), !cscMode && /*#__PURE__*/jsx(TableCell, {
        style: {
          width: '145px',
          textAlign: 'center'
        },
        children: task.status === 'DONE' ? /*#__PURE__*/jsx(FlexContainer, {
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/jsx(Avatar, {
            name: task.userId ? usersList[task.userId]?.fullName : '-'
          })
        }) : /*#__PURE__*/jsx(Dropdown, {
          value: task?.userId ?? '',
          options: convertUsersListToOptions(usersList),
          onChange: e => onUserAssigned(e.target.value, task),
          size: "small"
        })
      }), /*#__PURE__*/jsx(TableCell, {
        style: {
          textAlign: 'center'
        },
        children: /*#__PURE__*/jsx(TaskActions, {
          task: task,
          onDeleteTaskClick: onDeleteTask,
          onAddSubTaskClick: onAddSubTask,
          onEditTaskClick: onEditTask
        })
      })]
    }), showCommentsToggle && /*#__PURE__*/jsx(TaskCommentsList, {
      task: task,
      usersList: usersList,
      onClose: () => setShowCommentsToggle(false),
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved
    })]
  });
};
const TaskTitle = ({
  task,
  onViewTaskClick,
  viewTaskId,
  usersList,
  project,
  onEditTaskClick
}) => {
  return /*#__PURE__*/jsx("div", {
    className: css.titleCell,
    style: {
      textDecoration: task.status === 'DONE' ? 'line-through' : 'none'
    },
    children: /*#__PURE__*/jsxs("div", {
      className: css.viewTaskSection,
      children: [viewTaskId === task?.id && /*#__PURE__*/jsx(TaskView, {
        task: task,
        usersList: usersList,
        project: project,
        onEditTaskClick: onEditTaskClick,
        onCloseTaskClick: onViewTaskClick
      }), /*#__PURE__*/jsx("p", {
        className: "cursor-pointer",
        onClick: () => onViewTaskClick(task),
        children: task.subtasks.length !== 0 ? /*#__PURE__*/jsx("b", {
          dangerouslySetInnerHTML: {
            __html: task.title
          }
        }) : /*#__PURE__*/jsx("span", {
          dangerouslySetInnerHTML: {
            __html: task.title
          }
        })
      })]
    })
  });
};
const DueDateStatusCell = ({
  task,
  onDueDateChange
}) => {
  if (task.timeStatus === taskDueDateStatus.OVERDUE) {
    return /*#__PURE__*/jsx(TableCell, {
      style: {
        backgroundColor: taskPriorityColours.URGENT_BG,
        color: taskPriorityColours.URGENT_TEXT,
        textAlign: 'center'
      },
      children: /*#__PURE__*/jsx(FlexContainer, {
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        children: /*#__PURE__*/jsxs("b", {
          children: [formatDate$1(task.dueDate, 'dd MMM'), " Overdue "]
        })
      })
    });
  }
  if (task.timeStatus === taskDueDateStatus.DUE_TODAY) {
    return /*#__PURE__*/jsx(TableCell, {
      style: {
        color: taskPriorityColours.HIGH_TEXT,
        textAlign: 'center'
      },
      children: /*#__PURE__*/jsxs(FlexContainer, {
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        children: [/*#__PURE__*/jsx("b", {
          children: "Today "
        }), /*#__PURE__*/jsx(AlertTriangle, {
          color: taskPriorityColours.HIGH_TEXT,
          width: 14
        })]
      })
    });
  }
  if (task.timeStatus === taskDueDateStatus.DUE_TOMORROW) {
    return /*#__PURE__*/jsx(TableCell, {
      style: {
        color: taskPriorityColours.MEDIUM_TEXT,
        textAlign: 'center'
      },
      children: /*#__PURE__*/jsxs(FlexContainer, {
        justifyContent: "center",
        alignItems: "center",
        gap: "5px",
        children: [/*#__PURE__*/jsx("b", {
          children: "Tomorrow "
        }), /*#__PURE__*/jsx(AlertTriangle, {
          color: taskPriorityColours.MEDIUM_TEXT,
          width: 14
        })]
      })
    });
  }
  return /*#__PURE__*/jsx(TableCell, {
    children: /*#__PURE__*/jsx(InputCalendar, {
      value: task.dueDate,
      name: "dueDate",
      onChange: e => onDueDateChange(task, e.target.value),
      min: formatDate$1(new Date(), 'yyyy-MM-dd'),
      size: "small"
    })
  });
};
const TaskActions = ({
  task,
  onAddSubTaskClick,
  onEditTaskClick,
  onDeleteTaskClick
}) => {
  return /*#__PURE__*/jsxs(DropdownButton, {
    variant: "ghost",
    showExpandableArrows: false,
    icon: /*#__PURE__*/jsx(DotHorizontalIcon, {}),
    menuInPortal: true,
    children: [!task.parentTaskId && /*#__PURE__*/jsx(ButtonDropdownItem, {
      onClick: () => onAddSubTaskClick(task),
      children: "Add Task"
    }), /*#__PURE__*/jsx(ButtonDropdownItem, {
      onClick: () => onEditTaskClick(task),
      children: "Edit Task"
    }), /*#__PURE__*/jsx(ButtonDropdownItem, {
      onClick: () => onDeleteTaskClick(task),
      children: "Delete Task"
    })]
  });
};

const ProjectTitle = ({
  project,
  addNewTaskToProject,
  deleteProject,
  canDeleteProject,
  editProject
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const hotelName = useMemo(() => project?.hotelName ? hotelNamePlain(project.hotelName, undefined, isDemoMode) : project?.name, [project?.hotelName, project?.name, isDemoMode]);
  return /*#__PURE__*/jsx("div", {
    className: css.projectTitle,
    children: project ? /*#__PURE__*/jsxs(FlexContainer, {
      flexWrap: "nowwrap",
      gap: "10px",
      alignItems: "center",
      width: "100%",
      children: [/*#__PURE__*/jsxs("div", {
        className: css.projectTitleContent,
        children: [/*#__PURE__*/jsx("h5", {
          dangerouslySetInnerHTML: {
            __html: purify.sanitize(hotelName)
          }
        }), /*#__PURE__*/jsxs("div", {
          className: css.projectDates,
          children: [project.startDate && /*#__PURE__*/jsxs("small", {
            children: ["Start: ", formatDate$1(project.startDate, 'dd MMM')]
          }), project.dueDate && /*#__PURE__*/jsxs("small", {
            children: ["Due: ", formatDate$1(project.dueDate, 'dd MMM')]
          }), project.completionDate && /*#__PURE__*/jsxs("small", {
            children: ["Completion: ", formatDate$1(project.completionDate, 'dd MMM')]
          })]
        })]
      }), /*#__PURE__*/jsxs("div", {
        className: css.projectTitleActions,
        children: [/*#__PURE__*/jsx(Button$1, {
          onClick: () => editProject(project),
          variant: "ghost",
          icon: /*#__PURE__*/jsx(Edit04, {})
        }), /*#__PURE__*/jsx(Button$1, {
          variant: "ghost",
          icon: /*#__PURE__*/jsx(Plus02, {}),
          onClick: () => addNewTaskToProject(project)
        }), canDeleteProject && /*#__PURE__*/jsx(DeleteButton, {
          onClick: () => deleteProject(project)
        })]
      })]
    }) : /*#__PURE__*/jsx("h5", {
      children: "Other Tasks"
    })
  });
};

const getTaskStatusOptions = () => {
  const statusOptions = Object.keys(taskStatus).map(status => ({
    label: status,
    value: status
  }));
  statusOptions.unshift({
    label: 'Any',
    value: ''
  });
  return statusOptions;
};
const taskStatusOptions = getTaskStatusOptions();
const getTaskPriorityOptions = () => {
  const priorityOptions = Object.keys(taskPriority).map(priority => ({
    label: priority,
    value: priority
  }));
  priorityOptions.unshift({
    label: 'Any',
    value: ''
  });
  return priorityOptions;
};
const taskPriorityOptions = getTaskPriorityOptions();
const getTaskDueDateStatusOptions = () => {
  const dueDateStatusOptions = Object.keys(taskDueDateStatus).map(status => ({
    label: status.replaceAll('_', ' '),
    value: status
  }));
  dueDateStatusOptions.unshift({
    label: 'Any',
    value: ''
  });
  return dueDateStatusOptions;
};
const taskDueDateStatusOptions = getTaskDueDateStatusOptions();

const ProjectFilters = ({
  filters,
  onChangeFilters
}) => {
  const handleUpdateStatus = evt => {
    onChangeFilters(filters => ({
      ...filters,
      status: evt.target.value
    }));
  };
  const handleUpdatePriority = evt => {
    onChangeFilters(filters => ({
      ...filters,
      priority: evt.target.value
    }));
  };
  const handleUpdateDueDateStatus = evt => {
    onChangeFilters(filters => ({
      ...filters,
      dueDateStatus: evt.target.value
    }));
  };
  return /*#__PURE__*/jsxs(InlineFilters, {
    children: [/*#__PURE__*/jsx(Dropdown, {
      label: "Status",
      options: taskStatusOptions,
      placeholder: "Select Status",
      value: filters.status,
      onChange: handleUpdateStatus,
      size: "small"
    }), /*#__PURE__*/jsx(Dropdown, {
      label: "Priority",
      options: taskPriorityOptions,
      placeholder: "Select Priority",
      value: filters.priority,
      onChange: handleUpdatePriority,
      size: "small"
    }), /*#__PURE__*/jsx(Dropdown, {
      label: "Due Date Status",
      options: taskDueDateStatusOptions,
      placeholder: "Select Date Status",
      value: filters.dueDateStatus,
      onChange: handleUpdateDueDateStatus,
      size: "small"
    })]
  });
};

const getInitialFilters$2 = () => {
  return {
    status: '',
    priority: '',
    dueDateStatus: ''
  };
};
const ProjectsList = ({
  tasksList,
  projectsList,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onUserAssigned,
  onDueDateChange,
  usersList,
  addNewTaskToProject,
  onCommentAdded,
  onCommentRemoved,
  deleteProject,
  editProject,
  onSortingChange,
  cscMode,
  onMarkTaskAsDone
}) => {
  let tasksWithoutProject = tasksList[''] ?? [];
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [Object.values(projectsList).map(project => /*#__PURE__*/jsx(ProjectItem, {
      project: project,
      tasksList: tasksList[project.id] ?? [],
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onMarkTaskAsDone: onMarkTaskAsDone,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      projectsList: projectsList,
      usersList: usersList,
      addNewTaskToProject: addNewTaskToProject,
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved,
      deleteProject: deleteProject,
      editProject: editProject,
      onSortingChange: onSortingChange,
      cscMode: false
    }, project.id)), tasksWithoutProject.length > 0 && /*#__PURE__*/jsx(ProjectItem, {
      project: null,
      tasksList: tasksWithoutProject,
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onMarkTaskAsDone: onMarkTaskAsDone,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      projectsList: projectsList,
      usersList: usersList,
      addNewTaskToProject: addNewTaskToProject,
      onCommentAdded: onCommentAdded,
      onCommentRemoved: onCommentRemoved,
      onSortingChange: onSortingChange,
      cscMode: cscMode
    }, '-')]
  });
};
const ProjectItem = ({
  project,
  tasksList,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onUserAssigned,
  onDueDateChange,
  onMarkTaskAsDone,
  usersList,
  addNewTaskToProject,
  onCommentAdded,
  onCommentRemoved,
  deleteProject,
  editProject,
  projectsList,
  onSortingChange,
  cscMode
}) => {
  const [viewTaskId, setViewTaskId] = useState(null);
  const [filters, setFilters] = useState(getInitialFilters$2());
  const posthog = usePostHog();
  useEffect(() => {
    posthog.capture('tasks_change_status_filter', {
      status: filters.status
    });
  }, [filters.status]);
  useEffect(() => {
    posthog.capture('tasks_change_priority_filter', {
      priority: filters.priority
    });
  }, [filters.priority]);
  useEffect(() => {
    posthog.capture('tasks_change_due_date_status_filter', {
      status: filters.dueDateStatus
    });
  }, [filters.dueDateStatus]);
  const filteredTasks = useMemo(() => {
    return tasksList.reduce((acc, task) => {
      const filteredSubTasks = task.subtasks.filter(subtask => {
        if (filters.status && subtask.status !== filters.status) {
          return false;
        }
        if (filters.priority && subtask.priority !== filters.priority) {
          return false;
        }
        if (filters.dueDateStatus && subtask.timeStatus !== filters.dueDateStatus) {
          return false;
        }
        return true;
      });
      if (filteredSubTasks.length > 0) {
        acc.push({
          ...task,
          subtasks: filteredSubTasks
        });
        return acc;
      }
      if (filters.status && task.status !== filters.status) {
        return acc;
      }
      if (filters.priority && task.priority !== filters.priority) {
        return acc;
      }
      if (filters.dueDateStatus && task.timeStatus !== filters.dueDateStatus) {
        return acc;
      }
      acc.push(task);
      return acc;
    }, []);
  }, [tasksList, filters]);
  const handleOnViewTaskClick = task => {
    if (!viewTaskId || task?.id !== viewTaskId) {
      setViewTaskId(task?.id);
    } else {
      setViewTaskId(null);
    }
  };
  let canDeleteProject = !!tasksList && tasksList.filter(task => task.status !== taskStatus.DONE).length === 0;
  const areFiltersApplied = filters.status || filters.priority || filters.dueDateStatus;
  return /*#__PURE__*/jsxs(Card, {
    isExpandable: true,
    title: /*#__PURE__*/jsx(ProjectTitle, {
      project: project,
      addNewTaskToProject: addNewTaskToProject,
      deleteProject: deleteProject,
      canDeleteProject: canDeleteProject,
      editProject: editProject,
      cscMode: cscMode
    }),
    className: css.projectCard,
    children: [Object.values(projectsList).length > 1 && /*#__PURE__*/jsx(ProjectFilters, {
      filters: filters,
      onChangeFilters: setFilters
    }), filteredTasks.length !== 0 && filteredTasks.map((task, idx) => /*#__PURE__*/jsx("div", {
      className: idx > 0 ? css.multipleTasks : '',
      children: /*#__PURE__*/jsx(TaskItem, {
        task: task,
        onDeleteTask: onDeleteTask,
        onAddSubTask: onAddSubTask,
        onEditTask: onEditTask,
        onMarkTaskAsDone: onMarkTaskAsDone,
        onUserAssigned: onUserAssigned,
        onDueDateChange: onDueDateChange,
        isParentTask: true,
        usersList: usersList,
        onCommentAdded: onCommentAdded,
        onCommentRemoved: onCommentRemoved,
        onViewTaskClick: handleOnViewTaskClick,
        viewTaskId: viewTaskId,
        project: project,
        areFiltersApplied: areFiltersApplied,
        onSortingChange: onSortingChange,
        cscMode: cscMode
      }, task.id)
    }))]
  });
};

const TasksForm = ({
  taskId,
  projectId,
  parentTaskId,
  onTaskSaved,
  onClose,
  usersList,
  projectsList
}) => {
  const {
    currentUser
  } = useCurrentUser();
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const [task, setTask] = useState(null);
  const [subTasksList, setSubTasksList] = useState([]);
  const [showAddSubTasksToggle, setShowAddSubTasksToggle] = useState(false);
  useEffect(() => {
    if (!showAddSubTasksToggle) {
      setSubTasksList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddSubTasksToggle]);
  useEffect(() => {
    loadTask();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [taskId]);
  useEffect(() => {
    if (showAddSubTasksToggle && subTasksList.length === 0) {
      setSubTasksList([{}]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAddSubTasksToggle]);
  const loadTask = async () => {
    if (taskId) {
      //get the task info for the inputs
      showLoading();
      try {
        let response = await axios.get(`${restUrls.tasksList}/${taskId}`);
        setTask(response.data.task);
      } catch (error) {
        console.log(error);
      }
      hideLoading();
    } else {
      setTask({});
    }
  };
  const handleTaskFieldsChange = e => {
    setTask({
      ...task,
      [e.target.name]: e.target.value
    });
  };
  const handleTaskDescriptionChange = value => {
    if (task !== null) {
      setTask({
        ...task,
        text: value
      });
    }
  };
  const handleSubTaskFieldsChange = (e, index) => {
    const updatedSubTaskField = {
      ...subTasksList[index],
      [e.target.name]: e.target.value
    };
    const updatedSubTasksList = [...subTasksList.slice(0, index), updatedSubTaskField, ...subTasksList.slice(index + 1)];
    setSubTasksList(updatedSubTasksList);
  };
  const handleSubTaskDescriptionChange = (index, value) => {
    const updatedSubTaskField = {
      ...subTasksList[index],
      text: value
    };
    const updatedSubTasksList = [...subTasksList.slice(0, index), updatedSubTaskField, ...subTasksList.slice(index + 1)];
    setSubTasksList(updatedSubTasksList);
  };
  const handleSubmit = async () => {
    showLoading();
    let mandatoryFieldsAreFilled = false;
    if (task?.dueDate && task?.title) {
      if (!showAddSubTasksToggle) {
        mandatoryFieldsAreFilled = true;
      }
      if (!taskId && subTasksList.length !== 0 && showAddSubTasksToggle) {
        subTasksList.forEach(subTask => {
          if (subTask?.dueDate && subTask?.title) {
            mandatoryFieldsAreFilled = true;
          }
        });
      }
    }
    if (!mandatoryFieldsAreFilled) {
      hideLoading();
      toast.warning('Please fill all the task mandatory fields.');
      return;
    }
    const savedTaskId = await saveTask(task);
    if (subTasksList.length) {
      for (const subTask of subTasksList) {
        await saveTask({
          ...subTask,
          parentTaskId: savedTaskId
        });
      }
    }
    hideLoading();
    onTaskSaved();
  };
  const saveTask = async taskData => {
    const saveTaskRoute = taskId ? `${restUrls.tasksList}/${taskId}` : restUrls.tasksList;
    showLoading();
    //if it's a new single task
    let newTaskFormData = new FormData();
    const text = taskData?.text?.constructor.name === 'SyntheticBaseEvent' ? null : taskData?.text;
    newTaskFormData.append('text', text ?? '');
    newTaskFormData.append('title', taskData?.title ?? '');
    newTaskFormData.append('dueDate', taskData?.dueDate ?? '');
    newTaskFormData.append('visibility', taskData?.visibility ?? 'HOTEL');
    newTaskFormData.append('projectId', taskData?.projectId ?? projectId ?? '');
    newTaskFormData.append('knowledgeBaseLink', taskData?.knowledgeBaseLink ?? '');
    newTaskFormData.append('platformLink', taskData?.platformLink ?? '');
    newTaskFormData.append('priority', taskData?.priority ?? 'LOW');
    newTaskFormData.append('userId', taskData?.userId ?? '');
    if (taskData?.parentTaskId || parentTaskId) {
      newTaskFormData.append('parentTaskId', taskData?.parentTaskId ?? parentTaskId);
    }
    try {
      let response = await axios.post(saveTaskRoute, newTaskFormData);
      return response.data.taskId;
    } catch (error) {
      hideLoading();
      toast.error('There was an error while trying to create task');
      return false;
    }
  };
  const isAddingSubtask = !taskId && parentTaskId;
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(BaseTaskForm, {
      projectId: projectId,
      parentTaskFields: task,
      isParentTask: !task?.parentTaskId,
      parentTaskId: task?.parentTaskId ?? null,
      handleTaskFieldsChange: handleTaskFieldsChange,
      handleTaskDescriptionChange: value => handleTaskDescriptionChange(value),
      projectsList: projectsList,
      usersList: usersList,
      currentUser: currentUser,
      isAddingSubtask: isAddingSubtask
    }), !taskId && !parentTaskId && /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(ToggleSwitch, {
        label: "Add SubTasks",
        checked: showAddSubTasksToggle,
        onChange: () => setShowAddSubTasksToggle(!showAddSubTasksToggle)
      })
    }), showAddSubTasksToggle && /*#__PURE__*/jsx(SubtasksList, {
      projectId: projectId,
      currentUser: currentUser,
      subTasksList: subTasksList,
      handleSubTaskFieldsChange: (e, index) => handleSubTaskFieldsChange(e, index),
      handleSubTaskDescriptionChange: (index, value) => handleSubTaskDescriptionChange(index, value),
      projectsList: projectsList,
      usersList: usersList,
      handleRemoveSubTask: index => setSubTasksList([...subTasksList.slice(0, index), ...subTasksList.slice(index + 1)]),
      handleAddSubTask: () => setSubTasksList(oldList => [...oldList, {}]),
      isAddingSubtask: isAddingSubtask
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        onClick: handleSubmit,
        children: "Save Task"
      })
    })]
  });
};
const SubtasksList = ({
  projectId,
  currentUser,
  subTasksList,
  handleSubTaskFieldsChange,
  handleSubTaskDescriptionChange,
  usersList,
  handleRemoveSubTask,
  handleAddSubTask,
  projectsList,
  isAddingSubtask
}) => {
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [subTasksList?.map((subTask, index) => /*#__PURE__*/jsxs(FlexContainer, {
      flexFlow: "column",
      gap: "10px",
      alignItems: "flex-end",
      children: [/*#__PURE__*/jsx(BaseTaskForm, {
        projectId: projectId,
        subTaskIndex: index,
        subtasksFields: subTasksList[index],
        parentTaskId: subTask.parentTaskId,
        handleSubTaskFieldsChange: e => handleSubTaskFieldsChange(e, index),
        handleSubTaskDescriptionChange: (index, value) => handleSubTaskDescriptionChange(index, value),
        projectsList: projectsList,
        usersList: usersList,
        currentUser: currentUser,
        isAddingSubtask: isAddingSubtask
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "danger",
        size: "small",
        icon: /*#__PURE__*/jsx(Trash01, {}),
        onClick: () => handleRemoveSubTask(index),
        children: "Remove SubTask"
      })]
    }, index)), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(Button$1, {
        variant: "secondary",
        size: "small",
        icon: /*#__PURE__*/jsx(Plus02, {}),
        onClick: handleAddSubTask,
        children: "Add Another Sub Task"
      })
    })]
  });
};
const BaseTaskForm = ({
  projectId,
  isParentTask,
  subTaskIndex,
  parentTaskFields,
  subtasksFields,
  handleTaskFieldsChange,
  handleTaskDescriptionChange,
  handleSubTaskFieldsChange,
  handleSubTaskDescriptionChange,
  projectsList,
  usersList,
  currentUser,
  isAddingSubtask
}) => {
  let projectsOptionsList = [{
    label: 'None',
    value: ''
  }];
  Object.entries(projectsList).forEach(project => {
    projectsOptionsList.push({
      label: project[1].name,
      value: project[0]
    });
  });
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsxs(FormGrid, {
      columns: 3,
      children: [/*#__PURE__*/jsx(InputCalendar, {
        label: "Due Date*",
        value: parentTaskFields ? parentTaskFields?.dueDate : subtasksFields?.dueDate,
        name: "dueDate",
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex),
        min: formatDate$1(new Date(), 'yyyy-MM-dd')
      }), isParentTask && !isAddingSubtask && /*#__PURE__*/jsx(Dropdown, {
        label: "Project",
        value: projectId,
        options: projectsOptionsList,
        name: "projectId",
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      })]
    }), /*#__PURE__*/jsxs(FormGrid, {
      columns: 3,
      children: [/*#__PURE__*/jsx(Dropdown, {
        label: "Assign to User",
        name: "userId",
        value: parentTaskFields ? parentTaskFields?.userId : subtasksFields?.userId,
        options: convertUsersListToOptions(usersList),
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      }), (currentUser.role === 'USG_EMPLOYEE_SALES' || currentUser.role === 'ADMIN') && /*#__PURE__*/jsx(Dropdown, {
        label: "Visibility*",
        value: parentTaskFields ? parentTaskFields?.visibility : subtasksFields?.visibility,
        options: visibilityFilters,
        name: "visibility",
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      }), /*#__PURE__*/jsx(Dropdown, {
        label: "Priority",
        value: parentTaskFields ? parentTaskFields?.priority : subtasksFields?.priority,
        options: tasksPriorities,
        name: "priority",
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      })]
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(InputText, {
        label: "Title*",
        placeholder: "Title",
        name: "title",
        value: parentTaskFields ? parentTaskFields?.title : subtasksFields?.title,
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      })
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(Description, {
        label: "Description",
        content: parentTaskFields ? parentTaskFields?.text : subtasksFields?.text,
        onChange: handleTaskDescriptionChange ? value => handleTaskDescriptionChange(value) : value => handleSubTaskDescriptionChange(subTaskIndex, value)
      })
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(InputText, {
        label: "Link To Knowledge Base",
        placeholder: "https://help.upsellguru.com/portal/en/kb/upsellguru",
        name: "knowledgeBaseLink",
        value: parentTaskFields ? parentTaskFields?.knowledgeBaseLink : subtasksFields?.knowledgeBaseLink,
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      })
    }), /*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(InputText, {
        label: "Link to Platform Page Where Task Applies",
        placeholder: "https://extranet.upsellguru.com",
        name: "platformLink",
        value: parentTaskFields ? parentTaskFields?.platformLink : subtasksFields?.platformLink,
        onChange: handleTaskFieldsChange ? e => handleTaskFieldsChange(e) : e => handleSubTaskFieldsChange(e, subTaskIndex)
      })
    })]
  });
};

const getInitialFilters$1 = () => {
  return {
    status: '',
    priority: '',
    dueDateStatus: ''
  };
};
const CustomerSuccessConsultantAssignedTasks = ({
  tasksList,
  onDeleteTask,
  onAddSubTask,
  onEditTask,
  onUserAssigned,
  onDueDateChange,
  onMarkTaskAsDone,
  usersList,
  onCommentAdded,
  onCommentRemoved,
  onSortingChange
}) => {
  const [viewTaskId, setViewTaskId] = useState(null);
  const [filters, setFilters] = useState(getInitialFilters$1());
  const posthog = usePostHog();
  useEffect(() => {
    posthog.capture('tasks_change_status_filter', {
      status: filters.status
    });
  }, [filters.status]);
  useEffect(() => {
    posthog.capture('tasks_change_priority_filter', {
      priority: filters.priority
    });
  }, [filters.priority]);
  useEffect(() => {
    posthog.capture('tasks_change_due_date_status_filter', {
      status: filters.dueDateStatus
    });
  }, [filters.dueDateStatus]);
  const filteredTasks = useMemo(() => {
    return tasksList.reduce((acc, task) => {
      const filteredSubTasks = task.subtasks.filter(subtask => {
        if (filters.status && subtask.status !== filters.status) {
          return false;
        }
        if (filters.priority && subtask.priority !== filters.priority) {
          return false;
        }
        if (filters.dueDateStatus && subtask.timeStatus !== filters.dueDateStatus) {
          return false;
        }
        return true;
      });
      if (filteredSubTasks.length > 0) {
        acc.push({
          ...task,
          subtasks: filteredSubTasks
        });
        return acc;
      }
      if (filters.status && task.status !== filters.status) {
        return acc;
      }
      if (filters.priority && task.priority !== filters.priority) {
        return acc;
      }
      if (filters.dueDateStatus && task.timeStatus !== filters.dueDateStatus) {
        return acc;
      }
      acc.push(task);
      return acc;
    }, []);
  }, [tasksList, filters]);
  const handleOnViewTaskClick = task => {
    if (!viewTaskId || task?.id !== viewTaskId) {
      setViewTaskId(task?.id);
    } else {
      setViewTaskId(null);
    }
  };
  const areFiltersApplied = filters.status || filters.priority || filters.dueDateStatus;
  return /*#__PURE__*/jsxs(Card, {
    isExpandable: true,
    title: "\uD83D\uDCCB Tasks",
    children: [/*#__PURE__*/jsx(ProjectFilters, {
      filters: filters,
      onChangeFilters: setFilters
    }), filteredTasks.length !== 0 && filteredTasks.map(task => {
      return /*#__PURE__*/jsx(TaskItem, {
        task: task,
        onDeleteTask: onDeleteTask,
        onAddSubTask: onAddSubTask,
        onEditTask: onEditTask,
        onMarkTaskAsDone: onMarkTaskAsDone,
        onUserAssigned: onUserAssigned,
        onDueDateChange: onDueDateChange,
        isParentTask: true,
        usersList: usersList,
        onCommentAdded: onCommentAdded,
        onCommentRemoved: onCommentRemoved,
        onViewTaskClick: handleOnViewTaskClick,
        viewTaskId: viewTaskId,
        project: null,
        areFiltersApplied: areFiltersApplied,
        onSortingChange: onSortingChange,
        cscMode: true
      }, task.id);
    })]
  });
};

const TasksFilters = ({
  filters,
  onChangeFilters,
  projectsList,
  cscList
}) => {
  const {
    currentUser
  } = useCurrentUser();
  let projectsOptionsList = useMemo(() => {
    const options = [{
      label: 'Any',
      value: ''
    }];
    Object.entries(projectsList).forEach(project => {
      let projectName = project[1].name;
      if (project[1].hotelName) {
        projectName = project[1].hotelName + ' - ' + projectName;
      }
      options.push({
        label: projectName,
        value: project[0]
      });
    });
    return options;
  });
  const handleUpdateFilters = newFilters => {
    if (Object.keys(newFilters).length) {
      onChangeFilters(filters => ({
        ...filters,
        ...newFilters
      }));
    } else {
      onChangeFilters(filters => ({
        cscId: '',
        projectId: '',
        assignedToMe: false
      }));
    }
  };
  return /*#__PURE__*/jsxs(FiltersBarWithSidePanel, {
    onChange: handleUpdateFilters,
    children: [currentUser.role === 'ADMIN' && !currentUser.isCustomerSuccessConsultant && /*#__PURE__*/jsx(FilterBarItem, {
      name: "cscId",
      label: "CSC",
      type: "dropdown",
      options: cscList,
      placeholder: "Select CSC",
      defaultValue: filters.cscId
    }), projectsOptionsList.length > 2 && /*#__PURE__*/jsx(FilterBarItem, {
      name: "projectId",
      label: "Projects",
      type: "dropdown",
      options: projectsOptionsList,
      placeholder: "Select Project",
      defaultValue: filters.projectId
    }), /*#__PURE__*/jsx(FilterBarItem, {
      name: "assignedToMe",
      label: "My Tasks",
      type: "toggle",
      defaultValue: filters.assignedToMe
    })]
  });
};

const getInitialFilters = () => {
  return {
    projectId: '',
    cscId: null,
    assignedToMe: null
  };
};
const TasksTab = ({
  usersList,
  onTaskStatusUpdate
}) => {
  const {
    currentUser
  } = useCurrentUser();
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const ASC = 'asc',
    DESC = 'desc';
  const [order, setOrder] = useState(ASC);
  const [sortField, setSortField] = useState('');
  const [showProjectFormToggle, setShowProjectFormToggle] = useState(false);
  const [showTaskFormToggle, setShowTaskFormToggle] = useState(false);
  const [filters, setFilters] = useState(getInitialFilters());
  const [formProjectId, setFormProjectId] = useState(null);
  const [formTaskId, setFormTaskId] = useState(null);
  const [formParentTaskId, setFormParentTaskId] = useState(null);
  const [availableCsc, setAvailableCsc] = useState([]);
  const [projectsList, setProjectsList] = useState([]);
  const [tasksList, setTasksList] = useState({});
  const [summary, setSummary] = useState(null);
  const [project, setProject] = useState(null);
  const posthog = usePostHog();
  const handleSortingChange = col => {
    const sortOrder = col === sortField && order === ASC ? DESC : ASC;
    setSortField(col);
    setOrder(sortOrder);
    sortProjectsList(col, sortOrder);
  };
  const sortProjectsList = (col, sortOrder) => {
    posthog.capture('tasks_col_sorting', {
      col: col
    });
    if (col === 'dueDate') {
      Object.keys(tasksList).forEach(projectId => {
        tasksList[projectId].sort((a, b) => {
          return (new Date(a.dueDate).getTime() - new Date(b.dueDate).getTime()) * (sortOrder === 'asc' ? 1 : -1);
        });
      });
    }
    if (col === 'user') {
      Object.keys(tasksList).forEach(projectId => {
        tasksList[projectId].sort((a, b) => {
          return usersList[a.userId] && usersList[a.userId].fullName.toString().localeCompare(usersList[b.userId] && usersList[b.userId].fullName.toString(), 'en', {
            numeric: true
          }) * (sortOrder === 'asc' ? 1 : -1);
        });
      });
    }
  };
  useEffect(() => {
    posthog.capture('tasks_load_list');
    loadTasksList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);
  useEffect(() => {
    posthog.capture('tasks_change_project_filter');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.projectId]);
  useEffect(() => {
    loadProjectsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters.cscId]);
  useEffect(() => {
    posthog.capture('tasks_open');
    loadProjectsList();
    if (currentUser.role === 'ADMIN') {
      loadCscFilters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const loadTasksList = async () => {
    showLoading();
    try {
      const response = await axios.get(restUrls.tasksList, {
        params: {
          projectId: filters.projectId,
          assignedUserId: filters.cscId
        }
      });
      setTasksList(response.data.tasks);
      setSummary(response.data.summary);
    } catch (error) {
      console.log(error);
      toast.error('There was an error getting the tasks list.');
    }
    hideLoading();
  };
  const loadCscFilters = async () => {
    let cscData = [{}];
    try {
      let response = await axios.get(restUrls.cscUsersList);
      if (response.data) {
        Object.values(response.data.cscList).forEach(csc => {
          cscData.push({
            label: csc.name,
            value: csc.id
          });
        });
      }
    } catch (error) {
      toast.error('Failed to load CSC User List');
    }
    setAvailableCsc(cscData);
  };
  const filterByAssignedUser = existingList => {
    let newList = {};
    for (let projectId in existingList) {
      let tasks = existingList[projectId] ?? [];
      newList[projectId] = tasks.filter(task => {
        return task.userId === currentUser.id || task.subtasks.filter(subTask => subTask.userId === currentUser.id).length > 0;
      });
    }
    return newList;
  };
  useEffect(() => {
    let filter = filters.assignedToMe ? null : currentUser.id;
    posthog.capture('tasks_show_assigned_to_me', {
      status: filter !== null ? 'enabled' : 'disabled'
    });
    const newFilters = {
      ...filters
    };
    if (filter && currentUser.isCustomerSuccessConsultant && filter !== currentUser.id) {
      newFilters.cscId = filter;
    } else if (!filter && currentUser.isCustomerSuccessConsultant) {
      newFilters.cscId = null;
    }
    setFilters(newFilters);
  }, [filters.assignedToMe]);
  const loadProjectsList = async () => {
    showLoading();
    if (filters.cscId) {
      setProjectsList([]);
      hideLoading();
      return;
    }
    try {
      const response = await axios.get(restUrls.projectsList);
      setProjectsList(response.data.projects);
    } catch (error) {
      toast.error('There was an error getting the projects list');
      console.log(error);
    }
    hideLoading();
  };
  const onDeleteTask = async task => {
    if (window.confirm(`Do you really want to delete this task ${task?.subtasks?.length > 0 ? 'and all its subtasks' : ''}?`)) {
      try {
        await axios.post(`${restUrls.taskRemove}/${task.id}`);
        await loadTasksList();
        toast.success('Task removed.');
        posthog.capture('tasks_remove');
        onTaskStatusUpdate?.();
      } catch (error) {
        toast.error('There was an error while removing the task.');
        console.log(error);
      }
    }
  };
  const onAddSubTask = parentTask => {
    setFormTaskId(null);
    setFormParentTaskId(parentTask?.id);
    setFormProjectId(parentTask?.projectId);
    setShowTaskFormToggle(true);
  };
  const onEditTask = task => {
    setFormTaskId(task.id);
    setFormParentTaskId(task.parentTaskId);
    setFormProjectId(task.projectId);
    setShowTaskFormToggle(true);
  };
  const onUserAssigned = async (userToAssignId, task) => {
    let userToAssignFormData = new FormData();
    userToAssignFormData.append('userId', userToAssignId);
    showLoading();
    try {
      await axios.post(`${restUrls.assignTaskToUser}/${task.id}`, userToAssignFormData);
      posthog.capture('tasks_assign_user');
      await loadTasksList();
      userToAssignId ? toast.success(`Task assigned to ${usersList[userToAssignId].fullName}`) : toast.success(`Task assignment removed`);
    } catch (error) {
      console.log(error);
      toast.error('There was an error while assigning the task to the user.');
    }
    hideLoading();
  };
  const onDueDateChange = async (task, dueDate) => {
    let changeDueDateFormData = new FormData();
    changeDueDateFormData.append('dueDate', dueDate);
    showLoading();
    try {
      await axios.post(`${restUrls.changeDueDate}/${task.id}`, changeDueDateFormData);
      posthog.capture('tasks_change_due_date');
      await loadTasksList();
      toast.success(`Task due date changed to ${dueDate}`);
    } catch (error) {
      console.log(error);
      toast.error('There was an error while changing the task\'s due date.');
    }
    hideLoading();
  };
  const handleProjectSaved = () => {
    posthog.capture('tasks_save_project');
    loadProjectsList();
    closeProjectForm();
  };
  const closeProjectForm = () => {
    posthog.capture('tasks_close_project_form');
    setProject(null);
    setShowProjectFormToggle(false);
  };
  const handleTaskSaved = async () => {
    posthog.capture('tasks_save_task');
    await loadTasksList();
    closeTaskForm();
    onTaskStatusUpdate?.();
  };
  const showTaskForm = (task, project) => {
    posthog.capture('tasks_open_task_form', {
      hasProject: project !== null,
      hasParentTask: task !== null
    });
    setFormProjectId(project ? project.id : null);
    setFormTaskId(task ? task.id : null);
    setFormParentTaskId(null);
    setShowTaskFormToggle(true);
  };
  const closeTaskForm = () => {
    posthog.capture('tasks_close_task_form');
    setShowTaskFormToggle(false);
  };
  const addNewTaskToProject = project => {
    setFormProjectId(project.id);
    showTaskForm(null, project);
  };
  const deleteProject = async project => {
    if (window.confirm('Do you really want to delete this project')) {
      try {
        await axios.post(`${restUrls.tasksDeleteProject}/${project.id}`);
        toast.success('Project deleted successfully');
        posthog.capture('tasks_delete_project');
        await loadProjectsList();
        await loadTasksList();
        onTaskStatusUpdate?.();
      } catch (error) {
        toast.error('There was an error while deleting the project.');
      }
    }
  };
  const markTaskAsDone = async task => {
    showLoading();
    try {
      await axios.post(`${restUrls.markTaskAsDone}/${task.id}`);
      if (task.status !== taskStatus.DONE) {
        toast.success('Task marked to done!');
      }
    } catch (error) {
      console.log(error);
      toast.error('There was an error while marking the task to done.');
      hideLoading();
      return;
    }
    await loadTasksList();
    onTaskStatusUpdate?.();
    hideLoading();
  };
  const editProject = project => {
    setProject(project);
    setShowProjectFormToggle(true);
  };
  let list = tasksList;
  if (filters.assignedToMe) {
    list = filterByAssignedUser(list);
  }
  return /*#__PURE__*/jsxs(Fragment$1, {
    children: [/*#__PURE__*/jsx(SetupBar, {
      showTaskForm: showTaskForm,
      setShowProjectFormToggle: setShowProjectFormToggle
    }), /*#__PURE__*/jsx(ProjectFormSidePanel, {
      project: project,
      showProjectFormToggle: showProjectFormToggle,
      closeProjectForm: closeProjectForm,
      handleProjectSaved: handleProjectSaved
    }), /*#__PURE__*/jsx(TaskFormSidePanel, {
      formTaskId: formTaskId,
      formProjectId: formProjectId,
      formParentTaskId: formParentTaskId,
      projectsList: projectsList,
      usersList: usersList,
      showTaskFormToggle: showTaskFormToggle,
      closeTaskForm: closeTaskForm,
      handleTaskSaved: handleTaskSaved
    }), /*#__PURE__*/jsx(TasksFilters, {
      filters: filters,
      onChangeFilters: setFilters,
      projectsList: projectsList,
      cscList: availableCsc
    }), !filters.cscId && /*#__PURE__*/jsx(ProjectsList, {
      tasksList: list,
      projectsList: projectsList,
      loadTasksList: loadTasksList,
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      usersList: usersList,
      addNewTaskToProject: addNewTaskToProject,
      onCommentAdded: () => loadTasksList(),
      onCommentRemoved: () => loadTasksList(),
      deleteProject: deleteProject,
      editProject: editProject,
      onTaskStatusUpdate: onTaskStatusUpdate,
      setTasksList: setTasksList,
      onSortingChange: handleSortingChange,
      cscMode: false,
      onMarkTaskAsDone: markTaskAsDone
    }), filters.cscId && /*#__PURE__*/jsx(CustomerSuccessConsultantAssignedTasks, {
      tasksList: list[''] ?? [],
      onDeleteTask: onDeleteTask,
      onAddSubTask: onAddSubTask,
      onEditTask: onEditTask,
      onUserAssigned: onUserAssigned,
      onDueDateChange: onDueDateChange,
      usersList: usersList,
      onCommentAdded: () => loadTasksList(),
      onCommentRemoved: () => loadTasksList(),
      summary: summary,
      onSortingChange: handleSortingChange,
      onMarkTaskAsDone: markTaskAsDone
    })]
  });
};
const SetupBar = ({
  showTaskForm,
  setShowProjectFormToggle
}) => {
  return /*#__PURE__*/jsx(SecondaryToolbar, {
    children: /*#__PURE__*/jsxs(SecondaryToolbarMainActions, {
      children: [/*#__PURE__*/jsx(Button$1, {
        variant: "secondary",
        icon: /*#__PURE__*/jsx(Plus02, {}),
        onClick: () => showTaskForm(null, null),
        size: "small",
        children: "Create New Task"
      }), /*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        icon: /*#__PURE__*/jsx(Plus02, {}),
        size: "small",
        onClick: () => setShowProjectFormToggle(true),
        children: "Create New Project"
      })]
    })
  });
};
const ProjectFormSidePanel = ({
  project,
  showProjectFormToggle,
  closeProjectForm,
  handleProjectSaved
}) => {
  const title = project ? 'Edit Project' : 'Create New Project';
  return /*#__PURE__*/jsx(SidePanel, {
    open: showProjectFormToggle,
    onClose: closeProjectForm,
    title: title,
    width: 800,
    children: /*#__PURE__*/jsx(ProjectForm, {
      project: project,
      onProjectSaved: handleProjectSaved
    })
  });
};
const TaskFormSidePanel = ({
  formTaskId,
  formProjectId,
  formParentTaskId,
  projectsList,
  usersList,
  showTaskFormToggle,
  closeTaskForm,
  handleTaskSaved
}) => {
  const title = formTaskId ? 'Edit Task' : 'Create New Task';
  return /*#__PURE__*/jsx(SidePanel, {
    open: showTaskFormToggle,
    onClose: closeTaskForm,
    width: 800,
    title: title,
    children: /*#__PURE__*/jsx(TasksForm, {
      onTaskSaved: handleTaskSaved,
      taskId: formTaskId,
      projectId: formProjectId,
      parentTaskId: formParentTaskId,
      projectsList: projectsList,
      usersList: usersList
    })
  });
};

const AnnotationForm = ({
  annotation,
  onClose,
  onSave
}) => {
  const [text, setText] = useState(annotation ? annotation.text : '');
  const save = async () => {
    if (text) {
      let newAnnotationFormData = new FormData();
      newAnnotationFormData.append('text', text);
      newAnnotationFormData.append('visibility', 'HOTEL');
      try {
        let url = restUrls.annotationsList;
        if (annotation && annotation.id) {
          url = `${url}/${annotation.id}`;
        }
        await axios.post(url, newAnnotationFormData);
        setText('');
        onSave();
        toast.success('New note created!');
      } catch (error) {
        console.log(error);
        toast.error('There was an error while creating the note.');
      }
    } else {
      alert('Please fill the note text.');
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: css.createNewAnnotationSectionWrapper,
    children: [/*#__PURE__*/jsxs("div", {
      className: css.createNewAnnotationSection,
      children: [/*#__PURE__*/jsx(FormGrid, {
        children: /*#__PURE__*/jsx(TextArea, {
          placeholder: "Leave a note...",
          value: text,
          onChange: event => setText(event.target.value)
        })
      }), /*#__PURE__*/jsxs(FlexContainer, {
        gap: "5px",
        alignItems: "center",
        children: [/*#__PURE__*/jsx(Button$1, {
          variant: "primary",
          size: "small",
          onClick: save,
          children: `${annotation ? 'Edit' : 'Add New'} Note`
        }), annotation && onClose && /*#__PURE__*/jsx(Button$1, {
          size: "small",
          variant: "secondary",
          onClick: onClose,
          children: "Close"
        })]
      })]
    }), /*#__PURE__*/jsx("hr", {})]
  });
};

const AnnotationCommentForm = ({
  annotation,
  onCommentSaved,
  onClose
}) => {
  const [comment, setComment] = useState('');
  const addComment = async () => {
    if (comment) {
      let newAnnotationCommentFormData = new FormData();
      newAnnotationCommentFormData.append('annotationId', annotation.id);
      newAnnotationCommentFormData.append('comment', comment);
      try {
        await axios.post(restUrls.annotationsSaveComment, newAnnotationCommentFormData);
        setComment('');
        onCommentSaved();
      } catch (error) {
        console.log(error);
        toast.error('There was an error while adding a comment.');
      }
    } else {
      alert('Please fill the comment text.');
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: css.addComment,
    children: [/*#__PURE__*/jsx(FormGrid, {
      children: /*#__PURE__*/jsx(TextArea, {
        placeholder: "Leave a comment...",
        value: comment,
        onChange: event => setComment(event.target.value)
      })
    }), /*#__PURE__*/jsxs(FlexContainer, {
      alignItems: "center",
      gap: "5px",
      children: [/*#__PURE__*/jsx(Button$1, {
        variant: "primary",
        size: "small",
        onClick: addComment,
        children: "Add Comment"
      }), /*#__PURE__*/jsx(Button$1, {
        size: "small",
        variant: "secondary",
        onClick: onClose,
        children: "Close"
      })]
    })]
  });
};

const AnnotationCommentItem = ({
  comment,
  onRemoveComment
}) => {
  if (comment.status === taskStatus.DELETED) {
    return null;
  }
  return /*#__PURE__*/jsxs(FlexContainer, {
    className: css.annotationCommentItem,
    flexWrap: "nowwrap",
    gap: "5px",
    justifyContent: "space-between",
    alignItems: "center",
    children: [/*#__PURE__*/jsxs("div", {
      className: css.taskComment,
      children: [/*#__PURE__*/jsx("small", {
        children: /*#__PURE__*/jsxs("b", {
          children: [formatDate$1(new Date(comment.createdAt), 'dd MMM yy HH:mm'), " by ", /*#__PURE__*/jsx(AgentName, {
            agentName: comment.userFullName
          })]
        })
      }), /*#__PURE__*/jsx("p", {
        dangerouslySetInnerHTML: {
          __html: comment.text
        }
      })]
    }, comment.id), /*#__PURE__*/jsx("div", {
      className: "cursor-pointer",
      onClick: () => onRemoveComment(comment),
      children: /*#__PURE__*/jsx(Trash01, {
        width: 12
      })
    })]
  });
};

const AnnotationCommentsList = ({
  commentsList,
  onRemoveComment
}) => {
  return /*#__PURE__*/jsx(Fragment$1, {
    children: commentsList?.length > 0 && /*#__PURE__*/jsxs("div", {
      className: css.annotationsPreviousComments,
      children: [/*#__PURE__*/jsxs("div", {
        className: "mb-small",
        children: [/*#__PURE__*/jsx(MessageSquareTypingIcon, {
          width: 15
        }), /*#__PURE__*/jsx("b", {
          children: " Previous Comments"
        })]
      }), commentsList?.map(comment => /*#__PURE__*/jsx(AnnotationCommentItem, {
        comment: comment,
        onRemoveComment: onRemoveComment
      }, comment.id))]
    })
  });
};

const AnnotationComments = ({
  annotation,
  onClose,
  onCommentChanges
}) => {
  const [commentsList, setCommentsList] = useState([]);
  const posthog = usePostHog();
  const loadAnnotationsComments = async () => {
    try {
      let response = await axios.get(`${restUrls.annotationsCommentsList}/${annotation.id}`);
      const sortedComments = response.data.comments.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
      setCommentsList(sortedComments);
    } catch (error) {
      console.log(error);
      toast.error('There was an error getting the comments.');
    }
  };
  const removeComment = async comment => {
    if (comment && window.confirm('Are you sure you want to remove this comment?')) {
      posthog.capture('annotations_remove_comment');
      try {
        await axios.post(`${restUrls.annotationRemoveComment}/${comment.id}`);
        loadAnnotationsComments();
        onCommentChanges();
      } catch (error) {
        console.log(error);
        toast.error('There was an error while removing the comment.');
      }
    }
  };
  const onCommentSaved = async () => {
    posthog.capture('annotations_add_comment');
    loadAnnotationsComments();
    onCommentChanges();
  };
  useEffect(() => {
    loadAnnotationsComments();
    posthog.capture('annotations_open_comments');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/jsxs("div", {
    className: css.annotationsCommentsSection,
    children: [/*#__PURE__*/jsx(AnnotationCommentForm, {
      annotation: annotation,
      onCommentSaved: onCommentSaved,
      onClose: onClose
    }), /*#__PURE__*/jsx(AnnotationCommentsList, {
      commentsList: commentsList,
      onRemoveComment: removeComment
    })]
  });
};

const AnnotationItem = ({
  annotation,
  usersList,
  onRemoveAnnotation,
  onSaveAnnotation
}) => {
  const [showEditFormToggle, setShowEditFormToggle] = useState(false);
  const [showCommentsToggle, setShowCommentsToggle] = useState(false);
  const toggleComments = () => {
    setShowCommentsToggle(!showCommentsToggle);
  };
  const toggleEditForm = () => {
    setShowEditFormToggle(!showEditFormToggle);
  };
  const handleSaveAnnotation = () => {
    toggleEditForm();
    onSaveAnnotation();
  };
  if (showEditFormToggle) {
    return /*#__PURE__*/jsx(AnnotationForm, {
      onClose: toggleEditForm,
      onSave: handleSaveAnnotation,
      annotation: annotation
    });
  }
  if (annotation.status === taskStatus.DELETED) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: css.annotationItemWrapper,
    children: [/*#__PURE__*/jsxs(FlexContainer, {
      flexWrap: "nowwrap",
      gap: "5px",
      justifyContent: "space-between",
      alignItems: "center",
      children: [/*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("small", {
          children: /*#__PURE__*/jsxs("b", {
            children: [formatDate$1(new Date(annotation.createdAt), 'dd MMM yy HH:mm'), " by ", /*#__PURE__*/jsx(AgentName, {
              agentName: annotation.userFullName
            })]
          })
        }), /*#__PURE__*/jsx("p", {
          dangerouslySetInnerHTML: {
            __html: annotation.text
          }
        })]
      }), /*#__PURE__*/jsxs(FlexContainer, {
        gap: "10px",
        className: css.annotationItemActions,
        alignItems: "center",
        children: [/*#__PURE__*/jsxs("div", {
          className: `cursor-pointer ${css.commentIcon}`,
          onClick: toggleComments,
          children: [/*#__PURE__*/jsx(MessageSquareTypingIcon, {
            width: 13
          }), "\xA0", /*#__PURE__*/jsx("span", {
            children: annotation.commentCount
          })]
        }), /*#__PURE__*/jsx("div", {
          className: `cursor-pointer ${css.edit}`,
          onClick: () => setShowEditFormToggle(true),
          children: /*#__PURE__*/jsx(Edit04, {
            width: 13
          })
        }), /*#__PURE__*/jsx("div", {
          className: `cursor-pointer ${css.delete}`,
          onClick: () => onRemoveAnnotation(annotation),
          children: /*#__PURE__*/jsx(Trash01, {
            width: 11
          })
        })]
      })]
    }), showCommentsToggle && /*#__PURE__*/jsx(AnnotationComments, {
      annotation: annotation,
      onClose: toggleComments,
      onCommentChanges: onSaveAnnotation
    })]
  });
};

const AnnotationsTab = ({
  usersList
}) => {
  const [annotationsList, setAnnotationsList] = useState([]);
  const posthog = usePostHog();
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const loadAnnotationsList = async () => {
    showLoading();
    try {
      const response = await axios.get(restUrls.annotationsList);
      let sort = (a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
      };
      let sortedAnnotationsList = response.data.annotations.sort(sort);
      setAnnotationsList(sortedAnnotationsList);
    } catch (error) {
      console.log(error);
      toast.error('There was an error getting the annotations list.');
    }
    hideLoading();
  };
  useEffect(() => {
    posthog.capture('annotations_open');
    loadAnnotationsList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const removeAnnotation = async annotation => {
    if (window.confirm('Are you sure you want to remove this note?')) {
      posthog.capture('annotations_remove');
      try {
        await axios.post(`${restUrls.annotationsRemove}/${annotation.id}`);
        loadAnnotationsList();
        toast.success('Note removed.');
      } catch (error) {
        console.log(error);
        toast.error('There was an error while removing the note.');
      }
    }
  };
  const handleNewAnnotationSaved = () => {
    posthog.capture('annotations_save');
    loadAnnotationsList();
  };
  const handleAnnotationUpdated = () => {
    posthog.capture('annotations_update');
    loadAnnotationsList();
  };
  return /*#__PURE__*/jsxs("div", {
    className: css.annotationsListWrapper,
    children: [/*#__PURE__*/jsx(AnnotationForm, {
      onSave: handleNewAnnotationSaved
    }), annotationsList.map(annotation => /*#__PURE__*/jsx(AnnotationItem, {
      annotation: annotation,
      usersList: usersList,
      onRemoveAnnotation: removeAnnotation,
      onSaveAnnotation: handleAnnotationUpdated
    }, annotation.id))]
  });
};

const TasksAndAnnotationsPanel = ({
  onClose
}) => {
  const {
    isDemoMode
  } = useDemoMode();
  const [usersList, setUsersList] = useState([]);
  const [selectedTab, setSelectedTab] = useState('tasks');
  const {
    showLoading,
    hideLoading
  } = useLoading();
  const {
    notifyTaskStatusUpdate
  } = useTasksSidePanel();
  const posthog = usePostHog();
  useEffect(() => {
    loadUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDemoMode]);
  const loadUsersList = async () => {
    showLoading();
    try {
      let response = await axios.get(restUrls.usersList);
      const users = Object.fromEntries(Object.entries(response.data.users).map(([id, user]) => [id, isDemoMode ? {
        ...user,
        fullName: 'Demo User'
      } : user]));
      setUsersList(users);
    } catch (error) {
      console.log(error);
      toast.error('There was an error getting the users list.');
    }
    hideLoading();
  };
  useEffect(() => {
    loadUsersList();
    posthog.capture('tasks_annotations:page_open');
    // eslint-disable-next-line
  }, []);
  return /*#__PURE__*/jsxs(SidePanel, {
    className: css.tasksListTab,
    title: "Tasks And Notes List",
    open: true,
    onClose: onClose,
    children: [/*#__PURE__*/jsxs(PillsTabs, {
      children: [/*#__PURE__*/jsx(PillsTabItem, {
        label: "Tasks",
        active: selectedTab === 'tasks',
        onClick: () => setSelectedTab('tasks')
      }), /*#__PURE__*/jsx(PillsTabItem, {
        label: "Notes",
        active: selectedTab === 'notes',
        onClick: () => setSelectedTab('notes')
      })]
    }), selectedTab === 'tasks' && /*#__PURE__*/jsx(TasksTab, {
      usersList: usersList,
      onTaskStatusUpdate: notifyTaskStatusUpdate
    }), selectedTab === 'notes' && /*#__PURE__*/jsx(AnnotationsTab, {
      usersList: usersList
    })]
  });
};

const TasksAndAnnotations = () => {
  const {
    currentHotel
  } = useCurrentHotel();
  const {
    showTasksSection,
    handleCloseSidePanel
  } = useTasksSidePanel();
  if (!currentHotel) {
    return;
  }
  const onClose = () => {
    handleCloseSidePanel();
  };
  if (window.location.href.indexOf('dashboard/onboarding') !== -1) {
    return null;
  }
  return /*#__PURE__*/jsx(Fragment$1, {
    children: showTasksSection && /*#__PURE__*/jsx("div", {
      className: css.tasksAndAnnotationsWrapper,
      children: /*#__PURE__*/jsx(TasksAndAnnotationsPanel, {
        onClose: onClose
      })
    })
  });
};

const TasksCard = () => {
  const {
    currentHotel
  } = useCurrentHotel();
  const [tasksTodoCount, setTasksTodoCount] = useState(0);
  const {
    handleShowSidePanel,
    taskStatusVersion
  } = useTasksSidePanel();
  const {
    isCollapsed
  } = useSidebar();
  const load = useCallback(async () => {
    if (!currentHotel) {
      return;
    }
    try {
      const response = await axios.get(restUrls.tasksTodoCount);
      setTasksTodoCount(response.data.count);
    } catch (error) {
      setTasksTodoCount(0);
    }
  }, [currentHotel]);
  useEffect(() => {
    load();
  }, [load, taskStatusVersion]);
  if (!currentHotel) {
    return null;
  }
  if (isCollapsed) {
    return /*#__PURE__*/jsx(SidebarCard, {
      variant: "primary",
      isCollapsed: true,
      onClick: handleShowSidePanel,
      collapsedContent: tasksTodoCount > 0 ? /*#__PURE__*/jsxs(Fragment$1, {
        children: [/*#__PURE__*/jsx(AlertTriangle, {
          width: 24,
          height: 24,
          color: colors$1.warning
        }), /*#__PURE__*/jsx("div", {
          style: {
            color: colors$1.white
          },
          children: tasksTodoCount
        })]
      }) : /*#__PURE__*/jsx(Inbox02Icon, {
        width: 24,
        height: 24,
        color: colors$1.white
      })
    });
  }
  return /*#__PURE__*/jsx(SidebarCard, {
    variant: "primary",
    onClick: handleShowSidePanel,
    icon: tasksTodoCount > 0 ? /*#__PURE__*/jsx(AlertTriangle, {
      width: 18,
      height: 18,
      color: colors$1.warning
    }) : /*#__PURE__*/jsx(Inbox02Icon, {
      width: 18,
      height: 18
    }),
    title: tasksTodoCount > 0 ? `${tasksTodoCount} Tasks Pending!` : 'No pending tasks',
    description: tasksTodoCount > 0 ? 'You have tasks awaiting for completion.' : 'create a new task'
  });
};

export { AcceptUpsellButton, AddSquare04Icon, AgentName, Alert, AlertTriangle, AnimatedCount, AnimatedMoney, AppliedFilter, AppliedFiltersSummary, AppsPickerButton, ArrowLeft, ArrowRefresh01, ArrowRightIcon, ArrowSwitchHorizontal, ArrowSwitchVertical, AsyncSearchableDropdown, Avatar, AwardAndTrophy04Icon, Badge, Bag04Icon, BankNote04, BarChartSquare03Icon, BarsAndLineChart, BarsChart, BaseEditor, BaseImproveWithAIButton, Bell02Icon, Bell03, Bell04Icon, Bold$1 as Bold, BoldButton, Book02, Breadcrumbs, BulletList$1 as BulletList, BulletListButton, BundleMarker, BundlesListProvider, Button$1 as Button, ButtonDropdownItem, Calendar01, CalendarCheckIcon, Card, CardTitle, CardUp, CaretIcon, ChartLegend, ChartLegendItem, ChartTooltip, CheckBroken, CheckCircleIcon, CheckSquareBroken, Checkbox, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ClockIcon, CloseIcon, ClosedCaptionsIcon, CollapseWidthIcon, ColorPicker, ColumnHorizontal01Icon, ColumnVisibilityProvider, Component, ContentSuggestionsSidePanel, CopyLeft, CrossCircleIcon, CrossPropertyRoomTypesListContext, CurrentHotelContext, CurrentHotelProvider, CurrentUserContext, CurrentUserProvider, Data04, DateRangePicker, DeleteButton, DemoModeCard, DemoModeContext, DemoModeGuard, DemoModeProvider, DemoTestHotelsSection, DenyUpsellButton, Description, DetailRow, DiamondIcon, Disabled, DotHorizontalIcon, DoughnutChart, DownArrow, Download02, DraggableTable, DraggableTableRow, Dropdown, DropdownButton, Edit03, Edit04, EditUpsellButton, EditUserProfile, EditableRemarks, Email$1 as Email, EmailAddress, EmojiPicker, EqualsIcon, ExpandWidthIcon, ExpandableButton, ExpandableItem, ExtraTypeCode, ExtraTypeName, ExtraTypeVariationCode, ExtraTypesListContext, ExtraTypesListProvider, EyeOpen, FeatureFlagsContext, FeatureFlagsProvider, Filter, FilterBarItem, FilterBarPillButton, FiltersBarWithSidePanel, FixedBottomBar, FlashcardIcon, FlexContainer, FocalPointPicker, FormGrid, FormGroupInnerChild, FormGroupOuterParent, FrontDeskAgent, Gear, Gift01Icon, Globe02Icon, Grid01Icon, GuestName, HOTEL_STATUS, HeaderContent, HelpCircleContainedIcon, Home02, HotelLookupProvider, HotelName, HotelPickerButton, HotelShortName, HotelStatusDot, HotelSwitcher, Hourglass03Icon, IconButtonMenu, IconWithBadge, ImageAdd, ImageAvatar, ImageIcon, ImageUpload, ImagesGallery, Inbox02Icon, InformationCircleContained, InlineFilters, InlineLoading, InputCalendar, InputMonth, InputNumber, InputRadio, InputText, InputTime, Iphone01Icon, Italic$1 as Italic, ItalicButton, Key02, KeyAreaBox, Label, LabelDelete, LabelDropdown, LabelTouchpoint, LabelTransactionStatus, Layers03, Layout, Layout02Icon, LayoutBreadcrumbs, LayoutHeader, LayoutMenuItem, LayoutSecondaryMenuItem, LayoutSidebar, LazyLoadingIndicator, LearningCard, LearningInProgressIcon, LearningNotStartedIcon, LearningQuizPassedIcon, LeftLayoutSection, LegendItem, Lightbulb01, LightningFilled, LineChart, LineChartUp02Icon, LineTabItem, LineTabs, LinkAngled, LinkButton, LinkExternal, LoadingProvider, LoadingScreen, Lock02Icon, LockOpen02Icon, LogoUpload, LogoutIcon, Mail03, Mail05, Marker01, Marker02Icon, MarketSegmentCode, MarketSegmentsListContext, MarketSegmentsListProvider, Maximize01Icon, Menu05, MessageChat01, MessageSquareIcon, MessageSquareTypingIcon, MessageText02, MetricBox, Minimize01Icon, MinusCircleContainedIcon, Modal, ModalActions, MultiLanguageInput, MultiLanguageInputGroup, MultiSelect, NoResultsFoundCard, NoResultsFoundMessage, NotificationsBadge, NumericPagination, PageActions, PageContainer, PageContainerContext, PageDescription, PageTitle, Pagination, PartialUpgradeCaption, Pause02Icon, PhoneNumber, PieChart02Icon, PillsTabItem, PillsTabs, PillsTabsTabPanel, PlaneIcon, Play02Icon, Plus01, Plus02, Plus03, PreArrivalInteractionLabel, ProgramLetter, ProgressBar, QuantityInput, QuizPassedBadge, RatePlanCode, RatePlansListContext, RatePlansListProvider, ReceiptLines, RefCollectContext, RefCollectorProvider, ReinstateUpsellButton, ResellerContext, ResellerProvider, ReservationProfileDetails, ReservationProfileEmails, ReservationProfileLogs, ReservationProfileRegCard, ReservationProfileSectionTitle, ReservationProfileStatus, ReservationProfileTableTitle, ReservationProfileUpsells, ReservationSegmentationDetails, ReservationSourceCode, ReservationSourcesListContext, ReservationSourcesListProvider, ReservationStatus, ReservationStatusLabel, RightLayoutSection, RoomIcon, RoomTypeCode, RoomTypeName, RoomTypeUpgrade, RoomTypesListContext, RoomTypesListProvider, Save02, Scan, ScreenIcon, Search01, SearchableDropdown, SecondaryToolbar, SecondaryToolbarActionGroup, SecondaryToolbarMainActions, SectionTitle, Send01, Server02, Settings, SidePanel, SidebarCard, SidebarProvider, Skip, Slider, SmileEmojiIcon, SmileyHappy, SmileyNeutral, SmileySad, SortVertical01, SortableItemsModal, SplitButton, SplitLayout, Star01Icon, Star02Icon, Stars, StatusBox, StatusLegend, StatusLegendItem, StickyActionsBar, StopCircleContainedIcon, StopwatchSnoozeIcon, Strike$1 as Strike, StrikeButton, SubTitle, TIMEZONE_OPTIONS, TText, Table, TableCell, TableHead, TableHeader, TableRow, TableSortableHeader, TagIcon, Target02Icon, Target04Icon, TargetingListSection, TasksAndAnnotations, TasksCard, TasksSidePanelProvider, TasksTab, Text$2 as Text, TextArea, ThinStar, ThumbDownIcon, ThumbUpIcon, TimezoneContext, TimezoneMenu, TimezonePicker, TimezoneProvider, ToggleSwitch, Toolbar, Tooltip$1 as Tooltip, TranslateButton, TranslateWithAIButton, Translation, TranslationsProvider, Trash01, TrendDown01Icon, TrendIndicator, TrendUp01Icon, Trophy01, TruncatedList, Underline$1 as Underline, UnderlineButton, UpArrow, Upload01, UpsellGuruLogo, UpsellStatusLabel, UserBehaviourTrackerProvider, UserBookmarksContext, UserBookmarksProvider, UserFullNameWithPicture, UserProfileCircleIcon, Volume02Icon, VolumeOff02Icon, Wallet01Icon, WideLayoutProvider, X01Icon, X02, ZoomIn, apiEndpoints, bookedExtraStatus, calculateUpsellTotal, changeWhitelabelTheme, changeWhitelabelThemeV2, colors$1 as colors, dataLoadingStatus$9 as dataLoadingStatus, decodeFilters, decodeHtmlEntities, encodeFilters, featureFlagsCodes, fetchRefs, fileToBase64, formatCompactNumber, formatCurrency, formatDate$1 as formatDate, formatDateTime, formatDateTimeNoConversion, formatNights, formatPercentage, genid, getCSSVariable, getColour, getRootStyle, getSuspenseRef, hotelNamePlain, isPartialUpgrade, objectIsEmpty, parseCalendarDay, parseDate$2 as parseDate, programs, range, readFiltersFromUrl, refCache, resetWhiteLabelTheme, roomAvailabilityCapturePoint, roomUpgradesStatus, sortSelectedColumn, touchpoints, trackGroup, transactionsStatus$1 as transactionsStatus, upgradeBidsStatus, urlToFile, useBroadcastChannel, useBundlesList, useClickOutside, useColumnVisibility, useColumnVisibilityContext, useCountUp, useCurrentHotel, useCurrentUser, useDemoMode, useDragAndDrop, useExtraTypesList, useFeatureFlags, useFixedBottomBarPosition, useHotelLookup, useIsMobileViewport$1 as useIsMobileViewport, useListKeyboardNavigation, useLoading, useMarketSegmentsList, useRatePlansList, useReseller, useReservationSourcesList, useRoomTypesList, useRow, useSidePanelLeftOffset, useSidebar, useSwitchHotel, useTasksSidePanel, useTimezone, useTrackedHotkeys, useTranslations, useUrlPage, useUserBookmarks, useUsersList, useWideLayout, useWindowWidth, validateEmail };
//# sourceMappingURL=index.esm.js.map
